
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea2a6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea2a6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8TgEi", function(module, exports) {
module.exports = function navigation(app) {
    app.ports.refresh && app.ports.refresh.subscribe(function() {
        window.location.reload(true);
    });
    app.ports.redirectAndRefresh && app.ports.redirectAndRefresh.subscribe(function(url) {
        setTimeout(function() {
            window.location.replace(url);
        }, 0);
    });
};

});

parcelRegister("bvPu1", function(module, exports) {
module.exports = function(app) {
    if (window.nomalab.intercom) {
        // Load intercom snippet
        (function() {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
                ic('reattach_activator');
                ic('update', w.intercomSettings);
            } else {
                var d = document;
                var i = function() {
                    i.c(arguments);
                };
                i.q = [];
                i.c = function(args) {
                    i.q.push(args);
                };
                w.Intercom = i;
                var l = function() {
                    var s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = 'https://widget.intercom.io/widget/' + window.nomalab.intercom.id;
                    var x = d.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);
                };
                if (document.readyState === 'complete') l();
                else if (w.attachEvent) w.attachEvent('onload', l);
                else w.addEventListener('load', l, false);
            }
        })();
        window.Intercom("boot", {
            api_base: "https://api-iam.intercom.io",
            app_id: window.nomalab.intercom.id,
            name: window.nomalab.user?.name || "",
            email: window.nomalab.user?.email,
            alignment: "left"
        });
    }
    if (window.nomalab.sentry) {
        var sentryTag = document.createElement('script');
        sentryTag.crossOrigin = "anonymous";
        sentryTag.src = "https://browser.sentry-cdn.com/5.27.6/bundle.tracing.min.js";
        sentryTag.integrity = "sha384-9Z8PxByVWP+gIm/rTMPn9BWwknuJR5oJcLj+Nr9mvzk8nJVkVXgQvlLGZ9SIFEJF";
        sentryTag.addEventListener('load', function() {
            Sentry.init({
                dsn: window.nomalab.sentry.url,
                release: 'dev',
                environment: window.nomalab.environment || 'prod',
                integrations: [
                    new Sentry.Integrations.BrowserTracing()
                ],
                tracesSampleRate: 0.2
            });
            if (window.nomalab.user && window.nomalab.user.email) Sentry.setUser({
                email: window.nomalab.user.email
            });
        });
        document.body.appendChild(sentryTag);
    }
    app.ports.openIntercom && app.ports.openIntercom.subscribe(function(toggle) {
        if (toggle) Intercom && Intercom('show');
        else Intercom && Intercom('hide');
    });
};

});

parcelRegister("hjsOJ", function(module, exports) {
module.exports = function(app) {
    app.ports.gotoSSO && app.ports.gotoSSO.subscribe(async function(ssoUrl) {
        window.location = ssoUrl;
    });
};

});

parcelRegister("iHeIR", function(module, exports) {
module.exports = function routing(app, portName) {
    // Manually handle the push history state
    // mostly to allow ctrl/cmd + click to open in new tab
    document.body.addEventListener('click', function(e) {
        // ignore click + meta or ctrl for new tabs
        if (e.ctrlKey || e.metaKey) return true;
        // lookup for an <a[href]>
        var element = e.target;
        while(!element.href){
            if (!element.parentNode) return true;
            element = element.parentNode;
        }
        var href = element.getAttribute('href');
        // ignore links for <a[data-prevent-history]>
        if (element.getAttribute('data-prevent-history')) return true;
        // ignore external links and anchors
        if (/^https?:\/\//.test(href) || href.slice(0, 1) === '#') return true;
        // ignore mailto links or tel
        if (href.slice(0, 7) === 'mailto:' || href.slice(0, 4) === 'tel:') return true;
        // let's do the magic
        e.preventDefault();
        try {
            app.ports.newurl.send(href);
        } catch (e) {
            console.error(e);
        }
        history.pushState(null, null, href);
        return false;
    }, true);
    window.addEventListener('popstate', function() {
        app.ports.newurl.send(window.location.pathname + window.location.search);
    });
    app.ports[portName].subscribe(function(href) {
        try {
            app.ports.newurl.send(href);
        } catch (e) {
            console.error(e);
        }
        history.pushState(null, null, href);
    });
};

});

parcelRegister("8oUNT", function(module, exports) {
function $61dca0a9cfd068cc$var$hoursToOffset(hours) {
    const sign = hours >= 0 ? "+" : "-";
    const absHours = Math.abs(hours);
    const pad = (num)=>num.toString().padStart(2, "0");
    return `${sign}${pad(absHours)}:00`;
}
Object.defineProperty(Event.prototype, "timezone", {
    get () {
        const offset = -(new Date().getTimezoneOffset() / 60);
        return this.target.value + $61dca0a9cfd068cc$var$hoursToOffset(offset);
    }
});
/*
 * <time-zone />
 * Gives a string representation of the navigator's timezone like "europe/paris".
 */ class $61dca0a9cfd068cc$var$TimeZone extends HTMLElement {
    constructor(){
        super();
        const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.attachShadow({
            mode: "open"
        });
        this.shadowRoot.innerHTML = timeZone;
    }
}
customElements.define("time-zone", $61dca0a9cfd068cc$var$TimeZone);

});

parcelRegister("3mVol", function(module, exports) {

var $bQTtn = parcelRequire("bQTtn");
var $01yxO = parcelRequire("01yxO");

var $9Mags = parcelRequire("9Mags");
var $273ff1f51366ad7c$var$localeFns = {
    locale: $9Mags.fr
};
/*
 * <format-time datetime="2020-06-04T12:27:06.222Z">
 */ class $273ff1f51366ad7c$var$FormatTime extends HTMLElement {
    constructor(){
        super();
        this.useRelativeDate = false;
    }
    connectedCallback() {
        this.render();
        this.onclick = function() {
            this.useRelativeDate = !this.useRelativeDate;
            this.render();
        };
    }
    render() {
        var x = new Date(this.getAttribute('datetime'));
        this.innerHTML = this.useRelativeDate ? $01yxO.formatRelative(x, new Date(), $273ff1f51366ad7c$var$localeFns) : $bQTtn.format(x, 'PP, p', $273ff1f51366ad7c$var$localeFns);
    }
}
customElements.define('format-time', $273ff1f51366ad7c$var$FormatTime);

});
parcelRegister("bQTtn", function(module, exports) {

$parcel$export(module.exports, "format", () => $8a0f94cf009a4946$export$d9468344d3651243);

var $lDwz3 = parcelRequire("lDwz3");

var $clqZR = parcelRequire("clqZR");

var $eU5LL = parcelRequire("eU5LL");

var $4lli5 = parcelRequire("4lli5");

var $9zwaQ = parcelRequire("9zwaQ");

var $gla4m = parcelRequire("gla4m");

var $9piCv = parcelRequire("9piCv");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $8a0f94cf009a4946$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $8a0f94cf009a4946$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $8a0f94cf009a4946$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $8a0f94cf009a4946$var$doubleQuoteRegExp = /''/g;
const $8a0f94cf009a4946$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $8a0f94cf009a4946$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $lDwz3.enUS);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $9piCv.toDate)(date, options?.in);
    if (!(0, $gla4m.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($8a0f94cf009a4946$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $4lli5.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8a0f94cf009a4946$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $8a0f94cf009a4946$var$cleanEscapedString(substring)
        };
        if ((0, $eU5LL.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($8a0f94cf009a4946$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $9zwaQ.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $9zwaQ.isProtectedDayOfYearToken)(token)) (0, $9zwaQ.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, $eU5LL.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $8a0f94cf009a4946$var$cleanEscapedString(input) {
    const matched = input.match($8a0f94cf009a4946$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($8a0f94cf009a4946$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$8a0f94cf009a4946$export$2e2bcd8739ae039 = $8a0f94cf009a4946$export$d9468344d3651243;

});
parcelRegister("lDwz3", function(module, exports) {

$parcel$export(module.exports, "enUS", () => $fc06801cb681cd51$export$137380d9ce54f7f);

var $186kz = parcelRequire("186kz");

var $kcojA = parcelRequire("kcojA");

var $5alD8 = parcelRequire("5alD8");

var $2qWXh = parcelRequire("2qWXh");

var $9mp8A = parcelRequire("9mp8A");
const $fc06801cb681cd51$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $186kz.formatDistance),
    formatLong: (0, $kcojA.formatLong),
    formatRelative: (0, $5alD8.formatRelative),
    localize: (0, $2qWXh.localize),
    match: (0, $9mp8A.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$fc06801cb681cd51$export$2e2bcd8739ae039 = $fc06801cb681cd51$export$137380d9ce54f7f;

});
parcelRegister("186kz", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $0d2b72f7daad25ab$export$2c14ff85d6318973);
const $0d2b72f7daad25ab$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0d2b72f7daad25ab$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $0d2b72f7daad25ab$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("kcojA", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $eb47ca12c1d82ea6$export$cbf60ecb96cbb82f);

var $27kCy = parcelRequire("27kCy");
const $eb47ca12c1d82ea6$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $eb47ca12c1d82ea6$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $eb47ca12c1d82ea6$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $eb47ca12c1d82ea6$export$cbf60ecb96cbb82f = {
    date: (0, $27kCy.buildFormatLongFn)({
        formats: $eb47ca12c1d82ea6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $27kCy.buildFormatLongFn)({
        formats: $eb47ca12c1d82ea6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $27kCy.buildFormatLongFn)({
        formats: $eb47ca12c1d82ea6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("27kCy", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", () => $18ac3b18a414568b$export$38e44e97ce4dbb7d);
function $18ac3b18a414568b$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("5alD8", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $3c2eaa3c76711534$export$8fbbfd65594f46a0);
const $3c2eaa3c76711534$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $3c2eaa3c76711534$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$3c2eaa3c76711534$var$formatRelativeLocale[token];

});

parcelRegister("2qWXh", function(module, exports) {

$parcel$export(module.exports, "localize", () => $1c5bbdbea2674188$export$b3bd0bc58e36cd63);

var $h8wHD = parcelRequire("h8wHD");
const $1c5bbdbea2674188$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $1c5bbdbea2674188$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $1c5bbdbea2674188$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $1c5bbdbea2674188$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $1c5bbdbea2674188$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $1c5bbdbea2674188$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $1c5bbdbea2674188$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $1c5bbdbea2674188$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1c5bbdbea2674188$var$ordinalNumber,
    era: (0, $h8wHD.buildLocalizeFn)({
        values: $1c5bbdbea2674188$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $h8wHD.buildLocalizeFn)({
        values: $1c5bbdbea2674188$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $h8wHD.buildLocalizeFn)({
        values: $1c5bbdbea2674188$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $h8wHD.buildLocalizeFn)({
        values: $1c5bbdbea2674188$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $h8wHD.buildLocalizeFn)({
        values: $1c5bbdbea2674188$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $1c5bbdbea2674188$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("h8wHD", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", () => $c79c8d23bc4e58f1$export$63596d6ee8878b25);
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $c79c8d23bc4e58f1$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("9mp8A", function(module, exports) {

$parcel$export(module.exports, "match", () => $6d09aaea8050d7cb$export$4659b591c19bdf3d);

var $21azF = parcelRequire("21azF");

var $ggD50 = parcelRequire("ggD50");
const $6d09aaea8050d7cb$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $6d09aaea8050d7cb$var$parseOrdinalNumberPattern = /\d+/i;
const $6d09aaea8050d7cb$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $6d09aaea8050d7cb$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $6d09aaea8050d7cb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $6d09aaea8050d7cb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6d09aaea8050d7cb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $6d09aaea8050d7cb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $6d09aaea8050d7cb$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $6d09aaea8050d7cb$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $6d09aaea8050d7cb$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $6d09aaea8050d7cb$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $6d09aaea8050d7cb$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $ggD50.buildMatchPatternFn)({
        matchPattern: $6d09aaea8050d7cb$var$matchOrdinalNumberPattern,
        parsePattern: $6d09aaea8050d7cb$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $21azF.buildMatchFn)({
        matchPatterns: $6d09aaea8050d7cb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d09aaea8050d7cb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $21azF.buildMatchFn)({
        matchPatterns: $6d09aaea8050d7cb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d09aaea8050d7cb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $21azF.buildMatchFn)({
        matchPatterns: $6d09aaea8050d7cb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d09aaea8050d7cb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $21azF.buildMatchFn)({
        matchPatterns: $6d09aaea8050d7cb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d09aaea8050d7cb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $21azF.buildMatchFn)({
        matchPatterns: $6d09aaea8050d7cb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6d09aaea8050d7cb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("21azF", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", () => $1783e097adacaea4$export$1430a0f35710914d);
function $1783e097adacaea4$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $1783e097adacaea4$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $1783e097adacaea4$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $1783e097adacaea4$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $1783e097adacaea4$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("ggD50", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", () => $bd7c7461c2ecc479$export$fdaf2fd6d7edde95);
function $bd7c7461c2ecc479$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("clqZR", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $8fcc633751370d5a$export$430a3269e24b912e);
let $8fcc633751370d5a$var$defaultOptions = {};
function $8fcc633751370d5a$export$430a3269e24b912e() {
    return $8fcc633751370d5a$var$defaultOptions;
}
function $8fcc633751370d5a$export$95365be1b0704abc(newOptions) {
    $8fcc633751370d5a$var$defaultOptions = newOptions;
}

});

parcelRegister("eU5LL", function(module, exports) {

$parcel$export(module.exports, "formatters", () => $ad9ac550a502d0dd$export$fe98a034cfb96d55);

var $2kNan = parcelRequire("2kNan");

var $7RD6s = parcelRequire("7RD6s");

var $gKHxq = parcelRequire("gKHxq");

var $3JkLZ = parcelRequire("3JkLZ");

var $2yLHC = parcelRequire("2yLHC");

var $1SrIf = parcelRequire("1SrIf");

var $1OfHQ = parcelRequire("1OfHQ");
const $ad9ac550a502d0dd$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $ad9ac550a502d0dd$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $1OfHQ.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $2yLHC.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $1SrIf.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $1SrIf.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $gKHxq.getISOWeekYear)(date);
        // Padding
        return (0, $1SrIf.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $1SrIf.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $1SrIf.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $1SrIf.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $1OfHQ.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $1SrIf.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $3JkLZ.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $1SrIf.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $7RD6s.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $1SrIf.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $1OfHQ.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $2kNan.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $1SrIf.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $1SrIf.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $1SrIf.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $1SrIf.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $1OfHQ.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $1OfHQ.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $1SrIf.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $1SrIf.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $1OfHQ.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $1OfHQ.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $1OfHQ.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $ad9ac550a502d0dd$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $ad9ac550a502d0dd$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $ad9ac550a502d0dd$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $ad9ac550a502d0dd$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $1SrIf.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $1SrIf.addLeadingZeros)(+date, token.length);
    }
};
function $ad9ac550a502d0dd$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $1SrIf.addLeadingZeros)(minutes, 2);
}
function $ad9ac550a502d0dd$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $1SrIf.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $ad9ac550a502d0dd$var$formatTimezone(offset, delimiter);
}
function $ad9ac550a502d0dd$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $1SrIf.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $1SrIf.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("2kNan", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", () => $1b33966f5fd76c6b$export$d3b42cd8452deec);

var $exQSP = parcelRequire("exQSP");

var $69LDz = parcelRequire("69LDz");

var $9piCv = parcelRequire("9piCv");
function $1b33966f5fd76c6b$export$d3b42cd8452deec(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const diff = (0, $exQSP.differenceInCalendarDays)(_date, (0, $69LDz.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$1b33966f5fd76c6b$export$2e2bcd8739ae039 = $1b33966f5fd76c6b$export$d3b42cd8452deec;

});
parcelRegister("exQSP", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", () => $a96d2b471ccbd713$export$4a02e9c37dab4871);

var $dL2Ic = parcelRequire("dL2Ic");

var $8k4Ky = parcelRequire("8k4Ky");

var $lXVqG = parcelRequire("lXVqG");

var $8Y3Vi = parcelRequire("8Y3Vi");
function $a96d2b471ccbd713$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $8k4Ky.normalizeDates)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $8Y3Vi.startOfDay)(laterDate_);
    const earlierStartOfDay = (0, $8Y3Vi.startOfDay)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $dL2Ic.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $dL2Ic.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $lXVqG.millisecondsInDay));
}
var // Fallback for modularized imports:
$a96d2b471ccbd713$export$2e2bcd8739ae039 = $a96d2b471ccbd713$export$4a02e9c37dab4871;

});
parcelRegister("dL2Ic", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", () => $a041c4b022a0abcb$export$113002b5eff6e430);

var $9piCv = parcelRequire("9piCv");
function $a041c4b022a0abcb$export$113002b5eff6e430(date) {
    const _date = (0, $9piCv.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});
parcelRegister("9piCv", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $6d94e4666b795786$export$e67a095c620b86fe);

var $4JKjc = parcelRequire("4JKjc");
function $6d94e4666b795786$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $4JKjc.constructFrom)(context || argument, argument);
}
var // Fallback for modularized imports:
$6d94e4666b795786$export$2e2bcd8739ae039 = $6d94e4666b795786$export$e67a095c620b86fe;

});
parcelRegister("4JKjc", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $372f49515f3dbe8b$export$ead8a1812b171991);

var $lXVqG = parcelRequire("lXVqG");
function $372f49515f3dbe8b$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $lXVqG.constructFromSymbol) in date) return date[0, $lXVqG.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$372f49515f3dbe8b$export$2e2bcd8739ae039 = $372f49515f3dbe8b$export$ead8a1812b171991;

});
parcelRegister("lXVqG", function(module, exports) {

$parcel$export(module.exports, "millisecondsInWeek", () => $ffdba7ec0b20562f$export$4fad13613e88edc8);
$parcel$export(module.exports, "millisecondsInDay", () => $ffdba7ec0b20562f$export$b76b1809a2898f9a);
$parcel$export(module.exports, "millisecondsInMinute", () => $ffdba7ec0b20562f$export$91246f0b9bd9beff);
$parcel$export(module.exports, "minutesInYear", () => $ffdba7ec0b20562f$export$3633035e63cee86a);
$parcel$export(module.exports, "minutesInMonth", () => $ffdba7ec0b20562f$export$ab7da2ccd1075c38);
$parcel$export(module.exports, "minutesInDay", () => $ffdba7ec0b20562f$export$2423174df8cd3cd2);
$parcel$export(module.exports, "constructFromSymbol", () => $ffdba7ec0b20562f$export$2a7b97929c48d47d);
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $ffdba7ec0b20562f$export$dfd9b671c89acc8e = 7;
const $ffdba7ec0b20562f$export$3913210603d8e9ae = 365.2425;
const $ffdba7ec0b20562f$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $ffdba7ec0b20562f$export$4dec998e48f9c246 = -$ffdba7ec0b20562f$export$81caae6e1cc7a622;
const $ffdba7ec0b20562f$export$4fad13613e88edc8 = 604800000;
const $ffdba7ec0b20562f$export$b76b1809a2898f9a = 86400000;
const $ffdba7ec0b20562f$export$91246f0b9bd9beff = 60000;
const $ffdba7ec0b20562f$export$7f72910d6dfd237a = 3600000;
const $ffdba7ec0b20562f$export$397c2d5776aa9055 = 1000;
const $ffdba7ec0b20562f$export$3633035e63cee86a = 525600;
const $ffdba7ec0b20562f$export$ab7da2ccd1075c38 = 43200;
const $ffdba7ec0b20562f$export$2423174df8cd3cd2 = 1440;
const $ffdba7ec0b20562f$export$f2f5ae5a8e2d8f9f = 60;
const $ffdba7ec0b20562f$export$3c58128db900d44e = 3;
const $ffdba7ec0b20562f$export$80d7e435f744f319 = 12;
const $ffdba7ec0b20562f$export$4db7641526e3241f = 4;
const $ffdba7ec0b20562f$export$698aec755e92c695 = 3600;
const $ffdba7ec0b20562f$export$a77c1a7ebebe2a5a = 60;
const $ffdba7ec0b20562f$export$815a9362476d2fe3 = $ffdba7ec0b20562f$export$698aec755e92c695 * 24;
const $ffdba7ec0b20562f$export$34804a017b31e2fe = $ffdba7ec0b20562f$export$815a9362476d2fe3 * 7;
const $ffdba7ec0b20562f$export$7271e9e3478110d1 = $ffdba7ec0b20562f$export$815a9362476d2fe3 * $ffdba7ec0b20562f$export$3913210603d8e9ae;
const $ffdba7ec0b20562f$export$8e6600bbdee7dabb = $ffdba7ec0b20562f$export$7271e9e3478110d1 / 12;
const $ffdba7ec0b20562f$export$be1dccf2de902d31 = $ffdba7ec0b20562f$export$8e6600bbdee7dabb * 3;
const $ffdba7ec0b20562f$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");

});




parcelRegister("8k4Ky", function(module, exports) {

$parcel$export(module.exports, "normalizeDates", () => $60f3e039e35760d5$export$9f53b88e82f64d8d);

var $4JKjc = parcelRequire("4JKjc");
function $60f3e039e35760d5$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $4JKjc.constructFrom).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}

});

parcelRegister("8Y3Vi", function(module, exports) {

$parcel$export(module.exports, "startOfDay", () => $6876f85f60833acc$export$63fa379ae8a9ba2);

var $9piCv = parcelRequire("9piCv");
function $6876f85f60833acc$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$6876f85f60833acc$export$2e2bcd8739ae039 = $6876f85f60833acc$export$63fa379ae8a9ba2;

});


parcelRegister("69LDz", function(module, exports) {

$parcel$export(module.exports, "startOfYear", () => $47b8891ac047b76a$export$f91e89d3d0406102);

var $9piCv = parcelRequire("9piCv");
function $47b8891ac047b76a$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $9piCv.toDate)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$47b8891ac047b76a$export$2e2bcd8739ae039 = $47b8891ac047b76a$export$f91e89d3d0406102;

});


parcelRegister("7RD6s", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", () => $5b9bd0b6d332dc16$export$7cabdc5698b63e2f);

var $lXVqG = parcelRequire("lXVqG");

var $ceCiY = parcelRequire("ceCiY");

var $e8Lwm = parcelRequire("e8Lwm");

var $9piCv = parcelRequire("9piCv");
function $5b9bd0b6d332dc16$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const diff = +(0, $ceCiY.startOfISOWeek)(_date) - +(0, $e8Lwm.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $lXVqG.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$5b9bd0b6d332dc16$export$2e2bcd8739ae039 = $5b9bd0b6d332dc16$export$7cabdc5698b63e2f;

});
parcelRegister("ceCiY", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", () => $8e84816b02742985$export$6173213f95a4431e);

var $7fUGY = parcelRequire("7fUGY");
function $8e84816b02742985$export$6173213f95a4431e(date, options) {
    return (0, $7fUGY.startOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$8e84816b02742985$export$2e2bcd8739ae039 = $8e84816b02742985$export$6173213f95a4431e;

});
parcelRegister("7fUGY", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", () => $5485e8fa6e6fea88$export$42c81a444fbfb5d4);

var $clqZR = parcelRequire("clqZR");

var $9piCv = parcelRequire("9piCv");
function $5485e8fa6e6fea88$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$5485e8fa6e6fea88$export$2e2bcd8739ae039 = $5485e8fa6e6fea88$export$42c81a444fbfb5d4;

});


parcelRegister("e8Lwm", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", () => $a4b6acbd542cebd6$export$236bdfa374eb69a9);

var $4JKjc = parcelRequire("4JKjc");

var $gKHxq = parcelRequire("gKHxq");

var $ceCiY = parcelRequire("ceCiY");
function $a4b6acbd542cebd6$export$236bdfa374eb69a9(date, options) {
    const year = (0, $gKHxq.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, $4JKjc.constructFrom)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $ceCiY.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$a4b6acbd542cebd6$export$2e2bcd8739ae039 = $a4b6acbd542cebd6$export$236bdfa374eb69a9;

});
parcelRegister("gKHxq", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", () => $c322b6f7d3bab504$export$3dbc52535f6f8fcc);

var $4JKjc = parcelRequire("4JKjc");

var $ceCiY = parcelRequire("ceCiY");

var $9piCv = parcelRequire("9piCv");
function $c322b6f7d3bab504$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $4JKjc.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $ceCiY.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $4JKjc.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $ceCiY.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$c322b6f7d3bab504$export$2e2bcd8739ae039 = $c322b6f7d3bab504$export$3dbc52535f6f8fcc;

});



parcelRegister("3JkLZ", function(module, exports) {

$parcel$export(module.exports, "getWeek", () => $2b75b02ab160a67b$export$efe19b760242b2fc);

var $lXVqG = parcelRequire("lXVqG");

var $7fUGY = parcelRequire("7fUGY");

var $3uwsX = parcelRequire("3uwsX");

var $9piCv = parcelRequire("9piCv");
function $2b75b02ab160a67b$export$efe19b760242b2fc(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const diff = +(0, $7fUGY.startOfWeek)(_date, options) - +(0, $3uwsX.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $lXVqG.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$2b75b02ab160a67b$export$2e2bcd8739ae039 = $2b75b02ab160a67b$export$efe19b760242b2fc;

});
parcelRegister("3uwsX", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", () => $28ad5b80ef4531e0$export$bb7b45bb8e74da0f);

var $clqZR = parcelRequire("clqZR");

var $4JKjc = parcelRequire("4JKjc");

var $2yLHC = parcelRequire("2yLHC");

var $7fUGY = parcelRequire("7fUGY");
function $28ad5b80ef4531e0$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $2yLHC.getWeekYear)(date, options);
    const firstWeek = (0, $4JKjc.constructFrom)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $7fUGY.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$28ad5b80ef4531e0$export$2e2bcd8739ae039 = $28ad5b80ef4531e0$export$bb7b45bb8e74da0f;

});
parcelRegister("2yLHC", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", () => $1dd3c2775aeead00$export$12d572480ceb6e58);

var $clqZR = parcelRequire("clqZR");

var $4JKjc = parcelRequire("4JKjc");

var $7fUGY = parcelRequire("7fUGY");

var $9piCv = parcelRequire("9piCv");
function $1dd3c2775aeead00$export$12d572480ceb6e58(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $4JKjc.constructFrom)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $7fUGY.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $4JKjc.constructFrom)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $7fUGY.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$1dd3c2775aeead00$export$2e2bcd8739ae039 = $1dd3c2775aeead00$export$12d572480ceb6e58;

});



parcelRegister("1SrIf", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", () => $15e054c450fa906c$export$c8306e720e213c0f);
function $15e054c450fa906c$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("1OfHQ", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", () => $1516a4dede9b3dcb$export$b0d4b338e1516f13);

var $1SrIf = parcelRequire("1SrIf");
const $1516a4dede9b3dcb$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $1SrIf.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $1SrIf.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $1SrIf.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $1SrIf.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $1SrIf.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $1SrIf.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $1SrIf.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $1SrIf.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("4lli5", function(module, exports) {

$parcel$export(module.exports, "longFormatters", () => $3299a3782897d2c4$export$70cc8fd02856fd58);
const $3299a3782897d2c4$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $3299a3782897d2c4$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $3299a3782897d2c4$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $3299a3782897d2c4$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $3299a3782897d2c4$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $3299a3782897d2c4$var$timeLongFormatter(timePattern, formatLong));
};
const $3299a3782897d2c4$export$70cc8fd02856fd58 = {
    p: $3299a3782897d2c4$var$timeLongFormatter,
    P: $3299a3782897d2c4$var$dateTimeLongFormatter
};

});

parcelRegister("9zwaQ", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $6f8057073b26e801$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $6f8057073b26e801$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "warnOrThrowProtectedError", () => $6f8057073b26e801$export$f5f38f90ecaaf879);
const $6f8057073b26e801$var$dayOfYearTokenRE = /^D+$/;
const $6f8057073b26e801$var$weekYearTokenRE = /^Y+$/;
const $6f8057073b26e801$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $6f8057073b26e801$export$c6cc36aa33304772(token) {
    return $6f8057073b26e801$var$dayOfYearTokenRE.test(token);
}
function $6f8057073b26e801$export$c6b49d6dceb604a1(token) {
    return $6f8057073b26e801$var$weekYearTokenRE.test(token);
}
function $6f8057073b26e801$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $6f8057073b26e801$var$message(token, format, input);
    console.warn(_message);
    if ($6f8057073b26e801$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $6f8057073b26e801$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("gla4m", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $be566b14e93ea1f9$export$1ea939691cdc45b8);

var $bicdS = parcelRequire("bicdS");

var $9piCv = parcelRequire("9piCv");
function $be566b14e93ea1f9$export$1ea939691cdc45b8(date) {
    return !(!(0, $bicdS.isDate)(date) && typeof date !== "number" || isNaN(+(0, $9piCv.toDate)(date)));
}
var // Fallback for modularized imports:
$be566b14e93ea1f9$export$2e2bcd8739ae039 = $be566b14e93ea1f9$export$1ea939691cdc45b8;

});
parcelRegister("bicdS", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $838adb5272615574$export$871608497c498473);
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $838adb5272615574$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$838adb5272615574$export$2e2bcd8739ae039 = $838adb5272615574$export$871608497c498473;

});



parcelRegister("01yxO", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $004ae3e38e95f2b8$export$8fbbfd65594f46a0);

var $lDwz3 = parcelRequire("lDwz3");

var $clqZR = parcelRequire("clqZR");

var $8k4Ky = parcelRequire("8k4Ky");

var $exQSP = parcelRequire("exQSP");

var $bQTtn = parcelRequire("bQTtn");
function $004ae3e38e95f2b8$export$8fbbfd65594f46a0(date, baseDate, options) {
    const [date_, baseDate_] = (0, $8k4Ky.normalizeDates)(options?.in, date, baseDate);
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $lDwz3.enUS);
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $exQSP.differenceInCalendarDays)(date_, baseDate_);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, date_, baseDate_, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $bQTtn.format)(date_, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}
var // Fallback for modularized imports:
$004ae3e38e95f2b8$export$2e2bcd8739ae039 = $004ae3e38e95f2b8$export$8fbbfd65594f46a0;

});

parcelRegister("9Mags", function(module, exports) {

$parcel$export(module.exports, "fr", () => $71e08f0cb96e66bd$export$acb2a88f7d552ebf);

var $ajAml = parcelRequire("ajAml");

var $bu71Y = parcelRequire("bu71Y");

var $6eCfD = parcelRequire("6eCfD");

var $eKJ2Y = parcelRequire("eKJ2Y");

var $eLBeG = parcelRequire("eLBeG");
const $71e08f0cb96e66bd$export$acb2a88f7d552ebf = {
    code: "fr",
    formatDistance: (0, $ajAml.formatDistance),
    formatLong: (0, $bu71Y.formatLong),
    formatRelative: (0, $6eCfD.formatRelative),
    localize: (0, $eKJ2Y.localize),
    match: (0, $eLBeG.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$71e08f0cb96e66bd$export$2e2bcd8739ae039 = $71e08f0cb96e66bd$export$acb2a88f7d552ebf;

});
parcelRegister("ajAml", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $7827e1ee3e178330$export$2c14ff85d6318973);
const $7827e1ee3e178330$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
const $7827e1ee3e178330$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const form = $7827e1ee3e178330$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};

});

parcelRegister("bu71Y", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $85c7f333f81b7d01$export$cbf60ecb96cbb82f);

var $27kCy = parcelRequire("27kCy");
const $85c7f333f81b7d01$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $85c7f333f81b7d01$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $85c7f333f81b7d01$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $85c7f333f81b7d01$export$cbf60ecb96cbb82f = {
    date: (0, $27kCy.buildFormatLongFn)({
        formats: $85c7f333f81b7d01$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $27kCy.buildFormatLongFn)({
        formats: $85c7f333f81b7d01$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $27kCy.buildFormatLongFn)({
        formats: $85c7f333f81b7d01$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("6eCfD", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $48a1b8c5b94b87ba$export$8fbbfd65594f46a0);
const $48a1b8c5b94b87ba$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
const $48a1b8c5b94b87ba$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$48a1b8c5b94b87ba$var$formatRelativeLocale[token];

});

parcelRegister("eKJ2Y", function(module, exports) {

$parcel$export(module.exports, "localize", () => $abd84df413b635c4$export$b3bd0bc58e36cd63);

var $h8wHD = parcelRequire("h8wHD");
const $abd84df413b635c4$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
const $abd84df413b635c4$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
const $abd84df413b635c4$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
const $abd84df413b635c4$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
const $abd84df413b635c4$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
const $abd84df413b635c4$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return "0";
    const feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    let suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
const $abd84df413b635c4$var$LONG_MONTHS_TOKENS = [
    "MMM",
    "MMMM"
];
const $abd84df413b635c4$export$b3bd0bc58e36cd63 = {
    preprocessor: (date, parts)=>{
        // Replaces the `do` tokens with `d` when used with long month tokens and the day of the month is greater than one.
        // Use case "do MMMM" => 1er août, 29 août
        // see https://github.com/date-fns/date-fns/issues/1391
        if (date.getDate() === 1) return parts;
        const hasLongMonthToken = parts.some((part)=>part.isToken && $abd84df413b635c4$var$LONG_MONTHS_TOKENS.includes(part.value));
        if (!hasLongMonthToken) return parts;
        return parts.map((part)=>part.isToken && part.value === "do" ? {
                isToken: true,
                value: "d"
            } : part);
    },
    ordinalNumber: $abd84df413b635c4$var$ordinalNumber,
    era: (0, $h8wHD.buildLocalizeFn)({
        values: $abd84df413b635c4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $h8wHD.buildLocalizeFn)({
        values: $abd84df413b635c4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $h8wHD.buildLocalizeFn)({
        values: $abd84df413b635c4$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $h8wHD.buildLocalizeFn)({
        values: $abd84df413b635c4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $h8wHD.buildLocalizeFn)({
        values: $abd84df413b635c4$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("eLBeG", function(module, exports) {

$parcel$export(module.exports, "match", () => $ac0256b859bbb5bc$export$4659b591c19bdf3d);

var $21azF = parcelRequire("21azF");

var $ggD50 = parcelRequire("ggD50");
const $ac0256b859bbb5bc$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
const $ac0256b859bbb5bc$var$parseOrdinalNumberPattern = /\d+/i;
const $ac0256b859bbb5bc$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
const $ac0256b859bbb5bc$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $ac0256b859bbb5bc$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
const $ac0256b859bbb5bc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ac0256b859bbb5bc$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
const $ac0256b859bbb5bc$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $ac0256b859bbb5bc$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
const $ac0256b859bbb5bc$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
const $ac0256b859bbb5bc$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
const $ac0256b859bbb5bc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
const $ac0256b859bbb5bc$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $ggD50.buildMatchPatternFn)({
        matchPattern: $ac0256b859bbb5bc$var$matchOrdinalNumberPattern,
        parsePattern: $ac0256b859bbb5bc$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $21azF.buildMatchFn)({
        matchPatterns: $ac0256b859bbb5bc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac0256b859bbb5bc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $21azF.buildMatchFn)({
        matchPatterns: $ac0256b859bbb5bc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac0256b859bbb5bc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $21azF.buildMatchFn)({
        matchPatterns: $ac0256b859bbb5bc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac0256b859bbb5bc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $21azF.buildMatchFn)({
        matchPatterns: $ac0256b859bbb5bc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac0256b859bbb5bc$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $21azF.buildMatchFn)({
        matchPatterns: $ac0256b859bbb5bc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ac0256b859bbb5bc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});



parcelRegister("4ARPW", function(module, exports) {

var $bQTtn = parcelRequire("bQTtn");

var $9Mags = parcelRequire("9Mags");
var $358449145bcc6074$var$localeFns = {
    locale: $9Mags.fr
};
/*
 * <format-date datetime="2020-06-04T12:27:06.222Z">
 */ class $358449145bcc6074$var$FormatDate extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.render();
        this.onclick = function() {
            this.render();
        };
    }
    render() {
        var x = new Date(this.getAttribute('datetime'));
        this.innerHTML = $bQTtn.format(x, 'PP', $358449145bcc6074$var$localeFns);
    }
}
customElements.define('format-date', $358449145bcc6074$var$FormatDate);

});

parcelRegister("5JGum", function(module, exports) {

var $hZ3s7 = parcelRequire("hZ3s7");

var $9Mags = parcelRequire("9Mags");
var $42d21d1d2554d6c6$var$localeFns = {
    locale: $9Mags.fr
};
/*
 * <format-distance startdate="2020-06-04T12:27:06.222Z" enddate="2021-06-04T12:27:06.222Z">
 */ class $42d21d1d2554d6c6$var$DistanceTime extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.render();
    }
    render() {
        var start = new Date(this.getAttribute('startdate'));
        var end = new Date(this.getAttribute('enddate'));
        this.innerHTML = $hZ3s7.formatDistanceStrict(end, start, $42d21d1d2554d6c6$var$localeFns);
    }
}
customElements.define('format-distance', $42d21d1d2554d6c6$var$DistanceTime);

});
parcelRegister("hZ3s7", function(module, exports) {

$parcel$export(module.exports, "formatDistanceStrict", () => $d17acfca019529ad$export$e4be225b8ee0a759);

var $lDwz3 = parcelRequire("lDwz3");

var $clqZR = parcelRequire("clqZR");

var $6XJQC = parcelRequire("6XJQC");

var $dL2Ic = parcelRequire("dL2Ic");

var $8k4Ky = parcelRequire("8k4Ky");

var $5u67A = parcelRequire("5u67A");

var $lXVqG = parcelRequire("lXVqG");
function $d17acfca019529ad$export$e4be225b8ee0a759(laterDate, earlierDate, options) {
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $lDwz3.enUS);
    const comparison = (0, $5u67A.compareAsc)(laterDate, earlierDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    const [laterDate_, earlierDate_] = (0, $8k4Ky.normalizeDates)(options?.in, ...comparison > 0 ? [
        earlierDate,
        laterDate
    ] : [
        laterDate,
        earlierDate
    ]);
    const roundingMethod = (0, $6XJQC.getRoundingMethod)(options?.roundingMethod ?? "round");
    const milliseconds = earlierDate_.getTime() - laterDate_.getTime();
    const minutes = milliseconds / (0, $lXVqG.millisecondsInMinute);
    const timezoneOffset = (0, $dL2Ic.getTimezoneOffsetInMilliseconds)(earlierDate_) - (0, $dL2Ic.getTimezoneOffsetInMilliseconds)(laterDate_);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / (0, $lXVqG.millisecondsInMinute);
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < (0, $lXVqG.minutesInDay)) unit = "hour";
        else if (dstNormalizedMinutes < (0, $lXVqG.minutesInMonth)) unit = "day";
        else if (dstNormalizedMinutes < (0, $lXVqG.minutesInYear)) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / (0, $lXVqG.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / (0, $lXVqG.minutesInMonth));
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / (0, $lXVqG.minutesInYear));
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}
var // Fallback for modularized imports:
$d17acfca019529ad$export$2e2bcd8739ae039 = $d17acfca019529ad$export$e4be225b8ee0a759;

});
parcelRegister("6XJQC", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $511bd12385432cec$export$b6474a47258c1211);
function $511bd12385432cec$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("5u67A", function(module, exports) {

$parcel$export(module.exports, "compareAsc", () => $3fe480aea1043697$export$fe114145ae75d197);

var $9piCv = parcelRequire("9piCv");
function $3fe480aea1043697$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $9piCv.toDate)(dateLeft) - +(0, $9piCv.toDate)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$3fe480aea1043697$export$2e2bcd8739ae039 = $3fe480aea1043697$export$fe114145ae75d197;

});



parcelRegister("3Ii3I", function(module, exports) {
module.exports = function raf(app) {
    var lastTime = 0;
    var vendors = [
        'ms',
        'moz',
        'webkit',
        'o'
    ];
    var usingSetTimeout = false;
    if (!window.requestAnimationFrame) vendors.forEach(function(prefix) {
        window.requestAnimationFrame = window[prefix + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[prefix + 'CancelAnimationFrame'] || window[prefix + 'CancelRequestAnimationFrame'];
    });
    if (!window.requestAnimationFrame) {
        usingSetTimeout = true;
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
    if (!window.cancelAnimationFrame) {
        if (usingSetTimeout) window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
        else window.cancelAnimationFrame = function() {};
    }
    return app;
};

});

parcelRegister("4lCIN", function(module, exports) {
module.exports = function keyboard(app) {
    window.addEventListener('keypress', function(e) {
        if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA") ;
        else app.ports.onKeypressNoInput.send(e.keyCode);
    });
// window.addEventListener('keydown', function (e) {
//   if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA") {
//     // filling a form...
//   } else {
//     // do not scroll
//     if (e.keyCode == 32) e.preventDefault();
//     app.ports.onKeydownNoInput.send(e.keyCode);
//   }
// });
// window.addEventListener('keyup', function (e) {
//   if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA") {
//     // filling a form...
//   } else {
//     app.ports.onKeyupNoInput.send(e.keyCode);
//   }
// });
};

});

parcelRegister("56a0I", function(module, exports) {
module.exports = function viewport(app) {
    window.onresize = function() {
        app.ports.viewport.send({
            width: window.innerWidth,
            height: window.innerHeight,
            isFullscreen: !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement)
        });
    };
};

});

parcelRegister("j63Xd", function(module, exports) {
window.document.body.addEventListener("click", function(e) {
    var target = e.target;
    var current = document.getElementById("CatchClickAll");
    if (!current) return true;
    do {
        if (target === current) return true;
    }while (target = target.parentNode);
    current.click();
}, true);

});

parcelRegister("fFcjN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3704c843920dcfc2$export$2e2bcd8739ae039);

var $ffDwH = parcelRequire("ffDwH");

var $kjMit = parcelRequire("kjMit");

var $eqZ8F = parcelRequire("eqZ8F");

var $8dcRR = parcelRequire("8dcRR");

var $gguoi = parcelRequire("gguoi");

var $6jqaU = parcelRequire("6jqaU");
const $3704c843920dcfc2$var$$ = $gguoi.$;
var $3704c843920dcfc2$var$shakaVideoContainer;
// shaka buffer config (in second)
const $3704c843920dcfc2$var$BUFFERBEHIND = 300;
const $3704c843920dcfc2$var$BUFFERINGGOAL = 300;
const $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY = 0.00001;
const $3704c843920dcfc2$var$IS_IOS = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
function $3704c843920dcfc2$export$2e2bcd8739ae039(app) {
    function sendEventToElm(event) {
        app.ports.jsToElm?.send(Object.assign({
            action: '',
            buffer: [
                {
                    start: 0,
                    end: 0
                }
            ],
            frame: 0
        }, event));
    }
    function preventDefaultWindowOnSpace(event) {
        if (event.key == ' ' && ![
            'INPUT',
            'TEXTAREA'
        ].includes(event.target.nodeName)) event.preventDefault();
    }
    function computeCurrentFrame(video, frameRate, supportFrameAccuracy) {
        if (supportFrameAccuracy) return $8dcRR(video);
        else return Math.floor(video.currentTime * frameRate);
    }
    class Nomaplayer extends HTMLElement {
        constructor(){
            super(), this.state = {
                selectedTracks: [],
                audiotracks: [],
                manifest: '',
                player: {},
                currentSubtitle: '',
                frameRate: 0,
                startTimecode: '00:00:00:00'
            }, this.frameAccuracySupport = true, // Timecode input
            this.maskInput = {}, this.timecodeMaskElt = {}, // Timecode overlay
            this.timeMaskElt = {}, this.timeCursorElt = {}, this.timeTCElt = {}, // Proxy `this` inside listener
            this.videoProgressListener = (event)=>this.onVideoProgress(event), this.inputFocusListener = ()=>this.getVideo().pause(), this.inputBlurListener = ()=>setTimeout(()=>this.getVideo().focus(), 10), this.moveTimecodeListener = (event)=>this.moveTimecode(event), this.requestFrameTimecodeOverlayListener = ()=>this.requestFrameTimecodeOverlay(), this.portsFromElm = (event)=>this.eventFromElm(event), this.onTimeMaskClickListener = (event)=>this.onTimeMaskClick(event), this.keyUpVideo = (event)=>{
                if (!(event.target.tagName === 'INPUT' || event.target.tagName === 'SELECT' || event.target.tagName === 'TEXTAREA')) switch(event.keyCode){
                    // space
                    case 32:
                        if (this.getVideo().paused) this.play();
                        else this.pause();
                        break;
                    // Left arrow
                    case 37:
                        this.prevFrame();
                        break;
                    // Right arrow
                    case 39:
                        this.nextFrame();
                }
            };
            $6jqaU.polyfill.installAll();
            this.attachShadow({
                mode: 'open'
            });
            this.frameAccuracySupport = !(!$6jqaU.Player.isBrowserSupported() || $3704c843920dcfc2$var$IS_IOS);
            const videoCtrl = document.createElement('div');
            $3704c843920dcfc2$var$shakaVideoContainer = videoCtrl;
            const videoStyles = document.createElement('style');
            videoStyles.innerHTML = `
.shaka-hidden{display:none!important}
.shaka-video-container{pointer-events:none;position:absolute;left:1vw;right:1vw;top:1vw;bottom:1vw;display:flex}

.shaka-text-container{position:absolute;left:0;right:0;top:0;bottom:0;font-size:1vw;line-height:1.4;color:#fff}
.shaka-text-container span.shaka-text-wrapper{display:inline;background:0 0}
@media (min-width: 1000px) and (max-width: 1400px) { .shaka-text-container { font-size: 1.55vw; } }
@media (max-width: 1000px) { .shaka-text-container { font-size: 2.2vw; } }
.PlayerFullScreen .shaka-text-container { font-size: 2.2vw !important; }
.shaka-text-container * { background-color: rgba(0,0,0,0) !important; }
.shaka-text-container {
  text-shadow: 0 0 0.11vw #000, 0 0 2px #000, 0 0 2px #000;
}
.PlayerControlsShown.shaka-video-container { bottom: calc(90px + 1vw); }

.shaka-spinner-container{display:none;}
      `;
            const video = document.createElement('video');
            video.setAttribute('style', 'width: 100%;display: block;margin-top: -3.68%;');
            video.setAttribute('id', 'video-player');
            video.setAttribute('playsinline', '');
            video.setAttribute('crossOrigin', 'anonymous');
            this.shadowRoot?.appendChild(video);
            this.shadowRoot?.appendChild(videoCtrl);
            this.shadowRoot?.appendChild(videoStyles);
        }
        connectedCallback() {
            this.initVariables();
            fetch(new Request(`/v4/proxy/${this.getAttribute('data-manifest')}/play`, {
                method: 'POST'
            }));
            this.render();
            app.ports.elmToJs?.subscribe(this.portsFromElm);
        }
        disconnectedCallback() {
            app.ports.elmToJs?.unsubscribe(this.portsFromElm);
            this.maskInput.destroy();
            this.ui.destroy();
            return this.state.player.destroy().then(()=>{
                this.state = {
                    selectedTracks: [],
                    audiotracks: [],
                    manifest: '',
                    player: {},
                    currentSubtitle: '',
                    frameRate: 0,
                    startTimecode: '00:00:00:00'
                };
                this.timecodeMaskElt.removeEventListener('focus', this.inputFocusListener);
                this.timecodeMaskElt.removeEventListener('blur', this.inputBlurListener);
                this.timeMaskElt.removeEventListener('mousemove', this.moveTimecodeListener);
                this.timeMaskElt.removeEventListener('mouseleave', this.requestFrameTimecodeOverlayListener);
                this.timeMaskElt.removeEventListener('click', this.onTimeMaskClickListener);
                this.getVideo().removeEventListener('ended', this.ended);
                this.getVideo().removeEventListener('progress', this.onVideoLoading);
                this.getVideo().removeEventListener('timeupdate', this.videoProgressListener);
                this.getVideo().removeEventListener('click', this.playOrPause);
                this.getVideo().removeEventListener('dblclick', this.handleFullScreen);
                window.removeEventListener('keydown', preventDefaultWindowOnSpace);
                window.removeEventListener('keyup', this.keyUpVideo);
            });
        }
        initVariables() {
            const manifest = this.getAttribute('data-manifest');
            if (manifest) this.state.manifest = manifest;
            const audiostracks = this.getAttribute('data-audiostracks');
            if (audiostracks) {
                this.state.audiotracks = JSON.parse(audiostracks);
                if (!this.state.audiotracks.length) this.state.audiotracks.push('1');
            }
            const playbackSpeed = this.getAttribute('data-playbackspeed');
            if (playbackSpeed) this.getVideo().playbackRate = parseFloat(playbackSpeed);
            const subtitles = this.getAttribute('data-subtitles');
            if (subtitles) this.state.currentSubtitle = subtitles;
            const framerate = this.getAttribute('data-framerate');
            if (framerate) this.state.frameRate = parseFloat(framerate);
            const startTimecode = this.getAttribute('data-starttimecode');
            if (startTimecode) this.state.startTimecode = startTimecode;
        }
        static get observedAttributes() {
            return [
                'data-manifest',
                'data-audiostracks',
                'data-playbackspeed',
                'data-subtitles',
                'data-framerate',
                'data-starttimecode'
            ];
        }
        attributeChangedCallback(name, _, newValue) {
            switch(name){
                case 'data-audiostracks':
                    this.state.audiotracks = JSON.parse(newValue);
                    if (Object.entries(this.state.player).length !== 0) this.loadVideo();
                    break;
                case 'data-manifest':
                    const isInitialized = this.state.manifest !== '';
                    this.state.manifest = newValue;
                    // Clear the current player if the manifest change and it was already initialized
                    if (isInitialized) {
                        if (this.state.player.destroy) return this.state.player.destroy().then(()=>this.initPlayer());
                        this.initPlayer();
                    }
                    break;
                case 'data-starttimecode':
                    this.state.startTimecode = newValue;
                    break;
                case 'data-playbackspeed':
                    if (newValue) this.getVideo().playbackRate = parseFloat(newValue);
                    break;
                case 'data-framerate':
                    if (newValue) this.state.frameRate = parseFloat(newValue);
                    break;
                case 'data-subtitles':
                    if (newValue != null) {
                        this.state.currentSubtitle = newValue;
                        if (this.state.player.destroy) return this.state.player.destroy().then(()=>this.initPlayer());
                        this.initPlayer();
                    }
                    break;
                default:
            }
        }
        eventFromElm(event) {
            switch(event.action){
                case 'Play':
                    this.play();
                    break;
                case 'Pause':
                    this.pause();
                    break;
                case 'GoTo':
                    if (event.frame !== undefined) this.goToFrame(event.frame);
                    break;
                case 'GoToStart':
                    this.goToStart();
                    break;
                case 'GoToEnd':
                    this.goToEnd();
                    break;
                case 'SubstractTime':
                    if (event.seconds !== undefined) this.substractTime(event.seconds);
                    break;
                case 'AddTime':
                    if (event.seconds !== undefined) this.addTime(event.seconds);
                    break;
                case 'NextFrame':
                    this.nextFrame();
                    break;
                case 'PrevFrame':
                    this.prevFrame();
                    break;
                case 'Fullscreen':
                    this.handleFullScreen();
                    break;
                case 'Aspectratio':
                    if (event.trackSelection !== undefined) this.state.selectedTracks = event.trackSelection;
                    break;
                case 'GetPicture':
                    if (event.rawFrame !== undefined) this.rawFrame(event.rawFrame);
                    break;
            }
        }
        play() {
            this.getVideo().play();
        }
        pause() {
            this.getVideo().pause();
        }
        playOrPause(event) {
            const videoElt = event.currentTarget;
            if (videoElt.paused) videoElt.play();
            else videoElt.pause();
        }
        substractTime(seconds) {
            if (this.getVideo().currentTime - seconds > 0) this.getVideo().currentTime -= seconds;
            else this.getVideo().currentTime = 0;
        }
        addTime(seconds) {
            if (this.getVideo().currentTime + seconds < this.getVideo().duration) this.getVideo().currentTime += seconds;
            else // Since setting the duration of the video make it bug, just remove the little constant to make it works
            this.getVideo().currentTime = this.getVideo().duration - $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
        }
        goToFrame(frame) {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            if (!isNaN(currentFrame)) {
                const lastFrameNumber = Math.floor(this.state.frameRate * this.getVideo().duration) - 1;
                if (frame < 0) frame = 0;
                if (frame > lastFrameNumber) frame = lastFrameNumber;
                this.getVideo().currentTime = frame / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
            }
        }
        nextFrame() {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            if (!isNaN(currentFrame)) {
                const lastFrameNumber = Math.floor(this.state.frameRate * this.getVideo().duration) - 1;
                if (currentFrame < lastFrameNumber) this.getVideo().currentTime = (currentFrame + 1) / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
            }
        }
        prevFrame() {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            if (!isNaN(currentFrame)) {
                const frameNumber = isNaN(currentFrame) ? null : currentFrame;
                if (frameNumber != null && frameNumber > 0) this.getVideo().currentTime = (currentFrame - 1) / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
            }
        }
        goToStart() {
            this.getVideo().currentTime = 0;
        }
        goToEnd() {
            const totalFrames = Math.round(this.state.frameRate * this.getVideo().duration);
            this.getVideo().currentTime = (totalFrames - 1) / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
        }
        rawFrame(params) {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            const frameNumber = isNaN(currentFrame) ? null : currentFrame;
            if (frameNumber != null) {
                const seconds = Math.floor(frameNumber / params.frameRate * 100) / 100;
                const imageUrl = `${window.nomalab.raw_frame_url}?bucket=${params.bucket}&key=${params.key}&seconds=${seconds}&user=${window.nomalab.user.id}`;
                const newWin = open('', '', 'height=1920,width=1080,toolbar=no,location=no,directories=no,status=no');
                if (newWin) newWin.document.write((0, $ffDwH.render)(imageUrl));
            }
        }
        getVideo() {
            return this.shadowRoot?.childNodes[0];
        }
        getMpdUrl() {
            const subtitle = this.state.currentSubtitle ? `?subtitle=${this.state.currentSubtitle}` : '';
            return `/v3/files/${this.state.manifest}/manifest${subtitle}`;
        }
        getMp4Url() {
            return fetch(this.getMpdUrl()).then((resp)=>{
                if (resp.ok) return resp.text().then((xml)=>{
                    let url = xml.match(/>([^>]+video_[^<]+\.mp4[^<]+)</g)[0].slice(1, -1);
                    let txt = document.createElement("textarea");
                    txt.innerHTML = url;
                    return txt.value;
                });
            });
        }
        // TODO Move this back in the elm
        displaySelectedVideo() {
            const videoStream = $3704c843920dcfc2$var$$('[name=selected-video-track]');
            if (videoStream) videoStream.checked = true;
        }
        onTimeMaskClick(event) {
            const b = this.timeMaskElt.getBoundingClientRect();
            const frame = Math.round((event.x - b.x) / b.width * this.state.frameRate * (this.getVideo().duration - 1 / this.state.frameRate));
            this.goToFrame(frame);
        }
        loadVideoOnly() {
            this.getMp4Url().then((url)=>{
                this.getVideo().src = url;
                this.getVideo().play();
            });
        }
        loadVideo() {
            this.state.player.setTextTrackVisibility(this.state.currentSubtitle != '' && this.state.currentSubtitle != null);
            const tracks = this.state.player.getVariantTracks();
            const trackIndex = parseInt(this.state.audiotracks[0]);
            const selectedTrack = tracks.find((el)=>{
                if (el.label?.includes('audio_stream')) {
                    const searchId = new RegExp("audio_stream_([^//]+)$");
                    const trackId = parseInt(el.label.replace(searchId, '$1'));
                    return trackId === (trackIndex || 0);
                }
                return false;
            });
            if (selectedTrack) {
                this.displaySelectedVideo();
                app.ports.updateAudioStreams.send([
                    [
                        trackIndex,
                        null
                    ]
                ]);
                this.state.player.selectVariantTrack(selectedTrack, true);
            }
            // Timecode input
            const timecodeMaskElt = $3704c843920dcfc2$var$$('.TimecodeEditable');
            if (timecodeMaskElt) {
                this.timecodeMaskElt = timecodeMaskElt;
                const lastTC = (0, $eqZ8F.Timecode).init({
                    framerate: this.state.frameRate,
                    timecode: this.state.startTimecode
                });
                lastTC.add([
                    Math.floor(this.state.frameRate * this.getVideo().duration) - 1
                ]);
                const tc = (0, $eqZ8F.Timecode).init({
                    framerate: this.state.frameRate,
                    timecode: this.state.startTimecode
                });
                this.maskInput = (0, $kjMit.inputMaskTimecode)(this.timecodeMaskElt, tc.frameCount, lastTC.frameCount, this.state.frameRate, (tc)=>{
                    tc.subtract([
                        this.state.startTimecode
                    ]);
                    this.goToFrame(tc.frameCount);
                });
                this.maskInput.setTc(tc);
                this.timecodeMaskElt.addEventListener('focus', this.inputFocusListener);
                this.timecodeMaskElt.addEventListener('blur', this.inputBlurListener);
            }
            // Timecode overlay on mousemove
            // TODO: do something better
            const timeMaskElt = $3704c843920dcfc2$var$$('.PlayerControlsTimeMask');
            if (timeMaskElt && !this.timeMaskElt.addEventListener) {
                this.timeMaskElt = timeMaskElt;
                this.timeMaskElt.addEventListener('mouseleave', this.requestFrameTimecodeOverlayListener);
                this.timeMaskElt.addEventListener('click', this.onTimeMaskClickListener);
                this.timeCursorElt = document.createElement('div');
                this.timeCursorElt.className = 'PlayerControlsTimeCursor';
                this.timeCursorElt.style.pointerEvents = 'none';
                this.timeTCElt = document.createElement('span');
                this.timeTCElt.className = 'PlayerControlsTimeTimecode';
                this.timeCursorElt.appendChild(this.timeTCElt);
                if (this.timeMaskElt) {
                    this.timeMaskElt.appendChild(this.timeCursorElt);
                    this.timeMaskElt.addEventListener('mousemove', this.moveTimecodeListener);
                }
            }
            this.state.player.addEventListener('buffering', this.buffer);
            this.getVideo().addEventListener('ended', this.ended);
            this.getVideo().addEventListener('progress', this.onVideoLoading);
            this.getVideo().addEventListener('timeupdate', this.videoProgressListener);
            this.getVideo().addEventListener('click', this.playOrPause);
            this.getVideo().addEventListener('dblclick', this.handleFullScreen);
            window.addEventListener('keydown', preventDefaultWindowOnSpace);
            window.addEventListener('keyup', this.keyUpVideo);
        }
        buffer(event) {
            const action = event.buffering ? 'Buffering' : 'StopBuffering';
            sendEventToElm({
                action: action
            });
        }
        ended() {
            sendEventToElm({
                action: 'Finished'
            });
        }
        onVideoLoading(event) {
            const videoElt = event.currentTarget;
            if (videoElt.buffered.length) {
                const eventForElm = {
                    action: 'Loaded',
                    buffer: [
                        {
                            start: videoElt.buffered.start(0),
                            end: videoElt.buffered.end(0)
                        }
                    ]
                };
                sendEventToElm(eventForElm);
            }
        }
        onVideoProgress(event) {
            const videoElt = event.currentTarget;
            const frameNumber = computeCurrentFrame(videoElt, this.state.frameRate, this.frameAccuracySupport);
            sendEventToElm({
                action: videoElt.paused ? 'isPaused' : 'Playing',
                frame: frameNumber
            });
            this.setTcFromFrame(frameNumber);
        }
        setTcFromFrame(frame) {
            const tc = (0, $eqZ8F.Timecode).init({
                framerate: this.state.frameRate
            });
            tc.setFrameNumberToTimecode(frame);
            tc.add([
                this.state.startTimecode
            ]);
            this.maskInput.setTc(tc);
        }
        moveTimecode(evt) {
            const b = this.timeMaskElt.getBoundingClientRect();
            if (evt.x < b.x + b.width && evt.x >= b.x && evt.y >= b.y && evt.y <= b.y + b.height) {
                const frame = Math.round((evt.x - b.x) / b.width * this.state.frameRate * (this.getVideo().duration - 1 / this.state.frameRate));
                const tc = (0, $eqZ8F.Timecode).init({
                    framerate: this.state.frameRate
                });
                tc.set(frame);
                tc.add([
                    this.state.startTimecode
                ]);
                requestAnimationFrame(()=>{
                    this.timeTCElt.innerHTML = tc.toString();
                    this.timeTCElt.style.transform = evt.offsetX < 80 ? `translateX(100%)` : '';
                    this.timeCursorElt.style.left = `${evt.x - b.x}px`;
                    this.timeMaskElt.style.opacity = '1';
                });
            } else requestAnimationFrame(()=>this.timeMaskElt.style.opacity = '0');
        }
        requestFrameTimecodeOverlay() {
            requestAnimationFrame(()=>this.timeMaskElt.style.opacity = '0');
        }
        warns(message) {
            const banner = $3704c843920dcfc2$var$$('.PlayerBanner');
            $3704c843920dcfc2$var$$('.PlayerBanner .BannerContent').innerHTML = message;
            banner.style.display = '';
            banner.addEventListener('click', function h() {
                banner.style.display = 'none';
                banner.removeEventListener('click', h);
            });
        }
        handleFullScreen() {
            const videoWrapper = $3704c843920dcfc2$var$$('#player-wrapper');
            const controlsWrapper = $3704c843920dcfc2$var$$('.PlayerControlsBox');
            let hoveringControls = false;
            let controlsFullscreenDelay = 0;
            function playerMouseMove() {
                if (controlsFullscreenDelay) clearTimeout(controlsFullscreenDelay);
                if (!hoveringControls) controlsFullscreenDelay = setTimeout(hideControls, 1000);
                toggleCtrl(true);
            }
            function controlsMouseEnter() {
                hoveringControls = true;
            }
            function controlsMouseLeave() {
                hoveringControls = false;
            }
            function hideControls() {
                toggleCtrl(false);
            }
            if (videoWrapper.webkitRequestFullscreen) null == document.webkitFullscreenElement ? videoWrapper.webkitRequestFullscreen() : document.webkitExitFullscreen();
            else if (videoWrapper.mozRequestFullScreen) null == document.mozFullScreenElement ? videoWrapper.mozRequestFullScreen() : document.mozCancelFullScreen();
            else if (videoWrapper.msRequestFullscreen) null == document.msFullscreenElement ? videoWrapper.msRequestFullscreen() : document.msExitFullscreen();
            else if (videoWrapper.requestFullscreen) null == document.fullscreenElement ? videoWrapper.requestFullscreen() : document.exitFullscreen();
            else if ($3704c843920dcfc2$var$IS_IOS) this.getVideo().webkitEnterFullscreen();
            function toggleCtrl(shown) {
                if (shown === undefined) {
                    videoWrapper.classList.remove('PlayerControlsHidden');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.remove('PlayerControlsShown');
                } else if (shown) {
                    videoWrapper.classList.remove('PlayerControlsHidden');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.add('PlayerControlsShown');
                } else {
                    videoWrapper.classList.add('PlayerControlsHidden');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.remove('PlayerControlsShown');
                }
            }
            function toggleFullscreen(full) {
                if (full) {
                    videoWrapper.classList.add('PlayerFullScreen');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.add('PlayerFullScreen');
                } else {
                    videoWrapper.classList.remove('PlayerFullScreen');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.remove('PlayerFullScreen');
                }
            }
            function toggle() {
                if (!document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement && !document.fullscreenElement) {
                    toggleCtrl();
                    toggleFullscreen(false);
                    if (controlsFullscreenDelay) clearTimeout(controlsFullscreenDelay);
                    videoWrapper.removeEventListener('mousemove', playerMouseMove);
                    controlsWrapper.removeEventListener('mouseenter', controlsMouseEnter);
                    controlsWrapper.removeEventListener('mouseleave', controlsMouseLeave);
                } else {
                    toggleFullscreen(true);
                    videoWrapper.addEventListener('mousemove', playerMouseMove);
                    controlsWrapper.addEventListener('mouseenter', controlsMouseEnter);
                    controlsWrapper.addEventListener('mouseleave', controlsMouseLeave);
                }
            }
            videoWrapper.addEventListener('fullscreenchange', toggle);
            videoWrapper.addEventListener('mozfullscreenchange', toggle);
            videoWrapper.addEventListener('MSFullscreenChange', toggle);
            videoWrapper.addEventListener('webkitfullscreenchange', toggle);
        }
        initPlayer() {
            // Init the shaka player
            this.state.player = new $6jqaU.Player(this.getVideo());
            const ui = new $6jqaU.ui.Overlay(this.state.player, $3704c843920dcfc2$var$shakaVideoContainer, this.getVideo());
            this.ui = ui;
            // disable shaka native controls https://shaka-player-demo.appspot.com/docs/api/shaka.extern.html#.UIConfiguration
            ui.configure({
                controlPanelElements: [],
                overflowMenuButtons: [],
                contextMenuElements: [],
                addSeekBar: false
            });
            this.state.player.configure({
                abr: {
                    enabled: false
                },
                streaming: {
                    bufferBehind: $3704c843920dcfc2$var$BUFFERBEHIND,
                    bufferingGoal: $3704c843920dcfc2$var$BUFFERINGGOAL
                }
            });
            this.state.player.load(this.getMpdUrl()).catch(()=>{
                this.loadVideoOnly();
                if (!$3704c843920dcfc2$var$IS_IOS) {
                    const message = navigator.language.startsWith('fr') ? "Essayez de mettre \xe0 jour votre navigateur (Chrome, Edge, Firefox...) pour lire la vid\xe9o avec le son, sinon contactez-nous." : 'Please try updating your brwoser (Chrome, Edge, Firefox...) to play the video with Sound, otherwise contact us.';
                    this.warns(message);
                }
            }).then(()=>{
                this.loadVideo();
                sendEventToElm({
                    action: 'Added'
                });
            });
        }
        render() {
            this.initPlayer();
        }
    }
    customElements.define('noma-player', Nomaplayer);
}

});
parcelRegister("ffDwH", function(module, exports) {

$parcel$export(module.exports, "render", () => $8463e20461391507$export$b3890eb0ae9dca99);
function $8463e20461391507$export$b3890eb0ae9dca99(imageUrl) {
    return `<html>
<head>
  <title>Nomalab</title>                                                  
</head>
<body style="background:#555D68; text-align:center">
  <style>
    @keyframes anim_spin {
      from { transform: rotate(0deg); } 
      to { transform: rotate(359deg); }
    }
    span {
      font-family: Open Sans, Roboto,sans-serif;
      font-size:13px;
      font-weight: 500;
      color: #CFD1D5;
      display: block;
    }
    svg {
      animation: anim_spin 1s linear infinite;
      fill: #3BAAFF;
    }
    div {
      margin: 250px 0 0 0;
    }
  </style>
  <div id="nomalabSpinner">
    <svg height="40px" viewBox="0 0 40 40" width="40px">
      <g transform="translate(5, 9)">
        <path d="M15,0 C21.0751322,0 26,4.92486775 26,11 C26,17.0751322 21.0751322,22 15,22 C9.26195744,22 4.55007179,17.6065 4.04484302,12 L6.05492878,12 C6.55237307,16.4999505 10.3674463,20 15,20 C19.9705627,20 24,15.9705627 24,11 C24,6.02943725 19.9705627,2 15,2 L15,0 Z"/>
        <polygon points="5 6 10 12 0 12"/>
      </g>
    </svg>
    <span>Extraction en cours...</span>
  </div>
  <script>
    var i = document.createElement('img');
    var loadedCb = function () {
      window.nomalabSpinner.style.display = 'none';
      window.document.body.appendChild(i);
    };

    var errorCb = function (err) {
      document.querySelector('#nomalabSpinner svg').style.display = 'none';
      document.querySelector('#nomalabSpinner span').innerHTML = 'Une erreur est survenue. Merci de contacter notre service op\xe9rations via le chat ou par mail \xe0 ops@nomalab.com';
    };
    
    i.onload = loadedCb;
    i.onerror = errorCb;
    i.style = "width: 100%";
    
    // get url and then create IMAGE

    let myRequest = new Request('${imageUrl}');

    fetch(myRequest)
    .then(function(response) {
      if (!response.ok) {
        throw new Error(\`HTTP error! status: \${response.status}\`);
      }
      return response.text();
    })
    .then(function(imgUrl) {
      i.src = imgUrl;
    });

  </script>
  </body>
</html>`;
}

});

parcelRegister("kjMit", function(module, exports) {

$parcel$export(module.exports, "inputMaskTimecode", () => $aaf81a275793b52d$export$4bccd78e60fd0875);

var $eqZ8F = parcelRequire("eqZ8F");
function $aaf81a275793b52d$export$4bccd78e60fd0875(el, minFrame, maxFrame, frameRate, cb) {
    let savedTC = (0, $eqZ8F.Timecode).init({
        framerate: frameRate
    });
    let isEditing = false;
    function doNothing(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    }
    function formatTC(value) {
        let segments = value.split(':').map((i)=>i.padStart(2, '0'));
        while(segments.length < 4)segments.unshift('00');
        return segments.join(':');
    }
    const numbers = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ];
    const autorizedKeyCodes = [
        37,
        39,
        38,
        40,
        8,
        46
    ];
    function onFocus() {
        isEditing = true;
        savedTC = (0, $eqZ8F.Timecode).init({
            framerate: frameRate
        });
        savedTC.set(el.value);
    }
    function updateValue() {
        try {
            let nextTC = (0, $eqZ8F.Timecode).init({
                framerate: frameRate
            });
            nextTC.set(formatTC(el.value));
            if (minFrame > nextTC.frame_count) nextTC.set(minFrame);
            else if (maxFrame < nextTC.frame_count) nextTC.set(maxFrame);
            savedTC = nextTC;
            savedTC.timecodeToFrameNumber();
            cb(savedTC);
            el.value = savedTC.toString();
        } catch (e) {
            el.value = savedTC.toString();
        }
        isEditing = false;
    }
    function onKeyDown(e) {
        if (autorizedKeyCodes.includes(e.keyCode) || e.ctrlKey || e.metaKey) {
            e.stopImmediatePropagation();
            return true;
        } else if (e.keyCode == 13 || e.keyCode == 27) el.blur();
        else if (numbers.includes(e.key)) {
            let value = el.value;
            let position = el.selectionStart;
            let newChar = e.key;
            if (position) {
                let prevChar = parseInt(value.charAt(position - 1));
                let prev2Char = parseInt(value.charAt(position - 2));
                let nextChar = value.charAt(position);
                let notSelecting = position == el.selectionEnd;
                // Can't have more than 2 consecutive digits
                if (!isNaN(prev2Char) && !isNaN(prevChar)) doNothing(e);
                else if (!isNaN(prevChar) && nextChar != ':' && canHaveMoreSegments() && notSelecting) {
                    el.value = value.slice(0, position) + newChar + ':' + value.slice(position);
                    el.setSelectionRange(position + 2, position + 2);
                    doNothing(e);
                }
            }
        } else if (e.key == ':') {
            // limit to 3 colons ':'
            if (!canHaveMoreSegments()) return doNothing(e);
        } else return doNothing(e);
    }
    function canHaveMoreSegments() {
        return el.value.split(':').length < 4;
    }
    function setTc(tc) {
        if (isEditing) return;
        savedTC = tc;
        el.value = savedTC.toString();
    }
    function setTcFromFrame(frame) {
        if (isEditing) return;
        savedTC.setFrameNumberToTimecode(frame);
        el.value = savedTC.toString();
    }
    function init() {
        el.addEventListener('focus', onFocus);
        el.addEventListener('blur', updateValue);
        el.addEventListener('keydown', onKeyDown);
    }
    function destroy() {
        el.removeEventListener('focus', onFocus);
        el.removeEventListener('blur', updateValue);
        el.removeEventListener('keydown', onKeyDown);
    }
    init();
    return {
        destroy: destroy,
        setTc: setTc,
        setTcFromFrame: setTcFromFrame
    };
}

});
parcelRegister("eqZ8F", function(module, exports) {

$parcel$export(module.exports, "Timecode", () => $41342b85841ebc6f$export$c7bb7bfc56e79955);
if (typeof Object.create !== 'function') Object.create = function(o) {
    let F = function() {};
    F.prototype = o;
    return new F();
};
function $41342b85841ebc6f$var$getValueFromDict(dict, name, default_value) {
    if (dict.hasOwnProperty(name)) return dict[name];
    else return default_value;
}
const $41342b85841ebc6f$export$c7bb7bfc56e79955 = {
    framerate: '',
    intFramerate: 0,
    dropFrame: false,
    hours: 0,
    minutes: 0,
    seconds: 0,
    frames: 0,
    frameCount: 0,
    init: function(args) {
        let obj = Object.create(this);
        obj.framerate = $41342b85841ebc6f$var$getValueFromDict(args, 'framerate', '29.97');
        obj.intFramerate = obj.getIntFramerate();
        obj.dropFrame = $41342b85841ebc6f$var$getValueFromDict(args, 'drop_frame', false);
        obj.hours = false;
        obj.minutes = false;
        obj.seconds = false;
        obj.frames = false;
        obj.frameCount = false;
        obj.set($41342b85841ebc6f$var$getValueFromDict(args, 'timecode', 0));
        return obj;
    },
    getIntFramerate: function() {
        if (this.framerate === 'ms') return 1000;
        else return Math.round(parseFloat(this.framerate));
    },
    set: function(timecode) {
        if (typeof timecode === 'string') {
            this.partsFromString(timecode);
            this.timecodeToFrameNumber();
            this.frameNumberToTimecode();
        } else if (typeof timecode === 'number') {
            this.frameCount = timecode;
            this.frameNumberToTimecode();
        } else if (timecode instanceof Date) {
            this.frameCount = this.dateToFrameNumber(timecode);
            this.frameNumberToTimecode();
        }
    },
    partsFromString: function(timecode) {
        // Parses timecode strings non-drop 'hh:mm:ss:ff', drop 'hh:mm:ss;ff', or milliseconds 'hh:mm:ss:fff'
        if (timecode.length === 11) this.frames = parseInt(timecode.slice(9, 11));
        else if (timecode.length === 12 && this.framerate === 'ms') this.frames = parseInt(timecode.slice(9, 12));
        else throw new Error(`Timecode string parsing error. ${timecode}`);
        this.hours = parseInt(timecode.slice(0, 2));
        this.minutes = parseInt(timecode.slice(3, 5));
        this.seconds = parseInt(timecode.slice(6, 8));
    },
    frameNumberToTimecode: function() {
        // Converts frame_count to timecode
        let frame_count = this.frameCount;
        if (this.dropFrame) {
            let parts = this.frameNumberToDropFrameTimecode(frame_count);
            this.hours = parts[0];
            this.minutes = parts[1];
            this.seconds = parts[2];
            this.frames = parts[3];
        } else {
            this.hours = frame_count / (3600 * this.intFramerate);
            if (this.hours > 23) {
                this.hours = this.hours % 24;
                frame_count = frame_count - 82800 * this.intFramerate;
            }
            this.minutes = frame_count % (3600 * this.intFramerate) / (60 * this.intFramerate);
            this.seconds = frame_count % (3600 * this.intFramerate) % (60 * this.intFramerate) / this.intFramerate;
            this.frames = frame_count % (3600 * this.intFramerate) % (60 * this.intFramerate) % this.intFramerate;
            this.hours = Math.floor(this.hours);
            this.minutes = Math.floor(this.minutes);
            this.seconds = Math.floor(this.seconds);
            this.frames = Math.floor(this.frames);
        }
    },
    timecodeToFrameNumber: function() {
        // converts the current timecode to frame_count.
        if (this.dropFrame) this.frameCount = this.dropFrameTimecodeToFrameNumber([
            this.hours,
            this.minutes,
            this.seconds,
            this.frames
        ]);
        else this.frameCount = (this.hours * 3600 + this.minutes * 60 + this.seconds) * this.intFramerate + this.frames;
    },
    _calculate: function(sign, timecodes) {
        // all timecodes are calculated in place
        let frameCount;
        let timecode;
        for(let i = 0; i < timecodes.length; i += 1){
            // if a string, number or Date is given, convert it to a timecode
            if (typeof timecodes[i] === 'string' || typeof timecodes[i] === 'number' || timecodes[i] instanceof Date) timecode = $41342b85841ebc6f$export$c7bb7bfc56e79955.init({
                framerate: this.framerate,
                timecode: timecodes[i],
                drop_frame: this.dropFrame
            });
            else timecode = timecodes[i];
            // make sure this is a valid timecode
            if (timecode.frameCount) {
                if (timecode.framerate != this.framerate) throw new Error('Timecode framerates must match to do calculations.');
                if (sign === '-') frameCount = timecode.frameCount * -1;
                else if (sign === '+') frameCount = timecode.frameCount;
                else throw new Error('Expected sign to be + or -.');
                this.frameCount = this.frameCount + frameCount;
                this.frameNumberToTimecode();
            }
        }
    },
    add: function(args) {
        /*
        // This takes one or more Timecode objects as arguments
        // If this has been initialized, add to this, otherwise just add timecodes given.
        var timecodes = [];
        if (this.frameCount) {
            timecodes.push(this);
        }
        */ this._calculate('+', args);
    },
    subtract: function(args) {
        this._calculate('-', args);
    },
    toString: function() {
        const zeroPad = function(number) {
            const pad = number < 10 ? '0' : '';
            return pad + Math.floor(number);
        };
        const delim = this.dropFrame ? ';' : ':';
        return `${zeroPad(this.hours)}:${zeroPad(this.minutes)}:${zeroPad(this.seconds)}${delim}${zeroPad(this.frames)}`;
    },
    frameNumberToDropFrameTimecode: function(frameNumber) {
        const framerate = parseFloat(this.framerate);
        const drop_frames = Math.round(framerate * 0.066666);
        const frames_per_hour = Math.round(framerate * 3600);
        const frames_per_24_hours = frames_per_hour * 24;
        const frames_per_10_minutes = Math.round(framerate * 600);
        const frames_per_minute = Math.round(framerate * 60);
        // Roll over clock if greater than 24 hours
        frameNumber = frameNumber % frames_per_24_hours;
        // If time is negative, count back from 24 hours
        if (frameNumber < 0) frameNumber = frames_per_24_hours + frameNumber;
        const d = Math.floor(frameNumber / frames_per_10_minutes);
        const m = frameNumber % frames_per_10_minutes;
        if (m > drop_frames) frameNumber = frameNumber + drop_frames * 9 * d + drop_frames * Math.floor((m - drop_frames) / frames_per_minute);
        else frameNumber = frameNumber + drop_frames * 9 * d;
        return [
            Math.floor(Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) / 60),
            Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) % 60,
            Math.floor(frameNumber / this.intFramerate) % 60,
            frameNumber % this.intFramerate
        ];
    },
    setFrameNumberToTimecode: function(frameNumber) {
        const framerate = parseFloat(this.framerate);
        const frames_per_hour = Math.round(framerate * 3600);
        const frames_per_24_hours = frames_per_hour * 24;
        // Roll over clock if greater than 24 hours
        frameNumber = frameNumber % frames_per_24_hours;
        // If time is negative, count back from 24 hours
        if (frameNumber < 0) frameNumber = frames_per_24_hours + frameNumber;
        this.hours = Math.floor(Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) / 60);
        this.minutes = Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) % 60;
        this.seconds = Math.floor(frameNumber / this.intFramerate) % 60;
        this.frames = frameNumber % this.intFramerate;
        this.timecodeToFrameNumber();
    },
    dropFrameTimecodeToFrameNumber: function(timecodeAsList) {
        const [hours, minutes, seconds, frames] = timecodeAsList;
        const drop_frames = Math.round(parseFloat(this.framerate) * 0.066666);
        const hour_frames = this.intFramerate * 3600;
        const minute_frames = this.intFramerate * 60;
        const total_minutes = hours * 60 + minutes;
        const frame_number = hour_frames * hours + minute_frames * minutes + this.intFramerate * seconds + frames - drop_frames * (total_minutes - Math.floor(total_minutes / 10));
        return frame_number;
    },
    /**
     * Converts the hour, minute, second, millisecond part of Date() object to the number of
     * frames using the current framerate
     * @param dt {Date}
     * @returns {number}
     */ dateToFrameNumber: function(dt) {
        const midnight = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0);
        return Math.floor((dt.getTime() - midnight.getTime()) / 1000 * parseFloat(this.framerate));
    }
};

});


parcelRegister("8dcRR", function(module, exports) {
/* braille.js
 *
 * Read the frame number coded in braille code
 * from the given video element.
 * returns NaN if failures while decoding
 *
 * braille : VideoHtmlElement -> Integer
 */ module.exports = function() {
    const numberOfSymbols = 7;
    const width = 392;
    const height = 60;
    const symbolWidth = width / numberOfSymbols;
    const symbolHeight = height;
    const colorMedian = 125;
    var brailleCoordinates = [
        [
            1 / 4,
            1 / 6
        ],
        [
            3 / 4,
            1 / 6
        ],
        [
            1 / 4,
            0.5
        ],
        [
            3 / 4,
            0.5
        ],
        [
            1 / 4,
            5 / 6
        ],
        [
            3 / 4,
            5 / 6
        ]
    ];
    var braille1 = JSON.stringify([
        1,
        0,
        0,
        0,
        0,
        0
    ]);
    var braille2 = JSON.stringify([
        1,
        0,
        1,
        0,
        0,
        0
    ]);
    var braille3 = JSON.stringify([
        1,
        1,
        0,
        0,
        0,
        0
    ]);
    var braille4 = JSON.stringify([
        1,
        1,
        0,
        1,
        0,
        0
    ]);
    var braille5 = JSON.stringify([
        1,
        0,
        0,
        1,
        0,
        0
    ]);
    var braille6 = JSON.stringify([
        1,
        1,
        1,
        0,
        0,
        0
    ]);
    var braille7 = JSON.stringify([
        1,
        1,
        1,
        1,
        0,
        0
    ]);
    var braille8 = JSON.stringify([
        1,
        0,
        1,
        1,
        0,
        0
    ]);
    var braille9 = JSON.stringify([
        0,
        1,
        1,
        0,
        0,
        0
    ]);
    var braille0 = JSON.stringify([
        0,
        1,
        1,
        1,
        0,
        0
    ]);
    // Would be better to test for all rgb to be exactly 0
    // but it appears sometime the value will be 2 or 3 or 4
    // so we just check it is in the lower half of the color range
    // (aka below 255/2, nearly)
    function isBlack(rgba) {
        return rgba[0] < colorMedian && rgba[1] < colorMedian && rgba[2] < colorMedian;
    }
    function parse(video) {
        let decodeCanvas = document.createElement('canvas');
        decodeCanvas.width = width;
        decodeCanvas.height = height;
        decodeCanvas.crossorigin = "anonymous";
        let decodeContext = decodeCanvas.getContext('2d');
        let frameNumber = '';
        if (!video) return 0;
        // void ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
        // braille font width is 56, height is 60 and drawn in the upper-left corner of
        // the video. we render 7 characters on each frame, making the total width 392.
        // however the 56px width includes letter-spacing, the interesting part of
        // a braille character is only 50px, so we take that into a account when decoding
        // the character.
        decodeContext.drawImage(video, 0, 0, width, height, 0, 0, width, height);
        // iterate over braille characters
        for(var i = 0; i < numberOfSymbols; i++){
            let candidate = JSON.stringify(// map over braille dots
            brailleCoordinates.map(function(rationalDotCoords) {
                // those are the coordinates of the center-most pixel of
                // the braille dot we are currently decoding
                var x = 50 * rationalDotCoords[0] + symbolWidth * i;
                var y = rationalDotCoords[1] * symbolHeight;
                var pixelData = decodeContext.getImageData(x, y, 1, 1).data;
                return isBlack(pixelData) ? 0 : 1;
            }));
            let decoded;
            switch(candidate){
                case braille0:
                    decoded = '0';
                    break;
                case braille1:
                    decoded = '1';
                    break;
                case braille2:
                    decoded = '2';
                    break;
                case braille3:
                    decoded = '3';
                    break;
                case braille4:
                    decoded = '4';
                    break;
                case braille5:
                    decoded = '5';
                    break;
                case braille6:
                    decoded = '6';
                    break;
                case braille7:
                    decoded = '7';
                    break;
                case braille8:
                    decoded = '8';
                    break;
                case braille9:
                    decoded = '9';
                    break;
                // returning NaN if decode failed
                default:
                    decoded = 'oops';
            }
            frameNumber += decoded;
        }
        return parseInt(frameNumber, 10);
    }
    return parse;
}();

});

parcelRegister("gguoi", function(module, exports) {

$parcel$export(module.exports, "$", () => $bd75b6fa0b73898b$export$3d8c2f653ac9d0b9, (v) => $bd75b6fa0b73898b$export$3d8c2f653ac9d0b9 = v);
/*
 * common.js
 */ var $bd75b6fa0b73898b$export$3c32761ab67e1b40;
var $bd75b6fa0b73898b$export$1a44d2b340da8eb5;
var $bd75b6fa0b73898b$export$3d8c2f653ac9d0b9;
var $bd75b6fa0b73898b$export$fe324b23443c13e2;
var $bd75b6fa0b73898b$export$185802fd694ee1f5;
var $bd75b6fa0b73898b$export$af88d00dbe7f521;
var $bd75b6fa0b73898b$export$627d822bae211d52;
$bd75b6fa0b73898b$export$3c32761ab67e1b40 = '<svg height="18px" width="18px" viewBox="0 0 18 18" class="IconIcon18"><rect class="Bg" height="18" width="18" x="0" y="0"></rect><rect class="Fg" height="8" width="3" x="5" y="5"></rect><rect class="Fg" height="8" width="3" x="10" y="5"></rect></svg>';
$bd75b6fa0b73898b$export$1a44d2b340da8eb5 = '<svg height="18px" width="18px" viewBox="0 0 18 18" class="IconIcon18"><rect class="Bg" height="18" width="18" x="0" y="0"></rect><polygon class="Fg" points="6 5 12 9 6 13"></polygon></svg>';
$bd75b6fa0b73898b$export$3d8c2f653ac9d0b9 = function $(s, el) {
    return (el || window.document).querySelector(s);
};
$bd75b6fa0b73898b$export$fe324b23443c13e2 = function $$(s, el) {
    return (el || window.document).querySelectorAll(s);
};
$bd75b6fa0b73898b$export$185802fd694ee1f5 = function create(t) {
    return window.document.createElement(t);
};
$bd75b6fa0b73898b$export$af88d00dbe7f521 = function logger(msg) {
    if (window.NOMALAB_DEBUG_MODE) {
        let m = typeof msg == 'object' ? JSON.stringify(msg, null, 2) : msg;
        console.log('%c[NOMALAB DEBUG] ' + m);
    }
};
$bd75b6fa0b73898b$export$627d822bae211d52 = function fixSubtitlePosition(video) {
    if (!video.textTracks[0] || !video.textTracks[0].cues) {
        console.log(video.textTracks);
        return;
    }
    let l = video.textTracks[0].cues.length;
    for(let i = 0; i < l; i++){
        let cue = video.textTracks[0].cues[i];
        if (cue.line == 0) cue.line = 1;
        video.textTracks[0].cues[i] = cue;
    }
};

});

parcelRegister("6jqaU", function(module, exports) {
/*
 @license
 Shaka Player
 Copyright 2016 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/ (function() {
    var innerGlobal = typeof window != "undefined" ? window : $parcel$global;
    var exportTo = {};
    (function(window1, global1, module) {
        var p, aa = typeof Object.create == "function" ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function ca(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window1 && window1,
                "object" == typeof self && self,
                "object" == typeof global1 && global1
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var da = ca(this), ea = "Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64".split(" ");
        da.BigInt64Array && (ea.push("BigInt64"), ea.push("BigUint64"));
        function fa(a, b) {
            if (b) for(var c = 0; c < ea.length; c++)ha(ea[c] + "Array.prototype." + a, b);
        }
        function ia(a, b) {
            b && ha(a, b);
        }
        function ha(a, b) {
            var c = da;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) return;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && b != null && ba(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
        var ja;
        if (typeof Object.setPrototypeOf == "function") ja = Object.setPrototypeOf;
        else {
            var ka;
            a: {
                var la = {
                    a: !0
                }, ma = {};
                try {
                    ma.__proto__ = la;
                    ka = ma.a;
                    break a;
                } catch (a) {}
                ka = !1;
            }
            ja = ka ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var na = ja;
        function oa(a, b) {
            a.prototype = aa(b.prototype);
            a.prototype.constructor = a;
            if (na) na(a, b);
            else for(var c in b)if (c != "prototype") {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.Xn = b.prototype;
        }
        function qa(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        function u(a) {
            var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if (typeof a.length == "number") return {
                next: qa(a)
            };
            throw Error(String(a) + " is not an iterable or ArrayLike");
        }
        function G(a) {
            if (!(a instanceof Array)) {
                a = u(a);
                for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                a = c;
            }
            return a;
        }
        function ra(a) {
            if (!(a instanceof Object)) throw new TypeError("Iterator result " + a + " is not an object");
        }
        function sa() {
            this.J = !1;
            this.H = null;
            this.i = void 0;
            this.h = 1;
            this.G = this.I = 0;
            this.L = this.D = null;
        }
        function ta(a) {
            if (a.J) throw new TypeError("Generator is already running");
            a.J = !0;
        }
        sa.prototype.K = function(a) {
            this.i = a;
        };
        function ya(a, b) {
            a.D = {
                Xi: b,
                kj: !0
            };
            a.h = a.I || a.G;
        }
        sa.prototype.getNextAddressJsc = function() {
            return this.h;
        };
        sa.prototype.getYieldResultJsc = function() {
            return this.i;
        };
        sa.prototype.return = function(a) {
            this.D = {
                return: a
            };
            this.h = this.G;
        };
        sa.prototype["return"] = sa.prototype.return;
        sa.prototype.O = function(a) {
            this.D = {
                B: a
            };
            this.h = this.G;
        };
        sa.prototype.jumpThroughFinallyBlocks = sa.prototype.O;
        sa.prototype.g = function(a, b) {
            this.h = b;
            return {
                value: a
            };
        };
        sa.prototype.yield = sa.prototype.g;
        sa.prototype.P = function(a, b) {
            a = u(a);
            var c = a.next();
            ra(c);
            if (c.done) this.i = c.value, this.h = b;
            else return this.H = a, this.g(c.value, b);
        };
        sa.prototype.yieldAll = sa.prototype.P;
        sa.prototype.B = function(a) {
            this.h = a;
        };
        sa.prototype.jumpTo = sa.prototype.B;
        sa.prototype.j = function() {
            this.h = 0;
        };
        sa.prototype.jumpToEnd = sa.prototype.j;
        sa.prototype.m = function(a, b) {
            this.I = a;
            b != void 0 && (this.G = b);
        };
        sa.prototype.setCatchFinallyBlocks = sa.prototype.m;
        sa.prototype.F = function(a) {
            this.I = 0;
            this.G = a || 0;
        };
        sa.prototype.setFinallyBlock = sa.prototype.F;
        sa.prototype.o = function(a, b) {
            this.h = a;
            this.I = b || 0;
        };
        sa.prototype.leaveTryBlock = sa.prototype.o;
        sa.prototype.l = function(a) {
            this.I = a || 0;
            a = this.D.Xi;
            this.D = null;
            return a;
        };
        sa.prototype.enterCatchBlock = sa.prototype.l;
        sa.prototype.A = function(a, b, c) {
            c ? this.L[c] = this.D : this.L = [
                this.D
            ];
            this.I = a || 0;
            this.G = b || 0;
        };
        sa.prototype.enterFinallyBlock = sa.prototype.A;
        sa.prototype.C = function(a, b) {
            b = this.L.splice(b || 0)[0];
            (b = this.D = this.D || b) ? b.kj ? this.h = this.I || this.G : b.B != void 0 && this.G < b.B ? (this.h = b.B, this.D = null) : this.h = this.G : this.h = a;
        };
        sa.prototype.leaveFinallyBlock = sa.prototype.C;
        sa.prototype.M = function(a) {
            return new za(a);
        };
        sa.prototype.forIn = sa.prototype.M;
        function za(a) {
            this.i = a;
            this.g = [];
            for(var b in a)this.g.push(b);
            this.g.reverse();
        }
        za.prototype.h = function() {
            for(; this.g.length > 0;){
                var a = this.g.pop();
                if (a in this.i) return a;
            }
            return null;
        };
        za.prototype.getNext = za.prototype.h;
        function Ba(a) {
            this.g = new sa;
            this.h = a;
        }
        function Ea(a, b) {
            ta(a.g);
            var c = a.g.H;
            if (c) return Fa(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return Ha(a);
        }
        function Fa(a, b, c, d) {
            try {
                var e = b.call(a.g.H, c);
                ra(e);
                if (!e.done) return a.g.J = !1, e;
                var f = e.value;
            } catch (g) {
                return a.g.H = null, ya(a.g, g), Ha(a);
            }
            a.g.H = null;
            d.call(a.g, f);
            return Ha(a);
        }
        function Ha(a) {
            for(; a.g.h;)try {
                var b = a.h(a.g);
                if (b) return a.g.J = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.i = void 0, ya(a.g, c);
            }
            a.g.J = !1;
            if (a.g.D) {
                b = a.g.D;
                a.g.D = null;
                if (b.kj) throw b.Xi;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function Ia(a) {
            this.next = function(b) {
                ta(a.g);
                a.g.H ? b = Fa(a, a.g.H.next, b, a.g.K) : (a.g.K(b), b = Ha(a));
                return b;
            };
            this.throw = function(b) {
                ta(a.g);
                a.g.H ? b = Fa(a, a.g.H["throw"], b, a.g.K) : (ya(a.g, b), b = Ha(a));
                return b;
            };
            this.return = function(b) {
                return Ea(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function La(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function f(g) {
                    g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(f, e);
                }
                f(a.next());
            });
        }
        function H(a) {
            return La(new Ia(new Ba(a)));
        }
        function Ma() {
            for(var a = Number(this), b = [], c = a; c < arguments.length; c++)b[c - a] = arguments[c];
            return b;
        }
        ia("Symbol", function(a) {
            function b(f) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (f || "") + "_" + e++, f);
            }
            function c(f, g) {
                this.g = f;
                ba(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (Math.random() * 1E9 >>> 0) + "_", e = 0;
            return b;
        });
        ia("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            ba(Array.prototype, a, {
                configurable: !0,
                writable: !0,
                value: function() {
                    return Na(qa(this));
                }
            });
            return a;
        });
        function Na(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        ia("Promise", function(a) {
            function b(g) {
                this.h = 0;
                this.i = void 0;
                this.g = [];
                this.o = !1;
                var h = this.j();
                try {
                    g(h.resolve, h.reject);
                } catch (k) {
                    h.reject(k);
                }
            }
            function c() {
                this.g = null;
            }
            function d(g) {
                return g instanceof b ? g : new b(function(h) {
                    h(g);
                });
            }
            if (a) return a;
            c.prototype.h = function(g) {
                if (this.g == null) {
                    this.g = [];
                    var h = this;
                    this.i(function() {
                        h.l();
                    });
                }
                this.g.push(g);
            };
            var e = da.setTimeout;
            c.prototype.i = function(g) {
                e(g, 0);
            };
            c.prototype.l = function() {
                for(; this.g && this.g.length;){
                    var g = this.g;
                    this.g = [];
                    for(var h = 0; h < g.length; ++h){
                        var k = g[h];
                        g[h] = null;
                        try {
                            k();
                        } catch (l) {
                            this.j(l);
                        }
                    }
                }
                this.g = null;
            };
            c.prototype.j = function(g) {
                this.i(function() {
                    throw g;
                });
            };
            b.prototype.j = function() {
                function g(l) {
                    return function(m) {
                        k || (k = !0, l.call(h, m));
                    };
                }
                var h = this, k = !1;
                return {
                    resolve: g(this.G),
                    reject: g(this.l)
                };
            };
            b.prototype.G = function(g) {
                if (g === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                else if (g instanceof b) this.I(g);
                else {
                    a: switch(typeof g){
                        case "object":
                            var h = g != null;
                            break a;
                        case "function":
                            h = !0;
                            break a;
                        default:
                            h = !1;
                    }
                    h ? this.F(g) : this.m(g);
                }
            };
            b.prototype.F = function(g) {
                var h = void 0;
                try {
                    h = g.then;
                } catch (k) {
                    this.l(k);
                    return;
                }
                typeof h == "function" ? this.J(h, g) : this.m(g);
            };
            b.prototype.l = function(g) {
                this.A(2, g);
            };
            b.prototype.m = function(g) {
                this.A(1, g);
            };
            b.prototype.A = function(g, h) {
                if (this.h != 0) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.h);
                this.h = g;
                this.i = h;
                this.h === 2 && this.H();
                this.C();
            };
            b.prototype.H = function() {
                var g = this;
                e(function() {
                    if (g.D()) {
                        var h = da.console;
                        typeof h !== "undefined" && h.error(g.i);
                    }
                }, 1);
            };
            b.prototype.D = function() {
                if (this.o) return !1;
                var g = da.CustomEvent, h = da.Event, k = da.dispatchEvent;
                if (typeof k === "undefined") return !0;
                typeof g === "function" ? g = new g("unhandledrejection", {
                    cancelable: !0
                }) : typeof h === "function" ? g = new h("unhandledrejection", {
                    cancelable: !0
                }) : (g = da.document.createEvent("CustomEvent"), g.initCustomEvent("unhandledrejection", !1, !0, g));
                g.promise = this;
                g.reason = this.i;
                return k(g);
            };
            b.prototype.C = function() {
                if (this.g != null) {
                    for(var g = 0; g < this.g.length; ++g)f.h(this.g[g]);
                    this.g = null;
                }
            };
            var f = new c;
            b.prototype.I = function(g) {
                var h = this.j();
                g.hf(h.resolve, h.reject);
            };
            b.prototype.J = function(g, h) {
                var k = this.j();
                try {
                    g.call(h, k.resolve, k.reject);
                } catch (l) {
                    k.reject(l);
                }
            };
            b.prototype.then = function(g, h) {
                function k(q, r) {
                    return typeof q == "function" ? function(t) {
                        try {
                            l(q(t));
                        } catch (v) {
                            m(v);
                        }
                    } : r;
                }
                var l, m, n = new b(function(q, r) {
                    l = q;
                    m = r;
                });
                this.hf(k(g, l), k(h, m));
                return n;
            };
            b.prototype.catch = function(g) {
                return this.then(void 0, g);
            };
            b.prototype.hf = function(g, h) {
                function k() {
                    switch(l.h){
                        case 1:
                            g(l.i);
                            break;
                        case 2:
                            h(l.i);
                            break;
                        default:
                            throw Error("Unexpected state: " + l.h);
                    }
                }
                var l = this;
                this.g == null ? f.h(k) : this.g.push(k);
                this.o = !0;
            };
            b.resolve = d;
            b.reject = function(g) {
                return new b(function(h, k) {
                    k(g);
                });
            };
            b.race = function(g) {
                return new b(function(h, k) {
                    for(var l = u(g), m = l.next(); !m.done; m = l.next())d(m.value).hf(h, k);
                });
            };
            b.all = function(g) {
                var h = u(g), k = h.next();
                return k.done ? d([]) : new b(function(l, m) {
                    function n(t) {
                        return function(v) {
                            q[t] = v;
                            r--;
                            r == 0 && l(q);
                        };
                    }
                    var q = [], r = 0;
                    do q.push(void 0), r++, d(k.value).hf(n(q.length - 1), m), k = h.next();
                    while (!k.done);
                });
            };
            return b;
        });
        function Oa(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
        }
        ia("WeakMap", function(a) {
            function b(k) {
                this.g = (h += Math.random() + 1).toString();
                if (k) {
                    k = u(k);
                    for(var l; !(l = k.next()).done;)l = l.value, this.set(l[0], l[1]);
                }
            }
            function c() {}
            function d(k) {
                var l = typeof k;
                return l === "object" && k !== null || l === "function";
            }
            function e(k) {
                if (!Oa(k, g)) {
                    var l = new c;
                    ba(k, g, {
                        value: l
                    });
                }
            }
            function f(k) {
                var l = Object[k];
                l && (Object[k] = function(m) {
                    if (m instanceof c) return m;
                    Object.isExtensible(m) && e(m);
                    return l(m);
                });
            }
            if (function() {
                if (!a || !Object.seal) return !1;
                try {
                    var k = Object.seal({}), l = Object.seal({}), m = new a([
                        [
                            k,
                            2
                        ],
                        [
                            l,
                            3
                        ]
                    ]);
                    if (m.get(k) != 2 || m.get(l) != 3) return !1;
                    m.delete(k);
                    m.set(l, 4);
                    return !m.has(k) && m.get(l) == 4;
                } catch (n) {
                    return !1;
                }
            }()) return a;
            var g = "$jscomp_hidden_" + Math.random();
            f("freeze");
            f("preventExtensions");
            f("seal");
            var h = 0;
            b.prototype.set = function(k, l) {
                if (!d(k)) throw Error("Invalid WeakMap key");
                e(k);
                if (!Oa(k, g)) throw Error("WeakMap key fail: " + k);
                k[g][this.g] = l;
                return this;
            };
            b.prototype.get = function(k) {
                return d(k) && Oa(k, g) ? k[g][this.g] : void 0;
            };
            b.prototype.has = function(k) {
                return d(k) && Oa(k, g) && Oa(k[g], this.g);
            };
            b.prototype.delete = function(k) {
                return d(k) && Oa(k, g) && Oa(k[g], this.g) ? delete k[g][this.g] : !1;
            };
            return b;
        });
        ia("Map", function(a) {
            function b() {
                var h = {};
                return h.Ec = h.next = h.head = h;
            }
            function c(h, k) {
                var l = h[1];
                return Na(function() {
                    if (l) {
                        for(; l.head != h[1];)l = l.Ec;
                        for(; l.next != l.head;)return l = l.next, {
                            done: !1,
                            value: k(l)
                        };
                        l = null;
                    }
                    return {
                        done: !0,
                        value: void 0
                    };
                });
            }
            function d(h, k) {
                var l = k && typeof k;
                l == "object" || l == "function" ? f.has(k) ? l = f.get(k) : (l = "" + ++g, f.set(k, l)) : l = "p_" + k;
                var m = h[0][l];
                if (m && Oa(h[0], l)) for(h = 0; h < m.length; h++){
                    var n = m[h];
                    if (k !== k && n.key !== n.key || k === n.key) return {
                        id: l,
                        list: m,
                        index: h,
                        entry: n
                    };
                }
                return {
                    id: l,
                    list: m,
                    index: -1,
                    entry: void 0
                };
            }
            function e(h) {
                this[0] = {};
                this[1] = b();
                this.size = 0;
                if (h) {
                    h = u(h);
                    for(var k; !(k = h.next()).done;)k = k.value, this.set(k[0], k[1]);
                }
            }
            if (function() {
                if (!a || typeof a != "function" || !a.prototype.entries || typeof Object.seal != "function") return !1;
                try {
                    var h = Object.seal({
                        x: 4
                    }), k = new a(u([
                        [
                            h,
                            "s"
                        ]
                    ]));
                    if (k.get(h) != "s" || k.size != 1 || k.get({
                        x: 4
                    }) || k.set({
                        x: 4
                    }, "t") != k || k.size != 2) return !1;
                    var l = k.entries(), m = l.next();
                    if (m.done || m.value[0] != h || m.value[1] != "s") return !1;
                    m = l.next();
                    return m.done || m.value[0].x != 4 || m.value[1] != "t" || !l.next().done ? !1 : !0;
                } catch (n) {
                    return !1;
                }
            }()) return a;
            var f = new WeakMap;
            e.prototype.set = function(h, k) {
                h = h === 0 ? 0 : h;
                var l = d(this, h);
                l.list || (l.list = this[0][l.id] = []);
                l.entry ? l.entry.value = k : (l.entry = {
                    next: this[1],
                    Ec: this[1].Ec,
                    head: this[1],
                    key: h,
                    value: k
                }, l.list.push(l.entry), this[1].Ec.next = l.entry, this[1].Ec = l.entry, this.size++);
                return this;
            };
            e.prototype.delete = function(h) {
                h = d(this, h);
                return h.entry && h.list ? (h.list.splice(h.index, 1), h.list.length || delete this[0][h.id], h.entry.Ec.next = h.entry.next, h.entry.next.Ec = h.entry.Ec, h.entry.head = null, this.size--, !0) : !1;
            };
            e.prototype.clear = function() {
                this[0] = {};
                this[1] = this[1].Ec = b();
                this.size = 0;
            };
            e.prototype.has = function(h) {
                return !!d(this, h).entry;
            };
            e.prototype.get = function(h) {
                return (h = d(this, h).entry) && h.value;
            };
            e.prototype.entries = function() {
                return c(this, function(h) {
                    return [
                        h.key,
                        h.value
                    ];
                });
            };
            e.prototype.keys = function() {
                return c(this, function(h) {
                    return h.key;
                });
            };
            e.prototype.values = function() {
                return c(this, function(h) {
                    return h.value;
                });
            };
            e.prototype.forEach = function(h, k) {
                for(var l = this.entries(), m; !(m = l.next()).done;)m = m.value, h.call(k, m[1], m[0], this);
            };
            e.prototype[Symbol.iterator] = e.prototype.entries;
            var g = 0;
            return e;
        });
        function Pa(a, b) {
            a instanceof String && (a += "");
            var c = 0, d = !1, e = {
                next: function() {
                    if (!d && c < a.length) {
                        var f = c++;
                        return {
                            value: b(f, a[f]),
                            done: !1
                        };
                    }
                    d = !0;
                    return {
                        done: !0,
                        value: void 0
                    };
                }
            };
            e[Symbol.iterator] = function() {
                return e;
            };
            return e;
        }
        ia("Array.prototype.keys", function(a) {
            return a ? a : function() {
                return Pa(this, function(b) {
                    return b;
                });
            };
        });
        ia("Set", function(a) {
            function b(c) {
                this.g = new Map;
                if (c) {
                    c = u(c);
                    for(var d; !(d = c.next()).done;)this.add(d.value);
                }
                this.size = this.g.size;
            }
            if (function() {
                if (!a || typeof a != "function" || !a.prototype.entries || typeof Object.seal != "function") return !1;
                try {
                    var c = Object.seal({
                        x: 4
                    }), d = new a(u([
                        c
                    ]));
                    if (!d.has(c) || d.size != 1 || d.add(c) != d || d.size != 1 || d.add({
                        x: 4
                    }) != d || d.size != 2) return !1;
                    var e = d.entries(), f = e.next();
                    if (f.done || f.value[0] != c || f.value[1] != c) return !1;
                    f = e.next();
                    return f.done || f.value[0] == c || f.value[0].x != 4 || f.value[1] != f.value[0] ? !1 : e.next().done;
                } catch (g) {
                    return !1;
                }
            }()) return a;
            b.prototype.add = function(c) {
                c = c === 0 ? 0 : c;
                this.g.set(c, c);
                this.size = this.g.size;
                return this;
            };
            b.prototype.delete = function(c) {
                c = this.g.delete(c);
                this.size = this.g.size;
                return c;
            };
            b.prototype.clear = function() {
                this.g.clear();
                this.size = 0;
            };
            b.prototype.has = function(c) {
                return this.g.has(c);
            };
            b.prototype.entries = function() {
                return this.g.entries();
            };
            b.prototype.values = function() {
                return this.g.values();
            };
            b.prototype.keys = b.prototype.values;
            b.prototype[Symbol.iterator] = b.prototype.values;
            b.prototype.forEach = function(c, d) {
                var e = this;
                this.g.forEach(function(f) {
                    return c.call(d, f, f, e);
                });
            };
            return b;
        });
        ia("Array.prototype.values", function(a) {
            return a ? a : function() {
                return Pa(this, function(b, c) {
                    return c;
                });
            };
        });
        ia("Array.from", function(a) {
            return a ? a : function(b, c, d) {
                c = c != null ? c : function(h) {
                    return h;
                };
                var e = [], f = typeof Symbol != "undefined" && Symbol.iterator && b[Symbol.iterator];
                if (typeof f == "function") {
                    b = f.call(b);
                    for(var g = 0; !(f = b.next()).done;)e.push(c.call(d, f.value, g++));
                } else for(f = b.length, g = 0; g < f; g++)e.push(c.call(d, b[g], g));
                return e;
            };
        });
        function Qa(a, b, c) {
            if (a == null) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
            return a + "";
        }
        ia("String.prototype.startsWith", function(a) {
            return a ? a : function(b, c) {
                var d = Qa(this, b, "startsWith"), e = d.length, f = b.length;
                c = Math.max(0, Math.min(c | 0, d.length));
                for(var g = 0; g < f && c < e;)if (d[c++] != b[g++]) return !1;
                return g >= f;
            };
        });
        ia("Object.is", function(a) {
            return a ? a : function(b, c) {
                return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
            };
        });
        ia("Array.prototype.includes", function(a) {
            return a ? a : function(b, c) {
                var d = this;
                d instanceof String && (d = String(d));
                var e = d.length;
                c = c || 0;
                for(c < 0 && (c = Math.max(c + e, 0)); c < e; c++){
                    var f = d[c];
                    if (f === b || Object.is(f, b)) return !0;
                }
                return !1;
            };
        });
        ia("String.prototype.includes", function(a) {
            return a ? a : function(b, c) {
                return Qa(this, b, "includes").indexOf(b, c || 0) !== -1;
            };
        });
        ia("String.fromCodePoint", function(a) {
            return a ? a : function(b) {
                for(var c = "", d = 0; d < arguments.length; d++){
                    var e = Number(arguments[d]);
                    if (e < 0 || e > 1114111 || e !== Math.floor(e)) throw new RangeError("invalid_code_point " + e);
                    e <= 65535 ? c += String.fromCharCode(e) : (e -= 65536, c += String.fromCharCode(e >>> 10 & 1023 | 55296), c += String.fromCharCode(e & 1023 | 56320));
                }
                return c;
            };
        });
        function Ra(a, b, c) {
            a instanceof String && (a = String(a));
            for(var d = a.length, e = 0; e < d; e++){
                var f = a[e];
                if (b.call(c, f, e, a)) return {
                    gj: e,
                    v: f
                };
            }
            return {
                gj: -1,
                v: void 0
            };
        }
        ia("Array.prototype.findIndex", function(a) {
            return a ? a : function(b, c) {
                return Ra(this, b, c).gj;
            };
        });
        ia("WeakSet", function(a) {
            function b(c) {
                this.g = new WeakMap;
                if (c) {
                    c = u(c);
                    for(var d; !(d = c.next()).done;)this.add(d.value);
                }
            }
            if (function() {
                if (!a || !Object.seal) return !1;
                try {
                    var c = Object.seal({}), d = Object.seal({}), e = new a([
                        c
                    ]);
                    if (!e.has(c) || e.has(d)) return !1;
                    e.delete(c);
                    e.add(d);
                    return !e.has(c) && e.has(d);
                } catch (f) {
                    return !1;
                }
            }()) return a;
            b.prototype.add = function(c) {
                this.g.set(c, !0);
                return this;
            };
            b.prototype.has = function(c) {
                return this.g.has(c);
            };
            b.prototype.delete = function(c) {
                return this.g.delete(c);
            };
            return b;
        });
        ia("Array.prototype.find", function(a) {
            return a ? a : function(b, c) {
                return Ra(this, b, c).v;
            };
        });
        ia("Object.entries", function(a) {
            return a ? a : function(b) {
                var c = [], d;
                for(d in b)Oa(b, d) && c.push([
                    d,
                    b[d]
                ]);
                return c;
            };
        });
        var Sa = typeof Object.assign == "function" ? Object.assign : function(a, b) {
            if (a == null) throw new TypeError("No nullish arg");
            a = Object(a);
            for(var c = 1; c < arguments.length; c++){
                var d = arguments[c];
                if (d) for(var e in d)Oa(d, e) && (a[e] = d[e]);
            }
            return a;
        };
        ia("Object.assign", function(a) {
            return a || Sa;
        });
        ia("Promise.prototype.finally", function(a) {
            return a ? a : function(b) {
                return this.then(function(c) {
                    return Promise.resolve(b()).then(function() {
                        return c;
                    });
                }, function(c) {
                    return Promise.resolve(b()).then(function() {
                        throw c;
                    });
                });
            };
        });
        ia("Array.prototype.entries", function(a) {
            return a ? a : function() {
                return Pa(this, function(b, c) {
                    return [
                        b,
                        c
                    ];
                });
            };
        });
        ia("Number.EPSILON", function() {
            return 2.220446049250313E-16;
        });
        ia("Number.MAX_SAFE_INTEGER", function() {
            return 9007199254740991;
        });
        ia("Math.clz32", function(a) {
            return a ? a : function(b) {
                b = Number(b) >>> 0;
                if (b === 0) return 32;
                var c = 0;
                (b & 4294901760) === 0 && (b <<= 16, c += 16);
                (b & 4278190080) === 0 && (b <<= 8, c += 8);
                (b & 4026531840) === 0 && (b <<= 4, c += 4);
                (b & 3221225472) === 0 && (b <<= 2, c += 2);
                (b & 2147483648) === 0 && c++;
                return c;
            };
        });
        ia("Number.isNaN", function(a) {
            return a ? a : function(b) {
                return typeof b === "number" && isNaN(b);
            };
        });
        ia("String.prototype.repeat", function(a) {
            return a ? a : function(b) {
                var c = Qa(this, null, "repeat");
                if (b < 0 || b > 1342177279) throw new RangeError("Invalid count value");
                b |= 0;
                for(var d = ""; b;)if (b & 1 && (d += c), b >>>= 1) c += c;
                return d;
            };
        });
        ia("Number.isFinite", function(a) {
            return a ? a : function(b) {
                return typeof b !== "number" ? !1 : !isNaN(b) && b !== Infinity && b !== -Infinity;
            };
        });
        ia("Object.values", function(a) {
            return a ? a : function(b) {
                var c = [], d;
                for(d in b)Oa(b, d) && c.push(b[d]);
                return c;
            };
        });
        ia("Math.log2", function(a) {
            return a ? a : function(b) {
                return Math.log(b) / Math.LN2;
            };
        });
        ia("String.prototype.endsWith", function(a) {
            return a ? a : function(b, c) {
                var d = Qa(this, b, "endsWith");
                c === void 0 && (c = d.length);
                c = Math.max(0, Math.min(c | 0, d.length));
                for(var e = b.length; e > 0 && c > 0;)if (d[--c] != b[--e]) return !1;
                return e <= 0;
            };
        });
        ia("Math.trunc", function(a) {
            return a ? a : function(b) {
                b = Number(b);
                if (isNaN(b) || b === Infinity || b === -Infinity || b === 0) return b;
                var c = Math.floor(Math.abs(b));
                return b < 0 ? -c : c;
            };
        });
        function Ta(a) {
            a = Math.trunc(a) || 0;
            a < 0 && (a += this.length);
            if (!(a < 0 || a >= this.length)) return this[a];
        }
        ia("Array.prototype.at", function(a) {
            return a ? a : Ta;
        });
        fa("at", function(a) {
            return a ? a : Ta;
        });
        ia("String.prototype.at", function(a) {
            return a ? a : Ta;
        });
        var Ua = this || self;
        function O(a, b) {
            a = a.split(".");
            var c = Ua;
            a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
            for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
        }
        function R(a, b) {
            if (b) {
                if (b instanceof Map) for(var c = u(b.keys()), d = c.next(); !d.done; d = c.next())d = d.value, Object.defineProperty(this, d, {
                    value: b.get(d),
                    writable: !0,
                    enumerable: !0
                });
                else for(c in b)Object.defineProperty(this, c, {
                    value: b[c],
                    writable: !0,
                    enumerable: !0
                });
            }
            this.defaultPrevented = this.cancelable = this.bubbles = !1;
            this.timeStamp = window1.performance && window1.performance.now ? window1.performance.now() : Date.now();
            this.type = a;
            this.isTrusted = !1;
            this.target = this.currentTarget = null;
            this.g = !1;
        }
        function Va(a) {
            var b = new R(a.type), c;
            for(c in a)Object.defineProperty(b, c, {
                value: a[c],
                writable: !0,
                enumerable: !0
            });
            return b;
        }
        R.prototype.preventDefault = function() {
            this.cancelable && (this.defaultPrevented = !0);
        };
        R.prototype.stopImmediatePropagation = function() {
            this.g = !0;
        };
        R.prototype.stopPropagation = function() {};
        O("shaka.util.FakeEvent", R);
        var Wa = {
            Km: "abrstatuschanged",
            Lm: "adaptation",
            Mm: "audiotrackchanged",
            Nm: "audiotrackschanged",
            Om: "boundarycrossed",
            Pm: "buffering",
            Qm: "canupdatestarttime",
            Rm: "complete",
            Sm: "currentitemchanged",
            Tm: "downloadcompleted",
            Um: "downloadfailed",
            Vm: "downloadheadersreceived",
            Wm: "drmsessionupdate",
            Xm: "emsg",
            dn: "itemsinserted",
            fn: "itemsremoved",
            xn: "prft",
            Error: "error",
            Ym: "expirationupdated",
            Zm: "firstquartile",
            $m: "gapjumped",
            gn: "keystatuschanged",
            ln: "loaded",
            mn: "loading",
            on: "manifestparsed",
            pn: "manifestupdated",
            qn: "mediaqualitychanged",
            rn: "mediasourcerecovered",
            tn: "metadataadded",
            Metadata: "metadata",
            un: "midpoint",
            vn: "nospatialvideoinfo",
            wn: "onstatechange",
            yn: "ratechange",
            Bn: "segmentappended",
            Cn: "sessiondata",
            Dn: "spatialvideoinfo",
            En: "stalldetected",
            Fn: "started",
            Gn: "statechanged",
            Hn: "streaming",
            In: "textchanged",
            Jn: "texttrackvisibility",
            Kn: "thirdquartile",
            Ln: "timelineregionadded",
            Mn: "timelineregionenter",
            Nn: "timelineregionexit",
            On: "trackschanged",
            Qn: "unloading",
            Sn: "variantchanged"
        };
        function Xa() {}
        function Ya() {}
        function Za() {}
        function $a(a) {
            var b = Ma.apply(1, arguments);
            ab.has(a) || (ab.add(a), Za.apply(Xa, G(b)));
        }
        function bb() {}
        function cb() {}
        function db() {}
        var ab = new Set;
        window1.console && ((new Map).set(1, function() {
            return console.error.apply(console, G(Ma.apply(0, arguments)));
        }).set(2, function() {
            return console.warn.apply(console, G(Ma.apply(0, arguments)));
        }).set(3, function() {
            return console.info.apply(console, G(Ma.apply(0, arguments)));
        }).set(4, function() {
            return console.log.apply(console, G(Ma.apply(0, arguments)));
        }).set(5, function() {
            return console.debug.apply(console, G(Ma.apply(0, arguments)));
        }).set(6, function() {
            return console.debug.apply(console, G(Ma.apply(0, arguments)));
        }), Za = function() {
            return console.warn.apply(console, G(Ma.apply(0, arguments)));
        }, Ya = function() {
            console.error.apply(console, G(Ma.apply(0, arguments)));
        });
        function eb() {
            this.g = new Map;
        }
        p = eb.prototype;
        p.push = function(a, b) {
            this.g.has(a) ? this.g.get(a).push(b) : this.g.set(a, [
                b
            ]);
        };
        p.get = function(a) {
            return this.g.has(a) ? this.g.get(a).slice() : null;
        };
        p.remove = function(a, b) {
            if (this.g.has(a)) {
                var c = this.g.get(a).filter(function(d) {
                    return d != b;
                });
                this.g.set(a, c);
                c.length || this.g.delete(a);
            }
        };
        p.forEach = function(a) {
            this.g.forEach(function(b, c) {
                a(c, b);
            });
        };
        p.size = function() {
            return this.g.size;
        };
        p.keys = function() {
            return Array.from(this.g.keys());
        };
        function fb() {
            this.hb = new eb;
            this.We = this;
        }
        fb.prototype.addEventListener = function(a, b) {
            this.hb && this.hb.push(a, b);
        };
        fb.prototype.removeEventListener = function(a, b) {
            this.hb && this.hb.remove(a, b);
        };
        fb.prototype.dispatchEvent = function(a) {
            if (!this.hb) return !0;
            var b = this.hb.get(a.type) || [], c = this.hb.get("All");
            c && (b = b.concat(c));
            b = u(b);
            for(c = b.next(); !c.done; c = b.next()){
                c = c.value;
                a.target = this.We;
                a.currentTarget = this.We;
                try {
                    c.handleEvent ? c.handleEvent(a) : c.call(this, a);
                } catch (d) {}
                if (a.g) break;
            }
            return a.defaultPrevented;
        };
        fb.prototype.release = function() {
            this.hb = null;
        };
        function gb(a, b) {
            var c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())c.push(b(d.value));
            return c;
        }
        function hb(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())if (!b(c.value)) return !1;
            return !0;
        }
        function ib(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())if (b(c.value)) return !0;
            return !1;
        }
        function jb(a, b) {
            var c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, b(d) && c.push(d);
            return c;
        }
        var kb = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#(.*))?$");
        function lb(a) {
            var b;
            a instanceof lb ? (mb(this, a.lc), this.rd = a.rd, nb(this, a.Eb), ob(this, a.Pd), this.Zb = a.Zb, pb(this, a.g.clone()), this.bd = a.bd) : a && (b = String(a).match(kb)) ? (mb(this, b[1] || "", !0), this.rd = qb(b[2] || ""), nb(this, b[3] || "", !0), ob(this, b[4]), this.Zb = qb(b[5] || "", !0), pb(this, b[6] || "", !0), this.bd = qb(b[7] || "")) : this.g = new rb(null);
        }
        p = lb.prototype;
        p.lc = "";
        p.rd = "";
        p.Eb = "";
        p.Pd = null;
        p.Zb = "";
        p.bd = "";
        p.toString = function() {
            var a = [], b = this.lc;
            b && a.push(tb(b, ub, !0), ":");
            if (b = this.Eb) {
                a.push("//");
                var c = this.rd;
                c && a.push(tb(c, ub, !0), "@");
                a.push(encodeURIComponent(b).replace(/%25([0-9a-fA-F]{2})/g, "%$1"));
                b = this.Pd;
                b != null && a.push(":", String(b));
            }
            if (b = this.Zb) this.Eb && b.charAt(0) != "/" && a.push("/"), a.push(tb(b, b.charAt(0) == "/" ? vb : xb, !0));
            (b = this.g.toString()) && a.push("?", b);
            (b = this.bd) && a.push("#", tb(b, yb));
            return a.join("");
        };
        p.resolve = function(a) {
            var b = this.clone();
            b.lc === "data" && (b = new lb);
            var c = !!a.lc;
            c ? mb(b, a.lc) : c = !!a.rd;
            c ? b.rd = a.rd : c = !!a.Eb;
            c ? nb(b, a.Eb) : c = a.Pd != null;
            var d = a.Zb;
            if (c) ob(b, a.Pd);
            else if (c = !!a.Zb) {
                if (d.charAt(0) != "/") {
                    if (this.Eb && !this.Zb) d = "/" + d;
                    else {
                        var e = b.Zb.lastIndexOf("/");
                        e != -1 && (d = b.Zb.substr(0, e + 1) + d);
                    }
                }
                e = d;
                if (e == ".." || e == ".") d = "";
                else if (e.indexOf("./") == -1 && e.indexOf("/.") == -1) d = e;
                else {
                    d = e.lastIndexOf("/", 0) == 0;
                    e = e.split("/");
                    for(var f = [], g = 0; g < e.length;){
                        var h = e[g++];
                        h == "." ? d && g == e.length && f.push("") : h == ".." ? ((f.length > 1 || f.length == 1 && f[0] != "") && f.pop(), d && g == e.length && f.push("")) : (f.push(h), d = !0);
                    }
                    d = f.join("/");
                }
            }
            c ? b.Zb = d : c = a.g.toString() !== "";
            c ? pb(b, a.g.clone()) : c = !!a.bd;
            c && (b.bd = a.bd);
            return b;
        };
        p.clone = function() {
            return new lb(this);
        };
        function mb(a, b, c) {
            a.lc = c ? qb(b, !0) : b;
            a.lc && (a.lc = a.lc.replace(/:$/, ""));
        }
        function nb(a, b, c) {
            a.Eb = c ? qb(b, !0) : b;
        }
        function ob(a, b) {
            if (b) {
                b = Number(b);
                if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
                a.Pd = b;
            } else a.Pd = null;
        }
        function pb(a, b, c) {
            b instanceof rb ? a.g = b : (c || (b = tb(b, zb)), a.g = new rb(b));
        }
        function qb(a, b) {
            return a ? b ? decodeURI(a) : decodeURIComponent(a) : "";
        }
        function tb(a, b, c) {
            return a != null ? (a = encodeURI(a).replace(b, Ab), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
        }
        function Ab(a) {
            a = a.charCodeAt(0);
            return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
        }
        var ub = /[#\/\?@]/g, xb = /[#\?:]/g, vb = /[#\?]/g, zb = /[#\?@]/g, yb = /#/g;
        function rb(a) {
            this.g = a || null;
        }
        function Bb(a) {
            if (!a.ob && (a.ob = new Map, a.je = 0, a.g)) for(var b = a.g.split("&"), c = 0; c < b.length; c++){
                var d = b[c].indexOf("="), e = null;
                if (d >= 0) {
                    var f = b[c].substring(0, d);
                    e = b[c].substring(d + 1);
                } else f = b[c];
                f = decodeURIComponent(f);
                e = e || "";
                a.add(f, decodeURIComponent(e));
            }
        }
        p = rb.prototype;
        p.ob = null;
        p.je = null;
        p.add = function(a, b) {
            Bb(this);
            this.g = null;
            var c = this.ob.has(a) ? this.ob.get(a) : null;
            c || this.ob.set(a, c = []);
            c.push(b);
            this.je++;
            return this;
        };
        p.set = function(a, b) {
            Bb(this);
            this.g = null;
            this.ob.has(a) ? this.ob.set(a, [
                b
            ]) : this.add(a, b);
            return this;
        };
        p.get = function(a) {
            Bb(this);
            return this.ob.get(a) || [];
        };
        p.toString = function() {
            if (this.g) return this.g;
            if (!this.ob || !this.ob.size) return "";
            for(var a = [], b = u(this.ob.keys()), c = b.next(); !c.done; c = b.next()){
                var d = c.value;
                c = encodeURIComponent(d);
                d = this.ob.get(d);
                for(var e = 0; e < d.length; e++){
                    var f = c;
                    d[e] !== "" && (f += "=" + encodeURIComponent(d[e]));
                    a.push(f);
                }
            }
            return this.g = a.join("&");
        };
        p.clone = function() {
            var a = new rb;
            a.g = this.g;
            if (this.ob) {
                for(var b = new Map, c = u(this.ob), d = c.next(); !d.done; d = c.next()){
                    var e = u(d.value);
                    d = e.next().value;
                    e = e.next().value;
                    b.set(d, e.concat());
                }
                a.ob = b;
                a.je = this.je;
            }
            return a;
        };
        function Cb() {}
        function Eb(a, b) {
            if (!a && !b) return !0;
            if (!a || !b || a.byteLength != b.byteLength) return !1;
            if ((ArrayBuffer.isView(a) ? a.buffer : a) == (ArrayBuffer.isView(b) ? b.buffer : b) && (a.byteOffset || 0) == (b.byteOffset || 0)) return !0;
            var c = Fb(a);
            b = Fb(b);
            for(var d = 0; d < a.byteLength; d++)if (c[d] != b[d]) return !1;
            return !0;
        }
        function Gb(a) {
            return ArrayBuffer.isView(a) ? a.byteOffset == 0 && a.byteLength == a.buffer.byteLength ? a.buffer : new Uint8Array(a).buffer : a;
        }
        function Fb(a, b, c) {
            c = c === void 0 ? Infinity : c;
            return Hb(a, b === void 0 ? 0 : b, c, Uint8Array);
        }
        function Ib(a, b, c) {
            c = c === void 0 ? Infinity : c;
            return Hb(a, b === void 0 ? 0 : b, c, Uint16Array);
        }
        function Jb(a, b, c) {
            c = c === void 0 ? Infinity : c;
            return Hb(a, b === void 0 ? 0 : b, c, DataView);
        }
        function Hb(a, b, c, d) {
            var e = ArrayBuffer.isView(a) ? a.buffer : a, f = 1;
            "BYTES_PER_ELEMENT" in d && (f = d.BYTES_PER_ELEMENT);
            var g = ((a.byteOffset || 0) + a.byteLength) / f;
            a = Math.floor(Math.max(0, Math.min(((a.byteOffset || 0) + b) / f, g)));
            return new d(e, a, Math.floor(Math.min(a + Math.max(c, 0), g)) - a);
        }
        O("shaka.util.BufferUtils", Cb);
        Cb.toDataView = Jb;
        Cb.toUint16 = Ib;
        Cb.toUint8 = Fb;
        Cb.toArrayBuffer = Gb;
        Cb.equal = Eb;
        function Kb(a) {
            this.h = a;
            this.g = void 0;
        }
        Kb.prototype.value = function() {
            this.g === void 0 && (this.g = this.h());
            return this.g;
        };
        function Lb(a, b) {
            if (a === b || !a.length || !b.length) return !0;
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                if (Mb(c)) return !0;
                for(var d = u(b), e = d.next(); !e.done; e = d.next())if (e = e.value, c.keySystem === e.keySystem || Mb(e)) return !0;
            }
            return !1;
        }
        function Nb(a, b) {
            if (!a.length) return b;
            if (!b.length) return a;
            var c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next()){
                d = d.value;
                for(var e = u(b), f = e.next(); !f.done; f = e.next())if (f = f.value, d.keySystem == f.keySystem) {
                    e = new Map;
                    for(var g = u((d.initData || []).concat(f.initData || [])), h = g.next(); !h.done; h = g.next())h = h.value, e.set(h.keyId, h);
                    e = Array.from(e.values());
                    g = d.keyIds && f.keyIds ? new Set([].concat(G(d.keyIds), G(f.keyIds))) : d.keyIds || f.keyIds;
                    c.push({
                        keySystem: d.keySystem,
                        licenseServerUri: d.licenseServerUri || f.licenseServerUri,
                        distinctiveIdentifierRequired: d.distinctiveIdentifierRequired || f.distinctiveIdentifierRequired,
                        persistentStateRequired: d.persistentStateRequired || f.persistentStateRequired,
                        videoRobustness: d.videoRobustness || f.videoRobustness,
                        audioRobustness: d.audioRobustness || f.audioRobustness,
                        serverCertificate: d.serverCertificate || f.serverCertificate,
                        serverCertificateUri: d.serverCertificateUri || f.serverCertificateUri,
                        initData: e,
                        keyIds: g
                    });
                    break;
                } else Mb(d) ? c.push(d) : Mb(f) && c.push(f);
            }
            return c;
        }
        function Ob(a) {
            return a === "org.w3.clearkey";
        }
        function Pb(a) {
            return a ? !!a.match(/^com\.widevine\.alpha/) : !1;
        }
        function Qb(a) {
            return a ? !!a.match(/^com\.(microsoft|chromecast)\.playready/) : !1;
        }
        function Rb(a) {
            return a ? !!a.match(/^com\.apple\.fps/) : !1;
        }
        function Mb(a) {
            return (a = a.licenseServerUri) ? a.startsWith("data:application/json;base64,") : !1;
        }
        function Sb(a, b, c, d) {
            d = [].concat(G(new Set(d))).sort().join("#");
            return a + "#" + b + "#" + c + "#" + d;
        }
        var Tb = new Kb(function() {
            return Gb(new Uint8Array([
                0
            ]));
        }), Ub = new Map;
        function T(a, b, c) {
            var d = Ma.apply(3, arguments);
            this.severity = a;
            this.category = b;
            this.code = c;
            this.data = d;
            this.handled = !1;
            this.message = "Shaka Error " + this.code;
            if (Vb) try {
                throw Error(this.message || "Shaka Error");
            } catch (e) {
                this.stack = e.stack;
            }
        }
        T.prototype.toString = function() {
            return "shaka.util.Error " + JSON.stringify(this, null, "  ");
        };
        O("shaka.util.Error", T);
        var Vb = !0;
        T.Severity = {
            RECOVERABLE: 1,
            CRITICAL: 2
        };
        T.Category = {
            NETWORK: 1,
            TEXT: 2,
            MEDIA: 3,
            MANIFEST: 4,
            STREAMING: 5,
            DRM: 6,
            PLAYER: 7,
            CAST: 8,
            STORAGE: 9,
            ADS: 10
        };
        T.Code = {
            UNSUPPORTED_SCHEME: 1E3,
            BAD_HTTP_STATUS: 1001,
            HTTP_ERROR: 1002,
            TIMEOUT: 1003,
            MALFORMED_DATA_URI: 1004,
            REQUEST_FILTER_ERROR: 1006,
            RESPONSE_FILTER_ERROR: 1007,
            MALFORMED_TEST_URI: 1008,
            UNEXPECTED_TEST_REQUEST: 1009,
            ATTEMPTS_EXHAUSTED: 1010,
            SEGMENT_MISSING: 1011,
            INVALID_TEXT_HEADER: 2E3,
            INVALID_TEXT_CUE: 2001,
            UNABLE_TO_DETECT_ENCODING: 2003,
            BAD_ENCODING: 2004,
            INVALID_XML: 2005,
            INVALID_MP4_TTML: 2007,
            INVALID_MP4_VTT: 2008,
            UNABLE_TO_EXTRACT_CUE_START_TIME: 2009,
            INVALID_MP4_CEA: 2010,
            TEXT_COULD_NOT_GUESS_MIME_TYPE: 2011,
            CANNOT_ADD_EXTERNAL_TEXT_TO_SRC_EQUALS: 2012,
            TEXT_ONLY_WEBVTT_SRC_EQUALS: 2013,
            MISSING_TEXT_PLUGIN: 2014,
            UNSUPPORTED_EXTERNAL_THUMBNAILS_URI: 2017,
            BUFFER_READ_OUT_OF_BOUNDS: 3E3,
            JS_INTEGER_OVERFLOW: 3001,
            EBML_OVERFLOW: 3002,
            EBML_BAD_FLOATING_POINT_SIZE: 3003,
            MP4_SIDX_WRONG_BOX_TYPE: 3004,
            MP4_SIDX_INVALID_TIMESCALE: 3005,
            MP4_SIDX_TYPE_NOT_SUPPORTED: 3006,
            WEBM_CUES_ELEMENT_MISSING: 3007,
            WEBM_EBML_HEADER_ELEMENT_MISSING: 3008,
            WEBM_SEGMENT_ELEMENT_MISSING: 3009,
            WEBM_INFO_ELEMENT_MISSING: 3010,
            WEBM_DURATION_ELEMENT_MISSING: 3011,
            WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING: 3012,
            WEBM_CUE_TIME_ELEMENT_MISSING: 3013,
            MEDIA_SOURCE_OPERATION_FAILED: 3014,
            MEDIA_SOURCE_OPERATION_THREW: 3015,
            VIDEO_ERROR: 3016,
            QUOTA_EXCEEDED_ERROR: 3017,
            TRANSMUXING_FAILED: 3018,
            CONTENT_TRANSFORMATION_FAILED: 3019,
            MSS_MISSING_DATA_FOR_TRANSMUXING: 3020,
            MSS_TRANSMUXING_FAILED: 3022,
            TRANSMUXING_NO_VIDEO_DATA: 3023,
            STREAMING_NOT_ALLOWED: 3024,
            UNABLE_TO_GUESS_MANIFEST_TYPE: 4E3,
            DASH_INVALID_XML: 4001,
            DASH_NO_SEGMENT_INFO: 4002,
            DASH_EMPTY_ADAPTATION_SET: 4003,
            DASH_EMPTY_PERIOD: 4004,
            DASH_WEBM_MISSING_INIT: 4005,
            DASH_UNSUPPORTED_CONTAINER: 4006,
            DASH_PSSH_BAD_ENCODING: 4007,
            DASH_NO_COMMON_KEY_SYSTEM: 4008,
            DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED: 4009,
            DASH_CONFLICTING_KEY_IDS: 4010,
            RESTRICTIONS_CANNOT_BE_MET: 4012,
            HLS_PLAYLIST_HEADER_MISSING: 4015,
            INVALID_HLS_TAG: 4016,
            HLS_INVALID_PLAYLIST_HIERARCHY: 4017,
            DASH_DUPLICATE_REPRESENTATION_ID: 4018,
            HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND: 4020,
            HLS_REQUIRED_ATTRIBUTE_MISSING: 4023,
            HLS_REQUIRED_TAG_MISSING: 4024,
            HLS_COULD_NOT_GUESS_CODECS: 4025,
            HLS_KEYFORMATS_NOT_SUPPORTED: 4026,
            DASH_UNSUPPORTED_XLINK_ACTUATE: 4027,
            DASH_XLINK_DEPTH_LIMIT: 4028,
            CONTENT_UNSUPPORTED_BY_BROWSER: 4032,
            CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM: 4033,
            NO_VARIANTS: 4036,
            PERIOD_FLATTENING_FAILED: 4037,
            INCONSISTENT_DRM_ACROSS_PERIODS: 4038,
            HLS_VARIABLE_NOT_FOUND: 4039,
            HLS_MSE_ENCRYPTED_MP2T_NOT_SUPPORTED: 4040,
            HLS_MSE_ENCRYPTED_LEGACY_APPLE_MEDIA_KEYS_NOT_SUPPORTED: 4041,
            NO_WEB_CRYPTO_API: 4042,
            CANNOT_ADD_EXTERNAL_THUMBNAILS_TO_LIVE_STREAM: 4045,
            MSS_INVALID_XML: 4046,
            MSS_LIVE_CONTENT_NOT_SUPPORTED: 4047,
            AES_128_INVALID_IV_LENGTH: 4048,
            AES_128_INVALID_KEY_LENGTH: 4049,
            DASH_CONFLICTING_AES_128: 4050,
            DASH_UNSUPPORTED_AES_128: 4051,
            DASH_INVALID_PATCH: 4052,
            HLS_EMPTY_MEDIA_PLAYLIST: 4053,
            DASH_MSE_ENCRYPTED_LEGACY_APPLE_MEDIA_KEYS_NOT_SUPPORTED: 4054,
            CANNOT_ADD_EXTERNAL_CHAPTERS_TO_LIVE_STREAM: 4055,
            STREAMING_ENGINE_STARTUP_INVALID_STATE: 5006,
            NO_RECOGNIZED_KEY_SYSTEMS: 6E3,
            REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE: 6001,
            FAILED_TO_CREATE_CDM: 6002,
            FAILED_TO_ATTACH_TO_VIDEO: 6003,
            INVALID_SERVER_CERTIFICATE: 6004,
            FAILED_TO_CREATE_SESSION: 6005,
            FAILED_TO_GENERATE_LICENSE_REQUEST: 6006,
            LICENSE_REQUEST_FAILED: 6007,
            LICENSE_RESPONSE_REJECTED: 6008,
            ENCRYPTED_CONTENT_WITHOUT_DRM_INFO: 6010,
            NO_LICENSE_SERVER_GIVEN: 6012,
            OFFLINE_SESSION_REMOVED: 6013,
            EXPIRED: 6014,
            SERVER_CERTIFICATE_REQUIRED: 6015,
            INIT_DATA_TRANSFORM_ERROR: 6016,
            SERVER_CERTIFICATE_REQUEST_FAILED: 6017,
            MIN_HDCP_VERSION_NOT_MATCH: 6018,
            ERROR_CHECKING_HDCP_VERSION: 6019,
            MISSING_EME_SUPPORT: 6020,
            LOAD_INTERRUPTED: 7E3,
            OPERATION_ABORTED: 7001,
            NO_VIDEO_ELEMENT: 7002,
            OBJECT_DESTROYED: 7003,
            CONTENT_NOT_LOADED: 7004,
            SRC_EQUALS_PRELOAD_NOT_SUPPORTED: 7005,
            PRELOAD_DESTROYED: 7006,
            QUEUE_INDEX_OUT_OF_BOUNDS: 7007,
            CAST_API_UNAVAILABLE: 8E3,
            NO_CAST_RECEIVERS: 8001,
            ALREADY_CASTING: 8002,
            UNEXPECTED_CAST_ERROR: 8003,
            CAST_CANCELED_BY_USER: 8004,
            CAST_CONNECTION_TIMED_OUT: 8005,
            CAST_RECEIVER_APP_UNAVAILABLE: 8006,
            STORAGE_NOT_SUPPORTED: 9E3,
            INDEXED_DB_ERROR: 9001,
            DEPRECATED_OPERATION_ABORTED: 9002,
            REQUESTED_ITEM_NOT_FOUND: 9003,
            MALFORMED_OFFLINE_URI: 9004,
            CANNOT_STORE_LIVE_OFFLINE: 9005,
            NO_INIT_DATA_FOR_OFFLINE: 9007,
            LOCAL_PLAYER_INSTANCE_REQUIRED: 9008,
            NEW_KEY_OPERATION_NOT_SUPPORTED: 9011,
            KEY_NOT_FOUND: 9012,
            MISSING_STORAGE_CELL: 9013,
            STORAGE_LIMIT_REACHED: 9014,
            DOWNLOAD_SIZE_CALLBACK_ERROR: 9015,
            MODIFY_OPERATION_NOT_SUPPORTED: 9016,
            INDEXED_DB_INIT_TIMED_OUT: 9017,
            CS_IMA_SDK_MISSING: 1E4,
            CS_AD_MANAGER_NOT_INITIALIZED: 10001,
            SS_IMA_SDK_MISSING: 10002,
            SS_AD_MANAGER_NOT_INITIALIZED: 10003,
            CURRENT_DAI_REQUEST_NOT_FINISHED: 10004,
            MT_AD_MANAGER_NOT_INITIALIZED: 10005,
            INTERSTITIAL_AD_MANAGER_NOT_INITIALIZED: 10006,
            VAST_INVALID_XML: 10007
        };
        function Xb() {
            return Yb.value();
        }
        var Zb = null, $b = null, Yb = new Kb(function() {
            var a = void 0;
            Zb && (a = Zb());
            !a && $b && (a = $b());
            return a;
        });
        function ac() {}
        function bc(a) {
            if (!a) return "";
            a = Fb(a);
            a[0] == 239 && a[1] == 187 && a[2] == 191 && (a = a.subarray(3));
            if (window1.TextDecoder && !Xb().ni()) return a = (new TextDecoder).decode(a), a.includes("\ufffd") && Ya('Decoded string contains an "unknown character" codepoint.  That probably means the UTF8 encoding was incorrect!'), a;
            for(var b = "", c = 0; c < a.length; ++c){
                var d = 65533;
                (a[c] & 128) == 0 ? d = a[c] : a.length >= c + 2 && (a[c] & 224) == 192 && (a[c + 1] & 192) == 128 ? (d = (a[c] & 31) << 6 | a[c + 1] & 63, c += 1) : a.length >= c + 3 && (a[c] & 240) == 224 && (a[c + 1] & 192) == 128 && (a[c + 2] & 192) == 128 ? (d = (a[c] & 15) << 12 | (a[c + 1] & 63) << 6 | a[c + 2] & 63, c += 2) : a.length >= c + 4 && (a[c] & 241) == 240 && (a[c + 1] & 192) == 128 && (a[c + 2] & 192) == 128 && (a[c + 3] & 192) == 128 && (d = (a[c] & 7) << 18 | (a[c + 1] & 63) << 12 | (a[c + 2] & 63) << 6 | a[c + 3] & 63, c += 3);
                if (d <= 65535) b += String.fromCharCode(d);
                else {
                    d -= 65536;
                    var e = d & 1023;
                    b += String.fromCharCode(55296 + (d >> 10));
                    b += String.fromCharCode(56320 + e);
                }
            }
            return b;
        }
        function cc(a, b, c) {
            if (!a) return "";
            if (!c && a.byteLength % 2 != 0) throw new T(2, 2, 2004);
            c = Math.floor(a.byteLength / 2);
            var d = new Uint16Array(c);
            a = Jb(a);
            for(var e = 0; e < c; e++)d[e] = a.getUint16(e * 2, b);
            return dc.value()(d);
        }
        function ec(a) {
            function b(d) {
                return c.byteLength <= d || c[d] >= 9 && c[d] <= 126;
            }
            if (!a) return "";
            var c = Fb(a);
            if (c[0] == 239 && c[1] == 187 && c[2] == 191) return bc(c);
            if (c[0] == 254 && c[1] == 255) return cc(c.subarray(2), !1);
            if (c[0] == 255 && c[1] == 254) return cc(c.subarray(2), !0);
            if (c[0] == 0 && c[2] == 0) return cc(a, !1);
            if (c[1] == 0 && c[3] == 0) return cc(a, !0);
            if (b(0) && b(1) && b(2) && b(3)) return bc(a);
            throw new T(2, 2, 2003);
        }
        function hc(a) {
            if (window1.TextEncoder && !Xb().ni()) {
                var b = new TextEncoder;
                return Gb(b.encode(a));
            }
            a = encodeURIComponent(a);
            a = unescape(a);
            b = new Uint8Array(a.length);
            for(var c = 0; c < a.length; c++)b[c] = a[c].charCodeAt(0);
            return Gb(b);
        }
        function ic(a, b) {
            for(var c = new ArrayBuffer(a.length * 2), d = new DataView(c), e = 0; e < a.length; ++e)d.setUint16(e * 2, a.charCodeAt(e), b);
            return c;
        }
        function jc(a) {
            var b = {
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&quot;": '"',
                "&apos;": "'",
                "&nbsp;": "\u00a0",
                "&lrm;": "\u200e",
                "&rlm;": "\u200f"
            }, c = /&(?:amp|lt|gt|quot|apos|nbsp|lrm|rlm|#[xX]?[0-9a-fA-F]+);/g, d = RegExp(c.source);
            return a && d.test(a) ? a.replace(c, function(e) {
                return e[1] == "#" ? (e = e[2] == "x" || e[2] == "X" ? parseInt(e.substring(3), 16) : parseInt(e.substring(2), 10), e >= 0 && e <= 1114111 ? String.fromCodePoint(e) : "") : b[e] || "'";
            }) : a || "";
        }
        O("shaka.util.StringUtils", ac);
        ac.resetFromCharCode = function() {
            dc.g = void 0;
        };
        ac.toUTF16 = ic;
        ac.toUTF8 = hc;
        ac.fromBytesAutoDetect = ec;
        ac.fromUTF16 = cc;
        ac.fromUTF8 = bc;
        var dc = new Kb(function() {
            function a(c) {
                try {
                    var d = new Uint8Array(c);
                    return String.fromCharCode.apply(null, d).length > 0;
                } catch (e) {
                    return !1;
                }
            }
            for(var b = {
                Xc: 65536
            }; b.Xc > 0; b = {
                Xc: b.Xc
            }, b.Xc /= 2)if (a(b.Xc)) return function(c) {
                return function(d) {
                    for(var e = "", f = 0; f < d.length; f += c.Xc)e += String.fromCharCode.apply(null, d.subarray(f, f + c.Xc));
                    return e;
                };
            }(b);
            return null;
        });
        function kc() {}
        function lc(a) {
            a = Fb(a);
            return Uint8Array.prototype.toBase64 ? a.toBase64({
                alphabet: "base64",
                omitPadding: !1
            }) : (a = dc.value()(a), btoa(a));
        }
        function mc(a, b) {
            b = b == void 0 ? !0 : b;
            return Uint8Array.prototype.toBase64 ? Fb(a).toBase64({
                alphabet: "base64url",
                omitPadding: !b
            }) : (a = lc(a).replace(/\+/g, "-").replace(/\//g, "_"), b ? a : a.replace(/[=]*$/, ""));
        }
        function qc(a) {
            if (!("fromBase64" in Uint8Array)) {
                a = window1.atob(a.replace(/-/g, "+").replace(/_/g, "/"));
                for(var b = new Uint8Array(a.length), c = 0; c < a.length; ++c)b[c] = a.charCodeAt(c);
                return b;
            }
            a = a.replace(/\s+/g, "");
            return Uint8Array.fromBase64(a, {
                alphabet: /[-_]/.test(a) ? "base64url" : "base64"
            });
        }
        function rc(a) {
            if (!("fromHex" in Uint8Array)) {
                for(var b = a.length / 2, c = new Uint8Array(b), d = 0; d < b; d++)c[d] = window1.parseInt(a.substr(d * 2, 2), 16);
                return c;
            }
            return Uint8Array.fromHex(a);
        }
        function sc(a) {
            var b = Fb(a);
            if (!Uint8Array.prototype.toHex) {
                a = "";
                b = u(b);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, c = c.toString(16), c.length == 1 && (c = "0" + c), a += c;
                return a;
            }
            return b.toHex();
        }
        function tc() {
            var a = Ma.apply(0, arguments);
            return uc(a, 0, a.length);
        }
        function uc(a, b, c) {
            b = b === void 0 ? 0 : b;
            c = c === void 0 ? a.length : c;
            for(var d = 0, e = b; e < c; ++e)d += a[e].byteLength;
            d = new Uint8Array(d);
            for(e = 0; b < c; ++b){
                var f = a[b];
                ArrayBuffer.isView(f) && f.BYTES_PER_ELEMENT === 1 ? d.set(f, e) : d.set(Fb(f), e);
                e += f.byteLength;
            }
            return d;
        }
        O("shaka.util.Uint8ArrayUtils", kc);
        kc.concat = tc;
        kc.toHex = sc;
        kc.fromHex = rc;
        kc.fromBase64 = qc;
        kc.toBase64 = mc;
        kc.toStandardBase64 = lc;
        function vc(a, b, c) {
            c = c === void 0 ? "" : c;
            if (b.length == 0) return a;
            if (a.length == 1 && b.length == 1) {
                var d = new lb(a[0]);
                b = new lb(b[0]);
                b = d.resolve(b);
                c && pb(b, c);
                return [
                    b.toString()
                ];
            }
            b = b.map(function(h) {
                return new lb(h);
            });
            d = [];
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next()){
                e = new lb(e.value);
                for(var f = u(b), g = f.next(); !g.done; g = f.next())g = e.resolve(g.value), c && pb(g, c), d.push(g.toString());
            }
            return d;
        }
        function yc(a, b, c, d, e) {
            b = {
                keySystem: a,
                encryptionScheme: b,
                licenseServerUri: "",
                distinctiveIdentifierRequired: !1,
                persistentStateRequired: !1,
                audioRobustness: "",
                videoRobustness: "",
                serverCertificate: null,
                serverCertificateUri: "",
                sessionType: "",
                initData: c || [],
                keyIds: new Set,
                mediaTypes: e
            };
            d && (b.keySystemUris = new Set([
                d
            ]));
            !c && Rb(a) && b.initData.push({
                initDataType: "sinf",
                initData: new Uint8Array(0),
                keyId: null
            });
            return b;
        }
        function zc(a, b) {
            b = b === void 0 ? "cenc" : b;
            var c = [], d = [], e = [];
            a.forEach(function(g, h) {
                var k = h;
                k.length != 22 && (k = mc(rc(h), !1));
                var l = g;
                l.length != 22 && (l = mc(rc(g), !1));
                g = {
                    kty: "oct",
                    kid: k,
                    k: l
                };
                c.push(g);
                d.push(g.kid);
                e.push(h);
            });
            a = JSON.stringify({
                keys: c
            });
            var f = JSON.stringify({
                kids: d
            });
            f = [
                {
                    initData: Fb(hc(f)),
                    initDataType: "keyids"
                }
            ];
            return {
                keySystem: "org.w3.clearkey",
                encryptionScheme: b,
                licenseServerUri: "data:application/json;base64," + window1.btoa(a),
                distinctiveIdentifierRequired: !1,
                persistentStateRequired: !1,
                audioRobustness: "",
                videoRobustness: "",
                serverCertificate: null,
                serverCertificateUri: "",
                sessionType: "",
                initData: f,
                keyIds: new Set(e)
            };
        }
        function Bc(a, b) {
            if (b.length == 1) return b[0];
            a = Cc(a, b);
            if (a != null) return a;
            throw new T(2, 4, 4025, b);
        }
        function Cc(a, b) {
            var c = Dc.get(a);
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next()){
                d = d.value;
                for(var e = u(b), f = e.next(); !f.done; f = e.next())if (f = f.value, d.test(f.trim())) return f.trim();
            }
            return a == Ec ? "" : null;
        }
        function Fc(a, b) {
            var c = [];
            a = Dc.get(a);
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next()){
                d = d.value;
                for(var e = u(b), f = e.next(); !f.done; f = e.next())f = f.value, d.test(f.trim()) && c.push(f.trim());
            }
            return c;
        }
        var Ec = "text", Gc = {
            Ba: "video",
            ha: "audio",
            Va: Ec,
            zg: "image",
            Im: "application"
        }, Hc = 1 / 15, Dc = (new Map).set("audio", [
            /^vorbis$/,
            /^Opus$/,
            /^opus$/,
            /^fLaC$/,
            /^flac$/,
            /^mp4a/,
            /^[ae]c-3$/,
            /^ac-4/,
            /^dts[cehx]?$/,
            /^iamf/,
            /^mhm[12]/,
            /^ac3$/,
            /^eac3$/,
            /^apac$/
        ]).set("video", [
            /^avc/,
            /^hev/,
            /^hvc/,
            /^vvc/,
            /^vvi/,
            /^vp0?[89]/,
            /^av01/,
            /^mp2v/,
            /^dvh/,
            /^dva/,
            /^dav/
        ]).set("text", [
            /^vtt$/,
            /^wvtt/,
            /^stpp/
        ]);
        function Ic() {}
        function Jc(a, b) {
            a = Kc(a);
            b = Kc(b);
            return a.split("-")[0] == b.split("-")[0];
        }
        function Lc(a, b) {
            a = Kc(a);
            b = Kc(b);
            a = a.split("-");
            b = b.split("-");
            return a[0] == b[0] && a.length == 1 && b.length == 2;
        }
        function Mc(a, b) {
            a = Kc(a);
            b = Kc(b);
            a = a.split("-");
            b = b.split("-");
            return a.length == 2 && b.length == 2 && a[0] == b[0];
        }
        function Kc(a) {
            a = u(a.split("-x-"));
            var b = a.next().value;
            b = b === void 0 ? "" : b;
            a = a.next().value;
            a = a === void 0 ? "" : a;
            var c = u(b.split("-"));
            b = c.next().value;
            b = b === void 0 ? "" : b;
            c = c.next().value;
            c = c === void 0 ? "" : c;
            a = a ? "x-" + a : "";
            b = b.toLowerCase();
            b = Nc.get(b) || b;
            c = c.toUpperCase();
            return (c ? b + "-" + c : b) + (a ? "-" + a : "");
        }
        function Oc(a, b) {
            var c = Pc(a), d = Pc(b);
            return a != c && b != d && c == d;
        }
        function Qc(a, b) {
            a = Kc(a);
            b = Kc(b);
            return b == a ? 4 : Lc(b, a) ? 3 : Mc(b, a) ? 2 : Lc(a, b) ? 1 : 0;
        }
        function Pc(a) {
            var b = a.indexOf("-");
            a = b >= 0 ? a.substring(0, b) : a;
            a = a.toLowerCase();
            return a = Nc.get(a) || a;
        }
        function Rc(a) {
            return a.language ? Kc(a.language) : a.audio && a.audio.language ? Kc(a.audio.language) : a.video && a.video.language ? Kc(a.video.language) : "und";
        }
        function Sc(a, b) {
            a = Kc(a);
            var c = new Set;
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())c.add(Kc(d.value));
            b = u(c);
            for(d = b.next(); !d.done; d = b.next())if (d = d.value, d == a) return d;
            b = u(c);
            for(d = b.next(); !d.done; d = b.next())if (d = d.value, Lc(d, a)) return d;
            b = u(c);
            for(d = b.next(); !d.done; d = b.next())if (d = d.value, Mc(d, a)) return d;
            c = u(c);
            for(b = c.next(); !b.done; b = c.next())if (b = b.value, Lc(a, b)) return b;
            return null;
        }
        O("shaka.util.LanguageUtils", Ic);
        Ic.findClosestLocale = Sc;
        Ic.getLocaleForVariant = Rc;
        Ic.getLocaleForText = function(a) {
            return Kc(a.language || "und");
        };
        Ic.getBase = Pc;
        Ic.relatedness = Qc;
        Ic.areSiblings = Oc;
        Ic.normalize = Kc;
        Ic.isSiblingOf = Mc;
        Ic.isParentOf = Lc;
        Ic.areLanguageCompatible = Jc;
        Ic.areLocaleCompatible = function(a, b) {
            a = Kc(a);
            b = Kc(b);
            return a == b;
        };
        var Nc = new Map([
            [
                "aar",
                "aa"
            ],
            [
                "abk",
                "ab"
            ],
            [
                "afr",
                "af"
            ],
            [
                "aka",
                "ak"
            ],
            [
                "alb",
                "sq"
            ],
            [
                "amh",
                "am"
            ],
            [
                "ara",
                "ar"
            ],
            [
                "arg",
                "an"
            ],
            [
                "arm",
                "hy"
            ],
            [
                "asm",
                "as"
            ],
            [
                "ava",
                "av"
            ],
            [
                "ave",
                "ae"
            ],
            [
                "aym",
                "ay"
            ],
            [
                "aze",
                "az"
            ],
            [
                "bak",
                "ba"
            ],
            [
                "bam",
                "bm"
            ],
            [
                "baq",
                "eu"
            ],
            [
                "bel",
                "be"
            ],
            [
                "ben",
                "bn"
            ],
            [
                "bih",
                "bh"
            ],
            [
                "bis",
                "bi"
            ],
            [
                "bod",
                "bo"
            ],
            [
                "bos",
                "bs"
            ],
            [
                "bre",
                "br"
            ],
            [
                "bul",
                "bg"
            ],
            [
                "bur",
                "my"
            ],
            [
                "cat",
                "ca"
            ],
            [
                "ces",
                "cs"
            ],
            [
                "cha",
                "ch"
            ],
            [
                "che",
                "ce"
            ],
            [
                "chi",
                "zh"
            ],
            [
                "chu",
                "cu"
            ],
            [
                "chv",
                "cv"
            ],
            [
                "cor",
                "kw"
            ],
            [
                "cos",
                "co"
            ],
            [
                "cre",
                "cr"
            ],
            [
                "cym",
                "cy"
            ],
            [
                "cze",
                "cs"
            ],
            [
                "dan",
                "da"
            ],
            [
                "deu",
                "de"
            ],
            [
                "div",
                "dv"
            ],
            [
                "dut",
                "nl"
            ],
            [
                "dzo",
                "dz"
            ],
            [
                "ell",
                "el"
            ],
            [
                "eng",
                "en"
            ],
            [
                "epo",
                "eo"
            ],
            [
                "est",
                "et"
            ],
            [
                "eus",
                "eu"
            ],
            [
                "ewe",
                "ee"
            ],
            [
                "fao",
                "fo"
            ],
            [
                "fas",
                "fa"
            ],
            [
                "fij",
                "fj"
            ],
            [
                "fin",
                "fi"
            ],
            [
                "fra",
                "fr"
            ],
            [
                "fre",
                "fr"
            ],
            [
                "fry",
                "fy"
            ],
            [
                "ful",
                "ff"
            ],
            [
                "geo",
                "ka"
            ],
            [
                "ger",
                "de"
            ],
            [
                "gla",
                "gd"
            ],
            [
                "gle",
                "ga"
            ],
            [
                "glg",
                "gl"
            ],
            [
                "glv",
                "gv"
            ],
            [
                "gre",
                "el"
            ],
            [
                "grn",
                "gn"
            ],
            [
                "guj",
                "gu"
            ],
            [
                "hat",
                "ht"
            ],
            [
                "hau",
                "ha"
            ],
            [
                "heb",
                "he"
            ],
            [
                "her",
                "hz"
            ],
            [
                "hin",
                "hi"
            ],
            [
                "hmo",
                "ho"
            ],
            [
                "hrv",
                "hr"
            ],
            [
                "hun",
                "hu"
            ],
            [
                "hye",
                "hy"
            ],
            [
                "ibo",
                "ig"
            ],
            [
                "ice",
                "is"
            ],
            [
                "ido",
                "io"
            ],
            [
                "iii",
                "ii"
            ],
            [
                "iku",
                "iu"
            ],
            [
                "ile",
                "ie"
            ],
            [
                "ina",
                "ia"
            ],
            [
                "ind",
                "id"
            ],
            [
                "ipk",
                "ik"
            ],
            [
                "isl",
                "is"
            ],
            [
                "ita",
                "it"
            ],
            [
                "jav",
                "jv"
            ],
            [
                "jpn",
                "ja"
            ],
            [
                "kal",
                "kl"
            ],
            [
                "kan",
                "kn"
            ],
            [
                "kas",
                "ks"
            ],
            [
                "kat",
                "ka"
            ],
            [
                "kau",
                "kr"
            ],
            [
                "kaz",
                "kk"
            ],
            [
                "khm",
                "km"
            ],
            [
                "kik",
                "ki"
            ],
            [
                "kin",
                "rw"
            ],
            [
                "kir",
                "ky"
            ],
            [
                "kom",
                "kv"
            ],
            [
                "kon",
                "kg"
            ],
            [
                "kor",
                "ko"
            ],
            [
                "kua",
                "kj"
            ],
            [
                "kur",
                "ku"
            ],
            [
                "lao",
                "lo"
            ],
            [
                "lat",
                "la"
            ],
            [
                "lav",
                "lv"
            ],
            [
                "lim",
                "li"
            ],
            [
                "lin",
                "ln"
            ],
            [
                "lit",
                "lt"
            ],
            [
                "ltz",
                "lb"
            ],
            [
                "lub",
                "lu"
            ],
            [
                "lug",
                "lg"
            ],
            [
                "mac",
                "mk"
            ],
            [
                "mah",
                "mh"
            ],
            [
                "mal",
                "ml"
            ],
            [
                "mao",
                "mi"
            ],
            [
                "mar",
                "mr"
            ],
            [
                "may",
                "ms"
            ],
            [
                "mkd",
                "mk"
            ],
            [
                "mlg",
                "mg"
            ],
            [
                "mlt",
                "mt"
            ],
            [
                "mon",
                "mn"
            ],
            [
                "mri",
                "mi"
            ],
            [
                "msa",
                "ms"
            ],
            [
                "mya",
                "my"
            ],
            [
                "nau",
                "na"
            ],
            [
                "nav",
                "nv"
            ],
            [
                "nbl",
                "nr"
            ],
            [
                "nde",
                "nd"
            ],
            [
                "ndo",
                "ng"
            ],
            [
                "nep",
                "ne"
            ],
            [
                "nld",
                "nl"
            ],
            [
                "nno",
                "nn"
            ],
            [
                "nob",
                "nb"
            ],
            [
                "nor",
                "no"
            ],
            [
                "nya",
                "ny"
            ],
            [
                "oci",
                "oc"
            ],
            [
                "oji",
                "oj"
            ],
            [
                "ori",
                "or"
            ],
            [
                "orm",
                "om"
            ],
            [
                "oss",
                "os"
            ],
            [
                "pan",
                "pa"
            ],
            [
                "per",
                "fa"
            ],
            [
                "pli",
                "pi"
            ],
            [
                "pol",
                "pl"
            ],
            [
                "por",
                "pt"
            ],
            [
                "pus",
                "ps"
            ],
            [
                "que",
                "qu"
            ],
            [
                "roh",
                "rm"
            ],
            [
                "ron",
                "ro"
            ],
            [
                "rum",
                "ro"
            ],
            [
                "run",
                "rn"
            ],
            [
                "rus",
                "ru"
            ],
            [
                "sag",
                "sg"
            ],
            [
                "san",
                "sa"
            ],
            [
                "sin",
                "si"
            ],
            [
                "slk",
                "sk"
            ],
            [
                "slo",
                "sk"
            ],
            [
                "slv",
                "sl"
            ],
            [
                "sme",
                "se"
            ],
            [
                "smo",
                "sm"
            ],
            [
                "sna",
                "sn"
            ],
            [
                "snd",
                "sd"
            ],
            [
                "som",
                "so"
            ],
            [
                "sot",
                "st"
            ],
            [
                "spa",
                "es"
            ],
            [
                "sqi",
                "sq"
            ],
            [
                "srd",
                "sc"
            ],
            [
                "srp",
                "sr"
            ],
            [
                "ssw",
                "ss"
            ],
            [
                "sun",
                "su"
            ],
            [
                "swa",
                "sw"
            ],
            [
                "swe",
                "sv"
            ],
            [
                "tah",
                "ty"
            ],
            [
                "tam",
                "ta"
            ],
            [
                "tat",
                "tt"
            ],
            [
                "tel",
                "te"
            ],
            [
                "tgk",
                "tg"
            ],
            [
                "tgl",
                "tl"
            ],
            [
                "tha",
                "th"
            ],
            [
                "tib",
                "bo"
            ],
            [
                "tir",
                "ti"
            ],
            [
                "ton",
                "to"
            ],
            [
                "tsn",
                "tn"
            ],
            [
                "tso",
                "ts"
            ],
            [
                "tuk",
                "tk"
            ],
            [
                "tur",
                "tr"
            ],
            [
                "twi",
                "tw"
            ],
            [
                "uig",
                "ug"
            ],
            [
                "ukr",
                "uk"
            ],
            [
                "urd",
                "ur"
            ],
            [
                "uzb",
                "uz"
            ],
            [
                "ven",
                "ve"
            ],
            [
                "vie",
                "vi"
            ],
            [
                "vol",
                "vo"
            ],
            [
                "wel",
                "cy"
            ],
            [
                "wln",
                "wa"
            ],
            [
                "wol",
                "wo"
            ],
            [
                "xho",
                "xh"
            ],
            [
                "yid",
                "yi"
            ],
            [
                "yor",
                "yo"
            ],
            [
                "zha",
                "za"
            ],
            [
                "zho",
                "zh"
            ],
            [
                "zul",
                "zu"
            ]
        ]);
        function Tc(a) {
            fb.call(this);
            this.j = Kc(a);
            this.i = new Map;
            this.g = new Set;
            this.h = new Map;
        }
        oa(Tc, fb);
        p = Tc.prototype;
        p.release = function() {
            fb.prototype.release.call(this);
        };
        p.Pi = function(a) {
            var b = this;
            this.g.clear();
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())this.g.add(Kc(c.value));
            Uc(this);
            a = jb(this.g, function(d) {
                return !b.h.has(d);
            });
            a.length && this.dispatchEvent(new R("unknown-locales", (new Map).set("locales", a)));
            a = jb(this.g, function(d) {
                return b.h.has(d);
            });
            a = (new Map).set("locales", a.length ? a : [
                this.j
            ]);
            this.dispatchEvent(new R("locale-changed", a));
        };
        p.Ya = function(a, b, c) {
            a = Kc(a);
            c === void 0 && (c = Vc);
            var d = this.h.get(a) || new Map;
            b.forEach(function(e, f) {
                d.has(f) && c != Vc || d.set(f, e);
            });
            this.h.set(a, d);
            Uc(this);
            this.dispatchEvent(new R("locale-updated"));
            return this;
        };
        p.nm = function(a) {
            for(var b = u(a.keys()), c = b.next(); !c.done; c = b.next())c = c.value, a.set(c, this.resolve(c));
        };
        p.resolve = function(a) {
            var b = this.i.get(a);
            if (b) return b;
            a = (new Map).set("locales", Array.from(this.g)).set("missing", a);
            this.dispatchEvent(new R("unknown-localization", a));
            return "";
        };
        p.Ok = function() {
            return this.g;
        };
        function Uc(a) {
            for(var b = a.h, c = a.j, d = a.g, e = new Set, f = u(d), g = f.next(), h = {}; !g.done; h = {
                xe: void 0
            }, g = f.next()){
                h.xe = g.value;
                e.add(h.xe);
                e.add(Pc(h.xe));
                g = jb(b.keys(), function(l) {
                    return function(m) {
                        return Oc(m, l.xe);
                    };
                }(h));
                g.sort();
                g = u(g);
                for(var k = g.next(); !k.done; k = g.next())e.add(k.value);
                h = jb(b.keys(), function(l) {
                    return function(m) {
                        return Pc(m) == l.xe;
                    };
                }(h));
                h.sort();
                h = u(h);
                for(g = h.next(); !g.done; g = h.next())e.add(g.value);
            }
            e.add(c);
            c = [];
            e = u(e);
            for(f = e.next(); !f.done; f = e.next())(f = b.get(f.value)) && c.push(f);
            c.reverse();
            a.i.clear();
            b = u(c);
            for(e = b.next(); !e.done; e = b.next())e.value.forEach(function(l, m) {
                a.i.set(m, l);
            });
            b = a.i.keys();
            e = new Set;
            c = u(a.g);
            for(f = c.next(); !f.done; f = c.next())f = a.h.get(f.value) || new Map, Wc(f, b, e);
            e.size > 0 && (d = (new Map).set("locales", Array.from(d)).set("missing", Array.from(e)), a.dispatchEvent(new R("missing-localizations", d)));
        }
        function Wc(a, b, c) {
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())d = d.value, a.get(d) || c.add(d);
        }
        O("shaka.ui.Localization", Tc);
        Tc.prototype.getCurrentLocales = Tc.prototype.Ok;
        Tc.prototype.resolve = Tc.prototype.resolve;
        Tc.prototype.resolveDictionary = Tc.prototype.nm;
        Tc.prototype.insert = Tc.prototype.Ya;
        Tc.prototype.changeLocale = Tc.prototype.Pi;
        Tc.prototype.release = Tc.prototype.release;
        var Vc = 1;
        Tc.ConflictResolution = {
            USE_OLD: 0,
            USE_NEW: Vc
        };
        Tc.UNKNOWN_LOCALES = "unknown-locales";
        Tc.UNKNOWN_LOCALIZATION = "unknown-localization";
        Tc.MISSING_LOCALIZATIONS = "missing-localizations";
        Tc.LOCALE_CHANGED = "locale-changed";
        Tc.LOCALE_UPDATED = "locale-updated";
        function Xc(a) {
            this.i = Math.log(.5);
            this.g = Math.exp(this.i / a);
            this.j = this.h = 0;
        }
        Xc.prototype.sample = function(a, b) {
            var c = Math.pow(this.g, a);
            b = b * (1 - c) + c * this.h;
            isNaN(b) || (this.h = b, this.j += a);
        };
        function Yc(a) {
            return a.h / (1 - Math.pow(a.g, a.j));
        }
        function Zc() {
            this.h = new Xc(2);
            this.j = new Xc(5);
            this.g = 0;
            this.i = 128E3;
            this.l = 16E3;
        }
        Zc.prototype.configure = function(a) {
            this.i = a.minTotalBytes;
            this.l = a.minBytes;
            var b = this.h;
            b.g = Math.exp(b.i / a.fastHalfLife);
            b = this.j;
            b.g = Math.exp(b.i / a.slowHalfLife);
        };
        Zc.prototype.sample = function(a, b) {
            if (!(b < this.l)) {
                var c = 8E3 * b / a;
                a /= 1E3;
                this.g += b;
                this.h.sample(a, c);
                this.j.sample(a, c);
            }
        };
        Zc.prototype.getBandwidthEstimate = function(a) {
            return this.g < this.i ? a : Math.min(Yc(this.h), Yc(this.j));
        };
        function $c(a, b) {
            return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b) ? !0 : a === b;
        }
        function ad(a, b) {
            b = a.indexOf(b);
            b > -1 && a.splice(b, 1);
        }
        function bd(a, b, c) {
            c || (c = $c);
            if (a.length != b.length) return !1;
            b = b.slice();
            a = u(a);
            for(var d = a.next(), e = {}; !d.done; e = {
                lj: void 0
            }, d = a.next()){
                e.lj = d.value;
                d = b.findIndex(function(f) {
                    return function(g) {
                        return c(f.lj, g);
                    };
                }(e));
                if (d == -1) return !1;
                b[d] = b[b.length - 1];
                b.pop();
            }
            return b.length == 0;
        }
        function cd(a, b) {
            var c = [], d = [];
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next())e = e.value, b(e) ? c.push(e) : d.push(e);
            return [
                c,
                d
            ];
        }
        function dd(a, b) {
            for(var c = 0, d = a.length; c < d;){
                var e = c + d >>> 1;
                b(a[e]) ? c = e + 1 : d = e;
            }
            return c;
        }
        function ed(a, b, c) {
            if (a === b) return !0;
            if (!a || !b) return a == b;
            c || (c = $c);
            if (a.length != b.length) return !1;
            for(var d = 0; d < a.length; d++)if (!c(a[d], b[d])) return !1;
            return !0;
        }
        function fd() {
            this.g = new eb;
        }
        p = fd.prototype;
        p.release = function() {
            this.Ta();
            this.g = null;
        };
        p.u = function(a, b, c, d) {
            this.g && (a = new gd(a, b, c, d), this.g.push(b, a));
        };
        p.ra = function(a, b, c, d) {
            function e(g) {
                f.Fa(a, b, e);
                c(g);
            }
            var f = this;
            this.u(a, b, e, d);
        };
        p.Fa = function(a, b, c) {
            if (this.g) {
                var d = this.g.get(b) || [];
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next())e = e.value, e.target != a || c != e.listener && c || (e.Fa(), this.g.remove(b, e));
            }
        };
        p.Ta = function() {
            if (this.g) {
                for(var a = [], b = u(this.g.g.values()), c = b.next(); !c.done; c = b.next())a.push.apply(a, G(c.value));
                a = u(a);
                for(b = a.next(); !b.done; b = a.next())b.value.Fa();
                this.g.g.clear();
            }
        };
        O("shaka.util.EventManager", fd);
        fd.prototype.removeAll = fd.prototype.Ta;
        fd.prototype.unlisten = fd.prototype.Fa;
        fd.prototype.listenOnce = fd.prototype.ra;
        fd.prototype.listen = fd.prototype.u;
        fd.prototype.release = fd.prototype.release;
        function gd(a, b, c, d) {
            this.target = a;
            this.type = b;
            this.listener = c;
            this.g = id(a, d);
            this.target.addEventListener(b, c, this.g);
        }
        gd.prototype.Fa = function() {
            this.target.removeEventListener(this.type, this.listener, this.g);
            this.listener = this.target = null;
            this.g = !1;
        };
        function id(a, b) {
            if (b == void 0) return !1;
            if (typeof b == "boolean") return b;
            var c = new Set([
                "passive",
                "capture"
            ]);
            Object.keys(b).filter(function(d) {
                return !c.has(d);
            });
            return jd(a) ? b : b.capture || !1;
        }
        function jd(a) {
            var b = kd;
            if (b == void 0) {
                b = !1;
                try {
                    var c = {}, d = {
                        get: function() {
                            b = !0;
                            return !1;
                        }
                    };
                    Object.defineProperty(c, "passive", d);
                    Object.defineProperty(c, "capture", d);
                    d = function() {};
                    a.addEventListener("test", d, c);
                    a.removeEventListener("test", d, c);
                } catch (e) {
                    b = !1;
                }
                kd = b;
            }
            return b || !1;
        }
        var kd = void 0;
        O("shaka.config.AutoShowText", {
            NEVER: 0,
            ALWAYS: 1,
            IF_PREFERRED_TEXT_LANGUAGE: 2,
            IF_SUBTITLES_MAY_BE_NEEDED: 3
        });
        function ld(a, b) {
            this.g = a;
            this.h = b;
        }
        ld.prototype.toString = function() {
            return "v" + this.g + "." + this.h;
        };
        function md(a, b) {
            var c = new ld(5, 0), d = nd, e = d.g, f = c.h - e.h;
            ((c.g - e.g || f) > 0 ? d.i : d.h)(d.g, c, a, b);
        }
        function od(a, b, c, d) {
            Za([
                c,
                "has been deprecated and will be removed in",
                b,
                ". We are currently at version",
                a,
                ". Additional information:",
                d
            ].join(" "));
        }
        function pd(a, b, c, d) {
            Ya([
                c,
                "has been deprecated and has been removed in",
                b,
                ". We are now at version",
                a,
                ". Additional information:",
                d
            ].join(" "));
        }
        var nd = null;
        function sd(a, b, c, d) {
            this.g = null;
            this.l = a;
            this.i = b;
            this.m = c;
            this.o = d;
            this.j = !1;
            a: {
                typeof libDPIModule === "undefined" && Za("Could not find LCEVC Library dependencies on this page");
                if (typeof LCEVCdec !== "undefined") this.h = LCEVCdec;
                else if (typeof LcevcDil !== "undefined") this.h = LcevcDil, this.j = !0, md("LcevcDil", "lcevc_dil.js is deprecated, please use lcevc_dec.js instead");
                else {
                    Za("Could not find LCEVC Library on this page");
                    a = !1;
                    break a;
                }
                typeof this.h.SupportObject === "undefined" ? (Za("Could not find LCEVC Library on this page"), a = !1) : (this.h.SupportObject.SupportStatus || Za(this.h.SupportObject.SupportError), a = typeof this.h !== "undefined" && typeof libDPIModule !== "undefined" && this.i instanceof HTMLCanvasElement && this.h.SupportObject.SupportStatus);
            }
            a && !this.g && this.h.SupportObject.webGLSupport(this.i) && (this.i.classList.remove("shaka-hidden"), this.g = this.j ? new this.h.LcevcDil(this.l, this.i, this.m) : new this.h.LCEVCdec(this.l, this.i, this.m));
        }
        function td(a, b, c, d) {
            d.type !== "video" || a.o && !d.baseOriginalId || a.g && a.g.appendBuffer(b, "video", d.id, -c, !a.o);
        }
        function ud(a) {
            a.g && a.i.classList.add("shaka-hidden");
        }
        sd.prototype.release = function() {
            this.g && (this.g.close(), this.g = null);
        };
        function vd(a) {
            return a && typeof LCEVCdec !== "undefined" ? a.codecs == "lvc1" : !1;
        }
        O("shaka.lcevc.Dec", sd);
        sd.prototype.release = sd.prototype.release;
        function wd() {}
        function xd(a, b) {
            yd.set(a, b);
        }
        function zd() {
            var a = {};
            Xb();
            if (Ad()) for(var b = u(yd.keys()), c = b.next(); !c.done; c = b.next())a[c.value] = !0;
            b = u([
                "application/dash+xml",
                "application/x-mpegurl",
                "application/vnd.apple.mpegurl",
                "audio/x-mpegurl",
                "application/vnd.ms-sstr+xml"
            ]);
            for(c = b.next(); !c.done; c = b.next())c = c.value, a[c] = Ad() ? yd.has(c) : Bd().canPlayType(c) != "";
            return a;
        }
        function Cd(a, b) {
            if (b) {
                var c = yd.get(b);
                if (c) return c;
            }
            throw new T(2, 4, 4E3, a, b);
        }
        O("shaka.media.ManifestParser", wd);
        wd.unregisterParserByMime = function(a) {
            yd.delete(a);
        };
        wd.registerParserByMime = xd;
        wd.registerParserByExtension = function() {
            md("ManifestParser.registerParserByExtension", "Please use an ManifestParser with registerParserByMime function.");
        };
        wd.AccessibilityPurpose = {
            Rn: "visually impaired",
            an: "hard of hearing",
            An: "spoken subtitles"
        };
        var yd = new Map;
        function Dd() {}
        Dd.prototype.extract = function() {};
        Dd.prototype.decode = function() {
            return [];
        };
        Dd.prototype.clear = function() {};
        Dd.prototype.getStreams = function() {
            return [];
        };
        function Ed() {}
        Ed.prototype.init = function() {};
        Ed.prototype.parse = function() {
            return [];
        };
        function Fd(a) {
            this.h = new Map;
            this.i = 0;
            this.j = new Ed;
            if (a = Hd(a.toLowerCase())) this.j = a();
            this.g = new Dd;
            if (a = Id) this.g = a(), this.h.set(this.i, this.g);
        }
        Fd.prototype.init = function(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? -1 : c;
            if (c != -1 && this.i != c) {
                b = c;
                var d = this.h.get(b);
                this.h.set(this.i, this.g);
                if (d) this.g = d;
                else {
                    if (d = Id) this.g = d();
                    this.h.set(b, this.g);
                }
            } else b || this.g.clear();
            this.j.init(a);
            c != -1 && (this.i = c);
        };
        function Jd(a, b) {
            b = a.j.parse(b);
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = Fb(c.packet);
                d.length > 0 && a.g.extract(d, c.pts);
            }
            return a.g.decode();
        }
        Fd.prototype.remove = function(a) {
            a = a === void 0 ? [] : a;
            a = new Set(a);
            for(var b = u(this.h.keys()), c = b.next(); !c.done; c = b.next())if (c = c.value, !a.has(c)) {
                var d = this.h.get(c);
                d && d.clear();
                this.h.delete(c);
            }
        };
        function Kd(a, b) {
            Ld.set(a, b);
        }
        function Hd(a) {
            return Ld.get(a);
        }
        O("shaka.media.ClosedCaptionParser", Fd);
        Fd.findDecoder = function() {
            return Id;
        };
        Fd.unregisterDecoder = function() {
            Id = null;
        };
        Fd.registerDecoder = function(a) {
            Id = a;
        };
        Fd.findParser = Hd;
        Fd.unregisterParser = function(a) {
            Ld.delete(a);
        };
        Fd.registerParser = Kd;
        var Ld = new Map, Id = null;
        function Md() {
            this.id = "";
            this.regionAnchorY = this.regionAnchorX = this.viewportAnchorY = this.viewportAnchorX = 0;
            this.height = this.width = 100;
            this.viewportAnchorUnits = this.widthUnits = this.heightUnits = Nd;
            this.scroll = Od;
        }
        O("shaka.text.CueRegion", Md);
        var Nd = 1;
        Md.units = {
            PX: 0,
            PERCENTAGE: Nd,
            LINES: 2
        };
        var Od = "";
        Md.scrollMode = {
            NONE: Od,
            UP: "up"
        };
        function Pd(a) {
            this.h = a || "";
            this.g = 0;
        }
        function Qd(a) {
            Rd(a, /[ \t]+/gm);
        }
        function Rd(a, b) {
            b.lastIndex = a.g;
            b = b.exec(a.h);
            b = b == null ? null : {
                position: b.index,
                length: b[0].length,
                results: b
            };
            if (a.g == a.h.length || b == null || b.position != a.g) return null;
            a.g += b.length;
            return b.results;
        }
        function Sd(a) {
            return a.g == a.h.length ? null : (a = Rd(a, /[^ \t\n]*/gm)) ? a[0] : null;
        }
        function Td(a) {
            a = Rd(a, Ud);
            if (a == null) return null;
            var b = Number(a[2]), c = Number(a[3]);
            return b > 59 || c > 59 ? null : (Number(a[6]) || 0) / 1E3 + c + b * 60 + (Number(a[1]) || 0) * 3600;
        }
        function Vd(a) {
            return a ? Td(new Pd(a)) : null;
        }
        var Ud = /(?:(\d{1,}):)?(\d{2}):(\d{2})((\.(\d{1,3})))?/g;
        function Wd() {}
        function Xd(a) {
            function b(d) {
                switch(typeof d){
                    case "undefined":
                    case "boolean":
                    case "number":
                    case "string":
                    case "symbol":
                    case "function":
                        return d;
                    default:
                        if (!d || ArrayBuffer.isView(d)) return d;
                        if (c.has(d)) return null;
                        var e = Array.isArray(d);
                        if (d.constructor != Object && !e) return null;
                        c.add(d);
                        var f = e ? [] : {}, g;
                        for(g in d)f[g] = b(d[g]);
                        e && (f.length = d.length);
                        return f;
                }
            }
            var c = new WeakSet;
            return b(a);
        }
        function Yd(a) {
            var b = {}, c;
            for(c in a)b[c] = a[c];
            return b;
        }
        function Zd(a) {
            if (Array.isArray(a)) {
                for(var b = [], c = 0; c < a.length; c++){
                    var d = c.toString(), e = a[c];
                    e !== void 0 && (e = Zd(e)) && b.push(d + ":" + e);
                }
                a = "[" + b.join(",") + "]";
            } else if (typeof a == "function") a = "";
            else if (a instanceof Object) {
                c = Object.keys(a);
                c.sort();
                b = [];
                c = u(c);
                for(d = c.next(); !d.done; d = c.next())e = d.value, d = JSON.stringify(e), e = a[e], e !== void 0 && (e = Zd(e)) && b.push(d + ":" + e);
                a = "{" + b.join(",") + "}";
            } else a = JSON.stringify(a);
            return a;
        }
        O("shaka.util.ObjectUtils", Wd);
        Wd.alphabeticalKeyOrderStringify = Zd;
        Wd.shallowCloneObject = Yd;
        Wd.cloneObject = Xd; /*
 @license
 tXml
 Copyright 2015 Tobias Nickel
 SPDX-License-Identifier: MIT
*/ 
        function $d(a, b) {
            var c = c === void 0 ? !1 : c;
            a = ec(a);
            return ae(a, b, c);
        }
        function ae(a, b, c) {
            a = be(a, c === void 0 ? !1 : c);
            if (!b && a.length) return a[0];
            var d = b.split(",");
            return (b = a.find(function(e) {
                return d.includes(e.tagName);
            })) ? b : null;
        }
        function ce(a) {
            return de.has(a) ? de.get(a) : "";
        }
        function be(a, b) {
            function c(g, h) {
                h = h === void 0 ? !1 : h;
                for(var k = []; a[e];)if (a.charCodeAt(e) == 60) {
                    if (a.charCodeAt(e + 1) === 47) {
                        h = e + 2;
                        e = a.indexOf(">", e);
                        h = a.substring(h, e);
                        var l = h.indexOf(g);
                        if (l == -1) {
                            var m = g.indexOf(".");
                            m > 0 && (l = h.indexOf(g.substring(0, m)));
                        }
                        if (l == -1) throw g = a.substring(0, e).split("\n"), Error("Unexpected close tag\nLine: " + (g.length - 1) + "\nColumn: " + (g[g.length - 1].length + 1) + "\nChar: " + a[e]);
                        e + 1 && (e += 1);
                        break;
                    } else if (a.charCodeAt(e + 1) === 33) {
                        if (a.charCodeAt(e + 2) == 45) {
                            for(; e !== -1 && (a.charCodeAt(e) !== 62 || a.charCodeAt(e - 1) != 45 || a.charCodeAt(e - 2) != 45 || e == -1);)e = a.indexOf(">", e + 1);
                            e === -1 && (e = a.length);
                        } else if (a.charCodeAt(e + 2) === 91 && a.charCodeAt(e + 8) === 91 && a.substr(e + 3, 5).toLowerCase() === "cdata") {
                            l = a.indexOf("]]\x3e", e);
                            l == -1 ? (k.push(a.substr(e + 9)), e = a.length) : (k.push(a.substring(e + 9, l)), e = l + 3);
                            continue;
                        }
                        e++;
                        continue;
                    }
                    if (f > 512) throw Error("XML is too deeply nested");
                    f++;
                    a: {
                        m = h;
                        e++;
                        var n = d(), q = {};
                        for(l = []; a.charCodeAt(e) !== 62 && a[e];){
                            var r = a.charCodeAt(e);
                            if (r > 64 && r < 91 || r > 96 && r < 123) {
                                r = d();
                                for(var t = a.charCodeAt(e); t && t !== 39 && t !== 34 && !(t > 64 && t < 91 || t > 96 && t < 123) && t !== 62;)e++, t = a.charCodeAt(e);
                                var v = e + 1;
                                e = a.indexOf(a[e], v);
                                v = (" " + a.slice(v, e)).slice(1);
                                if (t === 39 || t === 34) {
                                    if (e === -1) {
                                        m = {
                                            tagName: n,
                                            attributes: q,
                                            children: l,
                                            parent: null
                                        };
                                        if (b) for(n = 0; n < l.length; n++)typeof l[n] !== "string" && (l[n].parent = m);
                                        l = m;
                                        break a;
                                    }
                                } else v = null, e--;
                                if (r.startsWith("xmlns:")) {
                                    t = v;
                                    var w = r.split(":")[1];
                                    de.set(t, w);
                                    ee.set(w, t);
                                }
                                n === "tt" && r === "xml:space" && v === "preserve" && (m = !0);
                                q[r] = v;
                            }
                            e++;
                        }
                        a.charCodeAt(e - 1) !== 47 ? (e++, l = c(n, m)) : e++;
                        m = {
                            tagName: n,
                            attributes: q,
                            children: l,
                            parent: null
                        };
                        n = l.length;
                        for(q = 0; q < n; q++)r = l[q], typeof r !== "string" ? b && (r.parent = m) : q == n - 1 && r == "\n" && l.pop();
                        l = m;
                    }
                    f--;
                    k.push(l);
                    if (typeof l === "string") break;
                    l.tagName[0] === "?" && l.children && (k.push.apply(k, G(l.children)), l.children = []);
                } else l = e, e = a.indexOf("<", e) - 1, e === -2 && (e = a.length), l = (" " + a.slice(l, e + 1)).slice(1), h ? l.length > 0 && k.push(l) : k.length && l.length == 1 && l[0] == "\n" ? k.push(l) : l.trim().length > 0 && k.push(l), e++;
                return k;
            }
            function d() {
                for(var g = e; "\r\n\t>/= ".indexOf(a[e]) === -1 && a[e];)e++;
                return (" " + a.slice(g, e)).slice(1);
            }
            var e = 0, f = 0;
            return c("");
        }
        function fe(a) {
            return typeof a === "string";
        }
        function ge(a) {
            var b = [];
            if (!a.children) return [];
            a = u(a.children);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, typeof c !== "string" && b.push(c);
            return b;
        }
        function ie(a, b) {
            var c = [];
            if (!a.children) return [];
            a = u(a.children);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, d.tagName === b && c.push(d);
            return c;
        }
        function ke(a) {
            if (typeof a === "string") return jc(a);
            var b = [];
            a = u(a.children);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, typeof c === "string" && b.push(c);
            b = b.join("");
            return b === "" ? null : jc(b);
        }
        function le(a) {
            for(var b = u(a.children), c = b.next(); !c.done; c = b.next())if (typeof c.value !== "string") return null;
            (a = ke(a)) && (a = a.trim());
            return a;
        }
        function me(a, b, c) {
            c = c === void 0 ? [] : c;
            a.tagName === b && c.push(a);
            if (a.children) {
                a = u(a.children);
                for(var d = a.next(); !d.done; d = a.next())me(d.value, b, c);
            }
            return c;
        }
        function ne(a, b) {
            a = ie(a, b);
            return a.length != 1 ? null : a[0];
        }
        function oe(a, b, c) {
            a = pe(a, b, c);
            return a.length != 1 ? null : a[0];
        }
        function qe(a, b, c, d) {
            d = d === void 0 ? null : d;
            var e = null;
            a = a.attributes[b];
            a == null || a === "" && d !== null || (e = c(a));
            return e == null ? d : e;
        }
        function re(a, b, c) {
            b = ce(b);
            return a.attributes[b + ":" + c] || null;
        }
        function pe(a, b, c) {
            var d = ce(b);
            b = [];
            if (a.children) for(c = d ? d + ":" + c : c, a = u(a.children), d = a.next(); !d.done; d = a.next())(d = d.value) && d.tagName === c && b.push(d);
            return b;
        }
        function se(a, b, c) {
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())if (d = re(a, d.value, c)) return d;
            return null;
        }
        function te(a) {
            if (!a) return null;
            /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(a) && (a += "Z");
            a = Date.parse(a);
            return isNaN(a) ? null : a / 1E3;
        }
        function ue(a) {
            if (!a) return null;
            a = RegExp("^P(?:([0-9]*)Y)?(?:([0-9]*)M)?(?:([0-9]*)D)?(?:T(?:([0-9]*)H)?(?:([0-9]*)M)?(?:([0-9.]*)S)?)?$", "i").exec(a);
            if (!a) return null;
            a = 31536E3 * Number(a[1] || null) + 2592E3 * Number(a[2] || null) + 86400 * Number(a[3] || null) + 3600 * Number(a[4] || null) + 60 * Number(a[5] || null) + Number(a[6] || null);
            return isFinite(a) ? a : null;
        }
        function ve(a) {
            var b = /([0-9]+)-([0-9]+)/.exec(a);
            if (!b) return null;
            a = Number(b[1]);
            if (!isFinite(a)) return null;
            b = Number(b[2]);
            return isFinite(b) ? {
                start: a,
                end: b
            } : null;
        }
        function we(a) {
            a = Number(a);
            return a % 1 === 0 ? a : null;
        }
        function xe(a) {
            a = Number(a);
            return a % 1 === 0 && a > 0 ? a : null;
        }
        function ye(a) {
            a = Number(a);
            return a % 1 === 0 && a >= 0 ? a : null;
        }
        function ze(a) {
            a = Number(a);
            return isNaN(a) ? null : a;
        }
        function Ae(a) {
            return a ? a.toLowerCase() === "true" : !1;
        }
        function Be(a) {
            var b;
            var c = (b = a.match(/^(\d+)\/(\d+)$/)) ? Number(b[1]) / Number(b[2]) : Number(a);
            return isNaN(c) ? null : c;
        }
        function Ce(a) {
            var b = [];
            a = jc(a).split(/\/+(?=(?:[^'"]*['"][^'"]*['"])*[^'"]*$)/);
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = c.match(/^([\w]+)/);
                if (d) {
                    var e = c.match(/(@id='(.*?)')/), f = c.match(/(@t='(\d+)')/), g = c.match(/(@n='(\d+)')/), h = c.match(/\[(\d+)\]/);
                    b.push({
                        name: d[0],
                        id: e ? e[0].match(/'(.*?)'/)[0].replace(/'/gm, "") : null,
                        t: f ? Number(f[0].match(/'(.*?)'/)[0].replace(/'/gm, "")) : null,
                        n: g ? Number(g[0].match(/'(.*?)'/)[0].replace(/'/gm, "")) : null,
                        position: h ? Number(h[1]) - 1 : null,
                        Kc: c.split("/@")[1] || null
                    });
                } else c.startsWith("@") && b.length && (b[b.length - 1].Kc = c.slice(1));
            }
            return b;
        }
        function De(a, b) {
            var c = Ce(b.attributes.sel || "");
            if (c.length) {
                var d = c[c.length - 1], e = b.attributes.pos || null;
                c = d.position;
                c == null && (d.t !== null && (c = Ee(a, "t", d.t)), d.n !== null && (c = Ee(a, "n", d.n)));
                c === null ? c = e === "prepend" ? 0 : a.length : e === "prepend" ? --c : e === "after" && ++c;
                e = b.tagName;
                (d = d.Kc) && a[c] ? Fe(a[c], e, d, le(b) || "") : (e !== "remove" && e !== "replace" || a.splice(c, 1), e !== "add" && e !== "replace" || a.splice.apply(a, [
                    c,
                    0
                ].concat(G(b.children))));
            }
        }
        function Ee(a, b, c) {
            var d = 0;
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next()){
                if (Number(e.value.attributes[b]) === c) return d;
                d++;
            }
            return null;
        }
        function Fe(a, b, c, d) {
            if (b === "remove") delete a.attributes[c];
            else if (b === "add" || b === "replace") a.attributes[c] = d;
        }
        function Ge(a) {
            var b = "", c = a.tagName.split(":");
            c.length > 0 && (b = c[0], b = ee.has(b) ? ee.get(b) : "");
            b = document.createElementNS(b, a.tagName);
            for(var d in a.attributes)b.setAttribute(d, a.attributes[d]);
            a = u(a.children);
            for(d = a.next(); !d.done; d = a.next())d = d.value, c = void 0, typeof d == "string" ? c = new Text(d) : c = Ge(d), b.appendChild(c);
            return b;
        }
        function He(a) {
            if (!a) return null;
            var b = {
                tagName: a.tagName,
                attributes: Yd(a.attributes),
                children: [],
                parent: null
            };
            a = u(a.children);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, typeof c === "string" ? b.children.push(c) : (c = He(c), c.parent = b, b.children.push(c));
            return b;
        }
        var de = new Map, ee = new Map;
        function Ie(a, b, c) {
            this.startTime = a;
            this.endTime = b;
            this.payload = c;
            this.region = new Md;
            this.position = null;
            this.positionAlign = Je;
            this.size = 0;
            this.textAlign = Ke;
            this.direction = Le;
            this.writingMode = Me;
            this.lineInterpretation = Ne;
            this.line = null;
            this.lineHeight = "";
            this.lineAlign = Oe;
            this.displayAlign = Re;
            this.fontSize = this.border = this.backgroundImage = this.backgroundColor = this.color = "";
            this.fontWeight = Se;
            this.fontStyle = Te;
            this.linePadding = this.letterSpacing = this.fontFamily = "";
            this.opacity = 1;
            this.textCombineUpright = "";
            this.textDecoration = [];
            this.textStrokeWidth = this.textStrokeColor = this.textShadow = "";
            this.wrapLine = !0;
            this.id = "";
            this.nestedCues = [];
            this.lineBreak = this.isContainer = !1;
            this.rubyTag = null;
            this.cellResolution = {
                columns: 32,
                rows: 15
            };
        }
        function Ue(a, b) {
            a = new Ie(a, b, "");
            a.lineBreak = !0;
            return a;
        }
        Ie.prototype.clone = function() {
            var a = new Ie(0, 0, ""), b;
            for(b in this)a[b] = this[b], Array.isArray(a[b]) && (a[b] = a[b].slice());
            return a;
        };
        function Ve(a, b) {
            if (a.payload != b.payload || !(Math.abs(a.startTime - b.startTime) < .001 && Math.abs(a.endTime - b.endTime) < .001)) return !1;
            for(var c in a)if (c != "startTime" && c != "endTime" && c != "payload") {
                if (c == "nestedCues") {
                    if (!ed(a.nestedCues, b.nestedCues, Ve)) return !1;
                } else if (c == "region" || c == "cellResolution") for(var d in a[c]){
                    if (a[c][d] != b[c][d]) return !1;
                }
                else if (Array.isArray(a[c])) {
                    if (!ed(a[c], b[c])) return !1;
                } else if (a[c] != b[c]) return !1;
            }
            return !0;
        }
        function We(a, b) {
            b = b === void 0 ? new Map : b;
            var c = a.payload;
            if (c.includes("<")) {
                b.size === 0 && Xe(b);
                var d = c;
                c = [];
                for(var e = -1, f = 0; f < d.length; f++)d[f] === "<" ? e = f + 1 : d[f] === ">" && e > 0 && (e = d.substr(e, f - e), e.match(Ye) && c.push(e), e = -1);
                c = u(c);
                for(f = c.next(); !f.done; f = c.next())f = f.value, d = d.replace("<" + f + ">", '<div time="' + f + '">'), d += "</div>";
                a: {
                    f = d;
                    e = [];
                    var g = -1;
                    c = "";
                    d = !1;
                    for(var h = 0; h < f.length; h++)if (f[h] === "/") {
                        var k = f.indexOf(">", h);
                        if (k === -1) {
                            c = f;
                            break a;
                        }
                        if ((k = f.substring(h + 1, k)) && k == "v") {
                            d = !0;
                            var l = null;
                            e.length && (l = e[e.length - 1]);
                            if (l) {
                                if (l === k) c += "/" + k + ">";
                                else {
                                    if (!l.startsWith("v")) {
                                        c += f[h];
                                        continue;
                                    }
                                    c += "/" + l + ">";
                                }
                                h += k.length + 1;
                            } else c += f[h];
                        } else c += f[h];
                    } else f[h] === "<" ? (g = h + 1, f[g] != "v" && (g = -1)) : f[h] === ">" && g > 0 && (e.push(f.substr(g, h - g)), g = -1), c += f[h];
                    f = u(e);
                    for(e = f.next(); !e.done; e = f.next())e = e.value, g = e.replace(" ", ".voice-"), c = c.replace("<" + e + ">", "<" + g + ">"), c = c.replace("</" + e + ">", "</" + g + ">"), d || (c += "</" + g + ">");
                }
                c = Ze(c);
                a.payload = "";
                d = "<span>" + c.replace(/\n/g, "<br />") + "</span>";
                try {
                    var m = ae(d, "span");
                } catch (n) {}
                if (m) {
                    if (m = m.children, m.length != 1 || m[0].tagName) for(m = u(m), c = m.next(); !c.done; c = m.next())$e(c.value, a, b);
                    else a.payload = jc(c);
                } else a.payload = jc(c);
            } else a.payload = jc(c);
        }
        function Xe(a) {
            for(var b = u(Object.entries(af)), c = b.next(); !c.done; c = b.next()){
                var d = u(c.value);
                c = d.next().value;
                d = d.next().value;
                var e = new Ie(0, 0, "");
                e.color = d;
                a.set("." + c, e);
            }
            b = u(Object.entries(bf));
            for(c = b.next(); !c.done; c = b.next())d = u(c.value), c = d.next().value, d = d.next().value, e = new Ie(0, 0, ""), e.backgroundColor = d, a.set("." + c, e);
        }
        function Ze(a) {
            var b = {
                "< ": "",
                " >": " &gt;"
            }, c = /(< +>|<\s|\s>)/g, d = RegExp(c.source);
            return a && d.test(a) ? a.replace(c, function(e) {
                return b[e] || "";
            }) : a || "";
        }
        function $e(a, b, c) {
            var d = b.clone();
            d.nestedCues = [];
            d.payload = "";
            d.rubyTag = "";
            d.line = null;
            d.region = new Md;
            d.position = null;
            d.size = 0;
            d.textAlign = Ke;
            if (a.tagName) for(var e = u(a.tagName.split(/(?=[ .])+/g)), f = e.next(); !f.done; f = e.next()){
                var g = f = f.value;
                if (g.startsWith(".voice-")) {
                    var h = g.split("-").pop();
                    g = 'v[voice="' + h + '"]';
                    c.has(g) || (g = "v[voice=" + h + "]");
                }
                c.has(g) && (h = d, g = c.get(g)) && (h.backgroundColor = cf(g.backgroundColor, h.backgroundColor), h.color = cf(g.color, h.color), h.fontFamily = cf(g.fontFamily, h.fontFamily), h.fontSize = cf(g.fontSize, h.fontSize), h.textShadow = cf(g.textShadow, h.textShadow), h.fontWeight = g.fontWeight, h.fontStyle = g.fontStyle, h.opacity = g.opacity, h.rubyTag = g.rubyTag, h.textCombineUpright = g.textCombineUpright, h.wrapLine = g.wrapLine);
                switch(f){
                    case "br":
                        d = Ue(d.startTime, d.endTime);
                        b.nestedCues.push(d);
                        return;
                    case "b":
                        d.fontWeight = df;
                        break;
                    case "i":
                        d.fontStyle = ef;
                        break;
                    case "u":
                        d.textDecoration.push(ff);
                        break;
                    case "font":
                        if (f = a.attributes.color) d.color = f;
                        break;
                    case "div":
                        f = a.attributes.time;
                        if (!f) break;
                        if (f = Vd(f)) d.startTime = f;
                        break;
                    case "ruby":
                    case "rp":
                    case "rt":
                        d.rubyTag = f;
                }
            }
            e = a.children;
            if (fe(a) || e.length == 1 && fe(e[0])) for(c = ke(a).split("\n"), a = !0, c = u(c), e = c.next(); !e.done; e = c.next())e = e.value, a || (a = Ue(d.startTime, d.endTime), b.nestedCues.push(a)), e.length > 0 && (a = d.clone(), a.payload = jc(e), b.nestedCues.push(a)), a = !1;
            else for(b.nestedCues.push(d), b = u(e), a = b.next(); !a.done; a = b.next())$e(a.value, d, c);
        }
        function cf(a, b) {
            return a && a.length > 0 ? a : b;
        }
        O("shaka.text.Cue", Ie);
        Ie.parseCuePayload = We;
        Ie.equal = Ve;
        Ie.prototype.clone = Ie.prototype.clone;
        var Je = "auto";
        Ie.positionAlign = {
            LEFT: "line-left",
            RIGHT: "line-right",
            CENTER: "center",
            AUTO: Je
        };
        var Ke = "center", gf = {
            LEFT: "left",
            RIGHT: "right",
            CENTER: Ke,
            START: "start",
            END: "end"
        };
        Ie.textAlign = gf;
        var Re = "after", hf = {
            BEFORE: "before",
            CENTER: "center",
            AFTER: Re
        };
        Ie.displayAlign = hf;
        var Le = "ltr";
        Ie.direction = {
            HORIZONTAL_LEFT_TO_RIGHT: Le,
            HORIZONTAL_RIGHT_TO_LEFT: "rtl"
        };
        var Me = "horizontal-tb";
        Ie.writingMode = {
            HORIZONTAL_TOP_TO_BOTTOM: Me,
            VERTICAL_LEFT_TO_RIGHT: "vertical-lr",
            VERTICAL_RIGHT_TO_LEFT: "vertical-rl"
        };
        var Ne = 0;
        Ie.lineInterpretation = {
            LINE_NUMBER: Ne,
            PERCENTAGE: 1
        };
        var Oe = "start", jf = {
            CENTER: "center",
            START: Oe,
            END: "end"
        };
        Ie.lineAlign = jf;
        var af = {
            white: "white",
            lime: "lime",
            cyan: "cyan",
            red: "red",
            yellow: "yellow",
            magenta: "magenta",
            blue: "blue",
            black: "black"
        };
        Ie.defaultTextColor = af;
        var bf = {
            bg_white: "white",
            bg_lime: "lime",
            bg_cyan: "cyan",
            bg_red: "red",
            bg_yellow: "yellow",
            bg_magenta: "magenta",
            bg_blue: "blue",
            bg_black: "black"
        };
        Ie.defaultTextBackgroundColor = bf;
        var Se = 400, df = 700;
        Ie.fontWeight = {
            NORMAL: Se,
            BOLD: df
        };
        var Te = "normal", ef = "italic", kf = {
            NORMAL: Te,
            ITALIC: ef,
            OBLIQUE: "oblique"
        };
        Ie.fontStyle = kf;
        var ff = "underline";
        Ie.textDecoration = {
            UNDERLINE: ff,
            LINE_THROUGH: "line-through",
            OVERLINE: "overline"
        };
        var Ye = /(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{2,3})/g;
        function lf() {}
        lf.prototype.destroy = function() {};
        function mf(a, b, c) {
            nf.set(a.toLowerCase().split(";")[0] + "-" + c, {
                priority: c,
                Vf: b
            });
        }
        function of(a, b) {
            for(var c = a.toLowerCase().split(";")[0], d = u([
                pf,
                qf,
                rf,
                uf
            ]), e = d.next(); !e.done; e = d.next())if (e = nf.get(c + "-" + e.value)) {
                var f = e.Vf(), g = f.isSupported(a, b);
                f.destroy();
                if (g) return e.Vf;
            }
            return null;
        }
        O("shaka.transmuxer.TransmuxerEngine", lf);
        lf.findTransmuxer = of;
        lf.unregisterTransmuxer = function(a, b) {
            nf.delete(a.toLowerCase().split(";")[0] + "-" + b);
        };
        lf.registerTransmuxer = mf;
        lf.prototype.destroy = lf.prototype.destroy;
        var nf = new Map, uf = 1, rf = 2, qf = 3, pf = 4;
        lf.PluginPriority = {
            FALLBACK: uf,
            PREFERRED_SECONDARY: rf,
            PREFERRED: qf,
            APPLICATION: pf
        };
        function vf() {}
        function wf(a, b) {
            var c = a;
            b && !yf.includes(a) && (c += '; codecs="' + b + '"');
            return c;
        }
        function zf(a, b) {
            b && (a += '; codecs="' + b + '"');
            return a;
        }
        function Af(a, b, c) {
            var d = wf(a, b);
            b = zf(a, b);
            of(b) ? (a = of(b)) ? (a = a(), c = a.convertCodecs(c, b), a.destroy()) : c = b : c = a != "video/mp2t" && c == "audio" ? d.replace("video", "audio") : d;
            return c;
        }
        function Bf(a) {
            return a.split(";")[0].split("/")[1];
        }
        function Cf(a) {
            var b = Df(a);
            a = b[0].toLowerCase();
            b = b[1].toLowerCase();
            switch(!0){
                case a === "mp4a" && b === "69":
                case a === "mp4a" && b === "6b":
                case a === "mp4a" && b === "40.34":
                    return "mp3";
                case a === "mp4a" && b === "66":
                case a === "mp4a" && b === "67":
                case a === "mp4a" && b === "68":
                case a === "mp4a" && b === "40.2":
                case a === "mp4a" && b === "40.02":
                case a === "mp4a" && b === "40.5":
                case a === "mp4a" && b === "40.05":
                case a === "mp4a" && b === "40.29":
                case a === "mp4a" && b === "40.42":
                    return "aac";
                case a === "mp4a" && b === "a5":
                case a === "ac3":
                case a === "ac-3":
                    return "ac-3";
                case a === "mp4a" && b === "a6":
                case a === "eac3":
                case a === "ec-3":
                    return "ec-3";
                case a === "ac-4":
                    return "ac-4";
                case a === "mp4a" && b === "b2":
                    return "dtsx";
                case a === "mp4a" && b === "a9":
                    return "dtsc";
                case a === "vp09":
                case a === "vp9":
                    return "vp9";
                case a === "avc1":
                case a === "avc3":
                    return "avc";
                case a === "hvc1":
                case a === "hev1":
                    return "hevc";
                case a === "vvc1":
                case a === "vvi1":
                    return "vvc";
                case a === "dvh1":
                case a === "dvhe":
                    return b && b.startsWith("05") ? "dovi-p5" : "dovi-hevc";
                case a === "dvav":
                case a === "dva1":
                    return "dovi-avc";
                case a === "dav1":
                    return "dovi-av1";
                case a === "dvc1":
                case a === "dvi1":
                    return "dovi-vvc";
                case a === "lvc1":
                    return "lcevc";
            }
            return a;
        }
        function Ef(a) {
            var b = [];
            a = u(a.split(","));
            for(var c = a.next(); !c.done; c = a.next())c = Df(c.value), b.push(c[0]);
            return b.sort().join(",");
        }
        function Ff(a) {
            return a.split(";")[0];
        }
        function Gf(a) {
            a = a.split(/ *; */);
            a.shift();
            return (a = a.find(function(b) {
                return b.startsWith("codecs=");
            })) ? a.split("=")[1].replace(/^"|"$/g, "") : "";
        }
        function Hf(a) {
            return a === "application/x-mpegurl" || a === "application/vnd.apple.mpegurl" || a === "audio/x-mpegurl";
        }
        function Df(a) {
            a = a.split(".");
            var b = a[0];
            a.shift();
            return [
                b,
                a.join(".")
            ];
        }
        O("shaka.util.MimeUtils", vf);
        vf.getFullTypeWithAllCodecs = zf;
        vf.getFullType = wf;
        (new Map).set("codecs", "codecs").set("frameRate", "framerate").set("bandwidth", "bitrate").set("width", "width").set("height", "height").set("channelsCount", "channels");
        var yf = [
            "audio/aac",
            "audio/ac3",
            "audio/ec3",
            "audio/mpeg"
        ];
        function If(a) {
            this.i = null;
            this.l = a;
            this.C = this.G = !1;
            this.m = this.A = 0;
            this.o = Infinity;
            this.h = this.g = null;
            this.F = "";
            this.D = function() {};
            this.j = new Map;
        }
        function Jf(a, b) {
            Kf.set(a, b);
        }
        function Lf(a) {
            return Kf.get(a);
        }
        function Mf(a) {
            return Kf.has(a) ? !0 : a == "application/cea-608" || a == "application/cea-708" ? !!Id : !1;
        }
        If.prototype.destroy = function() {
            this.l = this.i = null;
            this.j.clear();
            return Promise.resolve();
        };
        function Nf(a, b, c, d, e) {
            var f, g, h, k, l, m, n, q;
            return H(function(r) {
                if (r.h == 1) return r.g(Promise.resolve(), 2);
                if (!a.i || !a.l) return r.return();
                if (c == null || d == null) return a.i.parseInit(Fb(b)), r.return();
                f = a.C ? 0 : a.A;
                g = a.G || a.C ? c : a.A;
                h = {
                    periodStart: f,
                    segmentStart: c,
                    segmentEnd: d,
                    vttOffset: g
                };
                k = a.i.parseMedia(Fb(b), h, e, []);
                l = u(k);
                for(m = l.next(); !m.done; m = l.next())n = m.value, a.D(n, e || null, h);
                q = k.filter(function(t) {
                    return t.startTime >= a.m && t.startTime < a.o;
                });
                a.l.append(q);
                a.g == null && (a.g = Math.max(c, a.m));
                a.h = Math.min(d, a.o);
                r.j();
            });
        }
        If.prototype.remove = function(a, b, c) {
            c = c === void 0 ? !1 : c;
            var d = this;
            return H(function(e) {
                if (e.h == 1) return e.g(Promise.resolve(), 2);
                if (a >= b || c && (Of(d, a, b), d.F === "")) return e.return();
                d.l && d.l.remove(a, b) && d.g != null && (b <= d.g || a >= d.h || (a <= d.g && b >= d.h ? d.g = d.h = null : a <= d.g && b < d.h ? d.g = b : a > d.g && b >= d.h && (d.h = a)), Pf(d));
                e.j();
            });
        };
        function Qf(a, b, c) {
            a.m = b;
            a.o = c;
        }
        function Rf(a, b, c) {
            a.F = b;
            if (b = a.j.get(b)) b = b.filter(function(d) {
                return d.endTime <= c;
            }), b.length && a.l.append(b);
        }
        function Sf(a, b, c) {
            b.startTime += c;
            b.endTime += c;
            b = u(b.nestedCues);
            for(var d = b.next(); !d.done; d = b.next())Sf(a, d.value, c);
        }
        function Tf(a, b, c) {
            var d = new Map;
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                var f = e.value;
                e = f.stream;
                f = f.cue;
                d.has(e) || d.set(e, []);
                Sf(a, f, c);
                f.startTime >= a.m && f.startTime < a.o && (d.get(e).push(f), e == a.F && a.l.append([
                    f
                ]));
            }
            c = u(d.keys());
            for(b = c.next(); !b.done; b = c.next())for(b = b.value, a.j.has(b) || a.j.set(b, []), e = u(d.get(b)), f = e.next(); !f.done; f = e.next())f = f.value, a.j.get(b).push(f);
            Pf(a);
        }
        function Of(a, b, c) {
            for(var d = u(a.j.keys()), e = d.next(); !e.done; e = d.next()){
                e = e.value;
                var f = a.j.get(e);
                f = f.filter(function(g) {
                    return g.startTime < b || g.endTime >= c;
                });
                a.j.set(e, f);
            }
        }
        function Pf(a) {
            for(var b = Infinity, c = -Infinity, d = u(a.j.values()), e = d.next(); !e.done; e = d.next()){
                e = u(e.value);
                for(var f = e.next(); !f.done; f = e.next())f = f.value, b = Math.min(b, f.startTime), c = Math.max(c, f.endTime);
            }
            b !== Infinity && c !== -Infinity && (a.g = a.g == null ? Math.max(b, a.m) : Math.min(a.g, Math.max(b, a.m)), a.h = Math.max(a.h, Math.min(c, a.o)));
        }
        O("shaka.text.TextEngine", If);
        If.prototype.destroy = If.prototype.destroy;
        If.findParser = Lf;
        If.unregisterParser = function(a) {
            Kf.delete(a);
        };
        If.registerParser = Jf;
        var Kf = new Map;
        function Uf(a) {
            this.g = a;
            this.h = null;
        }
        Uf.prototype.La = function() {
            this.stop();
            this.g();
            return this;
        };
        Uf.prototype.Z = function(a) {
            var b = this;
            this.stop();
            Vf(this, function() {
                b.g();
            }, a);
            return this;
        };
        Uf.prototype.xa = function(a) {
            this.stop();
            Wf(this, a);
            return this;
        };
        Uf.prototype.stop = function() {
            var a;
            (a = this.h) == null || a.call(this);
            this.h = null;
        };
        function Vf(a, b, c) {
            var d = !0, e = null;
            a.h = function() {
                clearTimeout(e);
                d = !1;
            };
            e = setTimeout(function() {
                d && b();
            }, c * 1E3);
        }
        function Wf(a, b) {
            Vf(a, function() {
                Wf(a, b);
                a.g();
            }, b);
        }
        O("shaka.util.Timer", Uf);
        Uf.prototype.stop = Uf.prototype.stop;
        Uf.prototype.tickEvery = Uf.prototype.xa;
        Uf.prototype.tickAfter = Uf.prototype.Z;
        Uf.prototype.tickNow = Uf.prototype.La;
        function Xf(a, b) {
            return a.concat(b);
        }
        function Yf() {}
        function Zf(a) {
            return a != null;
        }
        function $f(a, b) {
            return Promise.race([
                b,
                new Promise(function(c, d) {
                    new Uf(d).Z(a);
                })
            ]);
        }
        function ag() {}
        function bg(a, b, c, d, e) {
            if (e.length) {
                var f = a.textStreams;
                e = u(e);
                for(var g = e.next(), h = {}; !g.done; h = {
                    xi: void 0
                }, g = e.next())if (h.xi = g.value, g = f.filter(function(t) {
                    return function(v) {
                        return v.codecs.startsWith(t.xi) || v.mimeType.startsWith(t.xi) ? !0 : !1;
                    };
                }(h)), g.length) {
                    f = g;
                    break;
                }
                a.textStreams = f;
            }
            f = a.variants;
            if (b.length || c.length) f = cg(f, b, c);
            if (d.length) {
                b = new eb;
                f = u(f);
                for(c = f.next(); !c.done; c = f.next())c = c.value, b.push(String(c.video.width || 0), c);
                var k = [];
                b.forEach(function(t, v) {
                    t = 0;
                    var w = [];
                    v = u(v);
                    for(var x = v.next(), y = {}; !x.done; y = {
                        yg: void 0
                    }, x = v.next())y.yg = x.value, x = d.filter(function(z) {
                        return function(A) {
                            return z.yg.decodingInfos[0][A];
                        };
                    }(y)).length, x > t ? (t = x, w = [
                        y.yg
                    ]) : x == t && w.push(y.yg);
                    k.push.apply(k, G(w));
                });
                f = k;
            }
            b = new Set;
            c = u(f);
            for(e = c.next(); !e.done; e = c.next())e = e.value, e.video && b.add(e.video);
            if (b.size) {
                var l = {
                    vp8: 1,
                    avc: 1,
                    "dovi-avc": .95,
                    vp9: .9,
                    vp09: .9,
                    hevc: .85,
                    "dovi-hevc": .8,
                    "dovi-p5": .75,
                    av01: .7,
                    "dovi-av1": .65,
                    vvc: .6
                };
                e = Array.from(b).sort(function(t, v) {
                    return t.bandwidth && v.bandwidth && t.bandwidth != v.bandwidth ? t.bandwidth - v.bandwidth : t.width != v.width ? t.width - v.width : t.codecs && v.codecs ? (t = Cf(t.codecs), v = Cf(v.codecs), (l[t] || 1) - (l[v] || 1)) : 0;
                });
                var m = [];
                b = new Map;
                c = function(t) {
                    var v = [
                        String(t.width || ""),
                        String(t.height || ""),
                        String(Math.round(t.frameRate || 0)),
                        t.hdr || "",
                        t.fastSwitching
                    ];
                    t.dependencyStream && v.push(t.dependencyStream.baseOriginalId || "");
                    t.roles && v.push(t.roles.sort().join("_"));
                    return v.join(";");
                };
                e = u(e);
                for(g = e.next(); !g.done; g = e.next()){
                    g = g.value;
                    h = c(g);
                    var n = b.get(h) || [];
                    if (n.length) {
                        var q = Cf(n[n.length - 1].codecs), r = Cf(g.codecs);
                        q == r && (n.push(g), m.push(g.id));
                    } else n.push(g), m.push(g.id);
                    b.set(h, n);
                }
                a.variants = f.filter(function(t) {
                    return (t = t.video) && !m.includes(t.id) ? !1 : !0;
                });
            } else a.variants = f;
        }
        function cg(a, b, c) {
            b = u(b);
            for(var d = b.next(), e = {}; !d.done; e = {
                jk: void 0
            }, d = b.next())if (e.jk = d.value, d = a.filter(function(f) {
                return function(g) {
                    return g.video && g.video.codecs.startsWith(f.jk);
                };
            }(e)), d.length) {
                a = d;
                break;
            }
            c = u(c);
            b = c.next();
            for(d = {}; !b.done; d = {
                Ki: void 0
            }, b = c.next())if (d.Ki = b.value, b = a.filter(function(f) {
                return function(g) {
                    return g.audio && g.audio.codecs.startsWith(f.Ki);
                };
            }(d)), b.length) {
                a = b;
                break;
            }
            return a;
        }
        function dg(a, b, c) {
            a.variants = a.variants.filter(function(d) {
                return eg(d, b, c);
            });
        }
        function eg(a, b, c) {
            function d(g, h, k) {
                return g >= h && g <= k;
            }
            if (a && a.video && a.video.width && a.video.height) {
                var e = a.video.width, f = a.video.height;
                f > e && (f = u([
                    f,
                    e
                ]), e = f.next().value, f = f.next().value);
                if (!d(e, b.minWidth, Math.min(b.maxWidth, c.width)) || !d(f, b.minHeight, Math.min(b.maxHeight, c.height)) || !d(e * f, b.minPixels, b.maxPixels)) return !1;
            }
            return a && a.video && a.video.frameRate && !d(a.video.frameRate, b.minFrameRate, b.maxFrameRate) || a && a.audio && a.audio.channelsCount && !d(a.audio.channelsCount, b.minChannelsCount, b.maxChannelsCount) || !d(a.bandwidth, b.minBandwidth, b.maxBandwidth) ? !1 : !0;
        }
        function fg(a, b, c, d) {
            c = c === void 0 ? [] : c;
            d = d === void 0 ? {} : d;
            return H(function(e) {
                if (e.h == 1) return e.g(gg(a, b, b.offlineSessionIds.length > 0, c, d), 2);
                hg(b);
                return e.g(ig(b), 0);
            });
        }
        function gg(a, b, c, d, e) {
            var f, g;
            return H(function(h) {
                if (h.h == 1) return Xb().Tj() && jg(b.variants), h.g(kg(b.variants, c, !1, d), 2);
                f = null;
                a && (g = a.g) && (f = g.keySystem);
                b.variants = b.variants.filter(function(k) {
                    var l = lg(k, f, e);
                    if (!l) {
                        var m = [];
                        k.audio && m.push(mg(k.audio));
                        k.video && m.push(mg(k.video));
                    }
                    return l;
                });
                h.j();
            });
        }
        function jg(a) {
            var b = (new Map).set("dvav", "avc3").set("dva1", "avc1").set("dvhe", "hev1").set("dvh1", "hvc1").set("dvc1", "vvc1").set("dvi1", "vvi1"), c = new Set;
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, d.video && c.add(d.video);
            c = u(c);
            for(a = c.next(); !a.done; a = c.next()){
                a = a.value;
                d = u(b);
                for(var e = d.next(); !e.done; e = d.next()){
                    var f = u(e.value);
                    e = f.next().value;
                    f = f.next().value;
                    if (a.codecs.includes(e)) {
                        a.codecs = a.codecs.replace(e, f);
                        break;
                    }
                }
            }
        }
        function lg(a, b, c) {
            if (!a.decodingInfos.some(function(k) {
                return !k.supported || b && (k = k.keySystemAccess) && (c[k.keySystem] || k.keySystem) != b ? !1 : !0;
            })) return !1;
            var d = Xb(), e = d.Pb() === "Xbox";
            d = d.Pa() === "MOBILE" && d.Ma() === "GECKO";
            var f = a.video, g = f && f.width || 0, h = f && f.height || 0;
            if (e && f && (g > 1920 || h > 1080) && (f.codecs.includes("avc1.") || f.codecs.includes("avc3.")) || (e = f && f.dependencyStream) && !vd(e)) return !1;
            a = a.audio;
            return d && a && a.encrypted && a.codecs.toLowerCase().includes("opus") || a && a.dependencyStream ? !1 : !0;
        }
        function ng(a, b) {
            var c, d, e, f, g, h, k;
            return H(function(l) {
                if (l.h == 1) {
                    c = function(m, n) {
                        if (m) {
                            var q = Yd(m);
                            q.supported = m.supported && n.supported;
                            q.powerEfficient = m.powerEfficient && n.powerEfficient;
                            q.smooth = m.smooth && n.smooth;
                            n.keySystemAccess && !q.keySystemAccess && (q.keySystemAccess = n.keySystemAccess);
                            return q;
                        }
                        return n;
                    };
                    d = null;
                    e = [];
                    f = u(b);
                    g = f.next();
                    for(h = {}; !g.done; h = {
                        cache: void 0,
                        gf: void 0
                    }, g = f.next())k = g.value, h.gf = Zd(k), h.cache = og, h.cache.has(h.gf) ? d = c(d, h.cache.get(h.gf)) : e.push(pg(k).then(function(m) {
                        return function(n) {
                            var q = null;
                            n = u(n || []);
                            for(var r = n.next(); !r.done; r = n.next())q = c(q, r.value);
                            q && (m.cache.set(m.gf, q), d = c(d, q));
                        };
                    }(h)));
                    return l.g(Promise.all(e), 2);
                }
                d && a.decodingInfos.push(d);
                l.j();
            });
        }
        function pg(a) {
            var b = [
                ""
            ];
            a.video && (b = Gf(a.video.contentType).split(","));
            var c = [
                ""
            ];
            a.audio && (c = Gf(a.audio.contentType).split(","));
            var d = [];
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                for(var f = u(c), g = f.next(), h = {}; !g.done; h = {
                    $c: void 0
                }, g = f.next())g = g.value, h.$c = Xd(a), a.video && (h.$c.video.contentType = wf(Ff(h.$c.video.contentType), e)), a.audio && (h.$c.audio.contentType = wf(Ff(h.$c.audio.contentType), g)), d.push(new Promise(function(k) {
                    return function(l, m) {
                        (Xb().Pa() == "MOBILE" ? $f(5, navigator.mediaCapabilities.decodingInfo(k.$c)) : navigator.mediaCapabilities.decodingInfo(k.$c)).then(function(n) {
                            l(n);
                        }).catch(m);
                    };
                }(h)));
            }
            return Promise.all(d).catch(function() {
                JSON.stringify(a);
                return null;
            });
        }
        function kg(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C;
            return H(function(D) {
                switch(D.h){
                    case 1:
                        if (e = a.some(function(B) {
                            return B.decodingInfos.length;
                        })) return D.return();
                        f = u(d);
                        g = f.next();
                        h = {};
                    case 2:
                        if (g.done) {
                            D.B(4);
                            break;
                        }
                        h.yj = g.value;
                        k = !1;
                        l = u(a);
                        m = l.next();
                    case 5:
                        if (m.done) {
                            D.B(7);
                            break;
                        }
                        n = m.value;
                        q = qg(n, b, c).filter(function(B) {
                            return function(J) {
                                J = J[0];
                                J = J.keySystemConfiguration && J.keySystemConfiguration.keySystem;
                                return !J || J === B.yj;
                            };
                        }(h));
                        r = u(q);
                        t = r.next();
                    case 8:
                        if (t.done) {
                            D.B(10);
                            break;
                        }
                        v = t.value;
                        return D.g(ng(n, v), 9);
                    case 9:
                        t = r.next();
                        D.B(8);
                        break;
                    case 10:
                        n.decodingInfos.some(function(B) {
                            return B.supported;
                        }) && (k = !0);
                        m = l.next();
                        D.B(5);
                        break;
                    case 7:
                        if (k) return D.return();
                        h = {
                            yj: void 0
                        };
                        g = f.next();
                        D.B(2);
                        break;
                    case 4:
                        w = u(a), x = w.next();
                    case 12:
                        if (x.done) {
                            D.B(0);
                            break;
                        }
                        y = x.value;
                        z = qg(y, b, c).filter(function(B) {
                            B = B[0];
                            B = B.keySystemConfiguration && B.keySystemConfiguration.keySystem;
                            return !B || !d.includes(B);
                        });
                        A = u(z);
                        E = A.next();
                    case 15:
                        if (E.done) {
                            x = w.next();
                            D.B(12);
                            break;
                        }
                        C = E.value;
                        return D.g(ng(y, C), 16);
                    case 16:
                        E = A.next(), D.B(15);
                }
            });
        }
        function qg(a, b, c) {
            var d = a.audio, e = a.video, f = [], g = [];
            if (e) for(var h = u(e.fullMimeTypes), k = h.next(); !k.done; k = h.next()){
                k = k.value;
                var l = Gf(k);
                if (l.includes(",") && !d) {
                    var m = l.split(","), n = Ff(k);
                    l = Bc("video", m);
                    m = Bc("audio", m);
                    m = rg(m, n);
                    n = Af(n, m, "audio");
                    g.push({
                        contentType: n,
                        channels: 2,
                        bitrate: a.bandwidth || 1,
                        samplerate: 1,
                        spatialRendering: !1
                    });
                }
                l = sg(l);
                k = {
                    contentType: Af(Ff(k), l, "video"),
                    width: e.width || 64,
                    height: e.height || 64,
                    bitrate: e.bandwidth || a.bandwidth || 1,
                    framerate: e.frameRate || 30
                };
                if (e.hdr) switch(e.hdr){
                    case "PQ":
                        k.transferFunction = "pq";
                        break;
                    case "HLG":
                        k.transferFunction = "hlg";
                }
                e.colorGamut && (k.colorGamut = e.colorGamut);
                f.push(k);
            }
            if (d) for(h = u(d.fullMimeTypes), k = h.next(); !k.done; k = h.next())l = k.value, k = Ff(l), l = rg(Gf(l), k), k = Af(k, l, "audio"), g.push({
                contentType: k,
                channels: d.channelsCount || 2,
                bitrate: d.bandwidth || a.bandwidth || 1,
                samplerate: d.audioSamplingRate || 1,
                spatialRendering: d.spatialAudio
            });
            h = [];
            f.length == 0 && f.push(null);
            g.length == 0 && g.push(null);
            f = u(f);
            for(k = f.next(); !k.done; k = f.next())for(k = k.value, l = u(g), n = l.next(); !n.done; n = l.next())n = n.value, m = {
                type: c ? "file" : "media-source"
            }, k && (m.video = k), n && (m.audio = n), h.push(m);
            g = (a.video ? a.video.drmInfos : []).concat(a.audio ? a.audio.drmInfos : []);
            if (!g.length) return [
                h
            ];
            a = [];
            c = new Map;
            g = u(g);
            for(f = g.next(); !f.done; f = g.next())f = f.value, c.get(f.keySystem) || c.set(f.keySystem, []), c.get(f.keySystem).push(f);
            g = b ? "required" : "optional";
            b = b ? [
                "persistent-license"
            ] : [
                "temporary"
            ];
            f = u(c.keys());
            for(k = f.next(); !k.done; k = f.next()){
                k = k.value;
                n = c.get(k);
                l = new Map;
                n = u(n);
                for(m = n.next(); !m.done; m = n.next()){
                    m = m.value;
                    var q = m.videoRobustness + "," + m.audioRobustness;
                    l.get(q) || l.set(q, []);
                    l.get(q).push(m);
                }
                l = u(l.values());
                for(n = l.next(); !n.done; n = l.next()){
                    n = n.value;
                    m = [];
                    q = u(h);
                    for(var r = q.next(); !r.done; r = q.next()){
                        r = Object.assign({}, r.value);
                        for(var t = {
                            keySystem: k,
                            initDataType: "cenc",
                            persistentState: g,
                            distinctiveIdentifier: "optional",
                            sessionTypes: b
                        }, v = u(n), w = v.next(); !w.done; w = v.next()){
                            w = w.value;
                            if (w.initData && w.initData.length) {
                                for(var x = new Set, y = u(w.initData), z = y.next(); !z.done; z = y.next())x.add(z.value.initDataType);
                                t.initDataType = w.initData[0].initDataType;
                            }
                            w.distinctiveIdentifierRequired && (t.distinctiveIdentifier = "required");
                            w.persistentStateRequired && (t.persistentState = "required");
                            w.sessionType && (t.sessionTypes = [
                                w.sessionType
                            ]);
                            d && (t.audio ? (w.encryptionScheme && (t.audio.encryptionScheme = t.audio.encryptionScheme || w.encryptionScheme), t.audio.robustness = t.audio.robustness || w.audioRobustness) : (t.audio = {
                                robustness: w.audioRobustness
                            }, w.encryptionScheme && (t.audio.encryptionScheme = w.encryptionScheme)), t.audio.robustness == "" && delete t.audio.robustness);
                            e && (t.video ? (w.encryptionScheme && (t.video.encryptionScheme = t.video.encryptionScheme || w.encryptionScheme), t.video.robustness = t.video.robustness || w.videoRobustness) : (t.video = {
                                robustness: w.videoRobustness
                            }, w.encryptionScheme && (t.video.encryptionScheme = w.encryptionScheme)), t.video.robustness == "" && delete t.video.robustness);
                        }
                        r.keySystemConfiguration = t;
                        m.push(r);
                    }
                    a.push(m);
                }
            }
            return a;
        }
        function rg(a, b) {
            var c = Xb();
            return a.toLowerCase() == "flac" ? c.Ma() != "WEBKIT" ? "flac" : "fLaC" : a.toLowerCase() === "opus" ? c.Ma() != "WEBKIT" ? "opus" : Bf(b) == "mp4" ? "Opus" : "opus" : a.toLowerCase() == "ac-3" && c.Fe() ? "ec-3" : a;
        }
        function sg(a) {
            if (a.includes("avc1")) {
                var b = a.split(".");
                if (b.length == 3) return a = b.shift() + ".", a += parseInt(b.shift(), 10).toString(16), a += ("000" + parseInt(b.shift(), 10).toString(16)).slice(-4);
            } else if (a == "vp9") return "vp09.00.41.08";
            return a;
        }
        function hg(a) {
            a.textStreams = a.textStreams.filter(function(b) {
                b = wf(b.mimeType, b.codecs);
                return Mf(b);
            });
        }
        function ig(a) {
            var b, c, d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        b = [], c = u(a.imageStreams), d = c.next();
                    case 2:
                        if (d.done) {
                            l.B(4);
                            break;
                        }
                        e = d.value;
                        f = e.mimeType;
                        f == "application/mp4" && e.codecs == "mjpg" && (f = "image/jpg");
                        if (tg.has(f)) {
                            l.B(5);
                            break;
                        }
                        g = ug.get(f);
                        if (!g) {
                            tg.set(f, !1);
                            l.B(5);
                            break;
                        }
                        return l.g(vg(g), 7);
                    case 7:
                        h = l.i, tg.set(f, h);
                    case 5:
                        (k = tg.get(f)) && b.push(e);
                        d = c.next();
                        l.B(2);
                        break;
                    case 4:
                        a.imageStreams = b, l.j();
                }
            });
        }
        function vg(a) {
            return new Promise(function(b) {
                var c = new Image;
                c.src = a;
                "decode" in c ? c.decode().then(function() {
                    b(!0);
                }).catch(function() {
                    b(!1);
                }) : c.onload = c.onerror = function() {
                    b(c.height === 2);
                };
            });
        }
        function wg(a) {
            var b = a.audio, c = a.video, d = b ? b.mimeType : null, e = c ? c.mimeType : null, f = b ? b.codecs : null, g = c ? c.codecs : null, h = b ? b.groupId : null, k = [];
            c && k.push(c.mimeType);
            b && k.push(b.mimeType);
            k = k[0] || null;
            var l = [];
            b && l.push(b.kind);
            c && l.push(c.kind);
            l = l[0] || null;
            var m = new Set;
            if (b) for(var n = u(b.roles), q = n.next(); !q.done; q = n.next())m.add(q.value);
            if (c) for(n = u(c.roles), q = n.next(); !q.done; q = n.next())m.add(q.value);
            a = {
                id: a.id,
                active: !1,
                type: "variant",
                bandwidth: a.bandwidth,
                language: a.language,
                label: null,
                videoLabel: null,
                kind: l,
                width: null,
                height: null,
                frameRate: null,
                pixelAspectRatio: null,
                hdr: null,
                colorGamut: null,
                videoLayout: null,
                mimeType: k,
                audioMimeType: d,
                videoMimeType: e,
                codecs: "",
                audioCodec: f,
                videoCodec: g,
                primary: a.primary,
                roles: Array.from(m),
                audioRoles: null,
                videoRoles: null,
                forced: !1,
                videoId: null,
                audioId: null,
                audioGroupId: h,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                tilesLayout: null,
                audioBandwidth: null,
                videoBandwidth: null,
                originalVideoId: null,
                originalAudioId: null,
                originalTextId: null,
                originalImageId: null,
                accessibilityPurpose: null,
                originalLanguage: null
            };
            if (c) {
                a.videoId = c.id;
                a.originalVideoId = c.originalId;
                a.width = c.width || null;
                a.height = c.height || null;
                a.frameRate = c.frameRate || null;
                a.pixelAspectRatio = c.pixelAspectRatio || null;
                a.videoBandwidth = c.bandwidth || null;
                a.hdr = c.hdr || null;
                a.colorGamut = c.colorGamut || null;
                a.videoLayout = c.videoLayout || null;
                a.videoRoles = c.roles;
                a.videoLabel = c.label;
                if (d = c.dependencyStream) a.width = d.width || a.width, a.height = d.height || a.height, a.videoCodec = d.codecs || a.videoCodec, a.pixelAspectRatio = d.pixelAspectRatio || a.pixelAspectRatio, a.videoBandwidth && d.bandwidth && (a.videoBandwidth += d.bandwidth);
                if (g.includes(",")) {
                    a.channelsCount = c.channelsCount;
                    a.audioSamplingRate = c.audioSamplingRate;
                    a.spatialAudio = c.spatialAudio;
                    a.originalLanguage = c.originalLanguage;
                    a.audioMimeType = e;
                    e = g.split(",");
                    try {
                        a.videoCodec = Bc("video", e), a.audioCodec = Bc("audio", e);
                    } catch (r) {}
                }
            }
            b && (a.audioId = b.id, a.originalAudioId = b.originalId, a.channelsCount = b.channelsCount, a.audioSamplingRate = b.audioSamplingRate, a.audioBandwidth = b.bandwidth || null, a.spatialAudio = b.spatialAudio, a.label = b.label, a.audioRoles = b.roles, a.accessibilityPurpose = b.accessibilityPurpose, a.originalLanguage = b.originalLanguage, e = b.dependencyStream) && (a.audioCodec = e.codecs || a.audioCodec, a.audioBandwidth && e.bandwidth && (a.audioBandwidth += e.bandwidth));
            c && !a.videoBandwidth && (b ? a.audioBandwidth && (a.videoBandwidth = a.bandwidth - a.audioBandwidth) : a.videoBandwidth = a.bandwidth);
            b && !a.audioBandwidth && (c ? a.videoBandwidth && (a.audioBandwidth = a.bandwidth - a.videoBandwidth) : a.audioBandwidth = a.bandwidth);
            b = [];
            a.videoCodec && b.push(a.videoCodec);
            a.audioCodec && b.push(a.audioCodec);
            a.codecs = b.join(", ");
            return a;
        }
        function xg(a) {
            return {
                id: a.id,
                active: !1,
                type: Ec,
                bandwidth: a.bandwidth || 0,
                language: a.language,
                label: a.label,
                kind: a.kind || null,
                mimeType: a.mimeType,
                codecs: a.codecs || null,
                primary: a.primary,
                roles: a.roles,
                accessibilityPurpose: a.accessibilityPurpose,
                forced: a.forced,
                originalTextId: a.originalId,
                originalLanguage: a.originalLanguage
            };
        }
        function yg(a) {
            var b = a.width || null, c = a.height || null, d = null;
            a.segmentIndex && (d = a.segmentIndex.Fb());
            var e = a.tilesLayout;
            d && (e = d.tilesLayout || e);
            e && b != null && (b /= Number(e.split("x")[0]));
            e && c != null && (c /= Number(e.split("x")[1]));
            return {
                id: a.id,
                type: "image",
                bandwidth: a.bandwidth || 0,
                width: b,
                height: c,
                mimeType: a.mimeType,
                codecs: a.codecs || null,
                tilesLayout: e || null,
                originalImageId: a.originalId
            };
        }
        function zg(a) {
            a.__shaka_id || (a.__shaka_id = Ag++);
            return a.__shaka_id;
        }
        function Cg(a) {
            var b = {
                id: zg(a),
                active: a.mode != "disabled",
                type: Ec,
                bandwidth: 0,
                language: Kc(a.language || "und"),
                label: a.label,
                kind: a.kind,
                mimeType: null,
                codecs: null,
                primary: !1,
                roles: [],
                accessibilityPurpose: null,
                forced: a.kind == "forced",
                originalTextId: a.id,
                originalLanguage: a.language
            };
            a.kind == "captions" && (b.mimeType = "unknown");
            a.kind == "subtitles" && (b.mimeType = "text/vtt");
            a.kind && (b.roles = [
                a.kind
            ]);
            return b;
        }
        function Dg(a, b) {
            var c = a ? a.language : null;
            c = {
                id: zg(a || b),
                active: a ? a.enabled : b.selected,
                type: "variant",
                bandwidth: 0,
                language: Kc(c || "und"),
                label: a ? a.label : null,
                videoLabel: null,
                kind: a ? a.kind : null,
                width: null,
                height: null,
                frameRate: null,
                pixelAspectRatio: null,
                hdr: null,
                colorGamut: null,
                videoLayout: null,
                mimeType: null,
                audioMimeType: null,
                videoMimeType: null,
                codecs: null,
                audioCodec: null,
                videoCodec: null,
                primary: a ? a.kind == "main" : !1,
                roles: [],
                forced: !1,
                audioRoles: null,
                videoRoles: null,
                videoId: null,
                audioId: null,
                audioGroupId: null,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                tilesLayout: null,
                audioBandwidth: null,
                videoBandwidth: null,
                originalVideoId: b ? b.id : null,
                originalAudioId: a ? a.id : null,
                originalTextId: null,
                originalImageId: null,
                accessibilityPurpose: null,
                originalLanguage: c
            };
            a && a.kind && (c.roles = [
                a.kind
            ], c.audioRoles = [
                a.kind
            ]);
            a && a.configuration && (a.configuration.codec && (c.audioCodec = a.configuration.codec, c.codecs = c.audioCodec), a.configuration.bitrate && (c.audioBandwidth = a.configuration.bitrate, c.bandwidth += c.audioBandwidth), a.configuration.sampleRate && (c.audioSamplingRate = a.configuration.sampleRate), a.configuration.numberOfChannels && (c.channelsCount = a.configuration.numberOfChannels));
            if (b && b.configuration && (b.configuration.codec && (c.videoCodec = b.configuration.codec, c.codecs = c.codecs ? c.codecs + ("," + c.videoCodec) : c.videoCodec), b.configuration.bitrate && (c.videoBandwidth = b.configuration.bitrate, c.bandwidth += c.videoBandwidth), b.configuration.framerate && (c.frameRate = b.configuration.framerate), b.configuration.width && (c.width = b.configuration.width), b.configuration.height && (c.height = b.configuration.height), b.configuration.colorSpace && b.configuration.colorSpace.transfer)) switch(b.configuration.colorSpace.transfer){
                case "pq":
                    c.hdr = "PQ";
                    break;
                case "hlg":
                    c.hdr = "HLG";
                    break;
                case "bt709":
                    c.hdr = "SDR";
            }
            return c;
        }
        function Eg(a) {
            return a.allowedByApplication && a.allowedByKeySystem && a.disabledUntilTime == 0;
        }
        function Fg(a) {
            return a.filter(function(b) {
                return Eg(b);
            });
        }
        function Gg(a, b, c, d) {
            var e = a, f = a.filter(function(k) {
                return k.primary;
            });
            f.length && (e = f);
            var g = e.length ? e[0].language : "";
            e = e.filter(function(k) {
                return k.language == g;
            });
            if (b) {
                var h = Sc(Kc(b), a.map(function(k) {
                    return k.language;
                }));
                h && (e = a.filter(function(k) {
                    return Kc(k.language) == h;
                }));
            }
            e = e.filter(function(k) {
                return k.forced == d;
            });
            if (c) {
                if (a = Lg(e, c), a.length) return a;
            } else if (a = e.filter(function(k) {
                return k.roles.length == 0;
            }), a.length) return a;
            a = e.map(function(k) {
                return k.roles;
            }).reduce(Xf, []);
            return a.length ? Lg(e, a[0]) : e;
        }
        function Lg(a, b) {
            return a.filter(function(c) {
                return c.roles.includes(b);
            });
        }
        function Mg(a) {
            var b = [];
            a.audio && b.push(a.audio);
            a.video && b.push(a.video);
            return b;
        }
        function Ng(a, b) {
            b.length && (b = b.filter(function(c) {
                return Cf(a.codecs) == Cf(c.codecs);
            }).sort(function(c, d) {
                return c.bandwidth && d.bandwidth && c.bandwidth != d.bandwidth ? c.bandwidth - d.bandwidth : (c.width || 0) - (d.width || 0);
            }), a.trickModeVideo = b[0], b.length > 1 && (b = b.find(function(c) {
                return a.width == c.width && a.height == c.height;
            }))) && (a.trickModeVideo = b);
        }
        function mg(a) {
            return a.type == "audio" ? "type=audio codecs=" + a.codecs + " bandwidth=" + a.bandwidth + " channelsCount=" + a.channelsCount + " audioSamplingRate=" + a.audioSamplingRate : a.type == "video" ? "type=video codecs=" + a.codecs + " bandwidth=" + a.bandwidth + " frameRate=" + a.frameRate + " width=" + a.width + " height=" + a.height : "unexpected stream type";
        }
        function Og(a, b, c) {
            if (c.autoShowText == 0) return !1;
            if (c.autoShowText == 1) return !0;
            var d = Kc(c.preferredTextLanguage);
            b = Kc(b.language);
            if (c.autoShowText == 2) return Jc(b, d);
            if (c.autoShowText == 3) {
                if (!a) return !1;
                a = Kc(a.language);
                return Jc(b, d) && !Jc(a, b);
            }
            Za("Invalid autoShowText setting!");
            return !1;
        }
        function Pg(a) {
            var b = {
                id: 0,
                language: "und",
                disabledUntilTime: 0,
                primary: !1,
                audio: null,
                video: null,
                bandwidth: 100,
                allowedByApplication: !0,
                allowedByKeySystem: !0,
                decodingInfos: []
            };
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = {
                    id: 0,
                    originalId: null,
                    groupId: null,
                    createSegmentIndex: function() {
                        return Promise.resolve();
                    },
                    segmentIndex: null,
                    mimeType: c ? Ff(c) : "",
                    codecs: c ? Gf(c) : "",
                    encrypted: !0,
                    drmInfos: [],
                    keyIds: new Set,
                    language: "und",
                    originalLanguage: null,
                    label: null,
                    type: "video",
                    primary: !1,
                    trickModeVideo: null,
                    dependencyStream: null,
                    emsgSchemeIdUris: null,
                    roles: [],
                    forced: !1,
                    channelsCount: null,
                    audioSamplingRate: null,
                    spatialAudio: !1,
                    closedCaptions: null,
                    accessibilityPurpose: null,
                    external: !1,
                    fastSwitching: !1,
                    fullMimeTypes: new Set,
                    isAudioMuxedInVideo: !1,
                    baseOriginalId: null
                };
                d.fullMimeTypes.add(wf(d.mimeType, d.codecs));
                c.startsWith("audio/") ? (d.type = "audio", b.audio = d) : b.video = d;
            }
            return b;
        }
        O("shaka.util.StreamUtils", ag);
        ag.meetsRestrictions = eg;
        var og = new Map, Ag = 0, tg = (new Map).set("image/svg+xml", !0).set("image/png", !0).set("image/jpeg", !0).set("image/jpg", !0), ug = (new Map).set("image/webp", "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA").set("image/avif", "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=");
        function Qg() {
            var a = this;
            this.H = null;
            this.G = !1;
            this.A = new Zc;
            this.j = new fd;
            navigator.connection && navigator.connection.addEventListener && this.j.u(navigator.connection, "change", function() {
                a.g.useNetworkInformation && navigator.onLine && (a.A = new Zc, a.g && a.A.configure(a.g.advanced), a.trySuggestStreams());
            });
            this.l = [];
            this.I = 1;
            this.J = !1;
            this.h = this.o = this.g = this.C = null;
            this.m = new Uf(function() {
                if (a.G && (a.g.restrictToElementSize || a.g.restrictToScreenSize)) {
                    var b = a.chooseVariant();
                    b && a.H && a.H(b, a.g.clearBufferSwitch, a.g.safeMarginSwitch);
                }
            });
            this.D = window1;
            "documentPictureInPicture" in window1 && this.j.u(window1.documentPictureInPicture, "enter", function() {
                a.D = window1.documentPictureInPicture.window;
                a.m && a.m.La();
                a.j.ra(a.D, "pagehide", function() {
                    a.D = window1;
                    a.m && a.m.La();
                });
            });
            this.F = this.i = null;
        }
        p = Qg.prototype;
        p.stop = function() {
            this.H = null;
            this.G = !1;
            this.l = [];
            this.I = 1;
            this.o = this.C = null;
            this.h && (this.h.disconnect(), this.h = null);
            this.m && this.m.stop();
            this.F = this.i = null;
        };
        p.release = function() {
            this.stop();
            this.j.release();
            this.m = null;
        };
        p.init = function(a) {
            this.H = a;
        };
        p.chooseVariant = function(a) {
            a = a === void 0 ? !1 : a;
            var b = Infinity, c = Infinity;
            this.g.restrictToScreenSize && (c = this.g.ignoreDevicePixelRatio ? 1 : this.D.devicePixelRatio, b = this.D.screen.height * c, c *= this.D.screen.width);
            if (this.h && this.g.restrictToElementSize) {
                var d = this.g.ignoreDevicePixelRatio ? 1 : this.D.devicePixelRatio, e = this.o.clientHeight, f = this.o.clientWidth;
                this.i && document.pictureInPictureElement && document.pictureInPictureElement == this.o && (e = this.i.height, f = this.i.width);
                b = Math.min(b, e * d);
                c = Math.min(c, f * d);
            }
            e = this.l.filter(function(l) {
                return l && !(l.audio && l.audio.fastSwitching || l.video && l.video.fastSwitching);
            });
            e.length || (e = this.l);
            d = e;
            a && e.length != this.l.length && (d = this.l.filter(function(l) {
                return l && (l.audio && l.audio.fastSwitching || l.video && l.video.fastSwitching ? !0 : !1);
            }));
            a = Rg(this, this.g.restrictions, d, Infinity, Infinity);
            if (b != Infinity || c != Infinity) {
                a = Sg(a);
                a = u(a);
                for(e = a.next(); !e.done; e = a.next())if (e = e.value, e.height >= b && e.width >= c) {
                    b = e.height;
                    c = e.width;
                    break;
                }
                a = Rg(this, this.g.restrictions, d, b, c);
            }
            b = this.getBandwidthEstimate();
            d.length && !a.length && (a = Rg(this, null, d, Infinity, Infinity), a = [
                a[0]
            ]);
            c = a[0] || null;
            for(d = 0; d < a.length; d++){
                e = a[d];
                var g = isNaN(this.I) ? 1 : Math.abs(this.I);
                f = g * e.bandwidth / this.g.bandwidthDowngradeTarget;
                for(var h = {
                    bandwidth: Infinity
                }, k = d + 1; k < a.length; k++)if (e.bandwidth != a[k].bandwidth) {
                    h = a[k];
                    break;
                }
                g = g * h.bandwidth / this.g.bandwidthUpgradeTarget;
                c && e && b >= f && b <= g && (c.bandwidth != e.bandwidth || c.bandwidth == e.bandwidth && c.video && e.video && (c.video.width < e.video.width || c.video.height < e.video.height)) && (c = e);
            }
            this.C = Date.now();
            return c;
        };
        p.enable = function() {
            this.G = !0;
            this.l.length && this.trySuggestStreams();
        };
        p.disable = function() {
            this.G = !1;
        };
        p.segmentDownloaded = function(a, b, c, d) {
            var e = a;
            this.g.removeLatencyFromFirstPacketTime && d && d.packetNumber === 1 && d.timeToFirstByte && (e = a - d.timeToFirstByte);
            e >= this.g.cacheLoadThreshold && this.A.sample(e, b);
            c && this.C != null && this.G && Tg(this);
        };
        p.trySuggestStreams = function() {
            this.G && (this.C = Date.now(), Tg(this, !0));
        };
        p.getBandwidthEstimate = function() {
            var a = this.g.defaultBandwidthEstimate;
            navigator.connection && navigator.connection.downlink && this.g.useNetworkInformation && (a = navigator.connection.downlink * 1E6);
            if (navigator.connection && navigator.connection.downlink && this.g.useNetworkInformation && this.g.preferNetworkInformationBandwidth) return a;
            a = this.A.getBandwidthEstimate(a);
            return this.F ? this.F.getBandwidthEstimate(a) : a;
        };
        p.setVariants = function(a) {
            if (bd(a, this.l)) return !1;
            this.l = a;
            return !0;
        };
        p.playbackRateChanged = function(a) {
            this.I = a;
        };
        p.setMediaElement = function(a) {
            function b() {
                c.m.Z(Ug);
            }
            var c = this;
            this.o = a;
            this.h && (this.h.disconnect(), this.h = null);
            this.o && "ResizeObserver" in window1 && (this.h = new ResizeObserver(b), this.h.observe(this.o));
            this.j.u(a, "enterpictureinpicture", function(d) {
                d.pictureInPictureWindow && (c.i = d.pictureInPictureWindow, c.j.u(c.i, "resize", b));
            });
            this.j.u(a, "leavepictureinpicture", function() {
                c.i && c.j.Fa(c.i, "resize", b);
                c.i = null;
            });
        };
        p.setCmsdManager = function(a) {
            this.F = a;
        };
        p.configure = function(a) {
            this.g = a;
            this.A && this.g && this.A.configure(this.g.advanced);
        };
        function Tg(a, b) {
            if (b === void 0 || !b) {
                if (!a.J) {
                    b = a.A;
                    if (!(b.g >= b.i)) return;
                    a.J = !0;
                    a.C -= (a.g.switchInterval - a.g.minTimeToSwitch) * 1E3;
                }
                if (Date.now() - a.C < a.g.switchInterval * 1E3) return;
            }
            b = a.chooseVariant();
            a.getBandwidthEstimate();
            b && a.H && a.H(b, a.g.clearBufferSwitch, a.g.safeMarginSwitch);
        }
        function Rg(a, b, c, d, e) {
            if (a.F) {
                var f = a.F.aj();
                f && (c = c.filter(function(g) {
                    return g.bandwidth && f ? g.bandwidth <= f : !0;
                }));
            }
            b && (c = c.filter(function(g) {
                return eg(g, b, {
                    width: e,
                    height: d
                });
            }));
            return c.sort(function(g, h) {
                return g.bandwidth - h.bandwidth;
            });
        }
        function Sg(a) {
            var b = [];
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())(c = c.value) && (c = c.video) && c.height && c.width && b.push({
                height: c.height,
                width: c.width
            });
            return b.sort(function(d, e) {
                return d.width - e.width;
            });
        }
        O("shaka.abr.SimpleAbrManager", Qg);
        Qg.prototype.configure = Qg.prototype.configure;
        Qg.prototype.setCmsdManager = Qg.prototype.setCmsdManager;
        Qg.prototype.setMediaElement = Qg.prototype.setMediaElement;
        Qg.prototype.playbackRateChanged = Qg.prototype.playbackRateChanged;
        Qg.prototype.setVariants = Qg.prototype.setVariants;
        Qg.prototype.getBandwidthEstimate = Qg.prototype.getBandwidthEstimate;
        Qg.prototype.trySuggestStreams = Qg.prototype.trySuggestStreams;
        Qg.prototype.segmentDownloaded = Qg.prototype.segmentDownloaded;
        Qg.prototype.disable = Qg.prototype.disable;
        Qg.prototype.enable = Qg.prototype.enable;
        Qg.prototype.chooseVariant = Qg.prototype.chooseVariant;
        Qg.prototype.init = Qg.prototype.init;
        Qg.prototype.release = Qg.prototype.release;
        Qg.prototype.stop = Qg.prototype.stop;
        var Ug = 1;
        function Vg(a, b) {
            var c = Wg();
            this.l = a.maxAttempts == null ? c.maxAttempts : a.maxAttempts;
            this.j = a.baseDelay == null ? c.baseDelay : a.baseDelay;
            this.o = a.fuzzFactor == null ? c.fuzzFactor : a.fuzzFactor;
            this.m = a.backoffFactor == null ? c.backoffFactor : a.backoffFactor;
            this.g = 0;
            this.h = this.j;
            if (this.i = b === void 0 ? !1 : b) this.g = 1;
        }
        function Xg(a) {
            var b, c;
            return H(function(d) {
                if (d.h == 1) {
                    if (a.g >= a.l) {
                        if (a.i) a.g = 1, a.h = a.j;
                        else throw new T(2, 7, 1010);
                    }
                    b = a.g;
                    a.g++;
                    if (b == 0) return d.return();
                    c = a.h * (1 + (Math.random() * 2 - 1) * a.o);
                    return d.g(new Promise(function(e) {
                        new Uf(e).Z(c / 1E3);
                    }), 2);
                }
                a.h *= a.m;
                d.j();
            });
        }
        function Wg() {
            return {
                maxAttempts: 2,
                baseDelay: 1E3,
                backoffFactor: 2,
                fuzzFactor: .5,
                timeout: 3E4,
                stallTimeout: 5E3,
                connectionTimeout: 1E4
            };
        }
        function Yg() {
            var a, b, c = new Promise(function(d, e) {
                a = d;
                b = e;
            });
            c.resolve = a;
            c.reject = b;
            return c;
        }
        Yg.prototype.resolve = function() {};
        Yg.prototype.reject = function() {};
        function Zg(a, b) {
            this.promise = a;
            this.i = b;
            this.g = null;
        }
        function $g(a) {
            return new Zg(Promise.reject(a), function() {
                return Promise.resolve();
            });
        }
        function ah() {
            var a = Promise.reject(new T(2, 7, 7001));
            a.catch(function() {});
            return new Zg(a, function() {
                return Promise.resolve();
            });
        }
        function bh(a) {
            return new Zg(Promise.resolve(a), function() {
                return Promise.resolve();
            });
        }
        function ch(a) {
            return new Zg(a, function() {
                return a.catch(function() {});
            });
        }
        Zg.prototype.abort = function() {
            this.g || (this.g = this.i());
            return this.g;
        };
        function dh(a) {
            return new Zg(Promise.all(a.map(function(b) {
                return b.promise;
            })), function() {
                return Promise.all(a.map(function(b) {
                    return b.abort();
                }));
            });
        }
        Zg.prototype.finally = function(a) {
            this.promise.then(function() {
                return a(!0);
            }, function() {
                return a(!1);
            });
            return this;
        };
        Zg.prototype.eb = function(a, b) {
            function c(h) {
                return function(k) {
                    if (e.g && h) f.reject(g);
                    else {
                        var l = h ? a : b;
                        l ? d = eh(l, k, f) : (h ? f.resolve : f.reject)(k);
                    }
                };
            }
            function d() {
                f.reject(g);
                return e.abort();
            }
            var e = this, f = new Yg;
            f.catch(function() {});
            var g = new T(2, 7, 7001);
            this.promise.then(c(!0), c(!1));
            return new Zg(f, function() {
                return d();
            });
        };
        function eh(a, b, c) {
            try {
                var d = a(b);
                if (d && d.promise && d.abort) return c.resolve(d.promise), function() {
                    return d.abort();
                };
                c.resolve(d);
                return function() {
                    return Promise.resolve(d).then(function() {}, function() {});
                };
            } catch (e) {
                return c.reject(e), function() {
                    return Promise.resolve();
                };
            }
        }
        da.Object.defineProperties(Zg.prototype, {
            aborted: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g !== null;
                }
            }
        });
        O("shaka.util.AbortableOperation", Zg);
        Zg.prototype.chain = Zg.prototype.eb;
        Zg.prototype["finally"] = Zg.prototype.finally;
        Zg.all = dh;
        Zg.prototype.abort = Zg.prototype.abort;
        Zg.notAbortable = ch;
        Zg.completed = bh;
        Zg.aborted = ah;
        Zg.failed = $g;
        function fh() {
            this.g = [];
        }
        function gh(a, b) {
            a.g.push(b.finally(function() {
                ad(a.g, b);
            }));
        }
        fh.prototype.destroy = function() {
            for(var a = [], b = u(this.g), c = b.next(); !c.done; c = b.next())c = c.value, c.promise.catch(function() {}), a.push(c.abort());
            this.g = [];
            return Promise.all(a);
        };
        function hh(a, b, c, d, e, f, g) {
            fb.call(this);
            this.i = null;
            this.j = !1;
            this.A = new fh;
            this.g = new Set;
            this.h = new Set;
            this.o = a || null;
            this.m = b || null;
            this.C = c || null;
            this.D = d || null;
            this.F = e || null;
            this.H = f || null;
            this.G = g || null;
            this.l = new Map;
        }
        oa(hh, fb);
        p = hh.prototype;
        p.configure = function(a) {
            this.i = a;
        };
        function ih(a, b, c, d) {
            d = d === void 0 ? !1 : d;
            c = c || jh;
            var e = kh.get(a);
            (!e || c >= e.priority) && kh.set(a, {
                priority: c,
                Vf: b,
                $l: d
            });
        }
        function lh(a, b) {
            for(var c = u(a.g), d = c.next(); !d.done; d = c.next())b.g.add(d.value);
            a = u(a.h);
            for(c = a.next(); !c.done; c = a.next())b.h.add(c.value);
        }
        p.dm = function(a) {
            this.g.add(a);
        };
        p.Dm = function(a) {
            this.g.delete(a);
        };
        p.wk = function() {
            this.g.clear();
        };
        p.fm = function(a) {
            this.h.add(a);
        };
        p.Em = function(a) {
            this.h.delete(a);
        };
        p.xk = function() {
            this.h.clear();
        };
        p.Ri = function() {
            this.l.clear();
        };
        function mh(a, b, c) {
            return {
                uris: a,
                method: "GET",
                body: null,
                headers: {},
                allowCrossSiteCredentials: !1,
                retryParameters: b,
                licenseRequestType: null,
                sessionId: null,
                drmInfo: null,
                initData: null,
                initDataType: null,
                streamDataCallback: c === void 0 ? null : c
            };
        }
        p.destroy = function() {
            this.j = !0;
            this.g.clear();
            this.h.clear();
            this.l.clear();
            fb.prototype.release.call(this);
            return this.A.destroy();
        };
        p.request = function(a, b, c) {
            var d = this, e = new nh;
            if (this.j) {
                var f = Promise.reject(new T(2, 7, 7001));
                f.catch(function() {});
                return new oh(f, function() {
                    return Promise.resolve();
                }, e);
            }
            b.method = b.method || "GET";
            b.headers = b.headers || {};
            b.retryParameters = b.retryParameters ? Xd(b.retryParameters) : Wg();
            b.uris = Xd(b.uris);
            f = ph(this, a, b, c);
            var g = f.eb(function() {
                return qh(d, a, b, c, new Vg(b.retryParameters, !1), 0, null, e);
            }), h = g.eb(function(q) {
                return rh(d, a, q, c);
            }), k = Date.now(), l = 0;
            f.promise.then(function() {
                l = Date.now() - k;
            }, function() {});
            var m = 0;
            g.promise.then(function() {
                m = Date.now();
            }, function() {});
            var n = h.eb(function(q) {
                var r = Date.now() - m, t = q.response;
                t.timeMs += l;
                t.timeMs += r;
                q.Cl || !d.o || t.fromCache || b.method == "HEAD" || a != sh || d.o(t.timeMs, t.data.byteLength, th(c), b, c);
                d.G && d.G(a, t, c);
                return t;
            }, function(q) {
                q && (q.severity = 2);
                throw q;
            });
            f = new oh(n.promise, function() {
                return n.abort();
            }, e);
            gh(this.A, f);
            return f;
        };
        function ph(a, b, c, d) {
            function e(h) {
                f = f.eb(function() {
                    c.body && (c.body = Gb(c.body));
                    return h(b, c, d);
                });
            }
            var f = bh(void 0);
            a.F && e(a.F);
            a = u(a.g);
            for(var g = a.next(); !g.done; g = a.next())e(g.value);
            return f.eb(void 0, function(h) {
                if (h instanceof T && h.code == 7001) throw h;
                throw new T(2, 1, 1006, h);
            });
        }
        function qh(a, b, c, d, e, f, g, h) {
            a.i.forceHTTP && (c.uris[f] = c.uris[f].replace("https://", "http://"));
            a.i.forceHTTPS && (c.uris[f] = c.uris[f].replace("http://", "https://"));
            f > 0 && a.H && a.H(b, d, c.uris[f], c.uris[f - 1]);
            var k = new lb(c.uris[f]), l = k.lc, m = !1;
            l || (l = location.protocol, l = l.slice(0, -1), mb(k, l), c.uris[f] = k.toString());
            l = l.toLowerCase();
            var n = (l = kh.get(l)) ? l.Vf : null;
            if (!n) return $g(new T(2, 1, 1E3, k));
            var q = l.$l;
            (k = a.l.get(k.Eb)) && (c.headers["common-access-token"] = k);
            var r = null, t = null, v = !1, w = !1, x;
            return ch(Xg(e)).eb(function() {
                if (a.j) return ah();
                x = Date.now();
                var y = 0;
                c.requestStartTime = Date.now();
                var z = n(c.uris[f], c, b, function(C, D, B) {
                    r && r.stop();
                    t && t.Z(E / 1E3);
                    a.o && b == sh && (y++, c.packetNumber = y, a.o(C, D, th(d), c, d), m = !0, h.g = B);
                }, function(C) {
                    w = !0;
                    c.timeToFirstByte = Date.now() - c.requestStartTime;
                    a.m && a.m(C, c, b);
                }, {
                    minBytesForProgressEvents: a.i.minBytesForProgressEvents
                });
                if (!q) return z;
                var A = c.retryParameters.connectionTimeout;
                A && (r = new Uf(function() {
                    v = !0;
                    z.abort();
                }), r.Z(A / 1E3));
                var E = c.retryParameters.stallTimeout;
                E && (t = new Uf(function() {
                    v = !0;
                    z.abort();
                }));
                return z;
            }).eb(function(y) {
                r && r.stop();
                t && t.stop();
                y.timeMs == void 0 && (y.timeMs = Date.now() - x);
                var z = y.headers["common-access-token"];
                if (z) {
                    var A = new lb(y.uri);
                    a.l.set(A.Eb, z);
                }
                z = {
                    response: y,
                    Cl: m
                };
                !w && a.m && a.m(y.headers, c, b);
                a.C && a.C(c, y);
                return z;
            }, function(y) {
                r && r.stop();
                t && t.stop();
                if (a.D) {
                    var z = null, A = 0;
                    y instanceof T && (z = y, y.code == 1001 && (A = y.data[1]));
                    a.D(c, z, A, v);
                }
                if (a.j) return ah();
                v && (y = new T(1, 1, 1003, c.uris[f], b));
                if (y instanceof T) {
                    if (y.code == 7001) throw y;
                    if (y.code == 1010) throw g;
                    if (y.severity == 1) {
                        z = (new Map).set("error", y);
                        z = new R("retry", z);
                        z.cancelable = !0;
                        a.dispatchEvent(z);
                        if (z.defaultPrevented) throw y;
                        f = (f + 1) % c.uris.length;
                        return qh(a, b, c, d, e, f, y, h);
                    }
                }
                throw y;
            });
        }
        function rh(a, b, c, d) {
            var e = bh(void 0);
            a = u(a.h);
            for(var f = a.next(), g = {}; !f.done; g = {
                Ej: void 0
            }, f = a.next())g.Ej = f.value, e = e.eb(function(h) {
                return function() {
                    var k = c.response;
                    k.data && (k.data = Gb(k.data));
                    return (0, h.Ej)(b, k, d);
                };
            }(g));
            return e.eb(function() {
                return c;
            }, function(h) {
                var k = 2;
                if (h instanceof T) {
                    if (h.code == 7001) throw h;
                    k = h.severity;
                }
                throw new T(k, 1, 1007, h);
            });
        }
        function th(a) {
            if (a) {
                var b = a.segment;
                a = a.stream;
                if (b && a && a.fastSwitching && b.hd) return !1;
            }
            return !0;
        }
        O("shaka.net.NetworkingEngine", hh);
        hh.prototype.request = hh.prototype.request;
        hh.prototype.destroy = hh.prototype.destroy;
        hh.makeRequest = mh;
        hh.defaultRetryParameters = function() {
            return Wg();
        };
        hh.prototype.clearCommonAccessTokenMap = hh.prototype.Ri;
        hh.prototype.clearAllResponseFilters = hh.prototype.xk;
        hh.prototype.unregisterResponseFilter = hh.prototype.Em;
        hh.prototype.registerResponseFilter = hh.prototype.fm;
        hh.prototype.clearAllRequestFilters = hh.prototype.wk;
        hh.prototype.unregisterRequestFilter = hh.prototype.Dm;
        hh.prototype.registerRequestFilter = hh.prototype.dm;
        hh.unregisterScheme = function(a) {
            kh.delete(a);
        };
        hh.registerScheme = ih;
        hh.prototype.configure = hh.prototype.configure;
        function nh() {
            this.g = 0;
        }
        hh.NumBytesRemainingClass = nh;
        function oh(a, b, c) {
            Zg.call(this, a, b);
            this.h = c;
        }
        oa(oh, Zg);
        hh.PendingRequest = oh;
        var sh = 1;
        hh.RequestType = {
            MANIFEST: 0,
            SEGMENT: sh,
            LICENSE: 2,
            APP: 3,
            TIMING: 4,
            SERVER_CERTIFICATE: 5,
            KEY: 6,
            ADS: 7,
            CONTENT_STEERING: 8,
            CMCD: 9
        };
        hh.AdvancedRequestType = {
            INIT_SEGMENT: 0,
            MEDIA_SEGMENT: 1,
            MEDIA_PLAYLIST: 2,
            MASTER_PLAYLIST: 3,
            MPD: 4,
            MSS: 5,
            MPD_PATCH: 6,
            MEDIATAILOR_SESSION_INFO: 7,
            MEDIATAILOR_TRACKING_INFO: 8,
            MEDIATAILOR_STATIC_RESOURCE: 9,
            MEDIATAILOR_TRACKING_EVENT: 10,
            INTERSTITIAL_ASSET_LIST: 11,
            INTERSTITIAL_AD_URL: 12
        };
        var jh = 3;
        hh.PluginPriority = {
            FALLBACK: 1,
            PREFERRED: 2,
            APPLICATION: jh
        };
        var kh = new Map;
        function uh(a) {
            this.g = !1;
            this.h = new Yg;
            this.i = a;
        }
        uh.prototype.destroy = function() {
            var a = this;
            if (this.g) return this.h;
            this.g = !0;
            return this.i().then(function() {
                a.h.resolve();
            }, function() {
                a.h.resolve();
            });
        };
        function vh(a, b) {
            if (a.g) {
                if (b instanceof T && b.code == 7003) throw b;
                throw new T(2, 7, 7003, b);
            }
        }
        function wh(a) {
            for(var b = new Map, c = u(Object.keys(a)), d = c.next(); !d.done; d = c.next())d = d.value, b.set(d, a[d]);
            return b;
        }
        function xh(a) {
            var b = {};
            a.forEach(function(c, d) {
                b[d] = c;
            });
            return b;
        }
        function yh(a, b) {
            this.h = Jb(a);
            this.i = b == zh;
            this.g = 0;
        }
        p = yh.prototype;
        p.Sa = function() {
            return this.g < this.h.byteLength;
        };
        p.Xa = function() {
            return this.g;
        };
        p.getLength = function() {
            return this.h.byteLength;
        };
        p.ea = function() {
            try {
                var a = this.h.getUint8(this.g);
                this.g += 1;
                return a;
            } catch (b) {
                throw Ah();
            }
        };
        p.Ka = function() {
            try {
                var a = this.h.getUint16(this.g, this.i);
                this.g += 2;
                return a;
            } catch (b) {
                throw Ah();
            }
        };
        p.Y = function() {
            try {
                var a = this.h.getUint32(this.g, this.i);
                this.g += 4;
                return a;
            } catch (b) {
                throw Ah();
            }
        };
        p.Vh = function() {
            try {
                var a = this.h.getInt32(this.g, this.i);
                this.g += 4;
                return a;
            } catch (b) {
                throw Ah();
            }
        };
        p.Rd = function() {
            try {
                if (this.i) {
                    var a = this.h.getUint32(this.g, !0);
                    var b = this.h.getUint32(this.g + 4, !0);
                } else b = this.h.getUint32(this.g, !1), a = this.h.getUint32(this.g + 4, !1);
            } catch (c) {
                throw Ah();
            }
            if (b > 2097151) throw new T(2, 3, 3001);
            this.g += 8;
            return b * 4294967296 + a;
        };
        p.Wb = function(a, b) {
            if (this.g + a > this.h.byteLength) throw Ah();
            var c = Fb(this.h, this.g, a);
            this.g += a;
            return b ? new Uint8Array(c) : c;
        };
        p.skip = function(a) {
            if (this.g + a > this.h.byteLength) throw Ah();
            this.g += a;
        };
        p.Fj = function(a) {
            if (this.g < a) throw Ah();
            this.g -= a;
        };
        p.seek = function(a) {
            if (a < 0 || a > this.h.byteLength) throw Ah();
            this.g = a;
        };
        p.Qd = function() {
            for(var a = this.g; this.Sa() && this.h.getUint8(this.g) != 0;)this.g += 1;
            a = Fb(this.h, a, this.g - a);
            this.g += 1;
            return bc(a);
        };
        function Ah() {
            return new T(2, 3, 3E3);
        }
        O("shaka.util.DataViewReader", yh);
        yh.prototype.readTerminatedString = yh.prototype.Qd;
        yh.prototype.seek = yh.prototype.seek;
        yh.prototype.rewind = yh.prototype.Fj;
        yh.prototype.skip = yh.prototype.skip;
        yh.prototype.readBytes = yh.prototype.Wb;
        yh.prototype.readUint64 = yh.prototype.Rd;
        yh.prototype.readInt32 = yh.prototype.Vh;
        yh.prototype.readUint32 = yh.prototype.Y;
        yh.prototype.readUint16 = yh.prototype.Ka;
        yh.prototype.readUint8 = yh.prototype.ea;
        yh.prototype.getLength = yh.prototype.getLength;
        yh.prototype.getPosition = yh.prototype.Xa;
        yh.prototype.hasMoreData = yh.prototype.Sa;
        var zh = 1;
        yh.Endianness = {
            BIG_ENDIAN: 0,
            LITTLE_ENDIAN: zh
        };
        function Bh() {
            this.i = new Map;
            this.h = new Map;
            this.g = !1;
        }
        p = Bh.prototype;
        p.box = function(a, b) {
            a = Ch(a);
            this.i.set(a, Dh);
            this.h.set(a, b);
            return this;
        };
        p.boxes = function(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())this.box(c.value, b);
            return this;
        };
        p.qa = function(a, b) {
            a = Ch(a);
            this.i.set(a, Eh);
            this.h.set(a, b);
            return this;
        };
        p.stop = function() {
            this.g = !0;
        };
        p.parse = function(a, b, c) {
            a = new yh(a, 0);
            for(this.g = !1; a.Sa() && !this.g;)this.Nd(0, a, b, c);
        };
        p.Nd = function(a, b, c, d) {
            var e = b.Xa();
            if (d && e + 8 > b.getLength()) this.g = !0;
            else {
                var f = b.Y(), g = b.Y(), h = Fh(g), k = !1;
                switch(f){
                    case 0:
                        f = b.getLength() - e;
                        break;
                    case 1:
                        if (d && b.Xa() + 8 > b.getLength()) {
                            this.g = !0;
                            return;
                        }
                        f = b.Rd();
                        k = !0;
                }
                var l = this.h.get(g);
                if (l) {
                    var m = null, n = null;
                    if (this.i.get(g) == Eh) {
                        if (d && b.Xa() + 4 > b.getLength()) {
                            this.g = !0;
                            return;
                        }
                        n = b.Y();
                        m = n >>> 24;
                        n &= 16777215;
                    }
                    g = e + f;
                    c && g > b.getLength() && (g = b.getLength());
                    d && g > b.getLength() ? this.g = !0 : (g -= b.Xa(), b = g > 0 ? b.Wb(g, !1) : new Uint8Array(0), b = new yh(b, 0), l({
                        name: h,
                        parser: this,
                        partialOkay: c || !1,
                        stopOnPartial: d || !1,
                        version: m,
                        flags: n,
                        reader: b,
                        size: f,
                        start: e + a,
                        has64BitSize: k
                    }));
                } else b.skip(Math.min(e + f - b.Xa(), b.getLength() - b.Xa()));
            }
        };
        function Gh(a) {
            for(var b = Hh(a); a.reader.Sa() && !a.parser.g;)a.parser.Nd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial);
        }
        function Ih(a) {
            for(var b = Hh(a), c = a.reader.Y(), d = 0; d < c && (a.parser.Nd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial), !a.parser.g); d++);
        }
        function Jh(a) {
            var b = Hh(a);
            for(a.reader.skip(78); a.reader.Sa() && !a.parser.g;)a.parser.Nd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial);
        }
        function Kh(a) {
            var b = Hh(a);
            a.reader.skip(8);
            var c = a.reader.Ka();
            a.reader.skip(6);
            c == 2 ? a.reader.skip(48) : a.reader.skip(12);
            for(c == 1 && a.reader.skip(16); a.reader.Sa() && !a.parser.g;)a.parser.Nd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial);
        }
        function Lh(a, b) {
            return function(c) {
                a(c.reader.Wb(c.reader.getLength() - c.reader.Xa(), b));
            };
        }
        function Ch(a) {
            var b = 0;
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())b = b << 8 | c.value.charCodeAt(0);
            return b;
        }
        function Fh(a) {
            return String.fromCharCode(a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, a & 255);
        }
        function Hh(a) {
            return 8 + (a.has64BitSize ? 8 : 0) + (a.flags != null ? 4 : 0);
        }
        O("shaka.util.Mp4Parser", Bh);
        Bh.headerSize = Hh;
        Bh.typeToString = Fh;
        Bh.allData = Lh;
        Bh.audioSampleEntry = Kh;
        Bh.visualSampleEntry = Jh;
        Bh.sampleDescription = Ih;
        Bh.children = Gh;
        Bh.prototype.parseNext = Bh.prototype.Nd;
        Bh.prototype.parse = Bh.prototype.parse;
        Bh.prototype.stop = Bh.prototype.stop;
        Bh.prototype.fullBox = Bh.prototype.qa;
        Bh.prototype.boxes = Bh.prototype.boxes;
        Bh.prototype.box = Bh.prototype.box;
        var Dh = 0, Eh = 1;
        function Mh(a) {
            var b = this;
            this.g = [];
            this.data = [];
            (new Bh).boxes([
                "moov",
                "moof"
            ], Gh).qa("pssh", function(c) {
                if (!(c.version > 1)) {
                    var d = Fb(c.reader.h, -12, c.size);
                    b.data.push(d);
                    c = c.reader.Wb(16, !1);
                    b.g.push(sc(c));
                }
            }).parse(a);
        }
        function Nh(a, b, c, d) {
            var e = a.length, f = 12 + b.length + 4 + e;
            d > 0 && (f += 4 + 16 * c.size);
            var g = new Uint8Array(f), h = Jb(g), k = 0;
            h.setUint32(k, f);
            k += 4;
            h.setUint32(k, 1886614376);
            k += 4;
            d < 1 ? h.setUint32(k, 0) : h.setUint32(k, 16777216);
            k += 4;
            g.set(b, k);
            k += b.length;
            if (d > 0) for(h.setUint32(k, c.size), k += 4, b = u(c), c = b.next(); !c.done; c = b.next())c = rc(c.value), g.set(c, k), k += c.length;
            h.setUint32(k, e);
            g.set(a, k + 4);
            return g;
        }
        function Oh(a) {
            var b = this;
            this.F = a;
            this.l = this.C = null;
            this.W = this.R = !1;
            this.J = 0;
            this.g = null;
            this.o = new fd;
            this.i = new Map;
            this.V = [];
            this.D = new Map;
            this.K = !1;
            this.m = new Yg;
            this.h = null;
            this.A = function(c) {
                c.severity == 2 && b.m.reject(c);
                a.onError(c);
            };
            this.X = new Map;
            this.$ = new Map;
            this.L = new Uf(function() {
                return Ph(b);
            });
            this.P = !1;
            this.M = [];
            this.ba = !1;
            this.G = new Uf(function() {
                Qh(b);
            });
            this.m.catch(function() {});
            this.j = new uh(function() {
                return Rh(b);
            });
            this.O = !1;
            this.H = this.I = null;
            this.S = function() {
                return !1;
            };
        }
        p = Oh.prototype;
        p.destroy = function() {
            return this.j.destroy();
        };
        function Rh(a) {
            var b;
            return H(function(c) {
                switch(c.h){
                    case 1:
                        return a.o.release(), a.o = null, a.m.reject(), a.G.stop(), a.G = null, a.L.stop(), a.L = null, c.g(Sh(a), 2);
                    case 2:
                        if (!a.l) {
                            c.B(3);
                            break;
                        }
                        c.m(4);
                        return c.g(a.l.setMediaKeys(null), 6);
                    case 6:
                        c.o(5);
                        break;
                    case 4:
                        b = c.l(), Za("DrmEngine.destroyNow_ exception", b);
                    case 5:
                        a.l = null;
                    case 3:
                        a.g = null, a.C = null, a.D = new Map, a.h = null, a.A = function() {}, a.F = null, a.O = !1, a.I = null, c.j();
                }
            });
        }
        p.configure = function(a, b) {
            this.h = a;
            b && (this.S = b);
            this.G && this.R && this.g && this.G.xa(this.h.updateExpirationTime);
        };
        function Th(a, b, c) {
            a.W = !0;
            a.D = new Map;
            a.P = c;
            return Uh(a, b, !1);
        }
        function Vh(a, b, c, d) {
            d = d === void 0 ? !0 : d;
            a.D = new Map;
            c = u(c);
            for(var e = c.next(); !e.done; e = c.next())a.D.set(e.value, {
                initData: null,
                initDataType: null
            });
            c = u(a.h.persistentSessionsMetadata);
            for(e = c.next(); !e.done; e = c.next())e = e.value, a.D.set(e.sessionId, {
                initData: e.initData,
                initDataType: e.initDataType
            });
            a.P = a.D.size > 0;
            return Uh(a, b, d);
        }
        function Wh(a, b, c, d, e, f) {
            var g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) return g = [], f.length && g.push(f[0].contentType), e.length && g.push(e[0].contentType), h = function(q) {
                    q = yc(b, q, null);
                    q.licenseServerUri = c;
                    q.serverCertificate = d;
                    q.persistentStateRequired = !0;
                    q.sessionType = "persistent-license";
                    return q;
                }, k = Pg(g), k.video && (l = h(f[0].encryptionScheme || ""), k.video.drmInfos.push(l)), k.audio && (m = h(e[0].encryptionScheme || ""), k.audio.drmInfos.push(m)), n.g(kg([
                    k
                ], !0, a.O, []), 2);
                vh(a.j);
                return n.return(Xh(a, [
                    k
                ]));
            });
        }
        function Uh(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A;
            return H(function(E) {
                if (E.h == 1) {
                    Yh(a.h.clearKeys, b);
                    d = b.some(function(C) {
                        return C.video && C.video.drmInfos.length || C.audio && C.audio.drmInfos.length ? !0 : !1;
                    });
                    e = wh(a.h.servers);
                    f = wh(a.h.advanced || {});
                    !d && c && Zh(b, e);
                    g = new WeakSet;
                    h = u(b);
                    for(k = h.next(); !k.done; k = h.next())for(l = k.value, m = $h(l), n = u(m), q = n.next(); !q.done; q = n.next())r = q.value, g.has(r) || (g.add(r), ai(r, e, f, a.h.keySystemsMapping));
                    t = function(C, D) {
                        var B = [];
                        C = u(C);
                        for(var J = C.next(); !J.done; J = C.next()){
                            J = J.value;
                            var F = J[D] || f.has(J.keySystem) && f.get(J.keySystem)[D] || "";
                            F == "" && Pb(J.keySystem) && (D == "audioRobustness" ? F = [
                                a.h.defaultAudioRobustnessForWidevine
                            ] : D == "videoRobustness" && (F = [
                                a.h.defaultVideoRobustnessForWidevine
                            ]));
                            if (typeof F === "string") B.push(J);
                            else if (Array.isArray(F)) {
                                F.length === 0 && (F = [
                                    ""
                                ]);
                                F = u(F);
                                for(var I = F.next(); !I.done; I = F.next()){
                                    var K = {};
                                    B.push(Object.assign({}, J, (K[D] = I.value, K)));
                                }
                            }
                        }
                        return B;
                    };
                    v = new WeakSet;
                    w = u(b);
                    for(x = w.next(); !x.done; x = w.next())y = x.value, y.video && !v.has(y.video) && (y.video.drmInfos = t(y.video.drmInfos, "videoRobustness"), y.video.drmInfos = t(y.video.drmInfos, "audioRobustness"), v.add(y.video)), y.audio && !v.has(y.audio) && (y.audio.drmInfos = t(y.audio.drmInfos, "videoRobustness"), y.audio.drmInfos = t(y.audio.drmInfos, "audioRobustness"), v.add(y.audio));
                    return E.g(kg(b, a.P, a.O, a.h.preferredKeySystems), 2);
                }
                vh(a.j);
                z = d || e.size > 0;
                if (!z) return a.R = !0, E.return(Promise.resolve());
                A = Xh(a, b);
                return E.return(d ? A : A.catch(function() {}));
            });
        }
        function bi(a) {
            var b;
            return H(function(c) {
                switch(c.h){
                    case 1:
                        if (a.l.mediaKeys) return c.return();
                        if (!a.I) {
                            c.B(2);
                            break;
                        }
                        return c.g(a.I, 3);
                    case 3:
                        return vh(a.j), c.return();
                    case 2:
                        return c.m(4), a.I = a.l.setMediaKeys(a.C), c.g(a.I, 6);
                    case 6:
                        c.o(5);
                        break;
                    case 4:
                        b = c.l(), a.A(new T(2, 6, 6003, b.message));
                    case 5:
                        vh(a.j), c.j();
                }
            });
        }
        function ci(a, b) {
            return H(function(c) {
                if (c.h == 1) return c.g(bi(a), 2);
                di(a, b.initDataType, Fb(b.initData));
                c.j();
            });
        }
        p.Ob = function(a) {
            var b = this, c, d;
            return H(function(e) {
                if (e.h == 1) {
                    if (b.l === a) return e.return();
                    if (!b.C) return b.o.ra(a, "encrypted", function() {
                        b.A(new T(2, 6, 6010));
                    }), e.return();
                    b.l = a;
                    b.h.delayLicenseRequestUntilPlayed && b.o.ra(b.l, "play", function() {
                        for(var f = u(b.M), g = f.next(); !g.done; g = f.next())ei(b, g.value);
                        b.ba = !0;
                        b.M = [];
                    });
                    b.l.remote ? (b.o.u(b.l.remote, "connect", function() {
                        return Sh(b);
                    }), b.o.u(b.l.remote, "connecting", function() {
                        return Sh(b);
                    }), b.o.u(b.l.remote, "disconnect", function() {
                        return Sh(b);
                    })) : "webkitCurrentPlaybackTargetIsWireless" in b.l && b.o.u(b.l, "webkitcurrentplaybacktargetiswirelesschanged", function() {
                        return Sh(b);
                    });
                    b.H = b.g ? b.g.initData.find(function(f) {
                        return f.initData.length > 0;
                    }) || null : null;
                    c = b.g.keySystem;
                    return (d = Xb().Nh(c)) || !b.H && b.g.keySystem === "com.apple.fps" && !b.D.size ? e.B(2) : e.g(bi(b), 2);
                }
                fi(b).catch(function() {});
                !d && (b.H || b.D.size || b.h.parseInbandPsshEnabled) || b.o.u(b.l, "encrypted", function(f) {
                    return ci(b, f);
                });
                e.j();
            });
        };
        function gi(a) {
            var b, c, d, e, f;
            return H(function(g) {
                switch(g.h){
                    case 1:
                        if (!a.C || !a.g) return g.return();
                        if (!a.g.serverCertificateUri || a.g.serverCertificate && a.g.serverCertificate.length) {
                            g.B(2);
                            break;
                        }
                        b = mh([
                            a.g.serverCertificateUri
                        ], a.h.retryParameters);
                        g.m(3);
                        c = a.F.Cc.request(5, b, {
                            isPreload: a.S()
                        });
                        return g.g(c.promise, 5);
                    case 5:
                        d = g.i;
                        a.g.serverCertificate = Fb(d.data);
                        g.o(4);
                        break;
                    case 3:
                        throw e = g.l(), new T(2, 6, 6017, e);
                    case 4:
                        if (a.j.g) return g.return();
                    case 2:
                        if (!a.g.serverCertificate || !a.g.serverCertificate.length) return g.return();
                        g.m(6);
                        return g.g(a.C.setServerCertificate(a.g.serverCertificate), 8);
                    case 8:
                        g.o(0);
                        break;
                    case 6:
                        throw f = g.l(), new T(2, 6, 6004, f.message);
                }
            });
        }
        function hi(a, b) {
            var c, d, e;
            return H(function(f) {
                if (f.h == 1) return f.g(ii(a, b, {
                    initData: null,
                    initDataType: null
                }), 2);
                if (f.h != 3) {
                    c = f.i;
                    if (!c) return f.return();
                    d = [];
                    if (e = a.i.get(c)) e.Lb = new Yg, d.push(e.Lb);
                    d.push(c.remove());
                    return f.g(Promise.all(d), 3);
                }
                a.i.delete(c);
                f.j();
            });
        }
        function fi(a) {
            var b, c, d, e, f;
            return H(function(g) {
                if (g.h == 1) {
                    if (!a.D.size) return g.B(2);
                    a.D.forEach(function(h, k) {
                        ii(a, k, h);
                    });
                    return g.g(a.m, 3);
                }
                if (g.h != 2) {
                    b = a.g && a.g.keyIds || new Set([]);
                    if (b.size > 0 && ji(a)) return g.return(a.m);
                    a.K = !1;
                    a.m = new Yg;
                    a.m.catch(function() {});
                }
                c = (a.g ? a.g.initData : []) || [];
                d = u(c);
                for(e = d.next(); !e.done; e = d.next())f = e.value, di(a, f.initDataType, f.initData);
                ki(a) && a.m.resolve();
                return g.return(a.m);
            });
        }
        function di(a, b, c) {
            if (c.length) {
                try {
                    c = a.h.initDataTransform(c, b, a.g);
                } catch (g) {
                    b = g;
                    g instanceof T || (b = new T(2, 6, 6016, g));
                    a.A(b);
                    return;
                }
                if (a.h.ignoreDuplicateInitData) {
                    var d = a.i.values();
                    d = u(d);
                    for(var e = d.next(); !e.done; e = d.next())if (Eb(c, e.value.initData)) return;
                    var f = !1;
                    a.D.forEach(function(g) {
                        !f && Eb(c, g.initData) && (f = !0);
                    });
                    if (f) return;
                }
                a.K = !0;
                a.i.size > 0 && ki(a) && (a.m.resolve(), a.K = !1, a.m = new Yg, a.m.catch(function() {}));
                li(a, b, c, a.g.sessionType);
            }
        }
        function pi(a) {
            a = a.i.keys();
            a = gb(a, function(b) {
                return b.sessionId;
            });
            return Array.from(a);
        }
        p.oh = function() {
            var a = this, b = this.i.keys();
            b = gb(b, function(c) {
                var d = a.i.get(c);
                return {
                    sessionId: c.sessionId,
                    sessionType: d.type,
                    initData: d.initData,
                    initDataType: d.initDataType
                };
            });
            return Array.from(b);
        };
        p.oe = function() {
            var a = Infinity, b = this.i.keys();
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next())c = c.value, isNaN(c.expiration) || (a = Math.min(a, c.expiration));
            return a;
        };
        function qi(a) {
            return a.J ? a.J : NaN;
        }
        p.uf = function() {
            return xh(this.$);
        };
        function Xh(a, b) {
            var c, d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        c = new Map;
                        d = ri(a, b, c);
                        if (!d) {
                            if (!navigator.requestMediaKeySystemAccess) throw new T(2, 6, 6020);
                            throw new T(2, 6, 6001);
                        }
                        vh(a.j);
                        l.m(2);
                        d.getConfiguration();
                        e = a.h.keySystemsMapping[d.keySystem] || d.keySystem;
                        a.g = si(a, e, c.get(e));
                        if (!a.g.licenseServerUri) throw new T(2, 6, 6012, a.g.keySystem);
                        return l.g(d.createMediaKeys(), 4);
                    case 4:
                        f = l.i;
                        vh(a.j);
                        a.C = f;
                        if (!(a.h.minHdcpVersion != "" && "getStatusForPolicy" in a.C)) {
                            l.B(5);
                            break;
                        }
                        l.m(6);
                        return l.g(a.C.getStatusForPolicy({
                            minHdcpVersion: a.h.minHdcpVersion
                        }), 8);
                    case 8:
                        g = l.i;
                        if (g != "usable") throw new T(2, 6, 6018);
                        vh(a.j);
                        l.o(5, 2);
                        break;
                    case 6:
                        h = l.l(2);
                        if (h instanceof T) throw h;
                        throw new T(2, 6, 6019, h.message);
                    case 5:
                        return a.R = !0, a.G.xa(a.h.updateExpirationTime), l.g(gi(a), 9);
                    case 9:
                        vh(a.j);
                        l.o(0);
                        break;
                    case 2:
                        k = l.l();
                        vh(a.j, k);
                        a.g = null;
                        if (k instanceof T) throw k;
                        throw new T(2, 6, 6002, k.message);
                }
            });
        }
        function ri(a, b, c) {
            for(var d = u(b), e = d.next(); !e.done; e = d.next()){
                e = u($h(e.value));
                for(var f = e.next(); !f.done; f = e.next())f = f.value, c.has(f.keySystem) || c.set(f.keySystem, []), c.get(f.keySystem).push(f);
            }
            if (c.size == 1 && c.has("")) throw new T(2, 6, 6E3);
            d = a.h.preferredKeySystems;
            d.length || (e = wh(a.h.servers), e.size == 1 && (d = Array.from(e.keys())));
            e = u(d);
            var g = e.next();
            for(f = {}; !g.done; f = {
                zj: void 0
            }, g = e.next()){
                f.zj = g.value;
                g = u(b);
                for(var h = g.next(); !h.done; h = g.next())if (h = h.value.decodingInfos.find(function(n) {
                    return function(q) {
                        return q.supported && q.keySystemAccess != null && q.keySystemAccess.keySystem == n.zj;
                    };
                }(f))) return h.keySystemAccess;
            }
            e = u([
                !0,
                !1
            ]);
            for(f = e.next(); !f.done; f = e.next())for(f = f.value, g = u(b), h = g.next(); !h.done; h = g.next()){
                h = u(h.value.decodingInfos);
                for(var k = h.next(); !k.done; k = h.next())if (k = k.value, k.supported && k.keySystemAccess) {
                    var l = k.keySystemAccess.keySystem;
                    if (!d.includes(l)) {
                        var m = c.get(l);
                        !m && a.h.keySystemsMapping[l] && (m = c.get(a.h.keySystemsMapping[l]));
                        l = u(m);
                        for(m = l.next(); !m.done; m = l.next())if (!!m.value.licenseServerUri == f) return k.keySystemAccess;
                    }
                }
            }
            return null;
        }
        function ti(a) {
            ki(a) && a.m.resolve();
        }
        function ui(a, b) {
            new Uf(function() {
                b.loaded = !0;
                ti(a);
            }).Z(vi);
        }
        function ii(a, b, c) {
            var d, e, f, g, h, k, l;
            return H(function(m) {
                switch(m.h){
                    case 1:
                        try {
                            d = a.C.createSession("persistent-license");
                        } catch (n) {
                            return e = new T(2, 6, 6005, n.message), a.A(e), m.return(Promise.reject(e));
                        }
                        a.o.u(d, "message", function(n) {
                            wi(a) ? a.M.push(n) : ei(a, n);
                        });
                        a.o.u(d, "keystatuseschange", function(n) {
                            return xi(a, n);
                        });
                        f = {
                            initData: c.initData,
                            initDataType: c.initDataType,
                            loaded: !1,
                            Qh: Infinity,
                            Lb: null,
                            type: "persistent-license"
                        };
                        a.i.set(d, f);
                        m.m(2);
                        return m.g(d.load(b), 4);
                    case 4:
                        return g = m.i, vh(a.j), g || (a.i.delete(d), h = a.h.persistentSessionOnlinePlayback ? 1 : 2, a.A(new T(h, 6, 6013)), f.loaded = !0), ui(a, f), ti(a), m.return(d);
                    case 2:
                        k = m.l(), vh(a.j, k), a.i.delete(d), l = a.h.persistentSessionOnlinePlayback ? 1 : 2, a.A(new T(l, 6, 6005, k.message)), f.loaded = !0, ti(a);
                    case 3:
                        return m.return(Promise.resolve());
                }
            });
        }
        function li(a, b, c, d) {
            try {
                var e = a.C.createSession(d);
            } catch (f) {
                a.A(new T(2, 6, 6005, f.message));
                return;
            }
            a.o.u(e, "message", function(f) {
                wi(a) ? a.M.push(f) : ei(a, f);
            });
            a.o.u(e, "keystatuseschange", function(f) {
                return xi(a, f);
            });
            a.i.set(e, {
                initData: c,
                initDataType: b,
                loaded: !1,
                Qh: Infinity,
                Lb: null,
                type: d
            });
            a.h.logLicenseExchange && mc(c);
            e.generateRequest(b, c).catch(function(f) {
                if (!a.j.g) {
                    a.i.delete(e);
                    var g = f.errorCode;
                    if (g && g.systemCode) {
                        var h = g.systemCode;
                        h < 0 && (h += 4294967296);
                        h = "0x" + h.toString(16);
                    }
                    a.A(new T(2, 6, 6006, f.message, f, h));
                }
            });
        }
        function wi(a) {
            return a.l ? a.h.delayLicenseRequestUntilPlayed && a.l.paused && !a.ba : !a.W && a.h.delayLicenseRequestUntilPlayed;
        }
        function yi(a) {
            return H(function(b) {
                return b.h == 1 ? !a.K || wi(a) ? b.B(0) : b.g(a.m, 3) : b.g(Promise.all(a.V.map(function(c) {
                    return c.promise;
                })), 0);
            });
        }
        function ei(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x;
            H(function(y) {
                switch(y.h){
                    case 1:
                        c = b.target;
                        a.h.logLicenseExchange && mc(b.message);
                        d = a.i.get(c);
                        e = a.g.licenseServerUri;
                        f = a.h.advanced[a.g.keySystem];
                        b.messageType == "individualization-request" && f && f.individualizationServer && (e = f.individualizationServer);
                        g = mh([
                            e
                        ], a.h.retryParameters);
                        g.body = b.message;
                        g.method = "POST";
                        g.licenseRequestType = b.messageType;
                        g.sessionId = c.sessionId;
                        g.drmInfo = a.g;
                        d && (g.initData = d.initData, g.initDataType = d.initDataType);
                        if (f && f.headers) for(h in f.headers)g.headers[h] = f.headers[h];
                        if (Ob(a.g.keySystem)) {
                            var z = g, A = a.g;
                            try {
                                var E = ec(z.body);
                                if (E) {
                                    var C = JSON.parse(E);
                                    C.type || (C.type = A.sessionType, z.body = hc(JSON.stringify(C)));
                                }
                            } catch (D) {}
                        }
                        if (Qb(a.g.keySystem)) {
                            if (z = cc(g.body, !0, !0), z.includes("PlayReadyKeyMessage")) {
                                z = ae(z, "PlayReadyKeyMessage");
                                A = me(z, "HttpHeader");
                                A = u(A);
                                for(E = A.next(); !E.done; E = A.next())C = E.value, E = me(C, "name")[0], C = me(C, "value")[0], g.headers[ke(E)] = ke(C);
                                z = me(z, "Challenge")[0];
                                g.body = qc(ke(z));
                            } else g.headers["Content-Type"] = "text/xml; charset=utf-8";
                        }
                        k = Date.now();
                        y.m(2);
                        m = a.F.Cc.request(2, g, {
                            isPreload: a.S()
                        });
                        a.V.push(m);
                        return y.g(m.promise, 4);
                    case 4:
                        l = y.i;
                        ad(a.V, m);
                        y.o(3);
                        break;
                    case 2:
                        n = y.l();
                        if (a.j.g) return y.return();
                        q = {
                            sessionId: c.sessionId,
                            sessionType: d.type,
                            initData: d.initData,
                            initDataType: d.initDataType
                        };
                        r = new T(2, 6, 6007, n, q);
                        a.i.size == 1 ? (a.A(r), d && d.Lb && d.Lb.reject(r)) : (d && d.Lb && d.Lb.reject(r), a.i.delete(c), ki(a) && (a.m.resolve(), a.L.Z(.1)));
                        return y.return();
                    case 3:
                        if (a.j.g) return y.return();
                        a.J += (Date.now() - k) / 1E3;
                        a.h.logLicenseExchange && mc(l.data);
                        y.m(5);
                        return y.g(c.update(l.data), 7);
                    case 7:
                        y.o(6);
                        break;
                    case 5:
                        return v = (t = y.l()) && t.message || String(t), w = new T(2, 6, 6008, v), a.A(w), d && d.Lb && d.Lb.reject(w), y.return();
                    case 6:
                        if (a.j.g) return y.return();
                        x = new R("drmsessionupdate");
                        a.F.onEvent(x);
                        d && (d.Lb && d.Lb.resolve(), ui(a, d));
                        y.j();
                }
            });
        }
        function xi(a, b) {
            b = b.target;
            var c = a.i.get(b), d = !1;
            b.keyStatuses.forEach(function(f, g) {
                if (typeof g == "string") {
                    var h = g;
                    g = f;
                    f = h;
                }
                h = Xb();
                if (Qb(a.g.keySystem) && g.byteLength == 16 && h.cg()) {
                    h = Jb(g);
                    var k = h.getUint32(0, !0), l = h.getUint16(4, !0), m = h.getUint16(6, !0);
                    h.setUint32(0, k, !1);
                    h.setUint16(4, l, !1);
                    h.setUint16(6, m, !1);
                }
                f != "status-pending" && (c.loaded = !0);
                f == "expired" && (d = !0);
                g = sc(g).slice(0, 32);
                a.X.set(g, f);
            });
            var e = b.expiration - Date.now();
            (e < 0 || d && e < 1E3) && c && !c.Lb && (a.i.delete(b), zi(b));
            ki(a) && (a.m.resolve(), a.L.Z(Ai));
        }
        function Ph(a) {
            var b = a.X, c = a.$;
            c.clear();
            b.forEach(function(d, e) {
                return c.set(e, d);
            });
            b = Array.from(c.values());
            b.length && b.every(function(d) {
                return d == "expired";
            }) && a.A(new T(2, 6, 6014));
            a.F.Uf(xh(c));
        }
        function Ei() {
            var a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K;
            return H(function(N) {
                if (N.h == 1) {
                    a = "org.w3.clearkey com.widevine.alpha com.widevine.alpha.experiment com.microsoft.playready com.microsoft.playready.hardware com.microsoft.playready.recommendation com.microsoft.playready.recommendation.3000 com.microsoft.playready.recommendation.3000.clearlead com.chromecast.playready com.apple.fps.1_0 com.apple.fps com.huawei.wiseplay".split(" ");
                    if (!(window1.MediaKeys && window1.navigator && window1.navigator.requestMediaKeySystemAccess && window1.MediaKeySystemAccess && window1.MediaKeySystemAccess.prototype.getConfiguration)) {
                        b = {};
                        c = u(a);
                        for(d = c.next(); !d.done; d = c.next())e = d.value, b[e] = null;
                        return N.return(b);
                    }
                    f = "1.0 1.1 1.2 1.3 1.4 2.0 2.1 2.2 2.3".split(" ");
                    g = [
                        "SW_SECURE_CRYPTO",
                        "SW_SECURE_DECODE",
                        "HW_SECURE_CRYPTO",
                        "HW_SECURE_DECODE",
                        "HW_SECURE_ALL"
                    ];
                    h = [
                        "150",
                        "2000",
                        "3000"
                    ];
                    k = {
                        "com.widevine.alpha": g,
                        "com.widevine.alpha.experiment": g,
                        "com.microsoft.playready.recommendation": h
                    };
                    l = [
                        {
                            contentType: 'video/mp4; codecs="avc1.42E01E"'
                        },
                        {
                            contentType: 'video/webm; codecs="vp8"'
                        }
                    ];
                    m = [
                        {
                            contentType: 'audio/mp4; codecs="mp4a.40.2"'
                        },
                        {
                            contentType: 'audio/webm; codecs="opus"'
                        }
                    ];
                    n = {
                        videoCapabilities: l,
                        audioCapabilities: m,
                        initDataTypes: [
                            "cenc",
                            "sinf",
                            "skd",
                            "keyids"
                        ]
                    };
                    q = [
                        null,
                        "cenc",
                        "cbcs"
                    ];
                    r = new Map;
                    t = Xb();
                    v = function(P, M, L) {
                        var Q, S, Z, pa, va, Ca, ua, xa, Da, Ka, wa, Ja, Aa;
                        return H(function(Ga) {
                            switch(Ga.h){
                                case 1:
                                    return Ga.m(2), Ga.g(M.createMediaKeys(), 5);
                                case 5:
                                    Q = Ga.i;
                                case 4:
                                    Ga.o(3);
                                    break;
                                case 2:
                                    return Ga.l(), Ga.return();
                                case 3:
                                    Z = (S = M.getConfiguration().sessionTypes) ? S.includes("persistent-license") : !1;
                                    t.sj() && (Z = !1);
                                    pa = M.getConfiguration().videoCapabilities;
                                    va = M.getConfiguration().audioCapabilities;
                                    Ca = {
                                        persistentState: Z,
                                        encryptionSchemes: [],
                                        videoRobustnessLevels: [],
                                        audioRobustnessLevels: [],
                                        minHdcpVersions: []
                                    };
                                    r.get(P) ? Ca = r.get(P) : r.set(P, Ca);
                                    (ua = pa[0].encryptionScheme) && !Ca.encryptionSchemes.includes(ua) && Ca.encryptionSchemes.push(ua);
                                    (xa = pa[0].robustness) && !Ca.videoRobustnessLevels.includes(xa) && Ca.videoRobustnessLevels.push(xa);
                                    (Da = va[0].robustness) && !Ca.audioRobustnessLevels.includes(Da) && Ca.audioRobustnessLevels.push(Da);
                                    if (!(L && "getStatusForPolicy" in Q)) {
                                        Ga.B(0);
                                        break;
                                    }
                                    Ka = u(f);
                                    wa = Ka.next();
                                case 7:
                                    if (wa.done) {
                                        Ga.B(0);
                                        break;
                                    }
                                    Ja = wa.value;
                                    if (Ca.minHdcpVersions.includes(Ja)) {
                                        Ga.B(8);
                                        break;
                                    }
                                    return Ga.g(Q.getStatusForPolicy({
                                        minHdcpVersion: Ja
                                    }), 10);
                                case 10:
                                    if (Aa = Ga.i, Aa == "usable") Ca.minHdcpVersions.includes(Ja) || Ca.minHdcpVersions.push(Ja);
                                    else {
                                        Ga.B(0);
                                        break;
                                    }
                                case 8:
                                    wa = Ka.next(), Ga.B(7);
                            }
                        });
                    };
                    w = function(P, M, L, Q, S) {
                        S = S === void 0 ? !1 : S;
                        var Z, pa, va, Ca, ua, xa, Da, Ka, wa, Ja, Aa;
                        return H(function(Ga) {
                            switch(Ga.h){
                                case 1:
                                    Ga.m(2);
                                    Z = Xd(n);
                                    pa = u(Z.videoCapabilities);
                                    for(va = pa.next(); !va.done; va = pa.next())Ca = va.value, Ca.encryptionScheme = M, Ca.robustness = L;
                                    ua = u(Z.audioCapabilities);
                                    for(xa = ua.next(); !xa.done; xa = ua.next())Da = xa.value, Da.encryptionScheme = M, Da.robustness = Q;
                                    Ka = Xd(Z);
                                    Ka.persistentState = "required";
                                    Ka.sessionTypes = [
                                        "persistent-license"
                                    ];
                                    wa = [
                                        Ka,
                                        Z
                                    ];
                                    Aa = Xb();
                                    return Aa.Pa() == "MOBILE" ? Ga.g($f(5, navigator.requestMediaKeySystemAccess(P, wa)), 7) : Ga.g(navigator.requestMediaKeySystemAccess(P, wa), 6);
                                case 6:
                                    Ja = Ga.i;
                                    Ga.B(5);
                                    break;
                                case 7:
                                    Ja = Ga.i;
                                case 5:
                                    return Ga.g(v(P, Ja, S), 8);
                                case 8:
                                    Ga.o(0);
                                    break;
                                case 2:
                                    Ga.l(), Ga.j();
                            }
                        });
                    };
                    x = function(P) {
                        return Xb().Ma() === "WEBKIT" && Ob(P) ? !1 : !0;
                    };
                    y = [];
                    z = u(a);
                    for(A = z.next(); !A.done; A = z.next())if (E = A.value, r.set(E, null), x(E)) {
                        C = !0;
                        D = u(q);
                        for(B = D.next(); !B.done; B = D.next())J = B.value, y.push(w(E, J, "", "", C)), C = !1;
                        F = u(k[E] || []);
                        for(I = F.next(); !I.done; I = F.next())K = I.value, y.push(w(E, null, K, "")), y.push(w(E, null, "", K));
                    }
                    return N.g(Promise.all(y), 2);
                }
                return N.return(xh(r));
            });
        }
        function zi(a) {
            return H(function(b) {
                if (b.h == 1) return b.m(2), b.g($f(Fi, Promise.all([
                    a.close().catch(function() {}),
                    a.closed
                ])), 4);
                if (b.h != 2) return b.o(0);
                b.l();
                b.j();
            });
        }
        function Sh(a) {
            var b;
            return H(function(c) {
                b = Array.from(a.i.entries());
                a.i.clear();
                return c.g(Promise.all(b.map(function(d) {
                    d = u(d);
                    var e = d.next().value;
                    var f = d.next().value;
                    return H(function(g) {
                        if (g.h == 1) return g.m(2), a.W || a.D.has(e.sessionId) || f.type !== "persistent-license" || a.h.persistentSessionOnlinePlayback ? g.g(zi(e), 5) : g.g(e.remove(), 5);
                        if (g.h != 2) return g.o(0);
                        g.l();
                        g.j();
                    });
                })), 0);
            });
        }
        function $h(a) {
            return (a.video ? a.video.drmInfos : []).concat(a.audio ? a.audio.drmInfos : []);
        }
        function Qh(a) {
            a.i.forEach(function(b, c) {
                var d = b.Qh, e = c.expiration;
                isNaN(e) && (e = Infinity);
                e != d && (a.F.onExpirationUpdated(c.sessionId, e), b.Qh = e);
            });
        }
        function ki(a) {
            a = a.i.values();
            return hb(a, function(b) {
                return b.loaded;
            });
        }
        function ji(a) {
            for(var b = u(a.g && a.g.keyIds || new Set([])), c = b.next(); !c.done; c = b.next())if (a.X.get(c.value) !== "usable") return !1;
            return !0;
        }
        function Zh(a, b) {
            var c = [];
            b.forEach(function(d, e) {
                c.push({
                    keySystem: e,
                    licenseServerUri: d,
                    distinctiveIdentifierRequired: !1,
                    persistentStateRequired: !1,
                    audioRobustness: "",
                    videoRobustness: "",
                    serverCertificate: null,
                    serverCertificateUri: "",
                    initData: [],
                    keyIds: new Set
                });
            });
            a = u(a);
            for(b = a.next(); !b.done; b = a.next())b = b.value, b.video && (b.video.drmInfos = c), b.audio && (b.audio.drmInfos = c);
        }
        function si(a, b, c) {
            var d = [], e = [], f = [], g = [], h = [], k = new Set, l = new Set;
            Gi(c, d, e, g, f, h, k, l);
            a = a.P ? "persistent-license" : "temporary";
            b = {
                keySystem: b,
                encryptionScheme: d[0],
                licenseServerUri: e[0],
                distinctiveIdentifierRequired: c[0].distinctiveIdentifierRequired,
                persistentStateRequired: c[0].persistentStateRequired,
                sessionType: c[0].sessionType || a,
                audioRobustness: c[0].audioRobustness || "",
                videoRobustness: c[0].videoRobustness || "",
                serverCertificate: g[0],
                serverCertificateUri: f[0],
                initData: h,
                keyIds: k,
                mediaTypes: c[0].mediaTypes
            };
            l.size > 0 && (b.keySystemUris = l);
            c = u(c);
            for(l = c.next(); !l.done; l = c.next())l = l.value, l.distinctiveIdentifierRequired && (b.distinctiveIdentifierRequired = l.distinctiveIdentifierRequired), l.persistentStateRequired && (b.persistentStateRequired = l.persistentStateRequired);
            return b;
        }
        function Gi(a, b, c, d, e, f, g, h) {
            var k = [];
            a = u(a);
            for(var l = a.next(), m = {}; !l.done; m = {
                Ua: void 0
            }, l = a.next()){
                m.Ua = l.value;
                b.includes(m.Ua.encryptionScheme) || b.push(m.Ua.encryptionScheme);
                Ob(m.Ua.keySystem) && m.Ua.licenseServerUri.startsWith("data:application/json;base64,") ? k.includes(m.Ua.licenseServerUri) || k.push(m.Ua.licenseServerUri) : c.includes(m.Ua.licenseServerUri) || c.push(m.Ua.licenseServerUri);
                e.includes(m.Ua.serverCertificateUri) || e.push(m.Ua.serverCertificateUri);
                m.Ua.serverCertificate && (d.some(function(r) {
                    return function(t) {
                        return Eb(t, r.Ua.serverCertificate);
                    };
                }(m)) || d.push(m.Ua.serverCertificate));
                if (m.Ua.initData) {
                    l = u(m.Ua.initData);
                    for(var n = l.next(), q = {}; !n.done; q = {
                        Eh: void 0
                    }, n = l.next())q.Eh = n.value, f.some(function(r) {
                        return function(t) {
                            var v = r.Eh;
                            return t.keyId && t.keyId == v.keyId ? !0 : t.initDataType == v.initDataType && Eb(t.initData, v.initData);
                        };
                    }(q)) || f.push(q.Eh);
                }
                if (m.Ua.keyIds) for(l = u(m.Ua.keyIds), n = l.next(); !n.done; n = l.next())g.add(n.value);
                if (m.Ua.keySystemUris && h) for(m = u(m.Ua.keySystemUris), l = m.next(); !l.done; l = m.next())h.add(l.value);
            }
            if (k.length == 1) c.push(k[0]);
            else if (k.length > 0) {
                b = [];
                k = u(k);
                for(d = k.next(); !d.done; d = k.next())d = window1.atob(d.value.split("data:application/json;base64,").pop()), d = JSON.parse(d), b.push.apply(b, G(d.keys));
                k = JSON.stringify({
                    keys: b
                });
                c.push("data:application/json;base64," + window1.btoa(k));
            }
        }
        function ai(a, b, c, d) {
            var e = a.keySystem;
            if (e && (!Ob(e) || !a.licenseServerUri)) {
                b.size && b.get(e) && (b = b.get(e), a.licenseServerUri = b);
                a.keyIds || (a.keyIds = new Set);
                if (c = c.get(e)) a.distinctiveIdentifierRequired || (a.distinctiveIdentifierRequired = c.distinctiveIdentifierRequired), a.persistentStateRequired || (a.persistentStateRequired = c.persistentStateRequired), a.serverCertificate || (a.serverCertificate = c.serverCertificate), c.sessionType && (a.sessionType = c.sessionType), a.serverCertificateUri || (a.serverCertificateUri = c.serverCertificateUri);
                d[e] && (a.keySystem = d[e]);
                window1.cast && window1.cast.__platform__ && e == "com.microsoft.playready" && (a.keySystem = "com.chromecast.playready");
            }
        }
        function Yh(a, b) {
            a = wh(a);
            if (a.size != 0) {
                a = zc(a);
                b = u(b);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, c.video && (c.video.drmInfos = [
                    a
                ]), c.audio && (c.audio.drmInfos = [
                    a
                ]);
            }
        }
        var Fi = 1, vi = 5, Ai = .5;
        function Hi() {
            this.g = Ii;
            this.j = (new Map).set(Ii, 2).set(Ji, 1);
            this.i = 0;
            this.h = -1;
        }
        function Ki(a, b) {
            var c = a.g !== b;
            a.g = b;
            c && b === Ii && (a.i = Date.now());
            return c;
        }
        var Ji = 0, Ii = 1;
        function Li(a, b, c) {
            this.h = a;
            this.i = b;
            this.g = c;
        }
        function Mi(a, b) {
            return H(function(c) {
                if (c.h == 1) return c.g(fg(a.g, b, a.h.drm.preferredKeySystems, a.h.drm.keySystemsMapping), 2);
                a.h.streaming.dontChooseCodecs || bg(b, a.h.preferredVideoCodecs, a.h.preferredAudioCodecs, a.h.preferredDecodingAttributes, a.h.preferredTextFormats);
                if (!b.variants.some(Eg)) throw new T(2, 4, 4032);
                return c.return(Ni(a, b));
            });
        }
        function Oi(a, b) {
            var c = a.h.restrictions;
            a = a.i;
            var d = !1;
            b = u(b.variants);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = e.allowedByApplication;
                e.allowedByApplication = eg(e, c, a);
                f != e.allowedByApplication && (d = !0);
            }
            return d;
        }
        function Ni(a, b) {
            var c = Oi(a, b);
            if (b) {
                var d = a.g ? a.g.g : null;
                if (d && a.g.C) {
                    for(var e = new Set, f = u(b.variants), g = f.next(); !g.done; g = f.next())g = g.value, g.audio && e.add(g.audio), g.video && e.add(g.video);
                    e = u(e);
                    for(f = e.next(); !f.done; f = e.next())Pi(a, d.keySystem, f.value);
                }
                Qi(a, b);
            }
            return c;
        }
        function Pi(a, b, c) {
            c = u(c.drmInfos);
            for(var d = c.next(); !d.done; d = c.next())if (d = d.value, d.keySystem == b) {
                for(var e = u(d.initData || []), f = e.next(); !f.done; f = e.next())f = f.value, di(a.g, f.initDataType, f.initData);
                e = a.g;
                e.g && (e.g.mediaTypes !== d.mediaTypes && (e.g.mediaTypes = d.mediaTypes), Mb(d) && (e.g = si(e, e.g.keySystem, [
                    e.g,
                    d
                ])));
            }
        }
        function Qi(a, b) {
            function c(l) {
                if (l && !h.has(l) && (h.add(l), l.keyIds.size)) {
                    l = u(l.keyIds);
                    for(var m = l.next(); !m.done; m = l.next()){
                        m = m.value;
                        var n = d[e ? "00" : m];
                        n ? Ri.includes(n) && g.add(n) : f.add(m);
                    }
                }
            }
            var d = a.g ? a.g.uf() : {};
            a = Object.keys(d);
            var e = a.length && a[0] == "00";
            a = !1;
            var f = new Set, g = new Set, h = new WeakSet;
            b = u(b.variants);
            for(var k = b.next(); !k.done; k = b.next()){
                k = k.value;
                if (!k.allowedByApplication) a = !0;
                else if (k.allowedByKeySystem) return;
                c(k.audio);
                c(k.video);
            }
            a = {
                hasAppRestrictions: a,
                missingKeys: Array.from(f),
                restrictedKeyStatuses: Array.from(g)
            };
            throw new T(2, 4, 4012, a);
        }
        var Ri = [
            "output-restricted",
            "internal-error"
        ];
        O("shaka.config.CodecSwitchingStrategy", {
            RELOAD: "reload",
            SMOOTH: "smooth"
        });
        function Si(a) {
            if (Ti.has(a)) return Ti.get(a);
            var b = window1.ManagedMediaSource || window1.MediaSource;
            return b ? (b = b.isTypeSupported(a), Ti.set(a, b), b) : !1;
        }
        function Ui() {
            var a = window1.ManagedMediaSource || window1.MediaSource;
            return a && a.prototype ? !!a.prototype.setLiveSeekableRange && !!a.prototype.clearLiveSeekableRange : !1;
        }
        var Ti = new Map;
        function Vi(a, b) {
            var c = null, d = null, e = null, f = null, g = a.Y();
            b & 1 && (e = a.Rd());
            b & 2 && (f = a.Y());
            b & 8 && (c = a.Y());
            b & 16 && (d = a.Y());
            return {
                trackId: g,
                ke: c,
                le: d,
                tk: e,
                Gj: f
            };
        }
        function Wi(a, b) {
            return b == 1 ? (b = a.Y(), a = a.Y(), {
                baseMediaDecodeTime: b * 4294967296 + a
            }) : {
                baseMediaDecodeTime: a.Y()
            };
        }
        function Xi(a, b) {
            b == 1 ? (a.skip(8), a.skip(8)) : (a.skip(4), a.skip(4));
            b = a.Y();
            a.skip(4);
            a = a.Ka();
            return {
                timescale: b,
                language: String.fromCharCode((a >> 10) + 96) + String.fromCharCode(((a & 960) >> 5) + 96) + String.fromCharCode((a & 31) + 96)
            };
        }
        function Yi(a, b, c) {
            var d = a.Y(), e = [], f = null;
            c & 1 && (f = a.Vh());
            c & 4 && a.skip(4);
            for(var g = 0; g < d; g++){
                var h = {
                    di: null,
                    sampleSize: null,
                    dg: null
                };
                c & 256 && (h.di = a.Y());
                c & 512 && (h.sampleSize = a.Y());
                c & 1024 && a.skip(4);
                c & 2048 && (h.dg = b == 0 ? a.Y() : a.Vh());
                e.push(h);
            }
            return {
                Wn: d,
                ci: e,
                Ug: f
            };
        }
        function Zi(a) {
            a.skip(6);
            a.skip(2);
            a.skip(8);
            var b = a.Ka();
            a.skip(2);
            a.skip(2);
            a.skip(2);
            a = a.Ka() + a.Ka() / 65536;
            return {
                channelCount: b,
                sampleRate: a
            };
        }
        function $i(a) {
            a = a.Y();
            return {
                codec: Fh(a)
            };
        }
        function aj(a) {
            var b = null, c = null, d = a.Wb(4, !1);
            var e = String.fromCharCode(d[0]);
            e += String.fromCharCode(d[1]);
            e += String.fromCharCode(d[2]);
            e += String.fromCharCode(d[3]);
            if (e === "nclx") {
                switch(a.Ka()){
                    case 1:
                    case 5:
                    case 6:
                    case 7:
                        b = "srgb";
                        break;
                    case 9:
                        b = "rec2020";
                        break;
                    case 11:
                    case 12:
                        b = "p3";
                }
                d = a.Ka();
                a.Ka();
                switch(d){
                    case 1:
                    case 6:
                    case 13:
                    case 14:
                    case 15:
                        c = "SDR";
                        break;
                    case 16:
                        c = "PQ";
                        break;
                    case 18:
                        c = "HLG";
                }
            }
            return {
                colorGamut: b,
                Me: c
            };
        }
        function bj(a, b) {
            b = b === void 0 ? !1 : b;
            a = a.toString(16).toUpperCase();
            return b ? a : ("0" + a).slice(-2);
        }
        function cj(a) {
            return (a < 10 ? "0" : "") + a;
        }
        function dj(a) {
            this.g = a = a === void 0 ? [] : a;
        }
        function ej(a) {
            if (a.g.length === 0) throw Error("StreamInfos must have elements");
            for(var b = [], c = u(a.g), d = c.next(); !d.done; d = c.next()){
                var e = b, f = e.push;
                var g = d.value;
                d = fj;
                var h = g.id + 1;
                var k = g.stream.width || 0, l = g.stream.height || 0;
                g.type == "audio" && (l = k = 0);
                var m = g.duration * g.timescale, n = Math.floor(m / (gj + 1));
                m = Math.floor(m % (gj + 1));
                h = new Uint8Array([
                    1,
                    0,
                    0,
                    7,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3
                ].concat(G(hj(h, 4)), [
                    0,
                    0,
                    0,
                    0
                ], G(hj(n, 4)), G(hj(m, 4)), [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    64,
                    0,
                    0,
                    0
                ], G(hj(k, 2)), [
                    0,
                    0
                ], G(hj(l, 2)), [
                    0,
                    0
                ]));
                h = fj("tkhd", h);
                k = fj;
                n = g.duration * g.timescale;
                l = Math.floor(n / (gj + 1));
                n = Math.floor(n % (gj + 1));
                m = g.stream.language;
                m = m.charCodeAt(0) - 96 << 10 | m.charCodeAt(1) - 96 << 5 | m.charCodeAt(2) - 96;
                l = new Uint8Array([
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3
                ].concat(G(hj(g.timescale, 4)), G(hj(l, 4)), G(hj(n, 4)), G(hj(m, 2)), [
                    0,
                    0
                ]));
                l = fj("mdhd", l);
                n = g;
                m = new Uint8Array([]);
                switch(n.type){
                    case "video":
                        m = ij.value();
                        break;
                    case "audio":
                        m = jj.value();
                }
                n = fj("hdlr", m);
                a: {
                    switch(g.type){
                        case "video":
                            g = fj("minf", fj("vmhd", kj.value()), lj.value(), mj(g));
                            break a;
                        case "audio":
                            g = fj("minf", fj("smhd", nj.value()), lj.value(), mj(g));
                            break a;
                    }
                    g = new Uint8Array([]);
                }
                g = k("mdia", l, n, g);
                d = d("trak", h, g);
                f.call(e, d);
            }
            c = a.g[0];
            e = fj;
            f = e.apply;
            g = c.duration * c.timescale;
            d = Math.floor(g / (gj + 1));
            g = Math.floor(g % (gj + 1));
            d = new Uint8Array([
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                2,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                3
            ].concat(G(hj(c.timescale, 4)), G(hj(d, 4)), G(hj(g, 4)), [
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                64,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                255,
                255,
                255,
                255
            ]));
            d = [
                "moov",
                fj("mvhd", d)
            ];
            g = d.concat;
            b = G(b);
            h = [];
            a = u(a.g);
            for(n = a.next(); !n.done; n = a.next())k = h, l = k.push, n = new Uint8Array([
                0,
                0,
                0,
                0
            ].concat(G(hj(n.value.id + 1, 4)), [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ])), n = fj("trex", n), l.call(k, n);
            a = fj.apply(dj, [
                "mvex"
            ].concat(G(h)));
            a = f.call(e, dj, g.call(d, b, [
                a,
                oj(c.stream)
            ]));
            b = pj.value();
            c = new Uint8Array(b.byteLength + a.byteLength);
            c.set(b);
            c.set(a, b.byteLength);
            return c;
        }
        function mj(a) {
            var b = fj, c = "aac";
            a.codecs.includes("mp3") ? c = "mp3" : a.codecs.includes("ac-3") ? c = Xb().Fe() ? "ec-3" : "ac-3" : a.codecs.includes("ec-3") ? c = "ec-3" : a.codecs.includes("opus") && (c = "opus");
            var d = new Uint8Array([]);
            switch(a.type){
                case "video":
                    if (a.codecs.includes("avc1")) {
                        c = a.stream.width || 0;
                        d = a.stream.height || 0;
                        if (a.Za.byteLength > 0) var e = fj("avcC", a.Za);
                        else {
                            e = fj;
                            for(var f = 7, g = [], h = [], k = 0, l = 0, m = 0, n = 0; n < a.Cb.length; n++){
                                var q = qj(a.Cb[n]);
                                switch(q[0] & 31){
                                    case 7:
                                        g.push(q);
                                        f += q.length + 2;
                                        break;
                                    case 8:
                                        h.push(q), f += q.length + 2;
                                }
                            }
                            g.length > 0 && (k = g[0][1], m = g[0][2], l = g[0][3]);
                            f = new Uint8Array(f);
                            n = 0;
                            f[n++] = 1;
                            f[n++] = k;
                            f[n++] = m;
                            f[n++] = l;
                            f[n++] = 255;
                            f[n++] = 224 | g.length;
                            for(k = 0; k < g.length; k++)f[n++] = (g[k].length & 65280) >> 8, f[n++] = g[k].length & 255, f.set(g[k], n), n += g[k].length;
                            f[n++] = h.length;
                            for(g = 0; g < h.length; g++)f[n++] = (h[g].length & 65280) >> 8, f[n++] = h[g].length & 255, f.set(h[g], n), n += h[g].length;
                            e = e("avcC", f);
                        }
                        c = new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ].concat(G(hj(c, 2)), G(hj(d, 2)), [
                            0,
                            72,
                            0,
                            0,
                            0,
                            72,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            19,
                            118,
                            105,
                            100,
                            101,
                            111,
                            106,
                            115,
                            45,
                            99,
                            111,
                            110,
                            116,
                            114,
                            105,
                            98,
                            45,
                            104,
                            108,
                            115,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            24,
                            17,
                            17
                        ]));
                        d = "avc1";
                        h = rj(a);
                        g = new Uint8Array([]);
                        sj(a.stream) && (g = tj(a.stream, a.codecs), d = "encv");
                        d = fj(d, c, e, h, g);
                    } else a.codecs.includes("hvc1") && (d = a.stream.width || 0, e = a.stream.height || 0, c = new Uint8Array([]), a.Za.byteLength > 0 && (c = fj("hvcC", a.Za)), d = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ].concat(G(hj(d, 2)), G(hj(e, 2)), [
                        0,
                        72,
                        0,
                        0,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        19,
                        118,
                        105,
                        100,
                        101,
                        111,
                        106,
                        115,
                        45,
                        99,
                        111,
                        110,
                        116,
                        114,
                        105,
                        98,
                        45,
                        104,
                        108,
                        115,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        24,
                        17,
                        17
                    ])), e = "hvc1", h = rj(a), g = new Uint8Array([]), sj(a.stream) && (g = tj(a.stream, a.codecs), e = "encv"), d = fj(e, d, c, h, g));
                    break;
                case "audio":
                    if (c == "mp3") a = fj(".mp3", uj(a));
                    else if (c == "ac-3") c = fj("dac3", a.Ha), d = "ac-3", e = new Uint8Array([]), sj(a.stream) && (e = tj(a.stream, a.codecs), d = "enca"), a = fj(d, uj(a), c, e);
                    else if (c == "ec-3") c = fj("dec3", a.Ha), d = "ec-3", e = new Uint8Array([]), sj(a.stream) && (e = tj(a.stream, a.codecs), d = "enca"), a = fj(d, uj(a), c, e);
                    else if (c == "opus") c = fj("dOps", a.Ha), d = "Opus", e = new Uint8Array([]), sj(a.stream) && (e = tj(a.stream, a.codecs), d = "enca"), a = fj(d, uj(a), c, e);
                    else {
                        if (a.Ha.byteLength > 0) c = fj("esds", a.Ha);
                        else {
                            c = fj;
                            d = a.id + 1;
                            e = a.stream.channelsCount || 2;
                            g = a.stream.audioSamplingRate || 44100;
                            k = Bc("audio", a.codecs.split(","));
                            l = {
                                96E3: 0,
                                88200: 1,
                                64E3: 2,
                                48E3: 3,
                                44100: 4,
                                32E3: 5,
                                24E3: 6,
                                22050: 7,
                                16E3: 8,
                                12E3: 9,
                                11025: 10,
                                8E3: 11,
                                7350: 12
                            };
                            h = l[g];
                            if (k === "mp4a.40.5" || k === "mp4a.40.29") h = l[g * 2];
                            g = parseInt(k.split(".").pop(), 10);
                            d = new Uint8Array([
                                0,
                                0,
                                0,
                                0,
                                3,
                                25
                            ].concat(G(hj(d, 2)), [
                                0,
                                4,
                                17,
                                64,
                                21,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                5,
                                2,
                                g << 3 | h >>> 1,
                                h << 7 | e << 3,
                                6,
                                1,
                                2
                            ]));
                            c = c("esds", d);
                        }
                        d = "mp4a";
                        e = new Uint8Array([]);
                        sj(a.stream) && (e = tj(a.stream, a.codecs), d = "enca");
                        a = fj(d, uj(a), c, e);
                    }
                    d = a;
            }
            a = fj("stsd", vj.value(), d);
            return b("stbl", a, fj("stts", wj.value()), fj("stsc", xj.value()), fj("stsz", yj.value()), fj("stco", zj.value()));
        }
        function rj(a) {
            if (!a.fb && !a.gb) return new Uint8Array([]);
            var b = a.gb;
            a = new Uint8Array([].concat(G(hj(a.fb, 4)), G(hj(b, 4))));
            return fj("pasp", a);
        }
        function uj(a) {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                a.stream.channelsCount || 2,
                0,
                16,
                0,
                0,
                0,
                0
            ].concat(G(hj(a.stream.audioSamplingRate || 44100, 2)), [
                0,
                0
            ]));
        }
        function oj(a) {
            var b = [];
            if (!sj(a)) return new Uint8Array([]);
            a = u(a.drmInfos);
            for(var c = a.next(); !c.done; c = a.next())if (c = c.value, c.initData) {
                c = u(c.initData);
                for(var d = c.next(); !d.done; d = c.next())b.push(d.value.initData);
            }
            return tc.apply(kc, G(b));
        }
        function tj(a, b) {
            var c = fj;
            b = new Uint8Array([].concat(G(hj(Aj(b.split(".")[0]), 4))));
            b = fj("frma", b);
            var d = "cenc";
            var e = a.drmInfos[0];
            e && e.encryptionScheme && (d = e.encryptionScheme);
            d = new Uint8Array([
                0,
                0,
                0,
                0
            ].concat(G(hj(Aj(d), 4)), [
                0,
                1,
                0,
                0
            ]));
            d = fj("schm", d);
            e = fj;
            var f = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
            a = u(a.drmInfos);
            for(var g = a.next(); !g.done; g = a.next())if ((g = g.value) && g.keyIds && g.keyIds.size) {
                g = u(g.keyIds);
                for(var h = g.next(); !h.done; h = g.next())f = qj(h.value);
            }
            a = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                8
            ]);
            f = fj("tenc", a, f);
            return c("sinf", b, d, e("schi", f));
        }
        function Bj(a) {
            var b = [];
            a = u(a.g);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = b, e = d.push;
                var f = fj;
                var g = new Uint8Array([
                    0,
                    0,
                    0,
                    0
                ].concat(G(hj(c.data ? c.data.sequenceNumber : 0, 4))));
                g = fj("mfhd", g);
                var h;
                var k = c.data ? c.data.zb : [];
                var l = new Uint8Array(4 + k.length);
                for(h = 0; h < k.length; h++){
                    var m = k[h].flags;
                    l[h + 4] = m.pf << 4 | m.Ef << 2 | m.zf;
                }
                k = fj("sdtp", l);
                var n = k.length + 32 + 20 + 8 + 16 + 8 + 8;
                l = fj;
                h = new Uint8Array([
                    0,
                    0,
                    0,
                    58
                ].concat(G(hj(c.id + 1, 4)), [
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]));
                h = fj("tfhd", h);
                m = c.data ? c.data.baseMediaDecodeTime : 0;
                var q = Math.floor(m % (gj + 1));
                m = new Uint8Array([
                    1,
                    0,
                    0,
                    0
                ].concat(G(hj(Math.floor(m / (gj + 1)), 4)), G(hj(q, 4))));
                m = fj("tfdt", m);
                var r = n;
                n = c.data ? c.data.zb : [];
                q = n.length;
                var t = 12 + 16 * q, v = new Uint8Array(t);
                r += 8 + t;
                v.set([
                    c.type === "video" ? 1 : 0,
                    0,
                    15,
                    1
                ].concat(G(hj(q, 4)), G(hj(r, 4))), 0);
                for(r = 0; r < q; r++){
                    var w = n[r];
                    t = hj(w.duration, 4);
                    var x = hj(w.size, 4), y = w.flags;
                    w = hj(w.ub, 4);
                    v.set([].concat(G(t), G(x), [
                        y.Hh << 2 | y.pf,
                        y.Ef << 6 | y.zf << 4 | y.Jh,
                        y.nf & 61440,
                        y.nf & 15
                    ], G(w)), 12 + 16 * r);
                }
                n = fj("trun", v);
                k = l("traf", h, m, n, k);
                f = f("moof", g, k);
                e.call(d, f, Cj(c));
            }
            return tc.apply(kc, G(b));
        }
        function Cj(a) {
            a = (a.data ? a.data.zb : []).map(function(b) {
                return b.data;
            });
            return fj.apply(dj, [
                "mdat"
            ].concat(G(a)));
        }
        function hj(a, b) {
            var c = [];
            for(--b; b >= 0; b--)c.push(a >> 8 * b & 255);
            return c;
        }
        function qj(a) {
            for(var b = new Uint8Array(a.length / 2), c = 0; c < a.length / 2; c += 1)b[c] = parseInt(String(a[c * 2] + a[c * 2 + 1]), 16);
            return b;
        }
        function Aj(a) {
            for(var b = 0, c = 0; c < a.length; c += 1)b |= a.charCodeAt(c) << (a.length - c - 1) * 8;
            return b;
        }
        function fj(a) {
            var b = Ma.apply(1, arguments), c = Dj.get(a);
            c || (c = [
                a.charCodeAt(0),
                a.charCodeAt(1),
                a.charCodeAt(2),
                a.charCodeAt(3)
            ], Dj.set(a, c));
            for(var d = 8, e = b.length - 1; e >= 0; e--)d += b[e].byteLength;
            e = new Uint8Array(d);
            e[0] = d >> 24 & 255;
            e[1] = d >> 16 & 255;
            e[2] = d >> 8 & 255;
            e[3] = d & 255;
            e.set(c, 4);
            c = 0;
            for(d = 8; c < b.length; c++)e.set(b[c], d), d += b[c].byteLength;
            return e;
        }
        function sj(a) {
            return a.encrypted && a.drmInfos.length > 0;
        }
        var gj = 4294967295, Dj = new Map, ij = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                118,
                105,
                100,
                101,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                86,
                105,
                100,
                101,
                111,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                0
            ]);
        }), jj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                115,
                111,
                117,
                110,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                83,
                111,
                117,
                110,
                100,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                0
            ]);
        }), wj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), xj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), zj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), yj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), kj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), nj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), vj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]);
        }), pj = new Kb(function() {
            var a = new Uint8Array([
                105,
                115,
                111,
                109
            ]), b = new Uint8Array([
                97,
                118,
                99,
                49
            ]), c = new Uint8Array([
                0,
                0,
                0,
                1
            ]);
            return fj("ftyp", a, c, a, b);
        }), lj = new Kb(function() {
            var a = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                12,
                117,
                114,
                108,
                32,
                0,
                0,
                0,
                1
            ]);
            a = fj("dref", a);
            return fj("dinf", a);
        });
        function Ej(a) {
            a = Fb(a);
            var b = null;
            (new Bh).boxes([
                "moov",
                "trak",
                "mdia",
                "minf",
                "stbl"
            ], Gh).qa("stsd", Ih).box("enca", function(c) {
                b = c.reader.h;
                return Kh(c);
            }).box("sinf", Gh).box("frma", function(c) {
                c.parser.stop();
                $i(c.reader).codec === "ec-3" && b && b.getUint16(16) !== 2 && b.setUint16(16, 2);
            }).parse(a);
            return a;
        }
        function Fj(a, b, c) {
            var d = b = Fb(b), e = !1, f, g = [], h = [];
            (new Bh).boxes([
                "moov",
                "trak",
                "mdia",
                "minf",
                "stbl"
            ], function(l) {
                g.push(l);
                Gh(l);
            }).qa("stsd", function(l) {
                f = l;
                g.push(l);
                Ih(l);
            }).boxes([
                "encv",
                "enca"
            ], function(l) {
                e = !0;
                l.parser.stop();
            }).boxes("dvav dva1 dvh1 dvhe dvc1 dvi1 hev1 hvc1 avc1 avc3".split(" "), function(l) {
                h.push({
                    box: l,
                    tj: 1701733238
                });
            }).boxes("ac-3 ec-3 ac-4 Opus fLaC mp4a".split(" "), function(l) {
                h.push({
                    box: l,
                    tj: 1701733217
                });
            }).parse(b);
            if (e) return b;
            if (h.length == 0 || !f) throw db(sc(b)), new T(2, 3, 3019, c);
            h.reverse();
            c = u(h);
            for(var k = c.next(); !k.done; k = c.next())k = k.value, d = Gj(a, d, f, k.box, g, k.tj);
            d = Hj(a, d);
            return Xb().$h() ? (a = new Uint8Array(b.byteLength + d.byteLength), a.set(d), a.set(b, d.byteLength), a) : d;
        }
        function Ij(a) {
            a = Fb(a);
            var b = [];
            (new Bh).box("mdat", function(g) {
                b.push(g);
            }).parse(a);
            for(var c = [], d = 0; d < b.length; d++){
                var e = b[d - 1], f = b[d];
                c.push(Jj(a.subarray(e ? e.start + e.size : 0, f.start + f.size)));
            }
            return tc.apply(kc, G(c));
        }
        function Jj(a) {
            var b, c, d, e, f = [];
            (new Bh).boxes([
                "moof",
                "traf"
            ], function(m) {
                f.push(m);
                Gh(m);
            }).qa("tfhd", function(m) {
                b = m;
                d = Vi(m.reader, m.flags);
            }).qa("trun", function(m) {
                c = m;
                e = Yi(m.reader, m.version, m.flags);
            }).parse(a);
            if (d && d.Gj !== 2) {
                var g = b.start + Hh(b) + 4 + (d.tk !== null ? 8 : 0), h = Jb(a);
                if (d.Gj !== null) h.setUint32(g, 2);
                else {
                    Kj(a, b.start, b.size + 4);
                    var k = h.getUint32(b.start + 8);
                    h.setUint32(b.start + 8, k | 2);
                    e && e.Ug !== null && h.setInt32(c.start + Hh(c) + 4, e.Ug + 4);
                    k = a.subarray(0, g);
                    h = a.subarray(g);
                    a = new Uint8Array(a.byteLength + 4);
                    a.set(k);
                    k = [];
                    for(var l = 3; l >= 0; l--)k.push(2 >> 8 * l & 255);
                    a.set(new Uint8Array(k), g);
                    a.set(h, g + 4);
                    g = u(f);
                    for(h = g.next(); !h.done; h = g.next())h = h.value, Kj(a, h.start, h.size + 4);
                }
            }
            return a;
        }
        function Gj(a, b, c, d, e, f) {
            var g = tj(a, d.name), h = b.subarray(d.start, d.start + d.size);
            a = new Uint8Array(d.size + g.byteLength);
            a.set(h, 0);
            Jb(a).setUint32(4, f);
            a.set(g, d.size);
            Kj(a, 0, a.byteLength);
            f = new Uint8Array(b.byteLength + a.byteLength);
            d = Xb().Cf() ? d.start : d.start + d.size;
            g = b.subarray(d);
            f.set(b.subarray(0, d));
            f.set(a, d);
            f.set(g, d + a.byteLength);
            b = u(e);
            for(e = b.next(); !e.done; e = b.next())e = e.value, Kj(f, e.start, e.size + a.byteLength);
            a = Jb(f, c.start);
            c = Hh(c);
            b = a.getUint32(c);
            a.setUint32(c, b + 1);
            return f;
        }
        function Hj(a, b) {
            a = oj(a);
            if (a.byteLength === 0) return b;
            var c = 0, d = 0;
            (new Bh).box("moov", function(h) {
                c = h.start;
                d = h.size;
                h.parser.stop();
            }).parse(b);
            var e = c + d;
            Kj(b, c, d + a.byteLength);
            var f = new Uint8Array(b.byteLength + a.byteLength), g = b.subarray(e);
            f.set(b.subarray(0, e));
            f.set(a, e);
            f.set(g, e + a.byteLength);
            return f;
        }
        function Kj(a, b, c) {
            a = Jb(a, b);
            b = a.getUint32(0);
            b != 0 && (b == 1 ? (a.setUint32(8, c >> 32), a.setUint32(12, c & 4294967295)) : a.setUint32(0, c));
        }
        function Lj(a) {
            var b = Fb(a), c = [];
            (new Bh).boxes([
                "moov",
                "trak",
                "mdia",
                "minf",
                "stbl"
            ], function(d) {
                c.push({
                    start: d.start,
                    size: d.size
                });
                Gh(d);
            }).box("stsd", function(d) {
                c.push({
                    start: d.start,
                    size: d.size
                });
                for(var e = Jb(b, d.start), f = 0; f < d.size - 3; f++){
                    var g = e.getUint32(f);
                    g == 1633889587 ? e.setUint32(f, 1700998451) : g == 1684103987 && e.setUint32(f, 1684366131);
                }
            }).parse(b);
            return b;
        }
        function Mj(a, b, c, d, e, f, g, h) {
            this.T = a;
            this.startByte = b;
            this.endByte = c;
            this.Kd = d === void 0 ? null : d;
            this.timescale = e === void 0 ? null : e;
            this.h = f === void 0 ? null : f;
            this.aesKey = g === void 0 ? null : g;
            this.g = this.mimeType = this.codecs = null;
            this.encrypted = h === void 0 ? !1 : h;
        }
        Mj.prototype.Qc = function() {
            return this.startByte;
        };
        Mj.prototype.Oc = function() {
            return this.endByte;
        };
        Mj.prototype.He = function(a) {
            this.h = a;
        };
        Mj.prototype.dc = function() {
            return this.h;
        };
        function Nj(a, b) {
            return a === b ? !0 : a && b ? a.Qc() == b.Qc() && a.Oc() == b.Oc() && ed(a.T().sort(), b.T().sort()) && Eb(a.dc(), b.dc()) : a == b;
        }
        O("shaka.media.InitSegmentReference", Mj);
        Mj.prototype.getEndByte = Mj.prototype.Oc;
        Mj.prototype.getStartByte = Mj.prototype.Qc;
        function Oj(a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, v) {
            l = l === void 0 ? [] : l;
            r = r === void 0 ? Pj : r;
            this.startTime = a;
            this.j = this.endTime = b;
            this.D = c;
            this.startByte = d;
            this.endByte = e;
            this.ia = f;
            this.timestampOffset = g;
            this.appendWindowStart = h;
            this.appendWindowEnd = k;
            this.g = l;
            this.tilesLayout = m === void 0 ? "" : m;
            this.C = n === void 0 ? null : n;
            this.h = q === void 0 ? null : q;
            this.status = r;
            this.preload = !1;
            this.l = !0;
            this.o = !1;
            this.aesKey = t === void 0 ? null : t;
            this.thumbnailSprite = null;
            this.i = -1;
            this.m = v === void 0 ? !1 : v;
            this.we = this.hd = !1;
            a = u(this.g);
            for(b = a.next(); !b.done; b = a.next())b.value.qj();
            this.m && this.g.length && this.g[this.g.length - 1].pj();
            this.A = this.bandwidth = this.mimeType = this.codecs = null;
            this.F = !1;
        }
        p = Oj.prototype;
        p.T = function() {
            return this.D();
        };
        p.getStartTime = function() {
            return this.startTime;
        };
        p.Qk = function() {
            return this.endTime;
        };
        p.Qc = function() {
            return this.startByte;
        };
        p.Oc = function() {
            return this.endByte;
        };
        function Qj(a) {
            if (a.endByte) return a.endByte + 1 - a.startByte;
            if (a.bandwidth) {
                var b = a.bandwidth * (a.endTime - a.startTime);
                if (!isNaN(b) && b > 0) return b;
            }
            if (a.g.length > 0 && a.m) for(a = u(a.g), a = a.next(); !a.done; a = a.next()){
                Qj(a.value);
                break;
            }
            return null;
        }
        p.vl = function() {
            return this.tilesLayout;
        };
        p.ul = function() {
            return this.C;
        };
        p.ec = function() {
            return this.status;
        };
        p.Ql = function() {
            this.status = Rj;
        };
        p.Mh = function() {
            this.preload = !0;
        };
        p.isPreload = function() {
            return this.preload;
        };
        p.Jd = function() {
            this.l = !1;
        };
        p.Gl = function() {
            return this.l;
        };
        p.qj = function() {
            this.hd = !0;
        };
        p.Il = function() {
            return this.hd;
        };
        p.pj = function() {
            this.we = !0;
        };
        p.Hl = function() {
            return this.we;
        };
        p.oj = function() {
            this.o = !0;
        };
        p.Dl = function() {
            return this.o;
        };
        p.kg = function(a) {
            this.thumbnailSprite = a;
        };
        p.rl = function() {
            return this.thumbnailSprite;
        };
        p.offset = function(a) {
            this.startTime += a;
            this.endTime += a;
            this.j += a;
            for(var b = u(this.g), c = b.next(); !c.done; c = b.next())c = c.value, c.startTime += a, c.endTime += a, c.j += a;
        };
        p.ti = function(a) {
            this.h == null ? Ya("Sync attempted without sync time!") : (a = this.h - a - this.startTime, Math.abs(a) >= .001 && this.offset(a));
        };
        p.He = function(a, b) {
            this.A = a;
            this.F = b === void 0 ? !1 : b;
        };
        p.dc = function(a) {
            var b = this.A;
            (a === void 0 || a) && this.F && (this.A = null);
            return b;
        };
        function Sj(a, b) {
            a.ia = b;
            a = u(a.g);
            for(var c = a.next(); !c.done; c = a.next())Sj(c.value, b);
        }
        O("shaka.media.SegmentReference", Oj);
        Oj.prototype.getSegmentData = Oj.prototype.dc;
        Oj.prototype.setSegmentData = Oj.prototype.He;
        Oj.prototype.syncAgainst = Oj.prototype.ti;
        Oj.prototype.offset = Oj.prototype.offset;
        Oj.prototype.getThumbnailSprite = Oj.prototype.rl;
        Oj.prototype.setThumbnailSprite = Oj.prototype.kg;
        Oj.prototype.hasByterangeOptimization = Oj.prototype.Dl;
        Oj.prototype.markAsByterangeOptimization = Oj.prototype.oj;
        Oj.prototype.isLastPartial = Oj.prototype.Hl;
        Oj.prototype.markAsLastPartial = Oj.prototype.pj;
        Oj.prototype.isPartial = Oj.prototype.Il;
        Oj.prototype.markAsPartial = Oj.prototype.qj;
        Oj.prototype.isIndependent = Oj.prototype.Gl;
        Oj.prototype.markAsNonIndependent = Oj.prototype.Jd;
        Oj.prototype.isPreload = Oj.prototype.isPreload;
        Oj.prototype.markAsPreload = Oj.prototype.Mh;
        Oj.prototype.markAsUnavailable = Oj.prototype.Ql;
        Oj.prototype.getStatus = Oj.prototype.ec;
        Oj.prototype.getTileDuration = Oj.prototype.ul;
        Oj.prototype.getTilesLayout = Oj.prototype.vl;
        Oj.prototype.getEndByte = Oj.prototype.Oc;
        Oj.prototype.getStartByte = Oj.prototype.Qc;
        Oj.prototype.getEndTime = Oj.prototype.Qk;
        Oj.prototype.getStartTime = Oj.prototype.getStartTime;
        Oj.prototype.getUris = Oj.prototype.T;
        var Pj = 0, Rj = 1;
        Oj.Status = {
            Jm: Pj,
            Pn: Rj,
            nn: 2
        };
        function Tj(a) {
            return a.length == 1 && a.end(0) - a.start(0) < 1E-4;
        }
        function Uj(a) {
            return !a || Tj(a) ? null : a.length == 1 && a.start(0) < 0 ? 0 : a.length ? a.start(0) : null;
        }
        function Vj(a) {
            return !a || Tj(a) ? null : a.length ? a.end(a.length - 1) : null;
        }
        function Wj(a, b) {
            return !a || !a.length || Tj(a) || b > a.end(a.length - 1) ? !1 : b >= a.start(0);
        }
        function Xj(a, b) {
            if (!a || !a.length || Tj(a)) return 0;
            var c = 0;
            a = u(Yj(a));
            for(var d = a.next(); !d.done; d = a.next()){
                var e = d.value;
                d = e.start;
                e = e.end;
                e > b && (c += e - Math.max(d, b));
            }
            return c;
        }
        function Zj(a, b, c) {
            if (!a || !a.length || Tj(a)) return null;
            a = Yj(a).findIndex(function(d, e, f) {
                return d.start > b && (e == 0 || f[e - 1].end - b <= c);
            });
            return a >= 0 ? a : null;
        }
        function Yj(a) {
            if (!a) return [];
            for(var b = [], c = 0; c < a.length; c++)b.push({
                start: a.start(c),
                end: a.end(c)
            });
            return b;
        }
        function ak() {}
        function U(a) {
            return document.createElement(a);
        }
        function bk(a) {
            return document.createElementNS("http://www.w3.org/2000/svg", a);
        }
        function ck() {
            var a = document.createElement("button");
            a.setAttribute("type", "button");
            return a;
        }
        function dk(a, b) {
            var c = document.createElement("source");
            c.src = a;
            c.type = b === void 0 ? "" : b;
            return c;
        }
        function ek(a) {
            for(var b = !1, c = a.getElementsByTagName("source"), d = c.length - 1; d >= 0; --d)a.removeChild(c[d]), b = !0;
            a.src && (a.removeAttribute("src"), b = !0);
            return b;
        }
        function fk(a) {
            a = a.getElementsByClassName("shaka-overflow-quality-mark");
            return a.length ? a[0] : null;
        }
        function gk(a) {
            for(; a.firstChild;)a.removeChild(a.firstChild);
        }
        function Bd() {
            if (hk) return hk;
            ik || (ik = new Uf(function() {
                hk = null;
            }));
            (hk = document.getElementsByTagName("video")[0] || document.getElementsByTagName("audio")[0]) || (hk = document.createElement("video"));
            ik.Z(1);
            return hk;
        }
        function jk(a, b) {
            var c, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) return "fonts" in document && "FontFace" in window1 ? h.g(document.fonts.ready, 2) : h.return();
                if (!("entries" in document.fonts)) return h.return();
                c = function(k) {
                    k = k.entries();
                    for(var l = [], m = k.next(); m.done === !1;)l.push(m.value), m = k.next();
                    return l;
                };
                d = u(c(document.fonts));
                for(e = d.next(); !e.done; e = d.next())if (f = e.value, f.family === a && f.display === "swap") return h.return();
                g = new FontFace(a, "url(" + b + ")", {
                    display: "swap"
                });
                document.fonts.add(g);
                h.j();
            });
        }
        O("shaka.util.Dom", ak);
        ak.removeAllChildren = gk;
        ak.clearSourceFromVideo = ek;
        var ik = null, hk = null;
        function kk() {}
        function lk(a, b) {
            return b + 10 <= a.length && a[b] === 73 && a[b + 1] === 68 && a[b + 2] === 51 && a[b + 3] < 255 && a[b + 4] < 255 && a[b + 6] < 128 && a[b + 7] < 128 && a[b + 8] < 128 && a[b + 9] < 128 ? !0 : !1;
        }
        function mk(a, b) {
            return b + 10 <= a.length && a[b] === 51 && a[b + 1] === 68 && a[b + 2] === 73 && a[b + 3] < 255 && a[b + 4] < 255 && a[b + 6] < 128 && a[b + 7] < 128 && a[b + 8] < 128 && a[b + 9] < 128 ? !0 : !1;
        }
        function nk(a, b) {
            var c = (a[b] & 127) << 21;
            c |= (a[b + 1] & 127) << 14;
            c |= (a[b + 2] & 127) << 7;
            return c |= a[b + 3] & 127;
        }
        function ok(a) {
            var b = {
                key: a.type,
                description: "",
                data: "",
                mimeType: null,
                pictureType: null
            };
            if (a.type === "APIC") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                var c = a.data.subarray(1).indexOf(0);
                if (c === -1) return null;
                var d = bc(Fb(a.data, 1, c)), e = a.data[2 + c], f = a.data.subarray(3 + c).indexOf(0);
                if (f === -1) return null;
                var g = bc(Fb(a.data, 3 + c, f)), h;
                d === "--\x3e" ? h = bc(Fb(a.data, 4 + c + f)) : h = Gb(a.data.subarray(4 + c + f));
                b.mimeType = d;
                b.pictureType = e;
                b.description = g;
                b.data = h;
                return b;
            }
            if (a.type === "TXXX") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                d = a.data.subarray(1).indexOf(0);
                if (d === -1) return null;
                c = bc(Fb(a.data, 1, d));
                a = bc(Fb(a.data, 2 + d)).replace(/\0*$/, "");
                b.description = c;
                b.data = a;
                return b;
            }
            if (a.type === "WXXX") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                d = a.data.subarray(1).indexOf(0);
                if (d === -1) return null;
                c = bc(Fb(a.data, 1, d));
                a = bc(Fb(a.data, 2 + d)).replace(/\0*$/, "");
                b.description = c;
                b.data = a;
                return b;
            }
            if (a.type === "PRIV") {
                if (a.size < 2) return null;
                c = a.data.indexOf(0);
                if (c === -1) return null;
                c = bc(Fb(a.data, 0, c));
                b.description = c;
                c == "com.apple.streaming.transportStreamTimestamp" ? (c = a.data.subarray(c.length + 1), a = c[3] & 1, c = (c[4] << 23) + (c[5] << 15) + (c[6] << 7) + c[7], c /= 45, a && (c += 4.772185884E7), b.data = c) : (a = Gb(a.data.subarray(c.length + 1)), b.data = a);
                return b;
            }
            if (a.type[0] === "T") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                a = bc(a.data.subarray(1)).replace(/\0*$/, "");
                b.data = a;
                return b;
            }
            return a.type[0] === "W" ? (a = bc(a.data).replace(/\0*$/, ""), b.data = a, b) : a.data ? (b.data = Gb(a.data), b) : null;
        }
        function pk(a) {
            for(var b = 0, c = []; lk(a, b);){
                var d = nk(a, b + 6);
                a[b + 5] >> 6 & 1 && (b += 10);
                b += 10;
                for(d = b + d; b + 10 < d;){
                    var e = a.subarray(b), f = nk(e, 4);
                    e = {
                        type: String.fromCharCode(e[0], e[1], e[2], e[3]),
                        size: f,
                        data: e.subarray(10, 10 + f)
                    };
                    (f = ok(e)) && c.push(f);
                    b += e.size + 10;
                }
                mk(a, b) && (b += 10);
            }
            return c;
        }
        function qk(a, b) {
            for(var c = b = b === void 0 ? 0 : b, d = 0; lk(a, b);)a[b + 5] >> 6 & 1 && (d += 10), d += 10, d += nk(a, b + 6), mk(a, b + 10) && (d += 10), b += d;
            return d > 0 ? a.subarray(c, c + d) : new Uint8Array([]);
        }
        O("shaka.util.Id3Utils", kk);
        kk.getID3Data = qk;
        kk.getID3Frames = pk;
        function rk(a, b, c) {
            c = c === void 0 ? Number.EPSILON : c;
            if (a === b) return !0;
            a = Math.abs(a - b);
            return a <= c ? !0 : c !== Number.EPSILON ? Math.abs(a - c) <= Number.EPSILON : !1;
        }
        function sk(a) {
            return new Date(Date.UTC(1900, 0, 1, 0, 0, 0, 0) + a).getTime();
        }
        function tk(a, b) {
            this.j = a;
            if (b === void 0 ? 0 : b) {
                b = new Uint8Array(a.byteLength);
                for(var c = 0, d = 0; d < a.byteLength; d++)d >= 2 && a[d] == 3 && a[d - 1] == 0 && a[d - 2] == 0 || (b[c] = a[d], c++);
                this.j = Fb(b, 0, c);
            }
            this.i = this.j.byteLength;
            this.g = this.h = 0;
        }
        function uk(a) {
            var b = a.j.byteLength - a.i, c = Math.min(4, a.i);
            if (c !== 0) {
                for(var d = 0, e = 0; e < c; e++)d = d << 8 | a.j[b + e];
                a.h = d << (4 - c) * 8;
                a.g = c * 8;
                a.i -= c;
            }
        }
        function vk(a, b) {
            if (a.g <= b) {
                b -= a.g;
                var c = Math.floor(b / 8);
                b -= c * 8;
                a.g -= c;
                uk(a);
            }
            a.h <<= b;
            a.g -= b;
        }
        function wk(a, b) {
            var c = Math.min(a.g, b), d = a.h >>> 32 - c;
            a.g -= c;
            a.g > 0 ? a.h <<= c : a.i > 0 && uk(a);
            c = b - c;
            return c > 0 ? d << c | wk(a, c) : d;
        }
        function xk(a) {
            for(var b = 0; a.g === 0;){
                if (a.i === 0) return b;
                uk(a);
            }
            for(;;){
                var c = Math.clz32(a.h);
                c > a.g && (c = a.g);
                b += c;
                a.h <<= c;
                a.g -= c;
                if (a.g > 0 || a.i === 0) break;
                uk(a);
            }
            return b;
        }
        function yk(a) {
            vk(a, 1 + xk(a));
        }
        function V(a) {
            var b = xk(a);
            return wk(a, b + 1) - 1;
        }
        function zk(a) {
            a = V(a);
            return 1 & a ? 1 + a >>> 1 : -1 * (a >>> 1);
        }
        function Ak(a) {
            return wk(a, 1) === 1;
        }
        function Bk(a) {
            return wk(a, 8);
        }
        function Ck(a, b) {
            for(var c = 8, d = 8, e = 0; e < b; e++)d !== 0 && (d = zk(a), d = (c + d + 256) % 256), c = d === 0 ? c : d;
        }
        function Dk(a) {
            Bk(a);
            V(a);
            return V(a);
        }
        O("shaka.util.ExpGolomb", tk);
        function Ek() {
            this.K = null;
            this.L = !1;
            this.D = this.M = null;
            this.m = [];
            this.j = [];
            this.g = [];
            this.G = this.H = null;
            this.l = [];
            this.i = [];
            this.h = [];
            this.I = null;
            this.A = [];
            this.o = [];
            this.F = this.J = this.C = null;
        }
        p = Ek.prototype;
        p.clearData = function() {
            this.m = [];
            this.j = [];
            this.g = [];
            this.l = [];
            this.i = [];
            this.h = [];
            this.A = [];
            this.o = [];
        };
        p.hg = function(a) {
            this.F != null && this.F != a && (this.C = null);
            this.F = a;
        };
        p.parse = function(a) {
            if (a.length < 564) return this;
            for(var b = Math.max(0, Fk(a)), c = a.length - (a.length + b) % 188, d = !1, e = b; e < c; e += 188)if (a[e] == 71) {
                var f = !!(a[e + 1] & 64), g = ((a[e + 1] & 31) << 8) + a[e + 2];
                if ((a[e + 3] & 48) >> 4 > 1) {
                    var h = e + 5 + a[e + 4];
                    if (h == e + 188) continue;
                } else h = e + 4;
                switch(g){
                    case 0:
                        f && (h += a[h] + 1);
                        this.K = (a[h + 10] & 31) << 8 | a[h + 11];
                        break;
                    case 17:
                    case 8191:
                        break;
                    case this.K:
                        f && (h += a[h] + 1);
                        f = a;
                        g = {
                            audio: -1,
                            video: -1,
                            Af: -1,
                            audioCodec: "",
                            videoCodec: ""
                        };
                        var k = h + 3 + ((f[h + 1] & 15) << 8 | f[h + 2]) - 4;
                        for(h += 12 + ((f[h + 10] & 15) << 8 | f[h + 11]); h < k;){
                            var l = (f[h + 1] & 31) << 8 | f[h + 2], m = (f[h + 3] & 15) << 8 | f[h + 4];
                            switch(f[h]){
                                case 6:
                                    if (m > 0) for(var n = h + 5, q = m; q > 2;){
                                        var r = f[n + 1] + 2;
                                        switch(f[n]){
                                            case 5:
                                                var t = n + 2;
                                                t = f[t] << 24 | f[t + 1] << 16 | f[t + 2] << 8 | f[t + 3];
                                                g.audio == -1 && t === 1332770163 ? (g.audio = l, g.audioCodec = "opus") : g.video == -1 && t === 1096167473 && (g.video = l, g.videoCodec = "av1");
                                                break;
                                            case 106:
                                                g.audio == -1 && (g.audio = l, g.audioCodec = "ac3");
                                                break;
                                            case 122:
                                                g.audio == -1 && (g.audio = l, g.audioCodec = "ec3");
                                                break;
                                            case 124:
                                                g.audio == -1 && (g.audio = l, g.audioCodec = "aac");
                                                break;
                                            case 127:
                                                g.audioCodec == "opus" && (t = null, f[n + 2] === 128 && (t = f[n + 3]), t != null && (this.J = {
                                                    channelCount: (t & 15) === 0 ? 2 : t & 15,
                                                    vk: t,
                                                    sampleRate: 48E3
                                                }));
                                        }
                                        n += r;
                                        q -= r;
                                    }
                                    break;
                                case 15:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "aac");
                                    break;
                                case 17:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "aac-loas");
                                    break;
                                case 21:
                                    g.Af == -1 && (g.Af = l);
                                    break;
                                case 27:
                                    g.video == -1 && (g.video = l, g.videoCodec = "avc");
                                    break;
                                case 3:
                                case 4:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "mp3");
                                    break;
                                case 36:
                                    g.video == -1 && (g.video = l, g.videoCodec = "hvc");
                                    break;
                                case 129:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "ac3");
                                    break;
                                case 132:
                                case 135:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "ec3");
                            }
                            h += m + 5;
                        }
                        f = g;
                        f.video != -1 && (this.M = f.video, this.D = f.videoCodec);
                        f.audio != -1 && (this.H = f.audio, this.G = f.audioCodec);
                        f.Af != -1 && (this.I = f.Af);
                        d && !this.L && (d = !1, e = b - 188);
                        this.L = !0;
                        break;
                    case this.M:
                        h = a.subarray(h, e + 188);
                        f ? (this.j.push(this.m.length), this.m.push(h)) : this.j.length && this.m.push(h);
                        break;
                    case this.H:
                        h = a.subarray(h, e + 188);
                        f ? (this.i.push(this.l.length), this.l.push(h)) : this.i.length && this.l.push(h);
                        break;
                    case this.I:
                        h = a.subarray(h, e + 188);
                        f ? (this.o.push(this.A.length), this.A.push(h)) : this.o.length && this.A.push(h);
                        break;
                    default:
                        d = !0;
                }
            }
            return this;
        };
        function Gk(a, b, c) {
            return uc(a, b[c], c + 1 < b.length ? b[c + 1] : a.length);
        }
        function Hk(a, b, c) {
            if (b.byteLength < 9 || (b[0] << 16 | b[1] << 8 | b[2]) !== 1) return null;
            var d = b[4] << 8 | b[5];
            if (d && d > c - 6) return null;
            var e = null, f = null, g = b[7];
            if (b.byteLength < Ik(b)) return null;
            if (g & 192) {
                e = (b[9] & 14) * 536870912 + (b[10] & 255) * 4194304 + (b[11] & 254) * 16384 + (b[12] & 255) * 128 + (b[13] & 254) / 2;
                var h = null;
                g & 64 && (h = (b[14] & 14) * 536870912 + (b[15] & 255) * 4194304 + (b[16] & 254) * 16384 + (b[17] & 255) * 128 + (b[18] & 254) / 2, e = Jk(e, h));
                a.C == null && (a.C = e);
                e = Jk(e, a.C);
                f = a.C = e;
                h != null && (f = Jk(h, e));
            }
            a = b[8] + 9;
            return c <= a ? null : {
                packetLength: d,
                Zl: a,
                pts: e,
                dts: f
            };
        }
        function Kk(a, b) {
            return (a = Hk(a, b, b.byteLength)) ? {
                data: b.subarray(a.Zl),
                packetLength: a.packetLength,
                pts: a.pts,
                dts: a.dts,
                nalus: []
            } : null;
        }
        p.Yl = function(a) {
            md("TsParser.parseAvcNalus", "Please use parseNalus function instead.");
            return this.Sh(a, {
                ze: null,
                state: null
            });
        };
        p.Sh = function(a, b) {
            var c = a.pts ? a.pts / 9E4 : null;
            a = a.data;
            var d = a.byteLength, e = 1;
            this.D == "hvc" && (e = 2);
            var f = b.state || 0, g = f, h = 0, k = [], l = -1, m = 0, n = this.D === "hvc";
            f == -1 && (l = 0, m = n ? a[0] >> 1 & 63 : a[0] & 31, f = 0, h = 1);
            for(; h < d;){
                var q = a[h++];
                if (f) {
                    if (f === 1) f = q ? 0 : 2;
                    else if (q) {
                        if (q == 1) {
                            q = h - f - 1;
                            if (l >= 0) k.push({
                                data: a.subarray(l + e, q),
                                fullData: a.subarray(l, q),
                                type: m,
                                time: c,
                                state: null
                            });
                            else if (f = k.length ? k[k.length - 1] : b.ze) g && h <= 4 - g && f.state && (f.data = f.data.subarray(0, f.data.byteLength - g), f.fullData = f.fullData.subarray(0, f.fullData.byteLength - g)), q > 0 && (q = a.subarray(0, q), f.data = tc(f.data, q), f.fullData = tc(f.fullData, q), f.state = 0);
                            h < d ? (m = n ? a[h] >> 1 & 63 : a[h] & 31, l = h, f = 0) : f = -1;
                        } else f = 0;
                    } else f = 3;
                } else f = q ? 0 : 1;
            }
            l >= 0 && f >= 0 && k.push({
                data: a.subarray(l + e, d),
                fullData: a.subarray(l, d),
                type: m,
                time: c,
                state: f
            });
            !k.length && b.ze && (c = k.length ? k[k.length - 1] : b.ze) && (c.data = tc(c.data, a), c.fullData = tc(c.fullData, a));
            b.state = f;
            return k;
        };
        p.getMetadata = function() {
            for(var a = [], b = 0; b < this.o.length; b++){
                var c = Gk(this.A, this.o, b);
                (c = Kk(this, c)) && a.push({
                    cueTime: c.pts ? c.pts / 9E4 : null,
                    data: c.data,
                    frames: pk(c.data),
                    dts: c.dts,
                    pts: c.pts
                });
            }
            return a;
        };
        p.yb = function() {
            if (this.i.length && !this.h.length) for(var a = 0; a < this.i.length; a++){
                var b = Gk(this.l, this.i, a), c = Kk(this, b), d = this.h.length ? this.h[this.h.length - 1] : null;
                c && c.pts != null && c.dts != null && (!d || d.pts != c.pts && d.dts != c.dts) ? this.h.push(c) : this.h.length && (b = c ? c.data : b) && (d = this.h[this.h.length - 1], d.data = tc(d.data, b));
            }
            return this.h;
        };
        p.Ed = function(a) {
            a = a === void 0 ? !0 : a;
            if (this.j.length && !this.g.length) {
                for(var b = 0; b < this.j.length; b++){
                    var c = Gk(this.m, this.j, b), d = Kk(this, c), e = this.g.length ? this.g[this.g.length - 1] : null;
                    d && d.pts != null && d.dts != null && (!e || e.pts != d.pts && e.dts != d.dts) ? this.g.push(d) : this.g.length && (c = d ? d.data : c) && (e = this.g[this.g.length - 1], e.data = tc(e.data, c));
                }
                if (a) {
                    b = {
                        ze: null,
                        state: null
                    };
                    e = [];
                    c = u(this.g);
                    for(d = c.next(); !d.done; d = c.next())d = d.value, d.nalus = this.Sh(d, b), d.nalus.length && (e.push(d), b.ze = d.nalus[d.nalus.length - 1]);
                    this.g = e;
                }
            }
            return a ? this.g : (a = this.g, this.g = [], a);
        };
        function Lk(a, b) {
            if (b == "audio") {
                b = a.l;
                var c = a.i;
            } else if (b == "video") b = a.m, c = a.j;
            else return null;
            for(var d = 0; d < c.length; d++){
                var e = c[d], f = d + 1 < c.length ? c[d + 1] : b.length, g = b[e];
                if (g) {
                    for(var h = 0, k = e; k < f; k++)h += b[k].byteLength;
                    e = g.byteLength >= 9 && g.byteLength >= Ik(g) ? g : uc(b, e, f);
                    if (h = Hk(a, e, h)) {
                        if (h = Mk(h), h != null) return h;
                    }
                }
            }
            return null;
        }
        function Ik(a) {
            a = a[7];
            return a & 64 ? 19 : a & 192 ? 14 : 9;
        }
        function Mk(a) {
            return a.pts == null || a.dts == null ? null : Math.min(a.dts, a.pts) / 9E4;
        }
        p.getStartTime = function(a) {
            if (a == "audio") a = this.yb();
            else if (a == "video") a = this.Ed(!1);
            else return null;
            return a.length ? Mk(a[0]) : null;
        };
        p.me = function() {
            return {
                audio: this.G,
                video: this.D
            };
        };
        p.yf = function() {
            for(var a = [], b = u(this.Ed()), c = b.next(); !c.done; c = b.next())a.push.apply(a, G(c.value.nalus));
            return a;
        };
        p.Al = function() {
            md("TsParser.getVideoResolution", "Please use getVideoInfo function instead.");
            var a = this.yh();
            return {
                height: a.height,
                width: a.width
            };
        };
        p.yh = function() {
            return this.D == "hvc" ? Nk(this) : Ok(this);
        };
        function Pk(a) {
            var b = a.Ed();
            return b.length > 1 && (a = b[0].pts, b = b[1].pts, !isNaN(b - a)) ? String(Math.abs(1 / (b - a) * 9E4)) : null;
        }
        function Ok(a) {
            var b = {
                height: null,
                width: null,
                codec: null,
                frameRate: null
            }, c = a.yf();
            if (!c.length) return b;
            c = c.find(function(r) {
                return r.type == 7;
            });
            if (!c) return b;
            c = new tk(c.data);
            var d = Bk(c), e = Bk(c), f = Bk(c);
            yk(c);
            if (Qk.includes(d)) {
                var g = V(c);
                g === 3 && vk(c, 1);
                yk(c);
                yk(c);
                vk(c, 1);
                if (Ak(c)) {
                    g = g !== 3 ? 8 : 12;
                    for(var h = 0; h < g; h++)Ak(c) && (h < 6 ? Ck(c, 16) : Ck(c, 64));
                }
            }
            yk(c);
            g = V(c);
            if (g === 0) V(c);
            else if (g === 1) for(vk(c, 1), yk(c), yk(c), g = V(c), h = 0; h < g; h++)yk(c);
            yk(c);
            vk(c, 1);
            g = V(c);
            h = V(c);
            var k = wk(c, 1);
            k === 0 && vk(c, 1);
            vk(c, 1);
            var l = 0, m = 0, n = 0, q = 0;
            Ak(c) && (l = V(c), m = V(c), n = V(c), q = V(c));
            b.height = String((2 - k) * (h + 1) * 16 - n * 2 - q * 2);
            b.width = String((g + 1) * 16 - l * 2 - m * 2);
            b.codec = "avc1." + ("0" + d.toString(16).toUpperCase()).slice(-2) + ("0" + e.toString(16).toUpperCase()).slice(-2) + ("0" + f.toString(16).toUpperCase()).slice(-2);
            b.frameRate = Pk(a);
            return b;
        }
        function Nk(a) {
            var b = {
                height: null,
                width: null,
                codec: null,
                frameRate: null
            }, c = a.yf();
            if (!c.length) return b;
            c = c.find(function(E) {
                return E.type == 33;
            });
            if (!c) return b;
            var d = new tk(c.fullData, !0);
            Bk(d);
            Bk(d);
            wk(d, 4);
            var e = wk(d, 3);
            Ak(d);
            var f = wk(d, 2), g = wk(d, 1), h = wk(d, 5), k = wk(d, 32);
            c = Bk(d);
            for(var l = Bk(d), m = Bk(d), n = Bk(d), q = Bk(d), r = Bk(d), t = Bk(d), v = [], w = [], x = 0; x < e; x++)v.push(Ak(d)), w.push(Ak(d));
            if (e > 0) for(x = e; x < 8; x++)wk(d, 2);
            for(x = 0; x < e; x++)v[x] && wk(d, 88), w[x] && Bk(d);
            V(d);
            e = V(d);
            e == 3 && wk(d, 1);
            v = V(d);
            w = V(d);
            var y = x = 0, z = 0, A = 0;
            Ak(d) && (x += V(d), y += V(d), z += V(d), A += V(d));
            b.width = String(v - (x + y) * (e === 1 || e === 2 ? 2 : 1));
            b.height = String(w - (z + A) * (e === 1 ? 2 : 1));
            d = function(E) {
                for(var C = 0, D = 0; D < 32; D++)C |= (E >> D & 1) << 31 - D;
                return C >>> 0;
            }(k);
            g = g == 1 ? "H" : "L";
            f = "hvc1" + ("." + [
                "",
                "A",
                "B",
                "C"
            ][f] + h);
            f += "." + d.toString(16).toUpperCase();
            f += "." + g + t;
            r && (f += "." + r.toString(16).toUpperCase());
            q && (f += "." + q.toString(16).toUpperCase());
            n && (f += "." + n.toString(16).toUpperCase());
            m && (f += "." + m.toString(16).toUpperCase());
            l && (f += "." + l.toString(16).toUpperCase());
            c && (f += "." + c.toString(16).toUpperCase());
            b.codec = f;
            b.frameRate = Pk(a);
            return b;
        }
        function Jk(a, b) {
            var c = 1;
            for(a > b && (c = -1); Math.abs(b - a) > 4294967296;)a += c * 8589934592;
            return a;
        }
        function Rk(a) {
            return Fk(a) < 0 ? !1 : !0;
        }
        function Fk(a) {
            for(var b = Math.min(1E3, a.length - 564), c = 0; c < b;){
                if (a[c] == 71 && a[c + 188] == 71 && a[c + 376] == 71) return c;
                var d = a.indexOf(71, c + 1);
                c = d >= 0 && d < b ? d : c + 1;
            }
            return -1;
        }
        O("shaka.util.TsParser", Ek);
        Ek.syncOffset = Fk;
        Ek.probe = Rk;
        Ek.prototype.getVideoInfo = Ek.prototype.yh;
        Ek.prototype.getVideoResolution = Ek.prototype.Al;
        Ek.prototype.getVideoNalus = Ek.prototype.yf;
        Ek.prototype.getCodecs = Ek.prototype.me;
        Ek.prototype.getStartTime = Ek.prototype.getStartTime;
        Ek.prototype.getVideoData = Ek.prototype.Ed;
        Ek.prototype.getAudioData = Ek.prototype.yb;
        Ek.prototype.getMetadata = Ek.prototype.getMetadata;
        Ek.prototype.parseNalus = Ek.prototype.Sh;
        Ek.prototype.parseAvcNalus = Ek.prototype.Yl;
        Ek.prototype.parse = Ek.prototype.parse;
        Ek.prototype.setDiscontinuitySequence = Ek.prototype.hg;
        Ek.prototype.clearData = Ek.prototype.clearData;
        Ek.Timescale = 9E4;
        var Qk = [
            100,
            110,
            122,
            244,
            44,
            83,
            86,
            118,
            128,
            138,
            139,
            134
        ];
        function Sk(a, b, c, d, e) {
            var f = this;
            this.g = a;
            this.O = c;
            this.C = d;
            this.X = b;
            this.l = new Map;
            this.F = new Map;
            this.Ia = new Map;
            this.h = null;
            this.Ga = !1;
            this.D = e || null;
            this.m = new Map;
            this.A = new fd;
            this.j = new Map;
            this.J = null;
            this.L = new Yg;
            this.ya = "";
            this.kb = !1;
            this.va = !0;
            this.M = !1;
            this.K = this.V = null;
            this.i = Tk(this, this.L);
            this.Oa = this.H = !1;
            this.G = new uh(function() {
                return Uk(f);
            });
            this.I = !1;
            this.P = "UNKNOWN";
            this.ab = this.jb = !1;
            this.hb = new Yg;
            this.o = !1;
            this.ua = null;
            this.W = new Map;
            this.ba = this.R = this.na = this.S = null;
            this.$ = new Yg;
            this.g.remote && (this.M = this.g.remote.state != "disconnected", this.A.u(this.g.remote, "connect", function() {
                f.M = f.g.remote.state != "disconnected";
            }), this.A.u(this.g.remote, "connecting", function() {
                f.M = f.g.remote.state != "disconnected";
            }), this.A.u(this.g.remote, "disconnect", function() {
                f.M = f.g.remote.state != "disconnected";
            }));
        }
        function Tk(a, b) {
            a.va = !0;
            if (window1.ManagedMediaSource) {
                a.K || (a.g.disableRemotePlayback = !0);
                var c = new ManagedMediaSource;
                a.A.u(c, "startstreaming", function() {
                    a.va = !0;
                });
                a.A.u(c, "endstreaming", function() {
                    a.va = !1;
                });
            } else c = new MediaSource;
            a.A.ra(c, "sourceopen", function() {
                URL.revokeObjectURL(a.ya);
                b.resolve();
            });
            a.A.ra(a.g, "playing", function() {
                a.kb = !0;
            });
            a.ya = Vk(c);
            Wk(a);
            a.C.useSourceElements ? (a.V = dk(a.ya), a.g.appendChild(a.V), a.K && a.g.appendChild(a.K), a.g.load()) : a.g.src = a.ya;
            return c;
        }
        function Xk(a, b, c) {
            if (a.g && window1.ManagedMediaSource && a.i && a.C.useSourceElements) {
                var d;
                ((d = a.K) == null ? void 0 : d.parentElement) === a.g && a.g.removeChild(a.K);
                a.K = dk(b, c);
                a.g.appendChild(a.K);
                a.g.disableRemotePlayback = !1;
            }
        }
        function Zk() {
            var a = 'video/mp4; codecs="avc1.42E01E",video/mp4; codecs="avc3.42E01E",video/mp4; codecs="hev1.1.6.L93.90",video/mp4; codecs="hvc1.1.6.L93.90",video/mp4; codecs="hev1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.20000000.L153.B0",video/mp4; codecs="hvc1.2.4.L120.b0",video/mp4; codecs="hvc1.2.4.L123.b0",video/mp4; codecs="vp9",video/mp4; codecs="vp09.00.10.08",video/mp4; codecs="av01.0.01M.08",video/mp4; codecs="av01.0.31M.10.0.111.09.16.09.0",video/mp4; codecs="av01.0.31M.10.0.112.09.18.09.0",video/mp4; codecs="dvh1.05.01",video/mp4; codecs="dvh1.08.01",video/mp4; codecs="dav1.10.01",video/mp4; codecs="dvh1.20.01",audio/mp4; codecs="mp4a.40.2",audio/mp4; codecs="ac-3",audio/mp4; codecs="ec-3",audio/mp4; codecs="ac-4.02.01.03",audio/mp4; codecs="opus",audio/mp4; codecs="flac",audio/mp4; codecs="dtsc",audio/mp4; codecs="dtse",audio/mp4; codecs="dtsx",audio/mp4; codecs="apac.31.00",video/webm; codecs="vp8",video/webm; codecs="vp9",video/webm; codecs="vp09.00.10.08",audio/webm; codecs="vorbis",audio/webm; codecs="opus",video/mp2t; codecs="avc1.42E01E",video/mp2t; codecs="avc3.42E01E",video/mp2t; codecs="hvc1.1.6.L93.90",video/mp2t; codecs="mp4a.40.2",video/mp2t; codecs="ac-3",video/mp2t; codecs="ec-3",text/vtt,application/mp4; codecs="wvtt",application/ttml+xml,application/mp4; codecs="stpp"'.split(",").concat(G(yf)), b = {};
            Xb();
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                if (Mf(c)) b[c] = !0;
                else if (Ad()) {
                    var d = Ff(c), e = rg(Gf(c), d);
                    d = wf(d, e);
                    b[c] = Si(d) || (of(d) ? !0 : !1);
                } else b[c] = Bd().canPlayType(c) != "";
                d = c.split(";")[0];
                b[d] = b[d] || b[c];
            }
            return b;
        }
        p = Sk.prototype;
        p.destroy = function() {
            return this.G.destroy();
        };
        function Uk(a) {
            var b, c, d, e, f, g, h, k, l, m, n, q, r, t, v;
            return H(function(w) {
                if (w.h == 1) {
                    b = [];
                    c = u(a.m);
                    for(d = c.next(); !d.done; d = c.next())for(e = d.value, f = u(e), g = f.next().value, h = f.next().value, k = h[0], l = g, a.m.set(l, h.slice(0, 1)), k && b.push(k.p.catch(Yf)), m = u(h.slice(1)), n = m.next(); !n.done; n = m.next())q = n.value, q.p.reject(new T(2, 7, 7003, void 0));
                    a.h && b.push(a.h.destroy());
                    return w.g(Promise.all(b), 2);
                }
                r = u(a.j.values());
                for(t = r.next(); !t.done; t = r.next())v = t.value, v.destroy();
                a.A && (a.A.release(), a.A = null);
                a.g && (Wk(a), a.g.load(), a.g.disableRemotePlayback = !1);
                a.g = null;
                a.V = null;
                a.K = null;
                a.C = null;
                a.i = null;
                a.h = null;
                a.X = null;
                a.l.clear();
                a.Ia.clear();
                a.j.clear();
                a.J = null;
                a.m.clear();
                a.D = null;
                a.W.clear();
                a.O = null;
                w.j();
            });
        }
        function Wk(a) {
            if (a.g) {
                a.g.removeAttribute("src");
                var b;
                ((b = a.V) == null ? void 0 : b.parentElement) === a.g && a.g.removeChild(a.V);
                var c;
                ((c = a.K) == null ? void 0 : c.parentElement) === a.g && a.g.removeChild(a.K);
            }
        }
        p.init = function(a, b, c, d) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? "UNKNOWN" : c;
            d = d === void 0 ? !1 : d;
            var e = this, f, g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) return f = Gc, n.g(e.L, 2);
                if (n.h != 3) {
                    if (!$k(e) && !al(e)) return n.B(3);
                    Ya("Expected MediaSource to be open during init(); reopening the media source.");
                    e.L = new Yg;
                    e.i = Tk(e, e.L);
                    return n.g(e.L, 3);
                }
                e.I = b;
                e.P = c;
                e.jb = d;
                e.ab = !e.I && e.P == "HLS" && !e.jb;
                e.W.clear();
                e.S = null;
                e.na = null;
                e.R = null;
                e.ba = null;
                e.$ = new Yg;
                g = u(a.keys());
                for(h = g.next(); !h.done; h = g.next())k = h.value, l = a.get(k), bl(e, k, l, l.codecs), e.o ? (e.m.set(f.ha, []), e.m.set(f.Ba, [])) : e.m.set(k, []);
                (m = a.get(f.ha)) && m.isAudioMuxedInVideo && (e.o = !0);
                n.j();
            });
        };
        function bl(a, b, c, d) {
            b == "audio" && d && (d = rg(d, c.mimeType));
            b == "video" && d && c.mimeType == "video/mp4" && (d = sg(d));
            var e = wf(c.mimeType, d);
            if (b == Ec) cl(a, e, a.I, c.external);
            else {
                var f = a.C.forceTransmux;
                if (!Si(e) || !a.I && yf.includes(e)) f = !0;
                var g = zf(c.mimeType, d);
                if (f) {
                    f = Cc("audio", (d || "").split(","));
                    d = Cc("video", (d || "").split(","));
                    if (f && d) {
                        a.o = !0;
                        bl(a, "audio", c, f);
                        bl(a, "video", c, d);
                        return;
                    }
                    if (d = of(g)) e = d(), a.j.set(b, e), e = e.convertCodecs(b, g);
                }
                g = e + a.C.addExtraFeaturesToSourceBuffer(e);
                vh(a.G);
                try {
                    var h = a.i.addSourceBuffer(g);
                } catch (k) {
                    throw new T(2, 3, 3015, k, "The mediaSource_ status was " + a.i.readyState + " expected 'open'", null);
                }
                a.I && (h.mode = dl);
                a.A.u(h, "error", function() {
                    var k = a.m.get(b)[0];
                    k.p.reject(new T(2, 3, 3014, a.g.error ? a.g.error.code : 0, k.uri));
                });
                a.A.u(h, "updateend", function() {
                    return el(a, b);
                });
                a.l.set(b, h);
                a.F.set(b, e);
                a.Ia.set(b, !!c.drmInfos.length);
            }
        }
        p.configure = function(a) {
            this.C = a;
            this.h && (this.h.D = a.modifyCueCallback);
        };
        function fl(a) {
            return a.va && !a.M && !a.H;
        }
        function cl(a, b, c, d) {
            a.h || (a.h = new If(a.X), a.h && (a.h.D = a.C.modifyCueCallback));
            var e = a.h, f = a.Ga;
            a = a.P;
            b == "application/cea-608" || b == "application/cea-708" ? e.i = null : (e.i = Kf.get(b)(), e.i.setSequenceMode ? e.i.setSequenceMode(c) : md("Text parsers w/ setSequenceMode", 'Text parsers should have a "setSequenceMode" method!'), e.i.setManifestType ? e.i.setManifestType(a) : md("Text parsers w/ setManifestType", 'Text parsers should have a "setManifestType" method!'), e.G = f, e.C = d);
        }
        function $k(a) {
            return a.H ? !1 : a.i ? a.i.readyState == "ended" : !0;
        }
        function al(a) {
            return a.H ? !1 : a.i ? a.i.readyState == "closed" : !0;
        }
        function gl(a, b) {
            return a.l.size ? b == Ec ? a.h.g : Uj(hl(a, b)) : null;
        }
        function il(a, b) {
            return a.l.size ? b == Ec ? a.h.h : Vj(hl(a, b)) : null;
        }
        function jl(a, b, c) {
            if (b == Ec) return a = a.h, a.h == null || a.h < c ? 0 : a.h - Math.max(c, a.g);
            a = hl(a, b);
            return Xj(a, c);
        }
        p.Nc = function() {
            var a = {
                total: this.H ? [] : Yj(this.g.buffered),
                audio: Yj(hl(this, "audio")),
                video: Yj(hl(this, "video")),
                text: []
            };
            if (this.h) {
                var b = this.h.g, c = this.h.h;
                b != null && c != null && a.text.push({
                    start: b,
                    end: c
                });
            }
            return a;
        };
        function hl(a, b) {
            if (a.H || a.M || al(a)) return null;
            try {
                return a.l.get(b).buffered;
            } catch (c) {
                return a.l.has(b), null;
            }
        }
        function kl(a, b, c, d, e, f, g) {
            g = g === void 0 ? !1 : g;
            var h = null, k = [], l = Fb(c);
            if (yf.includes(f)) c = pk(l), c.length && d && ((g = c.find(function(v) {
                return v.description === "com.apple.streaming.transportStreamTimestamp";
            })) && typeof g.data == "number" && (h = Math.round(g.data) / 1E3), a.O.onMetadata([
                {
                    cueTime: d.startTime,
                    data: l,
                    frames: c,
                    dts: d.startTime,
                    pts: d.startTime
                }
            ], 0, d.endTime));
            else if (f.includes("/mp4") && d && d.ia) {
                l = new Bh;
                var m = e.emsgSchemeIdUris != null && e.emsgSchemeIdUris.length > 0 || a.C.dispatchAllEmsgBoxes, n = [];
                m && l.qa("emsg", function(v) {
                    a: {
                        var w = e.emsgSchemeIdUris;
                        if (v.version === 0) {
                            var x = v.reader.Qd();
                            var y = v.reader.Qd();
                            var z = v.reader.Y();
                            var A = v.reader.Y();
                            var E = v.reader.Y();
                            var C = v.reader.Y();
                            var D = d.startTime + A / z;
                        } else z = v.reader.Y(), D = v.reader.Rd() / z + d.timestampOffset, A = D - d.startTime, E = v.reader.Y(), C = v.reader.Y(), x = v.reader.Qd(), y = v.reader.Qd();
                        v = v.reader.Wb(v.reader.getLength() - v.reader.Xa(), !0);
                        if (w && w.includes(x) || a.C.dispatchAllEmsgBoxes) {
                            if (x == "urn:mpeg:dash:event:2012") a.O.Xl();
                            else {
                                w = D;
                                if (x !== "https://aomedia.org/emsg/ID3" || E !== 4294967295) w += E / z;
                                z = {
                                    startTime: D,
                                    endTime: w,
                                    schemeIdUri: x,
                                    value: y,
                                    timescale: z,
                                    presentationTimeDelta: A,
                                    eventDuration: E,
                                    id: C,
                                    messageData: v
                                };
                                break a;
                            }
                        }
                        z = null;
                    }
                    z && n.push(z);
                });
                var q = d.ia.timescale;
                b = q && !isNaN(q);
                var r = 0, t = !1;
                b && l.qa("prft", function(v) {
                    var w = v.reader, x = v.version;
                    w.Y();
                    v = w.Y();
                    var y = w.Y();
                    v = v * 1E3 + y / 4294967296 * 1E3;
                    x === 0 ? w = w.Y() : (x = w.Y(), w = w.Y(), w = x * 4294967296 + w);
                    v = sk(v);
                    w = (new Map).set("detail", {
                        wallClockTime: v,
                        programStartDate: new Date(v - w / q * 1E3)
                    });
                    w = new R("prft", w);
                    a.O.onEvent(w);
                }).boxes([
                    "moof",
                    "traf"
                ], Gh).qa("tfdt", function(v) {
                    t || (r = Wi(v.reader, v.version).baseMediaDecodeTime / q, t = !0, m || v.parser.stop());
                });
                (m || b) && l.parse(c, !1, g);
                t && d.timestampOffset == 0 && (h = r);
                l = u(n);
                for(c = l.next(); !c.done; c = l.next())ll(a, c.value, d, h);
            } else f.includes("/mp4") || f.includes("/webm") || !Rk(l) || (a.W.has(b) || a.W.set(b, new Ek), k = a.W.get(b), k.clearData(), k.hg(d.i), k.parse(l), l = Lk(k, b), l != null && (h = l), k = k.getMetadata());
            return {
                timestamp: h,
                metadata: k
            };
        }
        function ll(a, b, c, d) {
            var e = rk(b.startTime, c.startTime + b.presentationTimeDelta / b.timescale);
            d && a.P == "HLS" && !e && (c = -d + c.startTime, b.startTime += c, b.endTime += c);
            a.O.Vl(b);
            !b.messageData || b.schemeIdUri != "https://aomedia.org/emsg/ID3" && b.schemeIdUri != "https://developer.apple.com/streaming/emsg-id3" || (c = pk(b.messageData), c.length && (d = b.startTime, a.O.onMetadata([
                {
                    cueTime: d,
                    data: b.messageData,
                    frames: c,
                    dts: d,
                    pts: d
                }
            ], 0, b.endTime)));
        }
        function ml(a, b, c, d, e, f, g, h, k, l, m) {
            g = g === void 0 ? !1 : g;
            h = h === void 0 ? !1 : h;
            k = k === void 0 ? !1 : k;
            l = l === void 0 ? !1 : l;
            var n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M;
            return H(function(L) {
                switch(L.h){
                    case 1:
                        n = Gc;
                        if (b != n.Va) {
                            L.B(2);
                            break;
                        }
                        if (a.P != "HLS") {
                            L.B(3);
                            break;
                        }
                        return L.g(a.hb, 4);
                    case 4:
                        q = L.i, a.h.A = q;
                    case 3:
                        return L.g(Nf(a.h, c, d ? d.startTime : null, d ? d.endTime : null, d ? d.T()[0] : null), 5);
                    case 5:
                        return L.return();
                    case 2:
                        if (l || !a.o) {
                            L.B(6);
                            break;
                        }
                        return L.g(ml(a, n.ha, c, d, e, f, g, h, k, !0), 7);
                    case 7:
                        return L.g(ml(a, n.Ba, c, d, e, f, g, h, k, !0), 8);
                    case 8:
                        return L.return();
                    case 6:
                        if (!a.l.has(b)) return L.return();
                        r = a.l.get(b).timestampOffset;
                        t = a.F.get(b);
                        a.j.has(b) && (t = a.j.get(b).getOriginalMimeType());
                        if (d && (v = kl(a, b, c, d, e, t, k), w = v.timestamp, x = v.metadata, w != null && (a.S == null && b == n.Ba && (a.S = w, a.na = d.startTime, a.R != null && (y = 0, a.na == a.ba && (y = a.S - a.R), a.$.resolve(y))), a.R == null && b == n.ha && (a.R = w, a.ba = d.startTime, a.S != null && (z = 0, a.na == a.ba && (z = a.S - a.R), a.$.resolve(z))), A = w, E = yf, !a.I && E.includes(a.F.get(b)) && (A = 0), C = d.startTime - A, D = Math.abs(r - C), (D >= .001 || g || h) && (!k || C > 0 || !r) && (r = C, a.ab && (nl(a, b, function() {
                            return ol(a, b);
                        }, null), nl(a, b, function() {
                            return pl(a, b, r);
                        }, null))), (B = b == n.Ba || !a.l.has(n.Ba)) && a.hb.resolve(r)), x.length)) a.O.onMetadata(x, r, d ? d.endTime : null);
                        f && b == n.Ba && (a.h || cl(a, "application/cea-608", a.I, !1), a.J || (J = t.split(";", 1)[0], a.J = new Fd(J)), d ? (F = Jd(a.J, c), F.length && Tf(a.h, F, r)) : a.J.init(c, h, m));
                        if (!a.j.has(b)) {
                            L.B(9);
                            break;
                        }
                        return L.g(a.j.get(b).transmux(c, e, d, a.i.duration, b), 10);
                    case 10:
                        I = L.i, ArrayBuffer.isView(I) ? c = I : (K = I, K.init != null && (N = K.init, nl(a, b, function() {
                            a.D && td(a.D, N, r, e);
                            a.l.get(b).appendBuffer(N);
                        }, d ? d.T()[0] : null)), c = K.data);
                    case 9:
                        c = ql(a, e, c, d, b);
                        if (!d || !a.I || b == n.Va) {
                            L.B(11);
                            break;
                        }
                        if (!g && !h) {
                            L.B(11);
                            break;
                        }
                        P = d.startTime;
                        if (a.P != "HLS" || a.o || b != n.ha || !a.l.has(n.Ba)) {
                            L.B(13);
                            break;
                        }
                        return L.g(a.$, 14);
                    case 14:
                        M = L.i, Math.abs(M) > .15 && (P -= M);
                    case 13:
                        nl(a, b, function() {
                            return ol(a, b);
                        }, null), nl(a, b, function() {
                            return pl(a, b, P);
                        }, null);
                    case 11:
                        return L.g(nl(a, b, function() {
                            var Q = c;
                            a.D && td(a.D, Q, r, e);
                            a.l.get(b).appendBuffer(Q);
                        }, d ? d.T()[0] : null), 15);
                    case 15:
                        L.j();
                }
            });
        }
        function rl(a, b) {
            var c = il(a, "video") || 0;
            Rf(a.h, b, c);
        }
        function sl(a) {
            a.h && Rf(a.h, "", 0);
        }
        p.remove = function(a, b, c, d) {
            var e = this, f, g;
            return H(function(h) {
                return h.h == 1 ? (f = Gc, a == f.Ba && e.J && (e.J.remove(d), g = e.h.g || 0, e.h.remove(g, c, !0)), a == f.Va ? h.g(e.h.remove(b, c), 0) : c > b ? h.g(nl(e, a, function() {
                    return tl(e, a, b, c);
                }, null), 5) : h.B(0)) : e.o ? h.g(nl(e, f.ha, function() {
                    return tl(e, f.ha, b, c);
                }, null), 0) : h.B(0);
            });
        };
        function ul(a, b) {
            var c;
            return H(function(d) {
                return d.h == 1 ? (c = Gc, b == c.Va ? a.h ? d.g(a.h.remove(0, Infinity), 0) : d.return() : b === c.Ba && a.J && a.h ? d.g(a.h.remove(0, Infinity, !0), 4) : d.B(4)) : d.h != 6 ? d.g(nl(a, b, function() {
                    return tl(a, b, 0, a.i.duration);
                }, null), 6) : a.o ? d.g(nl(a, c.ha, function() {
                    return tl(a, c.ha, 0, a.i.duration);
                }, null), 0) : d.B(0);
            });
        }
        p.flush = function(a) {
            var b = this, c;
            return H(function(d) {
                return d.h == 1 ? (c = Gc, a == c.Va ? d.return() : d.g(nl(b, a, function() {
                    b.g.currentTime -= .001;
                    el(b, a);
                }, null), 2)) : b.o ? d.g(nl(b, c.ha, function() {
                    var e = c.ha;
                    b.g.currentTime -= .001;
                    el(b, e);
                }, null), 0) : d.B(0);
            });
        };
        function vl(a, b, c, d, e, f, g, h, k) {
            var l, m, n;
            return H(function(q) {
                if (q.h == 1) {
                    l = Gc;
                    if (b == l.Va) return f || (a.h.A = c), Qf(a.h, d, e), q.return();
                    m = [];
                    return q.g(wl(a, b, g, h, k), 2);
                }
                n = q.i;
                n || (m.push(nl(a, b, function() {
                    return ol(a, b);
                }, null)), a.o && m.push(nl(a, l.ha, function() {
                    return ol(a, l.ha);
                }, null)));
                f || (m.push(nl(a, b, function() {
                    return pl(a, b, c);
                }, null)), a.o && m.push(nl(a, l.ha, function() {
                    return pl(a, l.ha, c);
                }, null)));
                if (d != 0 || e != Infinity) m.push(nl(a, b, function() {
                    return xl(a, b, d, e);
                }, null)), a.o && m.push(nl(a, l.ha, function() {
                    return xl(a, l.ha, d, e);
                }, null));
                return m.length ? q.g(Promise.all(m), 0) : q.B(0);
            });
        }
        function yl(a, b, c) {
            var d, e;
            return H(function(f) {
                if (f.h == 1) {
                    d = Gc;
                    if (b == d.Va) return f.return();
                    b == d.Ba && (a.hb = new Yg);
                    if (!a.I || (e = il(a, b)) && Math.abs(e - c) < .15) return f.return();
                    nl(a, b, function() {
                        return ol(a, b);
                    }, null);
                    a.o && nl(a, d.ha, function() {
                        return ol(a, d.ha);
                    }, null);
                    return f.g(nl(a, b, function() {
                        return pl(a, b, c);
                    }, null), 2);
                }
                return a.o ? f.g(nl(a, d.ha, function() {
                    return pl(a, d.ha, c);
                }, null), 0) : f.B(0);
            });
        }
        p.endOfStream = function(a) {
            var b = this;
            return H(function(c) {
                return c.g(zl(b, function() {
                    $k(b) || al(b) || (a ? b.i.endOfStream(a) : b.i.endOfStream());
                }), 0);
            });
        };
        p.Ab = function(a) {
            var b = this;
            return H(function(c) {
                return c.g(zl(b, function() {
                    if (b.C.durationReductionEmitsUpdateEnd && a < b.i.duration) for(var d = u(b.l.keys()), e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        var f = {
                            start: function() {},
                            p: new Yg,
                            uri: null
                        };
                        b.m.get(e).unshift(f);
                    }
                    b.i.duration = a;
                    b.ua = a;
                }), 0);
            });
        };
        p.getDuration = function() {
            return this.i.duration;
        };
        function Al(a, b, c) {
            H(function(d) {
                return a.G.g || a.g.error || a.M || a.H || $k(a) || al(a) ? d.return() : d.g(zl(a, function() {
                    $k(a) || al(a) || a.i.setLiveSeekableRange(b, c);
                }), 0);
            });
        }
        function Bl(a) {
            H(function(b) {
                return a.G.g || a.g.error || a.M || a.H || $k(a) || al(a) ? b.return() : b.g(zl(a, function() {
                    $k(a) || al(a) || a.i.clearLiveSeekableRange();
                }), 0);
            });
        }
        function tl(a, b, c, d) {
            if (d <= c) el(a, b);
            else {
                if (a.D) {
                    var e = a.D;
                    b === "video" && e.g && e.g.flushBuffer(c, d);
                }
                a.l.get(b).remove(c, d);
            }
        }
        function ol(a, b) {
            var c = a.l.get(b), d = c.appendWindowStart, e = c.appendWindowEnd;
            c.abort();
            c.appendWindowStart = d;
            c.appendWindowEnd = e;
            el(a, b);
        }
        function pl(a, b, c) {
            c < 0 && (c += .001);
            a.l.get(b).timestampOffset = c;
            el(a, b);
        }
        function xl(a, b, c, d) {
            var e = a.l.get(b);
            if (e.appendWindowEnd !== d || e.appendWindowStart !== c) e.appendWindowStart = 0, e.appendWindowEnd = d, e.appendWindowStart = c;
            el(a, b);
        }
        function el(a, b) {
            if (a.H || a.G.g) {
                var c = a.m.get(b);
                c && c.length && ((c = c[0]) && c.p && c.p.resolve(), a.m.set(b, []));
            } else if (c = a.m.get(b)[0]) c.p.resolve(), Cl(a, b);
        }
        function nl(a, b, c, d) {
            vh(a.G);
            c = {
                start: c,
                p: new Yg,
                uri: d
            };
            a.m.get(b).push(c);
            a.m.get(b).length == 1 && Dl(a, b);
            return c.p;
        }
        function zl(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z;
            return H(function(A) {
                switch(A.h){
                    case 1:
                        vh(a.G);
                        c = [];
                        d = Array.from(a.l.keys());
                        e = new Map;
                        f = u(d);
                        g = f.next();
                        for(h = {}; !g.done; h = {
                            ready: void 0
                        }, g = f.next())k = g.value, h.ready = new Yg, l = {
                            start: function(E) {
                                return function() {
                                    return E.ready.resolve();
                                };
                            }(h),
                            p: h.ready,
                            uri: null
                        }, m = a.m.get(k), m.push(l), c.push(h.ready), e.set(k, l), m.length == 1 && l.start();
                        A.m(2);
                        return A.g(Promise.all(c), 4);
                    case 4:
                        A.o(3);
                        break;
                    case 2:
                        n = A.l();
                        if (a.G.g) {
                            q = u(d);
                            for(r = q.next(); !r.done; r = q.next())t = r.value, v = a.m.get(t), e.has(t) && ad(v, e.get(t));
                            return A.return();
                        }
                        throw n;
                    case 3:
                        return A.m(5, 6), A.g(b(), 6);
                    case 6:
                        A.A();
                        w = u(d);
                        for(x = w.next(); !x.done; x = w.next())y = x.value, Cl(a, y);
                        A.C(0);
                        break;
                    case 5:
                        throw z = A.l(), new T(2, 3, 3015, z, a.g.error || "No error in the media element", null);
                }
            });
        }
        function Cl(a, b) {
            a.m.get(b).shift();
            Dl(a, b);
        }
        function Dl(a, b) {
            var c = a.m.get(b)[0];
            if (c) try {
                c.start();
            } catch (d) {
                d.name == "QuotaExceededError" ? c.p.reject(new T(2, 3, 3017, b)) : fl(a) ? c.p.reject(new T(2, 3, 3015, d, a.g.error || "No error in the media element", c.uri)) : c.p.reject(new T(2, 3, 3024, b)), Cl(a, b);
            }
        }
        function El(a, b) {
            a.X = b;
            a.h && (a.h.l = b);
        }
        function ql(a, b, c, d, e) {
            if (Bf(a.F.get(e)) != "mp4") return c;
            var f = d === null, g = a.Ia.get(e), h = a.O.Uk(), k = !1;
            d && d.ia && (k = d.ia.encrypted);
            d = d ? d.T()[0] : null;
            var l = Xb();
            a.C.correctEc3Enca && f && e === "audio" && (c = Ej(c));
            a.C.insertFakeEncryptionInInit && g && l.Sd(h, e) && (f ? c = Fj(b, c, d) : !k && l.Cj(e) && (c = Ij(c)));
            f && l.Fe() && (c = Lj(c));
            return c;
        }
        function Fl(a, b, c, d) {
            return nl(a, b, function() {
                if (b !== Ec) {
                    a.F.get(b);
                    if (Xb().Bb()) {
                        a.j.has(b) && (a.j.get(b).destroy(), a.j.delete(b));
                        d && a.j.set(b, d);
                        var e = c + a.C.addExtraFeaturesToSourceBuffer(c);
                        a.l.get(b).changeType(e);
                        a.F.set(b, c);
                    }
                    el(a, b);
                }
            }, null);
        }
        function Ol(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E;
            return H(function(C) {
                if (C.h == 1) {
                    if (a.H || a.M) return C.return();
                    c = Gc;
                    a.H = !0;
                    a.o = !1;
                    d = a.g.currentTime;
                    e = a.g.autoplay;
                    a.g.paused || (a.Oa = !0);
                    a.kb && (a.g.autoplay = !1);
                    C.F(2);
                    a.A.Ta();
                    f = u(a.j.values());
                    for(g = f.next(); !g.done; g = f.next())h = g.value, h.destroy();
                    k = u(a.l.values());
                    for(l = k.next(); !l.done; l = k.next()){
                        m = l.value;
                        try {
                            a.i.removeSourceBuffer(m);
                        } catch (D) {}
                    }
                    a.j.clear();
                    a.l.clear();
                    n = a.i.duration;
                    a.L = new Yg;
                    a.i = Tk(a, a.L);
                    return C.g(a.L, 4);
                }
                if (C.h != 2) {
                    !isNaN(n) && n ? a.i.duration = n : !isNaN(a.ua) && a.ua && (a.i.duration = a.ua);
                    q = new Yg;
                    r = a.i.sourceBuffers;
                    t = b.size;
                    v = 0;
                    w = function() {
                        v++;
                        v === t && (q.resolve(), a.A.Fa(r, "addsourcebuffer", w));
                    };
                    a.A.u(r, "addsourcebuffer", w);
                    x = u(b.keys());
                    for(y = x.next(); !y.done; y = x.next())z = y.value, A = b.get(z), bl(a, z, A, A.codecs);
                    (E = b.get(c.ha)) && E.isAudioMuxedInVideo && (a.o = !0);
                    a.o && !a.m.has(c.ha) && a.m.set(c.ha, []);
                    return C.g(q, 2);
                }
                C.A();
                a.H = !1;
                vh(a.G);
                a.A.ra(a.g, "loadedmetadata", function() {
                    a.G.g || (a.g.currentTime = d);
                });
                a.A.ra(a.g, "canplaythrough", function() {
                    a.G.g || (a.g.autoplay = e, a.Oa && (a.Oa = !1, a.g.play()));
                });
                return C.C(0);
            });
        }
        function Pl(a, b) {
            return zl(a, function() {
                return Ol(a, b);
            });
        }
        function Ql(a, b, c, d) {
            var e = !1, f = Cc("audio", (d || "").split(",")), g = Cc("video", (d || "").split(",")), h = g;
            b == "audio" && (h = f);
            h || (h = d);
            var k = wf(c, h), l = Ff(a.F.get(b)), m = a.C.forceTransmux;
            !Si(k) || !a.I && yf.includes(k) ? m = !0 : m || c == l || (m = !Xb().mg() && yf.includes(c));
            if (m && (a = zf(c, h), h = of(a))) {
                var n = h();
                f && g && (e = !0);
                k = n.convertCodecs(b, a);
            }
            !n && b === "video" && f && (k = wf(c, d));
            b = Cf(Gf(k));
            return {
                qc: n,
                Cm: e,
                Mi: Ff(k),
                codec: b,
                mimeType: k
            };
        }
        function Rl(a, b, c, d, e) {
            if (b == Ec) return {
                type: Sl,
                Rf: c,
                qc: null
            };
            var f = Cf(Gf(a.F.get(b))), g = Ff(a.F.get(b)), h = Ql(a, b, c, d), k = h.qc, l = h.Cm, m = h.Mi, n = h.codec;
            h = h.mimeType;
            var q = !0;
            l && a.F.has("audio") && (c = Ql(a, "audio", c, d), d = Cf(Gf(a.F.get("audio"))), q = Ff(a.F.get("audio")), q = d == c.codec && q == c.Mi, c.qc && c.qc.destroy());
            if (f === n && g === m && q) return {
                type: Sl,
                Rf: h,
                qc: k
            };
            f = !0;
            if (a.o && !e.has("audio") || l && k && !a.j.has(b)) f = !1;
            b = Xb();
            if (f && a.C.codecSwitchingStrategy === "smooth" && b.Bb()) return {
                type: Tl,
                Rf: h,
                qc: k
            };
            k && k.destroy();
            return {
                type: Ul,
                Rf: h,
                qc: null
            };
        }
        function wl(a, b, c, d, e) {
            var f, g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) {
                    f = Gc;
                    g = Rl(a, b, c, d, e);
                    h = g.type;
                    k = g.qc;
                    l = g.Rf;
                    if (m = e.get(f.ha)) a.o = m.isAudioMuxedInVideo;
                    if (h == Sl) return a.j.has(b) && !k ? (a.j.get(b).destroy(), a.j.delete(b)) : !a.j.has(b) && k ? a.j.set(b, k) : k && (a.j.has(b) && a.j.get(b).transmux !== k.transmux ? (a.j.get(b).destroy(), a.j.set(b, k)) : k.destroy()), n.return(!1);
                    if (h == Tl) return n.g(Fl(a, b, l, k), 3);
                    if (h != Ul) return n.B(3);
                    k && k.destroy();
                    return n.g(Pl(a, e), 3);
                }
                return n.return(!0);
            });
        }
        function Vl(a, b, c, d, e) {
            a = Rl(a, b, c, d, e);
            a.qc && a.qc.destroy();
            return a.type == Ul;
        }
        var Vk = window1.URL.createObjectURL, dl = "sequence", Sl = "none", Ul = "reset", Tl = "changeType";
        function Wl(a, b, c) {
            this.i = a;
            this.F = b;
            this.A = this.l = Infinity;
            this.h = 1;
            this.g = this.j = null;
            this.C = 0;
            this.D = !0;
            this.J = !1;
            this.I = 0;
            this.G = c === void 0 ? !0 : c;
            this.H = 0;
            this.o = !1;
            this.m = a;
        }
        p = Wl.prototype;
        p.getDuration = function() {
            return this.l;
        };
        p.Zk = function() {
            return this.h;
        };
        p.Pj = function(a) {
            this.i = a;
        };
        p.Ab = function(a) {
            this.l = a;
        };
        p.hl = function() {
            return this.i;
        };
        p.Mj = function(a) {
            this.C = a;
        };
        p.md = function(a) {
            a && !this.D && (this.J = !0);
            this.D = a;
        };
        p.ig = function(a) {
            this.A = a;
        };
        p.xf = function() {
            return this.A;
        };
        p.ii = function(a) {
            this.F = a;
        };
        p.Pk = function() {
            return this.F;
        };
        p.wj = function(a, b) {
            if (a.length != 0) {
                var c = (Date.now() + this.C) / 1E3;
                a = a.filter(function(e) {
                    return e.start + b < c;
                });
                if (a.length != 0) {
                    var d = a[a.length - 1].end + b;
                    this.Sf(a[0].start + b);
                    this.h = a.reduce(function(e, f) {
                        return Math.max(e, f.end - f.start);
                    }, this.h);
                    this.g = Math.max(this.g, d);
                    this.i != null && this.G && !this.o && (this.i = c - this.g - this.h);
                }
            }
        };
        p.Ae = function(a) {
            if (a.length != 0) {
                var b = a[0].startTime, c = a[0].endTime, d = (Date.now() + this.C) / 1E3;
                a = u(a);
                for(var e = a.next(); !e.done; e = a.next())e = e.value, d < e.startTime || (b = Math.min(b, e.startTime), c = Math.max(c, e.endTime), this.h = Math.max(this.h, e.endTime - e.startTime));
                this.Sf(b);
                this.g = Math.max(this.g, c);
                this.i != null && this.G && !this.o && (this.i = d - this.g - this.h);
            }
        };
        p.vj = function(a, b) {
            this.Sf(a);
            b == Infinity || this.U() || (this.g = Math.max(this.g, b));
        };
        p.$k = function() {
            return this.g;
        };
        p.Mf = function() {
            this.o = !0;
        };
        p.Kl = function() {
            return this.o;
        };
        p.ki = function(a) {
            this.m = a;
        };
        p.Tk = function() {
            return this.m;
        };
        p.Sf = function(a) {
            this.j == null ? this.j = a : this.J || (this.j = Math.min(this.j, a));
        };
        p.Oh = function(a) {
            this.h = Math.max(this.h, a);
        };
        p.offset = function(a) {
            this.j != null && (this.j += a);
            this.g != null && (this.g += a);
        };
        p.U = function() {
            return this.l == Infinity && !this.D;
        };
        p.fd = function() {
            return this.l != Infinity && !this.D;
        };
        p.Hb = function() {
            return Math.max(this.I, this.Pc() - this.A);
        };
        p.Sj = function(a) {
            this.I = a;
        };
        p.Pc = function() {
            return this.U() || this.fd() ? Math.min(Math.max(0, (Date.now() + this.C) / 1E3 - this.h - this.i) + this.H, this.l) : this.g ? Math.min(this.g, this.l) : this.l;
        };
        p.pe = function(a) {
            var b = Math.max(this.j, this.I);
            return this.A == Infinity ? Math.ceil(b * 1E3) / 1E3 : Math.max(b, Math.min(this.Pc() - this.A + a, this.Gb()));
        };
        p.cc = function() {
            return this.pe(0);
        };
        p.Gb = function() {
            return Math.max(0, this.Pc() - (this.U() || this.fd() ? this.F : 0));
        };
        p.hk = function() {
            return this.i == null || this.g != null && this.G ? !1 : !0;
        };
        p.Lj = function(a) {
            this.H = a;
        };
        p.Fk = function() {
            return this.H;
        };
        O("shaka.media.PresentationTimeline", Wl);
        Wl.prototype.getAvailabilityTimeOffset = Wl.prototype.Fk;
        Wl.prototype.setAvailabilityTimeOffset = Wl.prototype.Lj;
        Wl.prototype.usingPresentationStartTime = Wl.prototype.hk;
        Wl.prototype.getSeekRangeEnd = Wl.prototype.Gb;
        Wl.prototype.getSeekRangeStart = Wl.prototype.cc;
        Wl.prototype.getSafeSeekRangeStart = Wl.prototype.pe;
        Wl.prototype.getSegmentAvailabilityEnd = Wl.prototype.Pc;
        Wl.prototype.setUserSeekStart = Wl.prototype.Sj;
        Wl.prototype.getSegmentAvailabilityStart = Wl.prototype.Hb;
        Wl.prototype.isInProgress = Wl.prototype.fd;
        Wl.prototype.isLive = Wl.prototype.U;
        Wl.prototype.offset = Wl.prototype.offset;
        Wl.prototype.notifyMaxSegmentDuration = Wl.prototype.Oh;
        Wl.prototype.notifyMinSegmentStartTime = Wl.prototype.Sf;
        Wl.prototype.getInitialProgramDateTime = Wl.prototype.Tk;
        Wl.prototype.setInitialProgramDateTime = Wl.prototype.ki;
        Wl.prototype.isStartTimeLocked = Wl.prototype.Kl;
        Wl.prototype.lockStartTime = Wl.prototype.Mf;
        Wl.prototype.getMaxSegmentEndTime = Wl.prototype.$k;
        Wl.prototype.notifyPeriodDuration = Wl.prototype.vj;
        Wl.prototype.notifySegments = Wl.prototype.Ae;
        Wl.prototype.notifyTimeRange = Wl.prototype.wj;
        Wl.prototype.getDelay = Wl.prototype.Pk;
        Wl.prototype.setDelay = Wl.prototype.ii;
        Wl.prototype.getSegmentAvailabilityDuration = Wl.prototype.xf;
        Wl.prototype.setSegmentAvailabilityDuration = Wl.prototype.ig;
        Wl.prototype.setStatic = Wl.prototype.md;
        Wl.prototype.setClockOffset = Wl.prototype.Mj;
        Wl.prototype.getPresentationStartTime = Wl.prototype.hl;
        Wl.prototype.setDuration = Wl.prototype.Ab;
        Wl.prototype.setPresentationStartTime = Wl.prototype.Pj;
        Wl.prototype.getMaxSegmentDuration = Wl.prototype.Zk;
        Wl.prototype.getDuration = Wl.prototype.getDuration;
        function Xl(a, b, c, d) {
            var e = this;
            this.A = d;
            this.g = a;
            this.F = b;
            this.h = c;
            this.l = new fd;
            this.o = !1;
            this.m = 0;
            this.D = !1;
            this.H = this.G = 0;
            this.j = Yl(this);
            this.C = !1;
            this.l.u(a, "waiting", function() {
                return Zl(e);
            });
            this.i = new Uf(function() {
                Zl(e);
            }).xa(this.h.gapJumpTimerTime);
        }
        Xl.prototype.release = function() {
            this.l && (this.l.release(), this.l = null);
            this.i != null && (this.i.stop(), this.i = null);
            this.j && (this.j.release(), this.j = null);
            this.g = this.F = this.A = null;
        };
        Xl.prototype.Md = function() {
            this.C = !0;
            this.i && this.i.xa(this.h.gapJumpTimerTime);
            Zl(this);
        };
        function Zl(a) {
            if (a.g.readyState != 0) {
                if (a.g.seeking) {
                    if (!a.o) return;
                } else a.o = !1;
                if (!a.g.paused || a.g.currentTime == a.m && (a.g.autoplay || a.g.currentTime != a.m)) {
                    if (!a.j || !$l(a.j)) {
                        var b = a.g.currentTime, c = a.g.buffered, d = Zj(c, b, a.h.gapDetectionThreshold);
                        if (d == null && a.j && !$l(a.j)) {
                            for(var e = Yj(c), f = 0; f < e.length - 1; f++)if (Math.abs(b - e[f].end) < .1 && e[f + 1].start > e[f].end) {
                                d = f + 1;
                                break;
                            }
                        }
                        d == null || d == 0 && !a.C || (e = c.start(d), (f = a.h.gapPadding) && (e = Math.ceil((e + f) * 100) / 100), e >= a.F.Gb() || e - b < .001 || (d != 0 && c.end(d - 1), am(a, e), b == a.m && (a.m = e), a.G++, a.A(new R("gapjumped"))));
                    }
                }
            }
        }
        function am(a, b) {
            a.D = !0;
            a.l.ra(a.g, "seeked", function() {
                a.D = !1;
            });
            a.g.currentTime = b;
        }
        function Yl(a) {
            if (!a.h.stallEnabled) return null;
            var b = a.h.stallThreshold, c = a.h.stallSkip;
            return new bm(new cm(a.g), b, function(d, e, f) {
                var g;
                return H(function(h) {
                    if (h.h == 1) return g = Yj(a.g.buffered), g.length ? c ? (a.g.currentTime += c, h.B(2)) : h.g(a.g.play(), 3) : h.return();
                    if (h.h != 2) {
                        if (!a.g) return h.return();
                        a.g.pause();
                        a.g.play();
                    }
                    f == 0 && (a.H++, a.A(new R("stalldetected")));
                    h.j();
                });
            });
        }
        function bm(a, b, c) {
            this.i = a;
            this.A = dm(a);
            this.h = a.g.currentTime;
            this.m = Date.now() / 1E3;
            this.l = this.g = 0;
            this.o = b;
            this.j = c;
        }
        bm.prototype.release = function() {
            this.i && this.i.release();
            this.j = this.i = null;
        };
        function $l(a) {
            var b = a.i, c = dm(b), d = b.g.currentTime, e = Date.now() / 1E3;
            if (a.h != d || a.A != c) a.m = e, a.h = d, a.A = c, a.g = 0;
            d = e - a.m;
            if (c = d >= a.o && c && a.g < 3 && (a.g == 0 || e - a.l >= a.o)) a.j && a.j(a.h, d, a.g), a.g++, a.l = e, a.h = b.g.currentTime;
            return c;
        }
        function cm(a) {
            var b = this;
            this.g = a;
            this.h = new fd;
            this.i = !1;
            this.h.u(this.g, "audiofocuspaused", function() {
                b.i = !0;
            });
            this.h.u(this.g, "audiofocusgranted", function() {
                b.i = !1;
            });
            this.h.u(this.g, "audiofocuslost", function() {
                b.i = !0;
            });
        }
        function dm(a) {
            if (a.g.paused || a.g.playbackRate == 0 || a.i || a.g.buffered.length == 0) var b = !1;
            else a: {
                b = a.g.currentTime;
                a = u(Yj(a.g.buffered));
                for(var c = a.next(); !c.done; c = a.next())if (c = c.value, !(b < c.start - .1 || b > c.end - .5)) {
                    b = !0;
                    break a;
                }
                b = !1;
            }
            return b;
        }
        cm.prototype.release = function() {
            this.h && this.h.release();
            this.h = null;
        };
        function em(a, b, c, d) {
            b == HTMLMediaElement.HAVE_NOTHING || a.readyState >= b ? d() : (b = fm.value().get(b), c.ra(a, b, d));
        }
        var fm = new Kb(function() {
            return new Map([
                [
                    HTMLMediaElement.HAVE_METADATA,
                    "loadedmetadata"
                ],
                [
                    HTMLMediaElement.HAVE_CURRENT_DATA,
                    "loadeddata"
                ],
                [
                    HTMLMediaElement.HAVE_FUTURE_DATA,
                    "canplay"
                ],
                [
                    HTMLMediaElement.HAVE_ENOUGH_DATA,
                    "canplaythrough"
                ]
            ]);
        });
        function gm(a, b, c, d) {
            var e = this;
            this.g = a;
            this.m = b;
            this.A = c;
            this.l = null;
            this.j = function() {
                e.l == null && (e.l = d());
                return e.l;
            };
            this.o = !1;
            this.h = new fd;
            this.i = new hm(a);
            em(this.g, HTMLMediaElement.HAVE_METADATA, this.h, function() {
                im(e, e.j());
            });
        }
        gm.prototype.release = function() {
            this.h && (this.h.release(), this.h = null);
            this.i != null && (this.i.release(), this.i = null);
            this.m = function() {};
            this.g = null;
        };
        function jm(a) {
            return a.o ? a.g.currentTime : a.j();
        }
        function km(a, b) {
            a.g.readyState > 0 ? lm(a.i, b) : em(a.g, HTMLMediaElement.HAVE_METADATA, a.h, function() {
                im(a, a.j());
            });
        }
        function im(a, b) {
            Math.abs(a.g.currentTime - b) < .001 ? mm(a) : (a.h.ra(a.g, "seeking", function() {
                mm(a);
            }), lm(a.i, a.g.currentTime && a.g.currentTime != 0 ? a.g.currentTime : b));
        }
        function mm(a) {
            a.o = !0;
            a.h.u(a.g, "seeking", function() {
                return a.m();
            });
            a.A(a.g.currentTime);
        }
        function hm(a) {
            var b = this;
            this.g = a;
            this.m = 10;
            this.j = this.l = this.i = 0;
            this.h = new Uf(function() {
                b.i <= 0 ? b.h.stop() : b.g.currentTime != b.l || b.g.currentTime === b.j ? b.h.stop() : (b.g.currentTime = b.j, b.i--);
            });
        }
        hm.prototype.release = function() {
            this.h && (this.h.stop(), this.h = null);
            this.g = null;
        };
        function lm(a, b) {
            a.l = a.g.currentTime;
            a.j = b;
            a.i = a.m;
            a.g.currentTime = b;
            a.h.xa(.1);
        }
        function nm(a) {
            this.g = a;
            this.i = !1;
            this.h = null;
            this.j = new fd;
        }
        p = nm.prototype;
        p.ready = function() {
            function a() {
                if (b.h == null || b.h == 0 && b.g.duration != Infinity) b.i = !0;
                else {
                    var c = b.g.currentTime, d = null;
                    if (typeof b.h === "number") d = b.h;
                    else if (b.h instanceof Date) {
                        var e = om(b);
                        e !== null && (d = b.h.getTime() / 1E3 - e, d = pm(b, d));
                    }
                    d == null ? b.i = !0 : (d < 0 && (d = Math.max(0, c + d)), c != d ? (b.j.ra(b.g, "seeking", function() {
                        b.i = !0;
                    }), b.g.currentTime = d) : b.i = !0);
                }
            }
            var b = this;
            em(this.g, HTMLMediaElement.HAVE_FUTURE_DATA, this.j, function() {
                a();
            });
        };
        p.release = function() {
            this.j && (this.j.release(), this.j = null);
            this.g = null;
        };
        p.Ag = function(a) {
            this.h = this.i ? this.h : a;
        };
        p.ee = function() {
            var a = this.i ? this.g.currentTime : this.h;
            a instanceof Date && (a = a.getTime() / 1E3 - (om(this) || 0), a = pm(this, a));
            return a || 0;
        };
        p.Fi = function() {
            return 0;
        };
        p.Di = function() {
            return 0;
        };
        p.Ei = function() {
            return !1;
        };
        p.uj = function() {};
        p.jj = function() {
            var a = Vj(this.g.buffered);
            return a != null && a >= this.g.duration - 1;
        };
        function om(a) {
            return a.g.getStartDate && (a = a.g.getStartDate().getTime(), !isNaN(a)) ? a / 1E3 : null;
        }
        function pm(a, b) {
            a = a.g.seekable;
            a.length > 0 && (b = Math.max(a.start(0), b), b = Math.min(a.end(a.length - 1), b));
            return b;
        }
        function qm(a, b, c, d, e, f) {
            var g = this;
            this.h = a;
            this.g = b.presentationTimeline;
            this.l = c;
            this.A = e;
            this.o = null;
            this.i = new Xl(a, b.presentationTimeline, c, f);
            this.j = new gm(a, function() {
                a: {
                    var h = g.i;
                    h.o = !0;
                    h.C = !1;
                    h.i && h.i.xa(h.h.gapJumpTimerTime);
                    Zl(h);
                    var k = jm(g.j);
                    h = rm(g, k);
                    if (!Ui() && Math.abs(h - k) > .001) {
                        k = !1;
                        var l = Xb().Hj();
                        if (l) {
                            var m = Date.now() / 1E3;
                            if (!g.o || g.o < m - l) g.o = m, k = !0;
                        } else k = !0;
                        if (k) {
                            km(g.j, h);
                            h = void 0;
                            break a;
                        }
                    }
                    g.A();
                    h = void 0;
                }
                return h;
            }, function(h) {
                var k = g.i;
                k.g.seeking && !k.o && (k.o = !0, k.m = h);
                k.i && k.i.xa(k.h.gapJumpTimerTime);
                Zl(k);
            }, function() {
                return sm(g, d);
            });
            this.m = new Uf(function() {
                if (g.h.readyState != 0 && !g.h.paused) {
                    var h = jm(g.j), k = g.g.cc(), l = g.g.Gb();
                    l - k < 3 && (k = l - 3);
                    h < k && (h = rm(g, h), g.h.currentTime = h);
                }
            });
        }
        p = qm.prototype;
        p.ready = function() {
            this.m.xa(.25);
        };
        p.release = function() {
            this.j && (this.j.release(), this.j = null);
            this.i && (this.i.release(), this.i = null);
            this.m && (this.m.stop(), this.m = null);
            this.h = this.j = this.g = this.l = null;
            this.A = function() {};
        };
        p.Ag = function(a) {
            km(this.j, sm(this, a));
        };
        p.ee = function() {
            var a = jm(this.j);
            return this.h.readyState > 0 && !this.h.paused ? tm(this, a) : a;
        };
        p.Fi = function() {
            return this.i.H;
        };
        p.Di = function() {
            return this.i.G;
        };
        p.Ei = function() {
            return this.i.D;
        };
        function sm(a, b) {
            b == null ? b = a.g.getDuration() < Infinity ? a.g.cc() : a.g.Gb() : b instanceof Date ? b = b.getTime() / 1E3 - (a.g.m || a.g.i) : b < 0 && (b = a.g.Gb() + b);
            return um(a, tm(a, b));
        }
        p.uj = function() {
            this.i.Md();
        };
        p.jj = function() {
            if (this.g.U()) {
                var a = this.g.Pc(), b = Vj(this.h.buffered);
                if (b != null && b >= a) return !0;
            }
            return !1;
        };
        function um(a, b) {
            var c = a.g.getDuration();
            return b >= c ? c - a.l.durationBackoff : b;
        }
        function rm(a, b) {
            var c = a.l.rebufferingGoal, d = a.l.safeSeekOffset, e = a.g.cc(), f = a.g.Gb(), g = a.g.getDuration();
            f - e < 3 && (e = f - 3);
            var h = a.g.pe(c), k = a.g.pe(d);
            c = a.g.pe(c + d);
            return b >= g ? um(a, b) : b > f ? f - a.l.safeSeekEndOffset : b < e ? a.g.U() && a.l.returnToEndOfLiveWindowWhenOutside ? f - a.l.safeSeekEndOffset : Wj(a.h.buffered, k) ? k : c : b >= h || Wj(a.h.buffered, b) ? b : c;
        }
        function tm(a, b) {
            var c = a.g.cc();
            if (b < c) return c;
            a = a.g.Gb();
            return b > a ? a : b;
        }
        function vm(a) {
            this.g = a;
            this.m = null;
            this.i = 0;
            this.o = !1;
        }
        p = vm.prototype;
        p.getNumReferences = function() {
            return this.g.length;
        };
        p.getNumEvicted = function() {
            return this.i;
        };
        p.release = function() {
            this.o || (this.g = [], this.m && this.m.stop(), this.m = null);
        };
        p.Rl = function() {
            this.o = !0;
        };
        p.xb = function(a) {
            for(var b = u(this.g), c = b.next(); !c.done; c = b.next())a(c.value);
        };
        p.Fb = function() {
            return this.g[0] || null;
        };
        p.find = function(a) {
            var b = this.g.length - 1;
            if (b < 0) return null;
            if (a < this.g[0].startTime) return this.i;
            var c = dd(this.g, function(e) {
                return e.startTime <= a;
            }) - 1;
            if (c < 0) return null;
            var d = this.g[c];
            b = c < b ? this.g[c + 1].startTime : d.endTime;
            return a >= d.startTime && a < b ? c + this.i : null;
        };
        p.get = function(a) {
            if (this.g.length == 0) return null;
            a -= this.i;
            return a < 0 || a >= this.g.length ? null : this.g[a];
        };
        p.offset = function(a) {
            if (!this.o) for(var b = u(this.g), c = b.next(); !c.done; c = b.next())c.value.offset(a);
        };
        p.Of = function(a) {
            if (!this.o && a.length) {
                var b = Math.round(a[0].startTime * 1E3) / 1E3, c = dd(this.g, function(d) {
                    return Math.round(d.startTime * 1E3) / 1E3 < b;
                });
                this.g.length = c;
                this.g.push.apply(this.g, G(a));
            }
        };
        p.ye = function(a, b) {
            for(var c = Math.max(b, this.g.length > 0 ? this.g[0].startTime : -Infinity), d = 0; d < a.length && a[d].endTime <= c;)d++;
            d > 0 && (a = a.slice(d));
            this.Of(a);
            this.$a(b);
        };
        p.$a = function(a) {
            if (!this.o) {
                var b = dd(this.g, function(c) {
                    return c.endTime <= a;
                });
                b > 0 && (this.i += b, this.g = this.g.slice(b));
            }
        };
        p.zd = function(a, b, c) {
            c = c === void 0 ? !1 : c;
            if (!this.o) {
                for(; this.g.length;)if (this.g[this.g.length - 1].startTime >= b) this.g.pop();
                else break;
                var d = dd(this.g, function(e) {
                    return e.endTime <= a;
                });
                d > 0 && (c || (this.i += d), this.g = this.g.slice(d));
                this.g.length != 0 && (c = this.g[this.g.length - 1], b = new Oj(c.startTime, b, c.D, c.startByte, c.endByte, c.ia, c.timestampOffset, c.appendWindowStart, c.appendWindowEnd, c.g, c.tilesLayout, c.C, c.h, c.status, c.aesKey), b.mimeType = c.mimeType, b.codecs = c.codecs, b.i = c.i, this.g[this.g.length - 1] = b);
            }
        };
        p.rg = function(a, b) {
            var c = this;
            this.o || (this.m && this.m.stop(), this.m = new Uf(function() {
                var d = b();
                d ? c.g.push.apply(c.g, G(d)) : (c.m.stop(), c.m = null);
            }), this.m.xa(a));
        };
        vm.prototype[Symbol.iterator] = function() {
            return this.ac(0);
        };
        vm.prototype.ac = function(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? !1 : c;
            var d = this.find(a);
            if (d == null) return null;
            var e = this.get(d);
            c ? d++ : d--;
            var f = -1;
            if (e && e.g.length > 0) for(var g = e.g.length - 1; g >= 0; --g){
                var h = e.g[g];
                if (a >= h.startTime && a < h.endTime) {
                    if (!b) {
                        for(; g && !h.l;)g--, h = e.g[g];
                        if (!h.l) return Ya("No independent partial segment found!"), null;
                    }
                    c ? d-- : d++;
                    f = g - 1;
                    break;
                }
            }
            return new wm(this, d, f, c);
        };
        vm.prototype.lf = function() {
            return -1;
        };
        function xm(a, b, c) {
            a = new Oj(a, a + b, function() {
                return c;
            }, 0, null, null, a, a, a + b);
            return new vm([
                a
            ]);
        }
        O("shaka.media.SegmentIndex", vm);
        vm.forSingleSegment = xm;
        vm.prototype.getIteratorForTime = vm.prototype.ac;
        vm.prototype.updateEvery = vm.prototype.rg;
        vm.prototype.fit = vm.prototype.zd;
        vm.prototype.evict = vm.prototype.$a;
        vm.prototype.mergeAndEvict = vm.prototype.ye;
        vm.prototype.offset = vm.prototype.offset;
        vm.prototype.get = vm.prototype.get;
        vm.prototype.find = vm.prototype.find;
        vm.prototype.markImmutable = vm.prototype.Rl;
        vm.prototype.release = vm.prototype.release;
        vm.prototype.getNumEvicted = vm.prototype.getNumEvicted;
        vm.prototype.getNumReferences = vm.prototype.getNumReferences;
        function wm(a, b, c, d) {
            this.i = a;
            this.h = b;
            this.g = c;
            this.reverse = d;
        }
        p = wm.prototype;
        p.Wd = function(a) {
            this.reverse = a;
        };
        p.Ak = function() {
            return this.h;
        };
        p.current = function() {
            var a = this.i.get(this.h);
            a && a.g.length > 0 && a.m && this.g >= a.g.length && (this.h++, this.g = 0, a = this.i.get(this.h));
            return a && a.g.length > 0 ? a.g[this.g] : a;
        };
        p.next = function() {
            var a = this.i.get(this.h);
            this.reverse ? a && a.g.length > 0 ? (this.g--, this.g < 0 && (this.h--, this.g = (a = this.i.get(this.h)) && a.g.length > 0 ? a.g.length - 1 : 0)) : (this.h--, this.g = 0) : a && a.g.length > 0 ? (this.g++, a.m && this.g == a.g.length && (this.h++, this.g = 0)) : (this.h++, this.g = 0);
            a = this.current();
            return {
                value: a,
                done: !a
            };
        };
        p.ai = function() {
            var a = this.current();
            if (a && a.hd && !a.l && (a = this.i.get(this.h)) && a.g.length > 0) for(var b = a.g[this.g]; b.l && !(this.g <= 0);)this.g--, b = a.g[this.g];
        };
        O("shaka.media.SegmentIterator", wm);
        wm.prototype.resetToLastIndependent = wm.prototype.ai;
        wm.prototype.next = wm.prototype.next;
        wm.prototype.current = wm.prototype.current;
        wm.prototype.currentPosition = wm.prototype.Ak;
        wm.prototype.setReverse = wm.prototype.Wd;
        function ym() {
            vm.call(this, []);
            this.h = [];
        }
        oa(ym, vm);
        p = ym.prototype;
        p.clone = function() {
            var a = new ym;
            a.h = this.h.slice();
            a.i = this.i;
            return a;
        };
        p.release = function() {
            this.h = [];
        };
        p.xb = function(a) {
            for(var b = u(this.h), c = b.next(); !c.done; c = b.next())c.value.xb(a);
        };
        function zm(a, b) {
            a = u(a.h);
            for(var c = a.next(); !c.done; c = a.next())b(c.value);
        }
        p.find = function(a) {
            for(var b = this.i, c = u(this.h), d = c.next(); !d.done; d = c.next()){
                d = d.value;
                var e = d.find(a);
                if (e != null) return e + b;
                b += d.getNumEvicted() + d.getNumReferences();
            }
            return null;
        };
        function Am(a, b) {
            a = u(a.h);
            for(var c = a.next(); !c.done; c = a.next())if (c = c.value, c.find(b) != null) return c.lf();
            return -1;
        }
        p.get = function(a) {
            for(var b = this.i, c = u(this.h), d = c.next(); !d.done; d = c.next()){
                d = d.value;
                var e = d.get(a - b);
                if (e) return e;
                e = d.getNumReferences();
                b += d.getNumEvicted() + e;
            }
            return null;
        };
        p.offset = function() {};
        p.Of = function() {};
        p.$a = function(a) {
            if (this.h.length) {
                var b = this.h[0];
                b.$a(a);
                b.getNumReferences() == 0 && (this.h.shift(), this.i += b.getNumEvicted(), b.release(), this.$a(a));
            }
        };
        p.ye = function() {};
        p.zd = function() {};
        p.rg = function() {};
        O("shaka.media.MetaSegmentIndex", ym);
        ym.prototype.updateEvery = ym.prototype.rg;
        ym.prototype.fit = ym.prototype.zd;
        ym.prototype.mergeAndEvict = ym.prototype.ye;
        ym.prototype.evict = ym.prototype.$a;
        ym.prototype.merge = ym.prototype.Of;
        ym.prototype.offset = ym.prototype.offset;
        ym.prototype.get = ym.prototype.get;
        ym.prototype.find = ym.prototype.find;
        ym.prototype.forEachTopLevelReference = ym.prototype.xb;
        ym.prototype.release = ym.prototype.release;
        function Bm(a) {
            var b = this;
            this.g = a;
            this.j = !1;
            this.h = this.g.wh();
            this.i = new Uf(function() {
                b.g.isPaused() || b.g.Tl(b.h * .25);
            });
        }
        Bm.prototype.release = function() {
            this.set(this.Cd());
            this.i && (this.i.stop(), this.i = null);
            this.g = null;
        };
        Bm.prototype.set = function(a) {
            this.h = a;
            Cm(this);
        };
        Bm.prototype.Cd = function() {
            return this.g.Cd();
        };
        function Cm(a) {
            a.i.stop();
            var b = a.j ? 0 : a.h;
            if (b >= 0 && b <= 16) try {
                a.g.wh() != b && a.g.Qj(b);
                return;
            } catch (c) {}
            a.i.xa(.25);
            a.g.wh() != 0 && a.g.Qj(0);
        }
        function Dm(a) {
            var b = this;
            this.j = a;
            this.h = new fd;
            this.g = new Set;
            this.i = new Uf(function() {
                Em(b, !1);
            }).La();
            a.paused || this.i.xa(.25);
            this.h.u(a, "playing", function() {
                b.i.La().xa(.25);
            });
            this.h.u(a, "pause", function() {
                b.i.stop();
            });
            this.h.u(a, "seeked", function() {
                b.i.La();
                a.paused || b.i.xa(.25);
            });
        }
        Dm.prototype.release = function() {
            this.h && (this.h.release(), this.h = null);
            this.i.stop();
            for(var a = u(this.g), b = a.next(); !b.done; b = a.next())b.value.release();
            this.g.clear();
        };
        function Em(a, b) {
            var c = a.j.currentTime;
            a = u(a.g);
            for(var d = a.next(); !d.done; d = a.next())d.value.j(c, b);
        }
        function Fm(a) {
            fb.call(this);
            this.g = new Map;
            this.h = a;
        }
        oa(Fm, fb);
        Fm.prototype.release = function() {
            this.g.clear();
            fb.prototype.release.call(this);
        };
        function Gm(a, b) {
            var c = a.g.get(b);
            c || (c = {
                Ee: [],
                Tg: null,
                contentType: b
            }, a.g.set(b, c));
            return c;
        }
        function Hm(a, b, c) {
            var d = Gm(a, b.contentType);
            Im(a, d);
            a = {
                Kd: b,
                position: c
            };
            d = d.Ee;
            b = d.findIndex(function(e) {
                return e.position >= c;
            });
            b >= 0 ? d.splice(b, d[b].position == c ? 1 : 0, a) : d.push(a);
        }
        Fm.prototype.j = function(a) {
            for(var b = u(this.g.values()), c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = c.Tg;
                a: {
                    var e = c.Ee;
                    for(var f = e.length - 1; f >= 0; f--){
                        var g = e[f];
                        if (g.position <= a) {
                            e = g.Kd;
                            break a;
                        }
                    }
                    e = null;
                }
                f = e && !(d === e || d && e && d.bandwidth == e.bandwidth && d.audioSamplingRate == e.audioSamplingRate && d.codecs == e.codecs && d.contentType == e.contentType && d.frameRate == e.frameRate && d.height == e.height && d.mimeType == e.mimeType && d.channelsCount == e.channelsCount && d.pixelAspectRatio == e.pixelAspectRatio && d.width == e.width);
                g = e && d && e.label && d.label && d.label !== e.label;
                var h = e && d && e.language && d.language && d.language !== e.language;
                d = e && d && e.roles && d.roles && !ed(d.roles, e.roles);
                (g || h || d) && Jm(this, a, e.contentType) && (c.Tg = e, d = new R("audiotrackchange", new Map([
                    [
                        "quality",
                        e
                    ],
                    [
                        "position",
                        a
                    ]
                ])), this.dispatchEvent(d));
                f && Jm(this, a, e.contentType) && (c.Tg = e, JSON.stringify(e), c = new R("qualitychange", new Map([
                    [
                        "quality",
                        e
                    ],
                    [
                        "position",
                        a
                    ]
                ])), this.dispatchEvent(c));
            }
        };
        function Jm(a, b, c) {
            return (a = a.h()[c]) && a.length > 0 && (c = a[a.length - 1].end, b >= a[0].start && b < c) ? !0 : !1;
        }
        function Im(a, b) {
            if ((a = a.h()[b.contentType]) && a.length > 0) {
                var c = a[0].start, d = a[a.length - 1].end, e = b.Ee;
                b.Ee = e.filter(function(f, g) {
                    return f.position <= c && g + 1 < e.length && e[g + 1].position <= c || f.position >= d ? !1 : !0;
                });
            } else b.Ee = [];
        }
        function Km(a) {
            var b = {
                bandwidth: a.bandwidth || 0,
                audioSamplingRate: null,
                codecs: a.codecs,
                contentType: a.type,
                frameRate: null,
                height: null,
                mimeType: a.mimeType,
                channelsCount: null,
                pixelAspectRatio: null,
                width: null,
                label: null,
                roles: a.roles,
                language: null
            };
            a.type == "video" && (b.frameRate = a.frameRate || null, b.height = a.height || null, b.pixelAspectRatio = a.pixelAspectRatio || null, b.width = a.width || null);
            a.type == "audio" && (b.audioSamplingRate = a.audioSamplingRate, b.channelsCount = a.channelsCount, b.label = a.label || null, b.language = a.language);
            return b;
        }
        function Lm(a) {
            fb.call(this);
            this.h = new Map;
            this.i = a;
            this.g = null;
        }
        oa(Lm, fb);
        Lm.prototype.release = function() {
            this.h.clear();
            this.g && (this.g.stop(), this.g = null);
            fb.prototype.release.call(this);
        };
        function Mm(a, b) {
            var c = b.schemeIdUri + "_" + b.id + "_" + (b.startTime.toFixed(1) + "_" + b.endTime.toFixed(1));
            a.h.has(c) || (a.h.set(c, b), b = new R("regionadd", new Map([
                [
                    "region",
                    b
                ]
            ])), a.dispatchEvent(b), Nm(a));
        }
        function Nm(a) {
            a.g || (a.g = new Uf(function() {
                for(var b = a.i(), c = u(a.h), d = c.next(); !d.done; d = c.next()){
                    var e = u(d.value);
                    d = e.next().value;
                    e = e.next().value;
                    e.endTime < b.start && (a.h.delete(d), d = new R("regionremove", new Map([
                        [
                            "region",
                            e
                        ]
                    ])), a.dispatchEvent(d));
                }
                !a.h.size && a.g && (a.g.stop(), a.g = null);
            }).xa(2));
        }
        function Om(a, b, c, d, e) {
            function f(g, h) {
                return h.fastSwitching && g.hd && g.we ? !1 : !0;
            }
            this.m = a;
            this.i = b;
            this.l = c;
            this.g = new Map;
            this.j = new Map;
            this.h = null;
            this.o = d;
            this.A = e || f;
        }
        function Pm(a, b) {
            a.l = b;
            a = u(a.g.values());
            for(var c = a.next(); !c.done; c = a.next())c.value.g = b;
        }
        function Qm(a, b, c) {
            c = c === void 0 ? !1 : c;
            if (!a.i.segmentIndex) return Promise.resolve();
            a.h || (a.h = a.i.segmentIndex.ac(b, !0, a.o));
            if (!a.h) return Promise.resolve();
            c && a.h.next();
            for(b = []; a.g.size < a.m;){
                c = a.h.next().value;
                if (!c) break;
                var d = !0;
                c.isPreload() && c.endByte != null && (d = !1);
                c.ec() == 2 && (d = !1);
                c.dc(!1) && (d = !1);
                d && c.ia && b.push(Rm(a, c.ia));
                d && !a.g.has(c) && (d = new Sm(a.l), b.push(Tm(d, c, a.i)), a.g.set(c, d));
                if (!a.A(c, a.i)) break;
            }
            Um(a);
            return Promise.all(b);
        }
        function Rm(a, b) {
            if (!a.i.segmentIndex || b.dc() || Array.from(a.j.keys()).some(function(e) {
                return Nj(e, b);
            })) return Promise.resolve();
            var c = new Sm(a.l), d = Tm(c, b, a.i);
            a.j.set(b, c);
            return d;
        }
        function Vm(a, b) {
            b = u(b.keys());
            for(var c = b.next(); !c.done; c = b.next())(c = c.value) && Wm(a, c);
        }
        function Xm(a) {
            Vm(a, a.g);
            Vm(a, a.j);
            a.h = null;
        }
        Om.prototype.$a = function(a, b) {
            b = b === void 0 ? !1 : b;
            for(var c = u(this.g.keys()), d = c.next(); !d.done; d = c.next())d = d.value, a > d.endTime && Wm(this, d);
            b && Um(this);
        };
        Om.prototype.Wd = function(a) {
            this.o = a;
            this.h && this.h.Wd(a);
        };
        function Um(a) {
            if (a.g.size) for(var b = Array.from(a.g.keys()), c = u(a.j.keys()), d = c.next(), e = {}; !d.done; e = {
                Fh: void 0
            }, d = c.next())e.Fh = d.value, b.some(function(f) {
                return function(g) {
                    return Nj(g.ia, f.Fh);
                };
            }(e)) || Wm(a, e.Fh);
        }
        function Ym(a, b) {
            a.m = b;
            for(var c = Array.from(a.g.keys()); c.length > b;){
                var d = c.pop();
                d && Wm(a, d);
            }
            Um(a);
        }
        function Zm(a, b) {
            b && b !== a.i && (Xm(a), a.i = b);
        }
        function Wm(a, b) {
            var c = a.g;
            b instanceof Mj && (c = a.j);
            a = c.get(b);
            c.delete(b);
            a && a.abort();
        }
        function Sm(a) {
            this.g = a;
            this.Be = this.ri = null;
        }
        function Tm(a, b, c) {
            var d = new Uint8Array(0);
            a.Be = a.g(b, c, function(e) {
                return H(function(f) {
                    if (f.h == 1) return d.byteLength > 0 ? d = tc(d, e) : d = e, a.ri ? f.g(a.ri(d), 3) : f.B(0);
                    d = new Uint8Array(0);
                    f.j();
                });
            });
            return a.Be.promise.catch(function(e) {
                return e instanceof T && e.code == 7001 ? Promise.resolve() : Promise.reject(e);
            });
        }
        Sm.prototype.abort = function() {
            this.Be && this.Be.abort();
        };
        O("shaka.config.CrossBoundaryStrategy", {
            KEEP: "keep",
            RESET: "reset",
            RESET_TO_ENCRYPTED: "reset_to_encrypted",
            RESET_ON_ENCRYPTION_CHANGE: "RESET_ON_ENCRYPTION_CHANGE"
        });
        function $m(a) {
            var b = Ff(a), c = b.split("/")[0];
            a = Gf(a);
            return {
                type: c,
                mimeType: b,
                codecs: a,
                language: null,
                height: null,
                width: null,
                channelCount: null,
                sampleRate: null,
                closedCaptions: new Map,
                Me: null,
                colorGamut: null,
                frameRate: null,
                timescale: null
            };
        }
        function an(a, b, c) {
            function d(B) {
                y = B.name;
                var J = B.reader;
                J.skip(24);
                var F = J.Ka(), I = J.Ka();
                J.skip(50);
                q = String(F);
                n = String(I);
                B.reader.Sa() && Gh(B);
            }
            function e(B) {
                var J = Zi(B.reader);
                r = J.channelCount;
                t = J.sampleRate;
                f(B.name);
            }
            function f(B) {
                B = B.toLowerCase();
                switch(B){
                    case "avc1":
                    case "avc3":
                        h.push(B + ".42E01E");
                        l = !0;
                        break;
                    case "hev1":
                    case "hvc1":
                        h.push(B + ".1.6.L93.90");
                        l = !0;
                        break;
                    case "dvh1":
                    case "dvhe":
                        h.push(B + ".05.04");
                        l = !0;
                        break;
                    case "vp09":
                        h.push(B + ".00.10.08");
                        l = !0;
                        break;
                    case "av01":
                        h.push(B + ".0.01M.08");
                        l = !0;
                        break;
                    case "mp4a":
                        g.push("mp4a.40.2");
                        k = !0;
                        break;
                    case "ac-3":
                    case "ec-3":
                    case "ac-4":
                    case "opus":
                    case "flac":
                        g.push(B);
                        k = !0;
                        break;
                    case "apac":
                        g.push("apac.31.00"), k = !0;
                }
            }
            var g = [], h = [], k = !1, l = !1, m = null, n = null, q = null, r = null, t = null, v = null, w = null, x = null, y;
            (new Bh).box("moov", Gh).box("trak", Gh).box("mdia", Gh).qa("mdhd", function(B) {
                B = Xi(B.reader, B.version);
                m = B.language;
                x = B.timescale;
            }).box("minf", Gh).box("stbl", Gh).qa("stsd", Ih).box("mp4a", function(B) {
                var J = Zi(B.reader);
                r = J.channelCount;
                t = J.sampleRate;
                B.reader.Sa() ? Gh(B) : f(B.name);
            }).box("esds", function(B) {
                B = B.reader;
                for(var J = "mp4a", F, I; B.Sa();){
                    F = B.ea();
                    for(var K = B.ea(); K & 128;)K = B.ea();
                    if (F == 3) B.Ka(), K = B.ea(), K & 128 && B.Ka(), K & 64 && B.skip(B.ea()), K & 32 && B.Ka();
                    else if (F == 4) I = B.ea(), B.skip(12);
                    else if (F == 5) break;
                }
                I && (J += "." + bj(I), F == 5 && B.Sa() && (F = B.ea(), I = (F & 248) >> 3, I === 31 && B.Sa() && (I = 32 + ((F & 7) << 3) + ((B.ea() & 224) >> 5)), J += "." + I));
                g.push(J);
                k = !0;
            }).box("ac-3", e).box("ec-3", e).box("ac-4", e).box("Opus", e).box("fLaC", e).box("apac", e).box("avc1", d).box("avc3", d).box("hev1", d).box("hvc1", d).box("dva1", d).box("dvav", d).box("dvh1", d).box("dvhe", d).box("vp09", d).box("av01", d).box("avcC", function(B) {
                var J = y || "";
                switch(y){
                    case "dvav":
                        J = "avc3";
                        break;
                    case "dva1":
                        J = "avc1";
                }
                B = B.reader;
                B.skip(1);
                B = J + "." + bj(B.ea()) + bj(B.ea()) + bj(B.ea());
                h.push(B);
                l = !0;
            }).box("hvcC", function(B) {
                var J = y || "";
                switch(y){
                    case "dvh1":
                        J = "hvc1";
                        break;
                    case "dvhe":
                        J = "hev1";
                }
                var F = B.reader;
                F.skip(1);
                B = F.ea();
                var I = [
                    "",
                    "A",
                    "B",
                    "C"
                ][B >> 6], K = B & 31, N = F.Y(), P = (B & 32) >> 5 ? "H" : "L";
                B = [
                    F.ea(),
                    F.ea(),
                    F.ea(),
                    F.ea(),
                    F.ea(),
                    F.ea()
                ];
                F = F.ea();
                for(var M = 0, L = 0; L < 32; L++){
                    M |= N & 1;
                    if (L == 31) break;
                    M <<= 1;
                    N >>= 1;
                }
                J = J + ("." + I + K) + ("." + bj(M, !0));
                J += "." + P + F;
                I = "";
                for(K = B.length; K--;)if ((P = B[K]) || I) I = "." + P.toString(16).toUpperCase() + I;
                J += I;
                h.push(J);
                l = !0;
            }).box("dvcC", function(B) {
                var J = y || "";
                switch(y){
                    case "hvc1":
                        J = "dvh1";
                        break;
                    case "hev1":
                        J = "dvhe";
                        break;
                    case "avc1":
                        J = "dva1";
                        break;
                    case "avc3":
                        J = "dvav";
                        break;
                    case "av01":
                        J = "dav1";
                }
                var F = B.reader;
                F.skip(2);
                B = F.ea();
                F = F.ea();
                h.push(J + "." + cj(B >> 1 & 127) + "." + cj(B << 5 & 32 | F >> 3 & 31));
                l = !0;
            }).box("dvvC", function(B) {
                var J = y || "";
                switch(y){
                    case "hvc1":
                        J = "dvh1";
                        break;
                    case "hev1":
                        J = "dvhe";
                        break;
                    case "avc1":
                        J = "dva1";
                        break;
                    case "avc3":
                        J = "dvav";
                        break;
                    case "av01":
                        J = "dav1";
                }
                var F = B.reader;
                F.skip(2);
                B = F.ea();
                F = F.ea();
                h.push(J + "." + cj(B >> 1 & 127) + "." + cj(B << 5 & 32 | F >> 3 & 31));
                l = !0;
            }).qa("vpcC", function(B) {
                var J = y || "", F = B.reader;
                B = F.ea();
                var I = F.ea();
                F = F.ea() >> 4 & 15;
                h.push(J + "." + cj(B) + "." + cj(I) + "." + cj(F));
                l = !0;
            }).box("av1C", function(B) {
                var J = y || "";
                switch(y){
                    case "dav1":
                        J = "av01";
                }
                var F = B.reader;
                F.skip(1);
                B = F.ea();
                F = F.ea();
                var I = B >>> 5, K = (F & 64) >> 6;
                h.push(J + "." + I + "." + cj(B & 31) + (F >>> 7 ? "H" : "M") + "." + cj(I === 2 && K ? (F & 32) >> 5 ? 12 : 10 : K ? 10 : 8) + "." + ((F & 16) >> 4) + "." + ((F & 8) >> 3) + ((F & 4) >> 2) + (F & 3) + "." + cj(1) + "." + cj(1) + "." + cj(1) + ".0");
                l = !0;
            }).box("enca", Kh).box("encv", Jh).box("sinf", Gh).box("frma", function(B) {
                B = $i(B.reader).codec;
                f(B);
            }).box("colr", function(B) {
                h = h.map(function(I) {
                    if (I.startsWith("av01.")) {
                        var K = B.reader, N = K.Xa(), P = K.Wb(4, !1);
                        var M = String.fromCharCode(P[0]);
                        M += String.fromCharCode(P[1]);
                        M += String.fromCharCode(P[2]);
                        M += String.fromCharCode(P[3]);
                        if (M === "nclx") {
                            P = K.Ka();
                            M = K.Ka();
                            var L = K.Ka(), Q = K.ea() >> 7, S = I.split(".");
                            S.length == 10 && (S[6] = cj(P), S[7] = cj(M), S[8] = cj(L), S[9] = String(Q), I = S.join("."));
                        }
                        K.seek(N);
                    }
                    return I;
                });
                var J = aj(B.reader), F = J.colorGamut;
                v = J.Me;
                w = F;
            }).parse(a || b, !0, !0);
            if (!g.length && !h.length) return null;
            var z = k && !l, A = new Map;
            if (l && !c) {
                c = new Fd("video/mp4");
                a && c.init(a);
                try {
                    Jd(c, b);
                    for(var E = u(c.g.getStreams()), C = E.next(); !C.done; C = E.next()){
                        var D = C.value;
                        A.set(D, D);
                    }
                } catch (B) {}
                c.g.clear();
            }
            return {
                type: z ? "audio" : "video",
                mimeType: z ? "audio/mp4" : "video/mp4",
                codecs: bn(g.concat(h)).join(", "),
                language: m,
                height: n,
                width: q,
                channelCount: r,
                sampleRate: t,
                closedCaptions: A,
                Me: v,
                colorGamut: w,
                frameRate: null,
                timescale: x
            };
        }
        function bn(a) {
            var b = new Set, c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next()){
                d = d.value;
                var e = Ef(d);
                b.has(e) || (c.push(d), b.add(e));
            }
            b = Fc("audio", c);
            d = Fc("video", c);
            a = Fc(Ec, c);
            d = cn(d);
            b = b.concat(d).concat(a);
            return c.length && !b.length ? c : b;
        }
        function cn(a) {
            if (a.length <= 1) return a;
            var b = a.find(function(c) {
                return c.startsWith("dvav.") || c.startsWith("dva1.") || c.startsWith("dvh1.") || c.startsWith("dvhe.") || c.startsWith("dav1.") || c.startsWith("dvc1.") || c.startsWith("dvi1.");
            });
            return b ? Si('video/mp4; codecs="' + b + '"') ? [
                b
            ] : a.filter(function(c) {
                return c != b;
            }) : a;
        }
        function dn(a) {
            var b = null;
            (new Bh).box("moov", Gh).box("trak", Gh).box("mdia", Gh).box("minf", Gh).box("stbl", Gh).qa("stsd", Ih).box("encv", Jh).box("enca", Kh).box("sinf", Gh).box("schi", Gh).qa("tenc", function(c) {
                c = c.reader;
                c.ea();
                c.ea();
                c.ea();
                c.ea();
                c = c.Wb(16, !1);
                b = sc(c);
            }).parse(a, !0);
            return b;
        }
        function en(a, b, c) {
            var d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) return d = b, d.cryptoKey ? k.B(2) : k.g(d.fetchKey(), 3);
                e = d.iv;
                if (!e) for(e = Fb(new ArrayBuffer(16)), f = d.firstMediaSequenceNumber + c, g = e.byteLength - 1; g >= 0; g--)e[g] = f & 255, f >>= 8;
                b.blockCipherMode == "CBC" ? h = {
                    name: "AES-CBC",
                    iv: e
                } : h = {
                    name: "AES-CTR",
                    counter: e,
                    length: 64
                };
                return k.return(window1.crypto.subtle.decrypt(h, d.cryptoKey, a));
            });
        }
        function fn(a, b, c) {
            var d, e, f, g, h, k, l;
            return H(function(m) {
                switch(m.h){
                    case 1:
                        d = gn(a);
                        if (e = hn.get(d)) return m.return(e);
                        f = 0;
                        g = mh([
                            a
                        ], c);
                        m.m(2);
                        g.method = "HEAD";
                        return m.g(b.request(f, g).promise, 4);
                    case 4:
                        h = m.i;
                        e = h.headers["content-type"];
                        m.o(3);
                        break;
                    case 2:
                        k = m.l();
                        if (!k || k.code != 1002 && k.code != 1001) {
                            m.B(3);
                            break;
                        }
                        g.method = "GET";
                        return m.g(b.request(f, g).promise, 6);
                    case 6:
                        l = m.i, e = l.headers["content-type"];
                    case 3:
                        return m.return(e ? e.toLowerCase().split(";").shift() : "");
                }
            });
        }
        function gn(a) {
            for(var b = a.length, c = 0; c < a.length; c++){
                var d = a.charCodeAt(c);
                if (d === 63 || d === 35) {
                    b = c;
                    break;
                }
            }
            for(c = b - 1; c >= 0; c--){
                d = a.charCodeAt(c);
                if (d === 46) {
                    if (c + 1 < b) return a.slice(c + 1, b).toLowerCase();
                    break;
                }
                if (d === 47) break;
            }
            return "";
        }
        function jn(a, b, c, d, e) {
            a = mh(a, d, e);
            if (b != 0 || c != null) a.headers.Range = c ? "bytes=" + b + "-" + c : "bytes=" + b + "-";
            return a;
        }
        var hn = (new Map).set("mp4", "video/mp4").set("m4v", "video/mp4").set("m4a", "audio/mp4").set("webm", "video/webm").set("weba", "audio/webm").set("mkv", "video/webm").set("ts", "video/mp2t").set("ogv", "video/ogg").set("ogg", "audio/ogg").set("mpg", "video/mpeg").set("mpeg", "video/mpeg").set("mov", "video/quicktime").set("m3u8", "application/x-mpegurl").set("mpd", "application/dash+xml").set("ism", "application/vnd.ms-sstr+xml").set("mp3", "audio/mpeg").set("aac", "audio/aac").set("flac", "audio/flac").set("wav", "audio/wav").set("sbv", "text/x-subviewer").set("srt", "text/srt").set("vtt", "text/vtt").set("webvtt", "text/vtt").set("ttml", "application/ttml+xml").set("lrc", "application/x-subtitle-lrc").set("ssa", "text/x-ssa").set("ass", "text/x-ssa").set("jpeg", "image/jpeg").set("jpg", "image/jpeg").set("png", "image/png").set("svg", "image/svg+xml").set("webp", "image/webp").set("avif", "image/avif").set("html", "text/html").set("htm", "text/html");
        function kn(a, b) {
            var c = this;
            this.g = b;
            this.j = a;
            this.i = null;
            this.L = new Map;
            this.D = 1;
            this.C = this.o = null;
            this.S = 0;
            this.h = new Map;
            this.M = !1;
            this.V = null;
            this.F = !1;
            this.l = new uh(function() {
                return ln(c);
            });
            this.P = Date.now() / 1E3;
            this.m = new Map;
            this.R = {
                projection: null,
                hfov: null
            };
            this.X = 0;
            this.W = Infinity;
            this.H = null;
            this.O = [];
            this.A = new Uf(function() {
                if (c.j && c.g) {
                    if (c.j.presentationTimeline.U()) {
                        var d = c.j.presentationTimeline.cc(), e = c.j.presentationTimeline.Gb();
                        e - d > 1 ? Al(c.g.aa, d, e) : Bl(c.g.aa);
                    } else Bl(c.g.aa), c.A && c.A.stop();
                } else c.A && c.A.stop();
            });
            this.I = null;
            this.J = !1;
            this.K = new Uf(function() {
                var d = c.g.video;
                !d.ended && c.I && (c.J = !0, d.currentTime = c.I, c.I = null);
            });
            this.G = new fd;
        }
        p = kn.prototype;
        p.destroy = function() {
            return this.l.destroy();
        };
        function ln(a) {
            var b, c, d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) {
                    a.A && a.A.stop();
                    a.A = null;
                    a.K && a.K.stop();
                    a.K = null;
                    a.G && (a.G.release(), a.G = null);
                    b = [];
                    c = u(a.h.values());
                    for(d = c.next(); !d.done; d = c.next())e = d.value, mn(e), b.push(nn(e)), e.ma && (Xm(e.ma), e.ma = null);
                    f = u(a.m.values());
                    for(g = f.next(); !g.done; g = f.next())h = g.value, Xm(h);
                    return k.g(Promise.all(b), 2);
                }
                a.h.clear();
                a.m.clear();
                a.g = null;
                a.j = null;
                a.i = null;
                a.I = null;
                k.j();
            });
        }
        p.configure = function(a) {
            this.i = a;
            this.V = new Vg({
                maxAttempts: Math.max(a.retryParameters.maxAttempts, 2),
                baseDelay: a.retryParameters.baseDelay,
                backoffFactor: a.retryParameters.backoffFactor,
                fuzzFactor: a.retryParameters.fuzzFactor,
                timeout: 0,
                stallTimeout: 0,
                connectionTimeout: 0
            }, !0);
            if (a.disableAudioPrefetch) {
                var b = this.h.get("audio");
                b && b.ma && (Xm(b.ma), b.ma = null);
                b = u(this.m.keys());
                for(var c = b.next(); !c.done; c = b.next())c = c.value, Xm(this.m.get(c)), this.m.delete(c);
            }
            a.disableTextPrefetch && (b = this.h.get(Ec)) && b.ma && (Xm(b.ma), b.ma = null);
            a.disableVideoPrefetch && (b = this.h.get("video")) && b.ma && (Xm(b.ma), b.ma = null);
            b = u(this.h.keys());
            for(c = b.next(); !c.done; c = b.next())c = this.h.get(c.value), c.ma ? (Ym(c.ma, a.segmentPrefetchLimit), a.segmentPrefetchLimit > 0 || (Xm(c.ma), c.ma = null)) : a.segmentPrefetchLimit > 0 && (c.ma = on(this, c.stream));
            a.disableAudioPrefetch || pn(this);
        };
        function qn(a, b, c) {
            a.j.presentationTimeline.U() || (a.X = b, a.W = c);
        }
        p.start = function(a) {
            var b = this;
            return H(function(c) {
                if (c.h == 1) return c.g(rn(b, a || new Map), 2);
                vh(b.l);
                b.M = !0;
                c.j();
            });
        };
        function sn(a, b) {
            var c, d, e, f, g, h, k;
            H(function(l) {
                switch(l.h){
                    case 1:
                        return c = Gc, a.S++, d = a.S, l.m(2), l.g(ul(a.g.aa, c.Va), 4);
                    case 4:
                        l.o(3);
                        break;
                    case 2:
                        if (e = l.l(), a.g) a.g.onError(e);
                    case 3:
                        f = wf(b.mimeType, b.codecs), cl(a.g.aa, f, a.j.sequenceMode, b.external), g = a.g.aa.X, (h = g.isTextVisible() || a.i.alwaysStreamText) && a.S == d && (k = tn(a, b), a.h.set(c.Va, k), un(a, k, 0)), l.j();
                }
            });
        }
        function vn(a) {
            var b = a.h.get(Ec);
            b && (mn(b), nn(b).catch(function() {}), a.H = a.h.get(Ec), a.h.delete(Ec), b.stream && b.stream.closeSegmentIndex && b.stream.closeSegmentIndex());
            a.C = null;
        }
        function wn(a, b) {
            for(var c = a.g.Wa() < 0, d = u(a.h.values()), e = d.next(); !e.done; e = d.next())e = e.value, e.Aa && e.Aa.Wd(c), e.ma && e.ma.Wd(c);
            d = u(a.m.values());
            for(e = d.next(); !e.done; e = d.next())e.value.Wd(c);
            if (c = a.h.get("video")) {
                if (d = c.stream) {
                    if (b) (b = d.trickModeVideo) && !c.Vc && (xn(a, b, !1, 0, !1), c.Vc = d);
                    else if (b = c.Vc) c.Vc = null, xn(a, b, !0, 0, !1);
                }
            }
        }
        function yn(a, b, c, d, e, f) {
            c = c === void 0 ? !1 : c;
            d = d === void 0 ? 0 : d;
            e = e === void 0 ? !1 : e;
            f = f === void 0 ? !1 : f;
            a.o = b;
            a.M && (b.video && xn(a, b.video, c, d, e, f), b.audio && xn(a, b.audio, c, d, e, f));
        }
        function zn(a, b) {
            H(function(c) {
                if (c.h == 1) return a.H = null, a.C = b, a.M ? b.segmentIndex ? c.B(2) : c.g(b.createSegmentIndex(), 2) : c.return();
                xn(a, b, !0, 0, !1);
                c.j();
            });
        }
        function An(a) {
            var b = a.h.get(Ec);
            b && xn(a, b.stream, !0, 0, !0);
        }
        function Bn(a, b) {
            for(var c = u(a.L.entries()), d = c.next(); !d.done; d = c.next()){
                var e = u(d.value);
                d = e.next().value;
                e = e.next().value;
                d.includes(b.type) && (e(), a.L.delete(d));
            }
        }
        function xn(a, b, c, d, e, f) {
            var g = a.h.get(b.type);
            g || b.type != Ec ? g && (g.Vc && (b.trickModeVideo ? (g.Vc = b, b = b.trickModeVideo) : g.Vc = null), g.stream != b || e) && (a.m.has(b) ? g.ma = a.m.get(b) : g.ma && Zm(g.ma, b), b.type == Ec && g.stream != b && (e = wf(b.mimeType, b.codecs), cl(a.g.aa, e, a.j.sequenceMode, b.external)), !a.m.has(g.stream) && g.stream.closeSegmentIndex && (g.Ra ? (e = "(" + g.type + ":" + g.stream.id + ")", a.L.has(e) || a.L.set(e, g.stream.closeSegmentIndex)) : g.stream.closeSegmentIndex()), e = g.stream.isAudioMuxedInVideo != b.isAudioMuxedInVideo, g.stream = b, g.Aa = null, g.Gg = !!f, b.dependencyStream ? g.Mc = tn(a, b.dependencyStream) : g.Mc = null, Cn(a), e && (g.qb = null, g.Ac = null, g.zc = null, b.isAudioMuxedInVideo && (b = null, g.type === "video" ? b = a.h.get("audio") : g.type === "audio" && (b = a.h.get("video")), b && (nn(b).catch(function() {}), b.qb = null, b.Ac = null, b.zc = null, Dn(a, b), En(a, b).catch(function(h) {
                if (a.g) a.g.onError(h);
            })))), c ? g.$b ? g.ae = !0 : g.Ra ? (g.Yb = !0, g.vd = d, g.ae = !0) : (mn(g), Fn(a, g, !0, d).catch(function(h) {
                if (a.g) a.g.onError(h);
            })) : g.Ra || g.rb || un(a, g, 0), En(a, g).catch(function(h) {
                if (a.g) a.g.onError(h);
            })) : sn(a, b);
        }
        function En(a, b) {
            var c, d, e;
            return H(function(f) {
                if (f.h == 1) {
                    if (!b.bb) return f.return();
                    c = b.stream;
                    d = b.bb;
                    return c.segmentIndex ? f.B(2) : f.g(c.createSegmentIndex(), 2);
                }
                if (f.h != 4) return e = c.dependencyStream, !e || e.segmentIndex ? f.B(4) : f.g(e.createSegmentIndex(), 4);
                if (b.bb != d || b.stream != c) return f.return();
                var g = a.g.bc();
                var h = il(a.g.aa, b.type), k = b.stream.segmentIndex.find(b.Na ? b.Na.endTime : g), l = k == null ? null : b.stream.segmentIndex.get(k);
                k = l ? Qj(l) : null;
                l && !k && (k = (l.endTime - l.getStartTime()) * (b.stream.bandwidth || a.o.bandwidth) / 8);
                k ? ((l = l.ia) && (k += (l.endByte ? l.endByte + 1 - l.startByte : null) || 0), l = a.g.getBandwidthEstimate(), g = k * 8 / l < (h || 0) - g - a.i.rebufferingGoal || b.bb.h.g > k ? !0 : !1) : g = !0;
                g && b.bb.abort();
                f.j();
            });
        }
        p.ld = function() {
            if (this.g) {
                for(var a = this.g.bc(), b = u(this.h.keys()), c = b.next(); !c.done; c = b.next()){
                    var d = c.value;
                    c = this.h.get(d);
                    var e;
                    if (e = !this.J) e = this.g.aa, d == Ec ? (e = e.h, e = e.g == null || e.h == null ? !1 : a >= e.g && a < e.h) : (e = hl(e, d), e = Wj(e, a)), e = !e;
                    if (e) {
                        this.P = 0;
                        c.ma && (c.ma.h = null);
                        if (c.type === "audio") {
                            e = u(this.m.values());
                            for(var f = e.next(); !f.done; f = e.next())f.value.h = null;
                        }
                        c.Aa = null;
                        (il(this.g.aa, d) != null || c.Ra) && Dn(this, c);
                        c.bb && (c.bb.abort(), c.bb = null);
                        d === Ec && (d = this.g.aa, d.J && d.J.g.clear());
                        c.ld = !0;
                    }
                    !this.J || c.$b || c.Ra || c.rb || un(this, c, 0);
                }
                Gn(this) && Hn(this);
            }
        };
        function Dn(a, b) {
            b.$b || b.Yb || (b.Ra ? (b.Yb = !0, b.vd = 0) : gl(a.g.aa, b.type) == null ? b.rb == null && un(a, b, 0) : (mn(b), Fn(a, b, !1, 0).catch(function(c) {
                if (a.g) a.g.onError(c);
            })));
        }
        function rn(a, b) {
            var c, d, e, f, g, h, k, l;
            return H(function(m) {
                if (m.h == 1) {
                    if (!a.o) throw new T(2, 5, 5006);
                    c = In(a, !0);
                    d = a.g.aa;
                    return m.g(d.init(c, a.j.sequenceMode, a.j.type, a.j.ignoreManifestTimestampsInSegmentsMode), 2);
                }
                vh(a.l);
                a.updateDuration();
                e = u(c.keys());
                for(f = e.next(); !f.done; f = e.next())g = f.value, h = c.get(g), a.h.has(g) || (k = tn(a, h), b.has(h.id) && (l = b.get(h.id), Pm(l, function(n, q, r) {
                    return Jn(n, q, r || null, a.i.retryParameters, a.g.Cc);
                }), k.ma = l), a.h.set(g, k), un(a, k, 0));
                Cn(a);
                m.j();
            });
        }
        function tn(a, b) {
            var c = {
                stream: b,
                type: b.type,
                Aa: null,
                ma: on(a, b),
                Na: null,
                qb: null,
                Lf: null,
                Ac: null,
                zc: null,
                Jf: null,
                Kf: null,
                Vc: null,
                endOfStream: !1,
                Ra: !1,
                rb: null,
                Yb: !1,
                vd: 0,
                ae: !1,
                $b: !1,
                ld: !0,
                Gg: !1,
                Wh: !1,
                Fd: !1,
                bb: null,
                Mc: null
            };
            b.dependencyStream && (c.Mc = tn(a, b.dependencyStream));
            return c;
        }
        function on(a, b) {
            if (b.type === "video" && a.i.disableVideoPrefetch || b.type === "audio" && a.i.disableAudioPrefetch || b.type === Ec && (b.mimeType == "application/cea-608" || b.mimeType == "application/cea-708") || b.type === Ec && a.i.disableTextPrefetch) return null;
            if (a.m.has(b)) return a.m.get(b);
            var c = a.h.get(b.type);
            return (c = c && c.ma) && b === c.i ? c : a.i.segmentPrefetchLimit > 0 ? new Om(a.i.segmentPrefetchLimit, b, function(d, e, f) {
                return Jn(d, e, f || null, a.i.retryParameters, a.g.Cc);
            }, a.g.Wa() < 0, a.g.Am) : null;
        }
        function pn(a) {
            for(var b = a.i.segmentPrefetchLimit, c = a.i.prefetchAudioLanguages, d = u(a.j.variants), e = d.next(), f = {}; !e.done; f = {
                Nb: void 0
            }, e = d.next())if (f.Nb = e.value, f.Nb.audio) {
                if (a.m.has(f.Nb.audio)) {
                    if (e = a.m.get(f.Nb.audio), Ym(e, b), !(b > 0 && c.some(function(h) {
                        return function(k) {
                            return Jc(h.Nb.audio.language, k);
                        };
                    }(f)))) {
                        var g = a.h.get(f.Nb.audio.type);
                        e !== (g && g.ma) && Xm(e);
                        a.m.delete(f.Nb.audio);
                    }
                } else b <= 0 || !c.some(function(h) {
                    return function(k) {
                        return Jc(h.Nb.audio.language, k);
                    };
                }(f)) || !(e = on(a, f.Nb.audio)) || (f.Nb.audio.segmentIndex || f.Nb.audio.createSegmentIndex(), a.m.set(f.Nb.audio, e));
            }
        }
        p.updateDuration = function() {
            var a = Ui(), b = this.j.presentationTimeline.getDuration();
            b < Infinity ? (a && (this.A && this.A.stop(), Bl(this.g.aa)), this.g.aa.Ab(b)) : a ? (this.A && this.A.xa(.5), this.g.aa.Ab(Infinity)) : this.g.aa.Ab(4294967296);
        };
        function Kn(a, b) {
            var c, d, e, f, g, h, k, l, m;
            return H(function(n) {
                switch(n.h){
                    case 1:
                        vh(a.l);
                        c = Gc;
                        if (b.Ra || b.rb == null || b.$b) return n.return();
                        b.rb = null;
                        if (!b.Yb) {
                            n.B(2);
                            break;
                        }
                        return n.g(Fn(a, b, b.ae, b.vd), 3);
                    case 3:
                        return n.return();
                    case 2:
                        Bn(a, b);
                        if (b.stream.segmentIndex) {
                            n.B(4);
                            break;
                        }
                        d = b.stream;
                        n.m(5);
                        return n.g(b.stream.createSegmentIndex(), 7);
                    case 7:
                        n.o(6);
                        break;
                    case 5:
                        return e = n.l(), n.g(Ln(a, b, e), 8);
                    case 8:
                        return n.return();
                    case 6:
                        if (d != b.stream) return d.closeSegmentIndex && d.closeSegmentIndex(), b.Ra || b.rb || un(a, b, 0), n.return();
                    case 4:
                        if (!b.Mc) {
                            n.B(9);
                            break;
                        }
                        if (b.Mc.stream.segmentIndex) {
                            n.B(9);
                            break;
                        }
                        n.m(11);
                        return n.g(b.Mc.stream.createSegmentIndex(), 13);
                    case 13:
                        n.o(9);
                        break;
                    case 11:
                        n.l();
                    case 9:
                        n.m(14);
                        f = Mn(a, b);
                        f != null && (un(a, b, f), b.Fd = !1);
                        n.o(15);
                        break;
                    case 14:
                        return g = n.l(), n.g(Ln(a, b, g), 16);
                    case 16:
                        return n.return();
                    case 15:
                        if (b.type === c.Va) return n.return();
                        h = [];
                        b.stream && !b.stream.isAudioMuxedInVideo && h.push(b);
                        k = b.type === c.ha ? c.Ba : c.ha;
                        (l = a.h.get(k)) && l.stream && !l.stream.isAudioMuxedInVideo && h.push(l);
                        if (!a.M || !h.every(function(q) {
                            return q.endOfStream;
                        })) {
                            n.B(0);
                            break;
                        }
                        return n.g(a.g.aa.endOfStream(), 18);
                    case 18:
                        vh(a.l), m = a.g.aa.getDuration(), m != 0 && m < a.j.presentationTimeline.getDuration() && a.j.presentationTimeline.Ab(m), n.j();
                }
            });
        }
        function Mn(a, b) {
            if (Nn(b)) return rl(a.g.aa, b.stream.originalId || ""), null;
            b.type == Ec && sl(a.g.aa);
            if (b.stream.isAudioMuxedInVideo && b.type == "audio") return null;
            if (b.type != Ec && al(a.g.aa)) return On(a, !0), null;
            var c = a.i.updateIntervalSeconds / Math.max(1, Math.abs(a.g.Wa()));
            if (!fl(a.g.aa) && b.type != Ec) return c / 2;
            var d = a.g.bc();
            if (b.type === "audio") for(var e = u(a.m.keys()), f = e.next(); !f.done; f = e.next())f = a.m.get(f.value), f.$a(d, !0), Qm(f, d);
            e = b.Na ? b.Na.endTime : d;
            var g = jl(a.g.aa, b.type, d);
            f = Math.max(1, Math.max(a.i.rebufferingGoal, a.i.bufferingGoal) * a.D);
            var h = a.j.presentationTimeline.getDuration() - e, k = il(a.g.aa, b.type);
            if (h < 1E-6 && k) return b.endOfStream = !0, b.type == "video" && ((c = a.h.get(Ec)) && Nn(c) && (c.endOfStream = !0), (c = a.h.get("audio")) && c.stream.isAudioMuxedInVideo && (c.endOfStream = !0)), null;
            b.endOfStream = !1;
            if (g >= f) return c / 2;
            h = !b.Aa;
            k = Pn(a, b, d, k);
            if (!k) return a = Infinity, (b = b.Na) && (a = b.endTime - b.startTime), Math.min(a / 2, c);
            g = b.qb;
            var l = k.ia;
            g && l && Nj(l, g) && (g.g = l.g);
            g = !1;
            h && b.Gg && (g = !0, b.Gg = !1);
            h = Infinity;
            l = u(a.h.values());
            for(var m = l.next(); !m.done; m = l.next())m = m.value, Nn(m) || m.stream.isAudioMuxedInVideo || m.Aa && !m.Aa.current() || (h = Math.min(h, m.Na ? m.Na.endTime : d));
            if (e >= h + a.j.presentationTimeline.h) return c;
            b.ma && b.Aa && !a.m.has(b.stream) && (b.ma.$a(k.startTime + .001), Qm(b.ma, k.startTime).catch(function() {}));
            if (Gn(a) && Qn(a, b, k)) return null;
            Rn(a, b, d, k, g).catch(function() {});
            b.Mc && Sn(a, b.Mc, d, f);
            return null;
        }
        function Pn(a, b, c, d) {
            if (b.Aa) {
                var e = b.Aa.current();
                e && b.Na && (c = b.Na.endTime, rk(b.Na.startTime, e.startTime, .002) && rk(c, e.endTime, .002) && (e = b.Aa.next().value));
                return e;
            }
            if (b.Na || d) return e = b.Na ? b.Na.endTime : d, c = a.g.Wa() < 0, b.stream.segmentIndex && (b.Aa = b.stream.segmentIndex.ac(e, !1, c)), b.Aa && b.Aa.next().value;
            d = a.j.sequenceMode || Gn(a) ? 0 : a.i.inaccurateManifestTolerance;
            var f = Math.max(c - d, 0), g = a.g.aa.getDuration();
            Math.abs(f - g) < 1 && (d = 1, f = Math.max(c - d, 0));
            g = a.g.Wa() < 0;
            a = null;
            d && (b.stream.segmentIndex && (b.Aa = b.stream.segmentIndex.ac(f, !1, g)), a = b.Aa && b.Aa.next().value);
            a || (b.stream.segmentIndex && (b.Aa = b.stream.segmentIndex.ac(c, !1, g)), a = b.Aa && b.Aa.next().value);
            for(; ((e = a) == null ? void 0 : e.ec()) === 2;)d = c = void 0, a = (d = (c = b.Aa) == null ? void 0 : c.next().value) != null ? d : null;
            return a;
        }
        function Rn(a, b, c, d, e) {
            var f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C;
            return H(function(D) {
                switch(D.h){
                    case 1:
                        f = Gc;
                        g = b.stream;
                        h = b.Aa;
                        b.Ra = !0;
                        D.m(2);
                        if (d.ec() == 2) throw new T(1, 1, 1011);
                        return D.g(Tn(a, b, d, e), 4);
                    case 4:
                        vh(a.l);
                        if (a.F) return D.return();
                        k = g.mimeType == "video/mp4" || g.mimeType == "audio/mp4";
                        l = window1.ReadableStream;
                        if ((m = a.i.lowLatencyMode && a.j.isLowLatency) && l && k && (a.j.type != "HLS" || d.o)) return r = new Uint8Array(0), v = t = !1, x = function(B) {
                            var J, F, I, K;
                            return H(function(N) {
                                switch(N.h){
                                    case 1:
                                        if (t) return N.return();
                                        v = !0;
                                        vh(a.l);
                                        if (a.F) return N.return();
                                        N.m(2);
                                        r = tc(r, B);
                                        J = !1;
                                        F = 0;
                                        (new Bh).box("mdat", function(P) {
                                            F = P.size + P.start;
                                            J = !0;
                                        }).parse(r, !1, !0);
                                        if (!J) {
                                            N.B(4);
                                            break;
                                        }
                                        I = r.subarray(0, F);
                                        r = r.subarray(F);
                                        return N.g(Un(a, b, c, g, d, I, !0, e), 5);
                                    case 5:
                                        b.ma && b.Aa && Qm(b.ma, d.startTime, !0);
                                    case 4:
                                        N.o(0);
                                        break;
                                    case 2:
                                        w = K = N.l(), N.j();
                                }
                            });
                        }, D.g(Vn(a, b, d, x), 9);
                        n = Vn(a, b, d);
                        return D.g(n, 7);
                    case 7:
                        q = D.i;
                        vh(a.l);
                        if (a.F) return D.return();
                        vh(a.l);
                        return b.Yb ? (b.Ra = !1, un(a, b, 0), D.return()) : D.g(Un(a, b, c, g, d, q, !1, e), 6);
                    case 9:
                        y = D.i;
                        if (w) throw w;
                        if (v) {
                            D.B(10);
                            break;
                        }
                        t = !0;
                        vh(a.l);
                        return a.F ? D.return() : b.Yb ? (b.Ra = !1, un(a, b, 0), D.return()) : D.g(Un(a, b, c, g, d, y, !1, e), 10);
                    case 10:
                        b.ma && b.Aa && Qm(b.ma, d.startTime, !0);
                    case 6:
                        vh(a.l);
                        if (a.F) return D.return();
                        b.Na = d;
                        h.next();
                        b.Ra = !1;
                        b.Wh = !1;
                        z = a.g.aa.Nc();
                        A = z[b.type];
                        cb(JSON.stringify(A));
                        b.Yb || (E = null, b.type === f.Ba ? E = a.h.get(f.ha) : b.type === f.ha && (E = a.h.get(f.Ba)), E && E.type == f.ha ? a.g.Md(d, b.stream, E.stream.isAudioMuxedInVideo, !1) : a.g.Md(d, b.stream, b.stream.codecs.includes(","), !1));
                        mn(b);
                        un(a, b, 0);
                        D.o(0);
                        break;
                    case 2:
                        C = D.l();
                        vh(a.l, C);
                        if (a.F) return D.return();
                        b.Ra = !1;
                        if (C.code == 7001) b.Ra = !1, mn(b), un(a, b, 0), D.B(0);
                        else if (b.type == f.Va && a.i.ignoreTextStreamFailures) a.h.delete(f.Va), D.B(0);
                        else {
                            if (C.code == 3017) return D.g(Wn(a, b, C), 0);
                            b.Fd = !0;
                            C.category == 1 && b.ma && Wm(b.ma, d);
                            C.severity = 2;
                            return D.g(Ln(a, b, C), 0);
                        }
                }
            });
        }
        function Sn(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w;
            return H(function(x) {
                switch(x.h){
                    case 1:
                        e = Gc;
                        f = b.stream;
                        for(k = (h = (g = f.segmentIndex) && g.ac(c)) && h.next().value; k && a.O.includes(k.startTime);)k = h && h.next().value;
                        if (!k) {
                            x.B(0);
                            break;
                        }
                        l = k.ia;
                        if (!l || Nj(l, b.qb)) {
                            x.B(3);
                            break;
                        }
                        b.qb = l;
                        x.m(4);
                        return x.g(Vn(a, b, l), 6);
                    case 6:
                        m = x.i;
                        if (!a.g) return x.return();
                        var y = a.g.aa;
                        y.D && td(y.D, m, 0, f);
                        a.O = [];
                        x.o(3);
                        break;
                    case 4:
                        throw n = x.l(), b.qb = null, n;
                    case 3:
                        if (b.Na && b.Na == k) {
                            x.B(0);
                            break;
                        }
                        b.Na = k;
                        x.m(8);
                        return x.g(Vn(a, b, k), 10);
                    case 10:
                        q = x.i;
                        if (!a.g) return x.return();
                        y = a.g.aa;
                        y.D && td(y.D, q, 0, f);
                        a.O.push(k.startTime);
                        x.o(9);
                        break;
                    case 8:
                        throw r = x.l(), b.Na = null, r;
                    case 9:
                        if (!a.g) return x.return();
                        b.Yb || (t = null, b.type === e.Ba ? t = a.h.get(e.ha) : b.type === e.ha && (t = a.h.get(e.Ba)), t && t.type == e.ha ? a.g.Md(k, b.stream, t.stream.isAudioMuxedInVideo, !0) : a.g.Md(k, b.stream, b.stream.codecs.includes(","), !0));
                        v = Math.max.apply(Math, [
                            0
                        ].concat(G(a.O)));
                        w = a.g.bc();
                        if (w + d > v) return x.g(Sn(a, b, k.startTime, d), 0);
                        x.B(0);
                }
            });
        }
        function Wn(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r;
            return H(function(t) {
                switch(t.h){
                    case 1:
                        d = !1;
                        e = u(a.h.values());
                        for(f = e.next(); !f.done; f = e.next())if (g = f.value, g != b && g.Wh) {
                            d = !0;
                            break;
                        }
                        if (d) {
                            t.B(2);
                            break;
                        }
                        if (a.i.avoidEvictionOnQuotaExceededError) {
                            h = Xn(a, c);
                            if (k = a.g.disableStream(b.stream, h)) return t.return();
                            un(a, b, 4);
                            return t.return();
                        }
                        l = Math.round(100 * a.D);
                        if (l > 20) {
                            a.D -= .2;
                            t.B(3);
                            break;
                        }
                        if (l > 4) {
                            a.D -= .04;
                            t.B(3);
                            break;
                        }
                        m = Xn(a, c);
                        n = a.g.disableStream(b.stream, m);
                        if (!n) {
                            b.Fd = !0;
                            a.F = !0;
                            a.g.onError(c);
                            t.B(5);
                            break;
                        }
                        a.D = 1;
                        q = a.g.bc();
                        return t.g(Yn(a, b, q), 5);
                    case 5:
                        return t.return();
                    case 3:
                        return b.Wh = !0, r = a.g.bc(), t.g(Yn(a, b, r), 2);
                    case 2:
                        un(a, b, 4), t.j();
                }
            });
        }
        function Tn(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z;
            return H(function(A) {
                switch(A.h){
                    case 1:
                        e = Gc;
                        f = b.Na == null;
                        g = [];
                        h = Math.max(0, Math.max(c.appendWindowStart, a.X) - .1);
                        k = Math.min(c.appendWindowEnd, a.W) + .1;
                        l = c.codecs || b.stream.codecs;
                        m = Ef(l);
                        n = Ff(c.mimeType || b.stream.mimeType);
                        q = c.timestampOffset;
                        if (q == b.Lf && h == b.Ac && k == b.zc && m == b.Jf && n == b.Kf) {
                            A.B(2);
                            break;
                        }
                        r = b.Jf && b.Kf && Vl(a.g.aa, b.type, n, l, In(a));
                        if (!r) {
                            A.B(3);
                            break;
                        }
                        t = null;
                        b.type === e.Ba ? t = a.h.get(e.ha) : b.type === e.ha && (t = a.h.get(e.Ba));
                        if (!t) {
                            A.B(3);
                            break;
                        }
                        return A.g(nn(t).catch(function() {}), 5);
                    case 5:
                        t.qb = null, t.Ac = null, t.zc = null, Dn(a, t);
                    case 3:
                        return A.g(Zn(a, b, q, h, k, c, m, n), 2);
                    case 2:
                        return Nj(c.ia, b.qb) || (b.qb = c.ia, c.l && c.ia && (v = Vn(a, b, c.ia), w = function() {
                            var E, C, D, B, J, F, I, K, N, P, M;
                            return H(function(L) {
                                switch(L.h){
                                    case 1:
                                        return L.m(2), L.g(v, 4);
                                    case 4:
                                        return E = L.i, vh(a.l), C = null, D = new Map, B = {
                                            projection: null,
                                            hfov: null
                                        }, b.stream && (J = b.stream.videoLayout) && (F = J.split("/"), F.includes("PROJ-RECT") ? B.projection = "rect" : F.includes("PROJ-EQUI") ? B.projection = "equi" : F.includes("PROJ-HEQU") ? B.projection = "hequ" : F.includes("PROJ-PRIM") ? B.projection = "prim" : F.includes("PROJ-AIV") && (B.projection = "hequ")), I = new Bh, I.box("moov", Gh).box("trak", Gh).box("mdia", Gh).qa("mdhd", function(Q) {
                                            C = Xi(Q.reader, Q.version).timescale;
                                        }).qa("hdlr", function(Q) {
                                            Q = Q.reader;
                                            Q.skip(4);
                                            Q = Q.Wb(4, !1);
                                            switch(String.fromCharCode(Q[0], Q[1], Q[2], Q[3])){
                                                case "soun":
                                                    D.set(e.ha, C);
                                                    break;
                                                case "vide":
                                                    D.set(e.Ba, C);
                                            }
                                            C = null;
                                        }), b.type !== e.Ba || B.projection || I.box("minf", Gh).box("stbl", Gh).qa("stsd", Ih).boxes("encv avc1 avc3 hev1 hvc1 dvav dva1 dvh1 dvhe dvc1 dvi1".split(" "), Jh).box("vexu", Gh).box("proj", Gh).qa("prji", function(Q) {
                                            Q = Q.reader.Qd();
                                            B.projection = Q;
                                        }).box("hfov", function(Q) {
                                            Q = Q.reader.Y() / 1E3;
                                            B.hfov = Q;
                                        }), I.parse(E, !0, !0), b.type === e.Ba && $n(a, B), D.has(b.type) ? c.ia.timescale = D.get(b.type) : C != null && (c.ia.timescale = C), K = b.stream.segmentIndex, K instanceof ym && (N = Am(K, c.startTime)), P = b.stream.closedCaptions && b.stream.closedCaptions.size > 0, L.g(a.g.Ni(b.type, E), 5);
                                    case 5:
                                        return L.g(ml(a.g.aa, b.type, E, null, b.stream, P, b.ld, d, !1, !1, N), 6);
                                    case 6:
                                        L.o(0);
                                        break;
                                    case 2:
                                        throw M = L.l(), b.qb = null, M;
                                }
                            });
                        }, x = c.startTime, f && (y = il(a.g.aa, b.type), y != null && (x = y)), a.g.Wl(x, c.ia), g.push(w()))), z = b.Na ? b.Na.i : -1, c.i != z && g.push(yl(a.g.aa, b.type, c.startTime)), A.g(Promise.all(g), 0);
                }
            });
        }
        function Zn(a, b, c, d, e, f, g, h) {
            var k, l, m, n, q;
            return H(function(r) {
                switch(r.h){
                    case 1:
                        k = Gc;
                        l = In(a);
                        r.m(2);
                        b.Ac = d;
                        b.zc = e;
                        g && (b.Jf = g);
                        h && (b.Kf = h);
                        b.Lf = c;
                        m = a.j.sequenceMode || a.j.type == "HLS";
                        n = null;
                        b.type === k.Ba ? n = a.h.get(k.ha) : b.type === k.ha && (n = a.h.get(k.Ba));
                        if (!(n && n.stream && n.stream.isAudioMuxedInVideo)) {
                            r.B(4);
                            break;
                        }
                        return r.g(vl(a.g.aa, n.type, c, d, e, m, n.stream.mimeType, n.stream.codecs, l), 4);
                    case 4:
                        return r.g(vl(a.g.aa, b.type, c, d, e, m, f.mimeType || b.stream.mimeType, f.codecs || b.stream.codecs, l), 6);
                    case 6:
                        r.o(0);
                        break;
                    case 2:
                        throw q = r.l(), b.Ac = null, b.zc = null, b.Jf = null, b.Kf = null, b.Lf = null, q;
                }
            });
        }
        function Un(a, b, c, d, e, f, g, h) {
            g = g === void 0 ? !1 : g;
            h = h === void 0 ? !1 : h;
            var k, l, m, n, q;
            return H(function(r) {
                switch(r.h){
                    case 1:
                        return k = d.closedCaptions && d.closedCaptions.size > 0, a.i.shouldFixTimestampOffset && (l = d.mimeType == "video/mp4" || d.mimeType == "audio/mp4", m = null, e.ia && (m = e.ia.timescale), (n = l && m && d.type === "video" && a.j.type == "DASH") && (new Bh).box("moof", Gh).box("traf", Gh).qa("tfdt", function(t) {
                            var v, w, x, y, z, A;
                            return H(function(E) {
                                v = Wi(t.reader, t.version);
                                w = v.baseMediaDecodeTime;
                                if (!w) return E.return();
                                x = -w / m;
                                y = Number(b.Lf) || 0;
                                if (!(y < x)) return E.B(0);
                                z = b.Ac;
                                A = b.zc;
                                return E.g(Zn(a, b, x, z, A, e), 0);
                            });
                        }).parse(f, !1, g)), r.g(Yn(a, b, c), 2);
                    case 2:
                        return vh(a.l), q = b.ld, b.ld = !1, r.g(a.g.Ni(b.type, f), 3);
                    case 3:
                        return r.g(ml(a.g.aa, b.type, f, e, d, k, q, h, g), 4);
                    case 4:
                        vh(a.l), r.j();
                }
            });
        }
        function Yn(a, b, c) {
            var d, e, f, g, h, k, l, m, n;
            return H(function(q) {
                if (q.h == 1) {
                    a.H == b && (a.H = null);
                    d = b.stream.segmentIndex;
                    d instanceof ym && (d.$a(a.j.presentationTimeline.Hb()), e = [], zm(d, function(r) {
                        e.push(r.lf());
                    }));
                    f = Math.max(a.i.bufferBehind * a.D, a.j.presentationTimeline.h);
                    g = gl(a.g.aa, b.type);
                    if (g == null) return q.return();
                    h = c - g;
                    k = a.i.evictionGoal;
                    l = a.j.presentationTimeline.cc();
                    m = a.j.presentationTimeline.Gb();
                    n = h - f;
                    m - l > k && (n = Math.max(h - f, l - k - g));
                    return n <= k ? q.return() : q.g(a.g.aa.remove(b.type, g, g + n, e), 2);
                }
                if (q.h != 4) return vh(a.l), a.H ? q.g(Yn(a, a.H, c), 4) : q.B(0);
                vh(a.l);
                q.j();
            });
        }
        function Nn(a) {
            return a && a.type == Ec && (a.stream.mimeType == "application/cea-608" || a.stream.mimeType == "application/cea-708");
        }
        function Vn(a, b, c, d) {
            var e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        if (e = c.dc()) return l.return(e);
                        f = null;
                        if (b.ma) {
                            var m = b.ma, n = m.g;
                            c instanceof Mj && (n = m.j);
                            n.has(c) ? (m = n.get(c), d && (m.ri = d), f = m.Be) : f = null;
                        }
                        f || (f = Jn(c, b.stream, d || null, a.i.retryParameters, a.g.Cc));
                        g = 0;
                        b.Aa && (g = b.Aa.h);
                        b.bb = f;
                        return l.g(f.promise, 2);
                    case 2:
                        h = l.i;
                        b.bb = null;
                        k = h.data;
                        if (!c.aesKey) {
                            l.B(3);
                            break;
                        }
                        return l.g(en(k, c.aesKey, g), 4);
                    case 4:
                        k = l.i;
                    case 3:
                        return l.return(k);
                }
            });
        }
        function Jn(a, b, c, d, e, f) {
            f = f === void 0 ? !1 : f;
            var g = a instanceof Oj ? a : void 0, h = g ? 1 : 0;
            a = jn(a.T(), a.startByte, a.endByte, d, c);
            a.contentType = b.type;
            return e.request(sh, a, {
                type: h,
                stream: b,
                segment: g,
                isPreload: f
            });
        }
        function Fn(a, b, c, d) {
            var e, f;
            return H(function(g) {
                if (g.h == 1) return b.Yb = !1, b.ae = !1, b.vd = 0, b.$b = !0, b.Na = null, b.Aa = null, b.ma && !a.m.has(b.stream) && Xm(b.ma), d ? (e = a.g.bc(), f = a.g.aa.getDuration(), g.g(a.g.aa.remove(b.type, e + d, f), 3)) : g.g(ul(a.g.aa, b.type), 4);
                if (g.h != 3) return vh(a.l), c ? g.g(a.g.aa.flush(b.type), 3) : g.B(3);
                vh(a.l);
                b.$b = !1;
                b.endOfStream = !1;
                b.Ra || b.rb || un(a, b, 0);
                g.j();
            });
        }
        function un(a, b, c) {
            var d = b.type;
            if (d != Ec || a.h.has(d)) b.rb = new Uf(function() {
                var e;
                return H(function(f) {
                    if (f.h == 1) return f.m(2), f.g(Kn(a, b), 4);
                    if (f.h != 2) return f.o(0);
                    e = f.l();
                    if (a.g) a.g.onError(e);
                    f.j();
                });
            }).Z(c);
        }
        function mn(a) {
            a.rb != null && (a.rb.stop(), a.rb = null);
        }
        function nn(a) {
            return H(function(b) {
                return a.bb ? b.g(a.bb.abort(), 0) : b.B(0);
            });
        }
        function Ln(a, b, c) {
            var d, e, f, g, h;
            return H(function(k) {
                switch(k.h){
                    case 1:
                        return c.code == 3024 ? (b.Ra = !1, mn(b), un(a, b, 0), k.return()) : k.g(Xg(a.V), 2);
                    case 2:
                        vh(a.l);
                        if (c.category === 1 && c.code != 1003) {
                            if (b.Vc) return wn(a, !1), k.return();
                            d = Xn(a, c);
                            c.handled = a.g.disableStream(b.stream, d);
                            c.handled && (c.severity = 1);
                        }
                        if (c.handled || c.code != 1011) {
                            k.B(3);
                            break;
                        }
                        e = a.g.bc();
                        f = il(a.g.aa, b.type);
                        for(g = Pn(a, b, e, f); ((h = g) == null ? void 0 : h.ec()) === 2;)b.Na = g, g = Pn(a, b, e, f);
                        if (!g) {
                            k.B(3);
                            break;
                        }
                        return k.g(yl(a.g.aa, b.type, g.startTime), 5);
                    case 5:
                        return b.Ra = !1, b.Fd = !1, mn(b), un(a, b, 0), k.return();
                    case 3:
                        if (!c.handled || c.code != 1011) a.g.onError(c);
                        c.handled || a.i.failureCallback(c);
                        k.j();
                }
            });
        }
        function Xn(a, b) {
            return a.i.maxDisabledTime === 0 && b.code == 1011 ? 1 : a.i.maxDisabledTime;
        }
        function On(a, b) {
            b = b === void 0 ? !1 : b;
            var c, d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) {
                    c = Date.now() / 1E3;
                    d = a.i.minTimeBetweenRecoveries;
                    if (!b && (!a.i.allowMediaSourceRecoveries || c - a.P < d)) return k.return(!1);
                    a.P = c;
                    e = Gc;
                    if (f = a.h.get(e.ha)) mn(f), f.bb && (f.bb.abort(), f.bb = null), f.qb = null, f.Ac = null, f.zc = null, f.Ra = !1, f.Yb = !1, f.vd = 0, f.ae = !1, f.$b = !1, f.Aa && f.Aa.ai();
                    if (g = a.h.get(e.Ba)) mn(g), g.bb && (g.bb.abort(), g.bb = null), g.qb = null, g.Ac = null, g.zc = null, g.Ra = !1, g.Yb = !1, g.vd = 0, g.ae = !1, g.$b = !1, g.Aa && g.Aa.ai();
                    h = a.g.video.paused;
                    return k.g(Pl(a.g.aa, In(a)), 2);
                }
                !g || g.$b || g.Ra || g.rb || un(a, g, 0);
                !f || f.$b || f.Ra || f.rb || un(a, f, 0);
                h || a.g.video.play();
                return k.return(!0);
            });
        }
        function $n(a, b) {
            if (a.R.projection != b.projection || a.R.hfov != b.hfov) {
                if (b.projection != null || b.hfov != null) {
                    var c = (new Map).set("detail", b);
                    c = new R("spatialvideoinfo", c);
                } else c = new R("nospatialvideoinfo");
                c.cancelable = !0;
                a.g.onEvent(c);
                a.R = b;
            }
        }
        function Gn(a) {
            if (a.i.crossBoundaryStrategy !== "keep") return !0;
            var b = Xb();
            if (!b.Bb()) {
                b = u(a.h.keys());
                for(var c = b.next(); !c.done; c = b.next())if (c = a.h.get(c.value), c.type !== Gc.Va && (c = c.stream) && c.fullMimeTypes && c.fullMimeTypes.size > 1) return !0;
            } else if (!b.mg()) {
                for(b = u(a.h.keys()), c = b.next(); !c.done; c = b.next())if (c = a.h.get(c.value), c.type !== Gc.Va && (c = c.stream) && c.fullMimeTypes && c.fullMimeTypes.size > 1) {
                    a = new Set;
                    b = u(c.fullMimeTypes);
                    for(c = b.next(); !c.done; c = b.next())a.add(Bf(c.value));
                    return a.size > 1;
                }
            }
            return !1;
        }
        function Cn(a) {
            a.G.Ta();
            Gn(a) && (a.G.u(a.g.video, "waiting", function() {
                return Hn(a);
            }), a.G.u(a.g.video, "timeupdate", function() {
                return Hn(a);
            }));
        }
        function Hn(a) {
            if (Gn(a)) {
                a.K.stop();
                var b = a.g.bc(), c = a.h.get("video") || a.h.get("audio");
                c && (c = c.qb) && c.g !== null && (b = c.g - b, b < 0 || b > 1 || (a.I = c.g + .1, a.K.Z(b)));
            }
        }
        function Qn(a, b, c) {
            if (b.type === Ec) return !1;
            var d = b.qb;
            if (!d) return !1;
            var e = c.ia;
            c = d.g !== e.g;
            a.i.crossBoundaryStrategy === "reset_to_encrypted" && (d.encrypted || e.encrypted || (c = !1), d.encrypted && (a.i.crossBoundaryStrategy = "keep"));
            a.i.crossBoundaryStrategy === "RESET_ON_ENCRYPTION_CHANGE" && d.encrypted == e.encrypted && (c = !1);
            if (a.i.crossBoundaryStrategy === "keep" && d.mimeType && e.mimeType) {
                var f = Cf(Gf(d.mimeType)), g = Cf(Gf(e.mimeType));
                d.mimeType == e.mimeType && f == g && (c = !1);
            }
            (a.h.get("video") || a.h.get("audio")) === b && c && (a.J || b.ld) && (a.J = !1, On(a, !0).then(function() {
                var h = (new Map).set("oldEncrypted", d.encrypted).set("newEncrypted", e.encrypted);
                a.g.onEvent(new R("boundarycrossed", h));
            }));
            return c;
        }
        function In(a, b) {
            function c(f) {
                if (f.fullMimeTypes && f.fullMimeTypes.size > 1 && a.h.has(f.type)) {
                    var g = a.h.get(f.type), h = il(a.g.aa, g.type), k = a.g.bc();
                    (g = Pn(a, g, k, h)) && g.codecs && g.mimeType && (f.codecs = g.codecs, f.mimeType = g.mimeType);
                }
            }
            b = b === void 0 ? !1 : b;
            var d = new Map, e = a.o.audio;
            e && (c(e), d.set("audio", e));
            if (e = a.o.video) c(e), d.set("video", e);
            b && a.C && d.set(Ec, a.C);
            return d;
        }
        function ao() {}
        function bo(a, b, c, d, e) {
            var f = e in d, g = new Set([
                "__proto__",
                "constructor",
                "prototype"
            ]);
            var h = f ? c.constructor == Object && Object.keys(d).length == 0 : c.constructor == Object && Object.keys(c).length == 0;
            for(var k = f || h, l = !0, m = u(Object.keys(b)), n = m.next(); !n.done; n = m.next()){
                n = n.value;
                var q = e + "." + n, r = f ? d[e] : c[n];
                g.has(n) ? (Ya("Invalid config, dangerous key " + q), l = !1) : k || n in c ? b[n] === void 0 ? r === void 0 || k ? delete a[n] : a[n] = Xd(r) : h ? a[n] = b[n] : r.constructor == Object && b[n] && b[n].constructor == Object ? (a[n] || (a[n] = Xd(r)), n = bo(a[n], b[n], r, d, q), l = l && n) : typeof b[n] != typeof r || b[n] == null || typeof b[n] != "function" && b[n].constructor != r.constructor ? (Ya("Invalid config, wrong type for " + q), l = !1) : typeof c[n] == "function" && c[n].length != b[n].length ? (Za("Unexpected number of arguments for " + q), a[n] = b[n]) : a[n] = Array.isArray(a[n]) ? b[n].slice() : b[n] : (Ya("Invalid config, unrecognized key " + q), l = !1);
            }
            return l;
        }
        function co(a, b) {
            for(var c = {}, d = c, e = 0, f = 0;;){
                e = a.indexOf(".", e);
                if (e < 0) break;
                if (e == 0 || a[e - 1] != "\\") f = a.substring(f, e).replace(/\\\./g, "."), d[f] = {}, d = d[f], f = e + 1;
                e += 1;
            }
            d[a.substring(f).replace(/\\\./g, ".")] = b;
            return c;
        }
        function eo(a, b) {
            return a && b;
        }
        function fo(a, b) {
            function c(f) {
                for(var g = u(Object.keys(f)), h = g.next(); !h.done; h = g.next())if (h = h.value, !(f[h] instanceof HTMLElement)) {
                    if (e(f[h]) && Object.keys(f[h]).length === 0) delete f[h];
                    else {
                        var k = f[h];
                        Array.isArray(k) && k.length === 0 ? delete f[h] : typeof f[h] == "function" ? delete f[h] : e(f[h]) && (c(f[h]), Object.keys(f[h]).length === 0 && delete f[h]);
                    }
                }
            }
            function d(f, g) {
                return Object.keys(f).reduce(function(h, k) {
                    var l = f[k];
                    if (g.hasOwnProperty(k)) {
                        if (l instanceof HTMLElement && g[k] instanceof HTMLElement) l.isEqualNode(g[k]) || (h[k] = l);
                        else if (e(l) && e(g[k])) {
                            if (l = d(l, g[k]), Object.keys(l).length > 0 || !e(l)) h[k] = l;
                        } else Array.isArray(l) && Array.isArray(g[k]) ? bd(l, g[k]) || (h[k] = l) : Number.isNaN(l) && Number.isNaN(g[k]) || l !== g[k] && (h[k] = l);
                    } else h[k] = l;
                    return h;
                }, {});
            }
            function e(f) {
                return f && typeof f === "object" && !Array.isArray(f);
            }
            a = d(a, b);
            c(a);
            return a;
        }
        O("shaka.util.ConfigUtils", ao);
        ao.getDifferenceFromConfigObjects = fo;
        ao.convertToConfigObject = co;
        ao.mergeConfigObjects = bo;
        O("shaka.config.RepeatMode", {
            OFF: 0,
            ALL: 1,
            SINGLE: 2
        });
        function go() {}
        function ho(a) {
            a = ec(a);
            return new lb(a).Eb;
        }
        function io(a, b, c) {
            function d(h) {
                Jb(f).setUint32(g, h.byteLength, !0);
                g += 4;
                f.set(Fb(h), g);
                g += h.byteLength;
            }
            if (!c || !c.byteLength) throw new T(2, 6, 6015);
            var e;
            typeof b == "string" ? e = ic(b, !0) : e = b;
            a = ec(a);
            a = ic(a, !0);
            var f = new Uint8Array(12 + a.byteLength + e.byteLength + c.byteLength), g = 0;
            d(a);
            d(e);
            d(c);
            return f;
        }
        function jo(a, b, c) {
            if (b !== "skd") return a;
            b = c.serverCertificate;
            c = ec(a).split("skd://").pop();
            return io(a, c, b);
        }
        function ko(a, b) {
            a === 2 && (a = b.drmInfo) && Rb(a.keySystem) && (b.headers["Content-Type"] = "application/octet-stream");
        }
        O("shaka.drm.FairPlay", go);
        go.commonFairPlayResponse = function(a, b) {
            if (a === 2 && (a = b.originalRequest.drmInfo) && Rb(a.keySystem)) {
                try {
                    var c = bc(b.data);
                } catch (e) {
                    return;
                }
                a = !1;
                c = c.trim();
                c.substr(0, 5) === "<ckc>" && c.substr(-6) === "</ckc>" && (c = c.slice(5, -6), a = !0);
                if (!a) try {
                    var d = JSON.parse(c);
                    d.ckc && (c = d.ckc, a = !0);
                    d.CkcMessage && (c = d.CkcMessage, a = !0);
                    d.License && (c = d.License, a = !0);
                } catch (e) {}
                a && (b.data = Gb(qc(c)));
            }
        };
        go.muxFairPlayRequest = function(a, b) {
            ko(a, b);
        };
        go.expressplayFairPlayRequest = function(a, b) {
            if (a === 2) {
                var c = b.drmInfo;
                c && Rb(c.keySystem) && ko(a, b);
            }
        };
        go.conaxFairPlayRequest = function(a, b) {
            ko(a, b);
        };
        go.ezdrmFairPlayRequest = function(a, b) {
            ko(a, b);
        };
        go.verimatrixFairPlayRequest = function(a, b) {
            a === 2 && (a = b.drmInfo) && Rb(a.keySystem) && (a = Fb(b.body), a = mc(a), b.headers["Content-Type"] = "application/x-www-form-urlencoded", b.body = hc("spc=" + a));
        };
        go.muxInitDataTransform = function(a, b, c) {
            return jo(a, b, c);
        };
        go.expressplayInitDataTransform = function(a, b, c) {
            return jo(a, b, c);
        };
        go.conaxInitDataTransform = function(a, b, c) {
            if (b !== "skd") return a;
            b = c.serverCertificate;
            c = ec(a).split("skd://").pop().split("?").shift();
            c = window1.atob(c);
            var d = new ArrayBuffer(c.length * 2);
            d = Ib(d);
            for(var e = 0, f = c.length; e < f; e++)d[e] = c.charCodeAt(e);
            return io(a, d, b);
        };
        go.ezdrmInitDataTransform = function(a, b, c) {
            if (b !== "skd") return a;
            b = c.serverCertificate;
            c = ec(a).split(";").pop();
            return io(a, c, b);
        };
        go.verimatrixInitDataTransform = function(a, b, c) {
            return jo(a, b, c);
        };
        go.initDataTransform = io;
        go.defaultGetContentId = ho;
        go.isFairPlaySupported = function() {
            var a;
            return H(function(b) {
                if (b.h == 1) return a = {
                    initDataTypes: [
                        "cenc",
                        "sinf",
                        "skd"
                    ],
                    videoCapabilities: [
                        {
                            contentType: 'video/mp4; codecs="avc1.42E01E"'
                        }
                    ]
                }, b.m(2), b.g(navigator.requestMediaKeySystemAccess("com.apple.fps", [
                    a
                ]), 4);
                if (b.h != 2) return b.return(!0);
                b.l();
                return b.return(!1);
            });
        };
        function lo(a, b, c) {
            c = c === void 0 ? !0 : c;
            this.h = a;
            this.g = new Set([
                a
            ]);
            b = b || [];
            a = u(b);
            for(b = a.next(); !b.done; b = a.next())this.add(b.value, c);
        }
        lo.prototype.add = function(a, b) {
            var c = this.h;
            b = b === void 0 ? !0 : b;
            var d;
            if (!(d = !!c.audio != !!a.audio || !!c.video != !!a.video || c.language != a.language) && (d = c.audio && a.audio)) {
                d = c.audio;
                var e = a.audio;
                d = !(!((!d.channelsCount || !e.channelsCount || d.channelsCount > 2 || e.channelsCount > 2) && d.channelsCount != e.channelsCount || d.spatialAudio !== e.spatialAudio || b && !mo(d, e)) && bd(d.roles, e.roles) && d.groupId === e.groupId);
            }
            !d && (d = c.video && a.video) && (c = c.video, d = a.video, d = !((!b || mo(c, d)) && bd(c.roles, d.roles)));
            return d ? !1 : (this.g.add(a), !0);
        };
        lo.prototype.values = function() {
            return this.g.values();
        };
        function mo(a, b) {
            if (a.mimeType != b.mimeType) return !1;
            a = a.codecs.split(",").map(function(c) {
                return Ef(c);
            });
            b = b.codecs.split(",").map(function(c) {
                return Ef(c);
            });
            return bd(a, b);
        }
        O("shaka.media.AdaptationSet", lo);
        function no() {
            this.h = this.g = null;
        }
        no.prototype.configure = function(a) {
            this.g = a;
        };
        no.prototype.getConfiguration = function() {
            return this.g;
        };
        no.prototype.create = function(a) {
            var b;
            if (this.g.language) {
                var c = oo(a, this.g.language);
                c.length && (b = c);
            }
            b || (b = a.filter(function(f) {
                return f.primary;
            }), b = b.length ? b : a);
            a = po(b, this.g.role);
            a.length && (b = a);
            a = qo(b, this.g.videoRole);
            a.length && (b = a);
            this.g.videoLayout && (a = ro(b, this.g.videoLayout), a.length && (b = a));
            this.g.hdrLevel && (a = so(b, this.g.hdrLevel), a.length && (b = a));
            var d = [
                this.g.channelCount,
                this.g.preferredAudioChannelCount
            ];
            a = d.filter(function(f, g) {
                return f && d.indexOf(f) === g;
            });
            if (a.length) {
                for(a = u(a), c = a.next(); !c.done; c = a.next())if (c = to(b, c.value), c.length) {
                    b = c;
                    break;
                }
            }
            this.g.audioLabel && (a = uo(b, this.g.audioLabel), a.length && (b = a));
            this.g.videoLabel && (a = vo(b, this.g.videoLabel), a.length && (b = a));
            a = wo(b, this.g.spatialAudio);
            a.length && (b = a);
            var e = [
                this.g.audioCodec,
                this.g.activeAudioCodec
            ].concat(G(this.g.preferredAudioCodecs));
            a = e.filter(function(f, g) {
                return f && e.indexOf(f) === g;
            });
            if (a.length) {
                for(a = u(a), c = a.next(); !c.done; c = a.next())if (c = xo(b, c.value), c.length) {
                    b = c;
                    break;
                }
            }
            a = Xb();
            a = this.g.codecSwitchingStrategy == "smooth" && a.Bb();
            return this.h = new lo(b[0], b, !a);
        };
        no.prototype.getLastAdaptationSet = function() {
            return this.h;
        };
        function oo(a, b) {
            b = Kc(b);
            var c = Sc(b, a.map(function(d) {
                return Rc(d);
            }));
            return c ? a.filter(function(d) {
                return c == Rc(d);
            }) : [];
        }
        function po(a, b) {
            return a.filter(function(c) {
                return c.audio ? b ? c.audio.roles.includes(b) : c.audio.roles.length == 0 : !1;
            });
        }
        function qo(a, b) {
            return a.filter(function(c) {
                return c.video ? b ? c.video.roles.includes(b) : c.video.roles.length == 0 : !1;
            });
        }
        function uo(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.label ? c.audio.label.toLowerCase() == b.toLowerCase() : !1;
            });
        }
        function vo(a, b) {
            return a.filter(function(c) {
                return c.video && c.video.label ? c.video.label.toLowerCase() == b.toLowerCase() : !1;
            });
        }
        function to(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.channelsCount && c.audio.channelsCount > b ? !1 : !0;
            }).sort(function(c, d) {
                return c.audio || d.audio ? c.audio ? d.audio ? (d.audio.channelsCount || 0) - (c.audio.channelsCount || 0) : 1 : -1 : 0;
            });
        }
        function so(a, b) {
            if (b == "AUTO") {
                var c = a.some(function(d) {
                    return d.video && d.video.hdr && d.video.hdr == "HLG" ? !0 : !1;
                });
                b = Xb().Dd(c);
            }
            return a.filter(function(d) {
                return d.video && d.video.hdr && d.video.hdr != b ? !1 : !0;
            });
        }
        function ro(a, b) {
            return a.filter(function(c) {
                return c.video && c.video.videoLayout && c.video.videoLayout != b ? !1 : !0;
            });
        }
        function wo(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.spatialAudio != b ? !1 : !0;
            });
        }
        function xo(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.codecs != b ? !1 : !0;
            });
        }
        function yo() {}
        function zo() {
            var a = Infinity, b = Xb();
            navigator.connection && navigator.connection.saveData && (a = 360);
            var c = {
                retryParameters: Wg(),
                servers: {},
                clearKeys: {},
                advanced: {},
                delayLicenseRequestUntilPlayed: !1,
                persistentSessionOnlinePlayback: !1,
                persistentSessionsMetadata: [],
                initDataTransform: function(h, k, l) {
                    "apple" === window1.shakaMediaKeysPolyfill && k == "skd" && (k = l.serverCertificate, l = ho(h), h = io(h, l, k));
                    return h;
                },
                logLicenseExchange: !1,
                updateExpirationTime: 1,
                preferredKeySystems: [],
                keySystemsMapping: {},
                parseInbandPsshEnabled: !1,
                minHdcpVersion: "",
                ignoreDuplicateInitData: !0,
                defaultAudioRobustnessForWidevine: "SW_SECURE_CRYPTO",
                defaultVideoRobustnessForWidevine: "SW_SECURE_DECODE"
            }, d = "reload";
            b.Bb() && (d = "smooth");
            var e = {
                retryParameters: Wg(),
                availabilityWindowOverride: NaN,
                disableAudio: !1,
                disableVideo: !1,
                disableText: !1,
                disableThumbnails: !1,
                disableIFrames: !1,
                defaultPresentationDelay: 0,
                segmentRelativeVttTiming: !1,
                raiseFatalErrorOnManifestUpdateRequestFailure: !1,
                continueLoadingWhenPaused: !0,
                ignoreSupplementalCodecs: !1,
                updatePeriod: -1,
                ignoreDrmInfo: !1,
                enableAudioGroups: !0,
                dash: {
                    clockSyncUri: "",
                    disableXlinkProcessing: !0,
                    xlinkFailGracefully: !1,
                    ignoreMinBufferTime: !1,
                    autoCorrectDrift: !0,
                    initialSegmentLimit: 1E3,
                    ignoreSuggestedPresentationDelay: !1,
                    ignoreEmptyAdaptationSet: !1,
                    ignoreMaxSegmentDuration: !1,
                    keySystemsByURI: {
                        "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
                        "urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e": "org.w3.clearkey",
                        "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
                        "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
                        "urn:uuid:79f0049a-4098-8642-ab92-e65be0885f95": "com.microsoft.playready",
                        "urn:uuid:94ce86fb-07ff-4f43-adb8-93d2fa968ca2": "com.apple.fps",
                        "urn:uuid:3d5e6d35-9b9a-41e8-b843-dd3c6e72c42c": "com.huawei.wiseplay"
                    },
                    manifestPreprocessor: Ao,
                    manifestPreprocessorTXml: Bo,
                    sequenceMode: !1,
                    useStreamOnceInPeriodFlattening: !1,
                    enableFastSwitching: !0
                },
                hls: {
                    ignoreTextStreamFailures: !1,
                    ignoreImageStreamFailures: !1,
                    defaultAudioCodec: "mp4a.40.2",
                    defaultVideoCodec: "avc1.42E01E",
                    ignoreManifestProgramDateTime: !1,
                    ignoreManifestProgramDateTimeForTypes: [],
                    mediaPlaylistFullMimeType: 'video/mp2t; codecs="avc1.42E01E, mp4a.40.2"',
                    liveSegmentsDelay: 3,
                    sequenceMode: b.pd(),
                    ignoreManifestTimestampsInSegmentsMode: !1,
                    disableCodecGuessing: !1,
                    disableClosedCaptionsDetection: !1,
                    allowLowLatencyByteRangeOptimization: !0,
                    allowRangeRequestsToGuessMimeType: !1
                },
                mss: {
                    manifestPreprocessor: Ao,
                    manifestPreprocessorTXml: Bo,
                    sequenceMode: !1,
                    keySystemsBySystemId: {
                        "9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
                        "79f0049a-4098-8642-ab92-e65be0885f95": "com.microsoft.playready"
                    }
                }
            }, f = {
                trackSelectionCallback: function(h) {
                    return H(function(k) {
                        return k.return(h);
                    });
                },
                downloadSizeCallback: function(h) {
                    var k;
                    return H(function(l) {
                        if (l.h == 1) return navigator.storage && navigator.storage.estimate ? l.g(navigator.storage.estimate(), 3) : l.return(!0);
                        k = l.i;
                        return l.return(k.usage + h < k.quota * .95);
                    });
                },
                progressCallback: function(h, k) {
                    return eo([
                        h,
                        k
                    ]);
                },
                usePersistentLicense: !0,
                numberOfParallelDownloads: 5
            }, g = {
                drm: c,
                manifest: e,
                streaming: {
                    retryParameters: Wg(),
                    failureCallback: function(h) {
                        return eo([
                            h
                        ]);
                    },
                    rebufferingGoal: 0,
                    bufferingGoal: 10,
                    bufferBehind: 30,
                    evictionGoal: 1,
                    ignoreTextStreamFailures: !1,
                    alwaysStreamText: !1,
                    startAtSegmentBoundary: !1,
                    gapDetectionThreshold: .5,
                    gapPadding: 0,
                    gapJumpTimerTime: .25,
                    durationBackoff: 1,
                    safeSeekOffset: 5,
                    safeSeekEndOffset: 0,
                    stallEnabled: !0,
                    stallThreshold: 1,
                    stallSkip: .1,
                    useNativeHlsForFairPlay: !0,
                    inaccurateManifestTolerance: 2,
                    lowLatencyMode: !0,
                    preferNativeDash: !1,
                    preferNativeHls: !1,
                    updateIntervalSeconds: 1,
                    observeQualityChanges: !1,
                    maxDisabledTime: 30,
                    segmentPrefetchLimit: 1,
                    prefetchAudioLanguages: [],
                    disableAudioPrefetch: !1,
                    disableTextPrefetch: !1,
                    disableVideoPrefetch: !1,
                    liveSync: {
                        enabled: !1,
                        targetLatency: .5,
                        targetLatencyTolerance: .5,
                        maxPlaybackRate: 1.1,
                        minPlaybackRate: .95,
                        panicMode: !1,
                        panicThreshold: 60,
                        dynamicTargetLatency: {
                            enabled: !1,
                            stabilityThreshold: 60,
                            rebufferIncrement: .5,
                            maxAttempts: 10,
                            maxLatency: 4,
                            minLatency: 1
                        }
                    },
                    allowMediaSourceRecoveries: !0,
                    minTimeBetweenRecoveries: 5,
                    vodDynamicPlaybackRate: !1,
                    vodDynamicPlaybackRateLowBufferRate: .95,
                    vodDynamicPlaybackRateBufferRatio: .5,
                    preloadNextUrlWindow: 30,
                    loadTimeout: 30,
                    clearDecodingCache: !1,
                    dontChooseCodecs: !1,
                    shouldFixTimestampOffset: !1,
                    avoidEvictionOnQuotaExceededError: !1,
                    crossBoundaryStrategy: "keep",
                    returnToEndOfLiveWindowWhenOutside: !1
                },
                networking: {
                    forceHTTP: !1,
                    forceHTTPS: !1,
                    minBytesForProgressEvents: 16E3
                },
                mediaSource: {
                    codecSwitchingStrategy: d,
                    addExtraFeaturesToSourceBuffer: function(h) {
                        return eo([
                            h
                        ], "");
                    },
                    forceTransmux: !1,
                    insertFakeEncryptionInInit: !0,
                    correctEc3Enca: !1,
                    modifyCueCallback: function(h, k, l) {
                        return eo([
                            h,
                            k,
                            l
                        ]);
                    },
                    dispatchAllEmsgBoxes: !1,
                    useSourceElements: !0,
                    durationReductionEmitsUpdateEnd: !0
                },
                offline: f,
                abrFactory: function() {
                    return new Qg;
                },
                adaptationSetCriteriaFactory: function() {
                    return new (Function.prototype.bind.apply(no, [
                        null
                    ].concat(G(Ma.apply(0, arguments)))));
                },
                abr: {
                    enabled: !0,
                    useNetworkInformation: !0,
                    defaultBandwidthEstimate: 1E6,
                    switchInterval: 8,
                    bandwidthUpgradeTarget: .85,
                    bandwidthDowngradeTarget: .95,
                    restrictions: {
                        minWidth: 0,
                        maxWidth: Infinity,
                        minHeight: 0,
                        maxHeight: a,
                        minPixels: 0,
                        maxPixels: Infinity,
                        minFrameRate: 0,
                        maxFrameRate: Infinity,
                        minBandwidth: 0,
                        maxBandwidth: Infinity,
                        minChannelsCount: 0,
                        maxChannelsCount: Infinity
                    },
                    advanced: {
                        minTotalBytes: 128E3,
                        minBytes: 16E3,
                        fastHalfLife: 2,
                        slowHalfLife: 5
                    },
                    restrictToElementSize: !1,
                    restrictToScreenSize: !1,
                    ignoreDevicePixelRatio: !1,
                    clearBufferSwitch: !1,
                    safeMarginSwitch: 0,
                    cacheLoadThreshold: 5,
                    minTimeToSwitch: 0,
                    preferNetworkInformationBandwidth: !1,
                    removeLatencyFromFirstPacketTime: !1
                },
                autoShowText: 3,
                preferredAudioLanguage: "",
                preferredAudioLabel: "",
                preferredTextLanguage: "",
                preferredAudioRole: "",
                preferredVideoRole: "",
                preferredTextRole: "",
                preferredAudioChannelCount: 2,
                preferredVideoHdrLevel: "AUTO",
                preferredVideoLayout: "",
                preferredVideoLabel: "",
                preferredVideoCodecs: [],
                preferredAudioCodecs: [],
                preferredTextFormats: [],
                preferForcedSubs: !1,
                preferSpatialAudio: !1,
                preferredDecodingAttributes: [],
                restrictions: {
                    minWidth: 0,
                    maxWidth: Infinity,
                    minHeight: 0,
                    maxHeight: Infinity,
                    minPixels: 0,
                    maxPixels: Infinity,
                    minFrameRate: 0,
                    maxFrameRate: Infinity,
                    minBandwidth: 0,
                    maxBandwidth: Infinity,
                    minChannelsCount: 0,
                    maxChannelsCount: Infinity
                },
                playRangeStart: 0,
                playRangeEnd: Infinity,
                textDisplayer: {
                    captionsUpdatePeriod: .25,
                    fontScaleFactor: 1
                },
                textDisplayFactory: function() {
                    return null;
                },
                cmcd: {
                    enabled: !1,
                    sessionId: "",
                    contentId: "",
                    rtpSafetyFactor: 5,
                    useHeaders: !1,
                    includeKeys: [],
                    version: 1,
                    targets: []
                },
                cmsd: {
                    enabled: !0,
                    applyMaximumSuggestedBitrate: !0,
                    estimatedThroughputWeightRatio: .5
                },
                lcevc: {
                    enabled: !1,
                    dynamicPerformanceScaling: !0,
                    logLevel: 0,
                    drawLogo: !1,
                    poster: !0
                },
                ads: {
                    customPlayheadTracker: !1,
                    skipPlayDetection: !1,
                    supportsMultipleMediaElements: !0,
                    disableHLSInterstitial: !1,
                    disableDASHInterstitial: !1,
                    allowPreloadOnDomElements: !0,
                    allowStartInMiddleOfInterstitial: !0
                },
                ignoreHardwareResolution: !1,
                queue: {
                    preloadNextUrlWindow: Infinity,
                    preloadPrevItem: !0,
                    repeatMode: 0
                }
            };
            f.trackSelectionCallback = function(h) {
                return H(function(k) {
                    return k.return(Co(h, g.preferredAudioLanguage, g.preferredVideoHdrLevel));
                });
            };
            return b.cb(g);
        }
        function Do() {
            return {
                streaming: {
                    inaccurateManifestTolerance: 0,
                    segmentPrefetchLimit: 2,
                    updateIntervalSeconds: .1,
                    maxDisabledTime: 1,
                    retryParameters: {
                        baseDelay: 100
                    }
                },
                manifest: {
                    dash: {
                        autoCorrectDrift: !1
                    },
                    retryParameters: {
                        baseDelay: 100
                    }
                },
                drm: {
                    retryParameters: {
                        baseDelay: 100
                    }
                }
            };
        }
        function Eo(a, b, c) {
            var d = {
                ".drm.keySystemsMapping": "",
                ".drm.servers": "",
                ".drm.clearKeys": "",
                ".drm.advanced": {
                    distinctiveIdentifierRequired: !1,
                    persistentStateRequired: !1,
                    videoRobustness: [],
                    audioRobustness: [],
                    sessionType: "",
                    serverCertificate: new Uint8Array(0),
                    serverCertificateUri: "",
                    individualizationServer: "",
                    headers: {}
                }
            };
            return bo(a, b, c || zo(), d, "");
        }
        function Co(a, b, c) {
            var d = c;
            d == "AUTO" && (c = a.some(function(h) {
                return h.hdr && h.hdr == "HLG" ? !0 : !1;
            }), d = Xb().Dd(c));
            var e = a.filter(function(h) {
                return h.type != "variant" || h.hdr && h.hdr != d ? !1 : !0;
            });
            c = [];
            var f = Sc(b, e.map(function(h) {
                return h.language;
            }));
            f && (c = e.filter(function(h) {
                return Kc(h.language) == f;
            }));
            c.length == 0 && (c = e.filter(function(h) {
                return h.primary;
            }));
            c.length == 0 && (e.map(function(h) {
                return h.language;
            }), c = e);
            var g = c.filter(function(h) {
                return h.height && h.height <= 480;
            });
            g.length && (g.sort(function(h, k) {
                return k.height - h.height;
            }), c = g.filter(function(h) {
                return h.height == g[0].height;
            }));
            b = [];
            c.length && (e = Math.floor(c.length / 2), c.sort(function(h, k) {
                return h.bandwidth - k.bandwidth;
            }), b.push(c[e]));
            a = u(a);
            for(c = a.next(); !c.done; c = a.next())c = c.value, c.type != Ec && c.type != "image" || b.push(c);
            return b;
        }
        function Ao(a) {
            return eo([
                a
            ], a);
        }
        function Bo(a) {
            return eo([
                a
            ], a);
        }
        O("shaka.util.PlayerConfiguration", yo);
        yo.mergeConfigObjects = Eo;
        yo.createDefaultForLL = Do;
        yo.createDefault = zo;
        function Fo() {
            this.g = null;
            this.h = [];
        }
        function Go(a, b) {
            var c = 0;
            a.g && a.g.state == b && (c += a.g.duration);
            a = u(a.h);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, c += d.state == b ? d.duration : 0;
            return c;
        }
        function Ho(a) {
            function b(f) {
                return {
                    timestamp: f.timestamp,
                    state: f.state,
                    duration: f.duration
                };
            }
            for(var c = [], d = u(a.h), e = d.next(); !e.done; e = d.next())c.push(b(e.value));
            a.g && c.push(b(a.g));
            return c;
        }
        function Io() {
            this.i = this.h = null;
            this.g = [];
        }
        function Jo(a, b, c) {
            a.i != b && (a.i = b, a.g.push({
                timestamp: Date.now() / 1E3,
                id: b.id,
                type: "text",
                fromAdaptation: c,
                bandwidth: null
            }));
        }
        function Ko() {
            this.D = this.V = NaN;
            this.l = "";
            this.j = this.nj = this.A = this.C = this.K = this.F = this.o = this.m = this.J = this.G = this.i = this.R = this.S = this.M = this.O = this.P = NaN;
            this.L = 0;
            this.H = this.I = NaN;
            this.g = new Fo;
            this.h = new Io;
        }
        function Lo(a, b, c) {
            a.P = b;
            a.O = c;
        }
        function Mo(a, b, c) {
            a.V = b;
            a.D = c;
        }
        function No(a, b) {
            a.i = isNaN(a.i) ? b : Math.max(a.i, b);
        }
        function Oo(a, b) {
            b >= 0 && (a.o = b);
        }
        function Po(a, b) {
            b >= 0 && (a.F = b);
        }
        function Qo(a, b) {
            b >= 0 && (a.K = b);
        }
        function Ro(a, b) {
            a.j = isNaN(a.j) ? b : a.j + b;
        }
        function So(a) {
            var b = a.V, c = a.D, d = a.l, e = a.C, f = a.O, g = a.P, h = a.M, k = a.S, l = a.R, m = a.A, n = a.i, q = a.G, r = a.J, t = a.m, v = Go(a.g, "playing"), w = Go(a.g, "paused"), x = Go(a.g, "buffering"), y = a.o, z = a.F, A = a.K, E = a.nj, C = a.j, D = a.L, B = a.I, J = a.H, F = Ho(a.g), I = [];
            a = u(a.h.g);
            for(var K = a.next(); !K.done; K = a.next())K = K.value, I.push({
                timestamp: K.timestamp,
                id: K.id,
                type: K.type,
                fromAdaptation: K.fromAdaptation,
                bandwidth: K.bandwidth
            });
            return {
                width: b,
                height: c,
                currentCodecs: d,
                streamBandwidth: e,
                decodedFrames: f,
                droppedFrames: g,
                corruptedFrames: h,
                stallsDetected: k,
                gapsJumped: l,
                estimatedBandwidth: m,
                completionPercent: n,
                loadLatency: q,
                manifestTimeSeconds: r,
                drmTimeSeconds: t,
                playTime: v,
                pauseTime: w,
                bufferingTime: x,
                licenseTime: y,
                liveLatency: z,
                maxSegmentDuration: A,
                manifestSizeBytes: E,
                bytesDownloaded: C,
                nonFatalErrorCount: D,
                manifestPeriodCount: B,
                manifestGapCount: J,
                stateHistory: F,
                switchHistory: I
            };
        }
        function To(a, b, c, d) {
            fb.call(this);
            this.M = a;
            this.S = b;
            this.ya = d.networkingEngine;
            this.o = c;
            this.D = null;
            this.va = 0;
            this.Ia = d.wd;
            this.G = d.Ol;
            this.Oa = d.Pl;
            this.g = d.config;
            this.m = this.H = this.h = null;
            this.ba = !1;
            this.I = d.bm;
            this.na = !1;
            this.j = null;
            this.X = !1;
            this.A = null;
            this.L = new Map;
            this.ua = !1;
            this.Ga = d.am;
            this.V = new Ko;
            this.$ = new Yg;
            this.C = new Yg;
            this.O = null;
            this.l = !1;
            this.W = d.rk;
            this.R = this.i = null;
            this.P = !1;
            this.K = [];
            this.J = [];
            this.F = !0;
        }
        oa(To, fb);
        function Uo(a, b, c) {
            (a = b ? a.J : a.K) ? a.push(c) : c();
        }
        function Vo(a) {
            if (a.J) for(var b = u(a.J), c = b.next(); !c.done; c = b.next())c = c.value, c();
            a.J = null;
        }
        function Wo(a, b) {
            a.O = b;
            a.P = !0;
            if (a.K) {
                b = u(a.K);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, c();
            }
            a.K = null;
        }
        p = To.prototype;
        p.getStartTime = function() {
            return this.o;
        };
        p.dd = function() {
            return this.M;
        };
        p.sh = function() {
            return this.h;
        };
        function Xo(a) {
            a.na = !0;
            return a.I;
        }
        p.getStats = function() {
            return this.V;
        };
        function Yo(a) {
            a.X = !0;
            return a.j;
        }
        p.fl = function() {
            return this.i ? wg(this.i) : null;
        };
        p.cl = function() {
            return this.R ? xg(this.R) : null;
        };
        function Zo(a) {
            a.ua = !0;
            return a.L;
        }
        p.start = function() {
            var a = this;
            (function() {
                var b;
                return H(function(c) {
                    switch(c.h){
                        case 1:
                            return c.g(Promise.resolve(), 2);
                        case 2:
                            return c.m(3), c.g($o(a), 5);
                        case 5:
                            ap(a);
                            if ("webkit" === window1.shakaMediaKeysPolyfill) {
                                c.B(6);
                                break;
                            }
                            return c.g(bp(a), 7);
                        case 7:
                            ap(a);
                        case 6:
                            return c.g(cp(a), 8);
                        case 8:
                            ap(a);
                            if (!a.W) {
                                c.B(9);
                                break;
                            }
                            return c.g(dp(a), 10);
                        case 10:
                            ap(a);
                        case 9:
                            if (!a.W || !a.j) {
                                c.B(11);
                                break;
                            }
                            return c.g(yi(a.j), 12);
                        case 12:
                            ap(a);
                        case 11:
                            a.C.resolve();
                            c.o(0);
                            break;
                        case 3:
                            b = c.l(), b instanceof T && (b.code == 7001 || b.code == 7003) || a.C.reject(b), c.j();
                    }
                });
            })();
        };
        p.dispatchEvent = function(a) {
            return this.O ? this.O.dispatchEvent(a) : fb.prototype.dispatchEvent.call(this, a);
        };
        p.onError = function(a) {
            a.severity === 2 && (this.C.reject(a), this.destroy());
            var b = (new Map).set("detail", a);
            b = new R("error", b);
            this.dispatchEvent(b);
            b.defaultPrevented && (a.handled = !0);
        };
        function ap(a) {
            if (a.l) throw new T(2, 7, 7003);
        }
        function ep(a, b) {
            a.dispatchEvent(new R("onstatechange", (new Map).set("state", b)));
        }
        function $o(a) {
            var b, c, d, e, f, g;
            return H(function(h) {
                switch(h.h){
                    case 1:
                        ep(a, "manifest-parser");
                        a.m || (a.H = Cd(a.M, a.S), a.m = a.H(), a.m.configure(a.g.manifest, function() {
                            return a.F;
                        }));
                        b = Date.now() / 1E3;
                        ep(a, "manifest");
                        if (a.h) {
                            h.B(2);
                            break;
                        }
                        return h.g(a.m.start(a.M, a.Oa), 3);
                    case 3:
                        return a.h = h.i, fp(a.h), h.g(gp(a), 2);
                    case 2:
                        return a.$.resolve(), c = new R("manifestparsed", void 0), h.g(Promise.resolve(), 5);
                    case 5:
                        a.dispatchEvent(c);
                        if (a.h.variants.length == 0) throw new T(2, 4, 4036);
                        fp(a.h);
                        d = Oi(a.G, a.h);
                        if (!d) {
                            h.B(6);
                            break;
                        }
                        e = new R("trackschanged", void 0);
                        return h.g(Promise.resolve(), 7);
                    case 7:
                        ap(a), a.dispatchEvent(e);
                    case 6:
                        f = Date.now() / 1E3, g = f - b, g >= 0 && (a.V.J = g), h.j();
                }
            });
        }
        function bp(a, b) {
            var c, d, e, f;
            return H(function(g) {
                switch(g.h){
                    case 1:
                        if (!a.h || a.j) return g.return();
                        ep(a, "drm-engine");
                        a.va = Date.now() / 1E3;
                        a.j = a.Ia();
                        a.G.g = a.j;
                        a.j.configure(a.g.drm, function() {
                            return a.F;
                        });
                        c = Fg(a.h.variants);
                        d = !0;
                        a.h && a.h.presentationTimeline && (d = a.h.presentationTimeline.U());
                        return g.g(Vh(a.j, c, a.h.offlineSessionIds, d), 2);
                    case 2:
                        ap(a);
                        if (!b) {
                            g.B(3);
                            break;
                        }
                        return g.g(a.j.Ob(b), 4);
                    case 4:
                        ap(a);
                    case 3:
                        return g.g(Mi(a.G, a.h), 5);
                    case 5:
                        e = g.i;
                        if (!e) {
                            g.B(0);
                            break;
                        }
                        f = new R("trackschanged", void 0);
                        return g.g(Promise.resolve(), 7);
                    case 7:
                        a.dispatchEvent(f), g.j();
                }
            });
        }
        p.configure = function(a, b) {
            a = co(a, b);
            Eo(this.g, a);
        };
        p.getConfiguration = function() {
            return Xd(this.g);
        };
        function gp(a) {
            return H(function(b) {
                a.D || (a.D = a.g.adaptationSetCriteriaFactory(), a.D.configure({
                    language: a.g.preferredAudioLanguage,
                    role: a.g.preferredAudioRole,
                    videoRole: a.g.preferredVideoRole,
                    channelCount: 0,
                    hdrLevel: a.g.preferredVideoHdrLevel,
                    spatialAudio: a.g.preferSpatialAudio,
                    videoLayout: a.g.preferredVideoLayout,
                    audioLabel: a.g.preferredAudioLabel,
                    videoLabel: a.g.preferredVideoLabel,
                    codecSwitchingStrategy: a.g.mediaSource.codecSwitchingStrategy,
                    audioCodec: "",
                    activeAudioCodec: "",
                    activeAudioChannelCount: 0,
                    preferredAudioCodecs: a.g.preferredAudioCodecs,
                    preferredAudioChannelCount: a.g.preferredAudioChannelCount
                }));
                if (a.i || !a.h.variants.length || a.h.variants.length != 1 && a.h.type != "HLS") return b.B(0);
                a.i = hp(a);
                return a.i ? b.g(ip(a.i), 0) : b.B(0);
            });
        }
        function cp(a) {
            return H(function(b) {
                if (b.h == 1) return !a.i || a.h.variants.includes(a.i) ? b.B(0) : b.g(jp(a.i), 3);
                a.i = hp(a);
                return a.i ? b.g(ip(a.i), 0) : b.B(0);
            });
        }
        function dp(a) {
            var b, c, d, e, f;
            return H(function(g) {
                !a.i && (b = hp(a)) && (a.i = b);
                if (!a.i) return g.B(0);
                c = a.h.presentationTimeline.U();
                d = [];
                e = a.i;
                e.video && d.push(kp(a, e.video, c));
                e.audio && d.push(kp(a, e.audio, c));
                (f = Gg(a.h.textStreams, a.g.preferredTextLanguage, a.g.preferredTextRole, a.g.preferForcedSubs)[0] || null) && Og(e.audio, f, a.g) && (d.push(kp(a, f, c)), a.R = f);
                return g.g(Promise.all(d), 0);
            });
        }
        function hp(a) {
            if (!a.A) {
                var b = a.g.abrFactory;
                a.A = b();
                a.A.configure(a.g.abr);
            }
            b = Fg(a.h.variants);
            b = a.D.create(b);
            a.A.setVariants(Array.from(b.values()));
            return a.A.chooseVariant(!0);
        }
        function kp(a, b, c) {
            var d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) return d = a.g.streaming.segmentPrefetchLimit || 2, e = new Om(d, b, function(l, m, n) {
                    return Jn(l, m, n || null, a.g.streaming.retryParameters, a.ya, a.F);
                }, !1), a.L.set(b.id, e), b.segmentIndex ? k.B(2) : k.g(b.createSegmentIndex(), 2);
                f = typeof a.o === "number" ? a.o : 0;
                g = b.segmentIndex.ac(f);
                h = null;
                g && (h = g.current(), h || (h = g.next().value));
                h || (h = b.segmentIndex.Fb());
                return h ? c ? h.ia ? k.g(Rm(e, h.ia), 0) : k.B(0) : k.g(Qm(e, h.startTime), 0) : k.B(0);
            });
        }
        function ip(a) {
            var b, c, d, e;
            return H(function(f) {
                b = [];
                c = u([
                    a.video,
                    a.audio
                ]);
                for(d = c.next(); !d.done; d = c.next())(e = d.value) && !e.segmentIndex && b.push(e.createSegmentIndex());
                return b.length > 0 ? f.g(Promise.all(b), 0) : f.B(0);
            });
        }
        function jp(a) {
            var b, c, d, e;
            return H(function(f) {
                b = [];
                c = u([
                    a.video,
                    a.audio
                ]);
                for(d = c.next(); !d.done; d = c.next())(e = d.value) && e.segmentIndex && e.closeSegmentIndex && b.push(e.closeSegmentIndex());
                return b.length > 0 ? f.g(Promise.all(b), 0) : f.B(0);
            });
        }
        p.Hm = function() {
            return this.C;
        };
        p.destroy = function() {
            var a = this, b, c, d;
            return H(function(e) {
                if (e.h == 1) return a.l = !0, !a.m || a.ba ? e.B(2) : e.g(a.m.stop(), 2);
                if (e.h != 4) return a.A && a.A.release(), a.I && !a.na && a.I.release(), !a.j || a.X ? e.B(4) : e.g(a.j.destroy(), 4);
                if (a.L.size > 0 && !a.ua) for(b = u(a.L.values()), c = b.next(); !c.done; c = b.next())d = c.value, Xm(d);
                e.j();
            });
        };
        function fp(a) {
            function b(c) {
                return c.video && c.audio || c.video && c.video.codecs.includes(",");
            }
            a.variants.some(b) && (a.variants = a.variants.filter(b));
        }
        O("shaka.media.PreloadManager", To);
        To.prototype.destroy = To.prototype.destroy;
        To.prototype.waitForFinish = To.prototype.Hm;
        To.prototype.getPrefetchedTextTrack = To.prototype.cl;
        To.prototype.getPrefetchedVariantTrack = To.prototype.fl;
        function mp(a, b) {
            fb.call(this);
            var c = this;
            this.i = a;
            this.l = b;
            this.g = new Map;
            this.m = [
                {
                    td: null,
                    sd: np,
                    ed: function(d, e) {
                        return op(c, "enter", d, e);
                    }
                },
                {
                    td: pp,
                    sd: np,
                    ed: function(d, e) {
                        return op(c, "enter", d, e);
                    }
                },
                {
                    td: qp,
                    sd: np,
                    ed: function(d, e) {
                        return op(c, "enter", d, e);
                    }
                },
                {
                    td: np,
                    sd: pp,
                    ed: function(d, e) {
                        return op(c, "exit", d, e);
                    }
                },
                {
                    td: np,
                    sd: qp,
                    ed: function(d, e) {
                        return op(c, "exit", d, e);
                    }
                },
                {
                    td: pp,
                    sd: qp,
                    ed: function(d, e) {
                        e ? op(c, "skip", d, e) : (op(c, "enter", d, e), op(c, "exit", d, e));
                    }
                },
                {
                    td: qp,
                    sd: pp,
                    ed: function(d, e) {
                        return op(c, "skip", d, e);
                    }
                }
            ];
            this.h = new fd;
            this.h.u(this.i, "regionremove", function(d) {
                c.g.delete(d.region);
            });
        }
        oa(mp, fb);
        mp.prototype.release = function() {
            this.i = null;
            this.g.clear();
            this.h.release();
            this.h = null;
            fb.prototype.release.call(this);
        };
        mp.prototype.j = function(a, b) {
            if (!this.l || a != 0) {
                this.l = !1;
                for(var c = u(this.i.h.values()), d = c.next(); !d.done; d = c.next()){
                    d = d.value;
                    var e = this.g.get(d), f = a < d.startTime ? pp : a > d.endTime ? qp : np;
                    this.g.set(d, f);
                    for(var g = u(this.m), h = g.next(); !h.done; h = g.next())h = h.value, h.td == e && h.sd == f && h.ed(d, b);
                }
            }
        };
        function op(a, b, c, d) {
            b = new R(b, new Map([
                [
                    "region",
                    c
                ],
                [
                    "seeking",
                    d
                ]
            ]));
            a.dispatchEvent(b);
        }
        var pp = 1, np = 2, qp = 3; /*
 @license
 Copyright 2013 Ali Al Dallal

 Licensed under the MIT license.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
*/ 
        for(var rp = {
            ach: "Lwo",
            ady: "\u0410\u0434\u044b\u0433\u044d\u0431\u0437\u044d",
            af: "Afrikaans",
            "af-NA": "Afrikaans (Namibia)",
            "af-ZA": "Afrikaans (South Africa)",
            ak: "T\u0255\u0265i",
            ar: "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
            "ar-AR": "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
            "ar-MA": "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
            "ar-SA": "\u0627\u0644\u0639\u0631\u0628\u064a\u0629 (\u0627\u0644\u0633\u0639\u0648\u062f\u064a\u0629)",
            "ay-BO": "Aymar aru",
            az: "Az\u0259rbaycan dili",
            "az-AZ": "Az\u0259rbaycan dili",
            "be-BY": "\u0411\u0435\u043b\u0430\u0440\u0443\u0441\u043a\u0430\u044f",
            bg: "\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438",
            "bg-BG": "\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438",
            bn: "\u09ac\u09be\u0982\u09b2\u09be",
            "bn-IN": "\u09ac\u09be\u0982\u09b2\u09be (\u09ad\u09be\u09b0\u09a4)",
            "bn-BD": "\u09ac\u09be\u0982\u09b2\u09be(\u09ac\u09be\u0982\u09b2\u09be\u09a6\u09c7\u09b6)",
            "bs-BA": "Bosanski",
            ca: "Catal\u00e0",
            "ca-ES": "Catal\u00e0",
            cak: "Maya Kaqchikel",
            "ck-US": "\u13e3\u13b3\u13a9 (tsalagi)",
            cs: "\u010ce\u0161tina",
            "cs-CZ": "\u010ce\u0161tina",
            cy: "Cymraeg",
            "cy-GB": "Cymraeg",
            da: "Dansk",
            "da-DK": "Dansk",
            de: "Deutsch",
            "de-AT": "Deutsch (\u00d6sterreich)",
            "de-DE": "Deutsch (Deutschland)",
            "de-CH": "Deutsch (Schweiz)",
            dsb: "Dolnoserb\u0161\u0107ina",
            el: "\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac",
            "el-GR": "\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac",
            en: "English",
            "en-GB": "English (UK)",
            "en-AU": "English (Australia)",
            "en-CA": "English (Canada)",
            "en-IE": "English (Ireland)",
            "en-IN": "English (India)",
            "en-PI": "English (Pirate)",
            "en-UD": "English (Upside Down)",
            "en-US": "English (US)",
            "en-ZA": "English (South Africa)",
            "en@pirate": "English (Pirate)",
            eo: "Esperanto",
            "eo-EO": "Esperanto",
            es: "Espa\u00f1ol",
            "es-AR": "Espa\u00f1ol (Argentine)",
            "es-419": "Espa\u00f1ol (Latinoam\u00e9rica)",
            "es-CL": "Espa\u00f1ol (Chile)",
            "es-CO": "Espa\u00f1ol (Colombia)",
            "es-EC": "Espa\u00f1ol (Ecuador)",
            "es-ES": "Espa\u00f1ol (Espa\u00f1a)",
            "es-LA": "Espa\u00f1ol (Latinoam\u00e9rica)",
            "es-NI": "Espa\u00f1ol (Nicaragua)",
            "es-MX": "Espa\u00f1ol (M\u00e9xico)",
            "es-US": "Espa\u00f1ol (Estados Unidos)",
            "es-VE": "Espa\u00f1ol (Venezuela)",
            et: "eesti keel",
            "et-EE": "Eesti (Estonia)",
            eu: "Euskara",
            "eu-ES": "Euskara",
            fa: "\u0641\u0627\u0631\u0633\u06cc",
            "fa-IR": "\u0641\u0627\u0631\u0633\u06cc",
            "fb-LT": "Leet Speak",
            ff: "Fulah",
            fi: "Suomi",
            "fi-FI": "Suomi",
            "fo-FO": "F\u00f8royskt",
            fr: "Fran\u00e7ais",
            "fr-CA": "Fran\u00e7ais (Canada)",
            "fr-FR": "Fran\u00e7ais (France)",
            "fr-BE": "Fran\u00e7ais (Belgique)",
            "fr-CH": "Fran\u00e7ais (Suisse)",
            "fy-NL": "Frysk",
            ga: "Gaeilge",
            "ga-IE": "Gaeilge (Gaelic)",
            gl: "Galego",
            "gl-ES": "Galego",
            "gn-PY": "Ava\u00f1e'\u1ebd",
            "gu-IN": "\u0a97\u0ac1\u0a9c\u0ab0\u0abe\u0aa4\u0ac0",
            "gx-GR": "\u1f19\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ae \u1f00\u03c1\u03c7\u03b1\u03af\u03b1",
            he: "\u05e2\u05d1\u05e8\u05d9\u05ea\u200f",
            "he-IL": "\u05e2\u05d1\u05e8\u05d9\u05ea\u200f",
            hi: "\u0939\u093f\u0928\u094d\u0926\u0940",
            "hi-IN": "\u0939\u093f\u0928\u094d\u0926\u0940",
            hr: "Hrvatski",
            "hr-HR": "Hrvatski",
            hsb: "Hornjoserb\u0161\u0107ina",
            ht: "Krey\u00f2l",
            hu: "Magyar",
            "hu-HU": "Magyar",
            "hy-AM": "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
            id: "Bahasa Indonesia",
            "id-ID": "Bahasa Indonesia",
            is: "\u00cdslenska",
            "is-IS": "\u00cdslenska (Iceland)",
            it: "Italiano",
            "it-IT": "Italiano",
            ja: "\u65e5\u672c\u8a9e",
            "ja-JP": "\u65e5\u672c\u8a9e",
            "jv-ID": "Basa Jawa",
            "ka-GE": "\u10e5\u10d0\u10e0\u10d7\u10e3\u10da\u10d8",
            "kk-KZ": "\u049a\u0430\u0437\u0430\u049b\u0448\u0430",
            km: "\u1797\u17b6\u179f\u17b6\u1781\u17d2\u1798\u17c2\u179a",
            "km-KH": "\u1797\u17b6\u179f\u17b6\u1781\u17d2\u1798\u17c2\u179a",
            kab: "Taqbaylit",
            kn: "\u0c95\u0ca8\u0ccd\u0ca8\u0ca1",
            "kn-IN": "\u0c95\u0ca8\u0ccd\u0ca8\u0ca1 (India)",
            ko: "\ud55c\uad6d\uc5b4",
            "ko-KR": "\ud55c\uad6d\uc5b4 (\u97e9\u56fd)",
            ku: "Kurd\u00ee",
            "ku-TR": "Kurd\u00ee",
            la: "Latin",
            "la-VA": "Latin",
            lb: "L\u00ebtzebuergesch",
            "li-NL": "L\u00e8mb\u00f6rgs",
            lt: "Lietuvi\u0173",
            "lt-LT": "Lietuvi\u0173",
            lv: "Latvie\u0161u",
            "lv-LV": "Latvie\u0161u",
            mai: "\u092e\u0948\u0925\u093f\u0932\u0940, \u09ae\u09c8\u09a5\u09bf\u09b2\u09c0",
            "mg-MG": "Malagasy",
            mk: "\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438",
            "mk-MK": "\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438 (\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438)",
            ml: "\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02",
            "ml-IN": "\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02",
            "mn-MN": "\u041c\u043e\u043d\u0433\u043e\u043b",
            mr: "\u092e\u0930\u093e\u0920\u0940",
            "mr-IN": "\u092e\u0930\u093e\u0920\u0940",
            ms: "Bahasa Melayu",
            "ms-MY": "Bahasa Melayu",
            mt: "Malti",
            "mt-MT": "Malti",
            my: "\u1017\u1019\u102c\u1005\u1000\u102c",
            nb: "Norsk (bokm\u00e5l)",
            "nb-NO": "Norsk (bokm\u00e5l)",
            ne: "\u0928\u0947\u092a\u093e\u0932\u0940",
            "ne-NP": "\u0928\u0947\u092a\u093e\u0932\u0940",
            nl: "Nederlands",
            "nl-BE": "Nederlands (Belgi\u00eb)",
            "nl-NL": "Nederlands (Nederland)",
            "nn-NO": "Norsk (nynorsk)",
            no: "Norsk",
            oc: "Occitan",
            "or-IN": "\u0b13\u0b21\u0b3c\u0b3f\u0b06",
            pa: "\u0a2a\u0a70\u0a1c\u0a3e\u0a2c\u0a40",
            "pa-IN": "\u0a2a\u0a70\u0a1c\u0a3e\u0a2c\u0a40 (\u0a2d\u0a3e\u0a30\u0a24 \u0a28\u0a42\u0a70)",
            pl: "Polski",
            "pl-PL": "Polski",
            "ps-AF": "\u067e\u069a\u062a\u0648",
            pt: "Portugu\u00eas",
            "pt-BR": "Portugu\u00eas (Brasil)",
            "pt-PT": "Portugu\u00eas (Portugal)",
            "qu-PE": "Qhichwa",
            "rm-CH": "Rumantsch",
            ro: "Rom\u00e2n\u0103",
            "ro-RO": "Rom\u00e2n\u0103",
            ru: "\u0420\u0443\u0441\u0441\u043a\u0438\u0439",
            "ru-RU": "\u0420\u0443\u0441\u0441\u043a\u0438\u0439",
            "sa-IN": "\u0938\u0902\u0938\u094d\u0915\u0943\u0924\u092e\u094d",
            "se-NO": "Davvis\u00e1megiella",
            "si-LK": "\u0db4\u0dc5\u0dcf\u0dad",
            sk: "Sloven\u010dina",
            "sk-SK": "Sloven\u010dina (Slovakia)",
            sl: "Sloven\u0161\u010dina",
            "sl-SI": "Sloven\u0161\u010dina",
            "so-SO": "Soomaaliga",
            sq: "Shqip",
            "sq-AL": "Shqip",
            sr: "\u0421\u0440\u043f\u0441\u043a\u0438",
            "sr-RS": "\u0421\u0440\u043f\u0441\u043a\u0438 (Serbia)",
            su: "Basa Sunda",
            sv: "Svenska",
            "sv-SE": "Svenska",
            sw: "Kiswahili",
            "sw-KE": "Kiswahili",
            ta: "\u0ba4\u0bae\u0bbf\u0bb4\u0bcd",
            "ta-IN": "\u0ba4\u0bae\u0bbf\u0bb4\u0bcd",
            te: "\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41",
            "te-IN": "\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41",
            tg: "\u0437\u0430\u0431\u043e\u0301\u043d\u0438 \u0442\u043e\u04b7\u0438\u043a\u04e3\u0301",
            "tg-TJ": "\u0442\u043e\u04b7\u0438\u043a\u04e3",
            th: "\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22",
            "th-TH": "\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22 (\u0e1b\u0e23\u0e30\u0e40\u0e17\u0e28\u0e44\u0e17\u0e22)",
            tl: "Filipino",
            "tl-PH": "Filipino",
            tlh: "tlhIngan-Hol",
            tr: "T\u00fcrk\u00e7e",
            "tr-TR": "T\u00fcrk\u00e7e",
            "tt-RU": "\u0442\u0430\u0442\u0430\u0440\u0447\u0430",
            uk: "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430",
            "uk-UA": "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430",
            ur: "\u0627\u0631\u062f\u0648",
            "ur-PK": "\u0627\u0631\u062f\u0648",
            uz: "O'zbek",
            "uz-UZ": "O'zbek",
            vi: "Ti\u1ebfng Vi\u1ec7t",
            "vi-VN": "Ti\u1ebfng Vi\u1ec7t",
            "xh-ZA": "isiXhosa",
            yi: "\u05d9\u05d9\u05b4\u05d3\u05d9\u05e9",
            "yi-DE": "\u05d9\u05d9\u05b4\u05d3\u05d9\u05e9 (German)",
            zh: "\u4e2d\u6587",
            "zh-HANS": "\u4e2d\u6587\u7b80\u4f53",
            "zh-HANT": "\u4e2d\u6587\u7e41\u9ad4",
            "zh-CN": "\u4e2d\u6587\uff08\u4e2d\u56fd\uff09",
            "zh-HK": "\u4e2d\u6587\uff08\u9999\u6e2f\uff09",
            "zh-SG": "\u4e2d\u6587\uff08\u65b0\u52a0\u5761\uff09",
            "zh-TW": "\u4e2d\u6587\uff08\u53f0\u7063\uff09",
            "zu-ZA": "isiZulu"
        }, sp = u(Object.keys(rp)), tp = sp.next(); !tp.done; tp = sp.next()){
            var up = tp.value;
            rp[up.toLowerCase()] = rp[up];
        }
        function vp(a, b) {
            if (a.lineBreak) return "\n";
            if (a.nestedCues.length) return a.nestedCues.map(function(g) {
                return vp(g, a);
            }).join("");
            if (!a.payload) return a.payload;
            var c = [], d = a.fontWeight >= df, e = a.fontStyle == ef, f = a.textDecoration.includes(ff);
            d && c.push([
                "b"
            ]);
            e && c.push([
                "i"
            ]);
            f && c.push([
                "u"
            ]);
            e = a.color;
            e == "" && b && (e = b.color);
            d = "";
            (e = wp(e)) && (d += "." + e);
            e = a.backgroundColor;
            e == "" && b && (e = b.backgroundColor);
            (b = wp(e)) && (d += ".bg_" + b);
            d && c.push([
                "c",
                d
            ]);
            return c.reduceRight(function(g, h) {
                var k = u(h);
                h = k.next().value;
                k = k.next().value;
                return "<" + h + (k === void 0 ? "" : k) + ">" + g + "</" + h + ">";
            }, a.payload);
        }
        function wp(a) {
            a = a.toLowerCase();
            var b = a.replace(/\s/g, "").match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
            b ? a = "#" + (parseInt(b[1], 10) | 256).toString(16).slice(1) + (parseInt(b[2], 10) | 256).toString(16).slice(1) + (parseInt(b[3], 10) | 256).toString(16).slice(1) : a.startsWith("#") && a.length > 7 && (a = a.slice(0, 7));
            switch(a){
                case "white":
                case "#fff":
                case "#ffffff":
                    return "white";
                case "lime":
                case "#0f0":
                case "#00ff00":
                    return "lime";
                case "cyan":
                case "#0ff":
                case "#00ffff":
                    return "cyan";
                case "red":
                case "#f00":
                case "#ff0000":
                    return "red";
                case "yellow":
                case "#ff0":
                case "#ffff00":
                    return "yellow";
                case "magenta":
                case "#f0f":
                case "#ff00ff":
                    return "magenta";
                case "blue":
                case "#00f":
                case "#0000ff":
                    return "blue";
                case "black":
                case "#000":
                case "#000000":
                    return "black";
            }
            return null;
        }
        function xp(a, b) {
            var c = [];
            a = u(yp(a));
            for(var d = a.next(); !d.done; d = a.next())if (d = d.value, d.isContainer) c.push.apply(c, G(xp(d.nestedCues, d)));
            else {
                var e = d.clone();
                e.nestedCues = [];
                e.payload = vp(d, b);
                c.push(e);
            }
            return c;
        }
        function yp(a) {
            var b = [];
            a = u(a);
            for(var c = a.next(), d = {}; !c.done; d = {
                Qg: void 0
            }, c = a.next())d.Qg = c.value, b.some(function(e) {
                return function(f) {
                    return Ve(e.Qg, f);
                };
            }(d)) || b.push(d.Qg);
            return b;
        }
        function zp(a) {
            function b(d) {
                for(var e = 5381, f = d.length; f;)e = e * 33 ^ d.charCodeAt(--f);
                return (e >>> 0).toString();
            }
            if (a.startTime >= a.endTime) return null;
            var c = new VTTCue(a.startTime, a.endTime, a.payload);
            c.id = b(a.startTime.toString()) + b(a.endTime.toString()) + b(a.payload);
            c.lineAlign = a.lineAlign;
            c.positionAlign = a.positionAlign;
            a.size && (c.size = a.size);
            try {
                c.align = a.textAlign;
            } catch (d) {}
            a.textAlign == "center" && c.align != "center" && (c.align = "middle");
            a.writingMode == "vertical-lr" ? c.vertical = "lr" : a.writingMode == "vertical-rl" && (c.vertical = "rl");
            a.lineInterpretation == 1 && (c.snapToLines = !1);
            a.line != null && (c.line = a.line);
            a.position != null && (c.position = a.position);
            return c;
        }
        function Ap(a, b) {
            var c = xp(b), d = [];
            b = a.cues ? Array.from(a.cues) : [];
            c = u(c);
            for(var e = c.next(), f = {}; !e.done; f = {
                Gd: void 0
            }, e = c.next())f.Gd = e.value, !b.some(function(g) {
                return function(h) {
                    return h.startTime == g.Gd.startTime && h.endTime == g.Gd.endTime && h.text == g.Gd.payload ? !0 : !1;
                };
            }(f)) && f.Gd.payload && (e = zp(f.Gd)) && d.push(e);
            b = d.slice().sort(function(g, h) {
                return g.startTime != h.startTime ? g.startTime - h.startTime : g.endTime != h.endTime ? g.endTime - h.startTime : "line" in VTTCue.prototype ? d.indexOf(h) - d.indexOf(g) : d.indexOf(g) - d.indexOf(h);
            });
            b = u(b);
            for(c = b.next(); !c.done; c = b.next())a.addCue(c.value);
        }
        function Bp(a, b) {
            var c = !1;
            a.mode === "disabled" && (c = !0, a.mode = "hidden");
            for(var d = 0; d < a.cues.length;){
                var e = a.cues[d];
                b(e) ? a.removeCue(e) : d++;
            }
            c && (a.mode = "disabled");
        }
        function Cp(a) {
            var b = this;
            this.i = a;
            this.l = new fd;
            this.j = null;
            this.h = new Map;
            this.g = -1;
            this.A = !1;
            this.m = null;
            this.D = function() {
                var c;
                (c = b.m) == null || c.stop();
                b.m = null;
                b.l.Fa(b.i, "textchanged", b.o);
                b.l.Fa(b.j.textTracks, "change", b.C);
                c = u(b.h.values());
                for(var d = c.next(); !d.done; d = c.next())d.value.remove();
                b.h.clear();
                b.g = -1;
                b.j = null;
            };
            this.o = function() {
                var c = new Map, d = b.i.yc();
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next()){
                    e = e.value;
                    if (b.h.has(e.id)) {
                        var f = b.h.get(e.id);
                        e.active || f.track.mode === "disabled" || (f.track.mode = "disabled");
                        b.h.delete(e.id);
                    } else {
                        var g = f = b.j.ownerDocument.createElement("track");
                        var h = Xb();
                        h = e.forced && h.Ma() === "WEBKIT" ? "forced" : e.kind === "caption" ? "captions" : "subtitles";
                        g.kind = h;
                        g = f;
                        h = void 0;
                        if (e.label) h = e.label;
                        else if (e.language) {
                            if (e.language in rp) h = rp[e.language];
                            else {
                                var k = Pc(e.language);
                                k in rp && (h = rp[k] + " (" + e.language + ")");
                            }
                        }
                        h || (h = e.originalTextId, e.language && e.language !== e.originalTextId && (h += " (" + e.language + ")"));
                        g.label = h;
                        e.language ? e.language in rp ? f.srclang = e.language : (g = Pc(e.language), h = void 0, f.srclang = (h = g) != null ? h : "und") : f.srclang = "und";
                        f.src = "data:,WEBVTT";
                        f.track.mode = "disabled";
                        b.j.appendChild(f);
                    }
                    c.set(e.id, f);
                    e.active && (b.g = e.id);
                }
                d = u(b.h.values());
                for(e = d.next(); !e.done; e = d.next())e.value.remove();
                b.g > -1 && (c.has(b.g) ? (d = c.get(b.g).track, d.mode === "disabled" && (d.mode = b.A ? "showing" : "hidden")) : b.g = -1);
                b.h = c;
            };
            this.C = function() {
                if (!b.m) {
                    var c = b.j;
                    b.m = new Uf(function() {
                        b.m = null;
                        if (b.j === c) {
                            var d = -1, e = !1;
                            if (b.h.has(b.g)) {
                                var f = b.h.get(b.g);
                                f.track.mode === "showing" ? (d = b.g, e = !0) : f.track.mode === "hidden" && (d = b.g);
                            }
                            if (!e) for(e = u(b.h), f = e.next(); !f.done; f = e.next()){
                                var g = u(f.value);
                                f = g.next().value;
                                g = g.next().value;
                                if (g.track.mode === "showing") {
                                    d = f;
                                    break;
                                } else d < 0 && g.track.mode === "hidden" && (d = f);
                            }
                            e = u(b.h);
                            for(f = e.next(); !f.done; f = e.next())g = u(f.value), f = g.next().value, g = g.next().value, f !== d && g.track.mode !== "disabled" && (g.track.mode = "disabled");
                            b.g !== d && (b.g = d, d > -1 && b.i.gg({
                                id: d
                            }));
                            b.i.Xd(d > -1 && b.h.get(d).track.mode === "showing");
                        }
                    }).Z(0);
                }
            };
            this.l.u(a, "loaded", function() {
                return b.enableTextDisplayer();
            });
            this.enableTextDisplayer();
        }
        p = Cp.prototype;
        p.configure = function() {};
        p.remove = function(a, b) {
            if (this.i) this.h.has(this.g) && Bp(this.h.get(this.g).track, function(c) {
                return c.startTime < b && c.endTime > a;
            });
            else return !1;
            return !0;
        };
        p.append = function(a) {
            this.h.has(this.g) && Ap(this.h.get(this.g).track, a);
        };
        p.destroy = function() {
            this.i && (this.j && this.D(), this.i = null);
            var a;
            (a = this.m) == null || a.stop();
            this.m = null;
            var b;
            (b = this.l) == null || b.release();
            this.l = null;
            return Promise.resolve();
        };
        p.isTextVisible = function() {
            return this.A;
        };
        p.setTextVisibility = function(a) {
            this.A = a;
            if (this.h.has(this.g)) {
                var b = this.h.get(this.g).track;
                b.mode !== "disabled" && (a = a ? "showing" : "hidden", b.mode !== a && (b.mode = a));
            } else if (this.i && this.i.xc() === 3) {
                if (b = Array.from(this.i.vf().textTracks).filter(function(d) {
                    return [
                        "captions",
                        "subtitles",
                        "forced"
                    ].includes(d.kind);
                }), a) {
                    a = null;
                    b = u(b);
                    for(var c = b.next(); !c.done; c = b.next())if (c = c.value, c.mode === "showing") {
                        a = null;
                        break;
                    } else a || c.mode !== "hidden" || (a = c);
                    a && (a.mode = "showing");
                } else for(a = u(b), b = a.next(); !b.done; b = a.next())b = b.value, b.mode === "showing" && (b.mode = "hidden");
            }
        };
        p.setTextLanguage = function() {};
        p.enableTextDisplayer = function() {
            !this.j && this.i && this.i.xc() === 2 && (this.j = this.i.vf(), this.l.ra(this.i, "unloading", this.D), this.l.u(this.i, "textchanged", this.o), this.l.u(this.j.textTracks, "change", this.C), this.o());
        };
        O("shaka.text.NativeTextDisplayer", Cp);
        Cp.prototype.enableTextDisplayer = Cp.prototype.enableTextDisplayer;
        Cp.prototype.setTextLanguage = Cp.prototype.setTextLanguage;
        Cp.prototype.setTextVisibility = Cp.prototype.setTextVisibility;
        Cp.prototype.isTextVisible = Cp.prototype.isTextVisible;
        Cp.prototype.destroy = Cp.prototype.destroy;
        Cp.prototype.append = Cp.prototype.append;
        Cp.prototype.remove = Cp.prototype.remove;
        Cp.prototype.configure = Cp.prototype.configure;
        function Dp(a, b) {
            md("SimpleTextDisplayer", "Please migrate to NativeTextDisplayer");
            this.h = a;
            this.i = b;
            this.g = null;
            a = u(Array.from(this.h.textTracks));
            for(b = a.next(); !b.done; b = a.next())b = b.value, b.kind !== "metadata" && b.kind !== "chapters" && (b.mode = "disabled", b.label == this.i && (this.g = b));
            this.g && (this.g.mode = "hidden");
        }
        p = Dp.prototype;
        p.configure = function() {};
        p.remove = function(a, b) {
            if (!this.g) return !1;
            Bp(this.g, function(c) {
                return c.startTime < b && c.endTime > a;
            });
            return !0;
        };
        p.append = function(a) {
            this.g && Ap(this.g, a);
        };
        p.destroy = function() {
            this.g && (Bp(this.g, function() {
                return !0;
            }), this.g.mode = "disabled");
            this.g = this.h = null;
            return Promise.resolve();
        };
        p.isTextVisible = function() {
            return this.g ? this.g.mode == "showing" : !1;
        };
        p.setTextVisibility = function(a) {
            a && !this.g && Ep(this);
            this.g && (this.g.mode = a ? "showing" : "hidden");
        };
        p.setTextLanguage = function() {};
        p.enableTextDisplayer = function() {
            Ep(this);
        };
        function Ep(a) {
            a.h && !a.g && (a.g = a.h.addTextTrack("subtitles", a.i), a.g.mode = "hidden");
        }
        O("shaka.text.SimpleTextDisplayer", Dp);
        Dp.prototype.enableTextDisplayer = Dp.prototype.enableTextDisplayer;
        Dp.prototype.setTextLanguage = Dp.prototype.setTextLanguage;
        Dp.prototype.setTextVisibility = Dp.prototype.setTextVisibility;
        Dp.prototype.isTextVisible = Dp.prototype.isTextVisible;
        Dp.prototype.destroy = Dp.prototype.destroy;
        Dp.prototype.append = Dp.prototype.append;
        Dp.prototype.remove = Dp.prototype.remove;
        Dp.prototype.configure = Dp.prototype.configure;
        function Fp() {}
        p = Fp.prototype;
        p.configure = function() {};
        p.remove = function() {};
        p.append = function() {};
        p.destroy = function() {};
        p.isTextVisible = function() {
            return !1;
        };
        p.setTextVisibility = function() {};
        p.setTextLanguage = function() {};
        p.enableTextDisplayer = function() {};
        O("shaka.text.StubTextDisplayer", Fp);
        Fp.prototype.enableTextDisplayer = Fp.prototype.enableTextDisplayer;
        Fp.prototype.setTextLanguage = Fp.prototype.setTextLanguage;
        Fp.prototype.setTextVisibility = Fp.prototype.setTextVisibility;
        Fp.prototype.isTextVisible = Fp.prototype.isTextVisible;
        Fp.prototype.destroy = Fp.prototype.destroy;
        Fp.prototype.append = Fp.prototype.append;
        Fp.prototype.remove = Fp.prototype.remove;
        Fp.prototype.configure = Fp.prototype.configure;
        function Gp(a, b) {
            var c = this;
            this.j = !1;
            this.h = [];
            this.m = a;
            this.l = b;
            this.D = this.A = null;
            this.g = U("div");
            this.g.classList.add("shaka-text-container");
            this.g.style.textAlign = "center";
            this.g.style.display = "flex";
            this.g.style.flexDirection = "column";
            this.g.style.alignItems = "center";
            this.g.style.justifyContent = "flex-end";
            this.C = new Uf(function() {
                c.m.paused || Hp(c);
            });
            Ip(this);
            this.o = new Map;
            this.i = new fd;
            this.i.u(document, "fullscreenchange", function() {
                Hp(c, !0);
            });
            this.i.u(this.m, "seeking", function() {
                Hp(c, !0);
            });
            this.i.u(this.m, "ratechange", function() {
                Ip(c);
            });
            this.i.u(this.m, "resize", function() {
                var d = c.m, e = d.videoWidth;
                d = d.videoHeight;
                e && d ? c.A = e / d : c.A = null;
            });
            this.H = !1;
            this.F = null;
            "ResizeObserver" in window1 && (this.F = new ResizeObserver(function() {
                c.H || (c.H = !0, requestAnimationFrame(function() {
                    c.H = !1;
                    c.g && c.g.parentElement && c.j && Hp(c, !0);
                }));
            }), this.F.observe(this.l));
            this.G = new Map;
        }
        p = Gp.prototype;
        p.configure = function(a) {
            this.D = a;
            Ip(this);
            Hp(this, !0);
        };
        p.append = function(a) {
            var b = [].concat(G(this.h));
            a = u(yp(a));
            for(var c = a.next(), d = {}; !c.done; d = {
                Rg: void 0
            }, c = a.next())d.Rg = c.value, b.some(function(e) {
                return function(f) {
                    return Ve(f, e.Rg);
                };
            }(d)) || this.h.push(d.Rg);
            this.h.length && Ip(this);
            Hp(this);
        };
        p.destroy = function() {
            if (!this.g) return Promise.resolve();
            this.g.parentElement && this.l.removeChild(this.g);
            this.g = null;
            this.j = !1;
            this.h = [];
            this.C && (this.C.stop(), this.C = null);
            this.o.clear();
            this.i && (this.i.release(), this.i = null);
            this.F && (this.F.disconnect(), this.F = null);
            return Promise.resolve();
        };
        p.remove = function(a, b) {
            if (!this.g) return !1;
            var c = this.h.length;
            this.h = this.h.filter(function(d) {
                return d.startTime < a || d.endTime >= b;
            });
            Hp(this, c > this.h.length);
            this.h.length || Ip(this);
            return !0;
        };
        p.isTextVisible = function() {
            return this.j;
        };
        p.setTextVisibility = function(a) {
            (this.j = a) ? (this.g.parentElement || this.l.appendChild(this.g), Hp(this, !0)) : this.g.parentElement && this.l.removeChild(this.g);
        };
        p.setTextLanguage = function(a) {
            a && a != "und" ? this.g.setAttribute("lang", a) : this.g.setAttribute("lang", "");
        };
        p.enableTextDisplayer = function() {};
        function Ip(a) {
            a.C && (a.h.length ? a.C.xa((a.D ? a.D.captionsUpdatePeriod : .25) / Math.max(1, Math.abs(a.m.playbackRate))) : a.C.stop());
        }
        function Jp(a, b) {
            for(; b != null;){
                if (b == a.g) return !0;
                b = b.parentElement;
            }
            return !1;
        }
        function Kp(a, b, c, d, e) {
            var f = !1, g = [], h = [];
            b = u(b);
            for(var k = b.next(); !k.done; k = b.next()){
                k = k.value;
                e.push(k);
                var l = a.o.get(k), m = k.startTime <= d && k.endTime > d, n = l ? l.nk : null;
                l && (g.push(l.Sg), l.kd && g.push(l.kd), m || (f = !0, a.o.delete(k), l = null));
                m && (h.push(k), l ? Jp(a, n) || (f = !0) : (Lp(a, k, e), l = a.o.get(k), n = l.nk, f = !0));
                k.nestedCues.length > 0 && n && Kp(a, k.nestedCues, n, d, e);
                e.pop();
            }
            if (f) {
                d = u(g);
                for(e = d.next(); !e.done; e = d.next())e = e.value, e.parentElement && e.parentElement.removeChild(e);
                h.sort(function(q, r) {
                    return q.startTime != r.startTime ? q.startTime - r.startTime : q.endTime - r.endTime;
                });
                h = u(h);
                for(d = h.next(); !d.done; d = h.next())d = a.o.get(d.value), d.kd ? (d.kd.contains(c) && d.kd.removeChild(c), c.appendChild(d.kd), d.kd.appendChild(d.Sg)) : c.appendChild(d.Sg);
            }
        }
        function Hp(a, b) {
            if (a.g) {
                var c = a.m.currentTime;
                if (!a.j || (b === void 0 ? 0 : b)) {
                    b = u(a.G.values());
                    for(var d = b.next(); !d.done; d = b.next())gk(d.value);
                    gk(a.g);
                    a.o.clear();
                    a.G.clear();
                }
                a.j && Kp(a, a.h, a.g, c, []);
            }
        }
        function Lp(a, b, c) {
            var d = c.length > 1, e = d ? "span" : "div";
            b.lineBreak && (e = "br");
            b.rubyTag && (e = b.rubyTag);
            d = !d && b.nestedCues.length > 0;
            var f = U(e);
            e != "br" && Mp(a, f, b, c, d);
            c = null;
            if (b.region && b.region.id) {
                var g = b.region, h = a.A === 4 / 3 ? 2.5 : 1.9;
                c = g.id + "_" + g.width + "x" + g.height + (g.heightUnits == Nd ? "%" : "px") + "-" + g.viewportAnchorX + "x" + g.viewportAnchorY + (g.viewportAnchorUnits == Nd ? "%" : "px") + "-" + g.regionAnchorX + "x" + g.regionAnchorY;
                if (a.G.has(c)) c = a.G.get(c);
                else {
                    e = U("span");
                    var k = g.heightUnits == Nd ? "%" : "px", l = g.widthUnits == Nd ? "%" : "px", m = g.viewportAnchorUnits == Nd ? "%" : "px";
                    e.id = "shaka-text-region---" + c;
                    e.classList.add("shaka-text-region");
                    e.style.position = "absolute";
                    var n = g.height, q = g.width;
                    g.heightUnits === 2 && (n = g.height * 5.33, k = "%");
                    g.widthUnits === 2 && (q = g.width * h, l = "%");
                    e.style.height = n + k;
                    e.style.width = q + l;
                    g.viewportAnchorUnits === 2 ? (h = g.viewportAnchorY / 75 * 100, k = g.viewportAnchorX / (a.A === 4 / 3 ? 160 : 210) * 100, h -= g.regionAnchorY * n / 100, k -= g.regionAnchorX * q / 100, e.style.top = h + "%", e.style.left = k + "%") : (e.style.top = g.viewportAnchorY - g.regionAnchorY * n / 100 + m, e.style.left = g.viewportAnchorX - g.regionAnchorX * q / 100 + m);
                    g.heightUnits !== 0 && g.widthUnits !== 0 && g.viewportAnchorUnits !== 0 && (g = Math.max(0, Math.min(100 - (parseInt(e.style.width.slice(0, -1), 10) || 0), parseInt(e.style.left.slice(0, -1), 10) || 0)), e.style.top = Math.max(0, Math.min(100 - (parseInt(e.style.height.slice(0, -1), 10) || 0), parseInt(e.style.top.slice(0, -1), 10) || 0)) + "%", e.style.left = g + "%");
                    e.style.display = "flex";
                    e.style.flexDirection = "column";
                    e.style.alignItems = "center";
                    e.style.justifyContent = b.displayAlign == "before" ? "flex-start" : b.displayAlign == "center" ? "center" : "flex-end";
                    a.G.set(c, e);
                    c = e;
                }
            }
            e = f;
            d && (e = U("span"), e.classList.add("shaka-text-wrapper"), e.style.backgroundColor = b.backgroundColor, e.style.lineHeight = "normal", f.appendChild(e));
            a.o.set(b, {
                Sg: f,
                nk: e,
                kd: c
            });
        }
        function Np(a) {
            var b = a.direction, c = a.positionAlign;
            a = a.textAlign;
            return c !== Je ? c : a === "left" || a === "start" && b === Le || a === "end" && b === "rtl" ? "line-left" : a === "right" || a === "start" && b === "rtl" || a === "end" && b === Le ? "line-right" : "center";
        }
        function Mp(a, b, c, d, e) {
            var f = b.style, g = c.nestedCues.length == 0, h = d.length > 1;
            f.whiteSpace = "pre-wrap";
            var k = c.payload.replace(/\s+$/g, function(m) {
                return "\u00a0".repeat(m.length);
            });
            f.webkitTextStrokeColor = c.textStrokeColor;
            f.webkitTextStrokeWidth = c.textStrokeWidth;
            f.color = c.color;
            f.direction = c.direction;
            f.opacity = c.opacity;
            f.paddingLeft = Op(c.linePadding, c, a.l);
            f.paddingRight = Op(c.linePadding, c, a.l);
            f.textCombineUpright = c.textCombineUpright;
            f.textShadow = c.textShadow;
            if (c.backgroundImage) f.backgroundImage = "url('" + c.backgroundImage.replace(/['"()\\]/g, "") + "')", f.backgroundRepeat = "no-repeat", f.backgroundSize = "contain", f.backgroundPosition = "center", c.backgroundColor && (f.backgroundColor = c.backgroundColor), f.width = "100%", f.height = "100%";
            else {
                if (c.nestedCues.length) var l = b;
                else l = U("span"), b.appendChild(l);
                c.border && (l.style.border = c.border);
                e || ((b = Pp(d, function(m) {
                    return m.backgroundColor;
                })) ? l.style.backgroundColor = b : k && (l.style.backgroundColor = "rgba(0, 0, 0, 0.8)"));
                k && (l.setAttribute("translate", "no"), l.textContent = k);
            }
            if (h && !d[d.length - 1].isContainer) f.display = "inline";
            else {
                f.display = "flex";
                f.flexDirection = "column";
                f.alignItems = "center";
                if (c.textAlign == "left" || c.textAlign == "start") f.width = "100%", f.alignItems = "flex-start";
                else if (c.textAlign == "right" || c.textAlign == "end") f.width = "100%", f.alignItems = "flex-end";
                f.justifyContent = c.displayAlign == "before" ? "flex-start" : c.displayAlign == "center" ? "center" : "flex-end";
            }
            g || (f.margin = "0");
            f.fontFamily = c.fontFamily;
            f.fontWeight = c.fontWeight.toString();
            f.fontStyle = c.fontStyle;
            f.letterSpacing = c.letterSpacing;
            d = a.D ? a.D.fontScaleFactor : 1;
            if (d !== 1 || c.fontSize) f.fontSize = Op(c.fontSize || "1em", c, a.l, d);
            d = c.line;
            d != null && (g = c.lineInterpretation, g == Ne && (g = 1, h = 16, a.A && a.A < 1 && (h = 32), d = d < 0 ? 100 + d / h * 100 : d / h * 100), g == 1 && (f.position = "absolute", c.writingMode == Me ? (f.width = "100%", c.lineAlign == Oe ? f.top = d + "%" : c.lineAlign == "end" && (f.bottom = 100 - d + "%")) : c.writingMode == "vertical-lr" ? (f.height = "100%", c.lineAlign == Oe ? f.left = d + "%" : c.lineAlign == "end" && (f.right = 100 - d + "%")) : (f.height = "100%", c.lineAlign == Oe ? f.right = d + "%" : c.lineAlign == "end" && (f.left = 100 - d + "%"))));
            f.lineHeight = c.lineHeight;
            a = Np(c);
            a == "line-left" ? (f.cssFloat = "left", c.position !== null && (f.position = "absolute", c.writingMode == Me ? (f.left = c.position + "%", f.width = "auto") : f.top = c.position + "%")) : a == "line-right" ? (f.cssFloat = "right", c.position !== null && (f.position = "absolute", c.writingMode == Me ? (f.right = 100 - c.position + "%", f.width = "auto") : f.bottom = c.position + "%")) : c.position !== null && c.position != 50 && (f.position = "absolute", c.writingMode == Me ? (f.left = c.position + "%", f.width = "auto") : f.top = c.position + "%", c.size && (f.transform = "translateX(-50%)"));
            f.textAlign = c.textAlign;
            f.textDecoration = c.textDecoration.join(" ");
            f.writingMode = c.writingMode;
            "writingMode" in document.documentElement.style && f.writingMode == c.writingMode || (f.webkitWritingMode = c.writingMode);
            c.size && (c.writingMode == Me ? f.width = c.size + "%" : f.height = c.size + "%");
        }
        function Op(a, b, c, d) {
            d = d === void 0 ? 1 : d;
            var e = (e = new RegExp(/(\d*\.?\d+)([a-z]+|%+)/).exec(a)) ? {
                value: Number(e[1]),
                unit: e[2]
            } : null;
            if (!e) return a;
            a = e.unit;
            d *= e.value;
            switch(a){
                case "%":
                    return d / 100 * c.clientHeight / b.cellResolution.rows + "px";
                case "c":
                    return c.clientHeight * d / b.cellResolution.rows + "px";
                default:
                    return d + a;
            }
        }
        function Pp(a, b) {
            for(var c = a.length - 1; c >= 0; c--){
                var d = b(a[c]);
                if (d || d === 0) return d;
            }
            return null;
        }
        O("shaka.text.UITextDisplayer", Gp);
        Gp.prototype.enableTextDisplayer = Gp.prototype.enableTextDisplayer;
        Gp.prototype.setTextLanguage = Gp.prototype.setTextLanguage;
        Gp.prototype.setTextVisibility = Gp.prototype.setTextVisibility;
        Gp.prototype.isTextVisible = Gp.prototype.isTextVisible;
        Gp.prototype.remove = Gp.prototype.remove;
        Gp.prototype.destroy = Gp.prototype.destroy;
        Gp.prototype.append = Gp.prototype.append;
        Gp.prototype.configure = Gp.prototype.configure;
        function Qp(a, b) {
            function c(f) {
                for(var g = f, h = u(b), k = h.next(); !k.done; k = h.next())k = k.value, k.end && k.start < f && (g += k.end - k.start);
                f = Math.floor(g / 3600);
                h = Math.floor(g / 60 % 60);
                k = Math.floor(g % 60);
                g = Math.floor(g * 1E3 % 1E3);
                return (f < 10 ? "0" : "") + f + ":" + (h < 10 ? "0" : "") + h + ":" + (k < 10 ? "0" : "") + k + "." + (g < 100 ? g < 10 ? "00" : "0" : "") + g;
            }
            var d = xp(a);
            a = "WEBVTT\n\n";
            d = u(d);
            for(var e = d.next(); !e.done; e = d.next())e = e.value, a += c(e.startTime) + " --\x3e " + c(e.endTime) + function(f) {
                var g = [];
                switch(f.textAlign){
                    case "left":
                        g.push("align:left");
                        break;
                    case "right":
                        g.push("align:right");
                        break;
                    case Ke:
                        g.push("align:middle");
                        break;
                    case "start":
                        g.push("align:start");
                        break;
                    case "end":
                        g.push("align:end");
                }
                switch(f.writingMode){
                    case "vertical-lr":
                        g.push("vertical:lr");
                        break;
                    case "vertical-rl":
                        g.push("vertical:rl");
                }
                return g.length ? " " + g.join(" ") : "";
            }(e) + "\n", a += e.payload + "\n\n";
            return a;
        }
        O("shaka.text.WebVttGenerator", function() {});
        function Rp(a, b) {
            this.g = b;
            this.j = a;
            this.m = new Map;
            this.l = void 0;
            this.F = !1;
            this.J = !0;
            this.A = this.I = !1;
            this.D = this.C = void 0;
            this.H = 0;
            this.K = {
                request: !1,
                response: !1,
                event: !1
            };
            this.o = {};
            this.i = new fd;
            this.G = [];
            this.h = null;
        }
        Rp.prototype.setMediaElement = function(a) {
            this.h = a;
            Sp(this);
        };
        Rp.prototype.configure = function(a) {
            this.g = a;
            Tp(this);
        };
        function Up(a) {
            a.m.clear();
            a.F = !1;
            a.J = !0;
            a.I = !1;
            a.A = !1;
            a.C = 0;
            a.D = 0;
            a.H = 0;
            a.K = {
                request: !1,
                response: !1,
                event: !1
            };
            Vp(a);
            a.o = {};
            a.h = null;
            a.i.Ta();
        }
        function Wp(a, b) {
            a.A = b;
            a.A ? a.l == Xp ? a.l = Yp : a.l == Zp && (a.l = $p) : a.l == Yp ? a.l = Xp : a.l == $p && (a.l = Zp);
        }
        function aq(a, b) {
            if (a.g && a.g.enabled && (bq(a, "ps", {
                nd: "d"
            }), a.h && a.h.autoplay)) {
                var c = a.h.play();
                c && c.then(function() {
                    a.H = b;
                }).catch(function() {
                    a.H = 0;
                });
            }
        }
        function cq(a, b, c) {
            try {
                if (!a.g.enabled) return b;
                var d = dq(a);
                a: {
                    switch(c.toLowerCase()){
                        case "audio/mp4":
                        case "audio/webm":
                        case "audio/ogg":
                        case "audio/mpeg":
                        case "audio/aac":
                        case "audio/flac":
                        case "audio/wav":
                            var e = eq;
                            break a;
                        case "video/webm":
                        case "video/mp4":
                        case "video/mpeg":
                        case "video/mp2t":
                            e = fq;
                            break a;
                        case "application/x-mpegurl":
                        case "application/vnd.apple.mpegurl":
                        case "audio/x-mpegurl":
                        case "application/dash+xml":
                        case "video/vnd.mpeg.dash.mpd":
                        case "application/vnd.ms-sstr+xml":
                            e = gq;
                            break a;
                    }
                    e = void 0;
                }
                d.ot = e;
                d.su = !0;
                var f = hq(d);
                return iq(b, f);
            } catch (g) {
                return $a("CMCD_SRC_ERROR", "Could not generate src CMCD data.", g), b;
            }
        }
        function Sp(a) {
            a.i.u(a.h, "playing", function() {
                a.D || (a.D = Date.now());
                bq(a, "ps", {
                    nd: "p"
                });
            });
            a.i.u(a.h, "volumechange", function() {
                bq(a, a.h.muted ? "m" : "um");
            });
            a.i.u(a.h, "play", function() {
                a.C || (a.C = Date.now(), bq(a, "ps", {
                    nd: "s"
                }));
            });
            a.i.u(a.h, "pause", function() {
                bq(a, "ps", {
                    nd: "a"
                });
            });
            a.i.u(a.j, "buffering", function() {
                bq(a, "ps", {
                    nd: "w"
                });
            });
            a.i.u(a.h, "seeking", function() {
                return bq(a, "ps", {
                    nd: "k"
                });
            });
            a.i.u(document, "fullscreenchange", function() {
                bq(a, document.fullscreenElement ? "pe" : "pc");
            });
            var b = a.h;
            (b.webkitPresentationMode || b.webkitSupportsFullscreen) && a.i.u(b, "webkitpresentationmodechanged", function() {
                b.webkitPresentationMode ? bq(a, b.webkitPresentationMode !== "inline" ? "pe" : "pc") : b.webkitSupportsFullscreen && bq(a, b.webkitDisplayingFullscreen ? "pe" : "pc");
            });
            a.i.u(a.h, "enterpictureinpicture", function() {
                bq(a, "pe");
            });
            a.i.u(a.h, "leavepictureinpicture", function() {
                bq(a, "pc");
            });
            "documentPictureInPicture" in window1 && a.i.u(window1.documentPictureInPicture, "enter", function(c) {
                bq(a, "pe");
                a.i.ra(c.window, "pagehide", function() {
                    bq(a, "pc");
                });
            });
            a.i.u(document, "visibilitychange", function() {
                document.hidden ? bq(a, "b", {
                    bg: !0
                }) : bq(a, "b");
            });
            a.i.u(a.j, "complete", function() {
                bq(a, "ps", {
                    nd: "e"
                });
            });
        }
        function Tp(a) {
            Vp(a);
            var b = jq(a);
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next())if (c = c.value.timeInterval, c === void 0 && (c = kq), c >= 1) {
                var d = new Uf(function() {
                    return bq(a, lq);
                });
                d.xa(c);
                a.G.push(d);
            }
        }
        function Vp(a) {
            if (a.G) for(var b = u(a.G), c = b.next(); !c.done; c = b.next())c.value.stop();
            a.G = [];
        }
        function jq(a) {
            return (a = a.g.targets) ? a.filter(function(b) {
                return b.mode === mq && b.enabled;
            }) : [];
        }
        function nq(a) {
            return (a = a.g.targets) ? a.filter(function(b) {
                return b.mode === oq && b.enabled === !0;
            }) : [];
        }
        function dq(a) {
            a.g.sessionId || (a.g.sessionId = window1.crypto.randomUUID());
            return {
                v: a.g.version,
                sf: a.l,
                sid: a.g.sessionId,
                cid: a.g.contentId,
                mtp: a.j.getBandwidthEstimate() / 1E3
            };
        }
        function bq(a, b, c) {
            c = c === void 0 ? {} : c;
            b = Object.assign({
                e: b,
                ts: Date.now()
            }, c);
            b = pq(a, b, mq);
            c = a.g.targets;
            if (!(a.g.version < qq) && c) {
                var d = jq(a);
                c = Array.from(new Set([].concat(G(rq), G(sq))));
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next()){
                    e = e.value;
                    var f = tq(e.includeKeys || [], c);
                    f.includes(Jq) || f.push(Jq);
                    f = Kq(b, f);
                    var g = e.events || [], h = f.e, k = f.sta;
                    h && (!Lq.includes(h) || !(h !== "ps" || k && Mq.includes(k)) || g && g.length > 0 && !g.includes(h)) || Nq(a, f, e);
                }
            }
        }
        function Oq(a, b, c) {
            if (a.g.enabled) {
                c = pq(a, c, Pq);
                var d = Qq({
                    mode: Pq,
                    useHeaders: a.g.useHeaders,
                    includeKeys: a.g.includeKeys || []
                });
                a.o[d] || (a.o[d] = {
                    request: 1,
                    response: 1
                });
                c.sn = a.o[d].request++;
                d = a.g.includeKeys || [];
                var e = a.g.version == qq ? Array.from(new Set([].concat(G(rq), G(Rq)))) : Sq;
                d = tq(d, e);
                c = Kq(c, d);
                Tq(a, c, b, a.g.useHeaders);
            }
        }
        function Nq(a, b, c, d) {
            var e = Wg(), f = c.url;
            if (c.useHeaders) {
                b = Uq(b);
                if (!Object.keys(b).length) return;
                d && Object.assign(d.headers, b);
                d = mh([
                    f
                ], e);
                Object.assign(d.headers, b);
            } else {
                b = hq(b);
                if (!b) return;
                f = iq(f, b);
                d && (d.uri = f);
                d = mh([
                    f
                ], e);
            }
            a.j.Qb().request(9, d);
        }
        function Tq(a, b, c, d) {
            if (d) {
                b = Uq(b);
                if (!Object.keys(b).length) return;
                Object.assign(c.headers, b);
            } else {
                var e = hq(b);
                if (!e) return;
                c.uris = c.uris.map(function(f) {
                    return iq(f, e);
                });
            }
            nq(a).length > 0 || !a.m.has(c) || a.m.delete(c);
        }
        function tq(a, b) {
            if (!a || a.length === 0) return b;
            for(var c = u(a), d = c.next(); !d.done; d = c.next())b.includes(d.value);
            return a = a.filter(function(e) {
                return b.includes(e);
            });
        }
        function Kq(a, b) {
            return Object.keys(a).reduce(function(c, d) {
                b.includes(d) && (c[d] = a[d]);
                return c;
            }, {});
        }
        function Vq(a) {
            if (a.type === 0) return Wq;
            if (a = a.stream) {
                var b = a.type;
                if (b == "video") return a.codecs && a.codecs.includes(",") ? fq : Xq;
                if (b == "audio") return eq;
                if (b == "text") return a.mimeType === "application/mp4" ? Yq : Zq;
            }
        }
        function Qq(a) {
            var b = Object.keys(a).sort().reduce(function(c, d) {
                d !== "enabled" && (c[d] = a[d]);
                return c;
            }, {});
            return JSON.stringify(b);
        }
        function $q(a, b) {
            b = a.j.Nc()[b];
            if (!b.length) return NaN;
            var c = a.h ? a.h.currentTime : 0;
            return (a = b.find(function(d) {
                return d.start <= c && d.end >= c;
            })) ? (a.end - c) * 1E3 : NaN;
        }
        function ar(a, b) {
            b = a.j.Nc()[b];
            if (!b.length) return 0;
            var c = a.h ? a.h.currentTime : 0;
            return (a = b.find(function(d) {
                return d.start <= c && d.end >= c;
            })) ? (a.end - c) * 1E3 : 0;
        }
        function br(a, b) {
            var c = a.j.Ib();
            if (!c.length) return NaN;
            a = c[0];
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next())d = d.value, d.type === "variant" && d.bandwidth > a.bandwidth && (a = d);
            switch(b){
                case Xq:
                    return a.videoBandwidth || NaN;
                case eq:
                    return a.audioBandwidth || NaN;
                default:
                    return a.bandwidth;
            }
        }
        function cr(a, b, c) {
            var d = b.segment, e = 0;
            d && (e = d.endTime - d.startTime);
            e = {
                d: e * 1E3,
                st: a.j.U() ? dr : er
            };
            e.ot = Vq(b);
            var f = e.ot === Xq || e.ot === eq || e.ot === fq || e.ot === Yq;
            if (b = b.stream) {
                var g = a.j.Wa();
                if (f && (e.bl = $q(a, b.type), e.ot !== Yq)) {
                    var h = ar(a, b.type);
                    e.dl = g ? h / Math.abs(g) : h;
                }
                b.bandwidth && (e.br = b.bandwidth / 1E3);
                if (b.segmentIndex && d) {
                    if ((g = b.segmentIndex.ac(d.endTime, !0, g < 0)) && (g = g.next().value) && g != d) {
                        if (c && !ed(d.T(), g.T())) {
                            var k = g.T()[0];
                            h = new URL(k);
                            var l = new URL(c);
                            if (h.origin !== l.origin) c = k;
                            else {
                                c = h.pathname.split("/").slice(1);
                                k = l.pathname.split("/").slice(1, -1);
                                l = Math.min(c.length, k.length);
                                for(var m = 0; m < l && c[m] === k[m]; m++)c.shift(), k.shift();
                                for(; k.length;)k.shift(), c.unshift("..");
                                c = c.join("/") + h.search + h.hash;
                            }
                            e.nor = c;
                        }
                        !g.startByte && !g.endByte || d.startByte == g.startByte && d.endByte == g.endByte || (c = g.startByte + "-", g.endByte && (c += g.endByte), e.nrr = c);
                    }
                    g = a.j.Wa() || 1;
                    c = ar(a, b.type) || 500;
                    d = (b = b.bandwidth) ? b * (d.endTime - d.startTime) / 1E3 / (c / g / 1E3) * a.g.rtpSafetyFactor : NaN;
                    isNaN(d) || (e.rtp = d);
                }
            }
            f && e.ot !== Yq && (e.tb = br(a, e.ot) / 1E3);
            return e;
        }
        function pq(a, b, c) {
            Object.assign(b, dq(a));
            b.pr = a.j.Wa();
            var d = b.ot === Xq || b.ot === fq;
            a.I && d && (b.bs = !0, b.su = !0, a.I = !1);
            b.su == null && (b.su = a.J);
            a.j.U() && (d = fr(a.j), b.ltc = d || void 0);
            document.hidden && (b.bg = !0);
            d = a.D && a.C ? a.D - (a.H || a.C) : void 0;
            d == void 0 || a.K[c] || (b.msd = d, a.K[c] = !0);
            return b;
        }
        function hq(a) {
            function b(n) {
                return c(n / 100) * 100;
            }
            function c(n) {
                return Math.round(n);
            }
            function d(n) {
                return !Number.isNaN(n) && n != null && n !== "" && n !== !1;
            }
            var e = [], f = {
                br: c,
                d: c,
                bl: b,
                dl: b,
                mtp: b,
                nor: function(n) {
                    return encodeURIComponent(n);
                },
                rtp: b,
                tb: c,
                ttfb: c,
                ttlb: c
            }, g = Object.keys(a || {}).sort();
            g = u(g);
            for(var h = g.next(); !h.done; h = g.next()){
                h = h.value;
                var k = a[h];
                if (d(k) && (h !== "v" || k !== 1) && (h != "pr" || k !== 1)) {
                    var l = f[h];
                    l && (k = l(k));
                    l = typeof k;
                    var m = void 0;
                    m = l === "string" && h !== "ot" && h !== "sf" && h !== "st" ? h + "=" + JSON.stringify(k) : l === "boolean" ? h : l === "symbol" ? h + "=" + k.description : h + "=" + k;
                    e.push(m);
                }
            }
            return e.join(",");
        }
        function Uq(a) {
            var b = Object.keys(a), c = {}, d = [
                "Object",
                "Request",
                "Session",
                "Status"
            ], e = [
                {},
                {},
                {},
                {}
            ], f = {
                br: 0,
                d: 0,
                ot: 0,
                tb: 0,
                url: 0,
                bl: 1,
                dl: 1,
                mtp: 1,
                nor: 1,
                nrr: 1,
                su: 1,
                ltc: 1,
                ttfb: 1,
                ttlb: 1,
                ts: 1,
                rc: 1,
                cmsdd: 1,
                cmsds: 1,
                sn: 1,
                cid: 2,
                pr: 2,
                sf: 2,
                sid: 2,
                st: 2,
                v: 2,
                msd: 2,
                bs: 3,
                rtp: 3,
                bg: 3
            };
            b = u(b);
            for(var g = b.next(); !g.done; g = b.next())g = g.value, e[f[g] != null ? f[g] : 1][g] = a[g];
            for(a = 0; a < e.length; a++)(f = hq(e[a])) && (c["CMCD-" + d[a]] = f);
            return c;
        }
        function iq(a, b) {
            if (!b || a.includes("offline:")) return a;
            a = new lb(a);
            a.g.set("CMCD", b);
            return a.toString();
        }
        var gq = "m", eq = "a", Xq = "v", fq = "av", Wq = "i", Zq = "c", Yq = "tt", qq = 2, er = "v", dr = "l", Xp = "d", Yp = "ld", Zp = "h", $p = "lh";
        O("shaka.util.CmcdManager.StreamingFormat", {
            DASH: Xp,
            hn: Yp,
            HLS: Zp,
            jn: $p,
            zn: "s",
            OTHER: "o"
        });
        var Sq = "br bl bs cid d dl mtp nor nrr ot pr rtp sf sid st su tb v".split(" "), rq = "br ab bl tbl bs cdn cid ltc mtp pr sf sid bg sta st ts tpb tb lb tab lab pt ec msd v sn".split(" "), Rq = "ab bl tbl bs cdn cid d dl ltc mtp nor ot pr rtp sf sid bg sta st su ts tpb tb lb tab lab pt ec msd v".split(" "), gr = "d dl nor ot rtp rc su ttfb ttfbb ttlb url cmsdd cmsds".split(" "), sq = [
            "e",
            "sta"
        ], Lq = "ps e t c b m um pe pc".split(" "), Mq = "spawkrfeqd".split(""), kq = 10, Jq = "ts", lq = "t", Pq = "request", oq = "response", mq = "event";
        function hr(a) {
            this.h = a;
            this.g = null;
        }
        p = hr.prototype;
        p.configure = function(a) {
            this.h = a;
        };
        p.aj = function() {
            return this.h.enabled && this.h.applyMaximumSuggestedBitrate && this.g && this.g.has(ir) ? this.g.get(ir) * 1E3 : null;
        };
        p.$i = function() {
            return this.h.enabled && this.g && this.g.has(jr) ? this.g.get(jr) * 1E3 : null;
        };
        p.il = function() {
            return this.h.enabled && this.g && this.g.has(kr) ? this.g.get(kr) : null;
        };
        p.jl = function() {
            return this.h.enabled && this.g && this.g.has(lr) ? this.g.get(lr) : null;
        };
        p.getBandwidthEstimate = function(a) {
            var b = this.$i();
            if (!b) return a;
            var c = this.h.estimatedThroughputWeightRatio;
            return c > 0 && c <= 1 ? a * (1 - c) + b * c : a;
        };
        function mr(a) {
            return a ? a.toLowerCase() === "false" ? !1 : /^[-0-9]/.test(a) ? parseInt(a, 10) : a.replace(/["]+/g, "") : !0;
        }
        O("shaka.util.CmsdManager", hr);
        hr.prototype.getBandwidthEstimate = hr.prototype.getBandwidthEstimate;
        hr.prototype.getRoundTripTime = hr.prototype.jl;
        hr.prototype.getResponseDelay = hr.prototype.il;
        hr.prototype.getEstimatedThroughput = hr.prototype.$i;
        hr.prototype.getMaxBitrate = hr.prototype.aj;
        var jr = "etp", ir = "mb", kr = "rd", lr = "rtt";
        function nr() {
            this.g = null;
            this.h = [];
        }
        function or(a, b) {
            return H(function(c) {
                if (c.h == 1) return a.g ? c.g(new Promise(function(d) {
                    return a.h.push(d);
                }), 2) : c.B(2);
                a.g = b;
                c.j();
            });
        }
        nr.prototype.release = function() {
            this.h.length > 0 ? this.h.shift()() : this.g = null;
        };
        function W(a, b, c) {
            b = b === void 0 ? null : b;
            fb.call(this);
            var d = this;
            this.m = pr;
            this.h = null;
            this.Oe = b;
            this.W = !1;
            this.Ye = new fd;
            this.Pe = new fd;
            this.j = new fd;
            this.jc = new fd;
            this.Td = new fd;
            this.G = this.H = this.F = this.M = null;
            this.Ze = 0;
            this.X = new nr;
            this.O = this.Ga = this.V = this.i = this.Gc = this.I = this.l = this.Le = this.R = this.Hi = this.na = this.K = this.jb = this.ya = this.Ne = this.P = this.Ia = this.L = this.Kb = null;
            this.Oa = !1;
            this.Te = this.o = null;
            this.Se = 1E9;
            this.Xe = [];
            this.Fc = new Map;
            this.kb = [];
            this.Bg = -1;
            this.g = qr(this);
            this.Dg = Do();
            this.S = null;
            this.$e = -1;
            this.hc = null;
            this.ua = {
                width: Infinity,
                height: Infinity
            };
            this.Re = new Li(this.g, this.ua, null);
            this.Ve = [];
            this.C = null;
            this.J = this.g.adaptationSetCriteriaFactory();
            this.J.configure({
                language: this.g.preferredAudioLanguage,
                role: this.g.preferredAudioRole,
                videoRole: this.g.preferredVideoRole,
                channelCount: 0,
                hdrLevel: this.g.preferredVideoHdrLevel,
                spatialAudio: this.g.preferSpatialAudio,
                videoLayout: this.g.preferredVideoLayout,
                audioLabel: this.g.preferredAudioLabel,
                videoLabel: this.g.preferredVideoLabel,
                codecSwitchingStrategy: this.g.mediaSource.codecSwitchingStrategy,
                audioCodec: "",
                activeAudioCodec: "",
                activeAudioChannelCount: 0,
                preferredAudioCodecs: this.g.preferredAudioCodecs,
                preferredAudioChannelCount: this.g.preferredAudioChannelCount
            });
            this.Zd = this.g.preferredTextLanguage;
            this.ce = this.g.preferredTextRole;
            this.be = this.g.preferForcedSubs;
            this.Qe = [];
            c && c(this);
            this.K = new Rp(this, this.g.cmcd);
            this.na = new hr(this.g.cmsd);
            this.M = rr(this);
            this.$ = this.ba = this.va = this.D = null;
            this.Fg = !1;
            this.Cg = [];
            this.Eg = new Uf(function() {
                return H(function(e) {
                    if (e.h == 1) return d.ba ? e.g(d.Ob(d.$, !0), 3) : e.B(0);
                    if (e.h != 4) return e.g(d.load(d.ba), 4);
                    d.Fg ? d.$.pause() : d.$.play();
                    d.ba = null;
                    d.Fg = !1;
                    e.j();
                });
            });
            sr && (this.D = sr(), this.D.configure(this.g.ads), this.Td.u(this.D, "ad-content-pause-requested", function(e) {
                var f, g;
                return H(function(h) {
                    if (h.h == 1) {
                        d.Eg.stop();
                        if (d.ba) return h.B(0);
                        d.$ = d.h;
                        d.Fg = d.isEnded();
                        f = e.saveLivePosition || !1;
                        g = !0;
                        d.U() && (g = f);
                        return h.g(d.Vi(!0, g), 3);
                    }
                    d.ba = h.i;
                    h.j();
                });
            }), this.Td.u(this.D, "ad-content-resume-requested", function(e) {
                e = e.offset || 0;
                if (d.ba) {
                    var f = d.ba;
                    f.o && e && (typeof f.o === "number" ? f.o += e : f.o.setTime(f.o.getTime() + e * 1E3));
                }
                d.Eg.Z(.1);
            }), this.Td.u(this.D, "ad-content-attach-requested", function() {
                return H(function(e) {
                    if (e.h == 1) return d.h || !d.$ ? e.B(0) : e.g(d.Ob(d.$, !0), 3);
                    d.$ = null;
                    e.j();
                });
            }));
            tr && (this.va = tr(this), this.va.configure(this.g.queue));
            this.Ye.u(window1, "online", function() {
                ur(d);
                d.bi();
            });
            this.Ue = new Uf(function() {
                for(var e = Date.now() / 1E3, f = !1, g = !0, h = u(d.i.variants), k = h.next(); !k.done; k = h.next())k = k.value, k.disabledUntilTime > 0 && k.disabledUntilTime <= e && (k.disabledUntilTime = 0, f = !0), k.disabledUntilTime > 0 && (g = !1);
                g && d.Ue.stop();
                f && vr(d, !1, void 0, !1, !1);
            });
            this.ab = null;
            a && (md("Player w/ mediaElement", "Please migrate from initializing Player with a mediaElement; use the attach method instead."), this.Ob(a, !0));
            this.A = null;
        }
        oa(W, fb);
        function wr(a) {
            a.R != null && (ud(a.R), a.R.release(), a.R = null);
        }
        function xr(a, b, c) {
            c || b.lcevc.enabled ? (wr(a), a.R == null && (a.R = new sd(a.h, a.Hi, b.lcevc, c), a.H && (a.H.D = a.R))) : wr(a);
        }
        function yr(a, b) {
            return new R(a, b);
        }
        p = W.prototype;
        p.destroy = function() {
            var a = this, b;
            return H(function(c) {
                switch(c.h){
                    case 1:
                        if (a.m == zr) return c.return();
                        wr(a);
                        b = a.detach();
                        a.m = zr;
                        return c.g(b, 2);
                    case 2:
                        return c.g(a.Vg(), 3);
                    case 3:
                        a.Ye && (a.Ye.release(), a.Ye = null);
                        a.Pe && (a.Pe.release(), a.Pe = null);
                        a.j && (a.j.release(), a.j = null);
                        a.jc && (a.jc.release(), a.jc = null);
                        a.Td && (a.Td.release(), a.Td = null);
                        a.Te = null;
                        a.g = null;
                        a.C = null;
                        a.Oe = null;
                        a.K = null;
                        a.na = null;
                        if (!a.M) {
                            c.B(4);
                            break;
                        }
                        return c.g(a.M.destroy(), 5);
                    case 5:
                        a.M = null;
                    case 4:
                        a.o && (a.o.release(), a.o = null), a.va && (a.va.destroy(), a.va = null), fb.prototype.release.call(a), c.j();
                }
            });
        };
        function Ar(a, b) {
            Br.set(a, b);
        }
        function Cr() {
            window1.Promise || Za("A Promise implementation or polyfill is required");
            if (!(window1.Promise && window1.Uint8Array && Array.prototype.forEach) || (navigator.userAgent || "").includes("Trident/")) return !1;
            Xb();
            return Ad() ? !0 : Bd().canPlayType("application/x-mpegurl") != "";
        }
        function Dr(a, b) {
            a.dispatchEvent(yr("onstatechange", (new Map).set("state", b)));
        }
        p.Ob = function(a, b) {
            b = b === void 0 ? !0 : b;
            var c = this, d, e, f;
            return H(function(g) {
                switch(g.h){
                    case 1:
                        if (c.m == zr) throw new T(2, 7, 7E3);
                        d = c.h && c.h == a;
                        if (!c.h || c.h == a) {
                            g.B(2);
                            break;
                        }
                        return g.g(c.detach(), 2);
                    case 2:
                        return g.g(Er(c, "attach"), 4);
                    case 4:
                        if (g.i) return g.return();
                        g.m(5, 6);
                        d || (Dr(c, "attach"), e = function() {
                            var h = Fr(c, !1);
                            h && Gr(c, h);
                        }, c.Pe.u(a, "error", e), c.h = a, c.K && c.K.setMediaElement(a));
                        Xb();
                        if (!b || !Ad() || c.H) {
                            g.B(6);
                            break;
                        }
                        return g.g(Hr(c), 6);
                    case 6:
                        g.A();
                        c.X.release();
                        g.C(0);
                        break;
                    case 5:
                        return f = g.l(), g.g(c.detach(), 10);
                    case 10:
                        throw f;
                }
            });
        };
        p.Ji = function(a) {
            this.Hi = a;
        };
        p.detach = function(a) {
            a = a === void 0 ? !1 : a;
            var b = this;
            return H(function(c) {
                if (c.h == 1) {
                    if (b.m == zr) throw new T(2, 7, 7E3);
                    return c.g(b.tc(!1, a), 2);
                }
                if (c.h != 3) return c.g(Er(b, "detach"), 3);
                if (c.i) return c.return();
                try {
                    b.h && (b.Pe.Ta(), b.h = null), Dr(b, "detach"), b.D && !a && b.D.release();
                } finally{
                    b.X.release();
                }
                c.j();
            });
        };
        function Er(a, b) {
            var c;
            return H(function(d) {
                return d.h == 1 ? (c = ++a.Ze, d.g(or(a.X, b), 2)) : c != a.Ze ? (a.X.release(), d.return(!0)) : d.return(!1);
            });
        }
        p.tc = function(a, b) {
            a = a === void 0 ? !0 : a;
            b = b === void 0 ? !1 : b;
            var c = this, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y;
            return H(function(z) {
                switch(z.h){
                    case 1:
                        return c.m != zr && (c.m = pr), z.g(Er(c, "unload"), 2);
                    case 2:
                        if (z.i) return z.return();
                        z.F(3);
                        c.Oa = !1;
                        Dr(c, "unload");
                        wr(c);
                        d = c.Qe.map(function(A) {
                            return A();
                        });
                        c.Qe = [];
                        return z.g(Promise.all(d), 5);
                    case 5:
                        c.dispatchEvent(yr("unloading"));
                        c.Ne && (c.Ne.release(), c.Ne = null);
                        c.ya && (c.ya.release(), c.ya = null);
                        c.jb && (c.jb.release(), c.jb = null);
                        c.h && (c.j.Ta(), c.jc.Ta());
                        c.Ue.stop();
                        c.Kb && (c.Kb.release(), c.Kb = null);
                        c.Ia && (c.Ia.stop(), c.Ia = null);
                        if (!c.I) {
                            z.B(6);
                            break;
                        }
                        return z.g(c.I.stop(), 7);
                    case 7:
                        c.I = null, c.Gc = null;
                    case 6:
                        c.o && c.o.stop();
                        if (!c.l) {
                            z.B(8);
                            break;
                        }
                        return z.g(c.l.destroy(), 9);
                    case 9:
                        c.l = null;
                    case 8:
                        c.L && (c.L.release(), c.L = null);
                        c.G && (c.G.release(), c.G = null);
                        if ("webkit" !== window1.shakaMediaKeysPolyfill || !c.F) {
                            z.B(10);
                            break;
                        }
                        return z.g(c.F.destroy(), 11);
                    case 11:
                        c.F = null;
                    case 10:
                        if (!c.H) {
                            z.B(12);
                            break;
                        }
                        return z.g(c.H.destroy(), 13);
                    case 13:
                        c.H = null;
                    case 12:
                        if (c.D && !b) c.D.onAssetUnload();
                        c.ba && !b && (c.ba.destroy(), c.ba = null);
                        b || c.Eg.stop();
                        c.K && Up(c.K);
                        c.na && (c.na.g = null);
                        if (!c.A) {
                            z.B(14);
                            break;
                        }
                        return z.g(c.A.destroy(), 15);
                    case 15:
                        c.A = null;
                    case 14:
                        c.W = !1;
                        if (c.h) {
                            e = u(c.Cg);
                            for(f = e.next(); !f.done; f = e.next())g = f.value, g.src.startsWith("blob:") && URL.revokeObjectURL(g.src), g.remove();
                            c.Cg = [];
                            ek(c.h) && c.h.load();
                        }
                        if (!c.F) {
                            z.B(16);
                            break;
                        }
                        return z.g(c.F.destroy(), 17);
                    case 17:
                        c.F = null;
                    case 16:
                        c.ab && c.V != c.ab.dd() && (c.ab.l || c.ab.destroy(), c.ab = null);
                        c.V = null;
                        c.Ga = null;
                        c.P = null;
                        if (c.i) {
                            h = u(c.i.variants);
                            for(k = h.next(); !k.done; k = h.next())for(l = k.value, m = u([
                                l.audio,
                                l.video
                            ]), n = m.next(); !n.done; n = m.next())(q = n.value) && q.segmentIndex && q.segmentIndex.release();
                            r = u(c.i.textStreams);
                            for(t = r.next(); !t.done; t = r.next())v = t.value, v.segmentIndex && v.segmentIndex.release();
                        }
                        c.g && c.g.streaming.clearDecodingCache && (og.clear(), Ub.clear());
                        c.i = null;
                        c.C = new Ko;
                        c.Gi = null;
                        c.hc = null;
                        c.S = null;
                        c.$e = -1;
                        c.Xe = [];
                        w = u(c.Fc.values());
                        for(x = w.next(); !x.done; x = w.next())y = x.value, y.stop();
                        c.Fc.clear();
                        c.kb = [];
                        c.Bg = -1;
                        c.M && c.M.Ri();
                        Ir(c);
                    case 3:
                        z.A();
                        c.X.release();
                        z.C(4);
                        break;
                    case 4:
                        Xb();
                        if (a && Ad() && !c.H && c.h) return z.g(Hr(c), 0);
                        z.B(0);
                }
            });
        };
        p.Gm = function(a) {
            this.O = a;
        };
        p.load = function(a, b, c) {
            b = b === void 0 ? null : b;
            var d = this, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y;
            return H(function(z) {
                switch(z.h){
                    case 1:
                        if (d.m == zr) throw new T(2, 7, 7E3);
                        if (d.h || !d.$) {
                            z.B(2);
                            break;
                        }
                        return z.g(d.Ob(d.$, !0), 3);
                    case 3:
                        d.$ = null;
                    case 2:
                        e = null;
                        f = "";
                        c = (g = c) == null ? void 0 : g.toLowerCase();
                        if (a instanceof To) {
                            if (a.l) throw new T(2, 7, 7006);
                            e = a;
                            f = e.dd() || "";
                        } else f = a || "";
                        return z.g(or(d.X, "load"), 4);
                    case 4:
                        d.X.release();
                        if (!d.h) throw new T(2, 7, 7002);
                        if (!d.V) {
                            z.B(5);
                            break;
                        }
                        d.V = f;
                        return z.g(d.tc(!1), 5);
                    case 5:
                        h = ++d.Ze;
                        k = function() {
                            return H(function(A) {
                                if (A.h == 1) return d.Ze == h ? A.B(0) : e ? A.g(e.destroy(), 3) : A.B(3);
                                throw new T(2, 7, 7E3);
                            });
                        };
                        l = function(A, E) {
                            return H(function(C) {
                                switch(C.h){
                                    case 1:
                                        return C.F(2), C.g(or(d.X, E), 4);
                                    case 4:
                                        return C.g(k(), 5);
                                    case 5:
                                        return C.g(A(), 6);
                                    case 6:
                                        return C.g(k(), 7);
                                    case 7:
                                        e && d.g && (e.g = d.g);
                                    case 2:
                                        C.A(), d.X.release(), C.C(0);
                                }
                            });
                        };
                        z.m(7, 8);
                        b == null && e && (b = e.getStartTime());
                        d.O = b;
                        d.Oa = !1;
                        d.dispatchEvent(yr("loading"));
                        if (e) {
                            c = e.S;
                            z.B(10);
                            break;
                        }
                        if (c) {
                            z.B(10);
                            break;
                        }
                        return z.g(l(function() {
                            return H(function(A) {
                                if (A.h == 1) return A.g(Jr(d, f), 2);
                                c = A.i;
                                A.j();
                            });
                        }, "guessMimeType_"), 10);
                    case 10:
                        m = !!e;
                        if (e) {
                            Wo(e, d);
                            d.C = e.getStats();
                            z.B(13);
                            break;
                        }
                        return z.g(Kr(d, f, b, c, !0, d.g), 14);
                    case 14:
                        (e = z.i) ? (e.F = !1, Wo(e, d), d.C = e.getStats(), e.start(), e.C.catch(function() {})) : d.C = new Ko;
                    case 13:
                        n = !e;
                        q = Date.now() / 1E3;
                        d.C = e ? e.getStats() : new Ko;
                        d.V = f;
                        d.Ga = c || null;
                        Ir(d);
                        r = function() {
                            var A = d.h ? d.h.buffered : null;
                            return {
                                start: Uj(A) || 0,
                                end: Vj(A) || 0
                            };
                        };
                        d.ya = new Lm(r);
                        d.ya.addEventListener("regionadd", function(A) {
                            Lr(d, A.region, "metadataadded");
                        });
                        if (n) return z.g(l(function() {
                            return H(function(A) {
                                return A.g(Mr(d, c), 0);
                            });
                        }, "initializeSrcEqualsDrmInner_"), 25);
                        d.jb = new Lm(r);
                        return z.g(l(function() {
                            return H(function(A) {
                                if (A.h == 1) return A.g(Promise.race([
                                    e.$,
                                    e.C
                                ]), 2);
                                d.Gc = e.H;
                                var E = e;
                                E.ba = !0;
                                d.I = E.m;
                                d.i = e.sh();
                                A.j();
                            });
                        }, "waitForFinish"), 17);
                    case 17:
                        if (d.H) {
                            z.B(18);
                            break;
                        }
                        return z.g(l(function() {
                            return H(function(A) {
                                return A.g(Hr(d), 0);
                            });
                        }, "initializeMediaSourceEngineInner_"), 18);
                    case 18:
                        return d.i && d.i.textStreams.length && (d.A.enableTextDisplayer ? d.A.enableTextDisplayer() : md("Text displayer w/ enableTextDisplayer", 'Text displayer should have a "enableTextDisplayer" method!')), z.g(l(function() {
                            return H(function(A) {
                                return A.g(e.C, 0);
                            });
                        }, "waitForFinish"), 20);
                    case 20:
                        d.g = e.getConfiguration();
                        d.Re = e.G;
                        d.I && d.I.setMediaElement && d.h && d.I.setMediaElement(d.h);
                        d.Ne = Xo(e);
                        d.Le = e.Ga;
                        if (t = e.D) d.J = t;
                        m && d.h && d.h.nodeName === "AUDIO" && (Nr(d), d.configure("manifest.disableVideo", !0));
                        if (e.j) {
                            z.B(21);
                            break;
                        }
                        return z.g(l(function() {
                            return H(function(A) {
                                return A.g(bp(e, d.h), 0);
                            });
                        }, "drmEngine_.init"), 21);
                    case 21:
                        return d.F = Yo(e), z.g(l(function() {
                            return H(function(A) {
                                return A.g(d.F.Ob(d.h), 0);
                            });
                        }, "drmEngine_.attach"), 23);
                    case 23:
                        return v = d.g.abrFactory, d.o && d.Te == v || (d.Te = v, d.o && d.o.release(), d.o = v(), typeof d.o.setMediaElement != "function" && (md("AbrManager w/o setMediaElement", "Please use an AbrManager with setMediaElement function."), d.o.setMediaElement = function() {}), typeof d.o.setCmsdManager != "function" && (md("AbrManager w/o setCmsdManager", "Please use an AbrManager with setCmsdManager function."), d.o.setCmsdManager = function() {}), typeof d.o.trySuggestStreams != "function" && (md("AbrManager w/o trySuggestStreams", "Please use an AbrManager with trySuggestStreams function."), d.o.trySuggestStreams = function() {}), d.o.configure(d.g.abr)), w = Zo(e), x = e.i, z.g(l(function() {
                            return H(function(A) {
                                return A.g(Or(d, q, x, w), 0);
                            });
                        }, "loadInner_"), 24);
                    case 24:
                        Vo(e);
                        d.Ga && Xb().lg() && Hf(d.Ga) && Xk(d.H, d.V, d.Ga);
                        z.B(16);
                        break;
                    case 25:
                        return z.g(l(function() {
                            return H(function(A) {
                                return A.g(Pr(d, q, c), 0);
                            });
                        }, "srcEqualsInner_"), 16);
                    case 16:
                        d.dispatchEvent(yr("loaded"));
                    case 8:
                        z.A();
                        if (!e) {
                            z.B(27);
                            break;
                        }
                        return z.g(e.destroy(), 27);
                    case 27:
                        d.ab = null;
                        z.C(0);
                        break;
                    case 7:
                        y = z.l();
                        if (!y || y.code == 7E3) {
                            z.B(29);
                            break;
                        }
                        return z.g(d.tc(!1), 29);
                    case 29:
                        throw y;
                }
            });
        };
        function Nr(a) {
            for(var b = u(a.i.variants), c = b.next(); !c.done; c = b.next())c = c.value, c.video && (c.video.closeSegmentIndex(), c.video = null), c.bandwidth = c.audio && c.audio.bandwidth ? c.audio.bandwidth : 0;
            a.i.variants = a.i.variants.filter(function(d) {
                return d.audio;
            });
        }
        p.gk = function(a, b, c) {
            a = a === void 0 ? !0 : a;
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? !1 : c;
            var d = this, e;
            return H(function(f) {
                return f.h == 1 ? f.g(Qr(d, c), 2) : f.h != 3 ? (e = f.i, f.g(d.tc(a, b), 3)) : f.return(e);
            });
        };
        p.Vi = function(a, b) {
            a = a === void 0 ? !1 : a;
            b = b === void 0 ? !1 : b;
            var c = this, d;
            return H(function(e) {
                return e.h == 1 ? e.g(Qr(c, b), 2) : e.h != 3 ? (d = e.i, e.g(c.detach(a), 3)) : e.return(d);
            });
        };
        function Qr(a, b) {
            b = b === void 0 ? !1 : b;
            var c, d, e;
            return H(function(f) {
                if (f.h == 1) {
                    c = null;
                    if (!(a.i && a.I && a.Gc && a.V && a.g)) return f.B(2);
                    d = a.h.currentTime;
                    b || (d = null);
                    return f.g(Rr(a, a.V, d, a.Ga, a.g, !0, !1), 3);
                }
                if (f.h != 2) {
                    c = f.i;
                    a.Ve.push(c);
                    a.I && a.I.setMediaElement && a.I.setMediaElement(null);
                    if (e = a.l ? a.l.o : null) c.i = e;
                    var g = c, h = a.I, k = a.Gc;
                    g.h = a.i;
                    g.m = h;
                    g.H = k;
                    c.D = a.J;
                    c.start();
                    a.i = null;
                    a.I = null;
                    a.Gc = null;
                    a.o = null;
                    a.Te = null;
                }
                return f.return(c);
            });
        }
        p.preload = function(a, b, c, d) {
            b = b === void 0 ? null : b;
            var e = this, f, g, h;
            return H(function(k) {
                if (k.h == 1) return c = (f = c) == null ? void 0 : f.toLowerCase(), g = qr(e), Eo(g, d || e.g, qr(e)), k.g(Kr(e, a, b, c, !1, g), 2);
                (h = k.i) ? h.start() : Gr(e, new T(2, 7, 7005));
                return k.return(h);
            });
        };
        p.Vg = function() {
            var a = this, b, c, d, e;
            return H(function(f) {
                b = [];
                c = u(a.Ve);
                for(d = c.next(); !d.done; d = c.next())e = d.value, e.l || b.push(e.destroy());
                a.Ve = [];
                return f.g(Promise.all(b), 0);
            });
        };
        function Kr(a, b, c, d, e, f) {
            e = e === void 0 ? !1 : e;
            var g, h, k, l;
            return H(function(m) {
                if (m.h == 1) return d ? m.B(2) : m.g(Jr(a, b), 3);
                m.h != 2 && (d = m.i);
                if (g = Sr(a, d)) return m.return(null);
                h = f || a.g;
                k = !1;
                e && a.h && a.h.nodeName === "AUDIO" && (k = !0);
                l = Rr(a, b, c, d || null, h, !e, k);
                l = e ? l.then(function(n) {
                    n.F = !1;
                    return n;
                }) : l.then(function(n) {
                    a.Ve.push(n);
                    return n;
                });
                return m.return(l);
            });
        }
        function Rr(a, b, c, d, e, f, g) {
            f = f === void 0 ? !0 : f;
            g = g === void 0 ? !1 : g;
            var h, k, l, m, n, q, r, t, v, w, x, y, z, A, E;
            return H(function(C) {
                if (C.h == 1) {
                    h = null;
                    k = Xd(e);
                    g && (k.manifest.disableVideo = !0);
                    l = function() {
                        return h.P && h.l ? null : h;
                    };
                    m = function() {
                        return l() ? l().getConfiguration() : a.g;
                    };
                    if (a.ua.width != Infinity || a.ua.height != Infinity || a.g.ignoreHardwareResolution) return C.B(2);
                    n = Xb();
                    return C.g(n.vc(), 3);
                }
                C.h != 2 && (q = C.i, a.ua.width = q.width, a.ua.height = q.height);
                r = new Li(k, a.ua, null);
                t = {
                    networkingEngine: a.M,
                    filter: function(D) {
                        var B, J;
                        return H(function(F) {
                            if (F.h == 1) return F.g(Mi(r, D), 2);
                            if (F.h != 4) {
                                B = F.i;
                                if (!B) return F.B(0);
                                J = yr("trackschanged");
                                return F.g(Promise.resolve(), 4);
                            }
                            h.dispatchEvent(J);
                            F.j();
                        });
                    },
                    makeTextStreamsForClosedCaptions: function(D) {
                        return Tr(a, D);
                    },
                    onTimelineRegionAdded: function(D) {
                        Mm(h.I, D);
                    },
                    onEvent: function(D) {
                        return h.dispatchEvent(D);
                    },
                    onError: function(D) {
                        return h.onError(D);
                    },
                    isLowLatencyMode: function() {
                        return m().streaming.lowLatencyMode;
                    },
                    updateDuration: function() {
                        a.l && h.P && a.l.updateDuration();
                    },
                    newDrmInfo: function(D) {
                        var B = h.j, J = B ? B.g : null;
                        J && B.C && Pi(r, J.keySystem, D);
                    },
                    onManifestUpdated: function() {
                        var D = (new Map).set("isLive", a.U());
                        h.dispatchEvent(yr("manifestupdated", D));
                        Uo(h, !1, function() {
                            if (a.D) a.D.onManifestUpdated(a.U());
                        });
                    },
                    getBandwidthEstimate: function() {
                        return a.o.getBandwidthEstimate();
                    },
                    onMetadata: function(D, B, J, F) {
                        var I = D;
                        if (D == "com.apple.hls.interstitial" || D == "com.apple.hls.overlay") {
                            if (I = "com.apple.quicktime.HLS", D = {
                                startTime: B,
                                endTime: J,
                                values: F
                            }, a.D) a.D.onHLSInterstitialMetadata(a, a.h, D);
                        }
                        F = u(F);
                        D = F.next();
                        for(var K = {}; !D.done; K = {
                            Uh: void 0
                        }, D = F.next())K.Uh = D.value, K.Uh.name != "ID" && Uo(h, !1, function(N) {
                            return function() {
                                Ur(a, B, J, I, N.Uh);
                            };
                        }(K));
                    },
                    disableStream: function(D) {
                        return a.disableStream(D, a.g.streaming.maxDisabledTime);
                    },
                    addFont: function(D, B) {
                        return a.addFont(D, B);
                    }
                };
                v = new Lm(function() {
                    return a.wa();
                });
                v.addEventListener("regionadd", function(D) {
                    var B = D.region;
                    Vr(a, "timelineregionadded", B, h);
                    Uo(h, !1, function() {
                        a.D && (a.D.onDashTimedMetadata(B), a.D.onDASHInterstitialMetadata(a, a.h, B));
                    });
                });
                w = null;
                k.streaming.observeQualityChanges && (w = new Fm(function() {
                    return a.Nc();
                }), w.addEventListener("qualitychange", function(D) {
                    Wr(a, D.quality, D.position);
                }), w.addEventListener("audiotrackchange", function(D) {
                    Wr(a, D.quality, D.position, !0);
                }));
                x = !0;
                y = {
                    Cc: a.M,
                    onError: function(D) {
                        return h.onError(D);
                    },
                    Uf: function(D) {
                        Uo(h, !0, function() {
                            a.F && Xr(a, D);
                        });
                    },
                    onExpirationUpdated: function(D, B) {
                        var J = yr("expirationupdated");
                        h.dispatchEvent(J);
                        if ((J = h.m) && J.onExpirationUpdated) J.onExpirationUpdated(D, B);
                    },
                    onEvent: function(D) {
                        h.dispatchEvent(D);
                        if (D.type == "drmsessionupdate" && x) {
                            x = !1;
                            D = Date.now() / 1E3 - h.va;
                            var B = a.C || h.getStats();
                            D >= 0 && (B.m = D);
                            a.R && ud(a.R);
                        }
                    }
                };
                z = rr(a, l);
                lh(a.M, z);
                A = function() {
                    return a.wd(y);
                };
                E = {
                    config: k,
                    Pl: t,
                    bm: v,
                    am: w,
                    wd: A,
                    Ol: r,
                    networkingEngine: z,
                    rk: f
                };
                h = new To(b, d, c, E);
                return C.return(h);
            });
        }
        function Jr(a, b) {
            var c, d, e, f;
            return H(function(g) {
                if (g.h == 1) return c = a.g.manifest.retryParameters, g.g(fn(b, a.M, c), 2);
                d = g.i;
                Hf(d) ? (e = Xb(), e.Ma() === "WEBKIT" && (d = "application/vnd.apple.mpegurl")) : d === "video/quicktime" && (f = Xb(), f.Ma() === "CHROMIUM" && (d = "video/mp4"));
                return g.return(d);
            });
        }
        function Sr(a, b) {
            if (!Ad(Xb())) return !0;
            if (b) {
                if ((a.h || Bd()).canPlayType(b) == "") return !1;
                if (!Ad(Xb()) || !yd.has(b)) return !0;
                if (Hf(b)) return Xb().Ma() === "WEBKIT" && (a.g.drm.servers["com.apple.fps"] || a.g.drm.servers["com.apple.fps.1_0"]) ? a.g.streaming.useNativeHlsForFairPlay : a.g.streaming.preferNativeHls;
                if (b === "application/dash+xml" || b === "video/vnd.mpeg.dash.mpd") return a.g.streaming.preferNativeDash;
            }
            return !1;
        }
        function Yr(a, b) {
            var c = a.g.textDisplayFactory;
            a.Gi !== c || (b === void 0 ? 0 : b) ? (b = a.A, a.A = c(), a.A.configure ? a.A.configure(a.g.textDisplayer) : md("Text displayer w/ configure", 'Text displayer should have a "configure" method!'), a.A.setTextLanguage || md("Text displayer w/ setTextLanguage", 'Text displayer should have a "setTextLanguage" method!'), b ? (a.A.setTextVisibility(b.isTextVisible()), b.destroy().catch(function() {})) : a.A.setTextVisibility(a.W), a.H && El(a.H, a.A), a.Gi = c, a.l && An(a.l)) : a.A && a.A.configure && a.A.configure(a.g.textDisplayer);
        }
        function Hr(a) {
            var b, c, d;
            return H(function(e) {
                if (e.h == 1) return Xb(), Dr(a, "media-source"), a.g.mediaSource.useSourceElements && ek(a.h), Yr(a), b = Zr(a.h, a.A, {
                    Uk: function() {
                        return a.keySystem();
                    },
                    onMetadata: function(f, g, h) {
                        f = u(f);
                        for(var k = f.next(); !k.done; k = f.next())if (k = k.value, k.data && typeof k.cueTime == "number" && k.frames) {
                            var l = k.cueTime + g, m = h;
                            m && l > m && (m = l);
                            for(var n = u(k.frames), q = n.next(); !q.done; q = n.next())Ur(a, l, m, "org.id3", q.value);
                            if (a.D) a.D.onHlsTimedMetadata(k, l);
                        }
                    },
                    Vl: function(f) {
                        a.jb && Mm(a.jb, {
                            schemeIdUri: f.schemeIdUri,
                            startTime: f.startTime,
                            endTime: f.endTime,
                            id: String(f.id),
                            emsg: f
                        });
                    },
                    onEvent: function(f) {
                        return a.dispatchEvent(f);
                    },
                    Xl: function() {
                        a.I && a.I.update && a.I.update();
                    }
                }, a.R, a.g.mediaSource), c = a.g.manifest, d = c.segmentRelativeVttTiming, b.Ga = d, e.g(b.L, 2);
                a.H = b;
                e.j();
            });
        }
        function $r(a, b) {
            a.L = new Bm({
                wh: function() {
                    return b.playbackRate;
                },
                Cd: function() {
                    return b.defaultPlaybackRate;
                },
                Qj: function(c) {
                    b.playbackRate = c;
                },
                Tl: function(c) {
                    var d = b.currentTime;
                    if (Wj(b.buffered, d) && !(b.readyState <= HTMLMediaElement.HAVE_CURRENT_DATA)) {
                        c = d + c;
                        var e = a.wa();
                        c < e.start ? d !== e.start && (b.currentTime = e.start) : c > e.end ? d !== e.end && (b.currentTime = e.end) : b.currentTime = c;
                    }
                },
                isPaused: function() {
                    return b.paused;
                }
            });
        }
        function as(a, b, c) {
            function d() {
                return bs(a);
            }
            a.j.u(b, "playing", d);
            a.j.u(b, "pause", d);
            a.j.u(b, "ended", d);
            a.j.u(b, "ratechange", function() {
                return cs(a);
            });
            b.remote && (a.j.u(b.remote, "connect", function() {
                a.l && b.remote.state == "connected" && ds(a);
                es(a);
            }), a.j.u(b.remote, "connecting", function() {
                return es(a);
            }), a.j.u(b.remote, "disconnect", function() {
                return H(function(f) {
                    if (f.h == 1) return a.l && b.remote.state == "disconnected" ? f.g(On(a.l), 3) : f.B(2);
                    f.h != 2 && ds(a);
                    es(a);
                    f.j();
                });
            }));
            b.audioTracks && (a.j.u(b.audioTracks, "addtrack", function() {
                return es(a);
            }), a.j.u(b.audioTracks, "removetrack", function() {
                return es(a);
            }), a.j.u(b.audioTracks, "change", function() {
                return es(a);
            }));
            b.videoTracks && (a.j.u(b.videoTracks, "addtrack", function() {
                return es(a);
            }), a.j.u(b.videoTracks, "removetrack", function() {
                return es(a);
            }), a.j.u(b.videoTracks, "change", function() {
                return es(a);
            }));
            (b.webkitPresentationMode || b.webkitSupportsFullscreen) && a.j.u(b, "webkitpresentationmodechanged", function() {
                a.Oe && Yr(a, !0);
            });
            if (b.textTracks) {
                var e = function() {
                    a.m === fs && a.A instanceof Cp && ds(a);
                    es(a);
                };
                a.j.u(b.textTracks, "addtrack", function(f) {
                    if (f.track) switch(f = f.track, f.kind){
                        case "metadata":
                            gs(a, f);
                            break;
                        case "chapters":
                            hs(a, f);
                            break;
                        default:
                            e();
                    }
                });
                a.j.u(b.textTracks, "removetrack", e);
                a.j.u(b.textTracks, "change", e);
            }
            b.preload != "none" && a.j.ra(b, "loadedmetadata", function() {
                var f = a.C, g = Date.now() / 1E3 - c;
                g >= 0 && (f.G = g);
            });
        }
        function Or(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L;
            return H(function(Q) {
                switch(Q.h){
                    case 1:
                        Dr(a, "load");
                        e = a.h;
                        $r(a, e);
                        as(a, e, b);
                        "onchange" in window1.screen && a.j.u(window1.screen, "change", function() {
                            if (a.J.getConfiguration) {
                                var S = a.J.getConfiguration();
                                S.hdrLevel == "AUTO" ? is(a) : a.g.preferredVideoHdrLevel == "AUTO" && a.g.abr.enabled && (S.hdrLevel = "AUTO", a.J.configure(S), is(a));
                            }
                        });
                        f = !1;
                        g = u(a.i.variants);
                        for(h = g.next(); !h.done; h = g.next())k = h.value, (l = k.video && k.video.dependencyStream) && (f = vd(l));
                        xr(a, a.g, f);
                        a.Zd = a.g.preferredTextLanguage;
                        a.ce = a.g.preferredTextRole;
                        a.be = a.g.preferForcedSubs;
                        js(a.i.presentationTimeline, a.g.playRangeStart, a.g.playRangeEnd);
                        a.o.init(function(S, Z, pa) {
                            a.i && a.l && S != a.l.o && ks(a, S, !0, Z === void 0 ? !1 : Z, pa === void 0 ? 0 : pa);
                        });
                        a.o.setMediaElement(e);
                        a.o.setCmsdManager(a.na);
                        a.l = ls(a);
                        a.l.configure(a.g.streaming);
                        a.m = ms;
                        a.dispatchEvent(yr("streaming"));
                        m = c;
                    case 2:
                        q = a.l.o;
                        q || (r = ns(a, !0), c || (m = r));
                        t = [];
                        n = q || m;
                        v = u([
                            n.video,
                            n.audio
                        ]);
                        for(w = v.next(); !w.done; w = v.next())(x = w.value) && !x.segmentIndex && (t.push(x.createSegmentIndex()), x.dependencyStream && t.push(x.dependencyStream.createSegmentIndex()));
                        if (!(t.length > 0)) {
                            Q.B(4);
                            break;
                        }
                        return Q.g(Promise.all(t), 4);
                    case 4:
                        if (!n || n.disabledUntilTime != 0) {
                            Q.B(2);
                            break;
                        }
                        is(a);
                        if (a.I && a.I.onInitialVariantChosen) a.I.onInitialVariantChosen(n);
                        a.i.isLowLatency && (a.g.streaming.lowLatencyMode ? a.configure(a.Dg) : Za("Low-latency live stream detected, but low-latency streaming mode is not enabled in Shaka Player. Set streaming.lowLatencyMode configuration to true, and see https://bit.ly/3clctcj for details."));
                        a.K && (Wp(a.K, a.i.isLowLatency && a.g.streaming.lowLatencyMode), aq(a.K, b * 1E3));
                        js(a.i.presentationTimeline, a.g.playRangeStart, a.g.playRangeEnd);
                        qn(a.l, a.g.playRangeStart, a.g.playRangeEnd);
                        a.Oa = !0;
                        a.dispatchEvent(yr("canupdatestarttime"));
                        y = function(S) {
                            a.G = os(a, S);
                            a.Kb = ps(a, S);
                            qs(a, e, !1);
                        };
                        a.g.streaming.startAtSegmentBoundary || (z = a.O, z == null && a.i.startTime && (z = a.i.startTime), y(z));
                        if (q) {
                            Q.B(7);
                            break;
                        }
                        if (!a.g.streaming.startAtSegmentBoundary) {
                            Q.B(8);
                            break;
                        }
                        A = a.i.presentationTimeline;
                        a.O instanceof Date && (C = A.m || A.i, D = a.O.getTime() / 1E3 - C, D != null && (E = D));
                        E == null && (E = typeof a.O === "number" ? a.O : a.U() ? Infinity : a.h.currentTime);
                        a.O == null && a.i.startTime && (E = a.i.startTime);
                        B = A.cc();
                        J = A.Gb();
                        E < B ? E = B : E > J && (E = J);
                        return Q.g(rs(m, E), 9);
                    case 9:
                        F = Q.i, y(F);
                    case 8:
                        ks(a, m, !0, !1, 0);
                    case 7:
                        return a.G.ready(), I = a.yc().find(function(S) {
                            return S.active;
                        }), I || ((K = Gg(a.i.textStreams, a.Zd, a.ce, a.be)[0] || null) && Jo(a.C.h, K, !0), m && (K ? (Og(m.audio, K, a.g) && (a.W = !0), a.W && a.A.setTextVisibility(!0)) : (a.W = !1, a.A.setTextVisibility(!1)), ss(a)), K && (a.g.streaming.alwaysStreamText || a.Tc()) && (zn(a.l, K), ts(a))), Q.g(a.l.start(d), 10);
                    case 10:
                        a.g.abr.enabled && (a.o.enable(), us(a));
                        es(a);
                        a.i.variants.some(function(S) {
                            return S.primary;
                        });
                        if ((N = a.U()) && (a.g.streaming.liveSync && a.g.streaming.liveSync.enabled || a.i.serviceDescription || a.g.streaming.liveSync.panicMode) || a.g.streaming.vodDynamicPlaybackRate) P = function() {
                            return vs(a);
                        }, a.j.u(e, "timeupdate", P);
                        N || (M = function() {
                            return ws(a);
                        }, a.j.u(e, "timeupdate", M), ws(a), a.i.nextUrl && (a.g.streaming.preloadNextUrlWindow > 0 && (L = function() {
                            var S;
                            return H(function(Z) {
                                if (Z.h == 1) {
                                    S = a.wa().end - a.h.currentTime;
                                    if (isNaN(S) || !(S <= a.g.streaming.preloadNextUrlWindow)) return Z.B(0);
                                    a.j.Fa(e, "timeupdate", L);
                                    return Z.g(a.preload(a.i.nextUrl), 4);
                                }
                                a.ab = Z.i;
                                Z.j();
                            });
                        }, a.j.u(e, "timeupdate", L)), a.j.u(e, "ended", function() {
                            a.load(a.ab || a.i.nextUrl);
                        })));
                        if (a.D) a.D.onManifestUpdated(N);
                        Q.j();
                }
            });
        }
        function Mr(a, b) {
            var c, d, e;
            return H(function(f) {
                return f.h == 1 ? (c = Date.now() / 1E3, d = !0, a.F = a.wd({
                    Cc: a.M,
                    onError: function(g) {
                        Gr(a, g);
                    },
                    Uf: function() {},
                    onExpirationUpdated: function() {
                        var g = yr("expirationupdated");
                        a.dispatchEvent(g);
                    },
                    onEvent: function(g) {
                        a.dispatchEvent(g);
                        if (g.type == "drmsessionupdate" && d) {
                            d = !1;
                            g = a.C;
                            var h = Date.now() / 1E3 - c;
                            h >= 0 && (g.m = h);
                        }
                    }
                }), a.F.configure(a.g.drm), e = Pg([
                    b
                ]), a.F.O = !0, f.g(Vh(a.F, [
                    e
                ], []), 2)) : f.g(a.F.Ob(a.h), 0);
            });
        }
        function Pr(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t;
            return H(function(v) {
                switch(v.h){
                    case 1:
                        Dr(a, "src-equals");
                        d = a.h;
                        a.G = new nm(d);
                        e = !1;
                        a.Qe.push(function() {
                            e = !0;
                        });
                        a.dispatchEvent(yr("canupdatestarttime"));
                        a.O != null && a.G.Ag(a.O);
                        a.Kb = xs(a, a.O || 0);
                        $r(a, d);
                        qs(a, d, !0);
                        d.textTracks && (Yr(a), f = function(w) {
                            if (!(a.A instanceof Cp)) {
                                var x = ys(a).find(function(y) {
                                    return y.mode !== "disabled";
                                });
                                x && (x.mode = w ? "showing" : "hidden");
                                a.A instanceof Dp && (x = zs(a)) && (x.mode = !w && a.A.isTextVisible() ? "showing" : "hidden");
                            }
                        }, a.j.u(d, "enterpictureinpicture", function() {
                            return f(!0);
                        }), a.j.u(d, "leavepictureinpicture", function() {
                            return f(!1);
                        }), d.remote ? (a.j.u(d.remote, "connect", function() {
                            return f(!1);
                        }), a.j.u(d.remote, "connecting", function() {
                            return f(!1);
                        }), a.j.u(d.remote, "disconnect", function() {
                            return f(!1);
                        })) : "webkitCurrentPlaybackTargetIsWireless" in d && a.j.u(d, "webkitcurrentplaybacktargetiswirelesschanged", function() {
                            return f(!1);
                        }), g = d, (g.webkitPresentationMode || g.webkitSupportsFullscreen) && a.j.u(g, "webkitpresentationmodechanged", function() {
                            g.webkitPresentationMode ? f(g.webkitPresentationMode !== "inline") : g.webkitSupportsFullscreen && f(g.webkitDisplayingFullscreen);
                        }));
                        as(a, d, b);
                        h = cq(a.K, a.V, c);
                        !h.includes("#t=") && (a.g.playRangeStart > 0 || isFinite(a.g.playRangeEnd)) && (h += "#t=", a.g.playRangeStart > 0 && (h += a.g.playRangeStart), isFinite(a.g.playRangeEnd) && (h += "," + a.g.playRangeEnd));
                        if (!a.H) {
                            v.B(2);
                            break;
                        }
                        return v.g(a.H.destroy(), 3);
                    case 3:
                        a.H = null;
                    case 2:
                        return ek(d), d.src = h, k = Xb(), k.Pa() == "TV" && d.load(), d.preload != "none" && !d.autoplay && Hf(c) && k.Ma() === "WEBKIT" && d.load(), a.m = fs, a.dispatchEvent(yr("streaming")), l = function() {
                            return new Promise(function(w) {
                                var x = new Uf(w);
                                a.j.u(d.textTracks, "change", function() {
                                    return x.Z(.5);
                                });
                                x.Z(.5);
                            });
                        }, m = new Yg, em(d, HTMLMediaElement.HAVE_METADATA, a.j, function() {
                            return H(function(w) {
                                if (w.h == 1) return a.G.ready(), a.Ga && Hf(a.Ga) ? w.g(l(), 3) : (m.resolve(), w.B(0));
                                m.resolve();
                                w.j();
                            });
                        }), em(d, HTMLMediaElement.HAVE_CURRENT_DATA, a.j, function() {
                            var w, x, y, z, A;
                            return H(function(E) {
                                if (E.h == 1) return E.g(l(), 2);
                                if (e) return E.return();
                                As(a);
                                w = ys(a);
                                w.some(function(C) {
                                    return C.mode === "showing";
                                }) && (a.W = !0, a.A.setTextVisibility(!0));
                                if (!(a.A instanceof Cp)) for(w.length && (a.A.enableTextDisplayer ? a.A.enableTextDisplayer() : md("Text displayer w/ enableTextDisplayer", 'Text displayer should have a "enableTextDisplayer" method')), x = !1, y = u(w), z = y.next(); !z.done; z = y.next())A = z.value, A.mode !== "disabled" && (x ? (A.mode = "disabled", Za("Found more than one enabled text track, disabling it", A)) : (Bs(a, A), x = !0));
                                Cs(a);
                                E.j();
                            });
                        }), d.error ? m.reject(Fr(a)) : d.preload == "none" && (Za('With <video preload="none">, the browser will not load anything until play() is called. We are unable to measure load latency in a meaningful way, and we cannot provide track info yet. Please do not use preload="none" with Shaka Player.'), m.resolve()), a.j.ra(d, "error", function() {
                            m.reject(Fr(a));
                        }), v.g($f(a.g.streaming.loadTimeout, m), 4);
                    case 4:
                        if ((n = a.U()) && (a.g.streaming.liveSync && a.g.streaming.liveSync.enabled || a.g.streaming.liveSync.panicMode) || a.g.streaming.vodDynamicPlaybackRate) q = function() {
                            return vs(a);
                        }, a.j.u(d, "timeupdate", q);
                        n || (r = function() {
                            return ws(a);
                        }, a.j.u(d, "timeupdate", r), ws(a));
                        a.D && (a.D.onManifestUpdated(n), n && (t = a.wa().end, a.j.u(d, "progress", function() {
                            var w = a.wa().end;
                            t != w && (a.D.onManifestUpdated(a.U()), t = w);
                        })));
                        a.Oa = !0;
                        v.j();
                }
            });
        }
        function As(a) {
            var b = a.g.preferredAudioLanguage;
            b != "" && a.Ij(b, a.g.preferredAudioRole);
        }
        function Cs(a) {
            var b = a.g.preferredTextLanguage;
            b != "" && a.ei(b, a.g.preferredTextRole, a.g.preferForcedSubs);
        }
        function gs(a, b) {
            if (b.kind == "metadata") {
                b.mode = "hidden";
                a.j.u(b, "cuechange", function() {
                    if (b.activeCues) {
                        for(var d = u(b.activeCues), e = d.next(); !e.done; e = d.next())if (e = e.value, Ur(a, e.startTime, e.endTime, e.type, e.value), a.D) a.D.onCueMetadataChange(e.value);
                    }
                    if (b.cues) {
                        d = [];
                        e = u(b.cues);
                        for(var f = e.next(), g = {}; !f.done; g = {
                            Lc: void 0
                        }, f = e.next())g.Lc = f.value, g.Lc.type == "com.apple.quicktime.HLS" && g.Lc.startTime != null && (f = d.find(function(h) {
                            return function(k) {
                                return k.startTime == h.Lc.startTime && k.endTime == h.Lc.endTime;
                            };
                        }(g)), f || (f = {
                            startTime: g.Lc.startTime,
                            endTime: g.Lc.endTime,
                            values: []
                        }, d.push(f)), f.values.push(g.Lc.value));
                        d = u(d);
                        for(e = d.next(); !e.done; e = d.next())e = e.value, e.values.some(function(h) {
                            return h.key == "X-ASSET-URI" || h.key == "X-ASSET-LIST";
                        }) && a.D && (e.values.push({
                            key: "CUE",
                            description: "",
                            data: e.startTime != 0 || a.U() ? "ONCE" : "ONCE,PRE",
                            mimeType: null,
                            pictureType: null
                        }), a.D.onHLSInterstitialMetadata(a, a.h, e));
                    }
                });
                var c = new Uf(function() {
                    var d = Ds(a);
                    d = u(d);
                    for(var e = d.next(); !e.done; e = d.next())e.value.mode = "hidden";
                }).La().Z(.5);
                a.Qe.push(function() {
                    c.stop();
                });
            }
        }
        function Lr(a, b, c) {
            b = (new Map).set("startTime", b.startTime).set("endTime", b.endTime).set("metadataType", b.schemeIdUri).set("payload", b.payload);
            a.dispatchEvent(yr(c, b));
        }
        function Ur(a, b, c, d, e) {
            a.ya && (b = {
                schemeIdUri: d,
                startTime: b,
                endTime: c || Infinity,
                id: "",
                payload: e
            }, b.id = JSON.stringify(b), Mm(a.ya, b));
        }
        function hs(a, b) {
            if (b && b.kind == "chapters") {
                b.mode = "hidden";
                var c = new Uf(function() {
                    b.mode = "hidden";
                }).La().Z(.5);
                a.Qe.push(function() {
                    c.stop();
                });
            }
        }
        p.hm = function() {
            for(var a = this.X; a.g;)a.release();
        };
        p.wd = function(a) {
            return new Oh(a);
        };
        function rr(a, b) {
            function c(f) {
                b() ? b().dispatchEvent(f) : a.dispatchEvent(f);
            }
            function d(f) {
                b() ? Uo(b(), !0, f) : f();
            }
            b || (b = function() {
                return null;
            });
            var e = new hh(function(f, g, h, k, l) {
                d(function() {
                    a.o && a.o.segmentDownloaded(f, g, h, k, l);
                });
            }, function(f, g, h) {
                g = (new Map).set("headers", f).set("request", g).set("requestType", h);
                c(yr("downloadheadersreceived", g));
                d(function() {
                    if (a.na) {
                        var k = a.na;
                        if (k.h.enabled) {
                            var l = f["cmsd-static"];
                            if (l) try {
                                var m = new Map, n = l.split(",");
                                for(l = 0; l < n.length; l++){
                                    var q = n[l].split("=");
                                    m.set(q[0], mr(q[1]));
                                }
                            } catch (x) {}
                            if (m = f["cmsd-dynamic"]) {
                                a: {
                                    try {
                                        var r = new Map, t = m.split(";");
                                        for(m = 1; m < t.length; m++){
                                            var v = t[m].split("=");
                                            r.set(v[0], mr(v[1]));
                                        }
                                        var w = r;
                                        break a;
                                    } catch (x) {
                                        w = null;
                                        break a;
                                    }
                                    w = void 0;
                                }
                                w && (k.g = w);
                            }
                        }
                    }
                });
            }, function(f, g) {
                f = (new Map).set("request", f).set("response", g);
                c(yr("downloadcompleted", f));
            }, function(f, g, h, k) {
                f = (new Map).set("request", f).set("error", g).set("httpResponseCode", h).set("aborted", k);
                c(yr("downloadfailed", f));
            }, function(f, g, h) {
                d(function() {
                    if (a.K) {
                        var k = a.K, l = h;
                        l = l === void 0 ? {} : l;
                        if (k.g.enabled) {
                            if (g.method === "HEAD") Oq(k, g, {});
                            else switch(f){
                                case 0:
                                    try {
                                        if (k.g.enabled) {
                                            if (l.type) {
                                                a: {
                                                    switch(l.type){
                                                        case 4:
                                                            var m = k.A ? Yp : Xp;
                                                            break a;
                                                        case 3:
                                                        case 2:
                                                            m = k.A ? $p : Zp;
                                                            break a;
                                                        case 5:
                                                            m = "s";
                                                            break a;
                                                    }
                                                    m = void 0;
                                                }
                                                k.l = m;
                                            }
                                            Oq(k, g, {
                                                ot: gq,
                                                su: !k.F
                                            });
                                        }
                                    } catch (q) {
                                        $a("CMCD_MANIFEST_ERROR", "Could not generate manifest CMCD data.", q);
                                    }
                                    break;
                                case sh:
                                    try {
                                        if (k.g.enabled) {
                                            var n = cr(k, l, g.uris[0]);
                                            n.ts = Date.now();
                                            k.m.has(g) && k.m.delete(g);
                                            k.m.set(g, n.ts);
                                            Oq(k, g, n);
                                        }
                                    } catch (q) {
                                        $a("CMCD_SEGMENT_ERROR", "Could not generate segment CMCD data.", q);
                                    }
                                    break;
                                case 2:
                                case 5:
                                case 6:
                                    Oq(k, g, {
                                        ot: "k"
                                    });
                                    break;
                                case 4:
                                    Oq(k, g, {
                                        ot: "o"
                                    });
                            }
                        }
                    }
                });
            }, function(f, g, h, k) {
                (f = b() ? b().m : a.I) && f.banLocation && f.banLocation(k);
            }, function(f, g, h) {
                if (g.data) {
                    var k = g.data.byteLength, l = b() ? b().getStats() : a.C;
                    l && (Ro(l, k), f === 0 && (l.nj = k));
                    k = a.K;
                    h = h === void 0 ? {} : h;
                    if (nq(k).length !== 0) switch(f){
                        case sh:
                            try {
                                var m = cr(k, h, g.uri);
                                g.originalRequest && g.originalRequest.timeToFirstByte != null && (m.ttfb = g.originalRequest.timeToFirstByte);
                                g.timeMs != null && (m.ttlb = g.timeMs);
                                var n = g.originalUri || g.uri;
                                if (n.includes("CMCD=")) try {
                                    var q = new URL(n);
                                    q.searchParams.delete("CMCD");
                                    var r = q.toString();
                                } catch (D) {
                                    r = n;
                                }
                                else r = n;
                                m.url = r;
                                k.m.has(g.originalRequest) ? (m.ts = k.m.get(g.originalRequest), k.m.delete(g.originalRequest)) : m.ts || (m.ts = Date.now());
                                var t = nq(k);
                                if (t.length !== 0) {
                                    var v = k.g.version == qq ? Array.from(new Set([].concat(G(rq), G(gr)))) : Sq;
                                    m.rc = g.status || 0;
                                    var w = pq(k, m, oq);
                                    g.headers && g.headers["CMSD-Static"] && (w.cmsds = btoa(g.headers["CMSD-Static"]));
                                    g.headers && g.headers["CMSD-Dynamic"] && (w.cmsdd = btoa(g.headers["CMSD-Dynamic"]));
                                    for(var x = u(t), y = x.next(); !y.done; y = x.next()){
                                        var z = y.value, A = tq(z.includeKeys || [], v), E = Qq(z);
                                        k.o[E] || (k.o[E] = {
                                            request: 1,
                                            response: 1
                                        });
                                        w.sn = k.o[E].response++;
                                        var C = Kq(w, A);
                                        Nq(k, C, z, g);
                                    }
                                }
                            } catch (D) {
                                $a("CMCD_SEGMENT_ERROR", "Could not generate response segment CMCD data.", D);
                            }
                    }
                }
            });
            e.configure(a.g.networking);
            return e;
        }
        function os(a, b) {
            return new qm(a.h, a.i, a.g.streaming, b, function() {
                a.Kb && Em(a.Kb, !a.G.Ei());
                a.l && a.l.ld();
                a.P && Es(a, "seeking");
            }, function(c) {
                return a.dispatchEvent(c);
            });
        }
        function ps(a, b) {
            var c = a.U() || typeof b === "number" && b > 0;
            b = new mp(a.Ne, c);
            b.addEventListener("enter", function(f) {
                Vr(a, "timelineregionenter", f.region);
            });
            b.addEventListener("exit", function(f) {
                Vr(a, "timelineregionexit", f.region);
            });
            b.addEventListener("skip", function(f) {
                var g = f.region;
                f.seeking || (Vr(a, "timelineregionenter", g), Vr(a, "timelineregionexit", g));
            });
            var d = new mp(a.ya, c);
            d.addEventListener("enter", function(f) {
                Lr(a, f.region, "metadata");
            });
            c = new mp(a.jb, c);
            c.addEventListener("enter", function(f) {
                f = (new Map).set("detail", f.region.emsg);
                a.dispatchEvent(yr("emsg", f));
            });
            var e = new Dm(a.h);
            e.g.add(b);
            e.g.add(d);
            e.g.add(c);
            a.Le && e.g.add(a.Le);
            return e;
        }
        function xs(a, b) {
            b = new mp(a.ya, b instanceof Date || b > 0);
            b.addEventListener("enter", function(d) {
                Lr(a, d.region, "metadata");
            });
            var c = new Dm(a.h);
            c.g.add(b);
            return c;
        }
        function qs(a, b, c) {
            a.P = new Hi;
            Ki(a.P, Ji);
            Fs(a);
            Ir(a);
            a.Ia = new Uf(function() {
                Es(a);
            });
            a.g.streaming.rebufferingGoal && a.Ia.xa(.25);
            a.j.u(b, "waiting", function() {
                return Es(a, "waiting");
            });
            a.j.u(b, "canplaythrough", function() {
                return Es(a, "canplaythrough");
            });
            a.j.u(b, "playing", function() {
                return Es(a, "playing");
            });
            a.j.u(b, "seeked", function() {
                return Es(a, "seeked");
            });
            a.j.u(b, "timeupdate", function() {
                return Es(a, "timeupdate");
            });
            c && (a.j.u(b, "progress", function() {
                return Es(a, "progress");
            }), a.j.u(b, "stalled", function() {
                return Es(a, "stalled");
            }));
        }
        function Fs(a) {
            var b = a.g.streaming.rebufferingGoal;
            a.P.j.set(Ii, Math.min(.5, b / 2)).set(Ji, b);
        }
        function Es(a, b) {
            if (a.g.streaming.rebufferingGoal) {
                b = a.H ? $k(a.H) : !1;
                b = a.isEnded() || b || a.G.jj();
                var c = Xj(a.h.buffered, a.h.currentTime), d = a.P, e = d.j.get(d.g);
                Ki(d, b || c >= e && c > 0 ? Ii : Ji) && Ir(a);
            } else if (b) {
                c = a.P;
                d = a.h.currentTime;
                e = c.h;
                c.h = d;
                var f = void 0;
                switch(b){
                    case "seeking":
                    case "waiting":
                        c.h = -1;
                        f = Ji;
                        break;
                    case "canplaythrough":
                    case "playing":
                    case "seeked":
                        f = Ii;
                        break;
                    case "timeupdate":
                        e >= 0 && d - e > .01 && (f = Ii);
                }
                f !== void 0 && Ki(c, f) && Ir(a);
            }
        }
        function Zr(a, b, c, d, e) {
            return new Sk(a, b, c, e, d);
        }
        function ls(a) {
            return new kn(a.i, {
                bc: function() {
                    return a.G ? a.G.ee() : 0;
                },
                getBandwidthEstimate: function() {
                    return a.o.getBandwidthEstimate();
                },
                Wa: function() {
                    return a.Wa();
                },
                video: a.h,
                aa: a.H,
                Cc: a.M,
                onError: function(b) {
                    return Gr(a, b);
                },
                onEvent: function(b) {
                    return a.dispatchEvent(b);
                },
                Md: function(b, c, d, e) {
                    var f = b.startTime, g = b.endTime, h = c.type;
                    if (h != Ec) {
                        if (a.G) {
                            a.G.uj();
                            var k = gl(a.H, h);
                            !a.U() && a.h.paused && !a.h.seeking && k != null && k > 0 && a.G.ee() < k && !rk(a.G.ee(), k, .001) && a.G.Ag(k);
                        }
                        Es(a);
                    }
                    d = (new Map).set("start", f).set("end", g).set("contentType", h).set("isMuxed", d).set("isDependency", e);
                    a.dispatchEvent(yr("segmentappended", d));
                    a.o && c.fastSwitching && b.hd && b.we && a.o.trySuggestStreams();
                },
                Wl: function(b, c) {
                    (c = c.Kd) && a.Le && Hm(a.Le, c, b);
                },
                Ni: function(b, c) {
                    var d = a.F;
                    if (d.h.parseInbandPsshEnabled && !d.H && [
                        "audio",
                        "video"
                    ].includes(b)) {
                        b = new Mh(Fb(c));
                        c = 0;
                        for(var e = u(b.data), f = e.next(); !f.done; f = e.next())c += f.value.length;
                        if (c == 0) d = Promise.resolve();
                        else {
                            c = new Uint8Array(c);
                            e = 0;
                            b = u(b.data);
                            for(f = b.next(); !f.done; f = b.next())f = f.value, c.set(f, e), e += f.length;
                            di(d, "cenc", c);
                            d = d.m;
                        }
                    } else d = Promise.resolve();
                    return d;
                },
                disableStream: function(b, c) {
                    return a.disableStream(b, c);
                },
                Am: function(b, c) {
                    return a.g.abr.enabled && c.fastSwitching && b.hd && b.we ? !1 : !0;
                }
            });
        }
        p.configure = function(a, b) {
            var c = this.getConfiguration();
            arguments.length == 2 && typeof a == "string" && (a = co(a, b));
            "preferredVariantRole" in a && (md("preferredVariantRole configuration", "Please Use preferredAudioRole instead."), a.preferredAudioRole = a.preferredVariantRole, delete a.preferredVariantRole);
            a.streaming && "forceTransmuxTS" in a.streaming && (md("streaming.forceTransmuxTS configuration", "Please Use mediaSource.forceTransmux instead."), a.mediaSource = a.mediaSource || {}, a.mediaSource.mediaSource = a.streaming.forceTransmuxTS, delete a.streaming.forceTransmuxTS);
            a.streaming && "forceTransmux" in a.streaming && (md("streaming.forceTransmux configuration", "Please Use mediaSource.forceTransmux instead."), a.mediaSource = a.mediaSource || {}, a.mediaSource.mediaSource = a.streaming.forceTransmux, delete a.streaming.forceTransmux);
            if (a.streaming && "useNativeHlsOnSafari" in a.streaming) {
                md("streaming.useNativeHlsOnSafari configuration", "Please Use streaming.useNativeHlsForFairPlay or streaming.preferNativeHls instead.");
                var d = Xb();
                a.streaming.preferNativeHls = a.streaming.useNativeHlsOnSafari && d.Ma() === "WEBKIT";
                delete a.streaming.useNativeHlsOnSafari;
            }
            a.streaming && typeof a.streaming.liveSync == "boolean" && (md("streaming.liveSync", "Please Use streaming.liveSync.enabled instead."), d = a.streaming.liveSync, a.streaming.liveSync = {}, a.streaming.liveSync.enabled = d);
            if (a.streaming && !(a.streaming.liveSync && "targetLatency" in a.streaming.liveSync) && ("liveSyncMinLatency" in a.streaming || "liveSyncMaxLatency" in a.streaming)) {
                d = a.streaming.liveSyncMinLatency || 0;
                var e = Math.abs((a.streaming.liveSyncMaxLatency || 1) - d) / 2;
                a.streaming.liveSync = a.streaming.liveSync || {};
                a.streaming.liveSync.targetLatency = d + e;
                a.streaming.liveSync.targetLatencyTolerance = e;
            }
            a.streaming && "liveSyncMaxLatency" in a.streaming && (md("streaming.liveSyncMaxLatency", "Please Use streaming.liveSync.targetLatency and streaming.liveSync.targetLatencyTolerance instead. Or, set the values in your DASH manifest"), delete a.streaming.liveSyncMaxLatency);
            a.streaming && "liveSyncMinLatency" in a.streaming && (md("streaming.liveSyncMinLatency", "Please Use streaming.liveSync.targetLatency and streaming.liveSync.targetLatencyTolerance instead. Or, set the values in your DASH manifest"), delete a.streaming.liveSyncMinLatency);
            a.streaming && "liveSyncTargetLatency" in a.streaming && (md("streaming.liveSyncTargetLatency", "Please Use streaming.liveSync.targetLatency instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.targetLatency = a.streaming.liveSyncTargetLatency, delete a.streaming.liveSyncTargetLatency);
            a.streaming && "liveSyncTargetLatencyTolerance" in a.streaming && (md("streaming.liveSyncTargetLatencyTolerance", "Please Use streaming.liveSync.targetLatencyTolerance instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.targetLatencyTolerance = a.streaming.liveSyncTargetLatencyTolerance, delete a.streaming.liveSyncTargetLatencyTolerance);
            a.streaming && "liveSyncPlaybackRate" in a.streaming && (md("streaming.liveSyncPlaybackRate", "Please Use streaming.liveSync.maxPlaybackRate instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.maxPlaybackRate = a.streaming.liveSyncPlaybackRate, delete a.streaming.liveSyncPlaybackRate);
            a.streaming && "liveSyncMinPlaybackRate" in a.streaming && (md("streaming.liveSyncMinPlaybackRate", "Please Use streaming.liveSync.minPlaybackRate instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.minPlaybackRate = a.streaming.liveSyncMinPlaybackRate, delete a.streaming.liveSyncMinPlaybackRate);
            a.streaming && "liveSyncPanicMode" in a.streaming && (md("streaming.liveSyncPanicMode", "Please Use streaming.liveSync.panicMode instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.panicMode = a.streaming.liveSyncPanicMode, delete a.streaming.liveSyncPanicMode);
            a.streaming && "liveSyncPanicThreshold" in a.streaming && (md("streaming.liveSyncPanicThreshold", "Please Use streaming.liveSync.panicThreshold instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.panicThreshold = a.streaming.liveSyncPanicThreshold, delete a.streaming.liveSyncPanicThreshold);
            if (a.mediaSource && "sourceBufferExtraFeatures" in a.mediaSource) {
                md("mediaSource.sourceBufferExtraFeatures configuration", "Please Use mediaSource.addExtraFeaturesToSourceBuffer() instead.");
                var f = a.mediaSource.sourceBufferExtraFeatures;
                a.mediaSource.addExtraFeaturesToSourceBuffer = function() {
                    return f;
                };
                delete a.mediaSource.sourceBufferExtraFeatures;
            }
            a.manifest && a.manifest.hls && "useSafariBehaviorForLive" in a.manifest.hls && (md("manifest.hls.useSafariBehaviorForLive configuration", "Please Use liveSync config to keep on live Edge instead."), delete a.manifest.hls.useSafariBehaviorForLive);
            a.streaming && "parsePrftBox" in a.streaming && (md("streaming.parsePrftBox configuration", "Now fired without needing a configuration."), delete a.streaming.parsePrftBox);
            a.manifest && a.manifest.dash && "enableAudioGroups" in a.manifest.dash && (md("manifest.dash.enableAudioGroups configuration", "Please Use manifest.enableAudioGroups instead."), a.manifest.enableAudioGroups = a.manifest.dash.enableAudioGroups, delete a.manifest.dash.enableAudioGroups);
            a.streaming && "dispatchAllEmsgBoxes" in a.streaming && (md("streaming.dispatchAllEmsgBoxes configuration", "Please Use mediaSource.dispatchAllEmsgBoxes instead."), a.mediaSource = a.mediaSource || {}, a.mediaSource.dispatchAllEmsgBoxes = a.streaming.dispatchAllEmsgBoxes, delete a.streaming.dispatchAllEmsgBoxes);
            a.streaming && "autoLowLatencyMode" in a.streaming && (md("streaming.autoLowLatencyMode configuration", "Please Use streaming.lowLatencyMode instead."), a.streaming.lowLatencyMode = a.streaming.autoLowLatencyMode, delete a.streaming.autoLowLatencyMode);
            a.manifest && a.manifest.dash && "ignoreSupplementalCodecs" in a.manifest.dash && (md("manifest.dash.ignoreSupplementalCodecs configuration", "Please Use manifest.ignoreSupplementalCodecs instead."), a.manifest.ignoreSupplementalCodecs = a.manifest.dash.ignoreSupplementalCodecs, delete a.manifest.dash.ignoreSupplementalCodecs);
            a.manifest && a.manifest.hls && "ignoreSupplementalCodecs" in a.manifest.hls && (md("manifest.hls.ignoreSupplementalCodecs configuration", "Please Use manifest.ignoreSupplementalCodecs instead."), a.manifest.ignoreSupplementalCodecs = a.manifest.hls.ignoreSupplementalCodecs, delete a.manifest.hls.ignoreSupplementalCodecs);
            a.manifest && a.manifest.dash && "updatePeriod" in a.manifest.dash && (md("manifest.dash.updatePeriod configuration", "Please Use manifest.updatePeriod instead."), a.manifest.updatePeriod = a.manifest.dash.updatePeriod, delete a.manifest.dash.updatePeriod);
            a.manifest && a.manifest.hls && "updatePeriod" in a.manifest.hls && (md("manifest.hls.updatePeriod configuration", "Please Use manifest.updatePeriod instead."), a.manifest.updatePeriod = a.manifest.hls.updatePeriod, delete a.manifest.hls.updatePeriod);
            a.manifest && a.manifest.dash && "ignoreDrmInfo" in a.manifest.dash && (md("manifest.dash.ignoreDrmInfo configuration", "Please Use manifest.ignoreDrmInfo instead."), a.manifest.ignoreDrmInfo = a.manifest.dash.ignoreDrmInfo, delete a.manifest.dash.ignoreDrmInfo);
            if (a.drm && a.drm.advanced) {
                d = !1;
                for(var g in a.drm.advanced){
                    var h = a.drm.advanced[g];
                    e = h.videoRobustness;
                    h = h.audioRobustness;
                    "videoRobustness" in a.drm.advanced[g] && !Array.isArray(a.drm.advanced[g].videoRobustness) && (a.drm.advanced[g].videoRobustness = [
                        e
                    ], d = !0);
                    "audioRobustness" in a.drm.advanced[g] && !Array.isArray(a.drm.advanced[g].audioRobustness) && (a.drm.advanced[g].audioRobustness = [
                        h
                    ], d = !0);
                }
                d && md("AdvancedDrmConfiguration's videoRobustness and audioRobustness", "These properties are no longer strings but array of strings, please update your usage of these properties.");
            }
            a.streaming && "forceHTTP" in a.streaming && (md("streaming.forceHTTP configuration", "Please Use networking.forceHTTP instead."), a.networking = a.networking || {}, a.networking.forceHTTP = a.streaming.forceHTTP, delete a.streaming.forceHTTP);
            a.streaming && "forceHTTPS" in a.streaming && (md("streaming.forceHTTPS configuration", "Please Use networking.forceHTTP instead."), a.networking = a.networking || {}, a.networking.forceHTTPS = a.streaming.forceHTTPS, delete a.streaming.forceHTTPS);
            a.streaming && "minBytesForProgressEvents" in a.streaming && (md("streaming.minBytesForProgressEvents configuration", "Please Use networking.minBytesForProgressEvents instead."), a.networking = a.networking || {}, a.networking.minBytesForProgressEvents = a.streaming.minBytesForProgressEvents, delete a.streaming.minBytesForProgressEvents);
            g = Eo(this.g, a, qr(this));
            Gs(this, c);
            return g;
        };
        p.zk = function(a) {
            this.Dg = a;
        };
        function Gs(a, b) {
            a.Re = new Li(a.g, a.ua, a.F);
            if (a.I) {
                var c = Xd(a.g.manifest);
                a.h && a.h.nodeName === "AUDIO" && (c.disableVideo = !0);
                a.I.configure(c);
            }
            a.F && a.F.configure(a.g.drm);
            if (a.l) {
                a.l.configure(a.g.streaming);
                try {
                    a.m != zr && Ni(a.Re, a.i) && es(a);
                } catch (e) {
                    Gr(a, e);
                }
                a.o && is(a);
                c = a.l.o;
                !c || c.allowedByApplication && c.allowedByKeySystem || vr(a);
            }
            a.M && a.M.configure(a.g.networking);
            a.H && (a.H.configure(a.g.mediaSource), a.H.Ga = a.g.manifest.segmentRelativeVttTiming);
            a.A && Yr(a);
            a.o && (a.o.configure(a.g.abr), a.g.abr.enabled ? a.o.enable() : a.o.disable(), us(a));
            a.P && Fs(a);
            a.Ia && (a.g.streaming.rebufferingGoal ? a.Ia.xa(.25) : a.Ia.stop());
            a.i && js(a.i.presentationTimeline, a.g.playRangeStart, a.g.playRangeEnd);
            a.D && a.D.configure(a.g.ads);
            a.K && a.K.configure(a.g.cmcd);
            a.na && a.na.configure(a.g.cmsd);
            a.va && a.va.configure(a.g.queue);
            if (a.m == ms && a.J.getConfiguration) {
                c = a.J.getConfiguration();
                var d = !1;
                b.preferredVideoHdrLevel != a.g.preferredVideoHdrLevel && c.hdrLevel != a.g.preferredVideoHdrLevel && (c.hdrLevel = a.g.preferredVideoHdrLevel, d = !0);
                b.preferredVideoLayout != a.g.preferredVideoLayout && c.videoLayout != a.g.preferredVideoLayout && (c.videoLayout = a.g.preferredVideoLayout, d = !0);
                b.preferSpatialAudio != a.g.preferSpatialAudio && c.spatialAudio != a.g.preferSpatialAudio && (c.spatialAudio = a.g.preferSpatialAudio, d = !0);
                b.preferredVideoRole != a.g.preferredVideoRole && c.videoRole != a.g.preferredVideoRole && (c.videoRole = a.g.preferredVideoRole, d = !0);
                d && (a.J.configure(c), vr(a));
            }
        }
        p.getConfiguration = function() {
            var a = qr(this);
            Eo(a, this.g, qr(this));
            return a;
        };
        p.Lk = function() {
            return this.Dg;
        };
        p.bj = function() {
            var a = qr(this);
            Eo(a, this.g, qr(this));
            return fo(this.g, qr(this));
        };
        p.Zi = function() {
            if (this.h) {
                var a = this.h.buffered.length;
                a = a ? this.h.buffered.end(a - 1) : 0;
                var b = Math.min(this.h.currentTime + this.g.streaming.bufferingGoal, this.wa().end);
                if (a >= b) return 1;
                if (!(a <= this.h.currentTime) && a < b) return (a - this.h.currentTime) / (b - this.h.currentTime);
            }
            return 0;
        };
        p.Dj = function() {
            var a = this.getConfiguration(), b;
            for(b in this.g)delete this.g[b];
            Eo(this.g, qr(this), qr(this));
            Gs(this, a);
        };
        p.xc = function() {
            return this.m;
        };
        p.uh = function() {
            return this.i ? this.i.type : null;
        };
        p.vf = function() {
            return this.h;
        };
        p.Qb = function() {
            return this.M;
        };
        p.dd = function() {
            return this.V;
        };
        p.tf = function() {
            return this.D ? this.D : null;
        };
        p.wf = function() {
            return this.va ? this.va : null;
        };
        p.U = function() {
            return this.i && !this.Da() ? this.i.presentationTimeline.U() : this.h && (this.h.src || this.Da()) ? this.h.duration == Infinity : !1;
        };
        p.fd = function() {
            return this.i ? this.i.presentationTimeline.fd() : !1;
        };
        p.Hd = function() {
            if (this.i && !this.Da()) {
                var a = this.i.variants;
                return a.length ? !a[0].video : !1;
            }
            return this.h && (this.h.src || this.Da()) ? this.h.videoTracks ? this.h.videoTracks.length == 0 : this.h.videoHeight == 0 : !1;
        };
        p.Hf = function() {
            if (this.i && !this.Da()) {
                var a = this.i.variants;
                if (!a.length) return !1;
                a = a[0];
                return a.audio || !a.video ? !1 : !a.video.codecs.includes(",");
            }
            return this.h && (this.h.src || this.Da()) && this.h.audioTracks ? this.h.audioTracks.length == 0 : !1;
        };
        p.wa = function() {
            if (this.i && !this.Da()) {
                if (!this.Oa && this.i.type == "HLS") return {
                    start: 0,
                    end: 0
                };
                var a = this.i.presentationTimeline;
                return {
                    start: a.cc(),
                    end: a.Gb()
                };
            }
            if (this.h && (this.h.src || this.Da()) && (a = this.h.seekable) && a.length) {
                var b = this.g ? this.g.playRangeStart : 0;
                b = Math.max(a.start(0), b);
                var c = this.g ? this.g.playRangeEnd : Infinity;
                a = Math.min(a.end(a.length - 1), c);
                return {
                    start: b,
                    end: a
                };
            }
            return {
                start: 0,
                end: 0
            };
        };
        p.Bl = function() {
            this.U() && (this.h.currentTime = this.wa().end);
        };
        p.Gh = function() {
            return this.Oa;
        };
        p.keySystem = function() {
            var a = this.drmInfo();
            return a ? a.keySystem : "";
        };
        p.drmInfo = function() {
            return this.F ? this.F.g : null;
        };
        p.oe = function() {
            return this.F ? this.F.oe() : Infinity;
        };
        p.oh = function() {
            return this.F ? this.F.oh() : [];
        };
        p.uf = function() {
            return this.F ? this.F.uf() : {};
        };
        p.Df = function() {
            return this.P ? this.P.g == Ji : !!this.V;
        };
        p.Wa = function() {
            return this.h ? this.L ? this.L.h : 1 : 0;
        };
        p.Ci = function(a) {
            this.m == ms && this.l && wn(this.l, a);
        };
        p.sc = function(a, b) {
            b = b === void 0 ? !0 : b;
            if (a == 0) Za("A trick play rate of 0 is unsupported!");
            else {
                var c = this.h.playbackRate, d = this.L.h;
                this.L.set(a);
                this.m == ms && (this.o.playbackRateChanged(a), this.Ci(b && a != 1));
                Hs(this, a);
                c === 0 && this.h.playbackRate === 0 && a != d && cs(this);
            }
        };
        p.ud = function() {
            var a = this.L.Cd();
            this.m == fs && this.L.set(a);
            this.m == ms && (this.L.set(a), this.o.playbackRateChanged(a), this.Ci(!1));
            this.jc.Ta();
        };
        p.Ib = function() {
            if (this.i && !this.Da()) {
                for(var a = this.l ? this.l.o : null, b = [], c = 0, d = u(this.i.variants), e = d.next(); !e.done; e = d.next())if (e = e.value, Eg(e)) {
                    var f = wg(e);
                    f.active = e == a;
                    f.active || c == 1 || a == null || e.video != a.video || e.audio != a.audio || (f.active = !0);
                    f.active && c++;
                    b.push(f);
                }
                return b;
            }
            if (this.h && this.h.audioTracks) {
                var g = Is(this);
                a = Array.from(this.h.audioTracks);
                return a.length ? a.map(function(h) {
                    return Dg(h, g);
                }) : g ? [
                    Dg(null, g)
                ] : [];
            }
            return [];
        };
        p.yc = function() {
            if (this.i) {
                if (this.Da()) return [];
                for(var a = this.l ? this.l.C : null, b = [], c = u(this.i.textStreams), d = c.next(); !d.done; d = c.next()){
                    d = d.value;
                    var e = xg(d);
                    e.active = d == a;
                    b.push(e);
                }
                return b;
            }
            return this.h && this.h.src && this.h.textTracks ? ys(this).map(function(f) {
                return Cg(f);
            }) : [];
        };
        p.rh = function() {
            var a = this.Xe;
            this.i && (a = this.i.imageStreams);
            return a.map(function(b) {
                return yg(b);
            });
        };
        p.Ck = function(a) {
            var b = this, c, d;
            return H(function(e) {
                if (e.h == 1) return e.g(Js(b, a), 2);
                c = e.i;
                if (!c) return e.return(null);
                d = [];
                c.segmentIndex.xb(function(f) {
                    var g = Ks(f.tilesLayout || c.tilesLayout);
                    if (g) for(var h = g.rows * g.columns, k = (f.j - f.startTime) / h, l = 0; l < h; l++){
                        var m = Ls(f, c, f.startTime + l * k, g);
                        if (!m) break;
                        d.push(m);
                    }
                });
                return e.return(d);
            });
        };
        function Ks(a) {
            return a ? (a = /(\d+)x(\d+)/.exec(a)) ? {
                columns: parseInt(a[1], 10),
                rows: parseInt(a[2], 10)
            } : null : null;
        }
        p.dj = function(a, b) {
            var c = this, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) return h.g(Js(c, a), 2);
                d = h.i;
                if (!d) return h.return(null);
                e = d.segmentIndex.find(b);
                if (e == null) return h.return(null);
                f = d.segmentIndex.get(e);
                return (g = Ks(f.tilesLayout || d.tilesLayout)) ? h.return(Ls(f, d, b, g)) : h.return(null);
            });
        };
        function Js(a, b) {
            var c, d, e;
            return H(function(f) {
                if (f.h == 1) {
                    if (a.m != ms && a.m != fs) return f.return(null);
                    c = a.Xe;
                    a.i && (c = a.i.imageStreams);
                    d = c[0];
                    if (!d) return f.return(null);
                    b != null && (d = c.find(function(g) {
                        return g.id == b;
                    }));
                    return d ? d.segmentIndex ? f.B(2) : f.g(d.createSegmentIndex(), 2) : f.return(null);
                }
                d.closeSegmentIndex && (a.Fc.has(d) || (e = new Uf(function() {
                    d && (d.closeSegmentIndex(), a.Fc.delete(d));
                }), a.Fc.set(d, e)), a.Fc.get(d).Z(5));
                return f.return(d);
            });
        }
        function Ls(a, b, c, d) {
            var e = b.width || 0, f = b.height || 0, g = e / d.columns, h = f / d.rows, k = d.columns * d.rows, l = a.j - a.startTime;
            l = a.C || l / k;
            var m = a.startTime, n = 0, q = 0;
            k > 1 && (q = Math.floor((c - a.startTime) / l + 1E-4), m = a.startTime + q * l, n = q % d.columns * g, q = Math.floor(q / d.columns) * h);
            if (m >= a.endTime || rk(m, a.endTime, 1E-4)) return null;
            d = !1;
            if (c = a.thumbnailSprite) d = !0, h = c.height, n = c.positionX, q = c.positionY, g = c.width;
            return {
                segment: a,
                imageHeight: f,
                imageWidth: e,
                height: h,
                positionX: n,
                positionY: q,
                startTime: m,
                duration: l,
                uris: a.T(),
                startByte: a.Qc(),
                endByte: a.Oc(),
                width: g,
                sprite: d,
                mimeType: a.mimeType || b.mimeType,
                codecs: a.codecs || b.codecs
            };
        }
        p.gg = function(a) {
            function b() {
                var d = c.i.textStreams.find(function(e) {
                    return e.id == a.id;
                });
                d && d != c.l.C && (Jo(c.C.h, d, !1), zn(c.l, d), ds(c), ts(c), c.Zd = d.language);
            }
            var c = this;
            if (this.i && this.G && (b(), !this.Da())) return;
            (function() {
                if (c.h && c.h.textTracks) {
                    var d = ys(c), e = d.find(function(h) {
                        return zg(h) === a.id;
                    });
                    if (e) {
                        if (c.A instanceof Cp) {
                            d = u(d);
                            for(var f = d.next(); !f.done; f = d.next()){
                                f = f.value;
                                var g = f === e ? c.W ? "showing" : "hidden" : "disabled";
                                f.mode !== g && (f.mode = g);
                            }
                        } else d = d.find(function(h) {
                            return h.mode !== "disabled";
                        }), d !== e && (d && (d.mode = "disabled", c.j.Fa(d, "cuechange"), c.A.remove(0, Infinity)), e && Bs(c, e));
                        ds(c);
                        ts(c);
                    }
                }
            })();
        };
        function Bs(a, b) {
            a.j.u(b, "cuechange", function() {
                a.A.remove(0, Math.max(0, a.h.currentTime - a.g.streaming.bufferBehind));
                var c = {
                    periodStart: 0,
                    segmentStart: 0,
                    segmentEnd: a.h.duration,
                    vttOffset: 0
                }, d = [], e = Array.from(b.activeCues || []);
                e = u(e);
                for(var f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    if (f.endTime === Infinity || f.endTime < f.startTime) f = null;
                    else {
                        var g = new Ie(f.startTime, f.endTime, f.text);
                        g.line = typeof f.line === "number" ? f.line : null;
                        f.lineAlign && (g.lineAlign = f.lineAlign);
                        g.lineInterpretation = f.snapToLines ? Ne : 1;
                        g.position = typeof f.position === "number" ? f.position : null;
                        f.positionAlign && (g.positionAlign = f.positionAlign);
                        g.size = f.size;
                        g.textAlign = f.align;
                        f.vertical === "lr" ? g.writingMode = "vertical-lr" : f.vertical === "rl" && (g.writingMode = "vertical-rl");
                        f.region && (g.region.id = f.region.id, g.region.height = f.region.lines, g.region.heightUnits = 2, g.region.regionAnchorX = f.region.regionAnchorX, g.region.regionAnchorY = f.region.regionAnchorY, g.region.scroll = f.region.scroll, g.region.viewportAnchorX = f.region.viewportAnchorX, g.region.viewportAnchorY = f.region.viewportAnchorY, g.region.viewportAnchorUnits = Nd, g.region.width = f.region.width, g.region.widthUnits = Nd);
                        We(g);
                        f = g;
                    }
                    f && ((g = a.g.mediaSource.modifyCueCallback) && g(f, null, c), d.push(f));
                }
                a.A.append(d);
            });
            b.mode = document.pictureInPictureElement ? "showing" : "hidden";
        }
        p.Ge = function(a, b, c) {
            function d() {
                var f = e.i.variants.find(function(h) {
                    return h.id == a.id;
                });
                if (f && Eg(f)) {
                    var g = e.l.o;
                    e.g.abr.enabled && (g.video != f.video || g.audio && f.audio && g.audio.language == f.audio.language && g.audio.channelsCount == f.audio.channelsCount && g.audio.label == f.audio.label) && Za("Changing tracks while abr manager is enabled will likely result in the selected track being overridden. Consider disabling abr before calling selectVariantTrack().");
                    e.Da() ? ks(e, f, !1, !1, 0) : ks(e, f, !1, b || !1, c || 0);
                    e.J.configure({
                        language: f.language,
                        role: f.audio && f.audio.roles && f.audio.roles[0] || "",
                        videoRole: f.video && f.video.roles && f.video.roles[0] || "",
                        channelCount: f.audio && f.audio.channelsCount ? f.audio.channelsCount : 0,
                        hdrLevel: f.video && f.video.hdr ? f.video.hdr : "",
                        spatialAudio: f.audio && f.audio.spatialAudio ? f.audio.spatialAudio : !1,
                        videoLayout: f.video && f.video.videoLayout ? f.video.videoLayout : "",
                        audioLabel: f.audio && f.audio.label ? f.audio.label : "",
                        videoLabel: f.video && f.video.label ? f.video.label : "",
                        codecSwitchingStrategy: e.g.mediaSource.codecSwitchingStrategy,
                        audioCodec: f.audio && f.audio.codecs ? f.audio.codecs : "",
                        activeAudioCodec: g.audio && g.audio.codecs ? g.audio.codecs : "",
                        activeAudioChannelCount: g.audio && g.audio.channelsCount ? g.audio.channelsCount : 0,
                        preferredAudioCodecs: e.g.preferredAudioCodecs,
                        preferredAudioChannelCount: e.g.preferredAudioChannelCount
                    });
                    is(e);
                }
            }
            var e = this;
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? 0 : c;
            if (this.i && this.G && (d(), !this.Da())) return;
            (function() {
                if (a.originalAudioId && e.h && e.h.audioTracks) {
                    var f = Array.from(e.h.audioTracks);
                    f = u(f);
                    for(var g = f.next(); !g.done; g = f.next())if (g = g.value, zg(g) == a.id) {
                        Ms(e, g);
                        break;
                    }
                }
            })();
        };
        p.Jj = function(a, b) {
            function c() {
                var e = d.J.getConfiguration();
                e.audioCodec = a.codecs || "";
                e.audioLabel = a.label || "";
                e.channelCount = a.channelsCount || 0;
                e.language = a.language;
                e.role = a.roles[0] || "";
                e.spatialAudio = a.spatialAudio;
                var f = d.l.o;
                if (f = f && f.audio) e.activeAudioCodec = f.codecs || "", e.activeAudioChannelCount = f.channelsCount || 0;
                d.J.configure(e);
                vr(d, !0, b, !1, !1);
            }
            var d = this;
            b = b === void 0 ? 0 : b;
            if (this.i && this.G && (c(), !this.Da())) return;
            (function() {
                if (d.h && d.h.audioTracks) {
                    var e = Kc(a.language), f = Array.from(d.h.audioTracks), g = null;
                    f = u(f);
                    for(var h = f.next(); !h.done; h = f.next()){
                        h = h.value;
                        var k = h.language || "und";
                        if (h.label == a.label && Kc(k) == e && h.kind == a.roles[0]) {
                            g = h;
                            break;
                        }
                    }
                    g && Ms(d, g);
                }
            })();
        };
        p.getAudioTracks = function() {
            if (this.i && !this.Da()) {
                var a = this.Ib();
                if (!a.length) return [];
                var b = a.find(function(f) {
                    return f.active;
                });
                if (!b) return [];
                var c = a;
                this.m != ms || this.Da() || (c = a.filter(function(f) {
                    return f.originalVideoId === b.originalVideoId && (f.audioCodec || yf.includes(f.audioMimeType || ""));
                }));
                if (!c.length) return [];
                a = new Map;
                c = u(c);
                for(var d = c.next(); !d.done; d = c.next()){
                    var e = d.value;
                    d = [
                        e.language,
                        e.originalLanguage,
                        e.label || "",
                        (e.audioRoles || []).join(","),
                        e.channelsCount,
                        e.spatialAudio,
                        e.audioCodec || "",
                        e.accessibilityPurpose || ""
                    ].join("_");
                    e = {
                        active: e.active,
                        language: e.language,
                        label: e.label,
                        mimeType: e.audioMimeType,
                        codecs: e.audioCodec,
                        primary: e.primary,
                        roles: e.audioRoles || [],
                        accessibilityPurpose: e.accessibilityPurpose,
                        channelsCount: e.channelsCount,
                        audioSamplingRate: e.audioSamplingRate,
                        spatialAudio: e.spatialAudio,
                        originalLanguage: e.originalLanguage
                    };
                    a.has(d) ? !a.get(d).active && e.active && a.set(d, e) : a.set(d, e);
                }
                return Array.from(a.values());
            }
            return this.h && this.h.audioTracks ? Array.from(this.h.audioTracks).map(function(f) {
                var g = f.language;
                g = {
                    active: f.enabled,
                    language: Kc(g || "und"),
                    label: f.label,
                    mimeType: null,
                    codecs: null,
                    primary: f.kind == "main",
                    roles: [],
                    accessibilityPurpose: null,
                    channelsCount: null,
                    audioSamplingRate: null,
                    spatialAudio: !1,
                    originalLanguage: g
                };
                f.kind && (f.kind == "description" && (g.accessibilityPurpose = "visually impaired"), g.roles.push(f.kind));
                f.configuration && (f.configuration.codec && (g.codecs = f.configuration.codec), f.configuration.sampleRate && (g.audioSamplingRate = f.configuration.sampleRate), f.configuration.numberOfChannels && (g.channelsCount = f.configuration.numberOfChannels));
                return g;
            }) : [];
        };
        p.Kj = function(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? 0 : c;
            var d = this.Ib();
            if (d.length) {
                var e = d.find(function(g) {
                    return g.active;
                });
                if (e) {
                    d = d.filter(function(g) {
                        return (g.videoBandwidth || g.bandwidth) == a.bandwidth && g.width == a.width && g.height == a.height && g.frameRate == a.frameRate && g.pixelAspectRatio == a.pixelAspectRatio && g.hdr == a.hdr && g.colorGamut == a.colorGamut && g.videoLayout == a.videoLayout && g.videoMimeType == a.mimeType && g.videoCodec == a.codecs && ed(g.videoRoles, a.roles) && g.videoLabel == a.label;
                    });
                    var f;
                    d.length == 1 ? f = d[0] : f = d.find(function(g) {
                        return g.audioId === e.audioId;
                    });
                    f || (f = d.find(function(g) {
                        return g.language == e.language && g.label === e.label && g.channelsCount === e.channelsCount && g.spatialAudio === e.spatialAudio && g.audioMimeType === e.audioMimeType && Cf(g.audioCodec || "") === Cf(e.audioCodec || "") && ed(g.audioRoles, e.audioRoles);
                    }));
                    f && !f.active && this.Ge(f, b, c);
                }
            }
        };
        p.getVideoTracks = function() {
            if (this.m == fs || this.Da()) return [];
            var a = this.Ib();
            if (!a.length) return [];
            var b = a.find(function(f) {
                return f.active;
            });
            if (!b) return [];
            var c = a;
            this.Hf() || (c = a.filter(function(f) {
                return f.videoCodec && f.audioGroupId === b.audioGroupId && f.originalAudioId === b.originalAudioId ? f.audioId === b.audioId ? !0 : f.language === b.language && f.label === b.label && f.channelsCount === b.channelsCount && f.spatialAudio === b.spatialAudio && f.audioMimeType === b.audioMimeType && Cf(f.audioCodec || "") === Cf(b.audioCodec || "") && ed(f.audioRoles, b.audioRoles) : !1;
            }));
            if (!c.length) return [];
            a = new Map;
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next()){
                d = d.value;
                var e = d.originalVideoId;
                e || d.videoId == null || (e = String(d.videoId));
                e && a.set(e, {
                    active: d.active,
                    bandwidth: d.videoBandwidth || d.bandwidth,
                    width: d.width,
                    height: d.height,
                    frameRate: d.frameRate,
                    pixelAspectRatio: d.pixelAspectRatio,
                    hdr: d.hdr,
                    colorGamut: d.colorGamut,
                    videoLayout: d.videoLayout,
                    mimeType: d.videoMimeType,
                    codecs: d.videoCodec,
                    roles: d.videoRoles || [],
                    label: d.videoLabel
                });
            }
            return Array.from(a.values());
        };
        p.Ek = function() {
            return Ns(this.Ib());
        };
        p.ql = function() {
            return Ns(this.yc());
        };
        p.Dk = function() {
            return Array.from(Os(this.Ib()));
        };
        p.ol = function() {
            return Array.from(Os(this.yc()));
        };
        p.Ij = function(a, b, c, d, e, f, g) {
            function h() {
                function l(t, v) {
                    return t.video || v.video ? t.video && v.video ? Math.abs((t.video.height || 0) - (v.video.height || 0)) + Math.abs((t.video.width || 0) - (v.video.width || 0)) : Infinity : 0;
                }
                var m = k.l.o;
                k.J = k.g.adaptationSetCriteriaFactory();
                k.J.configure({
                    language: a,
                    role: b || "",
                    videoRole: m.video && m.video.roles && m.video.roles[0] || "",
                    channelCount: c || 0,
                    hdrLevel: "",
                    spatialAudio: f || !1,
                    videoLayout: "",
                    audioLabel: g || "",
                    videoLabel: "",
                    codecSwitchingStrategy: k.g.mediaSource.codecSwitchingStrategy,
                    audioCodec: e || "",
                    activeAudioCodec: m.audio && m.audio.codecs ? m.audio.codecs : "",
                    activeAudioChannelCount: m.audio && m.audio.channelsCount ? m.audio.channelsCount : 0,
                    preferredAudioCodecs: k.g.preferredAudioCodecs,
                    preferredAudioChannelCount: k.g.preferredAudioChannelCount
                });
                var n = k.J.create(k.i.variants), q = null;
                n = u(n.values());
                for(var r = n.next(); !r.done; r = n.next())r = r.value, Eg(r) && (!q || l(q, m) > l(r, m)) && (q = r);
                q != m && (q ? (m = wg(q), k.Ge(m, !0, d || 0)) : vr(k));
            }
            var k = this;
            c = c === void 0 ? 0 : c;
            d = d === void 0 ? 0 : d;
            e = e === void 0 ? "" : e;
            f = f === void 0 ? !1 : f;
            g = g === void 0 ? "" : g;
            if (this.i && this.G && (h(), !this.Da())) return;
            (function() {
                if (k.h && k.h.audioTracks) {
                    var l = Gg(k.Ib(), a, b || "", !1)[0];
                    l && k.Ge(l);
                }
            })();
        };
        p.ei = function(a, b, c) {
            function d() {
                e.Zd = a;
                e.ce = b || "";
                e.be = c || !1;
                var f = Gg(e.i.textStreams, e.Zd, e.ce, e.be)[0] || null;
                f && f != e.l.C && (Jo(e.C.h, f, !1), e.g.streaming.alwaysStreamText || e.Tc()) && (zn(e.l, f), ds(e), ts(e));
            }
            var e = this;
            c = c === void 0 ? !1 : c;
            if (this.i && this.G && (d(), !this.Da())) return;
            (function() {
                var f = Gg(e.yc(), a, b || "", c || !1)[0];
                f && e.gg(f);
            })();
        };
        p.sm = function(a, b, c) {
            function d() {
                for(var f = null, g = u(e.i.variants), h = g.next(); !h.done; h = g.next())if (h = h.value, h.audio.label == a) {
                    f = h;
                    break;
                }
                f != null && (e.J = e.g.adaptationSetCriteriaFactory(), e.J.configure({
                    language: f.language,
                    role: "",
                    videoRole: "",
                    channelCount: 0,
                    hdrLevel: "",
                    spatialAudio: !1,
                    videoLayout: "",
                    videoLabel: "",
                    audioLabel: a,
                    codecSwitchingStrategy: e.g.mediaSource.codecSwitchingStrategy,
                    audioCodec: "",
                    activeAudioCodec: "",
                    activeAudioChannelCount: 0,
                    preferredAudioCodecs: e.g.preferredAudioCodecs,
                    preferredAudioChannelCount: e.g.preferredAudioChannelCount
                }), vr(e, b, c));
            }
            var e = this;
            b = b === void 0 ? !0 : b;
            c = c === void 0 ? 0 : c;
            if (this.i && this.G && (d(), !this.Da())) return;
            (function() {
                if (e.h && e.h.audioTracks) {
                    var f = Array.from(e.h.audioTracks), g = null;
                    f = u(f);
                    for(var h = f.next(); !h.done; h = f.next())h = h.value, h.label == a && (g = h);
                    g && Ms(e, g);
                }
            })();
        };
        p.Tc = function() {
            var a = this.W;
            return this.A ? this.A.isTextVisible() : a;
        };
        p.Ik = function() {
            return this.kb.map(function(a) {
                return xg(a);
            });
        };
        p.Hk = function(a) {
            md("getChapters", "Please use an getChaptersAsync.");
            if (!this.kb.length) return [];
            var b = Kc(a);
            a = this.kb.filter(function(f) {
                return Kc(f.language) == b;
            });
            if (!a.length) return [];
            var c = [], d = new Set;
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next())e = e.value, e.segmentIndex && e.segmentIndex.xb(function(f) {
                var g = f.T()[0], h = f.startTime + "-" + f.endTime + "-" + g;
                f = {
                    id: h,
                    title: g,
                    startTime: f.startTime,
                    endTime: f.endTime
                };
                d.has(h) || (c.push(f), d.add(h));
            });
            return c;
        };
        p.ph = function(a) {
            var b = this, c, d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        if (!b.kb.length) return l.return([]);
                        c = Kc(a);
                        d = b.kb.filter(function(m) {
                            return Kc(m.language) == c;
                        });
                        if (!d.length) return l.return([]);
                        e = [];
                        f = new Set;
                        g = u(d);
                        h = g.next();
                    case 2:
                        if (h.done) {
                            l.B(4);
                            break;
                        }
                        k = h.value;
                        if (k.segmentIndex) {
                            l.B(5);
                            break;
                        }
                        return l.g(k.createSegmentIndex(), 5);
                    case 5:
                        k.segmentIndex.xb(function(m) {
                            var n = m.T()[0], q = m.startTime + "-" + m.endTime + "-" + n;
                            m = {
                                id: q,
                                title: n,
                                startTime: m.startTime,
                                endTime: m.endTime
                            };
                            f.has(q) || (e.push(m), f.add(q));
                        });
                        h = g.next();
                        l.B(2);
                        break;
                    case 4:
                        return l.return(e);
                }
            });
        };
        function ys(a) {
            return Array.from(a.h.textTracks).filter(function(b) {
                return b.kind != "metadata" && b.kind != "chapters" && b.label != "Shaka Player TextTrack";
            });
        }
        function zs(a) {
            return Array.from(a.h.textTracks).find(function(b) {
                return b.label == "Shaka Player TextTrack";
            });
        }
        function Ds(a) {
            return Array.from(a.h.textTracks).filter(function(b) {
                return b.kind == "metadata";
            });
        }
        p.Xd = function(a) {
            a = !!a;
            this.W != a && (this.W = a, this.m == ms ? (this.A.setTextVisibility(a), this.g.streaming.alwaysStreamText || (a ? this.l.C || (a = Gg(this.i.textStreams, this.Zd, this.ce, this.be), a.length > 0 && (zn(this.l, a[0]), ds(this), ts(this))) : vn(this.l))) : this.h && this.h.src && this.h.textTracks && this.A.setTextVisibility(a), ss(this));
        };
        p.al = function() {
            if (this.G) var a = this.G.ee();
            else {
                if (this.O == null) return new Date;
                if (this.O instanceof Date) return this.O;
                a = this.O;
            }
            if (this.i && !this.Da()) {
                var b = this.i.presentationTimeline;
                return new Date(((b.m || b.i) + a) * 1E3);
            }
            return this.h && this.h.getStartDate ? (b = this.h.getStartDate(), b instanceof Date && !isNaN(b.getTime()) ? new Date(b.getTime() + a * 1E3) : null) : null;
        };
        p.cj = function() {
            if (this.i && !this.Da()) {
                var a = this.i.presentationTimeline;
                a = a.m || a.i;
                return a === null ? null : new Date(a * 1E3);
            }
            return this.h && this.h.getStartDate ? (a = this.h.getStartDate(), a instanceof Date && !isNaN(a.getTime()) ? a : null) : null;
        };
        p.xf = function() {
            return this.U() ? this.i ? this.i.presentationTimeline.xf() : null : null;
        };
        p.Nc = function() {
            if (this.m == ms) return this.H.Nc();
            var a = {
                total: [],
                audio: [],
                video: [],
                text: []
            };
            this.m == fs && (a.total = Yj(this.h.buffered));
            return a;
        };
        function fr(a) {
            if (!a.h || !a.h.currentTime) return null;
            var b = a.cj();
            return b ? Math.floor(Date.now() - (b.getTime() + a.h.currentTime * 1E3)) : null;
        }
        p.getBandwidthEstimate = function() {
            return this.o ? this.o.getBandwidthEstimate() : NaN;
        };
        p.getStats = function() {
            if (this.m != ms && this.m != fs) return {
                width: NaN,
                height: NaN,
                currentCodecs: "",
                streamBandwidth: NaN,
                decodedFrames: NaN,
                droppedFrames: NaN,
                corruptedFrames: NaN,
                stallsDetected: NaN,
                gapsJumped: NaN,
                estimatedBandwidth: NaN,
                completionPercent: NaN,
                loadLatency: NaN,
                manifestTimeSeconds: NaN,
                drmTimeSeconds: NaN,
                playTime: NaN,
                pauseTime: NaN,
                bufferingTime: NaN,
                licenseTime: NaN,
                liveLatency: NaN,
                maxSegmentDuration: NaN,
                manifestSizeBytes: NaN,
                bytesDownloaded: NaN,
                nonFatalErrorCount: NaN,
                manifestPeriodCount: NaN,
                manifestGapCount: NaN,
                switchHistory: [],
                stateHistory: []
            };
            bs(this);
            var a = this.h, b = a.currentTime / a.duration;
            isNaN(b) || this.U() || No(this.C, Math.round(100 * b));
            this.G && (this.C.R = this.G.Di(), this.C.S = this.G.Fi());
            a.getVideoPlaybackQuality && (b = a.getVideoPlaybackQuality(), Lo(this.C, Number(b.droppedVideoFrames), Number(b.totalVideoFrames)), this.C.M = Number(b.corruptedVideoFrames));
            Oo(this.C, this.F ? qi(this.F) : NaN);
            Mo(this.C, a.videoWidth || NaN, a.videoHeight || NaN);
            this.C.l = "";
            this.U() && (a = fr(this), a != null && Po(this.C, a / 1E3));
            b = this.Ib().find(function(e) {
                return e.active;
            });
            a = this.yc().find(function(e) {
                return e.active;
            });
            if (b) {
                if (b.bandwidth) {
                    var c = this.L ? this.L.h : 1, d = c * b.bandwidth;
                    a && a.bandwidth && (d += c * a.bandwidth);
                    this.C.C = d;
                }
                b.width && b.height && Mo(this.C, b.width || NaN, b.height || NaN);
                b = b.codecs;
                a && (b += "," + (a.codecs || a.mimeType));
                b && (this.C.l = b);
            }
            this.m != ms || this.Da() || (this.i && (this.C.I = this.i.periodCount, this.C.H = this.i.gapCount, this.i.presentationTimeline && Qo(this.C, this.i.presentationTimeline.h)), a = this.o.getBandwidthEstimate(), this.C.A = a);
            this.m == fs && Ro(this.C, NaN);
            return So(this.C);
        };
        p.fe = function(a, b, c, d, e, f, g) {
            g = g === void 0 ? !1 : g;
            var h = this, k, l, m, n, q, r, t, v, w, x, y, z;
            return H(function(A) {
                switch(A.h){
                    case 1:
                        if (h.m != ms && h.m != fs) throw new T(1, 7, 7004);
                        c != "subtitles" && c != "captions" && Za("Using a kind value different of `subtitles` or `captions` can cause unwanted issues.");
                        if (d) {
                            A.B(2);
                            break;
                        }
                        return A.g(Ps(h, a), 3);
                    case 3:
                        d = A.i;
                    case 2:
                        k = [];
                        h.D && (k = h.D.getCuePoints());
                        if (h.m != fs) {
                            A.B(4);
                            break;
                        }
                        l = Xb();
                        g && l.Ma() === "WEBKIT" && (c = "forced");
                        return A.g(Qs(h, a, b, c, d, f || "", k), 5);
                    case 5:
                        m = A.i;
                        if (m.track) return es(h), ds(h), A.return(Cg(m.track));
                        throw new T(1, 2, 2012);
                    case 4:
                        n = Gc;
                        q = h.wa();
                        r = q.end - q.start;
                        h.i && (r = h.i.presentationTimeline.getDuration());
                        if (r == Infinity) throw new T(1, 4, 4033);
                        if (!k.length) {
                            A.B(6);
                            break;
                        }
                        return A.g(Rs(h, a), 7);
                    case 7:
                        t = A.i, v = Ss(h, t, d, k), w = new Blob([
                            v
                        ], {
                            type: "text/vtt"
                        }), a = Vk(w), d = "text/vtt";
                    case 6:
                        x = {
                            id: h.Se++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: xm(0, r, [
                                a
                            ]),
                            mimeType: d || "",
                            codecs: e || "",
                            kind: c,
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: b,
                            originalLanguage: b,
                            label: f || null,
                            type: n.Va,
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !!g,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                wf(d || "", e || "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        };
                        y = wf(x.mimeType, x.codecs);
                        z = Mf(y);
                        if (!z) throw new T(2, 2, 2014, d);
                        h.i.textStreams.push(x);
                        es(h);
                        ds(h);
                        return A.return(xg(x));
                }
            });
        };
        p.cf = function(a, b) {
            var c = this, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A;
            return H(function(E) {
                switch(E.h){
                    case 1:
                        if (c.m != ms && c.m != fs) throw new T(1, 7, 7004);
                        if (b) {
                            E.B(2);
                            break;
                        }
                        return E.g(Ps(c, a), 3);
                    case 3:
                        b = E.i;
                    case 2:
                        if (b != "text/vtt") throw new T(1, 2, 2017, a);
                        d = Gc;
                        e = c.wa();
                        f = e.end - e.start;
                        c.i && (f = c.i.presentationTimeline.getDuration());
                        if (f == Infinity) throw new T(1, 4, 4045);
                        return E.g(Rs(c, a), 4);
                    case 4:
                        g = E.i;
                        h = Lf(b);
                        if (!h) throw new T(2, 2, 2014, b);
                        k = h();
                        l = {
                            periodStart: 0,
                            segmentStart: 0,
                            segmentEnd: f,
                            vttOffset: 0
                        };
                        m = Fb(g);
                        n = k.parseMedia(m, l, a, []);
                        q = [];
                        r = u(n);
                        t = r.next();
                        for(v = {}; !t.done; v = {
                            xg: void 0,
                            xd: void 0
                        }, t = r.next())v.xd = t.value, v.xg = null, w = function(C) {
                            return function() {
                                C.xg == null && (C.xg = vc([
                                    a
                                ], [
                                    C.xd.payload
                                ]));
                                return C.xg || [];
                            };
                        }(v), x = new Oj(v.xd.startTime, v.xd.endTime, w, 0, null, null, 0, 0, Infinity), v.xd.payload.includes("#xywh") && (y = v.xd.payload.split("#xywh=")[1].split(","), y.length === 4 && x.kg({
                            height: parseInt(y[3], 10),
                            positionX: parseInt(y[0], 10),
                            positionY: parseInt(y[1], 10),
                            width: parseInt(y[2], 10)
                        })), q.push(x);
                        z = b;
                        if (!q.length) {
                            E.B(5);
                            break;
                        }
                        return E.g(Ps(c, q[0].T()[0]), 6);
                    case 6:
                        z = E.i;
                    case 5:
                        return A = {
                            id: c.Se++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: new vm(q),
                            mimeType: z || "",
                            codecs: "",
                            kind: "",
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: "und",
                            originalLanguage: null,
                            label: null,
                            type: d.zg,
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !1,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            tilesLayout: "1x1",
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                wf(z || "", "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        }, c.m == fs ? c.Xe.push(A) : c.i.imageStreams.push(A), es(c), E.return(yg(A));
                }
            });
        };
        p.bf = function(a, b, c) {
            var d = this, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y;
            return H(function(z) {
                switch(z.h){
                    case 1:
                        if (d.m != ms && d.m != fs) throw new T(1, 7, 7004);
                        if (c) {
                            z.B(2);
                            break;
                        }
                        return z.g(Ps(d, a), 3);
                    case 3:
                        c = z.i;
                    case 2:
                        e = Gc;
                        f = d.wa();
                        g = f.end - f.start;
                        d.i && (g = d.i.presentationTimeline.getDuration());
                        if (g == Infinity) throw new T(1, 4, 4055);
                        h = Lf(c);
                        if (!h) throw new T(2, 2, 2014, c);
                        return z.g(Rs(d, a), 4);
                    case 4:
                        k = z.i;
                        l = h();
                        m = {
                            periodStart: 0,
                            segmentStart: 0,
                            segmentEnd: g,
                            vttOffset: 0
                        };
                        n = Fb(k);
                        q = l.parseMedia(n, m, a, []);
                        r = [];
                        t = u(q);
                        v = t.next();
                        for(w = {}; !v.done; w = {
                            mf: void 0
                        }, v = t.next())w.mf = v.value, x = new Oj(w.mf.startTime, w.mf.endTime, function(A) {
                            return function() {
                                return [
                                    A.mf.payload
                                ];
                            };
                        }(w), 0, null, null, 0, 0, Infinity), r.push(x);
                        y = {
                            id: d.Se++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: new vm(r),
                            mimeType: "text/plain",
                            codecs: "",
                            kind: "",
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: b,
                            originalLanguage: b,
                            label: null,
                            type: e.Va,
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !1,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                wf("text/plain", "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        };
                        d.kb.push(y);
                        es(d);
                        return z.return(xg(y));
                }
            });
        };
        function Ps(a, b) {
            var c;
            return H(function(d) {
                switch(d.h){
                    case 1:
                        return d.m(2), d.g(fn(b, a.M, a.g.streaming.retryParameters), 4);
                    case 4:
                        c = d.i;
                        d.o(3);
                        break;
                    case 2:
                        d.l();
                    case 3:
                        if (c) return d.return(c);
                        throw new T(1, 2, 2011, b);
                }
            });
        }
        function Qs(a, b, c, d, e, f, g) {
            var h, k, l, m;
            return H(function(n) {
                if (n.h == 1) return e != "text/vtt" || g.length ? n.g(Rs(a, b), 3) : n.B(2);
                n.h != 2 && (h = n.i, k = Ss(a, h, e, g), l = new Blob([
                    k
                ], {
                    type: "text/vtt"
                }), b = Vk(l), e = "text/vtt");
                m = document.createElement("track");
                a: {
                    var q = a.K, r = b;
                    try {
                        if (!q.g.enabled) {
                            var t = r;
                            break a;
                        }
                        var v = dq(q);
                        v.ot = Zq;
                        v.su = !0;
                        var w = hq(v);
                        t = iq(r, w);
                        break a;
                    } catch (x) {
                        $a("CMCD_TEXT_TRACK_ERROR", "Could not generate text track CMCD data.", x);
                        t = r;
                        break a;
                    }
                    t = void 0;
                }
                m.src = t;
                m.label = f;
                m.kind = d;
                m.srclang = c;
                a.h.getAttribute("crossorigin") || a.h.setAttribute("crossorigin", "anonymous");
                a.h.appendChild(m);
                a.Cg.push(m);
                return n.return(m);
            });
        }
        function Rs(a, b) {
            var c, d, e, f;
            return H(function(g) {
                if (g.h == 1) {
                    c = sh;
                    d = a.g.streaming.retryParameters;
                    e = mh([
                        b
                    ], d);
                    e.method = "GET";
                    var h = a.K;
                    try {
                        h.g.enabled && Oq(h, e, {
                            ot: Zq,
                            su: !0
                        });
                    } catch (k) {
                        $a("CMCD_TEXT_ERROR", "Could not generate text CMCD data.", k);
                    }
                    return g.g(a.M.request(c, e).promise, 2);
                }
                f = g.i;
                return g.return(f.data);
            });
        }
        function Ss(a, b, c, d) {
            var e = Lf(c);
            if (e) return c = e(), a = {
                periodStart: 0,
                segmentStart: 0,
                segmentEnd: a.h.duration,
                vttOffset: 0
            }, b = Fb(b), b = c.parseMedia(b, a, null, []), Qp(b, d);
            throw new T(2, 2, 2014, c);
        }
        p.ym = function(a, b) {
            this.ua.width = a;
            this.ua.height = b;
        };
        p.bi = function(a) {
            if (this.m == ms) {
                var b = this.l;
                a = a === void 0 ? .1 : a;
                if (b.l.g) b = !1;
                else if (b.F) b = !1;
                else {
                    for(var c = u(b.h.values()), d = c.next(); !d.done; d = c.next())d = d.value, !d.Fd || d.Ra || d.rb || (d.Fd = !1, un(b, d, a));
                    b = !0;
                }
            } else b = !1;
            return b;
        };
        p.sh = function() {
            Za("Shaka Player's internal Manifest structure is NOT covered by semantic versioning compatibility guarantees.  It may change at any time!  Please consider filing a feature request for whatever you use getManifest() for.");
            return this.i;
        };
        p.Yk = function() {
            return this.Gc;
        };
        p.Rk = function() {
            var a = {
                video: null,
                audio: null,
                text: null
            };
            if (this.m != ms) return a;
            var b = this.l.o, c = this.h.currentTime;
            b = u([
                b.video,
                b.audio,
                this.l.C
            ]);
            for(var d = b.next(); !d.done; d = b.next())if ((d = d.value) && d.segmentIndex) {
                var e = d.segmentIndex.find(c);
                e = d.segmentIndex.get(e);
                e = {
                    codecs: e.codecs || d.codecs,
                    mimeType: e.mimeType || d.mimeType,
                    bandwidth: e.bandwidth || d.bandwidth
                };
                d.type == "video" ? (e.width = d.width, e.height = d.height, a.video = e) : d.type == "audio" ? a.audio = e : d.type == Ec && (a.text = e);
            }
            return a;
        };
        function qr(a) {
            var b = zo();
            b.streaming.failureCallback = function(c) {
                if (a.U()) {
                    var d = null;
                    c.code == 1001 || c.code == 1002 ? (d = 1, a.g.streaming.lowLatencyMode && (d = .1)) : c.code == 1003 && (d = .1);
                    d != null && (c.severity = 1, a.bi(d));
                }
            };
            b.textDisplayFactory = function() {
                if (a.Oe) {
                    var c = a.h;
                    c = c.webkitDisplayingFullscreen || c.webkitPresentationMode && c.webkitPresentationMode != "inline" ? !1 : !0;
                } else c = !1;
                return c ? new Gp(a.h, a.Oe) : "track" in document.createElement("track") ? new Cp(a) : new Fp;
            };
            return b;
        }
        p.mi = function(a) {
            this.Oe = a;
        };
        function Tr(a, b) {
            for(var c = new Set, d = u(b.textStreams), e = d.next(); !e.done; e = d.next())e = e.value, e.mimeType != "application/cea-608" && e.mimeType != "application/cea-708" || c.add(e.originalId);
            d = u(b.variants);
            for(e = d.next(); !e.done; e = d.next())if ((e = e.value.video) && e.closedCaptions) {
                for(var f = u(e.closedCaptions.keys()), g = f.next(); !g.done; g = f.next())if (g = g.value, !c.has(g)) {
                    var h = g.startsWith("CC") ? "application/cea-608" : "application/cea-708", k = new ym, l = e.closedCaptions.get(g);
                    h = {
                        id: a.Se++,
                        originalId: g,
                        groupId: null,
                        createSegmentIndex: function() {
                            return Promise.resolve();
                        },
                        segmentIndex: k,
                        mimeType: h,
                        codecs: "",
                        kind: "caption",
                        encrypted: !1,
                        drmInfos: [],
                        keyIds: new Set,
                        language: l,
                        originalLanguage: l,
                        label: null,
                        type: Ec,
                        primary: !1,
                        trickModeVideo: null,
                        dependencyStream: null,
                        emsgSchemeIdUris: null,
                        roles: e.roles,
                        forced: !1,
                        channelsCount: null,
                        audioSamplingRate: null,
                        spatialAudio: !1,
                        closedCaptions: null,
                        accessibilityPurpose: null,
                        external: !1,
                        fastSwitching: !1,
                        fullMimeTypes: new Set([
                            wf(h, "")
                        ]),
                        isAudioMuxedInVideo: !1,
                        baseOriginalId: null
                    };
                    b.textStreams.push(h);
                    c.add(g);
                }
            }
        }
        function rs(a, b) {
            var c, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) return c = a.audio, d = a.video, e = function(k, l) {
                    var m, n, q;
                    return H(function(r) {
                        if (r.h == 1) return k ? k.segmentIndex ? r.B(2) : r.g(k.createSegmentIndex(), 2) : r.return(null);
                        n = (m = k.segmentIndex.ac(l)) ? m.next().value : null;
                        if (!n) return r.return(null);
                        q = n.startTime;
                        return r.return(q);
                    });
                }, h.g(e(c, b), 2);
                if (h.h != 3) return f = h.i, h.g(e(d, b), 3);
                g = h.i;
                return g != null && f != null ? h.return(Math.max(g, f)) : g != null ? h.return(g) : f != null ? h.return(f) : h.return(b);
            });
        }
        function Ir(a) {
            var b = a.Df();
            if (a.C && a.P && a.G) {
                if (a.g.streaming.rebufferingGoal == 0) {
                    var c = a.L;
                    c.j = !1;
                    Cm(c);
                } else c = a.L, c.j = b, Cm(c);
                a.K && (c = a.K, b || c.F || (c.F = !0), c.F && b && (c.I = !0, bq(c, "ps", {
                    nd: "r"
                })), c.J = b);
                bs(a);
                c = a.g.streaming.liveSync.dynamicTargetLatency.maxAttempts;
                if (a.g.streaming.liveSync.dynamicTargetLatency.enabled && b && a.$e < c) {
                    c = a.g.streaming.liveSync.dynamicTargetLatency.maxLatency;
                    var d = a.g.streaming.liveSync.targetLatencyTolerance, e = a.g.streaming.liveSync.dynamicTargetLatency.rebufferIncrement;
                    a.S && (a.S = Math.min(a.S + ++a.$e * e, c - d));
                }
            }
            b = (new Map).set("buffering", b);
            a.dispatchEvent(yr("buffering", b));
        }
        function cs(a) {
            var b = a.h.playbackRate;
            b == 0 ? (b = a.Wa(), b !== 0 && b !== 1 && (b = yr("ratechange"), a.dispatchEvent(b))) : (a.L && (a.L.set(b), a.m == ms && a.o.playbackRateChanged(b), Hs(a, b)), b = yr("ratechange"), a.dispatchEvent(b));
        }
        function Hs(a, b) {
            a.jc.Ta();
            a.jc.u(a.h, "timeupdate", function() {
                var c = a.h.currentTime, d = a.wa(), e = a.U(), f = e ? a.g.streaming.safeSeekOffset : 0;
                b > 0 ? e && b > 1 && Math.floor(c) >= Math.floor(d.end) && a.ud() : Math.floor(c) <= Math.floor(d.start + f) && a.ud();
            });
        }
        function bs(a) {
            if (a.C && a.P) {
                var b = a.C.g, c = "playing";
                a.P.g == Ji ? c = "buffering" : a.isEnded() ? c = "ended" : a.h.paused && (c = "paused");
                var d = c;
                if (b.g == null) b.g = {
                    timestamp: Date.now() / 1E3,
                    state: d,
                    duration: 0
                }, b = !0;
                else {
                    var e = Date.now() / 1E3;
                    b.g.duration = e - b.g.timestamp;
                    b.g.state == d ? b = !1 : (b.h.push(b.g), b.g = {
                        timestamp: e,
                        state: d,
                        duration: 0
                    }, b = !0);
                }
                b && (c = (new Map).set("newstate", c), a.dispatchEvent(yr("statechanged", c)));
            }
        }
        function vs(a) {
            var b = a.h.playbackRate, c = a.U();
            if (a.g.streaming.vodDynamicPlaybackRate && !c) {
                var d = a.g.streaming.vodDynamicPlaybackRateLowBufferRate, e = a.Zi();
                e <= a.g.streaming.vodDynamicPlaybackRateBufferRatio ? b != d && a.sc(d, !1) : e == 1 && b !== a.L.Cd() && a.ud();
            }
            if (c && (c = a.wa(), Number.isFinite(c.end) && !(a.h.currentTime < c.start || a.h.paused))) {
                d = a.g.streaming.liveSync.targetLatencyTolerance;
                e = a.g.streaming.liveSync.dynamicTargetLatency.enabled;
                var f = a.g.streaming.liveSync.dynamicTargetLatency.stabilityThreshold;
                if (a.g.streaming.liveSync && a.g.streaming.liveSync.enabled) {
                    var g = a.g.streaming.liveSync.targetLatency;
                    var h = g + d;
                    var k = Math.max(0, g - d);
                    var l = a.g.streaming.liveSync.maxPlaybackRate;
                    var m = a.g.streaming.liveSync.minPlaybackRate;
                } else a.i && a.i.serviceDescription && (g = a.i.serviceDescription.targetLatency, a.i.serviceDescription.targetLatency != null ? h = a.i.serviceDescription.targetLatency + d : a.i.serviceDescription.maxLatency != null && (h = a.i.serviceDescription.maxLatency), a.i.serviceDescription.targetLatency != null ? k = Math.max(0, a.i.serviceDescription.targetLatency - d) : a.i.serviceDescription.minLatency != null && (k = a.i.serviceDescription.minLatency), l = a.i.serviceDescription.maxPlaybackRate || a.g.streaming.liveSync.maxPlaybackRate, m = a.i.serviceDescription.minPlaybackRate || a.g.streaming.liveSync.minPlaybackRate);
                a.S || typeof g !== "number" || (a.S = g);
                var n = a.g.streaming.liveSync.dynamicTargetLatency.maxAttempts;
                e && a.hc && a.S !== null && typeof g === "number" && a.$e < n && Date.now() - a.hc > f * 1E3 && (f = a.g.streaming.liveSync.dynamicTargetLatency.minLatency, a.S = Math.max(a.S - (g - f) / 2, f + d), a.hc = Date.now());
                e && a.S !== null && (h = a.S + d, k = a.S - d);
                g = c.end - a.h.currentTime;
                d = 0;
                a.m == fs && (e = a.h.buffered, e.length > 0 && (d = e.end(e.length - 1), d = Math.max(l, d - c.end)));
                c = a.g.streaming.liveSync.panicMode;
                e = a.g.streaming.liveSync.panicThreshold * 1E3;
                f = Date.now() - a.P.i;
                c && !m && (m = a.g.streaming.liveSync.minPlaybackRate);
                c && m && f <= e ? b != m && a.sc(m, !1) : h != void 0 && l && g - d > h ? (b != l && a.sc(l, !1), a.hc = null) : k != void 0 && m && g - d < k ? (b != m && a.sc(m, !1), a.hc = null) : b !== a.L.Cd() && (a.ud(), a.hc = Date.now());
            }
        }
        function Ts(a, b, c) {
            return (rk(b, c, .01) || c > b) && a.Bg < b ? (a.Bg = b, !0) : !1;
        }
        function ws(a) {
            if (a.h) {
                var b = a.wa();
                b = b.end - b.start;
                b = b > 0 ? a.h.currentTime / b : 0;
                if (!isNaN(b)) {
                    b *= 100;
                    if (Ts(a, 0, b)) var c = yr("started");
                    else if (Ts(a, 25, b)) c = yr("firstquartile");
                    else if (Ts(a, 50, b)) c = yr("midpoint");
                    else if (Ts(a, 75, b)) c = yr("thirdquartile");
                    else {
                        if (Ts(a, 100, b) || b > 100) c = yr("complete");
                        a.g && a.g.playRangeEnd != Infinity && a.isEnded() && a.h.pause();
                    }
                    c && a.dispatchEvent(c);
                }
            }
        }
        function is(a) {
            try {
                Qi(a.Re, a.i);
            } catch (c) {
                return Gr(a, c), !1;
            }
            var b = Fg(a.i.variants);
            b = a.J.create(b);
            a = a.o.setVariants(Array.from(b.values()));
            return typeof a == "boolean" ? a : !0;
        }
        function ns(a, b) {
            b = b === void 0 ? !1 : b;
            if (is(a)) {
                if (!a.g.abr.enabled) {
                    var c = a.J;
                    typeof c.getLastAdaptationSet != "function" && (md("AdaptationSetCriteria w/o getLastAdaptationSet", "Please use an AdaptationSetCriteria with getLastAdaptationSet."), c.getLastAdaptationSet = function() {
                        return null;
                    });
                    if (c = c.getLastAdaptationSet()) {
                        if (c = Array.from(c.values()), c.length) {
                            var d = a.l.o;
                            if (d && d.video && (c = c.find(function(e) {
                                return e.video == d.video;
                            }))) return c;
                        }
                    }
                }
                return a.o.chooseVariant(b);
            }
            return null;
        }
        function vr(a, b, c, d, e) {
            b = b === void 0 ? !0 : b;
            c = c === void 0 ? 0 : c;
            d = d === void 0 ? !1 : d;
            e = e === void 0 ? !0 : e;
            var f = ns(a);
            f && ks(a, f, e, b, c, d);
        }
        function ks(a, b, c, d, e, f) {
            f = f === void 0 ? !1 : f;
            var g = a.l.o;
            if (b == g) d && yn(a.l, b, d, e, !0);
            else {
                var h = a.C.h;
                h.h != b && (h.h = b, h.g.push({
                    timestamp: Date.now() / 1E3,
                    id: b.id,
                    type: "variant",
                    fromAdaptation: c,
                    bandwidth: b.bandwidth
                }));
                yn(a.l, b, d, e, f, c);
                d = null;
                g && (d = wg(g));
                g = wg(b);
                g.active = !0;
                if (a.R && (e = a.R, b = b.video)) {
                    b.dependencyStream && (b = b.dependencyStream);
                    f = 0;
                    h = -1;
                    switch(b.mimeType){
                        case "video/webm":
                            f = 1;
                            break;
                        case "video/mp4":
                            f = 2;
                    }
                    switch(a.uh()){
                        case "DASH":
                            h = 1;
                            break;
                        case "HLS":
                            h = 0;
                    }
                    e.g && (e.g.setLevelSwitching(b.id, !0), e.g.setContainerFormat(f), e.j || e.g.setStreamingFormat(h));
                }
                c ? (c = (new Map).set("oldTrack", d).set("newTrack", g), c = yr("adaptation", c), Us(a, c)) : Vs(a, d, g);
                Ws(a, d, g);
            }
        }
        function Ms(a, b) {
            var c = Array.from(a.h.audioTracks).find(function(e) {
                return e.enabled;
            });
            b.enabled = !0;
            if (c) {
                b.id !== c.id && (c.enabled = !1);
                var d = Is(a);
                c = Dg(c, d);
                b = Dg(b, d);
                Vs(a, c, b);
                Ws(a, c, b);
            }
        }
        function Is(a) {
            return a.h && a.h.videoTracks ? Array.from(a.h.videoTracks).find(function(b) {
                return b.selected;
            }) : null;
        }
        function es(a) {
            var b = yr("trackschanged");
            Us(a, b);
            Xs(a);
        }
        function Vs(a, b, c) {
            b = (new Map).set("oldTrack", b).set("newTrack", c);
            b = yr("variantchanged", b);
            Us(a, b);
        }
        function Ws(a, b, c) {
            var d = !1;
            b && b.audioId == c.audioId && b.audioGroupId == c.audioGroupId || (d = !0);
            d && Xs(a);
        }
        function Xs(a) {
            var b = yr("audiotrackschanged");
            Us(a, b);
        }
        function ds(a) {
            var b = yr("textchanged");
            Us(a, b);
        }
        function ss(a) {
            var b = yr("texttrackvisibility");
            Us(a, b);
        }
        function us(a) {
            a.g.abr.enabled || ur(a);
            var b = (new Map).set("newStatus", a.g.abr.enabled);
            Us(a, yr("abrstatuschanged", b));
        }
        function ts(a) {
            var b = a.yc().find(function(c) {
                return c.active;
            });
            b && a.A && a.A.setTextLanguage && a.A.setTextLanguage(b.language);
        }
        function ur(a, b) {
            b = b === void 0 ? !0 : b;
            if (a.m == ms) {
                a.Ue.stop();
                for(var c = u(a.i.variants), d = c.next(); !d.done; d = c.next())d.value.disabledUntilTime = 0;
                b && is(a);
            }
        }
        p.disableStream = function(a, b) {
            if (!this.g.abr.enabled || this.m === zr || !navigator.onLine || b == 0 || !this.i) return !1;
            if (this.i.variants.some(function(h) {
                var k = h[a.type];
                return k && k.id !== a.id && !h.disabledUntilTime ? a.type == "audio" ? a.language === k.language : !0 : !1;
            })) {
                for(var c = !1, d = !1, e = u(this.i.variants), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    var g = f[a.type];
                    g && (g.id === a.id ? (f.disabledUntilTime = Date.now() / 1E3 + b, c = !0) : g.trickModeVideo && g.trickModeVideo.id == a.id && (d = !0));
                }
                if (!c && d) return !1;
                this.Ue.xa(1);
                b = this.Nc().video.reduce(function(h, k) {
                    return h + k.end - k.start;
                }, 0);
                vr(this, !1, b, !0, !1);
                return !0;
            }
            return !1;
        };
        function Gr(a, b) {
            var c, d, e, f, g;
            return H(function(h) {
                switch(h.h){
                    case 1:
                        if (a.m == zr) return h.return();
                        b.severity === 1 && a.C.L++;
                        c = !0;
                        if (!(a.Oa && a.i && a.l) || b.code != 3016 && b.code != 3014 && b.code != 3015 && b.code != 3024 && b.code != 3018) {
                            h.B(2);
                            break;
                        }
                        d = Xb();
                        if (d.Ma() === "WEBKIT" && b.code == 3016) return h.return();
                        h.m(3);
                        return h.g(On(a.l), 5);
                    case 5:
                        e = h.i;
                        c = !e;
                        e && (f = yr("mediasourcerecovered"), a.dispatchEvent(f));
                        h.o(2);
                        break;
                    case 3:
                        h.l(), c = !0;
                    case 2:
                        if (!c) return h.return();
                        b.severity === 2 && ur(a, !1);
                        g = yr("error", (new Map).set("detail", b));
                        a.dispatchEvent(g);
                        g.defaultPrevented && (b.handled = !0);
                        h.j();
                }
            });
        }
        p.addFont = function(a, b) {
            return jk(a, b);
        };
        function Vr(a, b, c, d) {
            d = d === void 0 ? a : d;
            a = (new Map).set("detail", {
                schemeIdUri: c.schemeIdUri,
                value: c.value,
                startTime: c.startTime,
                endTime: c.endTime,
                id: c.id,
                timescale: c.timescale,
                eventElement: c.eventElement,
                eventNode: c.eventNode
            });
            d.dispatchEvent(yr(b, a));
        }
        function Wr(a, b, c, d) {
            d = d === void 0 ? !1 : d;
            b = (new Map).set("mediaQuality", {
                bandwidth: b.bandwidth,
                audioSamplingRate: b.audioSamplingRate,
                codecs: b.codecs,
                contentType: b.contentType,
                frameRate: b.frameRate,
                height: b.height,
                mimeType: b.mimeType,
                channelsCount: b.channelsCount,
                pixelAspectRatio: b.pixelAspectRatio,
                width: b.width,
                label: b.label,
                roles: b.roles,
                language: b.language
            }).set("position", c);
            a.dispatchEvent(yr(d ? "audiotrackchanged" : "mediaqualitychanged", b));
        }
        function Fr(a, b) {
            b = b === void 0 ? !0 : b;
            if (!a.h.error) return b ? new T(2, 3, 3016) : null;
            var c = a.h.error.code;
            if (!b && c == 1) return null;
            if (b = a.h.error.msExtendedCode) b < 0 && (b += 4294967296), b = b.toString(16);
            return new T(2, 3, 3016, c, b, a.h.error.message);
        }
        function Xr(a, b) {
            if (a.l) {
                var c = yr("keystatuschanged");
                a.dispatchEvent(c);
                var d = Object.keys(b);
                d.length == 1 && d[0] == "" && (d = [
                    "00"
                ], b = {
                    "00": b[""]
                });
                var e = d.length == 1 && d[0] == "00";
                c = !1;
                if (d.length) {
                    d = a.keySystem();
                    for(var f = wh(a.g.drm.clearKeys), g = function(t, v) {
                        t.allowedByKeySystem = !0;
                        v = u(v);
                        for(var w = v.next(); !w.done; w = v.next())if (w = w.value, (w = b[e ? "00" : w]) || a.F.H) t.allowedByKeySystem = t.allowedByKeySystem && !!w && !Ri.includes(w);
                    }, h = u(a.i.variants), k = h.next(); !k.done; k = h.next()){
                        k = k.value;
                        var l = Mg(k);
                        l = u(l);
                        for(var m = l.next(); !m.done; m = l.next()){
                            m = m.value;
                            var n = k.allowedByKeySystem;
                            if (m.keyIds.size) {
                                if (m.drmInfos.length && !f.size && a.i.type == "HLS") for(var q = u(m.drmInfos), r = q.next(); !r.done; r = q.next())r = r.value, r.keySystem == d && (r.keyIds.size ? g(k, r.keyIds) : g(k, m.keyIds));
                                else g(k, m.keyIds);
                            }
                            n != k.allowedByKeySystem && (c = !0);
                        }
                    }
                }
                c && (es(a), (c = a.l.o) && !c.allowedByKeySystem ? vr(a) : is(a));
            }
        }
        function js(a, b, c) {
            b > 0 && (a.U() || a.Sj(b));
            b = a.getDuration();
            c < b && (a.U() || a.Ab(c));
        }
        function Us(a, b) {
            H(function(c) {
                if (c.h == 1) return c.g(Promise.resolve(), 2);
                a.m != zr && a.dispatchEvent(b);
                c.j();
            });
        }
        function Os(a) {
            var b = new Set;
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, c.language ? b.add(Kc(c.language)) : b.add("und");
            return b;
        }
        function Ns(a) {
            for(var b = new Map, c = new Map, d = 0; d < a.length; d++){
                var e = a[d], f = "und", g = [];
                e.language && (f = Kc(e.language));
                e.type == "variant" ? g = e.audioRoles : g = e.roles;
                g && g.length || (g = [
                    ""
                ]);
                b.has(f) || b.set(f, new Set);
                g = u(g);
                for(var h = g.next(); !h.done; h = g.next())h = h.value, b.get(f).add(h), e.label && (c.has(f) || c.set(f, new Map), c.get(f).set(h, e.label));
            }
            var k = [];
            b.forEach(function(l, m) {
                l = u(l);
                for(var n = l.next(); !n.done; n = l.next()){
                    n = n.value;
                    var q = null;
                    c.has(m) && c.get(m).has(n) && (q = c.get(m).get(n));
                    k.push({
                        language: m,
                        role: n,
                        label: q
                    });
                }
            });
            return k;
        }
        p.Da = function() {
            return this.h && this.h.remote ? this.h.remote.state != "disconnected" : !1;
        };
        p.isEnded = function() {
            return !this.h || this.h.ended ? !0 : this.Oa && !this.U() && this.h.currentTime >= this.wa().end;
        };
        O("shaka.Player", W);
        W.prototype.isEnded = W.prototype.isEnded;
        W.prototype.isRemotePlayback = W.prototype.Da;
        W.prototype.addFont = W.prototype.addFont;
        W.prototype.setVideoContainer = W.prototype.mi;
        W.prototype.getFetchedPlaybackInfo = W.prototype.Rk;
        W.prototype.getManifestParserFactory = W.prototype.Yk;
        W.prototype.getManifest = W.prototype.sh;
        W.prototype.retryStreaming = W.prototype.bi;
        W.prototype.setMaxHardwareResolution = W.prototype.ym;
        W.prototype.addChaptersTrack = W.prototype.bf;
        W.prototype.addThumbnailsTrack = W.prototype.cf;
        W.prototype.addTextTrackAsync = W.prototype.fe;
        W.prototype.getStats = W.prototype.getStats;
        W.prototype.getBufferedInfo = W.prototype.Nc;
        W.prototype.getSegmentAvailabilityDuration = W.prototype.xf;
        W.prototype.getPresentationStartTimeAsDate = W.prototype.cj;
        W.prototype.getPlayheadTimeAsDate = W.prototype.al;
        W.prototype.setTextTrackVisibility = W.prototype.Xd;
        W.prototype.getChaptersAsync = W.prototype.ph;
        W.prototype.getChapters = W.prototype.Hk;
        W.prototype.getChaptersTracks = W.prototype.Ik;
        W.prototype.isTextTrackVisible = W.prototype.Tc;
        W.prototype.selectVariantsByLabel = W.prototype.sm;
        W.prototype.selectTextLanguage = W.prototype.ei;
        W.prototype.selectAudioLanguage = W.prototype.Ij;
        W.prototype.getTextLanguages = W.prototype.ol;
        W.prototype.getAudioLanguages = W.prototype.Dk;
        W.prototype.getTextLanguagesAndRoles = W.prototype.ql;
        W.prototype.getAudioLanguagesAndRoles = W.prototype.Ek;
        W.prototype.getVideoTracks = W.prototype.getVideoTracks;
        W.prototype.selectVideoTrack = W.prototype.Kj;
        W.prototype.getAudioTracks = W.prototype.getAudioTracks;
        W.prototype.selectAudioTrack = W.prototype.Jj;
        W.prototype.selectVariantTrack = W.prototype.Ge;
        W.prototype.selectTextTrack = W.prototype.gg;
        W.prototype.getThumbnails = W.prototype.dj;
        W.prototype.getAllThumbnails = W.prototype.Ck;
        W.prototype.getImageTracks = W.prototype.rh;
        W.prototype.getTextTracks = W.prototype.yc;
        W.prototype.getVariantTracks = W.prototype.Ib;
        W.prototype.cancelTrickPlay = W.prototype.ud;
        W.prototype.trickPlay = W.prototype.sc;
        W.prototype.useTrickPlayTrackIfAvailable = W.prototype.Ci;
        W.prototype.getPlaybackRate = W.prototype.Wa;
        W.prototype.isBuffering = W.prototype.Df;
        W.prototype.getKeyStatuses = W.prototype.uf;
        W.prototype.getActiveSessionsMetadata = W.prototype.oh;
        W.prototype.getExpiration = W.prototype.oe;
        W.prototype.drmInfo = W.prototype.drmInfo;
        W.prototype.keySystem = W.prototype.keySystem;
        W.prototype.isFullyLoaded = W.prototype.Gh;
        W.prototype.goToLive = W.prototype.Bl;
        W.prototype.seekRange = W.prototype.wa;
        W.prototype.isVideoOnly = W.prototype.Hf;
        W.prototype.isAudioOnly = W.prototype.Hd;
        W.prototype.isInProgress = W.prototype.fd;
        W.prototype.isLive = W.prototype.U;
        W.prototype.getQueueManager = W.prototype.wf;
        W.prototype.getAdManager = W.prototype.tf;
        W.prototype.getAssetUri = W.prototype.dd;
        W.prototype.getNetworkingEngine = W.prototype.Qb;
        W.prototype.getMediaElement = W.prototype.vf;
        W.prototype.getManifestType = W.prototype.uh;
        W.prototype.getLoadMode = W.prototype.xc;
        W.prototype.resetConfiguration = W.prototype.Dj;
        W.prototype.getBufferFullness = W.prototype.Zi;
        W.prototype.getNonDefaultConfiguration = W.prototype.bj;
        W.prototype.getConfigurationForLowLatency = W.prototype.Lk;
        W.prototype.getConfiguration = W.prototype.getConfiguration;
        W.prototype.configurationForLowLatency = W.prototype.zk;
        W.prototype.configure = W.prototype.configure;
        W.prototype.releaseAllMutexes = W.prototype.hm;
        W.prototype.destroyAllPreloads = W.prototype.Vg;
        W.prototype.preload = W.prototype.preload;
        W.prototype.detachAndSavePreload = W.prototype.Vi;
        W.prototype.unloadAndSavePreload = W.prototype.gk;
        W.prototype.load = W.prototype.load;
        W.prototype.updateStartTime = W.prototype.Gm;
        W.prototype.unload = W.prototype.tc;
        W.prototype.detach = W.prototype.detach;
        W.prototype.attachCanvas = W.prototype.Ji;
        W.prototype.attach = W.prototype.Ob;
        W.probeSupport = function(a) {
            a = a === void 0 ? !0 : a;
            var b, c, d, e, f, g, h;
            return H(function(k) {
                switch(k.h){
                    case 1:
                        b = {};
                        if (!a) {
                            k.B(2);
                            break;
                        }
                        return k.g(Ei(), 3);
                    case 3:
                        b = k.i;
                    case 2:
                        return c = zd(), d = Zk(), e = Xb(), k.g(e.vc(), 4);
                    case 4:
                        return f = k.i, g = {
                            manifest: c,
                            media: d,
                            drm: b,
                            hardwareResolution: f
                        }, h = Br, h.forEach(function(l, m) {
                            g[m] = l();
                        }), k.return(g);
                }
            });
        };
        W.isBrowserSupported = Cr;
        W.setQueueManagerFactory = function(a) {
            tr = a;
        };
        W.setAdManagerFactory = function(a) {
            sr = a;
        };
        W.registerSupportPlugin = Ar;
        W.prototype.destroy = W.prototype.destroy;
        var zr = 0, pr = 1, ms = 2, fs = 3;
        W.LoadMode = {
            DESTROYED: zr,
            NOT_LOADED: pr,
            MEDIA_SOURCE: ms,
            SRC_EQUALS: fs
        };
        W.version = "v4.16.44";
        var Ys = [
            "4",
            "16"
        ];
        nd = new function(a) {
            this.g = a;
            this.i = od;
            this.h = pd;
        }(new ld(Number(Ys[0]), Number(Ys[1])));
        var Br = new Map, sr = null, tr = null;
        function Zs() {
            this.g = [];
            this.i = this.m = this.l = this.j = this.h = 0;
        }
        function $s(a) {
            return a.g.length ? a.g.reduce(function(b, c) {
                return b + c;
            }, 0) / a.g.length : 0;
        }
        function at(a, b, c) {
            var d = this;
            this.g = a;
            this.h = b;
            this.m = c;
            this.i = !1;
            this.j = this.h.getVolume();
            this.l = new fd;
            this.l.u(this.h, google.ima.AdEvent.Type.PAUSED, function() {
                d.i = !0;
            });
            this.l.u(this.h, google.ima.AdEvent.Type.RESUMED, function() {
                d.i = !1;
            });
        }
        p = at.prototype;
        p.needsSkipUI = function() {
            return !1;
        };
        p.isClientRendering = function() {
            return !0;
        };
        p.hasCustomClick = function() {
            return !0;
        };
        p.isUsingAnotherMediaElement = function() {
            return !0;
        };
        p.getDuration = function() {
            return this.g.getDuration();
        };
        p.getMinSuggestedDuration = function() {
            return this.g.getMinSuggestedDuration();
        };
        p.getRemainingTime = function() {
            return this.h.getRemainingTime();
        };
        p.isPaused = function() {
            return this.i;
        };
        p.isSkippable = function() {
            return this.g.getSkipTimeOffset() >= 0;
        };
        p.getTimeUntilSkippable = function() {
            var a = this.g.getSkipTimeOffset();
            a = this.getRemainingTime() - a;
            return Math.max(a, 0);
        };
        p.canSkipNow = function() {
            return this.h.getAdSkippableState();
        };
        p.skip = function() {
            return this.h.skip();
        };
        p.pause = function() {
            return this.h.pause();
        };
        p.play = function() {
            return this.h.resume();
        };
        p.getVolume = function() {
            return this.h.getVolume();
        };
        p.setVolume = function(a) {
            this.m.volume = a;
            return this.h.setVolume(a);
        };
        p.isMuted = function() {
            return this.h.getVolume() == 0;
        };
        p.isLinear = function() {
            return this.g.isLinear();
        };
        p.resize = function(a, b) {
            this.h.resize(a, b);
        };
        p.setMuted = function(a) {
            (this.m.muted = a) ? (this.j = this.getVolume(), this.h.setVolume(0)) : this.h.setVolume(this.j);
        };
        p.getSequenceLength = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getTotalAds();
        };
        p.getPositionInSequence = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getAdPosition();
        };
        p.getTitle = function() {
            return this.g.getTitle();
        };
        p.getDescription = function() {
            return this.g.getDescription();
        };
        p.getVastMediaBitrate = function() {
            return this.g.getVastMediaBitrate();
        };
        p.getVastMediaHeight = function() {
            return this.g.getVastMediaHeight();
        };
        p.getVastMediaWidth = function() {
            return this.g.getVastMediaWidth();
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.g.getAdId();
        };
        p.getCreativeAdId = function() {
            return this.g.getCreativeAdId();
        };
        p.getAdvertiserName = function() {
            return this.g.getAdvertiserName();
        };
        p.getMediaUrl = function() {
            return this.g.getMediaUrl();
        };
        p.getTimeOffset = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getTimeOffset();
        };
        p.getPodIndex = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getPodIndex();
        };
        p.release = function() {
            this.h = this.g = null;
        };
        O("shaka.ads.ClientSideAd", at);
        at.prototype.release = at.prototype.release;
        at.prototype.getPodIndex = at.prototype.getPodIndex;
        at.prototype.getTimeOffset = at.prototype.getTimeOffset;
        at.prototype.getMediaUrl = at.prototype.getMediaUrl;
        at.prototype.getAdvertiserName = at.prototype.getAdvertiserName;
        at.prototype.getCreativeAdId = at.prototype.getCreativeAdId;
        at.prototype.getAdId = at.prototype.getAdId;
        at.prototype.getVastAdId = at.prototype.getVastAdId;
        at.prototype.getVastMediaWidth = at.prototype.getVastMediaWidth;
        at.prototype.getVastMediaHeight = at.prototype.getVastMediaHeight;
        at.prototype.getVastMediaBitrate = at.prototype.getVastMediaBitrate;
        at.prototype.getDescription = at.prototype.getDescription;
        at.prototype.getTitle = at.prototype.getTitle;
        at.prototype.getPositionInSequence = at.prototype.getPositionInSequence;
        at.prototype.getSequenceLength = at.prototype.getSequenceLength;
        at.prototype.setMuted = at.prototype.setMuted;
        at.prototype.resize = at.prototype.resize;
        at.prototype.isLinear = at.prototype.isLinear;
        at.prototype.isMuted = at.prototype.isMuted;
        at.prototype.setVolume = at.prototype.setVolume;
        at.prototype.getVolume = at.prototype.getVolume;
        at.prototype.play = at.prototype.play;
        at.prototype.pause = at.prototype.pause;
        at.prototype.skip = at.prototype.skip;
        at.prototype.canSkipNow = at.prototype.canSkipNow;
        at.prototype.getTimeUntilSkippable = at.prototype.getTimeUntilSkippable;
        at.prototype.isSkippable = at.prototype.isSkippable;
        at.prototype.isPaused = at.prototype.isPaused;
        at.prototype.getRemainingTime = at.prototype.getRemainingTime;
        at.prototype.getMinSuggestedDuration = at.prototype.getMinSuggestedDuration;
        at.prototype.getDuration = at.prototype.getDuration;
        at.prototype.isUsingAnotherMediaElement = at.prototype.isUsingAnotherMediaElement;
        at.prototype.hasCustomClick = at.prototype.hasCustomClick;
        at.prototype.isClientRendering = at.prototype.isClientRendering;
        at.prototype.needsSkipUI = at.prototype.needsSkipUI;
        function bt() {}
        function ct(a, b) {
            var c = [];
            a = u(ie(a, "Ad"));
            for(var d = a.next(); !d.done; d = a.next())if (d = ne(d.value, "InLine")) {
                if (d = ne(d, "Creatives")) {
                    d = u(ie(d, "Creative"));
                    for(var e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        var f = ne(e, "Linear");
                        f && dt(c, b, f);
                        if (e = ne(e, "NonLinearAds")) {
                            e = ie(e, "NonLinear");
                            e = u(e);
                            for(var g = e.next(); !g.done; g = e.next())a: {
                                f = c;
                                var h = b, k = g.value, l = ne(k, "StaticResource");
                                if (l) g = l.attributes.creativeType;
                                else {
                                    l = ne(k, "HTMLResource");
                                    if (!l) break a;
                                    g = "text/html";
                                }
                                if (l = le(l)) {
                                    g === "text/html" && (l = "data:text/html;charset=UTF-8," + encodeURIComponent(l));
                                    var m = qe(k, "width", we) || qe(k, "expandedWidth", we), n = qe(k, "height", we) || qe(k, "expandedHeight", we);
                                    if (m || n) {
                                        var q = null, r = ne(k, "NonLinearClickThrough");
                                        r && (r = le(r)) && (q = r);
                                        r = null;
                                        (k = k.attributes.minSuggestedDuration) && (r = Vd(k));
                                        k = 0;
                                        h != null && (k = h);
                                        f.push({
                                            id: null,
                                            groupId: null,
                                            startTime: k,
                                            endTime: null,
                                            uri: l,
                                            mimeType: g,
                                            isSkippable: !1,
                                            skipOffset: null,
                                            skipFor: null,
                                            canJump: !1,
                                            resumeOffset: 0,
                                            playoutLimit: r,
                                            once: !0,
                                            pre: h == null,
                                            post: h == Infinity,
                                            timelineRange: !1,
                                            loop: !1,
                                            overlay: {
                                                viewport: {
                                                    x: 0,
                                                    y: 0
                                                },
                                                topLeft: {
                                                    x: 0,
                                                    y: 0
                                                },
                                                size: {
                                                    x: m || 0,
                                                    y: n || 0
                                                }
                                            },
                                            displayOnBackground: !1,
                                            currentVideo: null,
                                            background: null,
                                            clickThroughUrl: q
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return c;
        }
        function dt(a, b, c) {
            var d = 0;
            b != null && (d = b);
            var e = null;
            c.attributes.skipoffset && (e = Vd(c.attributes.skipoffset), isNaN(e) && (e = null));
            var f = ne(c, "MediaFiles");
            if (f) {
                var g = null;
                (c = ne(c, "VideoClicks")) && (c = ne(c, "ClickThrough")) && (c = le(c)) && (g = c);
                f = c = ie(f, "MediaFile");
                c = c.filter(function(k) {
                    return k.attributes.delivery == "streaming";
                });
                c.length && (f = c);
                f = f.sort(function(k, l) {
                    return (parseInt(l.attributes.height, 10) || 0) - (parseInt(k.attributes.height, 10) || 0);
                });
                f = u(f);
                for(c = f.next(); !c.done; c = f.next())if (c = c.value, !c.attributes.apiFramework) {
                    var h = le(c);
                    if (h) {
                        a.push({
                            id: null,
                            groupId: null,
                            startTime: d,
                            endTime: null,
                            uri: h,
                            mimeType: c.attributes.type || null,
                            isSkippable: e != null,
                            skipOffset: e,
                            skipFor: null,
                            canJump: !1,
                            resumeOffset: 0,
                            playoutLimit: null,
                            once: !0,
                            pre: b == null,
                            post: b == Infinity,
                            timelineRange: !1,
                            loop: !1,
                            overlay: null,
                            displayOnBackground: !1,
                            currentVideo: null,
                            background: null,
                            clickThroughUrl: g
                        });
                        break;
                    }
                }
            }
        }
        function et(a) {
            var b = [];
            a = u(ie(a, "vmap:AdBreak"));
            for(var c = a.next(); !c.done; c = a.next()){
                var d = c.value, e = d.attributes.timeOffset;
                e && (c = null, e == "start" ? c = null : e == "end" ? c = Infinity : c = Vd(e), (d = ne(d, "vmap:AdSource")) && (d = ne(d, "vmap:AdTagURI")) && (d = ke(d)) && b.push({
                    time: c,
                    uri: d
                }));
            }
            return b;
        }
        O("shaka.ads.Utils", bt);
        bt.ADS_LOADED = "ads-loaded";
        bt.AD_STARTED = "ad-started";
        bt.AD_FIRST_QUARTILE = "ad-first-quartile";
        bt.AD_MIDPOINT = "ad-midpoint";
        bt.AD_THIRD_QUARTILE = "ad-third-quartile";
        bt.AD_COMPLETE = "ad-complete";
        bt.AD_STOPPED = "ad-stopped";
        bt.AD_SKIPPED = "ad-skipped";
        bt.AD_VOLUME_CHANGED = "ad-volume-changed";
        bt.AD_MUTED = "ad-muted";
        bt.AD_PAUSED = "ad-paused";
        bt.AD_RESUMED = "ad-resumed";
        bt.AD_SKIP_STATE_CHANGED = "ad-skip-state-changed";
        bt.CUEPOINTS_CHANGED = "ad-cue-points-changed";
        bt.IMA_AD_MANAGER_LOADED = "ima-ad-manager-loaded";
        bt.IMA_STREAM_MANAGER_LOADED = "ima-stream-manager-loaded";
        bt.AD_CLICKED = "ad-clicked";
        bt.AD_PROGRESS = "ad-progress";
        bt.AD_BUFFERING = "ad-buffering";
        bt.AD_IMPRESSION = "ad-impression";
        bt.AD_DURATION_CHANGED = "ad-duration-changed";
        bt.AD_CLOSED = "ad-closed";
        bt.AD_LOADED = "ad-loaded";
        bt.ALL_ADS_COMPLETED = "all-ads-completed";
        bt.AD_LINEAR_CHANGED = "ad-linear-changed";
        bt.AD_METADATA = "ad-metadata";
        bt.AD_RECOVERABLE_ERROR = "ad-recoverable-error";
        bt.AD_ERROR = "ad-error";
        bt.AD_BREAK_READY = "ad-break-ready";
        bt.AD_INTERACTION = "ad-interaction";
        bt.AD_CONTENT_PAUSE_REQUESTED = "ad-content-pause-requested";
        bt.AD_CONTENT_RESUME_REQUESTED = "ad-content-resume-requested";
        bt.AD_CONTENT_ATTACH_REQUESTED = "ad-content-attach-requested";
        function ft(a, b, c, d, e) {
            var f = this;
            this.A = a;
            this.i = b;
            this.G = !1;
            this.C = this.o = null;
            this.H = NaN;
            this.l = e;
            this.j = null;
            this.h = new fd;
            google.ima.settings.setLocale(c);
            google.ima.settings.setDisableCustomPlaybackForIOS10Plus(!0);
            this.F = new google.ima.AdDisplayContainer(this.A, this.i);
            this.F.initialize();
            this.m = new google.ima.AdsLoader(this.F);
            this.m.getSettings().setPlayerType("shaka-player");
            this.m.getSettings().setPlayerVersion("v4.16.44");
            this.g = null;
            this.D = d || new google.ima.AdsRenderingSettings;
            this.h.u(this.m, google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, function(g) {
                gt(f, g);
            });
            this.h.u(this.m, google.ima.AdErrorEvent.Type.AD_ERROR, function(g) {
                ht(f, g);
            });
            this.h.u(this.i, "ended", function() {
                f.m.contentComplete();
            });
            this.h.ra(this.i, "play", function() {
                f.G = !0;
            });
        }
        ft.prototype.configure = function(a) {
            this.o = a;
        };
        ft.prototype.stop = function() {
            this.g && this.g.stop();
            this.A && gk(this.A);
        };
        ft.prototype.release = function() {
            this.stop();
            this.C && this.C.disconnect();
            this.h && this.h.release();
            this.g && this.g.destroy();
            this.m.destroy();
            this.F.destroy();
        };
        function ht(a, b) {
            b.getError();
            b = (new Map).set("originalEvent", b);
            a.l(new R("ad-error", b));
            it(a, null);
            a.l(new R("ad-cue-points-changed", (new Map).set("cuepoints", [])));
        }
        function gt(a, b) {
            a.l(new R("ads-loaded", (new Map).set("loadTime", Date.now() / 1E3 - a.H)));
            if (a.o.customPlayheadTracker) {
                var c = {
                    currentTime: a.i.currentTime
                };
                a.g = b.getAdsManager(c, a.D);
                a.i.muted ? a.g.setVolume(0) : a.g.setVolume(a.i.volume);
                a.h.u(a.i, "timeupdate", function() {
                    a.i.duration && (c.currentTime = a.i.currentTime);
                });
                a.h.u(a.i, "volumechange", function() {
                    a.j && (a.j.setVolume(a.i.volume), a.i.muted && a.j.setMuted(!0));
                });
            } else a.g = b.getAdsManager(a.i, a.D);
            a.l(new R("ima-ad-manager-loaded", (new Map).set("imaAdManager", a.g)));
            var d = a.g.getCuePoints();
            if (d.length) {
                b = [];
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next())b.push({
                    start: e.value,
                    end: null
                });
                a.l(new R("ad-cue-points-changed", (new Map).set("cuepoints", b)));
            }
            jt(a);
            try {
                a.g.init(a.i.offsetWidth, a.i.offsetHeight), a.h.u(a.i, "loadeddata", function() {
                    a.g.resize(a.i.offsetWidth, a.i.offsetHeight);
                }), "ResizeObserver" in window1 ? (a.C = new ResizeObserver(function() {
                    a.g.resize(a.i.offsetWidth, a.i.offsetHeight);
                }), a.C.observe(a.i)) : a.h.u(document, "fullscreenchange", function() {
                    a.g.resize(a.i.offsetWidth, a.i.offsetHeight);
                }), a.G || a.o.skipPlayDetection ? a.g.start() : a.h.ra(a.i, "play", function() {
                    a.G = !0;
                    a.g.start();
                });
            } catch (f) {
                it(a, null);
            }
        }
        function jt(a) {
            function b(c, d) {
                c = (new Map).set("originalEvent", c);
                a.l(new R(d, c));
            }
            a.h.u(a.g, google.ima.AdErrorEvent.Type.AD_ERROR, function(c) {
                ht(a, c);
            });
            a.h.u(a.g, google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function(c) {
                kt(a, c);
            });
            a.h.u(a.g, google.ima.AdEvent.Type.STARTED, function(c) {
                kt(a, c);
            });
            a.h.u(a.g, google.ima.AdEvent.Type.FIRST_QUARTILE, function(c) {
                b(c, "ad-first-quartile");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.MIDPOINT, function(c) {
                b(c, "ad-midpoint");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.THIRD_QUARTILE, function(c) {
                b(c, "ad-third-quartile");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.COMPLETE, function(c) {
                b(c, "ad-complete");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function(c) {
                it(a, c);
            });
            a.h.u(a.g, google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function(c) {
                b(c, "all-ads-completed");
                it(a, c);
            });
            a.h.u(a.g, google.ima.AdEvent.Type.SKIPPED, function(c) {
                b(c, "ad-skipped");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.VOLUME_CHANGED, function(c) {
                b(c, "ad-volume-changed");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.VOLUME_MUTED, function(c) {
                b(c, "ad-muted");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.PAUSED, function(c) {
                a.j && (a.j.i = !0, b(c, "ad-paused"));
            });
            a.h.u(a.g, google.ima.AdEvent.Type.RESUMED, function(c) {
                a.j && (a.j.i = !1, b(c, "ad-resumed"));
            });
            a.h.u(a.g, google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED, function(c) {
                a.j && b(c, "ad-skip-state-changed");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.CLICK, function(c) {
                b(c, "ad-clicked");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.AD_PROGRESS, function(c) {
                b(c, "ad-progress");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.AD_BUFFERING, function(c) {
                b(c, "ad-buffering");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.IMPRESSION, function(c) {
                b(c, "ad-impression");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.DURATION_CHANGE, function(c) {
                b(c, "ad-duration-changed");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.USER_CLOSE, function(c) {
                b(c, "ad-closed");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.LOADED, function(c) {
                b(c, "ad-loaded");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.LINEAR_CHANGED, function(c) {
                b(c, "ad-linear-changed");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.AD_METADATA, function(c) {
                b(c, "ad-metadata");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.LOG, function(c) {
                b(c, "ad-recoverable-error");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.AD_BREAK_READY, function(c) {
                b(c, "ad-break-ready");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.INTERACTION, function(c) {
                b(c, "ad-interaction");
            });
        }
        function kt(a, b) {
            var c = b.getAd();
            c ? (a.j = new at(c, a.g, a.i), b.type != google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED || a.o.supportsMultipleMediaElements || a.l(new R("ad-content-pause-requested")), b = (new Map).set("ad", a.j).set("sdkAdObject", c).set("originalEvent", b), a.l(new R("ad-started", b)), a.j.isLinear() && (a.A.setAttribute("ad-active", "true"), a.o.customPlayheadTracker || a.i.pause(), a.i.muted ? (b = a.j, b.j = a.i.volume, b.h.setVolume(0)) : a.j.setVolume(a.i.volume))) : Za("The IMA SDK fired a " + b.type + " event with no associated ad. Unable to play ad!");
        }
        function it(a, b) {
            b && b.type == google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED && !a.o.supportsMultipleMediaElements && a.l(new R("ad-content-resume-requested"));
            a.l(new R("ad-stopped", (new Map).set("originalEvent", b)));
            a.j && a.j.isLinear() && (a.A.removeAttribute("ad-active"), a.o.customPlayheadTracker || a.i.ended || a.i.play());
        }
        function lt(a, b, c, d, e, f) {
            this.g = a;
            this.h = b;
            this.j = (this.i = b.isSkippable) ? b.skipOffset || 0 : b.skipOffset;
            this.l = b.skipFor;
            this.C = c;
            this.o = d;
            this.m = e;
            this.A = f;
            this.D = b.overlay;
        }
        p = lt.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !0;
        };
        p.hasCustomClick = function() {
            return this.h.clickThroughUrl != null;
        };
        p.isUsingAnotherMediaElement = function() {
            return this.A;
        };
        p.getDuration = function() {
            var a = this.g.duration;
            return isNaN(a) ? -1 : a;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            var a = this.g.duration;
            return isNaN(a) ? -1 : a - this.g.currentTime;
        };
        p.isPaused = function() {
            return this.g.paused;
        };
        p.isSkippable = function() {
            return this.i && this.l != null ? this.getDuration() - this.getRemainingTime() < this.j + this.l : this.i;
        };
        p.getTimeUntilSkippable = function() {
            if (this.isSkippable()) {
                var a = this.getRemainingTime() + this.j - this.getDuration();
                return Math.max(a, 0);
            }
            return Math.max(this.getRemainingTime(), 0);
        };
        p.canSkipNow = function() {
            return this.i && this.getTimeUntilSkippable() == 0;
        };
        p.skip = function() {
            this.canSkipNow() && this.C();
        };
        p.pause = function() {
            return this.g.pause();
        };
        p.play = function() {
            return this.g.play();
        };
        p.getVolume = function() {
            return this.g.volume;
        };
        p.setVolume = function(a) {
            this.g.volume = a;
        };
        p.isMuted = function() {
            return this.g.muted;
        };
        p.isLinear = function() {
            return this.D == null;
        };
        p.resize = function() {};
        p.setMuted = function(a) {
            this.g.muted = a;
        };
        p.getSequenceLength = function() {
            return this.o;
        };
        p.getPositionInSequence = function() {
            return this.m;
        };
        p.getTitle = function() {
            return "";
        };
        p.getDescription = function() {
            return "";
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return 0;
        };
        p.getVastMediaWidth = function() {
            return 0;
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.h.id || "";
        };
        p.getCreativeAdId = function() {
            return "";
        };
        p.getAdvertiserName = function() {
            return "";
        };
        p.getMediaUrl = function() {
            return this.h.uri;
        };
        p.getTimeOffset = function() {
            return this.h.pre ? 0 : this.h.post ? -1 : this.h.startTime;
        };
        p.getPodIndex = function() {
            return 0;
        };
        p.release = function() {
            this.g = null;
        };
        O("shaka.ads.InterstitialAd", lt);
        lt.prototype.release = lt.prototype.release;
        lt.prototype.getPodIndex = lt.prototype.getPodIndex;
        lt.prototype.getTimeOffset = lt.prototype.getTimeOffset;
        lt.prototype.getMediaUrl = lt.prototype.getMediaUrl;
        lt.prototype.getAdvertiserName = lt.prototype.getAdvertiserName;
        lt.prototype.getCreativeAdId = lt.prototype.getCreativeAdId;
        lt.prototype.getAdId = lt.prototype.getAdId;
        lt.prototype.getVastAdId = lt.prototype.getVastAdId;
        lt.prototype.getVastMediaWidth = lt.prototype.getVastMediaWidth;
        lt.prototype.getVastMediaHeight = lt.prototype.getVastMediaHeight;
        lt.prototype.getVastMediaBitrate = lt.prototype.getVastMediaBitrate;
        lt.prototype.getDescription = lt.prototype.getDescription;
        lt.prototype.getTitle = lt.prototype.getTitle;
        lt.prototype.getPositionInSequence = lt.prototype.getPositionInSequence;
        lt.prototype.getSequenceLength = lt.prototype.getSequenceLength;
        lt.prototype.setMuted = lt.prototype.setMuted;
        lt.prototype.resize = lt.prototype.resize;
        lt.prototype.isLinear = lt.prototype.isLinear;
        lt.prototype.isMuted = lt.prototype.isMuted;
        lt.prototype.setVolume = lt.prototype.setVolume;
        lt.prototype.getVolume = lt.prototype.getVolume;
        lt.prototype.play = lt.prototype.play;
        lt.prototype.pause = lt.prototype.pause;
        lt.prototype.skip = lt.prototype.skip;
        lt.prototype.canSkipNow = lt.prototype.canSkipNow;
        lt.prototype.getTimeUntilSkippable = lt.prototype.getTimeUntilSkippable;
        lt.prototype.isSkippable = lt.prototype.isSkippable;
        lt.prototype.isPaused = lt.prototype.isPaused;
        lt.prototype.getRemainingTime = lt.prototype.getRemainingTime;
        lt.prototype.getMinSuggestedDuration = lt.prototype.getMinSuggestedDuration;
        lt.prototype.getDuration = lt.prototype.getDuration;
        lt.prototype.isUsingAnotherMediaElement = lt.prototype.isUsingAnotherMediaElement;
        lt.prototype.hasCustomClick = lt.prototype.hasCustomClick;
        lt.prototype.isClientRendering = lt.prototype.isClientRendering;
        lt.prototype.needsSkipUI = lt.prototype.needsSkipUI;
        function mt(a, b, c) {
            this.g = a;
            this.j = b;
            this.h = c;
            this.i = a.overlay == null;
        }
        p = mt.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !0;
        };
        p.hasCustomClick = function() {
            return this.g.clickThroughUrl != null;
        };
        p.isUsingAnotherMediaElement = function() {
            return !1;
        };
        p.getDuration = function() {
            return -1;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            return -1;
        };
        p.isPaused = function() {
            return !1;
        };
        p.isSkippable = function() {
            return !1;
        };
        p.getTimeUntilSkippable = function() {
            return 0;
        };
        p.canSkipNow = function() {
            return !1;
        };
        p.skip = function() {};
        p.pause = function() {};
        p.play = function() {};
        p.getVolume = function() {
            return 1;
        };
        p.setVolume = function() {};
        p.isMuted = function() {
            return !1;
        };
        p.isLinear = function() {
            return this.i;
        };
        p.resize = function() {};
        p.setMuted = function() {};
        p.getSequenceLength = function() {
            return this.j;
        };
        p.getPositionInSequence = function() {
            return this.h;
        };
        p.getTitle = function() {
            return "";
        };
        p.getDescription = function() {
            return "";
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return 0;
        };
        p.getVastMediaWidth = function() {
            return 0;
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.g.id || "";
        };
        p.getCreativeAdId = function() {
            return "";
        };
        p.getAdvertiserName = function() {
            return "";
        };
        p.getMediaUrl = function() {
            return this.g.uri;
        };
        p.getTimeOffset = function() {
            return this.g.pre ? 0 : this.g.post ? -1 : this.g.startTime;
        };
        p.getPodIndex = function() {
            return 0;
        };
        p.release = function() {};
        O("shaka.ads.InterstitialStaticAd", mt);
        mt.prototype.release = mt.prototype.release;
        mt.prototype.getPodIndex = mt.prototype.getPodIndex;
        mt.prototype.getTimeOffset = mt.prototype.getTimeOffset;
        mt.prototype.getMediaUrl = mt.prototype.getMediaUrl;
        mt.prototype.getAdvertiserName = mt.prototype.getAdvertiserName;
        mt.prototype.getCreativeAdId = mt.prototype.getCreativeAdId;
        mt.prototype.getAdId = mt.prototype.getAdId;
        mt.prototype.getVastAdId = mt.prototype.getVastAdId;
        mt.prototype.getVastMediaWidth = mt.prototype.getVastMediaWidth;
        mt.prototype.getVastMediaHeight = mt.prototype.getVastMediaHeight;
        mt.prototype.getVastMediaBitrate = mt.prototype.getVastMediaBitrate;
        mt.prototype.getDescription = mt.prototype.getDescription;
        mt.prototype.getTitle = mt.prototype.getTitle;
        mt.prototype.getPositionInSequence = mt.prototype.getPositionInSequence;
        mt.prototype.getSequenceLength = mt.prototype.getSequenceLength;
        mt.prototype.setMuted = mt.prototype.setMuted;
        mt.prototype.resize = mt.prototype.resize;
        mt.prototype.isLinear = mt.prototype.isLinear;
        mt.prototype.isMuted = mt.prototype.isMuted;
        mt.prototype.setVolume = mt.prototype.setVolume;
        mt.prototype.getVolume = mt.prototype.getVolume;
        mt.prototype.play = mt.prototype.play;
        mt.prototype.pause = mt.prototype.pause;
        mt.prototype.skip = mt.prototype.skip;
        mt.prototype.canSkipNow = mt.prototype.canSkipNow;
        mt.prototype.getTimeUntilSkippable = mt.prototype.getTimeUntilSkippable;
        mt.prototype.isSkippable = mt.prototype.isSkippable;
        mt.prototype.isPaused = mt.prototype.isPaused;
        mt.prototype.getRemainingTime = mt.prototype.getRemainingTime;
        mt.prototype.getMinSuggestedDuration = mt.prototype.getMinSuggestedDuration;
        mt.prototype.getDuration = mt.prototype.getDuration;
        mt.prototype.isUsingAnotherMediaElement = mt.prototype.isUsingAnotherMediaElement;
        mt.prototype.hasCustomClick = mt.prototype.hasCustomClick;
        mt.prototype.isClientRendering = mt.prototype.isClientRendering;
        mt.prototype.needsSkipUI = mt.prototype.needsSkipUI;
        function nt(a, b, c, d) {
            function e(g) {
                return g ? g.overlay ? !0 : f.g.ended ? g.post : f.g.paused ? !1 : !0 : !1;
            }
            var f = this;
            this.L = null;
            this.m = a;
            this.D = b;
            this.g = c;
            this.G = null;
            this.A = !0;
            this.h = this.g;
            this.na = d;
            this.$ = new Set;
            this.R = new Set;
            this.H = new Set;
            this.F = new Map;
            this.K = new Map;
            this.i = new W;
            ot(this);
            this.I = new fd;
            this.j = new fd;
            this.J = !1;
            this.W = this.o = this.C = this.l = null;
            this.X = !1;
            this.O = -1;
            this.V = function() {
                if (!f.J && f.l && !f.D.Da()) {
                    f.l = f.g.currentTime;
                    var g = pt(f);
                    g && e(g) && qt(f, g, 1, 1, Date.now());
                }
            };
            this.S = function() {
                if (!(f.J || f.l || f.D.Da())) {
                    f.g.paused || (f.l = f.g.currentTime);
                    var g;
                    f.C || (g = pt(f, !0));
                    g || (g = pt(f));
                    g && e(g) && qt(f, g, 1, 1, Date.now());
                }
            };
            this.ba = function() {
                if (!f.J && f.l && !f.D.Da()) {
                    var g = f.g.currentTime;
                    f.C && !f.C.pre && !f.C.post && g < (f.C.endTime || f.C.startTime) && (f.C = null);
                }
            };
            this.P = new Uf(this.V);
            this.M = new Uf(function() {
                var g, h, k, l, m, n, q, r, t, v, w;
                return H(function(x) {
                    switch(x.h){
                        case 1:
                            if (!f.H.size || f.l == null) {
                                x.B(0);
                                break;
                            }
                            g = f.D.xc();
                            if (g == zr || g == pr) return x.return();
                            h = !1;
                            k = Array.from(f.H);
                            l = f.D.wa();
                            m = u(k);
                            n = m.next();
                        case 3:
                            if (n.done) {
                                x.B(5);
                                break;
                            }
                            q = n.value;
                            if (q == f.C) {
                                x.B(4);
                                break;
                            }
                            r = q.endTime || q.startTime;
                            if (!(l.start - r >= 1)) {
                                t = q.startTime - f.l;
                                t > 0 && t <= 10 && (!f.F.has(q) && rt(q) && f.F.set(q, f.i.preload(q.uri, null, q.mimeType || void 0)), st(f, q));
                                x.B(4);
                                break;
                            }
                            if (!f.F.has(q)) {
                                x.B(7);
                                break;
                            }
                            return x.g(f.F.get(q), 8);
                        case 8:
                            (v = x.i) && v.destroy(), f.F.delete(q);
                        case 7:
                            tt(f, q), w = q.id || JSON.stringify(q), f.R.has(w) && f.R.delete(w), f.H.delete(q), ut(f), q.overlay || (h = !0);
                        case 4:
                            n = m.next();
                            x.B(3);
                            break;
                        case 5:
                            h && vt(f), x.j();
                    }
                });
            });
            this.configure(this.D.getConfiguration().ads);
        }
        p = nt.prototype;
        p.configure = function(a) {
            this.L = a;
            this.J || wt(this);
        };
        function xt(a) {
            if (!a.X && a.H.size) {
                a.I.u(a.g, "playing", a.S);
                a.I.u(a.g, "timeupdate", a.S);
                a.I.u(a.g, "seeked", a.ba);
                a.I.u(a.g, "ended", a.V);
                if ("requestVideoFrameCallback" in a.g && !yt()) {
                    var b = a.g, c = function() {
                        a.O != -1 && (a.V(), a.O != -1 && (a.O = b.requestVideoFrameCallback(c)));
                    };
                    a.O = b.requestVideoFrameCallback(c);
                } else a.P.xa(.025);
                a.M && a.M.xa(1);
                a.X = !0;
            }
        }
        function ut(a) {
            a.X && !a.H.size && (a.I.Fa(a.g, "playing", a.S), a.I.Fa(a.g, "timeupdate", a.S), a.I.Fa(a.g, "seeked", a.ba), a.I.Fa(a.g, "ended", a.V), a.O != -1 && (a.g.cancelVideoFrameCallback(a.O), a.O = -1), a.P && a.P.stop(), a.M && a.M.stop(), a.X = !1);
        }
        function wt(a) {
            if (a.m && a.L) {
                var b = a.L.supportsMultipleMediaElements, c = a.g;
                c.controls ? b = !1 : c.webkitPresentationMode && c.webkitPresentationMode !== "inline" ? b = !1 : c.webkitDisplayingFullscreen && (b = !1);
                a.A == b && (a.A = !b, a.A ? (a.h = a.g, a.G && (a.G.parentElement && a.m.removeChild(a.G), a.G = null)) : (a.G || (b = document.createElement(a.g.tagName), b.autoplay = !0, b.style.position = "absolute", b.style.top = "0", b.style.left = "0", b.style.width = "100%", b.style.height = "100%", b.style.display = "none", b.setAttribute("playsinline", ""), a.G = b), a.h = a.G));
            } else a.A = !0;
        }
        p.stop = function() {
            this.j && this.j.Ta();
            this.$.clear();
            this.R.clear();
            this.H.clear();
            this.i.Vg();
            if (this.F.size) {
                var a = Array.from(this.F.values());
                a = u(a);
                for(var b = a.next(); !b.done; b = a.next())(b = b.value) && b.then(function(c) {
                    c && c.destroy();
                });
            }
            this.F.clear();
            if (this.K.size) for(a = Array.from(this.K.keys()), a = u(a), b = a.next(); !b.done; b = a.next())tt(this, b.value);
            this.K.clear();
            this.i.detach();
            this.J = !1;
            this.C = this.l = null;
            this.A = !0;
            this.h = this.g;
            this.G = null;
            zt(this);
            ut(this);
            this.m && gk(this.m);
            this.o && (this.o.stop(), this.o = null);
        };
        p.release = function() {
            this.stop();
            this.I && this.I.release();
            this.j && this.j.release();
            this.P && (this.P.stop(), this.P = null);
            this.M && (this.M.stop(), this.M = null);
            this.i.destroy();
        };
        p.Rb = function() {
            return this.i;
        };
        function At(a, b) {
            var c, d, e;
            H(function(f) {
                if (f.h == 1) {
                    c = null;
                    if (d = b.values.find(function(g) {
                        return g.key == "ID";
                    })) c = d.data;
                    if (c) {
                        if (a.$.has(c)) return f.return();
                        a.$.add(c);
                    }
                    ot(a);
                    e = [];
                    return b && b.values.find(function(g) {
                        return g.key == "X-OVERLAY-ID";
                    }) ? (e = Bt(b), f.B(2)) : f.g(Ct(a, b), 3);
                }
                f.h != 2 && (e = f.i);
                e.length ? Dt(a, e) : Za("Unsupported HLS interstitial", b);
                f.j();
            });
        }
        function Et(a, b) {
            var c = ne(b.eventNode, "OverlayEvent"), d = c.attributes.uri, e = c.attributes.mimeType, f = c.attributes.loop == "true", g = qe(c, "z", we);
            if (d && g != 0) {
                var h = null, k = ne(c, "Background");
                if (k) {
                    var l = k.attributes.uri;
                    l ? h = "center / contain no-repeat url('" + l + "')" : h = le(k);
                }
                k = 1920;
                l = 1080;
                var m = ne(c, "Viewport");
                if (m) {
                    k = qe(m, "x", we);
                    if (k == null) return;
                    l = qe(m, "y", we);
                    if (l == null) return;
                }
                var n = {
                    viewport: {
                        x: k,
                        y: l
                    },
                    topLeft: {
                        x: 0,
                        y: 0
                    },
                    size: {
                        x: k,
                        y: l
                    }
                }, q = ne(c, "Overlay");
                if (m && q) {
                    var r = ne(q, "TopLeft"), t = ne(q, "Size");
                    if (r && t) {
                        q = qe(r, "x", we);
                        if (q == null) return;
                        r = qe(r, "y", we);
                        if (r == null) return;
                        var v = qe(t, "x", we);
                        if (v == null) return;
                        t = qe(t, "y", we);
                        if (t == null) return;
                        n.topLeft.x = q;
                        n.topLeft.y = r;
                        n.size.x = v;
                        n.size.y = t;
                    }
                }
                q = null;
                c = ne(c, "Squeeze");
                if (m && c && (t = ne(c, "TopLeft"), c = ne(c, "Size"), t && c)) {
                    m = qe(t, "x", we);
                    if (m == null) return;
                    q = qe(t, "y", we);
                    if (q == null) return;
                    t = qe(c, "x", we);
                    if (t == null) return;
                    c = qe(c, "y", we);
                    if (c == null) return;
                    q = {
                        viewport: {
                            x: k,
                            y: l
                        },
                        topLeft: {
                            x: m,
                            y: q
                        },
                        size: {
                            x: t,
                            y: c
                        }
                    };
                }
                Dt(a, [
                    {
                        id: b.id,
                        groupId: null,
                        startTime: b.startTime,
                        endTime: b.endTime,
                        uri: d,
                        mimeType: e,
                        isSkippable: !1,
                        skipOffset: null,
                        skipFor: null,
                        canJump: !0,
                        resumeOffset: null,
                        playoutLimit: null,
                        once: !1,
                        pre: !1,
                        post: !1,
                        timelineRange: !0,
                        loop: f,
                        overlay: n,
                        displayOnBackground: g == -1,
                        currentVideo: q,
                        background: h,
                        clickThroughUrl: null
                    }
                ]);
            }
        }
        p.addAdUrlInterstitial = function(a) {
            var b = this, c, d, e, f, g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) return c = {
                    type: 12
                }, n.g(Ft(b, a, c), 2);
                if (n.h != 3) {
                    d = n.i;
                    e = $d(d, "VAST,vmap:VMAP");
                    if (!e) throw new T(2, 10, 10007);
                    f = [];
                    if (e.tagName == "VAST") return f = ct(e, b.l), n.B(3);
                    if (e.tagName != "vmap:VMAP") return n.B(3);
                    g = function(q) {
                        var r, t;
                        return H(function(v) {
                            if (v.h == 1) return v.g(Ft(b, q.uri, c), 2);
                            r = v.i;
                            t = $d(r, "VAST");
                            if (!t) throw new T(2, 10, 10007);
                            f.push.apply(f, G(ct(t, q.time)));
                            v.j();
                        });
                    };
                    h = [];
                    k = u(et(e));
                    for(l = k.next(); !l.done; l = k.next())m = l.value, h.push(g(m));
                    return h.length ? n.g(Promise.all(h), 3) : n.B(3);
                }
                Dt(b, f);
                n.j();
            });
        };
        function Dt(a, b) {
            var c, d, e, f, g, h, k, l;
            H(function(m) {
                switch(m.h){
                    case 1:
                        c = !1, d = u(b), e = d.next();
                    case 2:
                        if (e.done) {
                            m.B(4);
                            break;
                        }
                        f = e.value;
                        if (!f.uri) {
                            Za("Missing URL in interstitial", f);
                            m.B(3);
                            break;
                        }
                        if (f.mimeType) {
                            m.B(5);
                            break;
                        }
                        m.m(6);
                        g = a.i.Qb();
                        return m.g(fn(f.uri, g, a.D.getConfiguration().streaming.retryParameters), 8);
                    case 8:
                        f.mimeType = m.i;
                        m.o(5);
                        break;
                    case 6:
                        m.l();
                    case 5:
                        h = f.id || JSON.stringify(f);
                        if (a.R.has(h)) {
                            m.B(3);
                            break;
                        }
                        f.loop && !f.overlay && Za("Loop is only supported in overlay interstitials", f);
                        f.overlay || (c = !0);
                        a.R.add(h);
                        a.H.add(f);
                        k = !1;
                        f.pre && a.l == null ? k = !0 : f.startTime != 0 || f.canJump ? a.l != null && (l = f.startTime - a.l, l > 0 && l <= 10 && (k = !0)) : k = !0;
                        k && (!a.F.has(f) && rt(f) && a.F.set(f, a.i.preload(f.uri, null, f.mimeType || void 0)), st(a, f));
                    case 3:
                        e = d.next();
                        m.B(2);
                        break;
                    case 4:
                        c && vt(a), xt(a), m.j();
                }
            });
        }
        function pt(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? null : c;
            var d = 0, e = null;
            if (a.H.size && a.l != null) {
                var f = a.g.ended, g = Array.from(a.H).sort(function(n, q) {
                    return q.startTime - n.startTime;
                }), h = g;
                h = b ? g.filter(function(n) {
                    return n.pre;
                }) : f ? g.filter(function(n) {
                    return n.post;
                }) : g.filter(function(n) {
                    return !n.pre && !n.post;
                });
                g = u(h);
                for(h = g.next(); !h.done; h = g.next()){
                    h = h.value;
                    var k = !1;
                    if (b) k = h.pre;
                    else if (f) k = h.post;
                    else if (!h.pre && !h.post) {
                        var l = a.l - Math.round(h.startTime * 1E3) / 1E3, m = 1;
                        a.L.allowStartInMiddleOfInterstitial && h.endTime && h.endTime != Infinity && (m = h.endTime - h.startTime);
                        (l > 0 || l == 0 && a.l == 0) && (l <= m || !h.canJump) && (k = c == null && a.C && !a.C.pre && !a.C.post && a.C.startTime >= h.startTime ? !1 : !0);
                    }
                    k && (!a.C || h.startTime >= a.C.startTime) && (d == (c || 0) ? e = h : e && !h.canJump && Math.round(h.startTime * 1E3) / 1E3 - Math.round(e.startTime * 1E3) / 1E3 > .001 && (e = h, d = 0), d++);
                }
            }
            return e;
        }
        function qt(a, b, c, d, e, f) {
            f = f === void 0 ? 0 : f;
            a.C = b;
            wt(a);
            a.A || !a.m || a.h.parentElement || a.m.appendChild(a.h);
            d == 1 && c == 1 && (c = Array.from(a.H).filter(function(g) {
                return b.pre ? g.pre == b.pre : b.post ? g.post == b.post : Math.abs(g.startTime - b.startTime) < .001;
            }).length);
            b.once && (f++, a.H.delete(b), ut(a), b.overlay || vt(a));
            b.mimeType && (b.mimeType.startsWith("image/") || b.mimeType === "text/html") ? b.overlay ? Gt(a, b, c, d, f) : Za("Unsupported interstitial", b) : a.A && b.overlay ? Za("Unsupported interstitial", b) : Ht(a, b, c, d, e, f);
        }
        function Gt(a, b, c, d, e) {
            function f() {
                a.o && (a.o.stop(), a.o = null);
                a.m.removeChild(k);
                zt(a, b);
                It(a, "ad-stopped");
                a.j.Ta();
                var q = pt(a, b.pre, d - e);
                q ? qt(a, q, c, ++d, Date.now(), e) : a.J = !1;
            }
            a.J = !0;
            var g = b.overlay, h = b.mimeType == "text/html" ? "iframe" : "img", k = document.createElement(h);
            k.style.objectFit = "contain";
            k.style.position = "absolute";
            k.style.border = "none";
            Jt(a, b);
            var l = new mt(b, c, d);
            It(a, "ad-impression");
            It(a, "ad-started", (new Map).set("ad", l));
            h == "iframe" ? k.src = b.uri : (k.src = b.uri, k.onerror = function(q) {
                It(a, "ad-error", (new Map).set("originalEvent", q));
                f();
            });
            l = g.viewport;
            var m = g.topLeft;
            g = g.size;
            l.x == 0 && l.y == 0 ? (k.width = b.overlay.size.x, k.height = b.overlay.size.y, k.style.bottom = "10%", k.style.left = "0", k.style.right = "0", k.style.width = "100%", b.overlay.size.y || h != "iframe" || (k.style.height = "auto")) : (k.style.height = g.y / l.y * 100 + "%", k.style.left = m.x / l.x * 100 + "%", k.style.top = m.y / l.y * 100 + "%", k.style.width = g.x / l.x * 100 + "%");
            a.m.appendChild(k);
            var n = Date.now();
            a.o && a.o.stop();
            a.o = new Uf(function() {
                b.playoutLimit && (Date.now() - n) / 1E3 > b.playoutLimit ? (It(a, "ad-complete"), f()) : b.endTime && a.g.currentTime > b.endTime ? (It(a, "ad-complete"), f()) : a.g.currentTime < b.startTime && (It(a, "ad-skipped"), f());
            });
            b.playoutLimit && !b.endTime ? a.o.Z(b.playoutLimit) : b.endTime && a.o.xa(.025);
            a.j.u(a.g, "seeked", function() {
                var q = a.g.currentTime;
                if (q < b.startTime || b.endTime && q > b.endTime) a.o && a.o.stop(), It(a, "ad-skipped"), f();
            });
            b.clickThroughUrl && a.j.u(k, "click", function() {
                b.clickThroughUrl && (It(a, "ad-clicked"), Kt(b.clickThroughUrl) && window1.open(b.clickThroughUrl, "_blank"));
            });
        }
        function Ht(a, b, c, d, e, f) {
            var g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F;
            H(function(I) {
                switch(I.h){
                    case 1:
                        g = Date.now();
                        a.J = !0;
                        h = !1;
                        k = function() {
                            if (!a.A && !b.overlay && b.resumeOffset == null) {
                                if (b.timelineRange && b.endTime && b.endTime != Infinity) a.g.currentTime != b.endTime && (a.g.currentTime = b.endTime);
                                else {
                                    var K = Date.now();
                                    a.g.currentTime += (K - e) / 1E3;
                                    e = K;
                                }
                            }
                        };
                        l = function(K) {
                            var N, P;
                            return H(function(M) {
                                if (M.h == 1) {
                                    k();
                                    N = pt(a, b.pre, d - f);
                                    if (K && b.groupId) for(; N && N.groupId == b.groupId;)d++, N = pt(a, b.pre, d - f);
                                    a.o && (!b.groupId || N && N.groupId != b.groupId) && (a.o.stop(), a.o = null);
                                    zt(a, b);
                                    if (N && !N.overlay) return M.B(2);
                                    b.post && (a.l = null, a.C = null);
                                    return a.A ? M.g(a.i.detach(), 4) : M.g(a.i.tc(), 4);
                                }
                                M.h != 2 && (a.A && (P = b.resumeOffset, P == null && (P = b.timelineRange && b.endTime && b.endTime != Infinity ? b.endTime - (a.l || 0) : (Date.now() - e) / 1E3), It(a, "ad-content-resume-requested", (new Map).set("offset", P))), It(a, "ad-stopped"), a.j.Ta(), a.J = !1, a.A ? vt(a) : (a.h.style.display = "none", k(), a.g.ended || a.g.play()));
                                wt(a);
                                N && (It(a, "ad-stopped"), a.j.Ta(), qt(a, N, c, ++d, e, f));
                                M.j();
                            });
                        };
                        m = function(K) {
                            return H(function(N) {
                                if (h) return N.return();
                                h = !0;
                                It(a, "ad-error", (new Map).set("originalEvent", K));
                                return N.g(l(!1), 0);
                            });
                        };
                        n = function() {
                            return H(function(K) {
                                if (K.h == 1) {
                                    if (h) return K.return();
                                    h = !0;
                                    return K.g(l(!1), 2);
                                }
                                It(a, "ad-complete");
                                K.j();
                            });
                        };
                        a.W = function() {
                            return H(function(K) {
                                if (h) return K.return();
                                h = !0;
                                It(a, "ad-skipped");
                                return K.g(l(!0), 0);
                            });
                        };
                        q = new lt(a.h, b, a.W, c, d, !a.A);
                        a.A || (q.setMuted(a.g.muted), q.setVolume(a.g.volume));
                        It(a, "ad-started", (new Map).set("ad", q));
                        (r = q.canSkipNow()) && It(a, "ad-skip-state-changed");
                        a.j.ra(a.i, "error", m);
                        a.j.u(a.h, "timeupdate", function() {
                            if (a.h.duration) {
                                var K = q.canSkipNow();
                                r != K && q.getRemainingTime() > 0 && q.getDuration() > 0 && It(a, "ad-skip-state-changed");
                                r = K;
                                !a.A && !b.overlay && b.resumeOffset == null && b.timelineRange && b.endTime && b.endTime != Infinity && a.g.currentTime != b.endTime && a.D.wa().end >= b.endTime && (a.g.currentTime = b.endTime);
                            }
                        });
                        a.j.ra(a.i, "firstquartile", function() {
                            k();
                            It(a, "ad-first-quartile");
                        });
                        a.j.ra(a.i, "midpoint", function() {
                            k();
                            It(a, "ad-midpoint");
                        });
                        a.j.ra(a.i, "thirdquartile", function() {
                            k();
                            It(a, "ad-third-quartile");
                        });
                        a.j.ra(a.i, "complete", n);
                        a.j.u(a.h, "play", function() {
                            It(a, "ad-resumed");
                        });
                        a.j.u(a.h, "pause", function() {
                            var K = a.i.getConfiguration();
                            a.h.currentTime >= K.playRangeEnd ? n() : It(a, "ad-paused");
                        });
                        a.j.u(a.h, "volumechange", function() {
                            a.h.muted ? It(a, "ad-muted") : It(a, "ad-volume-changed");
                            a.A || (a.g.volume = a.h.volume, a.g.muted = a.h.muted);
                        });
                        b.clickThroughUrl && (t = a.m || a.h, a.j.u(t, "click", function() {
                            b.clickThroughUrl && (q.isPaused() || q.pause(), Kt(b.clickThroughUrl) && window1.open(b.clickThroughUrl, "_blank"));
                        }));
                        if (!a.A || d != 1) {
                            I.B(2);
                            break;
                        }
                        It(a, "ad-content-pause-requested", (new Map).set("saveLivePosition", !0));
                        v = new Yg;
                        w = function(K) {
                            return H(function(N) {
                                if (N.h == 1) return K.state != "detach" ? N.B(0) : yt() ? N.g(new Promise(function(P) {
                                    return new Uf(P).Z(.1);
                                }), 3) : N.B(3);
                                v.resolve();
                                a.j.Fa(a.D, "onstatechange", w);
                                N.j();
                            });
                        };
                        a.j.u(a.D, "onstatechange", w);
                        return I.g(v, 2);
                    case 2:
                        return Jt(a, b), a.A || (a.h.style.display = "", b.overlay ? (a.h.loop = b.loop, x = b.overlay.viewport, y = b.overlay.topLeft, z = b.overlay.size, a.h.style.height = z.y / x.y * 100 + "%", a.h.style.left = y.x / x.x * 100 + "%", a.h.style.top = y.y / x.y * 100 + "%", a.h.style.width = z.x / x.x * 100 + "%") : (a.g.pause(), b.resumeOffset != null && b.resumeOffset != 0 && (a.g.currentTime += b.resumeOffset), a.h.loop = !1, a.h.style.height = "100%", a.h.style.left = "0", a.h.style.top = "0", a.h.style.width = "100%")), I.m(4), ot(a), b.startTime && b.endTime && b.endTime != Infinity && b.startTime != b.endTime && (A = b.endTime - b.startTime, A > 0 && a.i.configure("playRangeEnd", A)), b.playoutLimit && !a.o && (a.o = new Uf(function() {
                            a.W();
                        }).Z(b.playoutLimit), a.i.configure("playRangeEnd", b.playoutLimit)), I.g(a.i.Ob(a.h), 6);
                    case 6:
                        return E = null, b.pre || b.post || !a.L.allowStartInMiddleOfInterstitial || a.l == null || (C = a.l - b.startTime, Math.abs(C) > .25 && (E = C)), a.F.has(b) ? I.g(a.F.get(b), 10) : I.g(a.i.load(b.uri, E, b.mimeType || void 0), 8);
                    case 10:
                        return D = I.i, a.F.delete(b), D ? I.g(a.i.load(D), 8) : I.g(a.i.load(b.uri, E, b.mimeType || void 0), 8);
                    case 8:
                        b.overlay && a.g.paused ? a.h.pause() : a.h.play();
                        B = (Date.now() - g) / 1E3;
                        It(a, "ads-loaded", (new Map).set("loadTime", B));
                        a.A && a.g.play();
                        b.overlay && (b.pre || b.post || a.D.U() && !(b.startTime > 0) || (J = function() {
                            var K = a.g.currentTime - b.startTime;
                            Math.abs(K - a.h.currentTime) > .1 && (a.h.currentTime = K);
                        }, a.j.ra(a.h, "playing", J), a.j.u(a.g, "seeking", J)), a.j.u(a.g, "seeked", function() {
                            var K = a.g.currentTime;
                            (K < b.startTime || b.endTime && K > b.endTime) && a.W();
                        }));
                        I.o(0);
                        break;
                    case 4:
                        F = I.l();
                        if (!a.J) return I.return();
                        m(F);
                        I.j();
                }
            });
        }
        function Jt(a, b) {
            b.displayOnBackground && (a.g.style.zIndex = "1");
            if (b.currentVideo != null) {
                var c = b.currentVideo;
                a.g.style.transformOrigin = "top left";
                var d = !0, e = [], f = c.topLeft.x / c.viewport.x * 100;
                f > 0 && f <= 100 && (e.push("translateX(" + f + "%)"), d = !1);
                f = c.topLeft.y / c.viewport.y * 100;
                f > 0 && f <= 100 && (e.push("translateY(" + f + "%)"), d = !1);
                f = c.size.x / c.viewport.x;
                f < 1 && e.push("scaleX(" + f + ")");
                c = c.size.y / c.viewport.y;
                f < 1 && e.push("scaleY(" + c + ")");
                e.length && (a.g.style.transform = e.join(" "));
                d && (a.g.style.transition = "transform 250ms");
            }
            a.m && (b.clickThroughUrl ? (a.m.setAttribute("ad-active", "true"), a.m.style.pointerEvents = "") : a.m.style.pointerEvents = "none", b.background && (a.m.style.background = b.background));
            a.G && (a.G.style.background = b.overlay ? "" : "rgb(0, 0, 0)");
        }
        function zt(a, b) {
            if (!b || b.displayOnBackground) a.g.style.zIndex = "";
            b && b.currentVideo == null || (a.g.style.transformOrigin = "", a.g.style.transition = "", a.g.style.transform = "");
            a.m && (a.m.removeAttribute("ad-active"), a.m.style.pointerEvents = "", !b || b.background) && (a.m.style.background = "");
            a.G && (a.G.style.background = "");
        }
        function Ct(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa, Da, Ka, wa;
            return H(function(Ja) {
                switch(Ja.h){
                    case 1:
                        c = [];
                        if (!b) return Ja.return(c);
                        d = b.values.find(function(Aa) {
                            return Aa.key == "X-ASSET-URI";
                        });
                        e = b.values.find(function(Aa) {
                            return Aa.key == "X-ASSET-LIST";
                        });
                        if (!d && !e) return Ja.return(c);
                        f = null;
                        if (g = b.values.find(function(Aa) {
                            return Aa.key == "ID";
                        })) f = g.data;
                        h = f == null ? Math.floor(b.startTime * 10) / 10 : b.startTime;
                        (k = b.endTime) && b.endTime != Infinity && typeof b.endTime == "number" && (k = f == null ? Math.floor(b.endTime * 10) / 10 : b.endTime);
                        l = b.values.find(function(Aa) {
                            return Aa.key == "X-RESTRICT";
                        });
                        n = m = !0;
                        l && l.data && (q = l.data, m = !q.includes("SKIP"), n = !q.includes("JUMP"));
                        r = m ? 0 : null;
                        if (t = b.values.find(function(Aa) {
                            return Aa.key == "X-ENABLE-SKIP-AFTER";
                        })) v = t.data, r = parseFloat(v), isNaN(r) && (r = m ? 0 : null);
                        w = null;
                        if (x = b.values.find(function(Aa) {
                            return Aa.key == "X-ENABLE-SKIP-FOR";
                        })) y = x.data, w = parseFloat(y), isNaN(r) && (w = null);
                        z = null;
                        if (A = b.values.find(function(Aa) {
                            return Aa.key == "X-RESUME-OFFSET";
                        })) E = A.data, z = parseFloat(E), isNaN(z) && (z = null);
                        C = null;
                        if (D = b.values.find(function(Aa) {
                            return Aa.key == "X-PLAYOUT-LIMIT";
                        })) B = D.data, C = parseFloat(B), isNaN(C) && (C = null);
                        I = F = J = !1;
                        if (K = b.values.find(function(Aa) {
                            return Aa.key == "CUE";
                        })) N = K.data, J = N.includes("ONCE"), F = N.includes("PRE"), I = N.includes("POST");
                        P = !1;
                        (M = b.values.find(function(Aa) {
                            return Aa.key == "X-TIMELINE-OCCUPIES";
                        })) ? (L = M.data, P = L.includes("RANGE")) : !A && a.D.U() && (P = !F && !I);
                        if (d) {
                            Q = d.data;
                            if (!Q) return Ja.return(c);
                            c.push({
                                id: f,
                                groupId: null,
                                startTime: h,
                                endTime: k,
                                uri: Q,
                                mimeType: null,
                                isSkippable: m,
                                skipOffset: r,
                                skipFor: w,
                                canJump: n,
                                resumeOffset: z,
                                playoutLimit: C,
                                once: J,
                                pre: F,
                                post: I,
                                timelineRange: P,
                                loop: !1,
                                overlay: null,
                                displayOnBackground: !1,
                                currentVideo: null,
                                background: null,
                                clickThroughUrl: null
                            });
                            Ja.B(2);
                            break;
                        }
                        if (!e) {
                            Ja.B(2);
                            break;
                        }
                        S = e.data;
                        if (!S) return Ja.return(c);
                        Ja.m(4);
                        Z = {
                            type: 11
                        };
                        return Ja.g(Ft(a, S, Z), 6);
                    case 6:
                        pa = Ja.i;
                        va = bc(pa);
                        Ca = JSON.parse(va);
                        if (ua = Ca["SKIP-CONTROL"]) xa = ua["ENABLE-SKIP-AFTER"], typeof xa == "number" && (r = parseFloat(xa), isNaN(xa) && (r = m ? 0 : null)), Da = ua["ENABLE-SKIP-FOR"], typeof Da == "number" && (w = parseFloat(Da), isNaN(Da) && (w = null));
                        for(Ka = 0; Ka < Ca.ASSETS.length; Ka++)wa = Ca.ASSETS[Ka], wa.URI && c.push({
                            id: f + "_shaka_asset_" + Ka,
                            groupId: f,
                            startTime: h,
                            endTime: k,
                            uri: wa.URI,
                            mimeType: null,
                            isSkippable: m,
                            skipOffset: r,
                            skipFor: w,
                            canJump: n,
                            resumeOffset: z,
                            playoutLimit: C,
                            once: J,
                            pre: F,
                            post: I,
                            timelineRange: P,
                            loop: !1,
                            overlay: null,
                            displayOnBackground: !1,
                            currentVideo: null,
                            background: null,
                            clickThroughUrl: null
                        });
                        Ja.o(2);
                        break;
                    case 4:
                        Ja.l();
                    case 2:
                        return Ja.return(c);
                }
            });
        }
        function Bt(a) {
            var b = [];
            if (!a) return b;
            var c = a.values.find(function(w) {
                return w.key == "X-ASSET-URI";
            });
            if (!c) return b;
            c = c.data;
            if (!c) return b;
            var d = null, e = a.values.find(function(w) {
                return w.key == "X-OVERLAY-ID";
            });
            e && (d = e.data);
            e = d == null ? Math.floor(a.startTime * 10) / 10 : a.startTime;
            var f = a.endTime;
            a.endTime && a.endTime != Infinity && typeof a.endTime == "number" && (f = d == null ? Math.floor(a.endTime * 10) / 10 : a.endTime);
            var g = !1, h = !1, k = !1, l = a.values.find(function(w) {
                return w.key == "CUE";
            });
            l && (k = l.data, g = k.includes("ONCE"), h = k.includes("PRE"), k = k.includes("POST"));
            l = null;
            var m = a.values.find(function(w) {
                return w.key == "X-ASSET-MIMETYPE";
            });
            m && (l = m.data);
            m = !1;
            var n = a.values.find(function(w) {
                return w.key == "X-LOOP";
            });
            n && (m = n.data == "YES");
            n = 1;
            var q = a.values.find(function(w) {
                return w.key == "X-DEPTH";
            });
            q && (n = parseFloat(q.data), isNaN(n) && (n = 1));
            q = null;
            var r = a.values.find(function(w) {
                return w.key == "X-BACKGROUND";
            });
            r && (q = r.data);
            r = 1920;
            var t = 1080, v = a.values.find(function(w) {
                return w.key == "X-VIEWPORT";
            });
            if (v) {
                t = v.data.split("x");
                if (t.length != 2) return b;
                r = parseFloat(t[0]);
                t = parseFloat(t[1]);
            }
            r = {
                viewport: {
                    x: r,
                    y: t
                },
                topLeft: {
                    x: 0,
                    y: 0
                },
                size: {
                    x: r,
                    y: t
                }
            };
            if (t = a.values.find(function(w) {
                return w.key == "X-OVERLAY-POSITION";
            })) {
                t = t.data.split("x");
                if (t.length != 2) return b;
                r.topLeft.x = parseFloat(t[0]);
                r.topLeft.y = parseFloat(t[1]);
            }
            if (t = a.values.find(function(w) {
                return w.key == "X-OVERLAY-SIZE";
            })) {
                t = t.data.split("x");
                if (t.length != 2) return b;
                r.size.x = parseFloat(t[0]);
                r.size.y = parseFloat(t[1]);
            }
            t = null;
            if (v = a.values.find(function(w) {
                return w.key == "X-SQUEEZECURRENT";
            })) {
                if (t = parseFloat(v.data), isNaN(t) && (t = 1), t = {
                    viewport: {
                        x: 1920,
                        y: 1080
                    },
                    topLeft: {
                        x: 0,
                        y: 0
                    },
                    size: {
                        x: 1920 * t,
                        y: 1080 * t
                    }
                }, a = a.values.find(function(w) {
                    return w.key == "X-SQUEEZECURRENT-POSITION";
                })) {
                    a = a.data.split("x");
                    if (a.length != 2) return b;
                    t.topLeft.x = parseFloat(a[0]);
                    t.topLeft.y = parseFloat(a[1]);
                }
            }
            b.push({
                id: d,
                groupId: null,
                startTime: e,
                endTime: f,
                uri: c,
                mimeType: l,
                isSkippable: !1,
                skipOffset: null,
                skipFor: null,
                canJump: !0,
                resumeOffset: null,
                playoutLimit: null,
                once: g,
                pre: h,
                post: k,
                timelineRange: !0,
                loop: m,
                overlay: r,
                displayOnBackground: n == -1,
                currentVideo: t,
                background: q,
                clickThroughUrl: null
            });
            return b;
        }
        function vt(a) {
            for(var b = [], c = u(a.H), d = c.next(), e = {}; !d.done; e = {
                Ic: void 0
            }, d = c.next())d = d.value, d.overlay || (e.Ic = {
                start: d.startTime,
                end: null
            }, d.pre ? (e.Ic.start = 0, e.Ic.end = null) : d.post ? (e.Ic.start = -1, e.Ic.end = null) : d.timelineRange && (e.Ic.end = d.endTime), b.find(function(f) {
                return function(g) {
                    return f.Ic.start == g.start && f.Ic.end == g.end;
                };
            }(e)) || b.push(e.Ic));
            It(a, "ad-cue-points-changed", (new Map).set("cuepoints", b));
        }
        function ot(a) {
            a.i.configure(a.D.bj());
            a.i.configure("ads.disableHLSInterstitial", !0);
            a.i.configure("ads.disableDASHInterstitial", !0);
            a.i.configure("playRangeEnd", Infinity);
            lh(a.D.Qb(), a.i.Qb());
        }
        function Ft(a, b, c) {
            var d, e, f;
            return H(function(g) {
                if (g.h == 1) return d = mh([
                    b
                ], Wg()), e = a.D.Qb().request(7, d, c), g.g(e.promise, 2);
                f = g.i;
                return g.return(f.data);
            });
        }
        function rt(a) {
            return (a = a.mimeType) ? !a.startsWith("image/") && a !== "text/html" : !0;
        }
        function yt() {
            var a = Xb().Pa();
            return a == "TV" || a == "CONSOLE" || a == "CAST" ? !0 : !1;
        }
        function st(a, b) {
            if (!(a.K.has(b) || a.L && !a.L.allowPreloadOnDomElements)) {
                var c = function(f) {
                    var g = document.createElement("link");
                    g.rel = "preload";
                    g.href = f;
                    g.as = "image";
                    document.head.appendChild(g);
                    return g;
                }, d = [];
                if (b.background) {
                    var e = b.background.match(/url\(('|")?([^'"()]+)('|")\)?/);
                    e && d.push(c(e[2]));
                }
                b.mimeType && b.mimeType.startsWith("image/") && d.push(c(b.uri));
                a.K.set(b, d);
            }
        }
        function tt(a, b) {
            if (a.K.has(b)) {
                var c = a.K.get(b);
                c = u(c);
                for(var d = c.next(); !d.done; d = c.next())d = d.value, d.parentNode.removeChild(d);
                a.K.delete(b);
            }
        }
        function It(a, b, c) {
            a.na(new R(b, c));
        }
        function Kt(a) {
            a = /^([a-zA-Z][a-zA-Z0-9+.-]*):/.exec(a.replace(/[\u0000-\u0020]+/g, ""));
            if (!a) return !0;
            a = a[1].toLowerCase();
            return a == "http" || a == "https";
        }
        function Lt(a, b, c, d, e) {
            this.h = a;
            this.j = Vd(this.h.skipOffset);
            this.g = e;
            this.i = b;
            this.l = c;
            this.o = d;
            this.m = !1;
        }
        p = Lt.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !1;
        };
        p.hasCustomClick = function() {
            return !1;
        };
        p.isUsingAnotherMediaElement = function() {
            return !1;
        };
        p.getDuration = function() {
            return this.h.durationInSeconds;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            return this.h.startTimeInSeconds + this.h.durationInSeconds - this.g.currentTime;
        };
        p.isPaused = function() {
            return this.g.paused;
        };
        p.isSkippable = function() {
            return typeof this.j == "number" ? !0 : !1;
        };
        p.getTimeUntilSkippable = function() {
            if (typeof this.j != "number") return this.getRemainingTime();
            var a = this.getRemainingTime() + this.j - this.getDuration();
            return Math.max(a, 0);
        };
        p.canSkipNow = function() {
            return this.getTimeUntilSkippable() == 0;
        };
        p.skip = function() {
            this.m = !0;
            this.g.currentTime += this.getRemainingTime();
        };
        p.pause = function() {
            return this.g.pause();
        };
        p.play = function() {
            return this.g.play();
        };
        p.getVolume = function() {
            return this.g.volume;
        };
        p.setVolume = function(a) {
            this.g.volume = a;
        };
        p.isMuted = function() {
            return this.g.muted;
        };
        p.isLinear = function() {
            return this.o;
        };
        p.resize = function() {};
        p.setMuted = function(a) {
            this.g.muted = a;
        };
        p.getSequenceLength = function() {
            return this.l ? this.l : 1;
        };
        p.getPositionInSequence = function() {
            return this.i ? this.i : 1;
        };
        p.getTitle = function() {
            return this.h.adTitle;
        };
        p.getDescription = function() {
            return "";
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return 0;
        };
        p.getVastMediaWidth = function() {
            return 0;
        };
        p.getVastAdId = function() {
            return this.h.vastAdId || "";
        };
        p.getAdId = function() {
            return this.h.adId;
        };
        p.getCreativeAdId = function() {
            return this.h.creativeId;
        };
        p.getAdvertiserName = function() {
            return "";
        };
        p.getMediaUrl = function() {
            return null;
        };
        p.getTimeOffset = function() {
            return 0;
        };
        p.getPodIndex = function() {
            return 0;
        };
        p.release = function() {
            this.l = this.i = this.g = this.h = null;
        };
        O("shaka.ads.MediaTailorAd", Lt);
        Lt.prototype.release = Lt.prototype.release;
        Lt.prototype.getPodIndex = Lt.prototype.getPodIndex;
        Lt.prototype.getTimeOffset = Lt.prototype.getTimeOffset;
        Lt.prototype.getMediaUrl = Lt.prototype.getMediaUrl;
        Lt.prototype.getAdvertiserName = Lt.prototype.getAdvertiserName;
        Lt.prototype.getCreativeAdId = Lt.prototype.getCreativeAdId;
        Lt.prototype.getAdId = Lt.prototype.getAdId;
        Lt.prototype.getVastAdId = Lt.prototype.getVastAdId;
        Lt.prototype.getVastMediaWidth = Lt.prototype.getVastMediaWidth;
        Lt.prototype.getVastMediaHeight = Lt.prototype.getVastMediaHeight;
        Lt.prototype.getVastMediaBitrate = Lt.prototype.getVastMediaBitrate;
        Lt.prototype.getDescription = Lt.prototype.getDescription;
        Lt.prototype.getTitle = Lt.prototype.getTitle;
        Lt.prototype.getPositionInSequence = Lt.prototype.getPositionInSequence;
        Lt.prototype.getSequenceLength = Lt.prototype.getSequenceLength;
        Lt.prototype.setMuted = Lt.prototype.setMuted;
        Lt.prototype.resize = Lt.prototype.resize;
        Lt.prototype.isLinear = Lt.prototype.isLinear;
        Lt.prototype.isMuted = Lt.prototype.isMuted;
        Lt.prototype.setVolume = Lt.prototype.setVolume;
        Lt.prototype.getVolume = Lt.prototype.getVolume;
        Lt.prototype.play = Lt.prototype.play;
        Lt.prototype.pause = Lt.prototype.pause;
        Lt.prototype.skip = Lt.prototype.skip;
        Lt.prototype.canSkipNow = Lt.prototype.canSkipNow;
        Lt.prototype.getTimeUntilSkippable = Lt.prototype.getTimeUntilSkippable;
        Lt.prototype.isSkippable = Lt.prototype.isSkippable;
        Lt.prototype.isPaused = Lt.prototype.isPaused;
        Lt.prototype.getRemainingTime = Lt.prototype.getRemainingTime;
        Lt.prototype.getMinSuggestedDuration = Lt.prototype.getMinSuggestedDuration;
        Lt.prototype.getDuration = Lt.prototype.getDuration;
        Lt.prototype.isUsingAnotherMediaElement = Lt.prototype.isUsingAnotherMediaElement;
        Lt.prototype.hasCustomClick = Lt.prototype.hasCustomClick;
        Lt.prototype.isClientRendering = Lt.prototype.isClientRendering;
        Lt.prototype.needsSkipUI = Lt.prototype.needsSkipUI;
        function Mt(a, b, c, d) {
            this.D = a;
            this.K = b;
            this.h = c;
            this.l = null;
            this.P = NaN;
            this.i = d;
            this.J = !1;
            this.C = null;
            this.j = [];
            this.M = [];
            this.L = this.F = this.g = null;
            this.G = new Map;
            this.m = [];
            this.A = [];
            this.H = "";
            this.O = !0;
            this.I = "";
            this.o = new fd;
        }
        Mt.prototype.stop = function() {
            for(var a = u(this.m), b = a.next(); !b.done; b = a.next())b = b.value, this.o.Fa(b.target, b.type, b.listener);
            Nt(this);
            this.m = [];
            this.A = [];
            this.H = "";
            this.O = !0;
            this.I = "";
            this.C = null;
            this.j = [];
            this.M = [];
            this.G.clear();
        };
        Mt.prototype.release = function() {
            this.stop();
            this.o && this.o.release();
        };
        Mt.prototype.onManifestUpdated = function(a) {
            this.J = a;
            this.H != "" && (Ot(this, this.H, this.O), this.O = !1);
        };
        Mt.prototype.getCuePoints = function() {
            for(var a = [], b = u(this.j), c = b.next(); !c.done; c = b.next()){
                c = u(c.value.ads);
                for(var d = c.next(); !d.done; d = c.next())d = d.value, a.push({
                    start: d.startTimeInSeconds,
                    end: d.startTimeInSeconds + d.durationInSeconds
                });
            }
            return a;
        };
        function Pt(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t;
            H(function(v) {
                if (v.h == 1) return d = {
                    type: 7
                }, e = mh([
                    b
                ], Wg()), e.method = "POST", c && (f = JSON.stringify(c), e.body = hc(f)), g = a.K.request(7, e, d), v.m(2), v.g(g.promise, 4);
                if (v.h != 2) {
                    h = v.i;
                    k = bc(h.data);
                    l = JSON.parse(k);
                    if (l.manifestUrl && l.trackingUrl) m = new lb(b), n = new lb(l.trackingUrl), a.H = m.resolve(n).toString(), q = Date.now() / 1E3, r = q - a.P, a.i(new R("ads-loaded", (new Map).set("loadTime", r))), t = new lb(l.manifestUrl), a.l.resolve(m.resolve(t).toString()), a.l = null;
                    else throw Error("Insufficient data from MediaTailor.");
                    return v.o(0);
                }
                v.l();
                if (!a.I.length) return a.l.reject("MediaTailor request returned an error and there was no backup asset uri provided."), a.l = null, v.return();
                a.l.resolve(a.I);
                a.l = null;
                v.j();
            });
        }
        function Ot(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y;
            H(function(z) {
                if (z.h == 1) return d = {
                    type: 8
                }, e = mh([
                    b
                ], Wg()), f = a.K.request(7, e, d), z.m(2), z.g(f.promise, 4);
                if (z.h != 2) {
                    g = z.i;
                    h = [];
                    k = bc(g.data);
                    l = JSON.parse(k);
                    if (l.avails.length > 0) {
                        if (JSON.stringify(a.j) != JSON.stringify(l.avails)) {
                            a.j = l.avails;
                            m = u(a.j);
                            for(n = m.next(); !n.done; n = m.next())for(q = n.value, r = u(q.nonLinearAdsList), t = r.next(); !t.done; t = r.next())for(v = t.value, w = u(v.nonLinearAdList), x = w.next(); !x.done; x = w.next())y = x.value, Qt(a, y);
                            h = a.getCuePoints();
                            a.i(new R("ad-cue-points-changed", (new Map).set("cuepoints", h)));
                        }
                    } else a.j.length && a.i(new R("ad-cue-points-changed", (new Map).set("cuepoints", h))), Nt(a), a.j = [];
                    c && (a.J || h.length > 0) && Rt(a);
                    return z.o(0);
                }
                z.l();
                z.j();
            });
        }
        function Qt(a, b) {
            var c, d, e, f, g, h, k, l, m;
            H(function(n) {
                if (n.h == 1) {
                    if (!b.staticResource) return n.return();
                    c = St(b);
                    if (d = a.G.get(c)) return n.return();
                    e = {
                        type: 9
                    };
                    f = mh([
                        b.staticResource
                    ], Wg());
                    g = a.K.request(7, f, e);
                    n.m(2);
                    a.G.set(c, []);
                    return n.g(g.promise, 4);
                }
                if (n.h != 2) return h = n.i, k = bc(h.data), l = JSON.parse(k), m = l.apps, a.G.set(c, m), n.o(0);
                n.l();
                a.G.delete(c);
                n.j();
            });
        }
        function St(a) {
            return [
                a.adId,
                a.adParameters,
                a.adSystem,
                a.adTitle,
                a.creativeAdId,
                a.creativeId,
                a.creativeSequence,
                a.height,
                a.width,
                a.staticResource
            ].join("");
        }
        function Rt(a) {
            Tt(a);
            a.J || (Ut(a), a.o.u(a.h, "seeked", function() {
                Ut(a);
            }), a.o.u(a.h, "ended", function() {
                Nt(a);
            }));
            a.o.u(a.h, "timeupdate", function() {
                Tt(a);
            });
        }
        function Ut(a) {
            var b = a.h.currentTime;
            if (b != 0 && a.C == null) {
                for(var c, d, e = u(a.j), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    for(var g = u(f.ads), h = g.next(); !h.done; h = g.next())if (h = h.value, !d) h.startTimeInSeconds < b && (d = h, c = f);
                    else if (h.startTimeInSeconds < b && h.startTimeInSeconds > d.startTimeInSeconds + d.durationInSeconds) {
                        d = h;
                        c = f;
                        break;
                    }
                }
                c && d && !a.M.includes(d.adId) && (a.C = b, a.h.currentTime = c.startTimeInSeconds);
            }
        }
        function Tt(a) {
            if (a.h.duration && (a.g || a.j.length)) {
                var b = a.h.currentTime, c = !1;
                if (a.g) {
                    c = !0;
                    var d = a.F, e = d.startTimeInSeconds + .5 * d.durationInSeconds, f = d.startTimeInSeconds + .75 * d.durationInSeconds;
                    b >= d.startTimeInSeconds + .25 * d.durationInSeconds && !a.A.includes("firstQuartile") ? (a.A.push("firstQuartile"), Vt(a, "firstQuartile")) : b >= e && !a.A.includes("midpoint") ? (a.A.push("midpoint"), Vt(a, "midpoint")) : b >= f && !a.A.includes("thirdQuartile") && (a.A.push("thirdQuartile"), Vt(a, "thirdQuartile"));
                    d = a.g.getRemainingTime();
                    e = a.g.getDuration();
                    a.g.canSkipNow() && d > 0 && e > 0 && Vt(a, "skipStateChanged");
                    e > 0 && (d <= 0 || d > e) && Nt(a);
                }
                if (!a.g || !a.g.isLinear()) {
                    a: for(d = u(a.j), e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        if (a.g && a.g.isLinear()) break;
                        for(f = 0; f < e.ads.length; f++){
                            var g = e.ads[f], h = g.startTimeInSeconds + g.durationInSeconds;
                            if (g.startTimeInSeconds <= b && h > b) {
                                if (a.M.includes(g.adId)) {
                                    if (a.h.ended) continue;
                                    a.h.currentTime = h;
                                    break a;
                                }
                                Nt(a);
                                a.L = e;
                                a.g = new Lt(g, f + 1, e.ads.length, !0, a.h);
                                a.F = g;
                                f === 0 && Vt(a, "breakStart");
                                Wt(a);
                                break;
                            }
                        }
                    }
                    if (!a.g) for(d = u(a.j), e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        if (a.g) break;
                        for(f = 0; f < e.nonLinearAdsList.length; f++)if (g = e.nonLinearAdsList[f], g.nonLinearAdList.length) {
                            h = e.startTimeInSeconds;
                            var k = a.G.get(St(g.nonLinearAdList[0]));
                            if (h <= b && k && k.length) {
                                Nt(a);
                                h = a;
                                k = u(k);
                                for(var l = k.next(); !l.done; l = k.next())if (l = l.value, l.data.source.length) {
                                    var m = document.createElement("img");
                                    m.src = l.data.source[0].url;
                                    m.style.top = (l.placeholder.top || 0) + "%";
                                    m.style.height = 100 - (l.placeholder.top || 0) + "%";
                                    m.style.left = (l.placeholder.left || 0) + "%";
                                    m.style.maxWidth = 100 - (l.placeholder.left || 0) + "%";
                                    m.style.objectFit = "contain";
                                    m.style.position = "absolute";
                                    h.D.appendChild(m);
                                }
                                a.L = e;
                                a.g = new Lt(g, f + 1, e.ads.length, !1, a.h);
                                a.F = g;
                                f === 0 && Vt(a, "breakStart");
                                Wt(a);
                                break;
                            }
                        }
                    }
                    c && !a.g && (b = a.h.currentTime, a.C && a.C > b && (a.h.currentTime = a.C), a.C = null);
                }
            }
        }
        function Nt(a) {
            if (a.g) {
                for(; a.D.lastChild;)a.D.removeChild(a.D.firstChild);
                a.J || a.M.push(a.F.adId);
                var b = a.g.m;
                (b === void 0 ? 0 : b) ? Vt(a, "skip") : Vt(a, "complete");
                b = u(a.m);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, a.o.Fa(c.target, c.type, c.listener);
                a.m = [];
                a.A = [];
                b = a.g.getPositionInSequence();
                c = a.g.getSequenceLength();
                b === c && Vt(a, "breakEnd");
                a.g = null;
                a.F = null;
                a.L = null;
            }
        }
        function Wt(a) {
            var b = !1;
            a.h.paused ? b = !0 : (Vt(a, "impression"), Vt(a, "start"));
            a.m.push({
                target: a.h,
                type: "volumechange",
                listener: function() {
                    a.h.muted && Vt(a, "mute");
                }
            });
            a.m.push({
                target: a.h,
                type: "volumechange",
                listener: function() {
                    a.h.muted || Vt(a, "unmute");
                }
            });
            a.m.push({
                target: a.h,
                type: "play",
                listener: function() {
                    b ? (Vt(a, "impression"), Vt(a, "start"), b = !1) : Vt(a, "resume");
                }
            });
            a.m.push({
                target: a.h,
                type: "pause",
                listener: function() {
                    Vt(a, "pause");
                }
            });
            for(var c = u(a.m), d = c.next(); !d.done; d = c.next())d = d.value, a.o.u(d.target, d.type, d.listener);
        }
        function Vt(a, b) {
            var c = a.F.trackingEvents.find(function(f) {
                return f.eventType == b;
            });
            c || (c = a.L.adBreakTrackingEvents.find(function(f) {
                return f.eventType == b;
            }));
            if (c) {
                var d = {
                    type: 10
                };
                c = u(c.beaconUrls);
                for(var e = c.next(); !e.done; e = c.next())(e = e.value) && e != "" && (e = mh([
                    e
                ], Wg()), e.method = "POST", a.K.request(7, e, d));
            }
            switch(b){
                case "impression":
                    a.i(new R("ad-impression"));
                    break;
                case "start":
                    a.i(new R("ad-started", (new Map).set("ad", a.g)));
                    break;
                case "mute":
                    a.i(new R("ad-muted"));
                    break;
                case "unmute":
                    a.i(new R("ad-volume-changed"));
                    break;
                case "resume":
                    a.i(new R("ad-resumed"));
                    break;
                case "pause":
                    a.i(new R("ad-paused"));
                    break;
                case "firstQuartile":
                    a.i(new R("ad-first-quartile"));
                    break;
                case "midpoint":
                    a.i(new R("ad-midpoint"));
                    break;
                case "thirdQuartile":
                    a.i(new R("ad-third-quartile"));
                    break;
                case "complete":
                    a.i(new R("ad-complete"));
                    a.i(new R("ad-stopped"));
                    break;
                case "skip":
                    a.i(new R("ad-skipped"));
                    a.i(new R("ad-stopped"));
                    break;
                case "breakStart":
                    a.D.setAttribute("ad-active", "true");
                    break;
                case "breakEnd":
                    a.D.removeAttribute("ad-active");
                    break;
                case "skipStateChanged":
                    a.i(new R("ad-skip-state-changed"));
            }
        }
        function Xt(a, b) {
            this.g = a;
            this.i = null;
            this.h = b;
        }
        p = Xt.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !1;
        };
        p.hasCustomClick = function() {
            return !0;
        };
        p.isUsingAnotherMediaElement = function() {
            return !1;
        };
        p.getDuration = function() {
            return this.i ? this.i.duration : -1;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            return this.i ? this.i.duration - this.i.currentTime : -1;
        };
        p.isPaused = function() {
            return this.h.paused;
        };
        p.isSkippable = function() {
            return this.g.isSkippable();
        };
        p.getTimeUntilSkippable = function() {
            var a = this.g.getSkipTimeOffset();
            a = this.getRemainingTime() - a;
            return Math.max(a, 0);
        };
        p.canSkipNow = function() {
            return this.getTimeUntilSkippable() == 0;
        };
        p.skip = function() {
            this.h.currentTime += this.getRemainingTime();
        };
        p.pause = function() {
            return this.h.pause();
        };
        p.play = function() {
            return this.h.play();
        };
        p.getVolume = function() {
            return this.h.volume;
        };
        p.setVolume = function(a) {
            this.h.volume = a;
        };
        p.isMuted = function() {
            return this.h.muted;
        };
        p.isLinear = function() {
            return !0;
        };
        p.resize = function() {};
        p.setMuted = function(a) {
            this.h.muted = a;
        };
        p.getSequenceLength = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getTotalAds();
        };
        p.getPositionInSequence = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getAdPosition();
        };
        p.getTitle = function() {
            return this.g.getTitle();
        };
        p.getDescription = function() {
            return this.g.getDescription();
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return this.g.getVastMediaHeight();
        };
        p.getVastMediaWidth = function() {
            return this.g.getVastMediaWidth();
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.g.getAdId();
        };
        p.getCreativeAdId = function() {
            return this.g.getCreativeAdId();
        };
        p.getAdvertiserName = function() {
            return this.g.getAdvertiserName();
        };
        p.getMediaUrl = function() {
            return null;
        };
        p.getTimeOffset = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getTimeOffset();
        };
        p.getPodIndex = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getPodIndex();
        };
        p.release = function() {
            this.h = this.i = this.g = null;
        };
        O("shaka.ads.ServerSideAd", Xt);
        Xt.prototype.release = Xt.prototype.release;
        Xt.prototype.getPodIndex = Xt.prototype.getPodIndex;
        Xt.prototype.getTimeOffset = Xt.prototype.getTimeOffset;
        Xt.prototype.getMediaUrl = Xt.prototype.getMediaUrl;
        Xt.prototype.getAdvertiserName = Xt.prototype.getAdvertiserName;
        Xt.prototype.getCreativeAdId = Xt.prototype.getCreativeAdId;
        Xt.prototype.getAdId = Xt.prototype.getAdId;
        Xt.prototype.getVastAdId = Xt.prototype.getVastAdId;
        Xt.prototype.getVastMediaWidth = Xt.prototype.getVastMediaWidth;
        Xt.prototype.getVastMediaHeight = Xt.prototype.getVastMediaHeight;
        Xt.prototype.getVastMediaBitrate = Xt.prototype.getVastMediaBitrate;
        Xt.prototype.getDescription = Xt.prototype.getDescription;
        Xt.prototype.getTitle = Xt.prototype.getTitle;
        Xt.prototype.getPositionInSequence = Xt.prototype.getPositionInSequence;
        Xt.prototype.getSequenceLength = Xt.prototype.getSequenceLength;
        Xt.prototype.setMuted = Xt.prototype.setMuted;
        Xt.prototype.resize = Xt.prototype.resize;
        Xt.prototype.isLinear = Xt.prototype.isLinear;
        Xt.prototype.isMuted = Xt.prototype.isMuted;
        Xt.prototype.setVolume = Xt.prototype.setVolume;
        Xt.prototype.getVolume = Xt.prototype.getVolume;
        Xt.prototype.play = Xt.prototype.play;
        Xt.prototype.pause = Xt.prototype.pause;
        Xt.prototype.skip = Xt.prototype.skip;
        Xt.prototype.canSkipNow = Xt.prototype.canSkipNow;
        Xt.prototype.getTimeUntilSkippable = Xt.prototype.getTimeUntilSkippable;
        Xt.prototype.isSkippable = Xt.prototype.isSkippable;
        Xt.prototype.isPaused = Xt.prototype.isPaused;
        Xt.prototype.getRemainingTime = Xt.prototype.getRemainingTime;
        Xt.prototype.getMinSuggestedDuration = Xt.prototype.getMinSuggestedDuration;
        Xt.prototype.getDuration = Xt.prototype.getDuration;
        Xt.prototype.isUsingAnotherMediaElement = Xt.prototype.isUsingAnotherMediaElement;
        Xt.prototype.hasCustomClick = Xt.prototype.hasCustomClick;
        Xt.prototype.isClientRendering = Xt.prototype.isClientRendering;
        Xt.prototype.needsSkipUI = Xt.prototype.needsSkipUI;
        function Yt(a, b, c, d) {
            var e = this;
            this.A = a;
            this.l = b;
            this.j = null;
            this.G = NaN;
            this.i = d;
            this.H = !1;
            this.C = this.m = this.o = null;
            this.D = "";
            this.F = [];
            this.h = new fd;
            a = new google.ima.dai.api.UiSettings;
            a.setLocale(c);
            this.g = new google.ima.dai.api.StreamManager(this.l, this.A, a);
            this.i(new R("ima-stream-manager-loaded", (new Map).set("imaStreamManager", this.g)));
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.LOADED, function(f) {
                Zt(e, f);
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.ERROR, function() {
                e.D.length ? e.j.resolve(e.D) : e.j.reject("IMA Stream request returned an error and there was no backup asset uri provided.");
                e.j = null;
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED, function() {});
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.STARTED, function(f) {
                f = f.getAd();
                e.m = new Xt(f, e.l);
                e.C && (e.m.i = e.C);
                e.i(new R("ad-started", (new Map).set("ad", e.m)));
                e.A.setAttribute("ad-active", "true");
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED, function() {
                e.A.removeAttribute("ad-active");
                var f = e.l.currentTime;
                e.o && e.o > f && (e.l.currentTime = e.o, e.o = null);
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.AD_PROGRESS, function(f) {
                e.C = f.getStreamData().adProgressData;
                e.m && (e.m.i = e.C);
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.FIRST_QUARTILE, function() {
                e.i(new R("ad-first-quartile"));
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.MIDPOINT, function() {
                e.i(new R("ad-midpoint"));
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.THIRD_QUARTILE, function() {
                e.i(new R("ad-third-quartile"));
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.COMPLETE, function() {
                e.i(new R("ad-complete"));
                e.i(new R("ad-stopped"));
                e.A.removeAttribute("ad-active");
                e.m = null;
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.SKIPPED, function() {
                e.i(new R("ad-skipped"));
                e.i(new R("ad-stopped"));
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.CUEPOINTS_CHANGED, function(f) {
                var g = f.getStreamData();
                f = [];
                g = u(g.cuepoints);
                for(var h = g.next(); !h.done; h = g.next())h = h.value, f.push({
                    start: h.start,
                    end: h.end
                });
                e.F = f;
                e.i(new R("ad-cue-points-changed", (new Map).set("cuepoints", f)));
            });
        }
        p = Yt.prototype;
        p.configure = function() {};
        p.stop = function() {
            this.D = "";
            this.o = null;
            this.F = [];
        };
        p.release = function() {
            this.stop();
            this.h && this.h.release();
        };
        p.onCueMetadataChange = function(a) {
            if (a.key && a.data) {
                var b = {};
                b[a.key] = a.data;
                this.g.onTimedMetadata(b);
            }
        };
        p.getCuePoints = function() {
            return this.F;
        };
        function Zt(a, b) {
            a.i(new R("ads-loaded", (new Map).set("loadTime", Date.now() / 1E3 - a.G)));
            b = b.getStreamData().url;
            a.j.resolve(b);
            a.j = null;
            a.H || a.h.u(a.l, "seeked", function() {
                var c = a.l.currentTime;
                if (c != 0) {
                    a.g.streamTimeForContentTime(c);
                    var d = a.g.previousCuePointForStreamTime(c);
                    d && !d.played && (a.o = c, a.l.currentTime = d.start);
                }
            });
        }
        function X() {
            fb.call(this);
            this.h = this.i = this.j = this.g = null;
            this.m = new Zs;
            this.o = navigator.language;
            this.l = null;
        }
        oa(X, fb);
        p = X.prototype;
        p.setLocale = function(a) {
            this.o = a;
        };
        p.configure = function(a) {
            this.l = a;
            this.g && this.g.configure(this.l);
            this.j && this.j.configure(this.l);
            this.h && this.h.configure(this.l);
        };
        p.initInterstitial = function(a, b, c) {
            var d = this;
            this.g && this.g.release();
            this.g = new nt(a, b, c, function(e) {
                return $t(d, e);
            });
            this.g.configure(this.l);
        };
        p.initClientSide = function(a, b, c) {
            var d = this;
            if (!window1.google || !google.ima || !google.ima.AdsLoader) throw new T(2, 10, 1E4);
            this.j && this.j.release();
            this.j = new ft(a, b, this.o, c, function(e) {
                return $t(d, e);
            });
            this.j.configure(this.l);
        };
        p.release = function() {
            this.g && (this.g.release(), this.g = null);
            this.j && (this.j.release(), this.j = null);
            this.i && (this.i.release(), this.i = null);
            this.h && (this.h.release(), this.h = null);
            fb.prototype.release.call(this);
        };
        p.onAssetUnload = function() {
            this.g && this.g.stop();
            this.j && this.j.stop();
            this.i && this.i.stop();
            this.h && this.h.stop();
            this.dispatchEvent(new R("ad-stopped"));
            this.dispatchEvent(new R("ad-content-attach-requested"));
            this.m = new Zs;
        };
        p.requestClientSideAds = function(a) {
            if (!this.j) throw new T(1, 10, 10001);
            var b = this.j;
            b.g && b.g.destroy();
            b.m && b.m.contentComplete();
            b.H = Date.now() / 1E3;
            b.m.requestAds(a);
        };
        p.updateClientSideAdsRenderingSettings = function(a) {
            if (!this.j) throw new T(1, 10, 10001);
            var b = this.j;
            b.D = a;
            b.g && b.g.updateAdsRenderingSettings(b.D);
        };
        p.initMediaTailor = function(a, b, c) {
            var d = this;
            this.i && this.i.release();
            this.i = new Mt(a, b, c, function(e) {
                return $t(d, e);
            });
        };
        p.requestMediaTailorStream = function(a, b, c) {
            if (!this.i) throw new T(1, 10, 10005);
            var d = this.i;
            c = c === void 0 ? "" : c;
            d.l ? a = Promise.reject(new T(1, 10, 10004)) : (d.l = new Yg, Pt(d, a, b), d.I = c || "", d.P = Date.now() / 1E3, a = d.l);
            return a;
        };
        p.addMediaTailorTrackingUrl = function(a) {
            if (!this.i) throw new T(1, 10, 10005);
            var b = this.i;
            b.H = a;
            b.i(new R("ads-loaded", (new Map).set("loadTime", 0)));
        };
        p.initServerSide = function(a, b) {
            var c = this;
            if (!window1.google || !google.ima || !google.ima.dai) throw new T(2, 10, 10002);
            this.h && this.h.release();
            this.h = new Yt(a, b, this.o, function(d) {
                return $t(c, d);
            });
            this.h.configure(this.l);
        };
        p.requestServerSideStream = function(a, b) {
            b = b === void 0 ? "" : b;
            if (!this.h) throw new T(1, 10, 10003);
            a.adTagParameters || (a.adTagParameters = {});
            var c = a.adTagParameters;
            (c.mpt || c.mpv) && Za('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overridden.');
            a.adTagParameters.mpt = "shaka-player";
            a.adTagParameters.mpv = "v4.16.44";
            c = this.h;
            c.j ? a = Promise.reject(new T(1, 10, 10004)) : (a instanceof google.ima.dai.api.LiveStreamRequest && (c.H = !0), c.j = new Yg, c.g.requestStream(a), c.D = b || "", c.G = Date.now() / 1E3, a = c.j);
            return a;
        };
        p.replaceServerSideAdTagParameters = function(a) {
            if (!this.h) throw new T(1, 10, 10003);
            (a.mpt || a.mpv) && Za('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overridden.');
            a.mpt = "Shaka Player";
            a.mpv = "v4.16.44";
            this.h.g.replaceAdTagParameters(a);
        };
        p.getServerSideCuePoints = function() {
            md("AdManager.getServerSideCuePoints", "Please use getCuePoints function.");
            return this.getCuePoints();
        };
        p.getCuePoints = function() {
            var a = [];
            this.h && (a = a.concat(this.h.getCuePoints()));
            this.i && (a = a.concat(this.i.getCuePoints()));
            return a;
        };
        p.getStats = function() {
            var a = this.m;
            return {
                loadTimes: a.g,
                averageLoadTime: $s(a),
                started: a.h,
                overlayAds: a.j,
                playedCompletely: a.l,
                skipped: a.m,
                errors: a.i
            };
        };
        p.onManifestUpdated = function(a) {
            if (this.i) this.i.onManifestUpdated(a);
        };
        p.onDashTimedMetadata = function(a) {
            this.h && a.schemeIdUri == "urn:google:dai:2018" && this.h.g.processMetadata(a.schemeIdUri, a.eventNode ? a.eventNode.attributes.messageData : null, a.startTime);
        };
        p.onHlsTimedMetadata = function(a, b) {
            this.h && this.h.g.processMetadata("ID3", a.data, b);
        };
        p.onCueMetadataChange = function(a) {
            if (this.h) this.h.onCueMetadataChange(a);
        };
        p.onHLSInterstitialMetadata = function(a, b, c) {
            this.l && this.l.disableHLSInterstitial || (this.g || this.initInterstitial(null, a, b), this.g && At(this.g, c));
        };
        p.onDASHInterstitialMetadata = function(a, b, c) {
            if (!this.l || !this.l.disableDASHInterstitial) {
                var d = c.schemeIdUri;
                if (d == "urn:mpeg:dash:event:alternativeMPD:insert:2025" || d == "urn:mpeg:dash:event:alternativeMPD:replace:2025") {
                    if (this.g || this.initInterstitial(null, a, b), this.g && (a = this.g, b = c.schemeIdUri == "urn:mpeg:dash:event:alternativeMPD:replace:2025", d = c.schemeIdUri == "urn:mpeg:dash:event:alternativeMPD:insert:2025", b || d)) {
                        for(var e = c.startTime, f = c.endTime, g = null, h = 0, k, l = u(c.eventNode.children), m = l.next(); !m.done; m = l.next())if (m = m.value, m.tagName == "AlternativeMPD") {
                            if (m = m.attributes.uri) {
                                k = m;
                                break;
                            }
                        } else if (m.tagName == "InsertPresentation" || m.tagName == "ReplacePresentation") {
                            var n = m.attributes.uri || m.attributes.url;
                            if (n) {
                                k = jc(n);
                                (l = qe(m, "maxDuration", we)) && (g = l / c.timescale);
                                (l = qe(m, "returnOffset", we)) && (h = l / c.timescale);
                                b && h && (f = e + h);
                                break;
                            }
                        }
                        k && Dt(a, [
                            {
                                id: c.id,
                                groupId: null,
                                startTime: e,
                                endTime: f,
                                uri: k,
                                mimeType: null,
                                isSkippable: !1,
                                skipOffset: null,
                                skipFor: null,
                                canJump: !0,
                                resumeOffset: d ? h : null,
                                playoutLimit: g,
                                once: !1,
                                pre: !1,
                                post: !1,
                                timelineRange: b && !d,
                                loop: !1,
                                overlay: null,
                                displayOnBackground: !1,
                                currentVideo: null,
                                background: null,
                                clickThroughUrl: null
                            }
                        ]);
                    }
                } else (d == "urn:mpeg:dash:event:2012" || d == "urn:scte:dash:scte214-events") && c.eventNode && ne(c.eventNode, "OverlayEvent") && (this.g || this.initInterstitial(null, a, b), this.g && Et(this.g, c));
            }
        };
        p.addCustomInterstitial = function(a) {
            if (!this.g) throw new T(1, 10, 10006);
            Dt(this.g, [
                a
            ]);
        };
        p.addAdUrlInterstitial = function(a) {
            if (!this.g) throw new T(1, 10, 10006);
            return this.g.addAdUrlInterstitial(a);
        };
        p.getInterstitialPlayer = function() {
            if (!this.g) throw new T(1, 10, 10006);
            return this.g.Rb();
        };
        function $t(a, b) {
            if (b && b.type) switch(b.type){
                case "ads-loaded":
                    a.m.g.push(b.loadTime);
                    break;
                case "ad-started":
                    a.m.h++;
                    var c = b.ad;
                    c && !c.isLinear() && a.m.j++;
                    break;
                case "ad-complete":
                    a.m.l++;
                    break;
                case "ad-skipped":
                    a.m.m++;
                    break;
                case "ad-error":
                    a.m.i++;
            }
            a.dispatchEvent(b);
        }
        O("shaka.ads.AdManager", X);
        X.prototype.getInterstitialPlayer = X.prototype.getInterstitialPlayer;
        X.prototype.addAdUrlInterstitial = X.prototype.addAdUrlInterstitial;
        X.prototype.addCustomInterstitial = X.prototype.addCustomInterstitial;
        X.prototype.onDASHInterstitialMetadata = X.prototype.onDASHInterstitialMetadata;
        X.prototype.onHLSInterstitialMetadata = X.prototype.onHLSInterstitialMetadata;
        X.prototype.onCueMetadataChange = X.prototype.onCueMetadataChange;
        X.prototype.onHlsTimedMetadata = X.prototype.onHlsTimedMetadata;
        X.prototype.onDashTimedMetadata = X.prototype.onDashTimedMetadata;
        X.prototype.onManifestUpdated = X.prototype.onManifestUpdated;
        X.prototype.getStats = X.prototype.getStats;
        X.prototype.getCuePoints = X.prototype.getCuePoints;
        X.prototype.getServerSideCuePoints = X.prototype.getServerSideCuePoints;
        X.prototype.replaceServerSideAdTagParameters = X.prototype.replaceServerSideAdTagParameters;
        X.prototype.requestServerSideStream = X.prototype.requestServerSideStream;
        X.prototype.initServerSide = X.prototype.initServerSide;
        X.prototype.addMediaTailorTrackingUrl = X.prototype.addMediaTailorTrackingUrl;
        X.prototype.requestMediaTailorStream = X.prototype.requestMediaTailorStream;
        X.prototype.initMediaTailor = X.prototype.initMediaTailor;
        X.prototype.updateClientSideAdsRenderingSettings = X.prototype.updateClientSideAdsRenderingSettings;
        X.prototype.requestClientSideAds = X.prototype.requestClientSideAds;
        X.prototype.onAssetUnload = X.prototype.onAssetUnload;
        X.prototype.release = X.prototype.release;
        X.prototype.initClientSide = X.prototype.initClientSide;
        X.prototype.initInterstitial = X.prototype.initInterstitial;
        X.prototype.configure = X.prototype.configure;
        X.prototype.setLocale = X.prototype.setLocale;
        X.ADS_LOADED = "ads-loaded";
        X.AD_STARTED = "ad-started";
        X.AD_FIRST_QUARTILE = "ad-first-quartile";
        X.AD_MIDPOINT = "ad-midpoint";
        X.AD_THIRD_QUARTILE = "ad-third-quartile";
        X.AD_COMPLETE = "ad-complete";
        X.AD_STOPPED = "ad-stopped";
        X.AD_SKIPPED = "ad-skipped";
        X.AD_VOLUME_CHANGED = "ad-volume-changed";
        X.AD_MUTED = "ad-muted";
        X.AD_PAUSED = "ad-paused";
        X.AD_RESUMED = "ad-resumed";
        X.AD_SKIP_STATE_CHANGED = "ad-skip-state-changed";
        X.CUEPOINTS_CHANGED = "ad-cue-points-changed";
        X.IMA_AD_MANAGER_LOADED = "ima-ad-manager-loaded";
        X.IMA_STREAM_MANAGER_LOADED = "ima-stream-manager-loaded";
        X.AD_CLICKED = "ad-clicked";
        X.AD_PROGRESS = "ad-progress";
        X.AD_BUFFERING = "ad-buffering";
        X.AD_IMPRESSION = "ad-impression";
        X.AD_DURATION_CHANGED = "ad-duration-changed";
        X.AD_CLOSED = "ad-closed";
        X.AD_LOADED = "ad-loaded";
        X.ALL_ADS_COMPLETED = "all-ads-completed";
        X.AD_LINEAR_CHANGED = "ad-linear-changed";
        X.AD_METADATA = "ad-metadata";
        X.AD_RECOVERABLE_ERROR = "ad-recoverable-error";
        X.AD_ERROR = "ad-error";
        X.AD_BREAK_READY = "ad-break-ready";
        X.AD_INTERACTION = "ad-interaction";
        X.AD_CONTENT_PAUSE_REQUESTED = "ad-content-pause-requested";
        X.AD_CONTENT_RESUME_REQUESTED = "ad-content-resume-requested";
        X.AD_CONTENT_ATTACH_REQUESTED = "ad-content-attach-requested";
        sr = function() {
            return new X;
        };
        function au(a) {
            return JSON.stringify(a, function(b, c) {
                if (typeof c != "function") {
                    b = c instanceof R;
                    if (c instanceof Event || b) {
                        var d = {};
                        for(f in c){
                            var e = c[f];
                            e && typeof e == "object" ? f == "detail" ? d[f] = e : e instanceof Event || e instanceof R ? d[f] = {
                                __type__: "Event",
                                event: au(e)
                            } : b && Array.isArray(e) && (d[f] = e) : f in Event || (d[f] = e);
                        }
                        return d;
                    }
                    if (c instanceof Error) {
                        var f = new Set([
                            "name",
                            "message",
                            "stack"
                        ]);
                        for(d in c)f.add(d);
                        b = u(Object.getOwnPropertyNames(c));
                        for(d = b.next(); !d.done; d = b.next())f.add(d.value);
                        b = {};
                        f = u(f);
                        for(d = f.next(); !d.done; d = f.next())d = d.value, b[d] = c[d];
                        c = {
                            __type__: "Error",
                            contents: b
                        };
                    } else if (c instanceof TimeRanges) {
                        f = {
                            __type__: "TimeRanges",
                            length: c.length,
                            start: [],
                            end: []
                        };
                        c = u(Yj(c));
                        for(b = c.next(); !b.done; b = c.next())b = b.value, d = b.end, f.start.push(b.start), f.end.push(d);
                        c = f;
                    } else c = ArrayBuffer.isView(c) && c.BYTES_PER_ELEMENT === 1 ? {
                        __type__: "Uint8Array",
                        entries: Array.from(c)
                    } : typeof c == "number" ? isNaN(c) ? "NaN" : isFinite(c) ? c : c < 0 ? "-Infinity" : "Infinity" : c;
                    return c;
                }
            });
        }
        function bu(a) {
            return JSON.parse(a, function(b, c) {
                if (c == "NaN") var d = NaN;
                else if (c == "-Infinity") d = -Infinity;
                else if (c == "Infinity") d = Infinity;
                else if (c && typeof c == "object" && c.__type__ == "TimeRanges") d = cu(c);
                else if (c && typeof c == "object" && c.__type__ == "Uint8Array") d = new Uint8Array(c.entries);
                else if (c && typeof c == "object" && c.__type__ == "Error") {
                    b = c.contents;
                    c = Error(b.message);
                    for(d in b)c[d] = b[d];
                    d = c;
                } else d = c && typeof c == "object" && c.__type__ == "Event" ? bu(c.event) : c;
                return d;
            });
        }
        function cu(a) {
            return {
                length: a.length,
                start: function(b) {
                    return a.start[b];
                },
                end: function(b) {
                    return a.end[b];
                }
            };
        }
        var du = "ended play playing pause pausing ratechange seeked seeking timeupdate volumechange".split(" "), eu = "buffered currentTime duration ended loop muted paused playbackRate seeking videoHeight videoWidth volume".split(" "), fu = [
            "loop",
            "playbackRate"
        ], gu = [
            "pause",
            "play"
        ], hu = (new Map).set("getAssetUri", 2).set("getAudioLanguages", 4).set("getAudioLanguagesAndRoles", 4).set("getBufferFullness", 1).set("getBufferedInfo", 2).set("getExpiration", 2).set("getKeyStatuses", 2).set("getPlaybackRate", 2).set("getTextLanguages", 4).set("getTextLanguagesAndRoles", 4).set("isAudioOnly", 10).set("isBuffering", 1).set("isInProgress", 1).set("isLive", 10).set("isTextTrackVisible", 1).set("isVideoOnly", 10).set("keySystem", 10).set("seekRange", 1).set("getLoadMode", 10).set("getManifestType", 10).set("isFullyLoaded", 1).set("isEnded", 1).set("getBandwidthEstimate", 1).set("isRemotePlayback", 1), iu = (new Map).set("getConfiguration", 4).set("getConfigurationForLowLatency", 4).set("getStats", 5).set("getAudioTracks", 2).set("getChaptersTracks", 2).set("getImageTracks", 2).set("getVideoTracks", 2).set("getTextTracks", 2).set("getVariantTracks", 2), ju = (new Map).set("getPlayheadTimeAsDate", 1).set("getPresentationStartTimeAsDate", 20).set("getSegmentAvailabilityDuration", 20), ku = [
            [
                "getConfiguration",
                "configure",
                "getConfigurationForLowLatency",
                "configurationForLowLatency"
            ]
        ], lu = [
            [
                "isTextTrackVisible",
                "setTextTrackVisibility"
            ]
        ], mu = "cancelTrickPlay configure configurationForLowLatency getChapters resetConfiguration retryStreaming selectAudioLanguage selectAudioTrack selectTextLanguage selectTextTrack selectVariantTrack selectVariantsByLabel selectVideoTrack setTextTrackVisibility trickPlay updateStartTime goToLive useTrickPlayTrackIfAvailable".split(" "), nu = "addChaptersTrack addTextTrackAsync addThumbnailsTrack getAllThumbnails getChaptersAsync getThumbnails attach attachCanvas detach load unload".split(" ");
        function ou(a, b, c, d, e, f, g) {
            var h = this;
            this.H = a;
            this.K = g;
            this.l = new Uf(b);
            this.L = c;
            this.A = !1;
            this.C = d;
            this.G = e;
            this.M = f;
            this.i = this.m = !1;
            this.J = "";
            this.o = null;
            this.D = function() {
                return pu(h);
            };
            this.F = function(k, l) {
                k = bu(l);
                switch(k.type){
                    case "event":
                        var m = k.targetName, n = Va(k.event);
                        h.C(m, n);
                        break;
                    case "update":
                        m = k.update;
                        for(n in m){
                            k = h.g[n] || {};
                            for(var q in m[n])k[q] = m[n][q];
                        }
                        h.A && (h.L(), h.A = !1);
                        break;
                    case "asyncComplete":
                        if (q = k.id, n = k.error, l = k.res, k = h.h.get(q), h.h.delete(q), k) {
                            if (n) {
                                q = new T(n.severity, n.category, n.code);
                                for(m in n)q[m] = n[m];
                                k.reject(q);
                            } else k.resolve(l);
                        }
                }
            };
            this.g = {
                video: {},
                player: {}
            };
            this.I = 0;
            this.h = new Map;
            this.j = null;
            qu.add(this);
        }
        p = ou.prototype;
        p.destroy = function() {
            qu.delete(this);
            ru(this);
            su && tu(this);
            this.l && (this.l.stop(), this.l = null);
            this.G = this.C = null;
            this.i = this.m = !1;
            this.F = this.D = this.j = this.h = this.g = this.o = null;
            return Promise.resolve();
        };
        p.Qa = function() {
            return this.i;
        };
        p.Yf = function() {
            return this.J;
        };
        p.init = function() {
            if (this.H.length) {
                if (window1.chrome && chrome.cast && chrome.cast.isAvailable) {
                    this.m = !0;
                    this.l.La();
                    var a = new chrome.cast.SessionRequest(this.H, [], null, this.K, null);
                    a = new chrome.cast.ApiConfig(a, function(b) {
                        for(var c = u(qu), d = c.next(); !d.done; d = c.next()){
                            d = d.value;
                            var e = b;
                            d.j = new Yg;
                            d.A = !0;
                            uu(d, e);
                        }
                    }, function(b) {
                        for(var c = u(qu), d = c.next(); !d.done; d = c.next())d = d.value, vu = b == "available", d.l.La();
                    }, "origin_scoped");
                    chrome.cast.initialize(a, function() {}, function() {});
                    vu && this.l.Z(wu);
                    (a = su) && a.status != chrome.cast.SessionStatus.STOPPED ? (this.j = new Yg, this.A = !0, uu(this, a)) : su = null;
                } else window1.__onGCastApiAvailable !== xu && (yu = window1.__onGCastApiAvailable || null, window1.__onGCastApiAvailable = xu);
            }
        };
        p.gi = function(a) {
            this.o = a;
            this.i && zu(this, {
                type: "appData",
                appData: this.o
            });
        };
        p.cast = function() {
            var a = this;
            return H(function(b) {
                if (!a.m) throw new T(1, 8, 8E3);
                if (!vu) throw new T(1, 8, 8001);
                if (a.i) throw new T(1, 8, 8002);
                a.j = new Yg;
                chrome.cast.requestSession(function(c) {
                    return uu(a, c);
                }, function(c) {
                    return Au(a, c);
                });
                return b.g(a.j, 0);
            });
        };
        function Bu(a) {
            a.i && chrome.cast.requestSession(function(b) {
                return uu(a, b);
            }, function(b) {
                return Au(a, b);
            });
        }
        p.Bd = function() {
            if (this.i) {
                ru(this);
                if (su) {
                    tu(this);
                    try {
                        su.stop(function() {}, function() {});
                    } catch (a) {}
                    su = null;
                }
                pu(this);
            }
        };
        p.get = function(a, b) {
            var c = this;
            if (a == "video") {
                if (gu.includes(b)) return function() {
                    return c.Bj.apply(c, [
                        a,
                        b
                    ].concat(G(Ma.apply(0, arguments))));
                };
            } else if (a == "player") {
                if (ju.has(b) && !this.get("player", "isLive")()) return function() {};
                if (mu.includes(b)) return function() {
                    return c.Bj.apply(c, [
                        a,
                        b
                    ].concat(G(Ma.apply(0, arguments))));
                };
                if (nu.includes(b)) return function() {
                    return c.im.apply(c, [
                        a,
                        b
                    ].concat(G(Ma.apply(0, arguments))));
                };
                if (hu.has(b) || iu.has(b)) return function() {
                    return c.g[a][b];
                };
            }
            return this.g[a][b];
        };
        p.set = function(a, b, c) {
            this.g[a][b] = c;
            zu(this, {
                type: "set",
                targetName: a,
                property: b,
                value: c
            });
        };
        function uu(a, b) {
            var c = a.M();
            su = b;
            b.addUpdateListener(a.D);
            b.addMessageListener("urn:x-cast:com.google.shaka.v2", a.F);
            pu(a);
            zu(a, {
                type: "init",
                initState: c,
                appData: a.o
            });
            a.j.resolve();
        }
        function Au(a, b) {
            var c = 8003;
            switch(b.code){
                case "cancel":
                    c = 8004;
                    break;
                case "timeout":
                    c = 8005;
                    break;
                case "receiver_unavailable":
                    c = 8006;
            }
            a.j.reject(new T(2, 8, c, b));
        }
        p.Bj = function(a, b) {
            zu(this, {
                type: "call",
                targetName: a,
                methodName: b,
                args: Ma.apply(2, arguments)
            });
        };
        p.im = function(a, b) {
            var c = Ma.apply(2, arguments), d = new Yg, e = this.I.toString();
            this.I++;
            this.h.set(e, d);
            try {
                zu(this, {
                    type: "asyncCall",
                    targetName: a,
                    methodName: b,
                    args: c,
                    id: e
                });
            } catch (f) {
                d.reject(f);
            }
            return d;
        };
        function tu(a) {
            var b = su;
            b.removeUpdateListener(a.D);
            b.removeMessageListener("urn:x-cast:com.google.shaka.v2", a.F);
        }
        function pu(a) {
            var b = su ? su.status == "connected" : !1;
            if (a.i && !b) {
                a.G();
                for(var c in a.g)a.g[c] = {};
                ru(a);
            }
            a.i = b;
            a.J = b ? su.receiver.friendlyName : "";
            a.l.La();
        }
        function ru(a) {
            if (a.h) for(var b = u(a.h.keys()), c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = a.h.get(c);
                a.h.delete(c);
                d.reject(new T(1, 7, 7E3));
            }
        }
        function zu(a, b) {
            b = au(b);
            var c = su;
            try {
                c.sendMessage("urn:x-cast:com.google.shaka.v2", b, function() {}, bb);
            } catch (d) {
                throw b = new T(2, 8, 8005, d), c = new R("error", (new Map).set("detail", b)), a.C("player", c), a.Bd(), b;
            }
        }
        var wu = .02, vu = !1, su = null, yu = null, qu = new Set;
        function xu(a) {
            yu ? window1.__onGCastApiAvailable = yu : delete window1.__onGCastApiAvailable;
            yu = null;
            if (a) for(var b = u(qu), c = b.next(); !c.done; c = b.next())c.value.init();
            typeof window1.__onGCastApiAvailable === "function" && window1.__onGCastApiAvailable(a);
        }
        function Cu(a, b, c, d) {
            d = d === void 0 ? !1 : d;
            fb.call(this);
            var e = this;
            this.i = a;
            this.h = b;
            this.l = this.o = this.m = this.A = this.j = null;
            this.I = c;
            this.H = d;
            this.F = [];
            this.D = [];
            this.C = [];
            this.G = new Map;
            this.g = null;
            window1.chrome && Xb().Pa() != "CAST" ? (this.g = new ou(c, function() {
                return Du(e);
            }, function() {
                return Eu(e);
            }, function(f, g) {
                return Fu(e, f, g);
            }, function() {
                return Gu(e);
            }, function() {
                return Hu(e);
            }, d), Iu(this)) : (this.j = this.i, this.A = this.h);
        }
        oa(Cu, fb);
        p = Cu.prototype;
        p.destroy = function(a) {
            this.g && (a === void 0 ? 0 : a) && this.g.Bd();
            this.l && (this.l.release(), this.l = null);
            a = [];
            this.h && (a.push(this.h.destroy()), this.h = null);
            this.g && (a.push(this.g.destroy()), this.g = null);
            this.A = this.j = this.i = null;
            fb.prototype.release.call(this);
            return Promise.all(a);
        };
        p.Rc = function() {
            return this.j;
        };
        p.Rb = function() {
            return this.A;
        };
        p.Kg = function() {
            return this.g ? this.g.m && vu : !1;
        };
        p.Qa = function() {
            return this.g ? this.g.Qa() : !1;
        };
        p.Yf = function() {
            return this.g ? this.g.Yf() : "";
        };
        p.cast = function() {
            var a = this;
            return H(function(b) {
                return b.h == 1 ? a.g ? b.g(a.g.cast(), 2) : b.return() : a.h ? b.g(a.h.tc(), 0) : b.return();
            });
        };
        p.gi = function(a) {
            this.g && this.g.gi(a);
        };
        p.Yj = function() {
            this.g && Bu(this.g);
        };
        p.Bd = function() {
            this.g && this.g.Bd();
        };
        p.Qi = function(a, b) {
            b = b === void 0 ? !1 : b;
            var c = this;
            return H(function(d) {
                if (d.h == 1) {
                    if (a == c.I && b == c.H) return d.return();
                    c.I = a;
                    c.H = b;
                    if (!c.g) return d.return();
                    c.g.Bd();
                    return d.g(c.g.destroy(), 2);
                }
                c.g = null;
                c.g = new ou(a, function() {
                    return Du(c);
                }, function() {
                    return Eu(c);
                }, function(e, f) {
                    return Fu(c, e, f);
                }, function() {
                    return Gu(c);
                }, function() {
                    return Hu(c);
                }, b);
                c.g.init();
                d.j();
            });
        };
        function Iu(a) {
            a.g.init();
            a.l = new fd;
            for(var b = u(du), c = b.next(); !c.done; c = b.next())a.l.u(a.i, c.value, function(f) {
                a.g.Qa() || (f = Va(f), a.m.dispatchEvent(f));
            });
            for(var d in Wa)a.l.u(a.h, Wa[d], function(f) {
                a.g.Qa() || a.o.dispatchEvent(f);
            });
            a.j = {};
            b = {};
            for(var e in a.i)b = {
                ve: b.ve
            }, b.ve = e, Object.defineProperty(a.j, b.ve, {
                configurable: !1,
                enumerable: !0,
                get: function(f) {
                    return function() {
                        return Ju(a, f.ve);
                    };
                }(b),
                set: function(f) {
                    return function(g) {
                        var h = f.ve;
                        a.g.Qa() ? a.g.set("video", h, g) : a.i[h] = g;
                    };
                }(b)
            });
            a.A = {};
            Ku(a, function(f) {
                Object.defineProperty(a.A, f, {
                    configurable: !1,
                    enumerable: !0,
                    get: function() {
                        return Lu(a, f);
                    }
                });
            });
            Mu(a);
            a.m = new fb;
            a.m.We = a.j;
            a.o = new fb;
            a.o.We = a.A;
            a.l.u(a.h, "unloading", function() {
                a.g && a.g.Qa() || Nu(a);
            });
        }
        function Mu(a) {
            var b = new Map;
            Ku(a, function(c, d) {
                b.has(d) ? (d = b.get(d), c.length < d.length ? a.G.set(c, d) : a.G.set(d, c)) : b.set(d, c);
            });
        }
        function Ku(a, b) {
            function c(k) {
                return k == "constructor" || typeof d[k] != "function" ? !1 : !e.has(k);
            }
            var d = a.h, e = new Set, f;
            for(f in d)c(f) && (e.add(f), b(f, d[f]));
            a = Object.getPrototypeOf(d);
            for(f = Object.getPrototypeOf({}); a && a != f;){
                for(var g = u(Object.getOwnPropertyNames(a)), h = g.next(); !h.done; h = g.next())h = h.value, c(h) && (e.add(h), b(h, d[h]));
                a = Object.getPrototypeOf(a);
            }
        }
        function Hu(a) {
            var b = {
                video: {},
                player: {},
                playerAfterLoad: {},
                manifest: a.h.dd(),
                startTime: null,
                addThumbnailsTrackCalls: a.F,
                addTextTrackAsyncCalls: a.D,
                addChaptersTrackCalls: a.C
            };
            a.i.pause();
            for(var c = u(fu), d = c.next(); !d.done; d = c.next())d = d.value, b.video[d] = a.i[d];
            a.i.ended || (b.startTime = a.i.currentTime);
            c = u(ku);
            for(d = c.next(); !d.done; d = c.next()){
                var e = d.value;
                d = e[1];
                e = a.h[e[0]]();
                b.player[d] = e;
            }
            c = u(lu);
            for(d = c.next(); !d.done; d = c.next())e = d.value, d = e[1], e = a.h[e[0]](), b.playerAfterLoad[d] = e;
            return b;
        }
        function Du(a) {
            var b = new R("caststatuschanged");
            a.dispatchEvent(b);
        }
        function Eu(a) {
            var b = new R(a.j.paused ? "pause" : "play");
            a.m.dispatchEvent(b);
        }
        function Gu(a) {
            for(var b = u(ku), c = b.next(); !c.done; c = b.next()){
                var d = c.value;
                c = d[1];
                d = a.g.get("player", d[0])();
                a.h[c](d);
            }
            var e = a.F, f = a.D, g = a.C;
            Nu(a);
            var h = a.g.get("player", "getAssetUri")();
            d = a.g.get("video", "ended");
            b = Promise.resolve();
            var k = a.i.autoplay;
            c = null;
            d || (c = a.g.get("video", "currentTime"));
            var l;
            (d = a.g.get("player", "getTextTracks")()) && d.length && (l = d.find(function(q) {
                return q.active;
            }));
            var m = a.g.get("player", "isTextTrackVisible")();
            h && (a.i.autoplay = !1, b = a.h.load(h, c));
            var n = {};
            c = u(fu);
            for(d = c.next(); !d.done; d = c.next())d = d.value, n[d] = a.g.get("video", d);
            b.then(function() {
                if (a.i) {
                    for(var q = u(e), r = q.next(); !r.done; r = q.next()){
                        r = r.value;
                        var t;
                        (t = a.Rb()).cf.apply(t, G(r));
                    }
                    q = u(f);
                    for(t = q.next(); !t.done; t = q.next()){
                        t = t.value;
                        var v;
                        (v = a.Rb()).fe.apply(v, G(t));
                    }
                    v = u(g);
                    for(q = v.next(); !q.done; q = v.next()){
                        q = q.value;
                        var w;
                        (w = a.Rb()).bf.apply(w, G(q));
                    }
                    w = u(fu);
                    for(v = w.next(); !v.done; v = w.next())v = v.value, a.i[v] = n[v];
                    w = u(lu);
                    for(v = w.next(); !v.done; v = w.next())q = v.value, v = q[1], q = a.g.get("player", q[0])(), a.h[v](q);
                    a.h.Xd(m);
                    l && a.h.ei(l.language, l.roles, l.forced);
                    a.i.autoplay = k;
                    h && a.i.play();
                }
            }, function(q) {
                q = (new Map).set("detail", q);
                q = new R("error", q);
                a.h.dispatchEvent(q);
            });
        }
        function Ju(a, b) {
            if (b == "addEventListener") return function(d, e, f) {
                return a.m.addEventListener(d, e, f);
            };
            if (b == "removeEventListener") return function(d, e, f) {
                return a.m.removeEventListener(d, e, f);
            };
            if (a.g.Qa() && Object.keys(a.g.g.video).length == 0) {
                var c = a.i[b];
                if (typeof c != "function") return c;
            }
            return a.g.Qa() ? a.g.get("video", b) : (b = a.i[b], typeof b == "function" && (b = b.bind(a.i)), b);
        }
        function Lu(a, b, c) {
            c = c === void 0 ? !1 : c;
            a.G.has(b) && (b = a.G.get(b));
            if (b == "addEventListener") return function(d, e, f) {
                return a.o.addEventListener(d, e, f);
            };
            if (b == "removeEventListener") return function(d, e, f) {
                return a.o.removeEventListener(d, e, f);
            };
            if (b == "getMediaElement") return function() {
                return a.j;
            };
            if (b == "getSharedConfiguration") return a.g.get("player", "getConfiguration");
            if (b == "getNetworkingEngine") return function() {
                return a.h.Qb();
            };
            if (b == "getDrmEngine") return function() {
                return a.h.F;
            };
            if (b == "getAdManager") return function() {
                return a.h.tf();
            };
            if (b == "getQueueManager") return function() {
                return a.h.wf();
            };
            if (b == "setVideoContainer") return function(d) {
                return a.h.mi(d);
            };
            if (!c) {
                if (b == "addThumbnailsTrack") return function() {
                    var d = Ma.apply(0, arguments);
                    a.F.push(d);
                    return Lu(a, b, !0).apply(null, G(d));
                };
                if (b == "addTextTrackAsync") return function() {
                    var d = Ma.apply(0, arguments);
                    a.D.push(d);
                    return Lu(a, b, !0).apply(null, G(d));
                };
                if (b == "addChaptersTrack") return function() {
                    var d = Ma.apply(0, arguments);
                    a.C.push(d);
                    return Lu(a, b, !0).apply(null, G(d));
                };
            }
            if (a.g.Qa()) {
                if (b == "getManifest" || b == "drmInfo") return function() {
                    Za(b + "() does not work while casting!");
                    return null;
                };
                if (b == "attach" || b == "detach") return function() {
                    Za(b + "() does not work while casting!");
                    return Promise.resolve();
                };
                if (b == "getChapters") return function() {
                    Za(b + "() does not work while casting!");
                    return [];
                };
            }
            return a.g.Qa() && Object.keys(a.g.g.video).length == 0 && (hu.has(b) || iu.has(b)) || !a.g.Qa() ? a.h[b].bind(a.h) : a.g.get("player", b);
        }
        function Fu(a, b, c) {
            a.g.Qa() && (b == "video" ? a.m.dispatchEvent(c) : b == "player" && (c.type == "unloading" && Nu(a), a.o.dispatchEvent(c)));
        }
        function Nu(a) {
            a.F = [];
            a.D = [];
            a.C = [];
        }
        O("shaka.cast.CastProxy", Cu);
        Cu.prototype.changeReceiverId = Cu.prototype.Qi;
        Cu.prototype.forceDisconnect = Cu.prototype.Bd;
        Cu.prototype.suggestDisconnect = Cu.prototype.Yj;
        Cu.prototype.setAppData = Cu.prototype.gi;
        Cu.prototype.cast = Cu.prototype.cast;
        Cu.prototype.receiverName = Cu.prototype.Yf;
        Cu.prototype.isCasting = Cu.prototype.Qa;
        Cu.prototype.canCast = Cu.prototype.Kg;
        Cu.prototype.getPlayer = Cu.prototype.Rb;
        Cu.prototype.getVideo = Cu.prototype.Rc;
        Cu.prototype.destroy = Cu.prototype.destroy;
        function Ou(a, b, c, d) {
            fb.call(this);
            var e = this;
            this.h = a;
            this.g = b;
            this.j = new fd;
            this.I = {
                video: a,
                player: b
            };
            this.G = c || function() {};
            this.J = d || function(f) {
                return f;
            };
            this.i = null;
            this.H = !1;
            this.o = !0;
            this.m = 0;
            this.D = !1;
            this.C = !0;
            this.A = this.l = null;
            this.F = new Uf(function() {
                Pu(e);
            });
            Qu(this);
        }
        oa(Ou, fb);
        p = Ou.prototype;
        p.isConnected = function() {
            return this.H;
        };
        p.Fl = function() {
            return this.o;
        };
        p.vm = function(a) {
            this.i = a;
        };
        p.yk = function() {
            this.i = null;
        };
        p.wm = function(a) {
            this.i || (this.i = {
                metadataType: cast.receiver.media.MetadataType.GENERIC
            });
            this.i.title = a;
        };
        p.um = function(a) {
            this.i || (this.i = {
                metadataType: cast.receiver.media.MetadataType.GENERIC
            });
            this.i.images = [
                {
                    url: a
                }
            ];
        };
        p.tm = function(a) {
            this.i || (this.i = {});
            this.i.artist = a;
            this.i.metadataType = cast.receiver.media.MetadataType.MUSIC_TRACK;
        };
        p.destroy = function() {
            var a = this, b, c;
            return H(function(d) {
                if (d.h == 1) return a.j && (a.j.release(), a.j = null), b = [], a.g && (b.push(a.g.destroy()), a.g = null), a.F && (a.F.stop(), a.F = null), a.h = null, a.I = null, a.G = null, a.H = !1, a.o = !0, a.l = null, a.A = null, fb.prototype.release.call(a), d.g(Promise.all(b), 2);
                c = cast.receiver.CastReceiverManager.getInstance();
                c.stop();
                d.j();
            });
        };
        function Qu(a) {
            var b = cast.receiver.CastReceiverManager.getInstance();
            b.onSenderConnected = function() {
                return Ru(a);
            };
            b.onSenderDisconnected = function() {
                return Ru(a);
            };
            b.onSystemVolumeChanged = function() {
                var e = cast.receiver.CastReceiverManager.getInstance().getSystemVolume();
                e && Su(a, {
                    type: "update",
                    update: {
                        video: {
                            volume: e.level,
                            muted: e.muted
                        }
                    }
                }, a.l);
                Su(a, {
                    type: "event",
                    targetName: "video",
                    event: {
                        type: "volumechange"
                    }
                }, a.l);
            };
            a.A = b.getCastMessageBus("urn:x-cast:com.google.cast.media");
            a.A.onMessage = function(e) {
                return Tu(a, e);
            };
            a.l = b.getCastMessageBus("urn:x-cast:com.google.shaka.v2");
            a.l.onMessage = function(e) {
                return Uu(a, e);
            };
            b.start();
            b = u(du);
            for(var c = b.next(); !c.done; c = b.next())a.j.u(a.h, c.value, function(e) {
                return Vu(a, "video", e);
            });
            for(var d in Wa)a.j.u(a.g, Wa[d], function(e) {
                return Vu(a, "player", e);
            });
            a.j.u(a.h, "loadeddata", function() {
                a.D = !0;
            });
            a.j.u(a.g, "loading", function() {
                a.o = !1;
                Wu(a);
            });
            a.j.u(a.h, "playing", function() {
                a.o = !1;
                Wu(a);
            });
            a.j.u(a.h, "pause", function() {
                Wu(a);
            });
            a.j.u(a.g, "unloading", function() {
                a.o = !0;
                Wu(a);
            });
            a.j.u(a.h, "ended", function() {
                new Uf(function() {
                    a.h && a.h.ended && (a.o = !0, Wu(a));
                }).Z(Xu);
            });
        }
        function Ru(a) {
            a.m = 0;
            a.C = !0;
            a.H = cast.receiver.CastReceiverManager.getInstance().getSenders().length != 0;
            Wu(a);
        }
        function Wu(a) {
            var b;
            H(function(c) {
                if (c.h == 1) return c.g(Promise.resolve(), 2);
                if (!a.g) return c.return();
                b = new R("caststatuschanged");
                a.dispatchEvent(b);
                Yu(a) || Zu(a);
                c.j();
            });
        }
        function $u(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E;
            H(function(C) {
                switch(C.h){
                    case 1:
                        for(d in b.player)e = b.player[d], a.g[d](e);
                        a.G(c);
                        f = a.h.autoplay;
                        return b.manifest ? (a.h.autoplay = !1, C.m(5), C.g(a.g.load(b.manifest, b.startTime), 7)) : C.g(Promise.resolve(), 3);
                    case 7:
                        if (b.addThumbnailsTrackCalls) for(g = u(b.addThumbnailsTrackCalls), h = g.next(); !h.done; h = g.next())k = h.value, a.g.cf.apply(a.g, G(k));
                        if (b.addTextTrackAsyncCalls) for(l = u(b.addTextTrackAsyncCalls), m = l.next(); !m.done; m = l.next())n = m.value, a.g.fe.apply(a.g, G(n));
                        if (b.addChaptersTrackCalls) for(q = u(b.addChaptersTrackCalls), r = q.next(); !r.done; r = q.next())t = r.value, a.g.bf.apply(a.g, G(t));
                        C.o(3);
                        break;
                    case 5:
                        return v = C.l(), w = (new Map).set("detail", v), x = new R("error", w), a.g && a.g.dispatchEvent(x), C.return();
                    case 3:
                        if (!a.g) return C.return();
                        for(y in b.video)z = b.video[y], a.h[y] = z;
                        for(A in b.playerAfterLoad)E = b.playerAfterLoad[A], a.g[A](E);
                        a.h.autoplay = f;
                        b.manifest && (a.h.play(), Zu(a));
                        C.j();
                }
            });
        }
        function Vu(a, b, c) {
            a.g && (Pu(a), Su(a, {
                type: "event",
                targetName: b,
                event: c
            }, a.l));
        }
        function Pu(a) {
            a.F.Z(av);
            for(var b = {
                video: {},
                player: {}
            }, c = u(eu), d = c.next(); !d.done; d = c.next())d = d.value, b.video[d] = a.h[d];
            a.g.U() && ju.forEach(function(e, f) {
                a.m % e == 0 && (b.player[f] = a.g[f]());
            });
            hu.forEach(function(e, f) {
                a.m % e == 0 && (b.player[f] = a.g[f]());
            });
            if (c = cast.receiver.CastReceiverManager.getInstance().getSystemVolume()) b.video.volume = c.level, b.video.muted = c.muted;
            Su(a, {
                type: "update",
                update: b
            }, a.l);
            iu.forEach(function(e, f) {
                a.m % e == 0 && (e = {
                    player: {}
                }, e.player[f] = a.g[f](), Su(a, {
                    type: "update",
                    update: e
                }, a.l));
            });
            a.D && (a.m += 1);
            Yu(a);
        }
        function Yu(a) {
            return a.C && (a.h.duration || a.g.U()) ? (bv(a), a.C = !1, !0) : !1;
        }
        function bv(a, b) {
            var c = {
                contentId: a.g.dd(),
                streamType: a.g.U() ? "LIVE" : "BUFFERED",
                contentType: ""
            };
            a.g.U() || (c.duration = a.h.duration);
            a.i && (c.metadata = a.i);
            Zu(a, b === void 0 ? 0 : b, c);
        }
        function Uu(a, b) {
            var c = bu(b.data);
            switch(c.type){
                case "init":
                    a.m = 0;
                    a.D = !1;
                    a.C = !0;
                    $u(a, c.initState, c.appData);
                    Pu(a);
                    break;
                case "appData":
                    a.G(c.appData);
                    break;
                case "set":
                    var d = c.targetName, e = c.property;
                    c = c.value;
                    if (d == "video") {
                        if (b = cast.receiver.CastReceiverManager.getInstance(), e == "volume") {
                            b.setSystemVolumeLevel(c);
                            break;
                        } else if (e == "muted") {
                            b.setSystemVolumeMuted(c);
                            break;
                        }
                    }
                    a.I[d][e] = c;
                    break;
                case "call":
                    d = a.I[c.targetName];
                    d[c.methodName].apply(d, c.args);
                    break;
                case "asyncCall":
                    d = c.targetName;
                    e = c.methodName;
                    d == "player" && e == "load" && (a.m = 0, a.D = !1);
                    var f = c.id, g = b.senderId;
                    b = a.I[d];
                    c = b[e].apply(b, c.args);
                    d == "player" && e == "load" && (c = c.then(function() {
                        a.C = !0;
                    }));
                    c.then(function(h) {
                        return cv(a, g, f, null, h);
                    }, function(h) {
                        return cv(a, g, f, h, null);
                    });
            }
        }
        function Tu(a, b) {
            var c = bu(b.data);
            switch(c.type){
                case "PLAY":
                    a.h.play();
                    Zu(a);
                    break;
                case "PAUSE":
                    a.h.pause();
                    Zu(a);
                    break;
                case "SEEK":
                    b = c.currentTime;
                    var d = c.resumeState;
                    b != null && (a.h.currentTime = Number(b));
                    d && d == "PLAYBACK_START" ? (a.h.play(), Zu(a)) : d && d == "PLAYBACK_PAUSE" && (a.h.pause(), Zu(a));
                    break;
                case "STOP":
                    a.g.tc().then(function() {
                        a.g && Zu(a);
                    });
                    break;
                case "GET_STATUS":
                    bv(a, Number(c.requestId));
                    break;
                case "VOLUME":
                    d = c.volume;
                    b = d.level;
                    d = d.muted;
                    var e = a.h.volume, f = a.h.muted;
                    b != null && (a.h.volume = Number(b));
                    d != null && (a.h.muted = d);
                    e == a.h.volume && f == a.h.muted || Zu(a);
                    break;
                case "LOAD":
                    a.m = 0;
                    a.D = !1;
                    a.C = !1;
                    b = c.media;
                    d = c.currentTime;
                    e = a.J(b.contentId);
                    f = c.autoplay || !0;
                    a.G(b.customData);
                    f && (a.h.autoplay = !0);
                    a.g.load(e, d).then(function() {
                        a.g && bv(a);
                    }).catch(function(g) {
                        var h = "LOAD_FAILED";
                        g.category == 7 && g.code == 7E3 && (h = "LOAD_CANCELLED");
                        Su(a, {
                            requestId: Number(c.requestId),
                            type: h
                        }, a.A);
                    });
                    break;
                default:
                    Su(a, {
                        requestId: Number(c.requestId),
                        type: "INVALID_REQUEST",
                        reason: "INVALID_COMMAND"
                    }, a.A);
            }
        }
        function cv(a, b, c, d, e) {
            a.g && Su(a, {
                type: "asyncComplete",
                id: c,
                error: d,
                res: e
            }, a.l, b);
        }
        function Su(a, b, c, d) {
            a.H && (a = au(b), d ? c.getCastChannel(d).send(a) : c.broadcast(a));
        }
        function Zu(a, b, c) {
            c = c === void 0 ? null : c;
            var d = {
                mediaSessionId: 0,
                playbackRate: a.h.playbackRate,
                playerState: a.o ? dv : a.g.Df() ? ev : a.h.paused ? fv : gv,
                currentTime: a.h.currentTime,
                supportedMediaCommands: 63,
                volume: {
                    level: a.h.volume,
                    muted: a.h.muted
                }
            };
            c && (d.media = c);
            Su(a, {
                requestId: b === void 0 ? 0 : b,
                type: "MEDIA_STATUS",
                status: [
                    d
                ]
            }, a.A);
        }
        O("shaka.cast.CastReceiver", Ou);
        Ou.prototype.destroy = Ou.prototype.destroy;
        Ou.prototype.setContentArtist = Ou.prototype.tm;
        Ou.prototype.setContentImage = Ou.prototype.um;
        Ou.prototype.setContentTitle = Ou.prototype.wm;
        Ou.prototype.clearContentMetadata = Ou.prototype.yk;
        Ou.prototype.setContentMetadata = Ou.prototype.vm;
        Ou.prototype.isIdle = Ou.prototype.Fl;
        Ou.prototype.isConnected = Ou.prototype.isConnected;
        var av = .5, Xu = 5, dv = "IDLE", gv = "PLAYING", ev = "BUFFERING", fv = "PAUSED";
        function hv(a, b, c, d, e) {
            if (d >= e) return null;
            for(var f = -1, g = -1, h = 0; h < c.length; h++)if (c[h].some(function(A) {
                return A != null && A.g.trim() != "";
            })) {
                f = h;
                break;
            }
            for(h = c.length - 1; h >= 0; h--)if (c[h].some(function(A) {
                return A != null && A.g.trim() != "";
            })) {
                g = h;
                break;
            }
            if (f === -1 || g === -1) return null;
            for(var k = h = !1, l = "white", m = "black", n = iv(d, e, h, k, l, m); f <= g; f++){
                for(var q = c[f], r = -1, t = -1, v = 0; v < q.length; v++)if (q[v] != null && q[v].g.trim() !== "") {
                    r = v;
                    break;
                }
                for(v = q.length - 1; v >= 0; v--)if (q[v] != null && q[v].g.trim() !== "") {
                    t = v;
                    break;
                }
                if (r === -1 || t === -1) q = jv(d, e), a.nestedCues.push(q);
                else {
                    for(; r <= t; r++)if (v = q[r]) {
                        var w = v.l, x = v.i, y = v.j, z = v.h;
                        if (w != h || x != k || y != l || z != m) n.payload && a.nestedCues.push(n), n = iv(d, e, w, x, y, z), h = w, k = x, l = y, m = z;
                        n.payload += v.g;
                    } else n.payload += " ";
                    n.payload && a.nestedCues.push(n);
                    f !== g && (n = jv(d, e), a.nestedCues.push(n));
                    n = iv(d, e, h, k, l, m);
                }
            }
            return a.nestedCues.length ? {
                cue: a,
                stream: b
            } : null;
        }
        function iv(a, b, c, d, e, f) {
            a = new Ie(a, b, "");
            c && a.textDecoration.push(ff);
            d && (a.fontStyle = ef);
            a.color = e;
            a.backgroundColor = f;
            return a;
        }
        function jv(a, b) {
            a = new Ie(a, b, "");
            a.lineBreak = !0;
            return a;
        }
        function kv(a, b, c, d, e) {
            this.g = a;
            this.l = b;
            this.i = c;
            this.h = d;
            this.j = e;
        }
        function lv(a, b) {
            this.i = [];
            this.g = 1;
            this.h = 0;
            this.F = a;
            this.D = b;
            this.j = this.m = !1;
            this.l = "white";
            this.o = "black";
            this.A = this.C = null;
            mv(this);
        }
        function nv(a, b, c) {
            var d = "CC" + ((a.F << 1 | a.D) + 1), e = new Ie(b, c, "");
            e.lineInterpretation = 1;
            var f = ov.get(a.g);
            f && (e.line = f);
            a.A != null && a.C != null && (e.position = 10 + Math.min(70, a.A * 10) + a.C * 2.5);
            (b = hv(e, d, a.i, b, c)) && a.g + b.cue.nestedCues.length - 3 > 15 && (f = ov.get(a.g + 3 - b.cue.nestedCues.length)) && (e.line = f);
            return b;
        }
        function mv(a) {
            pv(a, 0, 15);
            a.g = 1;
        }
        function qv(a, b, c) {
            if (!(c < 32 || c > 127)) {
                var d = "";
                switch(b){
                    case 0:
                        d = rv.has(c) ? rv.get(c) : String.fromCharCode(c);
                        break;
                    case 1:
                        d = sv.get(c);
                        break;
                    case 2:
                        a.i[a.g].pop();
                        d = tv.get(c);
                        break;
                    case 3:
                        a.i[a.g].pop(), d = uv.get(c);
                }
                d && a.i[a.g].push(new kv(d, a.m, a.j, a.o, a.l));
            }
        }
        function vv(a, b, c, d) {
            if (!(c < 0 || b < 0)) {
                if (b >= c) for(--d; d >= 0; d--)a.i[b + d] = a.i[c + d].map(function(f) {
                    return f;
                });
                else for(var e = 0; e < d; e++)a.i[b + e] = a.i[c + e].map(function(f) {
                    return f;
                });
            }
        }
        function pv(a, b, c) {
            for(var d = 0; d <= c; d++)a.i[b + d] = [];
        }
        var rv = new Map([
            [
                39,
                "\u2019"
            ],
            [
                42,
                "\u00e1"
            ],
            [
                92,
                "\u00e9"
            ],
            [
                92,
                "\u00e9"
            ],
            [
                94,
                "\u00ed"
            ],
            [
                95,
                "\u00f3"
            ],
            [
                96,
                "\u00fa"
            ],
            [
                123,
                "\u00e7"
            ],
            [
                124,
                "\u00f7"
            ],
            [
                125,
                "\u00d1"
            ],
            [
                126,
                "\u00f1"
            ],
            [
                127,
                "\u2588"
            ]
        ]), sv = new Map([
            [
                48,
                "\u00ae"
            ],
            [
                49,
                "\u00b0"
            ],
            [
                50,
                "\u00bd"
            ],
            [
                51,
                "\u00bf"
            ],
            [
                52,
                "\u2122"
            ],
            [
                53,
                "\u00a2"
            ],
            [
                54,
                "\u00a3"
            ],
            [
                55,
                "\u266a"
            ],
            [
                56,
                "\u00e0"
            ],
            [
                57,
                " "
            ],
            [
                58,
                "\u00e8"
            ],
            [
                59,
                "\u00e2"
            ],
            [
                60,
                "\u00ea"
            ],
            [
                61,
                "\u00ee"
            ],
            [
                62,
                "\u00f4"
            ],
            [
                63,
                "\u00fb"
            ]
        ]), tv = new Map([
            [
                32,
                "\u00c1"
            ],
            [
                33,
                "\u00c9"
            ],
            [
                34,
                "\u00d3"
            ],
            [
                35,
                "\u00da"
            ],
            [
                36,
                "\u00dc"
            ],
            [
                37,
                "\u00fc"
            ],
            [
                38,
                "\u2018"
            ],
            [
                39,
                "\u00a1"
            ],
            [
                40,
                "*"
            ],
            [
                41,
                "'"
            ],
            [
                42,
                "\u2500"
            ],
            [
                43,
                "\u00a9"
            ],
            [
                44,
                "\u2120"
            ],
            [
                45,
                "\u00b7"
            ],
            [
                46,
                "\u201c"
            ],
            [
                47,
                "\u201d"
            ],
            [
                48,
                "\u00c0"
            ],
            [
                49,
                "\u00c2"
            ],
            [
                50,
                "\u00c7"
            ],
            [
                51,
                "\u00c8"
            ],
            [
                52,
                "\u00ca"
            ],
            [
                53,
                "\u00cb"
            ],
            [
                54,
                "\u00eb"
            ],
            [
                55,
                "\u00ce"
            ],
            [
                56,
                "\u00cf"
            ],
            [
                57,
                "\u00ef"
            ],
            [
                58,
                "\u00d4"
            ],
            [
                59,
                "\u00d9"
            ],
            [
                60,
                "\u00f9"
            ],
            [
                61,
                "\u00db"
            ],
            [
                62,
                "\u00ab"
            ],
            [
                63,
                "\u00bb"
            ]
        ]), uv = new Map([
            [
                32,
                "\u00c3"
            ],
            [
                33,
                "\u00e3"
            ],
            [
                34,
                "\u00cd"
            ],
            [
                35,
                "\u00cc"
            ],
            [
                36,
                "\u00ec"
            ],
            [
                37,
                "\u00d2"
            ],
            [
                38,
                "\u00f2"
            ],
            [
                39,
                "\u00d5"
            ],
            [
                40,
                "\u00f5"
            ],
            [
                41,
                "{"
            ],
            [
                42,
                "}"
            ],
            [
                43,
                "\\"
            ],
            [
                44,
                "^"
            ],
            [
                45,
                "_"
            ],
            [
                46,
                "|"
            ],
            [
                47,
                "~"
            ],
            [
                48,
                "\u00c4"
            ],
            [
                49,
                "\u00e4"
            ],
            [
                50,
                "\u00d6"
            ],
            [
                51,
                "\u00f6"
            ],
            [
                52,
                "\u00df"
            ],
            [
                53,
                "\u00a5"
            ],
            [
                54,
                "\u00a4"
            ],
            [
                55,
                "\u2502"
            ],
            [
                56,
                "\u00c5"
            ],
            [
                57,
                "\u00e5"
            ],
            [
                58,
                "\u00d8"
            ],
            [
                59,
                "\u00f8"
            ],
            [
                60,
                "\u250c"
            ],
            [
                61,
                "\u2510"
            ],
            [
                62,
                "\u2514"
            ],
            [
                63,
                "\u2518"
            ]
        ]), ov = new Map([
            [
                1,
                10
            ],
            [
                2,
                15.33
            ],
            [
                3,
                20.66
            ],
            [
                4,
                26
            ],
            [
                5,
                31.33
            ],
            [
                6,
                36.66
            ],
            [
                7,
                42
            ],
            [
                8,
                47.33
            ],
            [
                9,
                52.66
            ],
            [
                10,
                58
            ],
            [
                11,
                63.33
            ],
            [
                12,
                68.66
            ],
            [
                13,
                74
            ],
            [
                14,
                79.33
            ],
            [
                15,
                84.66
            ]
        ]);
        function wv(a, b) {
            this.h = 0;
            this.o = new lv(a, b);
            this.i = new lv(a, b);
            this.g = this.j = new lv(a, b);
            this.l = 0;
            this.m = null;
        }
        function xv(a, b, c) {
            a.g = a.i;
            var d = a.g, e = null;
            a.h !== 3 && a.h !== 4 && (e = nv(d, a.l, c), c = a.i, c.g = c.h > 0 ? c.h : 0, pv(c, 0, 15), c = a.j, c.g = c.h > 0 ? c.h : 0, pv(c, 0, 15), d.g = 15);
            a.h = 3;
            d.h = b;
            return e;
        }
        function yv(a) {
            a.h = 1;
            a.g = a.j;
            a.g.h = 0;
        }
        function zv(a) {
            $a("Cea608DataChannel", "CEA-608 text mode entered, but is unsupported");
            a.g = a.o;
            a.h = 4;
        }
        var Av = "black green blue cyan red yellow magenta black".split(" "), Bv = "white green blue cyan red yellow magenta white_italics".split(" ");
        function Cv(a, b) {
            this.J = b;
            this.M = a;
            this.K = this.l = !1;
            this.m = this.o = this.H = this.L = this.I = 0;
            this.G = 2;
            this.i = [];
            this.g = this.h = this.j = 0;
            this.F = this.C = !1;
            this.D = "white";
            this.A = "black";
            Dv(this);
        }
        function Dv(a) {
            a.i = [];
            for(var b = 0; b < 16; b++)a.i.push(Ev());
        }
        function Ev() {
            for(var a = [], b = 0; b < 42; b++)a.push(null);
            return a;
        }
        function Fv(a, b) {
            Gv(a) && (a.i[a.h][a.g] = new kv(b, a.F, a.C, a.A, a.D), a.g++);
        }
        function Gv(a) {
            var b = a.g < a.m && a.g >= 0;
            return a.h < a.o && a.h >= 0 && b;
        }
        Cv.prototype.isVisible = function() {
            return this.l;
        };
        function Hv(a) {
            for(var b = 0, c = 1; c < 16; c++, b++)a.i[b] = a.i[c];
            for(c = 0; c < 1; c++, b++)a.i[b] = Ev();
        }
        function Iv(a, b, c) {
            var d = new Ie(a.j, b, "");
            d.textAlign = a.G === 0 ? "left" : a.G === 1 ? "right" : Ke;
            var e = d.region;
            a.J && (e.id += "svc" + a.J);
            e.id += "win" + a.M;
            e.height = a.o;
            e.width = a.m;
            e.heightUnits = 2;
            e.widthUnits = 2;
            e.viewportAnchorX = a.I;
            e.viewportAnchorY = a.L;
            e.viewportAnchorUnits = a.K ? Nd : 2;
            switch(a.H){
                case 0:
                    e.regionAnchorX = 0;
                    e.regionAnchorY = 0;
                    break;
                case 1:
                    e.regionAnchorX = 50;
                    e.regionAnchorY = 0;
                    break;
                case 2:
                    e.regionAnchorX = 100;
                    e.regionAnchorY = 0;
                    break;
                case 3:
                    e.regionAnchorX = 0;
                    e.regionAnchorY = 50;
                    break;
                case 4:
                    e.regionAnchorX = 50;
                    e.regionAnchorY = 50;
                    break;
                case 5:
                    e.regionAnchorX = 100;
                    e.regionAnchorY = 50;
                    break;
                case 6:
                    e.regionAnchorX = 0;
                    e.regionAnchorY = 100;
                    break;
                case 7:
                    e.regionAnchorX = 50;
                    e.regionAnchorY = 100;
                    break;
                case 8:
                    e.regionAnchorX = 100, e.regionAnchorY = 100;
            }
            if (c = hv(d, "svc" + c, a.i, a.j, b)) a.j = b;
            return c;
        }
        Cv.prototype.display = function() {
            this.l = !0;
        };
        function Jv() {
            this.i = [];
            this.h = null;
            this.g = 0;
        }
        function Kv(a, b) {
            b.type === 3 ? (a.g = (b.value & 63) * 2 - 1, a.h = []) : a.h && (a.g > 0 && (a.h.push(b), a.g--), a.g === 0 && (a.i.push(new Lv(a.h)), a.h = null, a.g = 0));
        }
        function Lv(a) {
            this.g = 0;
            this.h = a;
        }
        Lv.prototype.Sa = function() {
            return this.g < this.h.length;
        };
        Lv.prototype.Xa = function() {
            return this.g;
        };
        function Mv(a) {
            if (!a.Sa()) throw new T(2, 2, 3E3);
            return a.h[a.g++];
        }
        Lv.prototype.skip = function(a) {
            if (this.g + a > this.h.length) throw new T(2, 2, 3E3);
            this.g += a;
        };
        Lv.prototype.Fj = function(a) {
            if (this.g - a < 0) throw new T(2, 2, 3E3);
            this.g -= a;
        };
        function Nv(a) {
            this.i = a;
            this.h = [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
            ];
            this.g = null;
        }
        function Ov(a, b, c, d) {
            if (!a.g) return [];
            if (c == 24) return c = Mv(b).value, d = Mv(b).value, c = function(f) {
                return f.map(function(g) {
                    return ("0" + (g & 255).toString(16)).slice(-2);
                }).join("");
            }([
                c,
                d
            ]), Fv(a.g, String.fromCharCode(parseInt(c, 16))), [];
            b = a.g;
            var e = null;
            switch(c){
                case 8:
                    !Gv(b) || b.g <= 0 && b.h <= 0 || (b.g <= 0 ? (b.g = b.m - 1, b.h--) : b.g--, b.i[b.h][b.g] = null);
                    break;
                case 13:
                    b.isVisible() && (e = Iv(b, d, a.i));
                    b.h + 1 >= b.o ? Hv(b) : b.h++;
                    b.g = 0;
                    break;
                case 14:
                    b.isVisible() && (e = Iv(b, d, a.i));
                    b.i[b.h] = Ev();
                    b.g = 0;
                    break;
                case 12:
                    b.isVisible() && (e = Iv(b, d, a.i)), Dv(b), b.h = 0, b.g = 0;
            }
            return e ? [
                e
            ] : [];
        }
        function Pv(a, b, c, d) {
            if (c >= 128 && c <= 135) d = c & 7, a.h[d] && (a.g = a.h[d]);
            else {
                if (c === 136) {
                    c = Mv(b).value;
                    b = [];
                    c = u(Qv(a, c));
                    for(var e = c.next(); !e.done; e = c.next()){
                        e = a.h[e.value];
                        if (e.isVisible()) {
                            var f = Iv(e, d, a.i);
                            f && b.push(f);
                        }
                        Dv(e);
                    }
                    return b;
                }
                if (c === 137) for(b = Mv(b).value, b = u(Qv(a, b)), c = b.next(); !c.done; c = b.next())c = a.h[c.value], c.isVisible() || (c.j = d), c.display();
                else {
                    if (c === 138) {
                        c = Mv(b).value;
                        b = null;
                        c = u(Qv(a, c));
                        for(e = c.next(); !e.done; e = c.next())e = a.h[e.value], e.isVisible() && (b = Iv(e, d, a.i)), e.l = !1;
                        return b ? [
                            b
                        ] : [];
                    }
                    if (c === 139) {
                        c = Mv(b).value;
                        b = null;
                        c = u(Qv(a, c));
                        for(e = c.next(); !e.done; e = c.next())e = a.h[e.value], e.isVisible() ? b = Iv(e, d, a.i) : e.j = d, e.l = !e.l;
                        return b ? [
                            b
                        ] : [];
                    }
                    if (c === 140) return b = Mv(b).value, Rv(a, b, d);
                    if (c === 143) return d = Rv(a, 255, d), Sv(a), d;
                    if (c === 144) b.skip(1), d = Mv(b).value, a.g && (a.g.C = (d & 128) > 0, a.g.F = (d & 64) > 0);
                    else if (c === 145) d = Mv(b).value, c = Mv(b).value, b.skip(1), a.g && (b = Tv((c & 48) >> 4, (c & 12) >> 2, c & 3), a.g.D = Tv((d & 48) >> 4, (d & 12) >> 2, d & 3), a.g.A = b);
                    else if (c === 146) d = Mv(b).value, b = Mv(b).value, a.g && (a = a.g, a.h = d & 15, a.g = b & 63);
                    else if (c === 151) b.skip(1), b.skip(1), d = Mv(b).value, b.skip(1), a.g && (a.g.G = d & 3);
                    else if (c >= 152 && c <= 159) {
                        c = (c & 15) - 8;
                        e = a.h[c] !== null;
                        e || (f = new Cv(c, a.i), f.j = d, a.h[c] = f);
                        d = Mv(b).value;
                        f = Mv(b).value;
                        var g = Mv(b).value, h = Mv(b).value, k = Mv(b).value;
                        b = Mv(b).value;
                        e && (b & 7) === 0 || (b = a.h[c], b.h = 0, b.g = 0, b.F = !1, b.C = !1, b.D = "white", b.A = "black");
                        b = a.h[c];
                        b.l = (d & 32) > 0;
                        b.L = f & 127;
                        b.I = g;
                        b.H = (h & 240) >> 4;
                        b.K = (f & 128) > 0;
                        b.o = (h & 15) + 1;
                        b.m = (k & 63) + 1;
                        a.g = a.h[c];
                    }
                }
            }
            return [];
        }
        function Qv(a, b) {
            for(var c = [], d = 0; d < 8; d++)(b & 1) === 1 && a.h[d] && c.push(d), b >>= 1;
            return c;
        }
        function Rv(a, b, c) {
            var d = [];
            b = u(Qv(a, b));
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = a.h[e];
                f.isVisible() && (f = Iv(f, c, a.i)) && d.push(f);
                a.h[e] = null;
            }
            return d;
        }
        function Sv(a) {
            a.g = null;
            a.h = [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
            ];
        }
        function Tv(a, b, c) {
            var d = {
                0: 0,
                1: 0,
                2: 1,
                3: 1
            };
            a = d[a];
            b = d[b];
            c = d[c];
            return Uv[a << 2 | b << 1 | c];
        }
        var Vv = new Map([
            [
                32,
                " "
            ],
            [
                33,
                "\u00a0"
            ],
            [
                37,
                "\u2026"
            ],
            [
                42,
                "\u0160"
            ],
            [
                44,
                "\u0152"
            ],
            [
                48,
                "\u2588"
            ],
            [
                49,
                "\u2018"
            ],
            [
                50,
                "\u2019"
            ],
            [
                51,
                "\u201c"
            ],
            [
                52,
                "\u201d"
            ],
            [
                53,
                "\u2022"
            ],
            [
                57,
                "\u2122"
            ],
            [
                58,
                "\u0161"
            ],
            [
                60,
                "\u0153"
            ],
            [
                61,
                "\u2120"
            ],
            [
                63,
                "\u0178"
            ],
            [
                118,
                "\u215b"
            ],
            [
                119,
                "\u215c"
            ],
            [
                120,
                "\u215d"
            ],
            [
                121,
                "\u215e"
            ],
            [
                122,
                "\u2502"
            ],
            [
                123,
                "\u2510"
            ],
            [
                124,
                "\u2514"
            ],
            [
                125,
                "\u2500"
            ],
            [
                126,
                "\u2518"
            ],
            [
                127,
                "\u250c"
            ]
        ]), Uv = "black blue green cyan red magenta yellow white".split(" ");
        function Wv() {
            this.h = [];
            this.g = [];
            this.i = new Jv;
            this.l = 0;
            this.m = new Map([
                [
                    "CC1",
                    new wv(0, 0)
                ],
                [
                    "CC2",
                    new wv(0, 1)
                ],
                [
                    "CC3",
                    new wv(1, 0)
                ],
                [
                    "CC4",
                    new wv(1, 1)
                ]
            ]);
            this.A = this.o = 0;
            this.j = new Map;
            this.D = !0;
            this.C = new Set;
            Xv(this);
        }
        Wv.prototype.clear = function() {
            this.l = 0;
            this.h = [];
            this.g = [];
            var a = this.i;
            a.i = [];
            a.h = [];
            a.g = 0;
            Xv(this);
            a = u(this.j.values());
            for(var b = a.next(); !b.done; b = a.next())Sv(b.value);
        };
        function Xv(a) {
            a.o = 0;
            a.A = 0;
            for(var b = u(a.m.values()), c = b.next(); !c.done; c = b.next())c = c.value, c.h = 0, c.g = c.j, c.m = null, mv(c.i), mv(c.j), mv(c.o);
            a.D = !0;
        }
        Wv.prototype.extract = function(a, b) {
            if (this.D) {
                for(var c = u(this.m.values()), d = c.next(); !d.done; d = c.next())d.value.l = b;
                this.D = !1;
            }
            a = new yh(a, 0);
            if (!(a.getLength() < 8) && a.ea() === 181 && a.Ka() === 49 && a.Y() === 1195456820 && a.ea() === 3 && (c = a.ea(), (c & 64) !== 0)) for(c &= 31, a.skip(1), d = 0; d < c; d++){
                var e = a.ea(), f = (e & 4) >> 2, g = a.ea(), h = a.ea();
                f && (e &= 3, e === 0 || e === 1 ? this.h.push({
                    pts: b,
                    type: e,
                    Db: g,
                    uc: h,
                    order: this.h.length
                }) : (this.g.push({
                    pts: b,
                    type: e,
                    value: g,
                    order: this.g.length
                }), this.g.push({
                    pts: b,
                    type: 2,
                    value: h,
                    order: this.g.length
                })));
            }
        };
        Wv.prototype.decode = function() {
            function a(e, f) {
                return e.pts - f.pts || e.order - f.order;
            }
            var b = [];
            this.h.sort(a);
            this.g.sort(a);
            for(var c = u(this.h), d = c.next(); !d.done; d = c.next())(d = Yv(this, d.value)) && b.push(d);
            c = u(this.g);
            for(d = c.next(); !d.done; d = c.next())Kv(this.i, d.value);
            c = u(this.i.i);
            for(d = c.next(); !d.done; d = c.next())d = Zv(this, d.value), b.push.apply(b, G(d));
            this.i.i = [];
            this.h = [];
            this.g = [];
            return b;
        };
        function Yv(a, b) {
            var c = b.type;
            if ((b.Db & 112) === 16) {
                var d = b.Db >> 3 & 1;
                c === 0 ? a.o = d : a.A = d;
            }
            d = "CC" + ((c << 1 | (c ? a.A : a.o)) + 1);
            c = a.m.get(d);
            if (b.Db === 255 && b.uc === 255 || !b.Db && !b.uc || !$v(b.Db) || !$v(b.uc)) return ++a.l >= 45 && Xv(a), null;
            a.l = 0;
            b.Db &= 127;
            b.uc &= 127;
            var e = b.Db;
            if (e >= 1 && e <= 15 || !b.Db && !b.uc) return null;
            e = null;
            if ((b.Db & 112) === 16) a: {
                a.C.add(d), d = b.Db;
                a = b.uc;
                if (c.m === (d << 8 | a)) c.m = null;
                else if (c.m = d << 8 | a, (d & 240) === 16 && (a & 192) === 64) {
                    b = [
                        11,
                        11,
                        1,
                        2,
                        3,
                        4,
                        12,
                        13,
                        14,
                        15,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10
                    ][(d & 7) << 1 | a >> 5 & 1];
                    d = "white";
                    e = !1;
                    var f = null;
                    var g = a > 95 ? a - 96 : a - 64;
                    g <= 13 ? d = Bv[Math.floor(g / 2)] : g <= 15 ? e = !0 : f = Math.floor((g - 16) / 2);
                    a = (a & 1) === 1;
                    c.h !== 4 && (g = c.g, c.h === 3 && b !== g.g && (c = 1 + b - g.h, vv(g, c, 1 + g.g - g.h, g.h), pv(g, 0, c - 1), pv(g, b + 1, 15 - b)), g.g = b, g.m = a, g.j = e, g.l = d, g.A = f, g.o = "black");
                } else if ((d & 247) === 17 && (a & 240) === 32) c.g.m = !1, c.g.j = !1, c.g.l = "white", qv(c.g, 0, 32), d = !1, b = Bv[(a & 14) >> 1], b === "white_italics" && (b = "white", d = !0), c.g.m = (a & 1) === 1, c.g.j = d, c.g.l = b;
                else if ((d & 247) === 16 && (a & 240) === 32 || (d & 247) === 23 && (a & 255) === 45) b = "black", (d & 7) === 0 && (b = Av[(a & 14) >> 1]), c.g.o = b;
                else if ((d & 247) === 17 && (a & 240) === 48) qv(c.g, 1, a);
                else if ((d & 246) === 18 && (a & 224) === 32) qv(c.g, d & 1 ? 3 : 2, a);
                else {
                    if ((d & 246) === 20 && (a & 240) === 32) {
                        a = b.pts;
                        d = null;
                        switch(b.uc){
                            case 32:
                                yv(c);
                                break;
                            case 33:
                                c = c.g;
                                c.i[c.g].pop();
                                break;
                            case 37:
                                d = xv(c, 2, a);
                                break;
                            case 38:
                                d = xv(c, 3, a);
                                break;
                            case 39:
                                d = xv(c, 4, a);
                                break;
                            case 40:
                                qv(c.g, 0, 32);
                                break;
                            case 41:
                                c.h = 2;
                                c.g = c.i;
                                c.g.h = 0;
                                c.l = a;
                                break;
                            case 42:
                                mv(c.o);
                                zv(c);
                                break;
                            case 43:
                                zv(c);
                                break;
                            case 44:
                                b = c.i;
                                d = null;
                                c.h !== 4 && (d = nv(b, c.l, a));
                                pv(b, 0, 15);
                                break;
                            case 45:
                                b = c.g;
                                c.h !== 3 ? d = null : (d = nv(b, c.l, a), e = b.g - b.h + 1, vv(b, e - 1, e, b.h), pv(b, 0, e - 1), pv(b, b.g, 15 - b.g), c.l = a);
                                break;
                            case 46:
                                pv(c.j, 0, 15);
                                break;
                            case 47:
                                b = null, c.h !== 4 && (b = nv(c.i, c.l, a)), d = c.j, c.j = c.i, c.i = d, yv(c), c.l = a, d = b;
                        }
                        e = d;
                        break a;
                    }
                    (d == 23 || d == 31) && a >= 33 && a <= 35 && (c.g.C = a - 32);
                }
                e = null;
            }
            else a = b.uc, qv(c.g, 0, b.Db), qv(c.g, 0, a);
            return e;
        }
        function Zv(a, b) {
            var c = [];
            try {
                for(; b.Sa();){
                    var d = Mv(b).value, e = (d & 224) >> 5, f = d & 31;
                    e === 7 && f != 0 && (e = Mv(b).value & 63);
                    if (e != 0) {
                        a.C.add("svc" + e);
                        a.j.has(e) || a.j.set(e, new Nv(e));
                        for(var g = a.j.get(e), h = b.Xa(); b.Xa() - h < f;){
                            e = g;
                            var k = b, l = Mv(k), m = l.value, n = l.pts;
                            if (m === 16) {
                                var q = Mv(k);
                                m = m << 16 | q.value;
                            }
                            if (m >= 0 && m <= 31) var r = Ov(e, k, m, n);
                            else if (m >= 128 && m <= 159) r = Pv(e, k, m, n);
                            else {
                                if (m >= 4096 && m <= 4127) e = k, k = m & 255, k >= 8 && k <= 15 ? e.skip(1) : k >= 16 && k <= 23 ? e.skip(2) : k >= 24 && k <= 31 && e.skip(3);
                                else if (m >= 4224 && m <= 4255) e = k, k = m & 255, k >= 128 && k <= 135 ? e.skip(4) : k >= 136 && k <= 143 && e.skip(5);
                                else if (m >= 32 && m <= 127) k = m, e.g && (k === 127 ? Fv(e.g, "\u266a") : Fv(e.g, String.fromCharCode(k)));
                                else if (m >= 160 && m <= 255) e.g && Fv(e.g, String.fromCharCode(m));
                                else if (m >= 4128 && m <= 4223) {
                                    if (k = m & 255, e.g) {
                                        if (Vv.has(k)) {
                                            var t = Vv.get(k);
                                            Fv(e.g, t);
                                        } else Fv(e.g, "_");
                                    }
                                } else m >= 4256 && m <= 4351 && e.g && ((m & 255) != 160 ? Fv(e.g, "_") : Fv(e.g, "[CC]"));
                                r = [];
                            }
                            c.push.apply(c, G(r));
                        }
                    }
                }
            } catch (v) {
                if (v instanceof T && v.code === 3E3) $a("CEA708_INVALID_DATA", "Buffer read out of bounds / invalid CEA-708 Data.");
                else throw v;
            }
            return c;
        }
        function $v(a) {
            for(var b = 0; a;)b ^= a & 1, a >>= 1;
            return b === 1;
        }
        Wv.prototype.getStreams = function() {
            return Array.from(this.C);
        };
        O("shaka.cea.CeaDecoder", Wv);
        Id = function() {
            return new Wv;
        };
        function aw(a) {
            for(var b = [], c = a, d = a = 0; d < c.length;)a == 2 && c[d] == 3 ? (a = 0, c = [].concat(G(c)), c.splice(d, 1), c = new Uint8Array(c)) : c[d] == 0 ? a++ : a = 0, d++;
            a = c;
            for(d = 0; d < a.length;){
                for(c = 0; a[d] == 255;)c += 255, d++;
                c += a[d++];
                for(var e = 0; a[d] == 255;)e += 255, d++;
                e += a[d++];
                c == 4 && b.push(a.subarray(d, d + e));
                d += e;
            }
            return b;
        }
        function bw() {
            this.j = new Map;
            this.i = this.h = 0;
            this.g = cw;
        }
        bw.prototype.init = function(a) {
            var b = this, c = [], d = [];
            (new Bh).boxes("moov trak mdia minf stbl mvex".split(" "), Gh).qa("trex", function(e) {
                var f = e.reader;
                f.skip(4);
                f.skip(4);
                e = f.Y();
                f = f.Y();
                b.h = e;
                b.i = f;
            }).qa("tkhd", function(e) {
                var f = e.reader;
                e = e.version;
                e == 1 ? (f.skip(8), f.skip(8)) : (f.skip(4), f.skip(4));
                var g = f.Y();
                e == 1 ? f.skip(8) : f.skip(4);
                f.skip(4);
                f.skip(8);
                f.skip(2);
                f.skip(2);
                f.skip(2);
                f.skip(2);
                f.skip(36);
                f.Ka();
                f.Ka();
                f.Ka();
                f.Ka();
                c.push(g);
            }).qa("mdhd", function(e) {
                e = Xi(e.reader, e.version);
                d.push(e.timescale);
            }).qa("stsd", Ih).boxes("avc1 avc3 dvav dva1 hev1 hvc1 dvh1 dvhe vvc1 vvi1 dvc1 dvi1".split(" "), function(e) {
                e = e.name;
                dw.has(e) && (b.g = dw.get(e));
            }).box("encv", Jh).box("sinf", Gh).box("frma", function(e) {
                e = $i(e.reader).codec;
                dw.has(e) && (b.g = dw.get(e));
            }).parse(a, !0, !0);
            if (!c.length || !d.length || c.length != d.length) throw new T(2, 2, 2010);
            this.g == cw && Za("Unable to determine bitstream format for CEA parsing!");
            c.forEach(function(e, f) {
                b.j.set(e, d[f]);
            });
        };
        bw.prototype.parse = function(a) {
            var b = this;
            if (this.g == cw) return [];
            var c = [], d = 0, e = [];
            (new Bh).box("moof", function(f) {
                d = f.start;
                e = [];
                Gh(f);
            }).box("traf", function(f) {
                e.push({
                    baseMediaDecodeTime: null,
                    ke: b.h,
                    le: b.i,
                    xj: [],
                    timescale: 9E4
                });
                Gh(f);
            }).qa("trun", function(f) {
                var g = e[e.length - 1];
                f = Yi(f.reader, f.version, f.flags);
                g.xj.push(f);
            }).qa("tfhd", function(f) {
                var g = e[e.length - 1];
                f = Vi(f.reader, f.flags);
                g.ke = f.ke || b.h;
                g.le = f.le || b.i;
                f = f.trackId;
                b.j.has(f) && (g.timescale = b.j.get(f));
            }).qa("tfdt", function(f) {
                var g = e[e.length - 1];
                f = Wi(f.reader, f.version);
                g.baseMediaDecodeTime = f.baseMediaDecodeTime;
            }).box("mdat", function(f) {
                for(var g = d - f.start - 8, h = f.reader.Xa(), k = u(e), l = k.next(); !l.done; l = k.next())l = l.value, l.baseMediaDecodeTime === null ? Za("Unable to find base media decode time for CEA captions!") : (f.reader.seek(h), ew(b, f.reader, l.baseMediaDecodeTime, l.timescale, l.ke, l.le, g, l.xj, c));
            }).parse(a, !1, !0);
            return c;
        };
        function ew(a, b, c, d, e, f, g, h, k) {
            var l = 0, m = f, n = h.map(function(t) {
                return t.ci;
            });
            n = [].concat.apply([], G(n));
            n.length && (m = n[0].sampleSize || f);
            for(b.skip(g + h[0].Ug); b.Sa();){
                g = b.Y();
                var q = b.ea(), r = null;
                r = !1;
                h = 1;
                switch(a.g){
                    case fw:
                        r = q & 31;
                        r = r == 6;
                        break;
                    case gw:
                        h = 2;
                        b.skip(1);
                        r = q >> 1 & 63;
                        r = r == 39 || r == 40;
                        break;
                    case hw:
                        h = 2;
                        b.skip(1);
                        r = q >> 1 & 63;
                        r = r == 23 || r == 24;
                        break;
                    default:
                        return;
                }
                if (r) for(q = 0, l < n.length && (q = n[l].dg || 0), q = (c + q) / d, h = b.Wb(g - h, !1), h = u(aw(h)), r = h.next(); !r.done; r = h.next())k.push({
                    packet: r.value,
                    pts: q
                });
                else try {
                    b.skip(g - h);
                } catch (t) {
                    break;
                }
                m -= g + 4;
                m == 0 && (c = l < n.length ? c + (n[l].di || e) : c + e, l++, l < n.length ? m = n[l].sampleSize || f : m = f);
            }
        }
        O("shaka.cea.Mp4CeaParser", bw);
        var cw = 0, fw = 1, gw = 2, hw = 3, dw = (new Map).set("avc1", fw).set("avc3", fw).set("dvav", fw).set("dva1", fw).set("hev1", gw).set("hvc1", gw).set("dvh1", gw).set("dvhe", gw).set("vvc1", hw).set("vvi1", hw).set("dvc1", hw).set("dvi1", hw);
        Kd("video/mp4", function() {
            return new bw;
        });
        function iw() {
            this.g = null;
        }
        iw.prototype.init = function() {};
        iw.prototype.parse = function(a) {
            this.g ? this.g.clearData() : this.g = new Ek;
            var b = [];
            a = Fb(a);
            if (!Rk(a)) return b;
            a = this.g.parse(a);
            var c = a.me(), d = a.yf();
            a = [];
            switch(c.video){
                case "avc":
                    a.push(6);
                    break;
                case "hvc":
                    a.push(39), a.push(40);
            }
            if (!a.length) return b;
            c = u(d);
            for(d = c.next(); !d.done; d = c.next())if (d = d.value, a.includes(d.type) && d.time != null) for(var e = u(aw(d.data)), f = e.next(); !f.done; f = e.next())b.push({
                packet: f.value,
                pts: d.time
            });
            return b;
        };
        O("shaka.cea.TsCeaParser", iw);
        Kd("video/mp2t", function() {
            return new iw;
        });
        function jw(a) {
            var b = 0, c = Jb(a), d = c.getUint32(b, !0);
            if (d != a.byteLength) return [];
            a: {
                a = b + 4 + 2;
                for(b = []; a < c.byteLength - 1;){
                    d = c.getUint16(a, !0);
                    a += 2;
                    var e = c.getUint16(a, !0);
                    a += 2;
                    if ((e & 1) != 0 || e + a > c.byteLength) {
                        c = [];
                        break a;
                    }
                    var f = Fb(c, a, e);
                    b.push({
                        type: d,
                        value: f
                    });
                    a += e;
                }
                c = b;
            }
            return c;
        }
        function kw(a) {
            a = qc(ke(a));
            a = jw(a).filter(function(b) {
                return b.type === lw;
            })[0];
            if (!a) return null;
            a = cc(a.value, !0);
            return (a = ae(a, "WRMHEADER")) ? a : null;
        }
        function mw(a) {
            try {
                var b = kw(a);
                if (b) a: {
                    for(var c = u(me(b, "DATA")), d = c.next(); !d.done; d = c.next()){
                        var e = d.value;
                        if (e.children) for(var f = u(e.children), g = f.next(); !g.done; g = f.next()){
                            var h = g.value;
                            if (h.tagName == "LA_URL") {
                                var k = ke(h);
                                break a;
                            }
                        }
                    }
                    k = "";
                }
                else k = "";
                return k;
            } catch (l) {
                return "";
            }
        }
        var lw = 1;
        function nw() {
            this.g = new Map;
        }
        nw.prototype.release = function() {
            this.g.clear();
        };
        function ow(a, b, c, d) {
            var e = pw(a, b), f = null;
            a = [];
            var g = [];
            b = null;
            var h = new Set(e.map(function(l) {
                return l.keyId;
            }));
            h.delete(null);
            var k = "cenc";
            if (h.size > 1) throw new T(2, 4, 4010);
            if (!c) {
                g = e.filter(function(l) {
                    return l.Ud == "urn:mpeg:dash:sea:2012";
                });
                if (g.length > 1) throw new T(2, 4, 4050);
                g.length && (b = qw(g[0]));
                (g = e.find(function(l) {
                    return l.Ud == "urn:mpeg:dash:mp4protection:2011";
                })) && g.encryptionScheme && (k = g.encryptionScheme);
                g = e.filter(function(l) {
                    return l.Ud == "urn:mpeg:dash:mp4protection:2011" ? (f = l.init || f, !1) : l.Ud != "urn:mpeg:dash:sea:2012";
                });
                g.length && (a = rw(f, k, g, d, h), a.length == 0 && (a = [
                    yc("", k, f)
                ]));
            }
            if (e.length && !b && (c || !g.length)) for(a = [], c = u(Object.values(d)), d = c.next(); !d.done; d = c.next())d = d.value, Ob(d) || (d = yc(d, k, f), a.push(d));
            if (h = Array.from(h)[0] || null) for(k = u(a), c = k.next(); !c.done; c = k.next())for(c = u(c.value.initData), d = c.next(); !d.done; d = c.next())d.value.keyId = h;
            return {
                Ti: h,
                Tn: f,
                drmInfos: a,
                Hg: b,
                Yi: !0
            };
        }
        function sw(a, b, c, d, e) {
            var f = ow(a, b, d, e);
            if (c.Yi) {
                a = c.drmInfos.length == 1 && !c.drmInfos[0].keySystem;
                b = f.drmInfos.length == 0;
                if (c.drmInfos.length == 0 || a && !b) c.drmInfos = f.drmInfos;
                c.Yi = !1;
            } else if (f.drmInfos.length > 0 && (c.drmInfos = c.drmInfos.filter(function(g) {
                return f.drmInfos.some(function(h) {
                    return h.keySystem == g.keySystem;
                });
            }), c.drmInfos.length == 0)) throw new T(2, 4, 4008);
            return f.Ti || c.Ti;
        }
        function tw(a) {
            var b = oe(a.node, "https://dashif.org/CPS", "Laurl");
            if (b && (b = ke(b))) return b;
            if ((b = oe(a.node, "urn:microsoft:playready", "pro")) && ke(b)) return mw(b);
            if (a = oe(a.node, "urn:mpeg:cenc:2013", "pssh")) {
                if (a = ke(a)) {
                    b = qc(a);
                    a = 8;
                    b = Jb(b);
                    var c = b.getUint8(a);
                    a += 20;
                    c > 0 && (a += 4 + 16 * b.getUint32(a));
                    a = Fb(b, a + 4);
                    a = lc(a);
                    a = ae("<pro>" + a + "</pro>");
                    return mw(a);
                }
            }
            return "";
        }
        function rw(a, b, c, d, e) {
            var f = [];
            c = u(c);
            for(var g = c.next(); !g.done; g = c.next()){
                g = g.value;
                var h = d[g.Ud];
                if (h) {
                    var k;
                    if ((k = oe(g.node, "urn:microsoft:playready", "pro")) && ke(k)) {
                        k = ke(k);
                        k = qc(k);
                        var l = new Uint8Array([
                            154,
                            4,
                            240,
                            121,
                            152,
                            64,
                            66,
                            134,
                            171,
                            146,
                            230,
                            91,
                            224,
                            136,
                            95,
                            149
                        ]);
                        k = [
                            {
                                initData: Nh(k, l, new Set, 0),
                                initDataType: "cenc",
                                keyId: g.keyId
                            }
                        ];
                    } else k = null;
                    l = null;
                    if (g.Ud === "urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e") {
                        l = g;
                        var m = e;
                        if (m.size == 0) l = null;
                        else {
                            var n = new Uint8Array([
                                16,
                                119,
                                239,
                                236,
                                192,
                                178,
                                77,
                                2,
                                172,
                                227,
                                60,
                                30,
                                82,
                                226,
                                251,
                                75
                            ]), q = new Uint8Array([]);
                            l = [
                                {
                                    initData: Nh(q, n, m, 1),
                                    initDataType: "cenc",
                                    keyId: l.keyId
                                }
                            ];
                        }
                    }
                    k = yc(h, b, g.init || a || k || l);
                    if (h = uw.get(h)) k.licenseServerUri = h(g);
                    a: {
                        if (g = oe(g.node, "https://dashif.org/CPS", "Certurl")) {
                            if (g = ke(g)) break a;
                        }
                        g = "";
                    }
                    k.serverCertificateUri = g;
                    f.push(k);
                }
            }
            return f;
        }
        function pw(a, b) {
            var c = [];
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())(d = vw(a, d.value)) && c.push(d);
            return c;
        }
        function vw(a, b) {
            var c = b.attributes.schemeIdUri, d = re(b, "urn:mpeg:cenc:2013", "default_KID"), e = pe(b, "urn:mpeg:cenc:2013", "pssh").map(le), f = b.attributes.value;
            if (!c) return null;
            c = c.toLowerCase();
            if (d && (d = d.replace(/-/g, "").toLowerCase(), d.includes(" "))) throw new T(2, 4, 4009);
            var g = [];
            try {
                g = e.map(function(h) {
                    if (!a.g.has(h)) {
                        var k = qc(h);
                        a.g.set(h, k);
                    }
                    return {
                        initDataType: "cenc",
                        initData: a.g.get(h),
                        keyId: null
                    };
                });
            } catch (h) {
                throw new T(2, 4, 4007);
            }
            return {
                node: b,
                Ud: c,
                keyId: d,
                init: g.length > 0 ? g : null,
                encryptionScheme: f
            };
        }
        function qw(a) {
            if (!window1.crypto || !window1.crypto.subtle) throw Za("Web Crypto API is not available to decrypt AES-128. (Web Crypto only exists in secure origins like https)"), new T(2, 4, 4042);
            var b = oe(a.node, "urn:mpeg:dash:schema:sea:2012", "SegmentEncryption");
            if (!b) throw new T(2, 4, 4051);
            if (b.attributes.schemeIdUri != "urn:mpeg:dash:sea:aes128-cbc:2013") throw new T(2, 4, 4051);
            b = oe(a.node, "urn:mpeg:dash:schema:sea:2012", "CryptoPeriod");
            if (!b) throw new T(2, 4, 4051);
            a = b.attributes.IV;
            b = jc(b.attributes.keyUriTemplate);
            if (!a || !b) throw new T(2, 4, 4051);
            a = rc(a.substr(2));
            if (a.byteLength != 16) throw new T(2, 4, 4048);
            return {
                Ll: b,
                iv: a
            };
        }
        var uw = (new Map).set("com.apple.fps", function(a) {
            if ("apple" === window1.shakaMediaKeysPolyfill) throw new T(2, 4, 4054);
            if (a = oe(a.node, "https://dashif.org/CPS", "Laurl")) {
                if (a = ke(a)) return a;
            }
            return "";
        }).set("com.widevine.alpha", function(a) {
            var b = oe(a.node, "https://dashif.org/CPS", "Laurl");
            return b && (b = ke(b)) ? b : (a = oe(a.node, "urn:microsoft", "laurl")) ? jc(a.attributes.licenseUrl) || "" : "";
        }).set("com.microsoft.playready", tw).set("com.microsoft.playready.recommendation", tw).set("com.microsoft.playready.software", tw).set("com.microsoft.playready.hardware", tw).set("org.w3.clearkey", function(a) {
            var b = oe(a.node, "https://dashif.org/CPS", "Laurl");
            return b && (b = ke(b)) ? b : (a = oe(a.node, "http://dashif.org/guidelines/clearKey", "Laurl")) && a.attributes.Lic_type === "EME-1.0" && a && (a = ke(a)) ? a : "";
        });
        function ww(a, b, c, d, e, f) {
            var g = (new Map).set("RepresentationID", b).set("Number", c).set("SubNumber", d).set("Bandwidth", e).set("Time", f);
            return a.replace(/\$(RepresentationID|Number|SubNumber|Bandwidth|Time)?(?:%0([0-9]+)([diouxX]))?\$/g, function(h, k, l, m) {
                if (h == "$$") return "$";
                var n = g.get(k);
                if (n == null) return h;
                k == "RepresentationID" && l && (l = void 0);
                k == "Time" && typeof n != "bigint" && (Math.abs(n - Math.round(n)) >= .2 && Za("Calculated $Time$ values must be close to integers"), n = Math.round(n));
                switch(m){
                    case void 0:
                    case "d":
                    case "i":
                    case "u":
                        h = n.toString();
                        break;
                    case "o":
                        h = n.toString(8);
                        break;
                    case "x":
                        h = n.toString(16);
                        break;
                    case "X":
                        h = n.toString(16).toUpperCase();
                        break;
                    default:
                        h = n.toString();
                }
                l = window1.parseInt(l, 10) || 1;
                return Array(Math.max(0, l - h.length) + 1).join("0") + h;
            });
        }
        function xw(a, b) {
            var c = yw(a, b, "timescale"), d = 1;
            c && (d = xe(c) || 1);
            c = yw(a, b, "duration");
            var e = (c = xe(c || "")) ? c / d : null, f = yw(a, b, "startNumber"), g = Number(yw(a, b, "presentationTimeOffset")) || 0, h = ye(f || "");
            if (f == null || h == null) h = 1;
            f = null;
            if (b = zw(a, b, "SegmentTimeline")) {
                b = ie(b, "S");
                f = d;
                a = a.sa.duration || Infinity;
                for(var k = h, l = [], m = -g, n = 0; n < b.length; ++n){
                    var q = b[n], r = b[n + 1], t = qe(q, "t", ye), v = qe(q, "d", ye), w = qe(q, "r", we);
                    q = qe(q, "k", we) || 0;
                    t != null && (t -= g);
                    if (v) {
                        t = t != null ? t : m;
                        w = w || 0;
                        if (w < 0) {
                            if (r) {
                                r = qe(r, "t", ye);
                                if (r == null) break;
                                else if (t >= r) break;
                                w = Math.ceil((r - t) / v) - 1;
                            } else {
                                if (a == Infinity) break;
                                else if (t / f >= a) break;
                                w = Math.ceil((a * f - t) / v) - 1;
                            }
                        }
                        l.length > 0 && t != m && (l[l.length - 1].end = t / f);
                        for(r = 0; r <= w; ++r)m = t + v, l.push({
                            start: t / f,
                            $d: t,
                            end: m / f,
                            Bi: m,
                            Dc: q,
                            rm: l.length + k
                        }), t = m;
                    }
                }
                f = l;
            }
            return {
                timescale: d,
                qg: c,
                pb: e,
                Ie: h,
                kc: g / d || 0,
                qd: g,
                timeline: f
            };
        }
        function Aw(a, b) {
            return [
                b(a.N),
                b(a.za),
                b(a.Ea)
            ].filter(Zf);
        }
        function yw(a, b, c) {
            b = Aw(a, b);
            a = null;
            b = u(b);
            for(var d = b.next(); !d.done && !(a = d.value.attributes[c]); d = b.next());
            return a;
        }
        function zw(a, b, c) {
            b = Aw(a, b);
            a = null;
            b = u(b);
            for(var d = b.next(); !d.done && !(a = ne(d.value, c)); d = b.next());
            return a;
        }
        function Bw(a, b, c, d, e, f) {
            for(var g = re(a, "http://www.w3.org/1999/xlink", "href"), h = re(a, "http://www.w3.org/1999/xlink", "actuate") || "onRequest", k = u(Object.keys(a.attributes)), l = k.next(); !l.done; l = k.next()){
                l = l.value;
                var m = l.split(":"), n = ce("http://www.w3.org/1999/xlink");
                m[0] == n && delete a.attributes[l];
            }
            if (f >= 5) return $g(new T(2, 4, 4028));
            if (h != "onLoad") return $g(new T(2, 4, 4027));
            var q = vc([
                d
            ], [
                g
            ]);
            return e.request(0, mh(q, b)).eb(function(r) {
                r = $d(r.data, a.tagName);
                if (!r) return $g(new T(2, 4, 4001, g));
                for(a.children = []; r.children.length;){
                    var t = r.children.shift();
                    a.children.push(t);
                }
                t = u(Object.keys(r.attributes));
                for(var v = t.next(); !v.done; v = t.next())v = v.value, a.attributes[v] = r.attributes[v];
                return Cw(a, b, c, q[0], e, f + 1);
            });
        }
        function Cw(a, b, c, d, e, f) {
            f = f === void 0 ? 0 : f;
            if (re(a, "http://www.w3.org/1999/xlink", "href")) {
                var g = Bw(a, b, c, d, e, f);
                c && (g = g.eb(void 0, function() {
                    return Cw(a, b, c, d, e, f);
                }));
                return g;
            }
            g = [];
            for(var h = u(ge(a)), k = h.next(), l = {}; !k.done; l = {
                ge: void 0
            }, k = h.next())l.ge = k.value, re(l.ge, "http://www.w3.org/1999/xlink", "href") == "urn:mpeg:dash:resolve-to-zero:2013" ? a.children = a.children.filter(function(m) {
                return function(n) {
                    return n !== m.ge;
                };
            }(l)) : l.ge.tagName != "SegmentTimeline" && g.push(Cw(l.ge, b, c, d, e, f));
            return dh(g).eb(function() {
                return a;
            });
        }
        function Dw(a, b, c, d, e, f, g, h) {
            var k, l = (new Bh).qa("sidx", function(m) {
                k = Ew(b, d, e, f, g, c, m, h);
            });
            a && l.parse(a);
            if (k) return k;
            throw new T(2, 3, 3004);
        }
        function Ew(a, b, c, d, e, f, g, h) {
            h = h === void 0 ? !1 : h;
            var k = [];
            g.reader.skip(4);
            var l = g.reader.Y();
            if (l == 0) throw new T(2, 3, 3005);
            if (g.version == 0) {
                var m = g.reader.Y();
                var n = g.reader.Y();
            } else m = g.reader.Rd(), n = g.reader.Rd();
            g.reader.skip(2);
            var q = g.reader.Ka();
            a = (h ? -g.size : a) + g.size + n;
            for(h = 0; h < q; h++){
                var r = g.reader.Y();
                n = (r & 2147483648) >>> 31;
                r &= 2147483647;
                var t = g.reader.Y();
                g.reader.skip(4);
                if (n == 1) throw new T(2, 3, 3006);
                k.push(new Oj(m / l + c, (m + t) / l + c, function() {
                    return f;
                }, a, a + r - 1, b, c, d, e));
                m += t;
                a += r;
            }
            g.parser.stop();
            return k;
        }
        function Fw(a) {
            this.h = Jb(a);
            this.g = new yh(this.h, 0);
        }
        Fw.prototype.Sa = function() {
            return this.g.Sa();
        };
        function Gw(a) {
            var b = Hw(a);
            if (b.length > 7) throw new T(2, 3, 3002);
            var c = 0;
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())c = 256 * c + d.value;
            b = Hw(a);
            a: {
                d = u(Iw);
                for(var e = d.next(); !e.done; e = d.next())if (Eb(b, new Uint8Array(e.value))) {
                    d = !0;
                    break a;
                }
                d = !1;
            }
            if (d) b = a.h.byteLength - a.g.Xa();
            else {
                if (b.length == 8 && b[1] & 224) throw new T(2, 3, 3001);
                for(e = d = 0; e < b.length; e++){
                    var f = b[e];
                    d = e == 0 ? f & (1 << 8 - b.length) - 1 : 256 * d + f;
                }
                b = d;
            }
            b = a.g.Xa() + b <= a.h.byteLength ? b : a.h.byteLength - a.g.Xa();
            d = Jb(a.h, a.g.Xa(), b);
            a.g.skip(b);
            return new Jw(c, d);
        }
        function Hw(a) {
            var b = a.g.Xa(), c = a.g.ea();
            if (c == 0) throw new T(2, 3, 3002);
            c = 8 - Math.floor(Math.log2(c));
            a.g.skip(c - 1);
            return Fb(a.h, b, c);
        }
        var Iw = [
            [
                255
            ],
            [
                127,
                255
            ],
            [
                63,
                255,
                255
            ],
            [
                31,
                255,
                255,
                255
            ],
            [
                15,
                255,
                255,
                255,
                255
            ],
            [
                7,
                255,
                255,
                255,
                255,
                255
            ],
            [
                3,
                255,
                255,
                255,
                255,
                255,
                255
            ],
            [
                1,
                255,
                255,
                255,
                255,
                255,
                255,
                255
            ]
        ];
        function Jw(a, b) {
            this.id = a;
            this.g = b;
        }
        function Kw(a) {
            if (a.g.byteLength > 8) throw new T(2, 3, 3002);
            if (a.g.byteLength == 8 && a.g.getUint8(0) & 224) throw new T(2, 3, 3001);
            for(var b = 0, c = 0; c < a.g.byteLength; c++){
                var d = a.g.getUint8(c);
                b = 256 * b + d;
            }
            return b;
        }
        function Lw(a, b, c, d, e, f, g) {
            b = new Fw(b);
            if (Gw(b).id != 440786851) throw new T(2, 3, 3008);
            var h = Gw(b);
            if (h.id != 408125543) throw new T(2, 3, 3009);
            b = h.g.byteOffset;
            h = new Fw(h.g);
            for(var k = null; h.Sa();){
                var l = Gw(h);
                if (l.id == 357149030) {
                    k = l;
                    break;
                }
            }
            if (!k) throw new T(2, 3, 3010);
            k = new Fw(k.g);
            l = 1E6;
            for(h = null; k.Sa();){
                var m = Gw(k);
                if (m.id == 2807729) l = Kw(m);
                else if (m.id == 17545) {
                    if (m.g.byteLength == 4) h = m.g.getFloat32(0);
                    else if (m.g.byteLength == 8) h = m.g.getFloat64(0);
                    else throw new T(2, 3, 3003);
                }
            }
            if (h == null) throw new T(2, 3, 3011);
            k = l / 1E9;
            h *= k;
            a = Gw(new Fw(a));
            if (a.id != 475249515) throw new T(2, 3, 3007);
            return Mw(a, b, k, h, c, d, e, f, g);
        }
        function Mw(a, b, c, d, e, f, g, h, k) {
            function l() {
                return e;
            }
            var m = [];
            a = new Fw(a.g);
            for(var n = null, q = null; a.Sa();){
                var r = Gw(a);
                if (r.id == 187) {
                    var t = Nw(r);
                    t && (r = c * t.Fm, t = b + t.gm, n != null && m.push(new Oj(n + g, r + g, l, q, t - 1, f, g, h, k)), n = r, q = t);
                }
            }
            n != null && m.push(new Oj(n + g, d + g, l, q, null, f, g, h, k));
            return m;
        }
        function Nw(a) {
            var b = new Fw(a.g);
            a = Gw(b);
            if (a.id != 179) throw new T(2, 3, 3013);
            a = Kw(a);
            b = Gw(b);
            if (b.id != 183) throw new T(2, 3, 3012);
            b = new Fw(b.g);
            for(var c = 0; b.Sa();){
                var d = Gw(b);
                if (d.id == 241) {
                    c = Kw(d);
                    break;
                }
            }
            return {
                Fm: a,
                gm: c
            };
        }
        function Ow(a, b, c) {
            b = zw(a, b, "Initialization");
            if (!b) return null;
            var d = a.N.ib(), e = b.attributes.sourceURL;
            e && (d = vc(d, [
                jc(e)
            ], a.Mb()));
            e = 0;
            var f = null;
            if (b = qe(b, "range", ve)) e = b.start, f = b.end;
            c = new Mj(function() {
                return d;
            }, e, f, Pw(a), null, null, c, a.za.encrypted);
            c.codecs = a.N.codecs;
            c.mimeType = a.N.mimeType;
            a.sa && !a.sa.Ff && (c.g = a.sa.start + a.sa.duration);
            return c;
        }
        function Qw(a, b, c) {
            var d = Number(yw(a, Rw, "presentationTimeOffset")) || 0, e = yw(a, Rw, "timescale"), f = 1;
            e && (f = xe(e) || 1);
            var g = d / f || 0, h = Ow(a, Rw, c);
            Sw(a, h);
            var k = Yd(a);
            return {
                endTime: -1,
                timeline: -1,
                cd: function() {
                    var l = zw(k, Rw, "RepresentationIndex");
                    var m = k.N.ib();
                    l && (l = jc(l.attributes.sourceURL)) && (m = vc(m, [
                        l
                    ], k.Mb()));
                    l = Tw(k);
                    return Uw(k, b, h, m, l.start, l.end, g);
                },
                timescale: f
            };
        }
        function Uw(a, b, c, d, e, f, g) {
            var h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F;
            return H(function(I) {
                if (I.h == 1) return h = a.presentationTimeline, k = !a.wb || !a.sa.Ff, l = a.sa.start, m = a.sa.duration, n = a.N.mimeType.split("/")[1], q = b, r = null, t = [
                    q(d, e, f, !1),
                    n == "webm" ? q(c.T(), c.startByte, c.endByte, !0) : null
                ], q = null, I.g(Promise.all(t), 2);
                v = I.i;
                w = v[0];
                x = v[1] || null;
                y = null;
                z = l - g;
                A = l;
                E = m ? l + m : Infinity;
                C = a.N.ib();
                D = C.length != d.length || C.some(function(K, N) {
                    return K != d[N];
                });
                y = n == "mp4" ? Dw(w, e, C, c, z, A, E, D) : Lw(w, x, C, c, z, A, E);
                B = u(y);
                for(J = B.next(); !J.done; J = B.next())F = J.value, F.codecs = a.N.codecs, F.mimeType = a.N.mimeType, F.bandwidth = a.bandwidth;
                h.Ae(y);
                r = new vm(y);
                k && r.zd(A, E, !0);
                return I.return(r);
            });
        }
        function Rw(a) {
            return a.Vd;
        }
        function Tw(a) {
            var b = zw(a, Rw, "RepresentationIndex");
            a = yw(a, Rw, "indexRange");
            a = ve(a || "");
            b && (a = qe(b, "range", ve, a));
            return a;
        }
        function Sw(a, b) {
            Vw(a, b);
            if (!Tw(a)) throw new T(2, 4, 4002);
        }
        function Vw(a, b) {
            var c = a.N.mimeType.split("/")[1];
            if (a.N.contentType != Ec && c != "mp4" && c != "webm") throw new T(2, 4, 4006);
            if (c == "webm" && !b) throw new T(2, 4, 4005);
        }
        function Pw(a) {
            var b = a.N;
            return {
                bandwidth: a.bandwidth,
                audioSamplingRate: b.audioSamplingRate,
                codecs: b.codecs,
                contentType: b.contentType,
                frameRate: b.frameRate || null,
                height: b.height || null,
                mimeType: b.mimeType,
                channelsCount: b.Tf,
                pixelAspectRatio: b.pixelAspectRatio || null,
                width: b.width || null,
                label: a.za.label || null,
                roles: a.roles || null,
                language: a.za.language || null
            };
        }
        function Ww(a, b, c) {
            var d = Ow(a, Xw, c), e = Yw(a);
            if (!e.pb && !e.timeline && e.Ld.length > 1) throw new T(2, 4, 4002);
            if (!e.pb && !a.sa.duration && !e.timeline && e.Ld.length == 1) throw new T(2, 4, 4002);
            if (e.timeline && e.timeline.length == 0) throw new T(2, 4, 4002);
            var f = null, g = null;
            a.Ea.id && a.N.id && (g = b.get(a.Ea.id + "," + a.N.id)) && (f = g.segmentIndex);
            var h = Zw(a.sa.start, a.sa.duration, a.N.ib, e, d, c, a.N.mimeType, a.N.codecs, a.bandwidth, a.Mb);
            b = !f;
            f ? f.ye(h, a.presentationTimeline.Hb()) : f = new vm(h);
            a.presentationTimeline.Ae(h);
            a.wb && a.sa.Ff || f.zd(a.sa.start, a.sa.duration ? a.sa.start + a.sa.duration : Infinity, b);
            g && (g.segmentIndex = f);
            return {
                endTime: -1,
                timeline: -1,
                cd: function() {
                    f && f.getNumReferences() != 0 || f.Of(h);
                    return Promise.resolve(f);
                },
                timescale: e.timescale
            };
        }
        function Xw(a) {
            return a.Hc;
        }
        function Yw(a) {
            var b = $w(a);
            a = xw(a, Xw);
            var c = a.Ie;
            c == 0 && (c = 1);
            var d = 0;
            a.pb ? d = a.pb * (c - 1) : a.timeline && a.timeline.length > 0 && (d = a.timeline[0].start);
            return {
                pb: a.pb,
                startTime: d,
                Ie: c,
                kc: a.kc,
                timescale: a.timescale,
                timeline: a.timeline,
                Ld: b
            };
        }
        function Zw(a, b, c, d, e, f, g, h, k, l) {
            var m = d.Ld.length;
            d.timeline && d.timeline.length != d.Ld.length && (m = Math.min(d.timeline.length, d.Ld.length));
            for(var n = a - d.kc, q = b ? a + b : Infinity, r = [], t = d.startTime, v = {}, w = 0; w < m; v = {
                sg: void 0,
                eg: void 0
            }, w++){
                v.eg = d.Ld[w];
                var x = t;
                t = void 0;
                t = d.pb != null ? x + d.pb : d.timeline ? d.timeline[w].end : x + b;
                v.sg = null;
                v = new Oj(a + x, a + t, function(y) {
                    return function() {
                        y.sg == null && (y.sg = vc(c(), [
                            y.eg.Sl
                        ], l()));
                        return y.sg;
                    };
                }(v), v.eg.start, v.eg.end, e, n, a, q, [], "", null, null, Pj, f);
                v.codecs = h;
                v.mimeType = g;
                v.bandwidth = k;
                r.push(v);
            }
            return r;
        }
        function $w(a) {
            return [
                a.N.Hc,
                a.za.Hc,
                a.Ea.Hc
            ].filter(Zf).map(function(b) {
                return ie(b, "SegmentURL");
            }).reduce(function(b, c) {
                return b.length > 0 ? b : c;
            }).map(function(b) {
                b.attributes.indexRange && !a.Dh && (a.Dh = !0);
                var c = jc(b.attributes.media);
                b = qe(b, "mediaRange", ve, {
                    start: 0,
                    end: null
                });
                return {
                    Sl: c,
                    start: b.start,
                    end: b.end
                };
            });
        }
        function ax(a, b, c, d, e, f, g, h, k, l) {
            k || a.N.Bf || (a.N.Bf = yw(a, bx, "initialization"));
            var m = a.N.Bf ? cx(a, g) : null, n = dx(a);
            ex(n);
            var q = Yd(a);
            if (n.se) return Vw(a, m), {
                endTime: -1,
                timeline: -1,
                cd: function() {
                    var x = ww(n.se, q.N.originalId, null, null, q.bandwidth || null, null);
                    x = vc(q.N.ib(), [
                        x
                    ]);
                    return Uw(q, b, m, x, 0, null, n.kc);
                },
                timescale: n.timescale
            };
            if (n.pb) return d || a.za.contentType === "image" || a.za.contentType === "text" || (d = a.sa.start, l = a.Ea.id, c = a.sa.duration, l = (l = l != null && f.get(l) || c) ? d + l : Infinity, a.presentationTimeline.Oh(n.pb), a.presentationTimeline.vj(d, l)), {
                endTime: -1,
                timeline: -1,
                cd: function() {
                    return fx(q, n, e, m, f, g, h, a.N.fg);
                },
                timescale: n.timescale
            };
            var r = null;
            d = d = null;
            a.Ea.id && a.N.id && (d = a.Ea.id + "," + a.N.id, d = c.get(d)) && (r = d.segmentIndex);
            var t = a.sa.start, v = a.sa.duration ? t + a.sa.duration : Infinity;
            if (r) l = r, gx(l, n, t, v, m, a.wb), l.$a(a.presentationTimeline.Hb());
            else {
                c = 0;
                k = -1;
                if (a.Ea.id != null && a.N.id != null) {
                    var w = l.get(a.Ea.id);
                    if (w) k = w.timeline;
                    else for(l = u(l.values()), w = l.next(); !w.done; w = l.next())if (w = w.value, Math.abs(n.kc - w.endTime) <= Hc && w.Yh.includes(a.N.id)) {
                        k = w.timeline;
                        break;
                    } else w.timeline >= c && (c = w.timeline + 1);
                }
                k == -1 && (k = c);
                r = new hx(a.wb, n, a.N.originalId, a.bandwidth, a.N.ib, a.Mb, t, v, m, g, a.N.fg, k);
            }
            n.timeline && a.za.contentType !== "image" && a.za.contentType !== "text" && a.presentationTimeline.wj(r.h ? r.h.timeline : [], t);
            d && a.wb && (d.segmentIndex = r);
            d = (d = (d = n.timeline) && d[d.length - 1]) ? d.end + n.kc : -1;
            l = -1;
            r instanceof hx && (l = r.lf());
            return {
                endTime: d,
                timeline: l,
                cd: function() {
                    r instanceof hx && r.getNumReferences() == 0 && gx(r, n, t, v, m, a.wb);
                    return Promise.resolve(r);
                },
                timescale: n.timescale
            };
        }
        function bx(a) {
            return a.Wc;
        }
        function dx(a) {
            var b = xw(a, bx), c = yw(a, bx, "media"), d = yw(a, bx, "index"), e = yw(a, bx, "k"), f = 0;
            e && (f = parseInt(e, 10));
            return {
                qg: b.qg,
                pb: b.pb,
                timescale: b.timescale,
                Ie: b.Ie,
                kc: b.kc,
                qd: b.qd,
                timeline: b.timeline,
                fc: c && jc(c),
                se: d,
                mimeType: a.N.mimeType,
                codecs: a.N.codecs,
                bandwidth: a.bandwidth,
                Ul: f
            };
        }
        function ex(a) {
            var b = a.se ? 1 : 0;
            b += a.timeline ? 1 : 0;
            b += a.pb ? 1 : 0;
            if (b == 0) throw new T(2, 4, 4002);
            b != 1 && (a.se && (a.timeline = null), a.qg = null, a.pb = null);
            if (!a.se && !a.fc) throw new T(2, 4, 4002);
        }
        function fx(a, b, c, d, e, f, g, h) {
            function k(I) {
                var K = I - w, N = K * v, P = b.qg, M = K * P;
                "BigInt" in window1 && M > Number.MAX_SAFE_INTEGER && (M = BigInt(K) * BigInt(P));
                N += q;
                K = N + v;
                P = Math.min(K, m());
                var L = [], Q = b.Ul;
                if (Q) for(var S = (P - N) / Q, Z = {}, pa = 0; pa < Q; Z = {
                    Wj: void 0
                }, pa++){
                    var va = N + S * pa, Ca = va + S;
                    Z.Wj = pa;
                    Z = new Oj(va, Ca, function(ua) {
                        return function() {
                            var xa = ww(x, z, I, ua.Wj, y, M);
                            return vc(A(), [
                                xa
                            ], E());
                        };
                    }(Z), 0, null, d, C, q, m(), [], "", null, null, Pj, f);
                    Z.codecs = a.N.codecs;
                    Z.mimeType = a.N.mimeType;
                    h == 0 ? pa > 0 && Z.Jd() : pa % h != 0 && Z.Jd();
                    L.push(Z);
                }
                N = new Oj(N, P, function() {
                    if (Q) return [];
                    var ua = ww(x, z, I, null, y, M);
                    return vc(A(), [
                        ua
                    ], E());
                }, 0, null, d, C, q, m(), L, "", null, null, Pj, f, L.length > 0);
                N.codecs = a.N.codecs;
                N.mimeType = a.N.mimeType;
                N.bandwidth = a.bandwidth;
                N.j = K;
                return N;
            }
            function l() {
                var I = [
                    Math.max(n.Hb(), q),
                    Math.min(n.Pc(), m())
                ].map(function(K) {
                    return K - q;
                });
                I = [
                    Math.ceil(I[0] / v),
                    Math.ceil(I[1] / v) - 1
                ];
                a.N.sb && I[1]++;
                return I.map(function(K) {
                    return K + w;
                });
            }
            function m() {
                var I = r != null && e.get(r) || t;
                return I ? q + I : Infinity;
            }
            var n = a.presentationTimeline, q = a.sa.start, r = a.Ea.id, t = a.sa.duration, v = b.pb, w = b.Ie, x = b.fc, y = a.bandwidth || null, z = a.N.originalId, A = a.N.ib, E = a.Mb, C = q - b.kc, D = l();
            c = a.wb ? Math.max(D[0], D[1] - c + 1) : D[0];
            g = g || D[1];
            var B = new ix(c, g, w, q, v, k);
            D = n.Pc() < m();
            var J = n.U();
            if (D || J) {
                var F = Math.max(c, g + 1);
                c = v;
                a.N.sb && (c = .1);
                B.rg(c, function() {
                    var I = n.Hb();
                    B.$a(I);
                    var K = u(l());
                    K.next();
                    K = K.next().value;
                    for(var N = []; F <= K;){
                        var P = k(F);
                        N.push(P);
                        F++;
                    }
                    return I > m() && !N.length ? null : N;
                });
            }
            return Promise.resolve(B);
        }
        function cx(a, b) {
            var c = a.N.Bf;
            c || (c = yw(a, bx, "initialization"));
            if (!c) return null;
            c = jc(c);
            var d = a.N.originalId, e = a.bandwidth || null, f = a.N.ib, g = a.Mb;
            b = new Mj(function() {
                var h = ww(c, d, null, null, e, null);
                return vc(f(), [
                    h
                ], g());
            }, 0, null, Pw(a), null, null, b, a.za.encrypted);
            b.codecs = a.N.codecs;
            b.mimeType = a.N.mimeType;
            a.sa && !a.sa.Ff && (b.g = a.sa.start + a.sa.duration);
            return b;
        }
        function ix(a, b, c, d, e, f) {
            vm.call(this, Array(Math.max(0, b - a + 1)));
            this.h = a;
            this.A = c;
            this.j = d;
            this.l = e;
            this.C = f;
        }
        oa(ix, vm);
        p = ix.prototype;
        p.find = function(a) {
            var b = this.g.length - 1;
            if (b < 0) return null;
            var c = this.get(this.i);
            if (!c) return null;
            if (a < c.startTime) return this.i;
            c = Math.floor((a - this.j) / this.l) + this.A - this.h;
            if (c < this.i) return null;
            var d = this.get(c);
            if (!d) return null;
            b = (b = c - this.i < b ? this.get(c + 1) : null) ? b.startTime : d.endTime;
            return a >= d.startTime && a < b ? c : null;
        };
        p.get = function(a) {
            var b = a - this.i;
            if (b < 0 || b >= this.g.length) return null;
            var c = this.g[b];
            c || (c = this.C(this.h + a), this.g[b] = c);
            return c;
        };
        p.Fb = function() {
            return this.get(this.i);
        };
        p.xb = function(a) {
            for(var b = 0; b < this.g.length; b++){
                var c = this.get(b + this.i);
                c && a(c);
            }
        };
        p.$a = function(a) {
            if (!this.o) {
                var b = this.g.length - 1;
                if (!(b < 0)) {
                    var c = this.get(this.i);
                    !c || c.endTime > a || (a = (b = this.get(this.i + b)) && b.endTime <= a ? this.g.length : Math.max(0, Math.min(this.g.length, Math.floor((a - this.j) / this.l + this.A - 1) - (this.h + this.i) + 1)), a > 0 && (this.i += a, this.g = this.g.slice(a)));
                }
            }
        };
        function hx(a, b, c, d, e, f, g, h, k, l, m, n) {
            vm.call(this, []);
            this.F = a;
            this.h = b;
            this.H = c;
            this.D = d;
            this.G = e;
            this.J = f;
            this.j = g;
            this.l = h;
            this.A = k;
            this.C = l;
            this.I = m;
            this.K = n;
            jx(this);
        }
        oa(hx, vm);
        p = hx.prototype;
        p.getNumReferences = function() {
            return this.h ? this.h.timeline.length : 0;
        };
        p.release = function() {
            vm.prototype.release.call(this);
            this.h = null;
        };
        p.$a = function(a) {
            if (this.h) {
                var b = this.h.timeline;
                if (b) {
                    for(var c = 0; c < b.length && b[c].end + this.j <= a;)c++;
                    c > 0 && (this.h.timeline = b.slice(c), this.g.length >= c && (this.g = this.g.slice(c)), this.i += c, this.getNumReferences() === 0 && this.release());
                }
            }
        };
        function gx(a, b, c, d, e, f) {
            kx(a, e);
            a.F = f;
            if (a.h) {
                if (a.h.qd !== b.qd) for(c = b.qd - a.h.qd, e = 0; e < b.timeline.length; e++)f = b.timeline[e], f.$d += c, f.Bi += c, f.start = (f.$d + c) / b.timescale, f.end = (f.Bi + c) / b.timescale;
                a.h.fc !== b.fc && (a.h.fc = b.fc);
                c = a.h.timeline;
                if (c.length) {
                    var g = c[c.length - 1];
                    b = b.timeline.filter(function(h) {
                        return h.end > g.end;
                    });
                } else b = b.timeline.slice();
                b.length > 0 && a.h.timeline.push.apply(a.h.timeline, G(b));
                a.l !== d && (a.l = d);
            } else a.h = b, a.j = c, a.l = d;
            jx(a);
        }
        function kx(a, b) {
            if (a.A !== b) {
                a.A = b;
                a = u(a.g);
                for(var c = a.next(); !c.done; c = a.next())(c = c.value) && Sj(c, b);
            }
        }
        function jx(a) {
            if (a.h && !a.o) {
                for(var b = [], c = u(a.h.timeline), d = c.next(); !d.done; d = c.next())d = d.value, d.start >= a.l || d.end <= 0 || b.push(d);
                a.h.timeline = b;
                a.$a(a.j);
            }
        }
        p.find = function(a) {
            var b = this;
            if (this.h && this.h.timeline && this.h.timeline.length && a < this.h.timeline[0].start + this.j) return this.i;
            if (!this.h) return null;
            var c = this.h.timeline;
            if (a < this.j || a >= this.l) return null;
            var d = c.length - 1, e = dd(c, function(h) {
                return h.start + b.j <= a;
            }) - 1;
            if (e < 0) return null;
            var f = c[e], g = f.start + this.j;
            c = e < d ? c[e + 1].start + this.j : this.l === Infinity ? f.end + this.j : this.l;
            return a >= g && a < c ? e + this.i : null;
        };
        p.get = function(a) {
            var b = this;
            a -= this.i;
            if (a < 0 || a >= this.getNumReferences() || !this.h) return null;
            var c = this.g[a];
            if (!c) {
                c = this.h.timeline[a];
                var d = c.rm, e = c.$d + this.h.qd, f = this.j - this.h.kc, g = this.j + c.end, h = g;
                a === this.getNumReferences() - 1 && this.l !== Infinity && (h = this.F && Math.abs(h - this.l) > .1 ? Math.min(h, this.l) : this.l);
                var k = this.h.codecs, l = this.h.mimeType, m = this.h.bandwidth, n = [], q = !1;
                c.Dc && this.h && this.h.fc && (q = this.h.fc.includes("$SubNumber$"));
                if (q) {
                    q = (c.end - c.start) / c.Dc;
                    for(var r = {}, t = 0; t < c.Dc; r = {
                        ug: void 0,
                        Xj: void 0
                    }, t++){
                        var v = c.start + q * t, w = v + q;
                        r.Xj = t;
                        r.ug = null;
                        r = new Oj(this.j + v, this.j + w, function(x) {
                            return function() {
                                if (!b.h) return [];
                                x.ug == null && (x.ug = lx(b.h.fc, b.H, d, b.D, e, x.Xj, b.G, b.J));
                                return x.ug;
                            };
                        }(r), 0, null, this.A, f, this.j, this.l, [], "", null, null, Pj, this.C);
                        r.codecs = k;
                        r.mimeType = l;
                        r.bandwidth = m;
                        this.I == 0 ? t > 0 && r.Jd() : t % this.I != 0 && r.Jd();
                        n.push(r);
                    }
                }
                c = new Oj(this.j + c.start, h, function() {
                    return n.length > 0 || !b.h ? [] : lx(b.h.fc, b.H, d, b.D, e, null, b.G, b.J);
                }, 0, null, this.A, f, this.j, this.l, n, "", null, null, Pj, this.C, n.length > 0);
                c.codecs = k;
                c.mimeType = l;
                c.j = g;
                c.bandwidth = m;
                this.g[a] = c;
            }
            return c;
        };
        p.xb = function(a) {
            jx(this);
            for(var b = 0; b < this.getNumReferences(); b++){
                var c = this.get(b + this.i);
                c && a(c);
            }
        };
        function lx(a, b, c, d, e, f, g, h) {
            a = ww(a, b, c, f, d || null, e);
            return vc(g(), [
                a
            ], h()).map(function(k) {
                return k.toString();
            });
        }
        p.lf = function() {
            return this.K;
        };
        function mx(a) {
            this.o = null;
            this.C = a;
            this.H = new fh;
            this.i = [];
            this.h = null;
            this.m = [];
            this.D = null;
            this.G = [];
            this.F = 300;
            this.l = new Map;
            this.j = new Map;
            this.g = null;
            this.A = "UNKNOWN";
        }
        mx.prototype.configure = function(a) {
            this.o = a;
        };
        mx.prototype.destroy = function() {
            this.C = this.o = null;
            this.i = [];
            this.h = null;
            this.m = [];
            this.G = [];
            this.l.clear();
            this.g != null && (this.g.stop(), this.g = null);
            return this.H.destroy();
        };
        mx.prototype.setManifestType = function(a) {
            this.A = a;
        };
        function nx(a, b) {
            var c, d, e, f, g, h, k;
            return H(function(l) {
                if (l.h == 1) return c = vc(a.i, [
                    ox(a, b)
                ]), d = mh(c, a.o.retryParameters), e = a.C.networkingEngine.request(8, d), gh(a.H, e), l.m(2), l.g(e.promise, 4);
                if (l.h != 2) return f = l.i, g = bc(f.data), h = JSON.parse(g), h.VERSION == 1 && px(a, h, f.uri), l.o(0);
                if ((k = l.l()) && k.code == 7001) return l.return();
                a.g != null && (a.g.stop(), a.g = null);
                a.g = new Uf(function() {
                    nx(a, b);
                });
                a.g.Z(a.F);
                l.j();
            });
        }
        function ox(a, b) {
            if (!a.m.length) return b;
            b = new lb(b);
            var c = a.D || a.m[0], d = Math.round(a.C.getBandwidthEstimate()), e = b.g;
            a.A == "DASH" ? (e.add("_DASH_pathway", c), e.add("_DASH_throughput", String(d))) : a.A == "HLS" && (e.add("_HLS_pathway", c), e.add("_HLS_throughput", String(d)));
            Bb(e);
            e.je && pb(b, e);
            return b.toString();
        }
        function px(a, b, c) {
            a.g != null && (a.g.stop(), a.g = null);
            var d = b["RELOAD-URI"] || c;
            a.g = new Uf(function() {
                nx(a, d);
            });
            if (c = b.TTL) a.F = c;
            a.g.Z(a.F);
            a.m = b["PATHWAY-PRIORITY"] || [];
            a.G = b["PATHWAY-CLONES"] || [];
        }
        function qx(a, b, c, d) {
            var e = a.l.get(b);
            e || (e = new Map);
            e.set(c, d);
            a.l.set(b, e);
        }
        mx.prototype.banLocation = function(a) {
            this.j.set(a, Date.now() + 6E4);
        };
        function rx(a, b, c) {
            c = c === void 0 ? !1 : c;
            b = a.l.get(b) || new Map;
            for(var d = [], e = u(a.m), f = e.next(), g = {}; !f.done; g = {
                Od: void 0
            }, f = e.next())if (g.Od = f.value, f = b.get(g.Od)) d.push({
                Th: g.Od,
                location: f
            });
            else if (f = a.G.find(function(k) {
                return function(l) {
                    return l.cn == k.Od;
                };
            }(g))) {
                var h = b.get(f["BASE-ID"]);
                h && (f["URI-REPLACEMENT"].pk ? (h = new lb(h), nb(h, f["URI-REPLACEMENT"].pk), d.push({
                    Th: g.Od,
                    location: h.toString()
                })) : d.push({
                    Th: g.Od,
                    location: h
                }));
            }
            e = Date.now();
            g = u(a.j.keys());
            for(f = g.next(); !f.done; f = g.next())f = f.value, h = a.j.get(f), e > h && a.j.delete(f);
            d = d.filter(function(k) {
                for(var l = u(a.j.keys()), m = l.next(); !m.done; m = l.next())if (m.value.includes(new lb(k.location).Eb)) return !1;
                return !0;
            });
            d.length && (a.D = d[0].Th);
            d = d.map(function(k) {
                return k.location;
            });
            if (!d.length && a.h) {
                for(e = u(a.h.split(",")), g = e.next(); !g.done; g = e.next())if (g = b.get(g.value)) a.D = a.h, d.push(g);
            }
            if (!d.length) for(b = u(b.values()), e = b.next(); !e.done; e = b.next())d.push(e.value);
            return c ? d : vc(a.i, d);
        }
        function sx() {
            this.l = [];
            this.h = [];
            this.g = [];
            this.j = [];
            this.i = [];
            this.o = !1;
            this.m = new Set;
        }
        p = sx.prototype;
        p.release = function() {
            for(var a = u(this.h.concat(this.g, this.j, this.i)), b = a.next(); !b.done; b = a.next())b = b.value, b.segmentIndex && b.segmentIndex.release();
            this.h = [];
            this.g = [];
            this.j = [];
            this.i = [];
            this.l = [];
            this.o = !1;
            this.m.clear();
        };
        p.yl = function() {
            return this.l;
        };
        p.xh = function() {
            return this.j.slice();
        };
        p.Sk = function() {
            return this.i;
        };
        p.Ui = function(a, b) {
            if (a) {
                if (a.type == "audio") for(var c = u(this.h), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                });
                else if (a.type == "video") for(c = u(this.g), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                }), d.trickModeVideo && (d.trickModeVideo.matchedStreams = d.trickModeVideo.matchedStreams.filter(function(e) {
                    return e !== a;
                })), d.dependencyStream && (d.dependencyStream.matchedStreams = d.dependencyStream.matchedStreams.filter(function(e) {
                    return e !== a;
                }));
                else if (a.type == Ec) for(c = u(this.j), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                });
                else if (a.type == "image") for(c = u(this.i), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                });
                a.segmentIndex && a.closeSegmentIndex();
                this.m.delete(b);
            }
        };
        function tx(a, b) {
            var c = [], d = [], e = [], f = [];
            a = u(a);
            for(var g = a.next(); !g.done; g = a.next()){
                var h = g.value;
                g = new Map(h.audioStreams.map(function(n) {
                    return [
                        ux(n),
                        n
                    ];
                }));
                var k = new Map(h.videoStreams.map(function(n) {
                    return [
                        vx(n),
                        n
                    ];
                })), l = new Map(h.textStreams.map(function(n) {
                    return [
                        wx(n),
                        n
                    ];
                }));
                h = new Map(h.imageStreams.map(function(n) {
                    return [
                        xx(n),
                        n
                    ];
                }));
                if (b) {
                    var m = yx(Ec);
                    l.set(wx(m), m);
                    m = yx("image");
                    h.set(xx(m), m);
                }
                c.push(g);
                d.push(k);
                e.push(l);
                f.push(h);
            }
            return {
                Li: c,
                kk: d,
                ck: e,
                ij: f
            };
        }
        p.Pg = function(a, b, c) {
            c = c === void 0 ? !1 : c;
            var d = this, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z;
            return H(function(pa) {
                if (pa.h == 1) {
                    e = Gc;
                    if (!b && a.length == 1) return f = tx(a, !1), g = f.Li, h = f.kk, k = f.ck, l = f.ij, d.h = Array.from(g[0].values()), d.g = Array.from(h[0].values()), d.j = Array.from(k[0].values()), d.i = Array.from(l[0].values()), pa.B(2);
                    m = c ? d.m.size : 0;
                    n = -1;
                    for(q = 0; q < a.length; q++)r = a[q], d.m.has(r.id) || (d.m.add(r.id), n == -1 && (n = q));
                    if (n == -1) return pa.return();
                    t = tx(a, !0);
                    v = t.Li;
                    w = t.kk;
                    x = t.ck;
                    y = t.ij;
                    return pa.g(Promise.all([
                        zx(d, d.h, v, n, Ax, Bx, m),
                        zx(d, d.g, w, n, Ax, Bx, m),
                        zx(d, d.j, x, n, Ax, Bx, m),
                        zx(d, d.i, y, n, Ax, Bx, m)
                    ]), 2);
                }
                z = 0;
                A = [];
                if (d.g.length && d.h.length) for(I = u(d.h), K = I.next(); !K.done; K = I.next())for(N = K.value, P = u(d.g), M = P.next(); !M.done; M = P.next())L = M.value, Q = Nb(N.drmInfos, L.drmInfos), N.drmInfos.length && L.drmInfos.length && !Q.length || (S = (N.bandwidth || 0) + (L.bandwidth || 0), N.dependencyStream && (S += N.dependencyStream.bandwidth || 0), L.dependencyStream && (S += L.dependencyStream.bandwidth || 0), Z = z++, A.push({
                    id: Z,
                    language: N.language,
                    disabledUntilTime: 0,
                    primary: N.primary,
                    audio: N,
                    video: L,
                    bandwidth: S,
                    drmInfos: Q,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                }));
                else for(E = d.g.length ? d.g : d.h, C = u(E), D = C.next(); !D.done; D = C.next())B = D.value, J = z++, F = B.bandwidth || 0, B.dependencyStream && (F += B.dependencyStream.bandwidth || 0), A.push({
                    id: J,
                    language: B.language,
                    disabledUntilTime: 0,
                    primary: B.primary,
                    audio: B.type == e.ha ? B : null,
                    video: B.type == e.Ba ? B : null,
                    bandwidth: F,
                    drmInfos: B.drmInfos,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                });
                d.l = A;
                pa.j();
            });
        };
        function Cx(a) {
            var b, c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P;
            return H(function(M) {
                switch(M.h){
                    case 1:
                        b = Gc;
                        if (a.length == 1) return M.return(a[0]);
                        c = a.map(function(L) {
                            return new Map(L.filter(function(Q) {
                                return Q.type === b.ha;
                            }).map(function(Q) {
                                return [
                                    ux(Q),
                                    Q
                                ];
                            }));
                        });
                        d = a.map(function(L) {
                            return new Map(L.filter(function(Q) {
                                return Q.type === b.Ba;
                            }).map(function(Q) {
                                return [
                                    vx(Q),
                                    Q
                                ];
                            }));
                        });
                        e = a.map(function(L) {
                            return new Map(L.filter(function(Q) {
                                return Q.type === b.Va;
                            }).map(function(Q) {
                                return [
                                    wx(Q),
                                    Q
                                ];
                            }));
                        });
                        f = a.map(function(L) {
                            return new Map(L.filter(function(Q) {
                                return Q.type === b.zg;
                            }).map(function(Q) {
                                return [
                                    xx(Q),
                                    Q
                                ];
                            }));
                        });
                        g = u(e);
                        for(h = g.next(); !h.done; h = g.next())k = h.value, l = Dx(b.Va), k.set(wx(l), l);
                        m = u(f);
                        for(n = m.next(); !n.done; n = m.next())q = n.value, r = Dx(b.zg), q.set(xx(r), r);
                        t = new sx;
                        return M.g(zx(t, [], c, 0, Ex, Fx, 0), 2);
                    case 2:
                        return v = M.i, M.g(zx(t, [], d, 0, Ex, Fx, 0), 3);
                    case 3:
                        return w = M.i, M.g(zx(t, [], e, 0, Ex, Fx, 0), 4);
                    case 4:
                        return x = M.i, M.g(zx(t, [], f, 0, Ex, Fx, 0), 5);
                    case 5:
                        y = M.i;
                        z = 0;
                        if (w.length && v.length) for(B = u(v), J = B.next(); !J.done; J = B.next())for(F = J.value, I = u(w), K = I.next(); !K.done; K = I.next())N = K.value, P = z++, N.variantIds.push(P), F.variantIds.push(P);
                        else for(A = w.concat(v), E = u(A), C = E.next(); !C.done; C = E.next())D = C.value, D.variantIds = [
                            z++
                        ];
                        return M.return(w.concat(v).concat(x).concat(y));
                }
            });
        }
        function zx(a, b, c, d, e, f, g) {
            var h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F;
            return H(function(I) {
                switch(I.h){
                    case 1:
                        h = [];
                        for(k = 0; k < c.length; k++)k >= d ? h.push(new Set(c[k].values())) : h.push(new Set);
                        l = u(b);
                        m = l.next();
                    case 2:
                        if (m.done) {
                            I.B(4);
                            break;
                        }
                        n = m.value;
                        return I.g(Gx(a, n, c, d, f, h, g), 5);
                    case 5:
                        q = I.i;
                        if (!q) throw new T(2, 4, 4037);
                        m = l.next();
                        I.B(2);
                        break;
                    case 4:
                        r = u(h);
                        for(t = r.next(); !t.done; t = r.next())for(v = t.value, w = u(v), x = w.next(); !x.done; x = w.next())y = x.value, (z = Hx(a, b, y, c, e, f, h)) && b.push(z);
                        A = u(h);
                        for(E = A.next(); !E.done; E = A.next())for(C = E.value, D = u(C), B = D.next(), J = {}; !B.done; J = {
                            oi: void 0
                        }, B = D.next())if (J.oi = B.value, !Ix(J.oi) && (F = b.some(function(K) {
                            return function(N) {
                                return Jx(K.oi, N);
                            };
                        }(J)))) throw new T(2, 4, 4037);
                        return I.return(b);
                }
            });
        }
        function Gx(a, b, c, d, e, f, g) {
            return H(function(h) {
                if (h.h == 1) return Kx(a, c, b, g > 0), b.matchedStreams ? b.segmentIndex ? h.g(Lx(b, d + g), 2) : h.B(2) : h.return(!1);
                Mx(b, d, e, f, g);
                return h.return(!0);
            });
        }
        function Lx(a, b) {
            var c, d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) {
                    c = [];
                    d = a.matchedStreams;
                    for(e = b; e < d.length; e++)f = d[e], c.push(f.createSegmentIndex()), f.trickModeVideo && !f.trickModeVideo.segmentIndex && c.push(f.trickModeVideo.createSegmentIndex()), f.dependencyStream && !f.dependencyStream.segmentIndex && c.push(f.dependencyStream.createSegmentIndex());
                    return k.g(Promise.all(c), 2);
                }
                if (a.segmentIndex instanceof ym) for(g = b; g < d.length; g++)h = d[g], h.segmentIndex && a.segmentIndex.h.push(h.segmentIndex);
                k.j();
            });
        }
        function Hx(a, b, c, d, e, f, g) {
            if (Ix(c)) return null;
            var h = e(c);
            Kx(a, d, h);
            h.createSegmentIndex && (h.createSegmentIndex = function() {
                return H(function(k) {
                    if (h.segmentIndex) return k.B(0);
                    h.segmentIndex = new ym;
                    return k.g(Lx(h, 0), 0);
                });
            }, h.closeSegmentIndex = function() {
                h.segmentIndex && (h.segmentIndex.release(), h.segmentIndex = null);
                if (h.matchedStreams) for(var k = u(h.matchedStreams), l = k.next(); !l.done; l = k.next()){
                    l = l.value;
                    var m;
                    if (m = l.segmentIndex) {
                        a: {
                            m = u(b);
                            for(var n = m.next(); !n.done; n = m.next())if (n = n.value, n !== h && n.segmentIndex && n.matchedStreams && n.matchedStreams.includes(l)) {
                                m = !0;
                                break a;
                            }
                            m = !1;
                        }
                        m = !m;
                    }
                    m && (l.segmentIndex.release(), l.segmentIndex = null);
                }
            });
            if (!h.matchedStreams || !h.matchedStreams.length) return null;
            Mx(h, 0, f, g, 0);
            return h;
        }
        function Mx(a, b, c, d, e) {
            var f = a.matchedStreams;
            for(b += e; b < f.length; b++){
                var g = f[b];
                c(a, g);
                var h = !0;
                a.type == "audio" && Qc(a.language, g.language) == 0 && (h = !1);
                if (h && ((h = d[b - e]) && h.delete(g), g.fullMimeTypes)) for(g = u(g.fullMimeTypes.values()), h = g.next(); !h.done; h = g.next())a.fullMimeTypes.add(h.value);
            }
        }
        function Ax(a) {
            var b = Object.assign({}, a);
            b.originalId = null;
            b.createSegmentIndex = function() {
                return Promise.resolve();
            };
            b.closeSegmentIndex = function() {};
            b.roles = b.roles.slice();
            b.segmentIndex = null;
            b.emsgSchemeIdUris = [];
            b.keyIds = new Set(a.keyIds);
            b.closedCaptions = a.closedCaptions ? new Map(a.closedCaptions) : null;
            b.trickModeVideo = null;
            b.dependencyStream = null;
            return b;
        }
        function Ex(a) {
            var b = Object.assign({}, a);
            b.roles = b.roles.slice();
            b.keyIds = new Set(a.keyIds);
            b.segments = [];
            b.variantIds = [];
            b.closedCaptions = a.closedCaptions ? new Map(a.closedCaptions) : null;
            return b;
        }
        function Bx(a, b) {
            function c(g, h) {
                g || (g = []);
                h = u(h);
                for(var k = h.next(); !k.done; k = h.next())k = k.value, g.includes(k) || g.push(k);
                return g;
            }
            a.roles = c(a.roles, b.roles);
            b.emsgSchemeIdUris && (a.emsgSchemeIdUris = c(a.emsgSchemeIdUris, b.emsgSchemeIdUris));
            for(var d = u(b.keyIds), e = d.next(); !e.done; e = d.next())a.keyIds.add(e.value);
            a.originalId == null ? a.originalId = b.originalId : (d = b.originalId || "") && !a.originalId.endsWith(d) && (a.originalId += "," + d);
            d = Nb(a.drmInfos, b.drmInfos);
            if (b.drmInfos.length && a.drmInfos.length && !d.length) throw new T(2, 4, 4038);
            a.drmInfos = d;
            a.encrypted = a.encrypted || b.encrypted;
            if (b.closedCaptions) for(a.closedCaptions || (a.closedCaptions = new Map), d = u(b.closedCaptions), e = d.next(); !e.done; e = d.next()){
                var f = u(e.value);
                e = f.next().value;
                f = f.next().value;
                a.closedCaptions.set(e, f);
            }
            a.bandwidth && b.bandwidth && (a.bandwidth = Math.max(a.bandwidth, b.bandwidth));
            b.trickModeVideo ? (a.trickModeVideo || (a.trickModeVideo = Ax(b.trickModeVideo), a.trickModeVideo.matchedStreams = [], a.trickModeVideo.createSegmentIndex = function() {
                if (a.trickModeVideo.segmentIndex) return Promise.resolve();
                for(var g = new ym, h = u(a.trickModeVideo.matchedStreams), k = h.next(); !k.done; k = h.next())g.h.push(k.value.segmentIndex);
                a.trickModeVideo.segmentIndex = g;
                return Promise.resolve();
            }), a.trickModeVideo.matchedStreams.push(b.trickModeVideo), Bx(a.trickModeVideo, b.trickModeVideo)) : a.trickModeVideo && (a.trickModeVideo.matchedStreams.push(b), Bx(a.trickModeVideo, b));
            b.dependencyStream ? (a.dependencyStream || (a.dependencyStream = Ax(b.dependencyStream), a.dependencyStream.matchedStreams = [], a.dependencyStream.createSegmentIndex = function() {
                if (a.dependencyStream.segmentIndex) return Promise.resolve();
                for(var g = new ym, h = u(a.dependencyStream.matchedStreams), k = h.next(); !k.done; k = h.next())g.h.push(k.value.segmentIndex);
                a.dependencyStream.segmentIndex = g;
                return Promise.resolve();
            }), a.dependencyStream.matchedStreams.push(b.dependencyStream), Bx(a.dependencyStream, b.dependencyStream)) : a.dependencyStream && (a.dependencyStream.matchedStreams.push(b), Bx(a.dependencyStream, b));
        }
        function Fx(a, b) {
            var c = a.roles;
            c || (c = []);
            for(var d = u(b.roles), e = d.next(); !e.done; e = d.next())e = e.value, c.includes(e) || c.push(e);
            a.roles = c;
            c = u(b.keyIds);
            for(d = c.next(); !d.done; d = c.next())a.keyIds.add(d.value);
            a.encrypted = a.encrypted && b.encrypted;
            a.segments.push.apply(a.segments, G(b.segments));
            if (b.closedCaptions) for(a.closedCaptions || (a.closedCaptions = new Map), b = u(b.closedCaptions), c = b.next(); !c.done; c = b.next())d = u(c.value), c = d.next().value, d = d.next().value, a.closedCaptions.set(c, d);
        }
        function Kx(a, b, c, d) {
            d = (d === void 0 ? 0 : d) ? c.matchedStreams : [];
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = Nx(a, e.value, c);
                if (!e) return;
                d.push(e);
            }
            c.matchedStreams = d;
        }
        function Nx(a, b, c) {
            var d = {
                audio: ux,
                video: vx,
                text: wx,
                image: xx
            }[c.type], e = null, f = d(c);
            if (b.has(f)) e = b.get(f);
            else {
                f = ({
                    audio: function(l, m) {
                        return Jx(l, m);
                    },
                    video: function(l, m) {
                        return Jx(l, m);
                    },
                    text: Ox,
                    image: Px
                })[c.type];
                for(var g = {
                    audio: Qx,
                    video: Rx,
                    text: Sx,
                    image: Tx
                }[c.type], h = u(b.values()), k = h.next(); !k.done; k = h.next())k = k.value, !f(c, k) || c.fastSwitching != k.fastSwitching || e && !g(c, e, k) || (e = k);
            }
            a.o && !Ix(e) && b.delete(d(e));
            return e;
        }
        function Ux(a, b) {
            return a.mimeType != b.mimeType ? !1 : Vx(a.codecs) === Vx(b.codecs);
        }
        p.Rj = function(a) {
            this.o = a;
        };
        function Jx(a, b) {
            return a.drmInfos && !Lb(a.drmInfos, b.drmInfos) ? !1 : !0;
        }
        function Ox(a, b) {
            return b.language ? a.forced !== b.forced || Qc(a.language, b.language) == 0 || b.kind != a.kind ? !1 : !0 : !0;
        }
        function Px() {
            return !0;
        }
        function Qx(a, b, c) {
            var d = Wx(a, b, c);
            if (d === Xx) return !0;
            if (d === Yx) return !1;
            d = Qc(a.language, b.language);
            var e = Qc(a.language, c.language);
            if (e > d) return !0;
            if (e < d) return !1;
            if (b.label !== c.label) {
                if (a.label === b.label) return !1;
                if (a.label === c.label) return !0;
            }
            if (a.roles.length) {
                d = b.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                e = c.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                if (e.length > d.length) return !0;
                if (e.length < d.length) return !1;
                if (c.roles.length !== b.roles.length) return c.roles.length < b.roles.length;
            } else {
                if (!c.roles.length && b.roles.length) return !0;
                if (c.roles.length && !b.roles.length) return !1;
            }
            if (!b.primary && c.primary) return !0;
            if (b.primary && !c.primary) return !1;
            d = Zx(a.channelsCount, b.channelsCount, c.channelsCount);
            if (d == Xx) return !0;
            if (d == Yx) return !1;
            d = Zx(a.audioSamplingRate, b.audioSamplingRate, c.audioSamplingRate);
            return d == Xx ? !0 : d == Yx ? !1 : a.bandwidth && $x(a.bandwidth, b.bandwidth, c.bandwidth) == Xx ? !0 : !1;
        }
        function Rx(a, b, c) {
            var d = Wx(a, b, c);
            if (d === Xx) return !0;
            if (d === Yx) return !1;
            d = Zx(a.width * a.height, b.width * b.height, c.width * c.height);
            if (d == Xx) return !0;
            if (d == Yx) return !1;
            if (a.frameRate) {
                d = Zx(a.frameRate, b.frameRate, c.frameRate);
                if (d == Xx) return !0;
                if (d == Yx) return !1;
            }
            return a.bandwidth && $x(a.bandwidth, b.bandwidth, c.bandwidth) == Xx ? !0 : !1;
        }
        function Sx(a, b, c) {
            var d = Qc(a.language, b.language), e = Qc(a.language, c.language);
            if (e > d) return !0;
            if (e < d) return !1;
            if (!b.primary && c.primary) return !0;
            if (b.primary && !c.primary) return !1;
            if (b.label !== c.label) {
                if (a.label === b.label) return !1;
                if (a.label === c.label) return !0;
            }
            if (a.roles.length) {
                d = b.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                e = c.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                if (e.length > d.length) return !0;
                if (e.length < d.length) return !1;
            } else {
                if (!c.roles.length && b.roles.length) return !0;
                if (c.roles.length && !b.roles.length) return !1;
            }
            return c.mimeType != a.mimeType || c.codecs != a.codecs || b.mimeType == a.mimeType && b.codecs == a.codecs ? !1 : !0;
        }
        function Tx(a, b, c) {
            return Zx(a.width * a.height, b.width * b.height, c.width * c.height) == Xx ? !0 : !1;
        }
        function Dx(a) {
            return {
                id: 0,
                originalId: "",
                groupId: null,
                primary: !1,
                type: a,
                mimeType: "",
                codecs: "",
                language: "",
                originalLanguage: null,
                label: null,
                width: null,
                height: null,
                encrypted: !1,
                keyIds: new Set,
                segments: [],
                variantIds: [],
                roles: [],
                forced: !1,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                closedCaptions: null,
                external: !1,
                fastSwitching: !1,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
        }
        function yx(a) {
            return {
                id: 0,
                originalId: "",
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: new vm([]),
                mimeType: "",
                codecs: "",
                encrypted: !1,
                drmInfos: [],
                keyIds: new Set,
                language: "",
                originalLanguage: null,
                label: null,
                type: a,
                primary: !1,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: null,
                roles: [],
                forced: !1,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                closedCaptions: null,
                accessibilityPurpose: null,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
        }
        function Zx(a, b, c) {
            if (b == a && a != c) return Yx;
            if (c == a && a != b) return Xx;
            if (b > a) {
                if (c <= a || c - a < b - a) return Xx;
                if (c - a > b - a) return Yx;
            } else {
                if (c > a) return Yx;
                if (a - c < a - b) return Xx;
                if (a - c > a - b) return Yx;
            }
            return ay;
        }
        function Wx(a, b, c) {
            var d = a.mimeType === b.mimeType && a.codecs === b.codecs, e = a.mimeType === c.mimeType && a.codecs === c.codecs;
            if (d && !e) return Yx;
            if (!d && e) return Xx;
            b = Ux(a, b);
            a = Ux(a, c);
            return b && !a ? Yx : !b && a ? Xx : ay;
        }
        function $x(a, b, c) {
            b = Math.abs(a - b);
            a = Math.abs(a - c);
            return a < b ? Xx : b < a ? Yx : ay;
        }
        function Ix(a) {
            switch(a.type){
                case Ec:
                    return !a.language;
                case "image":
                    return !a.tilesLayout;
                default:
                    return !1;
            }
        }
        function vx(a) {
            return by([
                a.fastSwitching,
                a.width,
                a.frameRate,
                a.codecs,
                a.mimeType,
                a.label,
                a.roles,
                a.closedCaptions ? Array.from(a.closedCaptions.entries()) : null,
                a.bandwidth,
                a.dependencyStream ? a.dependencyStream.baseOriginalId : null,
                Array.from(a.keyIds)
            ]);
        }
        function ux(a) {
            return by([
                a.fastSwitching,
                a.channelsCount,
                a.language,
                a.bandwidth,
                a.label,
                a.codecs,
                a.mimeType,
                a.roles,
                a.audioSamplingRate,
                a.primary,
                a.dependencyStream ? a.dependencyStream.baseOriginalId : null,
                Array.from(a.keyIds)
            ]);
        }
        function wx(a) {
            return by([
                a.language,
                a.label,
                a.codecs,
                a.mimeType,
                a.bandwidth,
                a.roles
            ]);
        }
        function xx(a) {
            return by([
                a.width,
                a.codecs,
                a.mimeType
            ]);
        }
        function by(a) {
            return JSON.stringify(a);
        }
        function Vx(a) {
            if (!cy.has(a)) {
                var b = Cf(a);
                cy.set(a, b);
            }
            return cy.get(a);
        }
        O("shaka.util.PeriodCombiner", sx);
        sx.prototype.setUseStreamOnce = sx.prototype.Rj;
        sx.prototype.combinePeriods = sx.prototype.Pg;
        sx.prototype.deleteStream = sx.prototype.Ui;
        sx.prototype.getImageStreams = sx.prototype.Sk;
        sx.prototype.getTextStreams = sx.prototype.xh;
        sx.prototype.getVariants = sx.prototype.yl;
        var Xx = 1, ay = 0, Yx = -1, cy = new Map;
        function dy(a, b) {
            var c = new DOMParser, d = ey.value()(a);
            a = null;
            try {
                a = c.parseFromString(d, "text/xml");
            } catch (e) {
                return null;
            }
            c = a.documentElement;
            if (!c || c.getElementsByTagName("parsererror").length || c.tagName != b) return null;
            if (!("createNodeIterator" in document)) return c;
            for(b = document.createNodeIterator(a, NodeFilter.SHOW_ALL); a = b.nextNode();)if (a instanceof HTMLElement || a instanceof SVGElement) return null;
            return c;
        }
        function fy(a, b) {
            try {
                var c = ec(a);
                return dy(c, b);
            } catch (d) {
                return null;
            }
        }
        var ey = new Kb(function() {
            if (typeof trustedTypes !== "undefined") {
                var a = trustedTypes.createPolicy("shaka-player#xml", {
                    createHTML: function(b) {
                        return b;
                    }
                });
                return function(b) {
                    return a.createHTML(b);
                };
            }
            return function(b) {
                return b;
            };
        });
        function gy() {
            var a = this;
            this.j = this.g = null;
            this.C = [];
            this.h = null;
            this.Ia = 1;
            this.I = [];
            this.l = {
                Qf: "",
                type: "",
                profiles: [],
                Bc: null,
                sb: 0,
                ib: null,
                De: 0
            };
            this.A = new Map;
            this.D = new Map;
            this.H = new Map;
            this.o = new Map;
            this.G = new Map;
            this.ya = new Map;
            this.m = new sx;
            this.L = 0;
            this.Ga = new Xc(5);
            this.M = new Uf(function() {
                if (a.K && !a.g.continueLoadingWhenPaused && (a.J.Fa(a.K, "timeupdate"), a.K.paused)) {
                    a.J.ra(a.K, "timeupdate", function() {
                        return hy(a);
                    });
                    return;
                }
                hy(a);
            });
            this.R = new fh;
            this.P = null;
            this.F = [];
            this.$ = Infinity;
            this.ua = !1;
            this.i = null;
            this.O = 0;
            this.S = !1;
            this.J = new fd;
            this.K = null;
            this.V = !1;
            this.X = "";
            this.na = function() {
                return !1;
            };
            this.W = [];
            this.ba = new Set;
            this.va = new nw;
        }
        p = gy.prototype;
        p.configure = function(a, b) {
            var c = this.j && a.updatePeriod != this.g.updatePeriod && a.updatePeriod >= 0;
            this.g = a;
            b && (this.na = b);
            c && this.h && this.h.presentationTimeline.U() && this.M.La();
            this.i && this.i.configure(this.g);
            this.m && this.m.Rj(this.g.dash.useStreamOnceInPeriodFlattening);
        };
        p.start = function(a, b) {
            var c = this, d;
            return H(function(e) {
                if (e.h == 1) return c.ua = b.isLowLatencyMode(), c.C = [
                    a
                ], c.j = b, e.g(iy(c), 2);
                d = e.i;
                c.j && jy(c, d);
                if (!c.j) throw new T(2, 7, 7001);
                return e.return(c.h);
            });
        };
        p.stop = function() {
            for(var a = u(this.o.values()), b = a.next(); !b.done; b = a.next())b = b.value, b.segmentIndex && b.segmentIndex.release();
            this.m && this.m.release();
            this.g = this.j = null;
            this.C = [];
            this.h = null;
            this.o.clear();
            this.G.clear();
            this.A.clear();
            this.D.clear();
            this.H.clear();
            this.l = {
                Qf: "",
                type: "",
                profiles: [],
                Bc: null,
                sb: 0,
                ib: null,
                De: 0
            };
            this.m = null;
            this.M != null && (this.M.stop(), this.M = null);
            this.i && this.i.destroy();
            this.J && (this.J.release(), this.J = null);
            this.ba.clear();
            this.va.release();
            return this.R.destroy();
        };
        p.update = function() {
            var a = this, b;
            return H(function(c) {
                if (c.h == 1) return c.m(2), c.g(iy(a), 4);
                if (c.h != 2) return c.o(0);
                b = c.l();
                if (!a.j || !b) return c.return();
                a.j.onError(b);
                c.j();
            });
        };
        p.onExpirationUpdated = function() {};
        p.onInitialVariantChosen = function(a) {
            if (this.h && this.h.presentationTimeline.U()) {
                var b = a.video || a.audio;
                if (b && b.segmentIndex) {
                    a = this.h.presentationTimeline.Pc();
                    var c = b.segmentIndex.find(a);
                    c != null && (b = b.segmentIndex.get(c)) && (this.L = b.endTime - a, jy(this, 0));
                }
            }
        };
        p.banLocation = function(a) {
            this.i && this.i.banLocation(a);
        };
        p.setMediaElement = function(a) {
            this.K = a;
        };
        function iy(a) {
            var b, c, d, e, f, g, h, k, l, m, n;
            return H(function(q) {
                if (q.h == 1) return b = 4, c = "MPD", d = ky(a), e = a.C, d.length ? (e = d, c = "Patch", b = 6) : a.C.length > 1 && a.i && (f = rx(a.i, "Location", !0), f.length && (e = f)), g = mh(e, a.g.retryParameters), h = Date.now(), q.g(ly(a, g, 0, {
                    type: b
                }), 2);
                if (q.h != 3) {
                    k = q.i;
                    if (!a.j) return q.return(0);
                    k.uri && k.uri != k.originalUri && !a.C.includes(k.uri) && a.C.unshift(k.uri);
                    l = new lb(k.uri);
                    a.X = l.g.toString();
                    return q.g(my(a, k.data, k.uri, c), 3);
                }
                m = Date.now();
                n = (m - h) / 1E3;
                a.Ga.sample(1, n);
                a.ba.clear();
                return q.return(n);
            });
        }
        function my(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t;
            return H(function(v) {
                if (v.h == 1) {
                    e = b;
                    f = a.g.dash.manifestPreprocessor;
                    g = Ao;
                    if (f != g) {
                        md("manifest.dash.manifestPreprocessor configuration", "Please Use manifest.dash.manifestPreprocessorTXml instead.");
                        h = fy(e, d);
                        if (!h) throw new T(2, 4, 4001, c);
                        f(h);
                        e = hc(h.outerHTML);
                    }
                    k = $d(e, d);
                    if (!k) throw new T(2, 4, 4001, c);
                    l = a.g.dash.manifestPreprocessorTXml;
                    m = Bo;
                    l != m && l(k);
                    if (d === "Patch") return v.return(ny(a, k));
                    if (n = a.g.dash.disableXlinkProcessing) return v.return(oy(a, k, c));
                    q = a.g.dash.xlinkFailGracefully;
                    r = Cw(k, a.g.retryParameters, q, c, a.j.networkingEngine);
                    gh(a.R, r);
                    return v.g(r.promise, 2);
                }
                t = v.i;
                return v.return(oy(a, t, c));
            });
        }
        function oy(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa, Da, Ka, wa, Ja, Aa, Ga, sb, Wb, wb, wc, he, hd, qd, sf, Bg, rd, xc, nc, mi;
            return H(function(oc) {
                switch(oc.h){
                    case 1:
                        a.i && a.i.l.clear();
                        d = [
                            c
                        ];
                        e = [];
                        f = new Map;
                        g = ie(b, "Location");
                        h = u(g);
                        for(k = h.next(); !k.done; k = h.next())if (l = k.value, m = l.attributes.serviceLocation, n = le(l)) q = vc(d, [
                            n
                        ])[0], m && (a.i ? qx(a.i, "Location", m, q) : f.set(m, q)), e.push(q);
                        a.i ? (r = rx(a.i, "Location", !0), r.length > 0 && (d = a.C = r)) : e.length && (d = a.C = e);
                        a.l.Qf = b.attributes.id || "";
                        a.l.De = qe(b, "publishTime", te) || 0;
                        a.I = ie(b, "PatchLocation");
                        t = Promise.resolve();
                        if ((v = ne(b, "ContentSteering")) && a.j) {
                            w = v.attributes.defaultServiceLocation;
                            if (a.i) a.i.i = d, a.i.h = w;
                            else if (a.i = new mx(a.j), a.i.configure(a.g), a.i.setManifestType("DASH"), a.i.i = d, a.i.h = w, x = le(v)) (y = qe(v, "queryBeforeStart", Ae, !1)) ? t = nx(a.i, x) : nx(a.i, x);
                            z = u(f.keys());
                            for(A = z.next(); !A.done; A = z.next())E = A.value, C = f.get(E), qx(a.i, "Location", E, C);
                        }
                        D = ie(b, "BaseURL");
                        B = !1;
                        if (a.i) for(J = u(D), F = J.next(); !F.done; F = J.next())I = F.value, K = I.attributes.serviceLocation, N = le(I), K && N && (qx(a.i, "BaseURL", K, N), B = !0);
                        a.W.splice(0);
                        B && a.i || (P = D.map(le), a.W.push.apply(a.W, G(vc(d, P))));
                        M = a.i;
                        L = a.W;
                        Q = py;
                        S = Q.call(gy, M, B, L);
                        a.l.ib = S;
                        Z = 0;
                        D && D.length && (Z = qe(D[0], "availabilityTimeOffset", ze) || 0);
                        a.l.sb = Z;
                        a.L = qe(b, "minimumUpdatePeriod", ue, -1);
                        pa = qe(b, "availabilityStartTime", te);
                        va = qe(b, "timeShiftBufferDepth", ue);
                        Ca = a.g.dash.ignoreSuggestedPresentationDelay;
                        ua = null;
                        Ca || (ua = qe(b, "suggestedPresentationDelay", ue));
                        xa = a.g.dash.ignoreMaxSegmentDuration;
                        Da = null;
                        xa || (Da = qe(b, "maxSegmentDuration", ue));
                        Ka = b.attributes.type || "static";
                        a.h && a.h.presentationTimeline && (a.V = a.h.presentationTimeline.U() && Ka == "static");
                        a.l.type = Ka;
                        if (a.h) for(wa = a.h.presentationTimeline, Ja = wa.Hb(), Aa = u(a.o.values()), Ga = Aa.next(); !Ga.done; Ga = Aa.next())sb = Ga.value, sb.segmentIndex && sb.segmentIndex.$a(Ja);
                        else Wb = a.g.dash.ignoreMinBufferTime, wb = 0, Wb || (wb = qe(b, "minBufferTime", ue) || 0), wc = 0, wc = ua != null ? Math.min(ua, va || Infinity) : a.g.defaultPresentationDelay > 0 ? a.g.defaultPresentationDelay : Math.min(wb * 1.5, va || Infinity), wa = new Wl(pa, wc, a.g.dash.autoCorrectDrift);
                        wa.md(Ka == "static");
                        (he = wa.U()) && !isNaN(a.g.availabilityWindowOverride) && (va = a.g.availabilityWindowOverride);
                        va == null && (va = Infinity);
                        wa.ig(va);
                        hd = b.attributes.profiles || "";
                        a.l.profiles = hd.split(",");
                        qd = {
                            wb: Ka != "static",
                            presentationTimeline: wa,
                            Ea: null,
                            sa: null,
                            za: null,
                            N: null,
                            bandwidth: 0,
                            Dh: !1,
                            sb: Z,
                            Bc: null,
                            profiles: hd.split(","),
                            roles: null,
                            Mb: qy
                        };
                        return oc.g(t, 2);
                    case 2:
                        a.O = 0;
                        sf = ry(a, qd, S, b, !1);
                        Bg = sf.duration;
                        rd = sf.periods;
                        (Ka != "static" || a.V) && sf.Wi || wa.Ab(Bg || Infinity);
                        a.S && a.ua && wa.Lj(a.$);
                        wa.Oh(Da || 1);
                        a.S && a.ua && (xc = ua != null ? ua : a.g.defaultPresentationDelay, wa.ii(xc));
                        if (!a.h) return oc.g(a.m.Pg(rd, qd.wb), 6);
                        a.h.periodCount = rd.length;
                        a.h.gapCount = a.O;
                        return oc.g(sy(a, rd, !1), 4);
                    case 6:
                        var tf = wa, ni = a.m.l, oi = a.m.xh(), lp = a.m.i, Yk = a.g.dash.sequenceMode;
                        var Db = ne(b, "ServiceDescription");
                        if (Db) {
                            var Ac = ne(Db, "Latency");
                            Db = ne(Db, "PlaybackRate");
                            if (Ac || Db) {
                                var pc = {};
                                Ac && ("target" in Ac.attributes && (pc.targetLatency = parseInt(Ac.attributes.target, 10) / 1E3), "max" in Ac.attributes && (pc.maxLatency = parseInt(Ac.attributes.max, 10) / 1E3), "min" in Ac.attributes && (pc.minLatency = parseInt(Ac.attributes.min, 10) / 1E3));
                                Db && ("max" in Db.attributes && (pc.maxPlaybackRate = parseFloat(Db.attributes.max)), "min" in Db.attributes && (pc.minPlaybackRate = parseFloat(Db.attributes.min)));
                                Ac = pc;
                            } else Ac = null;
                        } else Ac = null;
                        a: {
                            Db = ie(b, "SupplementalProperty");
                            if (Db.length) {
                                for(Db = u(Db), pc = Db.next(); !pc.done; pc = Db.next())if (pc = pc.value, pc.attributes.schemeIdUri == "urn:mpeg:dash:chaining:2016") {
                                    Db = pc.attributes.value;
                                    break a;
                                }
                            }
                            Db = null;
                        }
                        a.h = {
                            presentationTimeline: tf,
                            variants: ni,
                            textStreams: oi,
                            imageStreams: lp,
                            offlineSessionIds: [],
                            sequenceMode: Yk,
                            ignoreManifestTimestampsInSegmentsMode: !1,
                            type: "DASH",
                            serviceDescription: Ac,
                            nextUrl: Db,
                            periodCount: rd.length,
                            gapCount: a.O,
                            isLowLatency: a.S,
                            startTime: null
                        };
                        if (!wa.hk()) {
                            oc.B(7);
                            break;
                        }
                        nc = ie(b, "UTCTiming");
                        return oc.g(ty(a, S, nc), 8);
                    case 8:
                        mi = oc.i;
                        if (!a.j) return oc.return();
                        wa.Mj(mi);
                    case 7:
                        wa.Mf(), a.m && !a.h.presentationTimeline.U() && a.m.release();
                    case 4:
                        a.j.makeTextStreamsForClosedCaptions(a.h), uy(a), vy(a, rd), oc.j();
                }
            });
        }
        function sy(a, b, c) {
            var d;
            return H(function(e) {
                if (e.h == 1) return e.g(a.m.Pg(b, !0, c), 2);
                a.h.variants = a.m.l;
                d = a.m.xh();
                d.length > 0 && (a.h.textStreams = d);
                a.h.imageStreams = a.m.i;
                a.j.filter(a.h);
                e.j();
            });
        }
        function ny(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K;
            return H(function(N) {
                if (N.h == 1) {
                    c = b.attributes.mpdId;
                    d = qe(b, "originalPublishTime", te);
                    if (!c || c !== a.l.Qf || d !== a.l.De) throw a.I = [], new T(1, 4, 4052);
                    e = [];
                    f = [];
                    g = new Set;
                    h = u(ge(b));
                    for(k = h.next(); !k.done; k = h.next())if (l = k.value, m = Ce(l.attributes.sel || ""), n = m[m.length - 1], q = le(l) || "", n.name === "MPD") {
                        if (n.Kc === "mediaPresentationDuration") {
                            r = le(l) || "";
                            var P = ue(r);
                            if (P != null) {
                                a.l.Bc = P;
                                for(var M = u(a.A.values()), L = M.next(); !L.done; L = M.next())L.value.Bc = P;
                            }
                        } else if (n.Kc === "type") {
                            a.h.presentationTimeline.md(q == "static");
                            a.l.type = q;
                            P = u(a.A.values());
                            for(M = P.next(); !M.done; M = P.next())M.value.wb = q == "dynamic";
                            q == "static" && (a.L = -1);
                        } else n.Kc === "publishTime" ? a.l.De = te(q) || 0 : n.Kc === null && l.tagName === "add" && f.push(l);
                    } else if (n.name === "PatchLocation") De(a.I, l);
                    else if (n.name === "Period") l.tagName === "add" ? f.push(l) : l.tagName === "remove" && n.id && wy(a, n.id);
                    else if (n.name === "SegmentTemplate") {
                        M = Ce(l.attributes.sel || "");
                        P = M[M.length - 1];
                        if (P.Kc) {
                            M = xy(a, M);
                            L = le(l) || "";
                            for(var Q = u(M), S = Q.next(); !S.done; S = Q.next())S = a.A.get(S.value), Fe(S.N.Wc, l.tagName, P.Kc, L);
                            P = M;
                        } else P = [];
                        t = P;
                        v = u(t);
                        for(w = v.next(); !w.done; w = v.next())x = w.value, g.add(x);
                    } else if (n.name === "SegmentTimeline" || n.name === "S") {
                        P = Ce(l.attributes.sel || "");
                        P = xy(a, P);
                        M = u(P);
                        for(L = M.next(); !L.done; L = M.next())L = a.A.get(L.value), L = zw(L, bx, "SegmentTimeline"), Q = ie(L, "S"), De(Q, l), L.children = Q;
                        y = P;
                        z = u(y);
                        for(A = z.next(); !A.done; A = z.next())E = A.value, g.add(E);
                    }
                    C = u(g);
                    for(D = C.next(); !D.done; D = C.next())B = D.value, yy(a, B);
                    J = u(f);
                    for(F = J.next(); !F.done; F = J.next())I = F.value, e.push.apply(e, G(ry(a, {
                        wb: a.l.type == "dynamic",
                        presentationTimeline: a.h.presentationTimeline,
                        Ea: null,
                        sa: null,
                        za: null,
                        N: null,
                        bandwidth: 0,
                        Dh: !1,
                        sb: a.l.sb,
                        profiles: a.l.profiles,
                        Bc: a.l.Bc,
                        roles: null,
                        Mb: qy
                    }, a.l.ib, I, !0).periods));
                    if (!e.length) return N.B(2);
                    a.h.periodCount += e.length;
                    a.h.gapCount = a.O;
                    return N.g(sy(a, e, !0), 2);
                }
                a.l.type == "static" && (K = a.l.Bc, a.h.presentationTimeline.Ab(K || Infinity));
                N.j();
            });
        }
        function wy(a, b) {
            a.h.periodCount--;
            for(var c = u(a.A.keys()), d = c.next(); !d.done; d = c.next())if (d = d.value, d.startsWith(b)) {
                var e = a.A.get(d);
                zw(e, bx, "SegmentTimeline").children = [];
                yy(a, d);
                a.A.delete(d);
            }
            a.F = a.F.filter(function(f) {
                return f !== b;
            });
            a.H.delete(b);
        }
        function xy(a, b) {
            var c = "", d = "", e = -1, f = "";
            b = u(b);
            for(var g = b.next(); !g.done; g = b.next())g = g.value, g.name === "Period" ? c = g.id : g.name === "AdaptationSet" ? (d = g.id, g.position !== null && (e = g.position)) : g.name === "Representation" && (f = g.id);
            b = [];
            if (f) b.push(c + "," + f);
            else if (d) for(e = u(a.A.values()), a = e.next(); !a.done; a = e.next())a = a.value, a.Ea.id === c && a.za.id === d && a.N.id && b.push(c + "," + a.N.id);
            else if (e > -1) for(d = u(a.A.values()), a = d.next(); !a.done; a = d.next())a = a.value, a.Ea.id === c && a.za.position === e && a.N.id && b.push(c + "," + a.N.id);
            return b;
        }
        function yy(a, b) {
            var c = a.A.get(b), d = a.o.get(b);
            d.segmentIndex && d.segmentIndex.$a(a.h.presentationTimeline.Hb());
            try {
                var e = ax(c, function(f, g, h, k) {
                    return zy(a, f, g, h, k);
                }, a.o, !0, a.g.dash.initialSegmentLimit, a.ya, c.N.aesKey, null, !0, a.D);
                d.createSegmentIndex = function() {
                    return H(function(f) {
                        if (f.h == 1) return d.segmentIndex ? f.B(0) : f.g(e.cd(), 3);
                        d.segmentIndex = f.i;
                        f.j();
                    });
                };
            } catch (f) {
                if (b = c.N.contentType, b != Ec && b != "application" && b != "image" || f.code != 4002) throw f;
            }
        }
        function ry(a, b, c, d, e) {
            var f = b.Bc;
            f || (f = qe(d, "mediaPresentationDuration", ue), a.l.Bc = f);
            var g = 0;
            a.h && a.h.presentationTimeline && a.V && (g = a.h.presentationTimeline.cc());
            var h = [], k = g;
            d = ie(d, "Period");
            var l = b.wb;
            l || a.H.clear();
            for(var m = l && !e ? new Set(a.F.slice(1, -1)) : null, n = 0; n < d.length; n++){
                var q = d[n], r = d[n + 1], t = qe(q, "start", ue, k), v = q.attributes.id, w = qe(q, "duration", ue);
                t = n == 0 && t == 0 && a.V ? g : t;
                var x = null;
                if (r) {
                    var y = qe(r, "start", ue);
                    y != null && (x = y - t + g);
                } else f != null && (x = f - t + g);
                y = Hc;
                x && w && Math.abs(x - w) > y && x > w && a.O++;
                x == null && (x = w);
                if (!(a.P !== null && v != null && t !== null && t < a.P) || a.F.includes(v) || n + 1 == d.length) {
                    t !== null && (a.P === null || t > a.P) && (a.P = t);
                    k = {
                        start: t,
                        duration: x,
                        node: q,
                        Ff: x == null || !r
                    };
                    q = null;
                    r = n > 0 && n < d.length - 1;
                    l && m && r && !e && (v != null || (v = "__shaka_period_" + t), m.has(v) && (v = a.H.get(v)) && (q = v));
                    q || (q = Ay(a, b, c, k), l && q.id && a.H.set(q.id, q));
                    h.push(q);
                    q.id && x && a.ya.set(q.id, x);
                    if (x == null) {
                        k = null;
                        break;
                    }
                    k = t + x;
                }
            }
            l && !e && By(a, h);
            if (e) for(b = u(h), c = b.next(); !c.done; c = b.next())c = c.value.id, a.F.includes(c) || a.F.push(c);
            else a.F = h.map(function(z) {
                return z.id;
            });
            return f != null ? {
                periods: h,
                duration: f + g,
                Wi: !1
            } : {
                periods: h,
                duration: k,
                Wi: !0
            };
        }
        function By(a, b) {
            b = new Set(b.map(function(e) {
                return e.id;
            }));
            for(var c = u(Array.from(a.H.keys())), d = c.next(); !d.done; d = c.next())d = d.value, b.has(d) || a.H.delete(d);
        }
        function uy(a) {
            var b = Array.from(a.G.keys()).filter(function(h) {
                return !a.F.includes(h);
            });
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value;
                for(var d = !0, e = u(a.G.get(c)), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    var g = a.o.get(f);
                    g && (g.segmentIndex && g.segmentIndex.getNumReferences() != 0 ? d = !1 : (a.m && a.m.Ui(g, c), a.o.delete(f)));
                }
                d && a.G.delete(c);
            }
        }
        function vy(a, b) {
            b = new Set(b.map(function(e) {
                return e.id;
            }));
            for(var c = u(a.D.keys()), d = c.next(); !d.done; d = c.next())d = d.value, b.has(d) || a.D.delete(d);
        }
        function Ay(a, b, c, d) {
            b.Ea = Cy(a, d.node, null, c);
            b.sa = d;
            b.Ea.sb = b.sb;
            b.Ea.id || (b.Ea.id = "__shaka_period_" + d.start);
            var e = ie(d.node, "EventStream");
            c = b.presentationTimeline.Hb();
            e = u(e);
            for(var f = e.next(); !f.done; f = e.next())Dy(a, d.start, d.duration, f.value, c);
            c = ie(d.node, "SupplementalProperty");
            c = u(c);
            for(e = c.next(); !e.done; e = c.next())if (e = e.value, e.attributes.schemeIdUri == "urn:mpeg:dash:urlparam:2014" && (e = Ey(a, e))) b.Mb = e;
            c = ie(d.node, "AdaptationSet").map(function(r, t) {
                return Fy(a, b, t, r);
            }).filter(Zf);
            if (b.wb) {
                e = [];
                f = u(c);
                for(var g = f.next(); !g.done; g = f.next()){
                    g = u(g.value.lm);
                    for(var h = g.next(); !h.done; h = g.next())e.push(h.value);
                }
                if (e.length != new Set(e).size) throw new T(2, 4, 4018);
            }
            e = new Map;
            f = u(c);
            for(g = f.next(); !g.done; g = f.next())for(g = u(g.value.Bk), h = g.next(); !h.done; h = g.next()){
                var k = u(h.value);
                h = k.next().value;
                k = k.next().value;
                e.set(h, k);
            }
            if (e.size) for(f = null, g = u(c), h = g.next(); !h.done; h = g.next()){
                h = h.value;
                k = [];
                for(var l = u(h.streams), m = l.next(), n = {}; !m.done; n = {
                    pi: void 0
                }, m = l.next())if (n.pi = m.value, e.has(n.pi.originalId)) {
                    f || (f = ie(d.node, "AdaptationSet").map(function(r, t) {
                        return Fy(a, b, t, r);
                    }).filter(Zf));
                    m = u(f);
                    for(var q = m.next(); !q.done; q = m.next())if (q = q.value.streams.find(function(r) {
                        return function(t) {
                            return t.originalId == r.pi.originalId;
                        };
                    }(n))) q.dependencyStream = e.get(q.originalId), q.originalId += q.dependencyStream.originalId, k.push(q);
                }
                k.length && h.streams.push.apply(h.streams, G(k));
            }
            d = u(cd(c, function(r) {
                return !!r.fk;
            }));
            c = d.next().value;
            d = d.next().value;
            if (!a.g.disableIFrames) {
                for(c = u(c), e = c.next(); !e.done; e = c.next())for(e = e.value, f = e.fk.split(" "), g = u(d), h = g.next(); !h.done; h = g.next())if (h = h.value, f.includes(h.id)) for(h = u(h.streams), k = h.next(); !k.done; k = h.next())Ng(k.value, e.streams);
            }
            c = Gy(a.g.disableAudio, d, "audio");
            e = Gy(a.g.disableVideo, d, "video");
            f = Gy(a.g.disableText, d, Ec);
            d = Gy(a.g.disableThumbnails, d, "image");
            if (e.length === 0 && c.length === 0) throw new T(2, 4, 4004);
            return {
                id: b.Ea.id,
                audioStreams: c,
                videoStreams: e,
                textStreams: f,
                imageStreams: d
            };
        }
        function Gy(a, b, c) {
            return a || !b.length ? [] : b.reduce(function(d, e) {
                if (e.contentType != c) return d;
                d.push.apply(d, G(e.streams));
                return d;
            }, []);
        }
        function Fy(a, b, c, d) {
            function e(K) {
                var N = K.attributes["dvb:fontFamily"];
                K = K.attributes["dvb:url"];
                N && K && (K = vc(b.za.ib(), [
                    K
                ], b.Mb()), a.j.addFont(N, K[0]));
            }
            function f(K) {
                switch(K){
                    case 1:
                    case 5:
                    case 6:
                    case 7:
                        return "srgb";
                    case 9:
                        return "rec2020";
                    case 11:
                    case 12:
                        return "p3";
                }
            }
            function g(K) {
                switch(K){
                    case 1:
                    case 6:
                    case 13:
                    case 14:
                    case 15:
                        return "SDR";
                    case 16:
                        return "PQ";
                    case 18:
                        return "HLG";
                }
            }
            b.za = Cy(a, d, b.Ea, null);
            b.za.position = c;
            var h = !1;
            c = ie(d, "Role");
            var k = c.map(function(K) {
                return K.attributes.value;
            }).filter(Zf), l = void 0, m = b.za.contentType == Ec;
            m && (l = "subtitle");
            c = u(c);
            for(var n = c.next(); !n.done; n = c.next()){
                n = n.value;
                var q = n.attributes.schemeIdUri;
                if (q == null || q == "urn:mpeg:dash:role:2011") switch(n = n.attributes.value, n){
                    case "main":
                        h = !0;
                        break;
                    case "caption":
                    case "subtitle":
                        l = n;
                }
            }
            var r = ie(d, "EssentialProperty");
            c = null;
            var t = !1;
            n = null;
            q = !1;
            r = u(r);
            for(var v = r.next(); !v.done; v = r.next()){
                v = v.value;
                var w = v.attributes.schemeIdUri;
                if (w == "http://dashif.org/guidelines/trickmode") c = v.attributes.value;
                else if (w == "urn:mpeg:mpegB:cicp:TransferCharacteristics") var x = g(parseInt(v.attributes.value, 10));
                else if (w == "urn:mpeg:mpegB:cicp:ColourPrimaries") var y = f(parseInt(v.attributes.value, 10));
                else w != "urn:mpeg:mpegB:cicp:MatrixCoefficients" && (w == "urn:mpeg:dash:ssr:2023" && a.g.dash.enableFastSwitching ? t = !0 : w == "urn:dvb:dash:fontdownload:2014" ? e(v) : w == "urn:mpeg:dash:urlparam:2014" ? (n = Ey(a, v)) || (q = !0) : q = !0);
            }
            if (q) return null;
            var z = null;
            q = ie(d, "SupplementalProperty");
            q = u(q);
            for(r = q.next(); !r.done; r = q.next())r = r.value, v = r.attributes.schemeIdUri, v == "http://dashif.org/guidelines/last-segment-number" ? z = parseInt(r.attributes.value, 10) - 1 : v == "urn:mpeg:mpegB:cicp:TransferCharacteristics" ? x = g(parseInt(r.attributes.value, 10)) : v == "urn:mpeg:mpegB:cicp:ColourPrimaries" ? y = f(parseInt(r.attributes.value, 10)) : v == "urn:dvb:dash:fontdownload:2014" ? e(r) : v == "urn:mpeg:dash:urlparam:2014" && (n = Ey(a, r));
            n && (b.Mb = n);
            n = ie(d, "Accessibility");
            var A = new Map, E;
            n = u(n);
            for(q = n.next(); !q.done; q = n.next())if (r = q.value, q = r.attributes.schemeIdUri, r = r.attributes.value, q != "urn:scte:dash:cc:cea-608:2015" || a.g.disableText) {
                if (q != "urn:scte:dash:cc:cea-708:2015" || a.g.disableText) q == "urn:mpeg:dash:role:2011" ? r != null && (k.push(r), r == "captions" && (l = "caption")) : q == "urn:tva:metadata:cs:AudioPurposeCS:2007" && (r == "1" ? E = "visually impaired" : r == "2" ? E = "hard of hearing" : r == "9" && (E = "spoken subtitles"));
                else if (q = 1, r != null) for(r = u(r.split(";")), v = r.next(); !v.done; v = r.next()){
                    w = v.value;
                    var C = v = void 0;
                    w.includes("=") ? (w = w.split("="), v = "svc" + w[0], C = w[1].split(",")[0].split(":").pop()) : (v = "svc" + q, q++, C = w);
                    A.set(v, Kc(C));
                }
                else A.set("svc1", "und");
            } else if (q = 1, r != null) for(r = r.split(";"), v = u(r), w = v.next(); !w.done; w = v.next()){
                C = w.value;
                var D = w = void 0;
                C.includes("=") ? (C = C.split("="), w = C[0].startsWith("CC") ? C[0] : "CC" + C[0], D = C[1] || "und") : (w = "CC" + q, r.length == 2 ? q += 2 : q++, D = C);
                A.set(w, Kc(D));
            }
            else A.set("CC1", "und");
            n = ie(d, "ContentProtection");
            var B = ow(a.va, n, a.g.ignoreDrmInfo, a.g.dash.keySystemsByURI);
            b.za.encrypted = n.length > 0;
            var J = Kc(b.za.language || "und"), F = b.za.label, I = new Map;
            d = ie(d, "Representation");
            if (!a.g.ignoreSupplementalCodecs) {
                n = [];
                q = u(d);
                for(r = q.next(); !r.done; r = q.next())if (v = r.value, r = re(v, "urn:scte:dash:scte214-extensions", "supplementalCodecs")) v = Xd(v), v.attributes.codecs = r.split(" ").join(","), v.attributes.id && (v.attributes.supplementalId = v.attributes.id + "_supplementalCodecs"), n.push(v);
                d.push.apply(d, G(n));
            }
            n = d.map(function(K) {
                var N = Hy(a, b, B, l, J, F, h, k, A, K, E, z);
                return N && (N.hdr = N.hdr || x, N.colorGamut = N.colorGamut || y, N.fastSwitching = t, K = K.attributes.dependencyId) ? (N.baseOriginalId = K, I.set(K, N), null) : N;
            }).filter(function(K) {
                return !!K;
            });
            if (n.length == 0 && I.size == 0) {
                c = b.za.contentType == "image";
                if (a.g.dash.ignoreEmptyAdaptationSet || m || c) return null;
                throw new T(2, 4, 4003);
            }
            if (!b.za.contentType || b.za.contentType == "application") for(b.za.contentType = Iy(n[0].mimeType, n[0].codecs), m = u(n), q = m.next(); !q.done; q = m.next())q.value.type = b.za.contentType;
            m = b.za.id || "__fake__" + a.Ia++;
            q = u(n);
            for(r = q.next(); !r.done; r = q.next()){
                r = r.value;
                v = u(B.drmInfos);
                for(w = v.next(); !w.done; w = v.next())w = w.value, w.keyIds = w.keyIds && r.keyIds ? new Set([].concat(G(w.keyIds), G(r.keyIds))) : w.keyIds || r.keyIds;
                a.g.enableAudioGroups && (r.groupId = m);
            }
            d = d.map(function(K) {
                return K.attributes.supplementalId || K.attributes.id;
            }).filter(Zf);
            return {
                id: m,
                contentType: b.za.contentType,
                language: J,
                Un: h,
                streams: n,
                drmInfos: B.drmInfos,
                fk: c,
                lm: d,
                Bk: I
            };
        }
        function Ey(a, b) {
            if ((b = oe(b, "urn:mpeg:dash:schema:urlparam:2014", "UrlQueryInfo")) && qe(b, "useMPDUrlQuery", Ae, !1)) {
                var c = b.attributes.queryTemplate;
                if (c) return function() {
                    return c == "$querypart$" ? a.X : c.split("&").map(function(d) {
                        if (d == "$querypart$") return a.X;
                        var e = /\$query:(.*?)\$/g.exec(d);
                        if (e && e.length == 2) {
                            e = e[1];
                            var f = new rb(a.X).get(e);
                            if (f.length) return e + "=" + f[0];
                        }
                        return d;
                    }).join("&");
                };
            }
            return null;
        }
        function Hy(a, b, c, d, e, f, g, h, k, l, m, n) {
            b.N = Cy(a, l, b.za, null);
            var q = b.N.id;
            a.$ = Math.min(a.$, b.N.sb);
            a.S = a.$ > 0;
            if (!Jy(b.N)) return null;
            var r = b.sa.start;
            b.bandwidth = qe(l, "bandwidth", xe) || 0;
            b.roles = h;
            var t = ie(l, "SupplementalProperty"), v = ie(l, "EssentialProperty"), w = ie(l, "ContentProtection");
            l = null;
            var x = v.find(function(M) {
                return M.attributes.schemeIdUri == "urn:mpeg:dash:urlparam:2014";
            });
            x ? l = Ey(a, x) : (x = t.find(function(M) {
                return M.attributes.schemeIdUri == "urn:mpeg:dash:urlparam:2014";
            })) && (l = Ey(a, x));
            l && (b.Mb = l);
            x = b.N.contentType;
            l = x == Ec || x == "application";
            x = x == "image";
            w.length && (b.za.encrypted = !0);
            try {
                var y = void 0;
                if (c.Hg) {
                    var z = b.N.ib, A = b.Mb, E = vc(z(), [
                        c.Hg.Ll
                    ], A()), C = mh(E, a.g.retryParameters);
                    y = {
                        bitsKey: 128,
                        blockCipherMode: "CBC",
                        iv: c.Hg.iv,
                        firstMediaSequenceNumber: 0,
                        fetchKey: function() {
                            var M, L, Q;
                            return H(function(S) {
                                if (S.h == 1) return S.g(ly(a, C, 6), 2);
                                if (S.h != 3) {
                                    M = S.i;
                                    if (!M.data || M.data.byteLength != 16) throw new T(2, 4, 4049);
                                    L = {
                                        name: "AES-CBC"
                                    };
                                    Q = y;
                                    return S.g(window1.crypto.subtle.importKey("raw", M.data, L, !0, [
                                        "decrypt"
                                    ]), 3);
                                }
                                Q.cryptoKey = S.i;
                                y.fetchKey = void 0;
                                S.j();
                            });
                        }
                    };
                }
                b.N.aesKey = y;
                z = function(M, L, Q, S) {
                    return zy(a, M, L, Q, S);
                };
                if (b.N.Vd) var D = Qw(b, z, y);
                else if (b.N.Hc) D = Ww(b, a.o, y);
                else if (b.N.Wc) D = ax(b, z, a.o, !!a.h, a.g.dash.initialSegmentLimit, a.ya, y, n, !1, a.D);
                else {
                    var B = b.sa.duration || 0, J = b.N.ib, F = b.N.mimeType, I = b.N.codecs;
                    D = {
                        endTime: -1,
                        timeline: -1,
                        cd: function() {
                            var M = xm(r, B, J());
                            M.xb(function(L) {
                                L.mimeType = F;
                                L.codecs = I;
                            });
                            return Promise.resolve(M);
                        },
                        timescale: 1
                    };
                }
            } catch (M) {
                if ((l || x) && M.code == 4002) return null;
                throw M;
            }
            n = sw(a.va, w, c, a.g.ignoreDrmInfo, a.g.dash.keySystemsByURI);
            n = new Set(n ? [
                n
            ] : []);
            w = t.some(function(M) {
                return M.attributes.schemeIdUri == "tag:dolby.com,2018:dash:EC3_ExtensionType:2018" && M.attributes.value == "JOC";
            });
            t = t.some(function(M) {
                return M.attributes.schemeIdUri == "tag:dolby.com,2016:dash:virtualized_content:2016" && M.attributes.value == "1";
            });
            t = w || t;
            w = !1;
            l && (w = h.includes("forced_subtitle") || h.includes("forced-subtitle"));
            var K;
            if (x && ((v = v.find(function(M) {
                return [
                    "http://dashif.org/thumbnail_tile",
                    "http://dashif.org/guidelines/thumbnail_tile"
                ].includes(M.attributes.schemeIdUri);
            })) && (K = v.attributes.value), !K)) return null;
            var N;
            l = b.N.codecs;
            b.profiles.includes("http://dashif.org/guidelines/dash-if-uhd#hevc-hdr-pq10") && (l.includes("hvc1.2.4.L153.B0") || l.includes("hev1.2.4.L153.B0")) && (N = "PQ");
            v = b.N.id ? b.Ea.id + "," + b.N.id : "";
            a.I.length && q && a.A.set(b.Ea.id + "," + q, Ky(b));
            b.N.Wf && Ly(a, b.N.Wf, D, b.presentationTimeline);
            D.endTime != -1 && b.Ea.id != null && b.N.id != null && ((q = a.D.get(b.Ea.id)) ? (q.endTime = D.endTime, q.Yh.includes(b.N.id) || q.Yh.push(b.N.id), a.D.set(b.Ea.id, q)) : a.D.set(b.Ea.id, {
                endTime: D.endTime,
                timeline: D.timeline,
                Yh: [
                    b.N.id
                ]
            }));
            var P = v && a.o.has(v) ? a.o.get(v) : {
                id: a.Ia++,
                originalId: b.N.id,
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                closeSegmentIndex: function() {
                    P.segmentIndex && (P.segmentIndex.release(), P.segmentIndex = null);
                },
                segmentIndex: null,
                mimeType: b.N.mimeType,
                codecs: l,
                frameRate: b.N.frameRate,
                pixelAspectRatio: b.N.pixelAspectRatio,
                bandwidth: b.bandwidth,
                width: b.N.width,
                height: b.N.height,
                kind: d,
                encrypted: c.drmInfos.length > 0,
                drmInfos: c.drmInfos,
                keyIds: n,
                language: e,
                originalLanguage: b.za.language,
                label: f,
                type: b.za.contentType,
                primary: g,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: b.N.emsgSchemeIdUris,
                roles: h,
                forced: w,
                channelsCount: b.N.Tf,
                audioSamplingRate: b.N.audioSamplingRate,
                spatialAudio: t,
                closedCaptions: k,
                hdr: N,
                colorGamut: void 0,
                videoLayout: void 0,
                tilesLayout: K,
                accessibilityPurpose: m,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set([
                    wf(b.N.mimeType, b.N.codecs)
                ]),
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
            P.createSegmentIndex = function() {
                var M;
                return H(function(L) {
                    if (L.h == 1) {
                        if (P.segmentIndex) return L.B(0);
                        M = P;
                        return L.g(D.cd(), 3);
                    }
                    M.segmentIndex = L.i;
                    L.j();
                });
            };
            v && b.wb && !a.o.has(v) && (b = b.Ea.id || "", a.G.has(b) || a.G.set(b, []), a.o.set(v, P), a.G.get(b).push(v));
            return P;
        }
        function Ly(a, b, c, d) {
            if (!a.ba.has(b)) {
                a.ba.add(b);
                var e = qe(b, "presentationTime", ye) || 0, f = ne(b, "UTCTiming"), g;
                if (g = f && f.attributes.schemeIdUri) f = f.attributes.schemeIdUri, g = !(f === "urn:mpeg:dash:utc:http-ntp:2014" || f === "urn:mpeg:dash:utc:ntp:2014" || f === "urn:mpeg:dash:utc:sntp:2014");
                g ? b = (qe(b, "wallClockTime", te) || 0) * 1E3 : (b = qe(b, "wallClockTime", ye) || 0, b = sk(b));
                c = new Date(b - e / c.timescale * 1E3);
                e = c.getTime() / 1E3;
                isNaN(e) || (d.o || d.ki(e), d = (new Map).set("detail", {
                    wallClockTime: b,
                    programStartDate: c
                }), d = new R("prft", d), a.j.onEvent(d));
            }
        }
        function Ky(a) {
            function b(c) {
                if (!c) return null;
                c = Yd(c);
                c.Vd = null;
                c.Hc = null;
                c.Wc = He(c.Wc);
                c.Wf = null;
                return c;
            }
            a = Yd(a);
            a.Ea = b(a.Ea);
            a.za = b(a.za);
            a.N = b(a.N);
            a.sa && (a.sa = Yd(a.sa), a.sa.node = null);
            return a;
        }
        function hy(a) {
            var b, c;
            return H(function(d) {
                switch(d.h){
                    case 1:
                        return b = 0, d.m(2), d.g(iy(a), 4);
                    case 4:
                        b = d.i;
                        d.o(3);
                        break;
                    case 2:
                        if (c = d.l(), a.j) {
                            if (a.g.raiseFatalErrorOnManifestUpdateRequestFailure) return a.j.onError(c), d.return();
                            c.severity = 1;
                            a.j.onError(c);
                        }
                    case 3:
                        if (!a.j) return d.return();
                        a.j.onManifestUpdated();
                        jy(a, b);
                        d.j();
                }
            });
        }
        function jy(a, b) {
            if (!(a.L < 0)) {
                var c = a.L;
                a.g.updatePeriod >= 0 && (c = a.g.updatePeriod);
                a.M.Z(Math.max(c - b, Yc(a.Ga)));
            }
        }
        function Cy(a, b, c, d) {
            c = c || {
                contentType: "",
                mimeType: "",
                codecs: "",
                emsgSchemeIdUris: [],
                frameRate: void 0,
                pixelAspectRatio: void 0,
                Tf: null,
                audioSamplingRate: null,
                sb: 0,
                fg: 1,
                encrypted: !1
            };
            d = d || c.ib;
            var e = b.attributes.id, f = b.attributes.supplementalId, g = ie(b, "BaseURL"), h, k = !1;
            if (a.i) for(var l = u(g), m = l.next(); !m.done; m = l.next()){
                var n = m.value;
                m = n.attributes.serviceLocation;
                n = le(n);
                m && n && (qx(a.i, e, m, n), k = !0);
            }
            k && a.i || (h = g.map(le));
            var q = a.i;
            a = b.attributes.contentType || c.contentType;
            l = b.attributes.mimeType || c.mimeType;
            m = bn([
                b.attributes.codecs || c.codecs
            ]).join(",");
            n = qe(b, "frameRate", Be) || c.frameRate;
            var r = b.attributes.sar || c.pixelAspectRatio, t = My(ie(b, "InbandEventStream"), c.emsgSchemeIdUris), v = ie(b, "AudioChannelConfiguration");
            v = Ny(v) || c.Tf;
            var w = qe(b, "audioSamplingRate", ye) || c.audioSamplingRate;
            a || (a = Iy(l, m));
            var x = ne(b, "SegmentBase"), y = ne(b, "SegmentTemplate"), z = x ? qe(x, "availabilityTimeOffset", ze) || 0 : 0, A = y ? qe(y, "availabilityTimeOffset", ze) || 0 : 0, E = g && g.length ? qe(g[0], "availabilityTimeOffset", ze) || 0 : 0;
            z = c.sb + E + z + A;
            A = null;
            (E = ne(b, "SegmentSequenceProperties")) && (E = qe(E, "cadence", xe)) && (A = E);
            E = b.attributes.label;
            var C = ie(b, "Label");
            C && C.length && (C = C[0], ke(C) && (E = ke(C)));
            return {
                ib: function() {
                    return vc(d(), g.length ? q && k ? rx(q, e) : h ? h : [] : []);
                },
                Vd: x || c.Vd,
                Hc: ne(b, "SegmentList") || c.Hc,
                Wc: y || c.Wc,
                Wf: ne(b, "ProducerReferenceTime") || c.Wf,
                width: qe(b, "width", ye) || c.width,
                height: qe(b, "height", ye) || c.height,
                contentType: a,
                mimeType: l,
                codecs: m,
                frameRate: n,
                pixelAspectRatio: r,
                emsgSchemeIdUris: t,
                id: f || e,
                originalId: e,
                language: b.attributes.lang,
                Tf: v,
                audioSamplingRate: w,
                sb: z,
                Bf: null,
                fg: A || c.fg,
                label: E || null,
                encrypted: !1
            };
        }
        function My(a, b) {
            b = b.slice();
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())c = c.value.attributes.schemeIdUri, b.includes(c) || b.push(c);
            return b;
        }
        function Ny(a) {
            a = u(a);
            for(var b = a.next(); !b.done; b = a.next()){
                b = b.value;
                var c = b.attributes.schemeIdUri;
                if (c && (b = b.attributes.value)) switch(c){
                    case "urn:mpeg:dash:outputChannelPositionList:2012":
                        return b.trim().split(/ +/).length;
                    case "urn:mpeg:dash:23003:3:audio_channel_configuration:2011":
                    case "urn:dts:dash:audio_channel_configuration:2012":
                        b = parseInt(b, 10);
                        if (!b) continue;
                        return b;
                    case "tag:dolby.com,2015:dash:audio_channel_configuration:2015":
                        c = [
                            2,
                            1,
                            2,
                            2,
                            2,
                            2,
                            1,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            2,
                            1,
                            1,
                            2,
                            2
                        ];
                        b = parseInt(b, 16);
                        if (!b) continue;
                        for(var d = 0, e = 0; e < c.length; e++)b & 1 << e && (d += c[e]);
                        if (d) return d;
                        continue;
                    case "tag:dolby.com,2014:dash:audio_channel_configuration:2011":
                    case "urn:dolby:dash:audio_channel_configuration:2011":
                        c = [
                            1,
                            1,
                            1,
                            1,
                            1,
                            2,
                            2,
                            1,
                            1,
                            2,
                            2,
                            2,
                            1,
                            2,
                            1,
                            1
                        ].reverse();
                        b = parseInt(b, 16);
                        if (!b) continue;
                        for(e = d = 0; e < c.length; e++)b & 1 << e && (d += c[e]);
                        if (d) return d;
                        continue;
                    case "urn:mpeg:mpegB:cicp:ChannelConfiguration":
                        if (c = [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            8,
                            2,
                            3,
                            4,
                            7,
                            8,
                            24,
                            8,
                            12,
                            10,
                            12,
                            14,
                            12,
                            14
                        ], (b = parseInt(b, 10)) && b > 0 && b < c.length) return c[b];
                }
            }
            return null;
        }
        function Jy(a) {
            var b = a.Vd ? 1 : 0;
            b += a.Hc ? 1 : 0;
            b += a.Wc ? 1 : 0;
            if (b == 0) return a.contentType == Ec || a.contentType == "application" ? !0 : !1;
            b != 1 && (a.Vd && (a.Hc = null), a.Wc = null);
            return !0;
        }
        function Oy(a, b, c, d) {
            var e, f, g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) return e = [
                    jc(c)
                ], f = vc(b(), e), g = mh(f, a.g.retryParameters), g.method = d, h = a.j.networkingEngine.request(4, g, {
                    isPreload: a.na()
                }), gh(a.R, h), n.g(h.promise, 2);
                k = n.i;
                if (d == "HEAD") {
                    if (!k.headers || !k.headers.date) return n.return(0);
                    l = k.headers.date;
                } else l = bc(k.data);
                m = Date.parse(l);
                return isNaN(m) ? n.return(0) : n.return(m - Date.now());
            });
        }
        function ty(a, b, c) {
            var d, e, f, g, h, k, l, m;
            return H(function(n) {
                switch(n.h){
                    case 1:
                        d = c.map(function(q) {
                            return {
                                scheme: q.attributes.schemeIdUri,
                                value: q.attributes.value
                            };
                        }), e = a.g.dash.clockSyncUri, !d.length && e && d.push({
                            scheme: "urn:mpeg:dash:utc:http-head:2014",
                            value: e
                        }), f = u(d), g = f.next();
                    case 2:
                        if (g.done) {
                            n.B(4);
                            break;
                        }
                        h = g.value;
                        n.m(5);
                        k = h.scheme;
                        l = h.value;
                        switch(k){
                            case "urn:mpeg:dash:utc:http-head:2014":
                            case "urn:mpeg:dash:utc:http-head:2012":
                                return n.B(7);
                            case "urn:mpeg:dash:utc:http-xsdate:2014":
                            case "urn:mpeg:dash:utc:http-iso:2014":
                            case "urn:mpeg:dash:utc:http-xsdate:2012":
                            case "urn:mpeg:dash:utc:http-iso:2012":
                                return n.B(8);
                            case "urn:mpeg:dash:utc:direct:2014":
                            case "urn:mpeg:dash:utc:direct:2012":
                                return m = Date.parse(l), n.return(isNaN(m) ? 0 : m - Date.now());
                            case "urn:mpeg:dash:utc:http-ntp:2014":
                            case "urn:mpeg:dash:utc:ntp:2014":
                            case "urn:mpeg:dash:utc:sntp:2014":
                                Za("NTP UTCTiming scheme is not supported");
                                break;
                            default:
                                Za("Unrecognized scheme in UTCTiming element", k);
                        }
                        n.B(9);
                        break;
                    case 7:
                        return n.g(Oy(a, b, l, "HEAD"), 10);
                    case 10:
                        return n.return(n.i);
                    case 8:
                        return n.g(Oy(a, b, l, "GET"), 11);
                    case 11:
                        return n.return(n.i);
                    case 9:
                        n.o(3);
                        break;
                    case 5:
                        n.l();
                    case 3:
                        g = f.next();
                        n.B(2);
                        break;
                    case 4:
                        return Za("A UTCTiming element should always be given in live manifests! This content may not play on clients with bad clocks!"), n.return(0);
                }
            });
        }
        function Dy(a, b, c, d, e) {
            var f = d.attributes.schemeIdUri || "", g = d.attributes.value || "", h = qe(d, "timescale", ye) || 1, k = qe(d, "presentationTimeOffset", ye) || 0;
            d = u(ie(d, "Event"));
            for(var l = d.next(); !l.done; l = d.next()){
                l = l.value;
                var m = qe(l, "presentationTime", ye) || 0, n = qe(l, "duration", ye) || 0;
                m = Math.max((m - k) / h + b, b);
                n = m + n / h;
                c != null && (m = Math.min(m, b + c), n = Math.min(n, b + c));
                n < e || (l = {
                    schemeIdUri: f,
                    value: g,
                    startTime: m,
                    endTime: n,
                    id: l.attributes.id || "",
                    timescale: h,
                    eventElement: Ge(l),
                    eventNode: He(l)
                }, a.j.onTimelineRegionAdded(l));
            }
        }
        function zy(a, b, c, d, e) {
            var f, g, h, k;
            return H(function(l) {
                if (l.h == 1) return f = sh, g = e ? 0 : 1, h = jn(b, c, d, a.g.retryParameters), l.g(ly(a, h, f, {
                    type: g
                }), 2);
                k = l.i;
                return l.return(k.data);
            });
        }
        function Iy(a, b) {
            b = wf(a, b);
            return Mf(b) ? Ec : a.split("/")[0];
        }
        function ly(a, b, c, d) {
            d || (d = {});
            d.isPreload = a.na();
            b = a.j.networkingEngine.request(c, b, d);
            gh(a.R, b);
            return b.promise;
        }
        function ky(a) {
            var b = a.l.De;
            if (!a.l.Qf || !b || !a.I.length) return [];
            var c = Date.now() / 1E3, d = a.I.filter(function(e) {
                e = ye(e.attributes.ttl);
                return !e || b + e > c;
            }).map(le).filter(Zf);
            return d.length ? vc(a.C, d) : [];
        }
        function qy() {
            return "";
        }
        function py(a, b, c) {
            return function() {
                return a && b ? rx(a, "BaseURL") : c.slice();
            };
        }
        O("shaka.dash.DashParser", gy);
        xd("application/dash+xml", function() {
            return new gy;
        });
        xd("video/vnd.mpeg.dash.mpd", function() {
            return new gy;
        });
        function Py() {}
        O("shaka.dependencies", Py);
        Py.has = function(a) {
            return Qy.has(a);
        };
        Py.add = function(a, b) {
            if (!Ry[a]) throw Error(a + " is not supported");
            a == Sy ? md("mux.js", "mux.js is no longer used in Shaka Player.") : Qy.set(a, function() {
                return b;
            });
        };
        var Sy = "muxjs", Ry = {
            Vn: Sy,
            ISOBoxer: "ISOBoxer"
        };
        Py.Allowed = Ry;
        var Qy = new Map([
            [
                "ISOBoxer",
                function() {
                    return window1.ISOBoxer;
                }
            ]
        ]);
        function Ty() {
            this.j = new Kb(function() {
                for(var a = navigator.userAgent.toLowerCase(), b = u([
                    {
                        type: "VR",
                        Xh: /oculus|quest/
                    },
                    {
                        type: "TV",
                        Xh: /smart[ _]?tv|android ?tv/
                    },
                    {
                        type: "MOBILE",
                        Xh: /iphone|ipad|ipod|android/
                    }
                ]), c = b.next(); !c.done; c = b.next())if (c = c.value, c.Xh.test(a)) return c.type;
                a = navigator.userAgentData;
                var d;
                b = (a == null ? void 0 : (d = a.platform) == null ? void 0 : d.toLowerCase()) || "";
                if (a) {
                    if (a.mobile) return "MOBILE";
                    if (b.includes("android")) return "TV";
                }
                return "DESKTOP";
            });
            this.l = new Kb(function() {
                var a = navigator.userAgent;
                return navigator.vendor.includes("Apple") && (a.includes("Version/") || a.includes("OS/")) ? "WEBKIT" : a.includes("Edge/") ? "EDGE" : a.includes("Chrome/") ? "CHROMIUM" : a.includes("Firefox/") ? "GECKO" : "UNKNOWN";
            });
        }
        function Ad() {
            var a = window1.ManagedMediaSource || window1.MediaSource;
            return a && a.isTypeSupported ? !0 : !1;
        }
        p = Ty.prototype;
        p.mc = function() {
            return !!navigator.mediaCapabilities;
        };
        p.Pa = function() {
            return this.j.value();
        };
        p.Ma = function() {
            return this.l.value();
        };
        p.Sd = function() {
            return !1;
        };
        p.$h = function() {
            return !1;
        };
        p.Cf = function() {
            return !1;
        };
        p.Cj = function() {
            return !1;
        };
        p.Fe = function() {
            return !1;
        };
        p.pd = function() {
            return !0;
        };
        p.Bb = function() {
            var a = window1.ManagedSourceBuffer || window1.SourceBuffer;
            return !!a && !!a.prototype && !!a.prototype.changeType;
        };
        p.Je = function() {
            return !0;
        };
        p.Hj = function() {
            return 0;
        };
        p.vc = function() {
            return Promise.resolve({
                width: Infinity,
                height: Infinity
            });
        };
        p.Tj = function() {
            return !1;
        };
        p.ni = function() {
            return !1;
        };
        p.cb = function(a) {
            var b = this.Pa();
            if (b === "TV" || b === "CONSOLE" || b === "CAST") a.ads.customPlayheadTracker = !0, a.ads.skipPlayDetection = !0, a.ads.supportsMultipleMediaElements = !1;
            return a;
        };
        p.si = function() {
            return !!window1.indexedDB;
        };
        p.Aj = function() {
            return [];
        };
        p.Dd = function(a) {
            return window1.matchMedia !== void 0 && (window1.matchMedia("(color-gamut: p3)").matches || window1.matchMedia("(dynamic-range: high)").matches) ? a ? "HLG" : "PQ" : "SDR";
        };
        p.lg = function() {
            return !1;
        };
        p.rj = function() {
            return !1;
        };
        p.cg = function() {
            return !1;
        };
        p.ng = function() {
            return !0;
        };
        p.sj = function() {
            return !1;
        };
        p.bk = function() {
            return !0;
        };
        p.od = function() {
            return !1;
        };
        p.Nh = function(a) {
            return a === "com.apple.fps";
        };
        p.mg = function() {
            return !0;
        };
        p.toString = function() {
            return "Device: " + this.Pb() + " v" + this.Ja() + "; Type: " + this.Pa();
        };
        function Uy() {
            Ty.call(this);
            this.g = new Kb(function() {
                var a = navigator.userAgent.match(/Version\/(\d+)(?:\.(\d+))?/);
                a || (a = navigator.userAgent.match(/OS (\d+)(?:_(\d+))?/));
                return a ? [
                    parseInt(a[1], 10),
                    parseInt(a[2] || "0", 10)
                ] : [
                    0,
                    0
                ];
            });
            this.h = new Kb(function() {
                return /(?:iPhone|iPad|iPod)/.test(navigator.userAgent) || navigator.maxTouchPoints > 1 ? "xr" in navigator ? "APPLE_VR" : "MOBILE" : "xr" in navigator ? "APPLE_VR" : "DESKTOP";
            });
        }
        oa(Uy, Ty);
        p = Uy.prototype;
        p.Ja = function() {
            return this.g.value()[0];
        };
        p.Pb = function() {
            return "Apple Browser";
        };
        p.Pa = function() {
            return this.h.value();
        };
        p.Ma = function() {
            return "WEBKIT";
        };
        p.mc = function() {
            return !1;
        };
        p.Sd = function(a, b) {
            return !Vy(this) && b === "audio";
        };
        p.Cf = function() {
            return !Vy(this);
        };
        p.Cj = function(a) {
            return !Vy(this) && a === "audio";
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            a.abr.minTimeToSwitch = .5;
            return a;
        };
        p.lg = function() {
            return !0;
        };
        p.mg = function() {
            return !1;
        };
        function Vy(a) {
            a = a.g.value();
            return a[0] >= 27 ? !0 : a[0] === 26 && a[1] >= 4;
        }
        (navigator.vendor || "").includes("Apple") && (/(?:iPhone|iPad|iPod)/.test(navigator.userAgent) || navigator.maxTouchPoints > 1 || navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform.toLowerCase() == "macos" || navigator.platform && navigator.platform.toLowerCase().includes("mac")) && (Zb = function() {
            return new Uy;
        });
        function Wy() {
            if (!Xy()) throw Error("Not a Chromecast device!");
            Ty.call(this);
            this.h = new Kb(function() {
                var a = navigator.userAgent.match(/Chrome\/(\d+)/);
                return a ? parseInt(a[1], 10) : null;
            });
            this.g = new Kb(function() {
                var a = navigator.userAgentData && navigator.userAgentData.platform || navigator.userAgent;
                a = a.toLowerCase();
                return a.includes("android") ? Yy : a.includes("fuchsia") ? Zy : $y;
            });
        }
        oa(Wy, Ty);
        p = Wy.prototype;
        p.Ja = function() {
            return this.h.value();
        };
        p.Pb = function() {
            return "Chromecast with " + this.g.value();
        };
        p.Pa = function() {
            return "CAST";
        };
        p.Ma = function() {
            return "CHROMIUM";
        };
        p.mc = function() {
            return Ty.prototype.mc.call(this) && this.g.value() !== $y;
        };
        p.Bb = function() {
            return Ty.prototype.Bb.call(this) && this.g.value() !== $y;
        };
        p.Hj = function() {
            switch(this.g.value()){
                case Yy:
                    return 0;
                case Zy:
                    return 3;
                default:
                    return 1;
            }
        };
        p.vc = function() {
            var a, b, c, d, e;
            return H(function(f) {
                switch(f.h){
                    case 1:
                        a = window1.cast && cast.__platform__ && cast.__platform__.canDisplayType;
                        b = {
                            width: 1280,
                            height: 720
                        };
                        f.m(2);
                        if (!(c = a)) {
                            f.B(4);
                            break;
                        }
                        return f.g(cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=3840; height=2160'), 5);
                    case 5:
                        c = f.i;
                    case 4:
                        if (c) {
                            b.width = 3840;
                            b.height = 2160;
                            f.B(6);
                            break;
                        }
                        if (!(d = a)) {
                            f.B(7);
                            break;
                        }
                        return f.g(cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=1920; height=1080'), 8);
                    case 8:
                        d = f.i;
                    case 7:
                        d && (b.width = 1920, b.height = 1080);
                    case 6:
                        f.o(3);
                        break;
                    case 2:
                        e = f.l(), Ya("Failed to check canDisplayType:", e);
                    case 3:
                        return f.return(b);
                }
            });
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            a.streaming.stallSkip = 0;
            return a;
        };
        p.si = function() {
            return !1;
        };
        p.od = function() {
            return !0;
        };
        function Xy() {
            return navigator.userAgent.includes("CrKey") && !navigator.userAgent.includes("VIZIO SmartCast");
        }
        var Yy = "Android", Zy = "Fuchsia", $y = "Linux";
        Xy() && (Zb = function() {
            return new Wy;
        });
        function az() {
            Ty.call(this);
            var a = this;
            this.i = new Kb(function() {
                var b = navigator.userAgent.match(/(Chrome|Firefox)\/(\d+)/);
                return b ? parseInt(b[2], 10) : null;
            });
            this.g = new Kb(function() {
                return navigator.userAgent.match(/Edge?\//) ? "Edge" : navigator.userAgent.includes("Chrome") ? "Chrome" : navigator.userAgent.includes("Firefox") ? "Firefox" : "Unknown";
            });
            this.h = new Kb(function() {
                return navigator.userAgentData && navigator.userAgentData.platform ? navigator.userAgentData.platform.toLowerCase() == "windows" : navigator.platform ? navigator.platform.toLowerCase().includes("win32") : !1;
            });
            this.A = new Kb(function() {
                return Ty.prototype.Bb.call(a) ? navigator.userAgent.match(/Edge?\//) ? !a.h.value() : !0 : !1;
            });
            this.o = new Kb(function() {
                return navigator.userAgent.includes("sony.hbbtv.tv");
            });
            this.m = new Kb(function() {
                return navigator.userAgentData && navigator.userAgentData.platform ? navigator.userAgentData.platform.toLowerCase() == "android" : navigator.userAgent.includes("Android") ? !0 : !1;
            });
        }
        oa(az, Ty);
        p = az.prototype;
        p.Ja = function() {
            return this.i.value();
        };
        p.Pb = function() {
            return this.g.value();
        };
        p.Sd = function(a) {
            return Qb(a) ? this.g.value() === "Edge" && this.h.value() : !1;
        };
        p.$h = function() {
            return this.g.value() === "Edge" && this.h.value();
        };
        p.Cf = function() {
            return this.g.value() === "Edge" && this.h.value();
        };
        p.Bb = function() {
            return this.A.value();
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            if (this.h.value()) switch(this.g.value()){
                case "Firefox":
                    a.drm.keySystemsMapping = {
                        "com.microsoft.playready": "com.microsoft.playready.recommendation"
                    };
                    break;
                case "Chrome":
                    a.drm.keySystemsMapping = {
                        "com.microsoft.playready": "com.microsoft.playready.recommendation.3000",
                        "com.microsoft.playready.recommendation": "com.microsoft.playready.recommendation.3000"
                    };
            }
            this.m.value() && (a.drm.defaultAudioRobustnessForWidevine = "SW_SECURE_CRYPTO", a.drm.defaultVideoRobustnessForWidevine = "SW_SECURE_CRYPTO");
            return a;
        };
        p.cg = function() {
            return this.g.value() === "Edge" || this.o.value();
        };
        p.od = function() {
            if (this.Ma() === "GECKO") {
                var a = this.Ja();
                return a !== null ? a >= 100 : Ty.prototype.od.call(this);
            }
            return Ty.prototype.od.call(this);
        };
        p.Nh = function(a) {
            return this.Ma() === "GECKO" ? a.startsWith("com.microsoft.playready.recommendation") : Ty.prototype.Nh.call(this, a);
        };
        $b = function() {
            return new az;
        };
        function bz() {
            Ty.apply(this, arguments);
        }
        oa(bz, Ty);
        p = bz.prototype;
        p.Ja = function() {
            return null;
        };
        p.Pb = function() {
            return "Hisense";
        };
        p.Pa = function() {
            return "TV";
        };
        p.mc = function() {
            return !1;
        };
        p.Bb = function() {
            return !1;
        };
        p.vc = function() {
            var a = {
                width: 1920,
                height: 1080
            }, b = null;
            if (window1.Hisense_Get4KSupportState) try {
                b = window1.Hisense_Get4KSupportState();
            } catch (c) {}
            b == null && (b = navigator.userAgent.includes("UHD"));
            b && (a.width = 3840, a.height = 2160);
            return Promise.resolve(a);
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            a.streaming.stallSkip = 0;
            return a;
        };
        if (navigator.userAgent.includes("Hisense") || navigator.userAgent.includes("VIDAA")) Zb = function() {
            return new bz;
        };
        function cz() {
            Ty.call(this);
            this.g = new Kb(function() {
                var a = navigator.userAgent.match(/PlayStation (\d+)/);
                return a ? parseInt(a[1], 10) : null;
            });
        }
        oa(cz, Ty);
        p = cz.prototype;
        p.Pb = function() {
            return "PlayStation";
        };
        p.Pa = function() {
            return "CONSOLE";
        };
        p.Ma = function() {
            return "WEBKIT";
        };
        p.Ja = function() {
            return this.g.value();
        };
        p.mc = function() {
            return !1;
        };
        p.pd = function() {
            return !1;
        };
        p.Bb = function() {
            return !1;
        };
        p.ni = function() {
            return this.Ja() === 4;
        };
        p.vc = function() {
            var a, b, c, d, e;
            return H(function(f) {
                switch(f.h){
                    case 1:
                        return a = {
                            width: 1920,
                            height: 1080
                        }, b = !1, f.m(2), f.g(window1.msdk.device.getDisplayInfo(), 4);
                    case 4:
                        c = f.i;
                        b = c.resolution === "4K";
                        f.o(3);
                        break;
                    case 2:
                        return f.l(), f.m(5), f.g(window1.msdk.device.getDisplayInfoImmediate(), 7);
                    case 7:
                        d = f.i;
                        b = d.resolution === "4K";
                        f.o(3);
                        break;
                    case 5:
                        e = f.l(), Za("PlayStation: Failed to get the display info:", e);
                    case 3:
                        return b && (a.width = 3840, a.height = 2160), f.return(a);
                }
            });
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            this.Ja() === 4 && a.drm.preferredKeySystems.push("com.microsoft.playready");
            a.streaming.clearDecodingCache = !0;
            return a;
        };
        p.cg = function() {
            return this.Ja() === 4;
        };
        p.ng = function() {
            return this.Ja() !== 4;
        };
        navigator.userAgent.includes("PlayStation") && (Zb = function() {
            return new cz;
        });
        function dz() {
            Ty.call(this);
            var a = navigator.userAgent.match(/Tizen (\d+).(\d+)/);
            this.g = a ? parseInt(a[1], 10) : null;
            this.h = a ? parseInt(a[2], 10) : null;
        }
        oa(dz, Ty);
        p = dz.prototype;
        p.Ja = function() {
            return this.g;
        };
        p.Pb = function() {
            return "Tizen";
        };
        p.Ma = function() {
            return "CHROMIUM";
        };
        p.Pa = function() {
            return "TV";
        };
        p.Sd = function() {
            return !0;
        };
        p.Fe = function() {
            return this.Ja() === 3;
        };
        p.mc = function() {
            return !1;
        };
        p.pd = function() {
            var a = this.Ja();
            return a !== null ? a >= 4 : Ty.prototype.pd.call(this);
        };
        p.Bb = function() {
            return !1;
        };
        p.Je = function() {
            return this.g && this.h ? this.g === 5 ? this.h >= 5 : this.g > 5 : Ty.prototype.Je.call(this);
        };
        p.vc = function() {
            var a = window1.devicePixelRatio;
            a = {
                width: window1.screen.width * a > 1920 ? 3840 : 1920,
                height: window1.screen.height * a > 1080 ? 2160 : 1080
            };
            try {
                if (webapis.systeminfo && webapis.systeminfo.getMaxVideoResolution) {
                    var b = webapis.systeminfo.getMaxVideoResolution();
                    a.width = b.width;
                    a.height = b.height;
                } else webapis.productinfo.is8KPanelSupported && webapis.productinfo.is8KPanelSupported() ? (a.width = 7680, a.height = 4320) : webapis.productinfo.isUdPanelSupported && webapis.productinfo.isUdPanelSupported() && (a.width = 3840, a.height = 2160);
            } catch (c) {
                Za("Tizen: Error detecting screen size, default screen size 1920x1080.");
            }
            return Promise.resolve(a);
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            a.drm.ignoreDuplicateInitData = this.Ja() !== 2;
            this.Ja() === 3 && (a.streaming.crossBoundaryStrategy = "reset_to_encrypted");
            a.streaming.shouldFixTimestampOffset = !0;
            a.streaming.stallSkip = 0;
            a.streaming.gapPadding = 2;
            return a;
        };
        p.Aj = function() {
            var a = [];
            this.g !== null && this.g < 5 && a.push("opus");
            return a;
        };
        p.Dd = function(a) {
            try {
                if (webapis.avinfo.isHdrTvSupport()) return a ? "HLG" : "PQ";
            } catch (b) {
                return Ty.prototype.Dd.call(this, a);
            }
            return "SDR";
        };
        p.rj = function() {
            return !0;
        };
        p.sj = function() {
            return this.Ja() === 3;
        };
        navigator.userAgent.includes("Tizen") && (Zb = function() {
            return new dz;
        });
        function ez() {
            Ty.apply(this, arguments);
        }
        oa(ez, Ty);
        ez.prototype.Ja = function() {
            return null;
        };
        ez.prototype.Pb = function() {
            return "Vizio";
        };
        ez.prototype.Pa = function() {
            return "TV";
        };
        ez.prototype.mc = function() {
            return !1;
        };
        navigator.userAgent.includes("VIZIO SmartCast") && (Zb = function() {
            return new ez;
        });
        function fz() {
            Ty.call(this);
            this.i = new Kb(function() {
                return navigator.userAgent.includes("DT_STB_BCM") || navigator.userAgent.includes("Sky_STB");
            });
            this.h = new Kb(function() {
                return navigator.userAgent.includes("SOPOpenBrowser");
            });
            this.g = new Kb(function() {
                if (navigator.userAgent.includes("DT_STB_BCM")) return 11;
                var a = navigator.userAgent.match(/Version\/(\d+)/);
                return a ? parseInt(a[1], 10) : (a = navigator.userAgent.match(/OS (\d+)(?:_\d+)?/)) ? parseInt(a[1], 10) : null;
            });
        }
        oa(fz, Ty);
        p = fz.prototype;
        p.Ja = function() {
            return this.g.value();
        };
        p.Pb = function() {
            return "WebKit STB";
        };
        p.Pa = function() {
            return "TV";
        };
        p.Ma = function() {
            return "WEBKIT";
        };
        p.mc = function() {
            return !1;
        };
        p.pd = function() {
            var a = this.g.value();
            return a !== null ? a >= 15 : !0;
        };
        p.Sd = function() {
            return this.h.value();
        };
        p.vc = function() {
            return Promise.resolve({
                width: window1.screen.width * window1.devicePixelRatio,
                height: window1.screen.height * window1.devicePixelRatio
            });
        };
        p.ng = function() {
            return !this.i.value();
        };
        p.mg = function() {
            return !1;
        };
        if (navigator.userAgent.includes("PlayStation") ? 0 : navigator.userAgent.includes("SOPOpenBrowser") || navigator.userAgent.includes("DT_STB_BCM") || navigator.userAgent.includes("Sky_STB") || !(!(navigator.vendor || "").includes("Apple") || /(?:iPhone|iPad|iPod)/.test(navigator.userAgent) || navigator.maxTouchPoints > 1 || navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform.toLowerCase() == "macos" || navigator.platform && navigator.platform.toLowerCase().includes("mac"))) Zb = function() {
            return new fz;
        };
        function gz() {
            Ty.call(this);
            var a = this;
            this.h = hz();
            this.g = null;
            try {
                var b = new PalmServiceBridge;
                b.onservicecallback = function(c) {
                    c = JSON.parse(c);
                    var d, e, f, g;
                    a.g = (g = (f = (d = c.configs) == null ? void 0 : d["tv.model.supportHDR"]) != null ? f : (e = c.configs) == null ? void 0 : e["tv.config.supportDolbyHDRContents"]) != null ? g : !1;
                };
                b.call("luna://com.webos.service.config/getConfigs", JSON.stringify({
                    configNames: [
                        "tv.model.supportHDR",
                        "tv.config.supportDolbyHDRContents"
                    ]
                }));
            } catch (c) {
                Za("WebOS: getConfigs call failed", c);
            }
        }
        oa(gz, Ty);
        p = gz.prototype;
        p.Ja = function() {
            return this.h;
        };
        p.Pb = function() {
            return "WebOS";
        };
        p.Pa = function() {
            return "TV";
        };
        p.Ma = function() {
            return "CHROMIUM";
        };
        p.mc = function() {
            return !1;
        };
        p.pd = function() {
            var a = this.Ja();
            return a !== null ? a > 3 : Ty.prototype.pd.call(this);
        };
        p.Bb = function() {
            return !1;
        };
        p.Je = function() {
            var a = this.Ja();
            return a !== null ? a > 3 : Ty.prototype.Je.call(this);
        };
        p.vc = function() {
            var a = {
                width: 1920,
                height: 1080
            };
            try {
                var b = JSON.parse(window1.PalmSystem.deviceInfo);
                a.width = Math.max(1920, b.screenWidth);
                a.height = Math.max(1080, b.screenHeight);
            } catch (c) {
                Za("WebOS: Error detecting screen size, default screen size 1920x1080.");
            }
            return Promise.resolve(a);
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            this.Ja() === 3 && (a.streaming.crossBoundaryStrategy = "reset");
            a.streaming.shouldFixTimestampOffset = !0;
            a.streaming.stallSkip = 0;
            return a;
        };
        p.Dd = function(a) {
            return this.g == null ? (Za("WebOS: getConfigs call haven't finished"), Ty.prototype.Dd.call(this, a)) : this.g ? a ? "HLG" : "PQ" : "SDR";
        };
        function hz() {
            var a = null, b = navigator.userAgent.match(/Chrome\/(\d+)/);
            b && (a = parseInt(b[1], 10));
            switch(a){
                case 38:
                    return 3;
                case 53:
                    return 4;
                case 68:
                    return 5;
                case 79:
                    return 6;
                case 87:
                    return 22;
                case 94:
                    return 23;
                case 108:
                    return 24;
                case 120:
                    return 25;
                case 132:
                    return 26;
                default:
                    return null;
            }
        }
        p.bk = function() {
            return !1;
        };
        p.od = function() {
            var a = this.Ja();
            return a !== null ? a >= 6 : Ty.prototype.od.call(this);
        };
        if (navigator.userAgent.includes("Web0S")) {
            var iz = new gz;
            Zb = function() {
                return iz;
            };
        }
        function jz() {
            Ty.call(this);
            this.g = navigator.userAgent.includes("Edge/");
            var a = navigator.userAgent.match(/Edge?\/(\d+)/);
            this.h = a ? parseInt(a[1], 10) : null;
        }
        oa(jz, Ty);
        p = jz.prototype;
        p.Ja = function() {
            return this.h;
        };
        p.Pb = function() {
            return "Xbox";
        };
        p.Pa = function() {
            return "CONSOLE";
        };
        p.Ma = function() {
            return this.g ? "EDGE" : "CHROMIUM";
        };
        p.Sd = function() {
            return !0;
        };
        p.$h = function() {
            return !0;
        };
        p.Cf = function() {
            return !0;
        };
        p.Tj = function() {
            return this.g;
        };
        p.vc = function() {
            var a = {
                width: 1920,
                height: 1080
            }, b = kz();
            if (b) try {
                var c = new b.Media.Protection.ProtectionCapabilities, d = b.Media.Protection.ProtectionCapabilityResult;
                b = null;
                do b = c.isTypeSupported('video/mp4;codecs="hvc1,mp4a";features="decode-res-x=3840,decode-res-y=2160,decode-bitrate=20000,decode-fps=30,decode-bpc=10,display-res-x=3840,display-res-y=2160,display-bpc=8"', "com.microsoft.playready.recommendation");
                while (b === d.maybe);
                b === d.probably && (a.width = 3840, a.height = 2160);
            } catch (e) {
                Za("Xbox: Error detecting screen size, default screen size 1920x1080.");
            }
            return Promise.resolve(a);
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            a.drm.parseInbandPsshEnabled = this.g;
            a.drm.preferredKeySystems.push("com.microsoft.playready");
            this.g && (a.streaming.gapPadding = .01);
            return a;
        };
        p.cg = function() {
            return !0;
        };
        p.si = function() {
            return !1;
        };
        function kz() {
            var a = null;
            try {
                a = typeof Windows !== "undefined" ? Windows : chrome.webview.hostObjects.sync.Windows;
            } catch (b) {}
            return a;
        }
        if (navigator.userAgent.includes("Xbox One") || kz() !== null) Zb = function() {
            return new jz;
        };
        function lz(a, b, c) {
            this.type = a;
            this.ka = b;
            this.segments = c || null;
        }
        function mz(a, b, c, d) {
            this.id = a;
            this.name = b;
            this.attributes = c;
            this.value = d === void 0 ? null : d;
        }
        mz.prototype.toString = function(a) {
            function b(e) {
                return e.name + "=" + (isNaN(Number(e.value)) ? '"' + e.value + '"' : e.value);
            }
            var c = "#" + this.name, d = this.attributes ? this.attributes.filter(function(e) {
                return a ? !a.has(e.name) : !0;
            }).map(b) : [];
            this.value && d.unshift(this.value);
            d.length > 0 && (c += ":" + d.join(","));
            return c;
        };
        function nz(a, b) {
            if (b) return a.toString();
            b = (new Set).add("AUDIO").add("VIDEO").add("SUBTITLES").add("PATHWAY-ID").add("GROUP-ID").add("URI");
            return a.toString(b);
        }
        function oz(a, b) {
            return a.attributes.find(function(c) {
                return c.name === b;
            }) || null;
        }
        function pz(a, b, c) {
            return (a = oz(a, b)) ? a.value : c || null;
        }
        function qz(a, b) {
            a = oz(a, b);
            if (!a) throw new T(2, 4, 4023, b);
            return a.value;
        }
        function rz(a, b, c) {
            c = c === void 0 ? [] : c;
            this.ka = b;
            this.g = a;
            this.Dc = c;
        }
        function sz(a, b) {
            this.name = a;
            this.value = b;
        }
        function tz(a, b) {
            return a.filter(function(c) {
                return c.name == b;
            });
        }
        function uz(a, b) {
            return a.filter(function(c) {
                return qz(c, "TYPE") == b;
            });
        }
        function vz(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())if (c = c.value, c.name === b) return c;
            return null;
        }
        function wz(a, b, c) {
            c = c === void 0 ? 0 : c;
            return (a = vz(a, b)) ? Number(a.value) : c;
        }
        function xz(a, b, c) {
            return b ? yz(a, [
                b
            ], c) : [];
        }
        function yz(a, b, c) {
            if (!b.length) return [];
            var d = b;
            c && c.size && (d = b.map(function(e) {
                return zz(e, c);
            }));
            return vc(a, d);
        }
        function zz(a, b) {
            if (!b || !b.size) return a;
            a = String(a).replace(/%7B/g, "{").replace(/%7D/g, "}");
            var c = a.match(/{\$\w*}/g);
            if (c) {
                c = u(c);
                for(var d = c.next(); !d.done; d = c.next()){
                    d = d.value;
                    var e = d.slice(2, d.length - 1), f = b.get(e);
                    if (f) a = a.replace(d, f);
                    else throw new T(2, 4, 4039, e);
                }
            }
            return a;
        }
        function Az(a) {
            a = a.value;
            var b = a.indexOf(",");
            return Number(b === -1 ? a : a.substring(0, b));
        }
        function Bz() {
            this.g = 0;
        }
        function Cz(a, b) {
            var c = bc(b).trim().split(/[\r\n]+/);
            if (!c[0].startsWith("#EXTM3U")) throw new T(2, 4, 4015);
            b = 0;
            for(var d = !1, e = [], f = !0, g = 0; g < c.length; g++){
                var h = c[g], k = c[g + 1];
                if (h.startsWith("#") && !h.startsWith("#EXT") || f) f = !1;
                else {
                    h = Dz(a, h);
                    d || (Ez.has(h.name) ? (b = 1, d = !0) : h.name == "EXT-X-STREAM-INF" || h.name == "EXT-X-MEDIA" ? d = !0 : Fz.has(h.name) && (b = 1, d = !0));
                    if (Fz.has(h.name)) {
                        if (b != 1) throw new T(2, 4, 4017);
                        f = a;
                        a = Array(Math.max(100, Math.floor((c.length - g) / 2)));
                        d = 0;
                        h = [];
                        var l = [];
                        for(k = null; g < c.length; g++){
                            var m = c[g];
                            if (m.startsWith("#EXT")) m = Dz(f, m), Ez.has(m.name) ? e.push(m) : m.name == "EXT-X-MAP" ? k = m : m.name == "EXT-X-PART" ? l.push(m) : m.name == "EXT-X-PRELOAD-HINT" ? pz(m, "TYPE") == "PART" ? l.push(m) : pz(m, "TYPE") == "MAP" && (m.name = "EXT-X-MAP", k = m) : h.push(m);
                            else if (!m.startsWith("#") || m.startsWith("#EXT")) m = m.trim(), k && h.push(k), h = new rz(m, h, l), d < a.length ? a[d++] = h : (a.push(h), d++), h = [], l = [];
                        }
                        l.length && (k && h.push(k), c = new rz("", h, l), d < a.length ? a[d++] = c : (a.push(c), d++));
                        return new lz(b, e, d < a.length ? a.slice(0, d) : a);
                    }
                    e.push(h);
                    h.name == "EXT-X-STREAM-INF" && (h.attributes.push(new sz("URI", k)), f = !0);
                }
            }
            return new lz(b, e);
        }
        function Dz(a, b) {
            a = a.g++;
            var c = b.indexOf(":"), d = c === -1 ? b.substring(1) : b.substring(1, c);
            if (!d.startsWith("EXT")) throw new T(2, 4, 4016, b);
            b = c === -1 ? null : b.substring(c + 1);
            if (b === null) a = new mz(a, d, []);
            else if (b.indexOf("=") === -1) a = new mz(a, d, [], b);
            else {
                c = [];
                var e = null, f = 0, g = b.indexOf(","), h = b.indexOf("=");
                g !== -1 && g < h && (e = b.substring(0, g), f = g + 1);
                for(; f < b.length;){
                    for(; b[f] === " ";)f++;
                    h = b.indexOf("=", f);
                    if (h === -1) break;
                    g = b.substring(f, h);
                    f = h + 1;
                    if (b[f] === '"') {
                        f++;
                        var k = b.indexOf('"', f);
                        h = k === -1 ? b.substring(f) : b.substring(f, k);
                        f = k === -1 ? b.length : k + 1;
                    } else k = b.indexOf(",", f), h = k === -1 ? b.substring(f) : b.substring(f, k), f = k === -1 ? b.length : k;
                    f < b.length && b[f] === "," && f++;
                    c.push(new sz(g, h));
                }
                a = new mz(a, d, c, e);
            }
            return a;
        }
        var Ez = new Set("EXT-X-TARGETDURATION EXT-X-MEDIA-SEQUENCE EXT-X-DISCONTINUITY-SEQUENCE EXT-X-PLAYLIST-TYPE EXT-X-I-FRAMES-ONLY EXT-X-ENDLIST EXT-X-SERVER-CONTROL EXT-X-SKIP EXT-X-PART-INF EXT-X-DATERANGE".split(" ")), Fz = new Set("EXTINF EXT-X-BYTERANGE EXT-X-DISCONTINUITY EXT-X-PROGRAM-DATE-TIME EXT-X-KEY EXT-X-DATERANGE EXT-X-MAP EXT-X-GAP EXT-X-TILES".split(" "));
        function Gz() {}
        function Hz(a, b) {
            try {
                var c = Iz(a);
                return bh({
                    uri: a,
                    originalUri: a,
                    data: c.data,
                    headers: {
                        "content-type": c.contentType
                    },
                    originalRequest: b
                });
            } catch (d) {
                return $g(d);
            }
        }
        function Iz(a) {
            if (!a.startsWith("data:")) throw new T(2, 1, 1004, a);
            var b = a.substring(5), c = b.indexOf(",");
            if (c < 0) throw new T(2, 1, 1004, a);
            a = b.substring(0, c);
            b = decodeURIComponent(b.substring(c + 1));
            c = a.split(";");
            a = c[0];
            var d = !1;
            c.length > 1 && c[c.length - 1].toLowerCase() == "base64" && (d = !0, c.pop());
            var e;
            d ? e = qc(b) : e = hc(b);
            return {
                data: e,
                contentType: a,
                Ai: c
            };
        }
        O("shaka.net.DataUriPlugin", Gz);
        Gz.parse = Hz;
        ih("data", Hz);
        function Jz() {
            var a = this;
            this.g = this.i = null;
            this.G = 1;
            this.F = new Map;
            this.L = new Map;
            this.o = new Map;
            this.o.set("video", new Map);
            this.o.set("audio", new Map);
            this.o.set(Ec, new Map);
            this.o.set("image", new Map);
            this.jc = (new Map).set("com.apple.streamingkeydelivery", function(b, c, d) {
                return Kz(a, b, c, d);
            }).set("urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", function(b) {
                var c = qz(b, "METHOD");
                if ([
                    "SAMPLE-AES",
                    "SAMPLE-AES-CTR"
                ].includes(c)) {
                    var d = "cenc";
                    c == "SAMPLE-AES" && (d = "cbcs");
                    var e = qz(b, "URI");
                    c = Iz(e.split("?")[0]);
                    e = e.split("?")[0];
                    if (!a.I.has(e)) {
                        var f = Fb(c.data);
                        a.I.set(e, f);
                    }
                    d = yc("com.widevine.alpha", d, [
                        {
                            initDataType: "cenc",
                            initData: a.I.get(e)
                        }
                    ], void 0, c.Ai);
                    (b = pz(b, "KEYID")) && d.keyIds.add(b.toLowerCase().substr(2));
                    b = Promise.resolve(d);
                } else b = Promise.resolve(null);
                return b;
            }).set("com.microsoft.playready", function(b) {
                var c = qz(b, "METHOD");
                if ([
                    "SAMPLE-AES",
                    "SAMPLE-AES-CTR"
                ].includes(c)) {
                    var d = "cenc";
                    c == "SAMPLE-AES" && (d = "cbcs");
                    b = qz(b, "URI");
                    c = Iz(b.split("?")[0]);
                    b = Fb(c.data);
                    var e = new Uint8Array([
                        154,
                        4,
                        240,
                        121,
                        152,
                        64,
                        66,
                        134,
                        171,
                        146,
                        230,
                        91,
                        224,
                        136,
                        95,
                        149
                    ]);
                    e = Nh(b, e, new Set, 0);
                    d = yc("com.microsoft.playready", d, [
                        {
                            initDataType: "cenc",
                            initData: e
                        }
                    ], void 0, c.Ai);
                    if (b = ae([
                        "<PLAYREADY>",
                        mc(b),
                        "</PLAYREADY>"
                    ].join("\n"))) d.licenseServerUri = mw(b);
                    d = Promise.resolve(d);
                } else d = Promise.resolve(null);
                return d;
            }).set("urn:uuid:3d5e6d35-9b9a-41e8-b843-dd3c6e72c42c", function(b) {
                var c = qz(b, "METHOD");
                if ([
                    "SAMPLE-AES",
                    "SAMPLE-AES-CTR"
                ].includes(c)) {
                    var d = "cenc";
                    c == "SAMPLE-AES" && (d = "cbcs");
                    var e = qz(b, "URI");
                    c = Iz(e.split("?")[0]);
                    e = e.split("?")[0];
                    if (!a.I.has(e)) {
                        var f = Fb(c.data);
                        a.I.set(e, f);
                    }
                    d = yc("com.huawei.wiseplay", d, [
                        {
                            initDataType: "cenc",
                            initData: a.I.get(e)
                        }
                    ], void 0, c.Ai);
                    (b = pz(b, "KEYID")) && d.keyIds.add(b.toLowerCase().substr(2));
                    b = Promise.resolve(d);
                } else b = Promise.resolve(null);
                return b;
            });
            this.kb = new Set;
            this.j = new Map;
            this.m = null;
            this.H = "";
            this.hb = new Bz;
            this.M = -1;
            this.$ = Infinity;
            this.P = this.Gc = this.jb = !1;
            this.D = new Uf(function() {
                if (a.W && !a.g.continueLoadingWhenPaused && (a.V.Fa(a.W, "timeupdate"), a.W.paused)) {
                    a.V.ra(a.W, "timeupdate", function() {
                        return Lz(a);
                    });
                    return;
                }
                Lz(a);
            });
            this.Ga = Mz;
            this.h = null;
            this.ab = 0;
            this.C = Infinity;
            this.Oa = this.Ia = this.S = 0;
            this.X = new fh;
            this.J = new Map;
            this.K = new Map;
            this.ya = new Map;
            this.na = new Map;
            this.O = new Map;
            this.ua = new Map;
            this.va = new Map;
            this.Fc = this.ba = !1;
            this.Kb = new Xc(5);
            this.l = null;
            this.R = !0;
            this.V = new fd;
            this.A = this.W = null;
            this.hc = function() {
                return !1;
            };
            this.I = new Map;
        }
        p = Jz.prototype;
        p.configure = function(a, b) {
            var c = this.i && a.updatePeriod != this.g.updatePeriod && a.updatePeriod >= 0;
            this.g = a;
            b && (this.hc = b);
            this.l && this.l.configure(this.g);
            c && this.h && this.h.presentationTimeline.U() && this.D.La();
        };
        p.start = function(a, b) {
            var c = this, d;
            return H(function(e) {
                return e.h == 1 ? (c.i = b, c.ba = b.isLowLatencyMode(), e.g(Nz(c, [
                    a
                ]).promise, 2)) : e.h != 3 ? (d = e.i, c.H = d.uri, e.g(Oz(c, d.data), 3)) : e.return(c.h);
            });
        };
        p.stop = function() {
            this.D && (this.D.stop(), this.D = null);
            var a = [];
            this.X && (a.push(this.X.destroy()), this.X = null);
            this.g = this.i = null;
            this.kb.clear();
            this.h = null;
            this.j.clear();
            this.L.clear();
            this.K.clear();
            this.F.clear();
            this.ya.clear();
            this.na.clear();
            this.O.clear();
            this.ua.clear();
            this.va.clear();
            this.I.clear();
            this.l && this.l.destroy();
            this.V && (this.V.release(), this.V = null);
            return Promise.all(a);
        };
        p.update = function() {
            var a = this, b, c, d, e, f, g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) {
                    if (!Pz(a)) return n.return();
                    b = [];
                    c = Array.from(a.j.values());
                    d = c.filter(function(q) {
                        return !q.stream.isAudioMuxedInVideo && q.stream.segmentIndex;
                    });
                    if (d.length === 0) return n.return();
                    a.C = Infinity;
                    a.h.gapCount = 0;
                    e = u(d);
                    for(f = e.next(); !f.done; f = e.next())g = f.value, b.push(Qz(a, g));
                    return n.g(Promise.all(b), 2);
                }
                Rz(a, d.map(function(q) {
                    return q.stream;
                }));
                h = d.some(function(q) {
                    return q.qe == 0;
                });
                d.length && !h && (Sz(a, Mz), Tz(a));
                h && Tz(a);
                k = u(d);
                for(l = k.next(); !l.done; l = k.next())m = l.value, m.stream.isAudioMuxedInVideo || !m.stream.segmentIndex || m.stream.segmentIndex.Fb() || a.i.disableStream(m.stream);
                n.j();
            });
        };
        function Uz(a, b) {
            return Pz(a) ? a.o.get(b.type) : b.Nf;
        }
        function Qz(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca;
            return H(function(ua) {
                switch(ua.h){
                    case 1:
                        if (b.stream.isAudioMuxedInVideo) return ua.return();
                        c = [];
                        d = u(b.T());
                        for(e = d.next(); !e.done; e = d.next())f = e.value, g = new lb(f), h = g.g, b.jf && (b.Ub >= 0 && h.add("_HLS_msn", String(b.Ub)), b.Vb >= 0 && h.add("_HLS_part", String(b.Vb))), b.kf && h.add("_HLS_skip", "YES"), c.push(g.toString());
                        ua.m(2);
                        return ua.g(Nz(a, c, !0).promise, 4);
                    case 4:
                        k = ua.i;
                        ua.o(3);
                        break;
                    case 2:
                        throw l = ua.l(), a.i && a.i.disableStream(b.stream), l;
                    case 3:
                        if (!b.stream.segmentIndex) return ua.return();
                        m = Cz(a.hb, k.data);
                        if (m.type != 1) throw new T(2, 4, 4017);
                        n = k.uri;
                        n == k.originalUri || b.T().includes(n) || b.Zf.push(n);
                        q = tz(m.ka, "EXT-X-DEFINE");
                        r = Vz(a, q, n);
                        t = b.stream;
                        v = Uz(a, b);
                        return ua.g(Wz(a, m, t.mimeType, b.T, r), 5);
                    case 5:
                        w = ua.i;
                        x = w.keyIds;
                        y = w.drmInfos;
                        z = w.encrypted;
                        A = w.Ii;
                        t.encrypted || !z || A || (t.encrypted = !0);
                        E = function(xa, Da) {
                            return xa.size === Da.size && [].concat(G(xa)).every(function(Ka) {
                                return Da.has(Ka);
                            });
                        };
                        E(t.keyIds, x) || (t.keyIds = x, t.drmInfos = y, a.i.newDrmInfo(t));
                        C = Xz(a, m, v, r, b.T, b.type);
                        D = C.segments;
                        if (B = C.bandwidth) t.bandwidth = B;
                        J = Km(t);
                        F = u(D);
                        for(I = F.next(); !I.done; I = F.next())K = I.value, K.ia && (K.ia.Kd = J);
                        t.segmentIndex.ye(D, a.m.Hb());
                        D.length && (N = wz(m.ka, "EXT-X-MEDIA-SEQUENCE", 0), M = (P = vz(m.ka, "EXT-X-SKIP")) ? Number(pz(P, "SKIPPED-SEGMENTS")) : 0, L = Yz(N, D), Q = L.Ub, S = L.Vb, b.Ub = Q + M, b.Vb = S, Z = v.get(N), t.segmentIndex.$a(Z));
                        if (pa = t.segmentIndex.Fb()) b.gd = pa.startTime, va = D[D.length - 1], b.Uc = va.endTime;
                        if (Ca = vz(m.ka, "EXT-X-ENDLIST")) b.qe = !0;
                        Zz(a, m);
                        $z(a, m.ka, t.type, r, b.T);
                        ua.j();
                }
            });
        }
        p.onExpirationUpdated = function() {};
        p.onInitialVariantChosen = function() {};
        p.banLocation = function(a) {
            this.l && this.l.banLocation(a);
        };
        p.setMediaElement = function(a) {
            this.W = a;
        };
        function aA(a, b, c) {
            c = c === void 0 ? !1 : c;
            for(var d = a.M == -1, e = u(b), f = e.next(); !f.done; f = e.next()){
                f = f.value;
                var g = f.stream.segmentIndex, h = Uz(a, f);
                if (g = g.Fb()) {
                    h = u(h);
                    for(var k = h.next(); !k.done; k = h.next()){
                        k = u(k.value);
                        var l = k.next().value;
                        if (k.next().value == g.startTime) {
                            d && (a.M = Math.max(a.M, l));
                            f.Wg = l;
                            break;
                        }
                    }
                }
            }
            if (!(a.M < 0)) {
                for(b = u(b), d = b.next(); !d.done; d = b.next())if (d = d.value, bA(a, d.type) || c) {
                    if (e = d.stream.segmentIndex) {
                        if (f = a.M - d.Wg, f > 0 && (e.g.splice(0, f), e = e.Fb())) e = -e.startTime, d.stream.segmentIndex.offset(e), cA(a, d, e);
                    }
                }
            }
        }
        function dA(a, b) {
            if (a.$ == Infinity) {
                b = u(b);
                for(var c = b.next(); !c.done; c = b.next())c = c.value.stream.segmentIndex.Fb(), c != null && c.h != null && (a.$ = Math.min(a.$, c.h));
            }
            b = a.$;
            if (b != Infinity) {
                c = u(a.j.values());
                for(var d = c.next(); !d.done; d = c.next())if (d = d.value, !bA(a, d.type)) {
                    var e = d.stream.segmentIndex;
                    if (e != null) {
                        var f = e.Fb();
                        if (f) {
                            if (f.h == null) Ya("Missing EXT-X-PROGRAM-DATE-TIME for stream", d.T(), "Expect AV sync issues!");
                            else for(cA(a, d, f.h - b - f.startTime), d = u(e), e = d.next(); !e.done; e = d.next())e.value.ti(b);
                        }
                    }
                }
            }
        }
        function cA(a, b, c) {
            if (!(Math.abs(c) < .001)) {
                b.gd += c;
                b.Uc += c;
                a = Uz(a, b);
                for(var d = u(a), e = d.next(); !e.done; e = d.next()){
                    var f = u(e.value);
                    e = f.next().value;
                    f = f.next().value;
                    a.set(e, f + c);
                }
                b.T();
            }
        }
        function Oz(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa, Da, Ka, wa, Ja;
            return H(function(Aa) {
                switch(Aa.h){
                    case 1:
                        c = Gc;
                        d = Cz(a.hb, b);
                        e = tz(d.ka, "EXT-X-DEFINE");
                        f = [];
                        g = [];
                        h = [];
                        a.m = new Wl(null, 0);
                        a.m.md(!0);
                        k = function() {
                            return [
                                a.H
                            ];
                        };
                        l = null;
                        m = new Map;
                        a.h = {
                            presentationTimeline: a.m,
                            variants: f,
                            textStreams: g,
                            imageStreams: h,
                            offlineSessionIds: [],
                            sequenceMode: a.g.hls.sequenceMode,
                            ignoreManifestTimestampsInSegmentsMode: a.g.hls.ignoreManifestTimestampsInSegmentsMode,
                            type: "HLS",
                            serviceDescription: null,
                            nextUrl: null,
                            periodCount: 1,
                            gapCount: 0,
                            isLowLatency: !1,
                            startTime: a.A
                        };
                        if (d.type == 1) return a.R = !1, Q = tz(d.ka, "EXT-X-DEFINE"), m = Vz(a, Q, a.H), l = c.Ba, S = "", Z = new Map, Aa.g(eA(a, a.G++, m, d, k, "", l, S, !0, "Media Playlist", null, Z, null, !1, null, !1), 7);
                        fA(a, e);
                        n = tz(d.ka, "EXT-X-MEDIA");
                        q = tz(d.ka, "EXT-X-STREAM-INF");
                        r = tz(d.ka, "EXT-X-IMAGE-STREAM-INF");
                        t = tz(d.ka, "EXT-X-I-FRAME-STREAM-INF");
                        v = tz(d.ka, "EXT-X-SESSION-KEY");
                        w = tz(d.ka, "EXT-X-SESSION-DATA");
                        x = tz(d.ka, "EXT-X-CONTENT-STEERING");
                        gA(a, w);
                        return Aa.g(hA(a, x), 4);
                    case 4:
                        if (!a.g.ignoreSupplementalCodecs) {
                            y = [];
                            z = u(q);
                            A = z.next();
                            for(E = {}; !A.done; E = {
                                Zj: void 0
                            }, A = z.next())if (C = A.value, D = pz(C, "SUPPLEMENTAL-CODECS")) E.Zj = D.split(/\s*,\s*/).map(function(Ga) {
                                return Ga.split("/")[0];
                            }), B = C.attributes.map(function(Ga) {
                                return function(sb) {
                                    var Wb = sb.name, wb = sb.value;
                                    Wb == "CODECS" && (wb = Ga.Zj.join(","), sb = sb.value.split(","), sb.length > 1 && (sb = Cc("audio", sb)) && (wb += "," + sb));
                                    return new sz(Wb, wb);
                                };
                            }(E)), y.push(new mz(C.id, C.name, B, null));
                            q.push.apply(q, G(y));
                            J = [];
                            F = u(t);
                            I = F.next();
                            for(K = {}; !I.done; K = {
                                $j: void 0
                            }, I = F.next())if (N = I.value, P = pz(N, "SUPPLEMENTAL-CODECS")) K.$j = P.split(/\s*,\s*/).map(function(Ga) {
                                return Ga.split("/")[0];
                            }), M = N.attributes.map(function(Ga) {
                                return function(sb) {
                                    var Wb = sb.name;
                                    sb = sb.value;
                                    Wb == "CODECS" && (sb = Ga.$j.join(","));
                                    return new sz(Wb, sb);
                                };
                            }(K)), J.push(new mz(N.id, N.name, M, null));
                            t.push.apply(t, G(J));
                        }
                        iA(a, q);
                        jA(a, n);
                        L = kA(a, t);
                        return Aa.g(lA(a, q, v, n, k, a.F, L), 5);
                    case 5:
                        return f = Aa.i, g = mA(a, n), Aa.g(nA(a, r, t), 6);
                    case 6:
                        h = Aa.i;
                        Aa.B(3);
                        break;
                    case 7:
                        pa = Aa.i, a.j.set(a.H, pa), pa.stream && (va = Km(pa.stream), pa.stream.segmentIndex.xb(function(Ga) {
                            Ga.ia && (Ga.ia.Kd = va);
                        })), l = pa.stream.type, Ca = !0, a.g.disableAudio && pa.type == "audio" ? Ca = !1 : a.g.disableVideo && pa.type == "video" && !pa.stream.codecs.includes(",") && (Ca = !1), Ca && f.push({
                            id: 0,
                            language: Kc(S || "und"),
                            disabledUntilTime: 0,
                            primary: !0,
                            audio: pa.type == "audio" ? pa.stream : null,
                            video: pa.type == "video" ? pa.stream : null,
                            bandwidth: pa.stream.bandwidth || 0,
                            allowedByApplication: !0,
                            allowedByKeySystem: !0,
                            decodingInfos: []
                        });
                    case 3:
                        if (!a.i) throw new T(2, 7, 7001);
                        oA(a, d);
                        d.type == 1 && (Pz(a) && (pA(a, d), ua = a.C, a.D.Z(ua)), xa = Array.from(a.j.values()), qA(a, xa), Tz(a), $z(a, d.ka, l, m, k));
                        a.h.variants = f;
                        a.h.textStreams = g;
                        a.h.imageStreams = h;
                        a.h.startTime = a.A;
                        if (a.P || !a.g.hls.disableCodecGuessing) {
                            Aa.B(8);
                            break;
                        }
                        Da = [];
                        Ka = u(a.h.variants);
                        for(wa = Ka.next(); !wa.done; wa = Ka.next())Ja = wa.value, Ja.audio && Ja.audio.codecs === "" && Da.push(Ja.audio.createSegmentIndex()), Ja.video && Ja.video.codecs === "" && Da.push(Ja.video.createSegmentIndex());
                        return Aa.g(Promise.all(Da), 8);
                    case 8:
                        a.i.makeTextStreamsForClosedCaptions(a.h), Aa.j();
                }
            });
        }
        function rA(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x;
            return H(function(y) {
                if (y.h == 1) {
                    c = $m(a.g.hls.mediaPlaylistFullMimeType);
                    if (!b.length) return y.return(c);
                    d = sA(a, b);
                    e = d.segment;
                    f = d.segmentIndex;
                    g = e.T();
                    if (h = gn(g[0])) {
                        if (k = tA.get(h)) return y.return($m(k));
                    }
                    return y.g(Promise.all([
                        uA(a, e.ia, 0),
                        uA(a, e, f)
                    ]), 2);
                }
                l = y.i;
                m = l[1].mimeType;
                n = l[0].data;
                q = l[1].data;
                r = "mp4 mp4a m4s m4i m4a m4f cmfa mp4v m4v cmfv fmp4".split(" ");
                t = [
                    "audio/mp4",
                    "video/mp4",
                    "video/iso.segment"
                ];
                v = e.ia || t.includes(m);
                if (!v && Rk(Fb(q))) {
                    var z = q, A = a.g.disableAudio, E = a.g.disableVideo, C = a.g.disableText;
                    var D = Fb(z);
                    var B = (new Ek).parse(D), J = B.me();
                    D = B.yh();
                    var F = [], I = !1, K = !1;
                    if (!A) switch(J.audio){
                        case "aac":
                        case "aac-loas":
                            B.yb().length && (F.push("mp4a.40.2"), I = !0);
                            break;
                        case "mp3":
                            B.yb().length && (F.push("mp4a.40.34"), I = !0);
                            break;
                        case "ac3":
                            B.yb().length && (F.push("ac-3"), I = !0);
                            break;
                        case "ec3":
                            B.yb().length && (F.push("ec-3"), I = !0);
                            break;
                        case "opus":
                            B.yb().length && (F.push("opus"), I = !0);
                    }
                    if (!E) switch(J.video){
                        case "avc":
                            D.codec ? F.push(D.codec) : F.push("avc1.42E01E");
                            K = !0;
                            break;
                        case "hvc":
                            D.codec ? F.push(D.codec) : F.push("hvc1.1.6.L93.90");
                            K = !0;
                            break;
                        case "av1":
                            F.push("av01.0.01M.08"), K = !0;
                    }
                    if (F.length) {
                        A = I && !K;
                        E = new Map;
                        if (K && !C) {
                            C = new Fd("video/mp2t");
                            Jd(C, z);
                            z = u(C.g.getStreams());
                            for(K = z.next(); !K.done; K = z.next())K = K.value, E.set(K, K);
                            C.g.clear();
                        }
                        D = {
                            type: A ? "audio" : "video",
                            mimeType: "video/mp2t",
                            codecs: F.join(", "),
                            language: null,
                            height: D.height,
                            width: D.width,
                            channelCount: null,
                            sampleRate: null,
                            closedCaptions: E,
                            Me: null,
                            colorGamut: null,
                            frameRate: D.frameRate,
                            timescale: null
                        };
                    } else D = null;
                    if (w = D) return y.return(w);
                } else if (v || r.includes(h)) {
                    if (x = an(n, q, a.g.disableText)) return y.return(x);
                }
                return m ? y.return($m(m)) : y.return(c);
            });
        }
        function uA(a, b, c) {
            var d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        if (!b) return l.return({
                            mimeType: null,
                            data: null
                        });
                        d = sh;
                        e = jn(b.T(), b.Qc(), b.Oc(), a.g.retryParameters);
                        f = b instanceof Oj ? 1 : 0;
                        return l.g(vA(a, e, d, {
                            type: f
                        }).promise, 2);
                    case 2:
                        g = l.i;
                        h = g.data;
                        if (!b.aesKey) {
                            l.B(3);
                            break;
                        }
                        return l.g(en(h, b.aesKey, c), 4);
                    case 4:
                        h = l.i;
                    case 3:
                        return b instanceof Oj ? b.He(h, !0) : b.He(h), (k = g.headers["content-type"]) && (k = k.split(";")[0].toLowerCase()), l.return({
                            mimeType: k,
                            data: h
                        });
                }
            });
        }
        function Tz(a) {
            if (Pz(a)) {
                if (a.Ga == wA) {
                    for(var b = Infinity, c = Infinity, d = u(a.j.values()), e = d.next(); !e.done; e = d.next())e = e.value, e.stream.segmentIndex && e.stream.type != "text" && !e.stream.isAudioMuxedInVideo && (b = Math.min(b, e.Uc), c = Math.min(c, e.gd));
                    b = b - c || 0;
                    isNaN(a.g.availabilityWindowOverride) || (b = a.g.availabilityWindowOverride);
                    a.m.ig(b);
                }
            } else a.m.Ab(xA(a));
            if (!a.m.o) for(b = u(a.j.values()), c = b.next(); !c.done; c = b.next())c = c.value, !c.stream.segmentIndex || c.type != "audio" && c.type != "video" || (c = c.stream.segmentIndex.Fb()) && c.h != null && a.m.ki(c.h);
            a.m.Mf();
        }
        function fA(a, b) {
            var c = new lb(a.H).g;
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next()){
                var e = d.value;
                d = pz(e, "NAME");
                var f = pz(e, "VALUE");
                e = pz(e, "QUERYPARAM");
                d && f && (a.F.has(d) || a.F.set(d, f));
                e && (d = c.get(e)[0]) && !a.F.has(d) && a.F.set(e, d);
            }
        }
        function Vz(a, b, c) {
            c = new lb(c).g;
            var d = new Map;
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                var f = e.value, g = pz(f, "NAME"), h = pz(f, "VALUE");
                e = pz(f, "QUERYPARAM");
                f = pz(f, "IMPORT");
                g && h && (d.has(g) || d.set(g, h));
                e && (g = c.get(e)[0]) && !d.has(g) && d.set(e, g);
                f && (e = a.F.get(f)) && d.set(f, e);
            }
            return d;
        }
        function iA(a, b) {
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                var d = c.value, e = pz(d, "AUDIO");
                c = pz(d, "VIDEO");
                var f = pz(d, "SUBTITLES");
                d = yA(a, d);
                if (f) {
                    var g = Cc(Ec, d);
                    a.K.set(f, g);
                    ad(d, g);
                }
                e && (f = Cc("audio", d), f || (f = a.g.hls.defaultAudioCodec), a.K.set(e, f));
                c && (e = Cc("video", d), e || (e = a.g.hls.defaultVideoCodec), a.K.set(c, e));
            }
        }
        function gA(a, b) {
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                var d = c.value, e = pz(d, "DATA-ID");
                c = pz(d, "URI");
                var f = pz(d, "LANGUAGE");
                d = pz(d, "VALUE");
                e = (new Map).set("id", e);
                c && e.set("uri", xz([
                    a.H
                ], c, a.F)[0]);
                f && e.set("language", f);
                d && e.set("value", d);
                c = new R("sessiondata", e);
                if (a.i) a.i.onEvent(c);
            }
        }
        function hA(a, b) {
            var c, d, e, f, g, h;
            return H(function(k) {
                if (!a.i || !a.g) return k.return();
                d = u(b);
                for(e = d.next(); !e.done; e = d.next())if (f = e.value, g = pz(f, "PATHWAY-ID"), h = pz(f, "SERVER-URI"), g && h) {
                    a.l = new mx(a.i);
                    a.l.configure(a.g);
                    a.l.i = [
                        a.H
                    ];
                    a.l.setManifestType("HLS");
                    a.l.h = g;
                    c = nx(a.l, h);
                    break;
                }
                return k.g(c, 0);
            });
        }
        function mA(a, b) {
            var c = uz(b, "SUBTITLES"), d = {};
            b = u(c);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = nz(e, !a.l);
                d[f] ? d[f].push(e) : d[f] = [
                    e
                ];
            }
            b = [];
            if (!a.g.disableText) for(var g in d)try {
                b.push(zA(a, d[g], new Map).stream);
            } catch (h) {
                if (!a.g.hls.ignoreTextStreamFailures) throw h;
            }
            g = u(c);
            for(c = g.next(); !c.done; c = g.next())if (d = qz(c.value, "GROUP-ID"), c = a.K.get(d)) {
                if (d = a.L.get(d)) for(d = u(d), e = d.next(); !e.done; e = d.next())e = e.value, e.stream.codecs = c, e.stream.mimeType = AA(Ec, c) || BA(Ec), CA(e.stream);
            }
            return b.filter(function(h) {
                return h;
            });
        }
        function CA(a) {
            var b = new Set([
                wf(a.mimeType, a.codecs)
            ]);
            a.segmentIndex && a.segmentIndex.xb(function(c) {
                c.mimeType && b.add(wf(c.mimeType, a.codecs));
            });
            a.fullMimeTypes = b;
        }
        function nA(a, b, c) {
            var d, e;
            return H(function(f) {
                if (f.h == 1) return d = b.map(function(g) {
                    var h, k, l;
                    return H(function(m) {
                        if (m.h == 1) {
                            if (h = a.g.disableThumbnails) return m.return(null);
                            m.m(2);
                            return m.g(DA(a, g), 4);
                        }
                        if (m.h != 2) return k = m.i, m.return(k.stream);
                        l = m.l();
                        if (a.g.hls.ignoreImageStreamFailures) return m.return(null);
                        throw l;
                    });
                }).concat(c.map(function(g) {
                    if (a.g.disableThumbnails) return null;
                    try {
                        var h = EA(a, g);
                        return h.stream.type !== "image" ? null : h.stream;
                    } catch (k) {
                        if (a.g.hls.ignoreImageStreamFailures) return null;
                        throw k;
                    }
                })), f.g(Promise.all(d), 2);
                e = f.i;
                return f.return(e.filter(function(g) {
                    return g;
                }));
            });
        }
        function FA(a, b, c) {
            b = b.filter(function(h) {
                var k = pz(h, "URI") || "";
                h = pz(h, "TYPE");
                return h != "SUBTITLES" && (k != "" || h == "AUDIO");
            });
            var d = {};
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = nz(e, !a.l);
                d[f] ? d[f].push(e) : d[f] = [
                    e
                ];
            }
            for(var g in d)zA(a, d[g], c, !1);
        }
        function kA(a, b) {
            return b.map(function(c) {
                c = EA(a, c);
                return c.stream.type !== "video" ? null : c.stream;
            }).filter(function(c) {
                return c;
            });
        }
        function lA(a, b, c, d, e, f, g) {
            var h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa, Da, Ka;
            return H(function(wa) {
                switch(wa.h){
                    case 1:
                        h = [];
                        k = new Set;
                        if (a.g.ignoreDrmInfo || !(c.length > 0)) {
                            wa.B(2);
                            break;
                        }
                        l = u(c);
                        m = l.next();
                    case 3:
                        if (m.done) {
                            wa.B(2);
                            break;
                        }
                        n = m.value;
                        q = qz(n, "METHOD");
                        r = pz(n, "KEYFORMAT") || "identity";
                        t = null;
                        if (q == "NONE") {
                            wa.B(4);
                            break;
                        }
                        if (GA(q)) {
                            v = xz(e(), qz(n, "URI"), f);
                            w = v.sort().join("");
                            a.O.has(w) || (x = mh(v, a.g.retryParameters), y = vA(a, x, 6).promise, a.O.set(w, y));
                            wa.B(4);
                            break;
                        }
                        if (r == "identity") return wa.g(HA(a, n, "", e, null, f), 12);
                        z = a.jc.get(r);
                        if (!z) {
                            A = null;
                            wa.B(10);
                            break;
                        }
                        return wa.g(z(n, "", null), 11);
                    case 11:
                        A = wa.i;
                    case 10:
                        t = A;
                        wa.B(6);
                        break;
                    case 12:
                        t = wa.i;
                    case 6:
                        if (t) {
                            if (t.keyIds) for(E = u(t.keyIds), C = E.next(); !C.done; C = E.next())D = C.value, k.add(D);
                            h.push(t);
                        }
                    case 4:
                        m = l.next();
                        wa.B(3);
                        break;
                    case 2:
                        B = {};
                        J = u(b);
                        for(F = J.next(); !F.done; F = J.next())I = F.value, K = nz(I, !a.l), B[K] ? B[K].push(I) : B[K] = [
                            I
                        ];
                        N = [];
                        for(P in B)M = B[P], L = M[0], Q = pz(L, "FRAME-RATE"), S = Number(qz(L, "BANDWIDTH")) || Number(pz(L, "AVERAGE-BANDWIDTH")), Z = pz(L, "RESOLUTION"), pa = u(Z ? Z.split("x") : [
                            null,
                            null
                        ]), va = pa.next().value, Ca = pa.next().value, ua = pz(L, "VIDEO-RANGE"), (xa = pz(L, "REQ-VIDEO-LAYOUT")) && xa.includes(",") && (Da = xa.split(",").filter(function(Ja) {
                            return Ja == "CH-STEREO" || Ja == "CH-MONO";
                        }), xa = Da[0]), xa = xa || "CH-MONO", Ka = IA(a, M, d), N.push.apply(N, G(JA(a, Ka.audio, Ka.video, S, va, Ca, Q, ua, xa, h, k, g)));
                        return wa.return(N.filter(function(Ja) {
                            return Ja != null;
                        }));
                }
            });
        }
        function IA(a, b, c) {
            for(var d = {
                audio: [],
                video: []
            }, e = new Map, f = [], g = !1, h = !1, k = u(b), l = k.next(); !l.done; l = k.next()){
                var m = l.value;
                l = pz(m, "AUDIO");
                var n = pz(m, "VIDEO"), q = l || n;
                q && (f.includes(q) || f.push(q), (m = pz(m, "PATHWAY-ID")) && e.set(q, m), l ? g = !0 : n && (h = !0));
            }
            f.length && c.length && (c = c.filter(function(t) {
                return f.includes(qz(t, "GROUP-ID"));
            }), FA(a, c, e));
            c = (e = f.sort().join(",")) && a.L.has(e) ? a.L.get(e) : [];
            g ? d.audio.push.apply(d.audio, G(c)) : h && d.video.push.apply(d.video, G(c));
            h = !1;
            var r = b.map(function(t) {
                return qz(t, "URI");
            });
            g = d.audio.find(function(t) {
                return t && t.T().find(function(v) {
                    return r.includes(v);
                });
            });
            c = yA(a, b[0]);
            k = Cc("video", c);
            (l = Cc("audio", c)) && !k ? (g = "audio", h = d.audio.length > 0 && !d.audio.some(function(t) {
                return t.stream.isAudioMuxedInVideo;
            })) : !d.audio.length && !d.video.length && l && k ? (g = "video", c = [
                [
                    k,
                    l
                ].join()
            ]) : d.audio.length && g ? (g = "audio", h = !0) : g = d.video.length && !d.audio.length ? "audio" : "video";
            h || (b = KA(a, b, c, g), e && a.g.enableAudioGroups && (b.stream.groupId = e), b.stream.type == "audio" && g === "audio" && d.audio.some(function(t) {
                return t.stream.isAudioMuxedInVideo;
            }) && (a = d.audio[0].stream, b.stream.language = a.language, b.stream.channelsCount = a.channelsCount, b.stream.label = a.label, b.stream.audioSamplingRate = a.audioSamplingRate, b.stream.originalId = a.originalId, b.stream.originalLanguage = a.originalLanguage), d[b.stream.type] = [
                b
            ]);
            return d;
        }
        function yA(a, b) {
            b = pz(b, "CODECS") || "";
            a.P = b.length > 0;
            a.P || a.g.hls.disableCodecGuessing || (b = [], a.g.disableVideo || b.push(a.g.hls.defaultVideoCodec), a.g.disableAudio || b.push(a.g.hls.defaultAudioCodec), b = b.join(","));
            return bn(b.split(/\s*,\s*/));
        }
        function LA(a) {
            return (a = pz(a, "CHANNELS")) ? parseInt(a.split("/")[0], 10) : null;
        }
        function MA(a) {
            return (a = pz(a, "SAMPLE-RATE")) ? parseInt(a, 10) : null;
        }
        function NA(a) {
            a = pz(a, "CHANNELS");
            if (!a) return !1;
            a = a.split("/");
            return a.length != 2 ? !1 : a[1] === "JOC" || a[1].includes("ATMOS") || a[1].includes("IMSA");
        }
        function ZA(a) {
            a = qz(a, "TYPE").toLowerCase();
            a == "subtitles" && (a = Ec);
            return a;
        }
        function JA(a, b, c, d, e, f, g, h, k, l, m, n) {
            for(var q = u(c), r = q.next(); !r.done; r = q.next())$A(r.value.stream, e, f, g, h, k, null);
            e = a.g.disableVideo;
            if (!c.length || e) c = [
                null
            ];
            e && (b = b.filter(function(x) {
                return !x.stream.isAudioMuxedInVideo;
            }));
            e = a.g.disableAudio;
            if (!b.length || e) b = [
                null
            ];
            e = [];
            b = u(b);
            for(f = b.next(); !f.done; f = b.next())for(f = f.value, g = u(c), h = g.next(); !h.done; h = g.next()){
                var t = h.value;
                if (h = f ? f.stream : null) h.drmInfos = l, h.keyIds = m;
                if (k = t ? t.stream : null) k.drmInfos = l, k.keyIds = m, a.g.disableIFrames || Ng(k, n);
                k && !h && (k.bandwidth = d);
                !k && h && (h.bandwidth = d);
                q = f ? f.stream.drmInfos : null;
                r = t ? t.stream.drmInfos : null;
                t = t ? t.T().sort().join(",") : "";
                var v = f ? f.T().sort().join(",") : "", w = [];
                h && h.codecs && w.push(h.codecs);
                k && k.codecs && w.push(k.codecs);
                t = [
                    t,
                    v,
                    w.sort()
                ].join("-");
                h && k && !Lb(q, r) || a.kb.has(t) || (h = {
                    id: a.G++,
                    language: h ? h.language : "und",
                    disabledUntilTime: 0,
                    primary: !!h && h.primary || !!k && k.primary,
                    audio: h,
                    video: k,
                    bandwidth: d,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                }, e.push(h), a.kb.add(t));
            }
            return e;
        }
        function jA(a, b) {
            b = uz(b, "CLOSED-CAPTIONS");
            a.R = b.length == 0;
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                var d = c.value, e = pz(d, "LANGUAGE");
                c = Kc(e || "und");
                e || (e = pz(d, "NAME")) && (c = e);
                e = qz(d, "GROUP-ID");
                d = qz(d, "INSTREAM-ID").replace("SERVICE", "svc");
                a.J.get(e) || a.J.set(e, new Map);
                a.J.get(e).set(d, c);
            }
        }
        function zA(a, b, c, d) {
            d = d === void 0 ? !0 : d;
            for(var e = [], f = [], g = new Map, h = u(b), k = h.next(), l = {}; !k.done; l = {
                hj: void 0
            }, k = h.next()){
                k = k.value;
                l.hj = ++a.G;
                l = function(v) {
                    return function() {
                        return "shaka://hls-muxed" + v.hj;
                    };
                }(l);
                var m = d ? qz(k, "URI") : pz(k, "URI") || l();
                l = qz(k, "GROUP-ID");
                e.push(m);
                f.push(l);
                g.set(l, m);
                (k = pz(k, "PATHWAY-ID")) && c.set(l, k);
            }
            d = f.sort().join(",");
            k = b[0];
            b = "";
            h = ZA(k);
            if (h == Ec) b = pz(k, "CODECS") || "";
            else for(f = u(f), l = f.next(); !l.done; l = f.next())if (l = l.value, a.K.has(l)) {
                b = a.K.get(l);
                break;
            }
            f = e.sort().join(",");
            h == "audio" && d && (f += d);
            if (a.j.has(f)) return a.j.get(f);
            l = a.G++;
            if (a.l) for(g = u(g), m = g.next(); !m.done; m = g.next()){
                var n = u(m.value);
                m = n.next().value;
                n = n.next().value;
                (m = c.get(m)) && qx(a.l, l, m, n);
            }
            c = pz(k, "LANGUAGE");
            g = pz(k, "NAME");
            m = pz(k, "DEFAULT") == "YES";
            n = h == "audio" ? LA(k) : null;
            var q = h == "audio" ? NA(k) : !1, r = pz(k, "CHARACTERISTICS"), t = pz(k, "FORCED") == "YES";
            k = h == "audio" ? MA(k) : null;
            e = aB(a, l, e, b, h, c, m, g, n, null, r, t, k, q);
            e.stream && a.g.enableAudioGroups && (e.stream.groupId = d);
            a.L.has(d) ? a.L.get(d).push(e) : a.L.set(d, [
                e
            ]);
            a.j.set(f, e);
            return e;
        }
        function DA(a, b) {
            var c, d, e, f, g, h, k, l, m, n;
            return H(function(q) {
                if (q.h == 1) {
                    c = qz(b, "URI");
                    d = pz(b, "CODECS", "jpeg") || "";
                    if (a.j.has(c)) return q.return(a.j.get(c));
                    e = pz(b, "LANGUAGE");
                    f = pz(b, "NAME");
                    g = pz(b, "CHARACTERISTICS");
                    h = aB(a, a.G++, [
                        c
                    ], d, "image", e, !1, f, null, null, g, !1, null, !1);
                    return (k = pz(b, "RESOLUTION")) ? q.g(h.stream.createSegmentIndex(), 3) : q.B(2);
                }
                if (q.h != 2) {
                    l = h.stream.segmentIndex.Fb();
                    if (m = l.tilesLayout) h.stream.width = Number(k.split("x")[0]) * Number(m.split("x")[0]), h.stream.height = Number(k.split("x")[1]) * Number(m.split("x")[1]);
                    h.stream.closeSegmentIndex();
                }
                if (n = pz(b, "BANDWIDTH")) h.stream.bandwidth = Number(n);
                a.j.set(c, h);
                return q.return(h);
            });
        }
        function EA(a, b) {
            var c = "video", d = qz(b, "URI"), e = pz(b, "CODECS") || "";
            e == "mjpg" && (c = "image");
            if (a.j.has(d)) return a.j.get(d);
            var f = pz(b, "LANGUAGE"), g = pz(b, "NAME"), h = pz(b, "CHARACTERISTICS");
            c = aB(a, a.G++, [
                d
            ], e, c, f, !1, g, null, null, h, !1, null, !1);
            e = pz(b, "RESOLUTION");
            f = u(e ? e.split("x") : [
                null,
                null
            ]);
            e = f.next().value;
            f = f.next().value;
            c.stream.width = Number(e) || void 0;
            c.stream.height = Number(f) || void 0;
            if (b = pz(b, "BANDWIDTH")) c.stream.bandwidth = Number(b);
            a.j.set(d, c);
            return c;
        }
        function KA(a, b, c, d) {
            for(var e = a.G++, f = [], g = u(b), h = g.next(); !h.done; h = g.next()){
                var k = h.value;
                h = qz(k, "URI");
                k = pz(k, "PATHWAY-ID");
                a.l && k && qx(a.l, e, k, h);
                f.push(h);
            }
            g = f.sort().join(",") + c.sort().join(",");
            if (a.j.has(g)) return a.j.get(g);
            h = f.join(",");
            a: {
                b = pz(b[0], "CLOSED-CAPTIONS");
                if (d == "video") {
                    if (a.g.disableText) {
                        a.R = !1;
                        b = null;
                        break a;
                    }
                    if (b) {
                        if (b != "NONE") {
                            b = a.J.get(b);
                            break a;
                        }
                        a.R = !1;
                    } else if (!b && a.J.size) for(b = u(a.J.keys()), b = b.next(); !b.done; b = b.next()){
                        b = a.J.get(b.value);
                        break a;
                    }
                }
                b = null;
            }
            c = Bc(d, c);
            d = aB(a, e, f, c, d, null, !1, h, null, b, null, !1, null, !1);
            a.j.set(g, d);
            return d;
        }
        function aB(a, b, c, d, e, f, g, h, k, l, m, n, q, r) {
            function t(A) {
                var E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa;
                return H(function(Da) {
                    switch(Da.h){
                        case 1:
                            return E = Gc, Da.m(2), Da.g(A.promise, 4);
                        case 4:
                            C = Da.i;
                            if (A.aborted) return Da.return();
                            D = C.uri;
                            D != C.originalUri && (B = x.T(), B.includes(D) || x.Zf.push(D));
                            J = Cz(a.hb, C.data);
                            if (J.type != 1) throw new T(2, 4, 4017);
                            F = tz(J.ka, "EXT-X-DEFINE");
                            I = Vz(a, F, D);
                            K = !1;
                            (!a.P && a.g.hls.disableCodecGuessing || a.R && e == E.Ba && !a.g.hls.disableClosedCaptionsDetection) && J.segments.length > 0 && (a.R = !1, K = !0);
                            N = !a.P && a.g.hls.disableCodecGuessing;
                            P = Pz(a);
                            return Da.g(eA(a, 0, I, J, v, d, e, f, g, h, k, l, m, n, q, r, void 0, K, N), 5);
                        case 5:
                            M = Da.i;
                            if (A.aborted) return Da.return();
                            L = M.stream;
                            oA(a, J);
                            Pz(a) && !P && pA(a, J);
                            x.gd = M.gd;
                            x.Uc = M.Uc;
                            x.kf = M.kf;
                            x.jf = M.jf;
                            x.qe = M.qe;
                            x.Nf = M.Nf;
                            x.Ub = M.Ub;
                            x.Vb = M.Vb;
                            w.segmentIndex = L.segmentIndex;
                            w.encrypted = L.encrypted;
                            w.drmInfos = L.drmInfos;
                            w.keyIds = L.keyIds;
                            w.mimeType = L.mimeType;
                            w.bandwidth = w.bandwidth || L.bandwidth;
                            w.codecs = w.codecs || L.codecs;
                            w.closedCaptions = w.closedCaptions || L.closedCaptions;
                            w.width = w.width || L.width;
                            w.height = w.height || L.height;
                            w.hdr = w.hdr || L.hdr;
                            w.colorGamut = w.colorGamut || L.colorGamut;
                            w.frameRate = w.frameRate || L.frameRate;
                            w.language == "und" && L.language != "und" && (w.language = L.language);
                            w.language = w.language || L.language;
                            w.channelsCount = w.channelsCount || L.channelsCount;
                            w.audioSamplingRate = w.audioSamplingRate || L.audioSamplingRate;
                            CA(w);
                            x.type != E.Ba || M.type != E.ha || a.P && !yf.includes(w.mimeType) || bB(a, x, L);
                            w.drmInfos.length && a.i.newDrmInfo(w);
                            Q = !1;
                            if (!l && w.closedCaptions || l && w.closedCaptions && l.size != w.closedCaptions.size) Q = !0;
                            a.h && Q && a.i.makeTextStreamsForClosedCaptions(a.h);
                            e == E.Va && (S = L.segmentIndex.Fb()) && S.ia && (w.mimeType = "application/mp4", CA(w));
                            Z = Km(w);
                            w.segmentIndex.xb(function(Ka) {
                                Ka.ia && (Ka.ia.Kd = Z);
                            });
                            cB(a) && (a.Gc ? qA(a, [
                                x
                            ]) : (a.Gc = !0, pa = Array.from(a.j.values()), va = pa.filter(function(Ka) {
                                return Ka.stream.segmentIndex;
                            }), qA(a, va), Tz(a), Ca = a.C, Ca > 0 && a.D.Z(Ca)));
                            $z(a, J.ka, w.type, I, v);
                            a.h && (a.h.startTime = a.A);
                            Da.o(0);
                            break;
                        case 2:
                            ua = Da.l();
                            w.closeSegmentIndex();
                            if (ua.code === 7001) return Da.return();
                            xa = a.i.disableStream(w);
                            if (!xa) throw ua;
                            Da.j();
                    }
                });
            }
            function v() {
                return a.l && c.length > 1 ? rx(a.l, b) : x.Zf.concat(yz([
                    a.H
                ], c, a.F));
            }
            var w = dB(a, d, e, f, g, h, k, l, m, n, q, r);
            c.some(function(A) {
                return A.startsWith("shaka://hls-muxed");
            }) && (w.isAudioMuxedInVideo = !0, w.mimeType = "video/mp2t", CA(w));
            var x = {
                stream: w,
                type: e,
                Zf: [],
                gd: 0,
                Uc: 0,
                Nf: new Map,
                kf: !1,
                jf: !1,
                qe: !1,
                Wg: -1,
                Ub: -1,
                Vb: -1,
                T: v
            }, y = null, z;
            w.createSegmentIndex = function() {
                if (y) return y;
                if (w.isAudioMuxedInVideo) return w.segmentIndex = new vm([]), Promise.resolve();
                z = Nz(a, x.T(), !0);
                return y = new Promise(function(A) {
                    A(t(z));
                });
            };
            w.closeSegmentIndex = function() {
                y && !w.segmentIndex && z.abort();
                w.segmentIndex && (w.segmentIndex.release(), w.segmentIndex = null);
                y = null;
            };
            return x;
        }
        function bB(a, b, c) {
            var d = b.stream, e = c.type, f = b.type;
            Pz(a) && (a.o.set(e, a.o.get(f)), a.o.set(f, new Map));
            b.type = e;
            d.type = e;
            d.codecs = Cc(e, c.codecs.split(/\s*,\s*/)) || "";
            CA(d);
            if (a.h) {
                b = u(a.h.variants);
                for(c = b.next(); !c.done; c = b.next())c = c.value, e == "audio" && c.video == d && (c.video = null, c.audio || (c.audio = d, c.language = d.language));
                a.h.variants = a.h.variants.filter(function(g) {
                    return g.audio || g.video;
                });
            }
        }
        function xA(a) {
            var b = Infinity;
            a = u(a.j.values());
            for(var c = a.next(); !c.done; c = a.next())c = c.value, c.stream.segmentIndex && c.stream.type != "text" && !c.stream.isAudioMuxedInVideo && (b = Math.min(b, c.Uc));
            return b;
        }
        function Rz(a, b) {
            var c = [];
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())d = d.value, d.segmentIndex && d.segmentIndex.xb(function(e) {
                c.push(e);
            });
            a.m.Ae(c);
        }
        function qA(a, b) {
            if (!Pz(a)) for(var c = xA(a), d = u(b), e = d.next(); !e.done; e = d.next())e.value.stream.segmentIndex.zd(0, c);
            Rz(a, b.map(function(f) {
                return f.stream;
            }));
            d = Array.from(a.j.values()).filter(function(f) {
                return f.stream.segmentIndex;
            });
            c = d.some(function(f) {
                return f.stream.type == "audio";
            });
            e = d.some(function(f) {
                return f.stream.type == "video";
            });
            d = Pz(a) && !a.jb;
            c = !Pz(a) && a.jb && !(c && e);
            a.g.hls.ignoreManifestProgramDateTime || d || c ? aA(a, b, d) : (dA(a, b), a.g.hls.ignoreManifestProgramDateTimeForTypes.length > 0 && aA(a, b));
        }
        function bA(a, b) {
            return a.g.hls.ignoreManifestProgramDateTime ? !0 : a.g.hls.ignoreManifestProgramDateTimeForTypes.includes(b);
        }
        function cB(a) {
            if (!a.h || !a.h.variants.length) return !1;
            var b = [], c = [];
            a = u(a.h.variants);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, d.video && b.push(d.video), d.audio && c.push(d.audio);
            return b.length > 0 && !b.some(function(e) {
                return e.segmentIndex;
            }) || c.length > 0 && !c.some(function(e) {
                return e.segmentIndex;
            }) ? !1 : !0;
        }
        function eA(a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y) {
            x = x === void 0 ? !0 : x;
            y = y === void 0 ? !0 : y;
            var z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa, Da, Ka, wa, Ja, Aa, Ga, sb, Wb;
            return H(function(wb) {
                switch(wb.h){
                    case 1:
                        z = g;
                        A = d.segments || [];
                        E = A.every(function(wc) {
                            return vz(wc.ka, "EXT-X-GAP") ? !0 : !1;
                        });
                        if (!A.length || E) throw new T(2, 4, 4053);
                        eB(a, d);
                        Pz(a) && Zz(a, d);
                        C = Pz(a) ? a.o.get(g) : new Map;
                        D = Xz(a, d, C, c, e, g);
                        B = D.segments;
                        J = D.bandwidth;
                        P = N = K = I = F = null;
                        if (!(B.length > 0 && x)) {
                            wb.B(2);
                            break;
                        }
                        return wb.g(rA(a, B), 3);
                    case 3:
                        M = wb.i, g != M.type && Pz(a) && (a.o.set(M.type, a.o.get(g)), a.o.set(g, new Map)), g = M.type, h = M.language, m = M.channelCount, t = M.sampleRate, a.g.disableText || (n = M.closedCaptions), I = M.height, F = M.width, K = M.Me, N = M.colorGamut, P = M.frameRate, y && (w = M.mimeType, f = M.codecs);
                    case 2:
                        if (w) {
                            wb.B(4);
                            break;
                        }
                        return wb.g(fB(a, g, f, B), 5);
                    case 5:
                        w = wb.i, g != Ec || f || w != "application/mp4" || !B[0] || B[0].ia || (w = "text/vtt");
                    case 4:
                        return z == "video" && yf.includes(w) && (g = "audio"), wb.g(Wz(a, d, w, e, c), 6);
                    case 6:
                        L = wb.i;
                        Q = L.drmInfos;
                        S = L.keyIds;
                        Z = L.encrypted;
                        pa = L.Ii;
                        if (Z && !Q.length && !pa) throw new T(2, 4, 4026);
                        va = dB(a, f, g, h, k, l, m, n, q, r, t, v);
                        va.encrypted = Z && !pa;
                        va.drmInfos = Q;
                        va.keyIds = S;
                        va.mimeType = w;
                        J && (va.bandwidth = J);
                        CA(va);
                        g == "video" && (F || I || K || N) && $A(va, F, I, P, K, null, N);
                        Pz(a) && Zz(a, d);
                        Ca = B[0].startTime;
                        ua = B[B.length - 1];
                        xa = ua.endTime;
                        Da = new vm(B);
                        va.segmentIndex = Da;
                        wa = (Ka = vz(d.ka, "EXT-X-SERVER-CONTROL")) ? oz(Ka, "CAN-SKIP-UNTIL") != null : !1;
                        Ja = Ka ? oz(Ka, "CAN-BLOCK-RELOAD") != null : !1;
                        Aa = wz(d.ka, "EXT-X-MEDIA-SEQUENCE", 0);
                        Ga = Yz(Aa, B);
                        sb = Ga.Ub;
                        Wb = Ga.Vb;
                        return wb.return({
                            stream: va,
                            type: g,
                            Zf: [],
                            T: e,
                            gd: Ca,
                            Uc: xa,
                            kf: wa,
                            jf: Ja,
                            qe: !1,
                            Wg: -1,
                            Ub: sb,
                            Vb: Wb,
                            Nf: C
                        });
                }
            });
        }
        function Yz(a, b) {
            a = a + b.length - 1;
            var c = -1;
            if (!b.length) return a++, {
                Ub: a,
                Vb: c
            };
            b = b[b.length - 1];
            var d = b.g;
            if (!b.g.length) return a++, b.o && (c = 0), {
                Ub: a,
                Vb: c
            };
            c = d.length - 1;
            d[d.length - 1].isPreload() || (a++, c = 0);
            return {
                Ub: a,
                Vb: c
            };
        }
        function dB(a, b, c, d, e, f, g, h, k, l, m, n) {
            var q = AA(c, b) || BA(c), r = [];
            if (k) {
                k = u(k.split(","));
                for(var t = k.next(); !t.done; t = k.next())r.push(t.value);
            }
            t = void 0;
            k = null;
            c == Ec ? t = r.includes("public.accessibility.transcribes-spoken-dialog") && r.includes("public.accessibility.describes-music-and-sound") ? "caption" : "subtitle" : r.includes("public.accessibility.describes-video") && (k = "visually impaired");
            r.length || t !== "subtitle" || r.push("subtitle");
            t = null;
            c != "video" && (t = f);
            a = {
                id: a.G++,
                originalId: f,
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: null,
                mimeType: q,
                codecs: b,
                kind: c == Ec ? "subtitle" : void 0,
                encrypted: !1,
                drmInfos: [],
                keyIds: new Set,
                language: Kc(d || "und"),
                originalLanguage: d,
                label: t,
                type: c,
                primary: e,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: null,
                frameRate: void 0,
                pixelAspectRatio: void 0,
                width: void 0,
                height: void 0,
                bandwidth: void 0,
                roles: r,
                forced: l,
                channelsCount: g,
                audioSamplingRate: m,
                spatialAudio: n,
                closedCaptions: h,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                tilesLayout: void 0,
                accessibilityPurpose: k,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
            CA(a);
            return a;
        }
        function Wz(a, b, c, d, e) {
            var f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q;
            return H(function(S) {
                switch(S.h){
                    case 1:
                        f = new Map;
                        if (!a.g.ignoreDrmInfo && b.segments) {
                            for(g = u(b.segments), h = g.next(); !h.done; h = g.next())if (k = h.value, l = tz(k.ka, "EXT-X-KEY"), m = null, l.length) for(m = gB(a, b, k.ka, d, e), n = u(l), q = n.next(); !q.done; q = n.next())r = q.value, f.set(r, m);
                        }
                        v = t = !1;
                        w = [];
                        x = new Set;
                        y = u(f);
                        z = y.next();
                    case 2:
                        if (z.done) {
                            S.B(4);
                            break;
                        }
                        A = z.value;
                        E = u(A);
                        C = E.next().value;
                        D = E.next().value;
                        B = C;
                        J = D;
                        F = qz(B, "METHOD");
                        if (F == "NONE") {
                            S.B(3);
                            break;
                        }
                        t = !0;
                        I = pz(B, "KEYFORMAT") || "identity";
                        K = null;
                        if (GA(F)) {
                            v = !0;
                            S.B(3);
                            break;
                        }
                        if (I == "identity") return S.g(HA(a, B, c, d, J, e), 11);
                        N = a.jc.get(I);
                        if (!N) {
                            P = null;
                            S.B(9);
                            break;
                        }
                        return S.g(N(B, c, J), 10);
                    case 10:
                        P = S.i;
                    case 9:
                        K = P;
                        S.B(6);
                        break;
                    case 11:
                        K = S.i;
                    case 6:
                        if (K) {
                            if (K.keyIds) for(M = u(K.keyIds), L = M.next(); !L.done; L = M.next())Q = L.value, x.add(Q);
                            w.push(K);
                        }
                    case 3:
                        z = y.next();
                        S.B(2);
                        break;
                    case 4:
                        return S.return({
                            drmInfos: w,
                            keyIds: x,
                            encrypted: t,
                            Ii: v
                        });
                }
            });
        }
        function hB(a, b, c, d, e) {
            if (!window1.crypto || !window1.crypto.subtle) throw Za("Web Crypto API is not available to decrypt AES. (Web Crypto only exists in secure origins like https)"), new T(2, 4, 4042);
            var f = 0, g = pz(b, "IV", "");
            if (g) {
                var h = rc(g.substr(2));
                if (h.byteLength != 16) throw new T(2, 4, 4048);
            } else f = wz(c.ka, "EXT-X-MEDIA-SEQUENCE", 0);
            var k = xz(d(), qz(b, "URI"), e), l = k.sort().join("");
            c = b.toString() + "-" + f + "-" + l;
            if (!a.na.has(c)) {
                var m = {
                    bitsKey: 128,
                    blockCipherMode: "CBC",
                    iv: h,
                    firstMediaSequenceNumber: f
                };
                switch(qz(b, "METHOD")){
                    case "AES-256":
                        m.bitsKey = 256;
                        break;
                    case "AES-256-CTR":
                        m.bitsKey = 256, m.blockCipherMode = "CTR";
                }
                m.fetchKey = function() {
                    var n, q, r, t;
                    return H(function(v) {
                        if (v.h == 1) return a.O.has(l) || (n = mh(k, a.g.retryParameters), q = vA(a, n, 6).promise, a.O.set(l, q)), v.g(a.O.get(l), 2);
                        if (v.h != 3) {
                            r = v.i;
                            if (!r.data || r.data.byteLength != m.bitsKey / 8) throw new T(2, 4, 4049);
                            t = {
                                name: m.blockCipherMode == "CTR" ? "AES-CTR" : "AES-CBC",
                                length: m.bitsKey
                            };
                            return v.g(window1.crypto.subtle.importKey("raw", r.data, t, !0, [
                                "decrypt"
                            ]), 3);
                        }
                        m.cryptoKey = v.i;
                        m.fetchKey = void 0;
                        v.j();
                    });
                };
                a.na.set(c, m);
            }
            return a.na.get(c);
        }
        function oA(a, b) {
            a.A == null && (b = vz(b.ka, "EXT-X-START")) && (a.A = Number(qz(b, "TIME-OFFSET")));
        }
        function eB(a, b) {
            var c = vz(b.ka, "EXT-X-PLAYLIST-TYPE");
            b = vz(b.ka, "EXT-X-ENDLIST");
            b = c && c.value == "VOD" || b;
            c = c && c.value == "EVENT" && !b;
            c = !b && !c;
            b ? Sz(a, Mz) : c ? Sz(a, wA) : Sz(a, iB);
        }
        function Zz(a, b) {
            var c = Infinity, d = b.segments;
            if (d.length) for(var e = d.length - 1; e >= 0;){
                var f = vz(d[e].ka, "EXTINF");
                if (f) {
                    c = Az(f);
                    break;
                }
                e--;
            }
            d = vz(b.ka, "EXT-X-TARGETDURATION");
            if (!d) throw new T(2, 4, 4024, "EXT-X-TARGETDURATION");
            d = Number(d.value);
            if (e = vz(b.ka, "EXT-X-PART-INF")) a.S = Number(qz(e, "PART-TARGET"));
            b = vz(b.ka, "EXT-X-SERVER-CONTROL");
            a.ba && a.S ? (a.C = a.Fc ? a.S * 5 <= c ? Math.min(a.S, a.C) : Math.min(c, a.C) : Math.min(a.S, a.C), a.Oa = b ? Number(qz(b, "PART-HOLD-BACK")) : 0) : (a.C = Math.min(c, a.C), c = b ? oz(b, "HOLD-BACK") : null, a.Ia = c ? Number(c.value) : 0);
            a.ab = Math.max(d, a.ab);
        }
        function pA(a, b) {
            var c = 0;
            if (a.g.defaultPresentationDelay) c = a.g.defaultPresentationDelay;
            else if (a.Oa) c = a.Oa;
            else if (a.Ia) c = a.Ia;
            else for(var d = b.segments.length, e = d - Math.min(d, a.g.hls.liveSegmentsDelay); e < d; e++){
                var f = vz(b.segments[e].ka, "EXTINF");
                c = f ? c + Az(f) : c + a.ab;
            }
            a.A && a.A < 0 && (c = Math.min(-a.A, c), a.A += c);
            a.m.Pj(0);
            a.m.ii(c);
            a.m.md(!1);
        }
        function gB(a, b, c, d, e) {
            var f = vz(c, "EXT-X-MAP");
            if (!f) return null;
            var g = qz(f, "URI"), h = xz(d(), g, e);
            g = [
                h.toString(),
                pz(f, "BYTERANGE", "")
            ].join("-");
            if (!a.ya.has(g)) {
                var k = void 0, l = null, m = !1;
                c = u(c);
                for(var n = c.next(); !n.done; n = c.next())n = n.value, n.name == "EXT-X-KEY" ? (m = qz(n, "METHOD"), GA(m) && n.id < f.id ? (m = !1, k = hB(a, n, b, d, e)) : m = m != "NONE") : n.name == "EXT-X-BYTERANGE" && n.id < f.id && (l = n);
                b = jB(h, f, l, k, m);
                a.ya.set(g, b);
            }
            return a.ya.get(g);
        }
        function jB(a, b, c, d, e) {
            var f = 0, g = null;
            b = pz(b, "BYTERANGE");
            !b && c && (b = c.value);
            b && (f = b.split("@"), g = Number(f[0]), f = Number(f[1]), g = f + g - 1, d && (c = g + 1 - f, c % 16 && (g += 16 - c % 16)));
            return new Mj(function() {
                return a;
            }, f, g, null, null, null, d, e);
        }
        function kB(a, b, c, d, e, f, g, h, k, l) {
            var m = d.ka, n = vz(m, "EXTINF"), q = 0, r = 0, t = null;
            d.Dc.length && (a.h.isLowLatency = !0);
            var v = null;
            if (!a.g.hls.ignoreManifestProgramDateTime) {
                var w = vz(m, "EXT-X-PROGRAM-DATE-TIME");
                w && w.value && (v = te(w.value), a.jb = !0);
            }
            var x = Pj;
            vz(m, "EXT-X-GAP") && (a.h.gapCount++, x = 2);
            if (!n) {
                if (d.Dc.length == 0) throw new T(2, 4, 4024, "EXTINF");
                if (!a.ba) return null;
            }
            var y = [];
            w = !1;
            var z = null, A = !1, E = !1;
            if (a.ba && d.Dc.length) {
                q = b && window1.ReadableStream && a.g.hls.allowLowLatencyByteRangeOptimization;
                for(var C = v, D = {}, B = 0; B < d.Dc.length; D = {
                    vg: void 0,
                    Ce: void 0
                }, B++){
                    var J = d.Dc[B], F = B == 0 ? c : y[y.length - 1], I = B == 0 ? e : F.endTime, K = Number(pz(J, "DURATION")) || a.S;
                    if (K) {
                        var N = I + K, P = 0, M = null;
                        J.name == "EXT-X-PRELOAD-HINT" ? (P = (P = pz(J, "BYTERANGE-START")) ? Number(P) : 0, (F = pz(J, "BYTERANGE-LENGTH")) ? M = P + Number(F) - 1 : P && (M = Number.MAX_SAFE_INTEGER)) : (P = pz(J, "BYTERANGE"), M = u(lB(F, P)), P = M.next().value, M = M.next().value);
                        D.Ce = pz(J, "URI");
                        if (D.Ce) {
                            F = Pj;
                            pz(J, "GAP") == "YES" && (a.h.gapCount++, F = 2, A = !0);
                            D.vg = null;
                            var L = function(S) {
                                return function() {
                                    S.vg == null && (S.vg = xz(h(), S.Ce, f));
                                    return S.vg;
                                };
                            }(D);
                            q && P >= 0 && M != null && (z = L, w = !0);
                            I = new Oj(I, N, L, P, M, b, 0, 0, Infinity, [], "", null, C, F, l);
                            J.name == "EXT-X-PRELOAD-HINT" && (I.Mh(), E = !0);
                            pz(J, "INDEPENDENT") != "YES" && B > 0 && I.Jd();
                            J = k;
                            J || (y.length && y[0].mimeType ? J = y[0].mimeType : D.Ce && (D = gn(D.Ce), J = mB.get(g).get(D) || null));
                            J && (I.mimeType = J, nB.has(J) && (I.ia = null));
                            y.push(I);
                            C && (C += K);
                        }
                    }
                }
            }
            if (n) {
                n = Az(n);
                if (n == 0) return null;
                q = e + n;
            } else if (y.length) q = y[y.length - 1].endTime;
            else return null;
            w && (A || y[0].startByte != 0 ? (w = !1, z = null) : y = []);
            (n = vz(m, "EXT-X-BYTERANGE")) ? (t = u(lB(c, n.value)), r = t.next().value, t = t.next().value) : y.length && (r = y[0].startByte, t = y[y.length - 1].endByte);
            c = "";
            n = null;
            g == "image" && (c = "1x1", g = vz(m, "EXT-X-TILES")) && (c = qz(g, "LAYOUT"), (g = pz(g, "DURATION")) && (n = Number(g)));
            var Q = null;
            b = new Oj(e, q, function() {
                if (z) return z();
                Q == null && (Q = xz(h(), d.g, f));
                return Q || [];
            }, r, t, b, 0, 0, Infinity, y, c, n, v, x, l, y.length > 0 && !!d.g);
            k && (b.mimeType = k, nB.has(k) && (b.ia = null));
            w && (a.Fc = !0, b.oj(), E && b.Mh());
            return b;
        }
        function lB(a, b) {
            var c = 0, d = null;
            b && (c = b.split("@"), b = Number(c[0]), c = c[1] ? Number(c[1]) : a.endByte + 1, d = c + b - 1);
            return [
                c,
                d
            ];
        }
        function $z(a, b, c, d, e) {
            if (c == "video" || c == "audio") {
                var f = a.m.m;
                if (f != null && !bA(a, c)) for(b = tz(b, "EXT-X-DATERANGE"), b = b.filter(function(F) {
                    return oz(F, "START-DATE") != null;
                }).sort(function(F, I) {
                    F = qz(F, "START-DATE");
                    I = qz(I, "START-DATE");
                    return F < I ? -1 : F > I ? 1 : 0;
                }), c = 0; c < b.length; c++){
                    var g = b[c];
                    try {
                        var h = qz(g, "START-DATE"), k = te(h);
                        if (!isNaN(k)) {
                            var l = Math.max(0, k - f), m = null, n = pz(g, "END-DATE");
                            if (n) {
                                var q = te(n);
                                if (!isNaN(q) && (m = q - f, m < 0)) continue;
                            }
                            if (m == null) {
                                var r = pz(g, "DURATION") || pz(g, "PLANNED-DURATION");
                                if (r) {
                                    var t = parseFloat(r);
                                    isNaN(t) || (m = l + t);
                                    if (k - f + t < 0) continue;
                                }
                            }
                            var v = pz(g, "CLASS") || "com.apple.quicktime.HLS", w = pz(g, "END-ON-NEXT") == "YES";
                            if (m == null && w) {
                                for(var x = c + 1; x < b.length; x++){
                                    var y = pz(b[x], "CLASS") || "com.apple.quicktime.HLS";
                                    if (v == y) {
                                        var z = qz(b[x], "START-DATE"), A = te(z);
                                        if (!isNaN(A) && A && A > k) {
                                            m = Math.max(0, A - f);
                                            break;
                                        }
                                    }
                                }
                                if (m == null) continue;
                            }
                            x = [
                                "CLASS",
                                "START-DATE",
                                "END-DATE",
                                "DURATION",
                                "END-ON-NEXT"
                            ];
                            for(var E = [], C = u(g.attributes), D = C.next(); !D.done; D = C.next()){
                                var B = D.value;
                                if (!x.includes(B.name)) {
                                    var J = zz(B.value, d);
                                    if (B.name == "X-ASSET-URI" || B.name == "X-ASSET-LIST") J = xz(e(), B.value, d)[0];
                                    E.push({
                                        key: B.name,
                                        description: "",
                                        data: J,
                                        mimeType: null,
                                        pictureType: null
                                    });
                                }
                            }
                            if (E.length > 1) a.i.onMetadata(v, l, m, E);
                        }
                    } catch (F) {}
                }
            }
        }
        function Xz(a, b, c, d, e, f) {
            function g(F) {
                F = gn(F);
                if (!F) return null;
                var I = mB.get(f).get(F);
                I || (I = tA.get(F));
                return I;
            }
            var h = b.segments, k = null, l = null, m = null, n = null, q = void 0, r = wz(b.ka, "EXT-X-DISCONTINUITY-SEQUENCE", -1), t = wz(b.ka, "EXT-X-MEDIA-SEQUENCE", 0), v = vz(b.ka, "EXT-X-SKIP"), w = v ? Number(pz(v, "SKIPPED-SEGMENTS")) : 0, x = t + w, y = 0;
            Pz(a) && c.has(x) && (y = c.get(x));
            y === 0 && a.Ga == wA && c.size > 0 && !c.has(x) && a.m.i != null && (y = a.m.Hb());
            var z = [], A = null;
            v = [];
            for(var E = 0; E < h.length; E++){
                var C = h[E];
                (x = vz(C.ka, "EXT-X-MAP")) && x.id !== l && (k = gB(a, b, C.ka, e, d), l = x.id);
                x = C.g;
                var D = "";
                x && (D = gn(x));
                D !== n && (m = g(x), n = D);
                D = E == 0 ? y : A.endTime;
                x = t + w + E;
                vz(C.ka, "EXT-X-DISCONTINUITY") && (r++, A && A.ia && (A.ia.g = D));
                for(var B = u(C.ka), J = B.next(); !J.done; J = B.next())J = J.value, J.name == "EXT-X-KEY" && (GA(qz(J, "METHOD")) ? q = hB(a, J, b, e, d) : q = void 0);
                c.set(x, D);
                if (D = kB(a, k, A, C, D, d, f, e, m, q)) {
                    if (A = wz(C.ka, "EXT-X-BITRATE")) v.push({
                        bitrate: A,
                        duration: D.endTime - D.startTime
                    }), D.bandwidth = A;
                    else if (D.endByte) {
                        if (C = Qj(D)) A = D.endTime - D.startTime, C = C * 8 / A / 1E3, v.push({
                            bitrate: C,
                            duration: A
                        }), D.bandwidth = C;
                    } else v.length && (A = v[v.length - 1], A.duration += D.endTime - D.startTime, D.bandwidth = A.bitrate);
                    if (D.bandwidth) for(A = u(D.g), C = A.next(); !C.done; C = A.next())C.value.bandwidth = D.bandwidth;
                    A = D;
                    D.i = r;
                    bA(a, f) && a.M != null && x < a.M || z.push(D);
                }
            }
            b = void 0;
            v.length && (b = v.reduce(function(F, I) {
                return F + I.duration;
            }, 0), b = Math.round(v.reduce(function(F, I) {
                return F + I.bitrate * I.duration;
            }, 0) / b * 1E3));
            if (v = z.some(function(F) {
                return F.h != null;
            })) {
                for(c = {}, d = 0; d < z.length; c = {
                    rf: void 0,
                    qf: void 0,
                    ef: void 0,
                    jd: void 0,
                    df: void 0
                }, d++)if (c.jd = z[d], c.jd.h == null) for(c.qf = 0, c.rf = d, e = function(F) {
                    return function() {
                        var I = z[F.rf];
                        if (I) {
                            if (I.h != null) return I.h + F.qf;
                            F.qf -= I.endTime - I.startTime;
                            F.rf += 1;
                        }
                        return null;
                    };
                }(c), c.df = 0, c.ef = d, h = function(F) {
                    return function() {
                        var I = z[F.ef];
                        if (I) {
                            I != F.jd && (F.df += I.endTime - I.startTime);
                            if (I.h != null) return I.h + F.df;
                            --F.ef;
                        }
                        return null;
                    };
                }(c); c.jd.h == null;)c.jd.h = h(), c.jd.h == null && (c.jd.h = e());
            }
            if (v) for(c = u(z), d = c.next(); !d.done; d = c.next())for(e = d.value, d = e.h, e = u(e.g), h = e.next(); !h.done; h = e.next())h = h.value, h.h = d, d += h.endTime - h.startTime;
            c = a.$;
            if (v && c != Infinity && !bA(a, f)) for(a = u(z), v = a.next(); !v.done; v = a.next())v.value.ti(c);
            return {
                segments: z,
                bandwidth: b
            };
        }
        function AA(a, b) {
            if (a == Ec) {
                if (b == "vtt" || b == "wvtt") return "text/vtt";
                if (b && b !== "") return "application/mp4";
            }
            return a != "image" || b && b != "jpeg" ? a == "audio" && b == "mp4a.40.34" ? "audio/mpeg" : b == "mjpg" ? "application/mp4" : null : "image/jpeg";
        }
        function BA(a) {
            return a == Ec ? "text/vtt" : mB.get(a).get("mp4");
        }
        function sA(a, b) {
            a = Pz(a) ? Math.trunc((b.length - 1) / 2) : 0;
            for(var c = b[a]; c.ec() == 2 && a + 1 < b.length;)a++, c = b[a];
            return {
                segment: c,
                segmentIndex: a
            };
        }
        function fB(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w;
            return H(function(x) {
                switch(x.h){
                    case 1:
                        e = sh;
                        f = sA(a, d);
                        g = f.segment;
                        if (g.status == 2) return x.return(BA(b));
                        k = g.T();
                        if (l = gn(k[0])) {
                            if (m = mB.get(b), (n = m.get(l)) || (n = tA.get(l))) return x.return(n);
                        }
                        if (h = AA(b, c)) return x.return(h);
                        r = 1;
                        t = mh(k, a.g.retryParameters);
                        x.m(2);
                        t.method = "HEAD";
                        return x.g(vA(a, t, e, {
                            type: r
                        }).promise, 4);
                    case 4:
                        v = x.i;
                        q = v.headers["content-type"];
                        x.o(3);
                        break;
                    case 2:
                        w = x.l();
                        if (!w || w.code != 1002 && w.code != 1001) {
                            x.B(3);
                            break;
                        }
                        t.method = "GET";
                        a.g.hls.allowRangeRequestsToGuessMimeType && (t.headers.Range = "bytes=0-0");
                        return x.g(vA(a, t, e, {
                            type: r
                        }).promise, 6);
                    case 6:
                        v = x.i, q = v.headers["content-type"];
                    case 3:
                        if (!q) {
                            x.B(7);
                            break;
                        }
                        h = q.toLowerCase().split(";")[0];
                        if (!oB.includes(h)) {
                            x.B(8);
                            break;
                        }
                        if (v.data.byteLength) {
                            x.B(9);
                            break;
                        }
                        t.method = "GET";
                        return x.g(vA(a, t, e, {
                            type: r
                        }).promise, 10);
                    case 10:
                        v = x.i;
                    case 9:
                        Rk(Fb(v.data)) && (h = "video/mp2t");
                    case 8:
                        if (!oB.includes(h)) return x.return(h);
                    case 7:
                        return x.return(BA(b));
                }
            });
        }
        function $A(a, b, c, d, e, f, g) {
            a && (a.width = Number(b) || void 0, a.height = Number(c) || void 0, a.frameRate = Number(d) || void 0, a.hdr = e || void 0, a.videoLayout = f || void 0, a.colorGamut = g || void 0);
        }
        function Nz(a, b, c) {
            return vA(a, mh(b, a.g.retryParameters), 0, {
                type: c ? 2 : 3
            });
        }
        function Lz(a) {
            var b, c, d, e, f, g;
            return H(function(h) {
                switch(h.h){
                    case 1:
                        if (!a.i) return h.return();
                        h.m(2);
                        b = Date.now();
                        return h.g(a.update(), 4);
                    case 4:
                        c = Date.now();
                        Pz(a) && (d = (c - b) / 1E3, a.Kb.sample(1, d), e = a.g.updatePeriod > 0 ? a.g.updatePeriod : a.C, f = Math.max(0, e - Yc(a.Kb)), isFinite(f) ? a.D.Z(f) : a.D.Z(1));
                        h.o(3);
                        break;
                    case 2:
                        g = h.l();
                        if (!a.i) return h.return();
                        if (a.g.raiseFatalErrorOnManifestUpdateRequestFailure) return a.i.onError(g), h.return();
                        g.severity = 1;
                        a.i.onError(g);
                        a.D.Z(.1);
                    case 3:
                        if (!a.i) return h.return();
                        a.i.onManifestUpdated();
                        h.j();
                }
            });
        }
        function Pz(a) {
            return a.Ga != Mz;
        }
        function Sz(a, b) {
            a.Ga = b;
            a.m && a.m.md(!Pz(a));
            Pz(a) || a.D.stop();
        }
        function vA(a, b, c, d) {
            if (!a.X) throw new T(2, 7, 7001);
            d || (d = {});
            d.isPreload = a.hc();
            b = a.i.networkingEngine.request(c, b, d);
            gh(a.X, b);
            return b;
        }
        function GA(a) {
            return a == "AES-128" || a == "AES-256" || a == "AES-256-CTR";
        }
        function Kz(a, b, c, d) {
            var e, f, g, h, k, l;
            return H(function(m) {
                if (m.h == 1) {
                    if (c == "video/mp2t") throw new T(2, 4, 4040);
                    if ("apple" === window1.shakaMediaKeysPolyfill) throw new T(2, 4, 4041);
                    e = qz(b, "METHOD");
                    f = [
                        "SAMPLE-AES",
                        "SAMPLE-AES-CTR"
                    ];
                    if (!f.includes(e)) return m.return(null);
                    g = "cenc";
                    e == "SAMPLE-AES" && (g = "cbcs");
                    h = qz(b, "URI");
                    k = yc("com.apple.fps", g, null, h);
                    var n = new lb(h).Eb.replace(/-/g, "").toLowerCase();
                    return (l = n.length === 32 && /^[0-9a-f]+$/.test(n) ? n : null) || !d ? m.B(2) : m.g(pB(a, d), 3);
                }
                m.h != 2 && (l = m.i);
                l && k.keyIds.add(l);
                return m.return(k);
            });
        }
        function HA(a, b, c, d, e, f) {
            var g, h, k, l, m, n, q, r, t, v, w, x;
            return H(function(y) {
                switch(y.h){
                    case 1:
                        if (c == "video/mp2t") throw new T(2, 4, 4040);
                        if ("apple" === window1.shakaMediaKeysPolyfill) throw new T(2, 4, 4041);
                        g = qz(b, "METHOD");
                        h = [
                            "SAMPLE-AES",
                            "SAMPLE-AES-CTR"
                        ];
                        if (!h.includes(g)) return y.return(null);
                        k = xz(d(), qz(b, "URI"), f);
                        if (k[0].startsWith("data:text/plain;base64,")) {
                            l = sc(qc(k[0].split("data:text/plain;base64,").pop()));
                            y.B(2);
                            break;
                        }
                        m = k.sort().join("");
                        a.ua.has(m) || (n = mh(k, a.g.retryParameters), q = vA(a, n, 6).promise, a.ua.set(m, q));
                        return y.g(a.ua.get(m), 3);
                    case 3:
                        r = y.i, l = sc(r.data);
                    case 2:
                        t = "00000000000000000000000000000000";
                        if (!e) {
                            y.B(4);
                            break;
                        }
                        return y.g(pB(a, e), 5);
                    case 5:
                        (v = y.i) && (t = v);
                    case 4:
                        return w = new Map, w.set(t, l), x = "cenc", g == "SAMPLE-AES" && (x = "cbcs"), y.return(zc(w, x));
                }
            });
        }
        function pB(a, b) {
            var c, d, e, f;
            return H(function(g) {
                if (g.h == 1) {
                    c = null;
                    if (a.va.has(b)) return c = a.va.get(b), g.B(2);
                    d = jn(b.T(), b.Qc(), b.Oc(), a.g.retryParameters);
                    e = sh;
                    return g.g(vA(a, d, e, {
                        type: 0
                    }).promise, 3);
                }
                g.h != 2 && (f = g.i, b.He(f.data), c = dn(f.data), a.va.set(b, c));
                return g.return(c);
            });
        }
        O("shaka.hls.HlsParser", Jz);
        var tA = (new Map).set("aac", "audio/aac").set("ac3", "audio/ac3").set("ec3", "audio/ec3").set("mp3", "audio/mpeg"), qB = (new Map).set("mp4", "audio/mp4").set("mp4a", "audio/mp4").set("m4s", "audio/mp4").set("m4i", "audio/mp4").set("m4a", "audio/mp4").set("m4f", "audio/mp4").set("cmfa", "audio/mp4").set("ts", "video/mp2t").set("tsa", "video/mp2t"), rB = (new Map).set("mp4", "video/mp4").set("mp4v", "video/mp4").set("m4s", "video/mp4").set("m4i", "video/mp4").set("m4v", "video/mp4").set("m4f", "video/mp4").set("cmfv", "video/mp4").set("ts", "video/mp2t").set("tsv", "video/mp2t"), sB = (new Map).set("mp4", "application/mp4").set("m4s", "application/mp4").set("m4i", "application/mp4").set("m4f", "application/mp4").set("cmft", "application/mp4").set("vtt", "text/vtt").set("webvtt", "text/vtt").set("ttml", "application/ttml+xml"), tB = (new Map).set("jpg", "image/jpeg").set("png", "image/png").set("svg", "image/svg+xml").set("webp", "image/webp").set("avif", "image/avif"), mB = (new Map).set("audio", qB).set("video", rB).set("text", sB).set("image", tB), nB = new Set([
            "video/mp2t"
        ].concat(G(yf))), oB = [
            "application/octet-stream",
            "binary/octet-stream"
        ], Mz = "VOD", iB = "EVENT", wA = "LIVE";
        xd("application/x-mpegurl", function() {
            return new Jz;
        });
        xd("application/vnd.apple.mpegurl", function() {
            return new Jz;
        });
        xd("audio/x-mpegurl", function() {
            return new Jz;
        });
        function uB(a) {
            return mw(a);
        }
        var vB = (new Map).set("com.microsoft.playready", uB).set("com.microsoft.playready.recommendation", uB).set("com.microsoft.playready.software", uB).set("com.microsoft.playready.hardware", uB);
        function wB() {
            var a = this;
            this.h = this.g = null;
            this.l = [];
            this.j = null;
            this.A = 1;
            this.i = null;
            this.F = new Xc(5);
            this.o = new Uf(function() {
                xB(a);
            });
            this.D = new fh;
            this.m = new Map;
            this.C = function() {
                return !1;
            };
        }
        p = wB.prototype;
        p.configure = function(a, b) {
            this.g = a;
            b && (this.C = b);
        };
        p.start = function(a, b) {
            var c = this;
            return H(function(d) {
                if (d.h == 1) return c.l = [
                    a
                ], c.h = b, d.g(yB(c), 2);
                if (!c.h) throw new T(2, 7, 7001);
                return d.return(c.j);
            });
        };
        function xB(a) {
            var b;
            H(function(c) {
                switch(c.h){
                    case 1:
                        return c.m(2), c.g(yB(a), 4);
                    case 4:
                        c.o(3);
                        break;
                    case 2:
                        b = c.l(), a.h && (b.severity = 1, a.h.onError(b));
                    case 3:
                        if (!a.h) return c.return();
                        c.j();
                }
            });
        }
        p.stop = function() {
            this.g = this.h = null;
            this.l = [];
            this.j = null;
            this.o != null && (this.o.stop(), this.o = null);
            this.m.clear();
            return this.D.destroy();
        };
        p.update = function() {
            var a = this, b;
            return H(function(c) {
                if (c.h == 1) return c.m(2), c.g(yB(a), 4);
                if (c.h != 2) return c.o(0);
                b = c.l();
                if (!a.h || !b) return c.return();
                a.h.onError(b);
                c.j();
            });
        };
        p.onExpirationUpdated = function() {};
        p.onInitialVariantChosen = function() {};
        p.banLocation = function() {};
        p.setMediaElement = function() {};
        function yB(a) {
            var b, c, d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) return b = mh(a.l, a.g.retryParameters), c = a.h.networkingEngine, d = Date.now(), e = c.request(0, b, {
                    type: 5,
                    isPreload: a.C()
                }), gh(a.D, e), k.g(e.promise, 2);
                f = k.i;
                if (!a.h) return k.return();
                f.uri && !a.l.includes(f.uri) && a.l.unshift(f.uri);
                var l = f.uri, m = f.data, n = a.g.mss.manifestPreprocessor;
                if (n != Ao) {
                    md("manifest.mss.manifestPreprocessor configuration", "Please Use manifest.mss.manifestPreprocessorTXml instead.");
                    m = fy(m, "SmoothStreamingMedia");
                    if (!m) throw new T(2, 4, 4046, l);
                    n(m);
                    m = hc(m.outerHTML);
                }
                var q = $d(m, "SmoothStreamingMedia");
                if (!q) throw new T(2, 4, 4046, l);
                l = a.g.mss.manifestPreprocessorTXml;
                l != Bo && l(q);
                a.i || (a.i = new Wl(null, 0));
                if (l = qe(q, "IsLive", Ae, !1)) throw new T(2, 4, 4047);
                a.i.md(!l);
                n = qe(q, "TimeScale", ye, 1E7);
                m = qe(q, "DVRWindowLength", ye);
                l && (m === 0 || isNaN(m)) && (m = Infinity);
                var r = qe(q, "CanSeek", Ae, !1);
                m === 0 && r && (m = Infinity);
                r = null;
                m && m > 0 && (r = m / n);
                l && !isNaN(a.g.availabilityWindowOverride) && (r = a.g.availabilityWindowOverride);
                r == null && (r = Infinity);
                a.i.ig(r);
                m = qe(q, "Duration", ye, Infinity);
                l || a.i.Ab(m / n);
                l = {
                    variants: [],
                    textStreams: [],
                    timescale: n,
                    duration: m / n
                };
                var t;
                r = ie(q, "Protection");
                n = a.g.mss.keySystemsBySystemId;
                m = [];
                r = u(r);
                for(t = r.next(); !t.done; t = r.next())m = m.concat(ie(t.value, "ProtectionHeader"));
                if (m.length) {
                    r = [];
                    for(t = 0; t < m.length; t++){
                        var v = m[t], w = v.attributes.SystemID.toLowerCase(), x = n[w];
                        if (x) {
                            var y;
                            a: {
                                if (y = kw(v)) {
                                    y = u(me(y, "DATA"));
                                    for(var z = y.next(); !z.done; z = y.next())if (z = ne(z.value, "KID")) {
                                        y = qc(ke(z));
                                        y = new Uint8Array([
                                            y[3],
                                            y[2],
                                            y[1],
                                            y[0],
                                            y[5],
                                            y[4],
                                            y[7],
                                            y[6]
                                        ].concat(G(y.slice(8))));
                                        y = sc(y);
                                        break a;
                                    }
                                }
                                y = null;
                            }
                            z = qc(ke(v));
                            w = rc(w.replace(/-/g, ""));
                            w = [
                                {
                                    initData: Nh(z, w, new Set, 0),
                                    initDataType: "cenc",
                                    keyId: y
                                }
                            ];
                            w = yc(x, "cenc", w);
                            y && w.keyIds.add(y);
                            if (x = vB.get(x)) w.licenseServerUri = x(v);
                            r.push(w);
                        }
                    }
                    n = r;
                } else n = [];
                t = n;
                r = [];
                n = [];
                m = [];
                q = ie(q, "StreamIndex");
                q = u(q);
                for(v = q.next(); !v.done; v = q.next()){
                    v = v.value;
                    x = ie(v, "QualityLevel");
                    w = l.timescale;
                    y = l.duration;
                    z = ie(v, "c");
                    for(var A = [], E = 0, C = 0; C < z.length; ++C){
                        var D = z[C], B = z[C + 1], J = qe(D, "t", ye), F = qe(D, "d", ye);
                        D = qe(D, "r", we);
                        if (!F) break;
                        J = J != null ? J : E;
                        (D = D || 0) && D--;
                        if (D < 0) {
                            if (B) {
                                B = qe(B, "t", ye);
                                if (B == null) break;
                                else if (J >= B) break;
                                D = Math.ceil((B - J) / F) - 1;
                            } else {
                                if (y == Infinity) break;
                                else if (J / w >= y) break;
                                D = Math.ceil((y * w - J) / F) - 1;
                            }
                        }
                        for(B = 0; B <= D; ++B)E = J + F, A.push({
                            start: J / w,
                            end: E / w,
                            $d: J
                        }), J = E;
                    }
                    w = A;
                    x = u(x);
                    for(y = x.next(); !y.done; y = x.next())(y = zB(a, v, y.value, w, t, l)) && (y.type != "audio" || a.g.disableAudio ? y.type != "video" || a.g.disableVideo ? y.type != Ec || a.g.disableText || m.push(y) : n.push(y) : r.push(y));
                }
                q = [];
                r = u(r.length > 0 ? r : [
                    null
                ]);
                for(t = r.next(); !t.done; t = r.next())for(t = t.value, v = u(n.length > 0 ? n : [
                    null
                ]), A = v.next(); !A.done; A = v.next())x = q, w = x.push, y = a, z = t, A = A.value, C = 0, z && z.bandwidth && z.bandwidth > 0 && (C += z.bandwidth), A && A.bandwidth && A.bandwidth > 0 && (C += A.bandwidth), y = {
                    id: y.A++,
                    language: z ? z.language : "und",
                    disabledUntilTime: 0,
                    primary: !!z && z.primary || !!A && A.primary,
                    audio: z,
                    video: A,
                    bandwidth: C,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                }, w.call(x, y);
                l.variants = q;
                l.textStreams = m;
                a.j ? (a.j.variants = l.variants, a.j.textStreams = l.textStreams, a.h.filter(a.j)) : (a.j = {
                    presentationTimeline: a.i,
                    variants: l.variants,
                    textStreams: l.textStreams,
                    imageStreams: [],
                    offlineSessionIds: [],
                    sequenceMode: a.g.mss.sequenceMode,
                    ignoreManifestTimestampsInSegmentsMode: !1,
                    type: "MSS",
                    serviceDescription: null,
                    nextUrl: null,
                    periodCount: 1,
                    gapCount: 0,
                    isLowLatency: !1,
                    startTime: null
                }, a.i.Mf());
                Promise.resolve();
                g = Date.now();
                h = (g - d) / 1E3;
                a.F.sample(1, h);
                k.j();
            });
        }
        function zB(a, b, c, d, e, f) {
            var g = b.attributes.Type;
            if (g !== "audio" && g !== "video" && g !== "text") return Za("Ignoring unrecognized type:", g), null;
            var h = b.attributes.Language, k = a.A++, l = qe(c, "Bitrate", xe), m = qe(c, "MaxWidth", xe), n = qe(c, "MaxHeight", xe), q = qe(c, "Channels", xe), r = qe(c, "SamplingRate", xe), t = f.duration;
            d.length && (t = d[d.length - 1].end - d[0].start);
            var v = a.i.getDuration();
            a.i.Ab(Math.min(t, v));
            (v = b.attributes.Name) && (v += c.attributes.Index);
            v || (v = String(k));
            var w = {
                id: k,
                originalId: v,
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                closeSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: null,
                mimeType: "",
                codecs: "",
                frameRate: void 0,
                pixelAspectRatio: void 0,
                bandwidth: l || 0,
                width: m || void 0,
                height: n || void 0,
                kind: "",
                encrypted: e.length > 0,
                drmInfos: e,
                keyIds: new Set,
                language: Kc(h || "und"),
                originalLanguage: h,
                label: "",
                type: "",
                primary: !1,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: [],
                roles: [],
                forced: !1,
                channelsCount: q,
                audioSamplingRate: r,
                spatialAudio: !1,
                closedCaptions: null,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                tilesLayout: void 0,
                matchedStreams: [],
                mssPrivateData: {
                    duration: t,
                    timescale: f.timescale,
                    codecPrivateData: null
                },
                accessibilityPurpose: null,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
            if (e = b.attributes.Subtype) (e = AB.get(e)) && w.roles.push(e), e === "main" && (w.primary = !0);
            e = c.attributes.FourCC;
            if (e === null || e === "") e = b.attributes.FourCC;
            if (!e) {
                if (g === "audio") e = "AAC";
                else if (g === "video") return Za('FourCC is not defined whereas it is required for a QualityLevel element for a StreamIndex of type "video"'), null;
            }
            if (!BB.includes(e.toUpperCase())) return Za("Codec not supported:", e), null;
            c = CB(c, g, e, w);
            w.mssPrivateData.codecPrivateData = c;
            switch(g){
                case "audio":
                    if (!c) return Za("Quality unsupported without CodecPrivateData", g), null;
                    w.type = "audio";
                    w.mimeType = "mss/audio/mp4";
                    w.codecs = DB(e, c);
                    break;
                case "video":
                    if (!c) return Za("Quality unsupported without CodecPrivateData", g), null;
                    w.type = "video";
                    w.mimeType = "mss/video/mp4";
                    w.codecs = EB(c);
                    break;
                case "text":
                    if (w.type = Ec, w.mimeType = "application/mp4", e === "TTML" || e === "DFXP") w.codecs = "stpp";
            }
            w.fullMimeTypes.add(wf(w.mimeType, w.codecs));
            w.createSegmentIndex = function() {
                if (w.segmentIndex) return Promise.resolve();
                if (a.m.has(w.id)) var x = a.m.get(w.id);
                else x = [], w.type == "video" && (x = w.mssPrivateData.codecPrivateData.split("00000001").slice(1)), x = {
                    id: w.id,
                    type: w.type,
                    codecs: w.codecs,
                    encrypted: w.encrypted,
                    timescale: w.mssPrivateData.timescale,
                    duration: w.mssPrivateData.duration,
                    Cb: x,
                    Ha: new Uint8Array([]),
                    Za: new Uint8Array([]),
                    fb: 0,
                    gb: 0,
                    data: null,
                    stream: w
                }, x = ej(new dj([
                    x
                ])), a.m.set(w.id, x);
                x = FB(a, new Mj(function() {
                    return [];
                }, 0, null, Km(w), w.mssPrivateData.timescale, x, null, w.encrypted), w, b, d);
                w.segmentIndex = new vm(x);
                return Promise.resolve();
            };
            w.closeSegmentIndex = function() {
                w.segmentIndex && (w.segmentIndex.release(), w.segmentIndex = null);
            };
            return w;
        }
        function CB(a, b, c, d) {
            if (a = a.attributes.CodecPrivateData) return a;
            if (b !== "audio") return null;
            b = d.channelsCount || 2;
            a = d.audioSamplingRate || 44100;
            var e = {
                96E3: 0,
                88200: 1,
                64E3: 2,
                48E3: 3,
                44100: 4,
                32E3: 5,
                24E3: 6,
                22050: 7,
                16E3: 8,
                12E3: 9,
                11025: 10,
                8E3: 11,
                7350: 12
            };
            d = e[a];
            if (c === "AACH") return c = new Uint8Array(4), a = e[a * 2], c[0] = 40 | d >> 1, c[1] = d << 7 | b << 3 | a >> 1, c[2] = a << 7 | 8, c[3] = 0, b = new Uint16Array(2), b[0] = (c[0] << 8) + c[1], b[1] = (c[2] << 8) + c[3], b[0].toString(16) + b[1].toString(16);
            c = new Uint8Array(2);
            c[0] = 16 | d >> 1;
            c[1] = d << 7 | b << 3;
            b = new Uint16Array(1);
            b[0] = (c[0] << 8) + c[1];
            return b[0].toString(16);
        }
        function DB(a, b) {
            var c = 0;
            a === "AACH" && (c = 5);
            b ? c === 0 && (c = (parseInt(b.substr(0, 2), 16) & 248) >> 3) : (c = 2, a === "AACH" && (c = 5));
            return "mp4a.40." + c;
        }
        function EB(a) {
            var b = /00000001[0-9]7/.exec(a);
            return b.length && a ? "avc1." + a.substr(a.indexOf(b[0]) + 10, 6) : "";
        }
        function FB(a, b, c, d, e) {
            var f = d.attributes.Url.replace("{bitrate}", String(c.bandwidth));
            d = [];
            e = u(e);
            for(var g = e.next(), h = {}; !g.done; h = {
                og: void 0
            }, g = e.next())h.og = g.value, d.push(new Oj(h.og.start, h.og.end, function(k) {
                return function() {
                    return vc(a.l, [
                        f.replace("{start time}", String(k.og.$d))
                    ]);
                };
            }(h), 0, null, b, 0, 0, c.mssPrivateData.duration));
            return d;
        }
        O("shaka.mss.MssParser", wB);
        var BB = "AAC AACL AACH AACP AVC1 H264 TTML DFXP".split(" "), AB = (new Map).set("CAPT", "main").set("SUBT", "alternate").set("DESC", "main");
        xd("application/vnd.ms-sstr+xml", function() {
            return new wB;
        });
        function GB(a, b, c, d, e, f, g) {
            if (c >= 200 && c <= 299 && c != 202 || c == 304) return {
                uri: e || d,
                originalUri: d,
                data: b,
                status: c,
                headers: a,
                fromCache: !!a["x-shaka-from-cache"],
                originalRequest: f
            };
            f = null;
            try {
                f = ec(b);
            } catch (h) {}
            throw new T(c == 401 || c == 403 ? 2 : 1, 1, 1001, d, c, f, a, g, e || d);
        }
        function HB() {}
        function IB(a, b, c, d, e, f) {
            var g = new JB;
            try {
                wh(b.headers).forEach(function(m, n) {
                    g.append(n, m);
                });
            } catch (m) {
                return $g(new T(1, 1, 1002, a, m, c));
            }
            var h = new KB, k = {
                Oi: !1,
                ek: !1
            };
            a = LB(a, b, c, {
                body: b.body || void 0,
                headers: g,
                method: b.method,
                signal: h.signal,
                credentials: b.allowCrossSiteCredentials ? "include" : void 0
            }, k, d, e, b.streamDataCallback, f.minBytesForProgressEvents || 0);
            a = new Zg(a, function() {
                k.Oi = !0;
                h.abort();
                return Promise.resolve();
            });
            if (b = b.retryParameters.timeout) {
                var l = new Uf(function() {
                    k.ek = !0;
                    h.abort();
                });
                l.Z(b / 1E3);
                a.finally(function() {
                    l.stop();
                });
            }
            return a;
        }
        function LB(a, b, c, d, e, f, g, h, k) {
            var l, m, n, q, r, t, v, w, x, y, z, A, E, C, D;
            return H(function(B) {
                switch(B.h){
                    case 1:
                        return l = MB, m = NB, q = new ArrayBuffer(0), t = r = 0, v = {}, w = Date.now(), B.m(2), B.g(l(a, d), 4);
                    case 4:
                        n = B.i;
                        v = OB(n.headers);
                        g(v);
                        if (d.method == "HEAD") {
                            B.B(5);
                            break;
                        }
                        y = (x = n.headers.get("Content-Length")) ? parseInt(x, 10) : 0;
                        if (!n.body) return B.g(n.arrayBuffer(), 9);
                        z = n.clone().body.getReader();
                        A = function(J) {
                            function F() {
                                var I, K, N, P;
                                return H(function(M) {
                                    switch(M.h){
                                        case 1:
                                            return M.m(2), M.g(z.read(), 4);
                                        case 4:
                                            I = M.i;
                                            M.o(3);
                                            break;
                                        case 2:
                                            return M.l(), M.return();
                                        case 3:
                                            if (I.done) {
                                                M.B(5);
                                                break;
                                            }
                                            r += I.value.byteLength;
                                            if (!h) {
                                                M.B(5);
                                                break;
                                            }
                                            return M.g(h(I.value), 5);
                                        case 5:
                                            K = Date.now();
                                            N = r - t;
                                            if (K - w > 100 && N >= k || I.done) P = I.done ? 0 : y - r, f(K - w, N, P), t = r, w = K;
                                            I.done ? J.close() : (J.enqueue(I.value), F());
                                            M.j();
                                    }
                                });
                            }
                            F();
                        };
                        new m({
                            start: A
                        });
                        return B.g(n.arrayBuffer(), 8);
                    case 8:
                        q = B.i;
                        B.B(5);
                        break;
                    case 9:
                        q = B.i, E = Date.now(), f(E - w, q.byteLength, 0);
                    case 5:
                        b.headers.Range && (C = b.headers.Range.replace("bytes=", "").split("-").filter(function(J) {
                            return J;
                        }).map(function(J) {
                            return parseInt(J, 10);
                        }), C.length == 2 && q.byteLength != C[1] - C[0] + 1 && Za("Payload length does not match range requested bytes", b, n));
                        B.o(3);
                        break;
                    case 2:
                        D = B.l();
                        if (e.Oi) throw new T(1, 1, 7001, a, c);
                        if (e.ek) throw new T(1, 1, 1003, a, c);
                        throw new T(1, 1, 1002, a, D, c);
                    case 3:
                        return B.return(GB(v, q, n.status, a, n.url, b, c));
                }
            });
        }
        function OB(a) {
            var b = {};
            a.forEach(function(c, d) {
                b[d.trim()] = c;
            });
            return b;
        }
        function PB() {
            if (window1.ReadableStream) try {
                new ReadableStream({});
            } catch (a) {
                return !1;
            }
            else return !1;
            if (window1.Response) {
                if (!new Response("").body) return !1;
            } else return !1;
            return !(!window1.fetch || "polyfill" in window1.fetch || !window1.AbortController);
        }
        O("shaka.net.HttpFetchPlugin", HB);
        HB.isSupported = PB;
        HB.parse = IB;
        var MB = window1.fetch, KB = window1.AbortController, NB = window1.ReadableStream, JB = window1.Headers;
        PB() && (ih("http", IB, 2, !0), ih("https", IB, 2, !0), ih("blob", IB, 2, !0));
        function QB() {}
        function RB(a, b, c, d, e, f) {
            var g = new SB, h = Date.now(), k = 0, l = new Promise(function(m, n) {
                g.open(b.method, a, !0);
                g.responseType = "arraybuffer";
                g.timeout = b.retryParameters.timeout;
                g.withCredentials = b.allowCrossSiteCredentials;
                var q = {};
                g.onabort = function() {
                    n(new T(1, 1, 7001, a, c));
                };
                g.onreadystatechange = function() {
                    if (g.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
                        var t = g.getAllResponseHeaders().trim().split("\r\n"), v = {};
                        t = u(t);
                        for(var w = t.next(); !w.done; w = t.next()){
                            w = w.value;
                            var x = w.indexOf(": ");
                            x !== -1 && (v[w.slice(0, x).toLowerCase()] = w.slice(x + 2));
                        }
                        q = v;
                        e(q);
                    }
                };
                g.onload = function() {
                    var t = g.response;
                    try {
                        var v = GB(q, t, g.status, a, g.responseURL, b, c);
                        m(v);
                    } catch (w) {
                        n(w);
                    }
                };
                g.onerror = function(t) {
                    n(new T(1, 1, 1002, a, t, c));
                };
                g.ontimeout = function() {
                    n(new T(1, 1, 1003, a, c));
                };
                g.onprogress = function(t) {
                    var v = Date.now(), w = f.minBytesForProgressEvents || 0, x = t.loaded - k;
                    if (v - h > 100 && x >= w || t.lengthComputable && t.loaded == t.total) d(v - h, x, g.readyState == 4 ? 0 : t.total - t.loaded), k = t.loaded, h = v;
                };
                for(var r in b.headers)try {
                    g.setRequestHeader(r.toLowerCase(), b.headers[r]);
                } catch (t) {
                    throw new T(1, 1, 1002, a, t, c);
                }
                g.send(b.body);
            });
            return new Zg(l, function() {
                g.abort();
                return Promise.resolve();
            });
        }
        O("shaka.net.HttpXHRPlugin", QB);
        QB.parse = RB;
        var SB = window1.XMLHttpRequest;
        ih("http", RB, 1, !0);
        ih("https", RB, 1, !0);
        ih("blob", RB, 1, !0);
        function TB(a, b, c, d, e) {
            this.g = a;
            this.i = b;
            this.groupId = c;
            this.h = d;
            this.j = e;
        }
        function UB(a) {
            var b = a.dc(!1);
            return b ? mc(b) : a.T().map(function(c) {
                return "{" + encodeURI(c.split("#xywh=")[0]) + "}";
            }).join("") + ":" + a.startByte + ":" + a.endByte;
        }
        function VB(a, b) {
            return jn(a.g.T(), a.g.startByte, a.g.endByte, b.streaming.retryParameters);
        }
        function WB() {
            this.g = this.j = this.i = 0;
            this.h = new Map;
            this.l = 0;
        }
        function XB(a, b) {
            a.i += b;
            var c = a.l;
            a.l++;
            a.h.set(c, b);
            return c;
        }
        WB.prototype.close = function(a, b) {
            if (this.h.has(a)) {
                var c = this.h.get(a);
                this.h.delete(a);
                this.j += c;
                this.g += b;
            }
        };
        function YB(a) {
            return a.i == 0 ? 0 : a.j / a.i;
        }
        function ZB(a) {
            var b = this;
            this.A = a;
            this.i = new Map;
            this.h = new uh(function() {
                return $B(b).catch(function() {});
            });
            this.j = [];
            this.o = function() {};
            this.m = function() {};
            this.g = new WB;
            this.l = !1;
        }
        ZB.prototype.destroy = function() {
            return this.h.destroy();
        };
        function aC(a, b, c) {
            a.o = b;
            a.m = c;
        }
        function $B(a) {
            a.l = !0;
            var b = a.j.map(function(c) {
                return c();
            });
            a.j = [];
            return Promise.all(b);
        }
        ZB.prototype.queue = function(a, b, c, d, e) {
            var f = this;
            vh(this.h);
            var g = (this.i.get(a) || Promise.resolve()).then(function() {
                var h, k, l, m, n, q, r;
                return H(function(t) {
                    if (t.h == 1) return t.g(bC(f, b), 2);
                    h = t.i;
                    if (f.h.g) throw new T(2, 9, 7001);
                    if (d) for(m in k = Fb(h), l = new Mh(k), l.data)n = Number(m), q = l.data[n], r = l.g[n], f.m(q, r);
                    f.g.close(c, h.byteLength);
                    f.o(YB(f.g), f.g.g);
                    return t.return(e(h));
                });
            });
            this.i.set(a, g);
            return g;
        };
        function cC(a, b, c, d, e, f) {
            vh(a.h);
            var g = (a.i.get(b) || Promise.resolve()).then(function() {
                if (a.h.g) throw new T(2, 9, 7001);
                if (e) {
                    var h = Fb(c);
                    h = new Mh(h);
                    for(var k in h.data){
                        var l = Number(k);
                        a.m(h.data[l], h.g[l]);
                    }
                }
                a.g.close(d, c.byteLength);
                a.o(YB(a.g), a.g.g);
                return f(c);
            });
            a.i.set(b, g);
        }
        function dC(a) {
            return H(function(b) {
                return b.h == 1 ? b.g(Promise.all(a.i.values()), 2) : b.return(a.g.g);
            });
        }
        function bC(a, b) {
            var c, d, e, f;
            return H(function(g) {
                if (g.h == 1) return c = sh, d = a.A.request(c, b), e = function() {
                    return d.abort();
                }, a.j.push(e), g.g(d.promise, 2);
                f = g.i;
                ad(a.j, e);
                return g.return(f.data);
            });
        }
        function eC(a, b) {
            var c = this;
            this.i = a;
            this.h = a.objectStore(b);
            this.g = new Yg;
            a.onabort = function(d) {
                d.preventDefault();
                c.g.reject();
            };
            a.onerror = function(d) {
                d.preventDefault();
                c.g.reject();
            };
            a.oncomplete = function() {
                c.g.resolve();
            };
        }
        eC.prototype.abort = function() {
            var a = this;
            return H(function(b) {
                if (b.h == 1) {
                    try {
                        a.i.abort();
                    } catch (c) {}
                    b.m(2);
                    return b.g(a.g, 4);
                }
                if (b.h != 2) return b.o(0);
                b.l();
                b.j();
            });
        };
        function fC(a, b) {
            return new Promise(function(c, d) {
                var e = a.h.openCursor();
                e.onerror = d;
                e.onsuccess = function() {
                    var f;
                    return H(function(g) {
                        if (g.h == 1) {
                            if (e.result == null) return c(), g.return();
                            f = e.result;
                            return g.g(b(f.key, f.value, f), 2);
                        }
                        f.continue();
                        g.j();
                    });
                };
            });
        }
        eC.prototype.store = function() {
            return this.h;
        };
        eC.prototype.promise = function() {
            return this.g;
        };
        function gC(a) {
            this.h = a;
            this.g = [];
        }
        gC.prototype.destroy = function() {
            return Promise.all(this.g.map(function(a) {
                return a.abort();
            }));
        };
        function hC(a, b) {
            return iC(a, b, "readwrite");
        }
        function iC(a, b, c) {
            c = a.h.transaction([
                b
            ], c);
            var d = new eC(c, b);
            a.g.push(d);
            d.promise().then(function() {
                ad(a.g, d);
            }, function() {
                ad(a.g, d);
            });
            return d;
        }
        function jC(a, b, c) {
            this.h = new gC(a);
            this.i = b;
            this.g = c;
        }
        p = jC.prototype;
        p.destroy = function() {
            return this.h.destroy();
        };
        p.hasFixedKeySpace = function() {
            return !0;
        };
        p.addSegments = function() {
            return kC(this.i);
        };
        p.removeSegments = function(a, b) {
            return lC(this, this.i, a, b);
        };
        p.getSegments = function(a) {
            var b = this, c;
            return H(function(d) {
                if (d.h == 1) return d.g(mC(b, b.i, a), 2);
                c = d.i;
                return d.return(c.map(function(e) {
                    return b.Si(e);
                }));
            });
        };
        p.addManifests = function() {
            return kC(this.g);
        };
        p.updateManifest = function() {
            return Promise.reject(new T(2, 9, 9016, "Cannot modify values in " + this.g));
        };
        function nC(a, b, c) {
            a = hC(a.h, a.g);
            var d = a.store();
            d.get(b).onsuccess = function() {
                d.put(c, b);
            };
            return a.promise();
        }
        p.updateManifestExpiration = function(a, b) {
            var c = hC(this.h, this.g), d = c.store();
            d.get(a).onsuccess = function(e) {
                if (e = e.target.result) e.expiration = b, d.put(e, a);
            };
            return c.promise();
        };
        p.removeManifests = function(a, b) {
            return lC(this, this.g, a, b);
        };
        p.getManifests = function(a) {
            var b = this, c;
            return H(function(d) {
                if (d.h == 1) return d.g(mC(b, b.g, a), 2);
                c = d.i;
                return d.return(Promise.all(c.map(function(e) {
                    return b.ie(e);
                })));
            });
        };
        p.getAllManifests = function() {
            var a = this, b, c;
            return H(function(d) {
                return d.h == 1 ? (b = iC(a.h, a.g, "readonly"), c = new Map, d.g(fC(b, function(e, f) {
                    var g;
                    return H(function(h) {
                        if (h.h == 1) return h.g(a.ie(f), 2);
                        g = h.i;
                        c.set(e, g);
                        h.j();
                    });
                }), 2)) : d.h != 3 ? d.g(b.promise(), 3) : d.return(c);
            });
        };
        p.Si = function(a) {
            return a;
        };
        p.ie = function(a) {
            return Promise.resolve(a);
        };
        function kC(a) {
            return Promise.reject(new T(2, 9, 9011, "Cannot add new value to " + a));
        }
        p.add = function(a, b) {
            var c = this, d, e, f, g, h, k, l;
            return H(function(m) {
                if (m.h == 1) {
                    d = hC(c.h, a);
                    e = d.store();
                    f = [];
                    g = u(b);
                    h = g.next();
                    for(k = {}; !h.done; k = {
                        Zh: void 0
                    }, h = g.next())l = h.value, k.Zh = e.add(l), k.Zh.onsuccess = function(n) {
                        return function() {
                            f.push(n.Zh.result);
                        };
                    }(k);
                    return m.g(d.promise(), 2);
                }
                return m.return(f);
            });
        };
        function lC(a, b, c, d) {
            a = hC(a.h, b);
            b = a.store();
            c = u(c);
            for(var e = c.next(), f = {}; !e.done; f = {
                Lh: void 0
            }, e = c.next())f.Lh = e.value, b.delete(f.Lh).onsuccess = function(g) {
                return function() {
                    return d(g.Lh);
                };
            }(f);
            return a.promise();
        }
        function mC(a, b, c) {
            var d, e, f, g, h, k, l;
            return H(function(m) {
                if (m.h == 1) {
                    d = iC(a.h, b, "readonly");
                    e = d.store();
                    f = {};
                    g = [];
                    h = u(c);
                    k = h.next();
                    for(l = {}; !k.done; l = {
                        ag: void 0,
                        If: void 0
                    }, k = h.next())l.If = k.value, l.ag = e.get(l.If), l.ag.onsuccess = function(n) {
                        return function() {
                            n.ag.result == void 0 && g.push(n.If);
                            f[n.If] = n.ag.result;
                        };
                    }(l);
                    return m.g(d.promise(), 2);
                }
                if (g.length) throw new T(2, 9, 9012, "Could not find values for " + g);
                return m.return(c.map(function(n) {
                    return f[n];
                }));
            });
        }
        function oC(a) {
            this.g = new gC(a);
        }
        oC.prototype.destroy = function() {
            return this.g.destroy();
        };
        oC.prototype.getAll = function() {
            var a = this, b, c;
            return H(function(d) {
                return d.h == 1 ? (b = iC(a.g, "session-ids", "readonly"), c = [], d.g(fC(b, function(e, f) {
                    c.push(f);
                }), 2)) : d.h != 3 ? d.g(b.promise(), 3) : d.return(c);
            });
        };
        oC.prototype.add = function(a) {
            var b = hC(this.g, "session-ids"), c = b.store();
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())c.add(d.value);
            return b.promise();
        };
        oC.prototype.remove = function(a) {
            var b = this, c;
            return H(function(d) {
                return d.h == 1 ? (c = hC(b.g, "session-ids"), d.g(fC(c, function(e, f, g) {
                    a.includes(f.sessionId) && g.delete();
                }), 2)) : d.g(c.promise(), 0);
            });
        };
        function pC() {
            this.g = new Map;
        }
        pC.prototype.destroy = function() {
            for(var a = [], b = u(this.g.values()), c = b.next(); !c.done; c = b.next())a.push(c.value.destroy());
            this.g.clear();
            return Promise.all(a);
        };
        pC.prototype.init = function() {
            var a = this;
            qC.forEach(function(e, f) {
                (e = e()) && a.g.set(f, e);
            });
            for(var b = [], c = u(this.g.values()), d = c.next(); !d.done; d = c.next())b.push(d.value.init());
            return Promise.all(b);
        };
        function rC(a) {
            var b = null;
            a.g.forEach(function(c, d) {
                c.getCells().forEach(function(e, f) {
                    e.hasFixedKeySpace() || b || (b = {
                        path: {
                            Tb: d,
                            mb: f
                        },
                        mb: e
                    });
                });
            });
            if (b) return b;
            throw new T(2, 9, 9013, "Could not find a cell that supports add-operations");
        }
        function sC(a, b) {
            a.g.forEach(function(c, d) {
                c.getCells().forEach(function(e, f) {
                    b({
                        Tb: d,
                        mb: f
                    }, e);
                });
            });
        }
        function tC(a, b, c) {
            a = a.g.get(b);
            if (!a) throw new T(2, 9, 9013, "Could not find mechanism with name " + b);
            b = a.getCells().get(c);
            if (!b) throw new T(2, 9, 9013, "Could not find cell with name " + c);
            return b;
        }
        function uC(a, b) {
            a.g.forEach(function(c) {
                b(c.getEmeSessionCell());
            });
        }
        function vC(a) {
            var b = Array.from(a.g.keys());
            if (!b.length) throw new T(2, 9, 9E3, "No supported storage mechanisms found");
            return a.g.get(b[0]).getEmeSessionCell();
        }
        function wC(a) {
            var b, c, d;
            return H(function(e) {
                return e.h == 1 ? (b = Array.from(a.g.values()), c = b.length > 0, c || (d = qC, d.forEach(function(f) {
                    (f = f()) && b.push(f);
                })), e.g(Promise.all(b.map(function(f) {
                    return f.erase();
                })), 2)) : c ? e.B(0) : e.g(Promise.all(b.map(function(f) {
                    return f.destroy();
                })), 0);
            });
        }
        function xC(a, b) {
            qC.set(a, b);
        }
        O("shaka.offline.StorageMuxer", pC);
        pC.unregister = function(a) {
            qC.delete(a);
        };
        pC.register = xC;
        pC.prototype.destroy = pC.prototype.destroy;
        var qC = new Map;
        function yC() {
            jC.apply(this, arguments);
        }
        oa(yC, jC);
        yC.prototype.updateManifestExpiration = function(a, b) {
            var c = this, d, e, f;
            return H(function(g) {
                d = hC(c.h, c.g);
                e = d.store();
                f = new Yg;
                e.get(a).onsuccess = function(h) {
                    (h = h.target.result) ? (h.expiration = b, e.put(h), f.resolve()) : f.reject(new T(2, 9, 9012, "Could not find values for " + a));
                };
                return g.g(Promise.all([
                    d.promise(),
                    f
                ]), 0);
            });
        };
        yC.prototype.ie = function(a) {
            var b, c, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) {
                    b = [];
                    for(c = 0; c < a.periods.length; ++c)d = c == a.periods.length - 1 ? a.duration : a.periods[c + 1].startTime, e = d - a.periods[c].startTime, f = zC(a.periods[c], e), b.push(f);
                    return h.g(Cx(b), 2);
                }
                g = h.i;
                return h.return({
                    creationTime: 0,
                    originalManifestUri: a.originalManifestUri,
                    duration: a.duration,
                    size: a.size,
                    expiration: a.expiration == null ? Infinity : a.expiration,
                    streams: g,
                    sessionIds: a.sessionIds,
                    drmInfo: a.drmInfo,
                    appMetadata: a.appMetadata,
                    sequenceMode: !1
                });
            });
        };
        function zC(a, b) {
            AC(a);
            for(var c = u(a.streams), d = c.next(); !d.done; d = c.next());
            return a.streams.map(function(e) {
                return BC(e, a.startTime, b);
            });
        }
        function BC(a, b, c) {
            var d = a.initSegmentUri ? CC(a.initSegmentUri) : null, e = b + a.presentationTimeOffset, f = b + c;
            return {
                id: a.id,
                originalId: null,
                groupId: null,
                primary: a.primary,
                type: a.contentType,
                mimeType: a.mimeType,
                codecs: a.codecs,
                frameRate: a.frameRate,
                pixelAspectRatio: void 0,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                kind: a.kind,
                language: a.language,
                originalLanguage: a.language || null,
                label: a.label,
                width: a.width,
                height: a.height,
                initSegmentKey: d,
                encrypted: a.encrypted,
                keyIds: new Set([
                    a.keyId
                ]),
                segments: a.segments.map(function(g) {
                    var h = CC(g.uri);
                    return {
                        startTime: b + g.startTime,
                        endTime: b + g.endTime,
                        dataKey: h,
                        initSegmentKey: d,
                        appendWindowStart: b,
                        appendWindowEnd: f,
                        timestampOffset: e,
                        tilesLayout: "",
                        mimeType: null,
                        codecs: null,
                        thumbnailSprite: null
                    };
                }),
                variantIds: a.variantIds,
                roles: [],
                forced: !1,
                audioSamplingRate: null,
                channelsCount: null,
                spatialAudio: !1,
                closedCaptions: null,
                tilesLayout: void 0,
                external: !1,
                fastSwitching: !1,
                isAudioMuxedInVideo: !1
            };
        }
        yC.prototype.Si = function(a) {
            return {
                data: a.data
            };
        };
        function CC(a) {
            var b;
            if ((b = /^offline:[0-9]+\/[0-9]+\/([0-9]+)$/.exec(a)) || (b = /^offline:segment\/([0-9]+)$/.exec(a))) return Number(b[1]);
            throw new T(2, 9, 9004, "Could not parse uri " + a);
        }
        function AC(a) {
            var b = a.streams.filter(function(h) {
                return h.contentType == "audio";
            });
            a = a.streams.filter(function(h) {
                return h.contentType == "video";
            });
            if (!b.every(function(h) {
                return h.variantIds;
            }) || !a.every(function(h) {
                return h.variantIds;
            })) {
                for(var c = u(b), d = c.next(); !d.done; d = c.next())d.value.variantIds = [];
                c = u(a);
                for(d = c.next(); !d.done; d = c.next())d.value.variantIds = [];
                c = 0;
                if (a.length && !b.length) {
                    d = c++;
                    for(var e = u(a), f = e.next(); !f.done; f = e.next())f.value.variantIds.push(d);
                }
                if (!a.length && b.length) for(d = c++, e = u(b), f = e.next(); !f.done; f = e.next())f.value.variantIds.push(d);
                if (a.length && b.length) for(b = u(b), d = b.next(); !d.done; d = b.next())for(d = d.value, e = u(a), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    var g = c++;
                    d.variantIds.push(g);
                    f.variantIds.push(g);
                }
            }
        }
        function DC() {
            jC.apply(this, arguments);
        }
        oa(DC, jC);
        DC.prototype.ie = function(a) {
            var b, c, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) {
                    b = [];
                    for(c = 0; c < a.periods.length; ++c){
                        d = c == a.periods.length - 1 ? a.duration : a.periods[c + 1].startTime;
                        e = d - a.periods[c].startTime;
                        for(var k = a.periods[c], l = [], m = u(k.streams), n = m.next(); !n.done; n = m.next())n = n.value, n.variantIds.length != 0 && l.push(EC(n, k.startTime, k.startTime + e));
                        f = l;
                        b.push(f);
                    }
                    return h.g(Cx(b), 2);
                }
                g = h.i;
                return h.return({
                    appMetadata: a.appMetadata,
                    creationTime: 0,
                    drmInfo: a.drmInfo,
                    duration: a.duration,
                    expiration: a.expiration == null ? Infinity : a.expiration,
                    originalManifestUri: a.originalManifestUri,
                    sessionIds: a.sessionIds,
                    size: a.size,
                    streams: g,
                    sequenceMode: !1
                });
            });
        };
        function EC(a, b, c) {
            return {
                id: a.id,
                originalId: a.originalId,
                groupId: null,
                primary: a.primary,
                type: a.contentType,
                mimeType: a.mimeType,
                codecs: a.codecs,
                frameRate: a.frameRate,
                pixelAspectRatio: a.pixelAspectRatio,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                kind: a.kind,
                language: a.language,
                originalLanguage: a.language || null,
                label: a.label,
                width: a.width,
                height: a.height,
                encrypted: a.encrypted,
                keyIds: new Set([
                    a.keyId
                ]),
                segments: a.segments.map(function(d) {
                    return {
                        startTime: b + d.startTime,
                        endTime: b + d.endTime,
                        initSegmentKey: a.initSegmentKey,
                        appendWindowStart: b,
                        appendWindowEnd: c,
                        timestampOffset: b - a.presentationTimeOffset,
                        dataKey: d.dataKey,
                        tilesLayout: "",
                        mimeType: null,
                        codecs: null,
                        thumbnailSprite: null
                    };
                }),
                variantIds: a.variantIds,
                roles: [],
                forced: !1,
                audioSamplingRate: null,
                channelsCount: null,
                spatialAudio: !1,
                closedCaptions: null,
                tilesLayout: void 0,
                external: !1,
                fastSwitching: !1,
                isAudioMuxedInVideo: !1
            };
        }
        function FC() {
            jC.apply(this, arguments);
        }
        oa(FC, jC);
        p = FC.prototype;
        p.hasFixedKeySpace = function() {
            return !1;
        };
        p.addSegments = function(a) {
            return this.add(this.i, a);
        };
        p.addManifests = function(a) {
            return this.add(this.g, a);
        };
        p.updateManifest = function(a, b) {
            return nC(this, a, b);
        };
        p.ie = function(a) {
            a.expiration == null && (a.expiration = Infinity);
            return Promise.resolve(a);
        };
        function GC() {
            this.m = this.j = this.i = this.h = this.g = this.l = null;
        }
        p = GC.prototype;
        p.init = function() {
            var a = this, b = new Yg, c = !1, d = new Uf(function() {
                c = !0;
                b.reject(new T(2, 9, 9017));
            });
            typeof HC === "number" && HC > 0 && d.Z(HC);
            var e = window1.indexedDB.open("shaka_offline_db", 5);
            e.onsuccess = function() {
                if (!c) {
                    d.stop();
                    var f = e.result;
                    a.l = f;
                    var g = f.objectStoreNames;
                    g = g.contains("manifest") && g.contains("segment") ? new yC(f, "segment", "manifest") : null;
                    a.g = g;
                    g = f.objectStoreNames;
                    g = g.contains("manifest-v2") && g.contains("segment-v2") ? new DC(f, "segment-v2", "manifest-v2") : null;
                    a.h = g;
                    g = f.objectStoreNames;
                    g = g.contains("manifest-v3") && g.contains("segment-v3") ? new DC(f, "segment-v3", "manifest-v3") : null;
                    a.i = g;
                    g = f.objectStoreNames;
                    g = g.contains("manifest-v5") && g.contains("segment-v5") ? new FC(f, "segment-v5", "manifest-v5") : null;
                    a.j = g;
                    f = f.objectStoreNames.contains("session-ids") ? new oC(f) : null;
                    a.m = f;
                    b.resolve();
                }
            };
            e.onupgradeneeded = function() {
                for(var f = e.result, g = u([
                    "segment-v5",
                    "manifest-v5",
                    "session-ids"
                ]), h = g.next(); !h.done; h = g.next())h = h.value, f.objectStoreNames.contains(h) || f.createObjectStore(h, {
                    autoIncrement: !0
                });
            };
            e.onerror = function(f) {
                c || (d.stop(), b.reject(new T(2, 9, 9001, e.error)), f.preventDefault());
            };
            return b;
        };
        p.destroy = function() {
            var a = this;
            return H(function(b) {
                switch(b.h){
                    case 1:
                        if (!a.g) {
                            b.B(2);
                            break;
                        }
                        return b.g(a.g.destroy(), 2);
                    case 2:
                        if (!a.h) {
                            b.B(4);
                            break;
                        }
                        return b.g(a.h.destroy(), 4);
                    case 4:
                        if (!a.i) {
                            b.B(6);
                            break;
                        }
                        return b.g(a.i.destroy(), 6);
                    case 6:
                        if (!a.j) {
                            b.B(8);
                            break;
                        }
                        return b.g(a.j.destroy(), 8);
                    case 8:
                        if (!a.m) {
                            b.B(10);
                            break;
                        }
                        return b.g(a.m.destroy(), 10);
                    case 10:
                        a.l && a.l.close(), b.j();
                }
            });
        };
        p.getCells = function() {
            var a = new Map;
            this.g && a.set("v1", this.g);
            this.h && a.set("v2", this.h);
            this.i && a.set("v3", this.i);
            this.j && a.set("v5", this.j);
            return a;
        };
        p.getEmeSessionCell = function() {
            return this.m;
        };
        p.erase = function() {
            var a = this;
            return H(function(b) {
                switch(b.h){
                    case 1:
                        if (!a.g) {
                            b.B(2);
                            break;
                        }
                        return b.g(a.g.destroy(), 2);
                    case 2:
                        if (!a.h) {
                            b.B(4);
                            break;
                        }
                        return b.g(a.h.destroy(), 4);
                    case 4:
                        if (!a.i) {
                            b.B(6);
                            break;
                        }
                        return b.g(a.i.destroy(), 6);
                    case 6:
                        if (!a.j) {
                            b.B(8);
                            break;
                        }
                        return b.g(a.j.destroy(), 8);
                    case 8:
                        return a.l && a.l.close(), b.g(IC(), 10);
                    case 10:
                        return a.l = null, a.g = null, a.h = null, a.i = null, a.j = null, b.g(a.init(), 0);
                }
            });
        };
        function IC() {
            var a = new Yg, b = window1.indexedDB.deleteDatabase("shaka_offline_db");
            b.onblocked = function() {};
            b.onsuccess = function() {
                a.resolve();
            };
            b.onerror = function(c) {
                a.reject(new T(2, 9, 9001, b.error));
                c.preventDefault();
            };
            return a;
        }
        var HC = 5;
        O("shaka.offline.indexeddb.StorageMechanismOpenTimeout", HC);
        xC("idb", function() {
            return Xb().si() ? new GC : null;
        });
        function JC(a, b, c, d) {
            this.g = a;
            this.i = b;
            this.h = c;
            this.l = d;
            this.j = [
                "offline:",
                a,
                "/",
                b,
                "/",
                c,
                "/",
                d
            ].join("");
        }
        JC.prototype.Tb = function() {
            return this.i;
        };
        JC.prototype.mb = function() {
            return this.h;
        };
        JC.prototype.key = function() {
            return this.l;
        };
        JC.prototype.toString = function() {
            return this.j;
        };
        function KC(a) {
            a = /^offline:([a-z]+)\/([^/]+)\/([^/]+)\/([0-9]+)$/.exec(a);
            if (a == null) return null;
            var b = a[1];
            if (b != "manifest" && b != "segment") return null;
            var c = a[2];
            if (!c) return null;
            var d = a[3];
            return d && b != null ? new JC(b, c, d, Number(a[4])) : null;
        }
        function LC(a, b) {
            this.h = a;
            this.g = b;
        }
        function MC(a, b) {
            var c = new Wl(null, 0);
            c.Ab(b.duration);
            var d = b.streams.filter(function(l) {
                return l.type == "audio";
            }), e = b.streams.filter(function(l) {
                return l.type == "video";
            });
            d = NC(a, d, e, c);
            e = b.streams.filter(function(l) {
                return l.type == Ec;
            }).map(function(l) {
                return OC(a, l, c);
            });
            var f = b.streams.filter(function(l) {
                return l.type == "image";
            }).map(function(l) {
                return OC(a, l, c);
            }), g = b.drmInfo ? [
                b.drmInfo
            ] : [];
            if (b.drmInfo) for(var h = u(d.values()), k = h.next(); !k.done; k = h.next())k = k.value, k.audio && k.audio.encrypted && (k.audio.drmInfos = g), k.video && k.video.encrypted && (k.video.drmInfos = g);
            return {
                presentationTimeline: c,
                offlineSessionIds: b.sessionIds,
                variants: Array.from(d.values()),
                textStreams: e,
                imageStreams: f,
                sequenceMode: b.sequenceMode || !1,
                ignoreManifestTimestampsInSegmentsMode: !1,
                type: b.type || "UNKNOWN",
                serviceDescription: null,
                nextUrl: null,
                periodCount: 1,
                gapCount: 0,
                isLowLatency: !1,
                startTime: null
            };
        }
        function NC(a, b, c, d) {
            for(var e = new Set, f = u(b), g = f.next(); !g.done; g = f.next()){
                g = u(g.value.variantIds);
                for(var h = g.next(); !h.done; h = g.next())e.add(h.value);
            }
            f = u(c);
            for(g = f.next(); !g.done; g = f.next())for(g = u(g.value.variantIds), h = g.next(); !h.done; h = g.next())e.add(h.value);
            f = new Map;
            e = u(e);
            for(g = e.next(); !g.done; g = e.next())g = g.value, f.set(g, {
                id: g,
                language: "",
                disabledUntilTime: 0,
                primary: !1,
                audio: null,
                video: null,
                bandwidth: 0,
                allowedByApplication: !0,
                allowedByKeySystem: !0,
                decodingInfos: []
            });
            b = u(b);
            for(e = b.next(); !e.done; e = b.next())for(g = e.value, e = OC(a, g, d), g = u(g.variantIds), h = g.next(); !h.done; h = g.next())h = f.get(h.value), h.language = e.language, h.primary = h.primary || e.primary, h.audio = e;
            c = u(c);
            for(b = c.next(); !b.done; b = c.next())for(e = b.value, b = OC(a, e, d), e = u(e.variantIds), g = e.next(); !g.done; g = e.next())g = f.get(g.value), g.primary = g.primary || b.primary, g.video = b;
            return f;
        }
        function OC(a, b, c) {
            var d = b.segments.map(function(e) {
                return PC(a, e, b);
            });
            c.Ae(d);
            return {
                id: b.id,
                originalId: b.originalId,
                groupId: b.groupId,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: new vm(d),
                mimeType: b.mimeType,
                codecs: b.codecs,
                width: b.width || void 0,
                height: b.height || void 0,
                frameRate: b.frameRate,
                pixelAspectRatio: b.pixelAspectRatio,
                hdr: b.hdr,
                colorGamut: b.colorGamut,
                videoLayout: b.videoLayout,
                kind: b.kind,
                encrypted: b.encrypted,
                drmInfos: [],
                keyIds: b.keyIds,
                language: b.language,
                originalLanguage: b.originalLanguage || null,
                label: b.label,
                type: b.type,
                primary: b.primary,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: null,
                roles: b.roles,
                forced: b.forced,
                channelsCount: b.channelsCount,
                audioSamplingRate: b.audioSamplingRate,
                spatialAudio: b.spatialAudio,
                closedCaptions: b.closedCaptions,
                tilesLayout: b.tilesLayout,
                mssPrivateData: b.mssPrivateData,
                accessibilityPurpose: null,
                external: b.external,
                fastSwitching: b.fastSwitching,
                fullMimeTypes: new Set([
                    wf(b.mimeType, b.codecs)
                ]),
                isAudioMuxedInVideo: b.isAudioMuxedInVideo || !1,
                baseOriginalId: null
            };
        }
        function PC(a, b, c) {
            var d = new JC("segment", a.h, a.g, b.dataKey);
            a = new Oj(b.startTime, b.endTime, function() {
                return [
                    d.toString()
                ];
            }, 0, null, b.initSegmentKey != null ? QC(a, b.initSegmentKey) : null, b.timestampOffset, b.appendWindowStart, b.appendWindowEnd, [], b.tilesLayout || "");
            a.mimeType = b.mimeType || c.mimeType || "";
            a.codecs = b.codecs || c.codecs || "";
            b.thumbnailSprite && a.kg(b.thumbnailSprite);
            return a;
        }
        function QC(a, b) {
            var c = new JC("segment", a.h, a.g, b);
            return new Mj(function() {
                return [
                    c.toString()
                ];
            }, 0, null);
        }
        function RC() {
            this.g = null;
        }
        p = RC.prototype;
        p.configure = function() {};
        p.start = function(a, b) {
            var c = this, d, e, f, g, h, k, l;
            return H(function(m) {
                switch(m.h){
                    case 1:
                        d = KC(a);
                        c.g = d;
                        if (d == null || d.g != "manifest") throw new T(2, 1, 9004, a);
                        e = new pC;
                        m.F(2);
                        return m.g(e.init(), 4);
                    case 4:
                        return m.g(tC(e, d.Tb(), d.mb()), 5);
                    case 5:
                        return f = m.i, m.g(f.getManifests([
                            d.key()
                        ]), 6);
                    case 6:
                        return g = m.i, h = g[0], k = new LC(d.Tb(), d.mb()), l = MC(k, h), b.makeTextStreamsForClosedCaptions(l), m.return(l);
                    case 2:
                        return m.A(), m.g(e.destroy(), 7);
                    case 7:
                        m.C(0);
                }
            });
        };
        p.stop = function() {
            return Promise.resolve();
        };
        p.update = function() {};
        p.onExpirationUpdated = function(a, b) {
            var c = this, d, e, f, g, h, k, l;
            return H(function(m) {
                switch(m.h){
                    case 1:
                        return d = c.g, e = new pC, m.m(2, 3), m.g(e.init(), 5);
                    case 5:
                        return m.g(tC(e, d.Tb(), d.mb()), 6);
                    case 6:
                        return f = m.i, m.g(f.getManifests([
                            d.key()
                        ]), 7);
                    case 7:
                        g = m.i;
                        h = g[0];
                        k = h.sessionIds.includes(a);
                        l = h.expiration == void 0 || h.expiration > b;
                        if (!k || !l) {
                            m.B(3);
                            break;
                        }
                        return m.g(f.updateManifestExpiration(d.key(), b), 3);
                    case 3:
                        return m.A(), m.g(e.destroy(), 10);
                    case 10:
                        m.C(0);
                        break;
                    case 2:
                        m.l(), m.B(3);
                }
            });
        };
        p.onInitialVariantChosen = function() {};
        p.banLocation = function() {};
        p.setMediaElement = function() {};
        xd("application/x-offline-manifest", function() {
            return new RC;
        });
        function SC() {}
        function TC(a, b) {
            var c = KC(a);
            c && c.g == "manifest" ? (a = {
                uri: a,
                originalUri: a,
                data: new ArrayBuffer(0),
                headers: {
                    "content-type": "application/x-offline-manifest"
                },
                originalRequest: b
            }, a = bh(a)) : a = c && c.g == "segment" ? UC(c.key(), c, b) : $g(new T(2, 1, 9004, a));
            return a;
        }
        function UC(a, b, c) {
            var d = new pC;
            return bh(void 0).eb(function() {
                return d.init();
            }).eb(function() {
                return tC(d, b.Tb(), b.mb());
            }).eb(function(e) {
                return e.getSegments([
                    b.key()
                ]);
            }).eb(function(e) {
                return {
                    uri: b,
                    data: e[0].data,
                    headers: {},
                    originalRequest: c
                };
            }).finally(function() {
                return d.destroy();
            });
        }
        O("shaka.offline.OfflineScheme", SC);
        SC.plugin = TC;
        ih("offline", TC);
        function VC(a, b, c) {
            var d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        d = [];
                        for(var m = [], n = u(c), q = n.next(); !q.done; q = n.next()){
                            q = q.value;
                            for(var r = !1, t = u(m), v = t.next(); !v.done; v = t.next())if (v = v.value, WC(v.info, q)) {
                                v.sessionIds.push(q.sessionId);
                                r = !0;
                                break;
                            }
                            r || m.push({
                                info: q,
                                sessionIds: [
                                    q.sessionId
                                ]
                            });
                        }
                        e = u(m);
                        f = e.next();
                    case 2:
                        if (f.done) {
                            l.B(4);
                            break;
                        }
                        g = f.value;
                        h = XC(a, b, g);
                        return l.g(h, 5);
                    case 5:
                        k = l.i;
                        d = d.concat(k);
                        f = e.next();
                        l.B(2);
                        break;
                    case 4:
                        return l.return(d);
                }
            });
        }
        function XC(a, b, c) {
            var d, e;
            return H(function(f) {
                switch(f.h){
                    case 1:
                        return d = new Oh({
                            Cc: b,
                            onError: function() {},
                            Uf: function() {},
                            onExpirationUpdated: function() {},
                            onEvent: function() {}
                        }), f.m(2), d.configure(a), f.g(Wh(d, c.info.keySystem, c.info.licenseUri, c.info.serverCertificate, c.info.audioCapabilities, c.info.videoCapabilities), 4);
                    case 4:
                        f.o(3);
                        break;
                    case 2:
                        return f.l(), f.g(d.destroy(), 5);
                    case 5:
                        return f.return([]);
                    case 3:
                        return e = [], f.g(Promise.all(c.sessionIds.map(function(g) {
                            return H(function(h) {
                                if (h.h == 1) return h.m(2), h.g(hi(d, g), 4);
                                if (h.h != 2) return e.push(g), h.o(0);
                                h.l();
                                h.j();
                            });
                        })), 6);
                    case 6:
                        return f.g(d.destroy(), 7);
                    case 7:
                        return f.return(e);
                }
            });
        }
        function WC(a, b) {
            function c(d, e) {
                return d.robustness == e.robustness && d.contentType == e.contentType;
            }
            return a.keySystem == b.keySystem && a.licenseUri == b.licenseUri && bd(a.audioCapabilities, b.audioCapabilities, c) && bd(a.videoCapabilities, b.videoCapabilities, c);
        }
        function YC(a, b, c) {
            var d = b.presentationTimeline.getDuration();
            b = ZC(b);
            return {
                offlineUri: null,
                originalManifestUri: a,
                duration: d,
                size: 0,
                expiration: Infinity,
                tracks: b,
                appMetadata: c,
                isIncomplete: !1
            };
        }
        function $C(a, b) {
            var c = MC(new LC(a.Tb(), a.mb()), b), d = b.appMetadata || {};
            c = ZC(c);
            return {
                offlineUri: a.toString(),
                originalManifestUri: b.originalManifestUri,
                duration: b.duration,
                size: b.size,
                expiration: b.expiration,
                tracks: c,
                appMetadata: d,
                isIncomplete: b.isIncomplete || !1
            };
        }
        function ZC(a) {
            var b = [], c = Fg(a.variants);
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next())b.push(wg(d.value));
            a = u(a.textStreams);
            for(c = a.next(); !c.done; c = a.next())b.push(xg(c.value));
            return b;
        }
        function aD() {
            this.g = new Map;
        }
        function bD(a, b) {
            var c = b.audio, d = b.video;
            c && !d && a.g.set(c.id, c.bandwidth || b.bandwidth);
            !c && d && a.g.set(d.id, d.bandwidth || b.bandwidth);
            if (c && d) {
                var e = c.bandwidth || 393216, f = d.bandwidth || b.bandwidth - e;
                f <= 0 && (f = b.bandwidth);
                a.g.set(c.id, e);
                a.g.set(d.id, f);
            }
        }
        function cD(a, b) {
            a.g.set(b.id, b.bandwidth || 2048);
        }
        function dD(a, b) {
            a = a.g.get(b);
            a == null && (a = 0);
            return a;
        }
        function eD(a) {
            var b = this;
            if (a && a.constructor != W) throw new T(2, 9, 9008);
            this.g = this.h = null;
            a ? (this.h = a.g, this.g = a.Qb()) : (this.h = zo(), this.g = new hh, this.g.configure(this.h.networking));
            this.i = [];
            this.l = [];
            var c = !a;
            this.j = new uh(function() {
                var d, e, f, g, h;
                return H(function(k) {
                    switch(k.h){
                        case 1:
                            return k.g(Promise.all(b.l.map(function(l) {
                                return $B(l);
                            })), 2);
                        case 2:
                            d = function() {};
                            e = [];
                            f = u(b.i);
                            for(g = f.next(); !g.done; g = f.next())h = g.value, e.push(h.then(d, d));
                            return k.g(Promise.all(e), 3);
                        case 3:
                            if (!c) {
                                k.B(4);
                                break;
                            }
                            return k.g(b.g.destroy(), 4);
                        case 4:
                            b.h = null, b.g = null, k.j();
                    }
                });
            });
            this.m = 1E9;
        }
        function fD() {
            if (Ad(Xb())) a: {
                var a = u(qC.values());
                for(var b = a.next(); !b.done; b = a.next())if (b = b.value, b = b()) {
                    b.destroy();
                    a = !0;
                    break a;
                }
                a = !1;
            }
            else a = !1;
            return a;
        }
        p = eD.prototype;
        p.destroy = function() {
            return this.j.destroy();
        };
        p.configure = function(a, b) {
            arguments.length == 2 && typeof a == "string" && (a = co(a, b));
            return Eo(this.h, a);
        };
        p.getConfiguration = function() {
            var a = zo();
            Eo(a, this.h, zo());
            return a;
        };
        p.Qb = function() {
            return this.g;
        };
        p.store = function(a, b, c, d, e) {
            var f = this, g = this.getConfiguration(), h = new ZB(this.g);
            this.l.push(h);
            b = gD(this, a, b || {}, d || [], e || [], function() {
                var k;
                return H(function(l) {
                    if (l.h == 1) return c ? l.B(2) : l.g(fn(a, f.g, g.manifest.retryParameters), 3);
                    l.h != 2 && (c = l.i);
                    k = Cd(a, c || null);
                    return l.return(k());
                });
            }, g, h);
            b = new Zg(b, function() {
                return $B(h);
            });
            b.finally(function() {
                ad(f.l, h);
            });
            return hD(this, b);
        };
        function gD(a, b, c, d, e, f, g, h) {
            var k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M;
            return H(function(L) {
                switch(L.h){
                    case 1:
                        return iD(), l = k = null, m = new pC, r = q = n = null, L.m(2, 3), L.g(f(), 5);
                    case 5:
                        return k = L.i, L.g(jD(a, b, k, g), 6);
                    case 6:
                        t = L.i;
                        kD(a);
                        v = !t.presentationTimeline.U() && !t.presentationTimeline.fd();
                        if (!v) throw new T(2, 9, 9005, b);
                        w = u(d);
                        x = w.next();
                    case 7:
                        if (x.done) {
                            L.B(9);
                            break;
                        }
                        y = x.value;
                        return L.g(lD(a, y, t), 10);
                    case 10:
                        z = L.i;
                        t.imageStreams.push(z);
                        kD(a);
                        x = w.next();
                        L.B(7);
                        break;
                    case 9:
                        A = u(e), E = A.next();
                    case 11:
                        if (E.done) return Yh(g.drm.clearKeys, t.variants), B = t.variants.some(function(Q) {
                            if (Q.audio) {
                                for(var S = u(Q.audio.drmInfos), Z = S.next(); !Z.done; Z = S.next())if (Z.value.licenseServerUri.startsWith("data:")) return !0;
                            }
                            if (Q.video) {
                                for(Q = u(Q.video.drmInfos), S = Q.next(); !S.done; S = Q.next())if (S.value.licenseServerUri.startsWith("data:")) return !0;
                            }
                            return !1;
                        }), J = g.offline.usePersistentLicense, B && (J = !1), L.g(a.wd(t, function(Q) {
                            r = r || Q;
                        }, g, J), 15);
                        C = E.value;
                        return L.g(mD(a, t, C.uri, C.language, C.kind, C.mime, C.codecs), 14);
                    case 14:
                        D = L.i;
                        t.textStreams.push(D);
                        kD(a);
                        E = A.next();
                        L.B(11);
                        break;
                    case 15:
                        l = L.i;
                        kD(a);
                        if (r) throw r;
                        return L.g(nD(t, l, g, J), 16);
                    case 16:
                        return L.g(m.init(), 17);
                    case 17:
                        return kD(a), L.g(rC(m), 18);
                    case 18:
                        return n = L.i, kD(a), F = oD(l, t, b, c, g, h, J), I = F.Nl, K = F.zi, L.g(n.mb.addManifests([
                            I
                        ]), 19);
                    case 19:
                        N = L.i;
                        kD(a);
                        q = N[0];
                        kD(a);
                        if (r) throw r;
                        return L.g(pD(a, K, q, I, h, g, n.mb, t, l, J), 20);
                    case 20:
                        return kD(a), qD(t, I, l, J), L.g(n.mb.updateManifest(q, I), 21);
                    case 21:
                        return kD(a), P = new JC("manifest", n.path.Tb, n.path.mb, q), L.return($C(P, I));
                    case 3:
                        return L.A(), L.g(m.destroy(), 22);
                    case 22:
                        if (!k) {
                            L.B(23);
                            break;
                        }
                        return L.g(k.stop(), 23);
                    case 23:
                        if (!l) {
                            L.B(25);
                            break;
                        }
                        return L.g(l.destroy(), 25);
                    case 25:
                        L.C(0);
                        break;
                    case 2:
                        M = L.l();
                        if (q == null) {
                            L.B(27);
                            break;
                        }
                        return L.g(rD(q), 27);
                    case 27:
                        throw r || M;
                }
            });
        }
        function pD(a, b, c, d, e, f, g, h, k, l) {
            var m, n, q, r, t, v, w, x, y, z, A;
            return H(function(E) {
                switch(E.h){
                    case 1:
                        m = {};
                        n = 0;
                        q = function() {
                            if (a.j.g || e.l) throw new T(2, 9, 7001);
                        };
                        r = function(C, D) {
                            var B, J, F, I, K, N, P, M, L;
                            return H(function(Q) {
                                if (Q.h == 1) {
                                    B = u(C);
                                    J = B.next();
                                    for(F = {}; !J.done; F = {
                                        wc: void 0
                                    }, J = B.next())F.wc = J.value, q(), I = VB(F.wc, f), K = F.wc.i, N = F.wc.h, P = function(S) {
                                        return function(Z) {
                                            var pa, va, Ca, ua;
                                            return H(function(xa) {
                                                switch(xa.h){
                                                    case 1:
                                                        pa = S.wc.g;
                                                        va = pa.dc(!1);
                                                        if (!pa.aesKey || va) {
                                                            xa.B(2);
                                                            break;
                                                        }
                                                        return xa.g(en(Z, pa.aesKey, S.wc.j), 3);
                                                    case 3:
                                                        Z = xa.i;
                                                    case 2:
                                                        return Ca = UB(pa), xa.g(g.addSegments([
                                                            {
                                                                data: Z
                                                            }
                                                        ]), 4);
                                                    case 4:
                                                        ua = xa.i, q(), m[Ca] = ua[0], n += Z.byteLength, xa.j();
                                                }
                                            });
                                        };
                                    }(F), M = F.wc.g, (L = M.dc(!1)) ? cC(e, F.wc.groupId, L, K, N, P) : e.queue(F.wc.groupId, I, K, N, P);
                                    return Q.g(dC(e), 2);
                                }
                                q();
                                if (!D || e.l) return Q.B(0);
                                qD(h, d, k, l);
                                return Q.g(g.updateManifest(c, d), 0);
                            });
                        };
                        t = !1;
                        E.m(2);
                        if (!sD(h) || !t || tD(h)) {
                            E.B(4);
                            break;
                        }
                        return E.g(r(b.filter(function(C) {
                            return C.h;
                        }), !0), 5);
                    case 5:
                        return q(), b = b.filter(function(C) {
                            return !C.h;
                        }), v = m, w = n, m = {}, n = 0, E.g(uD(g, c, d, v, w, function() {
                            return kD(a);
                        }), 6);
                    case 6:
                        q();
                    case 4:
                        if (t) {
                            E.B(7);
                            break;
                        }
                        return E.g(r(b, !1), 8);
                    case 8:
                        return q(), x = m, y = n, m = {}, n = 0, E.g(uD(g, c, d, x, y, function() {
                            return q();
                        }), 9);
                    case 9:
                        q();
                    case 7:
                        E.o(0);
                        break;
                    case 2:
                        return z = E.l(), A = Object.values(m), E.g(g.removeSegments(A, function() {}), 10);
                    case 10:
                        throw z;
                }
            });
        }
        function rD(a) {
            var b, c, d, e;
            return H(function(f) {
                switch(f.h){
                    case 1:
                        return b = new pC, f.g(b.init(), 2);
                    case 2:
                        return f.g(rC(b), 3);
                    case 3:
                        return c = f.i, d = new JC("manifest", c.path.Tb, c.path.mb, a), f.g(b.destroy(), 4);
                    case 4:
                        return e = new eD, f.g(e.remove(d.toString()), 0);
                }
            });
        }
        function uD(a, b, c, d, e, f) {
            var g, h, k, l, m, n, q, r, t, v, w;
            return H(function(x) {
                switch(x.h){
                    case 1:
                        g = !1;
                        x.m(2);
                        h = !0;
                        k = u(c.streams);
                        for(l = k.next(); !l.done; l = k.next())for(m = l.value, n = u(m.segments), q = n.next(); !q.done; q = n.next())r = q.value, t = r.pendingSegmentRefId ? d[r.pendingSegmentRefId] : null, t != null && (r.dataKey = t, r.pendingSegmentRefId = void 0), t = r.pendingInitSegmentRefId ? d[r.pendingInitSegmentRefId] : null, t != null && (r.initSegmentKey = t, r.pendingInitSegmentRefId = void 0), r.pendingSegmentRefId && (h = !1), r.pendingInitSegmentRefId && (h = !1);
                        c.size += e;
                        h && (c.isIncomplete = !1);
                        return x.g(a.updateManifest(b, c), 4);
                    case 4:
                        g = !0;
                        f();
                        x.o(0);
                        break;
                    case 2:
                        return v = x.l(), x.g(rD(b), 5);
                    case 5:
                        if (g) {
                            x.B(6);
                            break;
                        }
                        w = Object.values(d);
                        return x.g(a.removeSegments(w, function() {}), 6);
                    case 6:
                        throw v;
                }
            });
        }
        function nD(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q;
            return H(function(S) {
                switch(S.h){
                    case 1:
                        return e = {
                            width: Infinity,
                            height: Infinity
                        }, dg(a, c.restrictions, e), S.g(gg(b, a, d, c.drm.preferredKeySystems, c.drm.keySystemsMapping), 2);
                    case 2:
                        f = [];
                        g = c.preferredDecodingAttributes;
                        h = c.preferredVideoCodecs;
                        k = c.preferredAudioCodecs;
                        l = c.preferredTextFormats;
                        bg(a, h, k, g, l);
                        m = u(a.variants);
                        for(n = m.next(); !n.done; n = m.next())q = n.value, f.push(wg(q));
                        r = u(a.textStreams);
                        for(t = r.next(); !t.done; t = r.next())v = t.value, f.push(xg(v));
                        w = u(a.imageStreams);
                        for(x = w.next(); !x.done; x = w.next())y = x.value, f.push(yg(y));
                        return S.g(c.offline.trackSelectionCallback(f), 3);
                    case 3:
                        z = S.i;
                        A = a.presentationTimeline.getDuration();
                        E = 0;
                        C = u(z);
                        for(D = C.next(); !D.done; D = C.next())B = D.value, J = B.bandwidth * A / 8, E += J;
                        S.m(4);
                        return S.g(c.offline.downloadSizeCallback(E), 6);
                    case 6:
                        F = S.i;
                        if (!F) throw new T(2, 9, 9014);
                        S.o(5);
                        break;
                    case 4:
                        I = S.l();
                        if (I instanceof T) throw I;
                        throw new T(2, 9, 9015);
                    case 5:
                        K = new Set;
                        N = new Set;
                        P = new Set;
                        M = u(z);
                        for(L = M.next(); !L.done; L = M.next())Q = L.value, Q.type == "variant" && K.add(Q.id), Q.type == "text" && N.add(Q.id), Q.type == "image" && P.add(Q.id);
                        a.variants = a.variants.filter(function(Z) {
                            return K.has(Z.id);
                        });
                        a.textStreams = a.textStreams.filter(function(Z) {
                            return N.has(Z.id);
                        });
                        a.imageStreams = a.imageStreams.filter(function(Z) {
                            return P.has(Z.id);
                        });
                        vD(a);
                        S.j();
                }
            });
        }
        function oD(a, b, c, d, e, f, g) {
            var h = YC(c, b, d), k = e.offline.progressCallback;
            aC(f, function(t, v) {
                h.size = v;
                k(h, t);
            }, function(t, v) {
                l && g && m == v && di(a, "cenc", t);
            });
            var l = sD(b) && !tD(b), m = null;
            l && (m = wD.get(a.g.keySystem));
            for(var n = new aD, q = u(b.textStreams), r = q.next(); !r.done; r = q.next())n.g.set(r.value.id, 52);
            q = u(b.imageStreams);
            for(r = q.next(); !r.done; r = q.next())cD(n, r.value);
            q = u(b.variants);
            for(r = q.next(); !r.done; r = q.next())bD(n, r.value);
            f = xD(f, n, b, e);
            e = f.streams;
            f = f.zi;
            (n = a.g) && g && (n.initData = []);
            return {
                Nl: {
                    creationTime: Date.now(),
                    originalManifestUri: c,
                    duration: b.presentationTimeline.getDuration(),
                    size: 0,
                    expiration: a.oe(),
                    streams: e,
                    sessionIds: g ? pi(a) : [],
                    drmInfo: n,
                    appMetadata: d,
                    isIncomplete: !0,
                    sequenceMode: b.sequenceMode,
                    type: b.type
                },
                zi: f
            };
        }
        function sD(a) {
            return a.variants.some(function(b) {
                var c = b.audio && b.audio.encrypted;
                return b.video && b.video.encrypted || c;
            });
        }
        function tD(a) {
            return a.variants.some(function(b) {
                return (b.video ? b.video.drmInfos : []).concat(b.audio ? b.audio.drmInfos : []).some(function(c) {
                    return c.initData && c.initData.length;
                });
            });
        }
        function qD(a, b, c, d) {
            b.expiration = c.oe();
            c = pi(c);
            b.sessionIds = d ? c : [];
            if (sD(a) && d && !c.length) throw new T(2, 9, 9007);
        }
        p.remove = function(a) {
            return yD(this, zD(this, a));
        };
        function zD(a, b) {
            var c, d, e, f, g, h;
            return H(function(k) {
                switch(k.h){
                    case 1:
                        iD();
                        c = KC(b);
                        if (c == null || c.g != "manifest") throw new T(2, 9, 9004, b);
                        d = c;
                        e = new pC;
                        k.F(2);
                        return k.g(e.init(), 4);
                    case 4:
                        return k.g(tC(e, d.Tb(), d.mb()), 5);
                    case 5:
                        return f = k.i, k.g(f.getManifests([
                            d.key()
                        ]), 6);
                    case 6:
                        return g = k.i, h = g[0], k.g(Promise.all([
                            AD(a, h, e),
                            BD(f, d, h)
                        ]), 2);
                    case 2:
                        return k.A(), k.g(e.destroy(), 8);
                    case 8:
                        k.C(0);
                }
            });
        }
        function CD(a, b) {
            for(var c = [], d = u(a.streams), e = d.next(); !e.done; e = d.next())e = e.value, b && e.type == "video" ? c.push({
                contentType: wf(e.mimeType, e.codecs),
                robustness: a.drmInfo.videoRobustness
            }) : b || e.type != "audio" || c.push({
                contentType: wf(e.mimeType, e.codecs),
                robustness: a.drmInfo.audioRobustness
            });
            return c;
        }
        function AD(a, b, c) {
            return H(function(d) {
                return d.g(DD(a.g, a.h.drm, c, b), 0);
            });
        }
        function BD(a, b, c) {
            function d() {}
            var e = ED(c);
            $C(b, c);
            return Promise.all([
                a.removeSegments(e, d),
                a.removeManifests([
                    b.key()
                ], d)
            ]);
        }
        p.jm = function() {
            return yD(this, FD(this));
        };
        function FD(a) {
            var b, c, d, e, f, g, h, k, l, m;
            return H(function(n) {
                switch(n.h){
                    case 1:
                        return iD(), b = a.g, c = a.h.drm, d = new pC, e = !1, n.F(2), n.g(d.init(), 4);
                    case 4:
                        f = [], uC(d, function(q) {
                            return f.push(q);
                        }), g = u(f), h = g.next();
                    case 5:
                        if (h.done) {
                            n.B(2);
                            break;
                        }
                        k = h.value;
                        return n.g(k.getAll(), 8);
                    case 8:
                        return l = n.i, n.g(VC(c, b, l), 9);
                    case 9:
                        return m = n.i, n.g(k.remove(m), 10);
                    case 10:
                        m.length != l.length && (e = !0);
                        h = g.next();
                        n.B(5);
                        break;
                    case 2:
                        return n.A(), n.g(d.destroy(), 11);
                    case 11:
                        n.C(3);
                        break;
                    case 3:
                        return n.return(!e);
                }
            });
        }
        p.list = function() {
            return yD(this, GD());
        };
        function GD() {
            var a, b, c;
            return H(function(d) {
                switch(d.h){
                    case 1:
                        return iD(), a = [], b = new pC, d.F(2), d.g(b.init(), 4);
                    case 4:
                        return c = Promise.resolve(), sC(b, function(e, f) {
                            c = c.then(function() {
                                var g;
                                return H(function(h) {
                                    if (h.h == 1) return h.g(f.getAllManifests(), 2);
                                    g = h.i;
                                    g.forEach(function(k, l) {
                                        k = $C(new JC("manifest", e.Tb, e.mb, l), k);
                                        a.push(k);
                                    });
                                    h.j();
                                });
                            });
                        }), d.g(c, 2);
                    case 2:
                        return d.A(), d.g(b.destroy(), 6);
                    case 6:
                        d.C(3);
                        break;
                    case 3:
                        return d.return(a);
                }
            });
        }
        function jD(a, b, c, d) {
            var e, f, g, h, k;
            return H(function(l) {
                if (l.h == 1) return e = null, f = a.g, g = {
                    networkingEngine: f,
                    filter: function() {
                        return Promise.resolve();
                    },
                    makeTextStreamsForClosedCaptions: function() {},
                    onTimelineRegionAdded: function() {},
                    onEvent: function() {},
                    onError: function(m) {
                        e = m;
                    },
                    isLowLatencyMode: function() {
                        return !1;
                    },
                    updateDuration: function() {},
                    newDrmInfo: function() {},
                    onManifestUpdated: function() {},
                    getBandwidthEstimate: function() {
                        return d.abr.defaultBandwidthEstimate;
                    },
                    onMetadata: function() {},
                    disableStream: function() {},
                    addFont: function() {}
                }, c.configure(d.manifest), kD(a), l.g(c.start(b, g), 2);
                if (l.h != 3) return h = l.i, kD(a), k = HD(h), l.g(Promise.all(gb(k, function(m) {
                    return m.createSegmentIndex();
                })), 3);
                kD(a);
                if (e) throw e;
                return l.return(h);
            });
        }
        function lD(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x;
            return H(function(y) {
                switch(y.h){
                    case 1:
                        return y.g(ID(a, b), 2);
                    case 2:
                        d = y.i;
                        if (d != "text/vtt") throw new T(1, 2, 2017, b);
                        return y.g(JD(b, a.g, a.h.streaming.retryParameters), 3);
                    case 3:
                        e = y.i;
                        f = Lf(d);
                        if (!f) throw new T(2, 2, 2014, d);
                        g = f();
                        h = {
                            periodStart: 0,
                            segmentStart: 0,
                            segmentEnd: c.presentationTimeline.getDuration(),
                            vttOffset: 0
                        };
                        k = Fb(e);
                        l = g.parseMedia(k, h, b, []);
                        m = [];
                        n = u(l);
                        q = n.next();
                        for(r = {}; !q.done; r = {
                            wg: void 0,
                            yd: void 0
                        }, q = n.next())r.yd = q.value, r.wg = null, t = function(z) {
                            return function() {
                                z.wg == null && (z.wg = vc([
                                    b
                                ], [
                                    z.yd.payload
                                ]));
                                return z.wg || [];
                            };
                        }(r), v = new Oj(r.yd.startTime, r.yd.endTime, t, 0, null, null, 0, 0, Infinity), r.yd.payload.includes("#xywh") && (w = r.yd.payload.split("#xywh=")[1].split(","), w.length === 4 && v.kg({
                            height: parseInt(w[3], 10),
                            positionX: parseInt(w[0], 10),
                            positionY: parseInt(w[1], 10),
                            width: parseInt(w[2], 10)
                        })), m.push(v);
                        x = d;
                        if (!m.length) {
                            y.B(4);
                            break;
                        }
                        return y.g(fn(m[0].T()[0], a.g, a.h.manifest.retryParameters), 5);
                    case 5:
                        x = y.i;
                    case 4:
                        return y.return({
                            id: a.m++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: new vm(m),
                            mimeType: x || "",
                            codecs: "",
                            kind: "",
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: "und",
                            originalLanguage: null,
                            label: null,
                            type: "image",
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !1,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            tilesLayout: "1x1",
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                wf(x || "", "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        });
                }
            });
        }
        function mD(a, b, c, d, e, f, g) {
            var h, k, l;
            return H(function(m) {
                if (m.h == 1) return f ? m.B(2) : m.g(ID(a, c), 3);
                m.h != 2 && (f = m.i);
                h = {
                    id: a.m++,
                    originalId: null,
                    groupId: null,
                    createSegmentIndex: function() {
                        return Promise.resolve();
                    },
                    segmentIndex: xm(0, b.presentationTimeline.getDuration(), [
                        c
                    ]),
                    mimeType: f || "",
                    codecs: g || "",
                    kind: e,
                    encrypted: !1,
                    drmInfos: [],
                    keyIds: new Set,
                    language: d,
                    originalLanguage: d,
                    label: null,
                    type: Ec,
                    primary: !1,
                    trickModeVideo: null,
                    dependencyStream: null,
                    emsgSchemeIdUris: null,
                    roles: [],
                    forced: !1,
                    channelsCount: null,
                    audioSamplingRate: null,
                    spatialAudio: !1,
                    closedCaptions: null,
                    accessibilityPurpose: null,
                    external: !0,
                    fastSwitching: !1,
                    fullMimeTypes: new Set([
                        wf(f || "", g || "")
                    ]),
                    isAudioMuxedInVideo: !1,
                    baseOriginalId: null
                };
                k = wf(h.mimeType, h.codecs);
                l = Mf(k);
                if (!l) throw new T(2, 2, 2014, f);
                return m.return(h);
            });
        }
        function ID(a, b) {
            var c;
            return H(function(d) {
                switch(d.h){
                    case 1:
                        return d.m(2), d.g(fn(b, a.g, a.h.streaming.retryParameters), 4);
                    case 4:
                        c = d.i;
                        d.o(3);
                        break;
                    case 2:
                        d.l();
                    case 3:
                        if (c) return d.return(c);
                        throw new T(1, 2, 2011, b);
                }
            });
        }
        function JD(a, b, c) {
            var d, e, f;
            return H(function(g) {
                if (g.h == 1) return d = sh, e = mh([
                    a
                ], c), e.method = "GET", g.g(b.request(d, e).promise, 2);
                f = g.i;
                return g.return(f.data);
            });
        }
        p.wd = function(a, b, c, d) {
            var e = this, f;
            return H(function(g) {
                return g.h == 1 ? (f = new Oh({
                    Cc: e.g,
                    onError: b,
                    Uf: function() {},
                    onExpirationUpdated: function() {},
                    onEvent: function() {}
                }), f.configure(c.drm), g.g(Th(f, a.variants, d), 2)) : g.h != 3 ? d ? g.g(fi(f), 3) : g.B(3) : g.return(f);
            });
        };
        function xD(a, b, c, d) {
            var e = new Map, f = HD(c), g = new Map;
            f = u(f);
            for(var h = f.next(); !h.done; h = f.next()){
                h = h.value;
                var k = KD(a, b, c, h, d, e);
                g.set(h.id, k);
            }
            a = u(c.variants);
            for(b = a.next(); !b.done; b = a.next())b = b.value, b.audio && g.get(b.audio.id).variantIds.push(b.id), b.video && g.get(b.video.id).variantIds.push(b.id);
            return {
                streams: Array.from(g.values()),
                zi: Array.from(e.values())
            };
        }
        function KD(a, b, c, d, e, f) {
            var g = {
                id: d.id,
                originalId: d.originalId,
                groupId: d.groupId,
                primary: d.primary,
                type: d.type,
                mimeType: d.mimeType,
                codecs: d.codecs,
                frameRate: d.frameRate,
                pixelAspectRatio: d.pixelAspectRatio,
                hdr: d.hdr,
                colorGamut: d.colorGamut,
                videoLayout: d.videoLayout,
                kind: d.kind,
                language: d.language,
                originalLanguage: d.originalLanguage,
                label: d.label,
                width: d.width || null,
                height: d.height || null,
                encrypted: d.encrypted,
                keyIds: d.keyIds,
                segments: [],
                variantIds: [],
                roles: d.roles,
                forced: d.forced,
                channelsCount: d.channelsCount,
                audioSamplingRate: d.audioSamplingRate,
                spatialAudio: d.spatialAudio,
                closedCaptions: d.closedCaptions,
                tilesLayout: d.tilesLayout,
                mssPrivateData: d.mssPrivateData,
                external: d.external,
                fastSwitching: d.fastSwitching,
                isAudioMuxedInVideo: d.isAudioMuxedInVideo
            }, h = e.offline.numberOfParallelDownloads, k = h === 0 ? d.id : 0;
            LD(d, c.presentationTimeline.Hb(), function(l, m) {
                var n = UB(l), q = void 0;
                if (!f.has(n)) {
                    var r = l.endTime - l.startTime;
                    r = dD(b, d.id) * r;
                    r = XB(a.g, r);
                    f.set(n, new TB(l, r, k, !1, m));
                }
                l.ia && (q = UB(l.ia), f.has(q) || (r = dD(b, d.id) * .5, r = XB(a.g, r), f.set(q, new TB(l.ia, r, k, !0, m))));
                g.segments.push({
                    pendingInitSegmentRefId: q,
                    initSegmentKey: q ? 0 : null,
                    startTime: l.startTime,
                    endTime: l.endTime,
                    appendWindowStart: l.appendWindowStart,
                    appendWindowEnd: l.appendWindowEnd,
                    timestampOffset: l.timestampOffset,
                    tilesLayout: l.tilesLayout,
                    pendingSegmentRefId: n,
                    dataKey: 0,
                    mimeType: l.mimeType,
                    codecs: l.codecs,
                    thumbnailSprite: l.thumbnailSprite
                });
                h !== 0 && (k = (k + 1) % h);
            });
            return g;
        }
        function LD(a, b, c) {
            b = a.segmentIndex.find(b);
            if (b != null) for(var d = a.segmentIndex.get(b); d;)c(d, b), d = a.segmentIndex.get(++b);
        }
        function kD(a) {
            if (a.j.g) throw new T(2, 9, 7001);
        }
        function iD() {
            if (!fD()) throw new T(2, 9, 9E3);
        }
        function yD(a, b) {
            return H(function(c) {
                if (c.h == 1) return a.i.push(b), c.F(2), c.g(b, 4);
                if (c.h != 2) return c.return(c.i);
                c.A();
                ad(a.i, b);
                return c.C(0);
            });
        }
        function hD(a, b) {
            var c = b.promise;
            a.i.push(c);
            return b.finally(function() {
                ad(a.i, c);
            });
        }
        function ED(a) {
            var b = new Set;
            a = u(a.streams);
            for(var c = a.next(); !c.done; c = a.next()){
                c = u(c.value.segments);
                for(var d = c.next(); !d.done; d = c.next())d = d.value, d.initSegmentKey != null && b.add(d.initSegmentKey), b.add(d.dataKey);
            }
            return Array.from(b);
        }
        function DD(a, b, c, d) {
            var e, f, g;
            return H(function(h) {
                if (h.h == 1) {
                    if (!d.drmInfo) return h.return();
                    e = vC(c);
                    f = d.sessionIds.map(function(k) {
                        return {
                            sessionId: k,
                            keySystem: d.drmInfo.keySystem,
                            licenseUri: d.drmInfo.licenseServerUri,
                            serverCertificate: d.drmInfo.serverCertificate,
                            audioCapabilities: CD(d, !1),
                            videoCapabilities: CD(d, !0)
                        };
                    });
                    return h.g(VC(b, a, f), 2);
                }
                return h.h != 3 ? (g = h.i, h.g(e.remove(g), 3)) : h.g(e.add(f.filter(function(k) {
                    return !g.includes(k.sessionId);
                })), 0);
            });
        }
        function HD(a) {
            for(var b = new Set, c = u(a.variants), d = c.next(); !d.done; d = c.next())d = d.value, d.audio && b.add(d.audio), d.video && b.add(d.video);
            c = u(a.textStreams);
            for(d = c.next(); !d.done; d = c.next())b.add(d.value);
            a = u(a.imageStreams);
            for(c = a.next(); !c.done; c = a.next())b.add(c.value);
            return b;
        }
        function vD(a) {
            a.variants.map(function(f) {
                return f.video;
            });
            var b = new Set(a.variants.map(function(f) {
                return f.audio;
            }));
            a = a.textStreams;
            for(var c = u(b), d = c.next(); !d.done; d = c.next()){
                d = u(b);
                for(var e = d.next(); !e.done; e = d.next());
            }
            b = u(a);
            for(c = b.next(); !c.done; c = b.next())for(c = u(a), d = c.next(); !d.done; d = c.next());
        }
        O("shaka.offline.Storage", eD);
        eD.deleteAll = function() {
            var a;
            return H(function(b) {
                return b.h == 1 ? (a = new pC, b.F(2), b.g(wC(a), 2)) : b.h != 5 ? (b.A(), b.g(a.destroy(), 5)) : b.C(0);
            });
        };
        eD.prototype.list = eD.prototype.list;
        eD.prototype.removeEmeSessions = eD.prototype.jm;
        eD.prototype.remove = eD.prototype.remove;
        eD.prototype.store = eD.prototype.store;
        eD.prototype.getNetworkingEngine = eD.prototype.Qb;
        eD.prototype.getConfiguration = eD.prototype.getConfiguration;
        eD.prototype.configure = eD.prototype.configure;
        eD.prototype.destroy = eD.prototype.destroy;
        eD.support = fD;
        var wD = (new Map).set("org.w3.clearkey", "1077efecc0b24d02ace33c1e52e2fb4b").set("com.widevine.alpha", "edef8ba979d64acea3c827dcd51d21ed").set("com.microsoft.playready", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.recommendation", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.software", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.hardware", "9a04f07998404286ab92e65be0885f95").set("com.huawei.wiseplay", "3d5e6d359b9a41e8b843dd3c6e72c42c");
        Ar("offline", fD);
        function MD() {}
        function ND() {
            for(var a = u(OD), b = a.next(); !b.done; b = a.next()){
                b = b.value;
                try {
                    b.callback();
                } catch (c) {
                    Za("Error installing polyfill!", c);
                }
            }
        }
        function PD(a, b) {
            a = {
                priority: b || 0,
                callback: a
            };
            for(b = 0; b < OD.length; b++)if (OD[b].priority < a.priority) {
                OD.splice(b, 0, a);
                return;
            }
            OD.push(a);
        }
        O("shaka.polyfill", MD);
        MD.register = PD;
        MD.installAll = ND;
        var OD = [];
        function QD() {}
        function RD() {
            if (!Object.getOwnPropertyDescriptor(Element.prototype, "ariaHidden")) for(var a = u([
                "ariaHidden",
                "ariaLabel",
                "ariaPressed",
                "ariaSelected"
            ]), b = a.next(); !b.done; b = a.next())SD(b.value);
        }
        function SD(a) {
            var b = "aria-" + a.toLowerCase().replace(/^aria/, "");
            Object.defineProperty(Element.prototype, a, {
                get: function() {
                    return this.getAttribute(b);
                },
                set: function(c) {
                    c == null || c == void 0 ? this.removeAttribute(b) : this.setAttribute(b, c);
                }
            });
        }
        MD.Aria = QD;
        QD.install = RD;
        PD(RD);
        function TD(a, b, c) {
            this.g = a;
            this.i = b || null;
            this.h = c || null;
            this.keySystem = a.keySystem;
        }
        TD.prototype.getConfiguration = function() {
            var a = this.g.getConfiguration();
            if (a.videoCapabilities) for(var b = u(a.videoCapabilities), c = b.next(); !c.done; c = b.next())c.value.encryptionScheme = this.i;
            if (a.audioCapabilities) for(b = u(a.audioCapabilities), c = b.next(); !c.done; c = b.next())c.value.encryptionScheme = this.h;
            return a;
        };
        TD.prototype.createMediaKeys = function() {
            return this.g.createMediaKeys();
        };
        function UD(a) {
            if (Rb(a)) return "cbcs";
            if (Pb(a) || Qb(a) || Ob(a) || a === "com.huawei.wiseplay") return "cenc";
            Za("EmeEncryptionSchemePolyfill: Unknown key system:", a, "Please contribute!");
            return null;
        }
        function VD(a) {
            if (!a) return !1;
            a = a.getConfiguration();
            var b = a.audioCapabilities && a.audioCapabilities[0];
            return (a = a.videoCapabilities && a.videoCapabilities[0] || b) && a.encryptionScheme !== void 0 ? !0 : !1;
        }
        function WD(a, b) {
            return !a || a == b || (a == "cbcs" || a == "cbcs-1-9") && Xb().od() ? !0 : !1;
        }
        function XD() {}
        var YD;
        function ZD() {
            Xb().ng() && !YD && !navigator.emeEncryptionSchemePolyfilled && navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration && (YD = navigator.requestMediaKeySystemAccess, navigator.requestMediaKeySystemAccess = $D, navigator.emeEncryptionSchemePolyfilled = !0);
        }
        function $D(a, b) {
            var c = this, d, e;
            return H(function(f) {
                if (f.h == 1) return f.g(YD.call(c, a, b), 2);
                d = f.i;
                if (e = VD(d)) return navigator.requestMediaKeySystemAccess = YD, f.return(d);
                navigator.requestMediaKeySystemAccess = aE;
                return f.return(aE.call(c, a, b));
            });
        }
        function aE(a, b) {
            var c = this, d, e, f, g, h, k, l, m, n, q, r, t;
            return H(function(v) {
                if (v.h == 1) {
                    d = UD(a);
                    e = [];
                    f = u(b);
                    for(g = f.next(); !g.done; g = f.next())h = g.value, k = bE(h.videoCapabilities, d), l = bE(h.audioCapabilities, d), h.videoCapabilities && h.videoCapabilities.length && !k.length || h.audioCapabilities && h.audioCapabilities.length && !l.length || (m = Object.assign({}, h), m.videoCapabilities = k, m.audioCapabilities = l, e.push(m));
                    if (!e.length) throw n = Error("Unsupported keySystem or supportedConfigurations."), n.name = "NotSupportedError", n.code = DOMException.NOT_SUPPORTED_ERR, n;
                    return v.g(YD.call(c, a, e), 2);
                }
                q = v.i;
                t = r = null;
                e[0] && (e[0].videoCapabilities && (r = e[0].videoCapabilities[0].encryptionScheme), e[0].audioCapabilities && (t = e[0].audioCapabilities[0].encryptionScheme));
                return v.return(new TD(q, r, t));
            });
        }
        function bE(a, b) {
            return a ? a.filter(function(c) {
                return WD(c.encryptionScheme, b);
            }) : a;
        }
        MD.EmeEncryptionScheme = XD;
        XD.install = ZD;
        PD(ZD);
        function cE() {}
        function dE() {
            if (window1.Document) {
                var a = Element.prototype;
                a.requestFullscreen = a.requestFullscreen || a.mozRequestFullScreen || a.webkitRequestFullscreen;
                a = Document.prototype;
                a.exitFullscreen = a.exitFullscreen || a.mozCancelFullScreen || a.webkitCancelFullScreen;
                "fullscreenElement" in document || (Object.defineProperty(document, "fullscreenElement", {
                    get: function() {
                        return document.mozFullScreenElement || document.webkitCurrentFullScreenElement || document.webkitFullscreenElement;
                    }
                }), Object.defineProperty(document, "fullscreenEnabled", {
                    get: function() {
                        return document.mozFullScreenEnabled || document.webkitFullscreenEnabled;
                    }
                }));
                document.addEventListener("webkitfullscreenchange", eE);
                document.addEventListener("webkitfullscreenerror", eE);
                document.addEventListener("mozfullscreenchange", eE);
                document.addEventListener("mozfullscreenerror", eE);
            }
        }
        function eE(a) {
            var b = a.type.replace(/^(webkit|moz)/, "").toLowerCase(), c = document.createEvent("Event");
            c.initEvent(b, a.bubbles, a.cancelable);
            a.target.dispatchEvent(c);
        }
        MD.Fullscreen = cE;
        cE.install = dE;
        PD(dE);
        function fE() {}
        var gE;
        function hE() {
            Xb().ng() && !gE && !navigator.mediaCapabilitiesEncryptionSchemePolyfilled && navigator.mediaCapabilities && (gE = navigator.mediaCapabilities.decodingInfo, navigator.mediaCapabilities.decodingInfo = iE, navigator.mediaCapabilitiesEncryptionSchemePolyfilled = !0);
        }
        function iE(a) {
            var b = this, c, d, e;
            return H(function(f) {
                switch(f.h){
                    case 1:
                        return f.g(gE.call(b, a), 2);
                    case 2:
                        c = f.i;
                        if (!c.supported || !a.keySystemConfiguration) return f.return(c);
                        d = c.keySystemAccess;
                        if (e = VD(d)) return navigator.mediaCapabilities.decodingInfo = gE, f.return(c);
                        navigator.mediaCapabilities.decodingInfo = jE;
                        if (d) {
                            f.B(3);
                            break;
                        }
                        return f.g(kE(a), 4);
                    case 4:
                        return c.keySystemAccess = f.i, f.return(c);
                    case 3:
                        return f.return(jE.call(b, a));
                }
            });
        }
        function jE(a) {
            var b = this, c, d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        return d = c = null, !a.keySystemConfiguration || (e = a.keySystemConfiguration, f = e.keySystem, d = e.audio && e.audio.encryptionScheme, c = e.video && e.video.encryptionScheme, g = UD(f), h = {
                            powerEfficient: !1,
                            smooth: !1,
                            supported: !1,
                            keySystemAccess: null,
                            configuration: a
                        }, WD(d, g) && WD(c, g)) ? l.g(gE.call(b, a), 2) : l.return(h);
                    case 2:
                        k = l.i;
                        if (k.keySystemAccess) {
                            k.keySystemAccess = new TD(k.keySystemAccess, c, d);
                            l.B(3);
                            break;
                        }
                        if (!a.keySystemConfiguration) {
                            l.B(3);
                            break;
                        }
                        return l.g(kE(a), 5);
                    case 5:
                        k.keySystemAccess = l.i;
                    case 3:
                        return l.return(k);
                }
            });
        }
        function kE(a) {
            var b, c;
            return H(function(d) {
                if (d.h == 1) {
                    var e = a.keySystemConfiguration, f = [], g = [];
                    e.audio && f.push({
                        robustness: e.audio.robustness || "",
                        contentType: a.audio.contentType,
                        encryptionScheme: e.audio.encryptionScheme
                    });
                    e.video && g.push({
                        robustness: e.video.robustness || "",
                        contentType: a.video.contentType,
                        encryptionScheme: e.video.encryptionScheme
                    });
                    e = {
                        initDataTypes: e.initDataType ? [
                            e.initDataType
                        ] : [],
                        distinctiveIdentifier: e.distinctiveIdentifier,
                        persistentState: e.persistentState,
                        sessionTypes: e.sessionTypes
                    };
                    f.length && (e.audioCapabilities = f);
                    g.length && (e.videoCapabilities = g);
                    b = e;
                    return d.g(navigator.requestMediaKeySystemAccess(a.keySystemConfiguration.keySystem, [
                        b
                    ]), 2);
                }
                c = d.i;
                return d.return(c);
            });
        }
        MD.MCapEncryptionScheme = fE;
        fE.install = hE;
        PD(hE, -2);
        function lE() {}
        function mE() {
            Xb().mc() || (navigator.mediaCapabilities || (navigator.mediaCapabilities = {}), lE.originalMcap = navigator.mediaCapabilities, navigator.mediaCapabilities.decodingInfo = nE);
        }
        function nE(a) {
            var b, c, d, e, f, g, h, k, l, m, n;
            return H(function(q) {
                switch(q.h){
                    case 1:
                        b = {
                            supported: !1,
                            powerEfficient: !0,
                            smooth: !0,
                            keySystemAccess: null,
                            configuration: a
                        };
                        Xb();
                        c = a.video;
                        d = a.audio;
                        if (a.type != "media-source") {
                            if (a.type == "file") {
                                if (c && (e = c.contentType, f = Bd().canPlayType(e) != "", !f) || d && (g = d.contentType, h = Bd().canPlayType(g) != "", !h)) return q.return(b);
                            } else return q.return(b);
                            q.B(2);
                            break;
                        }
                        if (!Ad()) return q.return(b);
                        if (!c) {
                            q.B(3);
                            break;
                        }
                        return q.g(oE(c), 4);
                    case 4:
                        if (k = q.i, !k) return q.return(b);
                    case 3:
                        if (!d) {
                            q.B(2);
                            break;
                        }
                        return q.g(pE(d), 6);
                    case 6:
                        if (l = q.i, !l) return q.return(b);
                    case 2:
                        if (!a.keySystemConfiguration) return b.supported = !0, q.return(b);
                        m = a.keySystemConfiguration;
                        return q.g(qE(c, d, m), 8);
                    case 8:
                        if (n = q.i) b.supported = !0, b.keySystemAccess = n;
                    case 7:
                        return q.return(b);
                }
            });
        }
        function oE(a) {
            var b, c, d;
            return H(function(e) {
                return e.h == 1 ? (b = Xb(), c = b.Pa(), c !== "CAST" ? e.B(2) : e.g(rE(a), 3)) : e.h != 2 ? (d = e.i, e.return(d)) : e.return(Si(a.contentType));
            });
        }
        function pE(a) {
            var b, c, d, e, f;
            return H(function(g) {
                switch(g.h){
                    case 1:
                        b = Xb();
                        c = b.Pa();
                        d = a.contentType;
                        if (c !== "CAST" || !a.spatialRendering) {
                            g.B(2);
                            break;
                        }
                        d += "; spatialRendering=true";
                        if (!(window1.cast && cast.__platform__ && cast.__platform__.canDisplayType)) {
                            g.B(2);
                            break;
                        }
                        e = !1;
                        f = sE;
                        if (f.has(d)) {
                            e = f.get(d);
                            g.B(4);
                            break;
                        }
                        return g.g(cast.__platform__.canDisplayType(d), 5);
                    case 5:
                        e = g.i, f.set(d, e);
                    case 4:
                        return g.return(e);
                    case 2:
                        return g.return(Si(d));
                }
            });
        }
        function qE(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t;
            return H(function(v) {
                switch(v.h){
                    case 1:
                        d = [];
                        e = [];
                        f = [];
                        c.audio && (g = {
                            robustness: c.audio.robustness || "",
                            contentType: b.contentType
                        }, Xb().rj() && b.contentType.includes('codecs="ac-3"') && (g.contentType = 'audio/mp4; codecs="ec-3"'), c.audio.encryptionScheme && (g.encryptionScheme = c.audio.encryptionScheme, f.push(c.audio.encryptionScheme)), d.push(g));
                        c.video && (h = {
                            robustness: c.video.robustness || "",
                            contentType: a.contentType
                        }, c.video.encryptionScheme && (h.encryptionScheme = c.video.encryptionScheme, f.push(c.video.encryptionScheme)), e.push(h));
                        k = {
                            initDataTypes: [
                                c.initDataType
                            ],
                            distinctiveIdentifier: c.distinctiveIdentifier,
                            persistentState: c.persistentState,
                            sessionTypes: c.sessionTypes
                        };
                        d.length && (k.audioCapabilities = d);
                        e.length && (k.videoCapabilities = e);
                        l = a ? a.contentType : "";
                        m = b ? b.contentType : "";
                        n = Ff(l) + ";" + Ef(l);
                        q = Ff(m) + ";" + Ef(m);
                        r = c.keySystem;
                        t = null;
                        v.m(2);
                        var w = Sb(n, q, r, f);
                        if (Ub.has(w)) {
                            w = Sb(n, q, r, f);
                            t = Ub.get(w) || null;
                            v.B(4);
                            break;
                        }
                        return v.g(navigator.requestMediaKeySystemAccess(c.keySystem, [
                            k
                        ]), 5);
                    case 5:
                        w = t = v.i;
                        var x = Sb(n, q, r, f);
                        Ub.set(x, w);
                    case 4:
                        v.o(3);
                        break;
                    case 2:
                        v.l();
                    case 3:
                        return v.return(t);
                }
            });
        }
        function rE(a) {
            var b, c, d, e, f;
            return H(function(g) {
                if (g.h == 1) {
                    if (!(window1.cast && cast.__platform__ && cast.__platform__.canDisplayType)) return g.return(Si(a.contentType));
                    b = a.contentType;
                    a.width && a.height && a.width > 1280 && a.height > 720 && (b += "; width=" + a.width + "; height=" + a.height);
                    a.framerate && (c = Math.round(a.framerate), c < 24 || c > 30) && (b += "; framerate=" + a.framerate);
                    d = a.transferFunction || "";
                    switch(d){
                        case "":
                        case "srgb":
                            break;
                        case "pq":
                            b += "; eotf=smpte2084";
                            break;
                        case "hlg":
                            b += "; eotf=arib-std-b67";
                            break;
                        default:
                            return g.return(!1);
                    }
                    e = !1;
                    f = sE;
                    return f.has(b) ? (e = f.get(b), g.B(2)) : g.g(cast.__platform__.canDisplayType(b), 3);
                }
                g.h != 2 && (e = g.i, f.set(b, e));
                return g.return(e);
            });
        }
        MD.MediaCapabilities = lE;
        lE.install = mE;
        lE.originalMcap = null;
        var sE = new Map;
        PD(mE, -1);
        function tE() {}
        function uE() {
            var a = Xb(), b = a.Ma() === "WEBKIT" ? a.Ja() : null;
            (window1.MediaSource || window1.ManagedMediaSource) && b && window1.MediaSource && (b <= 12 ? (vE(), wE()) : b <= 15 && vE());
            a = u(a.Aj());
            for(b = a.next(); !b.done; b = a.next())xE(b.value);
            (window1.MediaSource || window1.ManagedMediaSource) && yE();
            window1.MediaSource && MediaSource.isTypeSupported('video/webm; codecs="vp9"') && !MediaSource.isTypeSupported('video/webm; codecs="vp09.00.10.08"') && zE();
        }
        function vE() {
            var a = MediaSource.prototype.addSourceBuffer;
            MediaSource.prototype.addSourceBuffer = function() {
                var b = a.apply(this, Ma.apply(0, arguments));
                b.abort = function() {};
                return b;
            };
        }
        function wE() {
            var a = SourceBuffer.prototype.remove;
            SourceBuffer.prototype.remove = function(b, c) {
                return a.call(this, b, c - .001);
            };
        }
        function yE() {
            if (window1.MediaSource) {
                var a = MediaSource.isTypeSupported.bind(MediaSource);
                MediaSource.isTypeSupported = function(c) {
                    return Bf(c) != "mp2t" && a(c);
                };
            }
            if (window1.ManagedMediaSource) {
                var b = ManagedMediaSource.isTypeSupported.bind(ManagedMediaSource);
                window1.ManagedMediaSource.isTypeSupported = function(c) {
                    return Bf(c) != "mp2t" && b(c);
                };
            }
        }
        function xE(a) {
            var b = MediaSource.isTypeSupported.bind(MediaSource);
            MediaSource.isTypeSupported = function(d) {
                return Ef(d) != a && b(d);
            };
            if (window1.ManagedMediaSource) {
                var c = ManagedMediaSource.isTypeSupported.bind(ManagedMediaSource);
                window1.ManagedMediaSource.isTypeSupported = function(d) {
                    return Ef(d) != a && c(d);
                };
            }
        }
        function zE() {
            var a = MediaSource.isTypeSupported;
            Xb().bk() && (MediaSource.isTypeSupported = function(b) {
                var c = b.split(/ *; */), d = c.findIndex(function(g) {
                    return g.startsWith("codecs=");
                });
                if (d < 0) return a(b);
                var e = c[d].replace("codecs=", "").replace(/"/g, "").split(/\s*,\s*/), f = e.findIndex(function(g) {
                    return g.startsWith("vp09");
                });
                f >= 0 && (e[f] = "vp9", c[d] = 'codecs="' + e.join(",") + '"', b = c.join("; "));
                return a(b);
            });
        }
        MD.MediaSource = tE;
        tE.install = uE;
        PD(uE);
        function AE() {}
        function BE() {
            screen.orientation && screen.orientation.unlock || (screen.orientation != void 0 ? CE() : window1.orientation != void 0 && DE());
        }
        function CE() {
            var a = Object.getPrototypeOf(screen.orientation);
            screen.orientation.lock === void 0 && (a.lock = function() {
                return Promise.resolve();
            });
            screen.orientation.unlock === void 0 && (a.unlock = function() {});
        }
        function DE() {
            function a() {
                switch(window1.orientation){
                    case -90:
                        b.type = "landscape-secondary";
                        b.angle = 270;
                        break;
                    case 0:
                        b.type = "portrait-primary";
                        b.angle = 0;
                        break;
                    case 90:
                        b.type = "landscape-primary";
                        b.angle = 90;
                        break;
                    case 180:
                        b.type = "portrait-secondary", b.angle = 180;
                }
            }
            var b = new EE;
            screen.orientation = b;
            a();
            window1.addEventListener("orientationchange", function() {
                a();
                var c = new R("change");
                b.dispatchEvent(c);
            });
        }
        MD.Orientation = AE;
        AE.install = BE;
        function EE() {
            fb.call(this);
            this.type = "";
            this.angle = 0;
        }
        oa(EE, fb);
        EE.prototype.lock = function(a) {
            function b(d) {
                return screen.lockOrientation ? screen.lockOrientation(d) : screen.mozLockOrientation ? screen.mozLockOrientation(d) : !1;
            }
            var c = !1;
            switch(a){
                case "natural":
                    c = b("default");
                    break;
                case "any":
                    c = !0;
                    this.unlock();
                    break;
                default:
                    c = b(a);
            }
            if (c) return Promise.resolve();
            a = Error("screen.orientation.lock() is not available on this device");
            a.name = "NotSupportedError";
            a.code = DOMException.NOT_SUPPORTED_ERR;
            return Promise.reject(a);
        };
        EE.prototype.unlock = function() {
            screen.unlockOrientation ? screen.unlockOrientation() : screen.mozUnlockOrientation && screen.mozUnlockOrientation();
        };
        PD(BE);
        function FE() {}
        var GE, HE, IE, JE, KE, LE;
        function ME(a) {
            if (window1.HTMLVideoElement && window1.WebKitMediaKeys && window1.shakaMediaKeysPolyfill != NE) {
                if (a === void 0 ? 0 : a) GE = !0, HE = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, "mediaKeys"), IE = HTMLMediaElement.prototype.setMediaKeys, JE = window1.MediaKeys, KE = window1.MediaKeySystemAccess, LE = navigator.requestMediaKeySystemAccess;
                delete HTMLMediaElement.prototype.mediaKeys;
                HTMLMediaElement.prototype.mediaKeys = null;
                HTMLMediaElement.prototype.setMediaKeys = OE;
                window1.MediaKeys = PE;
                window1.MediaKeySystemAccess = QE;
                navigator.requestMediaKeySystemAccess = RE;
                window1.shakaMediaKeysPolyfill = NE;
                og.clear();
                Ub.clear();
            }
        }
        function RE(a, b) {
            try {
                var c = new QE(a, b);
                return Promise.resolve(c);
            } catch (d) {
                return Promise.reject(d);
            }
        }
        function OE(a) {
            var b = this.mediaKeys;
            b && b != a && SE(b, null);
            delete this.mediaKeys;
            return (this.mediaKeys = a) ? SE(a, this) : Promise.resolve();
        }
        function TE(a) {
            a = Fb(a.initData);
            if (Jb(a).getUint32(0, !0) + 4 != a.byteLength) throw new RangeError("Malformed FairPlay init data");
            a = cc(a.subarray(4), !0);
            a = hc(a);
            var b = new Event("encrypted");
            b.initDataType = "skd";
            b.initData = Gb(a);
            this.dispatchEvent(b);
        }
        MD.PatchedMediaKeysApple = FE;
        FE.uninstall = function() {
            window1.shakaMediaKeysPolyfill == NE && GE && (GE = !1, Object.defineProperty(HTMLMediaElement.prototype, "mediaKeys", HE), HTMLMediaElement.prototype.setMediaKeys = IE, window1.MediaKeys = JE, window1.MediaKeySystemAccess = KE, navigator.requestMediaKeySystemAccess = LE, HE = LE = IE = KE = JE = null, window1.shakaMediaKeysPolyfill = "", og.clear(), Ub.clear());
        };
        FE.install = ME;
        function QE(a, b) {
            this.keySystem = a;
            if (a.startsWith("com.apple.fps")) for(a = u(b), b = a.next(); !b.done; b = a.next()){
                var c = b.value;
                if (c.persistentState == "required") b = null;
                else {
                    b = {
                        audioCapabilities: [],
                        videoCapabilities: [],
                        persistentState: "optional",
                        distinctiveIdentifier: "optional",
                        initDataTypes: c.initDataTypes,
                        sessionTypes: [
                            "temporary"
                        ],
                        label: c.label
                    };
                    var d = !1, e = !1;
                    if (c.audioCapabilities) for(var f = u(c.audioCapabilities), g = f.next(); !g.done; g = f.next())g = g.value, g.contentType && (d = !0, WebKitMediaKeys.isTypeSupported(this.keySystem, g.contentType.split(";")[0]) && (b.audioCapabilities.push(g), e = !0));
                    if (c.videoCapabilities) for(c = u(c.videoCapabilities), f = c.next(); !f.done; f = c.next())f = f.value, f.contentType && (d = !0, WebKitMediaKeys.isTypeSupported(this.keySystem, f.contentType.split(";")[0]) && (b.videoCapabilities.push(f), e = !0));
                    d || (e = WebKitMediaKeys.isTypeSupported(this.keySystem, "video/mp4"));
                    b = e ? b : null;
                }
                if (b) {
                    this.g = b;
                    return;
                }
            }
            a = Error("Unsupported keySystem");
            a.name = "NotSupportedError";
            a.code = DOMException.NOT_SUPPORTED_ERR;
            throw a;
        }
        QE.prototype.createMediaKeys = function() {
            var a = new PE(this.keySystem);
            return Promise.resolve(a);
        };
        QE.prototype.getConfiguration = function() {
            return this.g;
        };
        function PE(a) {
            this.h = new WebKitMediaKeys(a);
            this.g = new fd;
        }
        PE.prototype.createSession = function(a) {
            a = a || "temporary";
            if (a != "temporary") throw new TypeError("Session type " + a + " is unsupported on this platform.");
            return new UE(this.h, a);
        };
        PE.prototype.setServerCertificate = function() {
            return Promise.resolve(!1);
        };
        function SE(a, b) {
            a.g.Ta();
            if (!b) return Promise.resolve();
            a.g.u(b, "webkitneedkey", TE);
            try {
                return em(b, HTMLMediaElement.HAVE_METADATA, a.g, function() {
                    b.webkitSetMediaKeys(a.h);
                }), Promise.resolve();
            } catch (c) {
                return Promise.reject(c);
            }
        }
        PE.prototype.getStatusForPolicy = function() {
            return Promise.resolve("usable");
        };
        function UE(a) {
            fb.call(this);
            this.i = null;
            this.l = a;
            this.g = this.h = null;
            this.j = new fd;
            this.sessionId = "";
            this.expiration = NaN;
            this.closed = new Yg;
            this.keyStatuses = new VE;
            this.onkeystatuseschange = null;
        }
        oa(UE, fb);
        p = UE.prototype;
        p.generateRequest = function(a, b) {
            var c = this;
            this.h = new Yg;
            try {
                var d = this.l.createSession("video/mp4", Fb(b));
                this.i = d;
                this.sessionId = d.sessionId || "";
                this.j.u(this.i, "webkitkeymessage", function(e) {
                    c.h && (c.h.resolve(), c.h = null);
                    e = (new Map).set("messageType", c.keyStatuses.ec() == void 0 ? "license-request" : "license-renewal").set("message", Gb(e.message));
                    e = new R("message", e);
                    c.dispatchEvent(e);
                });
                this.j.u(d, "webkitkeyadded", function() {
                    c.g && (WE(c, "usable"), c.g.resolve(), c.g = null);
                });
                this.j.u(d, "webkitkeyerror", function() {
                    var e = Error("EME PatchedMediaKeysApple key error");
                    e.errorCode = c.i.error;
                    if (c.h != null) c.h.reject(e), c.h = null;
                    else if (c.g != null) c.g.reject(e), c.g = null;
                    else switch(c.i.error.code){
                        case WebKitMediaKeyError.MEDIA_KEYERR_OUTPUT:
                        case WebKitMediaKeyError.MEDIA_KEYERR_HARDWARECHANGE:
                            WE(c, "output-not-allowed");
                            break;
                        default:
                            WE(c, "internal-error");
                    }
                });
                WE(this, "status-pending");
            } catch (e) {
                this.h.reject(e);
            }
            return this.h;
        };
        p.load = function() {
            return Promise.reject(Error("MediaKeySession.load not yet supported"));
        };
        p.update = function(a) {
            this.g = new Yg;
            try {
                this.i.update(Fb(a));
            } catch (b) {
                this.g.reject(b);
            }
            return this.g;
        };
        p.close = function() {
            try {
                this.i.close(), this.closed.resolve(), this.j.Ta();
            } catch (a) {
                this.closed.reject(a);
            }
            return this.closed;
        };
        p.remove = function() {
            return Promise.reject(Error("MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform"));
        };
        function WE(a, b) {
            var c = a.keyStatuses;
            c.size = b == void 0 ? 0 : 1;
            c.g = b;
            b = new R("keystatuseschange");
            a.dispatchEvent(b);
            if (a.onkeystatuseschange) a.onkeystatuseschange(b);
        }
        function VE() {
            this.size = 0;
            this.g = void 0;
        }
        p = VE.prototype;
        p.ec = function() {
            return this.g;
        };
        p.forEach = function(a) {
            this.g && a(this.g, Tb.value());
        };
        p.get = function(a) {
            if (this.has(a)) return this.g;
        };
        p.has = function(a) {
            var b = Tb.value();
            return this.g && Eb(a, b) ? !0 : !1;
        };
        p.entries = function() {};
        p.keys = function() {};
        p.values = function() {};
        var NE = "apple";
        PD(function() {
            window1.HTMLVideoElement && window1.WebKitMediaKeys && (navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration || ME());
        });
        function XE() {}
        function YE() {
            if (window1.MediaKeys) {
                var a = Xb();
                MediaKeys.prototype.setServerCertificate && a.Je() || (MediaKeys.prototype.setServerCertificate = ZE);
            }
        }
        function ZE() {
            return Promise.resolve(!1);
        }
        MD.PatchedMediaKeysCert = XE;
        XE.install = YE;
        PD(YE);
        function $E() {}
        function aF() {
            if (!(!window1.HTMLVideoElement || navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration)) {
                if (HTMLMediaElement.prototype.webkitGenerateKeyRequest) bF = "webkit";
                else if (!HTMLMediaElement.prototype.generateKeyRequest) return;
                navigator.requestMediaKeySystemAccess = cF;
                delete HTMLMediaElement.prototype.mediaKeys;
                HTMLMediaElement.prototype.mediaKeys = null;
                HTMLMediaElement.prototype.setMediaKeys = dF;
                window1.MediaKeys = eF;
                window1.MediaKeySystemAccess = fF;
                window1.shakaMediaKeysPolyfill = gF;
            }
        }
        function hF(a) {
            var b = bF;
            return b ? b + a.charAt(0).toUpperCase() + a.slice(1) : a;
        }
        function cF(a, b) {
            try {
                var c = new fF(a, b);
                return Promise.resolve(c);
            } catch (d) {
                return Promise.reject(d);
            }
        }
        function dF(a) {
            var b = this.mediaKeys;
            b && b != a && iF(b, null);
            delete this.mediaKeys;
            (this.mediaKeys = a) && iF(a, this);
            return Promise.resolve();
        }
        MD.PatchedMediaKeysWebkit = $E;
        $E.install = aF;
        function fF(a, b) {
            this.g = this.keySystem = a;
            var c = !1;
            a == "org.w3.clearkey" && (this.g = "webkit-org.w3.clearkey", c = !1);
            var d = !1;
            var e = document.getElementsByTagName("video");
            e = e.length ? e[0] : document.createElement("video");
            b = u(b);
            for(var f = b.next(); !f.done; f = b.next()){
                f = f.value;
                var g = {
                    audioCapabilities: [],
                    videoCapabilities: [],
                    persistentState: "optional",
                    distinctiveIdentifier: "optional",
                    initDataTypes: f.initDataTypes,
                    sessionTypes: [
                        "temporary"
                    ],
                    label: f.label
                }, h = !1;
                if (f.audioCapabilities) for(var k = u(f.audioCapabilities), l = k.next(); !l.done; l = k.next())l = l.value, l.contentType && (h = !0, e.canPlayType(l.contentType.split(";")[0], this.g) && (g.audioCapabilities.push(l), d = !0));
                if (f.videoCapabilities) for(k = u(f.videoCapabilities), l = k.next(); !l.done; l = k.next())l = l.value, l.contentType && (h = !0, e.canPlayType(l.contentType, this.g) && (g.videoCapabilities.push(l), d = !0));
                h || (d = e.canPlayType("video/mp4", this.g) || e.canPlayType("video/webm", this.g));
                f.persistentState == "required" && (c ? (g.persistentState = "required", g.sessionTypes = [
                    "persistent-license"
                ]) : d = !1);
                if (d) {
                    this.h = g;
                    return;
                }
            }
            c = "Unsupported keySystem";
            if (a == "org.w3.clearkey" || a == "com.widevine.alpha") c = "None of the requested configurations were supported.";
            a = Error(c);
            a.name = "NotSupportedError";
            a.code = DOMException.NOT_SUPPORTED_ERR;
            throw a;
        }
        fF.prototype.createMediaKeys = function() {
            var a = new eF(this.g);
            return Promise.resolve(a);
        };
        fF.prototype.getConfiguration = function() {
            return this.h;
        };
        function eF(a) {
            this.l = a;
            this.h = null;
            this.g = new fd;
            this.i = [];
            this.j = new Map;
        }
        function iF(a, b) {
            a.h = b;
            a.g.Ta();
            var c = bF;
            b && (a.g.u(b, c + "needkey", function(d) {
                var e = new CustomEvent("encrypted");
                e.initDataType = "cenc";
                e.initData = Gb(d.initData);
                a.h.dispatchEvent(e);
            }), a.g.u(b, c + "keymessage", function(d) {
                var e = jF(a, d.sessionId);
                e && (d = (new Map).set("messageType", e.keyStatuses.ec() == void 0 ? "licenserequest" : "licenserenewal").set("message", d.message), d = new R("message", d), e.h && (e.h.resolve(), e.h = null), e.dispatchEvent(d));
            }), a.g.u(b, c + "keyadded", function(d) {
                (d = jF(a, d.sessionId)) && d.ready();
            }), a.g.u(b, c + "keyerror", function(d) {
                var e = jF(a, d.sessionId);
                if (e) {
                    var f = Error("EME v0.1b key error"), g = d.errorCode;
                    g.systemCode = d.systemCode;
                    f.errorCode = g;
                    !d.sessionId && e.h ? (d.systemCode == 45 && (f.message = "Unsupported session type."), e.h.reject(f), e.h = null) : d.sessionId && e.g ? (e.g.reject(f), e.g = null) : (f = d.systemCode, d.errorCode.code == MediaKeyError.MEDIA_KEYERR_OUTPUT ? kF(e, "output-restricted") : f == 1 ? kF(e, "expired") : kF(e, "internal-error"));
                }
            }));
        }
        eF.prototype.createSession = function(a) {
            a = a || "temporary";
            if (a != "temporary" && a != "persistent-license") throw new TypeError("Session type " + a + " is unsupported on this platform.");
            var b = this.h || document.createElement("video");
            b.src || (b.src = "about:blank");
            a = new lF(b, this.l, a);
            this.i.push(a);
            return a;
        };
        eF.prototype.setServerCertificate = function() {
            return Promise.resolve(!1);
        };
        eF.prototype.getStatusForPolicy = function() {
            return Promise.resolve("usable");
        };
        function jF(a, b) {
            var c = a.j.get(b);
            return c ? c : (c = a.i.shift()) ? (c.sessionId = b, a.j.set(b, c), c) : null;
        }
        function lF(a, b, c) {
            fb.call(this);
            this.j = a;
            this.m = !1;
            this.g = this.h = null;
            this.i = b;
            this.l = c;
            this.sessionId = "";
            this.expiration = NaN;
            this.closed = new Yg;
            this.keyStatuses = new mF;
            this.onkeystatuseschange = null;
        }
        oa(lF, fb);
        p = lF.prototype;
        p.ready = function() {
            kF(this, "usable");
            this.g && this.g.resolve();
            this.g = null;
        };
        function nF(a, b, c) {
            if (a.m) return Promise.reject(Error("The session is already initialized."));
            a.m = !0;
            try {
                if (a.l == "persistent-license") {
                    if (c) var d = Fb(hc("LOAD_SESSION|" + c));
                    else {
                        var e = hc("PERSISTENT|");
                        d = tc(e, b);
                    }
                } else d = Fb(b);
            } catch (g) {
                return Promise.reject(g);
            }
            a.h = new Yg;
            var f = hF("generateKeyRequest");
            try {
                a.j[f](a.i, d);
            } catch (g) {
                if (g.name != "InvalidStateError") return a.h = null, Promise.reject(g);
                new Uf(function() {
                    try {
                        a.j[f](a.i, d);
                    } catch (h) {
                        a.h.reject(h), a.h = null;
                    }
                }).Z(.01);
            }
            return a.h;
        }
        function oF(a, b, c) {
            if (a.g) a.g.then(function() {
                return oF(a, b, c);
            }).catch(function() {
                return oF(a, b, c);
            });
            else {
                a.g = b;
                if (a.i == "webkit-org.w3.clearkey") {
                    var d = bc(c);
                    var e = JSON.parse(d);
                    e.keys[0].kty != "oct" && (a.g.reject(Error("Response is not a valid JSON Web Key Set.")), a.g = null);
                    d = qc(e.keys[0].k);
                    e = qc(e.keys[0].kid);
                } else d = Fb(c), e = null;
                var f = hF("addKey");
                try {
                    a.j[f](a.i, d, e, a.sessionId);
                } catch (g) {
                    a.g.reject(g), a.g = null;
                }
            }
        }
        function kF(a, b) {
            var c = a.keyStatuses;
            c.size = b == void 0 ? 0 : 1;
            c.g = b;
            b = new R("keystatuseschange");
            a.dispatchEvent(b);
            if (a.onkeystatuseschange) a.onkeystatuseschange(b);
        }
        p.generateRequest = function(a, b) {
            return nF(this, b, null);
        };
        p.load = function(a) {
            return this.l == "persistent-license" ? nF(this, null, a) : Promise.reject(Error("Not a persistent session."));
        };
        p.update = function(a) {
            var b = new Yg;
            oF(this, b, a);
            return b;
        };
        p.close = function() {
            if (this.l != "persistent-license") {
                if (!this.sessionId) return this.closed.reject(Error("The session is not callable.")), this.closed;
                var a = hF("cancelKeyRequest");
                try {
                    this.j[a](this.i, this.sessionId);
                } catch (b) {}
            }
            this.closed.resolve();
            return this.closed;
        };
        p.remove = function() {
            return this.l != "persistent-license" ? Promise.reject(Error("Not a persistent session.")) : this.close();
        };
        function mF() {
            this.size = 0;
            this.g = void 0;
        }
        p = mF.prototype;
        p.ec = function() {
            return this.g;
        };
        p.forEach = function(a) {
            this.g && a(this.g, Tb.value());
        };
        p.get = function(a) {
            if (this.has(a)) return this.g;
        };
        p.has = function(a) {
            var b = Tb.value();
            return this.g && Eb(a, b) ? !0 : !1;
        };
        p.entries = function() {};
        p.keys = function() {};
        p.values = function() {};
        var bF = "", gF = "webkit";
        PD(aF);
        function pF() {}
        function qF() {
            if (window1.HTMLVideoElement) {
                var a = HTMLVideoElement.prototype;
                a.requestPictureInPicture && document.exitPictureInPicture || !a.webkitSupportsPresentationMode || (document.pictureInPictureEnabled = !0, document.pictureInPictureElement = null, a.requestPictureInPicture = rF, Object.defineProperty(a, "disablePictureInPicture", {
                    get: sF,
                    set: tF,
                    enumerable: !0,
                    configurable: !0
                }), document.exitPictureInPicture = uF, document.addEventListener("webkitpresentationmodechanged", vF, !0));
            }
        }
        function vF(a) {
            a = a.target;
            if (a.webkitPresentationMode == "picture-in-picture") {
                document.pictureInPictureElement = a;
                var b = new Event("enterpictureinpicture");
                a.dispatchEvent(b);
            } else document.pictureInPictureElement == a && (document.pictureInPictureElement = null), b = new Event("leavepictureinpicture"), a.dispatchEvent(b);
        }
        function rF() {
            return this.webkitSupportsPresentationMode("picture-in-picture") ? (this.webkitSetPresentationMode("picture-in-picture"), document.pictureInPictureElement = this, Promise.resolve()) : Promise.reject(Error("PiP not allowed by video element"));
        }
        function uF() {
            var a = document.pictureInPictureElement;
            return a ? (a.webkitSetPresentationMode("inline"), document.pictureInPictureElement = null, Promise.resolve()) : Promise.reject(Error("No picture in picture element found"));
        }
        function sF() {
            return this.hasAttribute("disablePictureInPicture") ? !0 : !this.webkitSupportsPresentationMode("picture-in-picture");
        }
        function tF(a) {
            a ? this.setAttribute("disablePictureInPicture", "") : this.removeAttribute("disablePictureInPicture");
        }
        MD.PiPWebkit = pF;
        pF.install = qF;
        PD(qF);
        function wF() {}
        function xF() {
            window1.crypto && ("randomUUID" in window1.crypto || (window1.crypto.randomUUID = yF));
        }
        function yF() {
            var a = URL.createObjectURL(new Blob), b = a.toString();
            URL.revokeObjectURL(a);
            return b.substr(b.lastIndexOf("/") + 1);
        }
        MD.RandomUUID = wF;
        wF.install = xF;
        PD(xF);
        function zF() {}
        function AF() {
            var a = Symbol.prototype;
            "description" in a || Object.defineProperty(a, "description", {
                get: BF
            });
        }
        function BF() {
            var a = /\((.*)\)/.exec(this.toString());
            return a ? a[1] : void 0;
        }
        MD.Symbol = zF;
        zF.install = AF;
        PD(AF);
        function CF() {}
        function DF() {
            for(var a = u([
                Uint8Array,
                Uint8ClampedArray,
                Uint16Array,
                Uint32Array,
                Int8Array,
                Int16Array,
                Int32Array,
                Float32Array,
                Float64Array
            ]), b = a.next(); !b.done; b = a.next()){
                b = b.value;
                var c = void 0;
                (c = b.prototype).indexOf != null || (c.indexOf = Array.prototype.indexOf);
                c = void 0;
                (c = b.prototype).lastIndexOf != null || (c.lastIndexOf = Array.prototype.lastIndexOf);
                c = void 0;
                (c = b.prototype).includes != null || (c.includes = Array.prototype.includes);
            }
        }
        MD.TypedArray = CF;
        CF.install = DF;
        PD(DF);
        function EF() {}
        function FF() {
            if (window1.HTMLMediaElement) {
                var a = HTMLMediaElement.prototype.play;
                HTMLMediaElement.prototype.play = function() {
                    var b = a.apply(this);
                    b && b.catch(function() {});
                    return b;
                };
            }
        }
        MD.VideoPlayPromise = EF;
        EF.install = FF;
        PD(FF);
        function GF() {}
        function HF() {
            if (window1.HTMLVideoElement) {
                var a = HTMLVideoElement.prototype;
                !a.getVideoPlaybackQuality && ("webkitDroppedFrameCount" in a || typeof Bd().webkitDroppedFrameCount === "number") && (a.getVideoPlaybackQuality = IF);
            }
        }
        function IF() {
            return {
                droppedVideoFrames: this.webkitDroppedFrameCount,
                totalVideoFrames: this.webkitDecodedFrameCount,
                corruptedVideoFrames: 0,
                creationTime: NaN,
                totalFrameDelay: 0
            };
        }
        MD.VideoPlaybackQuality = GF;
        GF.install = HF;
        PD(HF);
        function JF() {}
        function KF() {
            if (!window1.VTTCue && window1.TextTrackCue) {
                var a = null, b = TextTrackCue.length;
                if (b == 3) a = LF;
                else if (b == 6) a = MF;
                else {
                    try {
                        var c = !!LF(1, 2, "");
                    } catch (d) {
                        c = !1;
                    }
                    c && (a = LF);
                }
                a && (window1.VTTCue = function(d, e, f) {
                    return a(d, e, f);
                });
            }
        }
        function LF(a, b, c) {
            return new window1.TextTrackCue(a, b, c);
        }
        function MF(a, b, c) {
            return new window1.TextTrackCue(a + "-" + b + "-" + c, a, b, c);
        }
        MD.VTTCue = JF;
        JF.install = KF;
        PD(KF);
        function NF(a) {
            fb.call(this);
            this.g = a;
            this.m = null;
            this.h = [];
            this.j = -1;
            this.i = this.l = null;
            this.o = new fd;
        }
        oa(NF, fb);
        p = NF.prototype;
        p.destroy = function() {
            var a = this;
            return H(function(b) {
                if (b.h == 1) return b.g(a.removeAllItems(), 2);
                a.g = null;
                a.o && (a.o.release(), a.o = null);
                fb.prototype.release.call(a);
                b.j();
            });
        };
        p.configure = function(a) {
            this.m = a;
        };
        p.getConfiguration = function() {
            return this.m;
        };
        p.getCurrentItem = function() {
            return this.h.length && this.j >= 0 && this.j < this.h.length ? this.h[this.j] : null;
        };
        p.getCurrentItemIndex = function() {
            return this.j;
        };
        p.getItems = function() {
            return this.h.slice();
        };
        p.insertItems = function(a) {
            this.h.push.apply(this.h, G(a));
            this.dispatchEvent(new R("itemsinserted"));
        };
        p.removeAllItems = function() {
            var a = this, b, c, d, e;
            return H(function(f) {
                if (f.h == 1) return a.o.Ta(), a.h.length && a.j >= 0 ? f.g(a.g.tc(), 2) : f.B(2);
                if (f.h != 4) {
                    b = [];
                    a.i && (a.i.preloadManager.l || b.push(a.i.preloadManager.destroy()), a.i = null);
                    a.l && (a.l.preloadManager.l || b.push(a.l.preloadManager.destroy()), a.l = null);
                    c = u(a.h);
                    for(d = c.next(); !d.done; d = c.next())e = d.value, e.preloadManager && !e.preloadManager.l && b.push(e.preloadManager.destroy());
                    return b.length ? f.g(Promise.all(b), 4) : f.B(4);
                }
                a.h = [];
                a.j = -1;
                a.dispatchEvent(new R("itemsremoved"));
                f.j();
            });
        };
        p.playItem = function(a) {
            var b = this, c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y;
            return H(function(z) {
                switch(z.h){
                    case 1:
                        b.o.Ta();
                        if (!b.h.length || a >= b.h.length) throw new T(2, 7, 7007);
                        c = b.getCurrentItem();
                        d = b.h[a];
                        b.j != a && (b.j = a, b.dispatchEvent(new R("currentitemchanged")));
                        e = b.g.vf();
                        f = b.m ? b.m.preloadNextUrlWindow : 0;
                        f > 0 && (g = !1, b.o.u(e, "timeupdate", function() {
                            var A, E, C, D;
                            return H(function(B) {
                                switch(B.h){
                                    case 1:
                                        if (b.l || b.h.length <= 1 || g || b.g.U() || !e.duration) return B.return();
                                        A = b.g.wa().end - e.currentTime;
                                        if (isNaN(A)) {
                                            B.B(0);
                                            break;
                                        }
                                        if (!(A <= f)) {
                                            B.B(0);
                                            break;
                                        }
                                        E = b.m && b.m.repeatMode;
                                        C = null;
                                        b.j + 1 < b.h.length ? C = b.h[b.j + 1] : E == 1 && (C = b.h[0]);
                                        if (!C || C.preloadManager && !C.preloadManager.l) {
                                            B.B(0);
                                            break;
                                        }
                                        g = !0;
                                        D = null;
                                        B.m(5);
                                        return B.g(b.g.preload(C.manifestUri, C.startTime, C.mimeType, C.config), 7);
                                    case 7:
                                        D = B.i;
                                        B.o(6);
                                        break;
                                    case 5:
                                        B.l(), D = null;
                                    case 6:
                                        b.l = {
                                            item: C,
                                            preloadManager: D
                                        }, g = !1, B.j();
                                }
                            });
                        }));
                        b.o.u(b.g, "complete", function() {
                            var A = b.m && b.m.repeatMode, E = !1;
                            if (A == 2) E = !0;
                            else {
                                var C = b.j + 1;
                                C < b.h.length ? b.playItem(C) : A == 1 && (b.h.length == 1 ? E = !0 : b.playItem(0));
                            }
                            E && (e.paused ? (e.currentTime = b.g.wa().start, e.play()) : b.o.u(e, "paused", function() {
                                e.currentTime = b.g.wa().start;
                                e.play();
                            }));
                        });
                        h = d.manifestUri;
                        d.preloadManager && !d.preloadManager.l && (h = d.preloadManager);
                        k = !1;
                        b.l && b.l.item == d && b.l.preloadManager ? h = b.l.preloadManager : b.i && b.i.item == d && b.i.preloadManager && (h = b.i.preloadManager, k = !0);
                        if (!b.i) {
                            z.B(2);
                            break;
                        }
                        if (k || b.i.preloadManager.l) {
                            z.B(3);
                            break;
                        }
                        return z.g(b.i.preloadManager.destroy(), 3);
                    case 3:
                        b.i = null;
                    case 2:
                        if (!(b.m && b.m.preloadPrevItem && c && b.g.xc() === ms)) {
                            z.B(5);
                            break;
                        }
                        l = null;
                        z.m(6);
                        return z.g(b.g.gk(), 8);
                    case 8:
                        l = z.i;
                        z.o(7);
                        break;
                    case 6:
                        z.l(), l = null;
                    case 7:
                        b.i = {
                            item: c,
                            preloadManager: l
                        };
                    case 5:
                        return d.config && (b.g.Dj(), b.g.configure(d.config)), z.g(b.g.load(h, d.startTime, d.mimeType), 9);
                    case 9:
                        b.l = null;
                        if (d.extraText) for(m = u(d.extraText), n = m.next(); !n.done; n = m.next())q = n.value, q.mime ? b.g.fe(q.uri, q.language, q.kind, q.mime, q.codecs) : b.g.fe(q.uri, q.language, q.kind);
                        if (d.extraThumbnail) for(r = u(d.extraThumbnail), t = r.next(); !t.done; t = r.next())v = t.value, b.g.cf(v);
                        if (d.extraChapter) for(w = u(d.extraChapter), x = w.next(); !x.done; x = w.next())y = x.value, b.g.bf(y.uri, y.language, y.mime);
                        z.j();
                }
            });
        };
        O("shaka.queue.QueueManager", NF);
        NF.prototype.playItem = NF.prototype.playItem;
        NF.prototype.removeAllItems = NF.prototype.removeAllItems;
        NF.prototype.insertItems = NF.prototype.insertItems;
        NF.prototype.getItems = NF.prototype.getItems;
        NF.prototype.getCurrentItemIndex = NF.prototype.getCurrentItemIndex;
        NF.prototype.getCurrentItem = NF.prototype.getCurrentItem;
        NF.prototype.getConfiguration = NF.prototype.getConfiguration;
        NF.prototype.configure = NF.prototype.configure;
        NF.prototype.destroy = NF.prototype.destroy;
        tr = function(a) {
            return new NF(a);
        };
        function OF() {}
        OF.prototype.parseInit = function() {};
        OF.prototype.setSequenceMode = function() {};
        OF.prototype.setManifestType = function() {};
        OF.prototype.parseMedia = function(a, b) {
            var c = null, d = [];
            a = bc(a).split(/\r?\n/);
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next())if ((e = e.value) && !/^\s+$/.test(e) && (e = PF.exec(e))) {
                var f = QF.exec(e[1]);
                f = parseInt(f[1], 10) * 60 + parseFloat(f[2].replace(",", "."));
                e = new Ie(f, b.segmentEnd ? b.segmentEnd : f + 2, e[2]);
                c && (c.endTime = f, d.push(c));
                c = e;
            }
            c && d.push(c);
            return d;
        };
        O("shaka.text.LrcTextParser", OF);
        OF.prototype.parseMedia = OF.prototype.parseMedia;
        OF.prototype.setManifestType = OF.prototype.setManifestType;
        OF.prototype.setSequenceMode = OF.prototype.setSequenceMode;
        OF.prototype.parseInit = OF.prototype.parseInit;
        var PF = /^\[(\d{1,2}:\d{1,2}(?:[.,]\d{1,3})?)\](.*)/, QF = /^(\d+):(\d{1,2}(?:[.,]\d{1,3})?)$/;
        Jf("application/x-subtitle-lrc", function() {
            return new OF;
        });
        function RF() {
            this.g = "UNKNOWN";
        }
        RF.prototype.parseInit = function() {};
        RF.prototype.setSequenceMode = function() {};
        RF.prototype.setManifestType = function(a) {
            this.g = a;
        };
        RF.prototype.parseMedia = function(a, b, c, d) {
            var e = bc(a);
            a = [];
            if (e == "") return a;
            var f = ae(e, "tt", !0);
            if (!f) throw new T(2, 2, 2005, "Failed to parse TTML.");
            e = me(f, "body")[0];
            if (!e) return [];
            var g = se(f, SF, "frameRate"), h = se(f, SF, "subFrameRate"), k = se(f, SF, "frameRateMultiplier"), l = se(f, SF, "tickRate"), m = se(f, SF, "cellResolution"), n = f.attributes["xml:space"] || "default", q = se(f, TF, "extent");
            if (n != "default" && n != "preserve") throw new T(2, 2, 2005, "Invalid xml:space value: " + n);
            n = n == "default";
            g = new UF(g, h, k, l);
            m = VF(m);
            h = me(f, "metadata")[0];
            h = (h ? h.children : []).filter(function(v) {
                return v != "\n";
            });
            k = me(f, "style");
            f = me(f, "region");
            l = [];
            for(var r = u(f), t = r.next(); !t.done; t = r.next())(t = WF(this, t.value, k, q)) && l.push(t);
            if (ie(e, "p").length) throw new T(2, 2, 2001, "<p> can only be inside <div> in TTML");
            q = u(ie(e, "div"));
            for(r = q.next(); !r.done; r = q.next())if (ie(r.value, "span").length) throw new T(2, 2, 2001, "<span> can only be inside <p> in TTML");
            if (b = XF(this, e, b, g, h, k, f, l, n, m, null, !1, c, d)) b.backgroundColor || (b.backgroundColor = "transparent"), a.push(b);
            return a;
        };
        function XF(a, b, c, d, e, f, g, h, k, l, m, n, q, r) {
            var t = m;
            if (fe(b)) {
                if (!n) return null;
                var v = {
                    tagName: "span",
                    children: [
                        ke(b)
                    ],
                    attributes: {},
                    parent: null
                };
            } else v = b;
            for(var w = null, x = u(YF), y = x.next(); !y.done && !(w = ZF(v, "backgroundImage", e, "#", y.value)[0]); y = x.next());
            x = null;
            y = se(v, YF, "backgroundImage");
            var z = /^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/;
            if (y && z.test(y)) {
                x = parseInt(y.split(":").pop(), 10) - 1;
                if (x >= r.length) return null;
                x = r[x];
            } else q && y && !y.startsWith("#") && (z = new lb(q), y = new lb(y), (y = z.resolve(y).toString()) && (x = y));
            if (b.tagName == "p" || w || x) n = !0;
            b = n;
            y = (v.attributes["xml:space"] || (k ? "default" : "preserve")) == "default";
            z = v.children.every(fe);
            k = [];
            if (!z) for(var A = u(v.children), E = A.next(); !E.done; E = A.next())(E = XF(a, E.value, c, d, e, f, g, h, y, l, v, n, q, r)) && k.push(E);
            e = m != null;
            q = ke(v);
            q = v.children.length && q && /\S/.test(q);
            A = v.attributes.begin || v.attributes.end || v.attributes.dur;
            if (!(A || q || v.tagName == "br" || k.length != 0 || e && !y)) return null;
            r = $F(v, d);
            q = r.start;
            for(r = r.end; t && t.tagName && t.tagName != "tt";)r = aG(t, d, q, r), q = r.start, r = r.end, t = t.parent;
            q == null && (q = 0);
            q += c.periodStart;
            r = r == null ? Infinity : r + c.periodStart;
            a.g !== "HLS" && (q = Math.max(q, c.segmentStart), r = Math.min(r, c.segmentEnd));
            if (!A && k.length > 0) for(q = Infinity, r = 0, c = u(k), d = c.next(); !d.done; d = c.next())d = d.value, q = Math.min(q, d.startTime), r = Math.max(r, d.endTime);
            if (v.tagName == "br") return a = new Ie(q, r, ""), a.lineBreak = !0, a;
            c = "";
            z && (c = jc(ke(v) || ""), y && (c = c.replace(/\s+/g, " ")));
            c = new Ie(q, r, c);
            c.nestedCues = k;
            n || (c.isContainer = !0);
            l && (c.cellResolution = l);
            l = ZF(v, "region", g, "")[0];
            if (v.attributes.region && l && l.attributes["xml:id"]) {
                var C = l.attributes["xml:id"];
                c.region = h.filter(function(D) {
                    return D.id == C;
                })[0];
            }
            h = l;
            m && e && !v.attributes.region && !v.attributes.style && (h = ZF(m, "region", g, "")[0]);
            bG(a, c, v, h, w, x, f, b, k.length == 0);
            return c;
        }
        function WF(a, b, c, d) {
            var e = new Md, f = b.attributes["xml:id"];
            if (!f) return null;
            e.id = f;
            f = null;
            d && (f = cG.exec(d) || dG.exec(d));
            d = f ? Number(f[1]) : null;
            f = f ? Number(f[2]) : null;
            var g, h = eG(a, b, c, "extent");
            if (h) {
                var k = (g = cG.exec(h)) || dG.exec(h);
                k != null && (e.width = Number(k[1]), e.height = Number(k[2]), g || (d != null && (e.width = e.width * 100 / d), f != null && (e.height = e.height * 100 / f)), e.widthUnits = g || d != null ? Nd : 0, e.heightUnits = g || f != null ? Nd : 0);
            }
            if (a = eG(a, b, c, "origin")) {
                if (k = (g = cG.exec(a)) || dG.exec(a), k != null) e.viewportAnchorX = Number(k[1]), e.viewportAnchorY = Number(k[2]), g ? h || (e.width = 100 - e.viewportAnchorX, e.widthUnits = Nd, e.height = 100 - e.viewportAnchorY, e.heightUnits = Nd) : (f != null && (e.viewportAnchorY = e.viewportAnchorY * 100 / f), d != null && (e.viewportAnchorX = e.viewportAnchorX * 100 / d)), e.viewportAnchorUnits = g || d != null ? Nd : 0;
            }
            return e;
        }
        function fG(a) {
            var b = a.match(/rgba\(([^)]+)\)/);
            return b && (b = b[1].split(","), b.length == 4) ? (b[3] = String(Number(b[3]) / 255), "rgba(" + b.join(",") + ")") : a;
        }
        function bG(a, b, c, d, e, f, g, h, k) {
            h = h || k;
            gG(a, c, d, g, "direction", h) == "rtl" && (b.direction = "rtl");
            k = gG(a, c, d, g, "writingMode", h);
            k == "tb" || k == "tblr" ? b.writingMode = "vertical-lr" : k == "tbrl" ? b.writingMode = "vertical-rl" : k == "rltb" || k == "rl" ? b.direction = "rtl" : k && (b.direction = Le);
            (k = gG(a, c, d, g, "textAlign", !0)) ? (b.positionAlign = hG.get(k), b.lineAlign = iG.get(k), b.textAlign = gf[k.toUpperCase()]) : b.textAlign = Ke;
            if (k = gG(a, c, d, g, "displayAlign", !0)) b.displayAlign = hf[k.toUpperCase()];
            if (k = gG(a, c, d, g, "color", h)) b.color = fG(k);
            if (k = gG(a, c, d, g, "backgroundColor", h)) b.backgroundColor = fG(k);
            if (k = gG(a, c, d, g, "border", h)) b.border = k;
            if (k = gG(a, c, d, g, "fontFamily", h)) switch(k){
                case "monospaceSerif":
                    b.fontFamily = "Courier New,Liberation Mono,Courier,monospace";
                    break;
                case "proportionalSansSerif":
                    b.fontFamily = "Arial,Helvetica,Liberation Sans,sans-serif";
                    break;
                case "sansSerif":
                    b.fontFamily = "sans-serif";
                    break;
                case "monospaceSansSerif":
                    b.fontFamily = "Consolas,monospace";
                    break;
                case "proportionalSerif":
                    b.fontFamily = "serif";
                    break;
                default:
                    b.fontFamily = k.split(",").filter(function(l) {
                        return l != "default";
                    }).join(",");
            }
            (k = gG(a, c, d, g, "fontWeight", h)) && k == "bold" && (b.fontWeight = df);
            k = gG(a, c, d, g, "wrapOption", h);
            b.wrapLine = k && k == "noWrap" ? !1 : !0;
            (k = gG(a, c, d, g, "lineHeight", h)) && k.match(jG) && (b.lineHeight = k);
            (k = gG(a, c, d, g, "fontSize", h)) && (k.match(jG) || k.match(kG)) && (b.fontSize = k);
            if (k = gG(a, c, d, g, "fontStyle", h)) b.fontStyle = kf[k.toUpperCase()];
            e ? (f = e.attributes.imageType || e.attributes.imagetype, k = e.attributes.encoding, e = ke(e).trim(), f == "PNG" && k == "Base64" && e && (b.backgroundImage = "data:image/png;base64," + e)) : f && (b.backgroundImage = f);
            if (e = gG(a, c, d, g, "textOutline", h)) e = e.split(" "), e[0].match(jG) ? b.textStrokeColor = b.color : (b.textStrokeColor = fG(e[0]), e.shift()), e[0] && e[0].match(jG) ? b.textStrokeWidth = e[0] : b.textStrokeColor = "";
            (e = gG(a, c, d, g, "letterSpacing", h)) && e.match(jG) && (b.letterSpacing = e);
            (e = gG(a, c, d, g, "linePadding", h)) && e.match(jG) && (b.linePadding = e);
            if (e = gG(a, c, d, g, "opacity", h)) b.opacity = parseFloat(e);
            (e = eG(a, d, g, "textDecoration")) && lG(b, e);
            (e = mG(a, c, g, "textDecoration")) && lG(b, e);
            if (e = gG(a, c, d, g, "textCombine", h)) b.textCombineUpright = e;
            switch(gG(a, c, d, g, "ruby", h)){
                case "container":
                    b.rubyTag = "ruby";
                    break;
                case "text":
                    b.rubyTag = "rt";
            }
        }
        function lG(a, b) {
            b = u(b.split(" "));
            for(var c = b.next(); !c.done; c = b.next())switch(c.value){
                case "underline":
                    a.textDecoration.includes(ff) || a.textDecoration.push(ff);
                    break;
                case "noUnderline":
                    a.textDecoration.includes(ff) && ad(a.textDecoration, ff);
                    break;
                case "lineThrough":
                    a.textDecoration.includes("line-through") || a.textDecoration.push("line-through");
                    break;
                case "noLineThrough":
                    a.textDecoration.includes("line-through") && ad(a.textDecoration, "line-through");
                    break;
                case "overline":
                    a.textDecoration.includes("overline") || a.textDecoration.push("overline");
                    break;
                case "noOverline":
                    a.textDecoration.includes("overline") && ad(a.textDecoration, "overline");
            }
        }
        function gG(a, b, c, d, e, f) {
            f = f === void 0 ? !0 : f;
            return (b = mG(a, b, d, e)) ? b : f ? eG(a, c, d, e) : null;
        }
        function eG(a, b, c, d) {
            if (!b) return null;
            var e = se(b, TF, d);
            return e ? e : nG(a, b, c, d);
        }
        function mG(a, b, c, d) {
            var e = se(b, TF, d);
            return e ? e : nG(a, b, c, d);
        }
        function nG(a, b, c, d) {
            b = ZF(b, "style", c, "");
            for(var e = null, f = 0; f < b.length; f++){
                var g = re(b[f], "urn:ebu:tt:style", d);
                g || (g = se(b[f], TF, d));
                g || (g = mG(a, b[f], c, d));
                g && (e = g);
            }
            return e;
        }
        function ZF(a, b, c, d, e) {
            var f = [];
            if (!a || c.length < 1) return f;
            var g = a;
            for(a = null; !a && !(a = e ? re(g, e, b) : g.attributes[b]) && (g = g.parent, g););
            if (b = a) {
                for(b = u(b.split(" ")), e = b.next(); !e.done; e = b.next())for(e = e.value, a = u(c), g = a.next(); !g.done; g = a.next())if (g = g.value, d + g.attributes["xml:id"] == e) {
                    f.push(g);
                    break;
                }
            }
            return f;
        }
        function aG(a, b, c, d) {
            a = $F(a, b);
            c == null ? c = a.start : a.start != null && (c += a.start);
            d == null ? d = a.end : a.start != null && (d += a.start);
            return {
                start: c,
                end: d
            };
        }
        function $F(a, b) {
            var c = oG(a.attributes.begin, b), d = oG(a.attributes.end, b);
            a = oG(a.attributes.dur, b);
            d == null && a != null && (d = c + a);
            return {
                start: c,
                end: d
            };
        }
        function oG(a, b) {
            var c = null;
            if (pG.test(a)) {
                a = pG.exec(a);
                c = Number(a[1]);
                var d = Number(a[2]), e = Number(a[3]), f = Number(a[4]);
                f += (Number(a[5]) || 0) / b.h;
                e += f / b.frameRate;
                c = e + d * 60 + c * 3600;
            } else if (qG.test(a)) c = rG(qG, a);
            else if (sG.test(a)) c = rG(sG, a);
            else if (tG.test(a)) a = tG.exec(a), c = Number(a[1]) / b.frameRate;
            else if (uG.test(a)) a = uG.exec(a), c = Number(a[1]) / b.g;
            else if (vG.test(a)) c = rG(vG, a);
            else if (a) throw new T(2, 2, 2001, "Could not parse cue time range in TTML");
            return c;
        }
        function rG(a, b) {
            a = a.exec(b);
            return a == null || a[0] == "" ? null : (Number(a[4]) || 0) / 1E3 + (Number(a[3]) || 0) + (Number(a[2]) || 0) * 60 + (Number(a[1]) || 0) * 3600;
        }
        function VF(a) {
            return a ? (a = /^(\d+) (\d+)$/.exec(a)) ? {
                columns: parseInt(a[1], 10),
                rows: parseInt(a[2], 10)
            } : null : null;
        }
        O("shaka.text.TtmlTextParser", RF);
        RF.prototype.parseMedia = RF.prototype.parseMedia;
        RF.prototype.setManifestType = RF.prototype.setManifestType;
        RF.prototype.setSequenceMode = RF.prototype.setSequenceMode;
        RF.prototype.parseInit = RF.prototype.parseInit;
        function UF(a, b, c, d) {
            this.frameRate = Number(a) || 30;
            this.h = Number(b) || 1;
            this.g = Number(d);
            this.g == 0 && (this.g = a ? this.frameRate * this.h : 1);
            c && (a = /^(\d+) (\d+)$/g.exec(c)) && (this.frameRate *= Number(a[1]) / Number(a[2]));
        }
        var cG = /^(\d{1,2}(?:\.\d+)?|100(?:\.0+)?)% (\d{1,2}(?:\.\d+)?|100(?:\.0+)?)%$/, kG = /^(\d{1,4}(?:\.\d+)?|100)%$/, jG = /^(\d+px|\d+em|\d*\.?\d+c)$/, dG = /^(\d+)px (\d+)px$/, pG = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, qG = /^(?:(\d{2,}):)?(\d{2}):(\d{2})$/, sG = /^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d+)$/, tG = /^(\d*(?:\.\d*)?)f$/, uG = /^(\d*(?:\.\d*)?)t$/, vG = RegExp("^(?:(\\d*(?:\\.\\d*)?)h)?(?:(\\d*(?:\\.\\d*)?)m)?(?:(\\d*(?:\\.\\d*)?)s)?(?:(\\d*(?:\\.\\d*)?)ms)?$"), iG = (new Map).set("left", Oe).set("center", "center").set("right", "end").set("start", Oe).set("end", "end"), hG = (new Map).set("left", "line-left").set("center", "center").set("right", "line-right").set("start", "line-left").set("end", "line-right"), SF = [
            "http://www.w3.org/ns/ttml#parameter",
            "http://www.w3.org/2006/10/ttaf1#parameter"
        ], TF = [
            "http://www.w3.org/ns/ttml#styling",
            "http://www.w3.org/2006/10/ttaf1#styling"
        ], YF = [
            "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt",
            "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt"
        ];
        Jf("application/ttml+xml", function() {
            return new RF;
        });
        function wG() {
            this.g = new RF;
        }
        wG.prototype.parseInit = function(a) {
            var b = !1;
            (new Bh).boxes([
                "moov",
                "trak",
                "mdia",
                "minf",
                "stbl"
            ], Gh).qa("stsd", Ih).box("stpp", function(c) {
                b = !0;
                c.parser.stop();
            }).parse(a);
            if (!b) throw new T(2, 2, 2007);
        };
        wG.prototype.setSequenceMode = function(a) {
            this.g.setSequenceMode(a);
        };
        wG.prototype.setManifestType = function(a) {
            this.g.setManifestType(a);
        };
        wG.prototype.parseMedia = function(a, b, c) {
            var d = [], e = null, f = [], g = new Map, h = [];
            (new Bh).boxes([
                "moof",
                "traf"
            ], Gh).qa("tfhd", function(x) {
                e = Vi(x.reader, x.flags).le;
            }).qa("trun", function(x) {
                x = Yi(x.reader, x.version, x.flags);
                x = u(x.ci);
                for(var y = x.next(); !y.done; y = x.next())h.push(y.value.sampleSize || e || 0);
            }).qa("subs", function(x) {
                for(var y = x.reader, z = y.Y(), A = -1, E = 0; E < z; E++){
                    var C = y.Y();
                    A += C;
                    C = y.Ka();
                    for(var D = [], B = 0; B < C; B++)x.version == 1 ? D.push(y.Y()) : D.push(y.Ka()), y.ea(), y.ea(), y.Y();
                    g.set(A, D);
                }
            }).box("mdat", Lh(function(x) {
                f.push(x);
            }, !1)).parse(a, !1);
            if (f.length == 0) throw new T(2, 2, 2007);
            a = tc.apply(kc, G(f));
            for(var k = 0, l = 0; l < h.length; l++){
                var m = Fb(a, k, h[l]);
                k += h[l];
                var n = g.get(l);
                if (n && n.length) {
                    for(var q = Fb(m, 0, n[0]), r = [], t = n[0], v = 1; v < n.length; v++){
                        var w = Fb(m, t, n[v]);
                        w = lc(w);
                        r.push("data:image/png;base64," + w);
                        t += n[v];
                    }
                    d = d.concat(this.g.parseMedia(q, b, c, r));
                } else d = d.concat(this.g.parseMedia(m, b, c, []));
            }
            return d;
        };
        O("shaka.text.Mp4TtmlParser", wG);
        wG.prototype.parseMedia = wG.prototype.parseMedia;
        wG.prototype.setManifestType = wG.prototype.setManifestType;
        wG.prototype.setSequenceMode = wG.prototype.setSequenceMode;
        wG.prototype.parseInit = wG.prototype.parseInit;
        Jf('application/mp4; codecs="stpp"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.im1i"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.im1t"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.im2i"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.im2t"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.etd1"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.etd1|im1t"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.im1t|etd1"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.TTML.im1t"', function() {
            return new wG;
        });
        function xG() {
            this.g = "UNKNOWN";
        }
        xG.prototype.parseInit = function() {};
        xG.prototype.setSequenceMode = function() {};
        xG.prototype.setManifestType = function(a) {
            this.g = a;
        };
        xG.prototype.parseMedia = function(a, b) {
            a = bc(a);
            a = a.replace(/\r\n|\r(?=[^\n]|$)/gm, "\n");
            var c = a.split(/\n{2,}/m);
            if (!/^WEBVTT($|[ \t\n])/m.test(c[0])) throw new T(2, 2, 2E3);
            a = b.vttOffset;
            if (this.g == "HLS" && c[0].includes("X-TIMESTAMP-MAP")) {
                var d = c[0];
                a = d.match(/LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m);
                d = d.match(/MPEGTS:(\d+)/m);
                if (!a || !d) throw new T(2, 2, 2E3);
                a = Vd(a[1]);
                if (a == null) throw new T(2, 2, 2E3);
                d = Number(d[1]);
                for(var e = b.segmentStart - b.periodStart; e >= 95443.7176888889;)e -= 95443.7176888889, d += 8589934592;
                a = b.periodStart + d / 9E4 - a;
            }
            b = [];
            d = u(c[0].split("\n"));
            for(e = d.next(); !e.done; e = d.next())if (e = e.value, /^Region:/.test(e)) {
                e = new Pd(e);
                var f = new Md;
                Sd(e);
                Qd(e);
                for(var g = Sd(e); g;){
                    var h = f, k = g;
                    (g = /^id=(.*)$/.exec(k)) ? h.id = g[1] : (g = /^width=(\d{1,2}|100)%$/.exec(k)) ? h.width = Number(g[1]) : (g = /^lines=(\d+)$/.exec(k)) ? (h.height = Number(g[1]), h.heightUnits = 2) : (g = /^regionanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(k)) ? (h.regionAnchorX = Number(g[1]), h.regionAnchorY = Number(g[2])) : (g = /^viewportanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(k)) ? (h.viewportAnchorX = Number(g[1]), h.viewportAnchorY = Number(g[2])) : /^scroll=up$/.exec(k) && (h.scroll = "up");
                    Qd(e);
                    g = Sd(e);
                }
                b.push(f);
            }
            d = new Map;
            Xe(d);
            e = [];
            c = u(c.slice(1));
            for(f = c.next(); !f.done; f = c.next()){
                f = f.value.split("\n");
                if ((f.length != 1 || f[0]) && !yG.test(f[0]) && f[0] == "STYLE") {
                    h = [];
                    g = -1;
                    for(k = 1; k < f.length; k++)f[k].includes("::cue") && (h.push([]), g = h.length - 1), g != -1 && (h[g].push(f[k]), f[k].includes("}") && (g = -1));
                    h = u(h);
                    for(g = h.next(); !g.done; g = h.next()){
                        var l = g.value;
                        g = "global";
                        (k = l[0].match(/\((.*)\)/)) && (g = k.pop());
                        k = l.slice(1, -1);
                        l[0].includes("}") && (l = /\{(.*?)\}/.exec(l[0])) && (k = l[1].split(";"));
                        (l = d.get(g)) || (l = new Ie(0, 0, ""));
                        for(var m = !1, n = 0; n < k.length; n++){
                            var q = /^\s*([^:]+):\s*(.*)/.exec(k[n]);
                            if (q) {
                                var r = q[2].trim().replace(";", "");
                                switch(q[1].trim()){
                                    case "background-color":
                                    case "background":
                                        m = !0;
                                        l.backgroundColor = r;
                                        break;
                                    case "color":
                                        m = !0;
                                        l.color = r;
                                        break;
                                    case "font-family":
                                        m = !0;
                                        l.fontFamily = r;
                                        break;
                                    case "font-size":
                                        m = !0;
                                        l.fontSize = r;
                                        break;
                                    case "font-weight":
                                        if (parseInt(r, 10) >= 700 || r == "bold") m = !0, l.fontWeight = df;
                                        break;
                                    case "font-style":
                                        switch(r){
                                            case "normal":
                                                m = !0;
                                                l.fontStyle = Te;
                                                break;
                                            case "italic":
                                                m = !0;
                                                l.fontStyle = ef;
                                                break;
                                            case "oblique":
                                                m = !0, l.fontStyle = "oblique";
                                        }
                                        break;
                                    case "opacity":
                                        m = !0;
                                        l.opacity = parseFloat(r);
                                        break;
                                    case "text-combine-upright":
                                        m = !0;
                                        l.textCombineUpright = r;
                                        break;
                                    case "text-shadow":
                                        m = !0;
                                        l.textShadow = r;
                                        break;
                                    case "white-space":
                                        m = !0, l.wrapLine = r != "noWrap";
                                }
                            }
                        }
                        m && d.set(g, l);
                    }
                }
                l = f;
                n = a;
                if (l.length == 1 && !l[0] || yG.test(l[0]) || l[0] == "STYLE" || l[0] == "REGION") f = null;
                else if (f = null, m = 0, l[0].includes("--\x3e") || (f = l[0], m = 1), h = new Pd(l[m]), g = Td(h), q = Rd(h, /[ \t]+--\x3e[ \t]+/g), k = Td(h), g == null || q == null || k == null) Za("Failed to parse VTT time code. Cue skipped:", f, l), f = null;
                else {
                    g += n;
                    k += n;
                    g < 0 && (g = 0);
                    n = "";
                    for(q = m + 1; q < l.length; q++)q > m + 1 && (n += "\n"), n += l[q];
                    n = n.trim();
                    d.has("global") ? (l = d.get("global").clone(), l.startTime = g, l.endTime = k, l.payload = n) : l = new Ie(g, k, n);
                    Qd(h);
                    for(g = Sd(h); g;)zG(l, g, b), Qd(h), g = Sd(h);
                    We(l, d);
                    f != null && (l.id = f);
                    f = l;
                }
                f && e.push(f);
            }
            return e;
        };
        function zG(a, b, c) {
            var d;
            if (d = AG.exec(b)) b = d[1], b == "middle" ? a.textAlign = Ke : a.textAlign = gf[b.toUpperCase()];
            else if (d = BG.exec(b)) a.writingMode = d[1] == "lr" ? "vertical-lr" : "vertical-rl";
            else if (d = CG.exec(b)) a.size = Number(d[1]);
            else if (d = DG.exec(b)) a.position = Number(d[1]), d[2] && (b = d[2], a.positionAlign = b == "line-left" || b == "start" ? "line-left" : b == "line-right" || b == "end" ? "line-right" : b == "center" || b == "middle" ? "center" : Je);
            else if (d = EG.exec(b)) {
                if (b = FG(c, d[1])) a.region = b;
            } else if (c = GG.exec(b)) a.lineInterpretation = 1, a.line = Number(c[1]), c[2] && (a.lineAlign = jf[c[2].toUpperCase()]);
            else if (c = HG.exec(b)) a.lineInterpretation = Ne, a.line = Number(c[1]), c[2] && (a.lineAlign = jf[c[2].toUpperCase()]);
        }
        function FG(a, b) {
            a = a.filter(function(c) {
                return c.id == b;
            });
            return a.length ? a[0] : null;
        }
        O("shaka.text.VttTextParser", xG);
        xG.prototype.parseMedia = xG.prototype.parseMedia;
        xG.prototype.setManifestType = xG.prototype.setManifestType;
        xG.prototype.setSequenceMode = xG.prototype.setSequenceMode;
        xG.prototype.parseInit = xG.prototype.parseInit;
        var yG = /^NOTE($|[ \t])/, AG = /^align:(start|middle|center|end|left|right)$/, BG = /^vertical:(lr|rl)$/, CG = /^size:([\d.]+)%$/, DG = /^position:([\d.]+)%(?:,(line-left|line-right|middle|center|start|end|auto))?$/, EG = /^region:(.*)$/, GG = /^line:([\d.]+)%(?:,(start|end|center))?$/, HG = /^line:(-?\d+)(?:,(start|end|center))?$/;
        Jf("text/vtt", function() {
            return new xG;
        });
        Jf('text/vtt; codecs="vtt"', function() {
            return new xG;
        });
        Jf('text/vtt; codecs="wvtt"', function() {
            return new xG;
        });
        function IG() {
            this.g = null;
        }
        IG.prototype.parseInit = function(a) {
            var b = this, c = !1;
            (new Bh).boxes([
                "moov",
                "trak",
                "mdia",
                "minf",
                "stbl"
            ], Gh).qa("mdhd", function(d) {
                d = Xi(d.reader, d.version);
                b.g = d.timescale;
            }).qa("stsd", Ih).box("wvtt", function() {
                c = !0;
            }).parse(a);
            if (!this.g) throw new T(2, 2, 2008);
            if (!c) throw new T(2, 2, 2008);
        };
        IG.prototype.setSequenceMode = function() {};
        IG.prototype.setManifestType = function() {};
        IG.prototype.parseMedia = function(a, b) {
            if (!a.length) return [];
            if (!this.g) throw new T(2, 2, 2008);
            var c = 0, d = [], e, f = [], g = !1, h = !1, k = !1, l = null;
            (new Bh).boxes([
                "moof",
                "traf"
            ], Gh).qa("tfdt", function(z) {
                g = !0;
                c = Wi(z.reader, z.version).baseMediaDecodeTime;
            }).qa("tfhd", function(z) {
                l = Vi(z.reader, z.flags).ke;
            }).qa("trun", function(z) {
                h = !0;
                d = Yi(z.reader, z.version, z.flags).ci;
            }).box("mdat", Lh(function(z) {
                k = !0;
                e = z;
            }, !1)).parse(a, !1);
            if (!k && !g && !h) throw new T(2, 2, 2008);
            a = c;
            for(var m = new yh(e, 0), n = u(d), q = n.next(); !q.done; q = n.next()){
                q = q.value;
                var r = q.di || l, t = q.dg ? c + q.dg : a;
                a = t + (r || 0);
                var v = 0;
                do {
                    var w = m.Y();
                    v += w;
                    var x = m.Y(), y = null;
                    Fh(x) == "vttc" ? w > 8 && (y = m.Wb(w - 8, !1)) : m.skip(w - 8);
                    r && y && (w = JG(y, b.periodStart + t / this.g, b.periodStart + a / this.g), f.push(w));
                }while (q.sampleSize && v < q.sampleSize);
            }
            return f.filter(Zf);
        };
        function JG(a, b, c) {
            var d, e, f;
            (new Bh).box("payl", Lh(function(g) {
                d = bc(g);
            }, !1)).box("iden", Lh(function(g) {
                e = bc(g);
            }, !1)).box("sttg", Lh(function(g) {
                f = bc(g);
            }, !1)).parse(a);
            return d ? KG(d, e, f, b, c) : null;
        }
        function KG(a, b, c, d, e) {
            a = new Ie(d, e, a);
            We(a);
            b && (a.id = b);
            if (c) for(b = new Pd(c), c = Sd(b); c;)zG(a, c, []), Qd(b), c = Sd(b);
            return a;
        }
        O("shaka.text.Mp4VttParser", IG);
        IG.prototype.parseMedia = IG.prototype.parseMedia;
        IG.prototype.setManifestType = IG.prototype.setManifestType;
        IG.prototype.setSequenceMode = IG.prototype.setSequenceMode;
        IG.prototype.parseInit = IG.prototype.parseInit;
        Jf('application/mp4; codecs="wvtt"', function() {
            return new IG;
        });
        function LG() {}
        LG.prototype.parseInit = function() {};
        LG.prototype.setSequenceMode = function() {};
        LG.prototype.setManifestType = function() {};
        LG.prototype.parseMedia = function(a) {
            var b = bc(a).replace(/\r+/g, "");
            b = b.trim();
            a = [];
            if (b == "") return a;
            b = u(b.split("\n\n"));
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value.split("\n");
                var d = new Pd(c[0]), e = Td(d), f = Rd(d, /,/g);
                d = Td(d);
                if (e == null || f == null || d == null) throw new T(2, 2, 2001, "Could not parse cue time range in SubViewer");
                a.push(new Ie(e, d, c.slice(1).join("\n").trim()));
            }
            return a;
        };
        O("shaka.text.SbvTextParser", LG);
        LG.prototype.parseMedia = LG.prototype.parseMedia;
        LG.prototype.setManifestType = LG.prototype.setManifestType;
        LG.prototype.setSequenceMode = LG.prototype.setSequenceMode;
        LG.prototype.parseInit = LG.prototype.parseInit;
        Jf("text/x-subviewer", function() {
            return new LG;
        });
        function MG() {
            this.g = new xG;
        }
        MG.prototype.parseInit = function() {};
        MG.prototype.setSequenceMode = function() {};
        MG.prototype.setManifestType = function() {};
        MG.prototype.parseMedia = function(a, b, c) {
            var d = bc(a);
            a = "WEBVTT\n\n";
            if (d != "") {
                d = d.replace(/\r+/g, "");
                d = d.trim();
                d = u(d.split("\n\n"));
                for(var e = d.next(); !e.done; e = d.next())e = e.value.split(/\n/), e[0].match(/\d+/) && e.shift(), e[0] = e[0].replace(/,/g, "."), a += e.join("\n").replace(/{b}/g, "<b>").replace(/{\/b}/g, "</b>").replace(/{i}/g, "<i>").replace(/{\/i}/g, "</i>").replace(/{u}/g, "<u>").replace(/{\/u}/g, "</u>") + "\n\n";
            }
            a = Fb(hc(a));
            return this.g.parseMedia(a, b, c, []);
        };
        O("shaka.text.SrtTextParser", MG);
        MG.prototype.parseMedia = MG.prototype.parseMedia;
        MG.prototype.setManifestType = MG.prototype.setManifestType;
        MG.prototype.setSequenceMode = MG.prototype.setSequenceMode;
        MG.prototype.parseInit = MG.prototype.parseInit;
        Jf("text/srt", function() {
            return new MG;
        });
        function NG() {}
        NG.prototype.parseInit = function() {};
        NG.prototype.setSequenceMode = function() {};
        NG.prototype.setManifestType = function() {};
        NG.prototype.parseMedia = function(a) {
            var b = "", c = "", d = null, e = null;
            e = bc(a).split(/\r?\n\s*\r?\n/);
            a = u(e);
            for(e = a.next(); !e.done; e = a.next()){
                var f = e.value;
                e = f;
                if (f = OG.exec(f)) d = f[1], e = f[2];
                d == "V4 Styles" || d == "V4+ Styles" ? (b = e, b = c ? b + ("\n" + e) : e) : d == "Events" && (c = c ? c + ("\n" + e) : e);
            }
            d = [];
            e = null;
            b = u(b.split(/\r?\n/));
            for(a = b.next(); !a.done; a = b.next())if (a = a.value, !/^\s*;/.test(a) && (f = PG.exec(a))) {
                if (a = f[1].trim(), f = f[2].trim(), a == "Format") e = f.split(QG);
                else if (a == "Style") {
                    a = f.split(QG);
                    f = {};
                    for(var g = 0; g < e.length && g < a.length; g++)f[e[g]] = a[g];
                    d.push(f);
                }
            }
            e = [];
            b = null;
            c = u(c.split(/\r?\n/));
            f = c.next();
            for(a = {}; !f.done; a = {
                Vj: void 0
            }, f = c.next())if (f = f.value, !/^\s*;/.test(f) && (g = PG.exec(f))) {
                if (f = g[1].trim(), g = g[2].trim(), f == "Format") b = g.split(QG);
                else if (f == "Dialogue") {
                    g = g.split(QG);
                    f = {};
                    for(var h = 0; h < b.length && h < g.length; h++)f[b[h]] = g[h];
                    h = RG(f.Start);
                    var k = RG(f.End);
                    g = new Ie(h, k, g.slice(b.length - 1).join(",").replace(/\\N/g, "\n").replace(/\{[^}]+\}/g, ""));
                    a.Vj = f.Style;
                    (a = d.find(function(l) {
                        return function(m) {
                            return m.Name == l.Vj;
                        };
                    }(a))) && SG(g, a);
                    e.push(g);
                }
            }
            return e;
        };
        function SG(a, b) {
            var c = b.Fontname;
            c && (a.fontFamily = c);
            if (c = b.Fontsize) a.fontSize = c + "px";
            if (c = b.PrimaryColour) {
                if (c = TG(c)) a.color = c;
            }
            if (c = b.BackColour) {
                if (c = TG(c)) a.backgroundColor = c;
            }
            b.Bold && (a.fontWeight = df);
            b.Italic && (a.fontStyle = ef);
            b.Underline && a.textDecoration.push(ff);
            if (c = b.Spacing) a.letterSpacing = c + "px";
            if (c = b.Alignment) switch(parseInt(c, 10)){
                case 1:
                    a.displayAlign = Re;
                    a.textAlign = "start";
                    break;
                case 2:
                    a.displayAlign = Re;
                    a.textAlign = Ke;
                    break;
                case 3:
                    a.displayAlign = Re;
                    a.textAlign = "end";
                    break;
                case 5:
                    a.displayAlign = "before";
                    a.textAlign = "start";
                    break;
                case 6:
                    a.displayAlign = "before";
                    a.textAlign = Ke;
                    break;
                case 7:
                    a.displayAlign = "before";
                    a.textAlign = "end";
                    break;
                case 9:
                    a.displayAlign = "center";
                    a.textAlign = "start";
                    break;
                case 10:
                    a.displayAlign = "center";
                    a.textAlign = Ke;
                    break;
                case 11:
                    a.displayAlign = "center", a.textAlign = "end";
            }
            if (b = b.AlphaLevel) a.opacity = parseFloat(b);
        }
        function TG(a) {
            a = parseInt(a.replace("&H", ""), 16);
            return a >= 0 ? "rgba(" + (a & 255) + "," + (a >> 8 & 255) + "," + (a >> 16 & 255) + "," + (a >> 24 & 255 ^ 255) / 255 + ")" : null;
        }
        function RG(a) {
            a = UG.exec(a);
            return (a[1] ? parseInt(a[1].replace(":", ""), 10) : 0) * 3600 + parseInt(a[2], 10) * 60 + parseFloat(a[3]);
        }
        O("shaka.text.SsaTextParser", NG);
        NG.prototype.parseMedia = NG.prototype.parseMedia;
        NG.prototype.setManifestType = NG.prototype.setManifestType;
        NG.prototype.setSequenceMode = NG.prototype.setSequenceMode;
        NG.prototype.parseInit = NG.prototype.parseInit;
        var OG = /^\s*\[([^\]]+)\]\r?\n([\s\S]*)/, PG = /^\s*([^:]+):\s*(.*)/, QG = /\s*,\s*/, UG = /^(\d+:)?(\d{1,2}):(\d{1,2}(?:[.]\d{1,3})?)?$/;
        Jf("text/x-ssa", function() {
            return new NG;
        });
        function VG(a, b) {
            var c = a[b + 1] & 1 ? 7 : 9;
            return b + c <= a.length && (a = ((a[b + 3] & 3) << 11 | a[b + 4] << 3 | (a[b + 5] & 224) >>> 5) - c, a > 0) ? {
                re: c,
                oa: a
            } : null;
        }
        function WG(a, b) {
            var c = [
                96E3,
                88200,
                64E3,
                48E3,
                44100,
                32E3,
                24E3,
                22050,
                16E3,
                12E3,
                11025,
                8E3,
                7350
            ], d = (a[b + 2] & 60) >>> 2;
            if (d > c.length - 1) return null;
            var e = ((a[b + 2] & 192) >>> 6) + 1, f = (a[b + 2] & 1) << 2;
            f |= (a[b + 3] & 192) >>> 6;
            return {
                sampleRate: c[d],
                channelCount: f,
                codec: "mp4a.40." + e
            };
        }
        function XG(a, b) {
            if (b + 1 < a.length && a[b] === 255 && (a[b + 1] & 246) === 240) {
                var c = a[b + 1] & 1 ? 7 : 9;
                if (b + c >= a.length) return !1;
                var d = (a[b + 3] & 3) << 11 | a[b + 4] << 3 | (a[b + 5] & 224) >>> 5;
                if (d <= c) return !1;
                b += d;
                return b === a.length || b + 1 < a.length && a[b] === 255 && (a[b + 1] & 246) === 240;
            }
            return !1;
        }
        function YG(a, b) {
            switch(a){
                case "mp4a.40.2":
                    if (b === 1) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        35,
                        128
                    ]);
                    if (b === 2) return new Uint8Array([
                        33,
                        0,
                        73,
                        144,
                        2,
                        25,
                        0,
                        35,
                        128
                    ]);
                    if (b === 3) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        142
                    ]);
                    if (b === 4) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        128,
                        44,
                        128,
                        8,
                        2,
                        56
                    ]);
                    if (b === 5) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        130,
                        48,
                        4,
                        153,
                        0,
                        33,
                        144,
                        2,
                        56
                    ]);
                    if (b === 6) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        130,
                        48,
                        4,
                        153,
                        0,
                        33,
                        144,
                        2,
                        0,
                        178,
                        0,
                        32,
                        8,
                        224
                    ]);
                    break;
                default:
                    if (b === 1) return new Uint8Array([
                        1,
                        64,
                        34,
                        128,
                        163,
                        78,
                        230,
                        128,
                        186,
                        8,
                        0,
                        0,
                        0,
                        28,
                        6,
                        241,
                        193,
                        10,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        94
                    ]);
                    if (b === 2 || b === 3) return new Uint8Array([
                        1,
                        64,
                        34,
                        128,
                        163,
                        94,
                        230,
                        128,
                        186,
                        8,
                        0,
                        0,
                        0,
                        0,
                        149,
                        0,
                        6,
                        241,
                        161,
                        10,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        94
                    ]);
            }
            return null;
        }
        var ZG = Object.freeze({
            Hh: 0,
            Ef: 0,
            zf: 0,
            nf: 0,
            pf: 2,
            Jh: 0
        }), $G = Object.freeze({
            Hh: 0,
            Ef: 0,
            zf: 0,
            nf: 0,
            pf: 2,
            Jh: 0
        }), aH = Object.freeze({
            Hh: 0,
            Ef: 0,
            zf: 0,
            nf: 0,
            pf: 1,
            Jh: 1
        });
        function bH(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = bH.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/aac" ? Si(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/aac" ? 'audio/mp4; codecs="' + (Gf(b) || "mp4a.40.2") + '"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            for(var e = Fb(a), f = qk(e), g = f.length; g < e.length && !XG(e, g); g++);
            a = c.endTime * 1E3;
            f = pk(f);
            f.length && c && (f = f.find(function(m) {
                return m.description === "com.apple.streaming.transportStreamTimestamp";
            })) && (a = f.data);
            f = WG(e, g);
            if (!f) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
            b.audioSamplingRate = f.sampleRate;
            b.channelsCount = f.channelCount;
            for(var h = []; g < e.length;){
                var k = VG(e, g);
                if (!k) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
                var l = k.re + k.oa;
                g + l <= e.length && h.push({
                    data: e.subarray(g + k.re, g + l),
                    size: k.oa,
                    duration: 1024,
                    ub: 0,
                    flags: ZG
                });
                g += l;
            }
            e = f.sampleRate;
            a = Math.floor(a * e / 1E3);
            d = {
                id: b.id,
                type: "audio",
                codecs: f.codec,
                timescale: e,
                duration: d,
                Cb: [],
                Ha: new Uint8Array([]),
                Za: new Uint8Array([]),
                fb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: a,
                    zb: h
                },
                stream: b
            };
            d = new dj([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = ej(d), this.g.set(c, b));
            c = this.i !== b;
            d = Bj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        O("shaka.transmuxer.AacTransmuxer", bH);
        bH.prototype.transmux = bH.prototype.transmux;
        bH.prototype.getOriginalMimeType = bH.prototype.getOriginalMimeType;
        bH.prototype.convertCodecs = bH.prototype.convertCodecs;
        bH.prototype.isSupported = bH.prototype.isSupported;
        bH.prototype.destroy = bH.prototype.destroy;
        mf("audio/aac", function() {
            return new bH("audio/aac");
        }, uf);
        function cH(a, b, c) {
            if (b + 8 > a.length || a[b] !== 11 || a[b + 1] !== 119) return !1;
            var d = a[b + 4] >> 6;
            if (d >= 3) return !1;
            var e = a[b + 4] & 63, f = [
                64,
                69,
                96,
                64,
                70,
                96,
                80,
                87,
                120,
                80,
                88,
                120,
                96,
                104,
                144,
                96,
                105,
                144,
                112,
                121,
                168,
                112,
                122,
                168,
                128,
                139,
                192,
                128,
                140,
                192,
                160,
                174,
                240,
                160,
                175,
                240,
                192,
                208,
                288,
                192,
                209,
                288,
                224,
                243,
                336,
                224,
                244,
                336,
                256,
                278,
                384,
                256,
                279,
                384,
                320,
                348,
                480,
                320,
                349,
                480,
                384,
                417,
                576,
                384,
                418,
                576,
                448,
                487,
                672,
                448,
                488,
                672,
                512,
                557,
                768,
                512,
                558,
                768,
                640,
                696,
                960,
                640,
                697,
                960,
                768,
                835,
                1152,
                768,
                836,
                1152,
                896,
                975,
                1344,
                896,
                976,
                1344,
                1024,
                1114,
                1536,
                1024,
                1115,
                1536,
                1152,
                1253,
                1728,
                1152,
                1254,
                1728,
                1280,
                1393,
                1920,
                1280,
                1394,
                1920
            ][e * 3 + d] * 2;
            if (b + f > a.length) return !1;
            var g = a[b + 6] >> 5, h = 0;
            g === 2 ? h += 2 : (g & 1 && g !== 1 && (h += 2), g & 4 && (h += 2));
            h = (a[b + 6] << 8 | a[b + 7]) >> 12 - h & 1;
            var k = a[b + 5] & 7;
            a = new Uint8Array([
                d << 6 | a[b + 5] >> 3 << 1 | k >> 2,
                (k & 3) << 6 | g << 3 | h << 2 | e >> 4,
                e << 4 & 224
            ]);
            c.sampleRate = [
                48E3,
                44100,
                32E3
            ][d];
            c.channelCount = [
                2,
                1,
                2,
                3,
                3,
                4,
                4,
                5
            ][g] + h;
            c.Ha = a;
            c.oa = f;
            return !0;
        }
        function dH(a, b) {
            if (a[b] === 11 && a[b + 1] === 119) {
                var c = 0, d = 5;
                b += d;
                for(var e, f; d > 0;){
                    f = a[b];
                    var g = Math.min(d, 8), h = 8 - g;
                    e = 4278190080 >>> 24 + h << h;
                    e = (f & e) >> h;
                    c = c ? c << g | e : e;
                    b += 1;
                    d -= g;
                }
                if (c < 16) return !0;
            }
            return !1;
        }
        function eH(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = eH.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/ac3" ? Si(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/ac3" ? Xb().Fe() ? 'audio/mp4; codecs="ec-3"' : 'audio/mp4; codecs="ac-3"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            a = Fb(a);
            for(var e = qk(a), f = e.length; f < a.length && !dH(a, f); f++);
            var g = c.endTime * 1E3;
            e = pk(e);
            e.length && c && (e = e.find(function(m) {
                return m.description === "com.apple.streaming.transportStreamTimestamp";
            })) && (g = e.data);
            e = 0;
            for(var h = new Uint8Array([]), k = [], l = {
                sampleRate: 0,
                channelCount: 0,
                Ha: new Uint8Array(0),
                oa: 0
            }; f < a.length;){
                if (!cH(a, f, l)) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
                b.audioSamplingRate = l.sampleRate;
                b.channelsCount = l.channelCount;
                e = l.sampleRate;
                h = l.Ha;
                k.push({
                    data: a.subarray(f, f + l.oa),
                    size: l.oa,
                    duration: 1536,
                    ub: 0,
                    flags: ZG
                });
                f += l.oa;
            }
            a = Math.floor(g * e / 1E3);
            d = {
                id: b.id,
                type: "audio",
                codecs: "ac-3",
                timescale: e,
                duration: d,
                Cb: [],
                Ha: h,
                Za: new Uint8Array([]),
                fb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: a,
                    zb: k
                },
                stream: b
            };
            d = new dj([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = ej(d), this.g.set(c, b));
            c = this.i !== b;
            d = Bj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        O("shaka.transmuxer.Ac3Transmuxer", eH);
        eH.prototype.transmux = eH.prototype.transmux;
        eH.prototype.getOriginalMimeType = eH.prototype.getOriginalMimeType;
        eH.prototype.convertCodecs = eH.prototype.convertCodecs;
        eH.prototype.isSupported = eH.prototype.isSupported;
        eH.prototype.destroy = eH.prototype.destroy;
        mf("audio/ac3", function() {
            return new eH("audio/ac3");
        }, uf);
        function fH(a, b, c) {
            if (b + 8 > a.length || (a[b] << 8 | a[b + 1] << 0) !== 2935) return !1;
            var d = new tk(a.subarray(b + 2));
            vk(d, 2);
            vk(d, 3);
            var e = wk(d, 11) + 1 << 1, f = wk(d, 2);
            if (f == 3) {
                f = wk(d, 2);
                f = [
                    24E3,
                    22060,
                    16E3
                ][f];
                var g = 3;
            } else f = [
                48E3,
                44100,
                32E3
            ][f], g = wk(d, 2);
            var h = wk(d, 3), k = wk(d, 1);
            d = wk(d, 5);
            if (b + e > a.byteLength) return !1;
            a = Math.floor(e * f / ([
                1,
                2,
                3,
                6
            ][g] * 16));
            a = new Uint8Array([
                (a & 8160) >> 5,
                (a & 31) << 3,
                f << 6 | d << 1 | 0,
                0 | h << 1 | k << 0,
                0
            ]);
            c.sampleRate = f;
            c.channelCount = [
                2,
                1,
                2,
                3,
                3,
                4,
                4,
                5
            ][h] + k;
            c.Ha = a;
            c.oa = e;
            return !0;
        }
        function gH(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = gH.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/ec3" ? Si(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/ec3" ? 'audio/mp4; codecs="ec-3"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            a = Fb(a);
            for(var e = qk(a), f = e.length; f < a.length && (a[f] << 8 | a[f + 1] << 0) !== 2935; f++);
            var g = c.endTime * 1E3;
            e = pk(e);
            e.length && c && (e = e.find(function(m) {
                return m.description === "com.apple.streaming.transportStreamTimestamp";
            })) && (g = e.data);
            e = 0;
            for(var h = new Uint8Array([]), k = [], l = {
                sampleRate: 0,
                channelCount: 0,
                Ha: new Uint8Array(0),
                oa: 0
            }; f < a.length;){
                if (!fH(a, f, l)) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
                b.audioSamplingRate = l.sampleRate;
                b.channelsCount = l.channelCount;
                e = l.sampleRate;
                h = l.Ha;
                k.push({
                    data: a.subarray(f, f + l.oa),
                    size: l.oa,
                    duration: 1536,
                    ub: 0,
                    flags: ZG
                });
                f += l.oa;
            }
            a = Math.floor(g * e / 1E3);
            d = {
                id: b.id,
                type: "audio",
                codecs: "ec-3",
                timescale: e,
                duration: d,
                Cb: [],
                Ha: h,
                Za: new Uint8Array([]),
                fb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: a,
                    zb: k
                },
                stream: b
            };
            d = new dj([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = ej(d), this.g.set(c, b));
            c = this.i !== b;
            d = Bj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        O("shaka.transmuxer.Ec3Transmuxer", gH);
        gH.prototype.transmux = gH.prototype.transmux;
        gH.prototype.getOriginalMimeType = gH.prototype.getOriginalMimeType;
        gH.prototype.convertCodecs = gH.prototype.convertCodecs;
        gH.prototype.isSupported = gH.prototype.isSupported;
        gH.prototype.destroy = gH.prototype.destroy;
        mf("audio/ec3", function() {
            return new gH("audio/ec3");
        }, uf);
        function hH(a) {
            if (!a.length) return null;
            var b = a.find(function(v) {
                return v.type == 7;
            });
            a = a.find(function(v) {
                return v.type == 8;
            });
            if (!b || !a) return null;
            var c = new tk(b.data), d = Bk(c);
            Bk(c);
            Bk(c);
            yk(c);
            if (iH.includes(d) && (d = V(c), d === 3 && vk(c, 1), yk(c), yk(c), vk(c, 1), Ak(c))) {
                d = d !== 3 ? 8 : 12;
                for(var e = 0; e < d; e++)Ak(c) && (e < 6 ? Ck(c, 16) : Ck(c, 64));
            }
            yk(c);
            d = V(c);
            if (d === 0) V(c);
            else if (d === 1) for(vk(c, 1), yk(c), yk(c), d = V(c), e = 0; e < d; e++)yk(c);
            yk(c);
            vk(c, 1);
            var f = V(c), g = V(c), h = wk(c, 1);
            h === 0 && vk(c, 1);
            vk(c, 1);
            var k = 0, l = 0, m = 0, n = 0;
            Ak(c) && (k = V(c), l = V(c), m = V(c), n = V(c));
            e = d = 1;
            if (Ak(c) && Ak(c)) {
                var q = Bk(c), r = [
                    1,
                    12,
                    10,
                    16,
                    40,
                    24,
                    20,
                    32,
                    80,
                    18,
                    15,
                    64,
                    160,
                    4,
                    3,
                    2
                ], t = [
                    1,
                    11,
                    11,
                    11,
                    33,
                    11,
                    11,
                    11,
                    33,
                    11,
                    11,
                    33,
                    99,
                    3,
                    2,
                    1
                ];
                q > 0 && q <= 16 ? (d = r[q - 1], e = t[q - 1]) : q === 255 && (d = wk(c, 16), e = wk(c, 16));
            }
            c = (2 - h) * (g + 1) * 16 - m * 2 - n * 2;
            f = (f + 1) * 16 - k * 2 - l * 2;
            b = b.fullData;
            k = b.byteLength;
            a = a.fullData;
            l = a.byteLength;
            g = 0;
            h = new Uint8Array(11 + k + l);
            h[g++] = 1;
            h[g++] = b[1];
            h[g++] = b[2];
            h[g++] = b[3];
            h[g++] = 255;
            h[g++] = 225;
            h[g++] = k >>> 8 & 255;
            h[g++] = k & 255;
            h.set(b, g);
            g += k;
            h[g++] = 1;
            h[g++] = l >>> 8 & 255;
            h[g++] = l & 255;
            h.set(a, g);
            return {
                height: c,
                width: f,
                Za: h,
                fb: d,
                gb: e
            };
        }
        function jH(a) {
            function b(v) {
                e = {
                    data: g,
                    frame: !1,
                    isKeyframe: !1,
                    pts: v.pts,
                    dts: v.dts,
                    nalus: []
                };
            }
            function c() {
                if (e && e.nalus.length && e.frame) {
                    for(var v = e.nalus.length * 4, w = u(e.nalus), x = w.next(); !x.done; x = w.next())v += x.value.fullData.byteLength;
                    v = new Uint8Array(v);
                    w = 0;
                    x = u(e.nalus);
                    for(var y = x.next(); !y.done; y = x.next()){
                        y = y.value;
                        var z = y.fullData.byteLength;
                        v[w] = z >> 24 & 255;
                        v[w + 1] = z >> 16 & 255;
                        v[w + 2] = z >> 8 & 255;
                        v[w + 3] = z & 255;
                        v.set(y.fullData, w + 4);
                        w += 4 + z;
                    }
                    e.data = v;
                    d.push(e);
                }
            }
            for(var d = [], e = null, f = !1, g = new Uint8Array(0), h = 0; h < a.length; h++){
                var k = a[h], l = k.nalus, m = !1;
                e && l.length && !f && (c(), b(k));
                l = u(k.nalus);
                for(var n = l.next(); !n.done; n = l.next()){
                    n = n.value;
                    var q = !1;
                    switch(n.type){
                        case 1:
                            var r = !1;
                            q = !0;
                            var t = n.data;
                            m && t.length > 4 && (t = Dk(new tk(t)), t === 2 || t === 4 || t === 7 || t === 9) && (r = !0);
                            r && e && e.frame && !e.isKeyframe && (c(), e = null);
                            e || b(k);
                            e.frame = !0;
                            e.isKeyframe = r;
                            break;
                        case 5:
                            q = !0;
                            e && e.frame && !e.isKeyframe && (c(), e = null);
                            e || b(k);
                            e.frame = !0;
                            e.isKeyframe = !0;
                            break;
                        case 6:
                            q = !0;
                            break;
                        case 7:
                            m = q = !0;
                            break;
                        case 8:
                            q = !0;
                            break;
                        case 9:
                            f = q = !0;
                            e && e.frame && (c(), e = null);
                            e || b(k);
                            break;
                        case 12:
                            q = !0;
                            break;
                        default:
                            q = !1;
                    }
                    e && q && e.nalus.push(n);
                }
            }
            c();
            return d;
        }
        var iH = [
            100,
            110,
            122,
            244,
            44,
            83,
            86,
            118,
            128,
            138,
            139,
            134
        ];
        function kH(a) {
            if (!a.length) return null;
            var b = a.find(function(g) {
                return g.type == 32;
            }), c = a.find(function(g) {
                return g.type == 33;
            }), d = a.find(function(g) {
                return g.type == 34;
            });
            if (!b || !c || !d) return null;
            var e = lH(b.fullData);
            a = mH(c.fullData);
            var f = nH(d.fullData);
            b = oH(b.fullData, c.fullData, d.fullData, {
                Ph: e.Ph,
                wi: e.wi,
                mh: a.mh,
                nh: a.nh,
                fh: a.fh,
                kh: a.kh,
                gh: a.gh,
                hh: a.hh,
                ih: a.ih,
                jh: a.jh,
                Zg: a.Zg,
                $g: a.$g,
                ah: a.ah,
                bh: a.bh,
                dh: a.dh,
                eh: a.eh,
                Pf: a.Pf,
                Ng: a.Ng,
                Jg: a.Jg,
                Ig: a.Ig,
                Rh: f.Rh,
                Yg: a.Yg,
                Xg: a.Xg
            });
            return {
                height: a.height,
                width: a.width,
                Za: b,
                fb: a.qm,
                gb: a.pm
            };
        }
        function lH(a) {
            var b = new tk(a, !0);
            Bk(b);
            Bk(b);
            wk(b, 4);
            wk(b, 2);
            wk(b, 6);
            a = wk(b, 3);
            b = Ak(b);
            return {
                Ph: a + 1,
                wi: b
            };
        }
        function mH(a) {
            a = new tk(a, !0);
            Bk(a);
            Bk(a);
            var b = 0, c = 0, d = 0, e = 0;
            wk(a, 4);
            var f = wk(a, 3);
            Ak(a);
            for(var g = wk(a, 2), h = wk(a, 1), k = wk(a, 5), l = Bk(a), m = Bk(a), n = Bk(a), q = Bk(a), r = Bk(a), t = Bk(a), v = Bk(a), w = Bk(a), x = Bk(a), y = Bk(a), z = Bk(a), A = [], E = [], C = 0; C < f; C++)A.push(Ak(a)), E.push(Ak(a));
            if (f > 0) for(C = f; C < 8; C++)wk(a, 2);
            for(C = 0; C < f; C++)A[C] && wk(a, 88), E[C] && Bk(a);
            V(a);
            A = V(a);
            A == 3 && wk(a, 1);
            E = V(a);
            C = V(a);
            Ak(a) && (b += V(a), c += V(a), d += V(a), e += V(a));
            var D = V(a), B = V(a), J = V(a);
            if (Ak(a)) for(var F = 0; F <= f; F++)V(a), V(a), V(a);
            else V(a), V(a), V(a);
            V(a);
            V(a);
            V(a);
            V(a);
            V(a);
            V(a);
            if (Ak(a) && Ak(a)) for(F = 0; F < 4; F++)for(var I = 0; I < (F === 3 ? 2 : 6); I++)if (Ak(a)) {
                var K = Math.min(64, 1 << 4 + (F << 1));
                F > 1 && zk(a);
                for(var N = 0; N < K; N++)zk(a);
            } else V(a);
            Ak(a);
            Ak(a);
            Ak(a) && (Bk(a), V(a), V(a), Ak(a));
            F = V(a);
            for(K = I = 0; K < F; K++)if (N = !1, K !== 0 && (N = Ak(a)), N) {
                K === F && V(a);
                Ak(a);
                V(a);
                for(var P = N = 0; P <= I; P++){
                    var M = Ak(a), L = !1;
                    M || (L = Ak(a));
                    (M || L) && N++;
                }
                I = N;
            } else {
                P = V(a);
                N = V(a);
                I = P + N;
                for(M = 0; M < P; M++)V(a), Ak(a);
                for(P = 0; P < N; P++)V(a), Ak(a);
            }
            if (Ak(a)) for(F = V(a), I = 0; I < F; I++){
                for(K = 0; K < J + 4; K++)wk(a, 1);
                wk(a, 1);
            }
            F = J = 1;
            I = !0;
            K = 1;
            P = N = 0;
            Ak(a);
            Ak(a);
            if (Ak(a)) {
                if (Ak(a)) {
                    M = Bk(a);
                    L = [
                        1,
                        12,
                        10,
                        16,
                        40,
                        24,
                        20,
                        32,
                        80,
                        18,
                        15,
                        64,
                        160,
                        4,
                        3,
                        2
                    ];
                    var Q = [
                        1,
                        11,
                        11,
                        11,
                        33,
                        11,
                        11,
                        11,
                        33,
                        11,
                        11,
                        33,
                        99,
                        3,
                        2,
                        1
                    ];
                    M > 0 && M <= 16 ? (J = L[M - 1], F = Q[M - 1]) : M === 255 && (J = wk(a, 16), F = wk(a, 16));
                }
                Ak(a) && Ak(a);
                Ak(a) && (wk(a, 3), Ak(a), Ak(a) && (Bk(a), Bk(a), Bk(a)));
                Ak(a) && (V(a), V(a));
                Ak(a);
                Ak(a);
                Ak(a);
                if (M = Ak(a)) yk(a), yk(a), yk(a), yk(a);
                if (Ak(a) && (K = wk(a, 32), N = wk(a, 32), Ak(a) && V(a), Ak(a))) {
                    Q = !1;
                    M = Ak(a);
                    L = Ak(a);
                    if (M || L) {
                        if (Q = Ak(a)) Bk(a), wk(a, 5), Ak(a), wk(a, 5);
                        wk(a, 4);
                        wk(a, 4);
                        Q && wk(a, 4);
                        wk(a, 5);
                        wk(a, 5);
                        wk(a, 5);
                    }
                    for(var S = 0; S <= f; S++){
                        I = Ak(a);
                        var Z = !0, pa = 1;
                        I || (Z = Ak(a));
                        var va = !1;
                        Z ? V(a) : va = Ak(a);
                        va || (pa = V(a) + 1);
                        if (M) {
                            for(Z = 0; Z < pa; Z++)V(a), V(a), Q && (V(a), V(a));
                            Ak(a);
                        }
                        if (L) {
                            for(Z = 0; Z < pa; Z++)V(a), V(a), Q && (V(a), V(a));
                            Ak(a);
                        }
                    }
                }
                Ak(a) && (Ak(a), Ak(a), Ak(a), P = V(a), V(a), V(a), V(a), V(a));
            }
            return {
                fh: z,
                mh: g,
                nh: h,
                kh: k,
                gh: l,
                hh: m,
                ih: n,
                jh: q,
                Zg: r,
                $g: t,
                ah: v,
                bh: w,
                dh: x,
                eh: y,
                Pf: P,
                Ng: A,
                Jg: D,
                Ig: B,
                width: E - (b + c) * (A === 1 || A === 2 ? 2 : 1),
                height: C - (d + e) * (A === 1 ? 2 : 1),
                qm: J,
                pm: F,
                Yg: N / K,
                Xg: I
            };
        }
        function nH(a) {
            var b = new tk(a, !0);
            Bk(b);
            Bk(b);
            V(b);
            V(b);
            Ak(b);
            Ak(b);
            wk(b, 3);
            Ak(b);
            Ak(b);
            V(b);
            V(b);
            zk(b);
            Ak(b);
            Ak(b);
            Ak(b) && V(b);
            zk(b);
            zk(b);
            Ak(b);
            Ak(b);
            Ak(b);
            Ak(b);
            a = Ak(b);
            b = Ak(b);
            var c = 1;
            b && a ? c = 0 : b ? c = 3 : a && (c = 2);
            return {
                Rh: c
            };
        }
        function oH(a, b, c, d) {
            var e = new Uint8Array(23 + (5 + a.byteLength) + (5 + b.byteLength) + (5 + c.byteLength));
            e[0] = 1;
            e[1] = (d.mh & 3) << 6 | (d.nh ? 1 : 0) << 5 | d.kh & 31;
            e[2] = d.gh;
            e[3] = d.hh;
            e[4] = d.ih;
            e[5] = d.jh;
            e[6] = d.Zg;
            e[7] = d.$g;
            e[8] = d.ah;
            e[9] = d.bh;
            e[10] = d.dh;
            e[11] = d.eh;
            e[12] = d.fh;
            e[13] = 240 | (d.Pf & 3840) >> 8;
            e[14] = d.Pf & 255;
            e[15] = 252 | d.Rh & 3;
            e[16] = 252 | d.Ng & 3;
            e[17] = 248 | d.Jg & 7;
            e[18] = 248 | d.Ig & 7;
            e[19] = 0;
            e[20] = parseInt(d.Yg, 10);
            e[21] = ((d.Xg ? 1 : 0) & 3) << 6 | (d.Ph & 7) << 3 | (d.wi ? 1 : 0) << 2 | 3;
            e[22] = 3;
            a = [
                a,
                b,
                c
            ];
            b = 23;
            c = a.length - 1;
            for(d = 0; d < a.length; d += 1)e.set(new Uint8Array([
                32 + d | (d === c ? 128 : 0),
                0,
                1,
                a[d].byteLength >> 8,
                a[d].byteLength & 255
            ]), b), b += 5, e.set(a[d], b), b += a[d].byteLength;
            return e;
        }
        function pH(a, b) {
            var c = a[b + 1] >> 3 & 3, d = a[b + 1] >> 1 & 3, e = a[b + 2] >> 4 & 15, f = a[b + 2] >> 2 & 3;
            if (c !== 1 && e !== 0 && e !== 15 && f !== 3) {
                var g = a[b + 3] >> 6;
                e = qH[(c === 3 ? 3 - d : d === 3 ? 3 : 4) * 14 + e - 1] * 1E3;
                f = rH[(c === 3 ? 0 : c === 2 ? 1 : 2) * 3 + f];
                c = sH[c][d];
                var h = tH[d], k = Math.floor(c * e / f + (a[b + 2] >> 1 & 1)) * h, l = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
                (l = l ? parseInt(l[1], 10) : 0) && l <= 87 && d === 2 && e >= 224E3 && g === 0 && (a[b + 3] |= 128);
                return {
                    sampleRate: f,
                    channelCount: g === 3 ? 1 : 2,
                    oa: k,
                    om: c * 8 * h
                };
            }
            return null;
        }
        function uH(a, b) {
            return a[b] === 255 && (a[b + 1] & 224) === 224 && (a[b + 1] & 6) !== 0;
        }
        function vH(a, b) {
            if (b + 1 < a.length && uH(a, b)) {
                var c = pH(a, b), d = 4;
                c && c.oa && (d = c.oa);
                b += d;
                return b === a.length || b + 1 < a.length && uH(a, b);
            }
            return !1;
        }
        var qH = [
            32,
            64,
            96,
            128,
            160,
            192,
            224,
            256,
            288,
            320,
            352,
            384,
            416,
            448,
            32,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            256,
            320,
            384,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            256,
            320,
            32,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            144,
            160,
            176,
            192,
            224,
            256,
            8,
            16,
            24,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            144,
            160
        ], rH = [
            44100,
            48E3,
            32E3,
            22050,
            24E3,
            16E3,
            11025,
            12E3,
            8E3
        ], sH = [
            [
                0,
                72,
                144,
                12
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                72,
                144,
                12
            ],
            [
                0,
                144,
                144,
                12
            ]
        ], tH = [
            0,
            1,
            1,
            4
        ];
        function wH(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = wH.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/mpeg" ? Si(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/mpeg" ? 'audio/mp4; codecs="mp3"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            for(var e = Fb(a), f = qk(e).length; f < e.length && !vH(e, f); f++);
            var g;
            for(a = []; f < e.length;){
                var h = pH(e, f);
                if (!h) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
                g || (g = h);
                f + h.oa <= e.length && a.push({
                    data: e.subarray(f, f + h.oa),
                    size: h.oa,
                    duration: 1152,
                    ub: 0,
                    flags: ZG
                });
                f += h.oa;
            }
            if (!g) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
            e = g.om * 9E4 / g.sampleRate * this.h;
            d = {
                id: b.id,
                type: "audio",
                codecs: "mp3",
                timescale: g.sampleRate,
                duration: d,
                Cb: [],
                Ha: new Uint8Array([]),
                Za: new Uint8Array([]),
                fb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: e,
                    zb: a
                },
                stream: b
            };
            d = new dj([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = ej(d), this.g.set(c, b));
            c = this.i !== b;
            d = Bj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        O("shaka.transmuxer.Mp3Transmuxer", wH);
        wH.prototype.transmux = wH.prototype.transmux;
        wH.prototype.getOriginalMimeType = wH.prototype.getOriginalMimeType;
        wH.prototype.convertCodecs = wH.prototype.convertCodecs;
        wH.prototype.isSupported = wH.prototype.isSupported;
        wH.prototype.destroy = wH.prototype.destroy;
        mf("audio/mpeg", function() {
            return new wH("audio/mpeg");
        }, uf);
        function xH(a) {
            this.h = a;
            this.g = null;
        }
        p = xH.prototype;
        p.destroy = function() {};
        p.isSupported = function(a) {
            if (a.toLowerCase().split(";")[0] != "video/mp2t") return !1;
            var b = Gf(a).split(","), c = Cc("audio", b);
            b = Cc("video", b);
            return !c || b || Cf(c) != "mp3" ? !1 : Si(this.convertCodecs("audio", a));
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "video/mp2t" ? "audio/mpeg" : b;
        };
        p.getOriginalMimeType = function() {
            return this.h;
        };
        p.transmux = function(a, b, c, d, e) {
            this.g ? this.g.clearData() : this.g = new Ek;
            this.g.hg(c.i);
            a = Fb(a);
            a = this.g.parse(a);
            if (a.me().audio != "mp3" || e != "audio") return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
            c = new Uint8Array([]);
            e = u(a.yb());
            for(a = e.next(); !a.done; a = e.next())if (a = a.value.data) for(b = 0; b < a.length;)(d = pH(a, b)) ? (b + d.oa <= a.length && (c = tc(c, a.subarray(b, b + d.oa))), b += d.oa) : b++;
            return Promise.resolve(c);
        };
        O("shaka.transmuxer.MpegTsTransmuxer", xH);
        xH.prototype.transmux = xH.prototype.transmux;
        xH.prototype.getOriginalMimeType = xH.prototype.getOriginalMimeType;
        xH.prototype.convertCodecs = xH.prototype.convertCodecs;
        xH.prototype.isSupported = xH.prototype.isSupported;
        xH.prototype.destroy = xH.prototype.destroy;
        mf("video/mp2t", function() {
            return new xH("video/mp2t");
        }, rf); /*
 @license
 MSS Transmuxer
 Copyright 2015 Dash Industry Forum
 SPDX-License-Identifier: BSD-3-Clause
*/ 
        function yH(a) {
            this.h = a;
            (this.g = Qy.get("ISOBoxer")()) && zH(this);
        }
        function zH(a) {
            function b() {
                this._procFullBox();
                this.flags & 1 && (this._procField("AlgorithmID", "uint", 24), this._procField("IV_size", "uint", 8), this._procFieldArray("KID", 16, "uint", 8));
                this._procField("sample_count", "uint", 32);
                this._procEntries("entry", this.sample_count, function(c) {
                    this._procEntryField(c, "InitializationVector", "data", 8);
                    this.flags & 2 && (this._procEntryField(c, "NumberOfEntries", "uint", 16), this._procSubEntries(c, "clearAndCryptedData", c.NumberOfEntries, function(d) {
                        this._procEntryField(d, "BytesOfClearData", "uint", 16);
                        this._procEntryField(d, "BytesOfEncryptedData", "uint", 32);
                    }));
                });
            }
            a.g.addBoxProcessor("saio", function() {
                this._procFullBox();
                this.flags & 1 && (this._procField("aux_info_type", "uint", 32), this._procField("aux_info_type_parameter", "uint", 32));
                this._procField("entry_count", "uint", 32);
                this._procFieldArray("offset", this.entry_count, "uint", this.version === 1 ? 64 : 32);
            });
            a.g.addBoxProcessor("saiz", function() {
                this._procFullBox();
                this.flags & 1 && (this._procField("aux_info_type", "uint", 32), this._procField("aux_info_type_parameter", "uint", 32));
                this._procField("default_sample_info_size", "uint", 8);
                this._procField("sample_count", "uint", 32);
                this.default_sample_info_size === 0 && this._procFieldArray("sample_info_size", this.sample_count, "uint", 8);
            });
            a.g.addBoxProcessor("senc", b);
            a.g.addBoxProcessor("uuid", function() {
                for(var c = !0, d = 0; d < 16; d++)this.usertype[d] !== AH[d] && (c = !1);
                c && (this._parsing && (this.type = "sepiff"), b.call(this));
            });
        }
        p = yH.prototype;
        p.destroy = function() {};
        p.isSupported = function(a, b) {
            var c = a.startsWith("mss/");
            if (!this.g || !c) return !1;
            if (b) return Si(this.convertCodecs(b, a));
            b = this.convertCodecs("audio", a);
            a = this.convertCodecs("video", a);
            return Si(b) || Si(a);
        };
        p.convertCodecs = function(a, b) {
            return b.replace("mss/", "");
        };
        p.getOriginalMimeType = function() {
            return this.h;
        };
        p.transmux = function(a, b, c) {
            if (!c) return Promise.resolve(Fb(a));
            if (!b.mssPrivateData) return Promise.reject(new T(2, 3, 3020, c ? c.T()[0] : null));
            try {
                var d, e = this.g.parseBuffer(a), f = e.fetch("tfhd");
                f.track_ID = b.id + 1;
                var g = e.fetch("tfdt"), h = e.fetch("traf");
                g === null && (g = this.g.createFullBox("tfdt", h, f), g.version = 1, g.flags = 0, g.baseMediaDecodeTime = Math.floor(c.startTime * b.mssPrivateData.timescale));
                var k = e.fetch("trun"), l = e.fetch("tfxd");
                l && l._parent.boxes.splice(l._parent.boxes.indexOf(l), 1);
                var m = e.fetch("tfrf");
                m && m._parent.boxes.splice(m._parent.boxes.indexOf(m), 1);
                var n = e.fetch("sepiff");
                if (n !== null) {
                    n.type = "senc";
                    n.usertype = void 0;
                    var q = e.fetch("saio");
                    if (q === null) {
                        q = this.g.createFullBox("saio", h);
                        q.version = 0;
                        q.flags = 0;
                        q.entry_count = 1;
                        q.offset = [
                            0
                        ];
                        var r = this.g.createFullBox("saiz", h);
                        r.version = 0;
                        r.flags = 0;
                        r.sample_count = n.sample_count;
                        r.default_sample_info_size = 0;
                        r.sample_info_size = [];
                        if (n.flags & 2) for(d = 0; d < n.sample_count; d += 1)r.sample_info_size[d] = 10 + 6 * n.entry[d].NumberOfEntries;
                        else r.default_sample_info_size = 8;
                    }
                }
                f.flags &= 16777214;
                f.flags |= 131072;
                k.flags |= 1;
                var t = e.fetch("moof");
                k.data_offset = t.getLength() + 8;
                var v = e.fetch("saio");
                v !== null && (v.offset[0] = BH(t, "traf") + BH(h, "senc") + 16);
                var w = Fb(e.write());
                return Promise.resolve(w);
            } catch (x) {
                return x instanceof T ? Promise.reject(x) : Promise.reject(new T(2, 3, 3022, c ? c.T()[0] : null));
            }
        };
        function BH(a, b) {
            for(var c = 8, d = 0; d < a.boxes.length && a.boxes[d].type !== b; d++)c += a.boxes[d].size;
            return c;
        }
        O("shaka.transmuxer.MssTransmuxer", yH);
        yH.prototype.transmux = yH.prototype.transmux;
        yH.prototype.getOriginalMimeType = yH.prototype.getOriginalMimeType;
        yH.prototype.convertCodecs = yH.prototype.convertCodecs;
        yH.prototype.isSupported = yH.prototype.isSupported;
        yH.prototype.destroy = yH.prototype.destroy;
        var AH = new Uint8Array([
            162,
            57,
            79,
            82,
            90,
            155,
            79,
            20,
            162,
            68,
            108,
            66,
            124,
            100,
            141,
            244
        ]);
        mf("mss/audio/mp4", function() {
            return new yH("mss/audio/mp4");
        }, uf);
        mf("mss/video/mp4", function() {
            return new yH("mss/video/mp4");
        }, uf);
        function CH(a) {
            if (a.length < 1) return 960;
            var b = a[0], c = b & 3;
            b = DH[b >> 3 & 31];
            if (c === 0) a = 1;
            else if (c === 1 || c === 2) a = 2;
            else {
                if (a.length < 2) return b;
                a = a[1] & 63;
                if (a === 0) return b;
            }
            return b * a;
        }
        var DH = [
            480,
            960,
            1920,
            2880,
            480,
            960,
            1920,
            2880,
            480,
            960,
            1920,
            2880,
            480,
            960,
            480,
            960,
            120,
            240,
            480,
            960,
            120,
            240,
            480,
            960,
            120,
            240,
            480,
            960,
            120,
            240,
            480,
            960
        ];
        function EH(a) {
            this.m = a;
            this.g = 0;
            this.j = new Map;
            this.l = this.i = this.h = null;
        }
        p = EH.prototype;
        p.destroy = function() {
            this.j.clear();
            this.i && this.i.destroy();
        };
        p.isSupported = function(a, b) {
            if (a.toLowerCase().split(";")[0] != "video/mp2t") return !1;
            var c = a;
            b && (c = this.convertCodecs(b, a));
            var d = Gf(c).split(",");
            c = Cc("audio", d);
            d = Cc("video", d);
            if (c && (c = Cf(c), !FH.includes(c)) || d && (c = Cf(d), !GH.includes(c))) return !1;
            if (b) return Si(this.convertCodecs(b, a));
            b = this.convertCodecs("audio", a);
            a = this.convertCodecs("video", a);
            return Si(b) || Si(a);
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "video/mp2t" ? (b = Gf(b).replace("mp4a.40.34", "mp3").split(",").map(function(c) {
                return rg(c, "audio/mp4");
            }).map(sg).join(","), a == "audio" ? 'audio/mp4; codecs="' + b + '"' : 'video/mp4; codecs="' + b + '"') : b;
        };
        p.getOriginalMimeType = function() {
            return this.m;
        };
        p.transmux = function(a, b, c, d, e) {
            var f = Fb(a);
            if (e == "audio" && !Rk(f)) {
                for(var g = qk(f), h = g.length; h < f.length; h++)if (vH(f, h)) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
                for(h = g.length; h < f.length; h++)if (XG(f, h)) return this.i || (this.i = new bH("audio/aac")), this.i.transmux(a, b, c, d, e);
                return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
            }
            this.h ? this.h.clearData() : this.h = new Ek;
            this.h.hg(c.i);
            var k = this.h.parse(f), l = [], m = k.me();
            try {
                var n = null;
                if (e == "video") {
                    switch(m.video){
                        case "avc":
                            var q = [], r = null, t = k.Ed(), v = jH(t);
                            if (!v.length) throw new T(2, 3, 3023, c ? c.T()[0] : null);
                            for(var w = 0; w < v.length; w++){
                                var x = v[w];
                                r == null && (r = x.dts);
                                var y = void 0;
                                y = w + 1 < v.length ? (v[w + 1].dts || 0) - (x.dts || 0) : v.length > 1 ? (x.dts || 0) - (v[w - 1].dts || 0) : (c.endTime - c.startTime) * 9E4;
                                q.push({
                                    data: x.data,
                                    size: x.data.byteLength,
                                    duration: y,
                                    ub: Math.round((x.pts || 0) - (x.dts || 0)),
                                    flags: x.isKeyframe ? $G : aH
                                });
                            }
                            for(var z = [], A = u(t), E = A.next(); !E.done; E = A.next())z.push.apply(z, G(E.value.nalus));
                            var C = hH(z);
                            if (!C || r == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            b.height = b.height || C.height;
                            b.width = b.width || C.width;
                            n = {
                                id: b.id,
                                type: "video",
                                codecs: "avc1",
                                timescale: 9E4,
                                duration: d,
                                Cb: [],
                                Ha: new Uint8Array([]),
                                Za: C.Za,
                                fb: C.fb,
                                gb: C.gb,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: r,
                                    zb: q
                                },
                                stream: b
                            };
                            break;
                        case "hvc":
                            var D = [], B = null, J = [], F = k.Ed(), I = new Uint8Array(0), K = !1;
                            if (!F.length) throw new T(2, 3, 3023, c ? c.T()[0] : null);
                            for(var N = 0; N < F.length; N++){
                                var P = F[N], M = P.nalus;
                                J.push.apply(J, G(M));
                                for(var L = !1, Q = [], S = 0, Z = !1, pa = u(M), va = pa.next(); !va.done; va = pa.next()){
                                    var Ca = va.value;
                                    switch(Ca.type){
                                        case 1:
                                        case 0:
                                            var ua = Z = !0;
                                            break;
                                        case 19:
                                        case 20:
                                        case 21:
                                            L = ua = Z = !0;
                                            break;
                                        case 32:
                                        case 33:
                                        case 34:
                                            ua = !0;
                                            break;
                                        case 35:
                                            Z = ua = !0;
                                            break;
                                        case 39:
                                        case 40:
                                            ua = !0;
                                            break;
                                        default:
                                            ua = !1;
                                    }
                                    Z && ua && (Q.push(Ca.fullData), S += Ca.fullData.byteLength);
                                }
                                if (Q.length) {
                                    S += 4 * Q.length;
                                    for(var xa = new Uint8Array(S), Da = 0, Ka = u(Q), wa = Ka.next(); !wa.done; wa = Ka.next()){
                                        var Ja = wa.value, Aa = Ja.byteLength;
                                        xa[Da] = Aa >> 24 & 255;
                                        xa[Da + 1] = Aa >> 16 & 255;
                                        xa[Da + 2] = Aa >> 8 & 255;
                                        xa[Da + 3] = Aa & 255;
                                        xa.set(Ja, Da + 4);
                                        Da += Aa + 4;
                                    }
                                    I = xa;
                                    K = L;
                                    var Ga = !0;
                                } else Ga = !1;
                                if (Ga) {
                                    B == null && P.dts != null && (B = P.dts);
                                    var sb = void 0;
                                    sb = N + 1 < F.length ? (F[N + 1].dts || 0) - (P.dts || 0) : F.length > 1 ? (P.dts || 0) - (F[N - 1].dts || 0) : (c.endTime - c.startTime) * 9E4;
                                    D.push({
                                        data: I,
                                        size: I.byteLength,
                                        duration: sb,
                                        ub: Math.round((P.pts || 0) - (P.dts || 0)),
                                        flags: K ? $G : aH
                                    });
                                }
                            }
                            var Wb = kH(J);
                            if (!Wb || B == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            b.height = b.height || Wb.height;
                            b.width = b.width || Wb.width;
                            n = {
                                id: b.id,
                                type: "video",
                                codecs: "hvc1",
                                timescale: 9E4,
                                duration: d,
                                Cb: [],
                                Ha: new Uint8Array([]),
                                Za: Wb.Za,
                                fb: Wb.fb,
                                gb: Wb.gb,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: B,
                                    zb: D
                                },
                                stream: b
                            };
                    }
                    n && (l.push(n), n = null);
                }
                if (e == "audio") {
                    switch(m.audio){
                        case "aac":
                            for(var wb = [], wc, he = null, hd = null, qd = null, sf = u(k.yb()), Bg = sf.next(); !Bg.done; Bg = sf.next()){
                                var rd = Bg.value, xc = rd.data;
                                if (xc) {
                                    var nc = 0;
                                    if (hd == -1 && qd) xc = tc(qd, rd.data), hd = null;
                                    else if (hd != null && qd) {
                                        nc = Math.max(0, hd);
                                        var mi = tc(qd, xc.subarray(0, nc));
                                        wb.push({
                                            data: mi,
                                            size: mi.byteLength,
                                            duration: 1024,
                                            ub: 0,
                                            flags: ZG
                                        });
                                        hd = qd = null;
                                    }
                                    wc = WG(xc, nc);
                                    if (!wc) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                                    b.audioSamplingRate = wc.sampleRate;
                                    b.channelsCount = wc.channelCount;
                                    he == null && rd.pts !== null && (he = rd.pts);
                                    for(; nc < xc.length;){
                                        var oc = VG(xc, nc);
                                        if (!oc) {
                                            qd = xc.subarray(nc, xc.length);
                                            hd = -1;
                                            break;
                                        }
                                        var tf = oc.re + oc.oa;
                                        hd = Math.max(0, nc + tf - xc.length);
                                        hd != 0 ? qd = xc.subarray(nc + oc.re, nc + tf) : nc + tf <= xc.length && wb.push({
                                            data: xc.subarray(nc + oc.re, nc + tf),
                                            size: oc.oa,
                                            duration: 1024,
                                            ub: 0,
                                            flags: ZG
                                        });
                                        nc += tf;
                                    }
                                }
                            }
                            if (!wc || he == null) {
                                he = c.startTime * 9E4;
                                var ni = Cc("audio", b.codecs.split(","));
                                if (!ni || !b.channelsCount || !b.audioSamplingRate) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                                wc = {
                                    sampleRate: b.audioSamplingRate,
                                    channelCount: b.channelsCount,
                                    codec: ni
                                };
                                var oi = YG(ni, b.channelsCount);
                                if (!oi) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                                for(var lp = he + (c.endTime - c.startTime) * 9E4, Yk = he; Yk < lp;)wb.push({
                                    data: oi,
                                    size: oi.byteLength,
                                    duration: 1024,
                                    ub: 0,
                                    flags: ZG
                                }), Yk += 1024 / wc.sampleRate * 9E4;
                            }
                            var Db = wc.sampleRate, Ac = he / 9E4 * Db;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: wc.codec,
                                timescale: Db,
                                duration: d,
                                Cb: [],
                                Ha: new Uint8Array([]),
                                Za: new Uint8Array([]),
                                fb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: Ac,
                                    zb: wb
                                },
                                stream: b
                            };
                            break;
                        case "ac3":
                            for(var pc = [], Gl = 0, uq = new Uint8Array([]), Hl = null, Pe = {
                                sampleRate: 0,
                                channelCount: 0,
                                Ha: new Uint8Array(0),
                                oa: 0
                            }, OA = u(k.yb()), vq = OA.next(); !vq.done; vq = OA.next()){
                                var wq = vq.value, xq = wq.data;
                                Hl == null && wq.pts !== null && (Hl = wq.pts);
                                for(var Hg = 0; Hg < xq.length;)cH(xq, Hg, Pe) ? (b.audioSamplingRate = Pe.sampleRate, b.channelsCount = Pe.channelCount, Gl = Pe.sampleRate, uq = Pe.Ha, pc.push({
                                    data: xq.subarray(Hg, Hg + Pe.oa),
                                    size: Pe.oa,
                                    duration: 1536,
                                    ub: 0,
                                    flags: ZG
                                }), Hg += Pe.oa) : Hg++;
                            }
                            if (Gl == 0 || uq.byteLength == 0 || Hl == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            var AL = Hl / 9E4 * Gl;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "ac-3",
                                timescale: Gl,
                                duration: d,
                                Cb: [],
                                Ha: uq,
                                Za: new Uint8Array([]),
                                fb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: AL,
                                    zb: pc
                                },
                                stream: b
                            };
                            break;
                        case "ec3":
                            for(var PA = [], Il = 0, yq = new Uint8Array([]), Jl = null, Qe = {
                                sampleRate: 0,
                                channelCount: 0,
                                Ha: new Uint8Array(0),
                                oa: 0
                            }, QA = u(k.yb()), zq = QA.next(); !zq.done; zq = QA.next()){
                                var Aq = zq.value, Bq = Aq.data;
                                Jl == null && Aq.pts !== null && (Jl = Aq.pts);
                                for(var Ig = 0; Ig < Bq.length;)fH(Bq, Ig, Qe) ? (b.audioSamplingRate = Qe.sampleRate, b.channelsCount = Qe.channelCount, Il = Qe.sampleRate, yq = Qe.Ha, PA.push({
                                    data: Bq.subarray(Ig, Ig + Qe.oa),
                                    size: Qe.oa,
                                    duration: 1536,
                                    ub: 0,
                                    flags: ZG
                                }), Ig += Qe.oa) : Ig++;
                            }
                            if (Il == 0 || yq.byteLength == 0 || Jl == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            var BL = Jl / 9E4 * Il;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "ec-3",
                                timescale: Il,
                                duration: d,
                                Cb: [],
                                Ha: yq,
                                Za: new Uint8Array([]),
                                fb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: BL,
                                    zb: PA
                                },
                                stream: b
                            };
                            break;
                        case "mp3":
                            for(var RA = [], Kl, Ll = null, SA = u(k.yb()), Cq = SA.next(); !Cq.done; Cq = SA.next()){
                                var Dq = Cq.value, Bi = Dq.data;
                                if (Bi) {
                                    Ll == null && Dq.pts !== null && (Ll = Dq.pts);
                                    for(var xf = 0; xf < Bi.length;){
                                        var Jg = pH(Bi, xf);
                                        Jg ? (Kl || (Kl = Jg), xf + Jg.oa <= Bi.length && RA.push({
                                            data: Bi.subarray(xf, xf + Jg.oa),
                                            size: Jg.oa,
                                            duration: 1152,
                                            ub: 0,
                                            flags: ZG
                                        }), xf += Jg.oa) : xf++;
                                    }
                                }
                            }
                            if (!Kl || Ll == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            var TA = Kl.sampleRate, CL = Ll / 9E4 * TA;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "mp3",
                                timescale: TA,
                                duration: d,
                                Cb: [],
                                Ha: new Uint8Array([]),
                                Za: new Uint8Array([]),
                                fb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: CL,
                                    zb: RA
                                },
                                stream: b
                            };
                            break;
                        case "opus":
                            var UA = [], Ml = null, Gd = k.J;
                            if (!Gd) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            var fc = [];
                            switch(Gd.vk){
                                case 1:
                                case 2:
                                    fc = [
                                        0
                                    ];
                                    break;
                                case 0:
                                    fc = [
                                        255,
                                        1,
                                        1,
                                        0,
                                        1
                                    ];
                                    break;
                                case 128:
                                    fc = [
                                        255,
                                        2,
                                        0,
                                        0,
                                        1
                                    ];
                                    break;
                                case 3:
                                    fc = [
                                        1,
                                        2,
                                        1,
                                        0,
                                        2,
                                        1
                                    ];
                                    break;
                                case 4:
                                    fc = [
                                        1,
                                        2,
                                        2,
                                        0,
                                        1,
                                        2,
                                        3
                                    ];
                                    break;
                                case 5:
                                    fc = [
                                        1,
                                        3,
                                        2,
                                        0,
                                        4,
                                        1,
                                        2,
                                        3
                                    ];
                                    break;
                                case 6:
                                    fc = [
                                        1,
                                        4,
                                        2,
                                        0,
                                        4,
                                        1,
                                        2,
                                        3,
                                        5
                                    ];
                                    break;
                                case 7:
                                    fc = [
                                        1,
                                        4,
                                        2,
                                        0,
                                        4,
                                        1,
                                        2,
                                        3,
                                        5,
                                        6
                                    ];
                                    break;
                                case 8:
                                    fc = [
                                        1,
                                        5,
                                        3,
                                        0,
                                        6,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        7
                                    ];
                                    break;
                                case 130:
                                    fc = [
                                        1,
                                        1,
                                        2,
                                        0,
                                        1
                                    ];
                                    break;
                                case 131:
                                    fc = [
                                        1,
                                        1,
                                        3,
                                        0,
                                        1,
                                        2
                                    ];
                                    break;
                                case 132:
                                    fc = [
                                        1,
                                        1,
                                        4,
                                        0,
                                        1,
                                        2,
                                        3
                                    ];
                                    break;
                                case 133:
                                    fc = [
                                        1,
                                        1,
                                        5,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ];
                                    break;
                                case 134:
                                    fc = [
                                        1,
                                        1,
                                        6,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5
                                    ];
                                    break;
                                case 135:
                                    fc = [
                                        1,
                                        1,
                                        7,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ];
                                    break;
                                case 136:
                                    fc = [
                                        1,
                                        1,
                                        8,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ];
                            }
                            var VA = new Uint8Array([
                                0,
                                Gd.channelCount,
                                0,
                                0,
                                Gd.sampleRate >>> 24 & 255,
                                Gd.sampleRate >>> 17 & 255,
                                Gd.sampleRate >>> 8 & 255,
                                Gd.sampleRate >>> 0 & 255,
                                0,
                                0
                            ].concat(G(fc)));
                            for(var WA = Gd.sampleRate, XA = u(k.yb()), Eq = XA.next(); !Eq.done; Eq = XA.next()){
                                var Fq = Eq.value, Kg = Fq.data;
                                Ml == null && Fq.pts !== null && (Ml = Fq.pts);
                                for(var Ci = 0; Ci < Kg.length;){
                                    for(var DL = (Kg[Ci + 1] & 16) !== 0, EL = (Kg[Ci + 1] & 8) !== 0, je = Ci + 2, Nl = 0; Kg[je] === 255;)Nl += 255, je += 1;
                                    Nl += Kg[je];
                                    je += 1;
                                    je += DL ? 2 : 0;
                                    je += EL ? 2 : 0;
                                    var Gq = Kg.slice(je, je + Nl);
                                    UA.push({
                                        data: Gq,
                                        size: Gq.byteLength,
                                        duration: CH(Gq),
                                        ub: 0,
                                        flags: ZG
                                    });
                                    Ci = je + Nl;
                                }
                            }
                            if (VA.byteLength == 0 || Ml == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            b.audioSamplingRate = Gd.sampleRate;
                            b.channelsCount = Gd.channelCount;
                            var FL = Ml / 9E4 * WA;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "opus",
                                timescale: WA,
                                duration: d,
                                Cb: [],
                                Ha: VA,
                                Za: new Uint8Array([]),
                                fb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: FL,
                                    zb: UA
                                },
                                stream: b
                            };
                    }
                    n && (l.push(n), n = null);
                }
            } catch (Hq) {
                return Hq && Hq.code == 3023 ? Promise.resolve(new Uint8Array([])) : Promise.reject(Hq);
            }
            if (!l.length) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
            var YA = new dj(l), Iq = b.id + "_" + c.i;
            if (this.j.has(Iq)) var Di = this.j.get(Iq);
            else Di = ej(YA), this.j.set(Iq, Di);
            var GL = this.l !== Di, HL = Bj(YA);
            this.l = Di;
            this.g++;
            return Promise.resolve({
                data: HL,
                init: GL ? Di : null
            });
        };
        O("shaka.transmuxer.TsTransmuxer", EH);
        EH.prototype.transmux = EH.prototype.transmux;
        EH.prototype.getOriginalMimeType = EH.prototype.getOriginalMimeType;
        EH.prototype.convertCodecs = EH.prototype.convertCodecs;
        EH.prototype.isSupported = EH.prototype.isSupported;
        EH.prototype.destroy = EH.prototype.destroy;
        var FH = [
            "aac",
            "ac-3",
            "ec-3",
            "mp3",
            "opus"
        ], GH = [
            "avc",
            "hevc"
        ];
        mf("video/mp2t", function() {
            return new EH("video/mp2t");
        }, qf);
        function HH() {}
        oa(HH, go);
        O("shaka.util.FairPlayUtils", HH);
        function IH(a, b) {
            var c = this;
            this.parent = a;
            this.controls = b;
            this.eventManager = new fd;
            this.localization = this.controls.ya;
            this.player = this.controls.Rb();
            this.video = this.controls.Rc();
            this.adManager = this.player.tf();
            this.ad = b.getAd();
            this.eventManager.u(this.adManager, "ad-started", function(d) {
                c.ad = d.ad;
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                c.ad = null;
            });
        }
        IH.prototype.release = function() {
            this.eventManager.release();
            this.ad = this.adManager = this.video = this.player = this.localization = this.eventManager = this.controls = this.parent = null;
        };
        O("shaka.ui.Element", IH);
        IH.prototype.release = IH.prototype.release;
        function JH(a, b) {
            this.parent = a;
            this.g = bk("svg");
            this.h = bk("path");
            this.g.classList.add("material-svg-icon");
            this.g.setAttribute("viewBox", "0 -960 960 960");
            b && this.use(b);
            this.g.appendChild(this.h);
            this.parent && a.appendChild(this.g);
        }
        JH.prototype.use = function(a) {
            a && typeof a == "string" && this.h.setAttribute("d", a);
        };
        JH.prototype.ll = function() {
            return this.g;
        };
        O("shaka.ui.MaterialSVGIcon", JH);
        JH.prototype.getSvgElement = JH.prototype.ll;
        JH.prototype.use = JH.prototype.use;
        function KH(a) {
            return LH(a, "shaka-back-to-overflow-button");
        }
        function LH(a, b) {
            a = a.getElementsByClassName(b);
            return a.length ? a[0] : null;
        }
        function MH(a) {
            a && (a = LH(a, "shaka-chosen-item")) && a.parentElement.focus();
        }
        function NH() {
            var a = new JH(null, "m382-354 339-339q12-12 28-12t28 12q12 12 12 28.5T777-636L410-268q-12 12-28 12t-28-12L182-440q-12-12-11.5-28.5T183-497q12-12 28.5-12t28.5 12l142 143Z").g;
            a.classList.add("shaka-chosen-item");
            a.ariaHidden = "true";
            return a;
        }
        function OH(a, b) {
            a && (b ? a.classList.remove("shaka-hidden") : a.classList.add("shaka-hidden"));
        }
        function PH(a, b) {
            var c = Math.floor(a / 86400), d = Math.floor(a % 86400 / 3600), e = Math.floor(a / 60 % 60);
            a = Math.floor(a % 60);
            a < 10 && (a = "0" + a);
            a = e + ":" + a;
            b && (e < 10 && (a = "0" + a), a = d + ":" + a, c > 0 && (d < 10 && (a = "0" + a), a = c + ":" + a));
            return a;
        }
        function QH(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-ad-info");
            this.g.disabled = !0;
            this.parent.appendChild(this.g);
            this.h = new Uf(function() {
                if (c.ad.isLinear()) {
                    var d = "", e = c.ad.getSequenceLength();
                    e > 1 && (d = c.ad.getPositionInSequence(), d = c.localization.resolve("AD_PROGRESS").replace("[AD_ON]", String(d)).replace("[NUM_ADS]", String(e)));
                    var f = Math.round(c.ad.getRemainingTime()), g = c.ad.getDuration();
                    f != -1 && g != -1 && isFinite(f) && isFinite(g) ? f > 0 ? (f = PH(g - f, !1) + " / " + PH(g, !1), d = e > 1 ? d + ("\u00a0\u00a0" + f) : c.localization.resolve("AD_TIME").replace("[AD_TIME]", f), c.g.textContent = d, OH(c.g, d != "")) : (c.h.stop(), c.g.textContent = "") : (c.g.textContent = d, OH(c.g, d != ""));
                }
            });
            this.eventManager.u(this.localization, "locale-updated", function() {});
            this.eventManager.u(this.localization, "locale-changed", function() {});
            this.eventManager.u(this.adManager, "ad-started", function() {
                c.h.La();
                c.h.xa(.5);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                c.h.stop();
                c.g.textContent = "";
            });
            this.ad && (this.h.La(), this.h.xa(.5));
        }
        oa(QH, IH);
        QH.prototype.release = function() {
            this.h.stop();
            this.h = null;
            IH.prototype.release.call(this);
        };
        O("shaka.ui.AdInfo", QH);
        function RH(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.j = this.controls.g;
            this.h = this.controls.i;
            this.i = [];
            this.g = U("div");
            this.g.classList.add("shaka-no-propagation");
            this.g.classList.add("shaka-context-menu");
            this.g.classList.add("shaka-hidden");
            this.h.appendChild(this.g);
            this.eventManager.u(this.h, "contextmenu", function(d) {
                if (c.g.classList.contains("shaka-hidden")) {
                    d.preventDefault();
                    var e = c.h.getBoundingClientRect();
                    c.g.style.left = d.clientX - e.left + "px";
                    c.g.style.top = d.clientY - e.top + "px";
                    OH(c.g, !0);
                } else OH(c.g, !1);
            });
            this.eventManager.u(window1, "click", function() {
                OH(c.g, !1);
            });
            this.eventManager.u(this.g, "click", function() {
                OH(c.g, !1);
            });
            this.eventManager.u(document, "click", function(d) {
                !c.h || c.g.classList.contains("shaka-hidden") || c.h.contains(d.target) || c.Og();
            });
            SH(this);
        }
        oa(RH, IH);
        RH.prototype.release = function() {
            this.h = null;
            for(var a = u(this.i), b = a.next(); !b.done; b = a.next())b.value.release();
            this.i = [];
            IH.prototype.release.call(this);
        };
        RH.prototype.Og = function() {
            OH(this.g, !1);
        };
        function TH(a, b) {
            UH.set(a, b);
        }
        function SH(a) {
            for(var b = u(a.j.contextMenuElements), c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = UH.get(c);
                d ? a.i.push(d.create(a.g, a.controls)) : Za("Unrecognized context menu element:", c);
            }
        }
        O("shaka.ui.ContextMenu", RH);
        RH.registerElement = TH;
        RH.prototype.closeMenu = RH.prototype.Og;
        var UH = new Map;
        function VH(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.button = ck();
            this.parent.appendChild(this.button);
            this.h = new JH(this.button);
            this.eventManager.u(this.localization, "locale-updated", function() {
                WH(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                WH(c);
            });
            this.eventManager.u(this.video, "play", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.video, "pause", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.video, "seeking", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.player, "loaded", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.adManager, "ad-paused", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.adManager, "ad-resumed", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.button, "click", function() {
                c.controls.Ca() && XH(c.controls);
            });
            WH(this);
            this.g();
        }
        oa(VH, IH);
        VH.prototype.isPaused = function() {
            if (this.ad && this.ad.isLinear()) var a = this.ad.isPaused();
            else a = this.controls, a = a.C.paused && !a.V;
            return a;
        };
        VH.prototype.isEnded = function() {
            return this.ad && this.ad.isLinear() ? !1 : this.player ? this.player.isEnded() : !0;
        };
        function WH(a) {
            if (a.isEnded() && a.video.duration) a.button.ariaLabel = a.localization.resolve("REPLAY");
            else {
                var b = a.isPaused() ? "PLAY" : "PAUSE";
                a.button.ariaLabel = a.localization.resolve(b);
            }
        }
        VH.prototype.g = function() {
            this.isEnded() && this.video.duration ? this.h.use("M480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440q0-17 11.5-28.5T160-480q17 0 28.5 11.5T200-440q0 117 81.5 198.5T480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720h-6l34 34q12 12 11.5 28T508-630q-12 12-28.5 12.5T451-629L348-732q-12-12-12-28t12-28l103-103q12-12 28.5-11.5T508-890q11 12 11.5 28T508-834l-34 34h6q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-440q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80Z") : this.h.use(this.isPaused() ? "M320-273v-414q0-17 12-28.5t28-11.5q5 0 10.5 1.5T381-721l326 207q9 6 13.5 15t4.5 19q0 10-4.5 19T707-446L381-239q-5 3-10.5 4.5T360-233q-16 0-28-11.5T320-273Z" : "M640-200q-33 0-56.5-23.5T560-280v-400q0-33 23.5-56.5T640-760q33 0 56.5 23.5T720-680v400q0 33-23.5 56.5T640-200Zm-320 0q-33 0-56.5-23.5T240-280v-400q0-33 23.5-56.5T320-760q33 0 56.5 23.5T400-680v400q0 33-23.5 56.5T320-200Z");
        };
        O("shaka.ui.PlayButton", VH);
        function YH(a, b) {
            VH.call(this, a, b);
            this.button.classList.add("shaka-play-button");
            this.button.classList.add("shaka-no-propagation");
        }
        oa(YH, VH);
        YH.prototype.g = function() {
            this.isEnded() && this.video.duration ? this.button.setAttribute("icon", "replay") : this.isPaused() ? this.button.setAttribute("icon", "play") : this.button.setAttribute("icon", "pause");
        };
        O("shaka.ui.BigPlayButton", YH);
        function ZH(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.m = null;
            this.i = this.D = !1;
            this.C = this.A = null;
            this.j = new Uf(function() {
                parseInt(c.h.textContent, 10) === 0 && $H(c.controls, !0);
                var d = parseInt(c.h.textContent, 10);
                d !== 0 && (c.video.currentTime = c.controls.qh() + d);
                c.g.style.opacity = "0";
                c.D = !1;
                c.h.textContent = "0s";
            });
            this.g = U("div");
            this.g.classList.add("shaka-no-propagation");
            this.parent.appendChild(this.g);
            this.h = U("span");
            this.h.textContent = "0s";
            this.g.appendChild(this.h);
            this.o = new JH(this.g);
            this.o.g.classList.add("shaka-forward-rewind-container-icon");
            this.l = !1;
            this.eventManager.u(this.g, "touchstart", function(d) {
                d.touches.length > 0 && (c.A = d.touches[0].clientX, c.C = d.touches[0].clientY);
                c.i = !1;
            });
            this.eventManager.u(this.g, "touchmove", function(d) {
                if (d.touches.length > 0 && c.A != null && c.C != null) {
                    var e = d.touches[0].clientX - c.A;
                    d = d.touches[0].clientY - c.C;
                    Math.sqrt(e * e + d * d) > 10 && (c.i = !0);
                }
            });
            this.eventManager.u(this.g, "touchend", function(d) {
                if (!c.i) {
                    if (c.controls.Jc()) d.preventDefault(), c.controls.Sc();
                    else if (c.controls.g.tapSeekDistance > 0 && (!c.ad || !c.ad.isLinear())) {
                        if (d.preventDefault(), d = c.controls.g.tapSeekDistance, !c.D) c.D = !0, c.m = Date.now(), c.j.Z(.5);
                        else if (c.m + 500 > Date.now()) {
                            c.j.stop();
                            c.m = Date.now();
                            var e = parseInt(c.h.textContent, 10);
                            e = c.l ? e - d : e + d;
                            c.h.textContent = e.toString() + "s";
                            c.g.style.opacity = "1";
                            c.j.Z(.5);
                        }
                    }
                }
            });
        }
        oa(ZH, IH);
        O("shaka.ui.HiddenSeekButton", ZH);
        function aI(a, b) {
            ZH.call(this, a, b);
            this.g.classList.add("shaka-fast-forward-container");
            this.o.use("M100-315v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T428-480q0 10-4.5 18.5T410-447L162-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Zm400 0v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T828-480q0 10-4.5 18.5T810-447L562-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Z");
            this.l = !1;
        }
        oa(aI, ZH);
        O("shaka.ui.HiddenFastForwardButton", aI);
        function bI(a, b) {
            ZH.call(this, a, b);
            this.g.classList.add("shaka-rewind-container");
            this.o.use("M798-281 550-447q-9-6-13.5-14.5T532-480q0-10 4.5-18.5T550-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Zm-400 0L150-447q-9-6-13.5-14.5T132-480q0-10 4.5-18.5T150-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Z");
            this.l = !0;
        }
        oa(bI, ZH);
        O("shaka.ui.HiddenRewindButton", bI);
        function cI(a, b, c, d) {
            IH.call(this, a, b);
            var e = this;
            this.container = U("div");
            this.container.classList.add("shaka-range-container");
            this.container.classList.add.apply(this.container.classList, G(c));
            this.o = this.h = !1;
            this.bar = document.createElement("input");
            this.H = new Uf(function() {
                e.onChangeEnd();
                e.h = !1;
            });
            this.bar.classList.add("shaka-range-element");
            this.bar.classList.add.apply(this.bar.classList, G(d));
            this.bar.type = "range";
            this.bar.step = "any";
            this.bar.min = "0";
            this.bar.max = "1";
            this.bar.value = "0";
            this.bar.disabled = !this.controls.Ca();
            this.container.appendChild(this.bar);
            this.parent.appendChild(this.container);
            this.M = new Uf(function() {
                e.bar.disabled = !1;
            });
            this.eventManager.u(this.controls, "showingui", function() {
                e.M.Z(0);
            });
            this.eventManager.u(this.controls, "hidingui", function() {
                e.M.stop();
                e.bar.disabled = !0;
            });
            this.eventManager.u(this.bar, "mousedown", function(f) {
                e.bar.disabled || (f.preventDefault(), e.bar.focus(), e.h = !0, e.o = !0, dI(e, f), e.onChangeStart(), e.onChange(), f.stopPropagation());
            });
            this.eventManager.u(document, "mousemove", function(f) {
                e.o && (dI(e, f), e.onChange());
            });
            this.eventManager.u(document, "mouseup", function(f) {
                e.o && (e.o = !1, e.h && (e.h = !1, dI(e, f), e.onChangeEnd()));
            });
            this.eventManager.u(this.bar, "touchstart", function(f) {
                e.bar.disabled || (e.h = !0, eI(e, f), e.onChangeStart(), f.stopPropagation());
            });
            this.eventManager.u(this.bar, "input", function() {
                e.onChange();
            });
            this.eventManager.u(this.bar, "touchmove", function(f) {
                e.h && (eI(e, f), e.onChange(), f.stopPropagation());
            });
            this.eventManager.u(this.bar, "touchend", function(f) {
                e.h && (e.h = !1, eI(e, f), e.onChangeEnd(), f.stopPropagation());
            });
            this.eventManager.u(this.bar, "touchcancel", function(f) {
                e.h && (e.h = !1, eI(e, f), e.onChangeEnd(), f.stopPropagation());
            });
            this.eventManager.u(this.bar, "mouseup", function(f) {
                e.h && (e.h = !1, e.o = !1, dI(e, f), e.onChangeEnd(), f.stopPropagation());
            });
            this.eventManager.u(this.bar, "blur", function() {
                e.h && (e.h = !1, e.o = !1, e.onChangeEnd());
            });
            this.eventManager.u(this.bar, "contextmenu", function(f) {
                f.preventDefault();
                f.stopPropagation();
            });
        }
        oa(cI, IH);
        p = cI.prototype;
        p.release = function() {
            this.H && (this.H.stop(), this.H = null);
            IH.prototype.release.call(this);
        };
        p.setRange = function(a, b) {
            this.bar.min = a;
            this.bar.max = b;
        };
        p.onChangeStart = function() {};
        p.onChange = function() {};
        p.onChangeEnd = function() {};
        p.changeTo = function(a) {
            this.h || (this.h = !0, this.onChangeStart());
            var b = parseFloat(this.bar.min), c = parseFloat(this.bar.max);
            this.bar.value = a > c ? c : a < b ? b : a;
            this.onChange();
            this.H.Z(.5);
        };
        p.getValue = function() {
            return parseFloat(this.bar.value);
        };
        p.setValue = function(a) {
            this.h || (this.bar.value = a);
        };
        function fI(a, b) {
            var c = a.bar.getBoundingClientRect(), d = parseFloat(a.bar.min), e = parseFloat(a.bar.max);
            a = parseFloat(a.bar.step) || 1;
            var f = c.left + 6;
            c = c.right - 6;
            b = d + (Math.max(f, Math.min(c, b)) - f) / (c - f) * (e - d);
            b = Math.round((b - d) / a) * a + d;
            return b = Math.min(e, Math.max(d, b));
        }
        function dI(a, b) {
            a.bar.value = fI(a, b.clientX);
        }
        function eI(a, b) {
            b.preventDefault();
            a.bar.value = fI(a, b.changedTouches[0].clientX);
        }
        O("shaka.ui.RangeElement", cI);
        cI.prototype.setValue = cI.prototype.setValue;
        cI.prototype.getValue = cI.prototype.getValue;
        cI.prototype.changeTo = cI.prototype.changeTo;
        cI.prototype.onChangeEnd = cI.prototype.onChangeEnd;
        cI.prototype.onChange = cI.prototype.onChange;
        cI.prototype.onChangeStart = cI.prototype.onChangeStart;
        cI.prototype.setRange = cI.prototype.setRange;
        function gI(a, b) {
            cI.call(this, a, b, [
                "shaka-seek-bar-container"
            ], [
                "shaka-seek-bar",
                "shaka-no-propagation",
                "shaka-show-controls-on-mouse-over"
            ]);
            var c = this;
            this.G = U("div");
            this.G.classList.add("shaka-ad-markers");
            this.container.insertBefore(this.G, this.container.childNodes[0]);
            this.J = this.controls.g;
            this.D = new Uf(function() {
                var d = c.getValue();
                c.player.U() || d == c.video.duration && (d -= .001);
                c.video.currentTime = d;
            });
            this.F = new Uf(function() {
                hI(c);
            });
            this.O = !1;
            this.i = U("div");
            this.i.id = "shaka-player-ui-thumbnail-container";
            this.g = U("img");
            this.g.id = "shaka-player-ui-thumbnail-image";
            this.g.draggable = !1;
            this.L = U("div");
            this.L.id = "shaka-player-ui-thumbnail-time-container";
            this.I = U("div");
            this.I.id = "shaka-player-ui-thumbnail-time";
            this.L.appendChild(this.I);
            this.i.appendChild(this.g);
            this.i.appendChild(this.L);
            this.container.appendChild(this.i);
            this.j = U("div");
            this.j.id = "shaka-player-ui-time-container";
            this.container.appendChild(this.j);
            this.l = this.A = null;
            this.K = !1;
            this.C = new Uf(function() {
                iI(c);
            });
            this.m = [];
            this.eventManager.u(this.bar, "input", function() {
                c.controls.Sc();
            });
            this.eventManager.u(this.localization, "locale-updated", function() {
                return jI(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                return jI(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                kI(c) || OH(c.container, !1);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                kI(c) && OH(c.container, !0);
            });
            this.eventManager.u(this.adManager, "ad-cue-points-changed", function(d) {
                c.m = d.cuepoints;
                lI(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                c.m = [];
                lI(c);
                c.l && (c.l.abort(), c.l = null);
                c.A = null;
                iI(c);
                mI(c);
            });
            this.eventManager.u(this.bar, "mousemove", function(d) {
                if (c.controls.Jc()) mI(c), iI(c);
                else {
                    var e = fI(c, d.clientX), f = c.bar.getBoundingClientRect();
                    d = Math.max(0, d.clientX - f.left);
                    c.player.rh().length ? (mI(c), nI(c, d, e)) : (iI(c), oI(c, d, e));
                }
            });
            this.eventManager.u(this.container, "mouseleave", function() {
                mI(c);
                c.C.stop();
                c.C.Z(.25);
            });
            this.setValue(this.video.currentTime);
            this.update();
            jI(this);
            this.ad && OH(this.container, !1);
        }
        oa(gI, cI);
        p = gI.prototype;
        p.release = function() {
            this.D && (this.D.stop(), this.D = null, this.F.stop(), this.F = null);
            cI.prototype.release.call(this);
        };
        p.onChangeStart = function() {
            this.O = !this.video.paused;
            this.controls.li(!0);
            this.video.pause();
            this.C.stop();
            this.K = !0;
        };
        p.onChange = function() {
            if (this.video.duration) {
                if (this.update(), this.D.Z(.125), this.player.rh().length && !this.controls.Jc()) {
                    var a = parseFloat(this.bar.min), b = parseFloat(this.bar.max), c = this.bar.getBoundingClientRect(), d = Math.round(this.getValue());
                    nI(this, (d - a) / ((b - a) / c.width), d);
                } else iI(this);
            }
        };
        p.onChangeEnd = function() {
            this.D.La();
            this.controls.li(!1);
            this.O && this.video.play();
            this.K && (this.K = !1, this.C.stop(), this.C.Z(.25));
        };
        p.isShowing = function() {
            return !this.container.classList.contains("shaka-hidden");
        };
        p.update = function() {
            var a = this.J.seekBarColors, b = this.getValue(), c = this.video.buffered.length, d = c ? this.video.buffered.start(0) : 0, e = c ? this.video.buffered.end(c - 1) : 0;
            c = this.player.wa();
            var f = c.end - c.start;
            this.setRange(c.start, c.end);
            kI(this) ? (OH(this.container, !0), d = (Math.max(d, c.start) - c.start) / f || 0, e = (Math.min(e, c.end) - c.start) / f || 0, b = (Math.min(Math.max(b, c.start), c.end) - c.start) / f || 0, this.container.style.background = "linear-gradient(" + [
                "to right",
                (this.J.showUnbufferedStart ? a.base : a.played) + " " + d * 100 + "%",
                a.played + " " + d * 100 + "%",
                a.played + " " + b * 100 + "%",
                a.buffered + " " + b * 100 + "%",
                a.buffered + " " + e * 100 + "%",
                a.base + " " + e * 100 + "%"
            ].join() + ")") : OH(this.container, !1);
        };
        function hI(a) {
            if (a.m.length) {
                for(var b = a.player.wa(), c = b.end - b.start, d = [
                    "to right"
                ], e = [], f = a.J.seekBarColors.adBreaks, g = !1, h = u(a.m), k = h.next(); !k.done; k = h.next())if (k = k.value, k.start == -1 && !k.end) g = !0;
                else if (!k.end && k.start >= b.start || typeof k.end == "number" && k.end > b.start) {
                    var l = (Math.max(k.start, b.start) - b.start) / c || 0, m = l + .01;
                    k.end && (m = (k.end - b.start) / c || 0);
                    e.push({
                        start: l,
                        end: m
                    });
                }
                e = e.sort(function(n, q) {
                    return n.start - q.start;
                });
                b = u(e);
                for(c = b.next(); !c.done; c = b.next())c = c.value, d.push("transparent " + c.start * 100 + "%"), d.push(f + " " + c.start * 100 + "%"), d.push(f + " " + c.end * 100 + "%"), d.push("transparent " + c.end * 100 + "%");
                g && (d.push("transparent 99%"), d.push(f + " 99%"));
                a.G.style.background = "linear-gradient(" + d.join(",") + ")";
            } else a.G.style.background = "transparent", a.F.stop();
        }
        function lI(a) {
            function b() {
                hI(a);
                var c = a.player.wa();
                c = c.end - c.start;
                a.player.U() && c > 5 && a.F.xa(.25);
            }
            b();
            a.player.Gh() || a.eventManager.ra(a.player, "loaded", b);
        }
        function kI(a) {
            var b = a.player.wa();
            b = b.end - b.start;
            return a.player.U() && (b < 5 || !isFinite(b)) ? !1 : a.ad == null || !a.ad.isLinear();
        }
        function jI(a) {
            a.bar.ariaLabel = a.localization.resolve("SEEK");
        }
        function oI(a, b, c) {
            var d = a.j.clientWidth;
            a.j.style.width = "auto";
            a.j.style.height = "20px";
            a.j.style.top = "-30px";
            a.j.style.left = Math.min(a.bar.offsetWidth - d, Math.max(0, b - d / 2)) + "px";
            a.j.style.right = "";
            a.j.style.visibility = "visible";
            b = a.player.wa();
            a.player.U() ? (c = b.end - c, c < 1 ? (a.j.textContent = a.localization.resolve("LIVE"), a.j.style.left = "", a.j.style.right = "0px") : a.j.textContent = "-" + PH(c, c >= 3600)) : (c -= b.start, a.j.textContent = PH(c, c >= 3600));
        }
        function nI(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A;
            H(function(E) {
                switch(E.h){
                    case 1:
                        c < 0 && (c = 0);
                        d = !1;
                        a.m.length && (d = a.m.some(function(C) {
                            return C.end ? c >= C.start && c <= C.end : !1;
                        }));
                        if (d) return iI(a), oI(a, b, c), E.return();
                        e = a.player.wa();
                        f = Math.max(Math.ceil(e.start), Math.min(Math.floor(e.end), c));
                        a.player.U() ? (g = e.end - c, a.I.textContent = g < 1 ? a.localization.resolve("LIVE") : "-" + PH(g, g >= 3600)) : a.I.textContent = PH(c, c >= 3600);
                        h = -10;
                        k = a.i.clientWidth;
                        l = Math.floor(k * 9 / 16);
                        a.i.style.height = l + "px";
                        a.i.style.top = -(l - h) + "px";
                        m = Math.min(a.bar.offsetWidth - k, Math.max(0, b - k / 2));
                        a.i.style.left = m + "px";
                        return E.g(a.player.dj(null, f), 2);
                    case 2:
                        n = E.i;
                        if (!n || !n.uris || !n.uris.length) return iI(a), oI(a, b, c), E.return();
                        n.width < n.height ? a.i.classList.add("portrait-thumbnail") : a.i.classList.remove("portrait-thumbnail");
                        a.i.style.visibility = "visible";
                        q = n.uris[0].split("#xywh=")[0];
                        if (a.A && q === a.A.uris[0].split("#xywh=")[0] && n.startByte == a.A.startByte && n.endByte == a.A.endByte) {
                            E.B(3);
                            break;
                        }
                        a.A = n;
                        a.l && (a.l.abort(), a.l = null);
                        if (n.codecs != "mjpg" && !q.startsWith("offline:")) {
                            E.B(4);
                            break;
                        }
                        a.g.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"/>';
                        E.m(5);
                        r = sh;
                        t = jn(n.uris, n.startByte, n.endByte, a.player.getConfiguration().streaming.retryParameters);
                        a.l = a.player.Qb().request(r, t, {
                            type: 1
                        });
                        return E.g(a.l.promise, 7);
                    case 7:
                        v = E.i;
                        a.l = null;
                        n.codecs == "mjpg" ? (w = (new Bh).box("mdat", Lh(function(C) {
                            q = URL.createObjectURL(new Blob([
                                C
                            ], {
                                type: "image/jpeg"
                            }));
                        }, !0)), w.parse(v.data, !1)) : (x = n.mimeType || "image/jpeg", y = new Blob([
                            v.data
                        ], {
                            type: x
                        }), q = URL.createObjectURL(y));
                        E.o(4);
                        break;
                    case 5:
                        z = E.l();
                        if (z.code == 7001) return E.return();
                        throw z;
                    case 4:
                        try {
                            a.i.removeChild(a.g);
                        } catch (C) {}
                        a.g = U("img");
                        a.g.id = "shaka-player-ui-thumbnail-image";
                        a.g.draggable = !1;
                        a.g.src = q;
                        a.g.onload = function() {
                            q.startsWith("blob:") && URL.revokeObjectURL(q);
                        };
                        a.i.insertBefore(a.g, a.i.firstChild);
                    case 3:
                        A = k / n.width, n.imageHeight ? a.g.height = n.imageHeight : n.sprite || (a.g.style.height = "100%", a.g.style.objectFit = "contain"), n.imageWidth ? a.g.width = n.imageWidth : n.sprite || (a.g.style.width = "100%", a.g.style.objectFit = "contain"), a.g.style.left = "-" + A * n.positionX + "px", a.g.style.top = "-" + A * n.positionY + "px", a.g.style.transform = "scale(" + A + ")", a.g.style.transformOrigin = "left top", l = Math.floor(k * n.height / n.width), a.i.style.height = l + "px", a.i.style.top = -(l - h) + "px", E.j();
                }
            });
        }
        function iI(a) {
            a.i.style.visibility = "hidden";
        }
        function mI(a) {
            a.j.style.visibility = "hidden";
        }
        O("shaka.ui.SeekBar", gI);
        function pI() {}
        pI.prototype.create = function(a, b) {
            return new gI(a, b);
        };
        gI.Factory = pI;
        function qI(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.j = U("div");
            this.j.classList.add("shaka-skip-ad-container");
            this.parent.appendChild(this.j);
            this.h = U("div");
            this.h.classList.add("shaka-skip-ad-counter");
            OH(this.h, !1);
            this.j.appendChild(this.h);
            this.g = ck();
            this.g.classList.add("shaka-skip-ad-button");
            this.g.disabled = !0;
            OH(this.g, !1);
            this.g.classList.add("shaka-no-propagation");
            this.j.appendChild(this.g);
            rI(this);
            this.i = new Uf(function() {
                if (c.ad.isSkippable()) {
                    var d = Math.round(c.ad.getTimeUntilSkippable());
                    d > 0 ? c.h.textContent = d : (c.i.stop(), OH(c.h, !1));
                } else sI(c);
            });
            this.eventManager.u(this.localization, "locale-updated", function() {
                rI(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                rI(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                tI(c);
            });
            this.eventManager.u(this.adManager, "ad-skip-state-changed", function() {
                c.ad.isSkippable() ? c.ad.canSkipNow() && (c.g.disabled = !1, c.i.stop(), OH(c.h, !1)) : sI(c);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                sI(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.ad.skip();
            });
            this.ad && tI(this);
        }
        oa(qI, IH);
        qI.prototype.release = function() {
            this.i.stop();
            this.i = null;
            IH.prototype.release.call(this);
        };
        function rI(a) {
            a.g.textContent = a.localization.resolve("SKIP_AD");
        }
        function tI(a) {
            a.ad.isSkippable() && a.ad.needsSkipUI() && (OH(a.g, !0), OH(a.h, !0), a.h.textContent = "", a.i.La(), a.i.xa(.5));
        }
        function sI(a) {
            a.i.stop();
            a.g.disabled = !0;
            OH(a.g, !1);
            OH(a.h, !1);
        }
        O("shaka.ui.SkipAdButton", qI); /*
 @license
 glMatrix: https://github.com/toji/gl-matrix/
 Copyright 2015-2021, Brandon Jones, Colin MacKenzie IV
 SPDX-License-Identifier: MIT
*/ 
        function uI() {
            var a = new Float32Array(16);
            a[0] = 1;
            a[5] = 1;
            a[10] = 1;
            a[15] = 1;
            return a;
        }
        function vI(a, b, c) {
            b = 1 / Math.tan(b / 2);
            a[0] = b / c;
            a[1] = 0;
            a[2] = 0;
            a[3] = 0;
            a[4] = 0;
            a[5] = b;
            a[6] = 0;
            a[7] = 0;
            a[8] = 0;
            a[9] = 0;
            a[11] = -1;
            a[12] = 0;
            a[13] = 0;
            a[15] = 0;
            c = 1 / -99.9;
            a[10] = 100.1 * c;
            a[14] = 20 * c;
        }
        function wI(a, b, c) {
            var d = b[0], e = b[1], f = b[2], g = b[3], h = b[4], k = b[5], l = b[6], m = b[7], n = b[8], q = b[9], r = b[10], t = b[11], v = b[12], w = b[13], x = b[14];
            b = b[15];
            var y = c[0], z = c[1], A = c[2], E = c[3];
            a[0] = y * d + z * h + A * n + E * v;
            a[1] = y * e + z * k + A * q + E * w;
            a[2] = y * f + z * l + A * r + E * x;
            a[3] = y * g + z * m + A * t + E * b;
            y = c[4];
            z = c[5];
            A = c[6];
            E = c[7];
            a[4] = y * d + z * h + A * n + E * v;
            a[5] = y * e + z * k + A * q + E * w;
            a[6] = y * f + z * l + A * r + E * x;
            a[7] = y * g + z * m + A * t + E * b;
            y = c[8];
            z = c[9];
            A = c[10];
            E = c[11];
            a[8] = y * d + z * h + A * n + E * v;
            a[9] = y * e + z * k + A * q + E * w;
            a[10] = y * f + z * l + A * r + E * x;
            a[11] = y * g + z * m + A * t + E * b;
            y = c[12];
            z = c[13];
            A = c[14];
            E = c[15];
            a[12] = y * d + z * h + A * n + E * v;
            a[13] = y * e + z * k + A * q + E * w;
            a[14] = y * f + z * l + A * r + E * x;
            a[15] = y * g + z * m + A * t + E * b;
        }
        function xI(a, b) {
            var c = new Float32Array(3), d = b[0], e = b[1], f = b[2], g = b[4], h = b[5], k = b[6], l = b[8], m = b[9], n = b[10];
            c[0] = Math.sqrt(d * d + e * e + f * f);
            c[1] = Math.sqrt(g * g + h * h + k * k);
            c[2] = Math.sqrt(l * l + m * m + n * n);
            k = 1 / c[0];
            l = 1 / c[1];
            m = 1 / c[2];
            g = b[0] * k;
            c = b[1] * l;
            d = b[2] * m;
            e = b[4] * k;
            h = b[5] * l;
            f = b[6] * m;
            k *= b[8];
            l *= b[9];
            b = b[10] * m;
            m = g + h + b;
            m > 0 ? (b = Math.sqrt(m + 1) * 2, a[3] = .25 * b, a[0] = (f - l) / b, a[1] = (k - d) / b, a[2] = (c - e) / b) : g > h && g > b ? (b = Math.sqrt(1 + g - h - b) * 2, a[3] = (f - l) / b, a[0] = .25 * b, a[1] = (c + e) / b, a[2] = (k + d) / b) : h > b ? (b = Math.sqrt(1 + h - g - b) * 2, a[3] = (k - d) / b, a[0] = (c + e) / b, a[1] = .25 * b, a[2] = (f + l) / b) : (b = Math.sqrt(1 + b - g - h) * 2, a[3] = (c - e) / b, a[0] = (k + d) / b, a[1] = (f + l) / b, a[2] = .25 * b);
        }
        function yI(a, b) {
            var c = b[0], d = b[1], e = b[2];
            b = b[3];
            var f = c + c, g = d + d, h = e + e;
            c *= f;
            var k = d * f;
            d *= g;
            var l = e * f, m = e * g;
            e *= h;
            f *= b;
            g *= b;
            b *= h;
            a[0] = 1 - d - e;
            a[1] = k + b;
            a[2] = l - g;
            a[3] = 0;
            a[4] = k - b;
            a[5] = 1 - c - e;
            a[6] = m + f;
            a[7] = 0;
            a[8] = l + g;
            a[9] = m - f;
            a[10] = 1 - c - d;
            a[11] = 0;
            a[12] = 0;
            a[13] = 0;
            a[14] = 0;
            a[15] = 1;
        }
        function zI() {
            var a = new Float32Array(4);
            a[3] = 1;
            return a;
        }
        function AI(a, b) {
            var c = b[0], d = b[1], e = b[2];
            b = b[3];
            var f = c * c + d * d + e * e + b * b;
            f > 0 && (f = 1 / Math.sqrt(f));
            a[0] = c * f;
            a[1] = d * f;
            a[2] = e * f;
            a[3] = b * f;
        }
        function BI(a) {
            var b = [], c = [], d = [], e = Math.PI;
            a = (a === void 0 ? 0 : a) ? e / 2 : e;
            for(var f = 0; f <= 100; f++){
                var g = f * e / 100, h = Math.sin(g);
                g = Math.cos(g);
                for(var k = 0; k <= 100; k++){
                    var l = k * 2 * a / 100;
                    b.push(Math.sin(l) * h, g, Math.cos(l) * h);
                    c.push(k / 100, f / 100);
                }
            }
            for(e = 0; e < 100; e++)for(a = 0; a < 100; a++)f = e * 101 + a, h = f + 100 + 1, d.push(f, h, f + 1), d.push(h, h + 1, f + 1);
            return {
                ik: b,
                dk: c,
                indices: d
            };
        }
        function CI(a, b, c, d, e) {
            this.i = a;
            this.ua = b;
            this.o = c;
            this.g = d;
            this.A = new fd;
            this.M = zI();
            this.h = zI();
            this.ba = this.na = this.$ = this.l = null;
            this.F = uI();
            this.J = uI();
            this.O = uI();
            this.W = uI();
            this.D = null;
            this.P = !1;
            this.K = this.C = null;
            this.va = this.ya = 0;
            this.X = this.R = this.S = this.L = null;
            this.I = this.H = 0;
            this.j = 75;
            this.V = 0;
            this.m = e;
            this.G = -1;
            DI(this);
        }
        CI.prototype.release = function() {
            this.G != -1 && (this.i.cancelVideoFrameCallback(this.G), this.G = -1);
            this.A && (this.A.release(), this.A = null);
            this.C && (this.C.stop(), this.C = null);
            this.K && (this.K.stop(), this.K = null);
        };
        CI.prototype.Yd = function() {
            (this.P = !this.P) || this.g.viewport(0, 0, this.o.width, this.o.height);
            EI(this, !1);
        };
        function DI(a) {
            FI(a);
            GI(a);
            HI(a);
            II(a);
            JI(a);
            em(a.i, HTMLMediaElement.HAVE_CURRENT_DATA, a.A, function() {
                a.i.readyState >= HTMLMediaElement.HAVE_ENOUGH_DATA && EI(a);
                if ("requestVideoFrameCallback" in a.i) {
                    var b = function() {
                        a.G != -1 && (EI(a), a.G != -1 && (a.G = a.i.requestVideoFrameCallback(b)));
                    };
                    a.G = a.i.requestVideoFrameCallback(b);
                } else {
                    var c;
                    a.A.u(a.i, "canplaythrough", function() {
                        EI(a);
                    });
                    a.A.u(a.i, "playing", function() {
                        a.C && a.C.stop();
                        if (!c) {
                            var d = a.ua.Ib();
                            d = u(d);
                            for(var e = d.next(); !e.done; e = d.next())(e = e.value.frameRate) && (!c || c < e) && (c = e);
                        }
                        c || (c = 60);
                        EI(a);
                        a.C = new Uf(function() {
                            EI(a);
                        }).La().xa(1 / c);
                    });
                    a.A.u(a.i, "pause", function() {
                        a.C && a.C.stop();
                        a.C = null;
                        EI(a);
                    });
                    a.A.u(a.i, "seeked", function() {
                        EI(a);
                    });
                    a.A.u(document, "visibilitychange", function() {
                        EI(a);
                    });
                }
            });
        }
        function FI(a) {
            var b = a.F, c = [
                0,
                0,
                0
            ], d = [
                1,
                0,
                0
            ], e = [
                0,
                1,
                0
            ], f = c[0], g = c[1];
            c = c[2];
            var h = e[0];
            var k = e[1];
            var l = e[2];
            var m = d[0];
            e = d[1];
            var n = d[2];
            if (Math.abs(f - m) < 1E-6 && Math.abs(g - e) < 1E-6 && Math.abs(c - n) < 1E-6) for(f = 0; f < 16; f++)b[f] = f % 5 == 0 ? 1 : 0;
            else {
                d = f - m;
                e = g - e;
                m = c - n;
                var q = 1 / Math.sqrt(d * d + e * e + m * m);
                d *= q;
                e *= q;
                m *= q;
                n = k * m - l * e;
                l = l * d - h * m;
                h = h * e - k * d;
                (q = Math.sqrt(n * n + l * l + h * h)) ? (q = 1 / q, n *= q, l *= q, h *= q) : h = l = n = 0;
                k = e * h - m * l;
                var r = m * n - d * h;
                var t = d * l - e * n;
                (q = Math.sqrt(k * k + r * r + t * t)) ? (q = 1 / q, k *= q, r *= q, t *= q) : t = r = k = 0;
                b[0] = n;
                b[1] = k;
                b[2] = d;
                b[3] = 0;
                b[4] = l;
                b[5] = r;
                b[6] = e;
                b[7] = 0;
                b[8] = h;
                b[9] = t;
                b[10] = m;
                b[11] = 0;
                b[12] = -(n * f + l * g + h * c);
                b[13] = -(k * f + r * g + t * c);
                b[14] = -(d * f + e * g + m * c);
                b[15] = 1;
            }
            xI(a.M, a.F);
            a = b = a.W;
            c = [
                4,
                4,
                4
            ];
            f = c[0];
            g = c[1];
            c = c[2];
            b[0] = a[0] * f;
            b[1] = a[1] * f;
            b[2] = a[2] * f;
            b[3] = a[3] * f;
            b[4] = a[4] * g;
            b[5] = a[5] * g;
            b[6] = a[6] * g;
            b[7] = a[7] * g;
            b[8] = a[8] * c;
            b[9] = a[9] * c;
            b[10] = a[10] * c;
            b[11] = a[11] * c;
            b[12] = a[12];
            b[13] = a[13];
            b[14] = a[14];
            b[15] = a[15];
        }
        function GI(a) {
            KI(a);
            a.g.viewport(0, 0, a.g.drawingBufferWidth, a.g.drawingBufferHeight);
            a.g.clearColor(0, 0, 0, 1);
            a.g.enable(a.g.CULL_FACE);
            a.g.cullFace(a.g.FRONT);
            a.g.clear(a.g.COLOR_BUFFER_BIT);
        }
        function HI(a) {
            var b = LI(a, a.g.VERTEX_SHADER), c = LI(a, a.g.FRAGMENT_SHADER);
            a.l = a.g.createProgram();
            a.g.attachShader(a.l, b);
            a.g.attachShader(a.l, c);
            a.g.linkProgram(a.l);
            a.m == "cubemap" ? (a.S = a.g.getAttribLocation(a.l, "aVertexPosition"), a.R = a.g.getAttribLocation(a.l, "aTextureCoord")) : (a.S = a.g.getAttribLocation(a.l, "a_vPosition"), a.g.enableVertexAttribArray(a.S), a.R = a.g.getAttribLocation(a.l, "a_TexCoordinate"), a.g.enableVertexAttribArray(a.R));
        }
        function LI(a, b) {
            switch(b){
                case a.g.VERTEX_SHADER:
                    var c = a.m == "cubemap" ? "attribute vec4 aVertexPosition;\nattribute vec2 aTextureCoord;\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nvarying highp vec2 vTextureCoord;\nvarying highp vec3 vLighting;\nvoid main(void) {\n  gl_Position = uProjectionMatrix * uModelViewMatrix * aVertexPosition;\n  vTextureCoord = aTextureCoord;\n}" : "attribute vec4 a_vPosition;\n// Per-vertex texture coordinate info\nattribute vec2 a_TexCoordinate;\nuniform mat4 u_VPMatrix;\n// Passed into the fragment shader.\nvarying vec2 v_TexCoordinate;\nvarying vec3 pass_position;\nvoid main()\n{\n gl_Position = u_VPMatrix * a_vPosition;\n // Pass through texture coord\n v_TexCoordinate = a_TexCoordinate;\n pass_position = a_vPosition.xyz;\n}";
                    break;
                case a.g.FRAGMENT_SHADER:
                    c = a.m == "cubemap" ? "varying highp vec2 vTextureCoord;\nuniform sampler2D uSampler;\nvoid main(void) {\n  highp vec4 texelColor = texture2D(uSampler, vTextureCoord);\n  gl_FragColor = vec4(texelColor.rgb , texelColor.a);\n}" : "precision highp float;\n#define PI 3.141592653589793238462643383279\nvarying vec2 v_TexCoordinate;\nvarying vec3 pass_position;\nuniform sampler2D uSampler;\nvoid main(void) {\nhighp float xValue =\n      (PI + atan(pass_position.z, pass_position.x)) / (2.0 * PI);\n vec2 tc = vec2(xValue, v_TexCoordinate.t);\n tc = vec2(tc.x , tc.y);\nhighp vec4 texelColor =\n      texture2D(uSampler, tc);\n  gl_FragColor = vec4(texelColor.rgb, texelColor.a);\n}";
                    break;
                default:
                    return null;
            }
            b = a.g.createShader(b);
            a.g.shaderSource(b, c);
            a.g.compileShader(b);
            return b;
        }
        function II(a) {
            a.L = a.m == "cubemap" ? {
                ik: [
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    -1,
                    -1
                ],
                dk: [
                    2 / 3,
                    .5,
                    1 / 3,
                    .5,
                    1 / 3,
                    0,
                    2 / 3,
                    0,
                    2 / 3,
                    .5,
                    2 / 3,
                    0,
                    1,
                    0,
                    1,
                    .5,
                    1,
                    1,
                    2 / 3,
                    1,
                    2 / 3,
                    .5,
                    1,
                    .5,
                    0,
                    .5,
                    0,
                    0,
                    1 / 3,
                    0,
                    1 / 3,
                    .5,
                    0,
                    .5,
                    1 / 3,
                    .5,
                    1 / 3,
                    1,
                    0,
                    1,
                    1 / 3,
                    1,
                    1 / 3,
                    .5,
                    2 / 3,
                    .5,
                    2 / 3,
                    1
                ],
                indices: [
                    0,
                    1,
                    2,
                    0,
                    2,
                    3,
                    4,
                    5,
                    6,
                    4,
                    6,
                    7,
                    8,
                    9,
                    10,
                    8,
                    10,
                    11,
                    12,
                    13,
                    14,
                    12,
                    14,
                    15,
                    16,
                    17,
                    18,
                    16,
                    18,
                    19,
                    20,
                    21,
                    22,
                    20,
                    22,
                    23
                ]
            } : a.m == "halfequirectangular" ? BI(!0) : BI();
            a.$ = a.g.createBuffer();
            a.g.bindBuffer(a.g.ARRAY_BUFFER, a.$);
            a.g.bufferData(a.g.ARRAY_BUFFER, new Float32Array(a.L.ik), a.g.STATIC_DRAW);
            a.na = a.g.createBuffer();
            a.g.bindBuffer(a.g.ARRAY_BUFFER, a.na);
            a.g.bufferData(a.g.ARRAY_BUFFER, new Float32Array(a.L.dk), a.g.STATIC_DRAW);
            a.ba = a.g.createBuffer();
            a.g.bindBuffer(a.g.ELEMENT_ARRAY_BUFFER, a.ba);
            a.g.bufferData(a.g.ELEMENT_ARRAY_BUFFER, new Uint16Array(a.L.indices), a.g.STATIC_DRAW);
        }
        function JI(a) {
            a.X = a.g.createTexture();
            a.g.bindTexture(a.g.TEXTURE_2D, a.X);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_WRAP_S, a.g.CLAMP_TO_EDGE);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_WRAP_T, a.g.CLAMP_TO_EDGE);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_MIN_FILTER, a.g.NEAREST);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_MAG_FILTER, a.g.NEAREST);
        }
        function EI(a, b) {
            b = b === void 0 ? !0 : b;
            var c = a.ua.xc() == ms;
            if (!(!a.i || a.i.readyState < 2 || !c && a.i.playbackRate == 0)) {
                vI(a.J, a.j * Math.PI / 180, 1.5625);
                a.m == "cubemap" ? vI(a.J, a.j * Math.PI / 180, 2.5) : vI(a.J, a.j * Math.PI / 180, 1.5625);
                a.g.useProgram(a.l);
                a.g.clear(a.g.COLOR_BUFFER_BIT);
                KI(a);
                b && (a.g.activeTexture(a.g.TEXTURE0), a.g.bindTexture(a.g.TEXTURE_2D, a.X), a.g.pixelStorei(a.g.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0), a.g.texImage2D(a.g.TEXTURE_2D, 0, a.g.RGBA, a.g.RGBA, a.g.UNSIGNED_BYTE, a.i));
                if (a.m == "equirectangular" || a.m == "halfequirectangular") wI(a.O, a.F, a.W), wI(a.O, a.J, a.O);
                a.g.bindBuffer(a.g.ARRAY_BUFFER, a.$);
                a.g.vertexAttribPointer(a.S, 3, a.g.FLOAT, !1, 0, 0);
                a.g.enableVertexAttribArray(a.S);
                a.g.bindBuffer(a.g.ARRAY_BUFFER, a.na);
                a.g.vertexAttribPointer(a.R, 2, a.g.FLOAT, !1, 0, 0);
                a.g.enableVertexAttribArray(a.R);
                a.g.bindBuffer(a.g.ELEMENT_ARRAY_BUFFER, a.ba);
                a.m == "cubemap" ? (a.g.uniformMatrix4fv(a.g.getUniformLocation(a.l, "uProjectionMatrix"), !1, a.J), a.g.uniformMatrix4fv(a.g.getUniformLocation(a.l, "uModelViewMatrix"), !1, a.O)) : a.g.uniformMatrix4fv(a.g.getUniformLocation(a.l, "u_VPMatrix"), !1, a.O);
                a.g.uniform1i(a.g.getUniformLocation(a.l, "uSampler"), 0);
                a.P && a.g.viewport(0, 0, a.o.width / 2, a.o.height);
                a.g.drawElements(a.g.TRIANGLES, a.L.indices.length, a.g.UNSIGNED_SHORT, 0);
                a.P && (a.g.viewport(a.o.width / 2, 0, a.o.width / 2, a.o.height), a.g.drawElements(a.g.TRIANGLES, a.L.indices.length, a.g.UNSIGNED_SHORT, 0));
            }
        }
        function KI(a) {
            var b = a.i.videoWidth;
            b || (b = a.o.scrollWidth);
            var c = a.i.videoHeight;
            c || (c = a.o.scrollHeight);
            if (a.ya !== b || a.va !== c) {
                a.o.width = b;
                a.o.height = c;
                a.ya = b;
                a.va = c;
                var d = b / c, e = a.J, f = -d, g = 1 / (d - f);
                e[0] = 0 * g;
                e[1] = 0;
                e[2] = 0;
                e[3] = 0;
                e[4] = 0;
                e[5] = 0;
                e[6] = 0;
                e[7] = 0;
                e[8] = (d + f) * g;
                e[9] = 0;
                e[10] = -1;
                e[11] = -1;
                e[12] = 0;
                e[13] = 0;
                e[14] = -0;
                e[15] = 0;
                a.J = e;
                a.g.viewport(0, 0, b, c);
            }
        }
        function MI(a, b, c, d) {
            var e = Infinity, f = 90 * Math.PI / 180;
            a.m == "halfequirectangular" && (e = 90 * Math.PI / 180, f /= 2);
            var g = a.m == "cubemap" ? a.O : a.F;
            a.H += b;
            a.I += c;
            if (a.H < e && a.H > -e) {
                e = Math.sin(b);
                b = Math.cos(b);
                var h = g[0], k = g[1], l = g[2], m = g[3], n = g[8], q = g[9], r = g[10], t = g[11];
                g !== g && (g[4] = g[4], g[5] = g[5], g[6] = g[6], g[7] = g[7], g[12] = g[12], g[13] = g[13], g[14] = g[14], g[15] = g[15]);
                g[0] = h * b - n * e;
                g[1] = k * b - q * e;
                g[2] = l * b - r * e;
                g[3] = m * b - t * e;
                g[8] = h * e + n * b;
                g[9] = k * e + q * b;
                g[10] = l * e + r * b;
                g[11] = m * e + t * b;
            } else a.H -= b;
            a.I < f && a.I > -f ? (f = uI(), e = uI(), b = -1 * c, c = Math.sin(b), b = Math.cos(b), h = e[4], k = e[5], l = e[6], m = e[7], n = e[8], q = e[9], r = e[10], t = e[11], e !== f && (f[0] = e[0], f[1] = e[1], f[2] = e[2], f[3] = e[3], f[12] = e[12], f[13] = e[13], f[14] = e[14], f[15] = e[15]), f[4] = h * b + n * c, f[5] = k * b + q * c, f[6] = l * b + r * c, f[7] = m * b + t * c, f[8] = n * b - h * c, f[9] = q * b - k * c, f[10] = r * b - l * c, f[11] = t * b - m * c, wI(g, f, g)) : a.I -= c;
            c = uI();
            f = uI();
            e = Math.sin(d);
            d = Math.cos(d);
            b = f[0];
            h = f[1];
            k = f[2];
            l = f[3];
            m = f[4];
            n = f[5];
            q = f[6];
            r = f[7];
            f !== c && (c[8] = f[8], c[9] = f[9], c[10] = f[10], c[11] = f[11], c[12] = f[12], c[13] = f[13], c[14] = f[14], c[15] = f[15]);
            c[0] = b * d + m * e;
            c[1] = h * d + n * e;
            c[2] = k * d + q * e;
            c[3] = l * d + r * e;
            c[4] = m * d - b * e;
            c[5] = n * d - h * e;
            c[6] = q * d - k * e;
            c[7] = r * d - l * e;
            wI(g, c, g);
            EI(a, !1);
        }
        function NI(a, b) {
            if (b === void 0 || b) xI(a.h, a.F), a.V = 0, a.D = zI(), a.D[0] = (a.h[0] - a.M[0]) / 20, a.D[1] = (a.h[1] - a.M[1]) / 20, a.D[2] = (a.h[2] - a.M[2]) / 20, a.D[3] = (a.h[3] - a.M[3]) / 20;
            a.h[0] -= a.D[0];
            a.h[1] -= a.D[1];
            a.h[2] -= a.D[2];
            a.h[3] -= a.D[3];
            b = uI();
            AI(a.h, a.h);
            yI(b, a.h);
            a.F = b;
            a.K && (a.K.stop(), a.K = null);
            a.V < 20 ? a.K = new Uf(function() {
                NI(a, !1);
                a.H = 0;
                a.I = 0;
                a.V++;
                EI(a, !1);
            }).Z(.025) : (yI(b, a.M), a.F = b);
        }
        function OI(a, b, c, d, e, f) {
            fb.call(this);
            var g = this;
            this.i = a;
            this.j = b;
            this.G = c;
            this.L = d;
            this.F = e;
            this.H = f;
            this.o = new fd;
            this.h = new fd;
            this.A = PI(this.j);
            this.g = null;
            this.m = !1;
            this.K = this.J = this.I = this.D = this.C = 0;
            this.l = null;
            this.o.u(d, "loading", function() {
                g.g && NI(g.g);
                QI(g);
            });
            this.o.u(d, "spatialvideoinfo", function(h) {
                h = h.detail;
                switch(h.projection){
                    case "rect":
                        g.l = null;
                        break;
                    case "equi":
                        g.l = "equirectangular";
                        break;
                    case "hequ":
                        switch(h.hfov){
                            case 360:
                                g.l = "equirectangular";
                                break;
                            case 180:
                                g.l = "halfequirectangular";
                                break;
                            default:
                                h.hfov == null ? g.l = "halfequirectangular" : g.l = null;
                        }
                        break;
                    case "fish":
                        g.l = "halfequirectangular";
                        break;
                    default:
                        g.l = null;
                }
                QI(g);
            });
            this.o.u(d, "nospatialvideoinfo", function() {
                g.l = null;
                QI(g);
            });
            this.o.u(d, "unloading", function() {
                g.l = null;
                QI(g);
            });
            this.o.u(this.H, "caststatuschanged", function() {
                QI(g);
            });
            QI(this);
        }
        oa(OI, fb);
        p = OI.prototype;
        p.release = function() {
            this.o && (this.o.release(), this.o = null);
            this.h && (this.h.release(), this.h = null);
            this.g && (this.g.release(), this.g = null);
            fb.prototype.release.call(this);
        };
        p.configure = function(a) {
            this.F = a;
            QI(this);
        };
        p.Lg = function() {
            return this.j ? !!this.A : !!PI(document.createElement("canvas"));
        };
        p.Sb = function() {
            return !!this.g;
        };
        p.Yd = function() {
            this.g ? this.g.Yd() : Za("Not playing VR content");
        };
        p.Ch = function(a) {
            this.g ? MI(this.g, a * RI, 0, 0) : Za("Not playing VR content");
        };
        p.Ah = function(a) {
            this.g ? MI(this.g, 0, a * RI, 0) : Za("Not playing VR content");
        };
        p.Bh = function(a) {
            this.g ? MI(this.g, 0, 0, a * RI) : Za("Not playing VR content");
        };
        function QI(a) {
            var b = a.H.F.Qa();
            !a.F.displayInVrMode && !a.l || b ? a.j && a.g && (a.j.style.display = "none", a.h.Ta(), a.g.release(), a.g = null, a.dispatchEvent(new R("vrstatuschanged", (new Map).set("newStatus", a.Sb())))) : (a.j || (a.j = document.createElement("canvas"), a.j.classList.add("shaka-vr-canvas-container"), a.G.parentElement.insertBefore(a.j, a.G.nextElementSibling), a.A = PI(a.j)), b = a.l || a.F.defaultVrProjectionMode, a.g) ? a.g.m != b && (a.h.Ta(), a.g.release(), SI(a, b)) : (a.j.style.display = "", SI(a, b), a.dispatchEvent(new R("vrstatuschanged", (new Map).set("newStatus", a.Sb()))));
        }
        function SI(a, b) {
            a.A && a.j && (a.g = new CI(a.G, a.L, a.j, a.A, b), TI(a));
        }
        function PI(a) {
            if (!a || !window1.WebGLRenderingContext) return null;
            for(var b = u([
                "webgl2",
                "webgl"
            ]), c = b.next(); !c.done; c = b.next())if (c = a.getContext(c.value)) return c;
            return null;
        }
        function TI(a) {
            a.h.u(a.i, "mousedown", function(d) {
                if (!a.m) {
                    var e = d.clientX;
                    d = d.clientY;
                    a.m = !0;
                    a.C = e;
                    a.D = d;
                }
            });
            navigator.maxTouchPoints > 0 && a.h.u(a.i, "touchstart", function(d) {
                if (!a.m) {
                    var e = d.touches[0].clientX;
                    d = d.touches[0].clientY;
                    a.m = !0;
                    a.C = e;
                    a.D = d;
                }
            });
            a.h.u(a.i, "wheel", function(d) {
                if (!a.m) {
                    var e = a.g, f = d.deltaY;
                    f /= 50;
                    e.j >= 20 && e.j <= 100 && (e.j += f);
                    e.j < 20 ? e.j = 20 : e.j > 100 && (e.j = 100);
                    EI(e, !1);
                    d.preventDefault();
                    d.stopPropagation();
                }
            });
            a.h.u(a.i, "mousemove", function(d) {
                a.m && UI(a, d.clientX, d.clientY);
            });
            navigator.maxTouchPoints > 0 && a.h.u(a.i, "touchmove", function(d) {
                a.m && UI(a, d.touches[0].clientX, d.touches[0].clientY);
                d.preventDefault();
            });
            a.h.u(a.i, "mouseleave", function() {
                a.m = !1;
            });
            a.h.u(a.i, "mouseup", function() {
                a.m = !1;
            });
            navigator.maxTouchPoints > 0 && a.h.u(a.i, "touchend", function() {
                a.m = !1;
            });
            var b = !1;
            if (window1.DeviceOrientationEvent) {
                if (typeof DeviceMotionEvent.requestPermission == "function") {
                    var c = function() {
                        DeviceMotionEvent.requestPermission().then(function(d) {
                            d !== "granted" || b || (b = !0, VI(a));
                        });
                    };
                    DeviceMotionEvent.requestPermission().then(function(d) {
                        a.h.Fa(a.i, "click", c);
                        a.h.Fa(a.i, "mouseup", c);
                        navigator.maxTouchPoints > 0 && a.h.Fa(a.i, "touchend", c);
                        d !== "granted" ? (a.h.ra(a.i, "click", c), a.h.ra(a.i, "mouseup", c), navigator.maxTouchPoints > 0 && a.h.ra(a.i, "touchend", c)) : (b = !0, VI(a));
                    }).catch(function() {
                        a.h.Fa(a.i, "click", c);
                        a.h.Fa(a.i, "mouseup", c);
                        navigator.maxTouchPoints > 0 && a.h.Fa(a.i, "touchend", c);
                        a.h.ra(a.i, "click", c);
                        a.h.ra(a.i, "mouseup", c);
                        navigator.maxTouchPoints > 0 && a.h.ra(a.i, "touchend", c);
                    });
                } else b = !0, VI(a);
            }
        }
        function VI(a) {
            a.h.u(window1, "deviceorientation", function(b) {
                if (a.g) {
                    var c = (b.alpha || 0) - a.I, d = (b.beta || 0) - a.J, e = (b.gamma || 0) - a.K;
                    if (Math.abs(c) > 10 || Math.abs(d) > 10 || Math.abs(e) > 5) d = e = c = 0;
                    a.I = b.alpha || 0;
                    a.J = b.beta || 0;
                    a.K = b.gamma || 0;
                    b = screen.orientation.angle;
                    b == 90 || b == -90 ? MI(a.g, c * RI * -1, e * RI * -1, 0) : MI(a.g, c * RI * -1, d * RI, 0);
                }
            });
        }
        function UI(a, b, c) {
            var d = -0.6 * Math.PI / 180;
            MI(a.g, (b - a.C) * d, (c - a.D) * -1 * d, 0);
            a.C = b;
            a.D = c;
        }
        var RI = Math.PI / 180;
        function Y(a, b, c, d, e) {
            fb.call(this);
            var f = this;
            this.X = !0;
            this.g = e;
            this.F = new Cu(c, a, this.g.castReceiverAppId, this.g.castAndroidReceiverCompatible);
            this.va = !0;
            this.C = this.F.Rc();
            this.o = c;
            this.m = this.F.Rb();
            this.$ = a;
            this.l = b;
            this.Kb = d;
            this.ua = this.m.tf();
            this.A = this.j = null;
            this.V = !1;
            this.K = [];
            this.ab = [];
            this.Oa = !1;
            this.L = new Uf(function() {
                f.l.classList.add("no-cursor");
                f.Oa = !1;
                WI(f);
            });
            this.ba = new Uf(function() {
                f.i.removeAttribute("shown");
                XI(f);
                YI(f);
                f.W && f.W.Og();
                f.P.Z(f.g.closeMenusDelay);
            });
            this.P = new Uf(function() {
                for(var g = u(f.K), h = g.next(); !h.done; h = g.next())OH(h.value, !1);
                f.g.enableTooltips && f.H.classList.add("shaka-tooltips-on");
            });
            this.Ga = new Uf(function() {
                f.Ca() && ZI(f);
            });
            this.R = null;
            this.J = [];
            this.ya = $I();
            this.h = new fd;
            this.D = null;
            this.configure(this.g);
            aJ(this);
            bJ(this);
            this.na = new Set;
            cJ(this);
            this.Ga.xa(this.g.refreshTickInSeconds);
            this.h.u(this.ya, "locale-changed", function(g) {
                g = g.locales[0];
                f.ua.setLocale(g);
                f.l.setAttribute("lang", g);
            });
            this.ua.initInterstitial(this.G, this.$, this.o);
            this.h.u(this.m, "texttrackvisibility", function() {
                YI(f);
            });
            this.h.u(this.m, "unloading", function() {
                f.j || (f.Jb() && dJ(f), f.Id() && f.Yc());
            });
        }
        oa(Y, fb);
        p = Y.prototype;
        p.destroy = function(a) {
            a = a === void 0 ? !1 : a;
            var b = this;
            return H(function(c) {
                switch(c.h){
                    case 1:
                        if (document.pictureInPictureElement != b.o) {
                            c.B(2);
                            break;
                        }
                        return c.g(document.exitPictureInPicture(), 2);
                    case 2:
                        b.h && (b.h.release(), b.h = null);
                        b.L && (b.L.stop(), b.L = null);
                        b.ba && (b.ba.stop(), b.ba = null);
                        b.P && (b.P.stop(), b.P = null);
                        b.Ga && (b.Ga.stop(), b.Ga = null);
                        b.D && (b.D.release(), b.D = null);
                        eJ(b);
                        b.i && (b.l.removeChild(b.i), b.i = null);
                        if (!b.F) {
                            c.B(4);
                            break;
                        }
                        return c.g(b.F.destroy(a), 5);
                    case 5:
                        b.F = null;
                    case 4:
                        b.M && (b.l.removeChild(b.M), b.M = null);
                        b.G && (b.l.removeChild(b.G), b.G = null);
                        b.I && (b.l.removeChild(b.I), b.I = null);
                        if (!b.$) {
                            c.B(6);
                            break;
                        }
                        return c.g(b.$.destroy(), 7);
                    case 7:
                        b.$ = null;
                    case 6:
                        b.m = null, b.o = null, b.C = null, b.ya = null, b.na.clear(), fJ(b), fb.prototype.release.call(b), c.j();
                }
            });
        };
        function eJ(a) {
            for(var b = u(a.J), c = b.next(); !c.done; c = b.next())c.value.release();
            a.J = [];
        }
        function gJ(a, b) {
            hJ.set(a, b);
        }
        p.qk = function(a) {
            this.va = a;
            cJ(this);
        };
        p.Ml = function() {
            WI(this);
        };
        p.configure = function(a) {
            var b = this;
            this.g = a;
            this.F.Qi(a.castReceiverAppId, a.castAndroidReceiverCompatible);
            this.A && (this.A = null);
            this.Ia && (this.Ia = null);
            this.W && (this.W = null);
            this.D && this.D.configure(a);
            this.i ? (gk(this.i), eJ(this)) : (iJ(this), jJ(this), this.D = new OI(this.i, this.Kb, this.o, this.m, this.g, this));
            this.l.classList.add("shaka-video-container");
            this.o.classList.add("shaka-video");
            kJ(this);
            this.g.addBigPlayButton && lJ(this);
            this.g.customContextMenu && (this.W = new RH(this.H, this), this.J.push(this.W));
            this.M || mJ(this);
            this.g.seekOnTaps && (nJ(this), oJ(this));
            pJ(this);
            this.K = Array.from(this.l.getElementsByClassName("shaka-settings-menu"));
            this.K.push.apply(this.K, G(Array.from(this.l.getElementsByClassName("shaka-overflow-menu"))));
            this.ab = Array.from(this.l.getElementsByClassName("shaka-show-controls-on-mouse-over"));
            WI(this);
            a = u(this.l.getElementsByClassName("shaka-no-propagation"));
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = function(e) {
                    return e.stopPropagation();
                };
                this.h.u(c, "click", d);
                this.h.u(c, "dblclick", d);
                navigator.maxTouchPoints > 0 && this.h.u(c, "touchend", function(e) {
                    b.Ca() && e.stopPropagation();
                });
            }
        };
        p.ji = function(a) {
            (this.X = a) ? (this.l.setAttribute("shaka-controls", "true"), this.o.tabIndex = -1, this.o.controls = !1) : this.l.removeAttribute("shaka-controls");
            WI(this);
        };
        p.Nj = function(a) {
            this.o.controls = a;
            this.o.tabIndex = a ? 0 : -1;
            a && this.ji(!1);
        };
        p.getAd = function() {
            return this.j;
        };
        p.Gk = function() {
            return this.F;
        };
        p.Xk = function() {
            return this.ya;
        };
        p.zl = function() {
            return this.l;
        };
        p.Rc = function() {
            return this.C;
        };
        p.Wk = function() {
            return this.o;
        };
        p.Rb = function() {
            return this.m;
        };
        p.Vk = function() {
            return this.$;
        };
        p.Nk = function() {
            return this.i;
        };
        p.kl = function() {
            return this.I;
        };
        p.Jk = function() {
            return this.G;
        };
        p.Kk = function() {
            return this.g;
        };
        p.Jl = function() {
            return this.V;
        };
        p.li = function(a) {
            (this.V = a) ? this.L.stop() : this.L.Z(3);
        };
        p.El = function() {
            return this.va;
        };
        p.qh = function() {
            return this.A ? this.A.getValue() : this.C.currentTime;
        };
        p.Oj = function(a) {
            this.R = a;
        };
        p.Jc = function() {
            return this.K.some(function(a) {
                return !a.classList.contains("shaka-hidden");
            });
        };
        p.Sc = function() {
            this.P.La();
        };
        function qJ(a) {
            return !document.fullscreenEnabled || a.o.webkitSupportsFullscreen && a.g.preferVideoFullScreenInVisionOS && Xb().Pa() == "APPLE_VR" ? !1 : !0;
        }
        function rJ(a) {
            return "documentPictureInPicture" in window1 && a.g.preferDocumentPictureInPicture;
        }
        p.ue = function() {
            return this.F.Qa() ? !1 : qJ(this) || (!this.j || !this.j.isUsingAnotherMediaElement()) && this.o.webkitSupportsFullscreen ? !0 : !1;
        };
        p.Jb = function() {
            if (qJ(this)) return !!document.fullscreenElement;
            var a = this.o;
            return a.webkitSupportsFullscreen ? a.webkitDisplayingFullscreen : !1;
        };
        function sJ(a) {
            var b, c, d;
            return H(function(e) {
                switch(e.h){
                    case 1:
                        e.m(2);
                        if (!qJ(a)) {
                            b = a.o;
                            b.webkitSupportsFullscreen && b.webkitEnterFullscreen();
                            e.B(4);
                            break;
                        }
                        if (!a.Id()) {
                            e.B(5);
                            break;
                        }
                        return e.g(a.Yc(), 6);
                    case 6:
                        if (!rJ(a)) {
                            e.B(5);
                            break;
                        }
                        return e.g(new Promise(function(f) {
                            new Uf(f).Z(.05);
                        }), 5);
                    case 5:
                        return c = a.g.fullScreenElement, e.g(c.requestFullscreen({
                            navigationUI: "hide"
                        }), 9);
                    case 9:
                        if (!a.g.forceLandscapeOnFullscreen || !screen.orientation) {
                            e.B(4);
                            break;
                        }
                        e.m(11);
                        return e.g(screen.orientation.lock("landscape"), 13);
                    case 13:
                        e.o(4, 2);
                        break;
                    case 11:
                        e.l(2);
                    case 4:
                        e.o(0);
                        break;
                    case 2:
                        d = e.l(), a.dispatchEvent(new R("error", (new Map).set("detail", d))), e.j();
                }
            });
        }
        function dJ(a) {
            var b;
            return H(function(c) {
                if (!qJ(a)) return b = a.o, b.webkitSupportsFullscreen && b.webkitExitFullscreen(), c.B(0);
                screen.orientation && screen.orientation.unlock();
                return c.g(document.exitFullscreen(), 0);
            });
        }
        p.pg = function() {
            var a = this;
            return H(function(b) {
                return a.Jb() ? b.g(dJ(a), 0) : b.g(sJ(a), 0);
            });
        };
        p.Gf = function() {
            return this.F.Qa() ? !1 : document.pictureInPictureEnabled || rJ(this) ? !this.o.disablePictureInPicture : !1;
        };
        p.Id = function() {
            return !!(window1.documentPictureInPicture && window1.documentPictureInPicture.window || document.pictureInPictureElement);
        };
        p.Yc = function() {
            var a = this, b, c;
            return H(function(d) {
                switch(d.h){
                    case 1:
                        d.m(2);
                        if (rJ(a)) {
                            if (!a.Jb()) {
                                d.B(10);
                                break;
                            }
                            return d.g(dJ(a), 10);
                        }
                        return document.pictureInPictureElement ? d.g(document.exitPictureInPicture(), 5) : (a.Jb() && dJ(a), b = a.o, d.g(b.requestPictureInPicture(), 5));
                    case 10:
                        return d.g(tJ(a), 5);
                    case 5:
                        d.o(0);
                        break;
                    case 2:
                        c = d.l(), a.dispatchEvent(new R("error", (new Map).set("detail", c))), d.j();
                }
            });
        };
        function tJ(a) {
            var b, c, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) {
                    if (window1.documentPictureInPicture.window) return window1.documentPictureInPicture.window.close(), h.return();
                    b = a.l;
                    c = b.getBoundingClientRect();
                    return h.g(window1.documentPictureInPicture.requestWindow({
                        width: c.width,
                        height: c.height
                    }), 2);
                }
                d = h.i;
                uJ(d);
                e = b.parentNode || document.body;
                f = a.l.cloneNode(!0);
                f.style.visibility = "hidden";
                f.style.height = getComputedStyle(b).height;
                e.appendChild(f);
                g = document.createElement("style");
                g.append("[data-shaka-player-container] {\n      width: 100% !important; max-height: 100%}");
                d.document.head.append(g);
                d.document.body.append(b);
                a.h.ra(d, "pagehide", function() {
                    f.replaceWith(b);
                });
                h.j();
            });
        }
        function uJ(a) {
            var b = [].concat(G(document.styleSheets)).map(function(d) {
                try {
                    return [].concat(G(d.cssRules)).map(function(f) {
                        return f.cssText;
                    }).join("");
                } catch (f) {
                    var e = document.createElement("link");
                    e.rel = "stylesheet";
                    e.type = d.type;
                    e.media = d.media;
                    e.href = d.href;
                    a.document.head.appendChild(e);
                }
                return "";
            }).filter(Boolean).join("\n"), c = document.createElement("style");
            c.textContent = b;
            a.document.head.appendChild(c);
        }
        p.Uj = function() {
            OH(this.S, !0);
            this.G && this.G.hasChildNodes() && OH(this.G, !0);
            this.I && this.I.hasChildNodes() && OH(this.I, !0);
            this.j.hasCustomClick() ? this.i.setAttribute("ad-active", "true") : this.i.removeAttribute("ad-active");
        };
        p.ej = function() {
            OH(this.S, !1);
            OH(this.G, !1);
            OH(this.I, !1);
            this.i.removeAttribute("ad-active");
        };
        function XH(a) {
            if (a.X) {
                if (a.j && (a.j && a.j.isPaused() ? a.j.play() : a.j && a.j.pause(), a.j.isLinear())) return;
                a.C.duration && (a.C.paused && !a.V ? (a.m.isEnded() && (a.C.currentTime = a.m.wa().start), a.C.play()) : a.C.pause());
            }
        }
        function iJ(a) {
            a.i = U("div");
            a.i.classList.add("shaka-controls-container");
            a.l.appendChild(a.i);
            a.l.setAttribute("shaka-controls", "true");
            a.h.u(a.i, "touchend", function(b) {
                a.C.duration && (a.Ca() ? (a.R = Date.now(), $H(a, !0)) : vJ(a, b), b.cancelable && b.preventDefault());
            });
            a.h.u(a.i, "click", function() {
                $H(a);
            });
            a.h.u(a.i, "dblclick", function() {
                a.g.doubleClickForFullscreen && a.ue() && a.pg();
            });
        }
        function lJ(a) {
            var b = U("div");
            b.classList.add("shaka-play-button-container");
            a.i.appendChild(b);
            a.Ia = new YH(b, a);
            a.J.push(a.Ia);
        }
        function kJ(a) {
            var b = U("div");
            b.classList.add("shaka-scrim-container");
            a.i.appendChild(b);
        }
        function wJ(a) {
            a.S = U("div");
            a.S.classList.add("shaka-ad-controls");
            var b = a.j != null && a.j.isLinear();
            OH(a.S, b);
            a.O.appendChild(a.S);
            b = new qI(a.S, a);
            a.J.push(b);
        }
        function mJ(a) {
            a.M = U("div");
            a.M.classList.add("shaka-spinner-container");
            a.l.appendChild(a.M);
            var b = U("div");
            b.classList.add("shaka-spinner");
            a.M.appendChild(b);
            b.insertAdjacentHTML("beforeend", '<svg focusable="false" stroke="currentColor"\n         viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"\n         width="50px" height="50px" class="q-spinner text-grey-9">\n      <g transform="translate(1 1)" stroke-width="6" fill="none"\n        fill-rule="evenodd">\n        <circle stroke-opacity=".5" cx="18" cy="18" r="16"></circle>\n        <path d="M34 18c0-9.94-8.06-16-16-16">\n          <animateTransform attributeName="transform" type="rotate"\n            from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite">\n          </animateTransform>\n        </path>\n      </g>\n    </svg>');
        }
        function nJ(a) {
            var b = U("div");
            b.classList.add("shaka-hidden-fast-forward-container");
            a.i.appendChild(b);
            a.jb = new aI(b, a);
            a.J.push(a.jb);
        }
        function oJ(a) {
            var b = U("div");
            b.classList.add("shaka-hidden-rewind-container");
            a.i.appendChild(b);
            a.kb = new bI(b, a);
            a.J.push(a.kb);
        }
        function pJ(a) {
            a.O = U("div");
            a.O.classList.add("shaka-bottom-controls");
            a.O.classList.add("shaka-no-propagation");
            a.i.appendChild(a.O);
            a.h.u(a.O, "click", function(e) {
                e.target.closest(".shaka-overflow-button") || a.Sc();
            });
            wJ(a);
            xJ(a);
            a.H = U("div");
            a.H.classList.add("shaka-controls-button-panel");
            a.H.classList.add("shaka-show-controls-on-mouse-over");
            a.g.enableTooltips && a.H.classList.add("shaka-tooltips-on");
            a.O.appendChild(a.H);
            for(var b = u(a.g.controlPanelElements), c = b.next(); !c.done; c = b.next())if (c = c.value, hJ.get(c)) {
                var d = hJ.get(c).create(a.H, a);
                a.J.push(d);
                c == "time_and_duration" && (c = new QH(a.H, a), a.J.push(c));
            } else Za("Unrecognized control panel element requested:", c);
        }
        function xJ(a) {
            if (a.g.addSeekBar) a.A = yJ.create(a.O, a), a.J.push(a.A);
            else {
                for(var b = u(a.K), c = b.next(); !c.done; c = b.next())c.value.classList.add("shaka-low-position");
                a = a.H;
                a.classList.contains("shaka-tooltips-on") && a.classList.add("shaka-tooltips-low-position");
            }
        }
        function jJ(a) {
            a.G = U("div");
            a.G.classList.add("shaka-client-side-ad-container");
            OH(a.G, !1);
            a.h.u(a.G, "click", function() {
                $H(a);
            });
            a.l.appendChild(a.G);
            a.I = U("div");
            a.I.classList.add("shaka-server-side-ad-container");
            OH(a.I, !1);
            a.h.u(a.I, "click", function() {
                $H(a);
            });
            a.l.appendChild(a.I);
        }
        function aJ(a) {
            a.h.u(a.m, "buffering", function() {
                zJ(a);
            });
            zJ(a);
            a.h.u(window1, "keydown", function(b) {
                AJ(a, b);
            });
            a.h.u(window1, "click", function() {
                return a.Sc();
            });
            a.h.u(a, "submenuopen", function() {
                a.Sc();
            });
            a.h.u(a.C, "play", function() {
                WI(a);
            });
            a.h.u(a.C, "pause", function() {
                WI(a);
            });
            a.h.u(a.l, "mousemove", function(b) {
                vJ(a, b);
            });
            a.h.u(a.l, "touchmove", function(b) {
                vJ(a, b);
            }, {
                passive: !0
            });
            a.h.u(a.l, "touchend", function(b) {
                vJ(a, b);
            }, {
                passive: !0
            });
            a.h.u(a.l, "mouseleave", function() {
                a.R || a.L.La();
            });
            a.h.u(a.l, "wheel", function(b) {
                vJ(a, b);
            }, {
                passive: !0
            });
            a.h.u(a.F, "caststatuschanged", function() {
                cJ(a);
            });
            a.h.u(a.D, "vrstatuschanged", function() {
                a.dispatchEvent(new R("vrstatuschanged"));
            });
            BJ(a, a.l, function() {
                return !a.g.enableKeyboardPlaybackControlsInWindow && !a.Jb();
            });
            BJ(a, window1, function() {
                return a.g.enableKeyboardPlaybackControlsInWindow || a.Jb();
            });
            a.h.u(a.ua, "ad-started", function(b) {
                a.j = b.ad;
                a.Uj();
                zJ(a);
            });
            a.h.u(a.ua, "ad-stopped", function() {
                a.j = null;
                a.ej();
                zJ(a);
            });
            screen.orientation && a.h.u(screen.orientation, "change", function() {
                return H(function(b) {
                    return b.g(CJ(a), 0);
                });
            });
        }
        function bJ(a) {
            if (a.g.setupMediaSession && navigator.mediaSession) {
                var b = function(f, g) {
                    try {
                        navigator.mediaSession.setActionHandler(f, function(h) {
                            g(h);
                        });
                    } catch (h) {}
                }, c = function() {
                    if (a.j && a.j.isLinear()) d();
                    else {
                        var f = a.m.wa(), g = f.end - f.start;
                        f = parseFloat((a.C.currentTime - f.start).toFixed(2));
                        a.m.U() && Math.abs(g - f) < 1 && (g = Infinity);
                        try {
                            navigator.mediaSession.setPositionState({
                                duration: Math.max(0, g),
                                playbackRate: a.C.playbackRate,
                                position: Math.max(0, f)
                            });
                        } catch (h) {}
                    }
                }, d = function() {
                    try {
                        navigator.mediaSession.setPositionState();
                    } catch (f) {}
                }, e = function(f) {
                    var g = a.g.keyboardSeekDistance;
                    switch(f.action){
                        case "pause":
                            XH(a);
                            break;
                        case "play":
                            XH(a);
                            break;
                        case "seekbackward":
                            if (f.seekOffset && !isFinite(f.seekOffset)) break;
                            a.j && a.j.isLinear() || DJ(a, a.A.getValue() - (f.seekOffset || g));
                            break;
                        case "seekforward":
                            if (f.seekOffset && !isFinite(f.seekOffset)) break;
                            a.j && a.j.isLinear() || DJ(a, a.A.getValue() + (f.seekOffset || g));
                            break;
                        case "seekto":
                            if (f.seekTime && !isFinite(f.seekTime)) break;
                            a.j && a.j.isLinear() || DJ(a, a.m.wa().start + f.seekTime);
                            break;
                        case "stop":
                            a.m.tc();
                            break;
                        case "enterpictureinpicture":
                            a.j && a.j.isLinear() || a.Yc();
                    }
                };
                b("pause", e);
                b("play", e);
                b("seekbackward", e);
                b("seekforward", e);
                b("seekto", e);
                b("stop", e);
                ("documentPictureInPicture" in window1 || document.pictureInPictureEnabled) && b("enterpictureinpicture", e);
                b = function() {
                    a.m.U() || a.m.wa().start != 0 ? (c(), a.h.u(a.C, "timeupdate", c)) : d();
                };
                a.m.Gh() && b();
                a.h.u(a.m, "loaded", b);
                a.h.u(a.m, "unloading", function() {
                    a.h.Fa(a.C, "timeupdate", c);
                });
                a.h.u(a.m, "metadata", function(f) {
                    if (f = f.payload) {
                        var g;
                        f.key == "TIT2" && f.data && (g = f.data);
                        var h;
                        f.key == "APIC" && f.mimeType == "--\x3e" && (h = f.data);
                        g && (f = {
                            title: g,
                            artwork: []
                        }, navigator.mediaSession.metadata && (f = navigator.mediaSession.metadata, f.title = g), navigator.mediaSession.metadata = new MediaMetadata(f));
                        h && (g = a.o, h != g.poster && (g.poster = h), g = {
                            title: "",
                            artwork: [
                                {
                                    src: h
                                }
                            ]
                        }, navigator.mediaSession.metadata && (g = navigator.mediaSession.metadata, g.artwork = [
                            {
                                src: h
                            }
                        ]), navigator.mediaSession.metadata = new MediaMetadata(g));
                    }
                });
            }
        }
        function fJ(a) {
            if (a.g.setupMediaSession && navigator.mediaSession) {
                try {
                    navigator.mediaSession.setPositionState();
                } catch (b) {}
                a = function(b) {
                    try {
                        navigator.mediaSession.setActionHandler(b, null);
                    } catch (c) {}
                };
                a("pause");
                a("play");
                a("seekbackward");
                a("seekforward");
                a("seekto");
                a("stop");
                a("enterpictureinpicture");
            }
        }
        function CJ(a) {
            return H(function(b) {
                return a.C && a.C.readyState != 0 && !a.F.Qa() && a.g.enableFullscreenOnRotation && a.ue() ? screen.orientation.type.includes("landscape") && !a.Jb() ? b.g(sJ(a), 0) : screen.orientation.type.includes("portrait") && a.Jb() ? b.g(dJ(a), 0) : b.B(0) : b.return();
            });
        }
        function vJ(a, b) {
            b.type == "mousemove" && (a.i.classList.remove("shaka-keyboard-navigation"), WI(a));
            b.type == "touchstart" || b.type == "touchmove" || b.type == "touchend" || b.type == "keyup" ? a.R = Date.now() : a.R + 1E3 < Date.now() && (a.R = null);
            a.R && b.type == "mousemove" || (a.l.classList.remove("no-cursor"), a.Oa = !0, a.P.stop(), a.Ca() || (ZI(a), WI(a)), a.L.stop(), b.type != "touchend" && b.type != "wheel" && b.type != "keyup" && a.R || a.L.Z(3));
        }
        function EJ(a) {
            return window1.matchMedia("hover: hover").matches ? a.ab.some(function(b) {
                return b.matches(":hover");
            }) : !1;
        }
        function YI(a) {
            var b = a.l.getElementsByClassName("shaka-text-container")[0];
            b && (a.Ca() ? b.style.bottom = a.O.clientHeight + "px" : b.style.bottom = "0px");
        }
        function WI(a) {
            var b = a.j ? a.j.isPaused() : !1, c = a.C.paused && !a.V, d = a.i.classList.contains("shaka-keyboard-navigation");
            b || (!a.j || !a.j.isLinear()) && c || a.Oa || d || EJ(a) ? (ZI(a), a.i.getAttribute("shown") == null && (a.i.setAttribute("shown", "true"), XI(a)), YI(a), a.ba.stop()) : a.ba.Z(a.g.fadeDelay);
            a.Jc() && a.H.classList.remove("shaka-tooltips-on");
        }
        function $H(a, b) {
            b = b === void 0 ? !1 : b;
            a.X && !a.Sb() && (a.Jc() ? a.P.La() : a.g.singleClickForPlayAndPause ? XH(a) : b && a.Ca() && a.fj());
        }
        function cJ(a) {
            var b = a.F.Qa();
            a.dispatchEvent(new R("caststatuschanged", (new Map).set("newStatus", b)));
            b ? a.i.getAttribute("casting") == null && (a.i.setAttribute("casting", "true"), XI(a)) : a.i.getAttribute("casting") != null && (a.i.removeAttribute("casting"), XI(a));
        }
        function BJ(a, b, c) {
            a.h.u(b, "keydown", function(d) {
                if (c()) {
                    var e = document.activeElement, f = e && e.classList ? e.classList.contains("shaka-volume-bar") : !1, g = e && e.classList && e.classList.contains("shaka-seek-bar"), h = a.Jb();
                    e = a.i.contains(e);
                    h = h || a.g.enableKeyboardPlaybackControlsInWindow;
                    e && vJ(a, d);
                    if (a.g.enableKeyboardPlaybackControls && a.m.dd()) {
                        var k = a.g.keyboardSeekDistance, l = a.g.keyboardLargeSeekDistance;
                        switch(d.key){
                            case "ArrowLeft":
                                a.A && k > 0 && (g || h) && !f && (d.preventDefault(), DJ(a, a.A.getValue() - k));
                                break;
                            case "ArrowRight":
                                a.A && k > 0 && (g || h) && !f && (d.preventDefault(), DJ(a, a.A.getValue() + k));
                                break;
                            case "PageDown":
                                a.A && l > 0 && (g || h) && (d.preventDefault(), DJ(a, a.A.getValue() - l));
                                break;
                            case "PageUp":
                                a.A && l > 0 && (g || h) && (d.preventDefault(), DJ(a, a.A.getValue() + l));
                                break;
                            case "Home":
                                a.A && DJ(a, a.m.wa().start);
                                break;
                            case "End":
                                a.A && DJ(a, a.m.wa().end);
                                break;
                            case "c":
                                a.m.Xd(!a.m.Tc());
                                break;
                            case "f":
                                a.ue() && a.pg();
                                break;
                            case "m":
                                a.j && a.j.isLinear() ? a.j.setMuted(!a.j.isMuted()) : a.o.muted = !a.o.muted;
                                break;
                            case "p":
                                a.Gf() && a.Yc();
                                break;
                            case ">":
                                d = a.g.playbackRates.indexOf(a.m.Wa());
                                d > -1 && d + 1 < a.g.playbackRates.length && a.m.sc(a.g.playbackRates[d + 1], !1);
                                break;
                            case "<":
                                d = a.g.playbackRates.indexOf(a.m.Wa());
                                d > -1 && d - 1 >= 0 && a.m.sc(a.g.playbackRates[d - 1], !1);
                                break;
                            case " ":
                                (g || h && !e) && XH(a);
                        }
                    }
                }
            });
            a.h.u(b, "keyup", function(d) {
                c() && a.na.delete(d.key);
            });
        }
        function zJ(a) {
            a.X && (a.j && a.j.isClientRendering() && a.j.isLinear() ? OH(a.M, !1) : OH(a.M, a.m.Df()));
        }
        p.Ca = function() {
            return this.X ? this.i.getAttribute("shown") != null || this.i.getAttribute("casting") != null : !1;
        };
        function XI(a) {
            a.Ca() ? a.dispatchEvent(new R("showingui")) : a.dispatchEvent(new R("hidingui"));
        }
        function DJ(a, b) {
            a.C.currentTime = b;
            ZI(a);
        }
        function ZI(a) {
            if (a.A) {
                if (a.A.setValue(a.C.currentTime), a.A.update(), a.A.isShowing()) {
                    for(var b = u(a.K), c = b.next(); !c.done; c = b.next())c.value.classList.remove("shaka-low-position");
                    b = a.H;
                    b.classList.contains("shaka-tooltips-on") && b.classList.remove("shaka-tooltips-low-position");
                } else {
                    b = u(a.K);
                    for(c = b.next(); !c.done; c = b.next())c.value.classList.add("shaka-low-position");
                    b = a.H;
                    b.classList.contains("shaka-tooltips-on") && b.classList.add("shaka-tooltips-low-position");
                }
            }
            a.dispatchEvent(new R("timeandseekrangeupdated"));
        }
        function AJ(a, b) {
            a.na.add(b.key);
            var c = a.Jc();
            b.key == "Tab" && (a.i.classList.add("shaka-keyboard-navigation"), WI(a), a.h.u(window1, "mousedown", function() {
                a.h.Fa(window1, "mousedown");
            }));
            b.key == "Escape" && a.P.La();
            c && a.na.has("Tab") && FJ(a, b);
        }
        function FJ(a, b) {
            var c = a.K.filter(function(f) {
                return !f.classList.contains("shaka-hidden");
            });
            if (c.length) {
                var d = c[0];
                if (d.childNodes.length) {
                    for(c = d.firstElementChild; c && c.classList.contains("shaka-hidden");)c = c.nextElementSibling;
                    for(d = d.lastElementChild; d && d.classList.contains("shaka-hidden");)d = d.previousElementSibling;
                    var e = document.activeElement;
                    a.na.has("Shift") ? e == c && (b.preventDefault(), d.focus()) : e == d && (b.preventDefault(), c.focus());
                }
            }
        }
        p.Bm = function() {
            var a = new Event("mousemove", {
                bubbles: !1,
                cancelable: !1
            });
            vJ(this, a);
        };
        p.fj = function() {
            this.L.La();
        };
        p.Lg = function() {
            return this.D.Lg();
        };
        p.Sb = function() {
            return this.D.Sb();
        };
        p.xl = function() {
            var a = this.D;
            if (a.g) {
                a = a.g;
                xI(a.h, a.F);
                var b = a.h, c = 0;
                a = 0;
                a = b[0];
                var d = b[1], e = b[2];
                b = b[3];
                c = d * d;
                var f = e * e, g = b * b;
                c = a * a + c + f + g;
                var h = a * b - d * e;
                h > .499995 * c ? (c = Math.PI / 2, a = 2 * Math.atan2(d, a)) : h < -0.499995 * c ? (c = -Math.PI / 2, a = 2 * Math.atan2(d, a)) : (c = Math.asin(2 * (a * e - b * d)), a = Math.atan2(2 * (a * b + d * e), 1 - 2 * (f + g)));
                a = Math.acos(Math.cos(a) * Math.cos(c)) * 180 / Math.PI;
            } else Za("Not playing VR content"), a = null;
            return a;
        };
        p.wl = function() {
            var a = this.D;
            a.g ? a = a.g.j : (Za("Not playing VR content"), a = null);
            return a;
        };
        p.zm = function(a) {
            var b = this.D;
            b.g ? (a < 0 ? (Za("Field of view should be greater than 0"), a = 0) : a > 100 && (Za("Field of view should be less than 100"), a = 100), b = b.g, b.j = a, EI(b, !1)) : Za("Not playing VR content");
        };
        p.Yd = function() {
            this.D.Yd();
        };
        p.Ch = function(a) {
            this.D.Ch(a);
        };
        p.Ah = function(a) {
            this.D.Ah(a);
        };
        p.Bh = function(a) {
            this.D.Bh(a);
        };
        function $I() {
            var a = new Tc("en");
            a.Ya("ar", new Map([
                [
                    "AD_DURATION",
                    "\u0645\u062f\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646"
                ],
                [
                    "AD_PROGRESS",
                    "\u0627\u0644\u0625\u0639\u0644\u0627\u0646 [AD_ON] \u0645\u0646 [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u0625\u062d\u0635\u0627\u0621\u0627\u062a \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062a"
                ],
                [
                    "AD_TIME",
                    "\u0627\u0644\u0625\u0639\u0644\u0627\u0646: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u062a\u0644\u0642\u0627\u0626\u064a"
                ],
                [
                    "BACK",
                    "\u0631\u062c\u0648\u0639"
                ],
                [
                    "CAPTIONS",
                    "\u0627\u0644\u062a\u0631\u062c\u0645\u0629 \u0648\u0627\u0644\u0634\u0631\u062d"
                ],
                [
                    "CAST",
                    "\u0625\u0631\u0633\u0627\u0644..."
                ],
                [
                    "CHAPTERS",
                    "\u0627\u0644\u0641\u0635\u0648\u0644"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u062d\u0641\u0638 \u0625\u0637\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0627\u0644\u062d\u0627\u0644\u064a"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    '\u0627\u0644\u062f\u062e\u0648\u0644 \u0641\u064a \u0648\u0636\u0639 "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0646\u0627\u0641\u0630\u0629"'
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u0625\u0646\u0647\u0627\u0621 \u0648\u0636\u0639 \u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u0625\u064a\u0642\u0627\u0641 \u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0627\u0644\u062d\u0627\u0644\u064a"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    '\u0627\u0644\u062e\u0631\u0648\u062c \u0645\u0646 \u0648\u0636\u0639 "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0646\u0627\u0641\u0630\u0629"'
                ],
                [
                    "FAST_FORWARD",
                    "\u062a\u0642\u062f\u064a\u0645 \u0633\u0631\u064a\u0639"
                ],
                [
                    "FULL_SCREEN",
                    "\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629"
                ],
                [
                    "LANGUAGE",
                    "\u0627\u0644\u0644\u063a\u0629"
                ],
                [
                    "LIVE",
                    "\u0645\u0628\u0627\u0634\u0631"
                ],
                [
                    "LOOP",
                    "\u062a\u0643\u0631\u0627\u0631"
                ],
                [
                    "MORE_SETTINGS",
                    "\u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u0625\u0639\u062f\u0627\u062f\u0627\u062a"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u0644\u063a\u0627\u062a \u0645\u062a\u0639\u062f\u062f\u0629"
                ],
                [
                    "MUTE",
                    "\u0643\u062a\u0645 \u0627\u0644\u0635\u0648\u062a"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u063a\u064a\u0631 \u0633\u0627\u0631\u064d"
                ],
                [
                    "OFF",
                    "\u0625\u064a\u0642\u0627\u0641"
                ],
                [
                    "ON",
                    "\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "PAUSE",
                    "\u0625\u064a\u0642\u0627\u0641 \u0645\u0624\u0642\u062a"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0627\u0644\u0646\u0627\u0641\u0630\u0629"
                ],
                [
                    "PLAY",
                    "\u0627\u0644\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u0633\u0631\u0639\u0629 \u0627\u0644\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "QUALITY",
                    "\u0627\u0644\u062c\u0648\u062f\u0629"
                ],
                [
                    "RECENTER_VR",
                    "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0648\u0633\u064a\u0637"
                ],
                [
                    "REPLAY",
                    "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "RESOLUTION",
                    "\u062f\u0631\u062c\u0629 \u0627\u0644\u062f\u0642\u0629"
                ],
                [
                    "REWIND",
                    "\u062a\u0631\u062c\u064a\u0639"
                ],
                [
                    "SEEK",
                    "\u0627\u0644\u0628\u062d\u062b \u0628\u0627\u0644\u062a\u0645\u0631\u064a\u0631"
                ],
                [
                    "SKIP_AD",
                    "\u062a\u062e\u0637\u0651\u064a \u0627\u0644\u0625\u0639\u0644\u0627\u0646"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u0627\u0644\u0627\u0646\u062a\u0642\u0627\u0644 \u0625\u0644\u0649 \u0628\u062b \u0645\u0628\u0627\u0634\u0631"
                ],
                [
                    "STATISTICS",
                    "\u0627\u0644\u0625\u062d\u0635\u0627\u0621\u0627\u062a"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u0639\u0631\u0636 \u0625\u062c\u0628\u0627\u0631\u064a"
                ],
                [
                    "SURROUND",
                    "\u0635\u0648\u062a \u0645\u062d\u064a\u0637\u064a"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u0625\u064a\u0642\u0627\u0641 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u062c\u0633\u0651\u0645 \u0623\u0648 \u062a\u0641\u0639\u064a\u0644\u0647"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u063a\u064a\u0631 \u0645\u062d\u062f\u062f"
                ],
                [
                    "UNMUTE",
                    "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u0635\u0648\u062a"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641"
                ],
                [
                    "VOLUME",
                    "\u0645\u0633\u062a\u0648\u0649 \u0627\u0644\u0635\u0648\u062a"
                ]
            ]));
            a.Ya("de", new Map([
                [
                    "AD_DURATION",
                    "Dauer der Werbeanzeige"
                ],
                [
                    "AD_PROGRESS",
                    "Werbung\u00a0[AD_ON] von\u00a0[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Anzeigenstatistiken"
                ],
                [
                    "AD_TIME",
                    "Werbeanzeige: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatisch"
                ],
                [
                    "BACK",
                    "Zur\u00fcck"
                ],
                [
                    "CAPTIONS",
                    "Untertitel"
                ],
                [
                    "CAST",
                    "Streamen..."
                ],
                [
                    "CHAPTERS",
                    "Kapitel"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Videoframe speichern"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "In Endlosschleife spielen"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Bild im Bild aktivieren"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Vollbildmodus beenden"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Endlosschleife stoppen"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Bild im Bild beenden"
                ],
                [
                    "FAST_FORWARD",
                    "Vorspulen"
                ],
                [
                    "FULL_SCREEN",
                    "Vollbildmodus"
                ],
                [
                    "LANGUAGE",
                    "Sprache"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Schleife"
                ],
                [
                    "MORE_SETTINGS",
                    "Weitere Einstellungen"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Mehrere Sprachen"
                ],
                [
                    "MUTE",
                    "Stummschalten"
                ],
                [
                    "NOT_APPLICABLE",
                    "Nicht zutreffend"
                ],
                [
                    "OFF",
                    "Aus"
                ],
                [
                    "ON",
                    "Ein"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Bild im Bild"
                ],
                [
                    "PLAY",
                    "Wiedergabe"
                ],
                [
                    "PLAYBACK_RATE",
                    "Geschwindigkeit"
                ],
                [
                    "QUALITY",
                    "Qualit\u00e4t"
                ],
                [
                    "RECENTER_VR",
                    "Zentrieren"
                ],
                [
                    "REPLAY",
                    "Noch einmal wiedergeben"
                ],
                [
                    "RESOLUTION",
                    "Aufl\u00f6sung"
                ],
                [
                    "REWIND",
                    "Zur\u00fcckspulen"
                ],
                [
                    "SEEK",
                    "Suche"
                ],
                [
                    "SKIP_AD",
                    "\u00dcberspringen"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Zum Live-Videostream wechseln"
                ],
                [
                    "STATISTICS",
                    "Statistiken"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Erzwungen"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Einstellung \u201estereoskopisch\u201c ein\u2011/ausschalten"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Unbestimmt"
                ],
                [
                    "UNMUTE",
                    "Stummschaltung aufheben"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Unbekannt"
                ],
                [
                    "VOLUME",
                    "Lautst\u00e4rke"
                ]
            ]));
            a.Ya("en", new Map([
                [
                    "AD_DURATION",
                    "Ad duration"
                ],
                [
                    "AD_PROGRESS",
                    "Ad [AD_ON] of [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Ad statistics"
                ],
                [
                    "AD_TIME",
                    "Ad: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Auto"
                ],
                [
                    "BACK",
                    "Back"
                ],
                [
                    "CAPTIONS",
                    "Captions"
                ],
                [
                    "CAST",
                    "Cast..."
                ],
                [
                    "CHAPTERS",
                    "Chapters"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Save video frame"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Loop the current video"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Enter Picture-in-Picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Exit full screen"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Stop looping the current video"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Exit Picture-in-Picture"
                ],
                [
                    "FAST_FORWARD",
                    "Fast-forward"
                ],
                [
                    "FULL_SCREEN",
                    "Full screen"
                ],
                [
                    "LANGUAGE",
                    "Language"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Loop"
                ],
                [
                    "MORE_SETTINGS",
                    "More settings"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Multiple languages"
                ],
                [
                    "MUTE",
                    "Mute"
                ],
                [
                    "NOT_APPLICABLE",
                    "Not applicable"
                ],
                [
                    "OFF",
                    "Off"
                ],
                [
                    "ON",
                    "On"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-Picture"
                ],
                [
                    "PLAY",
                    "Play"
                ],
                [
                    "PLAYBACK_RATE",
                    "Playback speed"
                ],
                [
                    "QUALITY",
                    "Quality"
                ],
                [
                    "RECENTER_VR",
                    "Recenter"
                ],
                [
                    "REPLAY",
                    "Replay"
                ],
                [
                    "RESOLUTION",
                    "Resolution"
                ],
                [
                    "REWIND",
                    "Rewind"
                ],
                [
                    "SEEK",
                    "Seek"
                ],
                [
                    "SKIP_AD",
                    "Skip Ad"
                ],
                [
                    "SKIP_NEXT",
                    "Next"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Previous"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Skip ahead to live"
                ],
                [
                    "STATISTICS",
                    "Statistics"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forced"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Toggle stereoscopic"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Undetermined"
                ],
                [
                    "UNMUTE",
                    "Unmute"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Unrecognized"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Ya("en-GB", new Map([
                [
                    "AD_DURATION",
                    "Ad duration"
                ],
                [
                    "AD_PROGRESS",
                    "Ad [AD_ON] of [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Ad statistics"
                ],
                [
                    "AD_TIME",
                    "Ad: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Auto"
                ],
                [
                    "BACK",
                    "Back"
                ],
                [
                    "CAPTIONS",
                    "Captions"
                ],
                [
                    "CAST",
                    "Cast..."
                ],
                [
                    "CHAPTERS",
                    "Chapters"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Save video frame"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Loop the current video"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Enter picture-in-picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Exit full screen"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Stop looping the current video"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Exit picture-in-picture"
                ],
                [
                    "FAST_FORWARD",
                    "Fast-forward"
                ],
                [
                    "FULL_SCREEN",
                    "Full screen"
                ],
                [
                    "LANGUAGE",
                    "Language"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Loop"
                ],
                [
                    "MORE_SETTINGS",
                    "More settings"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Multiple languages"
                ],
                [
                    "MUTE",
                    "Mute"
                ],
                [
                    "NOT_APPLICABLE",
                    "Not applicable"
                ],
                [
                    "OFF",
                    "Off"
                ],
                [
                    "ON",
                    "On"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-picture"
                ],
                [
                    "PLAY",
                    "Play"
                ],
                [
                    "PLAYBACK_RATE",
                    "Playback speed"
                ],
                [
                    "QUALITY",
                    "Quality"
                ],
                [
                    "RECENTER_VR",
                    "Recentre"
                ],
                [
                    "REPLAY",
                    "Replay"
                ],
                [
                    "RESOLUTION",
                    "Resolution"
                ],
                [
                    "REWIND",
                    "Rewind"
                ],
                [
                    "SEEK",
                    "Seek"
                ],
                [
                    "SKIP_AD",
                    "Skip ad"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Skip ahead to live"
                ],
                [
                    "STATISTICS",
                    "Statistics"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forced"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Toggle stereoscopic"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Undetermined"
                ],
                [
                    "UNMUTE",
                    "Unmute"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Unrecognised"
                ],
                [
                    "VOLUME",
                    "volume"
                ]
            ]));
            a.Ya("es", new Map([
                [
                    "AD_DURATION",
                    "Duraci\u00f3n del anuncio"
                ],
                [
                    "AD_PROGRESS",
                    "Anuncio [AD_ON] de [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Estad\u00edsticas del anuncio"
                ],
                [
                    "AD_TIME",
                    "Anuncio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Autom\u00e1tico"
                ],
                [
                    "BACK",
                    "Atr\u00e1s"
                ],
                [
                    "CAPTIONS",
                    "Subt\u00edtulos"
                ],
                [
                    "CAST",
                    "Enviar..."
                ],
                [
                    "CHAPTERS",
                    "Cap\u00edtulos"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Guardar fotograma"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Reproducir en bucle el v\u00eddeo actual"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Activar el modo imagen en imagen"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Salir del modo de pantalla completa"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Dejar de reproducir en bucle el v\u00eddeo actual"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Salir del modo imagen en imagen"
                ],
                [
                    "FAST_FORWARD",
                    "Avanzar r\u00e1pidamente"
                ],
                [
                    "FULL_SCREEN",
                    "Pantalla completa"
                ],
                [
                    "LANGUAGE",
                    "Idioma"
                ],
                [
                    "LIVE",
                    "En directo"
                ],
                [
                    "LOOP",
                    "Reproducir en bucle"
                ],
                [
                    "MORE_SETTINGS",
                    "M\u00e1s ajustes"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Varios idiomas"
                ],
                [
                    "MUTE",
                    "Silenciar"
                ],
                [
                    "NOT_APPLICABLE",
                    "No aplicable"
                ],
                [
                    "OFF",
                    "Desactivado"
                ],
                [
                    "ON",
                    "Activado"
                ],
                [
                    "PAUSE",
                    "Pausar"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Imagen en imagen"
                ],
                [
                    "PLAY",
                    "Reproducir"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocidad de reproducci\u00f3n"
                ],
                [
                    "QUALITY",
                    "Calidad"
                ],
                [
                    "RECENTER_VR",
                    "Volver a centrar"
                ],
                [
                    "REPLAY",
                    "Volver a reproducir"
                ],
                [
                    "RESOLUTION",
                    "Resoluci\u00f3n"
                ],
                [
                    "REWIND",
                    "Rebobinar"
                ],
                [
                    "SEEK",
                    "Buscar"
                ],
                [
                    "SKIP_AD",
                    "Saltar anuncio"
                ],
                [
                    "SKIP_NEXT",
                    "Siguiente"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Anterior"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Ir al v\u00eddeo en directo"
                ],
                [
                    "STATISTICS",
                    "Estad\u00edsticas"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forzado"
                ],
                [
                    "SURROUND",
                    "Envolvente"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Activar/Desactivar estereosc\u00f3pica"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Sin especificar"
                ],
                [
                    "UNMUTE",
                    "Activar sonido"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "No reconocida"
                ],
                [
                    "VOLUME",
                    "Volumen"
                ]
            ]));
            a.Ya("es-419", new Map([
                [
                    "AD_DURATION",
                    "Duraci\u00f3n del anuncio"
                ],
                [
                    "AD_PROGRESS",
                    "Anuncio [AD_ON] de [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Estad\u00edsticas de anuncios"
                ],
                [
                    "AD_TIME",
                    "Anuncio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Autom\u00e1tico"
                ],
                [
                    "BACK",
                    "Atr\u00e1s"
                ],
                [
                    "CAPTIONS",
                    "Subt\u00edtulos"
                ],
                [
                    "CAST",
                    "Transmitir..."
                ],
                [
                    "CHAPTERS",
                    "Cap\u00edtulos"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Guardar fotograma"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Repetir indefinidamente el video actual"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Ingresar al modo de pantalla en pantalla"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Salir de pantalla completa"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Detener la repetici\u00f3n indefinida del video actual"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Salir del modo de pantalla en pantalla"
                ],
                [
                    "FAST_FORWARD",
                    "Avanzar"
                ],
                [
                    "FULL_SCREEN",
                    "Pantalla completa"
                ],
                [
                    "LANGUAGE",
                    "Idioma"
                ],
                [
                    "LIVE",
                    "En directo"
                ],
                [
                    "LOOP",
                    "Repetir indefinidamente"
                ],
                [
                    "MORE_SETTINGS",
                    "M\u00e1s opciones de configuraci\u00f3n"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Varios idiomas"
                ],
                [
                    "MUTE",
                    "Silenciar"
                ],
                [
                    "NOT_APPLICABLE",
                    "No aplicable"
                ],
                [
                    "OFF",
                    "Desactivado"
                ],
                [
                    "ON",
                    "Activado"
                ],
                [
                    "PAUSE",
                    "Detener"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Pantalla en pantalla"
                ],
                [
                    "PLAY",
                    "Reproducir"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocidad de reproducci\u00f3n"
                ],
                [
                    "QUALITY",
                    "Calidad"
                ],
                [
                    "RECENTER_VR",
                    "Volver a centrar"
                ],
                [
                    "REPLAY",
                    "Volver a reproducir"
                ],
                [
                    "RESOLUTION",
                    "Resoluci\u00f3n"
                ],
                [
                    "REWIND",
                    "Retroceder"
                ],
                [
                    "SEEK",
                    "Buscar"
                ],
                [
                    "SKIP_AD",
                    "Omitir anuncio"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Adelantar hasta la transmisi\u00f3n en vivo"
                ],
                [
                    "STATISTICS",
                    "Estad\u00edsticas"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forzado"
                ],
                [
                    "SURROUND",
                    "Sonido envolvente"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Activar o desactivar el modo estereosc\u00f3pico"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Sin especificar"
                ],
                [
                    "UNMUTE",
                    "Dejar de silenciar"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "No reconocida"
                ],
                [
                    "VOLUME",
                    "Volumen"
                ]
            ]));
            a.Ya("fr", new Map([
                [
                    "AD_DURATION",
                    "Dur\u00e9e de l'annonce"
                ],
                [
                    "AD_PROGRESS",
                    "Annonce\u00a0[AD_ON] sur\u00a0[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Statistiques sur les annonces"
                ],
                [
                    "AD_TIME",
                    "Annonce\u00a0: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatique"
                ],
                [
                    "BACK",
                    "Retour"
                ],
                [
                    "CAPTIONS",
                    "Sous-titres"
                ],
                [
                    "CAST",
                    "Caster\u2026"
                ],
                [
                    "CHAPTERS",
                    "Chapitres"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "T\u00e9l\u00e9charger l'image de la vid\u00e9o"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Lire en boucle la vid\u00e9o en cours"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Utiliser le mode Picture-in-Picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Quitter le mode plein \u00e9cran"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Arr\u00eater la lecture en boucle de la vid\u00e9o en cours"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Quitter le mode\u00a0PIP (Picture-in-picture)"
                ],
                [
                    "FAST_FORWARD",
                    "Avance rapide"
                ],
                [
                    "FULL_SCREEN",
                    "Plein \u00e9cran"
                ],
                [
                    "LANGUAGE",
                    "Langue"
                ],
                [
                    "LIVE",
                    "En direct"
                ],
                [
                    "LOOP",
                    "R\u00e9p\u00e9ter"
                ],
                [
                    "MORE_SETTINGS",
                    "Plus de param\u00e8tres"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Plusieurs langues"
                ],
                [
                    "MUTE",
                    "Couper le son"
                ],
                [
                    "NOT_APPLICABLE",
                    "Non applicable"
                ],
                [
                    "OFF",
                    "D\u00e9sactiv\u00e9e"
                ],
                [
                    "ON",
                    "Activ\u00e9e"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-Picture"
                ],
                [
                    "PLAY",
                    "Visionner"
                ],
                [
                    "PLAYBACK_RATE",
                    "Vitesse de lecture"
                ],
                [
                    "QUALITY",
                    "Qualit\u00e9"
                ],
                [
                    "RECENTER_VR",
                    "Recentrer"
                ],
                [
                    "REPLAY",
                    "Revoir"
                ],
                [
                    "RESOLUTION",
                    "R\u00e9solution"
                ],
                [
                    "REWIND",
                    "Retour arri\u00e8re"
                ],
                [
                    "SEEK",
                    "Chercher"
                ],
                [
                    "SKIP_AD",
                    "Passer l'annonce"
                ],
                [
                    "SKIP_NEXT",
                    "Suivante"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Pr\u00e9c\u00e9dente"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Acc\u00e9der \u00e0 la partie la plus r\u00e9cente du direct"
                ],
                [
                    "STATISTICS",
                    "Statistiques"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forc\u00e9"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Activer/D\u00e9sactiver le mode st\u00e9r\u00e9oscopique"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Langue ind\u00e9termin\u00e9e"
                ],
                [
                    "UNMUTE",
                    "R\u00e9activer le son"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Non reconnu"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Ya("it", new Map([
                [
                    "AD_DURATION",
                    "Durata dell'annuncio"
                ],
                [
                    "AD_PROGRESS",
                    "Annuncio [AD_ON] di [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Statistiche sugli annunci"
                ],
                [
                    "AD_TIME",
                    "Annuncio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatica"
                ],
                [
                    "BACK",
                    "Indietro"
                ],
                [
                    "CAPTIONS",
                    "Sottotitoli"
                ],
                [
                    "CAST",
                    "Trasmetti..."
                ],
                [
                    "CHAPTERS",
                    "Capitoli"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Salva fotogramma"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Riproduci in loop il video corrente"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Attiva Picture in picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Esci da schermo intero"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Interrompi riproduzione in loop del video corrente"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Esci da Picture in picture"
                ],
                [
                    "FAST_FORWARD",
                    "Avanti veloce"
                ],
                [
                    "FULL_SCREEN",
                    "Schermo intero"
                ],
                [
                    "LANGUAGE",
                    "Lingua"
                ],
                [
                    "LIVE",
                    "Dal vivo"
                ],
                [
                    "LOOP",
                    "Riproduci in loop"
                ],
                [
                    "MORE_SETTINGS",
                    "Altre impostazioni"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Pi\u00f9 lingue"
                ],
                [
                    "MUTE",
                    "Disattiva audio"
                ],
                [
                    "NOT_APPLICABLE",
                    "Non applicabile"
                ],
                [
                    "OFF",
                    "Disattivo"
                ],
                [
                    "ON",
                    "Attivo"
                ],
                [
                    "PAUSE",
                    "Metti in pausa"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture in picture"
                ],
                [
                    "PLAY",
                    "Riproduci"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocit\u00e0 di riproduzione"
                ],
                [
                    "QUALITY",
                    "Qualit\u00e0"
                ],
                [
                    "RECENTER_VR",
                    "Ricentra"
                ],
                [
                    "REPLAY",
                    "Riproduci di nuovo"
                ],
                [
                    "RESOLUTION",
                    "Risoluzione"
                ],
                [
                    "REWIND",
                    "Riavvolgi"
                ],
                [
                    "SEEK",
                    "Cerca"
                ],
                [
                    "SKIP_AD",
                    "Salta annuncio"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Passa alla trasmissione dal vivo"
                ],
                [
                    "STATISTICS",
                    "Statistiche"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forzata"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Pulsante di attivazione/disattivazione stereoscopico"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Indeterminata"
                ],
                [
                    "UNMUTE",
                    "Riattiva audio"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Non riconosciuto"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Ya("ja", new Map([
                [
                    "AD_DURATION",
                    "\u5e83\u544a\u518d\u751f\u6642\u9593"
                ],
                [
                    "AD_PROGRESS",
                    "[AD_ON] \u756a\u76ee\u306e\u5e83\u544a\uff08\u5168 [NUM_ADS] \u500b\uff09"
                ],
                [
                    "AD_STATISTICS",
                    "\u5e83\u544a\u306e\u7d71\u8a08\u60c5\u5831"
                ],
                [
                    "AD_TIME",
                    "\u5e83\u544a: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u81ea\u52d5"
                ],
                [
                    "BACK",
                    "\u623b\u308b"
                ],
                [
                    "CAPTIONS",
                    "\u5b57\u5e55"
                ],
                [
                    "CAST",
                    "\u30ad\u30e3\u30b9\u30c8..."
                ],
                [
                    "CHAPTERS",
                    "\u7ae0"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u52d5\u753b\u30d5\u30ec\u30fc\u30e0\u3092\u4fdd\u5b58"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u73fe\u5728\u306e\u52d5\u753b\u3092\u30eb\u30fc\u30d7\u518d\u751f"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc\u3092\u958b\u59cb"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u5168\u753b\u9762\u8868\u793a\u3092\u7d42\u4e86"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u73fe\u5728\u306e\u52d5\u753b\u306e\u30eb\u30fc\u30d7\u518d\u751f\u3092\u505c\u6b62"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc\u3092\u7d42\u4e86"
                ],
                [
                    "FAST_FORWARD",
                    "\u65e9\u9001\u308a"
                ],
                [
                    "FULL_SCREEN",
                    "\u5168\u753b\u9762\u8868\u793a"
                ],
                [
                    "LANGUAGE",
                    "\u8a00\u8a9e"
                ],
                [
                    "LIVE",
                    "\u30e9\u30a4\u30d6"
                ],
                [
                    "LOOP",
                    "\u30eb\u30fc\u30d7"
                ],
                [
                    "MORE_SETTINGS",
                    "\u8a73\u7d30\u8a2d\u5b9a"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u591a\u8a00\u8a9e"
                ],
                [
                    "MUTE",
                    "\u30df\u30e5\u30fc\u30c8"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u8a72\u5f53\u306a\u3057"
                ],
                [
                    "OFF",
                    "\u30aa\u30d5"
                ],
                [
                    "ON",
                    "\u30aa\u30f3"
                ],
                [
                    "PAUSE",
                    "\u4e00\u6642\u505c\u6b62"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc"
                ],
                [
                    "PLAY",
                    "\u518d\u751f"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u518d\u751f\u901f\u5ea6"
                ],
                [
                    "QUALITY",
                    "\u54c1\u8cea"
                ],
                [
                    "RECENTER_VR",
                    "\u4e2d\u5fc3\u3092\u518d\u8a2d\u5b9a"
                ],
                [
                    "REPLAY",
                    "\u3082\u3046\u4e00\u5ea6\u518d\u751f"
                ],
                [
                    "RESOLUTION",
                    "\u89e3\u50cf\u5ea6"
                ],
                [
                    "REWIND",
                    "\u5dfb\u304d\u623b\u3057"
                ],
                [
                    "SEEK",
                    "\u30b7\u30fc\u30af\u518d\u751f"
                ],
                [
                    "SKIP_AD",
                    "\u5e83\u544a\u3092\u30b9\u30ad\u30c3\u30d7"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u30e9\u30a4\u30d6\u914d\u4fe1\u307e\u3067\u30b9\u30ad\u30c3\u30d7"
                ],
                [
                    "STATISTICS",
                    "\u7d71\u8a08\u60c5\u5831"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u5f37\u5236"
                ],
                [
                    "SURROUND",
                    "\u30b5\u30e9\u30a6\u30f3\u30c9"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u7acb\u4f53\u753b\u50cf\u3092\u5207\u308a\u66ff\u3048\u308b"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u4e0d\u660e"
                ],
                [
                    "UNMUTE",
                    "\u30df\u30e5\u30fc\u30c8\u3092\u89e3\u9664"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u4e0d\u660e"
                ],
                [
                    "VOLUME",
                    "\u97f3\u91cf"
                ]
            ]));
            a.Ya("ko", new Map([
                [
                    "AD_DURATION",
                    "\uad11\uace0 \uae30\uac04"
                ],
                [
                    "AD_PROGRESS",
                    "\uad11\uace0 [AD_ON]/[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\uad11\uace0 \ud1b5\uacc4"
                ],
                [
                    "AD_TIME",
                    "\uad11\uace0: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\uc790\ub3d9"
                ],
                [
                    "BACK",
                    "\ub4a4\ub85c"
                ],
                [
                    "CAPTIONS",
                    "\uc790\ub9c9"
                ],
                [
                    "CAST",
                    "\uc804\uc1a1..."
                ],
                [
                    "CHAPTERS",
                    "\uc7a5"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\ub3d9\uc601\uc0c1 \ud504\ub808\uc784 \uc800\uc7a5"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\ud604\uc7ac \ub3d9\uc601\uc0c1 \ubc18\ubcf5 \uc7ac\uc0dd"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "PIP \ubaa8\ub4dc \uc2dc\uc791"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\uc804\uccb4\ud654\uba74 \ub2eb\uae30"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\ud604\uc7ac \ub3d9\uc601\uc0c1 \ubc18\ubcf5 \uc7ac\uc0dd \uc911\uc9c0"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "PIP \ubaa8\ub4dc \uc885\ub8cc"
                ],
                [
                    "FAST_FORWARD",
                    "\ube68\ub9ac \uac10\uae30"
                ],
                [
                    "FULL_SCREEN",
                    "\uc804\uccb4\ud654\uba74"
                ],
                [
                    "LANGUAGE",
                    "\uc5b8\uc5b4"
                ],
                [
                    "LIVE",
                    "\uc2e4\uc2dc\uac04"
                ],
                [
                    "LOOP",
                    "\ubc18\ubcf5 \uc7ac\uc0dd"
                ],
                [
                    "MORE_SETTINGS",
                    "\uc124\uc815 \ub354\ubcf4\uae30"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\uc5ec\ub7ec \uc5b8\uc5b4"
                ],
                [
                    "MUTE",
                    "\uc74c\uc18c\uac70"
                ],
                [
                    "NOT_APPLICABLE",
                    "\ud574\ub2f9 \uc0ac\ud56d \uc5c6\uc74c"
                ],
                [
                    "OFF",
                    "\uc0ac\uc6a9 \uc548\ud568"
                ],
                [
                    "ON",
                    "\uc0ac\uc6a9"
                ],
                [
                    "PAUSE",
                    "\uc77c\uc2dc\uc911\uc9c0"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "PIP \ubaa8\ub4dc"
                ],
                [
                    "PLAY",
                    "\uc7ac\uc0dd"
                ],
                [
                    "PLAYBACK_RATE",
                    "\uc7ac\uc0dd \uc18d\ub3c4"
                ],
                [
                    "QUALITY",
                    "\ud488\uc9c8"
                ],
                [
                    "RECENTER_VR",
                    "\uc911\uc2ec \uc7ac\uc124\uc815"
                ],
                [
                    "REPLAY",
                    "\ub2e4\uc2dc\ubcf4\uae30"
                ],
                [
                    "RESOLUTION",
                    "\ud574\uc0c1\ub3c4"
                ],
                [
                    "REWIND",
                    "\ub418\uac10\uae30"
                ],
                [
                    "SEEK",
                    "\ucc3e\uae30"
                ],
                [
                    "SKIP_AD",
                    "\uad11\uace0 \uac74\ub108\ub6f0\uae30"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\ub77c\uc774\ube0c \ub3d9\uc601\uc0c1\uc73c\ub85c \uac74\ub108\ub6f0\uae30"
                ],
                [
                    "STATISTICS",
                    "\ud1b5\uacc4"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\uac15\uc81c"
                ],
                [
                    "SURROUND",
                    "\uc11c\ub77c\uc6b4\ub4dc"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\uc785\uccb4 \ubcf4\uae30 \uc804\ud658"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\ubbf8\uc815"
                ],
                [
                    "UNMUTE",
                    "\uc74c\uc18c\uac70 \ud574\uc81c"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\uc54c \uc218 \uc5c6\uc74c"
                ],
                [
                    "VOLUME",
                    "\ubcfc\ub968"
                ]
            ]));
            a.Ya("nl", new Map([
                [
                    "AD_DURATION",
                    "Advertentieduur"
                ],
                [
                    "AD_PROGRESS",
                    "Advertentie [AD_ON] van [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Advertentiestatistieken"
                ],
                [
                    "AD_TIME",
                    "Advertentie: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatisch"
                ],
                [
                    "BACK",
                    "Terug"
                ],
                [
                    "CAPTIONS",
                    "Ondertiteling"
                ],
                [
                    "CAST",
                    "Casten..."
                ],
                [
                    "CHAPTERS",
                    "Hoofdstukken"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Videoframe opslaan"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "De huidige video lussen"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Scherm-in-scherm openen"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Volledig scherm sluiten"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "De huidige video niet meer lussen"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Scherm-in-scherm afsluiten"
                ],
                [
                    "FAST_FORWARD",
                    "Vooruitspoelen"
                ],
                [
                    "FULL_SCREEN",
                    "Volledig scherm"
                ],
                [
                    "LANGUAGE",
                    "Taal"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Lussen"
                ],
                [
                    "MORE_SETTINGS",
                    "Meer instellingen"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Meerdere talen"
                ],
                [
                    "MUTE",
                    "Geluid uitzetten"
                ],
                [
                    "NOT_APPLICABLE",
                    "Niet van toepassing"
                ],
                [
                    "OFF",
                    "Uit"
                ],
                [
                    "ON",
                    "Aan"
                ],
                [
                    "PAUSE",
                    "Onderbreken"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Scherm-in-scherm"
                ],
                [
                    "PLAY",
                    "Afspelen"
                ],
                [
                    "PLAYBACK_RATE",
                    "Afspeelsnelheid"
                ],
                [
                    "QUALITY",
                    "Kwaliteit"
                ],
                [
                    "RECENTER_VR",
                    "Opnieuw centreren"
                ],
                [
                    "REPLAY",
                    "Opnieuw afspelen"
                ],
                [
                    "RESOLUTION",
                    "Resolutie"
                ],
                [
                    "REWIND",
                    "Terugspoelen"
                ],
                [
                    "SEEK",
                    "Zoeken"
                ],
                [
                    "SKIP_AD",
                    "Advertentie overslaan"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Doorgaan naar live"
                ],
                [
                    "STATISTICS",
                    "Statistieken"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Afgedwongen"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Stereoscopisch aan-/uitzetten"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Onbepaald"
                ],
                [
                    "UNMUTE",
                    "Geluid aanzetten"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Onbekend"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Ya("pl", new Map([
                [
                    "AD_DURATION",
                    "Czas trwania reklamy"
                ],
                [
                    "AD_PROGRESS",
                    "Reklama\u00a0[AD_ON] z\u00a0[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Statystyki reklam"
                ],
                [
                    "AD_TIME",
                    "Reklama: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatycznie"
                ],
                [
                    "BACK",
                    "Wstecz"
                ],
                [
                    "CAPTIONS",
                    "Napisy"
                ],
                [
                    "CAST",
                    "Przesy\u0142aj..."
                ],
                [
                    "CHAPTERS",
                    "Rozdzia\u0142y"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Zapisz klatk\u0119 filmu"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Odtwarzaj bie\u017c\u0105cy film w\u00a0p\u0119tli"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "W\u0142\u0105cz tryb obrazu w\u00a0obrazie"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Zamknij pe\u0142ny ekran"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Wy\u0142\u0105cz odtwarzanie bie\u017c\u0105cego filmu w\u00a0p\u0119tli"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Wy\u0142\u0105cz tryb obrazu w\u00a0obrazie"
                ],
                [
                    "FAST_FORWARD",
                    "Przewi\u0144 do przodu"
                ],
                [
                    "FULL_SCREEN",
                    "Pe\u0142ny ekran"
                ],
                [
                    "LANGUAGE",
                    "J\u0119zyk"
                ],
                [
                    "LIVE",
                    "Na \u017cywo"
                ],
                [
                    "LOOP",
                    "Odtwarzaj w\u00a0p\u0119tli"
                ],
                [
                    "MORE_SETTINGS",
                    "Wi\u0119cej ustawie\u0144"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Wiele j\u0119zyk\u00f3w"
                ],
                [
                    "MUTE",
                    "Wycisz"
                ],
                [
                    "NOT_APPLICABLE",
                    "Nie dotyczy"
                ],
                [
                    "OFF",
                    "Wy\u0142\u0105czone"
                ],
                [
                    "ON",
                    "W\u0142\u0105czone"
                ],
                [
                    "PAUSE",
                    "Wstrzymaj"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Obraz w\u00a0obrazie"
                ],
                [
                    "PLAY",
                    "Odtw\u00f3rz"
                ],
                [
                    "PLAYBACK_RATE",
                    "Szybko\u015b\u0107 odtwarzania"
                ],
                [
                    "QUALITY",
                    "Jako\u015b\u0107"
                ],
                [
                    "RECENTER_VR",
                    "Wy\u015brodkuj"
                ],
                [
                    "REPLAY",
                    "Odtw\u00f3rz ponownie"
                ],
                [
                    "RESOLUTION",
                    "Rozdzielczo\u015b\u0107"
                ],
                [
                    "REWIND",
                    "Przewi\u0144 do ty\u0142u"
                ],
                [
                    "SEEK",
                    "Szukaj"
                ],
                [
                    "SKIP_AD",
                    "Pomi\u0144 reklam\u0119"
                ],
                [
                    "SKIP_NEXT",
                    "Dalej"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Poprzedni"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Przejd\u017a do transmisji na \u017cywo"
                ],
                [
                    "STATISTICS",
                    "Statystyki"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Wymuszone"
                ],
                [
                    "SURROUND",
                    "Przestrzenny"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Prze\u0142\u0105cz tryb stereoskopowy"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Nie okre\u015blono"
                ],
                [
                    "UNMUTE",
                    "Wy\u0142\u0105cz wyciszenie"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Nierozpoznany"
                ],
                [
                    "VOLUME",
                    "G\u0142o\u015bno\u015b\u0107"
                ]
            ]));
            a.Ya("pt-BR", new Map([
                [
                    "AD_DURATION",
                    "Dura\u00e7\u00e3o do an\u00fancio"
                ],
                [
                    "AD_PROGRESS",
                    "An\u00fancio [AD_ON] de [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Estat\u00edsticas de an\u00fancios"
                ],
                [
                    "AD_TIME",
                    "An\u00fancio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Autom\u00e1tica"
                ],
                [
                    "BACK",
                    "Voltar"
                ],
                [
                    "CAPTIONS",
                    "Legendas"
                ],
                [
                    "CAST",
                    "Transmitir..."
                ],
                [
                    "CHAPTERS",
                    "Cap\u00edtulos"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Salvar frame do v\u00eddeo"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Repetir o v\u00eddeo atual"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Entrar no modo picture-in-picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Sair do modo tela cheia"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Parar repeti\u00e7\u00e3o do v\u00eddeo atual"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Sair de picture-in-picture"
                ],
                [
                    "FAST_FORWARD",
                    "Avan\u00e7ar"
                ],
                [
                    "FULL_SCREEN",
                    "Tela cheia"
                ],
                [
                    "LANGUAGE",
                    "Idioma"
                ],
                [
                    "LIVE",
                    "Ao vivo"
                ],
                [
                    "LOOP",
                    "Repetir"
                ],
                [
                    "MORE_SETTINGS",
                    "Mais defini\u00e7\u00f5es"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "V\u00e1rios idiomas"
                ],
                [
                    "MUTE",
                    "Desativar som"
                ],
                [
                    "NOT_APPLICABLE",
                    "N\u00e3o relevante"
                ],
                [
                    "OFF",
                    "Desativado"
                ],
                [
                    "ON",
                    "Ativado"
                ],
                [
                    "PAUSE",
                    "Pausar"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-picture"
                ],
                [
                    "PLAY",
                    "Reproduzir"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocidade da reprodu\u00e7\u00e3o"
                ],
                [
                    "QUALITY",
                    "Qualidade"
                ],
                [
                    "RECENTER_VR",
                    "Centralizar"
                ],
                [
                    "REPLAY",
                    "Repetir"
                ],
                [
                    "RESOLUTION",
                    "Resolu\u00e7\u00e3o"
                ],
                [
                    "REWIND",
                    "Voltar"
                ],
                [
                    "SEEK",
                    "Procurar"
                ],
                [
                    "SKIP_AD",
                    "Pular an\u00fancio"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Pular para transmiss\u00e3o ao vivo"
                ],
                [
                    "STATISTICS",
                    "Estat\u00edsticas"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Exibi\u00e7\u00e3o for\u00e7ada"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Alternar imagem estereosc\u00f3pica"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Indeterminado"
                ],
                [
                    "UNMUTE",
                    "Ativar som"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "N\u00e3o reconhecido"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Ya("ru", new Map([
                [
                    "AD_DURATION",
                    "\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0441\u0442\u044c \u0440\u0435\u043a\u043b\u0430\u043c\u044b"
                ],
                [
                    "AD_PROGRESS",
                    "\u0420\u0435\u043a\u043b\u0430\u043c\u0430 [AD_ON] \u0438\u0437 [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0430 \u043e\u0431\u044a\u044f\u0432\u043b\u0435\u043d\u0438\u0439"
                ],
                [
                    "AD_TIME",
                    "\u0420\u0435\u043a\u043b\u0430\u043c\u0430: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u0410\u0432\u0442\u043e"
                ],
                [
                    "BACK",
                    "\u041d\u0430\u0437\u0430\u0434"
                ],
                [
                    "CAPTIONS",
                    "\u0421\u0443\u0431\u0442\u0438\u0442\u0440\u044b"
                ],
                [
                    "CAST",
                    "\u0422\u0440\u0430\u043d\u0441\u043b\u0438\u0440\u043e\u0432\u0430\u0442\u044c..."
                ],
                [
                    "CHAPTERS",
                    "\u042d\u043f\u0438\u0437\u043e\u0434\u044b"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u043a\u0430\u0434\u0440 \u0432\u0438\u0434\u0435\u043e"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u0417\u0430\u0446\u0438\u043a\u043b\u0438\u0442\u044c \u0442\u0435\u043a\u0443\u0449\u0435\u0435 \u0432\u0438\u0434\u0435\u043e"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    '\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u0440\u0435\u0436\u0438\u043c "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"'
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u041e\u0431\u044b\u0447\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c \u0437\u0430\u0446\u0438\u043a\u043b\u0438\u0432\u0430\u043d\u0438\u0435 \u0442\u0435\u043a\u0443\u0449\u0435\u0433\u043e \u0432\u0438\u0434\u0435\u043e"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    '\u0412\u044b\u0439\u0442\u0438 \u0438\u0437 \u0440\u0435\u0436\u0438\u043c\u0430 "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"'
                ],
                [
                    "FAST_FORWARD",
                    "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u043a\u0430 \u0432\u043f\u0435\u0440\u0435\u0434"
                ],
                [
                    "FULL_SCREEN",
                    "\u041f\u043e\u043b\u043d\u043e\u044d\u043a\u0440\u0430\u043d\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c"
                ],
                [
                    "LANGUAGE",
                    "\u042f\u0437\u044b\u043a"
                ],
                [
                    "LIVE",
                    "\u041f\u0440\u044f\u043c\u043e\u0439 \u044d\u0444\u0438\u0440"
                ],
                [
                    "LOOP",
                    "\u0417\u0430\u0446\u0438\u043a\u043b\u0438\u0442\u044c"
                ],
                [
                    "MORE_SETTINGS",
                    "\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0435 \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u041d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u044f\u0437\u044b\u043a\u043e\u0432"
                ],
                [
                    "MUTE",
                    "\u041e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0437\u0432\u0443\u043a"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u041d\u0435\u043f\u0440\u0438\u043c\u0435\u043d\u0438\u043c\u043e"
                ],
                [
                    "OFF",
                    "\u0412\u044b\u043a\u043b."
                ],
                [
                    "ON",
                    "\u0412\u043a\u043b."
                ],
                [
                    "PAUSE",
                    "\u041f\u0430\u0443\u0437\u0430"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"
                ],
                [
                    "PLAY",
                    "\u0412\u043e\u0441\u043f\u0440\u043e\u0438\u0437\u0432\u0435\u0441\u0442\u0438"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u0421\u043a\u043e\u0440\u043e\u0441\u0442\u044c \u0432\u043e\u0441\u043f\u0440\u043e\u0438\u0437\u0432\u0435\u0434\u0435\u043d\u0438\u044f"
                ],
                [
                    "QUALITY",
                    "\u041a\u0430\u0447\u0435\u0441\u0442\u0432\u043e"
                ],
                [
                    "RECENTER_VR",
                    "\u0426\u0435\u043d\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0437\u0430\u043d\u043e\u0432\u043e"
                ],
                [
                    "REPLAY",
                    "\u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u044c"
                ],
                [
                    "RESOLUTION",
                    "\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043d\u0438\u0435"
                ],
                [
                    "REWIND",
                    "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u0430\u0442\u044c \u043d\u0430\u0437\u0430\u0434"
                ],
                [
                    "SEEK",
                    "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u043a\u0430"
                ],
                [
                    "SKIP_AD",
                    "\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c \u0438 \u043f\u0435\u0440\u0435\u0439\u0442\u0438 \u043a \u043f\u0440\u044f\u043c\u043e\u0439 \u0442\u0440\u0430\u043d\u0441\u043b\u044f\u0446\u0438\u0438"
                ],
                [
                    "STATISTICS",
                    "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0430"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u0421\u0443\u0431\u0442\u0438\u0442\u0440\u044b \u043f\u0440\u0438\u043d\u0443\u0434\u0438\u0442\u0435\u043b\u044c\u043d\u043e"
                ],
                [
                    "SURROUND",
                    "\u041e\u0431\u044a\u0435\u043c\u043d\u044b\u0439 \u0437\u0432\u0443\u043a"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u0412\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0438\u043b\u0438 \u043e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0441\u0442\u0435\u0440\u0435\u043e\u0441\u043a\u043e\u043f\u0438\u0447\u0435\u0441\u043a\u0438\u0439 \u0440\u0435\u0436\u0438\u043c"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u041d\u0435 \u0443\u043a\u0430\u0437\u0430\u043d\u043e"
                ],
                [
                    "UNMUTE",
                    "\u0412\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0437\u0432\u0443\u043a"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u041d\u0435 \u0440\u0430\u0441\u043f\u043e\u0437\u043d\u0430\u043d\u043e"
                ],
                [
                    "VOLUME",
                    "\u0413\u0440\u043e\u043c\u043a\u043e\u0441\u0442\u044c"
                ]
            ]));
            a.Ya("th", new Map([
                [
                    "AD_DURATION",
                    "\u0e23\u0e30\u0e22\u0e30\u0e40\u0e27\u0e25\u0e32\u0e42\u0e06\u0e29\u0e13\u0e32"
                ],
                [
                    "AD_PROGRESS",
                    "\u0e42\u0e06\u0e29\u0e13\u0e32 [AD_ON] \u0e08\u0e32\u0e01 [NUM_ADS] \u0e23\u0e32\u0e22\u0e01\u0e32\u0e23"
                ],
                [
                    "AD_STATISTICS",
                    "\u0e2a\u0e16\u0e34\u0e15\u0e34\u0e42\u0e06\u0e29\u0e13\u0e32"
                ],
                [
                    "AD_TIME",
                    "\u0e42\u0e06\u0e29\u0e13\u0e32: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34"
                ],
                [
                    "BACK",
                    "\u0e01\u0e25\u0e31\u0e1a"
                ],
                [
                    "CAPTIONS",
                    "\u0e04\u0e33\u0e1a\u0e23\u0e23\u0e22\u0e32\u0e22\u0e41\u0e17\u0e19\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ],
                [
                    "CAST",
                    "\u0e41\u0e04\u0e2a\u0e15\u0e4c..."
                ],
                [
                    "CHAPTERS",
                    "\u0e1a\u0e17"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01\u0e40\u0e1f\u0e23\u0e21\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u0e27\u0e19\u0e0b\u0e49\u0e33\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u0e40\u0e02\u0e49\u0e32\u0e2a\u0e39\u0e48\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e41\u0e1a\u0e1a\u0e40\u0e15\u0e47\u0e21\u0e2b\u0e19\u0e49\u0e32\u0e08\u0e2d"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u0e2b\u0e22\u0e38\u0e14\u0e27\u0e19\u0e0b\u0e49\u0e33\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"
                ],
                [
                    "FAST_FORWARD",
                    "\u0e01\u0e23\u0e2d\u0e44\u0e1b\u0e02\u0e49\u0e32\u0e07\u0e2b\u0e19\u0e49\u0e32"
                ],
                [
                    "FULL_SCREEN",
                    "\u0e40\u0e15\u0e47\u0e21\u0e2b\u0e19\u0e49\u0e32\u0e08\u0e2d"
                ],
                [
                    "LANGUAGE",
                    "\u0e20\u0e32\u0e29\u0e32"
                ],
                [
                    "LIVE",
                    "\u0e2a\u0e14"
                ],
                [
                    "LOOP",
                    "\u0e25\u0e39\u0e1b"
                ],
                [
                    "MORE_SETTINGS",
                    "\u0e01\u0e32\u0e23\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u0e2b\u0e25\u0e32\u0e22\u0e20\u0e32\u0e29\u0e32"
                ],
                [
                    "MUTE",
                    "\u0e1b\u0e34\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u0e44\u0e21\u0e48\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e02\u0e49\u0e2d\u0e07"
                ],
                [
                    "OFF",
                    "\u0e1b\u0e34\u0e14"
                ],
                [
                    "ON",
                    "\u0e40\u0e1b\u0e34\u0e14"
                ],
                [
                    "PAUSE",
                    "\u0e2b\u0e22\u0e38\u0e14\u0e0a\u0e31\u0e48\u0e27\u0e04\u0e23\u0e32\u0e27"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"
                ],
                [
                    "PLAY",
                    "\u0e40\u0e25\u0e48\u0e19"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u0e04\u0e27\u0e32\u0e21\u0e40\u0e23\u0e47\u0e27\u0e43\u0e19\u0e01\u0e32\u0e23\u0e40\u0e25\u0e48\u0e19"
                ],
                [
                    "QUALITY",
                    "\u0e04\u0e38\u0e13\u0e20\u0e32\u0e1e"
                ],
                [
                    "RECENTER_VR",
                    "\u0e08\u0e31\u0e14\u0e01\u0e36\u0e48\u0e07\u0e01\u0e25\u0e32\u0e07\u0e43\u0e2b\u0e21\u0e48"
                ],
                [
                    "REPLAY",
                    "\u0e40\u0e25\u0e48\u0e19\u0e0b\u0e49\u0e33"
                ],
                [
                    "RESOLUTION",
                    "\u0e04\u0e27\u0e32\u0e21\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14"
                ],
                [
                    "REWIND",
                    "\u0e01\u0e23\u0e2d\u0e01\u0e25\u0e31\u0e1a"
                ],
                [
                    "SEEK",
                    "\u0e04\u0e49\u0e19\u0e2b\u0e32"
                ],
                [
                    "SKIP_AD",
                    "\u0e02\u0e49\u0e32\u0e21\u0e42\u0e06\u0e29\u0e13\u0e32"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u0e02\u0e49\u0e32\u0e21\u0e44\u0e1b\u0e17\u0e35\u0e48\u0e01\u0e32\u0e23\u0e16\u0e48\u0e32\u0e22\u0e17\u0e2d\u0e14\u0e2a\u0e14"
                ],
                [
                    "STATISTICS",
                    "\u0e2a\u0e16\u0e34\u0e15\u0e34"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u0e1a\u0e31\u0e07\u0e04\u0e31\u0e1a"
                ],
                [
                    "SURROUND",
                    "\u0e40\u0e0b\u0e2d\u0e23\u0e4c\u0e23\u0e32\u0e27\u0e14\u0e4c"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u0e40\u0e1b\u0e34\u0e14/\u0e1b\u0e34\u0e14\u0e1f\u0e35\u0e40\u0e08\u0e2d\u0e23\u0e4c\u0e2a\u0e32\u0e21\u0e21\u0e34\u0e15\u0e34"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u0e44\u0e21\u0e48\u0e01\u0e33\u0e2b\u0e19\u0e14"
                ],
                [
                    "UNMUTE",
                    "\u0e40\u0e1b\u0e34\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u0e17\u0e35\u0e48\u0e44\u0e21\u0e48\u0e23\u0e39\u0e49\u0e08\u0e31\u0e01"
                ],
                [
                    "VOLUME",
                    "\u0e23\u0e30\u0e14\u0e31\u0e1a\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ]
            ]));
            a.Ya("tr", new Map([
                [
                    "AD_DURATION",
                    "Reklam s\u00fcresi"
                ],
                [
                    "AD_PROGRESS",
                    "[AD_ON]/[NUM_ADS] reklam"
                ],
                [
                    "AD_STATISTICS",
                    "Reklam istatistikleri"
                ],
                [
                    "AD_TIME",
                    "Reklam: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Otomatik"
                ],
                [
                    "BACK",
                    "Geri"
                ],
                [
                    "CAPTIONS",
                    "Altyaz\u0131lar"
                ],
                [
                    "CAST",
                    "Yay\u0131nla..."
                ],
                [
                    "CHAPTERS",
                    "B\u00f6l\u00fcmler"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Video karesini kaydet"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Mevcut videoyu d\u00f6ng\u00fcye al"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Pencere i\u00e7inde Pencere moduna gir"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Tam ekrandan \u00e7\u0131k"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Mevcut videonun d\u00f6ng\u00fcs\u00fcn\u00fc durdur"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Pencere \u0130\u00e7inde Pencereden \u00c7\u0131k"
                ],
                [
                    "FAST_FORWARD",
                    "\u0130leri sar"
                ],
                [
                    "FULL_SCREEN",
                    "Tam ekran"
                ],
                [
                    "LANGUAGE",
                    "Dil"
                ],
                [
                    "LIVE",
                    "Canl\u0131"
                ],
                [
                    "LOOP",
                    "D\u00f6ng\u00fc"
                ],
                [
                    "MORE_SETTINGS",
                    "Daha fazla ayar"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Birden \u00e7ok dil"
                ],
                [
                    "MUTE",
                    "Sesi kapat"
                ],
                [
                    "NOT_APPLICABLE",
                    "Ge\u00e7erli de\u011fil"
                ],
                [
                    "OFF",
                    "Kapal\u0131"
                ],
                [
                    "ON",
                    "A\u00e7\u0131k"
                ],
                [
                    "PAUSE",
                    "Duraklat"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Pencere \u0130\u00e7inde Pencere"
                ],
                [
                    "PLAY",
                    "Oynat"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u00c7alma h\u0131z\u0131"
                ],
                [
                    "QUALITY",
                    "Kalite"
                ],
                [
                    "RECENTER_VR",
                    "Ortala"
                ],
                [
                    "REPLAY",
                    "Tekrar Oynat"
                ],
                [
                    "RESOLUTION",
                    "\u00c7\u00f6z\u00fcn\u00fcrl\u00fck"
                ],
                [
                    "REWIND",
                    "Geri sar"
                ],
                [
                    "SEEK",
                    "Ara"
                ],
                [
                    "SKIP_AD",
                    "Reklam\u0131 Atla"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Canl\u0131 yay\u0131na atla"
                ],
                [
                    "STATISTICS",
                    "\u0130statistikler"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Zorunlu"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Stereoskopik modu a\u00e7/kapat"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Belirsiz"
                ],
                [
                    "UNMUTE",
                    "Sesi a\u00e7"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Tan\u0131nmayan"
                ],
                [
                    "VOLUME",
                    "Ses"
                ]
            ]));
            a.Ya("zh", new Map([
                [
                    "AD_DURATION",
                    "\u5e7f\u544a\u6301\u7eed\u65f6\u95f4"
                ],
                [
                    "AD_PROGRESS",
                    "\u5e7f\u544a [AD_ON]/[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u5e7f\u544a\u7edf\u8ba1\u4fe1\u606f"
                ],
                [
                    "AD_TIME",
                    "\u5e7f\u544a\uff1a[AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u81ea\u52a8"
                ],
                [
                    "BACK",
                    "\u8fd4\u56de"
                ],
                [
                    "CAPTIONS",
                    "\u5b57\u5e55"
                ],
                [
                    "CAST",
                    "\u6295\u653e\u2026"
                ],
                [
                    "CHAPTERS",
                    "\u7ae0\u8282"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u4fdd\u5b58\u89c6\u9891\u5e27"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u5faa\u73af\u64ad\u653e\u5f53\u524d\u89c6\u9891"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u8fdb\u5165\u201c\u753b\u4e2d\u753b\u201d\u6a21\u5f0f"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u9000\u51fa\u5168\u5c4f\u6a21\u5f0f"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u505c\u6b62\u5faa\u73af\u64ad\u653e\u5f53\u524d\u89c6\u9891"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u9000\u51fa\u201c\u753b\u4e2d\u753b\u201d\u6a21\u5f0f"
                ],
                [
                    "FAST_FORWARD",
                    "\u5feb\u8fdb"
                ],
                [
                    "FULL_SCREEN",
                    "\u5168\u5c4f"
                ],
                [
                    "LANGUAGE",
                    "\u8bed\u8a00"
                ],
                [
                    "LIVE",
                    "\u76f4\u64ad"
                ],
                [
                    "LOOP",
                    "\u5faa\u73af\u64ad\u653e"
                ],
                [
                    "MORE_SETTINGS",
                    "\u66f4\u591a\u8bbe\u7f6e"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u591a\u79cd\u8bed\u8a00"
                ],
                [
                    "MUTE",
                    "\u9759\u97f3"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u4e0d\u9002\u7528"
                ],
                [
                    "OFF",
                    "\u5173\u95ed"
                ],
                [
                    "ON",
                    "\u5f00\u542f"
                ],
                [
                    "PAUSE",
                    "\u6682\u505c"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u753b\u4e2d\u753b"
                ],
                [
                    "PLAY",
                    "\u64ad\u653e"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u64ad\u653e\u901f\u5ea6"
                ],
                [
                    "QUALITY",
                    "\u753b\u8d28"
                ],
                [
                    "RECENTER_VR",
                    "\u91cd\u65b0\u7f6e\u4e2d"
                ],
                [
                    "REPLAY",
                    "\u91cd\u653e"
                ],
                [
                    "RESOLUTION",
                    "\u5206\u8fa8\u7387"
                ],
                [
                    "REWIND",
                    "\u5feb\u9000"
                ],
                [
                    "SEEK",
                    "\u8fdb\u5ea6"
                ],
                [
                    "SKIP_AD",
                    "\u8df3\u8fc7\u5e7f\u544a"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u8df3\u81f3\u5f53\u524d\u76f4\u64ad"
                ],
                [
                    "STATISTICS",
                    "\u7edf\u8ba1\u4fe1\u606f"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u5df2\u5f3a\u5236\u663e\u793a"
                ],
                [
                    "SURROUND",
                    "\u73af\u7ed5\u58f0"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u5207\u6362\u7acb\u4f53\u58f0"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u672a\u786e\u5b9a"
                ],
                [
                    "UNMUTE",
                    "\u53d6\u6d88\u9759\u97f3"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u65e0\u6cd5\u8bc6\u522b"
                ],
                [
                    "VOLUME",
                    "\u97f3\u91cf"
                ]
            ]));
            a.Ya("zh-TW", new Map([
                [
                    "AD_DURATION",
                    "\u5ee3\u544a\u9577\u5ea6"
                ],
                [
                    "AD_PROGRESS",
                    "\u5ee3\u544a [AD_ON]/[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u5ee3\u544a\u7d71\u8a08\u8cc7\u6599"
                ],
                [
                    "AD_TIME",
                    "\u5ee3\u544a\uff1a[AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u81ea\u52d5"
                ],
                [
                    "BACK",
                    "\u8fd4\u56de"
                ],
                [
                    "CAPTIONS",
                    "\u5b57\u5e55"
                ],
                [
                    "CAST",
                    "\u6295\u653e..."
                ],
                [
                    "CHAPTERS",
                    "\u7ae0\u7bc0"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u5132\u5b58\u5f71\u7247\u5f71\u683c"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u5faa\u74b0\u64ad\u653e\u76ee\u524d\u7684\u5f71\u7247"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u9032\u5165\u5b50\u6bcd\u756b\u9762"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u9000\u51fa\u5168\u87a2\u5e55\u6a21\u5f0f"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u505c\u6b62\u5faa\u74b0\u64ad\u653e\u76ee\u524d\u7684\u5f71\u7247"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u96e2\u958b\u5b50\u6bcd\u756b\u9762"
                ],
                [
                    "FAST_FORWARD",
                    "\u5feb\u8f49"
                ],
                [
                    "FULL_SCREEN",
                    "\u5168\u87a2\u5e55"
                ],
                [
                    "LANGUAGE",
                    "\u8a9e\u8a00"
                ],
                [
                    "LIVE",
                    "\u76f4\u64ad"
                ],
                [
                    "LOOP",
                    "\u5faa\u74b0\u64ad\u653e"
                ],
                [
                    "MORE_SETTINGS",
                    "\u986f\u793a\u66f4\u591a\u8a2d\u5b9a"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u591a\u7a2e\u8a9e\u8a00"
                ],
                [
                    "MUTE",
                    "\u975c\u97f3"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u4e0d\u9069\u7528"
                ],
                [
                    "OFF",
                    "\u95dc\u9589"
                ],
                [
                    "ON",
                    "\u958b\u555f"
                ],
                [
                    "PAUSE",
                    "\u66ab\u505c"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u5b50\u6bcd\u756b\u9762"
                ],
                [
                    "PLAY",
                    "\u64ad\u653e"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u64ad\u653e\u901f\u5ea6"
                ],
                [
                    "QUALITY",
                    "\u97f3\u8cea"
                ],
                [
                    "RECENTER_VR",
                    "\u91cd\u65b0\u7f6e\u4e2d"
                ],
                [
                    "REPLAY",
                    "\u91cd\u64ad"
                ],
                [
                    "RESOLUTION",
                    "\u89e3\u6790\u5ea6"
                ],
                [
                    "REWIND",
                    "\u5012\u8f49"
                ],
                [
                    "SEEK",
                    "\u641c\u5c0b"
                ],
                [
                    "SKIP_AD",
                    "\u7565\u904e\u5ee3\u544a"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u8df3\u81f3\u5f53\u524d\u76f4\u64ad"
                ],
                [
                    "STATISTICS",
                    "\u7d71\u8a08\u8cc7\u6599"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u5f37\u5236\u986f\u793a"
                ],
                [
                    "SURROUND",
                    "\u74b0\u5834\u97f3\u6548"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u5207\u63db\u7acb\u9ad4\u5f71\u50cf"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u4e0d\u660e"
                ],
                [
                    "UNMUTE",
                    "\u53d6\u6d88\u975c\u97f3"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u7121\u6cd5\u8fa8\u8b58"
                ],
                [
                    "VOLUME",
                    "\u97f3\u91cf"
                ]
            ]));
            a.Pi(navigator.languages || []);
            return a;
        }
        O("shaka.ui.Controls", Y);
        Y.prototype.incrementRoll = Y.prototype.Bh;
        Y.prototype.incrementPitch = Y.prototype.Ah;
        Y.prototype.incrementYaw = Y.prototype.Ch;
        Y.prototype.toggleStereoscopicMode = Y.prototype.Yd;
        Y.prototype.setVRFieldOfView = Y.prototype.zm;
        Y.prototype.getVRFieldOfView = Y.prototype.wl;
        Y.prototype.getVRNorth = Y.prototype.xl;
        Y.prototype.isPlayingVR = Y.prototype.Sb;
        Y.prototype.canPlayVR = Y.prototype.Lg;
        Y.prototype.hideUI = Y.prototype.fj;
        Y.prototype.showUI = Y.prototype.Bm;
        Y.prototype.isOpaque = Y.prototype.Ca;
        Y.prototype.hideAdUI = Y.prototype.ej;
        Y.prototype.showAdUI = Y.prototype.Uj;
        Y.prototype.togglePiP = Y.prototype.Yc;
        Y.prototype.isPiPEnabled = Y.prototype.Id;
        Y.prototype.isPiPAllowed = Y.prototype.Gf;
        Y.prototype.toggleFullScreen = Y.prototype.pg;
        Y.prototype.isFullScreenEnabled = Y.prototype.Jb;
        Y.prototype.isFullScreenSupported = Y.prototype.ue;
        Y.prototype.hideSettingsMenus = Y.prototype.Sc;
        Y.prototype.anySettingsMenusAreOpen = Y.prototype.Jc;
        Y.prototype.setLastTouchEventTime = Y.prototype.Oj;
        Y.prototype.getDisplayTime = Y.prototype.qh;
        Y.prototype.isCastAllowed = Y.prototype.El;
        Y.prototype.setSeeking = Y.prototype.li;
        Y.prototype.isSeeking = Y.prototype.Jl;
        Y.prototype.getConfig = Y.prototype.Kk;
        Y.prototype.getClientSideAdContainer = Y.prototype.Jk;
        Y.prototype.getServerSideAdContainer = Y.prototype.kl;
        Y.prototype.getControlsContainer = Y.prototype.Nk;
        Y.prototype.getLocalPlayer = Y.prototype.Vk;
        Y.prototype.getPlayer = Y.prototype.Rb;
        Y.prototype.getLocalVideo = Y.prototype.Wk;
        Y.prototype.getVideo = Y.prototype.Rc;
        Y.prototype.getVideoContainer = Y.prototype.zl;
        Y.prototype.getLocalization = Y.prototype.Xk;
        Y.prototype.getCastProxy = Y.prototype.Gk;
        Y.prototype.getAd = Y.prototype.getAd;
        Y.prototype.setEnabledNativeControls = Y.prototype.Nj;
        Y.prototype.setEnabledShakaControls = Y.prototype.ji;
        Y.prototype.configure = Y.prototype.configure;
        Y.prototype.loadComplete = Y.prototype.Ml;
        Y.prototype.allowCast = Y.prototype.qk;
        Y.registerSeekBar = function(a) {
            yJ = a;
        };
        Y.registerElement = gJ;
        Y.prototype.destroy = Y.prototype.destroy;
        var hJ = new Map, yJ = new pI;
        function GJ(a, b) {
            function c() {
                return HJ(d);
            }
            IH.call(this, a, b);
            var d = this;
            this.m = this.controls.g;
            this.l = this.controls.i;
            this.o = this.controls.l;
            this.j = [];
            IJ(this);
            this.g = U("div");
            this.g.classList.add("shaka-overflow-menu");
            this.g.classList.add("shaka-no-propagation");
            this.g.classList.add("shaka-show-controls-on-mouse-over");
            this.g.classList.add("shaka-hidden");
            this.l.appendChild(this.g);
            JJ(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                KJ(d);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                KJ(d);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                d.ad && d.ad.isLinear() && OH(d.h, !1);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                OH(d.h, !0);
            });
            this.eventManager.u(this.controls, "submenuopen", function() {
                OH(d.g, !1);
            });
            this.eventManager.u(this.g, "touchstart", function(e) {
                d.controls.Oj(Date.now());
                e.stopPropagation();
            });
            this.eventManager.u(this.h, "click", function() {
                d.controls.Ca() && LJ(d);
            });
            KJ(this);
            this.ad && this.ad.isLinear() && OH(this.h, !1);
            this.i = null;
            window1.ResizeObserver ? (this.i = new ResizeObserver(c), this.i.observe(this.controls.l)) : this.eventManager.u(window1, "resize", c);
        }
        oa(GJ, IH);
        GJ.prototype.release = function() {
            this.l = null;
            for(var a = u(this.j), b = a.next(); !b.done; b = a.next())b.value.release();
            this.j = [];
            this.i && (this.i.disconnect(), this.i = null);
            IH.prototype.release.call(this);
        };
        function MJ(a, b) {
            NJ.set(a, b);
        }
        function IJ(a) {
            a.h = ck();
            a.h.classList.add("shaka-overflow-menu-button");
            a.h.classList.add("shaka-no-propagation");
            a.h.classList.add("shaka-tooltip");
            new JH(a.h).use("M433-80q-27 0-46.5-18T363-142l-9-66q-13-5-24.5-12T307-235l-62 26q-25 11-50 2t-39-32l-47-82q-14-23-8-49t27-43l53-40q-1-7-1-13.5v-27q0-6.5 1-13.5l-53-40q-21-17-27-43t8-49l47-82q14-23 39-32t50 2l62 26q11-8 23-15t24-12l9-66q4-26 23.5-44t46.5-18h94q27 0 46.5 18t23.5 44l9 66q13 5 24.5 12t22.5 15l62-26q25-11 50-2t39 32l47 82q14 23 8 49t-27 43l-53 40q1 7 1 13.5v27q0 6.5-2 13.5l53 40q21 17 27 43t-8 49l-48 82q-14 23-39 32t-50-2l-60-26q-11 8-23 15t-24 12l-9 66q-4 26-23.5 44T527-80h-94Zm49-260q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Z");
            var b = U("span");
            b.classList.add("shaka-overflow-quality-mark");
            b.style.display = "none";
            a.h.appendChild(b);
            a.parent.appendChild(a.h);
        }
        function JJ(a) {
            for(var b = u(a.m.overflowMenuButtons), c = b.next(); !c.done; c = b.next())c = c.value, NJ.get(c) ? (c = NJ.get(c), a.j.push(c.create(a.g, a.controls))) : Za("Unrecognized overflow menu element requested:", c);
        }
        function LJ(a) {
            if (a.controls.Jc()) a.controls.Sc();
            else {
                OH(a.g, !0);
                WI(a.controls);
                var b = function(c) {
                    return c.classList.contains("shaka-hidden") == 0;
                };
                ib(a.g.childNodes, b) && jb(a.g.childNodes, b)[0].focus();
                HJ(a);
            }
        }
        function KJ(a) {
            a.h.ariaLabel = a.localization.resolve("MORE_SETTINGS");
        }
        function HJ(a) {
            var b = a.g.getBoundingClientRect(), c = window1.getComputedStyle(a.g), d = parseFloat(c.paddingTop);
            c = parseFloat(c.paddingBottom);
            var e = a.o.getBoundingClientRect();
            a.g.style.maxHeight = b.bottom - e.top - d - c - 5 + "px";
        }
        O("shaka.ui.OverflowMenu", GJ);
        GJ.registerElement = MJ;
        function OJ() {}
        OJ.prototype.create = function(a, b) {
            return new GJ(a, b);
        };
        gJ("overflow_menu", new OJ);
        var NJ = new Map;
        function PJ(a, b) {
            function c(e) {
                return d.i[e];
            }
            IH.call(this, a, b);
            var d = this;
            this.h = ck();
            this.h.classList.add("shaka-ad-statistics-button");
            this.o = new JH(this.h, "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.A = U("span");
            a.appendChild(this.A);
            this.l = U("span");
            this.l.classList.add("shaka-current-selection-span");
            a.appendChild(this.l);
            this.h.appendChild(a);
            this.parent.appendChild(this.h);
            this.g = U("div");
            this.g.classList.add("shaka-no-propagation");
            this.g.classList.add("shaka-show-controls-on-mouse-over");
            this.g.classList.add("shaka-ad-statistics-container");
            this.g.classList.add("shaka-hidden");
            this.controls.i.appendChild(this.g);
            this.D = [];
            this.i = this.adManager.getStats();
            OH(this.h, this.i.started > 0);
            this.m = new Map;
            this.C = (new Map).set("loadTimes", function(e) {
                var f = 0;
                e = u(d.i[e]);
                for(var g = e.next(); !g.done; g = e.next())f += parseFloat(g.value);
                return f;
            }).set("averageLoadTime", c).set("started", c).set("overlayAds", c).set("playedCompletely", c).set("skipped", c).set("errors", c);
            this.j = new Uf(function() {
                d.i = d.adManager.getStats();
                for(var e = u(d.D), f = e.next(); !f.done; f = e.next())f = f.value, d.m.get(f).textContent = d.C.get(f)(f);
            });
            QJ(this);
            RJ(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                QJ(d);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                QJ(d);
            });
            this.eventManager.u(this.h, "click", function() {
                d.controls.Ca() && (SJ(d), QJ(d));
            });
            this.eventManager.u(this.player, "loading", function() {
                OH(d.h, !1);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                OH(d.h, !0);
            });
        }
        oa(PJ, IH);
        function SJ(a) {
            a.g.classList.contains("shaka-hidden") ? (a.o.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm120-440q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.xa(.1), OH(a.g, !0)) : (a.o.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.stop(), OH(a.g, !1));
        }
        function QJ(a) {
            a.A.textContent = a.localization.resolve("AD_STATISTICS");
            a.h.ariaLabel = a.localization.resolve("AD_STATISTICS");
            a.l.textContent = a.localization.resolve(a.g.classList.contains("shaka-hidden") ? "OFF" : "ON");
        }
        function TJ(a, b) {
            var c = U("div"), d = U("label");
            d.textContent = b + ":";
            c.appendChild(d);
            d = U("span");
            d.textContent = a.C.get(b)(b);
            c.appendChild(d);
            a.m.set(b, d);
            return c;
        }
        function RJ(a) {
            var b = U("div");
            b.classList.add("shaka-no-propagation");
            b.classList.add("shaka-statistics-close");
            var c = new JH(b, "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z").g;
            c.classList.add("material-icons", "notranslate");
            a.g.appendChild(b);
            a.eventManager.u(c, "click", function() {
                SJ(a);
            });
            b = u(a.controls.g.adStatisticsList);
            for(c = b.next(); !c.done; c = b.next())c = c.value, c in a.i ? (a.g.appendChild(TJ(a, c)), a.D.push(c)) : Za("Unrecognized ad statistic element:", c);
        }
        PJ.prototype.release = function() {
            this.j.stop();
            this.j = null;
            IH.prototype.release.call(this);
        };
        O("shaka.ui.AdStatisticsButton", PJ);
        function UJ() {}
        UJ.prototype.create = function(a, b) {
            return new PJ(a, b);
        };
        MJ("ad_statistics", new UJ);
        TH("ad_statistics", new UJ);
        function VJ(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-airplay-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            new JH(this.g).use("M80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200h-80q-17 0-28.5-11.5T680-240q0-17 11.5-28.5T720-280h80v-480H160v480h80q17 0 28.5 11.5T280-240q0 17-11.5 28.5T240-200h-80q-33 0-56.5-23.5T80-280Zm232 160q-14 0-22-9.5t-8-20.5q0-5 2-10.5t7-10.5l161-161q6-6 13-9t15-3q8 0 15 3t13 9l161 161q5 5 7 10.5t2 10.5q0 11-8 20.5t-22 9.5H312Zm168-360Z");
            window1.WebKitPlaybackTargetAvailabilityEvent || this.g.classList.add("shaka-hidden");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.i = U("span");
            a.appendChild(this.i);
            this.h = U("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            WJ(this);
            XJ(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                WJ(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                WJ(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && c.controls.Rc().webkitShowPlaybackTargetPicker();
            });
            a = this.controls.Rc();
            this.eventManager.u(a, "webkitplaybacktargetavailabilitychanged", function(d) {
                var e = c.player.xc() == fs;
                OH(c.g, d.availability == "available" && e);
            });
            this.eventManager.u(a, "webkitcurrentplaybacktargetiswirelesschanged", function() {
                XJ(c);
            });
        }
        oa(VJ, IH);
        function XJ(a) {
            var b = a.controls.Rc();
            a.g.ariaPressed = b && b.webkitCurrentPlaybackTargetIsWireless ? "true" : "false";
        }
        function WJ(a) {
            a.g.ariaLabel = a.localization.resolve("AIRPLAY");
            a.i.textContent = a.localization.resolve("AIRPLAY");
        }
        O("shaka.ui.AirPlayButton", VJ);
        function YJ() {}
        YJ.prototype.create = function(a, b) {
            return new VJ(a, b);
        };
        MJ("airplay", new YJ);
        gJ("airplay", new YJ);
        function ZJ(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = document.createElement("canvas");
            this.g.style.position = "absolute";
            this.g.style.top = "0";
            this.g.style.left = "0";
            this.g.style.pointerEvents = "none";
            this.parent.appendChild(this.g);
            $J(this);
            this.i = this.h = null;
            window1.ResizeObserver ? (this.i = new ResizeObserver(function() {
                return $J(c);
            }), this.i.observe(this.parent)) : window1.addEventListener("resize", function() {
                return $J(c);
            });
        }
        oa(ZJ, IH);
        function aK(a) {
            return (a = a.g.getContext("2d")) ? a : null;
        }
        function $J(a) {
            a.g.width = a.parent.offsetWidth;
            a.g.height = a.parent.offsetHeight;
        }
        ZJ.prototype.jg = function(a, b) {
            a = {
                type: "static",
                text: a,
                position: "top-right",
                color: "rgba(255, 255, 255, 0.7)",
                size: 20,
                alpha: .7,
                interval: 2E3,
                skip: 500,
                displayDuration: 2E3,
                transitionDuration: .5
            };
            b = Object.assign({}, a, b || a);
            if (b.type === "static") {
                if (a = aK(this)) {
                    a.clearRect(0, 0, this.g.width, this.g.height);
                    a.globalAlpha = b.alpha;
                    a.fillStyle = b.color;
                    a.font = b.size + "px Arial";
                    var c = a.measureText(b.text);
                    switch(b.position){
                        case "top-left":
                            c = 20;
                            var d = b.size + 20;
                            break;
                        case "top-right":
                            c = this.g.width - c.width - 20;
                            d = b.size + 20;
                            break;
                        case "bottom-left":
                            c = 20;
                            d = this.g.height - 20;
                            break;
                        case "bottom-right":
                            c = this.g.width - c.width - 20;
                            d = this.g.height - 20;
                            break;
                        default:
                            c = (this.g.width - c.width) / 2, d = (this.g.height + b.size) / 2;
                    }
                    a.fillText(b.text, c, d);
                }
            } else b.type === "dynamic" && bK(this, b);
        };
        function bK(a, b) {
            function c() {
                if (a.h) {
                    e.clearRect(0, 0, a.g.width, a.g.height);
                    switch(h){
                        case "fadeIn":
                            g = Math.min(b.alpha, g + l);
                            g >= b.alpha && (h = "display");
                            break;
                        case "display":
                            --k <= 0 && (h = "fadeOut");
                            break;
                        case "fadeOut":
                            g = Math.max(0, g - l), g <= 0 && (h = "transition", f = d(), k = Math.round(b.displayDuration * 60), h = "fadeIn");
                    }
                    g > 0 && (e.globalAlpha = g, e.fillStyle = b.color, e.font = b.size + "px Arial", e.fillText(b.text, f.left, f.top));
                    a.h && (a.h = requestAnimationFrame(c));
                }
            }
            function d() {
                e.font = b.size + "px Arial";
                var n = e.measureText(b.text).width, q = b.size;
                n = [
                    {
                        left: 20,
                        top: q + 20
                    },
                    {
                        left: a.g.width - n - 20,
                        top: q + 20
                    },
                    {
                        left: 20,
                        top: a.g.height - 20
                    },
                    {
                        left: a.g.width - n - 20,
                        top: a.g.height - 20
                    },
                    {
                        left: (a.g.width - n) / 2,
                        top: (a.g.height + q) / 2
                    }
                ];
                q = n[m];
                m = (m + 1) % n.length;
                return q;
            }
            var e = a.g.getContext("2d"), f = {
                left: 0,
                top: 0
            }, g = 0, h = "fadeIn", k = Math.round(b.displayDuration * 60), l = 1 / (Math.round(b.transitionDuration * 60) / 2), m = 0;
            f = d();
            a.h = requestAnimationFrame(c);
        }
        ZJ.prototype.$f = function() {
            this.h && (cancelAnimationFrame(this.h), this.h = null);
            var a = aK(this);
            a && a.clearRect(0, 0, this.g.width, this.g.height);
        };
        ZJ.prototype.release = function() {
            var a = this;
            this.g && this.g.parentNode && this.g.parentNode.removeChild(this.g);
            this.i ? (this.i.disconnect(), this.i = null) : window1.removeEventListener("resize", function() {
                return $J(a);
            });
            IH.prototype.release.call(this);
        };
        O("shaka.ui.Watermark", ZJ);
        ZJ.prototype.removeWatermark = ZJ.prototype.$f;
        ZJ.prototype.setTextWatermark = ZJ.prototype.jg;
        function cK(a, b, c, d) {
            d = d === void 0 ? null : d;
            this.j = a;
            this.l = b;
            this.h = dK(this);
            var e = "", f = !1;
            b.dataset && b.dataset.shakaPlayerCastReceiverId ? (f = b.dataset, e = f.shakaPlayerCastReceiverId, f = f.shakaPlayerCastAndroidReceiverCompatible === "true") : c.dataset && c.dataset.shakaPlayerCastReceiverId && (f = c.dataset, e = f.shakaPlayerCastReceiverId, f = f.shakaPlayerCastAndroidReceiverCompatible === "true");
            e.length && (this.h.castReceiverAppId = e, this.h.castAndroidReceiverCompatible = f);
            b.dataset.shakaPlayerContainer = "";
            b.ui = this;
            this.Ih() && b.classList.add("shaka-mobile");
            this.g = new Y(a, b, c, d, this.h);
            c.controls || a.mi(b);
            b.ui = this;
            c.ui = this;
            this.i = null;
        }
        p = cK.prototype;
        p.destroy = function(a) {
            a = a === void 0 ? !1 : a;
            var b = this;
            return H(function(c) {
                if (c.h == 1) return b.g ? c.g(b.g.destroy(a), 2) : c.B(2);
                if (c.h != 4) return b.g = null, b.j ? c.g(b.j.destroy(), 4) : c.B(4);
                b.j = null;
                b.i = null;
                c.j();
            });
        };
        p.Ih = function() {
            return Xb().Pa() == "MOBILE";
        };
        p.Kh = function() {
            return Xb().Pa() == "TV";
        };
        p.getConfiguration = function() {
            var a = dK(this);
            bo(a, this.h, dK(this), {}, "");
            return a;
        };
        p.configure = function(a, b) {
            arguments.length == 2 && typeof a == "string" && (a = co(a, b));
            var c = Object.assign({}, this.h);
            bo(c, a, dK(this), {}, "");
            var d = fo(c, this.h);
            if (Object.keys(d).length && (this.h = c, this.g.configure(this.h), this.g.dispatchEvent(new R("uiupdated")), (c = this.h.castSenderUrl) && this.h.castReceiverAppId && window1.chrome && !chrome.cast && !this.Kh())) {
                d = !1;
                for(var e = u(document.getElementsByTagName("script")), f = e.next(); !f.done; f = e.next())if (f.value.src === c) {
                    d = !0;
                    break;
                }
                d || (d = document.createElement("script"), d.src = c, d.defer = !0, document.head.appendChild(d));
            }
        };
        p.Mk = function() {
            return this.g;
        };
        p.xm = function(a) {
            this.g.ji(a);
        };
        p.jg = function(a, b) {
            a && !this.i && this.l && this.g && (this.i = new ZJ(this.l, this.g));
            this.i && this.i.jg(a, b);
        };
        p.$f = function() {
            this.i && this.i.$f();
        };
        function dK(a) {
            var b = "play_pause skip_previous skip_next mute_volume time_and_duration spacer overflow_menu".split(" ");
            window1.chrome && b.push("cast");
            "remote" in HTMLMediaElement.prototype ? b.push("remote") : window1.WebKitPlaybackTargetAvailabilityEvent && b.push("airplay");
            b.push("fullscreen");
            b = {
                controlPanelElements: b,
                overflowMenuButtons: "captions quality language chapter picture_in_picture playback_rate recenter_vr toggle_stereoscopic".split(" "),
                statisticsList: "width height currentCodecs corruptedFrames decodedFrames droppedFrames drmTimeSeconds licenseTime liveLatency loadLatency bufferingTime manifestTimeSeconds estimatedBandwidth streamBandwidth maxSegmentDuration pauseTime playTime completionPercent manifestSizeBytes bytesDownloaded nonFatalErrorCount manifestPeriodCount manifestGapCount".split(" "),
                adStatisticsList: "loadTimes averageLoadTime started overlayAds playedCompletely skipped errors".split(" "),
                contextMenuElements: [
                    "loop",
                    "picture_in_picture",
                    "save_video_frame",
                    "statistics",
                    "ad_statistics"
                ],
                playbackRates: [
                    .5,
                    .75,
                    1,
                    1.25,
                    1.5,
                    1.75,
                    2
                ],
                fastForwardRates: [
                    2,
                    4,
                    8,
                    1
                ],
                rewindRates: [
                    -1,
                    -2,
                    -4,
                    -8
                ],
                addSeekBar: !0,
                addBigPlayButton: !1,
                customContextMenu: !1,
                castReceiverAppId: "",
                castAndroidReceiverCompatible: !1,
                clearBufferOnQualityChange: !0,
                showUnbufferedStart: !1,
                seekBarColors: {
                    base: "rgba(255, 255, 255, 0.3)",
                    buffered: "rgba(255, 255, 255, 0.54)",
                    played: "rgb(255, 255, 255)",
                    adBreaks: "rgb(255, 204, 0)"
                },
                volumeBarColors: {
                    base: "rgba(255, 255, 255, 0.54)",
                    level: "rgb(255, 255, 255)"
                },
                qualityMarks: {
                    720: "",
                    1080: "HD",
                    1440: "2K",
                    2160: "4K",
                    4320: "8K"
                },
                trackLabelFormat: eK,
                textTrackLabelFormat: eK,
                fadeDelay: 0,
                closeMenusDelay: 2,
                doubleClickForFullscreen: !0,
                singleClickForPlayAndPause: !0,
                enableKeyboardPlaybackControls: !0,
                enableFullscreenOnRotation: !1,
                forceLandscapeOnFullscreen: !1,
                enableTooltips: !0,
                keyboardSeekDistance: 5,
                keyboardLargeSeekDistance: 60,
                fullScreenElement: a.l,
                preferDocumentPictureInPicture: !0,
                showAudioChannelCountVariants: !0,
                seekOnTaps: !1,
                tapSeekDistance: 10,
                refreshTickInSeconds: .125,
                displayInVrMode: !1,
                defaultVrProjectionMode: "equirectangular",
                setupMediaSession: !0,
                preferVideoFullScreenInVisionOS: !0,
                showAudioCodec: !0,
                showVideoCodec: !0,
                castSenderUrl: "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js",
                enableKeyboardPlaybackControlsInWindow: !1,
                alwaysShowVolumeBar: !1
            };
            if (a.Ih()) {
                b.addBigPlayButton = !0;
                b.singleClickForPlayAndPause = !1;
                b.seekOnTaps = !0;
                b.enableTooltips = !1;
                b.doubleClickForFullscreen = !1;
                a = Xb();
                b.enableFullscreenOnRotation = a.Ma() !== "WEBKIT";
                b.forceLandscapeOnFullscreen = !0;
                var c = [
                    "play_pause",
                    "skip_previous",
                    "skip_next",
                    "volume"
                ];
                b.controlPanelElements = b.controlPanelElements.filter(function(e) {
                    return !c.includes(e);
                });
                b.overflowMenuButtons = b.overflowMenuButtons.filter(function(e) {
                    return !c.includes(e);
                });
                b.contextMenuElements = b.contextMenuElements.filter(function(e) {
                    return !c.includes(e);
                });
            } else if (a.Kh()) {
                b.addBigPlayButton = !0;
                b.singleClickForPlayAndPause = !1;
                b.enableTooltips = !1;
                b.doubleClickForFullscreen = !1;
                var d = "play_pause cast remote airplay volume save_video_frame".split(" ");
                b.controlPanelElements = b.controlPanelElements.filter(function(e) {
                    return !d.includes(e);
                });
                b.overflowMenuButtons = b.overflowMenuButtons.filter(function(e) {
                    return !d.includes(e);
                });
                b.contextMenuElements = b.contextMenuElements.filter(function(e) {
                    return !d.includes(e);
                });
            }
            return b;
        }
        function fK() {
            var a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E;
            return H(function(C) {
                switch(C.h){
                    case 1:
                        ND();
                        if (!Cr()) return gK("shaka-ui-load-failed", hK), C.return();
                        a = document.querySelectorAll("[data-shaka-player-container]");
                        b = document.querySelectorAll("[data-shaka-player]");
                        c = document.querySelectorAll("[data-shaka-player-canvas]");
                        d = document.querySelectorAll("[data-shaka-player-vr-canvas]");
                        if (!b.length && !a.length) {
                            C.B(2);
                            break;
                        }
                        if (b.length && !a.length) {
                            C.B(3);
                            break;
                        }
                        e = u(a);
                        f = e.next();
                    case 5:
                        if (f.done) {
                            C.B(2);
                            break;
                        }
                        g = f.value;
                        if (g.ui) {
                            C.B(6);
                            break;
                        }
                        h = null;
                        k = u(b);
                        for(l = k.next(); !l.done; l = k.next())if (m = l.value, m.parentElement == g) {
                            h = m;
                            break;
                        }
                        h || (h = document.createElement("video"), h.setAttribute("playsinline", ""), g.appendChild(h));
                        n = iK(g, c, d);
                        q = n.mj;
                        r = n.lk;
                        C.m(8);
                        return C.g(jK(g, h, q, r), 10);
                    case 10:
                        C.o(6);
                        break;
                    case 8:
                        return C.l(), gK("shaka-ui-load-failed", kK), C.return();
                    case 6:
                        f = e.next();
                        C.B(5);
                        break;
                    case 3:
                        t = u(b), v = t.next();
                    case 11:
                        if (v.done) {
                            C.B(2);
                            break;
                        }
                        w = v.value;
                        if (w.ui) {
                            C.B(12);
                            break;
                        }
                        x = document.createElement("div");
                        y = w.parentElement;
                        y.replaceChild(x, w);
                        x.appendChild(w);
                        z = iK(x, c, d);
                        A = z.mj;
                        E = z.lk;
                        C.m(14);
                        return C.g(jK(x, w, A, E), 16);
                    case 16:
                        C.o(12);
                        break;
                    case 14:
                        return C.l(), gK("shaka-ui-load-failed", kK), C.return();
                    case 12:
                        v = t.next();
                        C.B(11);
                        break;
                    case 2:
                        gK("shaka-ui-loaded"), C.j();
                }
            });
        }
        function gK(a, b) {
            var c = null;
            b != void 0 && (c = {
                reasonCode: b
            });
            a = new CustomEvent(a, {
                detail: c
            });
            document.dispatchEvent(a);
        }
        function jK(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r;
            return H(function(t) {
                switch(t.h){
                    case 1:
                        e = new W;
                        f = [];
                        if (g = b.getAttribute("src")) f.push(g), b.removeAttribute("src");
                        h = u(b.getElementsByTagName("source"));
                        for(k = h.next(); !k.done; k = h.next())l = k.value, f.push(l.src), b.removeChild(l);
                        return t.g(e.Ob(b), 2);
                    case 2:
                        e.Ji(c), m = new cK(e, a, b, d ? d : null), b.controls && m.g.Nj(!0), n = u(f), q = n.next();
                    case 3:
                        if (q.done) {
                            t.B(0);
                            break;
                        }
                        r = q.value;
                        t.m(6);
                        return t.g(m.g.Rb().load(r), 8);
                    case 8:
                        t.B(0);
                        break;
                    case 6:
                        t.l();
                    case 4:
                        q = n.next(), t.B(3);
                }
            });
        }
        function iK(a, b, c) {
            var d = null;
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next())if (e = e.value, e.parentElement == a) {
                d = e;
                break;
            }
            d || (d = document.createElement("canvas"), d.classList.add("shaka-canvas-container"), a.appendChild(d));
            b = null;
            c = u(c);
            for(e = c.next(); !e.done; e = c.next())if (e = e.value, e.parentElement == a) {
                b = e;
                break;
            }
            return {
                mj: d,
                lk: b
            };
        }
        O("shaka.ui.Overlay", cK);
        cK.prototype.removeWatermark = cK.prototype.$f;
        cK.prototype.setTextWatermark = cK.prototype.jg;
        cK.prototype.setEnabled = cK.prototype.xm;
        cK.prototype.getControls = cK.prototype.Mk;
        cK.prototype.configure = cK.prototype.configure;
        cK.prototype.getConfiguration = cK.prototype.getConfiguration;
        cK.prototype.isSmartTV = cK.prototype.Kh;
        cK.prototype.isMobile = cK.prototype.Ih;
        cK.prototype.destroy = cK.prototype.destroy;
        var eK = 0;
        cK.TrackLabelFormat = {
            LANGUAGE: eK,
            ROLE: 1,
            LANGUAGE_ROLE: 2,
            LABEL: 3
        };
        var hK = 0, kK = 1;
        cK.FailReasonCode = {
            NO_BROWSER_SUPPORT: hK,
            PLAYER_FAILED_TO_LOAD: kK
        };
        document.readyState == "complete" ? H(function(a) {
            if (a.h == 1) return a.g(Promise.resolve(), 2);
            fK();
            a.j();
        }) : window1.addEventListener("load", fK);
        function lK(a) {
            function b(d) {
                return {
                    codecs: d.codecs,
                    channelCount: d.channelCount,
                    language: d.language,
                    roles: d.roles,
                    spatialAudio: d.spatialAudio
                };
            }
            var c = b(a[0]);
            return a.every(function(d) {
                return JSON.stringify(b(d)) === JSON.stringify(c);
            });
        }
        function mK(a, b, c, d, e, f, g, h) {
            function k(F) {
                var I = "";
                F == "aac" ? I = "AAC" : F === "ac-3" ? I = "Dolby" : F === "ec-3" ? I = "DD+" : F === "ac-4" ? I = "Dolby AC-4" : F === "opus" ? I = "Opus" : F === "flac" && (I = "fLaC");
                return I ? " " + I : I;
            }
            function l(F) {
                var I = "";
                F >= 5 && (I = " " + e.resolve("SURROUND"));
                return I;
            }
            function m(F, I, K, N, P, M) {
                I = [
                    F,
                    I,
                    M
                ];
                g && N != null && I.push(N);
                h && n(F) && P && I.push(P);
                K && f == 3 && I.push(K);
                return I.join(": ");
            }
            function n(F) {
                return r.has(F) && r.get(F).size > 1;
            }
            var q = a.find(function(F) {
                return F.active == 1;
            });
            a.length > 1 && a[0].label && f != 3 && lK(a) && (f = 3);
            for(var r = new Map, t = u(a), v = t.next(); !v.done; v = t.next())v = v.value, v.codecs && (r.has(v.language) || r.set(v.language, new Set), r.get(v.language).add(Cf(v.codecs)));
            t = KH(b);
            gk(b);
            b.appendChild(t);
            t = new Set;
            q = q ? m(q.language, q.roles.join(", "), q.label, q.channelsCount, q.codecs && Cf(q.codecs), q.spatialAudio) : "";
            a = u(a);
            var w = a.next();
            for(v = {}; !w.done; v = {
                Xb: void 0
            }, w = a.next()){
                v.Xb = w.value;
                w = v.Xb.language;
                var x = v.Xb.roles.join(", "), y = v.Xb.label, z = v.Xb.channelsCount, A = v.Xb.codecs && Cf(v.Xb.codecs), E = v.Xb.spatialAudio, C = m(w, x, y, z, A, E);
                if (!t.has(C)) {
                    t.add(C);
                    var D = ck();
                    D.addEventListener("click", function(F) {
                        return function() {
                            c(F.Xb);
                        };
                    }(v));
                    var B = U("span");
                    D.appendChild(B);
                    B.textContent = nK(w, e);
                    var J = "";
                    h && g && E && (A == "ec-3" || A == "ac-4") ? J += " Dolby Atmos" : (h && n(w) && (J += k(A)), g && (J += l(z)));
                    switch(f){
                        case eK:
                            B.textContent += J;
                            break;
                        case 1:
                            B.textContent += J;
                            x ? B.textContent = x : (Za("Track #" + JSON.stringify(v.Xb) + " does not have a role, but the UI is configured to only show role."), B.textContent = "?");
                            break;
                        case 2:
                            B.textContent += J;
                            x && (B.textContent += ": " + x);
                            break;
                        case 3:
                            y ? B.textContent = y : (Za("Track #" + JSON.stringify(v.Xb) + " does not have a label, but the UI is configured to only show labels."), B.textContent = "?");
                    }
                    C == q && (D.appendChild(NH()), B.classList.add("shaka-chosen-item"), D.ariaSelected = "true", d.textContent = B.textContent);
                    b.appendChild(D);
                }
            }
        }
        function oK(a, b, c, d, e, f, g) {
            function h(z, A, E, C) {
                z = [
                    z,
                    A,
                    C
                ];
                E && g == 3 && z.push(E);
                return z.join(": ");
            }
            var k = a.find(function(z) {
                return z.active == 1;
            }), l = KH(b);
            gk(b);
            b.appendChild(l);
            l = new Set;
            k = k ? h(k.language, k.roles.join(", "), k.label, k.forced) : "";
            a = u(a);
            for(var m = a.next(), n = {}; !m.done; n = {
                Zc: void 0
            }, m = a.next()){
                n.Zc = m.value;
                m = n.Zc.language;
                var q = n.Zc.forced, r = f.resolve("SUBTITLE_FORCED"), t = n.Zc.roles.join(", "), v = n.Zc.label, w = h(m, t, v, q);
                if (!l.has(w)) {
                    l.add(w);
                    var x = ck();
                    x.addEventListener("click", function(z) {
                        return function() {
                            c(z.Zc);
                        };
                    }(n));
                    var y = U("span");
                    x.appendChild(y);
                    y.textContent = nK(m, f);
                    switch(g){
                        case eK:
                            q && (y.textContent += " (" + r + ")");
                            break;
                        case 1:
                            t ? y.textContent = t : (Za("Track #" + n.Zc.id + " does not have a role, but the UI is configured to only show role."), y.textContent = "?");
                            q && (y.textContent += " (" + r + ")");
                            break;
                        case 2:
                            t && (y.textContent += ": " + t);
                            q && (y.textContent += " (" + r + ")");
                            break;
                        case 3:
                            v ? y.textContent = v : (Za("Track #" + n.Zc.id + " does not have a label, but the UI is configured to only show labels."), y.textContent = "?");
                    }
                    d && w == k && (x.appendChild(NH()), y.classList.add("shaka-chosen-item"), x.ariaSelected = "true", e.textContent = y.textContent);
                    b.appendChild(x);
                }
            }
        }
        function nK(a, b) {
            if (!a && !b) return "";
            switch(a){
                case "mul":
                    return b.resolve("MULTIPLE_LANGUAGES");
                case "und":
                    return b.resolve("UNDETERMINED_LANGUAGE");
                case "zxx":
                    return b.resolve("NOT_APPLICABLE");
            }
            var c = Pc(a);
            return a in rp ? rp[a] : c in rp ? rp[c] + " (" + a + ")" : b.resolve("UNRECOGNIZED_LANGUAGE") + " (" + a + ")";
        }
        function pK(a, b, c) {
            function d() {
                return qK(e);
            }
            IH.call(this, a, b);
            var e = this;
            this.m = this.controls.l;
            rK(this, c);
            sK(this);
            tK(this);
            this.eventManager.u(this.button, "click", function() {
                e.controls.Ca() && (e.menu.classList.contains("shaka-hidden") ? (e.controls.dispatchEvent(new R("submenuopen")), OH(e.menu, !0), MH(e.menu), qK(e)) : OH(e.menu, !1));
            });
            this.j = null;
            window1.ResizeObserver ? (this.j = new ResizeObserver(d), this.j.observe(this.controls.l)) : this.eventManager.u(window1, "resize", d);
        }
        oa(pK, IH);
        pK.prototype.release = function() {
            this.j && (this.j.disconnect(), this.j = null);
            IH.prototype.release.call(this);
        };
        function rK(a, b) {
            a.button = ck();
            a.button.classList.add("shaka-overflow-button");
            a.icon = new JH(a.button, b);
            b = U("label");
            b.classList.add("shaka-overflow-button-label");
            b.classList.add("shaka-overflow-menu-only");
            b.classList.add("shaka-overflow-button-label-inline");
            a.nameSpan = U("span");
            b.appendChild(a.nameSpan);
            a.currentSelection = U("span");
            a.currentSelection.classList.add("shaka-current-selection-span");
            b.appendChild(a.currentSelection);
            a.button.appendChild(b);
            a.parent.appendChild(a.button);
        }
        function sK(a) {
            a.menu = U("div");
            a.menu.classList.add("shaka-no-propagation");
            a.menu.classList.add("shaka-show-controls-on-mouse-over");
            a.menu.classList.add("shaka-settings-menu");
            a.menu.classList.add("shaka-hidden");
            a.backButton = ck();
            a.backButton.classList.add("shaka-back-to-overflow-button");
            a.menu.appendChild(a.backButton);
            a.eventManager.u(a.backButton, "click", function() {
                a.controls.Sc();
            });
            a.o = new JH(a.backButton, "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z");
            a.backSpan = U("span");
            a.backButton.appendChild(a.backSpan);
            a.controls.i.appendChild(a.menu);
        }
        function tK(a) {
            a.parent.classList.contains("shaka-overflow-menu") && (a.o.use("m432-480 156 156q11 11 11 28t-11 28q-11 11-28 11t-28-11L348-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l184-184q11-11 28-11t28 11q11 11 11 28t-11 28L432-480Z"), a.eventManager.u(a.menu, "click", function() {
                function b(c) {
                    return c.classList.contains("shaka-hidden") == 0;
                }
                OH(a.menu, !1);
                OH(a.parent, !0);
                ib(a.parent.childNodes, b) && jb(a.parent.childNodes, b)[0].focus();
                WI(a.controls);
                qK(a);
            }));
        }
        function qK(a) {
            var b = a.menu.getBoundingClientRect(), c = window1.getComputedStyle(a.menu), d = parseFloat(c.paddingTop);
            c = parseFloat(c.paddingBottom);
            var e = a.m.getBoundingClientRect();
            a.menu.style.maxHeight = b.bottom - e.top - d - c - 5 + "px";
        }
        O("shaka.ui.SettingsMenu", pK);
        function uK(a, b) {
            pK.call(this, a, b, "M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z");
            var c = this;
            this.button.classList.add("shaka-language-button");
            this.button.classList.add("shaka-tooltip-status");
            this.menu.classList.add("shaka-audio-languages");
            this.eventManager.u(this.localization, "locale-updated", function() {
                vK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                vK(c);
            });
            this.eventManager.u(this.player, "loading", function() {
                wK(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                wK(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                wK(c);
            });
            this.eventManager.u(this.player, "audiotrackschanged", function() {
                wK(c);
            });
            vK(this);
            wK(this);
        }
        oa(uK, pK);
        function wK(a) {
            var b = a.player.getAudioTracks() || [];
            mK(b, a.menu, function(c) {
                a.player.Jj(c);
                var d = {
                    preferredAudioLanguage: c.language,
                    preferSpatialAudio: c.spatialAudio
                };
                c.label && (d.preferredAudioLabel = c.label);
                c.channelsCount && (d.preferredAudioChannelCount = c.channelsCount);
                a.player.configure(d);
            }, a.currentSelection, a.localization, a.controls.g.trackLabelFormat, a.controls.g.showAudioChannelCountVariants, a.controls.g.showAudioCodec);
            MH(a.menu);
            a.controls.dispatchEvent(new R("languageselectionupdated"));
            a.button.setAttribute("shaka-status", a.currentSelection.innerText);
            OH(a.button, a.menu.getElementsByTagName("button").length > 2);
        }
        function vK(a) {
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.button.ariaLabel = a.localization.resolve("LANGUAGE");
            a.nameSpan.textContent = a.localization.resolve("LANGUAGE");
            a.backSpan.textContent = a.localization.resolve("LANGUAGE");
        }
        O("shaka.ui.AudioLanguageSelection", uK);
        function xK() {}
        xK.prototype.create = function(a, b) {
            return new uK(a, b);
        };
        MJ("language", new xK);
        gJ("language", new xK);
        function yK(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.h = this.controls.F;
            this.g = ck();
            this.g.classList.add("shaka-cast-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            this.l = new JH(this.g, "M480-480Zm320 320H600q0-20-1.5-40t-4.5-40h206v-480H160v46q-20-3-40-4.5T80-680v-40q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160Zm-720 0v-120q50 0 85 35t35 85H80Zm200 0q0-83-58.5-141.5T80-360v-80q117 0 198.5 81.5T360-160h-80Zm160 0q0-75-28.5-140.5t-77-114q-48.5-48.5-114-77T80-520v-80q91 0 171 34.5T391-471q60 60 94.5 140T520-160h-80Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.j = U("span");
            a.appendChild(this.j);
            this.i = U("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            zK(this);
            AK(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                zK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                zK(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && BK(c);
            });
            this.eventManager.u(this.controls, "caststatuschanged", function() {
                AK(c);
            });
        }
        oa(yK, IH);
        function BK(a) {
            var b;
            H(function(c) {
                if (c.h == 1) {
                    if (a.h.Qa()) return a.h.Yj(), c.B(0);
                    c.m(3);
                    a.g.disabled = !0;
                    return c.g(a.h.cast(), 5);
                }
                if (c.h != 3) return a.g.disabled = !1, c.o(0);
                b = c.l();
                a.g.disabled = !1;
                b.code != 8004 && a.controls.dispatchEvent(new R("error", (new Map).set("detail", b)));
                c.j();
            });
        }
        function AK(a) {
            var b = a.h.Kg() && a.controls.va, c = a.h.Qa();
            OH(a.g, b);
            a.l.use(c ? "M720-600v240q0 17-11.5 28.5T680-320h-87q-8 0-14.5-4.5T569-337q-29-81-81.5-147T364-596q-16-10-11.5-27t21.5-17h306q17 0 28.5 11.5T720-600ZM320-160q-16 0-28-9.5T277-195q-11-63-56.5-107T112-357q-15-2-23.5-14.5T80-400q0-17 11-28.5t26-9.5q94 12 160.5 79T357-198q2 16-9 27t-28 11Zm160 0q-17 0-28.5-11T438-199q-14-128-104.5-217T115-518q-16-2-25.5-14T80-560q0-17 10.5-29t25.5-10q161 13 274 125.5T518-201q2 17-9.5 29T480-160Zm-340 0q-25 0-42.5-17.5T80-220q0-25 17.5-42.5T140-280q25 0 42.5 17.5T200-220q0 25-17.5 42.5T140-160Zm740-560v480q0 33-23.5 56.5T800-160H638q-17 0-28.5-11.5T598-200q0-17 11.5-28.5T638-240h162v-480H160v6q0 17-11.5 28.5T120-674q-17 0-28.5-11.5T80-714v-6q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720Z" : "M480-480Zm320 320H600q0-20-1.5-40t-4.5-40h206v-480H160v46q-20-3-40-4.5T80-680v-40q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160Zm-720 0v-120q50 0 85 35t35 85H80Zm200 0q0-83-58.5-141.5T80-360v-80q117 0 198.5 81.5T360-160h-80Zm160 0q0-75-28.5-140.5t-77-114q-48.5-48.5-114-77T80-520v-80q91 0 171 34.5T391-471q60 60 94.5 140T520-160h-80Z");
            b && (a.g.ariaPressed = c ? "true" : "false");
            CK(a);
        }
        function CK(a) {
            a.i.textContent = a.h.Qa() ? a.h.Yf() : a.localization.resolve("OFF");
        }
        function zK(a) {
            a.g.ariaLabel = a.localization.resolve("CAST");
            a.j.textContent = a.localization.resolve("CAST");
            CK(a);
        }
        O("shaka.ui.CastButton", yK);
        function DK() {}
        DK.prototype.create = function(a, b) {
            return new yK(a, b);
        };
        MJ("cast", new DK);
        gJ("cast", new DK);
        function EK(a, b) {
            pK.call(this, a, b, "m400-200-182 91q-20 10-39-1.5T160-145v-495q0-33 23.5-56.5T240-720h320q33 0 56.5 23.5T640-640v495q0 23-19 34.5t-39 1.5l-182-91Zm360-40q-17 0-28.5-11.5T720-280v-520H320q-17 0-28.5-11.5T280-840q0-17 11.5-28.5T320-880h400q33 0 56.5 23.5T800-800v520q0 17-11.5 28.5T760-240Z");
            var c = this;
            this.button.classList.add("shaka-chapter-button");
            this.menu.classList.add("shaka-chapters");
            this.button.classList.add("shaka-tooltip-status");
            this.g = [];
            this.h = "und";
            this.eventManager.u(this.localization, "locale-updated", function() {
                FK(c);
                GK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                FK(c);
                GK(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                HK(c);
                c.h = "und";
                c.g = [];
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                GK(c);
            });
            FK(this);
            GK(this);
        }
        oa(EK, pK);
        function FK(a) {
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.button.ariaLabel = a.localization.resolve("CHAPTERS");
            a.nameSpan.textContent = a.localization.resolve("CHAPTERS");
            a.backSpan.textContent = a.localization.resolve("CHAPTERS");
        }
        function HK(a) {
            var b = KH(a.menu);
            gk(a.menu);
            a.menu.appendChild(b);
            OH(a.button, !1);
        }
        function GK(a) {
            var b, c, d, e, f, g, h, k, l, m, n, q, r, t;
            H(function(v) {
                switch(v.h){
                    case 1:
                        b = function(w, x) {
                            return !w && !x || w.id === x.id && w.title === x.title && w.startTime === x.startTime && w.endTime === x.endTime;
                        }, c = "und", d = [], e = a.localization.g, f = u(Array.from(e)), g = f.next();
                    case 2:
                        if (g.done) {
                            v.B(4);
                            break;
                        }
                        c = h = g.value;
                        if (!a.player) {
                            v.B(5);
                            break;
                        }
                        return v.g(a.player.ph(c), 6);
                    case 6:
                        d = v.i || [];
                    case 5:
                        if (d.length) {
                            v.B(4);
                            break;
                        }
                        g = f.next();
                        v.B(2);
                        break;
                    case 4:
                        if (d.length) {
                            v.B(7);
                            break;
                        }
                        c = "und";
                        if (!a.player) {
                            v.B(7);
                            break;
                        }
                        return v.g(a.player.ph(c), 9);
                    case 9:
                        d = v.i || [];
                    case 7:
                        k = c !== a.h;
                        l = a.g.length !== d.length || !a.g.some(function(w, x) {
                            x = d.at(x);
                            return b(w, x) || d.some(function(y) {
                                return b(w, y);
                            });
                        });
                        a.h = c;
                        a.g = d;
                        if (!d.length) HK(a);
                        else if (k || l) {
                            m = u(a.g);
                            n = m.next();
                            for(q = {}; !n.done; q = {
                                Mg: void 0
                            }, n = m.next())q.Mg = n.value, r = ck(), t = U("span"), t.classList.add("shaka-chapter"), t.textContent = q.Mg.title, r.appendChild(t), a.eventManager.u(r, "click", function(w) {
                                return function() {
                                    a.controls.Ca() && (a.video.currentTime = w.Mg.startTime);
                                };
                            }(q)), a.menu.appendChild(r);
                            OH(a.button, !0);
                            MH(a.menu);
                        }
                        v.j();
                }
            });
        }
        O("shaka.ui.ChapterSelection", EK);
        function IK() {}
        IK.prototype.create = function(a, b) {
            return new EK(a, b);
        };
        MJ("chapter", new IK);
        gJ("chapter", new IK);
        function JK(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-fast-forward-button");
            this.g.classList.add("shaka-tooltip-status");
            this.g.setAttribute("shaka-status", "1x");
            new JH(this.g).use("M100-315v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T428-480q0 10-4.5 18.5T410-447L162-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Zm400 0v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T828-480q0 10-4.5 18.5T810-447L562-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Z");
            this.parent.appendChild(this.g);
            KK(this);
            this.h = this.controls.g.fastForwardRates;
            this.eventManager.u(this.localization, "locale-updated", function() {
                KK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                KK(c);
            });
            this.eventManager.u(this.g, "click", function() {
                if (c.controls.Ca() && c.video.duration) {
                    var d = c.h.indexOf(c.player.Wa()) + 1;
                    d = d != c.h.length ? c.h[d] : c.h[0];
                    c.video.paused && c.video.play();
                    c.player.sc(d);
                    c.g.setAttribute("shaka-status", d + "x");
                }
            });
            this.eventManager.u(this.player, "ratechange", function() {
                c.g.setAttribute("shaka-status", c.player.Wa() + "x");
            });
        }
        oa(JK, IH);
        function KK(a) {
            a.g.ariaLabel = a.localization.resolve("FAST_FORWARD");
        }
        O("shaka.ui.FastForwardButton", JK);
        function LK() {}
        LK.prototype.create = function(a, b) {
            return new JK(a, b);
        };
        gJ("fast_forward", new LK);
        function MK(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.h = this.controls.o;
            this.g = ck();
            this.g.classList.add("shaka-fullscreen-button");
            this.g.classList.add("shaka-tooltip");
            this.i = new JH(this.g, "M200-200h80q17 0 28.5 11.5T320-160q0 17-11.5 28.5T280-120H160q-17 0-28.5-11.5T120-160v-120q0-17 11.5-28.5T160-320q17 0 28.5 11.5T200-280v80Zm560 0v-80q0-17 11.5-28.5T800-320q17 0 28.5 11.5T840-280v120q0 17-11.5 28.5T800-120H680q-17 0-28.5-11.5T640-160q0-17 11.5-28.5T680-200h80ZM200-760v80q0 17-11.5 28.5T160-640q-17 0-28.5-11.5T120-680v-120q0-17 11.5-28.5T160-840h120q17 0 28.5 11.5T320-800q0 17-11.5 28.5T280-760h-80Zm560 0h-80q-17 0-28.5-11.5T640-800q0-17 11.5-28.5T680-840h120q17 0 28.5 11.5T840-800v120q0 17-11.5 28.5T800-640q-17 0-28.5-11.5T760-680v-80Z");
            NK(this);
            this.parent.appendChild(this.g);
            OK(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                OK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                OK(c);
            });
            this.eventManager.u(this.g, "click", function() {
                return H(function(d) {
                    return c.controls.Ca() ? d.g(c.controls.pg(), 0) : d.return();
                });
            });
            this.eventManager.u(document, "fullscreenchange", function() {
                c.i.use(c.controls.Jb() ? "M240-240h-80q-17 0-28.5-11.5T120-280q0-17 11.5-28.5T160-320h120q17 0 28.5 11.5T320-280v120q0 17-11.5 28.5T280-120q-17 0-28.5-11.5T240-160v-80Zm480 0v80q0 17-11.5 28.5T680-120q-17 0-28.5-11.5T640-160v-120q0-17 11.5-28.5T680-320h120q17 0 28.5 11.5T840-280q0 17-11.5 28.5T800-240h-80ZM240-720v-80q0-17 11.5-28.5T280-840q17 0 28.5 11.5T320-800v120q0 17-11.5 28.5T280-640H160q-17 0-28.5-11.5T120-680q0-17 11.5-28.5T160-720h80Zm480 0h80q17 0 28.5 11.5T840-680q0 17-11.5 28.5T800-640H680q-17 0-28.5-11.5T640-680v-120q0-17 11.5-28.5T680-840q17 0 28.5 11.5T720-800v80Z" : "M200-200h80q17 0 28.5 11.5T320-160q0 17-11.5 28.5T280-120H160q-17 0-28.5-11.5T120-160v-120q0-17 11.5-28.5T160-320q17 0 28.5 11.5T200-280v80Zm560 0v-80q0-17 11.5-28.5T800-320q17 0 28.5 11.5T840-280v120q0 17-11.5 28.5T800-120H680q-17 0-28.5-11.5T640-160q0-17 11.5-28.5T680-200h80ZM200-760v80q0 17-11.5 28.5T160-640q-17 0-28.5-11.5T120-680v-120q0-17 11.5-28.5T160-840h120q17 0 28.5 11.5T320-800q0 17-11.5 28.5T280-760h-80Zm560 0h-80q-17 0-28.5-11.5T640-800q0-17 11.5-28.5T680-840h120q17 0 28.5 11.5T840-800v120q0 17-11.5 28.5T800-640q-17 0-28.5-11.5T760-680v-80Z");
                OK(c);
            });
            this.eventManager.u(this.h, "loadedmetadata", function() {
                NK(c);
            });
            this.eventManager.u(this.h, "loadeddata", function() {
                NK(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                NK(c);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                NK(c);
            });
        }
        oa(MK, IH);
        function NK(a) {
            a.controls.ue() ? a.g.classList.remove("shaka-hidden") : a.g.classList.add("shaka-hidden");
        }
        function OK(a) {
            var b = a.controls.Jb() ? "EXIT_FULL_SCREEN" : "FULL_SCREEN";
            a.g.ariaLabel = a.localization.resolve(b);
        }
        O("shaka.ui.FullscreenButton", MK);
        function PK() {}
        PK.prototype.create = function(a, b) {
            return new MK(a, b);
        };
        gJ("fullscreen", new PK);
        function QK(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-loop-button");
            this.g.classList.add("shaka-tooltip");
            this.m = new JH(this.g, "m274-200 34 34q12 12 11.5 28T308-110q-12 12-28.5 12.5T251-109L148-212q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l103-103q12-12 28.5-11.5T308-370q11 12 11.5 28T308-314l-34 34h406v-120q0-17 11.5-28.5T720-440q17 0 28.5 11.5T760-400v120q0 33-23.5 56.5T680-200H274Zm412-480H280v120q0 17-11.5 28.5T240-520q-17 0-28.5-11.5T200-560v-120q0-33 23.5-56.5T280-760h406l-34-34q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T709-851l103 103q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L709-589q-12 12-28.5 11.5T652-590q-11-12-11.5-28t11.5-28l34-34Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.j = U("span");
            this.j.textContent = this.localization.resolve("LOOP");
            a.appendChild(this.j);
            this.i = U("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            RK(this);
            this.parent.appendChild(this.g);
            this.eventManager.u(this.localization, "locale-updated", function() {
                RK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                RK(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && (c.video.loop = !c.video.loop, c.h.La(), c.h.xa(1));
            });
            this.l = this.video.loop;
            this.h = new Uf(function() {
                c.l != c.video.loop && (RK(c), c.l = c.video.loop);
            });
            this.h.xa(1);
            this.eventManager.u(this.player, "unloading", function() {
                SK(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                SK(c);
            });
            this.eventManager.u(this.player, "manifestupdated", function() {
                SK(c);
            });
            this.eventManager.u(this.video, "durationchange", function() {
                SK(c);
            });
        }
        oa(QK, IH);
        QK.prototype.release = function() {
            this.h.stop();
            this.h = null;
            IH.prototype.release.call(this);
        };
        function RK(a) {
            a.j.textContent = a.localization.resolve("LOOP");
            a.i.textContent = a.localization.resolve(a.video.loop ? "ON" : "OFF");
            a.m.use(a.video.loop ? "M120-40q-33 0-56.5-23.5T40-120v-720q0-33 23.5-56.5T120-920h720q33 0 56.5 23.5T920-840v720q0 33-23.5 56.5T840-40H120Zm154-160h406q33 0 56.5-23.5T760-280v-120q0-17-11.5-28.5T720-440q-17 0-28.5 11.5T680-400v120H274l34-34q12-12 11.5-28T308-370q-12-12-28.5-12.5T251-371L148-268q-6 6-8.5 13t-2.5 15q0 8 2.5 15t8.5 13l103 103q12 12 28.5 11.5T308-110q11-12 11.5-28T308-166l-34-34Zm412-480-34 34q-12 12-11.5 28t11.5 28q12 12 28.5 12.5T709-589l103-103q6-6 8.5-13t2.5-15q0-8-2.5-15t-8.5-13L709-851q-12-12-28.5-11.5T652-850q-11 12-11.5 28t11.5 28l34 34H280q-33 0-56.5 23.5T200-680v120q0 17 11.5 28.5T240-520q17 0 28.5-11.5T280-560v-120h406Z" : "m274-200 34 34q12 12 11.5 28T308-110q-12 12-28.5 12.5T251-109L148-212q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l103-103q12-12 28.5-11.5T308-370q11 12 11.5 28T308-314l-34 34h406v-120q0-17 11.5-28.5T720-440q17 0 28.5 11.5T760-400v120q0 33-23.5 56.5T680-200H274Zm412-480H280v120q0 17-11.5 28.5T240-520q-17 0-28.5-11.5T200-560v-120q0-33 23.5-56.5T280-760h406l-34-34q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T709-851l103 103q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L709-589q-12 12-28.5 11.5T652-590q-11-12-11.5-28t11.5-28l34-34Z");
            a.g.ariaLabel = a.localization.resolve(a.video.loop ? "EXIT_LOOP_MODE" : "ENTER_LOOP_MODE");
        }
        function SK(a) {
            OH(a.g, !a.player.U());
        }
        O("shaka.ui.LoopButton", QK);
        function TK() {}
        TK.prototype.create = function(a, b) {
            return new QK(a, b);
        };
        MJ("loop", new TK);
        gJ("loop", new TK);
        TH("loop", new TK);
        function UK(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-mute-button");
            this.g.classList.add("shaka-tooltip");
            this.j = new JH(this.g, "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.h = U("span");
            this.h.textContent = this.localization.resolve("MUTE");
            a.appendChild(this.h);
            this.i = U("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            VK(this);
            WK(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                VK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                VK(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && (c.ad && c.ad.isLinear() ? c.ad.setMuted(!c.ad.isMuted()) : c.video.muted || c.video.volume != 0 ? c.video.muted = !c.video.muted : c.video.volume = 1);
            });
            this.eventManager.u(this.video, "volumechange", function() {
                VK(c);
                WK(c);
            });
            this.eventManager.u(this.player, "loading", function() {
                VK(c);
                WK(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                XK(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                XK(c);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                XK(c);
            });
            this.eventManager.u(this.controls, "caststatuschanged", function() {
                VK(c);
                WK(c);
            });
            this.eventManager.u(this.adManager, "ad-volume-changed", function() {
                VK(c);
                WK(c);
            });
            this.eventManager.u(this.adManager, "ad-muted", function() {
                VK(c);
                WK(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                XK(c);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                c.ad = null;
                VK(c);
                WK(c);
                XK(c);
            });
            XK(this);
        }
        oa(UK, IH);
        function VK(a) {
            var b = a.ad ? a.ad.isMuted() ? "UNMUTE" : "MUTE" : a.video.muted || a.video.volume == 0 ? "UNMUTE" : "MUTE";
            a.g.ariaLabel = a.localization.resolve(b);
            a.h.textContent = a.localization.resolve(b);
        }
        function WK(a) {
            var b = a.ad ? a.ad.isMuted() ? "M671-177q-11 7-22 13t-23 11q-15 7-30.5 0T574-176q-6-15 1.5-29.5T598-227q4-2 7.5-4t7.5-4L480-368v111q0 27-24.5 37.5T412-228L280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h88L84-764q-11-11-11-28t11-28q11-11 28-11t28 11l680 680q11 11 11 28t-11 28q-11 11-28 11t-28-11l-93-93Zm89-304q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131t58 197q0 33-6 65.5T817-353q-8 22-24.5 27.5t-30.5.5q-14-5-22.5-18t-.5-30q11-26 16-52.5t5-55.5ZM591-623q33 21 51 63t18 80v10q0 5-1 10-2 13-14 17t-22-6l-51-51q-6-6-9-13.5t-3-15.5v-77q0-12 10.5-17.5t20.5.5Zm-201-59q-6-6-6-14t6-14l22-22q19-19 43.5-8.5T480-703v63q0 14-12 19t-22-5l-56-56Z" : "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80Z" : a.video.muted || a.video.volume == 0 ? "M671-177q-11 7-22 13t-23 11q-15 7-30.5 0T574-176q-6-15 1.5-29.5T598-227q4-2 7.5-4t7.5-4L480-368v111q0 27-24.5 37.5T412-228L280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h88L84-764q-11-11-11-28t11-28q11-11 28-11t28 11l680 680q11 11 11 28t-11 28q-11 11-28 11t-28-11l-93-93Zm89-304q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131t58 197q0 33-6 65.5T817-353q-8 22-24.5 27.5t-30.5.5q-14-5-22.5-18t-.5-30q11-26 16-52.5t5-55.5ZM591-623q33 21 51 63t18 80v10q0 5-1 10-2 13-14 17t-22-6l-51-51q-6-6-9-13.5t-3-15.5v-77q0-12 10.5-17.5t20.5.5Zm-201-59q-6-6-6-14t6-14l22-22q19-19 43.5-8.5T480-703v63q0 14-12 19t-22-5l-56-56Z" : "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80Z";
            a.j.use(b);
        }
        function XK(a) {
            var b = !0;
            a.ad && a.ad.isLinear() ? b = !0 : a.player.Hf() && (b = !1);
            OH(a.g, b);
        }
        O("shaka.ui.MuteButton", UK);
        function YK() {}
        YK.prototype.create = function(a, b) {
            return new UK(a, b);
        };
        MJ("mute", new YK);
        gJ("mute", new YK);
        TH("mute", new YK);
        function ZK(a, b) {
            cI.call(this, a, b, [
                "shaka-volume-bar-container"
            ], [
                "shaka-volume-bar"
            ]);
            var c = this;
            this.g = this.controls.g;
            this.g.alwaysShowVolumeBar || this.container.classList.add("shaka-volume-bar-container-allow-hiding");
            this.setRange(0, 100);
            this.eventManager.u(this.video, "volumechange", function() {
                return $K(c);
            });
            this.eventManager.u(this.player, "loading", function() {
                return $K(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                return aL(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                return aL(c);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                return aL(c);
            });
            this.eventManager.u(this.controls, "caststatuschanged", function() {
                return $K(c);
            });
            this.eventManager.u(this.adManager, "ad-volume-changed", function() {
                return bL(c);
            });
            this.eventManager.u(this.adManager, "ad-muted", function() {
                return bL(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                return aL(c);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                aL(c);
                $K(c);
            });
            this.eventManager.u(this.localization, "locale-updated", function() {
                return cL(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                return cL(c);
            });
            $K(this);
            cL(this);
            if (this.ad) this.onChange();
            aL(this);
        }
        oa(ZK, cI);
        ZK.prototype.onChange = function() {
            this.ad && this.ad.isLinear() ? this.ad.setVolume(this.getValue() / 100) : (this.video.volume = this.getValue() / 100, this.video.volume > 0 && (this.video.muted = !1));
        };
        function $K(a) {
            a.video.muted ? a.setValue(0) : a.setValue(a.video.volume * 100);
            dL(a);
        }
        function bL(a) {
            var b = a.ad.getVolume();
            a.setValue(b * 100);
            dL(a);
        }
        function dL(a) {
            var b = a.g.volumeBarColors, c = [
                "to right"
            ];
            c.push(b.level + a.getValue() + "%");
            c.push(b.base + a.getValue() + "%");
            c.push(b.base + "100%");
            a.container.style.background = "linear-gradient(" + c.join(",") + ")";
        }
        function cL(a) {
            a.bar.ariaLabel = a.localization.resolve("VOLUME");
        }
        function aL(a) {
            var b = !0;
            a.ad && a.ad.isLinear() ? b = !0 : a.player.Hf() && (b = !1);
            OH(a.container, b);
        }
        O("shaka.ui.VolumeBar", ZK);
        function eL() {}
        eL.prototype.create = function(a, b) {
            return new ZK(a, b);
        };
        gJ("volume", new eL);
        function fL(a, b) {
            IH.call(this, a, b);
            this.g = U("div");
            this.g.classList.add("shaka-mute-volume-container");
            this.parent.appendChild(this.g);
            this.h = new UK(this.g, b);
            this.i = new ZK(this.g, b);
        }
        oa(fL, IH);
        fL.prototype.release = function() {
            this.h.release();
            this.i.release();
            IH.prototype.release.call(this);
        };
        O("shaka.ui.MuteVolumeBar", fL);
        function gL() {}
        gL.prototype.create = function(a, b) {
            return new fL(a, b);
        };
        gJ("mute_volume", new gL);
        function hL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.j = this.controls.o;
            this.g = ck();
            this.g.classList.add("shaka-pip-button");
            this.g.classList.add("shaka-tooltip");
            this.l = new JH(this.g, "M120-520q-17 0-28.5-11.5T80-560q0-17 11.5-28.5T120-600h104L80-743q-12-12-12-28.5T80-800q12-12 28.5-12t28.5 12l143 144v-104q0-17 11.5-28.5T320-800q17 0 28.5 11.5T360-760v200q0 17-11.5 28.5T320-520H120Zm40 360q-33 0-56.5-23.5T80-240v-160q0-17 11.5-28.5T120-440q17 0 28.5 11.5T160-400v160h280q17 0 28.5 11.5T480-200q0 17-11.5 28.5T440-160H160Zm680-280q-17 0-28.5-11.5T800-480v-240H480q-17 0-28.5-11.5T440-760q0-17 11.5-28.5T480-800h320q33 0 56.5 23.5T880-720v240q0 17-11.5 28.5T840-440ZM600-160q-17 0-28.5-11.5T560-200v-120q0-17 11.5-28.5T600-360h240q17 0 28.5 11.5T880-320v120q0 17-11.5 28.5T840-160H600Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.i = U("span");
            this.i.textContent = this.localization.resolve("PICTURE_IN_PICTURE");
            a.appendChild(this.i);
            this.h = U("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            iL(this);
            this.parent.appendChild(this.g);
            this.controls.Gf() || OH(this.g, !1);
            this.eventManager.u(this.localization, "locale-updated", function() {
                iL(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                iL(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && c.controls.Yc();
            });
            this.eventManager.u(this.j, "enterpictureinpicture", function() {
                jL(c);
            });
            this.eventManager.u(this.j, "leavepictureinpicture", function() {
                kL(c);
            });
            this.eventManager.u(this.controls, "caststatuschanged", function() {
                lL(c);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                lL(c);
            });
            "documentPictureInPicture" in window1 && this.eventManager.u(window1.documentPictureInPicture, "enter", function(d) {
                jL(c);
                c.eventManager.ra(d.window, "pagehide", function() {
                    kL(c);
                });
            });
        }
        oa(hL, IH);
        function jL(a) {
            a.l.use("M160-160q-33 0-56.5-23.5T80-240v-240q0-17 11.5-28.5T120-520q17 0 28.5 11.5T160-480v240h640v-480H480q-17 0-28.5-11.5T440-760q0-17 11.5-28.5T480-800h320q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm400-263 95 95q12 12 28 12t28-12q12-12 12-28.5T711-385l-95-95h64q17 0 28.5-11.5T720-520q0-17-11.5-28.5T680-560H520q-17 0-28.5 11.5T480-520v160q0 17 11.5 28.5T520-320q17 0 28.5-11.5T560-360v-63ZM120-600q-17 0-28.5-11.5T80-640v-120q0-17 11.5-28.5T120-800h200q17 0 28.5 11.5T360-760v120q0 17-11.5 28.5T320-600H120Zm360 120Z");
            a.g.ariaLabel = a.localization.resolve("EXIT_PICTURE_IN_PICTURE");
            a.h.textContent = a.localization.resolve("ON");
        }
        function kL(a) {
            a.l.use("M120-520q-17 0-28.5-11.5T80-560q0-17 11.5-28.5T120-600h104L80-743q-12-12-12-28.5T80-800q12-12 28.5-12t28.5 12l143 144v-104q0-17 11.5-28.5T320-800q17 0 28.5 11.5T360-760v200q0 17-11.5 28.5T320-520H120Zm40 360q-33 0-56.5-23.5T80-240v-160q0-17 11.5-28.5T120-440q17 0 28.5 11.5T160-400v160h280q17 0 28.5 11.5T480-200q0 17-11.5 28.5T440-160H160Zm680-280q-17 0-28.5-11.5T800-480v-240H480q-17 0-28.5-11.5T440-760q0-17 11.5-28.5T480-800h320q33 0 56.5 23.5T880-720v240q0 17-11.5 28.5T840-440ZM600-160q-17 0-28.5-11.5T560-200v-120q0-17 11.5-28.5T600-360h240q17 0 28.5 11.5T880-320v120q0 17-11.5 28.5T840-160H600Z");
            a.g.ariaLabel = a.localization.resolve("ENTER_PICTURE_IN_PICTURE");
            a.h.textContent = a.localization.resolve("OFF");
        }
        function iL(a) {
            a.i.textContent = a.localization.resolve("PICTURE_IN_PICTURE");
            var b = a.controls.Id();
            a.g.ariaLabel = a.localization.resolve(b ? "EXIT_PICTURE_IN_PICTURE" : "ENTER_PICTURE_IN_PICTURE");
            a.h.textContent = a.localization.resolve(b ? "ON" : "OFF");
        }
        function lL(a) {
            H(function(b) {
                if (!a.controls.Gf()) return OH(a.g, !1), a.controls.Id() ? b.g(a.controls.Yc(), 0) : b.B(0);
                if (!a.player || !a.player.Hd()) return OH(a.g, !0), b.B(0);
                OH(a.g, !1);
                return a.controls.Id() ? b.g(a.controls.Yc(), 0) : b.B(0);
            });
        }
        O("shaka.ui.PipButton", hL);
        function mL() {}
        mL.prototype.create = function(a, b) {
            return new hL(a, b);
        };
        MJ("picture_in_picture", new mL);
        gJ("picture_in_picture", new mL);
        TH("picture_in_picture", new mL);
        function nL(a, b) {
            pK.call(this, a, b, "m426-330 195-125q14-9 14-25t-14-25L426-630q-15-10-30.5-1.5T380-605v250q0 18 15.5 26.5T426-330ZM121-440q17 0 30.5 11t18.5 28q6 23 14.5 43.5T204-317q9 15 7.5 32T198-256q-11 11-27 10t-25-14q-22-31-37-66.5T86-400q-3-16 7.5-28t27.5-12Zm77-264q12 12 13 29t-7 31q-11 20-19.5 41T170-559q-5 17-18.5 28T121-520q-17 0-27.5-12.5T87-561q8-38 23-73.5t36-66.5q9-13 25-13.5t27 10.5Zm56 505q12-13 29.5-14t32.5 8q20 11 40.5 20t42.5 15q17 5 28 18t11 30q0 17-12.5 27T397-88q-38-8-71.5-23T260-146q-14-9-15.5-25t9.5-28Zm186-639q0 17-10.5 30T402-790q-23 6-44 14.5T317-755q-15 9-32.5 7.5T255-761q-12-12-10.5-28.5T260-815q32-20 66.5-34.5T399-872q16-3 28.5 7t12.5 27Zm360 358q0-113-69.5-199.5T553-792q-15-4-24-17t-9-29q0-16 11-26.5t25-7.5q140 28 232 137t92 255q0 146-92 255T556-88q-14 3-25-7.5T520-122q0-16 9-29t24-17q108-26 177.5-112.5T800-480Z");
            var c = this;
            this.button.classList.add("shaka-playbackrate-button");
            this.menu.classList.add("shaka-playback-rates");
            this.button.classList.add("shaka-tooltip-status");
            Array.from(a.classList).includes("shaka-overflow-menu") || (this.g = U("span"), this.g.classList.add("shaka-overflow-playback-rate-mark"), this.button.appendChild(this.g));
            this.eventManager.u(this.localization, "locale-updated", function() {
                oL(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                oL(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                pL(c);
            });
            this.eventManager.u(this.player, "ratechange", function() {
                pL(c);
            });
            oL(this);
            qL(this);
            pL(this);
        }
        oa(nL, pK);
        function oL(a) {
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.button.ariaLabel = a.localization.resolve("PLAYBACK_RATE");
            a.nameSpan.textContent = a.localization.resolve("PLAYBACK_RATE");
            a.backSpan.textContent = a.localization.resolve("PLAYBACK_RATE");
        }
        function pL(a) {
            var b = a.player.Wa(), c = LH(a.menu, "material-svg-icon shaka-chosen-item");
            if (c) {
                var d = c.parentElement;
                d.removeAttribute("aria-selected");
                var e = d.getElementsByTagName("span")[0];
                e && e.classList.remove("shaka-chosen-item");
                d.removeChild(c);
            }
            if (c = Array.from(a.menu.querySelectorAll("span")).find(function(f) {
                return f.textContent == b + "x";
            })) d = c.parentElement, d.appendChild(NH()), d.ariaSelected = "true", c.classList.add("shaka-chosen-item");
            a.currentSelection.textContent = b + "x";
            a.button.setAttribute("shaka-status", b + "x");
            a.g && (a.g.textContent = b + "x");
        }
        function qL(a) {
            for(var b = u(a.controls.g.playbackRates), c = b.next(), d = {}; !c.done; d = {
                Xf: void 0
            }, c = b.next()){
                d.Xf = c.value;
                c = ck();
                var e = U("span");
                e.textContent = d.Xf + "x";
                c.appendChild(e);
                a.eventManager.u(c, "click", function(f) {
                    return function() {
                        f.Xf == a.video.defaultPlaybackRate ? a.player.ud() : a.player.sc(f.Xf, !1);
                    };
                }(d));
                a.menu.appendChild(c);
            }
            MH(a.menu);
        }
        O("shaka.ui.PlaybackRateSelection", nL);
        function rL() {}
        rL.prototype.create = function(a, b) {
            return new nL(a, b);
        };
        MJ("playback_rate", new rL);
        gJ("playback_rate", new rL);
        function sL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-current-time");
            tL(this, "0:00");
            this.parent.appendChild(this.g);
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && c.player.U() && (c.video.currentTime = c.player.wa().end);
            });
            this.eventManager.u(this.player, "loading", function() {
                OH(c.g, !0);
            });
            this.eventManager.u(this.controls, "timeandseekrangeupdated", function() {
                var d = c.controls.V, e = c.controls.qh(), f = c.player.wa(), g = f.end - f.start;
                isFinite(g) ? c.player.U() ? (e = Math.max(0, Math.floor(f.end - e)), g = g >= 3600, e >= 1 || d ? (tL(c, "- " + PH(e, g)), c.g.disabled = !1) : (tL(c, c.localization.resolve("LIVE")), c.g.disabled = !0)) : (d = g >= 3600, e = Math.max(0, e - f.start), g && (e = Math.min(e, g)), e = PH(e, d), g && (e += " / " + PH(g, d)), tL(c, e), c.g.disabled = !0) : (tL(c, c.localization.resolve("LIVE")), c.g.disabled = !0);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                c.player.U() && (c.g.ariaLabel = c.localization.resolve("SKIP_TO_LIVE"));
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                OH(c.g, !c.ad.isLinear());
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                OH(c.g, !0);
            });
        }
        oa(sL, IH);
        function tL(a, b) {
            b != a.g.textContent && (a.g.textContent = b);
        }
        O("shaka.ui.PresentationTimeTracker", sL);
        function uL() {}
        uL.prototype.create = function(a, b) {
            return new sL(a, b);
        };
        gJ("time_and_duration", new uL);
        function vL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-recenter-vr-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            new JH(this.g, "M479-359q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm-57 222-85-85q-12-12-11.5-28.5T338-279q12-12 28.5-12t28.5 12l85 86 85-85q11-11 28-11t28 11q11 11 11 28t-11 28l-85 85q-12 12-27 18t-30 6q-15 0-30-6t-27-18ZM221-337l-85-85q-12-12-18-27t-6-30q0-15 6-30t18-27l85-85q12-12 28.5-12t28.5 12q12 12 12 28.5T278-564l-86 86 85 85q11 11 11 28t-11 28q-11 11-28 11t-28-11Zm116-401 85-85q12-12 27-18t30-6q15 0 30 6t27 18l85 85q12 12 12 28t-12 28q-12 12-28.5 12T564-682l-86-85-85 85q-11 11-28 11t-28-11q-11-11-11-28t11-28Zm344 343 85-85-85-85q-11-11-11-28t11-28q11-11 28-11t28 11l85 85q12 12 18 27t6 30q0 15-6 30t-18 27l-85 85q-12 12-28 11.5T681-338q-12-12-12-28.5t12-28.5Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.i = U("span");
            a.appendChild(this.i);
            this.h = U("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            wL(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                wL(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                wL(c);
            });
            var d = this.controls.D;
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && (d.g ? NI(d.g) : Za("Not playing VR content"));
            });
            this.eventManager.u(d, "vrstatuschanged", function() {
                OH(c.g, c.controls.Sb());
            });
            OH(this.g, this.controls.Sb());
        }
        oa(vL, IH);
        function wL(a) {
            a.g.ariaLabel = a.localization.resolve("RECENTER_VR");
            a.i.textContent = a.localization.resolve("RECENTER_VR");
        }
        O("shaka.ui.RecenterVRButton", vL);
        function xL() {}
        xL.prototype.create = function(a, b) {
            return new vL(a, b);
        };
        MJ("recenter_vr", new xL);
        gJ("recenter_vr", new xL);
        function yL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.i = Xb().lg();
            this.g = ck();
            this.g.classList.add("shaka-remote-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            this.l = new JH(this.g, this.i ? "M80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200h-80q-17 0-28.5-11.5T680-240q0-17 11.5-28.5T720-280h80v-480H160v480h80q17 0 28.5 11.5T280-240q0 17-11.5 28.5T240-200h-80q-33 0-56.5-23.5T80-280Zm232 160q-14 0-22-9.5t-8-20.5q0-5 2-10.5t7-10.5l161-161q6-6 13-9t15-3q8 0 15 3t13 9l161 161q5 5 7 10.5t2 10.5q0 11-8 20.5t-22 9.5H312Zm168-360Z" : "M480-480Zm320 320H600q0-20-1.5-40t-4.5-40h206v-480H160v46q-20-3-40-4.5T80-680v-40q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160Zm-720 0v-120q50 0 85 35t35 85H80Zm200 0q0-83-58.5-141.5T80-360v-80q117 0 198.5 81.5T360-160h-80Zm160 0q0-75-28.5-140.5t-77-114q-48.5-48.5-114-77T80-520v-80q91 0 171 34.5T391-471q60 60 94.5 140T520-160h-80Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.m = U("span");
            a.appendChild(this.m);
            this.j = U("span");
            this.j.classList.add("shaka-current-selection-span");
            a.appendChild(this.j);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            this.h = -1;
            zL(this);
            OH(this.g, !1);
            this.video.remote ? (this.eventManager.u(this.localization, "locale-updated", function() {
                zL(c);
            }), this.eventManager.u(this.localization, "locale-changed", function() {
                zL(c);
            }), this.eventManager.u(this.controls, "caststatuschanged", function() {
                IL(c);
            }), this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && c.video.remote.prompt().catch(function() {});
            }), this.eventManager.u(this.video.remote, "connect", function() {
                IL(c);
                JL(c);
            }), this.eventManager.u(this.video.remote, "connecting", function() {
                IL(c);
                JL(c);
            }), this.eventManager.u(this.video.remote, "disconnect", function() {
                IL(c);
                JL(c);
            }), this.eventManager.u(this.player, "loaded", function() {
                IL(c);
            }), IL(this, !0), JL(this)) : this.g.classList.add("shaka-hidden");
        }
        oa(yL, IH);
        yL.prototype.release = function() {
            this.video.remote && this.h != -1 && this.video.remote.cancelWatchAvailability(this.h).catch(function() {});
            IH.prototype.release.call(this);
        };
        function IL(a, b) {
            b = b === void 0 ? !1 : b;
            var c, d;
            H(function(e) {
                switch(e.h){
                    case 1:
                        if (a.controls.F.Kg() && a.controls.va || !a.video.remote) {
                            OH(a.g, !1);
                            a.h != -1 && (a.video.remote.cancelWatchAvailability(a.h), a.h = -1);
                            e.B(0);
                            break;
                        }
                        if (a.video.remote.state == "disconnected" || b) {
                            c = function(f) {
                                if (a.player) {
                                    var g = a.video.disableRemotePlayback, h = !0;
                                    Xb().lg() && a.player.xc() == ms && a.player.uh() != "HLS" && (h = !1);
                                    OH(a.g, h && f && !g);
                                } else OH(a.g, !1);
                            };
                            e.m(7);
                            if (a.h == -1) {
                                e.B(9);
                                break;
                            }
                            return e.g(a.video.remote.cancelWatchAvailability(a.h), 10);
                        }
                        OH(a.g, !0);
                        if (a.h == -1) {
                            e.B(0);
                            break;
                        }
                        return e.g(a.video.remote.cancelWatchAvailability(a.h), 6);
                    case 6:
                        a.h = -1;
                        e.B(0);
                        break;
                    case 10:
                        a.h = -1;
                    case 9:
                        e.o(8);
                        break;
                    case 7:
                        e.l();
                    case 8:
                        return e.m(11), e.g(a.video.remote.watchAvailability(c), 13);
                    case 13:
                        d = e.i;
                        a.h = d;
                        e.o(0);
                        break;
                    case 11:
                        e.l(), c(!0), e.j();
                }
            });
        }
        function zL(a) {
            var b = a.i ? a.localization.resolve("AIRPLAY") : a.localization.resolve("CAST");
            a.g.ariaLabel = b;
            a.m.textContent = b;
        }
        function JL(a) {
            a.i || (a.video.remote.state == "disconnected" ? a.l.use("M480-480Zm320 320H600q0-20-1.5-40t-4.5-40h206v-480H160v46q-20-3-40-4.5T80-680v-40q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160Zm-720 0v-120q50 0 85 35t35 85H80Zm200 0q0-83-58.5-141.5T80-360v-80q117 0 198.5 81.5T360-160h-80Zm160 0q0-75-28.5-140.5t-77-114q-48.5-48.5-114-77T80-520v-80q91 0 171 34.5T391-471q60 60 94.5 140T520-160h-80Z") : a.l.use("M720-600v240q0 17-11.5 28.5T680-320h-87q-8 0-14.5-4.5T569-337q-29-81-81.5-147T364-596q-16-10-11.5-27t21.5-17h306q17 0 28.5 11.5T720-600ZM320-160q-16 0-28-9.5T277-195q-11-63-56.5-107T112-357q-15-2-23.5-14.5T80-400q0-17 11-28.5t26-9.5q94 12 160.5 79T357-198q2 16-9 27t-28 11Zm160 0q-17 0-28.5-11T438-199q-14-128-104.5-217T115-518q-16-2-25.5-14T80-560q0-17 10.5-29t25.5-10q161 13 274 125.5T518-201q2 17-9.5 29T480-160Zm-340 0q-25 0-42.5-17.5T80-220q0-25 17.5-42.5T140-280q25 0 42.5 17.5T200-220q0 25-17.5 42.5T140-160Zm740-560v480q0 33-23.5 56.5T800-160H638q-17 0-28.5-11.5T598-200q0-17 11.5-28.5T638-240h162v-480H160v6q0 17-11.5 28.5T120-674q-17 0-28.5-11.5T80-714v-6q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720Z"));
        }
        O("shaka.ui.RemoteButton", yL);
        function KL() {}
        KL.prototype.create = function(a, b) {
            return new yL(a, b);
        };
        MJ("remote", new KL);
        gJ("remote", new KL);
        function LL(a, b) {
            pK.call(this, a, b, "M480-120q-17 0-28.5-11.5T440-160v-160q0-17 11.5-28.5T480-360q17 0 28.5 11.5T520-320v40h280q17 0 28.5 11.5T840-240q0 17-11.5 28.5T800-200H520v40q0 17-11.5 28.5T480-120Zm-320-80q-17 0-28.5-11.5T120-240q0-17 11.5-28.5T160-280h160q17 0 28.5 11.5T360-240q0 17-11.5 28.5T320-200H160Zm160-160q-17 0-28.5-11.5T280-400v-40H160q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520h120v-40q0-17 11.5-28.5T320-600q17 0 28.5 11.5T360-560v160q0 17-11.5 28.5T320-360Zm160-80q-17 0-28.5-11.5T440-480q0-17 11.5-28.5T480-520h320q17 0 28.5 11.5T840-480q0 17-11.5 28.5T800-440H480Zm160-160q-17 0-28.5-11.5T600-640v-160q0-17 11.5-28.5T640-840q17 0 28.5 11.5T680-800v40h120q17 0 28.5 11.5T840-720q0 17-11.5 28.5T800-680H680v40q0 17-11.5 28.5T640-600Zm-480-80q-17 0-28.5-11.5T120-720q0-17 11.5-28.5T160-760h320q17 0 28.5 11.5T520-720q0 17-11.5 28.5T480-680H160Z");
            var c = this;
            this.button.classList.add("shaka-resolution-button");
            this.button.classList.add("shaka-tooltip-status");
            this.menu.classList.add("shaka-resolutions");
            this.h = U("span");
            this.h.classList.add("shaka-current-auto-quality");
            this.h.style.display = "none";
            this.i = U("sup");
            this.i.classList.add("shaka-current-quality-mark");
            this.i.style.display = "none";
            Array.from(a.classList).includes("shaka-overflow-menu") ? this.parent.parentElement && (this.g = fk(this.parent.parentElement)) : (this.g = U("span"), this.g.classList.add("shaka-overflow-playback-rate-mark"), this.button.appendChild(this.g));
            a = U("span");
            this.button.childNodes[1].appendChild(a);
            a.appendChild(this.currentSelection);
            a.appendChild(this.h);
            a.appendChild(this.i);
            this.eventManager.u(this.localization, "locale-updated", function() {
                ML(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                ML(c);
            });
            this.eventManager.u(this.player, "loading", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "variantchanged", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "abrstatuschanged", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "adaptation", function() {
                NL(c);
                OL(c);
            });
            NL(this);
        }
        oa(LL, pK);
        function OL(a) {
            var b = a.player.getConfiguration().abr.enabled;
            if (a.player.Hd()) {
                a.i.textContent = "";
                a.i.style.display = "none";
                a.g && (a.g.textContent = "", a.g.style.display = "none");
                var c = a.player.Ib() || [], d = c.find(function(e) {
                    return e.active;
                });
                d && (b ? (a.h.textContent = d.bandwidth ? PL(a, d, c) : "Unknown", a.h.style.display = "") : a.h.style.display = "none");
            } else c = a.player.getVideoTracks() || [], (d = c.find(function(e) {
                return e.active;
            })) ? (b ? (a.h.textContent = d.height && d.width ? QL(a, d, c) : d.bandwidth ? RL(d.bandwidth) : "Unknown", a.h.style.display = "") : a.h.style.display = "none", b = SL(a, d.width, d.height), a.i.textContent = b, a.i.style.display = b !== "" ? "" : "none", a.g && (a.g.textContent = b, a.g.style.display = b !== "" ? "" : "none")) : a.g && (b = a.player.getStats(), b = SL(a, b.width, b.height), a.g.textContent = b, a.g.style.display = b !== "" ? "" : "none");
        }
        function SL(a, b, c) {
            if (!b || !c) return "";
            c > b && (c = u([
                c,
                b
            ]), b = c.next().value, c = c.next().value);
            b / c > 16 / 9 && (c = Math.round(b * 9 / 16));
            a = a.controls.g.qualityMarks;
            return c >= 8640 ? c + "p" : c >= 4320 ? a["4320"] : c >= 2160 ? a["2160"] : c >= 1440 ? a["1440"] : c >= 1080 ? a["1080"] : c >= 720 ? a["720"] : "";
        }
        function NL(a) {
            var b = KH(a.menu);
            gk(a.menu);
            a.menu.appendChild(b);
            b = 0;
            b = a.player.Hd() ? TL(a) : UL(a);
            var c = ck();
            c.classList.add("shaka-enable-abr-button");
            a.eventManager.u(c, "click", function() {
                a.player.configure({
                    abr: {
                        enabled: !0
                    }
                });
                NL(a);
            });
            a.l = U("span");
            a.l.textContent = a.localization.resolve("AUTO_QUALITY");
            c.appendChild(a.l);
            a.player.getConfiguration().abr.enabled && (c.ariaSelected = "true", c.appendChild(NH()), a.l.classList.add("shaka-chosen-item"), a.currentSelection.textContent = a.localization.resolve("AUTO_QUALITY"));
            a.button.setAttribute("shaka-status", a.currentSelection.textContent);
            a.menu.appendChild(c);
            MH(a.menu);
            a.controls.dispatchEvent(new R("resolutionselectionupdated"));
            ML(a);
            OH(a.button, b > 0);
        }
        function TL(a) {
            var b = [];
            a.player.xc() == fs || a.player.Da() || (b = a.player.Ib() || []);
            var c = b.find(function(k) {
                return k.active;
            });
            c && (b = b.filter(function(k) {
                if (k.language != c.language || a.controls.g.showAudioChannelCountVariants && k.channelsCount && c.channelsCount && k.channelsCount != c.channelsCount) return !1;
                var l = a.controls.g.trackLabelFormat;
                return (l == 1 || l == 2) && JSON.stringify(k.audioRoles) != JSON.stringify(c.audioRoles) || l == 3 && k.label != c.label || !k.bandwidth ? !1 : !0;
            }));
            b = b.filter(function(k, l) {
                return b.findIndex(function(m) {
                    return m.bandwidth == k.bandwidth;
                }) == l;
            });
            b.sort(function(k, l) {
                return l.bandwidth - k.bandwidth;
            });
            for(var d = a.player.getConfiguration().abr.enabled, e = u(b), f = e.next(), g = {}; !f.done; g = {
                Ke: void 0
            }, f = e.next()){
                g.Ke = f.value;
                f = ck();
                f.classList.add("explicit-resolution");
                a.eventManager.u(f, "click", function(k) {
                    return function() {
                        var l = k.Ke;
                        a.player.configure({
                            abr: {
                                enabled: !1
                            }
                        });
                        a.player.Ge(l, a.controls.g.clearBufferOnQualityChange);
                    };
                }(g));
                var h = U("span");
                h.textContent = g.Ke.bandwidth ? PL(a, g.Ke, b) : "Unknown";
                f.appendChild(h);
                d || g.Ke != c || (f.ariaSelected = "true", f.appendChild(NH()), h.classList.add("shaka-chosen-item"), a.currentSelection.textContent = h.textContent);
                a.menu.appendChild(f);
            }
            return b.length;
        }
        function UL(a) {
            var b = a.player.getVideoTracks() || [], c = b.find(function(m) {
                return m.active;
            });
            b = b.filter(function(m, n) {
                return b.findIndex(function(q) {
                    var r = q.height == m.height && q.bandwidth == m.bandwidth && q.frameRate == m.frameRate && q.hdr == m.hdr && q.videoLayout == m.videoLayout && ed(q.roles, m.roles);
                    r && a.controls.g.showVideoCodec && q.codecs && m.codecs && (r = Cf(q.codecs) == Cf(m.codecs));
                    return r;
                }) == n;
            });
            b.sort(function(m, n) {
                return n.height == m.height || m.height == null || n.height == null ? n.bandwidth - m.bandwidth : n.height - m.height;
            });
            for(var d = a.player.getConfiguration().abr.enabled, e = u(b), f = e.next(), g = {}; !f.done; g = {
                nc: void 0
            }, f = e.next()){
                g.nc = f.value;
                f = ck();
                f.classList.add("explicit-resolution");
                a.eventManager.u(f, "click", function(m) {
                    return function() {
                        var n = m.nc;
                        a.player.configure({
                            abr: {
                                enabled: !1
                            }
                        });
                        a.player.Kj(n, a.controls.g.clearBufferOnQualityChange);
                    };
                }(g));
                var h = U("span");
                h.textContent = g.nc.height && g.nc.width ? QL(a, g.nc, b) : g.nc.bandwidth ? RL(g.nc.bandwidth) : "Unknown";
                f.appendChild(h);
                var k = SL(a, g.nc.width, g.nc.height);
                if (k !== "") {
                    var l = U("sup");
                    l.classList.add("shaka-quality-mark");
                    l.textContent = k;
                    f.appendChild(l);
                }
                d || g.nc != c || (f.ariaSelected = "true", f.appendChild(NH()), h.classList.add("shaka-chosen-item"), a.currentSelection.textContent = h.textContent);
                a.menu.appendChild(f);
            }
            return b.length;
        }
        function QL(a, b, c) {
            function d(n, q) {
                return n != q && n.height == q.height && n.hdr == q.hdr && f(n) == f(q) && e(n) == e(q) && Math.round(n.frameRate || 0) == Math.round(q.frameRate || 0);
            }
            function e(n) {
                return n.codecs ? Cf(n.codecs).startsWith("lcevc") : !1;
            }
            function f(n) {
                return n.codecs ? Cf(n.codecs).startsWith("dovi-") : !1;
            }
            var g = b.height || 0, h = b.width || 0, k = !0;
            if (b.pixelAspectRatio) {
                var l = b.pixelAspectRatio.split(":").map(function(n) {
                    return Number(n);
                });
                l.length === 2 ? k = l[0] === l[1] : l.length === 1 && (k = l[0] === 1);
            }
            g > h && k && (g = u([
                g,
                h
            ]), h = g.next().value, g = g.next().value);
            k = g;
            h / g > 16 / 9 && (k = Math.round(h * 9 / 16));
            h = k + "p";
            g = new Set;
            k = u(c);
            for(l = k.next(); !l.done; l = k.next())l = l.value, l.frameRate && g.add(Math.round(l.frameRate));
            g.size > 1 && (g = b.frameRate) && (g >= 50 || g <= 20) && (h += Math.round(b.frameRate));
            if (f(b)) h += " Dolby Vision";
            else if (b.hdr == "PQ" || b.hdr == "HLG") h += " HDR";
            e(b) && (h += " LCEVC");
            (b.videoLayout || "").includes("CH-STEREO") && (h += " 3D");
            if (c.some(function(n) {
                return d(b, n);
            }) && (c.some(function(n) {
                return d(b, n) && n.bandwidth == b.bandwidth;
            }) || (h += " (" + RL(b.bandwidth) + ")"), a.controls.g.showVideoCodec)) {
                var m = function(n) {
                    var q = "";
                    n && (q = Cf(n).toUpperCase());
                    return q ? " " + q : q;
                };
                c.some(function(n) {
                    return d(b, n) && m(n.codecs) != m(b.codecs);
                }) && (h += m(b.codecs));
            }
            return h;
        }
        function PL(a, b, c) {
            var d = RL(b.bandwidth);
            if (a.controls.g.showAudioCodec) {
                var e = function(f) {
                    var g = "";
                    f && (g = Cf(f).toUpperCase());
                    return g ? " " + g : g;
                };
                c.some(function(f) {
                    return e(f.codecs) != e(b.codecs);
                }) && (d += e(b.codecs));
            }
            return d;
        }
        function RL(a) {
            return a >= 1E6 ? (a / 1E6).toFixed(1).replace(".0", "") + " Mbps" : Math.floor(a / 1E3) + " Kbps";
        }
        function ML(a) {
            var b = a.player.Hd() ? "QUALITY" : "RESOLUTION";
            a.button.ariaLabel = a.localization.resolve(b);
            a.backButton.ariaLabel = a.localization.resolve(b);
            a.backSpan.textContent = a.localization.resolve(b);
            a.nameSpan.textContent = a.localization.resolve(b);
            a.l.textContent = a.localization.resolve("AUTO_QUALITY");
            a.player.getConfiguration().abr.enabled && (a.currentSelection.textContent = a.localization.resolve("AUTO_QUALITY"));
        }
        O("shaka.ui.ResolutionSelection", LL);
        function VL() {}
        VL.prototype.create = function(a, b) {
            return new LL(a, b);
        };
        MJ("quality", new VL);
        gJ("quality", new VL);
        function WL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-rewind-button");
            this.g.classList.add("shaka-tooltip-status");
            this.g.setAttribute("shaka-status", this.localization.resolve("OFF"));
            new JH(this.g).use("M798-281 550-447q-9-6-13.5-14.5T532-480q0-10 4.5-18.5T550-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Zm-400 0L150-447q-9-6-13.5-14.5T132-480q0-10 4.5-18.5T150-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Z");
            this.parent.appendChild(this.g);
            XL(this);
            this.h = this.controls.g.rewindRates;
            this.eventManager.u(this.localization, "locale-updated", function() {
                XL(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                XL(c);
            });
            this.eventManager.u(this.g, "click", function() {
                if (c.controls.Ca() && c.video.duration) {
                    var d = c.h.indexOf(c.player.Wa()) + 1;
                    d = d != c.h.length ? c.h[d] : c.h[0];
                    c.video.paused && c.video.play();
                    c.player.sc(d);
                    c.g.setAttribute("shaka-status", d + "x");
                }
            });
            this.eventManager.u(this.player, "ratechange", function() {
                c.g.setAttribute("shaka-status", c.player.Wa() + "x");
            });
        }
        oa(WL, IH);
        function XL(a) {
            a.g.ariaLabel = a.localization.resolve("REWIND");
        }
        O("shaka.ui.RewindButton", WL);
        function YL() {}
        YL.prototype.create = function(a, b) {
            return new WL(a, b);
        };
        gJ("rewind", new YL);
        function ZL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.j = this.controls.F;
            this.g = ck();
            this.g.classList.add("shaka-save.video-frame-button");
            this.g.classList.add("shaka-tooltip");
            new JH(this.g, "M480-337q-8 0-15-2.5t-13-8.5L308-492q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T365-549l75 75v-286q0-17 11.5-28.5T480-800q17 0 28.5 11.5T520-760v286l75-75q12-12 28.5-11.5T652-548q11 12 11.5 28T652-492L508-348q-6 6-13 8.5t-15 2.5ZM240-160q-33 0-56.5-23.5T160-240v-80q0-17 11.5-28.5T200-360q17 0 28.5 11.5T240-320v80h480v-80q0-17 11.5-28.5T760-360q17 0 28.5 11.5T800-320v80q0 33-23.5 56.5T720-160H240Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.h = U("span");
            this.h.textContent = this.localization.resolve("DOWNLOAD_VIDEO_FRAME");
            a.appendChild(this.h);
            this.i = U("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            $L(this);
            this.parent.appendChild(this.g);
            this.eventManager.u(this.localization, "locale-updated", function() {
                $L(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                $L(c);
            });
            this.eventManager.u(this.g, "click", function() {
                var d = document.createElement("canvas"), e = d.getContext("2d"), f = c.controls.o;
                d.width = f.videoWidth;
                d.height = f.videoHeight;
                e.drawImage(f, 0, 0, d.width, d.height);
                d = d.toDataURL("image/png");
                e = document.createElement("a");
                e.href = d;
                e.download = "videoframe_" + f.currentTime.toFixed(3) + ".png";
                e.click();
            });
            this.eventManager.u(this.controls.D, "vrstatuschanged", function() {
                aM(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                aM(c);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                aM(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                aM(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                aM(c);
            });
            this.eventManager.u(this.video, "play", function() {
                aM(c);
            });
            this.eventManager.u(this.video, "pause", function() {
                aM(c);
            });
            this.eventManager.u(this.video, "seeking", function() {
                aM(c);
            });
            this.eventManager.u(this.controls, "caststatuschanged", function() {
                aM(c);
            });
            aM(this);
        }
        oa(ZL, IH);
        function aM(a) {
            var b = !0;
            a.controls.Sb() && (b = !1);
            b && a.j.Qa() && (b = !1);
            b && (a.player.drmInfo() || a.player.Hd()) && (b = !1);
            b && a.ad && (b = !1);
            b && a.video.remote && a.video.remote.state != "disconnected" && (b = !1);
            OH(a.g, b);
        }
        function $L(a) {
            a.g.ariaLabel = a.localization.resolve("DOWNLOAD_VIDEO_FRAME");
            a.h.textContent = a.localization.resolve("DOWNLOAD_VIDEO_FRAME");
        }
        O("shaka.ui.SaveVideoFrameButton", ZL);
        function bM() {}
        bM.prototype.create = function(a, b) {
            return new ZL(a, b);
        };
        MJ("save_video_frame", new bM);
        TH("save_video_frame", new bM);
        function cM(a, b) {
            IH.call(this, a, b);
            var c = this;
            if (this.g = this.player.wf()) this.h = ck(), this.h.classList.add("shaka-skip-next-button"), this.h.classList.add("shaka-tooltip"), new JH(this.h).use("M660-280v-400q0-17 11.5-28.5T700-720q17 0 28.5 11.5T740-680v400q0 17-11.5 28.5T700-240q-17 0-28.5-11.5T660-280Zm-440-35v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T548-480q0 10-4.5 18.5T530-447L282-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Z"), this.parent.appendChild(this.h), dM(this), eM(this), this.eventManager.u(this.localization, "locale-updated", function() {
                dM(c);
            }), this.eventManager.u(this.localization, "locale-changed", function() {
                dM(c);
            }), this.eventManager.u(this.h, "click", function() {
                c.controls.Ca() && c.g.playItem(c.g.getCurrentItemIndex() + 1);
            }), this.eventManager.u(this.g, "currentitemchanged", function() {
                eM(c);
            }), this.eventManager.u(this.g, "itemsinserted", function() {
                eM(c);
            }), this.eventManager.u(this.g, "itemsremoved", function() {
                eM(c);
            }), this.eventManager.u(this.player, "loading", function() {
                eM(c);
            });
        }
        oa(cM, IH);
        function dM(a) {
            a.h.ariaLabel = a.localization.resolve("SKIP_NEXT");
        }
        function eM(a) {
            var b = a.g.getItems().length;
            b = b > 1 && a.g.getCurrentItemIndex() + 1 < b;
            OH(a.h, b);
        }
        O("shaka.ui.SkipNextButton", cM);
        function fM() {}
        fM.prototype.create = function(a, b) {
            return new cM(a, b);
        };
        gJ("skip_next", new fM);
        function gM(a, b) {
            IH.call(this, a, b);
            var c = this;
            if (this.g = this.player.wf()) this.h = ck(), this.h.classList.add("shaka-skip-previous-button"), this.h.classList.add("shaka-tooltip"), new JH(this.h).use("M220-280v-400q0-17 11.5-28.5T260-720q17 0 28.5 11.5T300-680v400q0 17-11.5 28.5T260-240q-17 0-28.5-11.5T220-280Zm458-1L430-447q-9-6-13.5-14.5T412-480q0-10 4.5-18.5T430-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Z"), this.parent.appendChild(this.h), hM(this), iM(this), this.eventManager.u(this.localization, "locale-updated", function() {
                hM(c);
            }), this.eventManager.u(this.localization, "locale-changed", function() {
                hM(c);
            }), this.eventManager.u(this.h, "click", function() {
                c.controls.Ca() && c.g.playItem(c.g.getCurrentItemIndex() - 1);
            }), this.eventManager.u(this.g, "currentitemchanged", function() {
                iM(c);
            }), this.eventManager.u(this.g, "itemsinserted", function() {
                iM(c);
            }), this.eventManager.u(this.g, "itemsremoved", function() {
                iM(c);
            }), this.eventManager.u(this.player, "loading", function() {
                iM(c);
            });
        }
        oa(gM, IH);
        function hM(a) {
            a.h.ariaLabel = a.localization.resolve("SKIP_PREVIOUS");
        }
        function iM(a) {
            var b = a.g.getItems().length > 1 && a.g.getCurrentItemIndex() > 0;
            OH(a.h, b);
        }
        O("shaka.ui.SkipPreviousButton", gM);
        function jM() {}
        jM.prototype.create = function(a, b) {
            return new gM(a, b);
        };
        gJ("skip_previous", new jM);
        function kM(a, b) {
            VH.call(this, a, b);
            this.button.classList.add("shaka-small-play-button");
            this.button.classList.add("shaka-tooltip");
        }
        oa(kM, VH);
        O("shaka.ui.SmallPlayButton", kM);
        function lM() {}
        lM.prototype.create = function(a, b) {
            return new kM(a, b);
        };
        gJ("play_pause", new lM);
        function mM(a, b) {
            IH.call(this, a, b);
            a = U("div");
            a.classList.add("shaka-spacer");
            a.ariaHidden = "true";
            this.parent.appendChild(a);
        }
        oa(mM, IH);
        O("shaka.ui.Spacer", mM);
        function nM() {}
        nM.prototype.create = function(a, b) {
            return new mM(a, b);
        };
        gJ("spacer", new nM);
        function oM(a, b) {
            function c(m) {
                m = parseInt(l.g[m], 10);
                return m > 2E9 ? (m / 1E9).toFixed(2) + "GB" : m > 1E6 ? (m / 1E6).toFixed(2) + "MB" : m > 1E3 ? (m / 1E3).toFixed(2) + "KB" : m + "B";
            }
            function d(m) {
                return l.g[m] + " (gaps)";
            }
            function e(m) {
                m = l.g[m];
                return PH(m, m > 3600);
            }
            function f(m) {
                return Math.round(l.g[m] / 1E3) + " (kbits/s)";
            }
            function g(m) {
                return l.g[m].toFixed(2) + " (s)";
            }
            function h(m) {
                return l.g[m] + " (frames)";
            }
            function k(m) {
                return l.g[m] + " (px)";
            }
            IH.call(this, a, b);
            var l = this;
            this.i = ck();
            this.i.classList.add("shaka-statistics-button");
            this.o = new JH(this.i, "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.A = U("span");
            a.appendChild(this.A);
            this.l = U("span");
            this.l.classList.add("shaka-current-selection-span");
            a.appendChild(this.l);
            this.i.appendChild(a);
            this.parent.appendChild(this.i);
            this.h = U("div");
            this.h.classList.add("shaka-no-propagation");
            this.h.classList.add("shaka-show-controls-on-mouse-over");
            this.h.classList.add("shaka-statistics-container");
            this.h.classList.add("shaka-hidden");
            this.controls.i.appendChild(this.h);
            this.D = [];
            this.F = [
                "stateHistory",
                "switchHistory"
            ];
            this.g = this.player.getStats();
            this.m = new Map;
            this.C = (new Map).set("width", k).set("height", k).set("currentCodecs", function(m) {
                return l.g[m];
            }).set("completionPercent", function(m) {
                return l.g[m] + " (%)";
            }).set("bufferingTime", g).set("drmTimeSeconds", g).set("licenseTime", g).set("liveLatency", g).set("loadLatency", g).set("manifestTimeSeconds", g).set("estimatedBandwidth", f).set("streamBandwidth", f).set("maxSegmentDuration", g).set("pauseTime", e).set("playTime", e).set("corruptedFrames", h).set("decodedFrames", h).set("droppedFrames", h).set("stallsDetected", function(m) {
                return l.g[m] + " (stalls)";
            }).set("gapsJumped", d).set("manifestSizeBytes", c).set("bytesDownloaded", c).set("nonFatalErrorCount", function(m) {
                return l.g[m] + " (errors)";
            }).set("manifestPeriodCount", function(m) {
                return l.g[m] + " (periods)";
            }).set("manifestGapCount", d);
            this.j = new Uf(function() {
                l.g = l.player.getStats();
                for(var m = u(l.D), n = m.next(); !n.done; n = m.next()){
                    var q = n.value;
                    n = l.m.get(q);
                    n.textContent = l.C.get(q)(q);
                    n && n.parentElement && (q = l.g[q], typeof q == "string" ? OH(n.parentElement, q != "") : OH(n.parentElement, !isNaN(q)));
                }
            });
            pM(this);
            qM(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                pM(l);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                pM(l);
            });
            this.eventManager.u(this.i, "click", function() {
                rM(l);
                pM(l);
            });
        }
        oa(oM, IH);
        function rM(a) {
            a.h.classList.contains("shaka-hidden") ? (a.o.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm120-440q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.xa(.1), OH(a.h, !0)) : (a.o.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.stop(), OH(a.h, !1));
        }
        function pM(a) {
            a.A.textContent = a.localization.resolve("STATISTICS");
            a.i.ariaLabel = a.localization.resolve("STATISTICS");
            a.l.textContent = a.localization.resolve(a.h.classList.contains("shaka-hidden") ? "OFF" : "ON");
        }
        function sM(a, b) {
            var c = U("div"), d = U("label");
            d.textContent = b + ":";
            c.appendChild(d);
            d = U("span");
            d.textContent = a.C.get(b)(b);
            c.appendChild(d);
            a.m.set(b, d);
            return c;
        }
        function qM(a) {
            var b = U("div");
            b.classList.add("shaka-no-propagation");
            b.classList.add("shaka-statistics-close");
            var c = new JH(b, "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z").g;
            c.classList.add("material-icons", "notranslate");
            a.h.appendChild(b);
            a.eventManager.u(c, "click", function() {
                rM(a);
            });
            b = u(a.controls.g.statisticsList);
            for(c = b.next(); !c.done; c = b.next())if (c = c.value, c in a.g && !a.F.includes(c)) {
                var d = sM(a, c);
                a.h.appendChild(d);
                a.D.push(c);
            } else Za("Unrecognized statistic element:", c);
        }
        oM.prototype.release = function() {
            this.j.stop();
            this.j = null;
            IH.prototype.release.call(this);
        };
        O("shaka.ui.StatisticsButton", oM);
        function tM() {}
        tM.prototype.create = function(a, b) {
            return new oM(a, b);
        };
        MJ("statistics", new tM);
        TH("statistics", new tM);
        function uM(a, b) {
            pK.call(this, a, b, "M200-160q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h560q33 0 56.5 23.5T840-720v480q0 33-23.5 56.5T760-160H200Zm80-200h120q17 0 28.5-11.5T440-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T400-600H280q-17 0-28.5 11.5T240-560v160q0 17 11.5 28.5T280-360Zm400-240H560q-17 0-28.5 11.5T520-560v160q0 17 11.5 28.5T560-360h120q17 0 28.5-11.5T720-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T680-600Z");
            var c = this;
            this.button.classList.add("shaka-caption-button");
            this.button.classList.add("shaka-tooltip-status");
            this.menu.classList.add("shaka-text-languages");
            this.player && this.player.Tc() ? this.button.ariaPressed = "true" : this.button.ariaPressed = "false";
            vM(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                wM(c);
                xM(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                wM(c);
                xM(c);
            });
            this.eventManager.u(this.player, "loading", function() {
                yM(c);
                xM(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                yM(c);
                xM(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                yM(c);
                xM(c);
            });
            this.eventManager.u(this.player, "texttrackvisibility", function() {
                yM(c);
                xM(c);
            });
            this.eventManager.u(this.player, "textchanged", function() {
                xM(c);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                xM(c);
            });
            yM(this);
            wM(this);
            xM(this);
        }
        oa(uM, pK);
        function vM(a) {
            var b = ck();
            b.ariaSelected = "true";
            a.menu.appendChild(b);
            b.appendChild(NH());
            a.g = U("span");
            b.appendChild(a.g);
        }
        function yM(a) {
            a.player.Tc() ? (a.icon.use("M200-160q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h560q33 0 56.5 23.5T840-720v480q0 33-23.5 56.5T760-160H200Zm80-200h120q17 0 28.5-11.5T440-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T400-600H280q-17 0-28.5 11.5T240-560v160q0 17 11.5 28.5T280-360Zm400-240H560q-17 0-28.5 11.5T520-560v160q0 17 11.5 28.5T560-360h120q17 0 28.5-11.5T720-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T680-600Z"), a.button.ariaPressed = "true") : (a.icon.use("M791-57 687-160H200q-33 0-56.5-23.5T120-240v-487l-65-65q-12-12-12-28.5T55-849q12-12 28.5-12t28.5 12l736 736q12 12 12 28t-12 28q-12 12-28.5 12T791-57ZM280-360h120q17 0 28.5-11.5T440-400v-25q0-8-6-14t-14-6h-20q-8 0-14 6t-6 14v5h-80v-127l-45-45v1q-7 5-11 13t-4 18v160q0 17 11.5 28.5T280-360Zm560-360v388q0 27-24.5 37.5T772-303l-66-66q7-5 10.5-13.5T720-400v-20q0-8-6-14t-14-6h-20q-8 0-14 6t-6 14h-5l-75-75v-45h80v5q0 8 6 14t14 6h20q8 0 14-6t6-14v-25q0-17-11.5-28.5T680-600H560q-17 0-28.5 11.5T520-560v5L343-732q-19-19-8.5-43.5T372-800h388q33 0 56.5 23.5T840-720Z"), a.button.ariaPressed = "false");
            a.controls.dispatchEvent(new R("captionselectionupdated"));
        }
        function xM(a) {
            var b = a.player.yc() || [];
            oK(b, a.menu, function(d) {
                return zM(a, d);
            }, a.player.Tc(), a.currentSelection, a.localization, a.controls.g.textTrackLabelFormat);
            var c = ck();
            c.classList.add("shaka-turn-captions-off-button");
            a.eventManager.u(c, "click", function() {
                a.player.Xd(!1);
                xM(a);
            });
            c.appendChild(a.g);
            a.menu.appendChild(c);
            a.player.Tc() ? a.g.classList.remove("shaka-chosen-item") : (c.ariaSelected = "true", c.appendChild(NH()), a.g.classList.add("shaka-chosen-item"), a.currentSelection.textContent = a.localization.resolve("OFF"));
            a.button.setAttribute("shaka-status", a.currentSelection.textContent);
            MH(a.menu);
            a.controls.dispatchEvent(new R("captionselectionupdated"));
            OH(a.button, b.length > 0);
        }
        function zM(a, b) {
            return H(function(c) {
                if (c.h == 1) return a.player.gg(b), c.g(a.player.Xd(!0), 2);
                a.player.configure({
                    preferredTextLanguage: b.language,
                    preferForcedSubs: b.forced
                });
                c.j();
            });
        }
        function wM(a) {
            a.button.ariaLabel = a.localization.resolve("CAPTIONS");
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.nameSpan.textContent = a.localization.resolve("CAPTIONS");
            a.backSpan.textContent = a.localization.resolve("CAPTIONS");
            a.g.textContent = a.localization.resolve("OFF");
        }
        O("shaka.ui.TextSelection", uM);
        function AM() {}
        AM.prototype.create = function(a, b) {
            return new uM(a, b);
        };
        MJ("captions", new AM);
        gJ("captions", new AM);
        function BM(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-toggle-stereoscopic-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            new JH(this.g, "M620-360H520q-8 0-14-6t-6-14v-200q0-8 6-14t14-6h100q17 0 28.5 11.5T660-560v160q0 17-11.5 28.5T620-360Zm-200 0h-90q-13 0-21.5-8.5T300-390q0-13 8.5-21.5T330-420h70v-40h-40q-8 0-14-6t-6-14q0-8 6-14t14-6h40v-40h-70q-13 0-21.5-8.5T300-570q0-13 8.5-21.5T330-600h90q17 0 28.5 11.5T460-560v160q0 17-11.5 28.5T420-360Zm140-60h40v-120h-40v120Zm280-20q-17 0-28.5-11.5T800-480q0-115-72.5-203T542-794l30 30q11 11 11 28t-11 28q-11 11-28 11t-28-11L387-837q-8-8-4.5-20t14.5-15q20-5 41-6.5t42-1.5q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 17-11.5 28.5T840-440ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-17 11.5-28.5T120-520q17 0 28.5 11.5T160-480q0 115 72.5 203T418-166l-30-30q-11-11-11-28t11-28q11-11 28-11t28 11l129 129q8 8 4.5 20T563-88q-20 5-41 6.5T480-80Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.i = U("span");
            a.appendChild(this.i);
            this.h = U("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            CM(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                CM(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                CM(c);
            });
            var d = this.controls.D;
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && d.Yd();
            });
            this.eventManager.u(d, "vrstatuschanged", function() {
                OH(c.g, c.controls.Sb());
            });
            OH(this.g, this.controls.Sb());
        }
        oa(BM, IH);
        function CM(a) {
            a.g.ariaLabel = a.localization.resolve("TOGGLE_STEREOSCOPIC");
            a.i.textContent = a.localization.resolve("TOGGLE_STEREOSCOPIC");
        }
        O("shaka.ui.ToggleStereoscopicButton", BM);
        function DM() {}
        DM.prototype.create = function(a, b) {
            return new BM(a, b);
        };
        MJ("toggle_stereoscopic", new DM);
        gJ("toggle_stereoscopic", new DM);
    }).call(exportTo, innerGlobal, innerGlobal, undefined);
    for(var k in exportTo.shaka)module.exports[k] = exportTo.shaka[k];
})();

});


parcelRegister("5pxJW", function(module, exports) {



module.exports = function(app) {
    var env = window.nomalab.aws;
    var Evaporate = (parcelRequire("kB1JX"));
    var SparkMD5 = (parcelRequire("3D2Yk"));
    var sha256 = (parcelRequire("aPr3M")).sha256;
    var evaporateInstance;
    var uploadCount = 0;
    var wakeLocking = null;
    var elmToJs = app.ports.uploadToJs;
    var jsToElm = app.ports.uploadToElm;
    function evaporateIdGen(key) {
        return decodeURIComponent(evaporateInstance.config.bucket + '/' + key);
    }
    elmToJs.subscribe(function(evt) {
        console.log("Upload to Js", evt.name, evt.event);
        switch(evt.name){
            case 'Upload':
                upload(evt.event);
                break;
            case 'Pause':
                evaporateInstance.pause(evaporateIdGen(evt.event), {
                    force: true
                });
                break;
            case 'Resume':
                evaporateInstance.resume(evaporateIdGen(evt.event));
                break;
            case 'Cancel':
                evaporateInstance.cancel(evaporateIdGen(evt.event));
                break;
        }
    });
    function onEvent(name, event) {
        // console.log("Upload to Elm", name, event)
        jsToElm.send({
            name: name,
            event: event
        });
    }
    Evaporate.create({
        signerUrl: "/v3/aws/signature",
        aws_key: env.awsKey,
        bucket: env.s3Bucket,
        awsRegion: env.awsRegion,
        awsSignatureVersion: env.awsSigVersion.slice(-1),
        s3Acceleration: true,
        logging: false,
        onlyRetryForSameFileName: true,
        cryptoMd5Method: function(data) {
            return btoa(SparkMD5.ArrayBuffer.hash(data, true));
        },
        // cryptoHmacMethod: function (signingKey, stringToSign) {
        //   return '';
        // },
        cryptoHexEncodedHash256: function(data) {
            return sha256(data);
        },
        computeContentMd5: true,
        allowS3ExistenceOptimization: true,
        s3FileCacheHoursAgo: 5,
        partSize: 104857600,
        encodeFilename: false,
        cloudfront: true
    }).then(function(instance) {
        if (instance.supported) evaporateInstance = instance;
        else onUnsupported();
    }).catch(function(err) {
        console.log("couldn't start Evaporate", err);
        onUnsupported();
    });
    function onUnsupported() {
        onEvent("Unsupported");
    }
    function upload(settings) {
        var source = settings.source;
        var fileId = settings.fileId;
        var key = settings.key;
        var userId = settings.userId;
        var file = settings.file;
        // This is actually the same id as the internal of Evaporate
        // but do not rely on it
        var evaporateId = evaporateIdGen(key);
        var lastProgress = 0, progressThrottle = 10000;
        var config = {
            name: key,
            file: file.blob,
            xAmzHeadersAtInitiate: {
                'x-amz-meta-user': '' + userId,
                'x-amz-meta-filename': '' + btoa(encodeURI(file.name)),
                'x-amz-meta-mime_type': '' + encodeURI(file.mimeType),
                'x-amz-meta-upload_start_time': new Date().toISOString()
            },
            started: onStarted,
            pausing: onPausing,
            paused: onPaused,
            resumed: onResumed,
            complete: onComplete,
            error: onError,
            uploadInitiated: onUploadInitiated,
            cancelled: onCancelled,
            progress: function(percentage, stats) {
                if (percentage >= 1 || Date.now() - progressThrottle > lastProgress) {
                    lastProgress = Date.now();
                    onProgress(percentage, stats);
                }
            }
        };
        try {
            evaporateInstance.add(config, {
                signParams: {
                    fileId: fileId,
                    source: source
                }
            }).catch(function(err) {
                // the user probably cancelled the operation
                // but we will react on the event rather than here
                console.log("Upload break", err);
            });
            onInit();
        } catch (err) {
            onError(err);
        }
        function onInit() {
            uploadStarted();
            onEvent("Created", {
                id: evaporateId,
                fileId: fileId,
                s3Id: null,
                name: file.name,
                progress: 0,
                progressedAt: new Date().toISOString(),
                pausing: false,
                pausedAt: null,
                size: file.size,
                mimeType: file.mimeType,
                blob: file.blob,
                secondsLeft: null,
                completedAt: null,
                error: null
            });
        }
        function onStarted() {
            onEvent("Started", {
                fileId: fileId
            });
        }
        function onComplete(xhr, awsObjectKey, stats) {
            uploadEnded();
            onEvent("Completed", {
                fileId: fileId,
                stats: normalizeStats(stats),
                s3Key: awsObjectKey,
                completedAt: new Date().toISOString()
            });
        }
        function onError(error) {
            uploadEnded();
            onEvent("Error", {
                fileId: fileId,
                error: error.toString()
            });
        }
        function onProgress(percentage, stats) {
            onEvent("Progress", {
                fileId: fileId,
                stats: normalizeStats(stats),
                progress: percentage,
                at: new Date().toISOString()
            });
        }
        function onPausing() {
            onEvent("Pausing", {
                fileId: fileId
            });
        }
        function onPaused() {
            uploadEnded();
            onEvent("Paused", {
                fileId: fileId,
                at: new Date().toISOString()
            });
        }
        function onResumed() {
            uploadStarted();
            onEvent("Resumed", {
                fileId: fileId
            });
        }
        function onUploadInitiated(s3UploadId) {
            onEvent("UploadInitiated", {
                fileId: fileId,
                s3UploadId: s3UploadId
            });
        }
        function onNameChanged(awsObjectKey) {
            onEvent("NameChanged", {
                fileId: fileId,
                s3Key: awsObjectKey
            });
        }
        function onCancelled() {
            uploadEnded();
            onEvent("Cancelled", {
                fileId: fileId
            });
        }
    }
    function uploadStarted() {
        uploadCount++;
        if ('wakeLock' in navigator && !wakeLocking) navigator.wakeLock.request('screen').then(function(w) {
            wakeLocking = w;
        });
    }
    function uploadEnded() {
        uploadCount--;
        if (uploadCount < 1 && wakeLocking && wakeLocking.release) {
            wakeLocking.release('screen');
            wakeLocking = null;
        }
    }
    function normalizeStats(stats) {
        if (stats.secondsLeft < 0) stats.secondsLeft = null;
        else stats.secondsLeft = stats.secondsLeft;
        // Looks like Evaporate might have a speed at NaN when resuming an upload
        if (isNaN(stats.speed)) {
            stats.speed = 0;
            stats.readableSpeed = '';
        }
        return stats;
    }
    window.addEventListener('beforeunload', function(e) {
        if (uploadCount > 0) {
            var message = "Vous avez des uploads en cours, voulez-vous abandonner ?";
            e.returnValue = message;
            return message;
        } else return true;
    });
} // enf of exports
;

});
parcelRegister("kB1JX", function(module, exports) {
/*Copyright (c) 2016, TT Labs, Inc.
 All rights reserved.

 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

 Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.

 Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

 Neither the name of the TT Labs, Inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.*/ /***************************************************************************************************
 *                                                                                                 *
 *  version 2.1.4                                                                                  *
 *                                                                                                 *
 ***************************************************************************************************/ (function() {
    "use strict";
    var FAR_FUTURE = new Date('2060-10-22'), HOURS_AGO, PENDING = 0, EVAPORATING = 2, COMPLETE = 3, PAUSED = 4, CANCELED = 5, ERROR = 10, ABORTED = 20, PAUSING = 30, PAUSED_STATUSES = [
        PAUSED,
        PAUSING
    ], ACTIVE_STATUSES = [
        PENDING,
        EVAPORATING,
        ERROR
    ], ETAG_OF_0_LENGTH_BLOB = '"d41d8cd98f00b204e9800998ecf8427e"', PARTS_MONITOR_INTERVAL_MS = 120000, IMMUTABLE_OPTIONS = [
        'maxConcurrentParts',
        'logging',
        'cloudfront',
        'encodeFilename',
        'computeContentMd5',
        'allowS3ExistenceOptimization',
        'onlyRetryForSameFileName',
        'timeUrl',
        'cryptoMd5Method',
        'cryptoHexEncodedHash256',
        'awsRegion',
        'awsSignatureVersion',
        'evaporateChanged'
    ], S3_EXTRA_ENCODED_CHARS = {
        33: "%21",
        39: "%27",
        40: "%28",
        41: "%29",
        42: "%2A" // *
    }, l;
    var Evaporate = function(config) {
        this.config = extend({
            readableStreams: false,
            readableStreamPartMethod: null,
            bucket: null,
            logging: true,
            maxConcurrentParts: 5,
            partSize: 6291456,
            retryBackoffPower: 2,
            maxRetryBackoffSecs: 300,
            progressIntervalMS: 1000,
            cloudfront: false,
            s3Acceleration: false,
            mockLocalStorage: false,
            encodeFilename: true,
            computeContentMd5: false,
            allowS3ExistenceOptimization: false,
            onlyRetryForSameFileName: false,
            timeUrl: null,
            cryptoMd5Method: null,
            cryptoHexEncodedHash256: null,
            aws_key: null,
            awsRegion: 'us-east-1',
            awsSignatureVersion: '4',
            sendCanonicalRequestToSignerUrl: false,
            s3FileCacheHoursAgo: null,
            signParams: {},
            signHeaders: {},
            customAuthMethod: undefined,
            maxFileSize: null,
            signResponseHandler: null,
            xhrWithCredentials: false,
            // undocumented, experimental
            localTimeOffset: undefined,
            evaporateChanged: function() {},
            abortCompletionThrottlingMs: 1000
        }, config);
        if (typeof window !== 'undefined' && window.console) {
            l = window.console;
            l.d = l.log;
            l.w = window.console.warn ? l.warn : l.d;
            l.e = window.console.error ? l.error : l.d;
        }
        this._instantiationError = this.validateEvaporateOptions();
        if (typeof this._instantiationError === 'string') {
            this.supported = false;
            return;
        } else delete this._instantiationError;
        if (!this.config.logging) // Reset the logger to be a no_op
        l = noOpLogger();
        var _d = new Date();
        HOURS_AGO = new Date(_d.setHours(_d.getHours() - (this.config.s3FileCacheHoursAgo || -100)));
        if (typeof config.localTimeOffset === 'number') this.localTimeOffset = config.localTimeOffset;
        else {
            var self = this;
            Evaporate.getLocalTimeOffset(this.config).then(function(offset) {
                self.localTimeOffset = offset;
            });
        }
        this.pendingFiles = {};
        this.queuedFiles = [];
        this.filesInProcess = [];
        historyCache = new HistoryCache(this.config.mockLocalStorage);
    };
    Evaporate.create = function(config) {
        var evapConfig = extend({}, config);
        return Evaporate.getLocalTimeOffset(evapConfig).then(function(offset) {
            evapConfig.localTimeOffset = offset;
            return new Promise(function(resolve, reject) {
                var e = new Evaporate(evapConfig);
                if (e.supported === true) resolve(e);
                else reject(e._instantiationError);
            });
        });
    };
    Evaporate.getLocalTimeOffset = function(config) {
        return new Promise(function(resolve, reject) {
            if (typeof config.localTimeOffset === 'number') return resolve(config.localTimeOffset);
            if (config.timeUrl) {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", config.timeUrl + '?requestTime=' + new Date().getTime());
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            var server_date = new Date(Date.parse(xhr.responseText)), offset = server_date - new Date();
                            l.d('localTimeOffset is', offset, 'ms');
                            resolve(offset);
                        }
                    }
                };
                xhr.onerror = function(xhr) {
                    l.e('xhr error timeUrl', xhr);
                    reject('Fetching offset time failed with status: ' + xhr.status);
                };
                xhr.send();
            } else resolve(0);
        });
    };
    Evaporate.prototype.config = {};
    Evaporate.prototype.localTimeOffset = 0;
    Evaporate.prototype.supported = false;
    Evaporate.prototype._instantiationError = undefined;
    Evaporate.prototype.evaporatingCount = 0;
    Evaporate.prototype.pendingFiles = {};
    Evaporate.prototype.filesInProcess = [];
    Evaporate.prototype.queuedFiles = [];
    Evaporate.prototype.startNextFile = function(reason) {
        if (!this.queuedFiles.length || this.evaporatingCount >= this.config.maxConcurrentParts) return;
        var fileUpload = this.queuedFiles.shift();
        if (fileUpload.status === PENDING) {
            l.d('Starting', decodeURIComponent(fileUpload.name), 'reason:', reason);
            this.evaporatingCnt(1);
            fileUpload.start();
        } else {
            // Add the file back to the stack, it's not ready
            l.d('Requeued', decodeURIComponent(fileUpload.name), 'status:', fileUpload.status, 'reason:', reason);
            this.queuedFiles.push(fileUpload);
        }
    };
    Evaporate.prototype.fileCleanup = function(fileUpload) {
        removeAtIndex(this.queuedFiles, fileUpload);
        if (removeAtIndex(this.filesInProcess, fileUpload)) this.evaporatingCnt(-1);
        fileUpload.done();
        this.consumeRemainingSlots();
    };
    Evaporate.prototype.queueFile = function(fileUpload) {
        this.filesInProcess.push(fileUpload);
        this.queuedFiles.push(fileUpload);
        if (this.filesInProcess.length === 1) this.startNextFile('first file');
    };
    Evaporate.prototype.add = function(file, pConfig) {
        var self = this, fileConfig;
        return new Promise(function(resolve, reject) {
            var c = extend(pConfig, {});
            IMMUTABLE_OPTIONS.forEach(function(a) {
                delete c[a];
            });
            fileConfig = extend(self.config, c);
            if (typeof file === 'undefined' || typeof file.file === 'undefined') return reject('Missing file');
            if (fileConfig.maxFileSize && file.file.size > fileConfig.maxFileSize) return reject('File size too large. Maximum size allowed is ' + fileConfig.maxFileSize);
            if (typeof file.name === 'undefined') return reject('Missing attribute: name');
            if (fileConfig.encodeFilename) // correctly encode to an S3 object name, considering '/' and ' '
            file.name = s3EncodedObjectName(file.name);
            var fileUpload = new FileUpload(extend({
                started: function() {},
                uploadInitiated: function() {},
                progress: function() {},
                complete: function() {},
                cancelled: function() {},
                paused: function() {},
                resumed: function() {},
                pausing: function() {},
                nameChanged: function() {},
                info: function() {},
                warn: function() {},
                error: function() {},
                beforeSigner: undefined,
                xAmzHeadersAtInitiate: {},
                notSignedHeadersAtInitiate: {},
                xAmzHeadersCommon: null,
                xAmzHeadersAtUpload: {},
                xAmzHeadersAtComplete: {}
            }, file, {
                status: PENDING,
                priority: 0,
                loadedBytes: 0,
                sizeBytes: file.file.size,
                eTag: ''
            }), fileConfig, self), fileKey = fileUpload.id;
            self.pendingFiles[fileKey] = fileUpload;
            self.queueFile(fileUpload);
            // Resolve or reject the Add promise based on how the fileUpload completes
            fileUpload.deferredCompletion.promise.then(function() {
                self.fileCleanup(fileUpload);
                resolve(decodeURIComponent(fileUpload.name));
            }, function(reason) {
                self.fileCleanup(fileUpload);
                reject(reason);
            });
        });
    };
    Evaporate.prototype.cancel = function(id) {
        return typeof id === 'undefined' ? this._cancelAll() : this._cancelOne(id);
    };
    Evaporate.prototype._cancelAll = function() {
        l.d('Canceling all file uploads');
        var promises = [];
        for(var key in this.pendingFiles)if (this.pendingFiles.hasOwnProperty(key)) {
            var file = this.pendingFiles[key];
            if (ACTIVE_STATUSES.indexOf(file.status) > -1) promises.push(file.stop());
        }
        if (!promises.length) promises.push(Promise.reject('No files to cancel.'));
        return Promise.all(promises);
    };
    Evaporate.prototype._cancelOne = function(id) {
        var promise = [];
        if (this.pendingFiles[id]) promise.push(this.pendingFiles[id].stop());
        else promise.push(Promise.reject('File does not exist'));
        return Promise.all(promise);
    };
    Evaporate.prototype.pause = function(id, options) {
        options = options || {};
        var force = typeof options.force === 'undefined' ? false : options.force;
        return typeof id === 'undefined' ? this._pauseAll(force) : this._pauseOne(id, force);
    };
    Evaporate.prototype._pauseAll = function(force) {
        l.d('Pausing all file uploads');
        var promises = [];
        for(var key in this.pendingFiles)if (this.pendingFiles.hasOwnProperty(key)) {
            var file = this.pendingFiles[key];
            if (ACTIVE_STATUSES.indexOf(file.status) > -1) this._pause(file, force, promises);
        }
        return Promise.all(promises);
    };
    Evaporate.prototype._pauseOne = function(id, force) {
        var promises = [], file = this.pendingFiles[id];
        if (typeof file === 'undefined') promises.push(Promise.reject('Cannot pause a file that has not been added.'));
        else if (file.status === PAUSED) promises.push(Promise.reject('Cannot pause a file that is already paused.'));
        if (!promises.length) this._pause(file, force, promises);
        return Promise.all(promises);
    };
    Evaporate.prototype._pause = function(fileUpload, force, promises) {
        promises.push(fileUpload.pause(force));
        removeAtIndex(this.filesInProcess, fileUpload);
        removeAtIndex(this.queuedFiles, fileUpload);
    };
    Evaporate.prototype.resume = function(id) {
        return typeof id === 'undefined' ? this._resumeAll() : this._resumeOne(id);
    };
    Evaporate.prototype._resumeAll = function() {
        l.d('Resuming all file uploads');
        for(var key in this.pendingFiles)if (this.pendingFiles.hasOwnProperty(key)) {
            var file = this.pendingFiles[key];
            if (PAUSED_STATUSES.indexOf(file.status) > -1) this.resumeFile(file);
        }
        return Promise.resolve();
    };
    Evaporate.prototype._resumeOne = function(id) {
        var file = this.pendingFiles[id], promises = [];
        if (typeof file === 'undefined') promises.push(Promise.reject('Cannot pause a file that does not exist.'));
        else if (PAUSED_STATUSES.indexOf(file.status) === -1) promises.push(Promise.reject('Cannot resume a file that has not been paused.'));
        else this.resumeFile(file);
        return Promise.all(promises);
    };
    Evaporate.prototype.resumeFile = function(fileUpload) {
        fileUpload.resume();
        this.queueFile(fileUpload);
    };
    Evaporate.prototype.forceRetry = function() {};
    Evaporate.prototype.consumeRemainingSlots = function() {
        var avail = this.config.maxConcurrentParts - this.evaporatingCount;
        if (!avail) return;
        for(var i = 0; i < this.filesInProcess.length; i++){
            var file = this.filesInProcess[i];
            var consumed = file.consumeSlots();
            if (consumed < 0) continue;
            avail -= consumed;
            if (!avail) return;
        }
    };
    Evaporate.prototype.validateEvaporateOptions = function() {
        this.supported = !(typeof File === 'undefined' || typeof Promise === 'undefined');
        if (!this.supported) return 'Evaporate requires support for File and Promise';
        if (this.config.readableStreams) {
            if (typeof this.config.readableStreamPartMethod !== 'function') return "Option readableStreamPartMethod is required when readableStreams is set.";
        } else {
            if (typeof Blob === 'undefined' || typeof (Blob.prototype.webkitSlice || Blob.prototype.mozSlice || Blob.prototype.slice) === 'undefined') return 'Evaporate requires support for Blob [webkitSlice || mozSlice || slice]';
        }
        if (!this.config.signerUrl && typeof this.config.customAuthMethod !== 'function') return "Option signerUrl is required unless customAuthMethod is present.";
        if (!this.config.bucket) return "The AWS 'bucket' option must be present.";
        if (this.config.computeContentMd5) {
            this.supported = typeof FileReader.prototype.readAsArrayBuffer !== 'undefined';
            if (!this.supported) return 'The browser\'s FileReader object does not support readAsArrayBuffer';
            if (typeof this.config.cryptoMd5Method !== 'function') return 'Option computeContentMd5 has been set but cryptoMd5Method is not defined.';
            if (this.config.awsSignatureVersion === '4') {
                if (typeof this.config.cryptoHexEncodedHash256 !== 'function') return 'Option awsSignatureVersion is 4 but cryptoHexEncodedHash256 is not defined.';
            }
        } else if (this.config.awsSignatureVersion === '4') return 'Option awsSignatureVersion is 4 but computeContentMd5 is not enabled.';
        return true;
    };
    Evaporate.prototype.evaporatingCnt = function(incr) {
        this.evaporatingCount = Math.max(0, this.evaporatingCount + incr);
        this.config.evaporateChanged(this, this.evaporatingCount);
    };
    function FileUpload(file, con, evaporate) {
        this.fileTotalBytesUploaded = 0;
        this.s3Parts = [];
        this.partsOnS3 = [];
        this.partsInProcess = [];
        this.partsToUpload = [];
        this.numParts = -1;
        this.con = extend({}, con);
        this.evaporate = evaporate;
        this.localTimeOffset = evaporate.localTimeOffset;
        this.deferredCompletion = defer();
        extend(this, file);
        this.id = decodeURIComponent(this.con.bucket + '/' + this.name);
        this.signParams = con.signParams;
    }
    FileUpload.prototype.con = undefined;
    FileUpload.prototype.evaporate = undefined;
    FileUpload.prototype.localTimeOffset = 0;
    FileUpload.prototype.id = undefined;
    FileUpload.prototype.status = PENDING;
    FileUpload.prototype.numParts = -1;
    FileUpload.prototype.fileTotalBytesUploaded = 0;
    FileUpload.prototype.partsInProcess = [];
    FileUpload.prototype.partsToUpload = [];
    FileUpload.prototype.s3Parts = [];
    FileUpload.prototype.partsOnS3 = [];
    FileUpload.prototype.deferredCompletion = undefined;
    FileUpload.prototype.abortedByUser = false;
    // Progress and Stats
    FileUpload.prototype.progressInterval = undefined;
    FileUpload.prototype.startTime = undefined;
    FileUpload.prototype.loaded = 0;
    FileUpload.prototype.totalUploaded = 0;
    FileUpload.prototype.updateLoaded = function(loadedNow) {
        this.loaded += loadedNow;
        this.fileTotalBytesUploaded += loadedNow;
    };
    FileUpload.prototype.progessStats = function() {
        // Adapted from https://github.com/fkjaekel
        // https://github.com/TTLabs/EvaporateJS/issues/13
        if (this.fileTotalBytesUploaded === 0) return {
            speed: 0,
            readableSpeed: "",
            loaded: 0,
            totalUploaded: 0,
            remainingSize: this.sizeBytes,
            secondsLeft: -1,
            fileSize: this.sizeBytes
        };
        this.totalUploaded += this.loaded;
        var delta = (new Date() - this.startTime) / 1000, avgSpeed = this.totalUploaded / delta, remainingSize = this.sizeBytes - this.fileTotalBytesUploaded, stats = {
            speed: avgSpeed,
            readableSpeed: readableFileSize(avgSpeed),
            loaded: this.loaded,
            totalUploaded: this.fileTotalBytesUploaded,
            remainingSize: remainingSize,
            secondsLeft: -1,
            fileSize: this.sizeBytes
        };
        if (avgSpeed > 0) stats.secondsLeft = Math.round(remainingSize / avgSpeed);
        return stats;
    };
    FileUpload.prototype.onProgress = function() {
        if ([
            ABORTED,
            PAUSED
        ].indexOf(this.status) === -1) {
            this.progress(this.fileTotalBytesUploaded / this.sizeBytes, this.progessStats());
            this.loaded = 0;
        }
    };
    FileUpload.prototype.startMonitor = function() {
        clearInterval(this.progressInterval);
        this.startTime = new Date();
        this.loaded = 0;
        this.totalUploaded = 0;
        this.onProgress();
        this.progressInterval = setInterval(this.onProgress.bind(this), this.con.progressIntervalMS);
    };
    FileUpload.prototype.stopMonitor = function() {
        clearInterval(this.progressInterval);
    };
    // Evaporate proxies
    FileUpload.prototype.startNextFile = function(reason) {
        this.evaporate.startNextFile(reason);
    };
    FileUpload.prototype.evaporatingCnt = function(incr) {
        this.evaporate.evaporatingCnt(incr);
    };
    FileUpload.prototype.consumeRemainingSlots = function() {
        this.evaporate.consumeRemainingSlots();
    };
    FileUpload.prototype.getRemainingSlots = function() {
        var evapCount = this.evaporate.evaporatingCount;
        if (!this.partsInProcess.length && evapCount > 0) // we can use our file slot
        evapCount -= 1;
        return this.con.maxConcurrentParts - evapCount;
    };
    FileUpload.prototype.lastPartSatisfied = Promise.resolve('onStart');
    FileUpload.prototype.start = function() {
        this.status = EVAPORATING;
        this.startMonitor();
        this.started(this.id);
        if (this.uploadId) {
            l.d('resuming FileUpload ', this.id);
            return this.consumeSlots();
        }
        var awsKey = this.name;
        this.getUnfinishedFileUpload();
        var existenceOptimized = this.con.computeContentMd5 && this.con.allowS3ExistenceOptimization && typeof this.firstMd5Digest !== 'undefined' && typeof this.eTag !== 'undefined';
        if (this.uploadId) {
            if (existenceOptimized) return this.reuseS3Object(awsKey).then(this.deferredCompletion.resolve).catch(this.uploadFileFromScratch.bind(this));
            this.resumeInterruptedUpload().then(this._uploadComplete.bind(this)).catch(this.uploadFileFromScratch.bind(this));
        } else this.uploadFileFromScratch("");
    };
    FileUpload.prototype.uploadFileFromScratch = function(reason) {
        if (ACTIVE_STATUSES.indexOf(this.status) === -1) return;
        l.d(reason);
        this.uploadId = undefined;
        return this.uploadFile(this.name).then(this._uploadComplete.bind(this)).catch(this._abortUpload.bind(this));
    };
    FileUpload.prototype._uploadComplete = function() {
        this.completeUpload().then(this.deferredCompletion.resolve);
    };
    FileUpload.prototype.stop = function() {
        l.d('stopping FileUpload ', this.id);
        this.setStatus(CANCELED);
        this.info('Canceling uploads...');
        this.abortedByUser = true;
        var self = this;
        return this.abortUpload().then(function() {
            throw "User aborted the upload";
        }).catch(function(reason) {
            self.deferredCompletion.reject(reason);
        });
    };
    FileUpload.prototype.pause = function(force) {
        l.d('pausing FileUpload, force:', !!force, this.id);
        var promises = [];
        this.info('Pausing uploads...');
        this.status = PAUSING;
        if (force) this.abortParts(true);
        else {
            promises = this.partsInProcess.map(function(p) {
                return this.s3Parts[p].awsRequest.awsDeferred.promise;
            }, this);
            this.pausing();
        }
        return Promise.all(promises).then((function() {
            this.stopMonitor();
            this.status = PAUSED;
            this.startNextFile('pause');
            this.paused();
        }).bind(this));
    };
    FileUpload.prototype.resume = function() {
        this.status = PENDING;
        this.resumed();
    };
    FileUpload.prototype.done = function() {
        clearInterval(this.progressInterval);
        this.startNextFile('file done');
        this.partsOnS3 = [];
        this.s3Parts = [];
    };
    FileUpload.prototype._startCompleteUpload = function(callComplete) {
        return function() {
            var promise = callComplete ? this.completeUpload() : Promise.resolve();
            promise.then(this.deferredCompletion.resolve.bind(this));
        };
    };
    FileUpload.prototype._abortUpload = function() {
        if (!this.abortedByUser) {
            var self = this;
            this.abortUpload().then(function() {
                self.deferredCompletion.reject('File upload aborted due to a part failing to upload');
            }, this.deferredCompletion.reject.bind(this));
        }
    };
    FileUpload.prototype.abortParts = function(pause) {
        var self = this;
        var toAbort = this.partsInProcess.slice(0);
        toAbort.forEach(function(i) {
            var s3Part = self.s3Parts[i];
            if (s3Part) {
                s3Part.awsRequest.abort();
                if (pause) s3Part.status = PENDING;
                removeAtIndex(self.partsInProcess, s3Part.partNumber);
                if (self.partsToUpload.length) self.evaporatingCnt(-1);
            }
        });
    };
    FileUpload.prototype.makeParts = function(firstPart) {
        this.numParts = Math.ceil(this.sizeBytes / this.con.partSize) || 1; // issue #58
        var partsDeferredPromises = [];
        var self = this;
        function cleanUpAfterPart(s3Part) {
            removeAtIndex(self.partsToUpload, s3Part.partNumber);
            removeAtIndex(self.partsInProcess, s3Part.partNumber);
            if (self.partsToUpload.length) self.evaporatingCnt(-1);
        }
        function resolve(s3Part) {
            return function() {
                cleanUpAfterPart(s3Part);
                if (self.partsToUpload.length) self.consumeRemainingSlots();
                if (self.partsToUpload.length < self.con.maxConcurrentParts) self.startNextFile('part resolve');
            };
        }
        function reject(s3Part) {
            return function() {
                cleanUpAfterPart(s3Part);
            };
        }
        var limit = firstPart ? 1 : this.numParts;
        for(var part = 1; part <= limit; part++){
            var s3Part = this.s3Parts[part];
            if (typeof s3Part !== "undefined") {
                if (s3Part.status === COMPLETE) continue;
            } else s3Part = this.makePart(part, PENDING, this.sizeBytes);
            s3Part.awsRequest = new PutPart(this, s3Part);
            s3Part.awsRequest.awsDeferred.promise.then(resolve(s3Part), reject(s3Part));
            this.partsToUpload.push(part);
            partsDeferredPromises.push(this.s3Parts[part].awsRequest.awsDeferred.promise);
        }
        return partsDeferredPromises;
    };
    FileUpload.prototype.makePart = function(partNumber, status, size) {
        var s3Part = {
            status: status,
            loadedBytes: 0,
            loadedBytesPrevious: null,
            isEmpty: size === 0,
            md5_digest: null,
            partNumber: partNumber
        };
        this.s3Parts[partNumber] = s3Part;
        return s3Part;
    };
    FileUpload.prototype.setStatus = function(s) {
        this.status = s;
    };
    FileUpload.prototype.createUploadFile = function() {
        if (this.status === ABORTED) return;
        var fileKey = uploadKey(this), newUpload = {
            awsKey: this.name,
            bucket: this.con.bucket,
            uploadId: this.uploadId,
            fileSize: this.sizeBytes,
            fileType: this.file.type,
            lastModifiedDate: dateISOString(this.file.lastModified),
            partSize: this.con.partSize,
            signParams: this.con.signParams,
            createdAt: new Date().toISOString()
        };
        saveUpload(fileKey, newUpload);
    };
    FileUpload.prototype.updateUploadFile = function(updates) {
        var fileKey = uploadKey(this), uploads = getSavedUploads(), upload = extend({}, uploads[fileKey], updates);
        saveUpload(fileKey, upload);
    };
    FileUpload.prototype.completeUploadFile = function(xhr) {
        var uploads = getSavedUploads(), upload = uploads[uploadKey(this)];
        if (typeof upload !== 'undefined') {
            upload.completedAt = new Date().toISOString();
            upload.eTag = this.eTag;
            upload.firstMd5Digest = this.firstMd5Digest;
            uploads[uploadKey(this)] = upload;
            historyCache.setItem('awsUploads', JSON.stringify(uploads));
        }
        this.complete(xhr, this.name, this.progessStats());
        this.setStatus(COMPLETE);
        this.onProgress();
    };
    FileUpload.prototype.removeUploadFile = function() {
        if (typeof this.file !== 'undefined') removeUpload(uploadKey(this));
    };
    FileUpload.prototype.getUnfinishedFileUpload = function() {
        var savedUploads = getSavedUploads(true), u = savedUploads[uploadKey(this)];
        if (this.canRetryUpload(u)) {
            this.uploadId = u.uploadId;
            this.name = u.awsKey;
            this.eTag = u.eTag;
            this.firstMd5Digest = u.firstMd5Digest;
            this.signParams = u.signParams;
        }
    };
    FileUpload.prototype.canRetryUpload = function(u) {
        // Must be the same file name, file size, last_modified, file type as previous upload
        if (typeof u === 'undefined') return false;
        var completedAt = new Date(u.completedAt || FAR_FUTURE);
        // check that the part sizes and bucket match, and if the file name of the upload
        // matches if onlyRetryForSameFileName is true
        return this.con.partSize === u.partSize && completedAt > HOURS_AGO && this.con.bucket === u.bucket && (this.con.onlyRetryForSameFileName ? this.name === u.awsKey : true);
    };
    FileUpload.prototype.partSuccess = function(eTag, putRequest) {
        var part = putRequest.part;
        l.d(putRequest.request.step, 'ETag:', eTag);
        if (part.isEmpty || eTag !== ETAG_OF_0_LENGTH_BLOB) {
            part.eTag = eTag;
            part.status = COMPLETE;
            this.partsOnS3.push(part);
            return true;
        } else {
            part.status = ERROR;
            putRequest.resetLoadedBytes();
            var msg = [
                'eTag matches MD5 of 0 length blob for part #',
                putRequest.partNumber,
                'Retrying part.'
            ].join(" ");
            l.w(msg);
            this.warn(msg);
        }
    };
    FileUpload.prototype.listPartsSuccess = function(listPartsRequest, partsXml) {
        this.info('uploadId', this.uploadId, 'is not complete. Fetching parts from part marker', listPartsRequest.partNumberMarker);
        partsXml = partsXml.replace(/(\r\n|\n|\r)/gm, ""); // strip line breaks to ease the regex requirements
        var partRegex = /<Part>(.+?)<\/Part\>/g;
        while(true){
            var cp = (partRegex.exec(partsXml) || [])[1];
            if (!cp) break;
            var partSize = parseInt(elementText(cp, "Size"), 10);
            this.fileTotalBytesUploaded += partSize;
            this.partsOnS3.push({
                eTag: elementText(cp, "ETag").replace(/&quot;/g, '"'),
                partNumber: parseInt(elementText(cp, "PartNumber"), 10),
                size: partSize,
                LastModified: elementText(cp, "LastModified")
            });
        }
        return elementText(partsXml, "IsTruncated") === 'true' ? elementText(partsXml, "NextPartNumberMarker") : undefined;
    };
    FileUpload.prototype.makePartsfromPartsOnS3 = function() {
        if (ACTIVE_STATUSES.indexOf(this.status) === -1) return;
        this.nameChanged(this.name);
        this.partsOnS3.forEach((function(cp) {
            var uploadedPart = this.makePart(cp.partNumber, COMPLETE, cp.size);
            uploadedPart.eTag = cp.eTag;
            uploadedPart.loadedBytes = cp.size;
            uploadedPart.loadedBytesPrevious = cp.size;
            uploadedPart.finishedUploadingAt = cp.LastModified;
        }).bind(this));
    };
    FileUpload.prototype.completeUpload = function() {
        var self = this;
        return new CompleteMultipartUpload(this).send().then(function(xhr) {
            self.eTag = elementText(xhr.responseText, "ETag").replace(/&quot;/g, '"');
            self.completeUploadFile(xhr);
        });
    };
    FileUpload.prototype.getCompletedPayload = function() {
        var completeDoc = [];
        completeDoc.push('<CompleteMultipartUpload>');
        this.s3Parts.forEach(function(part, partNumber) {
            if (partNumber > 0) [
                '<Part><PartNumber>',
                partNumber,
                '</PartNumber><ETag>',
                part.eTag,
                '</ETag></Part>'
            ].forEach(function(a) {
                completeDoc.push(a);
            });
        });
        completeDoc.push('</CompleteMultipartUpload>');
        return completeDoc.join("");
    };
    FileUpload.prototype.consumeSlots = function() {
        if (this.partsToUpload.length === 0) return -1;
        if (this.partsToUpload.length !== this.partsInProcess.length && this.status === EVAPORATING) {
            var partsToUpload = Math.min(this.getRemainingSlots(), this.partsToUpload.length);
            if (!partsToUpload) return -1;
            var satisfied = 0;
            for(var i = 0; i < this.partsToUpload.length; i++){
                var s3Part = this.s3Parts[this.partsToUpload[i]];
                if (s3Part.status === EVAPORATING) continue;
                if (this.canStartPart(s3Part)) {
                    if (this.partsInProcess.length && this.partsToUpload.length > 1) this.evaporatingCnt(1);
                    this.partsInProcess.push(s3Part.partNumber);
                    var awsRequest = s3Part.awsRequest;
                    this.lastPartSatisfied.then(awsRequest.delaySend.bind(awsRequest));
                    this.lastPartSatisfied = awsRequest.getStartedPromise();
                } else continue;
                satisfied += 1;
                if (satisfied === partsToUpload) break;
            }
            var allInProcess = this.partsToUpload.length === this.partsInProcess.length, remainingSlots = this.getRemainingSlots();
            if (allInProcess && remainingSlots > 0) // We don't need any more slots...
            this.startNextFile('consume slots');
            return remainingSlots;
        }
        return 0;
    };
    FileUpload.prototype.canStartPart = function(part) {
        return this.partsInProcess.indexOf(part.partNumber) === -1 && !part.awsRequest.errorExceptionStatus();
    };
    FileUpload.prototype.uploadFile = function(awsKey) {
        this.removeUploadFile();
        var self = this;
        return new InitiateMultipartUpload(self, awsKey).send().then(function() {
            self.uploadInitiated(self.uploadId);
            self.partsToUpload = [];
            return self.uploadParts().then(function() {}, function(reason) {
                throw reason;
            });
        });
    };
    FileUpload.prototype.uploadParts = function() {
        this.loaded = 0;
        this.totalUploaded = 0;
        if (ACTIVE_STATUSES.indexOf(this.status) === -1) return Promise.reject('Part uploading stopped because the file was canceled');
        var promises = this.makeParts();
        this.setStatus(EVAPORATING);
        this.startTime = new Date();
        this.consumeSlots();
        return Promise.all(promises);
    };
    FileUpload.prototype.abortUpload = function() {
        return new Promise((function(resolve, reject) {
            if (typeof this.uploadId === 'undefined') {
                resolve();
                return;
            }
            new DeleteMultipartUpload(this).send().then(resolve, reject);
        }).bind(this)).then((function() {
            this.setStatus(ABORTED);
            this.cancelled();
            this.removeUploadFile();
        }).bind(this), this.deferredCompletion.reject.bind(this));
    };
    FileUpload.prototype.resumeInterruptedUpload = function() {
        return new ResumeInterruptedUpload(this).send().then(this.uploadParts.bind(this));
    };
    FileUpload.prototype.reuseS3Object = function(awsKey) {
        var self = this;
        // Attempt to reuse entire uploaded object on S3
        this.makeParts(1);
        this.partsToUpload = [];
        var firstS3Part = this.s3Parts[1];
        function reject(reason) {
            self.name = awsKey;
            throw reason;
        }
        return firstS3Part.awsRequest.getPartMd5Digest().then(function() {
            if (self.firstMd5Digest === firstS3Part.md5_digest) return new ReuseS3Object(self, awsKey).send().then(function(xhr) {
                l.d('headObject found matching object on S3.');
                self.completeUploadFile(xhr);
                self.nameChanged(self.name);
            }).catch(reject);
            else {
                var msg = self.con.allowS3ExistenceOptimization ? 'File\'s first part MD5 digest does not match what was stored.' : 'allowS3ExistenceOptimization is not enabled.';
                reject(msg);
            }
        });
    };
    function SignedS3AWSRequest(fileUpload, request) {
        this.fileUpload = fileUpload;
        this.con = fileUpload.con;
        this.attempts = 1;
        this.localTimeOffset = this.fileUpload.localTimeOffset;
        this.awsDeferred = defer();
        this.started = defer();
        this.awsUrl = awsUrl(this.con);
        this.awsHost = uri(this.awsUrl).hostname;
        var r = extend({}, request);
        if (fileUpload.contentType) r.contentType = fileUpload.contentType;
        this.updateRequest(r);
    }
    SignedS3AWSRequest.prototype.fileUpload = undefined;
    SignedS3AWSRequest.prototype.con = undefined;
    SignedS3AWSRequest.prototype.awsUrl = undefined;
    SignedS3AWSRequest.prototype.awsHost = undefined;
    SignedS3AWSRequest.prototype.authorize = function() {};
    SignedS3AWSRequest.prototype.localTimeOffset = 0;
    SignedS3AWSRequest.prototype.awsDeferred = undefined;
    SignedS3AWSRequest.prototype.started = undefined;
    SignedS3AWSRequest.prototype.getPath = function() {
        var path = '/' + this.con.bucket + '/' + this.fileUpload.name;
        if (this.con.cloudfront || this.awsUrl.indexOf('cloudfront') > -1) path = '/' + this.fileUpload.name;
        return path;
    };
    SignedS3AWSRequest.prototype.updateRequest = function(request) {
        this.request = request;
        var SigningClass = signingVersion(this, l);
        this.signer = new SigningClass(request);
    };
    SignedS3AWSRequest.prototype.success = function() {
        this.awsDeferred.resolve(this.currentXhr);
    };
    SignedS3AWSRequest.prototype.backOffWait = function() {
        return this.attempts === 1 ? 0 : 1000 * Math.min(this.con.maxRetryBackoffSecs, Math.pow(this.con.retryBackoffPower, this.attempts - 2));
    };
    SignedS3AWSRequest.prototype.error = function(reason) {
        if (this.errorExceptionStatus()) return;
        this.signer.error();
        l.d(this.request.step, 'error:', this.fileUpload.id, reason);
        if (typeof this.errorHandler(reason) !== 'undefined') return;
        this.fileUpload.warn('Error in ', this.request.step, reason);
        this.fileUpload.setStatus(ERROR);
        var self = this, backOffWait = this.backOffWait();
        this.attempts += 1;
        setTimeout(function() {
            if (!self.errorExceptionStatus()) self.trySend();
        }, backOffWait);
    };
    SignedS3AWSRequest.prototype.errorHandler = function() {};
    SignedS3AWSRequest.prototype.errorExceptionStatus = function() {
        return false;
    };
    SignedS3AWSRequest.prototype.getPayload = function() {
        return Promise.resolve(null);
    };
    SignedS3AWSRequest.prototype.success_status = function(xhr) {
        return xhr.status >= 200 && xhr.status <= 299 || this.request.success404 && xhr.status === 404;
    };
    SignedS3AWSRequest.prototype.stringToSign = function() {
        return encodeURIComponent(this.signer.stringToSign());
    };
    SignedS3AWSRequest.prototype.canonicalRequest = function() {
        return this.signer.canonicalRequest();
    };
    SignedS3AWSRequest.prototype.signResponse = function(payload, stringToSign, signatureDateTime) {
        var self = this;
        return new Promise(function(resolve) {
            if (typeof self.con.signResponseHandler === 'function') return self.con.signResponseHandler(payload, stringToSign, signatureDateTime).then(resolve);
            resolve(payload);
        });
    };
    SignedS3AWSRequest.prototype.sendRequestToAWS = function() {
        var self = this;
        return new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            self.currentXhr = xhr;
            var url = [
                self.awsUrl,
                self.getPath(),
                self.request.path
            ].join(""), all_headers = {};
            if (self.request.query_string) url += self.request.query_string;
            extend(all_headers, self.request.not_signed_headers);
            extend(all_headers, self.request.x_amz_headers);
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (self.success_status(xhr)) {
                        if (self.request.response_match && xhr.response.match(new RegExp(self.request.response_match)) === undefined) reject('AWS response does not match set pattern: ' + self.request.response_match);
                        else resolve();
                    } else {
                        var reason = xhr.responseText ? getAwsResponse(xhr) : ' ';
                        reason += 'status:' + xhr.status;
                        reject(reason);
                    }
                }
            };
            xhr.open(self.request.method, url);
            xhr.setRequestHeader('Authorization', self.signer.authorizationString());
            for(var key in all_headers)if (all_headers.hasOwnProperty(key)) xhr.setRequestHeader(key, all_headers[key]);
            self.signer.setHeaders(xhr);
            if (self.request.contentType) xhr.setRequestHeader('Content-Type', self.request.contentType);
            if (self.request.md5_digest) xhr.setRequestHeader('Content-MD5', self.request.md5_digest);
            xhr.onerror = function(xhr) {
                var reason = xhr.responseText ? getAwsResponse(xhr) : 'transport error';
                reject(reason);
            };
            if (typeof self.request.onProgress === 'function') xhr.upload.onprogress = self.request.onProgress;
            self.getPayload().then(xhr.send.bind(xhr), reject);
            setTimeout(function() {
                self.started.resolve('request sent ' + self.request.step);
            }, 20);
            self.signer.payload = null;
            self.payloadPromise = undefined;
        });
    };
    //see: http://docs.amazonwebservices.com/AmazonS3/latest/dev/RESTAuthentication.html#ConstructingTheAuthenticationHeader
    SignedS3AWSRequest.prototype.authorize = function() {
        this.request.dateString = this.signer.dateString(this.localTimeOffset);
        this.request.x_amz_headers = extend(this.request.x_amz_headers, {
            'x-amz-date': this.request.dateString
        });
        return this.signer.getPayload().then((function() {
            return authorizationMethod(this).authorize();
        }).bind(this));
    };
    SignedS3AWSRequest.prototype.authorizationSuccess = function(authorization) {
        l.d(this.request.step, 'signature:', authorization);
        this.request.auth = authorization;
    };
    SignedS3AWSRequest.prototype.trySend = function() {
        var self = this;
        return this.authorize().then(function(value) {
            self.authorizationSuccess(value);
            if (self.fileUpload.status === ABORTED) return;
            self.sendRequestToAWS().then(self.success.bind(self), self.error.bind(self));
        }, self.error.bind(self));
    };
    SignedS3AWSRequest.prototype.send = function() {
        this.trySend();
        return this.awsDeferred.promise;
    };
    function CancelableS3AWSRequest(fileUpload, request) {
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    CancelableS3AWSRequest.prototype = Object.create(SignedS3AWSRequest.prototype);
    CancelableS3AWSRequest.prototype.constructor = CancelableS3AWSRequest;
    CancelableS3AWSRequest.prototype.errorExceptionStatus = function() {
        return [
            ABORTED,
            CANCELED
        ].indexOf(this.fileUpload.status) > -1;
    };
    function SignedS3AWSRequestWithRetryLimit(fileUpload, request, maxRetries) {
        if (maxRetries > -1) this.maxRetries = maxRetries;
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    SignedS3AWSRequestWithRetryLimit.prototype = Object.create(CancelableS3AWSRequest.prototype);
    SignedS3AWSRequestWithRetryLimit.prototype.constructor = SignedS3AWSRequestWithRetryLimit;
    SignedS3AWSRequestWithRetryLimit.prototype.maxRetries = 1;
    SignedS3AWSRequestWithRetryLimit.prototype.errorHandler = function(reason) {
        if (this.attempts > this.maxRetries) {
            var msg = [
                'MaxRetries exceeded. Will re-upload file id ',
                this.fileUpload.id,
                ', ',
                reason
            ].join("");
            l.w(msg);
            this.awsDeferred.reject(msg);
            return true;
        }
    };
    SignedS3AWSRequestWithRetryLimit.prototype.rejectedSuccess = function() {
        var reason = Array.prototype.slice.call(arguments, 1).join("");
        this.awsDeferred.reject(reason);
        return false;
    };
    // see: http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadInitiate.html
    function InitiateMultipartUpload(fileUpload, awsKey) {
        var request = {
            method: 'POST',
            path: '?uploads',
            step: 'initiate',
            x_amz_headers: fileUpload.xAmzHeadersAtInitiate,
            not_signed_headers: fileUpload.notSignedHeadersAtInitiate,
            response_match: '<UploadId>(.+)<\/UploadId>'
        };
        CancelableS3AWSRequest.call(this, fileUpload, request);
        this.awsKey = awsKey;
    }
    InitiateMultipartUpload.prototype = Object.create(CancelableS3AWSRequest.prototype);
    InitiateMultipartUpload.prototype.constructor = InitiateMultipartUpload;
    InitiateMultipartUpload.prototype.success = function() {
        var match = this.currentXhr.response.match(new RegExp(this.request.response_match));
        this.fileUpload.uploadId = match[1];
        this.fileUpload.awsKey = this.awsKey;
        l.d('InitiateMultipartUpload ID is', this.fileUpload.uploadId);
        this.fileUpload.createUploadFile();
        this.awsDeferred.resolve(this.currentXhr);
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadComplete.html
    function CompleteMultipartUpload(fileUpload) {
        fileUpload.info('will attempt to complete upload');
        var request = {
            method: 'POST',
            contentType: 'application/xml; charset=UTF-8',
            path: '?uploadId=' + fileUpload.uploadId,
            x_amz_headers: fileUpload.xAmzHeadersCommon || fileUpload.xAmzHeadersAtComplete,
            step: 'complete'
        };
        CancelableS3AWSRequest.call(this, fileUpload, request);
    }
    CompleteMultipartUpload.prototype = Object.create(CancelableS3AWSRequest.prototype);
    CompleteMultipartUpload.prototype.constructor = CompleteMultipartUpload;
    CompleteMultipartUpload.prototype.getPayload = function() {
        return Promise.resolve(this.fileUpload.getCompletedPayload());
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadComplete.html
    function ReuseS3Object(fileUpload, awsKey) {
        this.awsKey = awsKey;
        fileUpload.info('will attempt to verify existence of the file');
        var request = {
            method: 'HEAD',
            path: '',
            x_amz_headers: fileUpload.xAmzHeadersCommon,
            success404: true,
            step: 'head_object'
        };
        SignedS3AWSRequestWithRetryLimit.call(this, fileUpload, request);
    }
    ReuseS3Object.prototype = Object.create(SignedS3AWSRequestWithRetryLimit.prototype);
    ReuseS3Object.prototype.constructor = ReuseS3Object;
    ReuseS3Object.prototype.awsKey = undefined;
    ReuseS3Object.prototype.success = function() {
        var eTag = this.currentXhr.getResponseHeader('Etag');
        if (eTag !== this.fileUpload.eTag && !this.rejectedSuccess('uploadId ', this.fileUpload.id, ' found on S3 but the Etag doesn\'t match.')) return;
        this.awsDeferred.resolve(this.currentXhr);
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadListParts.html
    function ResumeInterruptedUpload(fileUpload) {
        SignedS3AWSRequestWithRetryLimit.call(this, fileUpload);
        this.updateRequest(this.setupRequest(0));
    }
    ResumeInterruptedUpload.prototype = Object.create(SignedS3AWSRequestWithRetryLimit.prototype);
    ResumeInterruptedUpload.prototype.constructor = ResumeInterruptedUpload;
    ResumeInterruptedUpload.prototype.awsKey = undefined;
    ResumeInterruptedUpload.prototype.partNumberMarker = 0;
    ResumeInterruptedUpload.prototype.setupRequest = function(partNumberMarker) {
        var msg = [
            'setupRequest() for uploadId:',
            this.fileUpload.uploadId,
            'for part marker:',
            partNumberMarker
        ].join(" ");
        l.d(msg);
        this.fileUpload.info(msg);
        this.awsKey = this.fileUpload.name;
        this.partNumberMarker = partNumberMarker;
        var request = {
            method: 'GET',
            path: [
                '?uploadId=',
                this.fileUpload.uploadId
            ].join(""),
            query_string: "&part-number-marker=" + partNumberMarker,
            x_amz_headers: this.fileUpload.xAmzHeadersCommon,
            step: 'get upload parts',
            success404: true
        };
        this.request = request;
        return request;
    };
    ResumeInterruptedUpload.prototype.success = function() {
        if (this.currentXhr.status === 404) {
            // Success! Upload is no longer recognized, so there is nothing to fetch
            if (this.rejectedSuccess('uploadId ', this.fileUpload.id, ' not found on S3.')) this.awsDeferred.resolve(this.currentXhr);
            return;
        }
        var nextPartNumber = this.fileUpload.listPartsSuccess(this, this.currentXhr.responseText);
        if (nextPartNumber) {
            var request = this.setupRequest(nextPartNumber); // let's fetch the next set of parts
            this.updateRequest(request);
            this.trySend();
        } else {
            this.fileUpload.makePartsfromPartsOnS3();
            this.awsDeferred.resolve(this.currentXhr);
        }
    };
    //http://docs.aws.amazon.com/AmazonS3/latest/API/mpUploadUploadPart.html
    function PutPart(fileUpload, part) {
        this.part = part;
        this.partNumber = part.partNumber;
        this.start = (this.partNumber - 1) * fileUpload.con.partSize;
        this.end = Math.min(this.partNumber * fileUpload.con.partSize, fileUpload.sizeBytes);
        var request = {
            method: 'PUT',
            path: '?partNumber=' + this.partNumber + '&uploadId=' + fileUpload.uploadId,
            step: 'upload #' + this.partNumber,
            x_amz_headers: fileUpload.xAmzHeadersCommon || fileUpload.xAmzHeadersAtUpload,
            contentSha256: "UNSIGNED-PAYLOAD",
            onProgress: this.onProgress.bind(this)
        };
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    PutPart.prototype = Object.create(SignedS3AWSRequest.prototype);
    PutPart.prototype.constructor = PutPart;
    PutPart.prototype.part = 1;
    PutPart.prototype.payloadPromise = undefined;
    PutPart.prototype.start = 0;
    PutPart.prototype.end = 0;
    PutPart.prototype.partNumber = undefined;
    PutPart.prototype.getPartMd5Digest = function() {
        var self = this, part = this.part;
        return new Promise(function(resolve, reject) {
            if (self.con.computeContentMd5 && !part.md5_digest) self.getPayload().then(function(data) {
                var md5_digest = self.con.cryptoMd5Method(data);
                if (self.partNumber === 1 && self.con.computeContentMd5 && typeof self.fileUpload.firstMd5Digest === "undefined") {
                    self.fileUpload.firstMd5Digest = md5_digest;
                    self.fileUpload.updateUploadFile({
                        firstMd5Digest: md5_digest
                    });
                }
                resolve(md5_digest);
            }, reject);
            else resolve(part.md5_digest);
        }).then(function(md5_digest) {
            if (md5_digest) {
                l.d(self.request.step, 'MD5 digest:', md5_digest);
                self.request.md5_digest = md5_digest;
                self.part.md5_digest = md5_digest;
            }
        });
    };
    PutPart.prototype.sendRequestToAWS = function() {
        this.stalledInterval = setInterval(this.stalledPartMonitor(), PARTS_MONITOR_INTERVAL_MS);
        this.stalledPartMonitor();
        return SignedS3AWSRequest.prototype.sendRequestToAWS.call(this);
    };
    PutPart.prototype.send = function() {
        if (this.part.status !== COMPLETE && [
            ABORTED,
            PAUSED,
            CANCELED
        ].indexOf(this.fileUpload.status) === -1) {
            l.d('uploadPart #', this.partNumber, this.attempts === 1 ? 'submitting' : 'retrying');
            this.part.status = EVAPORATING;
            this.attempts += 1;
            this.part.loadedBytesPrevious = null;
            var self = this;
            return this.getPartMd5Digest().then(function() {
                l.d('Sending', self.request.step);
                SignedS3AWSRequest.prototype.send.call(self);
            });
        }
    };
    PutPart.prototype.success = function() {
        clearInterval(this.stalledInterval);
        var eTag = this.currentXhr.getResponseHeader('ETag');
        this.currentXhr = null;
        if (this.fileUpload.partSuccess(eTag, this)) this.awsDeferred.resolve(this.currentXhr);
    };
    PutPart.prototype.onProgress = function(evt) {
        if (evt.loaded > 0) {
            var loadedNow = evt.loaded - this.part.loadedBytes;
            if (loadedNow) {
                this.part.loadedBytes = evt.loaded;
                this.fileUpload.updateLoaded(loadedNow);
            }
        }
    };
    PutPart.prototype.stalledPartMonitor = function() {
        var lastLoaded = this.part.loadedBytes;
        var self = this;
        return function() {
            clearInterval(self.stalledInterval);
            if ([
                EVAPORATING,
                ERROR,
                PAUSING,
                PAUSED
            ].indexOf(self.fileUpload.status) === -1 && self.part.status !== ABORTED && self.part.loadedBytes < this.size) {
                if (lastLoaded === self.part.loadedBytes) {
                    l.w('Part stalled. Will abort and retry:', self.partNumber, decodeURIComponent(self.fileUpload.name));
                    self.abort();
                    if (!self.errorExceptionStatus()) self.delaySend();
                } else self.stalledInterval = setInterval(self.stalledPartMonitor(), PARTS_MONITOR_INTERVAL_MS);
            }
        };
    };
    PutPart.prototype.resetLoadedBytes = function() {
        this.fileUpload.updateLoaded(-this.part.loadedBytes);
        this.part.loadedBytes = 0;
        this.fileUpload.onProgress();
    };
    PutPart.prototype.errorExceptionStatus = function() {
        return [
            CANCELED,
            ABORTED,
            PAUSED,
            PAUSING
        ].indexOf(this.fileUpload.status) > -1;
    };
    PutPart.prototype.delaySend = function() {
        var backOffWait = this.backOffWait();
        this.attempts += 1;
        setTimeout(this.send.bind(this), backOffWait);
    };
    PutPart.prototype.errorHandler = function(reason) {
        clearInterval(this.stalledInterval);
        if (reason.match(/status:404/)) {
            var errMsg = '404 error on part PUT. The part and the file will abort. ' + reason;
            l.w(errMsg);
            this.fileUpload.error(errMsg);
            this.part.status = ABORTED;
            this.awsDeferred.reject(errMsg);
            return true;
        }
        this.resetLoadedBytes();
        this.part.status = ERROR;
        if (!this.errorExceptionStatus()) this.delaySend();
        return true;
    };
    PutPart.prototype.abort = function() {
        if (this.currentXhr) this.currentXhr.abort();
        this.resetLoadedBytes();
        this.attempts = 1;
    };
    PutPart.size = 0;
    PutPart.prototype.streamToArrayBuffer = function(stream) {
        return new Promise((function(resolve, reject) {
            // stream is empty or ended
            if (!stream.readable) return resolve([]);
            var arr = new Uint8Array(Math.min(this.con.partSize, this.end - this.start)), i = 0;
            stream.on('data', onData);
            stream.on('end', onEnd);
            stream.on('error', onEnd);
            stream.on('close', onClose);
            function onData(data) {
                if (data.byteLength === 1) return;
                arr.set(data, i);
                i += data.byteLength;
            }
            function onEnd(err) {
                if (err) reject(err);
                else resolve(arr);
                cleanup();
            }
            function onClose() {
                resolve(arr);
                cleanup();
            }
            function cleanup() {
                arr = null;
                stream.removeListener('data', onData);
                stream.removeListener('end', onEnd);
                stream.removeListener('error', onEnd);
                stream.removeListener('close', onClose);
            }
        }).bind(this));
    };
    PutPart.prototype.getPayload = function() {
        if (typeof this.payloadPromise === 'undefined') this.payloadPromise = this.con.readableStreams ? this.payloadFromStream() : this.payloadFromBlob();
        return this.payloadPromise;
    };
    PutPart.prototype.payloadFromStream = function() {
        var stream = this.con.readableStreamPartMethod(this.fileUpload.file, this.start, this.end - 1);
        return new Promise((function(resolve, reject) {
            var streamPromise = this.streamToArrayBuffer(stream);
            streamPromise.then((function(data) {
                resolve(data);
            }).bind(this), reject);
        }).bind(this));
    };
    PutPart.prototype.payloadFromBlob = function() {
        // browsers' implementation of the Blob.slice function has been renamed a couple of times, and the meaning of the
        // 2nd parameter changed. For example Gecko went from slice(start,length) -> mozSlice(start, end) -> slice(start, end).
        // As of 12/12/12, it seems that the unified 'slice' is the best bet, hence it being first in the list. See
        // https://developer.mozilla.org/en-US/docs/DOM/Blob for more info.
        var file = this.fileUpload.file, slicerFn = file.slice ? 'slice' : file.mozSlice ? 'mozSlice' : 'webkitSlice', blob = file[slicerFn](this.start, this.end);
        if (this.con.computeContentMd5) return new Promise(function(resolve) {
            var reader = new FileReader();
            reader.onloadend = function() {
                var buffer = this.result && typeof this.result.buffer !== 'undefined', result = buffer ? new Uint8Array(this.result.buffer) : this.result;
                resolve(result);
            };
            reader.readAsArrayBuffer(blob);
        });
        return Promise.resolve(blob);
    };
    PutPart.prototype.stalledInterval = -1;
    PutPart.prototype.getStartedPromise = function() {
        return this.started.promise;
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadAbort.html
    function DeleteMultipartUpload(fileUpload) {
        fileUpload.info('will attempt to abort the upload');
        fileUpload.abortParts();
        var request = {
            method: 'DELETE',
            path: '?uploadId=' + fileUpload.uploadId,
            x_amz_headers: fileUpload.xAmzHeadersCommon,
            success404: true,
            step: 'abort'
        };
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    DeleteMultipartUpload.prototype = Object.create(SignedS3AWSRequest.prototype);
    DeleteMultipartUpload.prototype.constructor = DeleteMultipartUpload;
    DeleteMultipartUpload.prototype.maxRetries = 1;
    DeleteMultipartUpload.prototype.success = function() {
        this.fileUpload.setStatus(ABORTED);
        this.awsDeferred.resolve(this.currentXhr);
    };
    DeleteMultipartUpload.prototype.errorHandler = function(reason) {
        if (this.attempts > this.maxRetries) {
            var msg = 'Error aborting upload, Exceeded retries deleting the file upload: ' + reason;
            l.w(msg);
            this.fileUpload.error(msg);
            this.awsDeferred.reject(msg);
            return true;
        }
    };
    function signingVersion(awsRequest, l) {
        var con = awsRequest.con;
        function AwsSignature(request) {
            this.request = request;
        }
        AwsSignature.prototype.request = {};
        AwsSignature.prototype.error = function() {};
        AwsSignature.prototype.authorizationString = function() {};
        AwsSignature.prototype.stringToSign = function() {};
        AwsSignature.prototype.canonicalRequest = function() {};
        AwsSignature.prototype.setHeaders = function() {};
        AwsSignature.prototype.datetime = function(timeOffset) {
            return new Date(new Date().getTime() + timeOffset);
        };
        AwsSignature.prototype.dateString = function(timeOffset) {
            return this.datetime(timeOffset).toISOString().slice(0, 19).replace(/-|:/g, '') + "Z";
        };
        function AwsSignatureV2(request) {
            AwsSignature.call(this, request);
        }
        AwsSignatureV2.prototype = Object.create(AwsSignature.prototype);
        AwsSignatureV2.prototype.constructor = AwsSignatureV2;
        AwsSignatureV2.prototype.authorizationString = function() {
            return [
                'AWS ',
                con.aws_key,
                ':',
                this.request.auth
            ].join('');
        };
        AwsSignatureV2.prototype.stringToSign = function() {
            var x_amz_headers = '', result, header_key_array = [];
            for(var key in this.request.x_amz_headers)if (this.request.x_amz_headers.hasOwnProperty(key)) header_key_array.push(key);
            header_key_array.sort();
            header_key_array.forEach((function(header_key) {
                x_amz_headers += header_key + ':' + this.request.x_amz_headers[header_key] + '\n';
            }).bind(this));
            result = this.request.method + '\n' + (this.request.md5_digest || '') + '\n' + (this.request.contentType || '') + '\n' + '\n' + x_amz_headers + (con.cloudfront ? '/' + con.bucket : '') + awsRequest.getPath() + this.request.path;
            l.d('V2 stringToSign:', result);
            return result;
        };
        AwsSignatureV2.prototype.dateString = function(timeOffset) {
            return this.datetime(timeOffset).toUTCString();
        };
        AwsSignatureV2.prototype.getPayload = function() {
            return Promise.resolve();
        };
        function AwsSignatureV4(request) {
            this._cr = undefined;
            AwsSignature.call(this, request);
        }
        AwsSignatureV4.prototype = Object.create(AwsSignature.prototype);
        AwsSignatureV4.prototype.constructor = AwsSignatureV4;
        AwsSignatureV4.prototype._cr = undefined;
        AwsSignatureV4.prototype.payload = null;
        AwsSignatureV4.prototype.error = function() {
            this._cr = undefined;
        };
        AwsSignatureV4.prototype.getPayload = function() {
            return awsRequest.getPayload().then((function(data) {
                this.payload = data;
            }).bind(this));
        };
        AwsSignatureV4.prototype.authorizationString = function() {
            var authParts = [];
            var credentials = this.credentialString();
            var headers = this.canonicalHeaders();
            authParts.push([
                'AWS4-HMAC-SHA256 Credential=',
                con.aws_key,
                '/',
                credentials
            ].join(''));
            authParts.push('SignedHeaders=' + headers.signedHeaders);
            authParts.push('Signature=' + this.request.auth);
            return authParts.join(', ');
        };
        AwsSignatureV4.prototype.stringToSign = function() {
            var signParts = [];
            signParts.push('AWS4-HMAC-SHA256');
            signParts.push(this.request.dateString);
            signParts.push(this.credentialString());
            signParts.push(con.cryptoHexEncodedHash256(this.canonicalRequest()));
            var result = signParts.join('\n');
            l.d('V4 stringToSign:', result);
            return result;
        };
        AwsSignatureV4.prototype.credentialString = function() {
            var credParts = [];
            credParts.push(this.request.dateString.slice(0, 8));
            credParts.push(con.awsRegion);
            credParts.push('s3');
            credParts.push('aws4_request');
            return credParts.join('/');
        };
        AwsSignatureV4.prototype.canonicalQueryString = function() {
            var qs = awsRequest.request.query_string || '', search = uri([
                awsRequest.awsUrl,
                this.request.path,
                qs
            ].join("")).search, searchParts = search.length ? search.split('&') : [], encoded = [], nameValue, i;
            for(i = 0; i < searchParts.length; i++){
                nameValue = searchParts[i].split("=");
                encoded.push({
                    name: encodeURIComponent(nameValue[0]),
                    value: nameValue.length > 1 ? encodeURIComponent(nameValue[1]) : null
                });
            }
            var sorted = encoded.sort(function(a, b) {
                if (a.name < b.name) return -1;
                else if (a.name > b.name) return 1;
                return 0;
            });
            var result = [];
            for(i = 0; i < sorted.length; i++){
                nameValue = sorted[i].value ? [
                    sorted[i].name,
                    sorted[i].value
                ].join("=") : sorted[i].name + '=';
                result.push(nameValue);
            }
            return result.join('&');
        };
        AwsSignatureV4.prototype.getPayloadSha256Content = function() {
            var result = this.request.contentSha256 || con.cryptoHexEncodedHash256(this.payload || '');
            l.d(this.request.step, 'getPayloadSha256Content:', result);
            return result;
        };
        AwsSignatureV4.prototype.canonicalHeaders = function() {
            var canonicalHeaders = [], keys = [], i;
            function addHeader(name, value) {
                var key = name.toLowerCase();
                keys.push(key);
                canonicalHeaders[key] = value.replace(/\s+/g, ' ');
            }
            if (this.request.md5_digest) addHeader("Content-Md5", this.request.md5_digest);
            addHeader('Host', awsRequest.awsHost);
            if (this.request.contentType) addHeader('Content-Type', this.request.contentType || '');
            var amzHeaders = this.request.x_amz_headers || {};
            for(var key in amzHeaders)if (amzHeaders.hasOwnProperty(key)) addHeader(key, amzHeaders[key]);
            var sortedKeys = keys.sort(function(a, b) {
                if (a < b) return -1;
                else if (a > b) return 1;
                return 0;
            });
            var result = [];
            var unsigned_headers = [], not_signed = this.request.not_signed_headers || [], signed_headers = [];
            for(i = 0; i < not_signed.length; i++)unsigned_headers.push(not_signed[i].toLowerCase());
            for(i = 0; i < sortedKeys.length; i++){
                var k = sortedKeys[i];
                result.push([
                    k,
                    canonicalHeaders[k]
                ].join(":"));
                if (unsigned_headers.indexOf(k) === -1) signed_headers.push(k);
            }
            return {
                canonicalHeaders: result.join("\n"),
                signedHeaders: signed_headers.join(";")
            };
        };
        AwsSignatureV4.prototype.canonicalRequest = function() {
            if (typeof this._cr !== 'undefined') return this._cr;
            var canonParts = [];
            canonParts.push(this.request.method);
            canonParts.push(uri([
                awsRequest.awsUrl,
                awsRequest.getPath(),
                this.request.path
            ].join("")).pathname);
            canonParts.push(this.canonicalQueryString() || '');
            var headers = this.canonicalHeaders();
            canonParts.push(headers.canonicalHeaders + '\n');
            canonParts.push(headers.signedHeaders);
            canonParts.push(this.getPayloadSha256Content());
            this._cr = canonParts.join("\n");
            l.d(this.request.step, 'V4 CanonicalRequest:', this._cr);
            return this._cr;
        };
        AwsSignatureV4.prototype.setHeaders = function(xhr) {
            xhr.setRequestHeader("x-amz-content-sha256", this.getPayloadSha256Content());
        };
        return con.awsSignatureVersion === '4' ? AwsSignatureV4 : AwsSignatureV2;
    }
    function authorizationMethod(awsRequest) {
        var fileUpload = awsRequest.fileUpload, con = fileUpload.con, request = awsRequest.request;
        function AuthorizationMethod() {
            this.request = request;
        }
        AuthorizationMethod.prototype = Object.create(AuthorizationMethod.prototype);
        AuthorizationMethod.prototype.request = {};
        AuthorizationMethod.makeSignParamsObject = function(params) {
            var out = {};
            for(var param in params){
                if (!params.hasOwnProperty(param)) continue;
                if (typeof params[param] === 'function') out[param] = params[param]();
                else out[param] = params[param];
            }
            return out;
        };
        AuthorizationMethod.prototype.authorize = function() {
            return new Promise(function(resolve, reject) {
                var xhr = new XMLHttpRequest();
                awsRequest.currentXhr = xhr;
                var stringToSign = awsRequest.stringToSign(), url = [
                    con.signerUrl,
                    '?to_sign=',
                    stringToSign,
                    '&datetime=',
                    request.dateString
                ];
                if (con.sendCanonicalRequestToSignerUrl) {
                    url.push('&canonical_request=');
                    url.push(encodeURIComponent(awsRequest.canonicalRequest()));
                }
                url = url.join("");
                var signParams = AuthorizationMethod.makeSignParamsObject(fileUpload.signParams);
                for(var param in signParams){
                    if (!signParams.hasOwnProperty(param)) continue;
                    url += '&' + encodeURIComponent(param) + '=' + encodeURIComponent(signParams[param]);
                }
                if (con.xhrWithCredentials) xhr.withCredentials = true;
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) awsRequest.signResponse(xhr.response, stringToSign, request.dateString).then(resolve);
                        else {
                            if ([
                                401,
                                403
                            ].indexOf(xhr.status) > -1) {
                                var reason = "status:" + xhr.status;
                                fileUpload.deferredCompletion.reject('Permission denied ' + reason);
                                return reject(reason);
                            }
                            reject("Signature fetch returned status: " + xhr.status);
                        }
                    }
                };
                xhr.onerror = function(xhr) {
                    reject('authorizedSend transport error: ' + xhr.responseText);
                };
                xhr.open('GET', url);
                var signHeaders = AuthorizationMethod.makeSignParamsObject(con.signHeaders);
                for(var header in signHeaders){
                    if (!signHeaders.hasOwnProperty(header)) continue;
                    xhr.setRequestHeader(header, signHeaders[header]);
                }
                if (typeof fileUpload.beforeSigner === 'function') fileUpload.beforeSigner(xhr, url);
                xhr.send();
            });
        };
        function AuthorizationCustom() {
            AuthorizationMethod.call(this);
        }
        AuthorizationCustom.prototype = Object.create(AuthorizationMethod.prototype);
        AuthorizationCustom.prototype.authorize = function() {
            return con.customAuthMethod(AuthorizationMethod.makeSignParamsObject(fileUpload.signParams), AuthorizationMethod.makeSignParamsObject(con.signHeaders), awsRequest.stringToSign(), request.dateString, awsRequest.canonicalRequest()).catch(function(reason) {
                fileUpload.deferredCompletion.reject(reason);
                throw reason;
            });
        };
        if (typeof con.customAuthMethod === 'function') return new AuthorizationCustom();
        return new AuthorizationMethod();
    }
    function awsUrl(con) {
        var url;
        if (con.aws_url) url = [
            con.aws_url
        ];
        else {
            if (con.s3Acceleration) {
                url = [
                    "https://",
                    con.bucket,
                    ".s3-accelerate"
                ];
                con.cloudfront = true;
            } else {
                url = [
                    "https://",
                    con.cloudfront ? con.bucket + "." : "",
                    "s3"
                ];
                if (con.awsRegion !== "us-east-1") url.push("-", con.awsRegion);
            }
            url.push(".amazonaws.com");
        }
        return url.join("");
    }
    function s3EncodedObjectName(fileName) {
        var fileParts = fileName.split('/'), encodedParts = [];
        fileParts.forEach(function(p) {
            var buf = [], enc = encodeURIComponent(p);
            for(var i = 0; i < enc.length; i++)buf.push(S3_EXTRA_ENCODED_CHARS[enc.charCodeAt(i)] || enc.charAt(i));
            encodedParts.push(buf.join(""));
        });
        return encodedParts.join('/');
    }
    function uri(url) {
        var p, href = url || '/';
        try {
            p = new URL(href);
        } catch (e) {
            p = document.createElement('a');
            p.href = href;
        }
        return {
            protocol: p.protocol,
            hostname: p.hostname,
            // IE omits the leading slash, so add it if it's missing
            pathname: p.pathname.replace(/(^\/?)/, "/"),
            port: p.port,
            search: p.search[0] === '?' ? p.search.substr(1) : p.search,
            hash: p.hash,
            host: p.host // => "example.com:3000"
        };
    }
    function dateISOString(date) {
        // Try to get the modified date as an ISO String, if the date exists
        return date ? new Date(date).toISOString() : '';
    }
    function getAwsResponse(xhr) {
        var code = elementText(xhr.responseText, "Code"), msg = elementText(xhr.responseText, "Message");
        return code.length ? [
            'AWS Code: ',
            code,
            ', Message:',
            msg
        ].join("") : '';
    }
    function elementText(source, element) {
        var match = source.match([
            "<",
            element,
            ">(.+)</",
            element,
            ">"
        ].join(""));
        return match ? match[1] : '';
    }
    function defer() {
        var deferred = {}, promise;
        promise = new Promise(function(resolve, reject) {
            deferred = {
                resolve: resolve,
                reject: reject
            };
        });
        return {
            resolve: deferred.resolve,
            reject: deferred.reject,
            promise: promise
        };
    }
    function extend(obj1, obj2, obj3) {
        function ext(target, source) {
            if (typeof source !== 'object') return;
            for(var key in source)if (source.hasOwnProperty(key)) target[key] = source[key];
        }
        obj1 = obj1 || {};
        obj2 = obj2 || {};
        obj3 = obj3 || {};
        ext(obj2, obj3);
        ext(obj1, obj2);
        return obj1;
    }
    function getSavedUploads(purge) {
        var uploads = JSON.parse(historyCache.getItem('awsUploads') || '{}');
        if (purge) {
            for(var key in uploads)if (uploads.hasOwnProperty(key)) {
                var upload = uploads[key], completedAt = new Date(upload.completedAt || FAR_FUTURE);
                if (completedAt < HOURS_AGO) // The upload is recent, let's keep it
                delete uploads[key];
            }
            historyCache.setItem('awsUploads', JSON.stringify(uploads));
        }
        return uploads;
    }
    function uploadKey(fileUpload) {
        // The key tries to give a signature to a file in the absence of its path.
        // "<filename>-<mimetype>-<modifieddate>-<filesize>"
        return [
            fileUpload.file.name,
            fileUpload.file.type,
            dateISOString(fileUpload.file.lastModified),
            fileUpload.sizeBytes
        ].join("-");
    }
    function saveUpload(uploadKey, upload) {
        var uploads = getSavedUploads();
        uploads[uploadKey] = upload;
        historyCache.setItem('awsUploads', JSON.stringify(uploads));
    }
    function removeUpload(uploadKey) {
        var uploads = getSavedUploads();
        delete uploads[uploadKey];
        historyCache.setItem('awsUploads', JSON.stringify(uploads));
    }
    function removeAtIndex(a, i) {
        var idx = a.indexOf(i);
        if (idx > -1) {
            a.splice(idx, 1);
            return true;
        }
    }
    function readableFileSize(size) {
        // Adapted from https://github.com/fkjaekel
        // https://github.com/TTLabs/EvaporateJS/issues/13
        var units = [
            'B',
            'Kb',
            'Mb',
            'Gb',
            'Tb',
            'Pb',
            'Eb',
            'Zb',
            'Yb'
        ], i = 0;
        while(size >= 1024){
            size /= 1024;
            ++i;
        }
        return [
            size.toFixed(2).replace('.00', ''),
            units[i]
        ].join(" ");
    }
    var historyCache;
    function HistoryCache(mockLocalStorage) {
        var supported = HistoryCache.supported();
        this.cacheStore = mockLocalStorage ? {} : supported ? localStorage : undefined;
    }
    HistoryCache.prototype.supported = false;
    HistoryCache.prototype.cacheStore = undefined;
    HistoryCache.prototype.getItem = function(key) {
        if (this.cacheStore) return this.cacheStore[key];
    };
    HistoryCache.prototype.setItem = function(key, value) {
        if (this.cacheStore) this.cacheStore[key] = value;
    };
    HistoryCache.prototype.removeItem = function(key) {
        if (this.cacheStore) return delete this.cacheStore[key];
    };
    HistoryCache.supported = function() {
        var result = false;
        if (typeof window !== 'undefined') {
            if (!('localStorage' in window)) return result;
        } else return result;
        // Try to use storage (it might be disabled, e.g. user is in private mode)
        try {
            var k = '___test';
            localStorage[k] = 'OK';
            var test = localStorage[k];
            delete localStorage[k];
            return test === 'OK';
        } catch (e) {
            return result;
        }
    };
    function noOpLogger() {
        return {
            d: function() {},
            w: function() {},
            e: function() {}
        };
    }
    l = noOpLogger();
    if (module.exports) module.exports = Evaporate;
    else if (typeof window !== 'undefined') window.Evaporate = Evaporate;
})();

});

parcelRegister("3D2Yk", function(module, exports) {
(function(factory) {
    var glob, e;
    // Node/CommonJS
    module.exports = factory();
})(function(undefined) {
    'use strict';
    /*
     * Fastest md5 implementation around (JKM md5).
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */ /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */ var add32 = function(a, b) {
        return a + b & 0xFFFFFFFF;
    }, hex_chr = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f'
    ];
    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32(a << s | a >>> 32 - s, b);
    }
    function md5cycle(x, k) {
        var a = x[0], b = x[1], c = x[2], d = x[3];
        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    }
    function md5blk(s) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    function md5blk_array(a) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        return md5blks;
    }
    function md51(s) {
        var n = s.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        length = s.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function md51_array(a) {
        var n = a.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
        length = a.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= a[i] << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function rhex(n) {
        var s = '', j;
        for(j = 0; j < 4; j += 1)s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
        return s;
    }
    function hex(x) {
        var i;
        for(i = 0; i < x.length; i += 1)x[i] = rhex(x[i]);
        return x.join('');
    }
    // In some cases the fast add32 function cannot be used..
    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') add32 = function(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
    // ---------------------------------------------------
    /**
     * ArrayBuffer slice polyfill.
     *
     * @see https://github.com/ttaubert/node-arraybuffer-slice
     */ if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) (function() {
        function clamp(val, length) {
            val = val | 0 || 0;
            if (val < 0) return Math.max(val + length, 0);
            return Math.min(val, length);
        }
        ArrayBuffer.prototype.slice = function(from, to) {
            var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
            if (to !== undefined) end = clamp(to, length);
            if (begin > end) return new ArrayBuffer(0);
            num = end - begin;
            target = new ArrayBuffer(num);
            targetArray = new Uint8Array(target);
            sourceArray = new Uint8Array(this, begin, num);
            targetArray.set(sourceArray);
            return target;
        };
    })();
    // ---------------------------------------------------
    /**
     * Helpers.
     */ function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) str = unescape(encodeURIComponent(str));
        return str;
    }
    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
        for(i = 0; i < length; i += 1)arr[i] = str.charCodeAt(i);
        return returnUInt8Array ? arr : buff;
    }
    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }
    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);
        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);
        return returnUInt8Array ? result : result.buffer;
    }
    function hexToBinaryString(hex) {
        var bytes = [], length = hex.length, x;
        for(x = 0; x < length - 1; x += 2)bytes.push(parseInt(hex.substr(x, 2), 16));
        return String.fromCharCode.apply(String, bytes);
    }
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */ function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }
    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.append = function(str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));
        return this;
    };
    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.appendBinary = function(contents) {
        this._buff += contents;
        this._length += contents.length;
        var length = this._buff.length, i;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        this._buff = this._buff.substring(i - 64);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, i, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.reset = function() {
        this._buff = '';
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.prototype.getState = function() {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        };
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.setState = function(state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;
        return this;
    };
    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */ SparkMD5.prototype.destroy = function() {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };
    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */ SparkMD5.prototype._finish = function(tail, length) {
        var i = length, tmp, lo, hi;
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };
    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hash = function(str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };
    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hashBinary = function(content, raw) {
        var hash = md51(content), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */ SparkMD5.ArrayBuffer = function() {
        // call reset to init the instance
        this.reset();
    };
    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.append = function(arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true), length = buff.length, i;
        this._length += arr.byteLength;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], i, ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff[i] << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.reset = function() {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.ArrayBuffer.prototype.getState = function() {
        var state = SparkMD5.prototype.getState.call(this);
        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);
        return state;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.setState = function(state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);
        return SparkMD5.prototype.setState.call(this, state);
    };
    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.hash = function(arr, raw) {
        var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    return SparkMD5;
});

});

parcelRegister("aPr3M", function(module, exports) {
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 1.0.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2026
 * @license MIT
 */ 'use strict';
var $ca2137e69176009d$var$INPUT_ERROR = 'input is invalid type';
var $ca2137e69176009d$var$FINALIZE_ERROR = 'finalize already called';
var $ca2137e69176009d$var$ARRAY_BUFFER = typeof ArrayBuffer !== 'undefined';
var $ca2137e69176009d$var$formatMessage = function(message) {
    var type = typeof message;
    if (type === 'string') return [
        message,
        true
    ];
    if (Array.isArray(message)) return [
        message,
        false
    ];
    if ($ca2137e69176009d$var$ARRAY_BUFFER && message) {
        if (message.constructor === ArrayBuffer) return [
            new Uint8Array(message),
            false
        ];
        else if (ArrayBuffer.isView(message)) return [
            message,
            false
        ];
    }
    throw new Error($ca2137e69176009d$var$INPUT_ERROR);
};
var $ca2137e69176009d$var$HEX_CHARS = '0123456789abcdef'.split('');
var $ca2137e69176009d$var$EXTRA = [
    -2147483648,
    8388608,
    32768,
    128
];
var $ca2137e69176009d$var$SHIFT = [
    24,
    16,
    8,
    0
];
var $ca2137e69176009d$var$K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
var $ca2137e69176009d$var$OUTPUT_TYPES = [
    'hex',
    'array',
    'digest',
    'arrayBuffer'
];
var $ca2137e69176009d$var$blocks = [];
var $ca2137e69176009d$var$createOutputMethod = function(outputType, is224) {
    return function(message) {
        return new $ca2137e69176009d$var$Sha256(is224, true).update(message)[outputType]();
    };
};
var $ca2137e69176009d$var$createMethod = function(is224) {
    var method = $ca2137e69176009d$var$createOutputMethod('hex', is224);
    method.create = function() {
        return new $ca2137e69176009d$var$Sha256(is224);
    };
    method.update = function(message) {
        return method.create().update(message);
    };
    for(var i = 0; i < $ca2137e69176009d$var$OUTPUT_TYPES.length; ++i){
        var type = $ca2137e69176009d$var$OUTPUT_TYPES[i];
        method[type] = $ca2137e69176009d$var$createOutputMethod(type, is224);
    }
    return method;
};
var $ca2137e69176009d$var$createHmacOutputMethod = function(outputType, is224) {
    return function(key, message) {
        return new $ca2137e69176009d$var$HmacSha256(key, is224, true).update(message)[outputType]();
    };
};
var $ca2137e69176009d$var$createHmacMethod = function(is224) {
    var method = $ca2137e69176009d$var$createHmacOutputMethod('hex', is224);
    method.create = function(key) {
        return new $ca2137e69176009d$var$HmacSha256(key, is224);
    };
    method.update = function(key, message) {
        return method.create(key).update(message);
    };
    for(var i = 0; i < $ca2137e69176009d$var$OUTPUT_TYPES.length; ++i){
        var type = $ca2137e69176009d$var$OUTPUT_TYPES[i];
        method[type] = $ca2137e69176009d$var$createHmacOutputMethod(type, is224);
    }
    return method;
};
function $ca2137e69176009d$var$Sha256(is224, sharedMemory) {
    if (sharedMemory) {
        $ca2137e69176009d$var$blocks[0] = $ca2137e69176009d$var$blocks[16] = $ca2137e69176009d$var$blocks[1] = $ca2137e69176009d$var$blocks[2] = $ca2137e69176009d$var$blocks[3] = $ca2137e69176009d$var$blocks[4] = $ca2137e69176009d$var$blocks[5] = $ca2137e69176009d$var$blocks[6] = $ca2137e69176009d$var$blocks[7] = $ca2137e69176009d$var$blocks[8] = $ca2137e69176009d$var$blocks[9] = $ca2137e69176009d$var$blocks[10] = $ca2137e69176009d$var$blocks[11] = $ca2137e69176009d$var$blocks[12] = $ca2137e69176009d$var$blocks[13] = $ca2137e69176009d$var$blocks[14] = $ca2137e69176009d$var$blocks[15] = 0;
        this.blocks = $ca2137e69176009d$var$blocks;
    } else this.blocks = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    if (is224) {
        this.h0 = 0xc1059ed8;
        this.h1 = 0x367cd507;
        this.h2 = 0x3070dd17;
        this.h3 = 0xf70e5939;
        this.h4 = 0xffc00b31;
        this.h5 = 0x68581511;
        this.h6 = 0x64f98fa7;
        this.h7 = 0xbefa4fa4;
    } else {
        this.h0 = 0x6a09e667;
        this.h1 = 0xbb67ae85;
        this.h2 = 0x3c6ef372;
        this.h3 = 0xa54ff53a;
        this.h4 = 0x510e527f;
        this.h5 = 0x9b05688c;
        this.h6 = 0x1f83d9ab;
        this.h7 = 0x5be0cd19;
    }
    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
    this.is224 = is224;
}
$ca2137e69176009d$var$Sha256.prototype.update = function(message) {
    if (this.finalized) throw new Error($ca2137e69176009d$var$FINALIZE_ERROR);
    var result = $ca2137e69176009d$var$formatMessage(message);
    message = result[0];
    var isString = result[1];
    var code, index = 0, i, length = message.length, blocks = this.blocks;
    while(index < length){
        if (this.hashed) {
            this.hashed = false;
            blocks[0] = this.block;
            this.block = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        if (isString) for(i = this.start; index < length && i < 64; ++index){
            code = message.charCodeAt(index);
            if (code < 0x80) blocks[i >>> 2] |= code << $ca2137e69176009d$var$SHIFT[i++ & 3];
            else if (code < 0x800) {
                blocks[i >>> 2] |= (0xc0 | code >>> 6) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
                blocks[i >>> 2] |= (0xe0 | code >>> 12) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                blocks[i >>> 2] |= (0xf0 | code >>> 18) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
            }
        }
        else for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << $ca2137e69176009d$var$SHIFT[i++ & 3];
        this.lastByteIndex = i;
        this.bytes += i - this.start;
        if (i >= 64) {
            this.block = blocks[16];
            this.start = i - 64;
            this.hash();
            this.hashed = true;
        } else this.start = i;
    }
    if (this.bytes > 4294967295) {
        this.hBytes += this.bytes / 4294967296 << 0;
        this.bytes = this.bytes % 4294967296;
    }
    return this;
};
$ca2137e69176009d$var$Sha256.prototype.finalize = function() {
    if (this.finalized) return;
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >>> 2] |= $ca2137e69176009d$var$EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
        if (!this.hashed) this.hash();
        blocks[0] = this.block;
        blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[15] = this.bytes << 3;
    this.hash();
};
$ca2137e69176009d$var$Sha256.prototype.hash = function() {
    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
    for(j = 16; j < 64; ++j){
        // rightrotate
        t1 = blocks[j - 15];
        s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
        t1 = blocks[j - 2];
        s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
        blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
    }
    bc = b & c;
    for(j = 0; j < 64; j += 4){
        if (this.first) {
            if (this.is224) {
                ab = 300032;
                t1 = blocks[0] - 1413257819;
                h = t1 - 150054599 << 0;
                d = t1 + 24177077 << 0;
            } else {
                ab = 704751109;
                t1 = blocks[0] - 210244248;
                h = t1 - 1521486534 << 0;
                d = t1 + 143694565 << 0;
            }
            this.first = false;
        } else {
            s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
            s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
            ab = a & b;
            maj = ab ^ a & c ^ bc;
            ch = e & f ^ ~e & g;
            t1 = h + s1 + ch + $ca2137e69176009d$var$K[j] + blocks[j];
            t2 = s0 + maj;
            h = d + t1 << 0;
            d = t1 + t2 << 0;
        }
        s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
        s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
        da = d & a;
        maj = da ^ d & b ^ ab;
        ch = h & e ^ ~h & f;
        t1 = g + s1 + ch + $ca2137e69176009d$var$K[j + 1] + blocks[j + 1];
        t2 = s0 + maj;
        g = c + t1 << 0;
        c = t1 + t2 << 0;
        s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
        s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
        cd = c & d;
        maj = cd ^ c & a ^ da;
        ch = g & h ^ ~g & e;
        t1 = f + s1 + ch + $ca2137e69176009d$var$K[j + 2] + blocks[j + 2];
        t2 = s0 + maj;
        f = b + t1 << 0;
        b = t1 + t2 << 0;
        s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
        s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
        bc = b & c;
        maj = bc ^ b & d ^ cd;
        ch = f & g ^ ~f & h;
        t1 = e + s1 + ch + $ca2137e69176009d$var$K[j + 3] + blocks[j + 3];
        t2 = s0 + maj;
        e = a + t1 << 0;
        a = t1 + t2 << 0;
        this.chromeBugWorkAround = true;
    }
    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
    this.h5 = this.h5 + f << 0;
    this.h6 = this.h6 + g << 0;
    this.h7 = this.h7 + h << 0;
};
$ca2137e69176009d$var$Sha256.prototype.hex = function() {
    this.finalize();
    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
    var hex = $ca2137e69176009d$var$HEX_CHARS[h0 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 & 0x0F];
    if (!this.is224) hex += $ca2137e69176009d$var$HEX_CHARS[h7 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 & 0x0F];
    return hex;
};
$ca2137e69176009d$var$Sha256.prototype.toString = $ca2137e69176009d$var$Sha256.prototype.hex;
$ca2137e69176009d$var$Sha256.prototype.digest = function() {
    this.finalize();
    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
    var arr = [
        h0 >>> 24 & 0xFF,
        h0 >>> 16 & 0xFF,
        h0 >>> 8 & 0xFF,
        h0 & 0xFF,
        h1 >>> 24 & 0xFF,
        h1 >>> 16 & 0xFF,
        h1 >>> 8 & 0xFF,
        h1 & 0xFF,
        h2 >>> 24 & 0xFF,
        h2 >>> 16 & 0xFF,
        h2 >>> 8 & 0xFF,
        h2 & 0xFF,
        h3 >>> 24 & 0xFF,
        h3 >>> 16 & 0xFF,
        h3 >>> 8 & 0xFF,
        h3 & 0xFF,
        h4 >>> 24 & 0xFF,
        h4 >>> 16 & 0xFF,
        h4 >>> 8 & 0xFF,
        h4 & 0xFF,
        h5 >>> 24 & 0xFF,
        h5 >>> 16 & 0xFF,
        h5 >>> 8 & 0xFF,
        h5 & 0xFF,
        h6 >>> 24 & 0xFF,
        h6 >>> 16 & 0xFF,
        h6 >>> 8 & 0xFF,
        h6 & 0xFF
    ];
    if (!this.is224) arr.push(h7 >>> 24 & 0xFF, h7 >>> 16 & 0xFF, h7 >>> 8 & 0xFF, h7 & 0xFF);
    return arr;
};
$ca2137e69176009d$var$Sha256.prototype.array = $ca2137e69176009d$var$Sha256.prototype.digest;
$ca2137e69176009d$var$Sha256.prototype.arrayBuffer = function() {
    this.finalize();
    var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    dataView.setUint32(20, this.h5);
    dataView.setUint32(24, this.h6);
    if (!this.is224) dataView.setUint32(28, this.h7);
    return buffer;
};
function $ca2137e69176009d$var$HmacSha256(key, is224, sharedMemory) {
    var i, result = $ca2137e69176009d$var$formatMessage(key);
    key = result[0];
    if (result[1]) {
        var bytes = [], length = key.length, index = 0, code;
        for(i = 0; i < length; ++i){
            code = key.charCodeAt(i);
            if (code < 0x80) bytes[index++] = code;
            else if (code < 0x800) {
                bytes[index++] = 0xc0 | code >>> 6;
                bytes[index++] = 0x80 | code & 0x3f;
            } else if (code < 0xd800 || code >= 0xe000) {
                bytes[index++] = 0xe0 | code >>> 12;
                bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                bytes[index++] = 0x80 | code & 0x3f;
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                bytes[index++] = 0xf0 | code >>> 18;
                bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                bytes[index++] = 0x80 | code & 0x3f;
            }
        }
        key = bytes;
    }
    if (key.length > 64) key = new $ca2137e69176009d$var$Sha256(is224, true).update(key).array();
    var oKeyPad = [], iKeyPad = [];
    for(i = 0; i < 64; ++i){
        var b = key[i] || 0;
        oKeyPad[i] = 0x5c ^ b;
        iKeyPad[i] = 0x36 ^ b;
    }
    $ca2137e69176009d$var$Sha256.call(this, is224, sharedMemory);
    this.update(iKeyPad);
    this.oKeyPad = oKeyPad;
    this.inner = true;
    this.sharedMemory = sharedMemory;
}
$ca2137e69176009d$var$HmacSha256.prototype = new $ca2137e69176009d$var$Sha256();
$ca2137e69176009d$var$HmacSha256.prototype.finalize = function() {
    $ca2137e69176009d$var$Sha256.prototype.finalize.call(this);
    if (this.inner) {
        this.inner = false;
        var innerHash = this.array();
        $ca2137e69176009d$var$Sha256.call(this, this.is224, this.sharedMemory);
        this.update(this.oKeyPad);
        this.update(innerHash);
        $ca2137e69176009d$var$Sha256.prototype.finalize.call(this);
    }
};
var $ca2137e69176009d$var$sha256 = $ca2137e69176009d$var$createMethod();
var $ca2137e69176009d$var$sha224 = $ca2137e69176009d$var$createMethod(true);
$ca2137e69176009d$var$sha256.sha256 = $ca2137e69176009d$var$sha256;
$ca2137e69176009d$var$sha256.sha224 = $ca2137e69176009d$var$sha224;
$ca2137e69176009d$var$sha256.hmac = $ca2137e69176009d$var$createHmacMethod();
$ca2137e69176009d$var$sha224.hmac = $ca2137e69176009d$var$createHmacMethod(true);
module.exports = $ca2137e69176009d$var$sha256;

});


parcelRegister("kRPup", function(module, exports) {
module.exports = function player(app) {
    var key = 'nomalabLastAudioQualification';
    function init() {
        if (localStorage.getItem(key) === null) localStorage.setItem(key, JSON.stringify({}));
    }
    function clean() {
        if (localStorage.getItem(key) != null) {
            localStorage.setItem(key, JSON.stringify({}));
            app.ports.content.send(getContent());
        }
    }
    function set(k, v, l, t) {
        var s = JSON.parse(localStorage.getItem(key));
        s[k] = {
            v: v,
            l: l,
            t: t
        };
        localStorage.setItem(key, JSON.stringify(s));
    }
    function get(record) {
        return {
            fileId: record.fileId,
            channels: record.channels,
            result: getContent()
        };
    }
    function getContent() {
        var store = JSON.parse(localStorage.getItem(key));
        var r = [];
        Object.keys(store).forEach(function(k) {
            r.push({
                index: parseInt(k, 10),
                version: store[k].v,
                layout: store[k].l,
                typeVersion: store[k].t
            });
        });
        return r;
    }
    init();
    app.ports.get.subscribe(function(record) {
        app.ports.lastAudioQualification.send(get(record));
    });
    app.ports.info.subscribe(function() {
        app.ports.content.send(getContent());
    });
    app.ports.clean.subscribe(clean);
    app.ports.save.subscribe(function(recordList) {
        recordList.forEach(function(record) {
            if (record.layout !== null && record.typeVersion !== null) set(record.index, record.version, record.layout, record.typeVersion);
        });
        app.ports.content.send(getContent());
    });
    return app;
};

});

"use strict";
const $be336afef88fa60f$var$global_ = window || self || $parcel$global || Function('return this')();
const $be336afef88fa60f$var$setTimeout_ = setTimeout;
const $be336afef88fa60f$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $be336afef88fa60f$var$secret = -Math.random();
let $be336afef88fa60f$var$promiseSlot; // 👻
Object.defineProperty(Object.prototype, "_elm_ffi_read_", {
    get () {
        return this.value;
    },
    set (code) {
        try {
            this.value = Function(code)();
        } catch (e) {
            console.error(e);
        }
    }
});
Object.defineProperty(Object.prototype, "_elm_ffi_create_", {
    get () {
        return this.value;
    },
    set ({ args: args, code: code }) {
        this.value = $be336afef88fa60f$var$AsyncFunction(...args, code);
    }
});
Object.defineProperty(Object.prototype, "_elm_ffi_apply_", {
    get () {
        return this.value;
    },
    set ({ holder: holder, params: params }) {
        try {
            const f = this;
            this.value = {
                "AW": $be336afef88fa60f$var$secret
            };
            $be336afef88fa60f$var$promiseSlot = ()=>holder["_elm_ffi_create_"](...params).then((val)=>f.value = {
                        "OK": val
                    }).catch((err)=>f.value = {
                        "ER": err
                    });
        } catch (err) {
            this.value = {
                "ER": err
            };
        }
    }
});
$be336afef88fa60f$var$global_.setTimeout = (callback, time, ...args)=>time === $be336afef88fa60f$var$secret ? $be336afef88fa60f$var$promiseSlot().finally(callback) : $be336afef88fa60f$var$setTimeout_(callback, time, ...args);


// needed for ie11
if (!Object.assign) Object.assign = function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (source.hasOwnProperty(key)) target[key] = source[key];
    }
    return target;
};
// safari
// from https://github.com/uxitten/polyfill
if (!String.prototype.padStart) String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length > targetLength) return String(this);
    else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length);
        return padString.slice(0, targetLength) + String(this);
    }
};
/*
ES6 classes shim for custom elements

> See: https://github.com/webcomponents/custom-elements/blob/d8ecb29ad12abf79cc40ddfb4771d7673e59fce0/tests/html/shim.html
> and: https://github.com/webcomponents/custom-elements/blob/master/src/native-shim.js

EXAMPLE:

function MyTag() {
  return HTMLElement.apply(this);
}

MyTag.prototype = Object.create(HTMLElement.prototype);
MyTag.prototype.constructor = MyTag;

MyTag.prototype.connectedCallback = function() {
    // when added
}
MyTag.prototype.disconnectedCallback = function() {
    // when removed
}
MyTag.prototype.attributeChangedCallback = function() {
    // when attribute changed
}
MyTag.prototype.adoptedCallback = function() {
    // when added too?
}

*/ (function() {
    if (window.Reflect === undefined || window.customElements === undefined || window.customElements.polyfillWrapFlushCallback) return;
    var BuiltInHTMLElement = HTMLElement;
    var wrapperForTheName = {
        'HTMLElement': function HTMLElement1() {
            return Reflect.construct(BuiltInHTMLElement, [], this.constructor);
        }
    };
    window.HTMLElement = wrapperForTheName['HTMLElement'];
    HTMLElement.prototype = BuiltInHTMLElement.prototype;
    HTMLElement.prototype.constructor = HTMLElement;
    Object.setPrototypeOf(HTMLElement, BuiltInHTMLElement);
})();
//
window.toArray = function(e) {
    return Array.prototype.slice.call(e);
};
// LOGGING (HACK)
Object.defineProperty(Object.prototype, "_elm_ffi_log_str_", {
    get () {
        return this.value;
    },
    set (str) {
        console.log(str);
        this.value = str;
    }
});


var $53dd92cf139b6a84$exports = {};
// hi-tech versioning system
if (localStorage.getItem('version') != 'v01') {
    localStorage.clear();
    localStorage.setItem('version', 'v01');
}
function $53dd92cf139b6a84$var$defaults(name, def) {
    return {
        showAside: $53dd92cf139b6a84$var$get('showAside', '/settings'),
        browserArchive: $53dd92cf139b6a84$var$get('browserArchive', 'seeAll'),
        browserAccept: $53dd92cf139b6a84$var$get('browserAccept', 'seeAll')
    };
}
function $53dd92cf139b6a84$var$subscribe(app) {
    app.ports.setPreference.subscribe(function(value) {
        // sent as a tuple
        $53dd92cf139b6a84$var$set(value[0], value[1]);
    });
    app.ports.resetPreference.subscribe(function(value) {
        localStorage.clear();
    });
    app.ports.downloadAll.subscribe(function(className) {
        let elems = document.getElementsByClassName(className);
        for(let i = 0; i < elems.length; i++)elems[i].click();
    });
}
function $53dd92cf139b6a84$var$get(name, def) {
    return localStorage.getItem(name) || def;
}
function $53dd92cf139b6a84$var$set(name, value) {
    localStorage.setItem(name, value);
}
$53dd92cf139b6a84$exports = {
    defaults: $53dd92cf139b6a84$var$defaults,
    subscribe: $53dd92cf139b6a84$var$subscribe
};


var $cc2b0350e0cbd02a$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return n(r, t, e, u, o);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return n(r, t, e, u, o, a);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return n(r, t, e, u, o, a, i);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return n(r, t, e, u, o, a, i, c);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return n(r, t, e, u, o, a, i, c, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, o) {
        return 5 === n.a ? n.f(r, t, e, u, o) : n(r)(t)(e)(u)(o);
    }
    function A6(n, r, t, e, u, o, a) {
        return 6 === n.a ? n.f(r, t, e, u, o, a) : n(r)(t)(e)(u)(o)(a);
    }
    function A7(n, r, t, e, u, o, a, i) {
        return 7 === n.a ? n.f(r, t, e, u, o, a, i) : n(r)(t)(e)(u)(o)(a)(i);
    }
    function A8(n, r, t, e, u, o, a, i, c) {
        return 8 === n.a ? n.f(r, t, e, u, o, a, i, c) : n(r)(t)(e)(u)(o)(a)(i)(c);
    }
    function A9(n, r, t, e, u, o, a, i, c, f) {
        return 9 === n.a ? n.f(r, t, e, u, o, a, i, c, f) : n(r)(t)(e)(u)(o)(a)(i)(c)(f);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, d(t, r);
    }), u = F2(function(n, r) {
        return r[n];
    });
    function o(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function a(n, r) {
        for(var t, e = [], u = i(n, r, 0, e); u && (t = e.pop()); u = i(t.a, t.b, 0, e));
        return u;
    }
    function i(n, r, t, e) {
        if (t > 100) return e.push(d(n, r)), !0;
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && o(5), !1;
        for(var u in 0 > n.$ && (n = pt(n), r = pt(r)), n)if (!i(n[u], r[u], t + 1, e)) return !1;
        return !0;
    }
    var c = F2(a), f = F2(function(n, r) {
        return !a(n, r);
    });
    function s(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = s(n.a, r.a)) || (t = s(n.b, r.b)) ? t : s(n.c, r.c);
        for(; n.b && r.b && !(t = s(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var l = F2(function(n, r) {
        var t = s(n, r);
        return 0 > t ? gt : t ? wt : $t;
    });
    function d(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function m(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function b(n) {
        return n;
    }
    function p(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var v = F2($);
    function $(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = g(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = g(n.a, r);
        return t;
    }
    var w = {
        $: 0
    };
    function g(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var h = F2(g);
    function k(n) {
        for(var r = w, t = n.length; t--;)r = g(n[t], r);
        return r;
    }
    function C(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var T = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return k(e);
    }), P = F2(function(n, r) {
        return k(C(r).sort(function(r, t) {
            return s(n(r), n(t));
        }));
    }), S = F2(function(n, r) {
        return k(C(r).sort(function(r, t) {
            var e = A2(n, r, t);
            return e === $t ? 0 : e === gt ? -1 : 1;
        }));
    }), A = F2(function(n, r) {
        return n + r;
    }), y = F2(function(n, r) {
        return n - r;
    }), N = F2(function(n, r) {
        return n * r;
    }), L = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? o(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), j = Math.ceil, F = Math.floor, M = Math.round, I = Math.log, D = isNaN, B = F2(function(n, r) {
        return n + r;
    }), x = F2(function(n, r) {
        return n + r;
    }), q = F3(function(n, r, t) {
        for(var e = t.length, u = 0; e > u;){
            var o = t[u], a = t.charCodeAt(u);
            u++, 55296 > a || a > 56319 || (o += t[u], u++), r = A2(n, b(o), r);
        }
        return r;
    }), V = F2(function(n, r) {
        return r.split(n);
    }), O = F2(function(n, r) {
        return r.join(n);
    }), z = F3(function(n, r, t) {
        return t.slice(n, r);
    }), E = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(b(e))) return !1;
        }
        return !0;
    }), H = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), R = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), W = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    }), U = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return w;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return k(u);
    });
    function Q(n) {
        return n + "";
    }
    function _(n) {
        return {
            $: 2,
            b: n
        };
    }
    var Z = _(function(n) {
        return "number" != typeof n ? pn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? At(n) : !isFinite(n) || n % 1 ? pn("an INT", n) : At(n);
    }), K = _(function(n) {
        return "boolean" == typeof n ? At(n) : pn("a BOOL", n);
    }), X = _(function(n) {
        return "number" == typeof n ? At(n) : pn("a FLOAT", n);
    }), J = _(function(n) {
        return At(n);
    }), Y = _(function(n) {
        return "string" == typeof n ? At(n) : n instanceof String ? At(n + "") : pn("a STRING", n);
    }), G = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    }), nn = F2(function(n, r) {
        return {
            $: 7,
            e: n,
            b: r
        };
    });
    function rn(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var tn = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), en = F2(function(n, r) {
        return rn(n, [
            r
        ]);
    }), un = F3(function(n, r, t) {
        return rn(n, [
            r,
            t
        ]);
    }), on = F4(function(n, r, t, e) {
        return rn(n, [
            r,
            t,
            e
        ]);
    }), an = F5(function(n, r, t, e, u) {
        return rn(n, [
            r,
            t,
            e,
            u
        ]);
    }), cn = F9(function(n, r, t, e, u, o, a, i, c) {
        return rn(n, [
            r,
            t,
            e,
            u,
            o,
            a,
            i,
            c
        ]);
    }), fn = F2(function(n, r) {
        try {
            return ln(n, JSON.parse(r));
        } catch (n) {
            return Ct(A2(Tt, "This is not valid JSON! " + n.message, r));
        }
    }), sn = F2(function(n, r) {
        return ln(n, r);
    });
    function ln(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? At(n.c) : pn("null", r);
            case 3:
                return mn(r) ? dn(n.b, r, k) : pn("a LIST", r);
            case 4:
                return mn(r) ? dn(n.b, r, bn) : pn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return pn("an OBJECT with a field named `" + t + "`", r);
                var e = ln(n.b, r[t]);
                return Ce(e) ? e : Ct(A2(Pt, t, e.a));
            case 7:
                var u = n.e;
                return mn(r) ? r.length > u ? (e = ln(n.b, r[u]), Ce(e) ? e : Ct(A2(St, u, e.a))) : pn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : pn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || mn(r)) return pn("an OBJECT", r);
                var o = w;
                for(var a in r)if (r.hasOwnProperty(a)) {
                    if (e = ln(n.b, r[a]), !Ce(e)) return Ct(A2(Pt, a, e.a));
                    o = g(d(a, e.a), o);
                }
                return At(Zt(o));
            case 9:
                for(var i = n.f, c = n.g, f = 0; c.length > f; f++){
                    if (e = ln(c[f], r), !Ce(e)) return e;
                    i = i(e.a);
                }
                return At(i);
            case 10:
                return e = ln(n.b, r), Ce(e) ? ln(n.h(e.a), r) : e;
            case 11:
                for(var s = w, l = n.g; l.b; l = l.b){
                    if (e = ln(l.a, r), Ce(e)) return e;
                    s = g(e.a, s);
                }
                return Ct(yt(Zt(s)));
            case 1:
                return Ct(A2(Tt, n.a, r));
            case 0:
                return At(n.a);
        }
    }
    function dn(n, r, t) {
        for(var e = r.length, u = Array(e), o = 0; e > o; o++){
            var a = ln(n, r[o]);
            if (!Ce(a)) return Ct(A2(St, o, a.a));
            u[o] = a.a;
        }
        return At(t(u));
    }
    function mn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function bn(n) {
        return A2(ke, n.length, function(r) {
            return n[r];
        });
    }
    function pn(n, r) {
        return Ct(A2(Tt, "Expecting " + n, r));
    }
    function vn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return vn(n.b, r.b);
            case 6:
                return n.d === r.d && vn(n.b, r.b);
            case 7:
                return n.e === r.e && vn(n.b, r.b);
            case 9:
                return n.f === r.f && $n(n.g, r.g);
            case 10:
                return n.h === r.h && vn(n.b, r.b);
            case 11:
                return $n(n.g, r.g);
        }
    }
    function $n(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!vn(n[e], r[e])) return !1;
        return !0;
    }
    var wn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function gn(n) {
        return n;
    }
    function hn(n) {
        return n;
    }
    var kn = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function Cn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function Tn(n) {
        return {
            $: 1,
            a: n
        };
    }
    function Pn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var Sn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), An = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), yn = 0;
    function Nn(n) {
        var r = {
            $: 0,
            e: yn++,
            f: n,
            g: null,
            h: []
        };
        return Dn(r), r;
    }
    function Ln(n) {
        return Pn(function(r) {
            r(Cn(Nn(n)));
        });
    }
    function jn(n, r) {
        n.h.push(r), Dn(n);
    }
    var Fn = F2(function(n, r) {
        return Pn(function(t) {
            jn(n, r), t(Cn(0));
        });
    }), Mn = !1, In = [];
    function Dn(n) {
        if (In.push(n), !Mn) {
            for(Mn = !0; n = In.shift();)Bn(n);
            Mn = !1;
        }
    }
    function Bn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, Dn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function xn(n) {
        return Pn(function(r) {
            var t = setTimeout(function() {
                r(Cn(0));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }
    var qn = {};
    function Vn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function On(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, o = n.e, a = n.f;
        function i(n) {
            return A2(Sn, i, {
                $: 5,
                b: function(r) {
                    var i = r.a;
                    return 0 === r.$ ? A3(u, t, i, n) : o && a ? A4(e, t, i.i, i.j, n) : A3(e, t, o ? i.i : i.j, n);
                }
            });
        }
        return t.h = Nn(A2(Sn, i, n.b));
    }
    var zn = F2(function(n, r) {
        return Pn(function(t) {
            n.g(r), t(Cn(0));
        });
    }), En = F2(function(n, r) {
        return A2(Fn, n.h, {
            $: 0,
            a: r
        });
    });
    function Hn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function Rn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Wn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    });
    function Un(n, r, t) {
        var e = {};
        for(var u in Qn(!0, r, e, null), Qn(!1, t, e, null), n)jn(n[u], {
            $: "fx",
            a: e[u] || {
                i: w,
                j: w
            }
        });
    }
    function Qn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, o = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.q)n = r.p(n);
                        return n;
                    }
                    return A2(n ? qn[r].e : qn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: w,
                        j: w
                    }, n ? t.i = g(r, t.i) : t.j = g(r, t.j), t;
                }(n, o, t[u]));
            case 2:
                for(var a = r.m; a.b; a = a.b)Qn(n, a.a, t, e);
                return;
            case 3:
                return void Qn(n, r.o, t, {
                    p: r.n,
                    q: e
                });
        }
    }
    function _n(n) {
        qn[n] && o(3);
    }
    function Zn(n, r) {
        return _n(n), qn[n] = {
            e: Kn,
            r: r,
            a: Xn
        }, Hn(n);
    }
    var Kn = F2(function(n, r) {
        return r;
    });
    function Xn(n) {
        var r = [], t = qn[n].r, e = xn(0);
        return qn[n].b = e, qn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var o = r, a = hn(t(u.a)), i = 0; o.length > i; i++)o[i](a);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function Jn(n, r) {
        return _n(n), qn[n] = {
            f: Yn,
            r: r,
            a: Gn
        }, Hn(n);
    }
    var Yn = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function Gn(n, r) {
        var t = w, e = qn[n].r, u = Cn(null);
        return qn[n].b = u, qn[n].c = F3(function(n, r) {
            return t = r, u;
        }), {
            send: function(n) {
                var u = A2(sn, e, n);
                Ce(u) || o(4);
                for(var a = u.a, i = t; i.b; i = i.b)r(i.a(a));
            }
        };
    }
    var nr = "undefined" != typeof document ? document : {};
    function rr(n, r) {
        n.appendChild(r);
    }
    function tr(n) {
        return {
            $: 0,
            a: n
        };
    }
    var er = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], o = 0; e.b; e = e.b){
                var a = e.a;
                o += a.b || 0, u.push(a);
            }
            return o += u.length, {
                $: 1,
                c: r,
                d: Cr(t),
                e: u,
                f: n,
                b: o
            };
        });
    }), ur = er(void 0), or = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], o = 0; e.b; e = e.b){
                var a = e.a;
                o += a.b.b || 0, u.push(a);
            }
            return o += u.length, {
                $: 2,
                c: r,
                d: Cr(t),
                e: u,
                f: n,
                b: o
            };
        });
    }), ar = or(void 0), ir = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    });
    function cr(n, r) {
        return {
            $: 5,
            l: n,
            m: r,
            k: void 0
        };
    }
    var fr = F3(function(n, r, t) {
        return cr([
            n,
            r,
            t
        ], function() {
            return A2(n, r, t);
        });
    }), sr = F4(function(n, r, t, e) {
        return cr([
            n,
            r,
            t,
            e
        ], function() {
            return A3(n, r, t, e);
        });
    }), lr = F5(function(n, r, t, e, u) {
        return cr([
            n,
            r,
            t,
            e,
            u
        ], function() {
            return A4(n, r, t, e, u);
        });
    }), dr = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), mr = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), br = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), pr = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function vr(n) {
        return "script" == n ? "p" : n;
    }
    function $r(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    var wr, gr = F2(function(n, r) {
        return "a0" === r.$ ? A2(dr, r.n, function(n, r) {
            var t = Fe(r);
            return {
                $: r.$,
                a: t ? A3(Le, 3 > t ? hr : kr, je(n), r.a) : A2(Ne, n, r.a)
            };
        }(n, r.o)) : r;
    }), hr = F2(function(n, r) {
        return d(n(r.a), r.b);
    }), kr = F2(function(n, r) {
        return {
            nP: n(r.nP),
            rg: r.rg,
            pf: r.pf
        };
    });
    function Cr(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, o = t.o;
            if ("a2" !== e) {
                var a = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Tr(a, u, o) : a[u] = o;
            } else "className" === u ? Tr(r, u, hn(o)) : r[u] = hn(o);
        }
        return r;
    }
    function Tr(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Pr(n, r) {
        var t = n.$;
        if (5 === t) return Pr(n.k || (n.k = n.m()), r);
        if (0 === t) return nr.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var o = {
                j: u,
                p: r
            };
            return (a = Pr(e, o)).elm_event_node_ref = o, a;
        }
        if (3 === t) return Sr(a = n.h(n.g), r, n.d), a;
        var a = n.f ? nr.createElementNS(n.f, n.c) : nr.createElement(n.c);
        Sr(a, r, n.d);
        for(var i = n.e, c = 0; i.length > c; c++)rr(a, Pr(1 === t ? i[c] : i[c].b, r));
        return a;
    }
    function Sr(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Ar(n, u) : "a0" === e ? Lr(n, r, u) : "a3" === e ? yr(n, u) : "a4" === e ? Nr(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Ar(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function yr(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Nr(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, o = e.o;
            void 0 !== o ? n.setAttributeNS(u, t, o) : n.removeAttributeNS(u, t);
        }
    }
    function Lr(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var o = t[u], a = e[u];
            if (o) {
                if (a) {
                    if (a.q.$ === o.$) {
                        a.q = o;
                        continue;
                    }
                    n.removeEventListener(u, a);
                }
                a = jr(r, o), n.addEventListener(u, a, wr && {
                    passive: 2 > Fe(o)
                }), e[u] = a;
            } else n.removeEventListener(u, a), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                wr = !0;
            }
        }));
    } catch (n) {}
    function jr(n, r) {
        function t(r) {
            var e = t.q, u = ln(e.a, r);
            if (Ce(u)) {
                for(var o, a = Fe(e), i = u.a, c = a ? 3 > a ? i.a : i.nP : i, f = 1 == a ? i.b : 3 == a && i.rg, s = (f && r.stopPropagation(), (2 == a ? i.b : 3 == a && i.pf) && r.preventDefault(), n); o = s.j;){
                    if ("function" == typeof o) c = o(c);
                    else for(var l = o.length; l--;)c = o[l](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return t.q = r, t;
    }
    function Fr(n, r) {
        return n.$ == r.$ && vn(n.a, r.a);
    }
    function Mr(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Ir(n, r, t, e) {
        if (n !== r) {
            var u = n.$, o = r.$;
            if (u !== o) {
                if (1 !== u || 2 !== o) return void Mr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), o = 1;
            }
            switch(o){
                case 5:
                    for(var a = n.l, i = r.l, c = a.length, f = c === i.length; f && c--;)f = a[c] === i[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Ir(n.k, r.k, s, 0), void (s.length > 0 && Mr(t, 1, e, s));
                case 4:
                    for(var l = n.j, d = r.j, m = !1, b = n.k; 4 === b.$;)m = !0, "object" != typeof l ? l = [
                        l,
                        b.j
                    ] : l.push(b.j), b = b.k;
                    for(var p = r.k; 4 === p.$;)m = !0, "object" != typeof d ? d = [
                        d,
                        p.j
                    ] : d.push(p.j), p = p.k;
                    return m && l.length !== d.length ? void Mr(t, 0, e, r) : ((m ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, d) : l === d) || Mr(t, 2, e, d), void Ir(b, p, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Mr(t, 3, e, r.a));
                case 1:
                    return void Dr(n, r, t, e, xr);
                case 2:
                    return void Dr(n, r, t, e, qr);
                case 3:
                    if (n.h !== r.h) return void Mr(t, 0, e, r);
                    var v = Br(n.d, r.d);
                    v && Mr(t, 4, e, v);
                    var $ = r.i(n.g, r.g);
                    return void ($ && Mr(t, 5, e, $));
            }
        }
    }
    function Dr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var o = Br(n.d, r.d);
            o && Mr(t, 4, e, o), u(n, r, t, e);
        } else Mr(t, 0, e, r);
    }
    function Br(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var o = n[u], a = r[u];
                o === a && "value" !== u && "checked" !== u || "a0" === t && Fr(o, a) || ((e = e || {})[u] = a);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var i = Br(n[u], r[u] || {}, u);
            i && ((e = e || {})[u] = i);
        }
        for(var c in r)c in n || ((e = e || {})[c] = r[c]);
        return e;
    }
    function xr(n, r, t, e) {
        var u = n.e, o = r.e, a = u.length, i = o.length;
        a > i ? Mr(t, 6, e, {
            v: i,
            i: a - i
        }) : i > a && Mr(t, 7, e, {
            v: a,
            e: o
        });
        for(var c = i > a ? a : i, f = 0; c > f; f++){
            var s = u[f];
            Ir(s, o[f], t, ++e), e += s.b || 0;
        }
    }
    function qr(n, r, t, e) {
        for(var u = [], o = {}, a = [], i = n.e, c = r.e, f = i.length, s = c.length, l = 0, d = 0, m = e; f > l && s > d;){
            var b = (A = i[l]).a, p = (y = c[d]).a, v = A.b, $ = y.b, w = void 0, g = void 0;
            if (b !== p) {
                var h = i[l + 1], k = c[d + 1];
                if (h) {
                    var C = h.a, T = h.b;
                    g = p === C;
                }
                if (k) {
                    var P = k.a, S = k.b;
                    w = b === P;
                }
                if (w && g) Ir(v, S, u, ++m), Or(o, u, b, $, d, a), m += v.b || 0, zr(o, u, b, T, ++m), m += T.b || 0, l += 2, d += 2;
                else if (w) m++, Or(o, u, p, $, d, a), Ir(v, S, u, m), m += v.b || 0, l += 1, d += 2;
                else if (g) zr(o, u, b, v, ++m), m += v.b || 0, Ir(T, $, u, ++m), m += T.b || 0, l += 2, d += 1;
                else {
                    if (!h || C !== P) break;
                    zr(o, u, b, v, ++m), Or(o, u, p, $, d, a), m += v.b || 0, Ir(T, S, u, ++m), m += T.b || 0, l += 2, d += 2;
                }
            } else Ir(v, $, u, ++m), m += v.b || 0, l++, d++;
        }
        for(; f > l;){
            var A;
            m++, zr(o, u, (A = i[l]).a, v = A.b, m), m += v.b || 0, l++;
        }
        for(; s > d;){
            var y, N = N || [];
            Or(o, u, (y = c[d]).a, y.b, void 0, N), d++;
        }
        (u.length > 0 || a.length > 0 || N) && Mr(t, 8, e, {
            w: u,
            x: a,
            y: N
        });
    }
    var Vr = "_elmW6BL";
    function Or(n, r, t, e, u, o) {
        var a = n[t];
        if (!a) return o.push({
            r: u,
            A: a = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = a);
        if (1 === a.c) {
            o.push({
                r: u,
                A: a
            }), a.c = 2;
            var i = [];
            return Ir(a.z, e, i, a.r), a.r = u, void (a.s.s = {
                w: i,
                A: a
            });
        }
        Or(n, r, t + Vr, e, u, o);
    }
    function zr(n, r, t, e, u) {
        var o = n[t];
        if (o) {
            if (0 === o.c) {
                o.c = 2;
                var a = [];
                return Ir(e, o.z, a, u), void Mr(r, 9, u, {
                    w: a,
                    A: o
                });
            }
            zr(n, r, t + Vr, e, u);
        } else {
            var i = Mr(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: i
            };
        }
    }
    function Er(n, r, t, e) {
        Hr(n, r, t, 0, 0, r.b, e);
    }
    function Hr(n, r, t, e, u, o, a) {
        for(var i = t[e], c = i.r; c === u;){
            var f = i.$;
            if (1 === f) Er(n, r.k, i.s, a);
            else if (8 === f) i.t = n, i.u = a, (s = i.s.w).length > 0 && Hr(n, r, s, 0, u, o, a);
            else if (9 === f) {
                i.t = n, i.u = a;
                var s, l = i.s;
                l && (l.A.s = n, (s = l.w).length > 0 && Hr(n, r, s, 0, u, o, a));
            } else i.t = n, i.u = a;
            if (!(i = t[++e]) || (c = i.r) > o) return e;
        }
        var d = r.$;
        if (4 === d) {
            for(var m = r.k; 4 === m.$;)m = m.k;
            return Hr(n, m, t, e, u + 1, o, n.elm_event_node_ref);
        }
        for(var b = r.e, p = n.childNodes, v = 0; b.length > v; v++){
            u++;
            var $ = 1 === d ? b[v] : b[v].b, w = u + ($.b || 0);
            if (!(u > c || c > w || (i = t[e = Hr(p[v], $, t, e, u, w, a)]) && (c = i.r) <= o)) return e;
            u = w;
        }
        return e;
    }
    function Rr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, o = Wr(u, e);
            u === n && (n = o);
        }
        return n;
    }
    function Wr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Pr(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Sr(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Rr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, a = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(Pr(u[e], r.u), a);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var i = t.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Rr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = nr.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                rr(t, 2 === u.c ? u.s : Pr(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Rr(n, t.w);
                    for(var u = t.x, o = 0; u.length > o; o++){
                        var a = u[o], i = a.A, c = 2 === i.c ? i.s : Pr(i.z, r.u);
                        n.insertBefore(c, n.childNodes[a.r]);
                    }
                    return e && rr(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                o(10);
        }
    }
    function Ur(n) {
        if (3 === n.nodeType) return tr(n.textContent);
        if (1 !== n.nodeType) return tr("");
        for(var r = w, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = g(A2(pr, u.name, u.value), r);
        }
        var o = n.tagName.toLowerCase(), a = w, i = n.childNodes;
        for(e = i.length; e--;)a = g(Ur(i[e]), a);
        return A3(ur, o, r, a);
    }
    var Qr = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, a) {
            var i = A2(sn, n, r ? r.flags : void 0);
            Ce(i) || o(2);
            var c = {}, f = (i = t(i.a)).a, s = a(d, f), l = function(n, r) {
                var t;
                for(var e in qn){
                    var u = qn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = On(u, r);
                }
                return t;
            }(c, d);
            function d(n, r) {
                s(f = (i = A2(e, n, f)).a, r), Un(c, i.b, u(f));
            }
            return Un(c, i.b, u(f)), l ? {
                ports: l
            } : {};
        }(r, e, n.m, n.q, n.rm, function(r, t) {
            var u = n.r, o = e.node, a = Ur(o);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (_r(e), r(n), 1);
                }
                return function(u, o) {
                    n = u, o ? (r(n), 2 === t && (t = 1)) : (0 === t && _r(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Ir(n, r, t, 0), t;
                }(a, t);
                o = function(n, r, t, e) {
                    return 0 === t.length ? n : (Er(n, r, t, e), Rr(n, t));
                }(o, a, e, r), a = t;
            });
        });
    }), _r = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    var Zr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, Kr = "undefined" != typeof document ? document : Zr, Xr = "undefined" != typeof window ? window : Zr, Jr = F3(function(n, r, t) {
        return Ln(Pn(function() {
            function e(n) {
                Nn(t(n));
            }
            return n.addEventListener(r, e, wr && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), Yr = F2(function(n, r) {
        var t = ln(n, r);
        return Ce(t) ? ht(t.a) : kt;
    });
    var Gr = F2(function(n, r) {
        return function(n, r) {
            return Pn(function(t) {
                _r(function() {
                    var e = document.getElementById(n);
                    t(e ? Cn(r(e)) : Tn(Ie(n)));
                });
            });
        }(r, function(r) {
            return r[n](), 0;
        });
    }), nt = F3(function(n, r, t) {
        return Pn(function(e) {
            function u(n) {
                e(r(t.cN.a(n)));
            }
            var o = new XMLHttpRequest;
            o.addEventListener("error", function() {
                u(ai);
            }), o.addEventListener("timeout", function() {
                u(fi);
            }), o.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? oi : ei, function(n) {
                        return {
                            sr: n.responseURL,
                            bo: n.status,
                            re: n.statusText,
                            l5: rt(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.cN.b, o));
            }), si(t.h1) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || Nn(A2(li, n, d(t, ci({
                        qx: e.loaded,
                        qP: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || Nn(A2(li, n, d(t, ii({
                        pA: e.loaded,
                        qP: e.lengthComputable ? ht(e.total) : kt
                    }))));
                });
            }(n, o, t.h1.a);
            try {
                o.open(t.aP, t.sr, !0);
            } catch (n) {
                return u(ui(t.sr));
            }
            return function(n, r) {
                for(var t = r.l5; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.dF.a || 0, n.responseType = r.cN.d, n.withCredentials = r.iI;
            }(o, t), t.ei.a && o.setRequestHeader("Content-Type", t.ei.a), o.send(t.ei.b), function() {
                o.c = !0, o.abort();
            };
        });
    });
    function rt(n) {
        if (!n) return Su;
        for(var r = Su, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], o = u.indexOf(": ");
            if (o > 0) {
                var a = u.substring(0, o), i = u.substring(o + 2);
                r = A3(hi, a, function(n) {
                    return ht(si(n) ? i + ", " + n.a : i);
                }, r);
            }
        }
        return r;
    }
    var tt = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), et = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    }), ut = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ot = F5(function(n, r, t, e, u) {
        for(var o = n.length, a = u.length >= r + o, i = 0; a && o > i;){
            var c = u.charCodeAt(r);
            a = n[i++] === u[r++] && (10 === c ? (t++, e = 1) : (e++, 55296 == (63488 & c) ? n[i++] === u[r++] : 1));
        }
        return m(a ? r : -1, t, e);
    }), at = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), it = F2(function(n, r) {
        return Pn(function() {
            var t = setInterval(function() {
                Nn(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), ct = F2(function(n, r) {
        var t = "g";
        n.n4 && (t += "m"), n.jF && (t += "i");
        try {
            return ht(RegExp(r, t));
        } catch (n) {
            return kt;
        }
    }), ft = F2(function(n, r) {
        return null !== r.match(n);
    }), st = F3(function(n, r, t) {
        for(var e, u = [], o = 0, a = t, i = r.lastIndex, c = -1; o++ < n && (e = r.exec(a)) && c != r.lastIndex;){
            for(var f = e.length - 1, s = Array(f); f > 0;){
                var l = e[f];
                s[--f] = l ? ht(l) : kt;
            }
            u.push(A4(Rg, e[0], e.index, o, k(s))), c = r.lastIndex;
        }
        return r.lastIndex = i, k(u);
    }), lt = F4(function(n, r, t, e) {
        var u = 0;
        return e.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var e = arguments.length - 3, o = Array(e); e > 0;){
                var a = arguments[e];
                o[--e] = a ? ht(a) : kt;
            }
            return t(A4(Rg, r, arguments[arguments.length - 2], u, k(o)));
        });
    }), dt = 1 / 0, mt = h, bt = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, o = A3(n, t.b, t.c, A3(bt, n, r, t.e));
            n = u, r = o, t = e;
        }
    }), pt = function(n) {
        return A3(bt, F3(function(n, r, t) {
            return A2(mt, d(n, r), t);
        }), w, n);
    }, vt = function(n) {
        return A3(bt, F3(function(n, r, t) {
            return A2(mt, n, t);
        }), w, n);
    }, $t = 1, wt = 2, gt = 0, ht = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kt = {
        $: 1
    }, Ct = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Tt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Pt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), St = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), At = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Nt = A, Lt = E, jt = v, Ft = wn, Mt = Q, It = F2(function(n, r) {
        return A2(O, n, C(r));
    }), Dt = F2(function(n, r) {
        return k(A2(V, n, r));
    }), Bt = function(n) {
        return A2(It, "\n    ", A2(Dt, "\n", n));
    }, xt = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, o = A2(n, t.a, r);
            n = u, r = o, t = e;
        }
    }), qt = function(n) {
        return A3(xt, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Vt = T, Ot = y, zt = F3(function(n, r, t) {
        for(;;){
            if (s(n, r) >= 1) return t;
            var e = n, u = r - 1, o = A2(mt, r, t);
            n = e, r = u, t = o;
        }
    }), Et = F2(function(n, r) {
        return A3(zt, n, r, w);
    }), Ht = F2(function(n, r) {
        return A3(Vt, n, A2(Et, 0, qt(r) - 1), r);
    }), Rt = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Wt = function(n) {
        var r = Rt(n);
        return r >= 97 && 122 >= r;
    }, Ut = function(n) {
        var r = Rt(n);
        return 90 >= r && r >= 65;
    }, Qt = function(n) {
        var r = Rt(n);
        return 57 >= r && r >= 48;
    }, _t = function(n) {
        return Wt(n) || Ut(n) || Qt(n);
    }, Zt = function(n) {
        return A3(xt, mt, w, n);
    }, Kt = F2(function(n, r) {
        return "\n\n(" + Mt(n + 1) + ") " + Bt(Xt(r));
    }), Xt = function(n) {
        return A2(Jt, n, w);
    }, Jt = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n, r, e = (r = (n = t).charCodeAt(0)) ? ht(55296 > r || r > 56319 ? d(n[0], n.slice(1)) : d(n[0] + n[1], n.slice(2))) : kt;
                    if (1 === e.$) return !1;
                    var u, o = e.a, a = o.b;
                    return (Wt(u = o.a) || Ut(u)) && A2(Lt, _t, a);
                }();
                n = e, r = A2(mt, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var o = "[" + Mt(n.a) + "]";
                n = e, r = A2(mt, o, r);
                continue n;
            case 2:
                var a = n.a;
                if (a.b) {
                    if (a.b.b) {
                        var i = function() {
                            return r.b ? "The Json.Decode.oneOf at json" + A2(It, "", Zt(r)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + Mt(qt(a)) + " ways:";
                        return A2(It, "\n\n", A2(mt, i, A2(Ht, Kt, a)));
                    }
                    n = e = a.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return r.b ? " at json" + A2(It, "", Zt(r)) : "!";
                }();
            default:
                var c = n.a, f = n.b;
                return (i = function() {
                    return r.b ? "Problem with the value at json" + A2(It, "", Zt(r)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (Bt(A2(Ft, 4, f)) + "\n\n") + c;
        }
    }), Yt = 32, Gt = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), ne = [], re = j, te = F2(function(n, r) {
        return I(r) / I(n);
    }), ee = re(A2(te, 2, Yt)), ue = A4(Gt, 0, ee, ne, ne), oe = t, ae = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ie = F2(function(n, r) {
        return n(r);
    }), ce = F2(function(n, r) {
        return r(n);
    }), fe = c, se = F, le = function(n) {
        return n.length;
    }, de = F2(function(n, r) {
        return s(n, r) > 0 ? n : r;
    }), me = N, be = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pe = e, ve = F2(function(n, r) {
        for(;;){
            var t = A2(pe, Yt, n), e = t.b, u = A2(mt, be(t.a), r);
            if (!e.b) return Zt(u);
            n = e, r = u;
        }
    }), $e = function(n) {
        return n.a;
    }, we = F2(function(n, r) {
        for(;;){
            var t = re(r / Yt);
            if (1 === t) return A2(pe, Yt, n).a;
            n = A2(ve, n, w), r = t;
        }
    }), ge = F2(function(n, r) {
        if (r.n) {
            var t = r.n * Yt, e = se(A2(te, Yt, t - 1)), u = n ? Zt(r.t) : r.t, o = A2(we, u, r.n);
            return A4(Gt, le(r.s) + t, A2(de, 5, e * ee), o, r.s);
        }
        return A4(Gt, le(r.s), ee, ne, r.s);
    }), he = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(ge, !1, {
                t: e,
                n: t / Yt | 0,
                s: u
            });
            var o = ae(A3(oe, Yt, r, n));
            r -= Yt, e = A2(mt, o, e);
        }
    }), ke = F2(function(n, r) {
        if (n > 0) {
            var t = n % Yt;
            return A5(he, r, n - t - Yt, n, w, A3(oe, t, n - t, r));
        }
        return ue;
    }), Ce = function(n) {
        return !n.$;
    }, Te = tn, Pe = K, Se = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Ae = Se, ye = Ae("div"), Ne = en, Le = un, je = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Fe = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Me = function(n) {
        return n;
    }, Ie = Me, De = F6(function(n, r, t, e, u, o) {
        return {
            fd: o,
            fr: r,
            gs: e,
            gz: t,
            pl: n,
            px: u
        };
    }), Be = H, xe = function(n) {
        return n.length;
    }, qe = z, Ve = F2(function(n, r) {
        return 1 > n ? r : A3(qe, n, xe(r), r);
    }), Oe = U, ze = function(n) {
        return "" === n;
    }, Ee = F2(function(n, r) {
        return 1 > n ? "" : A3(qe, 0, n, r);
    }), He = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var o = n.charCodeAt(u);
            if (48 > o || o > 57) return kt;
            r = 10 * r + o - 48;
        }
        return u == e ? kt : ht(45 == t ? -r : r);
    }, Re = F5(function(n, r, t, e, u) {
        if (ze(u) || A2(Be, "@", u)) return kt;
        var o = A2(Oe, ":", u);
        if (o.b) {
            if (o.b.b) return kt;
            var a = o.a, i = He(A2(Ve, a + 1, u));
            if (1 === i.$) return kt;
            var c = i;
            return ht(A6(De, n, A2(Ee, a, u), c, r, t, e));
        }
        return ht(A6(De, n, u, kt, r, t, e));
    }), We = F4(function(n, r, t, e) {
        if (ze(e)) return kt;
        var u = A2(Oe, "/", e);
        if (u.b) {
            var o = u.a;
            return A5(Re, n, A2(Ve, o, e), r, t, A2(Ee, o, e));
        }
        return A5(Re, n, "/", r, t, e);
    }), Ue = F3(function(n, r, t) {
        if (ze(t)) return kt;
        var e = A2(Oe, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(We, n, ht(A2(Ve, u + 1, t)), r, A2(Ee, u, t));
        }
        return A4(We, n, kt, r, t);
    }), Qe = F2(function(n, r) {
        if (ze(r)) return kt;
        var t = A2(Oe, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(Ue, n, ht(A2(Ve, e + 1, r)), A2(Ee, e, r));
        }
        return A3(Ue, n, kt, r);
    }), _e = R, Ze = Cn, Ke = Ze(0), Xe = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, o = e.b;
            if (o.b) {
                var a = o.a, i = o.b;
                if (i.b) {
                    var c = i.a, f = i.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, a, A2(n, c, A2(n, f.a, t > 500 ? A3(xt, n, r, Zt(s)) : A4(Xe, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, a, A2(n, c, r)));
                }
                return A2(n, u, A2(n, a, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Je = F3(function(n, r, t) {
        return A4(Xe, n, r, 0, t);
    }), Ye = F2(function(n, r) {
        return A3(Je, F2(function(r, t) {
            return A2(mt, n(r), t);
        }), w, r);
    }), Ge = Sn, nu = F2(function(n, r) {
        return A2(Ge, function(r) {
            return Ze(n(r));
        }, r);
    }), ru = F3(function(n, r, t) {
        return A2(Ge, function(r) {
            return A2(Ge, function(t) {
                return Ze(A2(n, r, t));
            }, t);
        }, r);
    }), tu = function(n) {
        return A3(Je, ru(mt), Ze(w), n);
    }, eu = zn, uu = F2(function(n, r) {
        var t = r;
        return Ln(A2(Ge, eu(n), t));
    }), ou = F3(function(n, r) {
        return A2(nu, function() {
            return 0;
        }, tu(A2(Ye, uu(n), r)));
    }), au = F3(function() {
        return Ze(0);
    }), iu = F2(function(n, r) {
        return A2(nu, n, r);
    });
    qn.Task = Vn(Ke, ou, au, iu);
    var cu, fu = Hn("Task"), su = F2(function(n, r) {
        return fu(A2(nu, n, r));
    }), lu = Qr, du = G, mu = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), bu = F3(function(n, r, t) {
        return n(r(t));
    }), pu = function(n) {
        return !n;
    }, vu = F2(function(n, r) {
        return !A2(mu, A2(bu, pu, n), r);
    }), $u = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), wu = {
        $: -2
    }, gu = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5($u, n, r, t, e, u);
            var o = e.d;
            return a = e.e, A5($u, 0, e.b, e.c, A5($u, 1, o.b, o.c, o.d, o.e), A5($u, 1, r, t, a, u));
        }
        var a, i = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5($u, n, i, c, A5($u, 0, r, t, e, f), s) : A5($u, 0, r, t, A5($u, 1, e.b, e.c, e.d, a = e.e), A5($u, 1, i, c, f, s));
    }), hu = l, ku = F3(function(n, r, t) {
        if (-2 === t.$) return A5($u, 0, n, r, wu, wu);
        var e = t.a, u = t.b, o = t.c, a = t.d, i = t.e;
        switch(A2(hu, n, u)){
            case 0:
                return A5(gu, e, u, o, A3(ku, n, r, a), i);
            case 1:
                return A5($u, e, u, r, a, i);
            default:
                return A5(gu, e, u, o, a, A3(ku, n, r, i));
        }
    }), Cu = F3(function(n, r, t) {
        var e = A3(ku, n, r, t);
        return -1 !== e.$ || e.a ? e : A5($u, 1, e.b, e.c, e.d, e.e);
    }), Tu = function(n) {
        return !n.b;
    }, Pu = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return Tu(n.a.c) ? d(t, e) : d(t, A2(mt, n, e));
            case 1:
                return d(t, A2(vu, function(n) {
                    return Tu(n.c);
                }, n.b) ? e : A2(mt, n, e));
            case 2:
            case 4:
                return Tu(n.b) ? d(t, e) : d(t, A2(mt, n, e));
            case 3:
                return d(t, A2(mt, n, e));
            case 5:
            case 7:
            case 8:
                return Tu(n.a) ? d(t, e) : d(t, A2(mt, n, e));
            case 6:
                var u = n.a;
                return ze(u.kB) ? d(t, e) : d(A3(Cu, u.n6, u.kB, t), e);
            default:
                return d(t, A2(vu, function(n) {
                    return Tu(n.b);
                }, n.a) ? e : A2(mt, n, e));
        }
    }), Su = wu, Au = function(n) {
        return {
            $: 6,
            a: n
        };
    }, yu = F2(function(n, r) {
        return r.b ? A3(Je, mt, r, n) : n;
    }), Nu = F2(function(n, r) {
        return A2(yu, A2(Ye, function(n) {
            return Au({
                kB: n.b,
                n6: n.a
            });
        }, pt(n)), r);
    }), Lu = F2(function(n, r) {
        return r.$ ? kt : ht(n(r.a));
    }), ju = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Fu = function(n) {
        return A2(ju, "", A2(Lu, function(n) {
            return '@charset "' + n + '"';
        }, n));
    }, Mu = F2(function(n, r) {
        return A3(Je, F2(function(r, t) {
            return n(r) ? A2(mt, r, t) : t;
        }), w, r);
    }), Iu = function(n) {
        return "(" + n.e7 + A2(ju, "", A2(Lu, jt(": "), n.sw)) + ")";
    }, Du = function(n) {
        var r = F3(function(n, r, t) {
            return n + " " + A2(It, " and ", A2(mt, function(n) {
                switch(n){
                    case 0:
                        return "print";
                    case 1:
                        return "screen";
                    default:
                        return "speech";
                }
            }(r), A2(Ye, Iu, t)));
        });
        switch(n.$){
            case 0:
                return A2(It, " and ", A2(Ye, Iu, n.a));
            case 1:
                return A3(r, "only", n.a, n.b);
            case 2:
                return A3(r, "not", n.a, n.b);
            default:
                return n.a;
        }
    }, Bu = F2(function(n, r) {
        return '@import "' + n + Du(r) + '"';
    }), xu = function(n) {
        var r = n.b;
        return A2(It, "\n", A2(Ye, Bu(n.a), r));
    }, qu = function(n) {
        return "@namespace " + n.a + '"' + n.b + '"';
    }, Vu = "    ", Ou = function(n) {
        return $(Vu, n);
    }, zu = function(n) {
        return n + ";";
    }, Eu = function(n) {
        return A2(It, "\n", A2(Ye, A2(bu, Ou, zu), n));
    }, Hu = x, Ru = function(n) {
        return "::" + n;
    }, Wu = function(n) {
        switch(n){
            case 0:
                return "+";
            case 1:
                return "~";
            case 2:
                return ">";
            default:
                return "";
        }
    }, Uu = function(n) {
        switch(n.$){
            case 0:
                return "." + n.a;
            case 1:
                return "#" + n.a;
            case 2:
                return ":" + n.a;
            default:
                return "[" + n.a + "]";
        }
    }, Qu = function(n) {
        switch(n.$){
            case 0:
            default:
                return A2(It, "", A2(mt, n.a, A2(Ye, Uu, r = n.b)));
            case 1:
                var r;
                return Tu(r = n.a) ? "*" : A2(It, "", A2(Ye, Uu, r));
        }
    }, _u = function(n) {
        var r = n.b;
        return A2(It, " ", k([
            Wu(n.a),
            Qu(r)
        ]));
    }, Zu = function(n) {
        var r = n.b, t = n.c, e = A2(mt, Qu(n.a), A2(Ye, _u, r)), u = A2(It, "", k([
            A2(ju, "", A2(Lu, Ru, t))
        ]));
        return A2(Hu, A2(It, " ", A2(Mu, A2(bu, pu, ze), e)), u);
    }, Ku = F2(function(n, r) {
        var t = r.c;
        return A2(It, "", k([
            A2(It, ", ", A2(Ye, Zu, A2(mt, r.a, r.b))),
            " {\n",
            n,
            Eu(t),
            "\n",
            n,
            "}"
        ]));
    }), Xu = function(n) {
        switch(n.$){
            case 0:
                return A2(Ku, "", n.a);
            case 1:
                var r = n.b;
                return "@media " + A2(It, ",\n", A2(Ye, Du, n.a)) + " {\n" + A2(It, "\n\n", A2(Ye, A2(bu, Ou, Ku(Vu)), r)) + "\n}";
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 8:
            default:
                return "TODO";
            case 6:
                return "@keyframes " + n.a.n6 + " {\n" + n.a.kB + "\n}";
        }
    }, Ju = function(n) {
        return A3(Je, yu, w, n);
    }, Yu = F2(function(n, r) {
        return Ju(A2(Ye, n, r));
    }), Gu = function(n) {
        return {
            $: 8,
            a: n
        };
    }, no = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ro = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), to = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), eo = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), uo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, oo = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ao = function(n) {
        return {
            $: 7,
            a: n
        };
    }, io = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), co = F2(function(n, r) {
        return r.b ? r.b.b ? A2(mt, r.a, A2(co, n, r.b)) : k([
            n(r.a)
        ]) : r;
    }), fo = F2(function(n, r) {
        return A3(eo, r.a, r.b, $(r.c, k([
            n
        ])));
    }), so = F2(function(n, r) {
        if (!r.b) return r;
        if (r.b.b) return A2(mt, r.a, A2(so, n, r.b));
        switch(r.a.$){
            case 0:
                return k([
                    uo(A2(fo, n, r.a.a))
                ]);
            case 1:
                var t = r.a, e = t.b;
                return k([
                    A2(io, t.a, A2(co, fo(n), e))
                ]);
            default:
                return r;
        }
    }), lo = F2(function(n, r) {
        if (r.b.b) {
            var t = r.a, e = r.b, u = (a = r.c, A2(Ye, n, e)), o = n(t);
            return k([
                A3(eo, t, e, a),
                A3(eo, o, u, w)
            ]);
        }
        var a, i = r.a;
        return k([
            A3(eo, i, w, a = r.c),
            A3(eo, n(i), w, w)
        ]);
    }), mo = F2(function(n, r) {
        return A3(to, r.a, r.b, ht(n));
    }), bo = F2(function(n, r) {
        return A2(lo, mo(n), r);
    }), po = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), vo = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), $o = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wo = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(vo, r.a, $(r.b, k([
                    n
                ])));
            case 1:
                return $o($(r.a, k([
                    n
                ])));
            default:
                return A2(po, r.a, $(r.b, k([
                    n
                ])));
        }
    }), go = F2(function(n, r) {
        if (r.b) {
            if (r.b.b) return A2(mt, r.a, A2(go, n, r.b));
            var t = r.a;
            return k([
                d(t.a, A2(wo, n, t.b))
            ]);
        }
        return w;
    }), ho = F2(function(n, r) {
        if (r.b.b) return t = r.c, A3(to, r.a, A2(go, n, r.b), t);
        var t = r.c;
        return A3(to, A2(wo, n, r.a), w, t);
    }), ko = F2(function(n, r) {
        return A2(lo, ho(n), r);
    }), Co = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.a.$) {
                    n = t = n.b;
                    continue n;
                }
                var r = n.a.a, t = n.b;
                return $(A2(mt, r.a, r.b), Co(t));
            }
            return w;
        }
    }, To = F5(function(n, r, t, e, u) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Po = F2(function(n, r) {
        n: for(;;){
            if (!r.b) return r;
            if (r.b.b) break n;
            switch(r.a.$){
                case 0:
                    return A2(Ye, uo, n(s = r.a.a));
                case 1:
                    if (r.a.b.b) {
                        if (r.a.b.b.b) {
                            var t = r.a, e = t.b, u = e.a, o = A2(Po, n, k([
                                A2(io, t.a, e.b)
                            ]));
                            if (o.b && 1 === o.a.$ && !o.b.b) {
                                var a = o.a;
                                return k([
                                    A2(io, a.a, A2(mt, u, a.b))
                                ]);
                            }
                            return o;
                        }
                        var i = r.a;
                        return k([
                            A2(io, i.a, n(s = i.b.a))
                        ]);
                    }
                    break n;
                case 2:
                    var c = r.a;
                    return k([
                        A2(oo, c.a, A2(Po, n, c.b))
                    ]);
                case 3:
                    var f = r.a, s = f.e;
                    return A2(Ye, A4(To, f.a, f.b, f.c, f.d), n(s));
                default:
                    return r;
            }
        }
        return A2(mt, u = r.a, A2(Po, n, r.b));
    }), So = B, Ao = F4(function(n, r, t, e) {
        return {
            aD: e,
            l4: t,
            au: r,
            qz: n
        };
    }), yo = 3432918353, No = 461845907, Lo = F2(function(n, r) {
        return (65535 & r) * n + (((r >>> 16) * n & 65535) << 16);
    }), jo = f, Fo = F2(function(n, r) {
        return r << n | r >>> 32 - n;
    }), Mo = q, Io = F2(function(n, r) {
        return A2(Lo, 5, A2(Fo, 13, n ^ A2(Lo, No, A2(Fo, 15, A2(Lo, yo, r))))) + 3864292196;
    }), Do = F2(function(n, r) {
        var t = r.l4 | (255 & Rt(n)) << r.qz;
        return 24 === r.qz ? {
            aD: r.aD + 1,
            l4: 0,
            au: A2(Io, r.au, t),
            qz: 0
        } : {
            aD: r.aD + 1,
            l4: t,
            au: r.au,
            qz: r.qz + 8
        };
    }), Bo = F2(function(n, r) {
        var t, e, u, o;
        return ((o = A2(Lo, 3266489909, (u = A2(Lo, 2246822507, (e = ((t = A3(Mo, Do, A4(Ao, 0, n, 0, 0), r)).l4 ? t.au ^ A2(Lo, No, A2(Fo, 15, A2(Lo, yo, t.l4))) : t.au) ^ t.aD) ^ e >>> 16)) ^ u >>> 13)) ^ o >>> 16) >>> 0;
    }), xo = function(n) {
        return C(n).join("");
    }, qo = L, Vo = function(n) {
        n: for(;;)switch(n){
            case 0:
                return "0";
            case 1:
                return "1";
            case 2:
                return "2";
            case 3:
                return "3";
            case 4:
                return "4";
            case 5:
                return "5";
            case 6:
                return "6";
            case 7:
                return "7";
            case 8:
                return "8";
            case 9:
                return "9";
            case 10:
                return "a";
            case 11:
                return "b";
            case 12:
                return "c";
            case 13:
                return "d";
            case 14:
                return "e";
            case 15:
                return "f";
            default:
                continue n;
        }
    }, Oo = F2(function(n, r) {
        for(;;){
            if (16 > r) return A2(mt, Vo(r), n);
            n = A2(mt, Vo(A2(qo, 16, r)), n), r = r / 16 | 0;
        }
    }), zo = function(n) {
        return xo(0 > n ? A2(mt, "-", A2(Oo, w, -n)) : A2(Oo, w, n));
    }, Eo = function(n) {
        return n.b ? ht(n.a) : kt;
    }, Ho = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return ht(k([
                    n.a
                ]));
            }
            return kt;
        }
    }, Ro = function(n) {
        var r, t = function(n) {
            return n.b ? A2(mt, n.a, t(n.b)) : w;
        };
        return k([
            (r = t(n), {
                $: 9,
                a: r
            })
        ]);
    }, Wo = function(n) {
        return k([
            n
        ]);
    }, Uo = F2(function(n, r) {
        return r.$ ? r : A2(io, n, k([
            r.a
        ]));
    }), Qo = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(mt, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), _o = F2(function(n, r) {
        return Zt(A3(Qo, n, r, w));
    }), Zo = F3(function(n, r, t) {
        if (r > 0) {
            var e = d(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return k([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var o = e.b, a = o.b;
                                return k([
                                    o.a,
                                    a.a,
                                    a.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var i = e.b, c = i.b, f = c.b, s = f.b, l = s.b;
                                return A2(mt, i.a, A2(mt, c.a, A2(mt, f.a, A2(mt, s.a, n > 1e3 ? A2(_o, r - 4, l) : A3(Zo, n + 1, r - 4, l)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return k([
                e.b.a
            ]);
        }
        return w;
    }), Ko = F2(function(n, r) {
        return A3(Zo, 0, n, r);
    }), Xo = F5(function(n, r, t, e, u) {
        return u.$ ? u : A5(To, n, r, t, e, u.a);
    }), Jo = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(io, n, k([
                    r.a
                ]));
            case 1:
                var t = r.b;
                return A2(io, $(n, r.a), t);
            case 2:
                var e = r.b;
                return A2(oo, r.a, A2(Ye, Jo(n), e));
            case 3:
                return A5(To, r.a, r.b, r.c, r.d, r.e);
            default:
                return r;
        }
    }), Yo = function(n) {
        return n;
    }, Go = F4(function(n, r, t, e) {
        var u = function(n) {
            var r;
            return A2(ju, w, (r = n).b ? ht(r.b) : kt);
        }, o = A2(na, r, A2(ju, w, Ho(e))), i = function() {
            var n = d(Eo(o), function(n) {
                n: for(;;){
                    if (n.b) {
                        if (n.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return ht(n.a);
                    }
                    return kt;
                }
            }(e));
            if (n.a.$ || n.b.$) return e;
            var r = n.a.a, t = n.b.a;
            return $(A2(Ko, qt(e) - 1, e), k([
                a(t, r) ? t : r
            ]));
        }();
        return $(i, $(u(A2(ju, w, A2(Lu, function(r) {
            return Ju(A2(co, na(n), A2(Ye, Wo, A2(Po, t, r))));
        }, Ho(e)))), u(o)));
    }), na = F2(function(n, r) {
        if (!n.b) return r;
        switch(n.a.$){
            case 0:
                return A2(na, a = n.b, A2(so, n.a.a, r));
            case 1:
                var t = n.a;
                return A4(Go, p = t.b, a = n.b, ko(t.a), r);
            case 2:
                var e = n.a, u = e.a, o = e.b, a = n.b, i = F2(function(n, r) {
                    var t = n.c, e = r.b, o = r.c;
                    return A3(to, n.a, $(n.b, A2(mt, d(u, r.a), e)), function(n) {
                        n: for(;;){
                            if (n.b) {
                                var r = n.a;
                                if (1 === r.$) {
                                    n = n.b;
                                    continue n;
                                }
                                return r;
                            }
                            return kt;
                        }
                    }(k([
                        o,
                        t
                    ])));
                }), c = function(n) {
                    switch(n.$){
                        case 0:
                            var t = n.a, e = t.a, u = t.b, o = t.c, a = A2(Yu, function(n) {
                                return A2(Ye, i(n), A2(mt, e, u));
                            }, Co(r)), c = a.b ? k([
                                uo(A3(eo, a.a, a.b, w))
                            ]) : w;
                            return A2(na, o, c);
                        case 1:
                            return A2(ea, n.a, n.b);
                        case 2:
                            return A2(ua, n.a, n.b);
                        case 3:
                            var f = n.e;
                            return A2(Ye, A4(Xo, n.a, n.b, n.c, n.d), ra(f));
                        case 4:
                            return k([
                                A2(ro, n.a, n.b)
                            ]);
                        case 5:
                            return k([
                                no(n.a)
                            ]);
                        case 6:
                            return k([
                                ao(n.a)
                            ]);
                        case 7:
                            return k([
                                Gu(n.a)
                            ]);
                        default:
                            return Ro(n.a);
                    }
                };
                return Ju($(k([
                    A2(na, a, r)
                ]), A2(Ye, c, A2(Yu, Yo, o))));
            case 3:
                var f = n.a;
                return A4(Go, p = f.b, a = n.b, bo(f.a), r);
            case 5:
                var s = n.a.a, l = (a = n.b, function(n) {
                    return A2(So, "_", zo(A2(Bo, 15739, n)));
                }(s));
                return A2(yu, A2(na, a, A2(so, "animation-name:" + l, r)), k([
                    Au({
                        kB: s,
                        n6: l
                    })
                ]));
            case 4:
                var m = n.a, b = m.a, p = m.b, v = (a = n.b, function() {
                    var n = Co(r);
                    if (n.b) {
                        var t = n.a, e = n.b;
                        return A2(Ye, Uo(b), A2(na, p, Wo(uo(A3(eo, t, e, w)))));
                    }
                    return w;
                }());
                return $(A2(na, a, r), v);
            default:
                return A2(na, $(n.a.a, a = n.b), r);
        }
    }), ra = function(n) {
        return A2(na, n.c, k([
            uo(A3(eo, n.a, n.b, w))
        ]));
    }, ta = function(n) {
        if (n.b) {
            var r = n.b;
            return $(oa(n.a), ta(r));
        }
        return w;
    }, ea = F2(function(n, r) {
        return A2(Yu, function(r) {
            return A2(Ye, Jo(n), ra(r));
        }, r);
    }), ua = F2(function(n, r) {
        var t = ta(A2(Yu, Yo, r));
        return k([
            A2(oo, n, t)
        ]);
    }), oa = function(n) {
        switch(n.$){
            case 0:
                return ra(r = n.a);
            case 1:
                return A2(ea, n.a, n.b);
            case 2:
                return A2(ua, n.a, n.b);
            case 3:
                var r = n.e;
                return A2(Ye, A4(Xo, n.a, n.b, n.c, n.d), ra(r));
            case 4:
                return k([
                    A2(ro, n.a, n.b)
                ]);
            case 5:
                return k([
                    no(n.a)
                ]);
            case 6:
                return k([
                    ao(n.a)
                ]);
            case 7:
                return k([
                    Gu(n.a)
                ]);
            default:
                return Ro(n.a);
        }
    }, aa = function(n) {
        var r, t, e;
        return function(n) {
            var r = n.es, t = n.fu, e = n.ge, u = n.kC;
            return A2(It, "\n\n", A2(Mu, A2(bu, pu, ze), k([
                Fu(r),
                A2(It, "\n", A2(Ye, xu, t)),
                A2(It, "\n", A2(Ye, qu, e)),
                A2(It, "\n\n", A2(Ye, Xu, u))
            ])));
        }(function(n) {
            var r = n.es, t = n.fu, e = n.ge, u = n.kC, o = A3(Je, Pu, d(Su, w), u);
            return {
                es: r,
                kC: A2(Nu, o.a, o.b),
                fu: t,
                ge: e
            };
        }((t = (r = n).fu, e = r.ge, {
            es: r.es,
            kC: ta(A2(Yu, Yo, r.he)),
            fu: t,
            ge: e
        })));
    }, ia = function(n) {
        return A2(It, "\n\n", A2(Ye, aa, n));
    }, ca = function(n) {
        return ur(vr(n));
    }, fa = function(n) {
        return {
            es: kt,
            fu: w,
            ge: w,
            he: n
        };
    }, sa = tr, la = function(n) {
        return {
            $: 4,
            a: n
        };
    }, da = la, ma = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ba = sn, pa = function(n) {
        return n.e;
    }, va = null, $a = {
        lC: Su,
        c$: 1,
        nP: "",
        ar: va,
        N: !1,
        P: 400,
        ag: !1
    }, wa = function(n) {
        return A3(xt, F2(function(n, r) {
            return A3(kn, n.a, n.b, r);
        }), {}, n);
    }, ga = gn, ha = F2(function(n, r) {
        return r.$ ? Ct(n(r.a)) : At(r.a);
    }), ka = F2(function(n, r) {
        return p(r, {
            nP: n
        });
    }), Ca = ha(function(n) {
        var r;
        return r = Xt(n), wa(k([
            d("_elm_ffi_log_str_", ga(r))
        ])), A2(ka, Xt(n), $a);
    }), Ta = F2(function(n, r) {
        return Ca(A2(ba, pa(n), r));
    }), Pa = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Sa = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Aa = function(n) {
        return {
            $: 11,
            a: n
        };
    }, ya = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Na = function(n) {
        return {
            $: 0,
            a: n
        };
    }, La = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ja = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Fa = "Have you setup elm-ffi? https://github.com/Warry/elm-ffi#readme", Ma = J, Ia = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Da = Y, Ba = A2(Ia, "en", A2(ba, Da, A2(Ia, ga(Fa), A2(ba, A2(du, "_elm_ffi_read_", Ma), wa(k([
        d("_elm_ffi_read_", ga('\n    const hashLocationLang = window.location.hash.startsWith("#lang=") ? window.location.hash.slice(6,8) : undefined;\n    const navigatorLang = window.navigator.language;\n    return hashLocationLang ?? navigatorLang;\n    '))
    ])))))), xa = A2(_e, "fr", Ba) ? function(n) {
        return n.bT;
    } : function(n) {
        return n.bN;
    }, qa = xa({
        bN: "End date",
        bT: "Date de fin"
    }), Va = F2(function(n, r) {
        return {
            e: r,
            g: n
        };
    }), Oa = A2(Va, ga, Da), za = function(n) {
        return n({
            jd: kt,
            d8: !1,
            kx: Oa,
            kS: !1,
            kX: "",
            lp: w,
            lS: !1,
            fj: !1,
            l7: "",
            mS: !0,
            m7: "",
            n7: !0,
            gw: "",
            sw: ""
        });
    }, Ea = F2(function(n, r) {
        return {
            jN: r,
            e_: !0,
            m7: n,
            sx: Su
        };
    }), Ha = xa({
        bN: "Select organizations: ",
        bT: "S\xe9lectionnez les organisations: "
    }), Ra = P, Wa = xa({
        bN: "Start date",
        bT: "Date de d\xe9but"
    }), Ua = function(n) {
        return n.toLowerCase();
    }, Qa = function(n) {
        var r = A2(Ye, function(n) {
            return d(n.oO, n.gm);
        }, A2(Ra, A2(bu, Ua, function(n) {
            return n.gm;
        }), n.oQ));
        return {
            lj: za(function(n) {
                return p(n, {
                    m7: qa,
                    gw: "DD/MM/YY"
                });
            }),
            lo: kt,
            oQ: A2(Ea, Ha, r),
            q2: za(function(n) {
                return p(n, {
                    m7: Wa,
                    gw: "DD/MM/YY"
                });
            })
        };
    }, _a = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Za = An, Ka = F2(function(n, r) {
        return fu(A2(Za, A2(bu, A2(bu, Ze, n), Ct), A2(Ge, A2(bu, A2(bu, Ze, n), At), r)));
    }), Xa = Ka, Ja = xa({
        bN: "Confirmation",
        bT: "Confirmation"
    }), Ya = xa({
        bN: "Disable organization emails",
        bT: "D\xe9sactiver les mails de l'organisation"
    }), Ga = xa({
        bN: "Email",
        bT: "Email"
    }), ni = gn, ri = A2(Va, ni, Pe), ti = function(n) {
        return n({
            kx: ri,
            kS: !1,
            lp: w,
            lS: !1,
            fj: !1,
            l7: "",
            mo: "",
            mS: !0,
            m7: "",
            gw: "",
            sw: !1
        });
    }, ei = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ui = function(n) {
        return {
            $: 0,
            a: n
        };
    }, oi = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), ai = {
        $: 2
    }, ii = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ci = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fi = {
        $: 1
    }, si = function(n) {
        return !n.$;
    }, li = En, di = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return kt;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(hu, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return ht(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), mi = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return a = t.b, i = t.c, e = t.d, s = t.e, A5($u, 1, n.b, n.c, A5($u, 0, r.b, r.c, r.d, r.e), A5($u, 0, a, i, e, s));
            }
            var e, u = n.d, o = n.e, a = o.b, i = o.c, c = (e = o.d).d, f = e.e, s = o.e;
            return A5($u, 0, e.b, e.c, A5($u, 1, n.b, n.c, A5($u, 0, u.b, u.c, u.d, u.e), c), A5($u, 1, a, i, f, s));
        }
        return n;
    }, bi = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, l = t.d, d = t.e, A5($u, 1, e = n.b, u = n.c, A5($u, 0, r.b, r.c, r.d, i = r.e), A5($u, 0, f, s, l, d));
            }
            var e = n.b, u = n.c, o = n.d, a = o.d, i = o.e, c = n.e, f = c.b, s = c.c, l = c.d, d = c.e;
            return A5($u, 0, o.b, o.c, A5($u, 1, a.b, a.c, a.d, a.e), A5($u, 1, e, u, i, A5($u, 0, f, s, l, d)));
        }
        return n;
    }, pi = F7(function(n, r, t, e, u, o, a) {
        if (-1 !== o.$ || o.a) {
            n: for(;;){
                if (-1 === a.$ && 1 === a.a) {
                    if (-1 === a.d.$) {
                        if (1 === a.d.a) return bi(r);
                        break n;
                    }
                    return bi(r);
                }
                break n;
            }
            return r;
        }
        return A5($u, t, o.b, o.c, o.d, A5($u, 0, e, u, o.e, a));
    }), vi = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, o = u.d, a = n.e;
            if (1 === u.a) {
                if (-1 !== o.$ || o.a) {
                    var i = mi(n);
                    if (-1 === i.$) {
                        var c = i.e;
                        return A5(gu, i.a, i.b, i.c, vi(i.d), c);
                    }
                    return wu;
                }
                return A5($u, r, t, e, vi(u), a);
            }
            return A5($u, r, t, e, vi(u), a);
        }
        return wu;
    }, $i = F2(function(n, r) {
        if (-2 === r.$) return wu;
        var t = r.a, e = r.b, u = r.c, o = r.d, a = r.e;
        if (0 > s(n, e)) {
            if (-1 === o.$ && 1 === o.a) {
                var i = o.d;
                if (-1 !== i.$ || i.a) {
                    var c = mi(r);
                    if (-1 === c.$) {
                        var f = c.e;
                        return A5(gu, c.a, c.b, c.c, A2($i, n, c.d), f);
                    }
                    return wu;
                }
                return A5($u, t, e, u, A2($i, n, o), a);
            }
            return A5($u, t, e, u, A2($i, n, o), a);
        }
        return A2(wi, n, A7(pi, n, r, t, e, u, o, a));
    }), wi = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, o = r.d, i = r.e;
            if (a(n, e)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(i);
                return -1 === c.$ ? A5(gu, t, c.b, c.c, o, vi(i)) : wu;
            }
            return A5(gu, t, e, u, o, A2($i, n, i));
        }
        return wu;
    }), gi = F2(function(n, r) {
        var t = A2($i, n, r);
        return -1 !== t.$ || t.a ? t : A5($u, 1, t.b, t.c, t.d, t.e);
    }), hi = F3(function(n, r, t) {
        var e = r(A2(di, n, t));
        return e.$ ? A2(gi, n, t) : A3(Cu, n, e.a, t);
    }), ki = {
        $: 0
    }, Ci = F2(function(n, r) {
        return {
            ei: ki,
            aP: n,
            b8: At,
            O: w,
            sr: r
        };
    }), Ti = function(n) {
        return A2(It, "", n);
    }, Pi = F3(function(n, r, t) {
        return r(n(t));
    }), Si = function(n) {
        return n.$ ? "/v4" + function(n) {
            switch(n.$){
                case 0:
                    return "/organizations" + (1 === (u = n.a).$ ? "" : "/" + (u.a + function(n) {
                        switch(n){
                            case 1:
                                return "";
                            case 0:
                                return "/audioMapping";
                            case 2:
                                return "/segmentationRules";
                            case 3:
                                return "/formats";
                            case 4:
                                return "/extraFormats";
                            case 5:
                                return "/metadata/schema";
                            default:
                                return "/summary";
                        }
                    }(u.b)));
                case 1:
                    return "/shows/" + (a = n.a).a + (a.b ? "/events" : "/metadata");
                case 2:
                    return "/admin" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/files/csv";
                            case 1:
                                return "/metadata/schemas";
                            case 2:
                                return "/metadata/schemas/" + n.a;
                            case 3:
                                return "/app" + function(n) {
                                    return n.$ ? "/" + n.a : "";
                                }(n.a);
                            default:
                                return "/dowload";
                        }
                    }(n.a);
                case 3:
                    return "/broadcastables/" + ((o = n.a).a + function(n) {
                        switch(n){
                            case 0:
                                return "/analysis";
                            case 1:
                                return "/delivery";
                            case 2:
                                return "/deliver";
                            default:
                                return "/transcode/ad";
                        }
                    }(o.b));
                case 4:
                    return "/segmentationRules" + ((e = n.a).$ ? "/" + e.a : "");
                case 5:
                    return "/users" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/login";
                            case 1:
                                return "/logout";
                            case 2:
                                var r = n.b;
                                return "/sso?email=" + (n.a + A2(Pi, Lu(jt("&redirect=")), ju(""))(r));
                            case 3:
                                return "/askResetPassword";
                            case 4:
                                return "/resetPassword";
                            default:
                                return "/revoke";
                        }
                    }(n.a);
                case 6:
                    return "/audioMappings" + ((t = n.a).$ ? "/" + t.a : "");
                default:
                    return "/files/" + (r = n.a).a + (r.b ? "/qualifySubtitles" : "/qualifyAudio");
            }
            var r, t, e, u, o, a;
        }(n.a) : "/v3" + function(n) {
            switch(n.$){
                case 0:
                    return "/unitaries" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 1:
                    return "/collections" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 2:
                    return "/seasons" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 3:
                    return "/episodes" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 4:
                    return "/hierarchy" + function(n) {
                        var r = n.a;
                        switch(n.b){
                            case 0:
                                return "/" + r;
                            case 1:
                                return "/" + r + "/archive";
                            case 2:
                                return "/" + r + "/unarchive";
                            case 3:
                                return "/" + r + "/trash";
                            case 4:
                                return "/" + r + "/untrash";
                            case 5:
                                return "/" + r + "/invitations";
                            case 6:
                                return "/" + r + "/shows";
                            default:
                                return "/" + r + "/events";
                        }
                    }(n.a);
                case 5:
                    return "/shows/" + ((i = n.a).a + function(n) {
                        switch(n){
                            case 0:
                                return "";
                            case 1:
                                return "/invitations";
                            case 2:
                                return "/metadata";
                            case 3:
                                return "/files";
                            case 4:
                                return "/versions";
                            case 5:
                                return "/versions/admin";
                            case 6:
                                return "/accept";
                            case 7:
                                return "/archive";
                            case 8:
                                return "/unarchive";
                            case 9:
                                return "/trash";
                            default:
                                return "/untrash";
                        }
                    }(i.b));
                case 6:
                    return "/organizations" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 2:
                                return "/" + (n.a + function(n) {
                                    switch(n){
                                        case 0:
                                            return "";
                                        case 1:
                                            return "/filelist";
                                        case 2:
                                            return "/jobs";
                                        case 3:
                                            return "/subtitleFormats";
                                        default:
                                            return "/shows/deliveries";
                                    }
                                }(n.b));
                            default:
                                return "/deliverables";
                        }
                    }(n.a);
                case 7:
                    return "/channels" + ((a = n.a).$ ? "/" + a.a : "");
                case 8:
                    return "/webhooks" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/api";
                            case 2:
                                return "/api/" + n.a;
                            case 3:
                                return "/email";
                            default:
                                return "/email/" + n.a;
                        }
                    }(n.a);
                case 9:
                    return "/testplans" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/" + n.a;
                            default:
                                return "S3";
                        }
                    }(n.a);
                case 10:
                    return "/formats" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/" + n.a;
                            default:
                                return "/framerates";
                        }
                    }(n.a);
                case 11:
                    return "/subtitleFormats" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/" + n.a;
                            default:
                                return "/framerates";
                        }
                    }(n.a);
                case 12:
                    return "/users" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/logout";
                            case 1:
                                return "/impersonate";
                            case 2:
                                return "";
                            case 3:
                                return "/" + n.a;
                            case 4:
                                return "/password";
                            case 5:
                                return "/switch";
                            default:
                                return "/invitation";
                        }
                    }(n.a);
                case 13:
                    return "/uploads";
                case 14:
                    return "/invitations" + ((o = n.a).$ ? "/" + o.a + "/sftp" : "/" + o.a);
                case 15:
                    return "/reports?start=" + (u = n.a).a + "&end=" + (u.b + Ti(A2(Ye, function(n) {
                        return "&organization=" + n;
                    }, u.c)));
                case 16:
                    return "/comments/" + (e = n.a).a + (e.b ? "/answers" : "");
                case 17:
                    return "/answers/answers/" + n.a;
                case 18:
                    return "/broadcastables/" + ((t = n.a).a + function(n) {
                        switch(n){
                            case 0:
                                return "/copyToShow";
                            case 1:
                                return "/copyToOrganization";
                            case 2:
                                return "/qualify";
                            case 3:
                                return "/comments";
                            default:
                                return "/audioMapping";
                        }
                    }(t.b));
                case 19:
                    return "/files" + (1 === (r = n.a).$ ? "/search?keyName=" + r.a : "/" + (r.a + function(n) {
                        switch(n){
                            case 0:
                                return "";
                            case 1:
                                return "/download";
                            case 2:
                                return "/pause";
                            case 3:
                                return "/markDelivery";
                            case 4:
                                return "/restartVerification";
                            case 5:
                                return "/restartProxyTranscode";
                            case 6:
                                return "/startProxyHiResTranscode";
                            case 7:
                                return "/uploads";
                            case 8:
                                return "/uploads/name";
                            case 9:
                                return "/uploads/progress";
                            case 10:
                                return "/uploads/s3Id";
                            case 11:
                                return "/uploads/error";
                            case 12:
                                return "/uploads/pause";
                            default:
                                return "/segments";
                        }
                    }(r.b)));
                case 20:
                    return "/dashboard";
                case 21:
                    return "/aws/copy";
                case 22:
                    return "/admin/ftp/copy";
                case 23:
                    return "/status";
                case 24:
                    return function(n) {
                        switch(n.$){
                            case 0:
                                return "/organizations/" + n.a + "/jobs";
                            case 1:
                                return "/jobs/" + n.a + "/start";
                            case 2:
                                return "/jobs/" + n.a + "/complete";
                            default:
                                return "/jobs/notcompleted";
                        }
                    }(n.a);
                case 25:
                    return "/admin" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/files/" + n.a + "/probe";
                            case 1:
                                return "/analysis";
                            case 2:
                                return "/analysis/simple";
                            case 3:
                                return "/analysis/" + n.a;
                            case 4:
                                return "/analysis/tasks/organization/" + n.a;
                            default:
                                return "/analysis/tasks/show/" + n.a;
                        }
                    }(n.a);
                case 26:
                    return "/admin" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/shows/path";
                            case 2:
                                return "/files/csv";
                            default:
                                return "/jobs/" + n.a + "/acknowledge";
                        }
                    }(n.a);
                default:
                    return "/segments/" + n.a;
            }
            var r, t, e, u, o, a, i;
        }(n.a);
    }, Ai = function(n) {
        return A2(Ci, "GET", Si(n));
    }, yi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ni = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Li = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ji = F2(function(n, r) {
        return yi(Li(A2(Ni, n, r)));
    }), Fi = function(n) {
        var r = n;
        return {
            e: r.e,
            g: function(n) {
                return wa(r.g(n));
            }
        };
    }, Mi = function(n) {
        return {
            e: je(n),
            g: function() {
                return w;
            }
        };
    }, Ii = function(n) {
        return n.g;
    }, Di = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Bi = function(n) {
        return Di(k([
            A2(Ne, ht, n),
            je(kt)
        ]));
    }, xi = function(n) {
        return {
            e: Bi(pa(n)),
            g: function(r) {
                return 1 === r.$ ? va : A2(Ii, n, r.a);
            }
        };
    }, qi = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: A3(Le, F2(function(n, r) {
                return n(r);
            }), u.e, Bi(A2(du, n, pa(t)))),
            g: function(e) {
                return A2(mt, d(n, A2(Ii, xi(t), r(e))), u.g(e));
            }
        };
    }), Vi = Fi(A4(qi, "sso", function(n) {
        return n.q0;
    }, Oa, Mi(function(n) {
        return {
            q0: n
        };
    }))), Oi = fn, zi = F2(function(n, r) {
        return Ca(A2(Oi, pa(n), r));
    }), Ei = "Une erreur est survenue. Merci de contacter notre service op\xe9rations via le chat ou par mail \xe0 ops@nomalab.com", Hi = F2(function(n, r) {
        var t = A2(zi, n, r);
        return t.$ ? Ct({
            lC: Su,
            nP: "Impossible de lire les donn\xe9es. " + Ei,
            P: 500
        }) : At(t.a);
    }), Ri = F2(function(n, r) {
        return {
            ei: r.ei,
            aP: r.aP,
            b8: n,
            O: r.O,
            sr: r.sr
        };
    }), Wi = A2(bu, Ri, Hi), Ui = Tn, Qi = F2(function(n, r) {
        return A2(Za, A2(bu, Ui, n), r);
    }), _i = function(n) {
        return encodeURIComponent(n);
    }, Zi = function(n) {
        return n.b;
    }, Ki = F3(function(n, r, t) {
        return {
            lC: t,
            nP: r,
            P: n
        };
    }), Xi = F3(function(n, r, t) {
        var e = t;
        return {
            e: r(e.e),
            g: n(e.g)
        };
    }), Ji = function(n) {
        return A3(xt, F2(function(n, r) {
            return A3(Cu, n.a, n.b, r);
        }), Su, n);
    }, Yi = function(n) {
        return A2(Ne, Ji, function(n) {
            return {
                $: 8,
                b: n
            };
        }(n));
    }, Gi = F2(function(n, r) {
        if (-2 === r.$) return wu;
        var t = r.b, e = r.d, u = r.e;
        return A5($u, r.a, t, A2(n, t, r.c), A2(Gi, n, e), A2(Gi, n, u));
    }), nc = A2(Xi, function(n) {
        return A2(bu, A2(bu, wa, pt), Gi(function() {
            return n;
        }));
    }, Yi), rc = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: A3(Le, F2(function(n, r) {
                return n(r);
            }), u.e, A2(du, n, pa(t))),
            g: function(e) {
                return A2(mt, d(n, A2(Ii, t, r(e))), u.g(e));
            }
        };
    }), tc = Z, ec = gn, uc = A2(Va, ec, tc), oc = function(n) {
        return {
            $: 3,
            b: n
        };
    }, ac = F2(function(n, r) {
        return A3(xt, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), ic = A2(Xi, ac, oc), cc = Fi(A4(rc, "fields", function(n) {
        return n.lC;
    }, nc(ic(Oa)), A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, A4(rc, "status", function(n) {
        return n.P;
    }, uc, Mi(Ki))))), fc = Fi(A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, Mi(function(n) {
        return {
            nP: n
        };
    }))), sc = Fi(A4(rc, "error", function(n) {
        return n.lo;
    }, fc, Mi(function(n) {
        return {
            lo: n
        };
    }))), lc = A2(tt, "", Me), dc = function(n) {
        return n.$ ? Ui(n.a) : Ze(n.a);
    }, mc = function(n) {
        var r, t, e;
        return A2(Qi, function(n) {
            return n;
        }, (r = {
            ei: n.ei,
            l5: w,
            aP: n.aP,
            pI: (e = n.b8, lc(function(n) {
                switch(n.$){
                    case 1:
                        return Ct({
                            lC: Su,
                            nP: "Timeout",
                            P: 0
                        });
                    case 2:
                        return Ct({
                            lC: Su,
                            nP: "NetworkError",
                            P: 0
                        });
                    case 0:
                        return Ct({
                            lC: Su,
                            nP: "BadUrl",
                            P: 0
                        });
                    case 3:
                        var r = n.a, t = n.b, u = A2(zi, cc, t);
                        if (u.$) {
                            var o = A2(zi, fc, t);
                            if (o.$) {
                                var a = A2(zi, sc, t);
                                return Ct(a.$ ? {
                                    lC: Su,
                                    nP: Ei,
                                    P: 500
                                } : {
                                    lC: Su,
                                    nP: a.a.lo.nP,
                                    P: r.bo
                                });
                            }
                            return Ct({
                                lC: Su,
                                nP: o.a.nP,
                                P: r.bo
                            });
                        }
                        return Ct(u.a);
                    default:
                        var i = n.b;
                        if (400 > (r = n.a).bo) return e(i);
                        var c = A2(zi, cc, i);
                        if (c.$) {
                            var f = A2(zi, fc, i);
                            if (f.$) {
                                var s = A2(zi, sc, i);
                                return Ct(s.$ ? {
                                    lC: Su,
                                    nP: Ei,
                                    P: 500
                                } : {
                                    lC: Su,
                                    nP: s.a.lo.nP,
                                    P: r.bo
                                });
                            }
                            return Ct({
                                lC: Su,
                                nP: f.a.nP,
                                P: r.bo
                            });
                        }
                        return Ct(c.a);
                }
            })),
            dF: kt,
            sr: $(n.sr, (t = n.O, Tu(t) ? "" : A2(Hu, "?", A2(It, "&", A2(Ye, function(n) {
                return _i(n.a) + "=" + _i(n.b);
            }, t)))))
        }, A3(nt, 0, dc, {
            iI: !1,
            ei: r.ei,
            cN: r.pI,
            l5: r.l5,
            aP: r.aP,
            dF: r.dF,
            h1: kt,
            sr: r.sr
        })));
    }, bc = Rn, pc = F2(function(n, r) {
        return d(r, bc(n));
    }), vc = xa({
        bN: "Name",
        bT: "Nom"
    }), $c = xa({
        bN: "New password",
        bT: "Nouveau mot de passe"
    }), wc = xa({
        bN: "Password",
        bT: "Mot de passe"
    }), gc = F2(function(n, r) {
        var t;
        return A2(pc, k([
            A2(Xa, _a, (t = n.la, mc(A2(Wi, Vi, Ai(A2(ji, t, kt))))))
        ]), {
            kR: ti(function(r) {
                return p(r, {
                    m7: Ya,
                    sw: n.kR
                });
            }),
            la: za(function(r) {
                return p(r, {
                    kS: !0,
                    m7: Ga,
                    sw: n.la
                });
            }),
            lo: kt,
            mU: kt,
            n6: za(function(r) {
                return p(r, {
                    m7: vc,
                    sw: n.n6
                });
            }),
            oe: za(function(n) {
                return p(n, {
                    m7: $c
                });
            }),
            of: za(function(n) {
                return p(n, {
                    m7: Ja
                });
            }),
            o_: za(function(n) {
                return p(n, {
                    m7: wc
                });
            }),
            o$: kt,
            rz: kt,
            sz: r
        });
    }), hc = (cu = kt, function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return {
                                                                                cq: a,
                                                                                cz: i,
                                                                                cE: cu,
                                                                                cF: v,
                                                                                cX: l,
                                                                                cY: n,
                                                                                cZ: b,
                                                                                c2: p,
                                                                                db: t,
                                                                                dc: s,
                                                                                oQ: r,
                                                                                dh: $,
                                                                                dl: c,
                                                                                $7: m,
                                                                                dw: d,
                                                                                dB: o,
                                                                                dK: u,
                                                                                dL: e,
                                                                                dR: f
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt)(kt), kc = A2(pc, w, {
        oW: hc
    }), Cc = F3(function(n, r, t) {
        return {
            d2: !1,
            bL: n.bL,
            e1: {
                dt: Mt(n.op)
            },
            mM: n.mM,
            _: w,
            f_: "",
            b$: !1,
            sr: t,
            st: r,
            dO: {
                fm: n.fm,
                mR: !1,
                ig: n.ig
            }
        };
    }), Tc = Su, Pc = za(Me), Sc = {
        kx: kt,
        lo: kt,
        nm: !0
    }, Ac = function(n) {
        return {
            il: p(Pc, {
                sw: n.bL.ju
            }),
            iv: kt,
            iw: p(Pc, {
                d8: !0,
                kX: "addInBrowserInput"
            }),
            iU: p(Pc, {
                sw: n.bL.jv
            }),
            jL: w,
            jM: w,
            k3: kt,
            k5: p(Pc, {
                d8: !0,
                kX: "editInBrowserInput"
            }),
            lo: kt,
            fD: w,
            mJ: w,
            mM: n.mM,
            og: kt,
            oC: Tc,
            oK: kt,
            oL: p(Pc, {
                sw: "alphabetical"
            }),
            pN: !0,
            qs: kt,
            P: Sc,
            rl: Tc,
            su: n.st.oM
        };
    }, yc = {
        qc: p(za(Me), {
            kX: "searchInBrowserInput",
            n7: !1,
            gw: xa({
                bN: "Search...",
                bT: "Rechercher..."
            })
        }),
        qd: w,
        qe: !1
    }, Nc = {
        $: 0
    }, Lc = {
        $: 1
    }, jc = function(n) {
        return {
            iO: Nc,
            k_: kt,
            k$: kt,
            lo: kt,
            bQ: w,
            oY: Lc,
            pu: "",
            ss: !1,
            st: n
        };
    }, Fc = F2(function(n, r) {
        return A3(tt, "", Me, A2(Pi, r, n));
    }), Mc = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ic = {
        $: 2
    }, Dc = {
        $: 1
    }, Bc = F2(function(n, r) {
        switch(r.$){
            case 0:
                return Ct({
                    $: 0,
                    a: r.a
                });
            case 1:
                return Ct(Dc);
            case 2:
                return Ct(Ic);
            case 3:
                return Ct(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(r.a.bo));
            default:
                return A2(ha, Mc, n(r.b));
        }
    }), xc = F2(function(n, r) {
        return A2(Fc, n, Bc(function(n) {
            return A2(ha, Xt, A2(Oi, r, n));
        }));
    }), qc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vc = nn, Oc = F4(function(n, r, t, e) {
        return A2(Vc, t, A2(Te, function(u) {
            return a(u, r) ? e : 10 > t ? A4(Oc, n, r, t + 1, e) : qc("Can't find : " + r);
        }, A2(du, n, Da)));
    }), zc = A2(du, "refs", A4(Oc, "id", "master", 0, A2(du, "ref", Da))), Ec = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Hc = F2(function(n, r) {
        return {
            gR: n,
            hC: r
        };
    }), Rc = Ze(A2(Hc, Su, w)), Wc = function(n) {
        return Pn(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(Cn(0));
        });
    }, Uc = Ln, Qc = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var o = e.a;
                    return A2(Ge, function(r) {
                        var e = o.h1;
                        return A3(Qc, n, u, 1 === e.$ ? t : A3(Cu, e.a, r, t));
                    }, Uc(A3(nt, n, eu(n), o)));
                }
                var a = e.a, i = A2(di, a, t);
                if (1 === i.$) {
                    r = u;
                    continue n;
                }
                return A2(Ge, function() {
                    return A3(Qc, n, u, A2(gi, a, t));
                }, Wc(i.a));
            }
            return Ze(t);
        }
    }), _c = F4(function(n, r, t, e) {
        return A2(Ge, function(n) {
            return Ze(A2(Hc, n, t));
        }, A3(Qc, n, r, e.gR));
    }), Zc = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(mt, e.a, t);
    }), Kc = F2(function(n, r) {
        return A3(Je, Zc(n), w, r);
    }), Xc = F4(function(n, r, t, e) {
        var u = e.b;
        return a(r, e.a) ? ht(A2(eu, n, u(t))) : kt;
    }), Jc = F3(function(n, r, t) {
        return A2(Ge, function() {
            return Ze(t);
        }, tu(A2(Kc, A3(Xc, n, r.a, r.b), t.hC)));
    }), Yc = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return Ec({
                iI: t.iI,
                ei: t.ei,
                cN: A2(et, n, t.cN),
                l5: t.l5,
                aP: t.aP,
                dF: t.dF,
                h1: t.h1,
                sr: t.sr
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), Gc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), nf = F2(function(n, r) {
        return A2(Gc, r.a, A2(Pi, r.b, n));
    });
    qn.Http = Vn(Rc, _c, Jc, Yc, nf);
    var rf, tf, ef, uf, of, af, cf, ff, sf, lf, df = Hn("Http"), mf = (Hn("Http"), function(n) {
        return function(n) {
            return df(Ec({
                iI: !1,
                ei: n.ei,
                cN: n.cN,
                l5: n.l5,
                aP: n.aP,
                dF: n.dF,
                h1: n.h1,
                sr: n.sr
            }));
        }({
            ei: ki,
            cN: n.cN,
            l5: w,
            aP: "GET",
            dF: kt,
            h1: kt,
            sr: n.sr
        });
    }), bf = "https://nomalab.prismic.io/api/v2", pf = d({
        f_: "",
        oV: kt,
        b7: kt
    }, (rf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mf({
        cN: A2(xc, rf, zc),
        sr: bf
    }))), vf = xa({
        bN: "Can downlaod",
        bT: "Autoriser \xe0 t\xe9l\xe9charger"
    }), $f = ti(function(n) {
        return p(n, {
            mo: "checkbox-canDownload",
            m7: vf
        });
    }), wf = xa({
        bN: "Can upload",
        bT: "Autoriser \xe0 uploader"
    }), gf = ti(function(n) {
        return p(n, {
            mo: "checkbox-canUpload",
            m7: wf
        });
    }), hf = xa({
        bN: "Email",
        bT: "Email"
    }), kf = xa({
        bN: "Invited user\u2019s email",
        bT: "Email de l\u2019utilisateur invit\xe9"
    }), Cf = za(function(n) {
        return p(n, {
            m7: hf,
            gw: kf
        });
    }), Tf = xa({
        bN: "Expiration date",
        bT: "Date d\u2019Expiration"
    }), Pf = za(function(n) {
        return p(n, {
            m7: Tf
        });
    }), Sf = xa({
        bN: "Message",
        bT: "Message"
    }), Af = za(function(n) {
        return p(n, {
            m7: Sf,
            gw: Sf
        });
    }), yf = {
        jz: $f,
        jA: gf,
        kU: !1,
        la: Cf,
        lo: kt,
        lt: Pf,
        l_: kt,
        nP: Af
    }, Nf = {
        $: 0
    }, Lf = {
        oD: !1,
        oF: !1,
        P: Nf,
        r7: Nf,
        sh: Nf
    }, jf = {
        l_: {
            $: 0
        },
        fB: "",
        gk: !1
    }, Ff = {
        d2: Lf,
        iZ: 0,
        cJ: jf,
        e2: Sc,
        mo: "",
        fD: yf,
        nn: !0,
        no: !0,
        P: Sc,
        rV: Su
    }, Mf = {
        aL: 0
    }, If = F2(function(n, r) {
        return A3(Cu, n, 0, r);
    }), Df = function(n) {
        return A3(xt, If, Tc, n);
    }, Bf = {
        i6: w,
        d7: w,
        oE: Df(w),
        sE: w
    }, xf = F8(function(n, r, t, e, u, o, a, i) {
        return {
            eT: t,
            lV: i,
            fg: n,
            j: r,
            fh: a,
            mk: e,
            n$: u,
            qg: o
        };
    }), qf = M, Vf = function(n) {
        return qf(n);
    }, Of = F2(function(n, r) {
        return se(r) % se(n);
    }), zf = F2(function(n, r) {
        var t = 24 * qf(3600 * r.fg), e = qf(60 * r.fg * 10), u = 0 > n % t ? t + n : n % t, o = u % e, a = qf(.066666 * r.fg), i = se(u / e), c = s(o, a) > 0 ? u + 9 * a * i + a * se((o - a) / e) : u + 9 * a * i;
        return k([
            se(se(se(c / r.j) / 60) / 60),
            A2(Of, 60, se(c / r.j) / 60),
            A2(Of, 60, c / r.j),
            c % r.j
        ]);
    }), Ef = F3(function(n, r, t) {
        for(;;){
            var e = A2(pe, Yt, n), u = e.a, o = e.b;
            if (0 > s(le(u), Yt)) return A2(ge, !0, {
                t: r,
                n: t,
                s: u
            });
            n = o, r = A2(mt, ae(u), r), t += 1;
        }
    }), Hf = 4294967295 >>> 32 - ee, Rf = u, Wf = F3(function(n, r, t) {
        for(;;){
            var e = A2(Rf, Hf & r >>> n, t);
            if (e.$) return A2(Rf, Hf & r, e.a);
            n -= ee, t = e.a;
        }
    }), Uf = F2(function(n, r) {
        var t = r.a, e = r.b, u = r.c, o = r.d;
        return 0 > n || s(n, t) > -1 ? kt : s(n, function(n) {
            return n >>> 5 << 5;
        }(t)) > -1 ? ht(A2(Rf, Hf & n, o)) : ht(A3(Wf, e, n, u));
    }), Qf = function(n) {
        if (n.eT) {
            var r = A2(zf, n.lV, n), t = F2(function(n, r) {
                var t;
                return A2(Uf, n, (t = r).b ? A3(Ef, t, w, 0) : ue);
            });
            return p(n, {
                fh: A2(ju, 0, A2(t, 3, r)),
                mk: A2(ju, 0, A2(t, 0, r)),
                n$: A2(ju, 0, A2(t, 1, r)),
                qg: A2(ju, 0, A2(t, 2, r))
            });
        }
        var e = se(n.lV / (3600 * n.j)), u = e > 23 ? d(e % 24, n.lV - 82800 * n.j) : d(e, n.lV), o = u.b;
        return p(n, {
            fh: o % (3600 * n.j) % (60 * n.j) % n.j,
            mk: u.a,
            n$: se(o % (3600 * n.j) / (60 * n.j)),
            qg: se(o % (3600 * n.j) % (60 * n.j) / n.j)
        });
    }, _f = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return kt;
        var r = +n;
        return r == r ? ht(r) : kt;
    }, Zf = F2(function(n, r) {
        var t = _f(r);
        return t.$ ? n : t.a;
    }), Kf = F2(function(n, r) {
        var t = He(r);
        return t.$ ? n : t.a;
    }), Xf = F2(function(n, r) {
        var t = 11 === xe(n) ? A3(qe, 9, 11, n) : "00";
        return p(r, {
            fh: r.fh + A2(Kf, 0, t),
            mk: r.mk + A2(Zf, 0, A3(qe, 0, 2, n)),
            n$: r.n$ + A2(Zf, 0, A3(qe, 3, 5, n)),
            qg: r.qg + A2(Zf, 0, A3(qe, 6, 8, n))
        });
    }), Jf = F2(function(n, r) {
        return Qf(function(n) {
            var r = n.eT ? function(n) {
                var r = n.qg, t = n.n$, e = 60 * n.j, u = n.mk, o = 60 * u + t, a = 3600 * n.j, i = n.fh, c = qf(.066666 * n.fg), f = a * u + e * t + n.j * r + i - c * (o - se(o / 10));
                return qf(f);
            }(n) : function(n) {
                return qf(3600 * n.j * n.mk + 60 * n.j * n.n$ + n.j * n.qg + n.fh);
            }(n);
            return p(n, {
                lV: r
            });
        }(A2(Xf, n, r)));
    }), Yf = F3(function(n, r, t) {
        return A2(Jf, "00:00:00:00", A8(xf, A2(Zf, 29.97, n), Vf(A2(Zf, 29.97, n)), t, 0, 0, 0, r, 0));
    }), Gf = A3(Yf, "25", 0, !1), ns = {
        ix: !1,
        i$: !1,
        eo: w,
        kp: 0,
        kr: Gf,
        lW: 25,
        mN: !1,
        mP: !1,
        mT: !1,
        gx: 1,
        q5: "00:00:00:00",
        rp: ht("")
    }, rs = {
        $: 0
    }, ts = xa({
        bN: "Choose a delivery channel",
        bT: "Choisissez une chaine de livraison"
    }), es = xa({
        bN: "Request reason",
        bT: "Donnez le motif du refus"
    }), us = {
        nG: za(function(n) {
            return p(n, {
                gw: ts
            });
        }),
        nH: za(function(n) {
            return p(n, {
                gw: es
            });
        }),
        nI: rs,
        gk: !1
    }, os = {
        $: 0
    }, as = {
        $: 0
    }, is = xa({
        bN: "Add timecode",
        bT: "Ajouter le timecode"
    }), cs = xa({
        bN: "Comment",
        bT: "Commenter"
    }), fs = {
        jN: w,
        e_: !0,
        m7: "",
        gk: !1,
        gw: "",
        sw: kt
    }, ss = xa({
        bN: "Job's type choice",
        bT: "Choix type de Job"
    }), ls = xa({
        bN: "Ads",
        bT: "Publicit\xe9s"
    }), ds = xa({
        bN: "End credits",
        bT: "G\xe9n\xe9rique de fin"
    }), ms = xa({
        bN: "Introduction",
        bT: "Introduction"
    }), bs = xa({
        bN: "Textless elements",
        bT: "Fonds neutres"
    }), ps = xa({
        bN: "Opening credits",
        bT: "G\xe9n\xe9rique de d\xe9but"
    }), vs = xa({
        bN: "Program",
        bT: "Programme"
    }), $s = xa({
        bN: "Clip",
        bT: "Extrait"
    }), ws = k([
        d("openingCredits", ps),
        d("endingCredits", ds),
        d("introduction", ms),
        d("program", vs),
        d("trailer", $s),
        d("advertising", ls),
        d("neutralBases", bs)
    ]), gs = xa({
        bN: "Segment choice",
        bT: "Choix Segments"
    }), hs = function(n) {
        switch(n){
            case 0:
                return "Spotcheck";
            case 1:
                return "QC";
            case 2:
                return "DownloadAsIs";
            case 3:
                return "SimpleTranscode";
            default:
                return "PADTranscode";
        }
    }, ks = k([
        d(hs(1), hs(1)),
        d(hs(0), hs(0))
    ]), Cs = {
        ir: !1,
        is: !1,
        iQ: {
            cU: 3,
            sy: as
        },
        d1: Su,
        j0: !1,
        j1: os,
        kf: os,
        kt: kt,
        k4: Su,
        k6: Su,
        k7: Su,
        lo: kt,
        l3: !1,
        mZ: p(fs, {
            jN: ks,
            gw: ss
        }),
        nP: za(function(n) {
            return p(n, {
                gw: cs
            });
        }),
        qi: kt,
        qj: p(fs, {
            jN: ws,
            gw: gs
        }),
        qH: !1,
        q3: os,
        q4: os,
        q5: "00:00:00:00",
        rC: 0,
        hY: ti(function(n) {
            return p(n, {
                mo: "commentTitmecode",
                m7: is
            });
        })
    }, Ts = {
        e_: !0,
        lo: kt,
        pw: w,
        p0: kt,
        qp: kt,
        sB: Su
    }, Ps = {
        kq: kt
    }, Ss = {
        $: 0
    }, As = Ss, ys = {
        $: 0
    }, Ns = {
        $: 0
    }, Ls = xa({
        bN: "title",
        bT: "titre"
    }), js = {
        lp: Su,
        oE: Tc,
        pn: Su,
        pG: Su,
        hH: Su
    }, Fs = xa({
        bN: "Can download (extra costs apply)",
        bT: "Autoriser le t\xe9l\xe9chargement (soumis \xe0 facturation)"
    }), Ms = ti(function(n) {
        return p(n, {
            mo: "checkbox-canDownload",
            m7: Fs
        });
    }), Is = xa({
        bN: "Can Upload",
        bT: "Autoriser \xe0 l'upload"
    }), Ds = ti(function(n) {
        return p(n, {
            mo: "checkbox-canUpload",
            m7: Is
        });
    }), Bs = xa({
        bN: "Email",
        bT: "Email"
    }), xs = xa({
        bN: "Invited user\u2019s email",
        bT: "Email de l\u2019utilisateur invit\xe9"
    }), qs = za(function(n) {
        return p(n, {
            m7: Bs,
            gw: xs
        });
    }), Vs = xa({
        bN: "Expiration date",
        bT: "Date d\u2019Expiration"
    }), Os = za(function(n) {
        return p(n, {
            m7: Vs
        });
    }), zs = xa({
        bN: "Message",
        bT: "Message"
    }), Es = za(function(n) {
        return p(n, {
            m7: zs,
            gw: zs
        });
    }), Hs = {
        jz: Ms,
        jA: Ds,
        kU: !1,
        la: qs,
        lo: kt,
        lt: Os,
        nP: Es
    }, Rs = {
        $: 0
    }, Ws = xa({
        bN: "audio mapping",
        bT: "mapping audio"
    }), Us = xa({
        bN: "channel",
        bT: "chaine"
    }), Qs = xa({
        bN: "URL (s3:// ftp:// sftp:// https://)",
        bT: "URL (s3:// ftp:// sftp:// https://)"
    }), _s = xa({
        bN: "file\u2019s type",
        bT: "type de fichier"
    }), Zs = {
        lo: kt,
        mB: za(function(n) {
            return p(n, {
                m7: Qs,
                gw: Qs
            });
        }),
        qo: za(function(n) {
            return p(n, {
                m7: "",
                gw: _s,
                sw: "Material"
            });
        })
    }, Ks = xa({
        bN: "host",
        bT: "host"
    }), Xs = xa({
        bN: "password",
        bT: "mot de passe"
    }), Js = xa({
        bN: "path",
        bT: "path"
    }), Ys = xa({
        bN: "port (default 21)",
        bT: "port (default 21)"
    }), Gs = xa({
        bN: "user",
        bT: "utilisateur"
    }), nl = xa({
        bN: "file\u2019s type",
        bT: "type de fichier"
    }), rl = {
        lo: kt,
        mv: za(function(n) {
            return p(n, {
                m7: Ks,
                gw: Ks
            });
        }),
        mw: za(function(n) {
            return p(n, {
                m7: Xs,
                gw: Xs
            });
        }),
        mx: za(function(n) {
            return p(n, {
                m7: Js,
                gw: Js
            });
        }),
        my: za(function(n) {
            return p(n, {
                m7: Ys,
                gw: Ys
            });
        }),
        mC: za(function(n) {
            return p(n, {
                m7: Gs,
                gw: Gs
            });
        }),
        qo: za(function(n) {
            return p(n, {
                m7: "",
                gw: nl,
                sw: "Material"
            });
        })
    }, tl = xa({
        bN: "S3 file\u2019s bucket",
        bT: "bucket du fichier S3"
    }), el = xa({
        bN: "S3 file\u2019s key",
        bT: "cl\xe9 du fichier S3"
    }), ul = xa({
        bN: "file\u2019s type",
        bT: "type de fichier"
    }), ol = {
        mz: za(function(n) {
            return p(n, {
                m7: tl,
                gw: tl
            });
        }),
        mA: za(function(n) {
            return p(n, {
                m7: el,
                gw: el
            });
        }),
        qo: za(function(n) {
            return p(n, {
                m7: "",
                gw: ul,
                sw: "Material"
            });
        })
    }, al = xa({
        bN: "Request reason",
        bT: "Raison de la demande"
    }), il = xa({
        bN: "Segmentation rules",
        bT: "R\xe8gles de segmentation"
    }), cl = {
        iA: Zs,
        iN: Rs,
        d2: Rs,
        i5: za(function(n) {
            return p(n, {
                gw: Ws
            });
        }),
        bE: za(function(n) {
            return p(n, {
                gw: Us
            });
        }),
        kg: Rs,
        kh: za(function(n) {
            return p(n, {
                gw: al
            });
        }),
        kq: kt,
        kD: za(function(n) {
            return p(n, {
                gw: "Choose Deep Probe Template"
            });
        }),
        kG: Rs,
        kH: Rs,
        l$: rl,
        l9: !0,
        ma: !0,
        mb: !0,
        pg: Rs,
        ph: w,
        dh: w,
        pp: kt,
        pJ: Rs,
        pK: Rs,
        pL: Rs,
        pY: ol,
        $7: w,
        qk: za(function(n) {
            return p(n, {
                gw: il
            });
        }),
        g9: kt,
        qG: za(function(n) {
            return p(n, {
                gw: "Choose File"
            });
        }),
        si: Rs
    }, fl = {
        e_: !0,
        pw: kt,
        sB: Su
    }, sl = function(n) {
        return {
            ij: us,
            iq: Cs,
            d2: Lf,
            iZ: 0,
            i_: !1,
            i7: Ts,
            ja: Ps,
            jr: !1,
            ka: Bf,
            kJ: As,
            cJ: jf,
            k3: {
                jJ: Su,
                mD: Su,
                c2: w,
                p5: kt,
                P: Ns,
                rc: ys,
                rd: ys,
                rX: za(function(n) {
                    return p(n, {
                        m7: Ls,
                        gw: ""
                    });
                })
            },
            e2: Sc,
            bQ: js,
            mo: "",
            fD: Hs,
            nk: !1,
            np: !0,
            oJ: cl,
            oM: n.st.oM,
            oX: {
                bD: kt,
                cf: kt
            },
            o3: kt,
            o5: !0,
            o6: ns,
            po: kt,
            pw: kt,
            qD: !1,
            qE: !1,
            qF: !1,
            P: Sc,
            rq: fl,
            ru: Su,
            r5: !0
        };
    }, ll = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dl = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ml = dl({
        $: 20
    }), bl = function(n) {
        return {
            $: 14,
            a: n
        };
    }, pl = function(n) {
        return {
            $: 8,
            a: n
        };
    }, vl = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $l = function(n) {
        return {
            $: 12,
            a: n
        };
    }, wl = function(n) {
        return {
            $: 7,
            a: n
        };
    }, gl = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hl = function(n) {
        return {
            $: 13,
            a: n
        };
    }, kl = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Cl = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Tl = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Pl = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Sl = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Al = function(n) {
        return {
            $: 9,
            a: n
        };
    }, yl = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Nl = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Ll = function(n) {
        return {
            $: 5,
            a: n
        };
    }, jl = function(n) {
        switch(n){
            case "segmentation":
                return At(0);
            case "deep_probe":
                return At(1);
            default:
                return Ct("can't handle this analyze job kind");
        }
    }, Fl = function(n) {
        return n ? "deep_probe" : "segmentation";
    }, Ml = F2(function(n, r) {
        return {
            e: A2(Te, function(n) {
                var t = r(n);
                return t.$ ? qc("unknown enum: " + n) : je(t.a);
            }, Da),
            g: A2(bu, ga, n)
        };
    }), Il = A2(Ml, Fl, jl), Dl = F2(function(n) {
        return n;
    }), Bl = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), xl = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ql = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Bl, e.a, e.b);
            var u = e.a, o = e.c, a = n(e.b)(o);
            if (1 === a.$) {
                var i = a.a;
                return A2(Bl, u || i, a.b);
            }
            return i = a.a, A3(xl, u || i, a.b, a.c);
        };
    }), Vl = ql, Ol = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), zl = F4(function(n, r, t, e) {
        return {
            ev: r,
            j8: e,
            gA: t,
            pR: n
        };
    }), El = {
        $: 0
    }, Hl = F2(function(n, r) {
        return A2(Ol, El, A4(zl, n.pR, n.ev, r, n.ak));
    }), Rl = (tf = {
        $: 10
    }, function(n) {
        return a(xe(n.a), n.b2) ? A3(xl, !1, 0, n) : A2(Bl, !1, A2(Hl, n, tf));
    }), Wl = at, Ul = F5(function(n, r, t, e, u) {
        for(;;){
            var o = A3(Wl, n, r, u.a);
            if (a(o, -1)) return A3(xl, 0 > s(u.b2, r), 0, {
                ev: e,
                ak: u.ak,
                f: u.f,
                b2: r,
                pR: t,
                a: u.a
            });
            a(o, -2) ? (r += 1, t += 1, e = 1) : (r = o, e += 1);
        }
    }), Ql = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Bl, e.a, e.b);
            var u = e.b, o = e.c;
            return A3(xl, e.a, A2(n, A3(qe, r.b2, o.b2, r.a), u), o);
        };
    }), _l = function(n) {
        return A2(Ql, Dl, n);
    }, Zl = function(n) {
        return function(n) {
            return function(r) {
                return A2(Bl, !1, A2(Hl, r, n));
            };
        }({
            $: 12,
            a: n
        });
    }, Kl = function(n) {
        return function(r) {
            return A3(xl, !1, n, r);
        };
    }, Xl = A2(Vl, function(n) {
        if (xe(n) > 9) return Zl("Expected at most 9 digits, but got " + Mt(xe(n)));
        var r = _f("0." + n);
        return r.$ ? Zl('Invalid float: "' + n + '"') : Kl(qf(1e3 * r.a));
    }, _l((lf = Qt, function(n) {
        return A5(Ul, lf, n.b2, n.pR, n.ev, n);
    }))), Jl = Me, Yl = F6(function(n, r, t, e, u, o) {
        return Jl(n + 60 * r * 60000 + 60 * (t - o) * 1e3 + 1e3 * e + u);
    }), Gl = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(Bl, t.a, t.b);
            var o = t.a, a = t.b, i = u(t.c);
            if (1 === i.$) {
                var c = i.a;
                return A2(Bl, o || c, i.b);
            }
            c = i.a;
            var f = i.c;
            return A3(xl, o || c, A2(n, a, i.b), f);
        };
    }), nd = F2(function(n, r) {
        return A3(Gl, Dl, n, r);
    }), rd = nd, td = F2(function(n, r) {
        return A3(Gl, ie, n, r);
    }), ed = td, ud = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), od = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, u = (0, t.a)(n);
                if (u.$) {
                    var o;
                    if ((o = u).a) return o;
                    r = A2(ud, r, o.b), t = e;
                    continue n;
                }
                return u;
            }
            return A2(Bl, !1, r);
        }
    }), ad = function(n) {
        return function(r) {
            return A3(od, r, El, n);
        };
    }, id = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cd = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fd = {
        $: 11
    }, sd = F2(function(n, r) {
        return function(t) {
            var e = A3(Wl, n, t.b2, t.a);
            return a(e, -1) ? A2(Bl, !1, A2(Hl, t, r)) : a(e, -2) ? A3(xl, !0, 0, {
                ev: 1,
                ak: t.ak,
                f: t.f,
                b2: t.b2 + 1,
                pR: t.pR + 1,
                a: t.a
            }) : A3(xl, !0, 0, {
                ev: t.ev + 1,
                ak: t.ak,
                f: t.f,
                b2: e,
                pR: t.pR,
                a: t.a
            });
        };
    }), ld = function(n) {
        return A2(sd, n, fd);
    }, dd = F4(function(n, r, t, e) {
        for(;;){
            var u = t(r)(e);
            if (u.$) return o = u.a, A2(Bl, n || o, u.b);
            var o = u.a, a = u.b, i = u.c;
            if (a.$) return A3(xl, n || o, a.a, i);
            n = n || o, r = a.a, e = i;
        }
    }), md = F2(function(n, r) {
        return function(t) {
            return A4(dd, !1, n, r, t);
        };
    }), bd = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2(Bl, e.a, e.b);
            var u = e.c;
            return A3(xl, e.a, n(e.b), u);
        };
    }), pd = bd, vd = function(n) {
        return n.$ ? function(n) {
            return {
                $: 1,
                a: n
            };
        }(n.a) : function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a);
    }, $d = F2(function(n, r) {
        return A2(md, n, function(n) {
            return A2(pd, vd, r(n));
        });
    }), wd = function(n) {
        return A2($d, "", function(r) {
            if (a(xe(r), n)) {
                var t = He(r);
                return t.$ ? Zl('Invalid integer: "' + r + '"') : A2(pd, id, Kl(t.a));
            }
            return A2(pd, function(n) {
                return cd(A2(Hu, r, n));
            }, _l(ld(Qt)));
        });
    }, gd = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), hd = ot, kd = function(n) {
        return function(n) {
            var r = n.a, t = n.b, e = !ze(r);
            return function(n) {
                var u = A5(hd, r, n.b2, n.pR, n.ev, n.a), o = u.a, i = u.b, c = u.c;
                return a(o, -1) ? A2(Bl, !1, A2(Hl, n, t)) : A3(xl, e, 0, {
                    ev: c,
                    ak: n.ak,
                    f: n.f,
                    b2: o,
                    pR: i,
                    a: n.a
                });
            };
        }(A2(gd, n, {
            $: 8,
            a: n
        }));
    }, Cd = function(n) {
        return Zl("Invalid day: " + Mt(n));
    }, Td = function(n) {
        return !(A2(qo, 4, n) || !A2(qo, 100, n) && A2(qo, 400, n));
    }, Pd = function(n) {
        var r = n - 1;
        return (r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0);
    }, Sd = function(n) {
        var r = n.a, t = n.b, e = n.c;
        if (0 > e) return Cd(e);
        var u = function(n) {
            var u = 31536e6 * (r - 1970), o = 864e5 * ((3 > t || !Td(r) ? e - 1 : e) + (Pd(r) - Pd(1970)));
            return Kl(n + u + o);
        };
        switch(t){
            case 1:
                return e > 31 ? Cd(e) : u(0);
            case 2:
                return e > 29 || 29 === e && !Td(r) ? Cd(e) : u(26784e5);
            case 3:
                return e > 31 ? Cd(e) : u(50976e5);
            case 4:
                return e > 30 ? Cd(e) : u(7776e6);
            case 5:
                return e > 31 ? Cd(e) : u(10368e6);
            case 6:
                return e > 30 ? Cd(e) : u(130464e5);
            case 7:
                return e > 31 ? Cd(e) : u(156384e5);
            case 8:
                return e > 31 ? Cd(e) : u(183168e5);
            case 9:
                return e > 30 ? Cd(e) : u(209952e5);
            case 10:
                return e > 31 ? Cd(e) : u(235872e5);
            case 11:
                return e > 30 ? Cd(e) : u(262656e5);
            case 12:
                return e > 31 ? Cd(e) : u(288576e5);
            default:
                return Zl('Invalid month: "' + Mt(t) + '"');
        }
    }, Ad = A2(Vl, Sd, A2(ed, A2(ed, A2(ed, Kl(F3(function(n, r, t) {
        return m(n, r, t);
    })), wd(4)), ad(k([
        A2(ed, A2(rd, Kl(Me), kd("-")), wd(2)),
        wd(2)
    ]))), ad(k([
        A2(ed, A2(rd, Kl(Me), kd("-")), wd(2)),
        wd(2)
    ])))), yd = (ef = F3(function(n, r, t) {
        return n * (60 * r) + t;
    }), A2(ed, Kl(Me), ad(k([
        A2(pd, function() {
            return 0;
        }, kd("Z")),
        A2(ed, A2(ed, A2(ed, Kl(ef), ad(k([
            A2(pd, function() {
                return 1;
            }, kd("+")),
            A2(pd, function() {
                return -1;
            }, kd("-"))
        ]))), wd(2)), ad(k([
            A2(ed, A2(rd, Kl(Me), kd(":")), wd(2)),
            wd(2),
            Kl(0)
        ]))),
        A2(rd, Kl(0), Rl)
    ])))), Nd = A2(Vl, function(n) {
        return ad(k([
            A2(ed, A2(ed, A2(ed, A2(ed, A2(ed, A2(rd, Kl(Yl(n)), kd("T")), wd(2)), ad(k([
                A2(ed, A2(rd, Kl(Me), kd(":")), wd(2)),
                wd(2)
            ]))), ad(k([
                A2(ed, A2(rd, Kl(Me), kd(":")), wd(2)),
                wd(2)
            ]))), ad(k([
                A2(ed, A2(rd, Kl(Me), kd(".")), Xl),
                Kl(0)
            ]))), A2(rd, yd, Rl)),
            A2(rd, Kl(A6(Yl, n, 0, 0, 0, 0, 0)), Rl)
        ]));
    }, Ad), Ld = F3(function(n, r, t) {
        return {
            ev: r,
            gA: t,
            pR: n
        };
    }), jd = function(n) {
        return A3(Ld, n.pR, n.ev, n.gA);
    }, Fd = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(mt, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(Fd, e, r);
                continue n;
        }
    }), Md = F2(function(n, r) {
        var t = n({
            ev: 1,
            ak: w,
            f: 1,
            b2: 0,
            pR: 1,
            a: r
        });
        return t.$ ? Ct(A2(Fd, t.b, w)) : At(t.b);
    }), Id = F2(function(n, r) {
        var t = A2(Md, n, r);
        return t.$ ? Ct(A2(Ye, jd, t.a)) : At(t.a);
    }), Dd = function(n) {
        return A2(Id, Nd, n);
    }, Bd = A2(Pi, Dd, ha(Dl("Can't parse date"))), xd = A2(Te, function(n) {
        var r = Bd(n);
        return r.$ ? qc(r.a) : je(r.a);
    }, Da), qd = F2(function(n, r) {
        return se(n / r);
    }), Vd = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r + n;
            var e = t.a, u = t.b;
            if (0 > s(e.hs, r)) return r + e.b2;
            t = u;
        }
    }), Od = F2(function(n, r) {
        var t = n.b;
        return A3(Vd, n.a, A2(qd, r, 6e4), t);
    }), zd = function(n) {
        var r = A2(qd, n, 1440) + 719468, t = (0 > r ? r - 146096 : r) / 146097 | 0, e = r - 146097 * t, u = (e - (e / 1460 | 0) + (e / 36524 | 0) - (e / 146096 | 0)) / 365 | 0, o = e - (365 * u + (u / 4 | 0) - (u / 100 | 0)), a = (5 * o + 2) / 153 | 0, i = a + (10 > a ? 3 : -9);
        return {
            eL: o - ((153 * a + 2) / 5 | 0) + 1,
            f7: i,
            ih: u + 400 * t + (i > 2 ? 0 : 1)
        };
    }, Ed = F2(function(n, r) {
        return zd(A2(Od, n, r)).eL;
    }), Hd = F2(function(n, r) {
        return A2(qo, 24, A2(qd, A2(Od, n, r), 60));
    }), Rd = F2(function(n, r) {
        return A2(qo, 1e3, r);
    }), Wd = F2(function(n, r) {
        return A2(qo, 60, A2(Od, n, r));
    }), Ud = F2(function(n, r) {
        switch(zd(A2(Od, n, r)).f7){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), Qd = function(n) {
        return A2(So, n, "");
    }, _d = F3(function(n, r, t) {
        return n > 0 ? A3(_d, n >> 1, $(r, r), 1 & n ? $(t, r) : t) : t;
    }), Zd = F2(function(n, r) {
        return A3(_d, n, r, "");
    }), Kd = F3(function(n, r, t) {
        return $(A2(Zd, n - xe(t), Qd(r)), t);
    }), Xd = F2(function(n, r) {
        return A3(Kd, n, "0", Mt(r));
    }), Jd = F2(function(n, r) {
        return A2(qo, 60, A2(qd, r, 1e3));
    }), Yd = F2(function(n, r) {
        return zd(A2(Od, n, r)).ih;
    }), Gd = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), nm = A2(Gd, 0, w), rm = function(n) {
        return A2(Xd, 4, A2(Yd, nm, n)) + "-" + A2(Xd, 2, function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                case 6:
                    return 7;
                case 7:
                    return 8;
                case 8:
                    return 9;
                case 9:
                    return 10;
                case 10:
                    return 11;
                default:
                    return 12;
            }
        }(A2(Ud, nm, n))) + "-" + A2(Xd, 2, A2(Ed, nm, n)) + "T" + A2(Xd, 2, A2(Hd, nm, n)) + ":" + A2(Xd, 2, A2(Wd, nm, n)) + ":" + A2(Xd, 2, A2(Jd, nm, n)) + "." + A2(Xd, 3, A2(Rd, nm, n)) + "Z";
    }, tm = {
        e: xd,
        g: function(n) {
            return ga(rm(n));
        }
    }, em = function(n) {
        switch(n){
            case "Request":
                return At(0);
            case "Finish":
                return At(1);
            default:
                return Ct("not a Analyze kind");
        }
    }, um = function(n) {
        return n ? "Finish" : "Request";
    }, om = A2(Ml, um, em), am = Fi(A4(qi, "ruleName", function(n) {
        return n.dm;
    }, Oa, A4(qi, "error", function(n) {
        return n.lo;
    }, Oa, A4(qi, "fileName", function(n) {
        return n.cS;
    }, Oa, A4(qi, "fileId", function(n) {
        return n.z;
    }, Oa, A4(rc, "sourceName", function(n) {
        return n.du;
    }, Oa, A4(rc, "sourceId", function(n) {
        return n.hg;
    }, Oa, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "analyzeKind", function(n) {
        return n.cp;
    }, Il, A4(rc, "kind", function(n) {
        return n.c$;
    }, om, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            cp: e,
                                                            lo: l,
                                                            z: f,
                                                            cS: s,
                                                            mo: n,
                                                            c$: t,
                                                            dm: d,
                                                            g9: r,
                                                            hg: i,
                                                            du: c,
                                                            hD: o,
                                                            h_: a,
                                                            rW: u
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), im = F6(function(n, r, t, e, u, o) {
        return {
            mo: n,
            g9: r,
            dt: u,
            hD: e,
            h_: o,
            rW: t
        };
    }), cm = F6(function(n, r, t, e, u, o) {
        return {
            bz: o,
            la: t,
            mo: n,
            n6: r,
            oM: e,
            gm: u
        };
    }), fm = Fi(A4(rc, "avatar", function(n) {
        return n.bz;
    }, Oa, A4(qi, "organizationName", function(n) {
        return n.gm;
    }, Oa, A4(qi, "organization", function(n) {
        return n.oM;
    }, Oa, A4(rc, "email", function(n) {
        return n.la;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(cm)))))))), sm = Fi(A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(rc, "source", function(n) {
        return n.dt;
    }, fm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(im)))))))), lm = function(n) {
        var r = n;
        return {
            e: A2(Te, function(n) {
                return A2(r.e, n, qc(n + "did not match"));
            }, A2(Vc, 0, Da)),
            g: function(n) {
                return r.b_(n);
            }
        };
    }, dm = F8(function(n, r, t, e, u, o, a, i) {
        return {
            mo: n,
            nP: a,
            g9: r,
            dt: o,
            hD: e,
            hY: i,
            h_: u,
            rW: t
        };
    }), mm = Fi(A4(qi, "timecode", function(n) {
        return n.hY;
    }, Oa, A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, A4(rc, "source", function(n) {
        return n.dt;
    }, fm, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(dm)))))))))), bm = function(n) {
        return {
            e: function() {
                return Me;
            },
            b_: n
        };
    }, pm = F7(function(n, r, t, e, u, o, a) {
        return {
            cT: a,
            mo: n,
            g9: r,
            dt: o,
            hD: e,
            h_: u,
            rW: t
        };
    }), vm = Fi(A4(rc, "fileName", function(n) {
        return n.cT;
    }, Oa, A4(rc, "source", function(n) {
        return n.dt;
    }, fm, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(pm))))))))), $m = F8(function(n, r, t, e, u, o, a, i) {
        return {
            lD: a,
            cS: i,
            mo: n,
            g9: r,
            dt: u,
            hD: e,
            h_: o,
            rW: t
        };
    }), wm = Fi(A4(rc, "fileName", function(n) {
        return n.cS;
    }, Oa, A4(rc, "file", function(n) {
        return n.lD;
    }, Oa, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(rc, "source", function(n) {
        return n.dt;
    }, fm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi($m)))))))))), gm = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            cQ: i,
            z: o,
            cR: c,
            cS: a,
            mo: n,
            g9: r,
            hD: e,
            h_: u,
            rW: t
        };
    }), hm = Fi(A4(rc, "fileKey", function(n) {
        return n.cR;
    }, Oa, A4(rc, "fileBucket", function(n) {
        return n.cQ;
    }, Oa, A4(rc, "fileName", function(n) {
        return n.cS;
    }, Oa, A4(rc, "fileId", function(n) {
        return n.z;
    }, Oa, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(gm))))))))))), km = function(n) {
        switch(n){
            case "Add":
                return At(0);
            case "Remove":
                return At(1);
            default:
                return At(2);
        }
    }, Cm = function(n) {
        switch(n){
            case 0:
                return "Add";
            case 1:
                return "Remove";
            default:
                return "NoChanges";
        }
    }, Tm = A2(Ml, Cm, km), Pm = function(n) {
        switch(n){
            case "Add":
                return At(0);
            case "Update":
                return At(1);
            case "Delete":
                return At(2);
            default:
                return Ct("not a kind of inviatation");
        }
    }, Sm = function(n) {
        switch(n){
            case 0:
                return "Add";
            case 1:
                return "Update";
            default:
                return "Delete";
        }
    }, Am = A2(Ml, Sm, Pm), ym = function(n) {
        switch(n){
            case "Delivery":
                return At(0);
            case "Master":
                return At(1);
            default:
                return Ct("not ShowKind");
        }
    }, Nm = function(n) {
        return n ? "Master" : "Delivery";
    }, Lm = A2(Ml, Nm, ym), jm = Fi(A4(qi, "expireAt", function(n) {
        return n.cO;
    }, tm, A4(rc, "upload", function(n) {
        return n.sk;
    }, Tm, A4(rc, "download", function(n) {
        return n.cJ;
    }, Tm, A4(rc, "target", function(n) {
        return n.rP;
    }, fm, A4(rc, "source", function(n) {
        return n.dt;
    }, fm, A4(rc, "kind", function(n) {
        return n.c$;
    }, Am, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "showKind", function(n) {
        return n.qK;
    }, Lm, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        cJ: f,
                                                        cO: l,
                                                        mo: n,
                                                        c$: a,
                                                        g9: r,
                                                        qK: t,
                                                        dt: i,
                                                        hD: u,
                                                        rP: c,
                                                        h_: o,
                                                        rW: e,
                                                        sk: s
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), Fm = F7(function(n, r, t, e, u, o, a) {
        return {
            mo: n,
            c$: o,
            g9: r,
            dt: a,
            hD: e,
            h_: u,
            rW: t
        };
    }), Mm = function(n) {
        switch(n){
            case "Create":
                return At(0);
            case "Accept":
                return At(1);
            case "NewVersion":
                return At(2);
            default:
                return Ct("Not an event kind");
        }
    }, Im = function(n) {
        switch(n){
            case 0:
                return "Create";
            case 1:
                return "Accept";
            default:
                return "NewVersion";
        }
    }, Dm = A2(Ml, Im, Mm), Bm = Fi(A4(rc, "source", function(n) {
        return n.dt;
    }, fm, A4(rc, "kind", function(n) {
        return n.c$;
    }, Dm, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(Fm))))))))), xm = F6(function(n, r, t, e, u, o) {
        return {
            mo: n,
            g9: r,
            dt: u,
            hD: e,
            h_: o,
            rW: t
        };
    }), qm = Fi(A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(qi, "source", function(n) {
        return n.dt;
    }, fm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(xm)))))))), Vm = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            ki: c,
            mo: n,
            fC: a,
            g7: i,
            g9: r,
            dt: u,
            hD: e,
            h_: o,
            rW: t
        };
    }), Om = Fi(A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "sftpUser", function(n) {
        return n.g7;
    }, Oa, A4(rc, "invitationId", function(n) {
        return n.fC;
    }, Oa, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(rc, "source", function(n) {
        return n.dt;
    }, fm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(Vm))))))))))), zm = function(n) {
        switch(n){
            case "Request":
                return At(0);
            case "Finish":
                return At(1);
            default:
                return Ct("not a Transcode kind");
        }
    }, Em = function(n) {
        return n ? "Finish" : "Request";
    }, Hm = A2(Ml, Em, zm), Rm = function(n) {
        switch(n){
            case "deliverable":
            case "deliverable_subtitle":
                return At(2);
            case "proxy_hi_res":
                return At(1);
            case "proxy_low_res":
            case "proxy_audio":
            case "proxy_subtitle":
                return At(0);
            case "copy":
                return At(3);
            case "audio_merge":
                return At(4);
            case "proxy_dcp":
                return At(5);
            case "proxy_imf":
                return At(6);
            default:
                return Ct("can't handle this transcode job kind");
        }
    }, Wm = function(n) {
        switch(n){
            case 0:
                return "proxy";
            case 1:
                return "proxy_hi_res";
            case 2:
                return "deliverable";
            case 3:
                return "copy";
            case 4:
                return "audio_merge";
            case 5:
                return "proxy_dcp";
            default:
                return "proxy_imf";
        }
    }, Um = A2(Ml, Wm, Rm), Qm = {
        $: 12
    }, _m = {
        $: 11
    }, Zm = {
        $: 0
    }, Km = {
        $: 7
    }, Xm = {
        $: 10
    }, Jm = {
        $: 9
    }, Ym = {
        $: 5
    }, Gm = {
        $: 8
    }, nb = {
        $: 2
    }, rb = {
        $: 3
    }, tb = {
        $: 4
    }, eb = {
        $: 1
    }, ub = {
        $: 6
    }, ob = function(n) {
        switch(n){
            case "VD":
                return At(Zm);
            case "VO":
                return At(eb);
            case "VI":
                return At(nb);
            case "VIVD":
                return At(rb);
            case "VIVO":
                return At(tb);
            case "VDVO":
                return At(Ym);
            case "VOAD":
                return At(ub);
            case "VDAD":
                return At(Km);
            case "VDVOAD":
                return At(Gm);
            case "VDVIVONLY":
                return At(Jm);
            case "VDVIMEVONLY":
                return At(Xm);
            case "NoSound":
                return At(_m);
            case "AsMaster":
                return At(Qm);
            default:
                return At({
                    $: 13,
                    a: n
                });
        }
    }, ab = function(n) {
        switch(n.$){
            case 1:
                return "VO";
            case 0:
                return "VD";
            case 2:
                return "VI";
            case 3:
                return "VIVD";
            case 4:
                return "VIVO";
            case 5:
                return "VDVO";
            case 6:
                return "VOAD";
            case 7:
                return "VDAD";
            case 8:
                return "VDVOAD";
            case 9:
                return "VDVIVONLY";
            case 10:
                return "VDVIMEVONLY";
            case 11:
                return "NoSound";
            case 12:
                return "AsMaster";
            default:
                return n.a;
        }
    }, ib = A2(Ml, ab, ob), cb = Fi(A4(rc, "transcodeKind", function(n) {
        return n.dJ;
    }, Um, A4(qi, "targetOrganization", function(n) {
        return n.dy;
    }, Oa, A4(qi, "subtitlesFileName", function(n) {
        return n.aX;
    }, Oa, A4(qi, "mxfVersion", function(n) {
        return n.c5;
    }, ib, A4(qi, "mxfOut", function(n) {
        return n.c4;
    }, Oa, A4(qi, "mxfIn", function(n) {
        return n.c3;
    }, Oa, A4(qi, "error", function(n) {
        return n.lo;
    }, Oa, A4(rc, "nbWarning", function(n) {
        return n.c7;
    }, uc, A4(rc, "formatName", function(n) {
        return n.cW;
    }, Oa, A4(rc, "fileName", function(n) {
        return n.cS;
    }, Oa, A4(rc, "fileId", function(n) {
        return n.z;
    }, Oa, A4(rc, "kind", function(n) {
        return n.c$;
    }, Hm, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return {
                                                                            lo: s,
                                                                            z: a,
                                                                            cS: i,
                                                                            cW: c,
                                                                            mo: n,
                                                                            c$: o,
                                                                            c3: l,
                                                                            c4: d,
                                                                            c5: m,
                                                                            c7: f,
                                                                            g9: r,
                                                                            hD: e,
                                                                            aX: b,
                                                                            dy: p,
                                                                            h_: u,
                                                                            rW: t,
                                                                            dJ: v
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), fb = F6(function(n, r, t, e, u, o) {
        return {
            mo: n,
            g9: r,
            dt: u,
            hD: e,
            h_: o,
            rW: t
        };
    }), sb = Fi(A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(rc, "source", function(n) {
        return n.dt;
    }, fm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(fb)))))))), lb = F6(function(n, r, t, e, u, o) {
        return {
            mo: n,
            g9: r,
            dt: u,
            hD: e,
            h_: o,
            rW: t
        };
    }), db = Fi(A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(rc, "source", function(n) {
        return n.dt;
    }, fm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(lb)))))))), mb = function(n) {
        switch(n){
            case "Start":
                return At(0);
            case "Finish":
                return At(1);
            default:
                return Ct("not an Upload kind");
        }
    }, bb = function(n) {
        return n ? "Finish" : "Start";
    }, pb = A2(Ml, bb, mb), vb = Fi(A4(qi, "nbFiles", function(n) {
        return n.c6;
    }, uc, A4(qi, "error", function(n) {
        return n.lo;
    }, Oa, A4(rc, "fileName", function(n) {
        return n.cS;
    }, Oa, A4(rc, "fileId", function(n) {
        return n.z;
    }, Oa, A4(rc, "kind", function(n) {
        return n.c$;
    }, pb, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return {
                                                lo: c,
                                                z: a,
                                                cS: i,
                                                mo: n,
                                                c$: o,
                                                c6: f,
                                                g9: r,
                                                hD: e,
                                                h_: u,
                                                rW: t
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), $b = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: F2(function(r, e) {
                return a(r, n) ? t : A2(u.e, r, e);
            }),
            b_: u.b_(r(function(r) {
                return A2(ac, Me, A2(mt, ga(n), r));
            }))
        };
    }), wb = F3(function(n, r, t) {
        return A3($b, n, F2(function(n, r) {
            return n(k([
                A2(Ii, t, r)
            ]));
        }), A2(Ne, r, A2(Vc, 1, pa(t))));
    }), gb = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            lo: c,
            z: o,
            cS: a,
            mo: n,
            bl: i,
            g9: r,
            hD: e,
            h_: u,
            rW: t
        };
    }), hb = F2(function(n, r) {
        return {
            n8: n,
            aq: r
        };
    }), kb = Fi(A4(rc, "nbWarnings", function(n) {
        return n.aq;
    }, uc, A4(rc, "nbErrors", function(n) {
        return n.n8;
    }, uc, Mi(hb)))), Cb = Fi(A4(qi, "error", function(n) {
        return n.lo;
    }, Oa, A4(qi, "result", function(n) {
        return n.bl;
    }, kb, A4(rc, "fileName", function(n) {
        return n.cS;
    }, Oa, A4(rc, "fileId", function(n) {
        return n.z;
    }, Oa, A4(rc, "timestamp", function(n) {
        return n.h_;
    }, tm, A4(qi, "subtitle", function(n) {
        return n.hD;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(gb))))))))))), Tb = lm(A4(wb, "Analyze", bl, am, A4(wb, "ProxyPlayed", Cl, qm, A4(wb, "Invitation", hl, jm, A4(wb, "Delete", $l, vm, A4(wb, "Untrash", Nl, sb, A4(wb, "Trash", Al, sb, A4(wb, "Unarchive", yl, db, A4(wb, "Archive", pl, sm, A4(wb, "Download", wl, wm, A4(wb, "SftpLogin", Pl, Om, A4(wb, "Upload", Ll, vb, A4(wb, "Transcode", Sl, cb, A4(wb, "QualityCheck", Tl, Cb, A4(wb, "Ingest", gl, hm, A4(wb, "Comment", vl, mm, A4(wb, "Lifecycle", kl, Bm, bm(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        switch(v.$){
                                                                            case 4:
                                                                                return n(v.a);
                                                                            case 3:
                                                                                return r(v.a);
                                                                            case 1:
                                                                                return t(v.a);
                                                                            case 0:
                                                                                return e(v.a);
                                                                            case 2:
                                                                                return u(v.a);
                                                                            case 5:
                                                                                return o(v.a);
                                                                            case 7:
                                                                                return i(v.a);
                                                                            case 6:
                                                                                return a(v.a);
                                                                            case 8:
                                                                                return c(v.a);
                                                                            case 11:
                                                                                return f(v.a);
                                                                            case 9:
                                                                                return s(v.a);
                                                                            case 10:
                                                                                return l(v.a);
                                                                            case 12:
                                                                                return d(v.a);
                                                                            case 13:
                                                                                return m(v.a);
                                                                            case 14:
                                                                                return p(v.a);
                                                                            default:
                                                                                return b(v.a);
                                                                        }
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))), Pb = ic(Tb), Sb = mc(A2(Wi, Pb, Ai(ml))), Ab = A2(pc, k([
        A2(Xa, ll, Sb)
    ]), {
        lo: kt,
        oV: 0,
        rV: Su
    }), yb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nb = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lb = dl(Nb({
        $: 0
    })), jb = F4(function(n, r, t, e) {
        return {
            bH: r,
            gm: e,
            gW: n,
            g2: t
        };
    }), Fb = F6(function(n, r, t, e, u, o) {
        return {
            ki: t,
            bK: r,
            mo: n,
            n6: u,
            oO: e,
            hv: o
        };
    }), Mb = function(n) {
        switch(n){
            case "active":
                return At(0);
            case "archived":
                return At(1);
            case "restoring":
                return At(2);
            default:
                return Ct("Unrecognized state: " + n);
        }
    }, Ib = function(n) {
        switch(n){
            case 0:
                return "active";
            case 1:
                return "archived";
            default:
                return "restoring";
        }
    }, Db = A2(Ml, Ib, Mb), Bb = Fi(A4(rc, "state", function(n) {
        return n.hv;
    }, Db, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "organizationId", function(n) {
        return n.oO;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "creator", function(n) {
        return n.bK;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(Fb)))))))), xb = function(n) {
        return At("Own" === n ? 0 : 1);
    }, qb = function(n) {
        return n ? "Invited" : "Own";
    }, Vb = A2(Ml, qb, xb), Ob = F2(function(n, r) {
        return {
            cM: r,
            dn: n
        };
    }), zb = F2(function(n, r) {
        return {
            cL: n,
            dr: r
        };
    }), Eb = F6(function(n, r, t, e, u, o) {
        return {
            ki: t,
            bK: r,
            mo: n,
            n6: u,
            bm: e,
            hv: o
        };
    }), Hb = Fi(A4(rc, "state", function(n) {
        return n.hv;
    }, Db, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "seasonId", function(n) {
        return n.bm;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "creator", function(n) {
        return n.bK;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(Eb)))))))), Rb = function(n) {
        return A4(rc, "updatedAt", function(n) {
            return n.cl;
        }, tm, A4(rc, "updater", function(n) {
            return n.cm;
        }, Oa, A4(rc, "createdAt", function(n) {
            return n.ki;
        }, tm, A4(rc, "creator", function(n) {
            return n.bK;
        }, Oa, A4(rc, "id", function(n) {
            return n.mo;
        }, Oa, Mi(n))))));
    }, Wb = A2(Va, Me, Ma), Ub = Fi(A4(rc, "trashed", function(n) {
        return n.h5;
    }, ri, A4(rc, "parent", function(n) {
        return n.gq;
    }, Oa, A4(rc, "state", function(n) {
        return n.hv;
    }, Db, A4(rc, "kind", function(n) {
        return n.c$;
    }, Lm, A4(qi, "commandInfoXML", function(n) {
        return n.ex;
    }, Wb, A4(rc, "accepted", function(n) {
        return n.ik;
    }, ri, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, A4(qi, "title2", function(n) {
        return n.rY;
    }, Oa, A4(rc, "title1", function(n) {
        return n.rX;
    }, Oa, Rb(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return {
                                                                ik: c,
                                                                ex: f,
                                                                ki: t,
                                                                bK: r,
                                                                mo: n,
                                                                c$: s,
                                                                oM: i,
                                                                gq: d,
                                                                hv: l,
                                                                rX: o,
                                                                rY: a,
                                                                h5: m,
                                                                cl: u,
                                                                cm: e
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))), Qb = Fi(A4(rc, "shows", function(n) {
        return n.dr;
    }, ic(Ub), A4(rc, "episode", function(n) {
        return n.cL;
    }, Hb, Mi(zb)))), _b = F6(function(n, r, t, e, u, o) {
        return {
            a5: e,
            ki: t,
            bK: r,
            mo: n,
            n6: u,
            hv: o
        };
    }), Zb = Fi(A4(rc, "state", function(n) {
        return n.hv;
    }, Db, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "collectionId", function(n) {
        return n.a5;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "creator", function(n) {
        return n.bK;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(_b)))))))), Kb = Fi(A4(rc, "episodes", function(n) {
        return n.cM;
    }, ic(Qb), A4(rc, "season", function(n) {
        return n.dn;
    }, Zb, Mi(Ob)))), Xb = Fi(A4(rc, "organizationName", function(n) {
        return n.gm;
    }, Oa, A4(rc, "seasons", function(n) {
        return n.g2;
    }, ic(Kb), A4(rc, "collection", function(n) {
        return n.bH;
    }, Bb, A4(rc, "role", function(n) {
        return n.gW;
    }, Vb, Mi(jb)))))), Jb = ic(Xb), Yb = nu, Gb = function(n) {
        var r = n.b;
        return A2(Ge, function(n) {
            return A2(nu, function(r) {
                return d(n, r);
            }, r);
        }, n.a);
    }, np = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rp = dl(np({
        $: 0
    })), tp = F4(function(n, r, t, e) {
        return {
            gm: e,
            gW: n,
            dr: t,
            sf: r
        };
    }), ep = F6(function(n, r, t, e, u, o) {
        return {
            ki: t,
            bK: r,
            mo: n,
            n6: u,
            oO: e,
            hv: o
        };
    }), up = Fi(A4(rc, "state", function(n) {
        return n.hv;
    }, Db, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "organizationId", function(n) {
        return n.oO;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "creator", function(n) {
        return n.bK;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(ep)))))))), op = Fi(A4(rc, "organizationName", function(n) {
        return n.gm;
    }, Oa, A4(rc, "shows", function(n) {
        return n.dr;
    }, ic(Ub), A4(rc, "unitary", function(n) {
        return n.sf;
    }, up, A4(rc, "role", function(n) {
        return n.gW;
    }, Vb, Mi(tp)))))), ap = ic(op), ip = (uf = F2(function(n, r) {
        return mc(A2(Wi, r, Ai(n)));
    }), of = A2(Yb, Ye(function(n) {
        return {
            $: 1,
            a: n
        };
    }), A2(uf, rp, ap)), af = function(n) {
        return $(n.a, n.b);
    }, cf = A2(Yb, Ye(function(n) {
        return {
            $: 0,
            a: n
        };
    }), A2(uf, Lb, Jb)), A2(Xa, yb, A2(Yb, af, Gb(d(cf, of))))), cp = Wn, fp = function(n) {
        return {
            $: 10,
            a: n
        };
    }, sp = F2(function(n, r) {
        return r.$ ? kt : n(r.a);
    }), lp = F5(function(n, r, t, e, u) {
        return {
            an: e,
            oX: t,
            ae: r,
            sw: u,
            ay: n
        };
    }), dp = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(mt, n.a, dp(n.b)) : w;
    }, mp = F2(function(n, r) {
        return ht(1 === r.$ ? k([
            n
        ]) : A2(mt, n, r.a));
    }), bp = function(n) {
        try {
            return ht(decodeURIComponent(n));
        } catch (n) {
            return kt;
        }
    }, pp = F2(function(n, r) {
        var t = A2(Dt, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = bp(t.a);
            if (1 === u.$) return r;
            var o = u.a, a = bp(e);
            return 1 === a.$ ? r : A3(hi, o, mp(a.a), r);
        }
        return r;
    }), vp = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.ae;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return ht(r.sw);
                    }
                    return ht(r.sw);
                }
                return kt;
            }
        }(n(A5(lp, w, function(n) {
            var r = A2(Dt, "/", n);
            return dp(r.b && "" === r.a ? r.b : r);
        }(r.gs), 1 === (t = r.px).$ ? Su : A3(Je, pp, Su, A2(Dt, "&", t.a)), r.fd, Me)));
    }), $p = F3(function(n, r, t) {
        var e;
        return A2(ju, t, A2(sp, vp(r), A2(_e, "http://", e = "http://domain.co" + n) ? A2(Qe, 0, A2(Ve, 7, e)) : A2(_e, "https://", e) ? A2(Qe, 1, A2(Ve, 8, e)) : kt));
    }), wp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, gp = function(n) {
        return {
            $: 4,
            a: n
        };
    }, hp = {
        $: 6
    }, kp = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Cp = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Tp = {
        $: 9
    }, Pp = {
        $: 8
    }, Sp = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), Ap = {
        $: 0
    }, yp = {
        $: 7
    }, Np = F2(function(n, r) {
        return A5(lp, r.ay, r.ae, r.oX, r.an, n(r.sw));
    }), Lp = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.ay, u = r.ae, o = r.oX, a = r.an;
            return A2(Ye, Np(r.sw), t(A5(lp, e, u, o, a, n)));
        };
    }), jp = function(n) {
        return function(r) {
            return A2(Yu, function(n) {
                return n(r);
            }, n);
        };
    }, Fp = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(Yu, e, t(n));
        };
    }), Mp = F2(function(n, r) {
        return A2(Fp, n, function(n) {
            var r = n;
            return function(n) {
                var t = n.oX;
                return k([
                    A5(lp, n.ay, n.ae, t, n.an, (0, n.sw)(r(t)))
                ]);
            };
        }(r));
    }), Ip = {
        $: 1
    }, Dp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Bp = function(n) {
        return {
            lZ: n
        };
    }, xp = function(n) {
        return function(r) {
            var t = r.ay, e = r.ae, u = r.oX, o = r.an, i = r.sw;
            if (e.b) {
                var c = e.a, f = e.b;
                return a(c, n) ? k([
                    A5(lp, A2(mt, c, t), f, u, o, i)
                ]) : w;
            }
            return w;
        };
    }, qp = F2(function(n, r) {
        return function(t) {
            return r(A2(ju, w, A2(di, n, t)));
        };
    }), Vp = function(n) {
        return A2(qp, n, function(n) {
            return n.b && !n.b.b ? ht(n.a) : kt;
        });
    }, Op = jp(k([
        A2(Lp, A2(bu, A2(bu, Dp, Bp), sp(bp)), A2(Mp, xp("login"), Vp("from"))),
        A2(Lp, Ip, xp("forgotPassword")),
        A2(Lp, F2(function(n, r) {
            return {
                $: 2,
                a: {
                    la: A2(ju, "", n),
                    r0: A2(ju, "", r)
                }
            };
        }), A2(Mp, A2(Mp, xp("resetPassword"), Vp("email")), Vp("token"))),
        A2(Lp, F3(function(n, r, t) {
            return {
                $: 3,
                a: {
                    la: A2(ju, "", r),
                    pB: A2(ju, "/", A2(sp, bp, n)),
                    r0: A2(ju, "", t)
                }
            };
        }), A2(Mp, A2(Mp, A2(Mp, xp("invitation"), Vp("redirect")), Vp("email")), Vp("token")))
    ])), zp = {
        $: 6
    }, Ep = {
        $: 7
    }, Hp = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Rp = {
        $: 16
    }, Wp = {
        $: 11
    }, Up = {
        $: 0
    }, Qp = function(n) {
        return {
            $: 14,
            a: n
        };
    }, _p = {
        $: 15
    }, Zp = {
        $: 2
    }, Kp = {
        $: 10
    }, Xp = {
        $: 1
    }, Jp = {
        $: 17
    }, Yp = {
        $: 8
    }, Gp = {
        $: 13
    }, nv = {
        $: 12
    }, rv = {
        $: 5
    }, tv = {
        $: 4
    }, ev = {
        $: 3
    }, uv = {
        $: 9
    }, ov = function(n) {
        return {
            c$: n
        };
    }, av = jp(k([
        A2(Lp, function(n) {
            return ov(n);
        }, A2(Mp, xp("dashboard"), Vp("kind")))
    ])), iv = F4(function(n, r, t, e) {
        return {
            B: e,
            c$: r,
            oM: n,
            P: t
        };
    }), cv = F2(function(n, r) {
        return A2(qp, n, function(n) {
            return n.b && !n.b.b ? A2(di, n.a, r) : kt;
        });
    }), fv = jp(k([
        A2(Lp, F4(function(n, r, t, e) {
            return A4(iv, n, r, t, e);
        }), A2(Mp, A2(Mp, A2(Mp, A2(Mp, xp("jobs"), Vp("organization")), Vp("kind")), Vp("status")), A2(cv, "acknowledge", Ji(k([
            d("true", !0),
            d("false", !1)
        ])))))
    ])), sv = function(n) {
        return k([
            n
        ]);
    }, lv = jp(k([
        A2(Lp, Up, sv),
        A2(Lp, Xp, xp("adminOrganizations")),
        A2(Lp, Zp, xp("onboarding")),
        A2(Lp, ev, xp("adminUsers")),
        A2(Lp, tv, xp("adminUploads")),
        A2(Lp, rv, xp("adminTestPlans")),
        A2(Lp, zp, xp("adminAudioMappings")),
        A2(Lp, Ep, xp("adminChannels")),
        A2(Lp, Yp, xp("adminResearchs")),
        A2(Lp, uv, xp("adminWebhooks")),
        A2(Lp, Kp, xp("adminOrganizationFileListings")),
        A2(Lp, Wp, xp("adminFormats")),
        A2(Lp, nv, xp("adminSubtitleFormats")),
        A2(Lp, Gp, xp("adminSegmentationRules")),
        A2(Lp, Qp, fv),
        A2(Lp, _p, xp("metadata")),
        A2(Lp, Rp, xp("deepProbe")),
        A2(Lp, Jp, xp("probes")),
        A2(Lp, Hp, av)
    ])), dv = jp(k([
        A2(Lp, 0, sv),
        A2(Lp, 1, xp("settings"))
    ])), mv = jp(k([
        A2(Lp, 0, sv),
        A2(Lp, 1, xp("actions")),
        A2(Lp, 2, xp("settings")),
        A2(Lp, 3, xp("events")),
        A2(Lp, 4, xp("verif")),
        A2(Lp, 5, xp("comments"))
    ])), bv = F2(function(n, r) {
        return function(n) {
            var t = n.ay, e = n.ae, u = n.oX, o = n.an, a = n.sw;
            if (e.b) {
                var i = e.a, c = e.b, f = r(i);
                if (f.$) return w;
                var s = f.a;
                return k([
                    A5(lp, A2(mt, i, t), c, u, o, a(s))
                ]);
            }
            return w;
        };
    }), pv = A2(bv, "STRING", ht), vv = jp(k([
        A2(Lp, Ap, sv),
        A2(Lp, F4(function(n, r, t, e) {
            return A3(Sp, n, r, {
                bD: t,
                cf: A2(Lu, Dl(!1), e)
            });
        }), A2(Fp, jp(k([
            xp("show"),
            xp("master")
        ])), A2(Fp, pv, A2(Mp, A2(Mp, mv, Vp("broadcastable")), Vp("sortVerifByDate"))))),
        A2(Lp, Cp, A2(Fp, xp("hierarchy"), A2(Fp, pv, dv))),
        A2(Lp, wp, A2(Fp, xp("account"), Op)),
        A2(Lp, gp, A2(Fp, xp("admin"), lv)),
        A2(Lp, kp, A2(Fp, xp("help"), pv)),
        A2(Lp, hp, xp("archive")),
        A2(Lp, Pp, xp("settings")),
        A2(Lp, Tp, xp("report")),
        A2(Lp, yp, xp("upload")),
        A2(Lp, fp, A2(Fp, xp("notFound"), pv))
    ])), $v = function(n) {
        return A3($p, n, vv, fp(n));
    }, wv = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gv = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), hv = function(n) {
        switch(n){
            case 0:
                return "";
            case 1:
                return "/actions";
            case 2:
                return "/settings";
            case 3:
                return "/events";
            case 4:
                return "/verif";
            default:
                return "/comments";
        }
    }, kv = function(n) {
        return A3($p, n, mv, 2);
    }, Cv = Zn("setPreference", function(n) {
        var r = n.b;
        return A2(ac, Me, k([
            ga(n.a),
            ga(r)
        ]));
    }), Tv = function(n) {
        var r = n.a, t = n.b, e = r.g9, u = r.ak, o = u.bL, a = o.qA, i = e.iZ, c = hv(i);
        return i ? d(p(r, {
            ak: p(u, {
                bL: p(o, {
                    qA: c
                })
            })
        }), bc(k([
            t,
            Cv(d("showAside", c))
        ]))) : d(p(r, {
            g9: p(e, {
                iZ: kv(a)
            })
        }), t);
    }, Pv = function(n) {
        var r = n.ak.sr;
        switch(r.$){
            case 1:
            case 2:
                return ht(r.a);
            default:
                return kt;
        }
    }, Sv = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Av = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yv = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Nv = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Lv = function(n) {
        return mc(A2(Wi, Pb, Ai(function(n) {
            return dl(yv(A2(Nv, n, 7)));
        }(n))));
    }, jv = F2(function(n, r) {
        return {
            be: n,
            fD: r
        };
    }), Fv = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            ki: t,
            bK: r,
            mo: n,
            c$: a,
            n6: e,
            oM: u,
            gq: o,
            hv: i,
            h5: c
        };
    }), Mv = function(n) {
        switch(n){
            case "Collection":
                return At(0);
            case "Season":
                return At(2);
            case "Episode":
                return At(3);
            default:
                return At(1);
        }
    }, Iv = function(n) {
        switch(n){
            case 0:
                return "Collection";
            case 1:
                return "Unitary";
            case 2:
                return "Season";
            default:
                return "Episode";
        }
    }, Dv = A2(Ml, Iv, Mv), Bv = Fi(A4(rc, "trashed", function(n) {
        return n.h5;
    }, ri, A4(rc, "state", function(n) {
        return n.hv;
    }, Db, A4(rc, "kind", function(n) {
        return n.c$;
    }, Dv, A4(qi, "parent", function(n) {
        return n.gq;
    }, Oa, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "creator", function(n) {
        return n.bK;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(Fv))))))))))), xv = F2(function(n, r) {
        return {
            fB: r,
            st: n
        };
    }), qv = F8(function(n, r, t, e, u, o, a, i) {
        return {
            cJ: e,
            cO: u,
            mo: n,
            c$: a,
            qJ: i,
            hi: o,
            sk: t,
            st: r
        };
    }), Vv = function(n) {
        switch(n){
            case "Collection":
                return At(0);
            case "Season":
                return At(2);
            case "Episode":
                return At(3);
            default:
                return At(1);
        }
    }, Ov = function(n) {
        switch(n){
            case 0:
                return "Collection";
            case 1:
                return "Unitary";
            case 2:
                return "Season";
            default:
                return "Episode";
        }
    }, zv = A2(Ml, Ov, Vv), Ev = Fi(A4(qi, "showId", function(n) {
        return n.qJ;
    }, Oa, A4(qi, "kind", function(n) {
        return n.c$;
    }, zv, A4(qi, "sourceNodeId", function(n) {
        return n.hi;
    }, Oa, A4(qi, "expireAt", function(n) {
        return n.cO;
    }, tm, A4(rc, "download", function(n) {
        return n.cJ;
    }, ri, A4(rc, "upload", function(n) {
        return n.sk;
    }, ri, A4(rc, "user", function(n) {
        return n.st;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(qv)))))))))), Hv = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            iz: a,
            bz: e,
            ki: c,
            kR: i,
            la: t,
            mo: n,
            n6: r,
            oM: u,
            oQ: o
        };
    }), Rv = F3(function(n, r, t) {
        return {
            nr: t,
            oO: n,
            gm: r
        };
    }), Wv = Fi(A4(qi, "logo", function(n) {
        return n.nr;
    }, Oa, A4(rc, "organizationName", function(n) {
        return n.gm;
    }, Oa, A4(rc, "organizationId", function(n) {
        return n.oO;
    }, Oa, Mi(Rv))))), Uv = Fi(A4(qi, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "disableOrganizationEmails", function(n) {
        return n.kR;
    }, ri, A4(rc, "admin", function(n) {
        return n.iz;
    }, ri, A4(rc, "organizations", function(n) {
        return n.oQ;
    }, ic(Wv), A4(qi, "organization", function(n) {
        return n.oM;
    }, Oa, A4(rc, "avatar", function(n) {
        return n.bz;
    }, Oa, A4(rc, "email", function(n) {
        return n.la;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(Hv))))))))))), Qv = Fi(A4(rc, "invitation", function(n) {
        return n.fB;
    }, Ev, A4(rc, "user", function(n) {
        return n.st;
    }, Uv, Mi(xv)))), _v = Fi(A4(rc, "invitations", function(n) {
        return n.fD;
    }, ic(Qv), A4(rc, "node", function(n) {
        return n.be;
    }, Bv, Mi(jv)))), Zv = function(n) {
        return mc(A2(Wi, _v, Ai(function(n) {
            return dl(yv(A2(Nv, n, 0)));
        }(n))));
    }, Kv = function(n) {
        return bc(k([
            A2(Xa, Av, Zv(n)),
            A2(Xa, Sv, Lv(n))
        ]));
    }, Xv = {
        $: 1
    }, Jv = (ff = Jl, Pn(function(n) {
        n(Cn(ff(Date.now())));
    })), Yv = su, Gv = A2(Yv, Dl(Xv), Jv), n$ = bc(w), r$ = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return w;
            var e = t.a, u = t.b, o = e.eC;
            if (o.$) {
                if (a(e.mo, n)) return A2(mt, e.mo, r);
                t = u;
            } else {
                var i = o.b, c = A3(r$, n, A2(mt, e.mo, r), i);
                if (c.b) return c;
                t = u;
            }
        }
    }), t$ = function(n) {
        var r = n.qs;
        return r.$ ? n : p(n, {
            oC: A3(xt, If, n.oC, A3(r$, r.a, w, $(n.jL, n.fD)))
        });
    }, e$ = F2(function(n, r) {
        return t$(p(r, {
            pN: !0,
            qs: ht(n)
        }));
    }), u$ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), o$ = function(n) {
        return A2(u$, n, !1);
    }, a$ = {
        cq: w,
        kP: kt,
        lo: kt,
        oQ: Su,
        px: za(function(n) {
            return p(n, {
                gw: "Search Audio Mapping by Organization, Name or Tracks",
                sw: ""
            });
        }),
        rz: kt,
        rN: o$("Organization")
    }, i$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, c$ = F6(function(n, r, t, e, u, o) {
        return {
            mo: n,
            mO: u,
            mQ: o,
            n6: t,
            oM: r,
            r4: e
        };
    }), f$ = F3(function(n, r, t) {
        return {
            nd: n,
            r9: r,
            sz: t
        };
    }), s$ = {
        lC: Su,
        c$: 0,
        nP: "",
        ar: va,
        N: !1,
        P: 400,
        ag: !1
    }, l$ = function(n) {
        switch(n){
            case "Stereo":
                return At(0);
            case "OneTrackStereo":
                return At(1);
            case "OneTrack5.1":
                return At(2);
            case "OneTrack7.1":
                return At(3);
            case "5.1SMPTE(L/R/C/LFE/SL/SR)":
                return At(4);
            case "5.1ISO(L/R/SL/SR/C/LFE)":
                return At(5);
            default:
                return Ct(A2(ka, "Unknown output layout", s$));
        }
    }, d$ = function(n) {
        switch(n){
            case 0:
                return "Stereo";
            case 1:
                return "OneTrackStereo";
            case 2:
                return "OneTrack5.1";
            case 3:
                return "OneTrack7.1";
            case 4:
                return "5.1SMPTE(L/R/C/LFE/SL/SR)";
            default:
                return "5.1ISO(L/R/SL/SR/C/LFE)";
        }
    }, m$ = A2(Ml, d$, l$), b$ = function(n) {
        switch(n){
            case "Original":
                return At(0);
            case "Dubbed":
                return At(1);
            case "AudioDescription":
                return At(2);
            case "International":
                return At(3);
            case "VoiceOnly":
                return At(4);
            case "Silence":
                return At(5);
            case "MusicAndEffects":
                return At(6);
            case "Custom1":
                return At(7);
            case "Custom2":
                return At(8);
            case "Custom3":
                return At(9);
            case "Custom4":
                return At(10);
            case "Custom5":
                return At(11);
            case "Custom6":
                return At(12);
            case "Custom7":
                return At(13);
            case "Custom8":
                return At(14);
            case "Custom9":
                return At(15);
            case "Custom10":
                return At(16);
            default:
                return Ct(A2(ka, "Unknown output type version", s$));
        }
    }, p$ = function(n) {
        switch(n){
            case 0:
                return "Original";
            case 1:
                return "Dubbed";
            case 2:
                return "AudioDescription";
            case 3:
                return "International";
            case 4:
                return "VoiceOnly";
            case 5:
                return "Silence";
            case 6:
                return "MusicAndEffects";
            case 7:
                return "Custom1";
            case 8:
                return "Custom2";
            case 9:
                return "Custom3";
            case 10:
                return "Custom4";
            case 11:
                return "Custom5";
            case 12:
                return "Custom6";
            case 13:
                return "Custom7";
            case 14:
                return "Custom8";
            case 15:
                return "Custom9";
            default:
                return "Custom10";
        }
    }, v$ = A2(Ml, p$, b$), $$ = function(n) {
        switch(n){
            case "ARA":
                return At(0);
            case "BUL":
                return At(1);
            case "CHI":
                return At(2);
            case "CZE":
                return At(3);
            case "KOR":
                return At(4);
            case "DAN":
                return At(5);
            case "DUT":
                return At(6);
            case "GRE":
                return At(9);
            case "HEB":
                return At(7);
            case "HIN":
                return At(8);
            case "NLD":
                return At(10);
            case "RUS":
                return At(11);
            case "SWE":
                return At(14);
            case "SLV":
                return At(12);
            case "SRP":
                return At(13);
            case "TAM":
                return At(15);
            case "THA":
                return At(16);
            case "FRA":
                return At(17);
            case "FRE_CA":
                return At(18);
            case "GER":
                return At(19);
            case "ITA":
                return At(20);
            case "POR":
                return At(21);
            case "ENG":
                return At(22);
            case "SPA":
                return At(23);
            case "JPN":
                return At(24);
            case "NOR":
                return At(25);
            case "UKR":
                return At(26);
            case "FIN":
                return At(27);
            case "ESP":
                return At(28);
            case "POR_BR":
                return At(29);
            case "RON":
                return At(30);
            case "HRV":
                return At(31);
            case "GLA":
                return At(32);
            case "HUN":
                return At(33);
            case "IND":
                return At(34);
            case "TUR":
                return At(35);
            case "POL":
                return At(36);
            case "INT":
                return At(37);
            case "NOTHING":
                return At(38);
            default:
                return Ct("Not a version");
        }
    }, w$ = function(n) {
        switch(n){
            case 0:
                return "ARA";
            case 1:
                return "BUL";
            case 2:
                return "CHI";
            case 3:
                return "CZE";
            case 4:
                return "KOR";
            case 5:
                return "DAN";
            case 6:
                return "DUT";
            case 9:
                return "GRE";
            case 7:
                return "HEB";
            case 8:
                return "HIN";
            case 10:
                return "NLD";
            case 11:
                return "RUS";
            case 12:
                return "SLV";
            case 13:
                return "SRP";
            case 14:
                return "SWE";
            case 15:
                return "TAM";
            case 16:
                return "THA";
            case 17:
                return "FRA";
            case 18:
                return "FRE_CA";
            case 19:
                return "GER";
            case 20:
                return "ITA";
            case 21:
                return "POR";
            case 22:
                return "ENG";
            case 23:
                return "SPA";
            case 24:
                return "JPN";
            case 25:
                return "NOR";
            case 26:
                return "UKR";
            case 27:
                return "FIN";
            case 28:
                return "ESP";
            case 29:
                return "POR_BR";
            case 30:
                return "RON";
            case 31:
                return "HRV";
            case 32:
                return "GLA";
            case 33:
                return "HUN";
            case 34:
                return "IND";
            case 35:
                return "TUR";
            case 36:
                return "POL";
            case 37:
                return "INT";
            default:
                return "";
        }
    }, g$ = A2(Ml, w$, $$), h$ = Fi(A4(rc, "version", function(n) {
        return n.sz;
    }, xi(g$), A4(rc, "typeVersion", function(n) {
        return n.r9;
    }, v$, A4(rc, "layout", function(n) {
        return n.nd;
    }, m$, Mi(f$))))), k$ = Fi(A4(rc, "isExtraDefault", function(n) {
        return n.mQ;
    }, ri, A4(rc, "isDefault", function(n) {
        return n.mO;
    }, ri, A4(rc, "tracks", function(n) {
        return n.r4;
    }, ic(h$), A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(c$)))))))), C$ = ic(k$), T$ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, P$ = yi(T$({
        $: 0
    })), S$ = mc(A2(Wi, C$, Ai(P$))), A$ = function(n) {
        switch(n){
            case "CanalPlus":
                return At(0);
            case "CanalPlusPub":
                return At(1);
            case "Lagardere":
                return At(2);
            case "M6":
                return At(3);
            case "M6Pub":
                return At(4);
            case "M6PubDigital":
                return At(5);
            case "Salto":
                return At(6);
            case "FranceTV":
                return At(7);
            case "AmauryMediaPub":
                return At(8);
            case "Ligue1PlusPub":
                return At(9);
            case "MediawanPub":
                return At(10);
            case "MediawanLigue1PlusPub":
                return At(11);
            case "Tf1Pub":
                return At(12);
            case "RmcBfmPub":
                return At(13);
            case "RmcBfmPubTV":
                return At(14);
            case "Novo19":
                return At(15);
            case "GameOnePub":
                return At(16);
            case "ParamountPub":
                return At(17);
            case "BeinSportPub":
                return At(18);
            case "FTVPub":
                return At(19);
            case "ETF1":
                return At(20);
            default:
                return Ct(A2(ka, "Unknown broadcaster", s$));
        }
    }, y$ = function(n) {
        switch(n){
            case 0:
                return "CanalPlus";
            case 1:
                return "CanalPlusPub";
            case 2:
                return "Lagardere";
            case 3:
                return "M6";
            case 4:
                return "M6Pub";
            case 5:
                return "M6PubDigital";
            case 6:
                return "Salto";
            case 7:
                return "FranceTV";
            case 8:
                return "AmauryMediaPub";
            case 9:
                return "Ligue1PlusPub";
            case 10:
                return "MediawanPub";
            case 11:
                return "MediawanLigue1PlusPub";
            case 12:
                return "Tf1Pub";
            case 13:
                return "RmcBfmPub";
            case 14:
                return "RmcBfmPubTV";
            case 15:
                return "Novo19";
            case 16:
                return "GameOnePub";
            case 17:
                return "ParamountPub";
            case 18:
                return "BeinSportPub";
            case 19:
                return "FTVPub";
            default:
                return "ETF1";
        }
    }, N$ = A2(Ml, y$, A$), L$ = F2(function(n, r) {
        return {
            mo: n,
            mO: r
        };
    }), j$ = Fi(A4(rc, "isDefault", function(n) {
        return n.mO;
    }, ri, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(L$)))), F$ = Fi(A4(qi, "metadataSchema", function(n) {
        return n.nS;
    }, Oa, A4(rc, "autoDeleteShows", function(n) {
        return n.jc;
    }, ri, A4(rc, "staticIp", function(n) {
        return n.dv;
    }, ri, A4(rc, "needAccept", function(n) {
        return n.oa;
    }, ri, A4(rc, "adNomalabDest", function(n) {
        return n.iu;
    }, ri, A4(rc, "isAdvertiser", function(n) {
        return n.mM;
    }, ri, A4(rc, "segmentationRules", function(n) {
        return n.$7;
    }, ic(Oa), A4(rc, "extraFormats", function(n) {
        return n.e5;
    }, ic(j$), A4(rc, "subtitleFormats", function(n) {
        return n.dw;
    }, ic(Oa), A4(rc, "formats", function(n) {
        return n.cX;
    }, ic(j$), A4(qi, "logo", function(n) {
        return n.nr;
    }, Oa, A4(rc, "replication", function(n) {
        return n.pF;
    }, ri, A4(rc, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iJ;
    }, ri, A4(rc, "manualDelivery", function(n) {
        return n.nK;
    }, ri, A4(qi, "broadcaster", function(n) {
        return n.js;
    }, N$, A4(rc, "enableAutoReject", function(n) {
        return n.ld;
    }, ri, A4(rc, "enableAutoAccept", function(n) {
        return n.lc;
    }, ri, A4(rc, "enableUploadSuccessEmail", function(n) {
        return n.lg;
    }, ri, A4(rc, "enableVideoReadyEmail", function(n) {
        return n.lh;
    }, ri, A4(rc, "enableCreationEmail", function(n) {
        return n.le;
    }, ri, A4(qi, "downloadFileName", function(n) {
        return n.kZ;
    }, Oa, A4(qi, "destination", function(n) {
        return n.kO;
    }, Oa, A4(rc, "qcMasterReportTemplate", function(n) {
        return n.pq;
    }, Oa, A4(rc, "qcMasterTestPlan", function(n) {
        return n.pr;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(w) {
                                                                                return function(g) {
                                                                                    return function(h) {
                                                                                        return function(k) {
                                                                                            return function(C) {
                                                                                                return function(T) {
                                                                                                    return function(P) {
                                                                                                        return function(S) {
                                                                                                            return function(A) {
                                                                                                                return {
                                                                                                                    iu: C,
                                                                                                                    iJ: b,
                                                                                                                    jc: S,
                                                                                                                    js: d,
                                                                                                                    ki: r,
                                                                                                                    kO: o,
                                                                                                                    kZ: a,
                                                                                                                    lc: s,
                                                                                                                    ld: l,
                                                                                                                    le: i,
                                                                                                                    lg: f,
                                                                                                                    lh: c,
                                                                                                                    e5: g,
                                                                                                                    cX: $,
                                                                                                                    mo: n,
                                                                                                                    mM: k,
                                                                                                                    nr: v,
                                                                                                                    nK: m,
                                                                                                                    nS: A,
                                                                                                                    n6: t,
                                                                                                                    oa: T,
                                                                                                                    pq: u,
                                                                                                                    pr: e,
                                                                                                                    pF: p,
                                                                                                                    $7: h,
                                                                                                                    dv: P,
                                                                                                                    dw: w
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))), M$ = ic(F$), I$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, D$ = yi(I$({
        $: 1
    })), B$ = A2(Yb, Ji, A2(Yb, Ye(function(n) {
        return d(n.mo, n);
    }), mc(A2(Wi, M$, Ai(D$))))), x$ = A2(Xa, i$, Gb(d(S$, B$))), q$ = d(a$, x$), V$ = F2(function(n, r) {
        return d(n, r);
    }), O$ = F2(function(n, r) {
        return function(t) {
            var e = m(za(function(n) {
                return p(n, {
                    m7: "Layout",
                    sw: d$(r.nd)
                });
            }), za(function(n) {
                return p(n, {
                    m7: "TypeVersion",
                    sw: p$(r.r9)
                });
            }), za(function(n) {
                var t;
                return p(n, {
                    m7: "Version",
                    sw: (t = r.sz, t.$ ? n.sw : w$(t.a))
                });
            }));
            return p(t, {
                mo: n,
                ql: e.a,
                qm: e.b,
                qn: e.c
            });
        }({
            mo: 0,
            ql: za(Me),
            qm: za(Me),
            qn: za(Me)
        });
    }), z$ = function(n) {
        var r = function(n) {
            return A2(Pi, Lu(n), ju(""));
        };
        return {
            mO: ti(function(r) {
                return p(r, {
                    m7: "Set default",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.mO;
                    }, n))
                });
            }),
            mQ: ti(function(r) {
                return p(r, {
                    m7: "Set extra default",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.mQ;
                    }, n))
                });
            }),
            n6: za(function(t) {
                return p(t, {
                    m7: "Name",
                    sw: A2(r, function(n) {
                        return n.n6;
                    }, n)
                });
            }),
            oM: za(function(t) {
                return p(t, {
                    m7: "Organization",
                    sw: A2(r, function(n) {
                        return n.oM;
                    }, n)
                });
            }),
            oS: n,
            r4: n.$ ? Su : A2(Gi, O$, Ji(A2(Ht, V$, n.a.r4)))
        };
    }, E$ = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), H$ = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, o = A3(n, t.b, t.c, A3(H$, n, r, t.d));
            n = u, r = o, t = e;
        }
    }), R$ = F2(function(n, r) {
        return A3(H$, F3(function(r, t, e) {
            return A2(n, r, t) ? A3(Cu, r, t, e) : e;
        }), Su, r);
    }), W$ = function(n) {
        return n.b ? ht(A3(xt, de, n.a, n.b)) : kt;
    }, U$ = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Q$ = Fi(A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return {
            mo: n
        };
    }))), _$ = F5(function(n, r, t, e, u) {
        return {
            mO: e,
            mQ: u,
            n6: r,
            oM: n,
            r4: t
        };
    }), Z$ = Fi(A4(rc, "isExtraDefault", function(n) {
        return n.mQ;
    }, ri, A4(rc, "isDefault", function(n) {
        return n.mO;
    }, ri, A4(rc, "tracks", function(n) {
        return n.r4;
    }, ic(h$), A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, Mi(_$))))))), K$ = function(n) {
        return {
            lC: Su,
            c$: 0,
            nP: n,
            ar: va,
            N: !1,
            P: 400,
            ag: !1
        };
    }, X$ = F2(function(n, r) {
        return r.$ ? Ct(r.a) : At(n(r.a));
    }), J$ = F4(function(n, r, t, e) {
        if (1 === r.$) return Ct(r.a);
        var u = r.a;
        if (1 === t.$) return Ct(t.a);
        var o = t.a;
        return 1 === e.$ ? Ct(e.a) : At(A3(n, u, o, e.a));
    }), Y$ = F2(function(n, r) {
        return A2(mu, function(r) {
            return a(r, n);
        }, r);
    }), G$ = function(n) {
        return A2(Ia, w, A3(Je, F2(function(n, r) {
            var t = d(n, r);
            return t.b.$ ? Ct(t.b.a) : t.a.$ ? Ct(t.a.a) : At(A2(mt, t.a.a, t.b.a));
        }), At(w), A2(Ye, function(n) {
            var r = n.b;
            return A4(J$, f$, l$(r.ql.sw), b$(r.qm.sw), A2(Y$, r.qm.sw, k([
                "Original",
                "Dubbed",
                "AudioDescription"
            ])) && "" !== r.qn.sw ? A2(ha, K$, A2(X$, ht, $$(r.qn.sw))) : At(kt));
        }, pt(n))));
    }, nw = A2(bu, Ri, Hi), rw = function(n) {
        return A2(Ci, "POST", Si(n));
    }, tw = function(n) {
        return Ii(n);
    }, ew = function(n) {
        return A2(ut, "application/json", A2(Ft, 0, n));
    }, uw = F2(function(n, r) {
        return p(r, {
            ei: n
        });
    }), ow = F2(function(n, r) {
        return uw(ew(A2(tw, n, r)));
    }), aw = function(n) {
        var r;
        return A2(Xa, U$, mc(A2(nw, Q$, A3(ow, Z$, {
            mO: (r = n).mO.sw,
            mQ: r.mQ.sw,
            n6: r.n6.sw,
            oM: r.oM.sw,
            r4: G$(r.r4)
        }, rw(P$)))));
    }, iw = function(n) {
        return {
            $: 11,
            a: n
        };
    }, cw = function(n) {
        return yi(T$({
            $: 1,
            a: n
        }));
    }, fw = function(n) {
        return A2(Ci, "DELETE", Si(n));
    }, sw = Ri(Dl(At(0))), lw = function(n) {
        return {
            $: 9,
            a: n
        };
    }, dw = function(n) {
        return A2(Ci, "PUT", Si(n));
    }, mw = F2(function(n, r) {
        return mc(sw(A3(ow, Z$, {
            mO: r.mO.sw,
            mQ: r.mQ.sw,
            n6: r.n6.sw,
            oM: r.oM.sw,
            r4: G$(r.r4)
        }, dw(cw(n.mo)))));
    }), bw = F2(function(n, r) {
        return A2(Xa, lw, A2(mw, n, r));
    }), pw = F2(function(n, r) {
        return p(n, {
            sw: r
        });
    }), vw = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pw, r, t = n.a);
            case 1:
                return p(e = A2(pw, r, t = n.a), {
                    lS: !0
                });
            default:
                var t = n.a, e = p(r, {
                    lS: !1,
                    fj: !0
                });
                return A2(pw, e, t);
        }
    }), $w = F2(function(n, r) {
        return p(n, {
            fj: !0,
            sw: r
        });
    }), ww = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2($w, r, t = n.a);
            case 1:
                return p(e = A2($w, r, t = n.a), {
                    lS: !0
                });
            default:
                var t = n.a, e = p(r, {
                    lS: !1,
                    fj: !0
                });
                return A2($w, e, t);
        }
    }), gw = F2(function(n, r) {
        switch(n.$){
            case 0:
                return p(r, {
                    ql: A2(ww, n.a, r.ql)
                });
            case 1:
                return p(r, {
                    qm: A2(ww, n.a, r.qm)
                });
            default:
                return p(r, {
                    qn: A2(ww, n.a, r.qn)
                });
        }
    }), hw = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, w, p(r, {
                    kP: ht(z$(ht(n.a)))
                }));
            case 1:
                return A2(pc, w, p(r, {
                    kP: ht(z$(kt))
                }));
            case 4:
                return A2(pc, w, p(r, {
                    kP: kt,
                    lo: kt,
                    rz: kt
                }));
            case 3:
                return A2(pc, w, p(r, {
                    lo: kt,
                    rz: kt
                }));
            case 5:
                var t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        oM: A2(ww, t, n.oM)
                    });
                }, r.kP);
                return A2(pc, w, p(r, {
                    kP: e
                }));
            case 6:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        n6: A2(ww, t, n.n6)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 7:
                var u = r.kP;
                return A2(pc, k(1 === u.$ ? [
                    n$
                ] : 1 === (d = (e = u.a).oS).$ ? [
                    aw(e)
                ] : [
                    A2(bw, d.a, e)
                ]), r);
            case 10:
                return A2(pc, k([
                    (l = n.a, A2(Xa, iw, function(n) {
                        return mc(sw(fw(cw(n.mo))));
                    }(l)))
                ]), r);
            case 8:
                return (o = n.a).$ ? A2(pc, w, A2(E$, o.a, r)) : A2(pc, k([
                    x$
                ]), p(r, {
                    lo: kt,
                    rz: ht("Audio mapping created")
                }));
            case 9:
                return (o = n.a).$ ? A2(pc, w, A2(E$, o.a, r)) : A2(pc, k([
                    x$
                ]), p(r, {
                    lo: kt,
                    rz: ht("Audio mapping updated")
                }));
            case 11:
                return (o = n.a).$ ? A2(pc, w, A2(E$, o.a, r)) : A2(pc, k([
                    x$
                ]), p(r, {
                    lo: kt,
                    rz: ht("Audio mapping deleted")
                }));
            case 0:
                var o;
                if ((o = n.a).$) return A2(pc, w, A2(E$, o.a, r));
                var i = o.a;
                return A2(pc, w, p(r, {
                    cq: i.a,
                    oQ: i.b
                }));
            case 12:
                t = n.a;
                var c = n.b;
                n: for(; !t.a.$;)return e = A2(Lu, function(n) {
                    return p(n, {
                        r4: A2(Gi, F2(function(n, r) {
                            return a(n, c) ? A2(gw, t, r) : r;
                        }), n.r4)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
                return A2(pc, w, r);
            case 14:
                return c = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        r4: A2(R$, F2(function(n) {
                            return !a(n, c);
                        }), n.r4)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 13:
                var f = A2(ju, 0, A2(Lu, function(n) {
                    return A2(ju, 0, W$(vt(n.r4)));
                }, r.kP)), s = A2(O$, f + 1, A3(f$, 0, 5, kt));
                return e = A2(Lu, function(n) {
                    return p(n, {
                        r4: A3(Cu, f + 1, s, n.r4)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 16:
                return A2(pc, w, p(r, {
                    px: A2(ww, t = n.a, r.px)
                }));
            case 15:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            case 17:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        mO: A2(vw, t, n.mO)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            default:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        mQ: A2(vw, t, n.mQ)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
        }
        var l, d;
    }), kw = {
        $: 1
    }, Cw = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Tw = F2(function(n, r) {
        return A2(ju, "", A2(Lu, function(n) {
            return n.n6;
        }, A2(di, r.oM, n)));
    }), Pw = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Sw = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Aw = Ae("button"), yw = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Nw = F2(function(n, r) {
        return A2(pr, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), $r(r));
    }), Lw = F2(function(n, r) {
        return A3(yw, A2(Nw, n, r), w, "");
    }), jw = Lw("class"), Fw = jw, Mw = dr, Iw = F2(function(n, r) {
        return A3(yw, A2(Mw, n, r), w, "");
    }), Dw = F2(function(n, r) {
        return A2(Iw, n, {
            $: 0,
            a: r
        });
    }), Bw = F2(function(n, r) {
        var t;
        return A2(Aw, k([
            (t = r, A2(Dw, "click", je(t))),
            Fw("IconButton")
        ]), k([
            n
        ]));
    }), xw = F2(function(n, r) {
        return A2(br, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), $r(r));
    }), qw = F2(function(n, r) {
        return A3(yw, A2(xw, n, r), w, "");
    }), Vw = F2(function(n, r) {
        return A2(qw, n, ga(r));
    }), Ow = Vw("className"), zw = F2(function(n, r) {
        return {
            u: n,
            jL: r
        };
    }), Ew = function(n) {
        return {
            $: 3,
            a: Ra(n)
        };
    }, Hw = Lw("height"), Rw = Lw("points"), Ww = F4(function(n, r, t, e) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Uw = Ww, Qw = Uw("http://www.w3.org/2000/svg"), _w = Qw("polygon"), Zw = Qw("svg"), Kw = Lw("viewBox"), Xw = Lw("width"), Jw = A2(Zw, k([
        Hw("16px"),
        Xw("16px"),
        Kw("0 0 16 16"),
        Fw("IconKo")
    ]), k([
        A2(_w, k([
            Fw("Fg"),
            Rw("4 5 6 3 13 11 11 13")
        ]), w),
        A2(_w, k([
            Fw("Fg"),
            Rw("13 5 11 3 3 11 5 13")
        ]), w)
    ])), Yw = A2(Zw, k([
        Hw("16px"),
        Xw("16px"),
        Kw("0 0 16 16"),
        Fw("IconOk")
    ]), k([
        A2(_w, k([
            Fw("Fg"),
            Rw("2 8 7 13 15 5 13 3 7 9 4 6")
        ]), w)
    ])), Gw = Me, ng = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: Ew(function(n) {
                return r(n) ? "1" : "0";
            }),
            dN: function(n) {
                return A2(zw, w, k([
                    r(n) ? Yw : Jw
                ]));
            }
        });
    }), rg = {
        $: 0
    }, tg = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), eg = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: tg(r)
        });
    }), ug = function(n) {
        var r = n.rZ, t = n.r_, e = n.kv;
        return {
            j_: A2(Ye, function(n) {
                return n;
            }, n.j_),
            kv: e,
            rZ: r,
            r_: t
        };
    }, og = F3(function(n, r, t) {
        return {
            n6: n,
            ds: t,
            dN: r
        };
    }), ag = function(n) {
        return la(sa(n));
    }, ig = function(n) {
        return A2(zw, w, k([
            ag(n)
        ]));
    }, cg = function(n) {
        var r = n.ds;
        return A3(og, n.n6, A2(bu, ig, n.dN), r);
    }, fg = F2(function(n, r) {
        var t;
        return cg({
            n6: n,
            ds: Ew((t = r, A2(bu, Ua, t))),
            dN: r
        });
    }), sg = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, lg = xo(k([
        sg(160)
    ])), dg = Ae("span"), mg = mr, bg = F2(function(n, r) {
        return A3(yw, A2(mg, n, r), w, "");
    }), pg = bg, vg = function(n) {
        return A2(dg, k([
            A2(pg, "color", "#555")
        ]), k([
            ag($(lg, n))
        ]));
    }, $g = function(n) {
        return A2(dg, k([
            A2(pg, "color", "#ccc")
        ]), k([
            ag($(lg, n))
        ]));
    }, wg = Ae("th"), gg = function(n) {
        var r = n.a, t = n.b, e = n.c, u = function() {
            switch(t.$){
                case 0:
                    return k([
                        ag(r)
                    ]);
                case 1:
                    var n = t.a;
                    return k([
                        ag(r),
                        n ? vg("\u2193") : $g("\u2193")
                    ]);
                default:
                    if (1 === t.a.$) return k([
                        ag(r),
                        $g("\u2195")
                    ]);
                    var e = t.a.a;
                    return k([
                        ag(r),
                        vg(e ? "\u2191" : "\u2193")
                    ]);
            }
        }();
        return A2(wg, k([
            e
        ]), u);
    }, hg = {
        jC: kt,
        pS: function() {
            return w;
        },
        rE: w,
        rQ: w,
        dD: kt,
        dE: function(n) {
            return A2(zw, w, A2(Ye, gg, n));
        }
    }, kg = A2(Zw, k([
        Hw("16px"),
        Xw("16px"),
        Kw("0 0 16 16"),
        Fw("IconDelete")
    ]), k([
        A2(_w, k([
            Fw("Fg"),
            Rw("4 5 6 3 13 11 11 13")
        ]), w),
        A2(_w, k([
            Fw("Fg"),
            Rw("13 5 11 3 3 11 5 13")
        ]), w)
    ])), Cg = function(n) {
        return A2(Dw, "click", je(n));
    }, Tg = Vw("type"), Pg = F2(function(n, r) {
        return A2(Aw, k([
            Tg("button"),
            Cg(r),
            Ow("ButtonMini")
        ]), k([
            ag(n)
        ]));
    }), Sg = k([
        Ow("Table")
    ]), Ag = function(n) {
        return A6(c$, n.mo, n.oM, n.n6, n.r4, n.mO, n.mQ);
    }, yg = function(n) {
        var r = n.r9;
        return d$(n.nd) + " " + p$(r);
    }, Ng = ug({
        j_: k([
            A2(eg, "Edit", A2(bu, A2(bu, Pg("Edit"), Pw), Ag)),
            A2(fg, "Organization", function(n) {
                return n.gm;
            }),
            A2(fg, "Name", function(n) {
                return n.n6;
            }),
            A2(ng, "Default", function(n) {
                return n.mO || n.mQ;
            }),
            A2(fg, "Tracks", A2(Pi, function(n) {
                return n.r4;
            }, A2(Pi, Ye(yg), It(", ")))),
            A2(eg, "Delete", A2(bu, A2(bu, Bw(kg), Sw), Ag))
        ]),
        kv: p(hg, {
            pS: function() {
                return k([
                    Ow("TableTr")
                ]);
            },
            rE: Sg,
            rQ: k([
                Ow("TableTd")
            ])
        }),
        rZ: function(n) {
            return n.mo;
        },
        r_: function(n) {
            return {
                $: 15,
                a: n
            };
        }
    }), Lg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, jg = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Fg = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Mg = function(n) {
        return A2(Vw, "autocomplete", n ? "on" : "off");
    }, Ig = F2(function(n, r) {
        return A2(qw, n, ni(r));
    }), Dg = Ig("autofocus"), Bg = function(n) {
        return Ow(A2(It, " ", A2(Ye, $e, A2(Mu, Zi, n))));
    }, xg = F3(function(n, r, t) {
        return A2(n, r, k([
            ag(t)
        ]));
    }), qg = xg(dg), Vg = function(n) {
        return Tu(n) ? ag("") : A2(ye, k([
            Ow("InputErrors")
        ]), A2(Ye, qg(k([
            Ow("InputError")
        ])), n));
    }, Og = F2(function(n, r) {
        return A2(ye, k([
            Ow("InputWrapper"),
            Bg(k([
                d("InputHasError", Tu(n.lp))
            ]))
        ]), k([
            r,
            Vg(n.lp)
        ]));
    }), zg = Ig("disabled"), Eg = Ae("input"), Hg = Vw("name"), Rg = F4(function(n, r, t, e) {
        return {
            fv: r,
            b_: n,
            ot: t,
            rk: e
        };
    }), Wg = ct, Ug = function(n) {
        return A2(Wg, {
            jF: !1,
            n4: !1
        }, n);
    }, Qg = /.^/, _g = lt(dt), Zg = function(n) {
        return "" !== n ? A3(_g, A2(ju, Qg, Ug("[^a-z0-9]+")), function() {
            return "_";
        }, Ua(n)) : n;
    }, Kg = Vw("id"), Xg = function(n) {
        return "" === n ? Bg(w) : Kg(n);
    }, Jg = F2(function(n, r) {
        return A3(Je, du, r, n);
    }), Yg = A2(Jg, k([
        "target",
        "value"
    ]), Da), Gg = function(n) {
        return A2(Dw, "blur", A2(Ne, n, Yg));
    }, nh = function(n) {
        return A2(Dw, "focus", A2(Ne, n, Yg));
    }, rh = function(n) {
        return d(n, !0);
    }, th = F2(function(n, r) {
        return A2(Iw, n, {
            $: 1,
            a: r
        });
    }), eh = function(n) {
        return A2(th, "input", A2(Ne, rh, A2(Ne, n, Yg)));
    }, uh = Vw("placeholder"), oh = Vw("value"), ah = function(n) {
        return A2(Og, n, A2(Eg, k([
            Ow("InputText"),
            Xg(n.kX),
            Tg("text"),
            eh(Lg),
            Gg(jg),
            nh(Fg),
            oh(n.sw),
            uh(n.gw),
            Hg(Zg(n.m7)),
            zg(n.kS),
            Mg(n.n7),
            n.d8 ? Dg(!0) : Bg(w)
        ]), w));
    }, ih = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), ch = F4(function(n, r, t, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), fh = ir, sh = gr, lh = F2(function(n, r) {
        var t = r.b, e = r.c;
        return A3(yw, A2(sh, n, r.a), t, e);
    }), dh = F2(function(n, r) {
        switch(r.$){
            case 0:
                var t = r.b, e = r.c;
                return A3(Se, r.a, A2(Ye, lh(n), t), A2(Ye, dh(n), e));
            case 1:
                return t = r.c, e = r.d, A4(Ww, r.a, r.b, A2(Ye, lh(n), t), A2(Ye, dh(n), e));
            case 2:
                return t = r.b, e = r.c, A3(ih, r.a, A2(Ye, lh(n), t), A2(Ye, function(r) {
                    return d(r.a, A2(dh, n, r.b));
                }, e));
            case 3:
                return t = r.c, e = r.d, A4(ch, r.a, r.b, A2(Ye, lh(n), t), A2(Ye, function(r) {
                    return d(r.a, A2(dh, n, r.b));
                }, e));
            default:
                return la(A2(fh, n, r.a));
        }
    }), mh = dh, bh = Ae("caption"), ph = F3(function(n, r, t) {
        switch(r.$){
            case 0:
                return t;
            case 1:
                return (e = r.a)(t);
            case 2:
                return Zt((e = r.a)(t));
            case 3:
                var e = r.a;
                return n ? Zt(e(t)) : e(t);
            default:
                return e = r.a, n ? e(t) : Zt(e(t));
        }
    }), vh = F2(function(n, r) {
        for(;;){
            if (!r.b) return kt;
            var t = r.a.ds, e = r.b;
            if (a(r.a.n6, n)) return ht(t);
            r = e;
        }
    }), $h = F3(function(n, r, t) {
        var e = n.b, u = A2(vh, n.a, r);
        return 1 === u.$ ? t : A3(ph, e, u.a, t);
    }), wh = F3(function(n, r, t) {
        return A3($h, r, n.j_, t);
    }), gh = ih, hh = gh, kh = Ae("table"), Ch = Ae("tfoot"), Th = Ae("thead"), Ph = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Sh = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ah = {
        $: 0
    }, yh = F3(function(n, r, t) {
        return A2(Dw, "click", A2(Ne, t, A3(Le, u$, je(n), je(r))));
    }), Nh = F3(function(n, r, t) {
        var e = n.a, u = n.b, o = t.n6;
        switch(t.ds.$){
            case 0:
                return m(o, Ah, A3(yh, e, u, r));
            case 1:
                return m(o, Sh(!a(o, e)), A3(yh, o, !1, r));
            case 2:
                return m(o, Sh(a(o, e)), A3(yh, o, !1, r));
            case 3:
                return a(o, e) ? m(o, Ph(ht(!u)), A3(yh, o, !u, r)) : m(o, Ph(kt), A3(yh, o, !1, r));
            default:
                return a(o, e) ? m(o, Ph(ht(u)), A3(yh, o, !u, r)) : m(o, Ph(kt), A3(yh, o, !1, r));
        }
    }), Lh = Ae("tr"), jh = lr, Fh = F2(function(n, r) {
        var t = n.b, e = n.c;
        return Tu(t) ? r : A3(Cu, e, t, r);
    }), Mh = function(n) {
        return n.a;
    }, Ih = function(n) {
        return ar(vr(n));
    }, Dh = F2(function(n, r) {
        return A2(or, n, vr(r));
    }), Bh = function(n) {
        return er(vr(n));
    }, xh = F2(function(n, r) {
        var t = n.a, e = n.b, u = r.a, o = r.b;
        switch(e.$){
            case 4:
                return d(A2(mt, d(t, l = e.a), u), o);
            case 0:
                var a = e.a, i = e.c, c = A3(xt, qh, d(w, A3(xt, Fh, o, v = e.b)), i), f = c.a, s = c.b, l = A3(ca, a, A2(Ye, Mh, v), Zt(f));
                return d(A2(mt, d(t, l), u), s);
            case 1:
                var m = e.a, b = (a = e.b, i = e.d, A3(xt, qh, d(w, A3(xt, Fh, o, v = e.c)), i));
                return f = b.a, s = b.b, l = A4(Bh, m, a, A2(Ye, Mh, v), Zt(f)), d(A2(mt, d(t, l), u), s);
            case 2:
                a = e.a, i = e.c;
                var p = A3(xt, xh, d(w, A3(xt, Fh, o, v = e.b)), i);
                return f = p.a, s = p.b, l = A3(Ih, a, A2(Ye, Mh, v), Zt(f)), d(A2(mt, d(t, l), u), s);
            default:
                m = e.a, a = e.b, i = e.d;
                var v, $ = A3(xt, xh, d(w, A3(xt, Fh, o, v = e.c)), i);
                return f = $.a, s = $.b, l = A4(Dh, m, a, A2(Ye, Mh, v), Zt(f)), d(A2(mt, d(t, l), u), s);
        }
    }), qh = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 4:
                return d(A2(mt, f = n.a, t), e);
            case 0:
                var u = n.a, o = n.c, a = A3(xt, qh, d(w, A3(xt, Fh, e, b = n.b)), o), i = a.a, c = a.b, f = A3(ca, u, A2(Ye, Mh, b), Zt(i));
                return d(A2(mt, f, t), c);
            case 1:
                var s = n.a, l = (u = n.b, o = n.d, A3(xt, qh, d(w, A3(xt, Fh, e, b = n.c)), o));
                return i = l.a, c = l.b, f = A4(Bh, s, u, A2(Ye, Mh, b), Zt(i)), d(A2(mt, f, t), c);
            case 2:
                u = n.a, o = n.c;
                var m = A3(xt, xh, d(w, A3(xt, Fh, e, b = n.b)), o);
                return i = m.a, c = m.b, f = A3(Ih, u, A2(Ye, Mh, b), Zt(i)), d(A2(mt, f, t), c);
            default:
                s = n.a, u = n.b, o = n.d;
                var b, p = A3(xt, xh, d(w, A3(xt, Fh, e, b = n.c)), o);
                return i = p.a, c = p.b, f = A4(Dh, s, u, A2(Ye, Mh, b), Zt(i)), d(A2(mt, f, t), c);
        }
    }), Vh = F2(function(n, r) {
        return A5($u, 1, n, r, wu, wu);
    }), Oh = F2(function(n, r) {
        for(;;){
            if (!r.b) return n;
            var t = r.a, e = t.b, u = t.c, o = r.b;
            ze(u) || (n = ht(d(u, e))), r = o;
        }
    }), zh = function(n) {
        var r = A2(Oh, kt, n);
        if (1 === r.$) return Su;
        var t = r.a;
        return A2(Vh, t.a, t.b);
    }, Eh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hh = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Rh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wh = F2(function(n, r) {
        return k([
            Rh(A3(Hh, A3(to, r, w, kt), w, n))
        ]);
    }), Uh = function(n) {
        return A2(Wh, n.b, $o(k([
            Eh(n.a)
        ])));
    }, Qh = function(n) {
        return A3(ca, "style", w, Wo(sa(ia(Wo(fa(A2(Ye, Uh, pt(n))))))));
    }, _h = F3(function(n, r, t) {
        var e = A2(Ye, Mh, r), u = zh(r), o = A3(xt, qh, d(w, u), t), a = o.a, i = Qh(o.b);
        return A3(ca, n, e, A2(mt, i, Zt(a)));
    }), Zh = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (a(n, r.a.a)) return !0;
            r = t;
        }
    }), Kh = F2(function(n, r) {
        n: for(;;){
            if (r.b) {
                var t = r.b, e = "_" + r.a.a;
                if (A2(Zh, e, t)) {
                    n = e, r = t;
                    continue n;
                }
                return e;
            }
            return n;
        }
    }), Xh = F2(function(n, r) {
        return d(A2(Kh, "_", r), Qh(n));
    }), Jh = F3(function(n, r, t) {
        var e = A2(Ye, Mh, r), u = zh(r), o = A3(xt, xh, d(w, u), t), a = o.a;
        return A3(Ih, n, e, A2(mt, A2(Xh, o.b, a), Zt(a)));
    }), Yh = F4(function(n, r, t, e) {
        var u = A2(Ye, Mh, t), o = zh(t), a = A3(xt, xh, d(w, o), e), i = a.a;
        return A4(Dh, n, r, u, A2(mt, A2(Xh, a.b, i), Zt(i)));
    }), Gh = F4(function(n, r, t, e) {
        var u = A2(Ye, Mh, t), o = zh(t), a = A3(xt, qh, d(w, o), e), i = a.a, c = Qh(a.b);
        return A4(Bh, n, r, u, A2(mt, c, Zt(i)));
    }), nk = function(n) {
        switch(n.$){
            case 4:
                return n.a;
            case 0:
                return A3(_h, n.a, n.b, n.c);
            case 1:
                return A4(Gh, n.a, n.b, n.c, n.d);
            case 2:
                return A3(Jh, n.a, n.b, n.c);
            default:
                return A4(Yh, n.a, n.b, n.c, n.d);
        }
    }, rk = F4(function(n, r, t, e) {
        return nk(A3(n, r, t, e));
    }), tk = F4(function(n, r, t, e) {
        return la(A5(jh, rk, n, r, t, e));
    }), ek = tk, uk = Ae("td"), ok = F2(function(n, r) {
        var t = (0, r.dN)(n);
        return A2(uk, t.u, t.jL);
    }), ak = F3(function(n, r, t) {
        return A2(Lh, r(t), A2(Ye, ok(t), n));
    }), ik = F4(function(n, r, t, e) {
        return d(n(e), A4(ek, ak, r, t, e));
    }), ck = F3(function(n, r, t) {
        var e, u, o = n.rZ, a = n.j_, i = n.kv, c = i.dE(A2(Ye, A2(Nh, r, n.r_), a)), f = A2(Th, c.u, k([
            A2(Lh, w, c.jL)
        ])), s = A3(wh, n, r, t), l = A3(hh, "tbody", i.rQ, A2(Ye, A3(ik, o, a, i.pS), s)), d = 1 === (e = i.dD).$ ? A2(mt, l, w) : A2(mt, A2(Ch, e.a.u, e.a.jL), A2(mt, l, w));
        return A2(kh, i.rE, 1 === (u = i.jC).$ ? A2(mt, f, d) : A2(mt, A2(bh, u.a.u, u.a.jL), A2(mt, f, d)));
    }), fk = {
        $: 3
    }, sk = function(n) {
        return A2(ye, k([
            Ow("BannerInvalid")
        ]), k([
            Jw,
            A2(qg, k([
                Ow("BannerContent")
            ]), n)
        ]));
    }, lk = function(n) {
        return A2(ye, k([
            Ow("BannerValid")
        ]), k([
            Yw,
            A2(qg, k([
                Ow("BannerContent")
            ]), n)
        ]));
    }, dk = function(n) {
        var r = n.lo;
        if (r.$) {
            var t = n.rz;
            if (t.$) return ag("");
            var e = t.a;
            return A2(ye, k([
                Cg(fk)
            ]), k([
                lk(e)
            ]));
        }
        var u = r.a;
        return A2(ye, k([
            Cg(fk)
        ]), k([
            sk(u)
        ]));
    }, mk = {
        $: 4
    }, bk = function(n) {
        return {
            $: 17,
            a: n
        };
    }, pk = function(n) {
        return {
            $: 18,
            a: n
        };
    }, vk = function(n) {
        return {
            $: 6,
            a: n
        };
    }, $k = function(n) {
        return {
            $: 5,
            a: n
        };
    }, wk = {
        $: 13
    }, gk = {
        $: 7
    }, hk = ag(""), kk = ju(hk), Ck = function(n) {
        return A2(Pi, Lu(n), kk);
    }, Tk = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Pk = Ig("checked"), Sk = A2(Jg, k([
        "target",
        "checked"
    ]), Pe), Ak = function(n) {
        return A2(Dw, "change", A2(Ne, n, Sk));
    }, yk = function(n) {
        var r;
        return A2(Og, n, A2(Eg, k([
            Ow("InputCheckbox"),
            (r = n.mo, "" === r ? Bg(w) : Kg(r)),
            Tg("checkbox"),
            Ak(Tk),
            Pk(n.sw),
            zg(n.kS)
        ]), w));
    }, Nk = Ae("label"), Lk = Nk, jk = F2(function(n, r) {
        return "" === n.m7 ? r : A2(Lk, k([
            Ow("InputLabel")
        ]), k([
            A2(ye, k([
                Ow("InputLabelText")
            ]), k([
                ag(n.m7),
                n.mS ? ag("") : A2(qg, k([
                    Ow("InputMandatory")
                ]), "*")
            ])),
            r
        ]));
    }), Fk = function(n) {
        return A2(jk, n, yk(n));
    }, Mk = function(n) {
        return A2(jk, n, ah(n));
    }, Ik = Qw("g"), Dk = A2(Zw, k([
        Hw("20px"),
        Xw("20px"),
        Kw("0 0 20 20"),
        Fw("IconChoice")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(_w, k([
                Rw("10 4 7 8 13 8")
            ]), w),
            A2(_w, k([
                Rw("10 16 7 12 13 12")
            ]), w)
        ]))
    ])), Bk = F2(function(n, r) {
        return A2(ju, "", Eo(A2(Ye, Zi, A2(Mu, function(r) {
            return a(r.a, n);
        }, r))));
    }), xk = Ae("option"), qk = Ae("select"), Vk = Ig("selected"), Ok = F2(function(n, r) {
        var t = A2(xk, k([
            oh(""),
            Vk("" === n.sw)
        ]), k([
            ag(n.gw)
        ]));
        return A2(qk, k([
            Ow("InputSelectSelect"),
            eh(Lg),
            uh(n.gw),
            zg(n.kS)
        ]), A2(mt, t, A2(Ye, function(r) {
            var t = r.a, e = r.b;
            return A2(xk, k([
                oh(t),
                Vk(a(t, n.sw))
            ]), k([
                ag(e)
            ]));
        }, r)));
    }), zk = F2(function(n, r) {
        return A2(ye, k([
            Ow("InputWrapper"),
            Bg(k([
                d("InputWrapperDisabled", n.kS),
                d("InputHasError", Tu(n.lp))
            ]))
        ]), k([
            A2(ye, k([
                Ow("InputSelect"),
                Bg(k([
                    d("InputSelectEmpty", "" === n.sw)
                ]))
            ]), k([
                A2(ye, k([
                    Ow("InputSelectChoice")
                ]), k([
                    Dk
                ])),
                A2(qg, k([
                    Ow("InputSelectValue")
                ]), "" === n.sw || Tu(r) ? n.gw : A2(Bk, n.sw, r)),
                A2(Ok, n, r)
            ])),
            Vg(n.lp)
        ]));
    }), Ek = F2(function(n, r) {
        return A2(jk, n, A2(zk, n, r));
    }), Hk = Ae("form"), Rk = function(n) {
        return d(n, !0);
    }, Wk = F2(function(n, r) {
        return A2(Iw, n, {
            $: 2,
            a: r
        });
    }), Uk = function(n) {
        return A2(Wk, "submit", A2(Ne, Rk, je(n)));
    }, Qk = function(n) {
        return A2(Aw, k([
            Tg("submit"),
            Ow("Button")
        ]), k([
            ag(n)
        ]));
    }, _k = F4(function(n, r, t, e) {
        var u = r.a, o = r.b, a = t.a, i = t.b;
        return A2(ye, k([
            Ow("ModalWrapper")
        ]), k([
            A2(ye, k([
                Ow("ModalTitle")
            ]), k([
                ag(n),
                A2(Pg, a, i)
            ])),
            A2(Hk, k([
                Uk(o),
                Ow("ModalForm")
            ]), k([
                A2(ye, k([
                    Ow("ModalContent")
                ]), e),
                A2(ye, k([
                    Ow("ModalSubmit")
                ]), k([
                    A2(Pg, a, i),
                    Qk(u)
                ]))
            ]))
        ]));
    }), Zk = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), Kk = function(n) {
        switch(n){
            case 0:
                return xa({
                    bN: "Arabic",
                    bT: "Arabe"
                });
            case 1:
                return xa({
                    bN: "Bulgarian",
                    bT: "Bulgare"
                });
            case 2:
                return xa({
                    bN: "Chinese",
                    bT: "Chinois"
                });
            case 3:
                return xa({
                    bN: "Czech",
                    bT: "Tch\xe8que"
                });
            case 4:
                return xa({
                    bN: "Korean",
                    bT: "Cor\xe9en"
                });
            case 5:
                return xa({
                    bN: "Danish",
                    bT: "Danois"
                });
            case 6:
                return xa({
                    bN: "Flemish",
                    bT: "Flamand"
                });
            case 9:
                return xa({
                    bN: "Greek",
                    bT: "Grec"
                });
            case 7:
                return xa({
                    bN: "Hebrew",
                    bT: "H\xe9breu"
                });
            case 8:
                return xa({
                    bN: "Hindi",
                    bT: "Hindi"
                });
            case 10:
                return xa({
                    bN: "Dutch",
                    bT: "N\xe9erlandais"
                });
            case 11:
                return xa({
                    bN: "Russian",
                    bT: "Russe"
                });
            case 14:
                return xa({
                    bN: "Swedish",
                    bT: "Su\xe9dois"
                });
            case 12:
                return xa({
                    bN: "Slovenian",
                    bT: "Slov\xe8ne"
                });
            case 13:
                return xa({
                    bN: "Serbian",
                    bT: "Serbe"
                });
            case 15:
                return xa({
                    bN: "Tamil",
                    bT: "Tamoul"
                });
            case 16:
                return xa({
                    bN: "Thai",
                    bT: "Tha\xef"
                });
            case 17:
                return xa({
                    bN: "French",
                    bT: " Fran\xe7ais"
                });
            case 18:
                return xa({
                    bN: "Canadian french",
                    bT: "Fran\xe7ais canadien"
                });
            case 19:
                return xa({
                    bN: "German",
                    bT: "Allemand"
                });
            case 20:
                return xa({
                    bN: "Italian",
                    bT: "Italien"
                });
            case 21:
                return xa({
                    bN: "Portuguese",
                    bT: "Portugais"
                });
            case 22:
                return xa({
                    bN: " English",
                    bT: "Anglais"
                });
            case 23:
                return xa({
                    bN: "Spanish",
                    bT: "Espagnol"
                });
            case 24:
                return xa({
                    bN: "Japanese",
                    bT: "Japonais"
                });
            case 25:
                return xa({
                    bN: "Norwegian",
                    bT: "Norv\xe9gien"
                });
            case 26:
                return xa({
                    bN: "Ukrainian",
                    bT: "Ukrainien"
                });
            case 27:
                return xa({
                    bN: "Finnish",
                    bT: "Finnois"
                });
            case 28:
                return xa({
                    bN: "Castilian Spanish",
                    bT: "Espagnol castillan"
                });
            case 29:
                return xa({
                    bN: "Brazilian portuguese",
                    bT: "Portugais br\xe9silien"
                });
            case 30:
                return xa({
                    bN: "Romanian",
                    bT: "Roumain"
                });
            case 31:
                return xa({
                    bN: "Croatian",
                    bT: "Croate"
                });
            case 32:
                return xa({
                    bN: "Scottish Gaelic",
                    bT: "Ga\xe9lique \xe9cossais"
                });
            case 33:
                return xa({
                    bN: "Hungarian",
                    bT: "Hongrois"
                });
            case 34:
                return xa({
                    bN: "Indonesian",
                    bT: "Indon\xe9sien"
                });
            case 35:
                return xa({
                    bN: "Turkish",
                    bT: "Turc"
                });
            case 36:
                return xa({
                    bN: "Polish",
                    bT: "Polonais"
                });
            case 37:
                return xa({
                    bN: " International",
                    bT: " International"
                });
            default:
                return xa({
                    bN: "",
                    bT: ""
                });
        }
    }, Xk = A2(Ra, Zi, k([
        d(w$(0), Kk(0)),
        d(w$(1), Kk(1)),
        d(w$(2), Kk(2)),
        d(w$(3), Kk(3)),
        d(w$(4), Kk(4)),
        d(w$(5), Kk(5)),
        d(w$(6), Kk(6)),
        d(w$(7), Kk(7)),
        d(w$(8), Kk(8)),
        d(w$(9), Kk(9)),
        d(w$(10), Kk(10)),
        d(w$(11), Kk(11)),
        d(w$(12), Kk(12)),
        d(w$(13), Kk(13)),
        d(w$(14), Kk(14)),
        d(w$(15), Kk(15)),
        d(w$(16), Kk(16)),
        d(w$(17), Kk(17)),
        d(w$(18), Kk(18)),
        d(w$(19), Kk(19)),
        d(w$(20), Kk(20)),
        d(w$(21), Kk(21)),
        d(w$(22), Kk(22)),
        d(w$(23), Kk(23)),
        d(w$(24), Kk(24)),
        d(w$(25), Kk(25)),
        d(w$(26), Kk(26)),
        d(w$(27), Kk(27)),
        d(w$(28), Kk(28)),
        d(w$(29), Kk(29)),
        d(w$(30), Kk(30)),
        d(w$(31), Kk(31)),
        d(w$(32), Kk(32)),
        d(w$(33), Kk(33)),
        d(w$(34), Kk(34)),
        d(w$(35), Kk(35)),
        d(w$(36), Kk(36)),
        d(w$(38), Kk(38))
    ])), Jk = F3(function(n, r, t) {
        return A2(Aw, $(k([
            Tg("button"),
            Cg(t),
            Ow("ButtonMini")
        ]), A2(Ye, function(n) {
            return A2(pg, n.a, n.b);
        }, r)), k([
            ag(n)
        ]));
    }), Yk = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Gk = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nC = function(n) {
        return {
            $: 2,
            a: n
        };
    }, rC = F4(function(n, r, t, e) {
        return A2(ye, k([
            Ow("Select2Container")
        ]), k([
            A2(mh, Yk, A2(Ek, n.ql, r)),
            A2(mh, Gk, A2(Ek, n.qm, t)),
            A2(Y$, n.qm.sw, k([
                "Original",
                "Dubbed",
                "AudioDescription"
            ])) ? A2(mh, nC, A2(Ek, n.qn, e)) : ag("")
        ]));
    }), tC = function(n) {
        return A2(Ck, function(r) {
            var t = A2(mt, d("", ""), A2(Ra, A2(bu, Ua, Zi), A2(Ye, function(n) {
                return d(n.a, n.b.n6);
            }, pt(n.oQ)))), e = function(n) {
                return 1 !== n.oS.$;
            }(r) ? d("Save", "Edit AudioMapping") : d("Create", "New AudioMapping");
            return A4(_k, e.b, d(e.a, gk), d("Close", mk), $(k([
                dk(n),
                A2(mh, $k, A2(Ek, r.oM, t)),
                A2(mh, bk, Fk(r.mO)),
                A2(mh, pk, Fk(r.mQ)),
                A2(mh, vk, Mk(r.n6))
            ]), $(function(n) {
                var r = Xk, t = k([
                    d(p$(0), p$(0)),
                    d(p$(1), p$(1)),
                    d(p$(2), p$(2)),
                    d(p$(3), p$(3)),
                    d(p$(4), p$(4)),
                    d(p$(6), p$(6)),
                    d(p$(5), p$(5)),
                    d(p$(7), p$(7)),
                    d(p$(8), p$(8)),
                    d(p$(9), p$(9)),
                    d(p$(10), p$(10)),
                    d(p$(11), p$(11)),
                    d(p$(12), p$(12)),
                    d(p$(13), p$(13)),
                    d(p$(14), p$(14)),
                    d(p$(15), p$(15)),
                    d(p$(16), p$(16)),
                    d("", "")
                ]), e = k([
                    d(d$(0), d$(0)),
                    d(d$(1), d$(1)),
                    d(d$(2), d$(2)),
                    d(d$(3), d$(3)),
                    d(d$(4), d$(4)),
                    d(d$(5), d$(5))
                ]);
                return A2(Ye, Zi, pt(A2(Gi, F2(function(n, u) {
                    var o;
                    return A2(ye, k([
                        A2(pg, "position", "relative"),
                        A2(pg, "margin", "25px 0")
                    ]), k([
                        A2(mh, function(r) {
                            return A2(Zk, r, n);
                        }, A4(rC, u, e, t, r)),
                        A3(Jk, "remove", k([
                            d("position", "absolute"),
                            d("right", "0")
                        ]), (o = n, {
                            $: 14,
                            a: o
                        }))
                    ]));
                }), n.r4)));
            }(r), k([
                A2(Pg, "Add New Track", wk)
            ]))));
        }, n.kP);
    }, eC = F7(function(n, r, t, e, u, o, a) {
        return {
            mo: n,
            mO: o,
            mQ: a,
            n6: e,
            oM: r,
            gm: t,
            r4: u
        };
    }), uC = F2(function(n, r) {
        return A7(eC, r.mo, r.oM, n, r.n6, r.r4, r.mO, r.mQ);
    }), oC = Ae("a"), aC = Lw("d"), iC = Qw("path"), cC = A2(Zw, k([
        Hw("20px"),
        Xw("20px"),
        Kw("29 30 20 20"),
        Fw("IconBack")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(iC, k([
                aC("M29.8248086,42.1420204 L40.1751914,49.0422759 C40.6277051,49.3439517 41,49.1402383 41,48.5827792 L41,46.6015165 C41,46.0355006 40.6434763,45.3247546 40.2036819,44.9949089 L35.6666667,41.592148 L48.0081969,41.592148 C48.5446944,41.592148 49,41.1402382 49,40.5827791 L49,38.6015169 C49,38.0355012 48.5559546,37.592148 48.0081969,37.592148 L35.6666669,37.592148 L40.2036819,34.1893866 C40.6354685,33.8655467 41,33.1402382 41,32.5827791 L41,30.6015169 C41,30.0355012 40.6307206,29.8383343 40.1751914,30.1420204 L29.8248086,37.0422756 C29.3725854,37.3437578 29.000478,39.0431593 29.0000005,39.6004433 C29,40.1487948 29.3692794,41.8383343 29.8248086,42.1420204 Z")
            ]), w)
        ]))
    ])), fC = function(n) {
        return A2(Vw, "href", n);
    }, sC = function(n) {
        return ye(A2(mt, A2(pg, "display", "flex"), A2(mt, A2(pg, "flex-direction", "row"), n)));
    }, lC = A2(Zw, k([
        Hw("27px"),
        Xw("27px"),
        Kw("0 0 27 27"),
        Fw("IconSettings")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(iC, k([
                aC("M13.5,18.1264335 L11.8004065,19 L10.913745,17.2428633 L9.05040653,16.8991869 L9.31535158,14.9296466 L8,13.5 L9.31535158,12.0703534 L9.05040653,10.1008131 L10.913745,9.75713667 L11.8004065,8 L13.5,8.87356649 L15.1995935,8 L16.086255,9.75713667 L17.9495935,10.1008131 L17.6846484,12.0703534 L19,13.5 L17.6846484,14.9296466 L17.9495935,16.8991869 L16.086255,17.2428633 L15.1995935,19 L13.5,18.1264335 Z M13.5,16 C14.8807119,16 16,14.8807119 16,13.5 C16,12.1192881 14.8807119,11 13.5,11 C12.1192881,11 11,12.1192881 11,13.5 C11,14.8807119 12.1192881,16 13.5,16 Z")
            ]), w)
        ]))
    ])), dC = Ae("h3"), mC = F2(function(n, r) {
        return A2(n, w, k([
            ag(r)
        ]));
    }), bC = mC(dC), pC = Ae("h1"), vC = mC(pC), $C = function(n) {
        return A2(ye, k([
            Ow("LayoutAppBarWrapper")
        ]), k([
            A2(Ck, function(n) {
                return A2(oC, k([
                    Ow("LayoutHomeButton"),
                    fC(n)
                ]), k([
                    cC
                ]));
            }, n.fq),
            A2(Ck, function(n) {
                return A2(oC, k([
                    Ow("LayoutBackButton"),
                    fC(n)
                ]), k([
                    cC
                ]));
            }, n.d9),
            A2(ye, k([
                Ow("LayoutAppBar")
            ]), k([
                A2(ye, k([
                    Ow("LayoutAppBarTitle")
                ]), k([
                    bC(A2(ju, "\xa0", n.mo)),
                    A2(sC, w, k([
                        vC(n.rW)
                    ])),
                    bC("\xa0")
                ])),
                A2(ye, k([
                    Ow("LayoutAppBarActions")
                ]), k([
                    A2(ju, ag(""), n.dV)
                ]))
            ])),
            A2(Ck, function(n) {
                return A2(oC, k([
                    Ow("LayoutFwdButton"),
                    fC(n)
                ]), k([
                    lC
                ]));
            }, n.fc)
        ]));
    }, wC = {
        dV: kt,
        d9: kt,
        fc: kt,
        fq: kt,
        mo: kt,
        rW: ""
    }, gC = F3(function(n, r, t) {
        return A2(ye, k([
            Ow("LayoutPageWrapper")
        ]), k([
            $C(p(wC, {
                dV: r,
                rW: n
            })),
            A2(ye, k([
                Ow("LayoutPageContent")
            ]), k([
                A2(oC, k([
                    fC("#"),
                    Kg("LayoutPageTop")
                ]), k([
                    ag(" ")
                ])),
                t
            ]))
        ]));
    }), hC = F2(function(n, r) {
        var t = Ua(r.px.sw), e = A2(Mu, function(n) {
            return A2(bu, A2(bu, Be(t), Ua), function(n) {
                return n.gm;
            })(n) || A2(bu, A2(bu, Be(t), Ua), function(n) {
                return n.n6;
            })(n) || A2(bu, A2(bu, A2(bu, A2(bu, Be(t), Ua), It("/")), Ye(yg)), function(n) {
                return n.r4;
            })(n);
        }, A2(Ye, function(n) {
            return A2(uC, A2(Tw, r.oQ, n), n);
        }, r.cq));
        return A3(gC, "Audio Mappings", ht(A2(Pg, "New\u2026", kw)), A2(ye, w, k([
            A2(mh, Cw, ah(r.px)),
            dk(r),
            tC(r),
            A3(ck, Ng, r.rN, e)
        ])));
    }), kC = {
        l: function(n) {
            return n.cq;
        },
        m: q$,
        o: F2(function(n, r) {
            return p(n, {
                cq: r
            });
        }),
        p: function(n) {
            return {
                $: 7,
                a: n
            };
        },
        q: hw,
        r: hC
    }, CC = {
        cz: w,
        kP: kt,
        lo: kt,
        oQ: Su,
        rz: kt
    }, TC = function(n) {
        return {
            $: 0,
            a: n
        };
    }, PC = F3(function(n, r, t) {
        return {
            mo: n,
            oM: r,
            sw: t
        };
    }), SC = Fi(A4(rc, "value", function(n) {
        return n.sw;
    }, Oa, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(PC))))), AC = ic(SC), yC = function(n) {
        return {
            $: 7,
            a: n
        };
    }, NC = dl(yC({
        $: 0
    })), LC = mc(A2(Wi, AC, Ai(NC))), jC = A2(Yb, Ji, A2(Yb, Ye(function(n) {
        return d(n.mo, n);
    }), mc(A2(Wi, M$, Ai(D$))))), FC = A2(Xa, TC, Gb(d(LC, jC))), MC = d(CC, FC), IC = function(n) {
        return {
            n6: za(function(r) {
                return p(r, {
                    m7: "Name",
                    sw: A2(ju, "", A2(Lu, function(n) {
                        return n.sw;
                    }, n))
                });
            }),
            oM: za(function(r) {
                return p(r, {
                    m7: "Organization",
                    sw: A2(ju, "", A2(Lu, function(n) {
                        return n.oM;
                    }, n))
                });
            }),
            oS: n
        };
    }, DC = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), BC = function(n) {
        return {
            $: 7,
            a: n
        };
    }, xC = F2(function(n, r) {
        return {
            oM: n,
            sw: r
        };
    }), qC = Fi(A4(rc, "value", function(n) {
        return n.sw;
    }, Oa, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, Mi(xC)))), VC = function(n) {
        var r;
        return A2(Xa, BC, mc(A2(nw, SC, A3(ow, qC, {
            oM: (r = n).oM.sw,
            sw: r.n6.sw
        }, rw(NC)))));
    }, OC = function(n) {
        return {
            $: 10,
            a: n
        };
    }, zC = function(n) {
        return dl(yC({
            $: 1,
            a: n
        }));
    }, EC = function(n) {
        return {
            $: 8,
            a: n
        };
    }, HC = F2(function(n, r) {
        return mc(A2(Wi, SC, A3(ow, qC, {
            oM: r.oM.sw,
            sw: r.n6.sw
        }, dw(zC(n.mo)))));
    }), RC = F2(function(n, r) {
        return A2(Xa, EC, A2(HC, n, r));
    }), WC = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, w, p(r, {
                    kP: ht(IC(ht(n.a)))
                }));
            case 1:
                return A2(pc, w, p(r, {
                    kP: ht(IC(kt))
                }));
            case 3:
                return A2(pc, w, p(r, {
                    kP: kt,
                    lo: kt,
                    rz: kt
                }));
            case 4:
                var t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        oM: A2(ww, t, n.oM)
                    });
                }, r.kP);
                return A2(pc, w, p(r, {
                    kP: e
                }));
            case 5:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        n6: A2(ww, t, n.n6)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 6:
                var u = r.kP;
                return A2(pc, k(1 === u.$ ? [
                    n$
                ] : 1 === (c = (e = u.a).oS).$ ? [
                    VC(e)
                ] : [
                    A2(RC, c.a, e)
                ]), r);
            case 9:
                return A2(pc, k([
                    (i = n.a, A2(Xa, OC, function(n) {
                        return A2(Yb, Dl(n), mc(sw(fw(zC(n.mo)))));
                    }(i)))
                ]), r);
            case 7:
                return (o = n.a).$ ? A2(pc, w, A2(DC, o.a, r)) : A2(pc, k([
                    FC
                ]), p(r, {
                    lo: kt,
                    rz: ht("Channel created")
                }));
            case 8:
                return (o = n.a).$ ? A2(pc, w, A2(DC, o.a, r)) : A2(pc, k([
                    FC
                ]), p(r, {
                    lo: kt,
                    rz: ht("Channel updated")
                }));
            case 10:
                return (o = n.a).$ ? A2(pc, w, A2(DC, o.a, r)) : A2(pc, k([
                    FC
                ]), r);
            default:
                var o;
                if ((o = n.a).$) return A2(pc, w, A2(DC, o.a, r));
                var a = o.a;
                return A2(pc, w, p(r, {
                    cz: a.a,
                    oQ: a.b
                }));
        }
        var i, c;
    }), UC = {
        $: 1
    }, QC = function(n) {
        return {
            $: 9,
            a: n
        };
    }, _C = F2(function(n, r) {
        return A2(ju, "", A2(Lu, function(n) {
            return n.n6;
        }, A2(di, r.oM, n)));
    }), ZC = k([
        ag("Edit"),
        ag("Organization"),
        ag("Name"),
        ag("Delete")
    ]), KC = F3(function(n, r, t) {
        return A2(uk, k([
            Ow("TableTd"),
            Bg(k([
                d("TableRight", a(n - 1, r))
            ]))
        ]), k([
            t
        ]));
    }), XC = F3(function(n, r, t) {
        return A2(uk, k([
            Ow("TableHeader")
        ]), k([
            t
        ]));
    }), JC = F2(function(n, r) {
        return A2(Lh, k([
            Ow("TableTr")
        ]), A2(Ht, n(qt(r)), r));
    }), YC = F2(function(n, r) {
        return A2(kh, k([
            Ow("Table")
        ]), A2(mt, A2(JC, XC, n), A2(Ye, JC(KC), r)));
    }), GC = {
        $: 3
    }, nT = function(n) {
        return {
            $: 5,
            a: n
        };
    }, rT = function(n) {
        return {
            $: 4,
            a: n
        };
    }, tT = {
        $: 6
    }, eT = fr, uT = F2(function(n, r) {
        return nk(n(r));
    }), oT = F2(function(n, r) {
        return la(A3(eT, uT, n, r));
    }), aT = oT, iT = k([
        d("A", "A"),
        d("\u24B6", "A"),
        d("\uFF21", "A"),
        d("\xc0", "A"),
        d("\xc1", "A"),
        d("\xc2", "A"),
        d("\u1EA6", "A"),
        d("\u1EA4", "A"),
        d("\u1EAA", "A"),
        d("\u1EA8", "A"),
        d("\xc3", "A"),
        d("\u0100", "A"),
        d("\u0102", "A"),
        d("\u1EB0", "A"),
        d("\u1EAE", "A"),
        d("\u1EB4", "A"),
        d("\u1EB2", "A"),
        d("\u0226", "A"),
        d("\u01E0", "A"),
        d("\xc4", "A"),
        d("\u01DE", "A"),
        d("\u1EA2", "A"),
        d("\xc5", "A"),
        d("\u01FA", "A"),
        d("\u01CD", "A"),
        d("\u0200", "A"),
        d("\u0202", "A"),
        d("\u1EA0", "A"),
        d("\u1EAC", "A"),
        d("\u1EB6", "A"),
        d("\u1E00", "A"),
        d("\u0104", "A"),
        d("\u023A", "A"),
        d("\u2C6F", "A"),
        d("\uA732", "AA"),
        d("\xc6", "AE"),
        d("\u01FC", "AE"),
        d("\u01E2", "AE"),
        d("\uA734", "AO"),
        d("\uA736", "AU"),
        d("\uA738", "AV"),
        d("\uA73A", "AV"),
        d("\uA73C", "AY"),
        d("B", "B"),
        d("\u24B7", "B"),
        d("\uFF22", "B"),
        d("\u1E02", "B"),
        d("\u1E04", "B"),
        d("\u1E06", "B"),
        d("\u0243", "B"),
        d("\u0182", "B"),
        d("\u0181", "B"),
        d("C", "C"),
        d("\u24B8", "C"),
        d("\uFF23", "C"),
        d("\u0106", "C"),
        d("\u0108", "C"),
        d("\u010A", "C"),
        d("\u010C", "C"),
        d("\xc7", "C"),
        d("\u1E08", "C"),
        d("\u0187", "C"),
        d("\u023B", "C"),
        d("\uA73E", "C"),
        d("D", "D"),
        d("\u24B9", "D"),
        d("\uFF24", "D"),
        d("\u1E0A", "D"),
        d("\u010E", "D"),
        d("\u1E0C", "D"),
        d("\u1E10", "D"),
        d("\u1E12", "D"),
        d("\u1E0E", "D"),
        d("\u0110", "D"),
        d("\u018B", "D"),
        d("\u018A", "D"),
        d("\u0189", "D"),
        d("\uA779", "D"),
        d("\u01F1", "DZ"),
        d("\u01C4", "DZ"),
        d("\u01F2", "Dz"),
        d("\u01C5", "Dz"),
        d("E", "E"),
        d("\u24BA", "E"),
        d("\uFF25", "E"),
        d("\xc8", "E"),
        d("\xc9", "E"),
        d("\xca", "E"),
        d("\u1EC0", "E"),
        d("\u1EBE", "E"),
        d("\u1EC4", "E"),
        d("\u1EC2", "E"),
        d("\u1EBC", "E"),
        d("\u0112", "E"),
        d("\u1E14", "E"),
        d("\u1E16", "E"),
        d("\u0114", "E"),
        d("\u0116", "E"),
        d("\xcb", "E"),
        d("\u1EBA", "E"),
        d("\u011A", "E"),
        d("\u0204", "E"),
        d("\u0206", "E"),
        d("\u1EB8", "E"),
        d("\u1EC6", "E"),
        d("\u0228", "E"),
        d("\u1E1C", "E"),
        d("\u0118", "E"),
        d("\u1E18", "E"),
        d("\u1E1A", "E"),
        d("\u0190", "E"),
        d("\u018E", "E"),
        d("F", "F"),
        d("\u24BB", "F"),
        d("\uFF26", "F"),
        d("\u1E1E", "F"),
        d("\u0191", "F"),
        d("\uA77B", "F"),
        d("G", "G"),
        d("\u24BC", "G"),
        d("\uFF27", "G"),
        d("\u01F4", "G"),
        d("\u011C", "G"),
        d("\u1E20", "G"),
        d("\u011E", "G"),
        d("\u0120", "G"),
        d("\u01E6", "G"),
        d("\u0122", "G"),
        d("\u01E4", "G"),
        d("\u0193", "G"),
        d("\uA7A0", "G"),
        d("\uA77D", "G"),
        d("\uA77E", "G"),
        d("H", "H"),
        d("\u24BD", "H"),
        d("\uFF28", "H"),
        d("\u0124", "H"),
        d("\u1E22", "H"),
        d("\u1E26", "H"),
        d("\u021E", "H"),
        d("\u1E24", "H"),
        d("\u1E28", "H"),
        d("\u1E2A", "H"),
        d("\u0126", "H"),
        d("\u2C67", "H"),
        d("\u2C75", "H"),
        d("\uA78D", "H"),
        d("I", "I"),
        d("\u24BE", "I"),
        d("\uFF29", "I"),
        d("\xcc", "I"),
        d("\xcd", "I"),
        d("\xce", "I"),
        d("\u0128", "I"),
        d("\u012A", "I"),
        d("\u012C", "I"),
        d("\u0130", "I"),
        d("\xcf", "I"),
        d("\u1E2E", "I"),
        d("\u1EC8", "I"),
        d("\u01CF", "I"),
        d("\u0208", "I"),
        d("\u020A", "I"),
        d("\u1ECA", "I"),
        d("\u012E", "I"),
        d("\u1E2C", "I"),
        d("\u0197", "I"),
        d("J", "J"),
        d("\u24BF", "J"),
        d("\uFF2A", "J"),
        d("\u0134", "J"),
        d("\u0248", "J"),
        d("K", "K"),
        d("\u24C0", "K"),
        d("\uFF2B", "K"),
        d("\u1E30", "K"),
        d("\u01E8", "K"),
        d("\u1E32", "K"),
        d("\u0136", "K"),
        d("\u1E34", "K"),
        d("\u0198", "K"),
        d("\u2C69", "K"),
        d("\uA740", "K"),
        d("\uA742", "K"),
        d("\uA744", "K"),
        d("\uA7A2", "K"),
        d("L", "L"),
        d("\u24C1", "L"),
        d("\uFF2C", "L"),
        d("\u013F", "L"),
        d("\u0139", "L"),
        d("\u013D", "L"),
        d("\u1E36", "L"),
        d("\u1E38", "L"),
        d("\u013B", "L"),
        d("\u1E3C", "L"),
        d("\u1E3A", "L"),
        d("\u0141", "L"),
        d("\u023D", "L"),
        d("\u2C62", "L"),
        d("\u2C60", "L"),
        d("\uA748", "L"),
        d("\uA746", "L"),
        d("\uA780", "L"),
        d("\u01C7", "LJ"),
        d("\u01C8", "Lj"),
        d("M", "M"),
        d("\u24C2", "M"),
        d("\uFF2D", "M"),
        d("\u1E3E", "M"),
        d("\u1E40", "M"),
        d("\u1E42", "M"),
        d("\u2C6E", "M"),
        d("\u019C", "M"),
        d("N", "N"),
        d("\u24C3", "N"),
        d("\uFF2E", "N"),
        d("\u01F8", "N"),
        d("\u0143", "N"),
        d("\xd1", "N"),
        d("\u1E44", "N"),
        d("\u0147", "N"),
        d("\u1E46", "N"),
        d("\u0145", "N"),
        d("\u1E4A", "N"),
        d("\u1E48", "N"),
        d("\u0220", "N"),
        d("\u019D", "N"),
        d("\uA790", "N"),
        d("\uA7A4", "N"),
        d("\u01CA", "NJ"),
        d("\u01CB", "Nj"),
        d("O", "O"),
        d("\u24C4", "O"),
        d("\uFF2F", "O"),
        d("\xd2", "O"),
        d("\xd3", "O"),
        d("\xd4", "O"),
        d("\u1ED2", "O"),
        d("\u1ED0", "O"),
        d("\u1ED6", "O"),
        d("\u1ED4", "O"),
        d("\xd5", "O"),
        d("\u1E4C", "O"),
        d("\u022C", "O"),
        d("\u1E4E", "O"),
        d("\u014C", "O"),
        d("\u1E50", "O"),
        d("\u1E52", "O"),
        d("\u014E", "O"),
        d("\u022E", "O"),
        d("\u0230", "O"),
        d("\xd6", "O"),
        d("\u022A", "O"),
        d("\u1ECE", "O"),
        d("\u0150", "O"),
        d("\u01D1", "O"),
        d("\u020C", "O"),
        d("\u020E", "O"),
        d("\u01A0", "O"),
        d("\u1EDC", "O"),
        d("\u1EDA", "O"),
        d("\u1EE0", "O"),
        d("\u1EDE", "O"),
        d("\u1EE2", "O"),
        d("\u1ECC", "O"),
        d("\u1ED8", "O"),
        d("\u01EA", "O"),
        d("\u01EC", "O"),
        d("\xd8", "O"),
        d("\u01FE", "O"),
        d("\u0186", "O"),
        d("\u019F", "O"),
        d("\uA74A", "O"),
        d("\uA74C", "O"),
        d("\u01A2", "OI"),
        d("\uA74E", "OO"),
        d("\u0222", "OU"),
        d("\x8c", "OE"),
        d("\u0152", "OE"),
        d("\x9c", "oe"),
        d("\u0153", "oe"),
        d("P", "P"),
        d("\u24C5", "P"),
        d("\uFF30", "P"),
        d("\u1E54", "P"),
        d("\u1E56", "P"),
        d("\u01A4", "P"),
        d("\u2C63", "P"),
        d("\uA750", "P"),
        d("\uA752", "P"),
        d("\uA754", "P"),
        d("Q", "Q"),
        d("\u24C6", "Q"),
        d("\uFF31", "Q"),
        d("\uA756", "Q"),
        d("\uA758", "Q"),
        d("\u024A", "Q"),
        d("R", "R"),
        d("\u24C7", "R"),
        d("\uFF32", "R"),
        d("\u0154", "R"),
        d("\u1E58", "R"),
        d("\u0158", "R"),
        d("\u0210", "R"),
        d("\u0212", "R"),
        d("\u1E5A", "R"),
        d("\u1E5C", "R"),
        d("\u0156", "R"),
        d("\u1E5E", "R"),
        d("\u024C", "R"),
        d("\u2C64", "R"),
        d("\uA75A", "R"),
        d("\uA7A6", "R"),
        d("\uA782", "R"),
        d("S", "S"),
        d("\u24C8", "S"),
        d("\uFF33", "S"),
        d("\u1E9E", "S"),
        d("\u015A", "S"),
        d("\u1E64", "S"),
        d("\u015C", "S"),
        d("\u1E60", "S"),
        d("\u0160", "S"),
        d("\u1E66", "S"),
        d("\u1E62", "S"),
        d("\u1E68", "S"),
        d("\u0218", "S"),
        d("\u015E", "S"),
        d("\u2C7E", "S"),
        d("\uA7A8", "S"),
        d("\uA784", "S"),
        d("T", "T"),
        d("\u24C9", "T"),
        d("\uFF34", "T"),
        d("\u1E6A", "T"),
        d("\u0164", "T"),
        d("\u1E6C", "T"),
        d("\u021A", "T"),
        d("\u0162", "T"),
        d("\u1E70", "T"),
        d("\u1E6E", "T"),
        d("\u0166", "T"),
        d("\u01AC", "T"),
        d("\u01AE", "T"),
        d("\u023E", "T"),
        d("\uA786", "T"),
        d("\uA728", "TZ"),
        d("U", "U"),
        d("\u24CA", "U"),
        d("\uFF35", "U"),
        d("\xd9", "U"),
        d("\xda", "U"),
        d("\xdb", "U"),
        d("\u0168", "U"),
        d("\u1E78", "U"),
        d("\u016A", "U"),
        d("\u1E7A", "U"),
        d("\u016C", "U"),
        d("\xdc", "U"),
        d("\u01DB", "U"),
        d("\u01D7", "U"),
        d("\u01D5", "U"),
        d("\u01D9", "U"),
        d("\u1EE6", "U"),
        d("\u016E", "U"),
        d("\u0170", "U"),
        d("\u01D3", "U"),
        d("\u0214", "U"),
        d("\u0216", "U"),
        d("\u01AF", "U"),
        d("\u1EEA", "U"),
        d("\u1EE8", "U"),
        d("\u1EEE", "U"),
        d("\u1EEC", "U"),
        d("\u1EF0", "U"),
        d("\u1EE4", "U"),
        d("\u1E72", "U"),
        d("\u0172", "U"),
        d("\u1E76", "U"),
        d("\u1E74", "U"),
        d("\u0244", "U"),
        d("V", "V"),
        d("\u24CB", "V"),
        d("\uFF36", "V"),
        d("\u1E7C", "V"),
        d("\u1E7E", "V"),
        d("\u01B2", "V"),
        d("\uA75E", "V"),
        d("\u0245", "V"),
        d("\uA760", "VY"),
        d("W", "W"),
        d("\u24CC", "W"),
        d("\uFF37", "W"),
        d("\u1E80", "W"),
        d("\u1E82", "W"),
        d("\u0174", "W"),
        d("\u1E86", "W"),
        d("\u1E84", "W"),
        d("\u1E88", "W"),
        d("\u2C72", "W"),
        d("X", "X"),
        d("\u24CD", "X"),
        d("\uFF38", "X"),
        d("\u1E8A", "X"),
        d("\u1E8C", "X"),
        d("Y", "Y"),
        d("\u24CE", "Y"),
        d("\uFF39", "Y"),
        d("\u1EF2", "Y"),
        d("\xdd", "Y"),
        d("\u0176", "Y"),
        d("\u1EF8", "Y"),
        d("\u0232", "Y"),
        d("\u1E8E", "Y"),
        d("\u0178", "Y"),
        d("\u1EF6", "Y"),
        d("\u1EF4", "Y"),
        d("\u01B3", "Y"),
        d("\u024E", "Y"),
        d("\u1EFE", "Y"),
        d("Z", "Z"),
        d("\u24CF", "Z"),
        d("\uFF3A", "Z"),
        d("\u0179", "Z"),
        d("\u1E90", "Z"),
        d("\u017B", "Z"),
        d("\u017D", "Z"),
        d("\u1E92", "Z"),
        d("\u1E94", "Z"),
        d("\u01B5", "Z"),
        d("\u0224", "Z"),
        d("\u2C7F", "Z"),
        d("\u2C6B", "Z"),
        d("\uA762", "Z"),
        d("a", "a"),
        d("\u24D0", "a"),
        d("\uFF41", "a"),
        d("\u1E9A", "a"),
        d("\xe0", "a"),
        d("\xe1", "a"),
        d("\xe2", "a"),
        d("\u1EA7", "a"),
        d("\u1EA5", "a"),
        d("\u1EAB", "a"),
        d("\u1EA9", "a"),
        d("\xe3", "a"),
        d("\u0101", "a"),
        d("\u0103", "a"),
        d("\u1EB1", "a"),
        d("\u1EAF", "a"),
        d("\u1EB5", "a"),
        d("\u1EB3", "a"),
        d("\u0227", "a"),
        d("\u01E1", "a"),
        d("\xe4", "a"),
        d("\u01DF", "a"),
        d("\u1EA3", "a"),
        d("\xe5", "a"),
        d("\u01FB", "a"),
        d("\u01CE", "a"),
        d("\u0201", "a"),
        d("\u0203", "a"),
        d("\u1EA1", "a"),
        d("\u1EAD", "a"),
        d("\u1EB7", "a"),
        d("\u1E01", "a"),
        d("\u0105", "a"),
        d("\u2C65", "a"),
        d("\u0250", "a"),
        d("\uA733", "aa"),
        d("\xe6", "ae"),
        d("\u01FD", "ae"),
        d("\u01E3", "ae"),
        d("\uA735", "ao"),
        d("\uA737", "au"),
        d("\uA739", "av"),
        d("\uA73B", "av"),
        d("\uA73D", "ay"),
        d("b", "b"),
        d("\u24D1", "b"),
        d("\uFF42", "b"),
        d("\u1E03", "b"),
        d("\u1E05", "b"),
        d("\u1E07", "b"),
        d("\u0180", "b"),
        d("\u0183", "b"),
        d("\u0253", "b"),
        d("c", "c"),
        d("\u24D2", "c"),
        d("\uFF43", "c"),
        d("\u0107", "c"),
        d("\u0109", "c"),
        d("\u010B", "c"),
        d("\u010D", "c"),
        d("\xe7", "c"),
        d("\u1E09", "c"),
        d("\u0188", "c"),
        d("\u023C", "c"),
        d("\uA73F", "c"),
        d("\u2184", "c"),
        d("d", "d"),
        d("\u24D3", "d"),
        d("\uFF44", "d"),
        d("\u1E0B", "d"),
        d("\u010F", "d"),
        d("\u1E0D", "d"),
        d("\u1E11", "d"),
        d("\u1E13", "d"),
        d("\u1E0F", "d"),
        d("\u0111", "d"),
        d("\u018C", "d"),
        d("\u0256", "d"),
        d("\u0257", "d"),
        d("\uA77A", "d"),
        d("\u01F3", "dz"),
        d("\u01C6", "dz"),
        d("e", "e"),
        d("\u24D4", "e"),
        d("\uFF45", "e"),
        d("\xe8", "e"),
        d("\xe9", "e"),
        d("\xea", "e"),
        d("\u1EC1", "e"),
        d("\u1EBF", "e"),
        d("\u1EC5", "e"),
        d("\u1EC3", "e"),
        d("\u1EBD", "e"),
        d("\u0113", "e"),
        d("\u1E15", "e"),
        d("\u1E17", "e"),
        d("\u0115", "e"),
        d("\u0117", "e"),
        d("\xeb", "e"),
        d("\u1EBB", "e"),
        d("\u011B", "e"),
        d("\u0205", "e"),
        d("\u0207", "e"),
        d("\u1EB9", "e"),
        d("\u1EC7", "e"),
        d("\u0229", "e"),
        d("\u1E1D", "e"),
        d("\u0119", "e"),
        d("\u1E19", "e"),
        d("\u1E1B", "e"),
        d("\u0247", "e"),
        d("\u025B", "e"),
        d("\u01DD", "e"),
        d("f", "f"),
        d("\u24D5", "f"),
        d("\uFF46", "f"),
        d("\u1E1F", "f"),
        d("\u0192", "f"),
        d("\uA77C", "f"),
        d("g", "g"),
        d("\u24D6", "g"),
        d("\uFF47", "g"),
        d("\u01F5", "g"),
        d("\u011D", "g"),
        d("\u1E21", "g"),
        d("\u011F", "g"),
        d("\u0121", "g"),
        d("\u01E7", "g"),
        d("\u0123", "g"),
        d("\u01E5", "g"),
        d("\u0260", "g"),
        d("\uA7A1", "g"),
        d("\u1D79", "g"),
        d("\uA77F", "g"),
        d("h", "h"),
        d("\u24D7", "h"),
        d("\uFF48", "h"),
        d("\u0125", "h"),
        d("\u1E23", "h"),
        d("\u1E27", "h"),
        d("\u021F", "h"),
        d("\u1E25", "h"),
        d("\u1E29", "h"),
        d("\u1E2B", "h"),
        d("\u1E96", "h"),
        d("\u0127", "h"),
        d("\u2C68", "h"),
        d("\u2C76", "h"),
        d("\u0265", "h"),
        d("\u0195", "hv"),
        d("i", "i"),
        d("\u24D8", "i"),
        d("\uFF49", "i"),
        d("\xec", "i"),
        d("\xed", "i"),
        d("\xee", "i"),
        d("\u0129", "i"),
        d("\u012B", "i"),
        d("\u012D", "i"),
        d("\xef", "i"),
        d("\u1E2F", "i"),
        d("\u1EC9", "i"),
        d("\u01D0", "i"),
        d("\u0209", "i"),
        d("\u020B", "i"),
        d("\u1ECB", "i"),
        d("\u012F", "i"),
        d("\u1E2D", "i"),
        d("\u0268", "i"),
        d("\u0131", "i"),
        d("j", "j"),
        d("\u24D9", "j"),
        d("\uFF4A", "j"),
        d("\u0135", "j"),
        d("\u01F0", "j"),
        d("\u0249", "j"),
        d("k", "k"),
        d("\u24DA", "k"),
        d("\uFF4B", "k"),
        d("\u1E31", "k"),
        d("\u01E9", "k"),
        d("\u1E33", "k"),
        d("\u0137", "k"),
        d("\u1E35", "k"),
        d("\u0199", "k"),
        d("\u2C6A", "k"),
        d("\uA741", "k"),
        d("\uA743", "k"),
        d("\uA745", "k"),
        d("\uA7A3", "k"),
        d("l", "l"),
        d("\u24DB", "l"),
        d("\uFF4C", "l"),
        d("\u0140", "l"),
        d("\u013A", "l"),
        d("\u013E", "l"),
        d("\u1E37", "l"),
        d("\u1E39", "l"),
        d("\u013C", "l"),
        d("\u1E3D", "l"),
        d("\u1E3B", "l"),
        d("\u017F", "l"),
        d("\u0142", "l"),
        d("\u019A", "l"),
        d("\u026B", "l"),
        d("\u2C61", "l"),
        d("\uA749", "l"),
        d("\uA781", "l"),
        d("\uA747", "l"),
        d("\u01C9", "lj"),
        d("m", "m"),
        d("\u24DC", "m"),
        d("\uFF4D", "m"),
        d("\u1E3F", "m"),
        d("\u1E41", "m"),
        d("\u1E43", "m"),
        d("\u0271", "m"),
        d("\u026F", "m"),
        d("n", "n"),
        d("\u24DD", "n"),
        d("\uFF4E", "n"),
        d("\u01F9", "n"),
        d("\u0144", "n"),
        d("\xf1", "n"),
        d("\u1E45", "n"),
        d("\u0148", "n"),
        d("\u1E47", "n"),
        d("\u0146", "n"),
        d("\u1E4B", "n"),
        d("\u1E49", "n"),
        d("\u019E", "n"),
        d("\u0272", "n"),
        d("\u0149", "n"),
        d("\uA791", "n"),
        d("\uA7A5", "n"),
        d("\u01CC", "nj"),
        d("o", "o"),
        d("\u24DE", "o"),
        d("\uFF4F", "o"),
        d("\xf2", "o"),
        d("\xf3", "o"),
        d("\xf4", "o"),
        d("\u1ED3", "o"),
        d("\u1ED1", "o"),
        d("\u1ED7", "o"),
        d("\u1ED5", "o"),
        d("\xf5", "o"),
        d("\u1E4D", "o"),
        d("\u022D", "o"),
        d("\u1E4F", "o"),
        d("\u014D", "o"),
        d("\u1E51", "o"),
        d("\u1E53", "o"),
        d("\u014F", "o"),
        d("\u022F", "o"),
        d("\u0231", "o"),
        d("\xf6", "o"),
        d("\u022B", "o"),
        d("\u1ECF", "o"),
        d("\u0151", "o"),
        d("\u01D2", "o"),
        d("\u020D", "o"),
        d("\u020F", "o"),
        d("\u01A1", "o"),
        d("\u1EDD", "o"),
        d("\u1EDB", "o"),
        d("\u1EE1", "o"),
        d("\u1EDF", "o"),
        d("\u1EE3", "o"),
        d("\u1ECD", "o"),
        d("\u1ED9", "o"),
        d("\u01EB", "o"),
        d("\u01ED", "o"),
        d("\xf8", "o"),
        d("\u01FF", "o"),
        d("\u0254", "o"),
        d("\uA74B", "o"),
        d("\uA74D", "o"),
        d("\u0275", "o"),
        d("\u01A3", "oi"),
        d("\u0223", "ou"),
        d("\uA74F", "oo"),
        d("p", "p"),
        d("\u24DF", "p"),
        d("\uFF50", "p"),
        d("\u1E55", "p"),
        d("\u1E57", "p"),
        d("\u01A5", "p"),
        d("\u1D7D", "p"),
        d("\uA751", "p"),
        d("\uA753", "p"),
        d("\uA755", "p"),
        d("q", "q"),
        d("\u24E0", "q"),
        d("\uFF51", "q"),
        d("\u024B", "q"),
        d("\uA757", "q"),
        d("\uA759", "q"),
        d("r", "r"),
        d("\u24E1", "r"),
        d("\uFF52", "r"),
        d("\u0155", "r"),
        d("\u1E59", "r"),
        d("\u0159", "r"),
        d("\u0211", "r"),
        d("\u0213", "r"),
        d("\u1E5B", "r"),
        d("\u1E5D", "r"),
        d("\u0157", "r"),
        d("\u1E5F", "r"),
        d("\u024D", "r"),
        d("\u027D", "r"),
        d("\uA75B", "r"),
        d("\uA7A7", "r"),
        d("\uA783", "r"),
        d("s", "s"),
        d("\u24E2", "s"),
        d("\uFF53", "s"),
        d("\xdf", "s"),
        d("\u015B", "s"),
        d("\u1E65", "s"),
        d("\u015D", "s"),
        d("\u1E61", "s"),
        d("\u0161", "s"),
        d("\u1E67", "s"),
        d("\u1E63", "s"),
        d("\u1E69", "s"),
        d("\u0219", "s"),
        d("\u015F", "s"),
        d("\u023F", "s"),
        d("\uA7A9", "s"),
        d("\uA785", "s"),
        d("\u1E9B", "s"),
        d("t", "t"),
        d("\u24E3", "t"),
        d("\uFF54", "t"),
        d("\u1E6B", "t"),
        d("\u1E97", "t"),
        d("\u0165", "t"),
        d("\u1E6D", "t"),
        d("\u021B", "t"),
        d("\u0163", "t"),
        d("\u1E71", "t"),
        d("\u1E6F", "t"),
        d("\u0167", "t"),
        d("\u01AD", "t"),
        d("\u0288", "t"),
        d("\u2C66", "t"),
        d("\uA787", "t"),
        d("\uA729", "tz"),
        d("u", "u"),
        d("\u24E4", "u"),
        d("\uFF55", "u"),
        d("\xf9", "u"),
        d("\xfa", "u"),
        d("\xfb", "u"),
        d("\u0169", "u"),
        d("\u1E79", "u"),
        d("\u016B", "u"),
        d("\u1E7B", "u"),
        d("\u016D", "u"),
        d("\xfc", "u"),
        d("\u01DC", "u"),
        d("\u01D8", "u"),
        d("\u01D6", "u"),
        d("\u01DA", "u"),
        d("\u1EE7", "u"),
        d("\u016F", "u"),
        d("\u0171", "u"),
        d("\u01D4", "u"),
        d("\u0215", "u"),
        d("\u0217", "u"),
        d("\u01B0", "u"),
        d("\u1EEB", "u"),
        d("\u1EE9", "u"),
        d("\u1EEF", "u"),
        d("\u1EED", "u"),
        d("\u1EF1", "u"),
        d("\u1EE5", "u"),
        d("\u1E73", "u"),
        d("\u0173", "u"),
        d("\u1E77", "u"),
        d("\u1E75", "u"),
        d("\u0289", "u"),
        d("v", "v"),
        d("\u24E5", "v"),
        d("\uFF56", "v"),
        d("\u1E7D", "v"),
        d("\u1E7F", "v"),
        d("\u028B", "v"),
        d("\uA75F", "v"),
        d("\u028C", "v"),
        d("\uA761", "vy"),
        d("w", "w"),
        d("\u24E6", "w"),
        d("\uFF57", "w"),
        d("\u1E81", "w"),
        d("\u1E83", "w"),
        d("\u0175", "w"),
        d("\u1E87", "w"),
        d("\u1E85", "w"),
        d("\u1E98", "w"),
        d("\u1E89", "w"),
        d("\u2C73", "w"),
        d("x", "x"),
        d("\u24E7", "x"),
        d("\uFF58", "x"),
        d("\u1E8B", "x"),
        d("\u1E8D", "x"),
        d("y", "y"),
        d("\u24E8", "y"),
        d("\uFF59", "y"),
        d("\u1EF3", "y"),
        d("\xfd", "y"),
        d("\u0177", "y"),
        d("\u1EF9", "y"),
        d("\u0233", "y"),
        d("\u1E8F", "y"),
        d("\xff", "y"),
        d("\u1EF7", "y"),
        d("\u1E99", "y"),
        d("\u1EF5", "y"),
        d("\u01B4", "y"),
        d("\u024F", "y"),
        d("\u1EFF", "y"),
        d("z", "z"),
        d("\u24E9", "z"),
        d("\uFF5A", "z"),
        d("\u017A", "z"),
        d("\u1E91", "z"),
        d("\u017C", "z"),
        d("\u017E", "z"),
        d("\u1E93", "z"),
        d("\u1E95", "z"),
        d("\u01B6", "z")
    ]), cT = Ji(iT), fT = function(n) {
        return A3(Mo, F2(function(n, r) {
            var t = A2(di, n, cT);
            return $(r, t.$ ? Qd(n) : t.a);
        }), "", n);
    }, sT = A2(bu, Ua, fT), lT = F2(function(n, r) {
        var t = d(n, r);
        if (t.a.$) return t.b.$ ? A2(hu, t.a.a, t.b.a) : 0;
        if (t.b.$) return 2;
        var e = t.b.a;
        return A2(hu, sT(t.a.a), sT(e));
    }), dT = F2(function(n, r) {
        n: for(;;){
            var t = d(n, r);
            if (t.a.b) {
                if (t.b.b) {
                    var e = t.a, u = e.b, o = t.b, a = o.b, i = A2(lT, e.a, o.a);
                    if (1 === i) {
                        n = u, r = a;
                        continue n;
                    }
                    return i;
                }
                return 2;
            }
            return t.b.b ? 0 : 1;
        }
    }), mT = A2(ju, Qg, Ug("[0-9]+|[^0-9]+")), bT = st(dt), pT = D, vT = function(n) {
        return pT(n) ? kt : ht({
            $: 1,
            a: n
        });
    }, $T = function(n) {
        return A2(ju, {
            $: 0,
            a: n
        }, A2(sp, vT, He(n)));
    }, wT = function(n) {
        return A2(Ye, A2(bu, $T, function(n) {
            return n.b_;
        }), A2(bT, mT, n));
    }, gT = F3(function(n, r, t) {
        return A2(dT, wT(n(r)), wT(n(t)));
    }), hT = S, kT = hT(gT(Zi)), CT = F2(function(n, r) {
        return A2(aT, A2(bu, r, kT), n);
    }), TT = function(n) {
        return A2(Ck, function(r) {
            var t = A2(mt, d("", ""), A2(Ye, function(n) {
                return d(n.a, n.b.n6);
            }, pt(n.oQ))), e = function(n) {
                return 1 !== n.oS.$;
            }(r) ? d("Save", "Edit Channel") : d("Create", "New Channel");
            return A4(_k, e.b, d(e.a, tT), d("Cancel", GC), k([
                A2(mh, rT, A2(CT, t, Ek(r.oM))),
                A2(mh, nT, Mk(r.n6))
            ]));
        }, n.kP);
    }, PT = F2(function(n, r) {
        var t, e;
        return A3(gC, "Channels", ht(A2(Pg, "New\u2026", UC)), A2(ye, w, k([
            TT(r),
            A2(YC, ZC, (t = d(r.cz, r.oQ), e = t.b, A2(Ye, function(n) {
                var r;
                return k([
                    A2(Pg, "Edit", (r = n, {
                        $: 2,
                        a: r
                    })),
                    ag(A2(_C, e, n)),
                    ag(n.sw),
                    A2(Bw, kg, QC(n))
                ]);
            }, t.a)))
        ])));
    }), ST = {
        l: function(n) {
            return n.cz;
        },
        m: MC,
        o: F2(function(n, r) {
            return p(n, {
                cz: r
            });
        }),
        p: function(n) {
            return {
                $: 8,
                a: n
            };
        },
        q: WC,
        r: PT
    }, AT = function(n) {
        return {
            $: 5,
            a: n
        };
    }, yT = A2(Xa, AT, mc(A2(Wi, M$, Ai(D$)))), NT = function(n) {
        return {
            $: 6,
            a: n
        };
    }, LT = ic(Uv), jT = function(n) {
        return {
            $: 12,
            a: n
        };
    }, FT = dl(jT({
        $: 2
    })), MT = A2(Xa, NT, mc(A2(Wi, LT, Ai(FT)))), IT = {
        kx: w,
        m6: !1,
        nm: !1,
        oQ: w,
        oX: ov(kt),
        rN: o$("Completed At"),
        dL: w
    }, DT = function(n) {
        return {
            $: 2,
            a: n
        };
    }, BT = Ge, xT = function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            B: l,
                                                            $9: d,
                                                            j2: u,
                                                            j3: s,
                                                            ki: t,
                                                            lw: a,
                                                            mo: n,
                                                            fI: r,
                                                            oM: i,
                                                            pH: c,
                                                            g9: o,
                                                            q6: e,
                                                            q7: f
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, qT = function(n) {
        switch(n){
            case "DownloadAsIs":
                return At(0);
            case "PADTranscode":
                return At(1);
            case "SimpleTranscode":
                return At(2);
            case "QC":
                return At(3);
            case "Spotcheck":
                return At(4);
            default:
                return Ct("job type not found");
        }
    }, VT = function(n) {
        switch(n){
            case 0:
                return "DownloadAsIs";
            case 1:
                return "PADTranscode";
            case 2:
                return "SimpleTranscode";
            case 3:
                return "QC";
            default:
                return "Spotcheck";
        }
    }, OT = A2(Ml, VT, qT), zT = Fi(A4(rc, "acknowledgedBy", function(n) {
        return n.$9;
    }, xi(Oa), A4(rc, "acknowledge", function(n) {
        return n.B;
    }, ri, A4(rc, "completedBy", function(n) {
        return n.j3;
    }, xi(Oa), A4(rc, "startedBy", function(n) {
        return n.q7;
    }, xi(Oa), A4(rc, "requester", function(n) {
        return n.pH;
    }, Oa, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, A4(qi, "externalJobId", function(n) {
        return n.lw;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(qi, "completedAt", function(n) {
        return n.j2;
    }, tm, A4(qi, "startedAt", function(n) {
        return n.q6;
    }, tm, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "jobType", function(n) {
        return n.fI;
    }, OT, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(xT))))))))))))))), ET = ic(zT), HT = function(n) {
        return {
            $: 24,
            a: n
        };
    }, RT = dl(HT({
        $: 3
    })), WT = mc(A2(Wi, ET, Ai(RT))), UT = function(n) {
        return {
            ha: n
        };
    }, QT = function(n) {
        return {
            $: 26,
            a: n
        };
    }, _T = dl(QT({
        $: 0
    })), ZT = Fi(A4(rc, "showIds", function(n) {
        return n.ha;
    }, ic(Oa), Mi(UT))), KT = F2(function(n, r) {
        return {
            gs: r,
            qJ: n
        };
    }), XT = function(n) {
        return {
            sw: n
        };
    }, JT = Fi(A4(rc, "value", function(n) {
        return n.sw;
    }, Oa, Mi(XT))), YT = Fi(A4(rc, "path", function(n) {
        return n.gs;
    }, ic(JT), A4(rc, "showId", function(n) {
        return n.qJ;
    }, Oa, Mi(KT)))), GT = ic(YT), nP = F2(function(n, r) {
        var t;
        return (t = n.mo, function(n) {
            return function(r) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            B: l,
                                                            $9: d,
                                                            j2: u,
                                                            j3: s,
                                                            ki: r,
                                                            lw: a,
                                                            mo: t,
                                                            fI: n,
                                                            oM: i,
                                                            pH: c,
                                                            qL: o,
                                                            q6: e,
                                                            q7: f
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        })(n.fI)(n.ki)(n.q6)(n.j2)(r)(n.lw)(n.oM)(n.pH)(n.q7)(n.j3)(n.B)(n.$9);
    }), rP = F2(function(n, r) {
        return A2(nP, r, A2(ju, A2(KT, r.mo, k([
            XT(r.mo)
        ])), Eo(A2(Mu, function(n) {
            return a(n.qJ, r.g9);
        }, n))));
    }), tP = function(n) {
        return A2(Yb, function(r) {
            return A2(Ye, rP(r), n);
        }, mc(A2(Wi, GT, A3(ow, ZT, UT(A2(Ye, function(n) {
            return n.g9;
        }, n)), rw(_T)))));
    }, eP = A2(BT, tP, WT), uP = A2(Xa, DT, eP), oP = A2(pc, k([
        uP,
        yT,
        MT
    ]), IT), aP = function(n) {
        return {
            $: 11,
            a: n
        };
    }, iP = Ze, cP = function(n) {
        return A2(Yv, Dl({
            $: 8,
            a: n
        }), iP(0));
    }, fP = function(n) {
        return bc(k([
            uP,
            cP(n)
        ]));
    }, sP = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, w, r);
            case 9:
                return A2(pc, w, p(r, {
                    kx: w
                }));
            case 4:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            case 7:
                return A2(pc, w, p(r, {
                    m6: !r.m6
                }));
            case 2:
                return A2(pc, w, p(r, (u = n.a).$ ? {
                    kx: w
                } : {
                    kx: u.a,
                    nm: !1
                }));
            case 1:
                return A2(pc, k([
                    uP
                ]), r);
            case 5:
                return A2(pc, w, (u = n.a).$ ? r : p(r, {
                    oQ: u.a
                }));
            case 6:
                return A2(pc, w, (u = n.a).$ ? r : p(r, {
                    dL: u.a
                }));
            case 8:
                return A2(pc, w, p(r, {
                    oX: e = n.a
                }));
            case 3:
                var t = n.a, e = t.a;
                return A2(pc, w, (u = t.b).$ ? r : p(r, {
                    kx: u.a,
                    nm: !1,
                    oX: e
                }));
            case 10:
                return A2(pc, k([
                    A2(Xa, aP, (o = n.a.mo, mc(sw(dw(dl(QT({
                        $: 1,
                        a: o
                    })))))))
                ]), r);
            default:
                var u;
                return A2(pc, (u = n.a).$ ? w : k([
                    fP(r.oX)
                ]), r);
        }
        var o;
    }), lP = {
        $: 1
    }, dP = Ae("h2"), mP = F3(function(n, r, t) {
        return A2(ye, k([
            A2(pg, "margin", "10px")
        ]), k([
            A2(dP, w, k([
                ag(r)
            ])),
            t
        ]));
    }), bP = function(n) {
        return xT(n.mo)(n.fI)(n.ki)(n.q6)(n.j2)(n.qL.qJ)(n.lw)(n.oM)(n.pH)(n.q7)(n.j3)(n.B)(n.$9);
    }, pP = {
        $: 7
    }, vP = F2(function(n, r) {
        return A2(ju, n, A2(Lu, function(r) {
            return $(n, r ? "true" : "false");
        }, r));
    }), $P = function(n) {
        var r = m(n.oM, n.c$, n.P);
        return 1 === r.a.$ ? 1 === r.b.$ ? 1 === r.c.$ ? "/jobs" + A2(vP, "?acknowledge=", n.B) : "/jobs?status=" + (r.c.a + A2(vP, "&acknowledge=", n.B)) : r.c.$ ? "/jobs?kind=" + (r.b.a + A2(vP, "&acknowledge=", n.B)) : "/jobs?kind=" + r.b.a + "&status=" + (r.c.a + A2(vP, "&acknowledge=", n.B)) : r.b.$ ? 1 === r.c.$ ? "/jobs?organization=" + (r.a.a + A2(vP, "&acknowledge=", n.B)) : "/jobs?organization=" + r.a.a + "&status=" + (r.c.a + A2(vP, "&acknowledge=", n.B)) : 1 === r.c.$ ? "/jobs?organization=" + r.a.a + "&kind=" + (r.b.a + A2(vP, "&acknowledge=", n.B)) : "/jobs?organization=" + r.a.a + "&kind=" + r.b.a + "&status=" + (r.c.a + A2(vP, "&acknowledge=", n.B));
    }, wP = function(n) {
        switch(n.$){
            case 0:
                return "/";
            case 1:
                var r = n.c;
                return "/show/" + (n.a + (hv(n.b) + function() {
                    var n = d(r.bD, r.cf);
                    n: for(;;){
                        if (1 === n.a.$) {
                            if (n.b.$ || n.b.a) break n;
                            return "?sortVerifByDate=";
                        }
                        if (1 === n.b.$) return "?broadcastable=" + n.a.a;
                        if (n.b.a) break n;
                        return "?broadcastable=" + n.a.a + "&sortVerifByDate=";
                    }
                    return "";
                }()));
            case 2:
                return "/hierarchy/" + n.a + (n.b ? "/settings" : "");
            case 3:
                return function(n) {
                    switch(n.$){
                        case 1:
                            return "/account/forgotPassword";
                        case 0:
                            var r = n.a.lZ;
                            if (1 === r.$) return "/account/login";
                            switch(r.a){
                                case "/":
                                case "/logout":
                                    return "/account/login";
                                default:
                                    return "/account/login?from=" + r.a;
                            }
                        case 2:
                            return "/account/resetPassword?email=" + n.a.la + "&token=" + n.a.r0;
                        default:
                            var t = n.a;
                            return "/account/invitation?redirect=" + t.pB + "&email=" + t.la + "&token=" + t.r0;
                    }
                }(n.a);
            case 4:
                switch(n.a.$){
                    case 0:
                        return "/admin";
                    case 1:
                        return "/admin/adminOrganizations";
                    case 2:
                        return "/admin/onboarding";
                    case 3:
                        return "/admin/adminUsers";
                    case 4:
                        return "/admin/adminUploads";
                    case 5:
                        return "/admin/adminTestPlans";
                    case 6:
                        return "/admin/adminAudioMappings";
                    case 7:
                        return "/admin/adminChannels";
                    case 8:
                        return "/admin/adminResearchs";
                    case 9:
                        return "/admin/adminWebhooks";
                    case 10:
                        return "/admin/adminOrganizationFileListings";
                    case 11:
                        return "/admin/adminFormats";
                    case 12:
                        return "/admin/adminSubtitleFormats";
                    case 13:
                        return "/admin/adminSegmentationRules";
                    case 14:
                        return "/admin" + $P(r = n.a.a);
                    case 15:
                        return "/admin/metadata";
                    case 16:
                        return "/admin/deepProbe";
                    case 17:
                        return "/admin/probes";
                    default:
                        return "/admin" + function(n) {
                            var r = n.c$;
                            return r.$ ? "/dashboard" : "/dashboard?kind=" + r.a;
                        }(r = n.a.a);
                }
            case 5:
                return "/help/" + n.a;
            case 6:
                return "/archive";
            case 7:
                return "/upload";
            case 8:
                return "/settings";
            case 9:
                return "/report";
            default:
                return "/404";
        }
    }, gP = function(n) {
        return wP(gp(Hp(n)));
    }, hP = F2(function(n, r) {
        return m(a(n.oX.c$, ht(Ua(r.a))), gP({
            c$: ht(Ua(r.a))
        }), r.b);
    }), kP = function(n) {
        return n ? Kg("CatchClickAll") : Bg(w);
    }, CP = function(n) {
        var r = n.a, t = n.b, e = n.c;
        return A2(oC, k([
            Ow("SelectItem"),
            Bg(k([
                d("SelectItemSelected", r)
            ])),
            fC(t)
        ]), k([
            ag(e)
        ]));
    }, TP = F4(function(n, r, t, e) {
        var u = A2(ju, e, Eo(A2(Kc, function(n) {
            return n.a ? ht(n.c) : kt;
        }, t)));
        return A2(ye, k([
            Ow("Select"),
            Bg(k([
                d("SelectOpened", n)
            ])),
            Cg(r),
            kP(n)
        ]), k([
            A2(ye, k([
                Ow("SelectButton")
            ]), k([
                A2(ye, k([
                    Ow("SelectButtonIcon")
                ]), k([
                    Dk
                ])),
                A2(qg, k([
                    Ow("SelectButtonTitle")
                ]), u)
            ])),
            A2(ye, k([
                Ow("SelectList")
            ]), A2(Ye, CP, t))
        ]));
    }), PP = function(n) {
        var r = k([
            d("", "All Types"),
            d("DownloadAsIs", "DownloadAsIs"),
            d("PadTranscode", "PadTranscode"),
            d("SimpleTranscode", "SimpleTranscode"),
            d("QC", "QC"),
            d("Spotcheck", "Spotcheck")
        ]);
        return A4(TP, n.m6, pP, A2(Ye, hP(n), r), "Filter by type");
    }, SP = function(n) {
        return {
            $: 10,
            a: n
        };
    }, AP = function(n) {
        return {
            $: 4,
            a: n
        };
    }, yP = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), NP = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: yP(r)
        });
    }), LP = function(n) {
        return {
            $: 4,
            a: Ra(n)
        };
    }, jP = function(n) {
        return n;
    }, FP = F3(function(n, r, t) {
        return Gw({
            n6: n,
            ds: LP(A2(bu, jP, t)),
            dN: yP(r)
        });
    }), MP = Lw("datetime"), IP = function(n) {
        return A3(Ae, "format-time", k([
            MP(rm(n))
        ]), k([
            ag(rm(n))
        ]));
    }, DP = F2(function(n, r) {
        return A3(FP, n, function(n) {
            return IP(r(n));
        }, r);
    }), BP = F2(function(n, r) {
        if (r.$) return "";
        var t = r.a;
        return A2(ju, "", A2(Lu, function(n) {
            return n.n6;
        }, Eo(A2(Mu, function(n) {
            return a(n.mo, t);
        }, n))));
    }), xP = F2(function(n, r) {
        return A2(ju, "", A2(Lu, function(n) {
            return n.n6;
        }, Eo(A2(Mu, function(n) {
            return a(n.mo, r);
        }, n.oQ))));
    }), qP = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: LP(A2(bu, A2(bu, function(n) {
                return A2(ju, 0, n);
            }, Lu(jP)), r)),
            dN: yP(function(n) {
                return A2(ju, A2(ye, w, w), A2(Lu, IP, r(n)));
            })
        });
    }), VP = function(n) {
        return A3(xt, F2(function(n, r) {
            return r + "/" + n;
        }), "", A2(Ye, function(n) {
            return n.sw;
        }, n.gs));
    }, OP = F2(function(n, r) {
        return {
            n6: n,
            ds: Ew(r),
            dN: A2(bu, ig, r)
        };
    }), zP = k([
        Ow("Table")
    ]), EP = function() {
        return k([
            Ow("TableTr")
        ]);
    }, HP = function(n) {
        return ug({
            j_: k([
                A2(NP, "Acknowledge", A2(bu, Pg("Acknowledge"), SP)),
                A2(OP, "Organization", A2(bu, xP(n), function(n) {
                    return n.oM;
                })),
                A2(OP, "Type", A2(bu, VT, function(n) {
                    return n.fI;
                })),
                A2(DP, "Created At", function(n) {
                    return n.ki;
                }),
                A2(OP, "Requester", A2(bu, A2(bu, BP(n.dL), ht), function(n) {
                    return n.pH;
                })),
                A2(qP, "Started At", function(n) {
                    return n.q6;
                }),
                A2(OP, "Started By", A2(bu, BP(n.dL), function(n) {
                    return n.q7;
                })),
                A2(OP, "External Job Id", A2(bu, ju(""), function(n) {
                    return n.lw;
                })),
                A2(NP, "Show", A2(bu, function(n) {
                    return A2(oC, k([
                        fC("/show/" + n.qJ)
                    ]), k([
                        ag(VP(n))
                    ]));
                }, function(n) {
                    return n.qL;
                })),
                A2(OP, "Id", function(n) {
                    return n.mo;
                })
            ]),
            kv: p(hg, {
                pS: EP,
                rE: zP,
                rQ: k([
                    Ow("TableTd")
                ])
            }),
            rZ: function(n) {
                return n.mo;
            },
            r_: AP
        });
    }, RP = F2(function(n, r) {
        return A2(ye, k([
            A2(pg, "margin", "10px")
        ]), k([
            Tu(n.kx) ? ag("All jobs are completed !") : A3(ck, HP(n), n.rN, r)
        ]));
    }), WP = F2(function(n, r) {
        var t = r.oX.c$, e = A2(Mu, function(n) {
            if (t.$) return !0;
            var r = t.a;
            if (xe(r) > 0) {
                var e = bP(n);
                return a(Ua(VT(e.fI)), r);
            }
            return !0;
        }, r.kx);
        return A3(gC, "Dashboard", ht(A2(Pg, "Refresh", lP)), A2(ye, w, k([
            A2(ye, k([
                Ow("DarkZone"),
                Ow("Filter")
            ]), k([
                A2(ye, k([
                    Ow("JobsFilters")
                ]), k([
                    PP(r)
                ]))
            ])),
            A3(mP, r, "Not Completed Jobs: (" + Mt(qt(e)) + ")", A2(RP, r, e))
        ])));
    }), UP = {
        l: function(n) {
            return n.cE;
        },
        m: oP,
        o: F2(function(n, r) {
            return p(n, {
                cE: r
            });
        }),
        p: function(n) {
            return {
                $: 0,
                a: n
            };
        },
        q: sP,
        r: WP
    }, QP = {
        kx: w,
        kP: kt,
        lo: kt,
        rz: kt,
        rN: o$("Id")
    }, _P = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ZP = function(n) {
        return {
            $: 25,
            a: n
        };
    }, KP = dl(ZP({
        $: 1
    })), XP = F2(function(n, r) {
        return {
            jK: r,
            aj: n
        };
    }), JP = F3(function(n, r, t) {
        return {
            nL: t,
            nU: r,
            n6: n
        };
    }), YP = function(n) {
        switch(n){
            case "silence":
                return At(0);
            case "blackframe":
                return At(1);
            default:
                return Ct("Deep Probe Kind not found");
        }
    }, GP = function(n) {
        return n ? "blackframe" : "silence";
    }, nS = A2(Ml, GP, YP), rS = Fi(A4(rc, "max", function(n) {
        return n.nL;
    }, uc, A4(rc, "min", function(n) {
        return n.nU;
    }, uc, A4(rc, "name", function(n) {
        return n.n6;
    }, nS, Mi(JP))))), tS = ic(rS), eS = F2(function(n, r) {
        return {
            mo: n,
            n6: r
        };
    }), uS = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(eS)))), oS = Fi(A4(rc, "checks", function(n) {
        return n.jK;
    }, tS, A4(rc, "configuration", function(n) {
        return n.aj;
    }, uS, Mi(XP)))), aS = ic(oS), iS = A2(Yb, Ra(A2(Pi, function(n) {
        return n.aj;
    }, function(n) {
        return n.mo;
    })), mc(A2(Wi, aS, Ai(KP)))), cS = A2(Xa, _P, iS), fS = A2(pc, k([
        cS
    ]), QP), sS = function(n) {
        return m(za(function(r) {
            return p(r, {
                m7: "Type",
                sw: GP(n.n6)
            });
        }), za(function(r) {
            return p(r, {
                m7: "Min (ms for silence, frame for blackframe)",
                sw: Mt(n.nU)
            });
        }), za(function(r) {
            return p(r, {
                m7: "Max (ms for silence, frame for blackframe)",
                sw: Mt(n.nL)
            });
        }));
    }, lS = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), dS = function(n) {
        return {
            $: 11,
            a: n
        };
    }, mS = F2(function(n, r) {
        return {
            jK: r,
            n6: n
        };
    }), bS = F2(function(n, r) {
        return {
            n6: n,
            aR: r
        };
    }), pS = F2(function(n, r) {
        return {
            nL: r,
            nU: n
        };
    }), vS = Fi(A4(rc, "max", function(n) {
        return n.nL;
    }, uc, A4(rc, "min", function(n) {
        return n.nU;
    }, uc, Mi(pS)))), $S = Fi(A4(rc, "parameters", function(n) {
        return n.aR;
    }, vS, A4(rc, "name", function(n) {
        return n.n6;
    }, nS, Mi(bS)))), wS = ic($S), gS = Fi(A4(rc, "checks", function(n) {
        return n.jK;
    }, wS, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(mS)))), hS = function(n) {
        return A2(Kc, Zi, pt(A2(Gi, F2(function(n, r) {
            var t = r.b, e = r.c, u = YP(r.a.sw);
            return u.$ ? kt : ht(A2(bS, u.a, A2(pS, A2(ju, 0, He(t.sw)), A2(ju, 0, He(e.sw)))));
        }), n)));
    }, kS = function(n) {
        return A2(Xa, dS, function(n) {
            return mc(sw(A3(ow, gS, {
                jK: hS(n.jK),
                n6: n.n6.sw
            }, rw(KP))));
        }(n));
    }, CS = function(n) {
        return {
            $: 13,
            a: n
        };
    }, TS = function(n) {
        return dl(ZP({
            $: 3,
            a: n
        }));
    }, PS = F3(function(n, r, t) {
        return {
            jK: t,
            mo: n,
            n6: r
        };
    }), SS = Fi(A4(rc, "checks", function(n) {
        return n.jK;
    }, wS, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(PS))))), AS = function(n) {
        return {
            $: 12,
            a: n
        };
    }, yS = function(n) {
        return A2(Xa, AS, function(n) {
            var r = TS(A2(ju, "", A2(Lu, A2(Pi, function(n) {
                return n.aj;
            }, function(n) {
                return n.mo;
            }), n.oS)));
            return mc(sw(A3(ow, SS, {
                jK: hS(n.jK),
                mo: A2(ju, "", A2(Lu, A2(bu, function(n) {
                    return n.mo;
                }, function(n) {
                    return n.aj;
                }), n.oS)),
                n6: n.n6.sw
            }, dw(r))));
        }(n));
    }, NS = function(n) {
        return A2(Gi, F2(function(n, r) {
            return sS(r);
        }), Ji(A2(Ht, V$, n)));
    }, LS = function(n) {
        return {
            jK: A2(ju, Su, A2(Lu, A2(bu, NS, function(n) {
                return n.jK;
            }), n)),
            n6: za(function(r) {
                return p(r, {
                    m7: "Name",
                    sw: A2(ju, "", A2(Lu, A2(bu, function(n) {
                        return n.n6;
                    }, function(n) {
                        return n.aj;
                    }), n))
                });
            }),
            oS: n
        };
    }, jS = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            case 2:
                return A2(pc, w, p(r, {
                    kP: ht(LS(kt))
                }));
            case 3:
                return A2(pc, w, p(r, {
                    kP: ht(LS(ht(n.a)))
                }));
            case 4:
                var t = r.kP;
                return A2(pc, 1 === t.$ ? w : k(1 === (u = t.a).oS.$ ? [
                    kS(u)
                ] : [
                    yS(u)
                ]), r);
            case 5:
                return A2(pc, k([
                    (s = n.a, A2(Xa, CS, function(n) {
                        return mc(sw(A3(ow, SS, {
                            jK: w,
                            mo: n.aj.mo,
                            n6: n.aj.n6
                        }, fw(TS(n.aj.mo)))));
                    }(s)))
                ]), r);
            case 6:
                return A2(pc, w, p(r, {
                    kP: kt
                }));
            case 7:
                var e = n.a, u = A2(Lu, function(n) {
                    return p(n, {
                        n6: A2(ww, e, n.n6)
                    });
                }, r.kP);
                return A2(pc, w, p(r, {
                    kP: u
                }));
            case 11:
                return (o = n.a).$ ? A2(pc, w, A2(lS, o.a, r)) : A2(pc, k([
                    cS
                ]), p(r, {
                    kP: kt,
                    lo: kt,
                    rz: ht("Template created")
                }));
            case 12:
                return (o = n.a).$ ? A2(pc, w, A2(lS, o.a, r)) : A2(pc, k([
                    cS
                ]), p(r, {
                    kP: kt,
                    lo: kt,
                    rz: ht("Template updated")
                }));
            case 13:
                return (o = n.a).$ ? A2(pc, w, A2(lS, o.a, r)) : A2(pc, k([
                    cS
                ]), r);
            case 1:
                var o;
                return A2(pc, w, (o = n.a).$ ? A2(lS, o.a, r) : p(r, {
                    kx: o.a
                }));
            case 14:
                var i = sS(A3(JP, 0, 1e3, 2e3)), c = A2(ju, 0, A2(Lu, function(n) {
                    return A2(ju, 0, W$(vt(n.jK)));
                }, r.kP));
                return u = A2(Lu, function(n) {
                    return p(n, {
                        jK: A3(Cu, c + 1, i, n.jK)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: u
                }));
            case 8:
                e = n.a;
                var f = n.b;
                return u = A2(Lu, function(n) {
                    return p(n, {
                        jK: A2(Gi, F2(function(n, r) {
                            var t = r.a, u = r.b, o = r.c;
                            return a(n, f) ? m(A2(ww, e, t), u, o) : m(t, u, o);
                        }), n.jK)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: u
                }));
            case 9:
                return e = n.a, f = n.b, u = A2(Lu, function(n) {
                    return p(n, {
                        jK: A2(Gi, F2(function(n, r) {
                            var t = r.a, u = r.b, o = r.c;
                            return a(n, f) ? m(t, A2(ww, e, u), o) : m(t, u, o);
                        }), n.jK)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: u
                }));
            case 10:
                return e = n.a, f = n.b, u = A2(Lu, function(n) {
                    return p(n, {
                        jK: A2(Gi, F2(function(n, r) {
                            var t = r.a, u = r.b, o = r.c;
                            return a(n, f) ? m(t, u, A2(ww, e, o)) : m(t, u, o);
                        }), n.jK)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: u
                }));
            default:
                return f = n.a, u = A2(Lu, function(n) {
                    return p(n, {
                        jK: A2(R$, F2(function(n) {
                            return !a(n, f);
                        }), n.jK)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: u
                }));
        }
        var s;
    }), FS = {
        $: 2
    }, MS = function(n) {
        return {
            $: 3,
            a: n
        };
    }, IS = function(n) {
        return {
            $: 5,
            a: n
        };
    }, DS = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), BS = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: DS(r)
        });
    }), xS = k([
        Ow("Table")
    ]), qS = function(n) {
        return n.n6 ? "blackframe \u2208 [ frame " + Mt(n.nU) + ", frame " + Mt(n.nL) + "]" : "silence \u2208 [" + Mt(n.nU) + " ms, " + Mt(n.nL) + " ms]";
    }, VS = function(n) {
        return A3(xt, F2(function(n, r) {
            return $(r, $(xe(r) > 0 ? ", " : "", qS(n)));
        }), "", n);
    }, OS = ug({
        j_: k([
            A2(OP, "Name", A2(Pi, function(n) {
                return n.aj;
            }, function(n) {
                return n.n6;
            })),
            A2(OP, "Description", A2(bu, VS, function(n) {
                return n.jK;
            })),
            A2(BS, "", A2(bu, Pg("Edit"), MS)),
            A2(BS, "", A2(bu, Pg("Delete"), IS))
        ]),
        kv: p(hg, {
            pS: function() {
                return k([
                    Ow("TableTr")
                ]);
            },
            rE: xS,
            rQ: k([
                Ow("TableTd")
            ])
        }),
        rZ: A2(Pi, function(n) {
            return n.aj;
        }, function(n) {
            return n.mo;
        }),
        r_: function(n) {
            return {
                $: 0,
                a: n
            };
        }
    }), zS = {
        $: 6
    }, ES = function(n) {
        return {
            $: 7,
            a: n
        };
    }, HS = {
        $: 14
    }, RS = {
        $: 4
    }, WS = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), US = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), QS = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), _S = Vw("max"), ZS = Vw("min"), KS = F3(function(n, r, t) {
        return A2(Og, n, A2(Eg, k([
            Ow("InputText"),
            Xg(n.kX),
            Tg("number"),
            eh(Lg),
            Gg(jg),
            nh(Fg),
            oh(n.sw),
            uh(n.gw),
            Hg(Zg(n.m7)),
            zg(n.kS),
            ZS(A2(ju, "", A2(Lu, Mt, r))),
            _S(A2(ju, "", A2(Lu, Mt, t))),
            n.d8 ? Dg(!0) : Bg(w)
        ]), w));
    }), XS = F3(function(n, r, t) {
        return A2(jk, n, A3(KS, n, r, t));
    }), JS = function(n) {
        return A2(Ck, function(n) {
            var r, t, e, u = function(n) {
                return A2(ju, !1, A2(Lu, function() {
                    return !0;
                }, n.oS));
            }(n) ? d("Save", "Edit Template") : d("Create", "New Template");
            return A4(_k, u.b, d(u.a, RS), d("Cancel", zS), k([
                A2(mh, ES, Mk(n.n6)),
                (r = n.jK, t = k([
                    d("silence", "silence"),
                    d("blackframe", "blackframe")
                ]), e = F2(function(n, r) {
                    var e, u = r.a, o = r.b, a = r.c;
                    return A2(ye, k([
                        A2(pg, "position", "relative"),
                        A2(pg, "margin", "10px"),
                        A2(pg, "padding", "5px")
                    ]), k([
                        A2(mh, function(r) {
                            return A2(QS, r, n);
                        }, A2(Ek, u, t)),
                        A2(mh, function(r) {
                            return A2(US, r, n);
                        }, A3(XS, o, ht(0), kt)),
                        A2(mh, function(r) {
                            return A2(WS, r, n);
                        }, A3(XS, a, ht(0), kt)),
                        A3(Jk, "remove", k([
                            d("position", "absolute"),
                            d("left", "0")
                        ]), (e = n, {
                            $: 15,
                            a: e
                        }))
                    ]));
                }), A2(ye, k([
                    A2(pg, "padding", "10px 0")
                ]), A2(Ye, Zi, pt(A2(Gi, e, r))))),
                A2(Pg, "Add New Check", HS)
            ]));
        }, n.kP);
    }, YS = F2(function(n, r) {
        return A3(gC, "Deep Probe Templates", ht(A2(Pg, "New\u2026", FS)), A2(ye, w, k([
            JS(r),
            A3(ck, OS, r.rN, r.kx)
        ])));
    }), GS = {
        l: function(n) {
            return n.cF;
        },
        m: fS,
        o: F2(function(n, r) {
            return p(n, {
                cF: r
            });
        }),
        p: function(n) {
            return {
                $: 17,
                a: n
            };
        },
        q: jS,
        r: YS
    }, nA = {
        kP: kt,
        lo: kt,
        cX: w,
        lX: w,
        px: za(function(n) {
            return p(n, {
                gw: "Search Formats by Name, Specification, AudioCodec, Start Timecode, Frame Rate or FFMpeg Args",
                sw: ""
            });
        }),
        dw: w,
        rz: kt,
        rN: o$("Name"),
        dB: Su
    }, rA = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tA = F4(function(n, r, t, e) {
        return {
            cX: n,
            lY: r,
            dw: e,
            dB: t
        };
    }), eA = function(n) {
        switch(n){
            case "pcm_s16le":
                return At(1);
            case "pcm_s24le":
                return At(0);
            case "pcm_s24be":
                return At(2);
            case "libfdk_aac":
                return At(3);
            case "libmp3lame":
                return At(4);
            case "MOV_Conteneur":
                return At(5);
            default:
                return Ct(p(A2(ka, "can't parse str to audio codec", s$), {
                    N: !0,
                    ag: !0
                }));
        }
    }, uA = function(n) {
        switch(n){
            case 1:
                return "pcm_s16le";
            case 0:
                return "pcm_s24le";
            case 2:
                return "pcm_s24be";
            case 3:
                return "libfdk_aac";
            case 4:
                return "libmp3lame";
            default:
                return "MOV_Conteneur";
        }
    }, oA = A2(Ml, uA, eA), aA = F2(function(n, r) {
        return {
            jS: r,
            jT: n
        };
    }), iA = Fi(A4(rc, "clipMax", function(n) {
        return n.jS;
    }, uc, A4(rc, "clipMin", function(n) {
        return n.jT;
    }, uc, Mi(aA)))), cA = F4(function(n, r, t, e) {
        return {
            ek: e,
            fP: n,
            gV: r,
            h0: t
        };
    }), fA = Fi(A4(rc, "bottomPx", function(n) {
        return n.ek;
    }, uc, A4(rc, "topPx", function(n) {
        return n.h0;
    }, uc, A4(rc, "rightPx", function(n) {
        return n.gV;
    }, uc, A4(rc, "leftPx", function(n) {
        return n.fP;
    }, uc, Mi(cA)))))), sA = X, lA = gn, dA = A2(Va, lA, sA), mA = function(n) {
        switch(n){
            case "Mxf":
                return At(0);
            case "Mp4":
                return At(1);
            case "ProRes422":
                return At(2);
            case "ProRes4444":
                return At(3);
            case "TwoPass":
                return At(4);
            case "AVCIntra100":
                return At(5);
            case "IMX50":
                return At(6);
            case "Mp4Salto":
                return At(7);
            case "MxfProgressive":
                return At(12);
            case "MovH264":
                return At(8);
            case "MkvH264":
                return At(9);
            case "MovHevc":
                return At(10);
            case "Mp4Hevc":
                return At(11);
            case "XAVCIntra300":
                return At(13);
            case "WMV":
                return At(14);
            case "Demux":
                return At(15);
            case "AudioExtract":
                return At(16);
            default:
                return Ct(A2(ka, "Unknown format spec", s$));
        }
    }, bA = function(n) {
        switch(n){
            case 0:
                return "Mxf";
            case 1:
                return "Mp4";
            case 2:
                return "ProRes422";
            case 3:
                return "ProRes4444";
            case 4:
                return "TwoPass";
            case 5:
                return "AVCIntra100";
            case 6:
                return "IMX50";
            case 7:
                return "Mp4Salto";
            case 12:
                return "MxfProgressive";
            case 8:
                return "MovH264";
            case 9:
                return "MkvH264";
            case 10:
                return "MovHevc";
            case 11:
                return "Mp4Hevc";
            case 13:
                return "XAVCIntra300";
            case 14:
                return "WMV";
            case 15:
                return "Demux";
            default:
                return "AudioExtract";
        }
    }, pA = A2(Ml, bA, mA), vA = F3(function(n, r, t) {
        return {
            cG: t,
            mo: n,
            c9: r
        };
    }), $A = Fi(A4(rc, "denominator", function(n) {
        return n.cG;
    }, uc, A4(rc, "numerator", function(n) {
        return n.c9;
    }, uc, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(vA))))), wA = F8(function(n, r, t, e, u, o, a, i) {
        return {
            jW: u,
            jX: e,
            ku: o,
            me: a,
            m4: i,
            nf: t,
            pe: r,
            pj: n
        };
    }), gA = Fi(A4(rc, "keyframe", function(n) {
        return n.m4;
    }, uc, A4(rc, "highTiers", function(n) {
        return n.me;
    }, ri, A4(rc, "curveTransfert", function(n) {
        return n.ku;
    }, Oa, A4(rc, "colorPrimaries", function(n) {
        return n.jW;
    }, Oa, A4(rc, "colorspace", function(n) {
        return n.jX;
    }, Oa, A4(rc, "level", function(n) {
        return n.nf;
    }, Oa, A4(rc, "preset", function(n) {
        return n.pe;
    }, Oa, A4(rc, "profil", function(n) {
        return n.pj;
    }, Oa, Mi(wA)))))))))), hA = F8(function(n, r, t, e, u, o, a, i) {
        return {
            iB: u,
            iX: r,
            iY: t,
            jy: e,
            j9: n,
            kF: a,
            pv: i,
            sA: o
        };
    }), kA = Fi(A4(qi, "qmax", function(n) {
        return n.pv;
    }, uc, A4(rc, "deint", function(n) {
        return n.kF;
    }, ri, A4(rc, "version12", function(n) {
        return n.sA;
    }, ri, A4(qi, "afd", function(n) {
        return n.iB;
    }, uc, A4(rc, "BWF", function(n) {
        return n.jy;
    }, ri, A4(rc, "as11", function(n) {
        return n.iY;
    }, ri, A4(rc, "as10", function(n) {
        return n.iX;
    }, ri, A4(rc, "controlInstantaneousBitrate", function(n) {
        return n.j9;
    }, ri, Mi(hA)))))))))), CA = F4(function(n, r, t, e) {
        return {
            fm: r,
            p1: t,
            p3: e,
            ig: n
        };
    }), TA = Fi(A4(rc, "scaleLetterbox", function(n) {
        return n.p3;
    }, ri, A4(rc, "scaleAspectRatio", function(n) {
        return n.p1;
    }, ri, A4(rc, "heightScale", function(n) {
        return n.fm;
    }, uc, A4(rc, "widthScale", function(n) {
        return n.ig;
    }, uc, Mi(CA)))))), PA = function(n) {
        switch(n){
            case "PARTIAL":
                return At(0);
            case "COMPLETE":
                return At(1);
            case "COMPLETE_WITHOUT_PARTIAL":
                return At(2);
            case "SDH":
                return At(3);
            default:
                return Ct("Not a subtitle type version");
        }
    }, SA = function(n) {
        switch(n){
            case 0:
                return "PARTIAL";
            case 1:
                return "COMPLETE";
            case 2:
                return "COMPLETE_WITHOUT_PARTIAL";
            default:
                return "SDH";
        }
    }, AA = A2(Ml, SA, PA), yA = F2(function(n, r) {
        return {
            en: n,
            fL: r
        };
    }), NA = Fi(A4(rc, "key", function(n) {
        return n.fL;
    }, Oa, A4(rc, "bucket", function(n) {
        return n.en;
    }, Oa, Mi(yA)))), LA = F2(function(n, r) {
        return {
            dY: r,
            ec: n
        };
    }), jA = F8(function(n, r, t, e, u, o, a, i) {
        return {
            dX: e,
            eU: t,
            fv: n,
            c$: r,
            hf: o,
            hh: a,
            du: u,
            hI: i
        };
    }), FA = function(n) {
        switch(n){
            case "Mire":
                return At(0);
            case "Black":
                return At(1);
            case "Slate":
                return At(2);
            case "Video":
                return At(3);
            case "Countdown":
                return At(4);
            default:
                return Ct("not a Segment Kind");
        }
    }, MA = function(n) {
        switch(n){
            case 0:
                return "Mire";
            case 1:
                return "Black";
            case 2:
                return "Slate";
            case 3:
                return "Video";
            default:
                return "Countdown";
        }
    }, IA = A2(Ml, MA, FA), DA = Fi(A4(rc, "subtract", function(n) {
        return n.hI;
    }, ri, A4(qi, "sourceKey", function(n) {
        return n.hh;
    }, Oa, A4(qi, "sourceBucket", function(n) {
        return n.hf;
    }, Oa, A4(qi, "sourceName", function(n) {
        return n.du;
    }, Oa, A4(rc, "additionalFrameCount", function(n) {
        return n.dX;
    }, uc, A4(rc, "duration", function(n) {
        return n.eU;
    }, uc, A4(rc, "kind", function(n) {
        return n.c$;
    }, IA, A4(rc, "index", function(n) {
        return n.fv;
    }, uc, Mi(jA)))))))))), BA = Fi(A4(rc, "after", function(n) {
        return n.dY;
    }, ic(DA), A4(rc, "before", function(n) {
        return n.ec;
    }, ic(DA), Mi(LA)))), xA = Fi(A4(qi, "subtitlesSettings", function(n) {
        return n.dx;
    }, NA, A4(rc, "copyMetadata", function(n) {
        return n.kc;
    }, ri, A4(qi, "subtitleFormat", function(n) {
        return n.rn;
    }, Oa, A4(qi, "subtitleTypeVersion", function(n) {
        return n.rs;
    }, AA, A4(qi, "subtitleVersion", function(n) {
        return n.rt;
    }, g$, A4(rc, "qcReportTemplate", function(n) {
        return n.ps;
    }, Oa, A4(rc, "qcTestPlan", function(n) {
        return n.pt;
    }, Oa, A4(qi, "hevcParams", function(n) {
        return n.F;
    }, gA, A4(qi, "clip", function(n) {
        return n.bG;
    }, iA, A4(qi, "scale", function(n) {
        return n.aU;
    }, TA, A4(qi, "crop", function(n) {
        return n.aG;
    }, fA, A4(rc, "encodeSubtitle", function(n) {
        return n.li;
    }, ri, A4(qi, "videoBitrate", function(n) {
        return n.sF;
    }, dA, A4(rc, "writeTimecode", function(n) {
        return n.sN;
    }, ri, A4(qi, "videoEdit", function(n) {
        return n.dM;
    }, BA, A4(qi, "audioGain", function(n) {
        return n.i4;
    }, dA, A4(qi, "loudnessTruePeak", function(n) {
        return n.nu;
    }, dA, A4(qi, "loudnessProgram", function(n) {
        return n.ns;
    }, dA, A4(qi, "loudnessRange", function(n) {
        return n.nt;
    }, dA, A4(qi, "noLoudness", function(n) {
        return n.oj;
    }, ri, A4(qi, "options", function(n) {
        return n.M;
    }, kA, A4(qi, "bmxArgs", function(n) {
        return n.jk;
    }, Oa, A4(qi, "audioArgs", function(n) {
        return n.i0;
    }, Oa, A4(qi, "ffmpegArgs", function(n) {
        return n.lB;
    }, Oa, A4(rc, "noFrameRateConversion", function(n) {
        return n.oi;
    }, ri, A4(rc, "frameRate", function(n) {
        return n.lW;
    }, $A, A4(rc, "startTimecode", function(n) {
        return n.q5;
    }, Oa, A4(qi, "audioBitrate", function(n) {
        return n.i1;
    }, uc, A4(rc, "audioCodec", function(n) {
        return n.i2;
    }, oA, A4(rc, "specification", function(n) {
        return n.qZ;
    }, pA, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(w) {
                                                                                return function(g) {
                                                                                    return function(h) {
                                                                                        return function(k) {
                                                                                            return function(C) {
                                                                                                return function(T) {
                                                                                                    return function(P) {
                                                                                                        return function(S) {
                                                                                                            return function(A) {
                                                                                                                return function(y) {
                                                                                                                    return function(N) {
                                                                                                                        return function(L) {
                                                                                                                            return function(j) {
                                                                                                                                return function(F) {
                                                                                                                                    return {
                                                                                                                                        i0: f,
                                                                                                                                        i1: u,
                                                                                                                                        i2: e,
                                                                                                                                        i4: v,
                                                                                                                                        jk: s,
                                                                                                                                        bG: T,
                                                                                                                                        kc: j,
                                                                                                                                        aG: k,
                                                                                                                                        li: h,
                                                                                                                                        lB: c,
                                                                                                                                        lW: a,
                                                                                                                                        F: P,
                                                                                                                                        mo: n,
                                                                                                                                        ns: b,
                                                                                                                                        nt: m,
                                                                                                                                        nu: p,
                                                                                                                                        n6: r,
                                                                                                                                        oi: i,
                                                                                                                                        oj: d,
                                                                                                                                        M: l,
                                                                                                                                        ps: A,
                                                                                                                                        pt: S,
                                                                                                                                        aU: C,
                                                                                                                                        qZ: t,
                                                                                                                                        q5: o,
                                                                                                                                        rn: L,
                                                                                                                                        rs: N,
                                                                                                                                        rt: y,
                                                                                                                                        dx: F,
                                                                                                                                        sF: g,
                                                                                                                                        dM: $,
                                                                                                                                        sN: w
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))))))))))))), qA = ic(xA), VA = function(n) {
        return {
            $: 10,
            a: n
        };
    }, OA = dl(VA({
        $: 0
    })), zA = mc(A2(Wi, qA, Ai(OA))), EA = ic($A), HA = dl(VA({
        $: 2
    })), RA = mc(A2(Wi, EA, Ai(HA))), WA = F7(function(n, r, t, e, u, o, a) {
        return {
            kV: o,
            lE: t,
            mo: n,
            n6: r,
            b2: a,
            ro: u,
            rr: e
        };
    }), UA = function(n) {
        switch(n){
            case "open_subtitling":
                return At(0);
            case "teletext_level_1":
                return At(1);
            case "teletext_level_2":
                return At(2);
            default:
                return Ct(A2(ka, "Unknown subtitle display standard", s$));
        }
    }, QA = function(n) {
        switch(n){
            case 0:
                return "open_subtitling";
            case 1:
                return "teletext_level_1";
            default:
                return "teletext_level_2";
        }
    }, _A = A2(Ml, QA, UA), ZA = function(n) {
        switch(n){
            case "STL":
                return At(0);
            case "WebVTT":
                return At(1);
            case "SRT":
                return At(2);
            case "ASS":
                return At(3);
            default:
                return Ct(A2(ka, "Unknown subtitle file format", s$));
        }
    }, KA = function(n) {
        switch(n){
            case 0:
                return "STL";
            case 1:
                return "WebVTT";
            case 2:
                return "SRT";
            default:
                return "ASS";
        }
    }, XA = A2(Ml, KA, ZA), JA = Fi(A4(qi, "offset", function(n) {
        return n.b2;
    }, Oa, A4(qi, "display_standard", function(n) {
        return n.kV;
    }, _A, A4(qi, "frame_rate", function(n) {
        return n.ro;
    }, $A, A4(qi, "start_timecode", function(n) {
        return n.rr;
    }, Oa, A4(rc, "format", function(n) {
        return n.lE;
    }, XA, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(WA))))))))), YA = ic(JA), GA = function(n) {
        return {
            $: 11,
            a: n
        };
    }, ny = dl(GA({
        $: 0
    })), ry = mc(A2(Wi, YA, Ai(ny))), ty = F3(function(n, r, t) {
        return {
            bA: t,
            mo: n,
            n6: r
        };
    }), ey = Fi(A4(rc, "batonIdentifier", function(n) {
        return n.bA;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(ty))))), uy = ic(ey), oy = function(n) {
        return {
            $: 9,
            a: n
        };
    }, ay = dl(oy({
        $: 0
    })), iy = A2(Yb, Ji, A2(Yb, Ye(function(n) {
        return d(n.mo, n);
    }), mc(A2(Wi, uy, Ai(ay))))), cy = F5(function(n, r, t, e, u) {
        return A2(Ge, function(r) {
            return A2(Ge, function(t) {
                return A2(Ge, function(e) {
                    return A2(Ge, function(u) {
                        return Ze(A4(n, r, t, e, u));
                    }, u);
                }, e);
            }, t);
        }, r);
    }), fy = cy, sy = A2(Xa, rA, A5(fy, tA, zA, RA, iy, ry)), ly = d(nA, sy), dy = function(n) {
        return {
            $: 59,
            a: n
        };
    }, my = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), by = Q, py = xa({
        bN: "Add after video...",
        bT: "Ajouter apr\xe8s la vid\xe9o..."
    }), vy = xa({
        bN: "Add before video...",
        bT: "Ajouter avant la vid\xe9o..."
    }), $y = k([
        d("Mire", "Mire"),
        d("Black", "Noir"),
        d("Slate", "Panneau"),
        d("Video", "Video"),
        d("Countdown", "Compte \xe0 rebours")
    ]), wy = function(n) {
        var r, t = A2(ju, "", A2(Lu, function(n) {
            return n.fL;
        }, A2(sp, function(n) {
            return n.dx;
        }, n))), e = A2(ju, "", A2(Lu, function(n) {
            return n.en;
        }, A2(sp, function(n) {
            return n.dx;
        }, n))), u = A2(ju, "", A2(Lu, w$, A2(sp, function(n) {
            return n.rt;
        }, n))), o = A2(ju, "", A2(Lu, SA, A2(sp, function(n) {
            return n.rs;
        }, n))), a = A2(ju, "", A2(sp, function(n) {
            return n.rn;
        }, n)), i = function(n) {
            return A2(Pi, Lu(n), ju(""));
        };
        return {
            iB: za(function(r) {
                return p(r, {
                    m7: "AFD",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return A2(sp, function(n) {
                            return n.iB;
                        }, n.M);
                    }, n)))
                });
            }),
            iX: ti(function(r) {
                return p(r, {
                    m7: "AS10",
                    sw: A2(ju, !1, A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return n.iX;
                        }, n.M);
                    }, n))
                });
            }),
            iY: ti(function(r) {
                return p(r, {
                    m7: "AS11",
                    sw: A2(ju, !1, A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return n.iY;
                        }, n.M);
                    }, n))
                });
            }),
            i0: za(function(r) {
                return p(r, {
                    m7: "Args",
                    sw: A2(ju, "", A2(sp, function(n) {
                        return n.i0;
                    }, n))
                });
            }),
            i1: za(function(r) {
                return p(r, {
                    m7: "Audio Bitrate (kb/s)",
                    sw: A2(ju, "384", A2(Lu, Mt, A2(sp, function(n) {
                        return n.i1;
                    }, n)))
                });
            }),
            i2: za(function(r) {
                return p(r, {
                    m7: "Codec",
                    sw: A2(i, A2(Pi, function(n) {
                        return n.i2;
                    }, uA), n)
                });
            }),
            i4: za(function(r) {
                return p(r, {
                    m7: "Gain",
                    sw: A2(ju, "0", A2(Lu, by, A2(sp, function(n) {
                        return n.i4;
                    }, n)))
                });
            }),
            jk: za(function(r) {
                return p(r, {
                    m7: "BMX Args",
                    sw: A2(ju, "", A2(sp, function(n) {
                        return n.jk;
                    }, n))
                });
            }),
            jw: ti(function(n) {
                return p(n, {
                    m7: "Burned subtitle",
                    sw: "" !== u && "" !== o
                });
            }),
            jy: ti(function(r) {
                return p(r, {
                    m7: "BWF wrapping",
                    sw: A2(ju, !1, A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return n.jy;
                        }, n.M);
                    }, n))
                });
            }),
            jS: za(function(r) {
                return p(r, {
                    m7: "value max (luminance)",
                    sw: A2(ju, "235", A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return Mt(n.jS);
                        }, n.bG);
                    }, n))
                });
            }),
            jT: za(function(r) {
                return p(r, {
                    m7: "Value min (luminance)",
                    sw: A2(ju, "16", A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return Mt(n.jT);
                        }, n.bG);
                    }, n))
                });
            }),
            jW: za(function(r) {
                return p(r, {
                    m7: "Color Primaries",
                    sw: A2(ju, "bt709", A2(Lu, function(n) {
                        return n.jW;
                    }, A2(sp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            jX: za(function(r) {
                return p(r, {
                    m7: "Colorspace",
                    sw: A2(ju, "bt709", A2(Lu, function(n) {
                        return n.jX;
                    }, A2(sp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            j9: ti(function(r) {
                return p(r, {
                    m7: "Control instantaneous bitrate",
                    sw: A2(ju, !1, A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return n.j9;
                        }, n.M);
                    }, n))
                });
            }),
            kc: ti(function(r) {
                return p(r, {
                    m7: "Copy metadata",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.kc;
                    }, n))
                });
            }),
            kj: za(function(r) {
                return p(r, {
                    m7: "Crop pixel bottom",
                    sw: A2(ju, "0", A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return Mt(n.ek);
                        }, n.aG);
                    }, n))
                });
            }),
            kk: za(function(r) {
                return p(r, {
                    m7: "Crop pixel left",
                    sw: A2(ju, "0", A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return Mt(n.fP);
                        }, n.aG);
                    }, n))
                });
            }),
            kl: za(function(r) {
                return p(r, {
                    m7: "Crop pixel right",
                    sw: A2(ju, "0", A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return Mt(n.gV);
                        }, n.aG);
                    }, n))
                });
            }),
            km: za(function(r) {
                return p(r, {
                    m7: "Crop pixel top",
                    sw: A2(ju, "0", A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return Mt(n.h0);
                        }, n.aG);
                    }, n))
                });
            }),
            ku: za(function(r) {
                return p(r, {
                    m7: "CurveTransfert",
                    sw: A2(ju, "bt709", A2(Lu, function(n) {
                        return n.ku;
                    }, A2(sp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            kF: ti(function(r) {
                return p(r, {
                    m7: "Force deinterlacing",
                    sw: A2(ju, !1, A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return n.kF;
                        }, n.M);
                    }, n))
                });
            }),
            li: ti(function(r) {
                return p(r, {
                    m7: "Encode ASS Subtitle File",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.li;
                    }, n))
                });
            }),
            lB: za(function(r) {
                return p(r, {
                    m7: "Args",
                    sw: A2(ju, "", A2(sp, function(n) {
                        return n.lB;
                    }, n))
                });
            }),
            lW: za(function(r) {
                return p(r, {
                    m7: "FrameRate",
                    sw: A2(i, A2(Pi, function(n) {
                        return n.lW;
                    }, function(n) {
                        return n.mo;
                    }), n)
                });
            }),
            me: ti(function(r) {
                return p(r, {
                    m7: "HighTiers",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.me;
                    }, A2(sp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            m4: za(function(r) {
                return p(r, {
                    m7: "Keyframe",
                    sw: A2(ju, "250", A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return Mt(n.m4);
                        }, n.F);
                    }, n))
                });
            }),
            nf: za(function(r) {
                return p(r, {
                    m7: "Level",
                    sw: A2(ju, "0", A2(Lu, function(n) {
                        return n.nf;
                    }, A2(sp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            ns: za(function(r) {
                return p(r, {
                    m7: "Target Program Loudness",
                    sw: A2(ju, "-23", A2(Lu, by, A2(sp, function(n) {
                        return n.ns;
                    }, n)))
                });
            }),
            nt: za(function(r) {
                return p(r, {
                    m7: "Target Loudness Range",
                    sw: A2(ju, "11", A2(Lu, by, A2(sp, function(n) {
                        return n.nt;
                    }, n)))
                });
            }),
            nu: za(function(r) {
                return p(r, {
                    m7: "Target True Peak",
                    sw: A2(ju, "-1.3", A2(Lu, by, A2(sp, function(n) {
                        return n.nu;
                    }, n)))
                });
            }),
            n6: za(function(r) {
                return p(r, {
                    m7: "Name",
                    sw: A2(i, function(n) {
                        return n.n6;
                    }, n)
                });
            }),
            oi: ti(function(r) {
                return p(r, {
                    m7: "No FrameRate Conversion",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.oi;
                    }, n))
                });
            }),
            oj: ti(function(r) {
                return p(r, {
                    m7: "No Loudness",
                    sw: A2(ju, !1, A2(sp, function(n) {
                        return n.oj;
                    }, n))
                });
            }),
            oS: n,
            pe: za(function(r) {
                return p(r, {
                    m7: "Preset",
                    sw: A2(ju, "medium", A2(Lu, function(n) {
                        return n.pe;
                    }, A2(sp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            pj: za(function(r) {
                return p(r, {
                    m7: "Profil",
                    sw: A2(ju, "main", A2(Lu, function(n) {
                        return n.pj;
                    }, A2(sp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            ps: za(function(r) {
                return p(r, {
                    m7: "QC report template",
                    sw: A2(ju, "", A2(Lu, function(n) {
                        return n.ps;
                    }, n))
                });
            }),
            pt: za(function(r) {
                return p(r, {
                    m7: "QC test plan",
                    sw: A2(ju, "", A2(Lu, function(n) {
                        return n.pt;
                    }, n))
                });
            }),
            pv: za(function(r) {
                return p(r, {
                    m7: "Overwrite qmax",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return A2(sp, function(n) {
                            return n.pv;
                        }, n.M);
                    }, n)))
                });
            }),
            p1: ti(function(r) {
                return p(r, {
                    m7: "Enable Keep aspect ratio",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.p1;
                    }, A2(sp, function(n) {
                        return n.aU;
                    }, n)))
                });
            }),
            p2: za(function(r) {
                return p(r, {
                    m7: "Height",
                    sw: A2(ju, "1080", A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return Mt(n.fm);
                        }, n.aU);
                    }, n))
                });
            }),
            p3: ti(function(r) {
                return p(r, {
                    m7: "Enable Letterbox and Pillarbox",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.p3;
                    }, A2(sp, function(n) {
                        return n.aU;
                    }, n)))
                });
            }),
            p4: za(function(r) {
                return p(r, {
                    m7: "Width",
                    sw: A2(ju, "1920", A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return Mt(n.ig);
                        }, n.aU);
                    }, n))
                });
            }),
            qB: ti(function(r) {
                return p(r, {
                    m7: "Clip / PSE Parameters",
                    sw: A2(ju, !1, A2(sp, function(n) {
                        return A2(Lu, function() {
                            return !0;
                        }, n.bG);
                    }, n))
                });
            }),
            qC: ti(function(r) {
                return p(r, {
                    m7: "Crop Parameters",
                    sw: A2(ju, !1, A2(sp, function(n) {
                        return A2(Lu, function() {
                            return !0;
                        }, n.aG);
                    }, n))
                });
            }),
            qI: ti(function(r) {
                return p(r, {
                    m7: "HEVC : ",
                    sw: A2(ju, !0, A2(sp, function(n) {
                        return A2(Lu, function() {
                            return !0;
                        }, n.F);
                    }, n))
                });
            }),
            qM: ti(function(r) {
                return p(r, {
                    m7: "Scale Parameters",
                    sw: A2(ju, !1, A2(sp, function(n) {
                        return A2(Lu, function() {
                            return !0;
                        }, n.aU);
                    }, n))
                });
            }),
            qZ: za(function(r) {
                return p(r, {
                    m7: "Specification",
                    sw: A2(i, A2(Pi, function(n) {
                        return n.qZ;
                    }, bA), n)
                });
            }),
            q5: za(function(r) {
                return p(r, {
                    m7: "Start Timecode",
                    sw: A2(i, function(n) {
                        return n.q5;
                    }, n)
                });
            }),
            rf: ht((r = n.$ ? kt : n.a.dM, {
                iC: p(fs, {
                    jN: $y,
                    gw: py
                }),
                jg: p(fs, {
                    jN: $y,
                    gw: vy
                }),
                dM: A2(ju, A2(LA, w, w), r)
            })),
            rn: za(function(n) {
                return p(n, {
                    m7: "Subtitle format",
                    sw: a
                });
            }),
            rs: za(function(n) {
                return p(n, {
                    m7: "Subtitle type version",
                    sw: o
                });
            }),
            rt: za(function(n) {
                return p(n, {
                    m7: "Subtitle version",
                    sw: u
                });
            }),
            rw: za(function(n) {
                return p(n, {
                    m7: "bucket",
                    sw: e
                });
            }),
            rx: ti(function(n) {
                return p(n, {
                    m7: "Settings file (.txt)",
                    sw: "" !== e && "" !== t
                });
            }),
            ry: za(function(n) {
                return p(n, {
                    m7: "key",
                    sw: t
                });
            }),
            sA: ti(function(r) {
                return p(r, {
                    m7: "Version 1.2",
                    sw: A2(ju, !1, A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return n.sA;
                        }, n.M);
                    }, n))
                });
            }),
            sF: za(function(r) {
                return p(r, {
                    m7: "Bitrate (Mbits/s)",
                    sw: A2(ju, "5", A2(Lu, by, A2(sp, function(n) {
                        return n.sF;
                    }, n)))
                });
            }),
            sN: ti(function(r) {
                return p(r, {
                    m7: "Write Timecode",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.sN;
                    }, n))
                });
            })
        };
    }, gy = k([
        0,
        12
    ]), hy = k([
        1,
        11,
        7,
        8,
        10,
        9,
        4,
        14
    ]), ky = function(n) {
        return {
            $: 53,
            a: n
        };
    }, Cy = k([
        16
    ]), Ty = {
        lC: Su,
        c$: 3,
        nP: "",
        ar: va,
        N: !0,
        P: 500,
        ag: !1
    }, Py = k([
        0,
        2,
        3,
        5,
        6,
        12,
        13,
        1,
        11,
        7,
        8,
        10,
        9,
        4,
        14
    ]), Sy = F4(function(n, r, t, e) {
        return {
            d6: r,
            ho: n,
            hF: e,
            hG: t
        };
    }), Ay = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? kt : ht(A2(n, r.a, t.a));
    }), yy = F5(function(n, r, t, e, u) {
        return 1 === r.$ || 1 === t.$ || 1 === e.$ || 1 === u.$ ? kt : ht(A4(n, r.a, t.a, e.a, u.a));
    }), Ny = F5(function(n, r, t, e, u) {
        if (1 === r.$) return Ct(r.a);
        var o = r.a;
        if (1 === t.$) return Ct(t.a);
        var a = t.a;
        if (1 === e.$) return Ct(e.a);
        var i = e.a;
        return 1 === u.$ ? Ct(u.a) : At(A4(n, o, a, i, u.a));
    }), Ly = k([
        1,
        4,
        7,
        8,
        10,
        11,
        9
    ]), jy = k([
        0,
        5,
        6,
        12,
        13
    ]), Fy = k([
        0,
        12,
        6
    ]), My = function(n) {
        var r = function(r) {
            return A2(Y$, r, Cy) ? n.sN.sw : !A2(Y$, r, Ly) || n.sN.sw;
        }, t = function(r) {
            return 1 === r || 11 === r || 10 === r || 8 === r || 9 === r || 14 === r ? _f(n.sF.sw) : kt;
        }, e = "" === n.rt.sw ? At(kt) : A2(X$, function(n) {
            return ht(n);
        }, $$(n.rt.sw)), u = n.rx.sw ? ht({
            en: n.rw.sw,
            fL: n.ry.sw
        }) : kt, o = A2(ha, function(n) {
            return A2(ka, n, Ty);
        }, e), a = "" === n.rn.sw ? kt : ht(n.rn.sw), i = "" === n.rs.sw ? At(kt) : A2(X$, function(n) {
            return ht(n);
        }, PA(n.rs.sw)), c = A2(ha, function(n) {
            return A2(ka, n, Ty);
        }, i), f = mA(n.qZ.sw), s = function(r) {
            return 6 !== r && 4 !== r && n.qM.sw ? A3(Ay, F2(function(r, t) {
                return {
                    fm: t,
                    p1: n.p1.sw,
                    p3: n.p3.sw,
                    ig: r
                };
            }), He(n.p4.sw), He(n.p2.sw)) : kt;
        }, l = function(r) {
            return A2(Y$, r, jy) ? ht({
                iB: "" === n.iB.sw ? kt : He(n.iB.sw),
                iX: !!A2(Y$, r, gy) && n.iX.sw,
                iY: 5 === r && n.iY.sw,
                jy: n.jy.sw,
                j9: !!A2(Y$, r, gy) && n.j9.sw,
                kF: n.kF.sw,
                pv: A2(Y$, r, Fy) && "" !== n.pv.sw ? He(n.pv.sw) : kt,
                sA: !!A2(Y$, r, gy) && n.sA.sw
            }) : kt;
        }, d = function(r) {
            return A2(Y$, r, Py) ? ht(n.oj.sw) : kt;
        }, m = function(r) {
            return A2(Y$, r, Py) && !n.oj.sw ? _f(n.nu.sw) : kt;
        }, b = function(r) {
            return A2(Y$, r, Py) && !n.oj.sw ? _f(n.nt.sw) : kt;
        }, p = function(r) {
            return A2(Y$, r, Py) && !n.oj.sw ? _f(n.ns.sw) : kt;
        }, v = function(r) {
            return n.qI.sw || 11 === r || 10 === r ? A2(Lu, function(r) {
                return {
                    jW: n.jW.sw,
                    jX: n.jX.sw,
                    ku: n.ku.sw,
                    me: n.me.sw,
                    m4: r,
                    nf: n.nf.sw,
                    pe: n.pe.sw,
                    pj: n.pj.sw
                };
            }, He(n.m4.sw)) : kt;
        }, $ = "" === n.lB.sw ? kt : ht(n.lB.sw), w = function(r) {
            return 4 === r && n.li.sw;
        }, g = function(r) {
            return 4 !== r && n.qC.sw ? A5(yy, F4(function(n, r, t, e) {
                return {
                    ek: e,
                    fP: n,
                    gV: r,
                    h0: t
                };
            }), He(n.kk.sw), He(n.kl.sw), He(n.km.sw), He(n.kj.sw)) : kt;
        }, h = n.qB.sw ? A3(Ay, F2(function(n, r) {
            return {
                jS: r,
                jT: n
            };
        }), He(n.jT.sw), He(n.jS.sw)) : kt, k = "" === n.jk.sw ? kt : ht(n.jk.sw), C = function(r) {
            return A2(Y$, r, Py) && !n.oj.sw ? _f(n.i4.sw) : kt;
        }, T = eA(n.i2.sw), P = "" === n.i0.sw ? kt : ht(n.i0.sw);
        return A2(X$, function(e) {
            var o, i = e.ho, c = e.d6, f = e.hG, T = e.hF;
            return {
                i0: P,
                i1: (o = i, 1 === o || 16 === o || 11 === o || 10 === o || 8 === o || 9 === o || 14 === o ? He(n.i1.sw) : kt),
                i2: c,
                i4: C(i),
                jk: k,
                bG: h,
                kc: n.kc.sw,
                aG: g(i),
                li: w(i),
                lB: $,
                lW: n.lW.sw,
                F: v(i),
                ns: p(i),
                nt: b(i),
                nu: m(i),
                n6: n.n6.sw,
                oi: n.oi.sw,
                oj: d(i),
                M: l(i),
                ps: n.ps.sw,
                pt: n.pt.sw,
                aU: s(i),
                qZ: i,
                q5: n.q5.sw,
                rn: a,
                rs: T,
                rt: f,
                dx: u,
                sF: t(i),
                dM: A2(Lu, function(n) {
                    return n.dM;
                }, n.rf),
                sN: r(i)
            };
        }, A5(Ny, Sy, f, T, o, c));
    }, Iy = Fi(A4(qi, "subtitlesSettings", function(n) {
        return n.dx;
    }, NA, A4(rc, "copyMetadata", function(n) {
        return n.kc;
    }, ri, A4(qi, "subtitleFormat", function(n) {
        return n.rn;
    }, Oa, A4(qi, "subtitleTypeVersion", function(n) {
        return n.rs;
    }, AA, A4(qi, "subtitleVersion", function(n) {
        return n.rt;
    }, g$, A4(rc, "qcReportTemplate", function(n) {
        return n.ps;
    }, Oa, A4(rc, "qcTestPlan", function(n) {
        return n.pt;
    }, Oa, A4(qi, "hevcParams", function(n) {
        return n.F;
    }, gA, A4(qi, "clip", function(n) {
        return n.bG;
    }, iA, A4(qi, "scale", function(n) {
        return n.aU;
    }, TA, A4(qi, "crop", function(n) {
        return n.aG;
    }, fA, A4(qi, "videoEdit", function(n) {
        return n.dM;
    }, BA, A4(rc, "encodeSubtitle", function(n) {
        return n.li;
    }, ri, A4(qi, "videoBitrate", function(n) {
        return n.sF;
    }, dA, A4(rc, "writeTimecode", function(n) {
        return n.sN;
    }, ri, A4(qi, "audioGain", function(n) {
        return n.i4;
    }, dA, A4(qi, "loudnessTruePeak", function(n) {
        return n.nu;
    }, dA, A4(qi, "loudnessProgram", function(n) {
        return n.ns;
    }, dA, A4(qi, "loudnessRange", function(n) {
        return n.nt;
    }, dA, A4(qi, "noLoudness", function(n) {
        return n.oj;
    }, ri, A4(qi, "options", function(n) {
        return n.M;
    }, kA, A4(qi, "bmxArgs", function(n) {
        return n.jk;
    }, Oa, A4(qi, "audioArgs", function(n) {
        return n.i0;
    }, Oa, A4(qi, "ffmpegArgs", function(n) {
        return n.lB;
    }, Oa, A4(rc, "noFrameRateConversion", function(n) {
        return n.oi;
    }, ri, A4(rc, "frameRate", function(n) {
        return n.lW;
    }, Oa, A4(rc, "startTimecode", function(n) {
        return n.q5;
    }, Oa, A4(qi, "audioBitrate", function(n) {
        return n.i1;
    }, uc, A4(rc, "audioCodec", function(n) {
        return n.i2;
    }, oA, A4(rc, "specification", function(n) {
        return n.qZ;
    }, pA, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(w) {
                                                                                return function(g) {
                                                                                    return function(h) {
                                                                                        return function(k) {
                                                                                            return function(C) {
                                                                                                return function(T) {
                                                                                                    return function(P) {
                                                                                                        return function(S) {
                                                                                                            return function(A) {
                                                                                                                return function(y) {
                                                                                                                    return function(N) {
                                                                                                                        return function(L) {
                                                                                                                            return function(j) {
                                                                                                                                return {
                                                                                                                                    i0: c,
                                                                                                                                    i1: e,
                                                                                                                                    i2: t,
                                                                                                                                    i4: p,
                                                                                                                                    jk: f,
                                                                                                                                    bG: C,
                                                                                                                                    kc: L,
                                                                                                                                    aG: h,
                                                                                                                                    li: w,
                                                                                                                                    lB: i,
                                                                                                                                    lW: o,
                                                                                                                                    F: T,
                                                                                                                                    ns: m,
                                                                                                                                    nt: d,
                                                                                                                                    nu: b,
                                                                                                                                    n6: n,
                                                                                                                                    oi: a,
                                                                                                                                    oj: l,
                                                                                                                                    M: s,
                                                                                                                                    ps: S,
                                                                                                                                    pt: P,
                                                                                                                                    aU: k,
                                                                                                                                    qZ: r,
                                                                                                                                    q5: u,
                                                                                                                                    rn: N,
                                                                                                                                    rs: y,
                                                                                                                                    rt: A,
                                                                                                                                    dx: j,
                                                                                                                                    sF: $,
                                                                                                                                    dM: g,
                                                                                                                                    sN: v
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))))))), Dy = function(n) {
        return n.N || n.ag ? {
            lC: Su,
            nP: Ei,
            P: n.P
        } : {
            lC: n.lC,
            nP: n.nP,
            P: n.P
        };
    }, By = Ui, xy = function(n) {
        return n.$ ? By(n.a) : iP(n.a);
    }, qy = function(n) {
        return A2(Xa, ky, A2(BT, function(n) {
            return mc(A2(nw, xA, A3(ow, Iy, n, rw(OA))));
        }, A2(Qi, Dy, xy(My(n)))));
    }, Vy = function(n) {
        return {
            $: 56,
            a: n
        };
    }, Oy = function(n) {
        return dl(VA({
            $: 1,
            a: n
        }));
    }, zy = function(n) {
        return {
            $: 54,
            a: n
        };
    }, Ey = F2(function(n, r) {
        return A2(BT, function(r) {
            return mc(A2(Wi, xA, A3(ow, Iy, r, dw(Oy(n.mo)))));
        }, A2(Qi, Dy, xy(My(r))));
    }), Hy = F2(function(n, r) {
        return A2(Xa, zy, A2(Ey, n, r));
    }), Ry = F2(function(n, r) {
        var t = r.b;
        return d(n(r.a), t);
    }), Wy = F2(function(n, r) {
        return "Mire" === n ? {
            dX: 0,
            eU: 10,
            fv: r,
            c$: 0,
            hf: kt,
            hh: kt,
            du: kt,
            hI: !1
        } : "Slate" === n ? {
            dX: 0,
            eU: 10,
            fv: r,
            c$: 2,
            hf: kt,
            hh: kt,
            du: kt,
            hI: !1
        } : "Video" === n ? {
            dX: 0,
            eU: 10,
            fv: r,
            c$: 3,
            hf: kt,
            hh: kt,
            du: kt,
            hI: !1
        } : "Countdown" === n ? {
            dX: 0,
            eU: 10,
            fv: r,
            c$: 4,
            hf: kt,
            hh: kt,
            du: kt,
            hI: !1
        } : {
            dX: 0,
            eU: 10,
            fv: r,
            c$: 1,
            hf: kt,
            hh: kt,
            du: kt,
            hI: !1
        };
    }), Uy = F3(function(n, r, t) {
        var e = n ? t.ec : t.dY, u = $(e, k([
            A2(Wy, r, qt(e))
        ]));
        return p(t, n ? {
            ec: u
        } : {
            dY: u
        });
    }), Qy = F2(function(n, r) {
        return A2(Ye, function(n) {
            return p(n.b, {
                fv: n.a
            });
        }, A2(Ht, V$, A2(Kc, function(r) {
            var t = r.b;
            return a(r.a, n) ? kt : ht(t);
        }, A2(Ye, function(n) {
            return d(n.fv, n);
        }, r))));
    }), _y = F2(function(n, r) {
        return p(r, {
            dY: A2(Qy, n, r.dY)
        });
    }), Zy = F2(function(n, r) {
        return p(r, {
            ec: A2(Qy, n, r.ec)
        });
    }), Ky = function(n) {
        return p(n, {
            gk: !n.gk
        });
    }, Xy = F2(function(n, r) {
        switch(n.$){
            case 0:
                return r;
            case 1:
                var t = He(n.a);
                return t.$ ? r : p(r, {
                    eU: t.a
                });
            case 2:
                var e = He(n.a);
                return e.$ ? r : p(r, {
                    dX: e.a
                });
            case 4:
                return p(r, {
                    du: ht(n.a)
                });
            case 3:
                return p(r, {
                    hf: ht(n.a)
                });
            case 5:
                return p(r, {
                    hh: ht(n.a)
                });
            default:
                return p(r, {
                    hI: n.a
                });
        }
    }), Jy = F4(function(n, r, t, e) {
        var u = A2(Ye, function(n) {
            return a(r, n.fv) ? A2(Xy, t, n) : n;
        }, n ? e.ec : e.dY);
        return p(e, n ? {
            ec: u
        } : {
            dY: u
        });
    }), Yy = F2(function(n, r) {
        n: for(;;){
            if (n.$) return A2(pc, w, p(r, n.b.$ ? {
                dM: A3(Uy, n.a, n.b.a, r.dM)
            } : n.a ? {
                jg: Ky(r.jg)
            } : {
                iC: Ky(r.iC)
            }));
            if (n.a) {
                if (n.c.$) break n;
                return A2(pc, w, p(r, {
                    dM: A2(Zy, n.b, r.dM)
                }));
            }
            if (n.c.$) break n;
            return A2(pc, w, p(r, {
                dM: A2(_y, n.b, r.dM)
            }));
        }
        return A2(pc, w, p(r, {
            dM: A4(Jy, n.a, n.b, n.c, r.dM)
        }));
    }), Gy = F2(function(n, r) {
        var t, e = (t = r.rf).$ ? d(kt, n$) : A2(Ry, ht, A2(Yy, n, t.a)), u = e.b;
        return d(ht(p(r, {
            rf: e.a
        })), u);
    }), nN = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, w, p(r, {
                    kP: ht(wy(ht(n.a)))
                }));
            case 1:
                return A2(pc, w, p(r, {
                    kP: ht(wy(kt))
                }));
            case 3:
                return A2(pc, w, p(r, {
                    kP: kt,
                    lo: kt,
                    rz: kt
                }));
            case 4:
                var t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        n6: A2(ww, t, n.n6)
                    });
                }, r.kP);
                return A2(pc, w, p(r, {
                    kP: e
                }));
            case 5:
                t = n.a;
                var u = A2(Lu, function(n) {
                    var r = A2(Y$, n.qZ.sw, A2(Ye, bA, hy)), t = A2(Y$, n.qZ.sw, A2(Ye, bA, gy));
                    return p(n, {
                        oj: n.oj.fj ? n.oj : A2(pw, n.oj, r),
                        qB: n.qB.fj ? n.qB : A2(pw, n.qB, t)
                    });
                }, e = A2(Lu, function(n) {
                    return p(n, {
                        qZ: A2(ww, t, n.qZ)
                    });
                }, r.kP));
                return A2(pc, w, p(r, {
                    kP: u
                }));
            case 6:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        i2: A2(ww, t, n.i2)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 7:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        i1: A2(ww, t, n.i1)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 8:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        q5: A2(ww, t, n.q5)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 9:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lW: A2(ww, t, n.lW)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 10:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        oi: A2(vw, t, n.oi)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 11:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lB: A2(ww, t, n.lB)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 12:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        i0: A2(ww, t, n.i0)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 13:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        jk: A2(ww, t, n.jk)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 14:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        j9: A2(vw, t, n.j9)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 15:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        iX: A2(vw, t, n.iX)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 16:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        iY: A2(vw, t, n.iY)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 17:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        jy: A2(vw, t, n.jy)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 18:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        iB: A2(ww, t, n.iB)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 19:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        sA: A2(vw, t, n.sA)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 20:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        oj: A2(vw, t, n.oj)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 21:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nt: A2(ww, t, n.nt)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 22:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        ns: A2(ww, t, n.ns)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 23:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nu: A2(ww, t, n.nu)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 24:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        i4: A2(ww, t, n.i4)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 33:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        sN: A2(vw, t, n.sN)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 34:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        li: A2(vw, t, n.li)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 35:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        kF: A2(vw, t, n.kF)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 36:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        pv: A2(ww, t, n.pv)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 41:
                t = n.a;
                var o = A2(Lu, function(n) {
                    return n.qI.sw ? p(n, {
                        m4: A2($w, n.m4, "250")
                    }) : n;
                }, e = A2(Lu, function(n) {
                    return p(n, {
                        qI: A2(vw, t, n.qI)
                    });
                }, r.kP));
                return A2(pc, w, p(r, {
                    kP: o
                }));
            case 25:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        pj: A2(ww, t, n.pj)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 26:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        pe: A2(ww, t, n.pe)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 27:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nf: A2(ww, t, n.nf)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 32:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        m4: A2(ww, t, n.m4)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 28:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        me: A2(vw, t, n.me)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 29:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        jX: A2(ww, t, n.jX)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 30:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        jW: A2(ww, t, n.jW)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 31:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        ku: A2(ww, t, n.ku)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 37:
                return t = n.a, o = A2(Lu, function(n) {
                    return n.qC.sw ? p(n, {
                        kj: A2($w, n.kj, "0"),
                        kk: A2($w, n.kk, "0"),
                        kl: A2($w, n.kl, "0"),
                        km: A2($w, n.km, "0")
                    }) : n;
                }, e = A2(Lu, function(n) {
                    return p(n, {
                        qC: A2(vw, t, n.qC)
                    });
                }, r.kP)), A2(pc, w, p(r, {
                    kP: o
                }));
            case 48:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        kk: A2(ww, t, n.kk)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 49:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        kl: A2(ww, t, n.kl)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 50:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        km: A2(ww, t, n.km)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 51:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        kj: A2(ww, t, n.kj)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 39:
                return t = n.a, o = A2(Lu, function(n) {
                    return n.qM.sw ? p(n, {
                        p2: A2($w, n.p2, "1080"),
                        p4: A2($w, n.p4, "1920")
                    }) : n;
                }, e = A2(Lu, function(n) {
                    return p(n, {
                        qM: A2(vw, t, n.qM)
                    });
                }, r.kP)), A2(pc, w, p(r, {
                    kP: o
                }));
            case 40:
                t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        qB: A2(vw, t, n.qB)
                    });
                }, r.kP);
                var a = function(n) {
                    switch(n){
                        case "ProRes422":
                        case "ProRes4444":
                        case "AVCIntra100":
                        case "XAVCIntra300":
                            return d("70", "935");
                        default:
                            return d("16", "235");
                    }
                }(A2(ju, "", A2(Lu, A2(Pi, function(n) {
                    return n.qZ;
                }, function(n) {
                    return n.sw;
                }), r.kP))), i = a.a, c = a.b;
                return o = A2(Lu, function(n) {
                    return n.qB.sw ? p(n, {
                        jS: A2($w, n.jS, c),
                        jT: A2($w, n.jT, i)
                    }) : n;
                }, e), A2(pc, w, p(r, {
                    kP: o
                }));
            case 42:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        jT: A2(ww, t, n.jT)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 43:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        jS: A2(ww, t, n.jS)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 38:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        sF: A2(ww, t, n.sF)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 46:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        p4: A2(ww, t, n.p4)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 47:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        p2: A2(ww, t, n.p2)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 44:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        p1: A2(vw, t, n.p1)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 45:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        p3: A2(vw, t, n.p3)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 59:
                t = n.a;
                var f = A2(ju, d(kt, n$), A2(Lu, Gy(t), r.kP));
                return e = f.a, A2(pc, k([
                    A2(cp, dy, f.b)
                ]), p(r, {
                    kP: e
                }));
            case 52:
                var s = r.kP;
                return A2(pc, k(1 === s.$ ? [
                    n$
                ] : 1 === (v = (e = s.a).oS).$ ? [
                    qy(e)
                ] : [
                    A2(Hy, v.a, e)
                ]), r);
            case 55:
                return A2(pc, k([
                    (b = n.a, A2(Xa, Vy, function(n) {
                        return A2(Yb, Dl(n), mc(sw(fw(Oy(n.mo)))));
                    }(b)))
                ]), r);
            case 53:
                return (l = n.a).$ ? A2(pc, w, A2(my, l.a, r)) : A2(pc, k([
                    sy
                ]), p(r, {
                    kP: kt,
                    lo: kt,
                    rz: ht("Audio mapping created")
                }));
            case 54:
                return (l = n.a).$ ? A2(pc, w, A2(my, l.a, r)) : A2(pc, k([
                    sy
                ]), p(r, {
                    kP: kt,
                    lo: kt,
                    rz: ht("Audio mapping updated")
                }));
            case 56:
                return (l = n.a).$ ? A2(pc, w, A2(my, l.a, r)) : A2(pc, k([
                    sy
                ]), r);
            case 0:
                var l;
                if ((l = n.a).$) return A2(pc, w, A2(my, l.a, r));
                var m = l.a;
                return A2(pc, w, p(r, {
                    cX: m.cX,
                    lX: m.lY,
                    dw: m.dw,
                    dB: m.dB
                }));
            case 58:
                return A2(pc, w, p(r, {
                    px: A2(ww, t = n.a, r.px)
                }));
            case 57:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            case 60:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        pt: A2(ww, t, n.pt)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 61:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        ps: A2(ww, t, n.ps)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 62:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, n.jw.sw ? {
                        jw: A2(vw, t, n.jw),
                        rn: A2($w, n.rn, ""),
                        rs: A2($w, n.rs, ""),
                        rt: A2($w, n.rt, "")
                    } : {
                        jw: A2(vw, t, n.jw)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 63:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        rt: A2(ww, t, n.rt)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 64:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        rs: A2(ww, t, n.rs)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 65:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        rn: A2(ww, t, n.rn)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 66:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        kc: A2(vw, t, n.kc)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 67:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, n.rx.sw ? {
                        rw: A2($w, n.rw, ""),
                        rx: A2(vw, t, n.rx),
                        ry: A2($w, n.ry, "")
                    } : {
                        rx: A2(vw, t, n.rx)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 68:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        rw: A2(ww, t, n.rw)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            default:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        ry: A2(ww, t, n.ry)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
        }
        var b, v;
    }), rN = {
        $: 1
    }, tN = function(n) {
        return {
            $: 58,
            a: n
        };
    }, eN = function(n) {
        return n ? "True" : "False";
    }, uN = function(n) {
        return {
            $: 2,
            a: n
        };
    }, oN = function(n) {
        return {
            $: 57,
            a: n
        };
    }, aN = function(n) {
        return {
            $: 55,
            a: n
        };
    }, iN = function(n) {
        return "left: " + Mt(n.fP) + ", right: " + Mt(n.gV) + ", top: " + Mt(n.h0) + ", bottom: " + Mt(n.ek);
    }, cN = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), fN = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: cN(r)
        });
    }), sN = F2(function(n, r) {
        var t;
        return cg({
            n6: n,
            ds: Ew((t = r, A2(bu, Ua, t))),
            dN: r
        });
    }), lN = function(n) {
        return Mt(n.c9) + "/" + Mt(n.cG);
    }, dN = function(n) {
        return "profil: " + n.pj + ", preset: " + n.pe + ", level: " + n.nf + ", colorspace: " + n.jX + ", colorPrimaries: " + n.jW + ", curveTransfert: " + n.ku + ", highTiers: " + eN(n.me) + ", keyframe: " + Mt(n.m4);
    }, mN = function(n) {
        var r, t;
        return "control instanstaneous bitrate: " + eN(n.j9) + ", as10: " + eN(n.iX) + ", as11: " + eN(n.iY) + ", use bwf wrapping: " + eN(n.jy) + ", afd: " + (1 === (t = n.iB).$ ? "N/A" : Mt(t.a)) + ", mxf version 1.2: " + eN(n.sA) + ", force deinterlacing: " + eN(n.kF) + ", overwritten qmax: " + (1 === (r = n.pv).$ ? "N/A" : Mt(r.a));
    }, bN = function(n) {
        return "width: " + Mt(n.ig) + ", height: " + Mt(n.fm) + ", keep aspect ratio: " + eN(n.p1) + ", letter/pillar box: " + eN(n.p3);
    }, pN = F2(function(n, r) {
        var t = r.rn;
        if (t.$) return "N/A";
        var e = t.a;
        return A2(ju, "N/A", Eo(A2(Ye, function(n) {
            return n.n6;
        }, A2(Mu, function(n) {
            return a(n.mo, e);
        }, n))));
    }), vN = k([
        Ow("Table")
    ]), $N = F2(function(n, r) {
        return A2(ju, "", A2(Lu, function(n) {
            return n.n6;
        }, A2(di, r.pt, n)));
    }), wN = function() {
        return k([
            Ow("TableTr")
        ]);
    }, gN = F2(function(n, r) {
        return ug({
            j_: k([
                A2(fN, "Edit", A2(bu, Pg("Edit"), uN)),
                A2(sN, "Name", function(n) {
                    return n.n6;
                }),
                A2(sN, "Specification", A2(bu, bA, function(n) {
                    return n.qZ;
                })),
                A2(sN, "Test plan", $N(n)),
                A2(sN, "Report template", function(n) {
                    return n.ps;
                }),
                A2(sN, "startTimecode", function(n) {
                    return n.q5;
                }),
                A2(sN, "FrameRate", A2(bu, lN, function(n) {
                    return n.lW;
                })),
                A2(sN, "Video Args", A2(bu, ju("N/A"), function(n) {
                    return n.lB;
                })),
                A2(sN, "Audio Args", A2(bu, ju("N/A"), function(n) {
                    return n.i0;
                })),
                A2(sN, "BMX Args", A2(bu, ju("N/A"), function(n) {
                    return n.jk;
                })),
                A2(sN, "Crop Parameters", A2(bu, A2(bu, ju("N/A"), Lu(iN)), function(n) {
                    return n.aG;
                })),
                A2(sN, "Scale Parameters", A2(bu, A2(bu, ju("N/A"), Lu(bN)), function(n) {
                    return n.aU;
                })),
                A2(sN, "Hevc Parameters", A2(bu, A2(bu, ju("N/A"), Lu(dN)), function(n) {
                    return n.F;
                })),
                A2(sN, "MXF Options", A2(bu, A2(bu, ju("N/A"), Lu(mN)), function(n) {
                    return n.M;
                })),
                A2(sN, "No Loudness", A2(bu, A2(bu, ju("N/A"), Lu(eN)), function(n) {
                    return n.oj;
                })),
                A2(sN, "Subtitle Version", A2(bu, A2(bu, ju("N/A"), Lu(w$)), function(n) {
                    return n.rt;
                })),
                A2(sN, "Subtitle Type Version", A2(bu, A2(bu, ju("N/A"), Lu(SA)), function(n) {
                    return n.rs;
                })),
                A2(sN, "Subtitle Format", pN(r)),
                A2(fN, "Delete", A2(bu, Bw(kg), aN))
            ]),
            kv: p(hg, {
                pS: wN,
                rE: vN,
                rQ: k([
                    Ow("TableTd")
                ])
            }),
            rZ: function(n) {
                return n.mo;
            },
            r_: oN
        });
    }), hN = function(n) {
        return {
            $: 15,
            a: n
        };
    }, kN = function(n) {
        return {
            $: 16,
            a: n
        };
    }, CN = function(n) {
        return {
            $: 62,
            a: n
        };
    }, TN = function(n) {
        return {
            $: 17,
            a: n
        };
    }, PN = function(n) {
        return {
            $: 14,
            a: n
        };
    }, SN = function(n) {
        return {
            $: 40,
            a: n
        };
    }, AN = function(n) {
        return {
            $: 37,
            a: n
        };
    }, yN = function(n) {
        return {
            $: 35,
            a: n
        };
    }, NN = function(n) {
        return {
            $: 41,
            a: n
        };
    }, LN = function(n) {
        return {
            $: 28,
            a: n
        };
    }, jN = function(n) {
        return {
            $: 10,
            a: n
        };
    }, FN = function(n) {
        return {
            $: 20,
            a: n
        };
    }, MN = function(n) {
        return {
            $: 39,
            a: n
        };
    }, IN = function(n) {
        return {
            $: 34,
            a: n
        };
    }, DN = function(n) {
        return {
            $: 67,
            a: n
        };
    }, BN = function(n) {
        return {
            $: 33,
            a: n
        };
    }, xN = function(n) {
        return {
            $: 19,
            a: n
        };
    }, qN = {
        $: 3
    }, VN = function(n) {
        return {
            $: 66,
            a: n
        };
    }, ON = function(n) {
        return {
            $: 18,
            a: n
        };
    }, zN = function(n) {
        return {
            $: 44,
            a: n
        };
    }, EN = function(n) {
        return {
            $: 12,
            a: n
        };
    }, HN = function(n) {
        return {
            $: 7,
            a: n
        };
    }, RN = function(n) {
        return {
            $: 6,
            a: n
        };
    }, WN = function(n) {
        return {
            $: 24,
            a: n
        };
    }, UN = function(n) {
        return {
            $: 13,
            a: n
        };
    }, QN = function(n) {
        return {
            $: 43,
            a: n
        };
    }, _N = function(n) {
        return {
            $: 42,
            a: n
        };
    }, ZN = function(n) {
        return {
            $: 30,
            a: n
        };
    }, KN = function(n) {
        return {
            $: 29,
            a: n
        };
    }, XN = function(n) {
        return {
            $: 51,
            a: n
        };
    }, JN = function(n) {
        return {
            $: 48,
            a: n
        };
    }, YN = function(n) {
        return {
            $: 49,
            a: n
        };
    }, GN = function(n) {
        return {
            $: 50,
            a: n
        };
    }, nL = function(n) {
        return {
            $: 31,
            a: n
        };
    }, rL = function(n) {
        return {
            $: 11,
            a: n
        };
    }, tL = function(n) {
        return {
            $: 9,
            a: n
        };
    }, eL = function(n) {
        return {
            $: 47,
            a: n
        };
    }, uL = function(n) {
        return {
            $: 32,
            a: n
        };
    }, oL = function(n) {
        return {
            $: 45,
            a: n
        };
    }, aL = function(n) {
        return {
            $: 27,
            a: n
        };
    }, iL = function(n) {
        return {
            $: 22,
            a: n
        };
    }, cL = function(n) {
        return {
            $: 21,
            a: n
        };
    }, fL = function(n) {
        return {
            $: 23,
            a: n
        };
    }, sL = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lL = function(n) {
        return {
            $: 26,
            a: n
        };
    }, dL = function(n) {
        return {
            $: 25,
            a: n
        };
    }, mL = function(n) {
        return {
            $: 61,
            a: n
        };
    }, bL = function(n) {
        return {
            $: 60,
            a: n
        };
    }, pL = function(n) {
        return {
            $: 36,
            a: n
        };
    }, vL = function(n) {
        return {
            $: 5,
            a: n
        };
    }, $L = function(n) {
        return {
            $: 8,
            a: n
        };
    }, wL = function(n) {
        return {
            $: 65,
            a: n
        };
    }, gL = function(n) {
        return {
            $: 64,
            a: n
        };
    }, hL = function(n) {
        return {
            $: 63,
            a: n
        };
    }, kL = function(n) {
        return {
            $: 68,
            a: n
        };
    }, CL = function(n) {
        return {
            $: 69,
            a: n
        };
    }, TL = function(n) {
        return {
            $: 38,
            a: n
        };
    }, PL = function(n) {
        return {
            $: 46,
            a: n
        };
    }, SL = {
        $: 52
    }, AL = k([
        3,
        4
    ]), yL = Ae("br"), NL = k([
        "bt709",
        "bt2020",
        "unknown"
    ]), LL = k([
        "bt709",
        "bt2020_ncl",
        "bt2020_cl",
        "unknown"
    ]), jL = k([
        "bt709",
        "bt2020-10",
        "bt2020-12",
        "unknown"
    ]), FL = Ae("h4"), ML = k([
        10,
        11
    ]), IL = Ae("hr"), DL = F2(function(n, r) {
        return n ? r : hk;
    }), BL = k([
        0,
        5,
        6
    ]), xL = k([
        "0",
        "1",
        "2.1",
        "2",
        "3",
        "3.1",
        "4",
        "4.1",
        "5",
        "5.1",
        "5.2",
        "6",
        "6.1",
        "6.2",
        "8.5"
    ]), qL = k([
        10,
        8
    ]), VL = k([
        1,
        11
    ]), OL = k([
        "ultrafast",
        "superfast",
        "veryfast",
        "faster",
        "fast",
        "medium",
        "slow",
        "slower",
        "veryslow",
        "placebo"
    ]), zL = k([
        "main",
        "main-intra",
        "main444-8",
        "main444-intra",
        "main10",
        "main10-intra",
        "main422-10",
        "main422-10-intra",
        "main444-10",
        "main444-10-intra",
        "main12",
        "main12-intra",
        "main422-12",
        "main422-12-intra",
        "main444-12-intra",
        "main444-12"
    ]), EL = function(n) {
        switch(n){
            case 0:
                return xa({
                    bN: "Partial",
                    bT: "Partiel"
                });
            case 1:
                return xa({
                    bN: "Complete",
                    bT: "Complet"
                });
            case 2:
                return xa({
                    bN: "Complete without partial",
                    bT: "Complet sans partiel"
                });
            default:
                return xa({
                    bN: "SDH",
                    bT: "SME"
                });
        }
    }, HL = A2(Ra, Zi, k([
        d(SA(0), EL(0)),
        d(SA(1), EL(1)),
        d(SA(2), EL(2)),
        d(SA(3), EL(3))
    ])), RL = A2(Ra, Zi, k([
        d(w$(0), Kk(0)),
        d(w$(1), Kk(1)),
        d(w$(2), Kk(2)),
        d(w$(3), Kk(3)),
        d(w$(4), Kk(4)),
        d(w$(5), Kk(5)),
        d(w$(6), Kk(6)),
        d(w$(7), Kk(7)),
        d(w$(8), Kk(8)),
        d(w$(9), Kk(9)),
        d(w$(10), Kk(10)),
        d(w$(11), Kk(11)),
        d(w$(12), Kk(12)),
        d(w$(13), Kk(13)),
        d(w$(14), Kk(14)),
        d(w$(15), Kk(15)),
        d(w$(16), Kk(16)),
        d(w$(17), Kk(17)),
        d(w$(18), Kk(18)),
        d(w$(19), Kk(19)),
        d(w$(20), Kk(20)),
        d(w$(21), Kk(21)),
        d(w$(22), Kk(22)),
        d(w$(23), Kk(23)),
        d(w$(24), Kk(24)),
        d(w$(25), Kk(25)),
        d(w$(26), Kk(26)),
        d(w$(27), Kk(27)),
        d(w$(28), Kk(28)),
        d(w$(29), Kk(29)),
        d(w$(30), Kk(30)),
        d(w$(31), Kk(31)),
        d(w$(32), Kk(32)),
        d(w$(33), Kk(33)),
        d(w$(34), Kk(34)),
        d(w$(35), Kk(35)),
        d(w$(36), Kk(36)),
        d(w$(37), Kk(37))
    ])), WL = Vw("target"), UL = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), QL = {
        $: 0
    }, _L = F2(function(n, r) {
        var t, e = r.a, u = r.b;
        return A2(ye, k([
            Ow("SelectItem"),
            Bg(k([
                d("SelectItemSelected", a(n.sw, ht(e)))
            ])),
            Cg((t = e, {
                $: 1,
                a: t
            }))
        ]), k([
            ag(u)
        ]));
    }), ZL = function(n) {
        return A2(ye, k([
            Ow("Select"),
            Bg(k([
                d("SelectDisabled", !n.e_),
                d("SelectOpened", n.gk)
            ])),
            Cg(QL),
            kP(n.gk)
        ]), k([
            A2(ye, k([
                Ow("SelectButton")
            ]), k([
                A2(ye, k([
                    Ow("SelectButtonIcon")
                ]), k([
                    Dk
                ])),
                A2(qg, k([
                    Ow("SelectButtonTitle")
                ]), A2(ju, n.gw, A2(Lu, Zi, Eo(A2(Mu, function(r) {
                    return a(ht(r.a), n.sw);
                }, n.jN)))))
            ])),
            A2(ye, k([
                Ow("SelectList")
            ]), A2(Ye, _L(n), n.jN))
        ]));
    }, KL = function(n) {
        return {
            $: 6,
            a: n
        };
    }, XL = {
        $: 0
    }, JL = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), YL = function(n) {
        return {
            $: 2,
            a: n
        };
    }, GL = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nj = xa({
        bN: "Frame Count",
        bT: "Images suppl\xe9mentaires"
    }), rj = xa({
        bN: "Black",
        bT: "Noir"
    }), tj = A2(Zw, k([
        Hw("18px"),
        Xw("18px"),
        Kw("0 0 18 18"),
        Fw("IconPlus")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(_w, k([
                Rw("4 5.5 7.5 9 4 12.5 5.5 14 9 10.5 12.5 14 14 12.5 10.5 9 14 5.5 12.5 4 9 7.5 5.5 4")
            ]), w)
        ]))
    ])), ej = xa({
        bN: "Countdown",
        bT: "Compte \xe0 rebours"
    }), uj = xa({
        bN: "Duration",
        bT: "Dur\xe9e"
    }), oj = xa({
        bN: "(Frames)",
        bT: "(Images)"
    }), aj = xa({
        bN: "Mire",
        bT: "Mire"
    }), ij = xa({
        bN: "(Seconds)",
        bT: "(Secondes)"
    }), cj = xa({
        bN: "Slate",
        bT: "Panneau"
    }), fj = xa({
        bN: "Shift start timecode",
        bT: "D\xe9caler le start timecode"
    }), sj = F2(function(n, r) {
        switch(r.c$){
            case 3:
                return A2(ye, k([
                    Ow("StichSegment")
                ]), k([
                    A2(ye, k([
                        Ow("StichSegmentDelete"),
                        Cg(A3(JL, n, r.fv, XL))
                    ]), k([
                        tj
                    ])),
                    A2(qg, k([
                        Ow("StichSegmentTitle")
                    ]), "video"),
                    A2(DL, n, A2(ye, k([
                        Ow("StichSegmentSubtract")
                    ]), k([
                        A2(Eg, k([
                            Tg("checkbox"),
                            Pk(r.hI),
                            Ak(function(t) {
                                return A3(JL, n, r.fv, KL(t));
                            })
                        ]), w),
                        A2(qg, k([
                            Ow("StichSegmentTitle")
                        ]), fj)
                    ]))),
                    A2(ye, k([
                        Ow("StichVideoSegment")
                    ]), k([
                        A2(qg, k([
                            Ow("StichSegmentUnit")
                        ]), "name"),
                        A2(Eg, k([
                            uh("source name"),
                            oh(A2(ju, "", r.du)),
                            Ow("StichSegmentUrl"),
                            eh(function(t) {
                                return A3(JL, n, r.fv, {
                                    $: 4,
                                    a: t
                                });
                            })
                        ]), w),
                        A2(qg, k([
                            Ow("StichSegmentUnit")
                        ]), "bucket"),
                        A2(Eg, k([
                            uh("source bucket"),
                            oh(A2(ju, "", r.hf)),
                            Ow("StichSegmentUrl"),
                            eh(function(t) {
                                return A3(JL, n, r.fv, {
                                    $: 3,
                                    a: t
                                });
                            })
                        ]), w),
                        A2(qg, k([
                            Ow("StichSegmentUnit")
                        ]), "key"),
                        A2(Eg, k([
                            uh("source key"),
                            oh(A2(ju, "", r.hh)),
                            Ow("StichSegmentUrl"),
                            eh(function(t) {
                                return A3(JL, n, r.fv, {
                                    $: 5,
                                    a: t
                                });
                            })
                        ]), w)
                    ]))
                ]));
            case 0:
                return A2(ye, k([
                    Ow("StichSegment")
                ]), k([
                    A2(ye, k([
                        Ow("StichSegmentDelete"),
                        Cg(A3(JL, n, r.fv, XL))
                    ]), k([
                        tj
                    ])),
                    A2(qg, k([
                        Ow("StichSegmentTitle")
                    ]), aj),
                    A2(DL, n, A2(ye, k([
                        Ow("StichSegmentSubtract")
                    ]), k([
                        A2(Eg, k([
                            Tg("checkbox"),
                            Pk(r.hI),
                            Ak(function(t) {
                                return A3(JL, n, r.fv, KL(t));
                            })
                        ]), w),
                        A2(qg, k([
                            Ow("StichSegmentTitle")
                        ]), fj)
                    ]))),
                    A2(qg, k([
                        Ow("StichSegmentUnit")
                    ]), ij),
                    A2(Eg, k([
                        uh(uj),
                        oh(Mt(r.eU)),
                        Ow("StichSegmentDuration"),
                        eh(function(t) {
                            return A3(JL, n, r.fv, GL(t));
                        })
                    ]), w),
                    A2(qg, k([
                        Ow("StichSegmentUnit")
                    ]), oj),
                    A2(Eg, k([
                        uh(nj),
                        oh(Mt(r.dX)),
                        Ow("StichSegmentDuration"),
                        eh(function(t) {
                            return A3(JL, n, r.fv, YL(t));
                        })
                    ]), w)
                ]));
            case 1:
                return A2(ye, k([
                    Ow("StichSegment")
                ]), k([
                    A2(ye, k([
                        Ow("StichSegmentDelete"),
                        Cg(A3(JL, n, r.fv, XL))
                    ]), k([
                        tj
                    ])),
                    A2(qg, k([
                        Ow("StichSegmentTitle")
                    ]), rj),
                    A2(DL, n, A2(ye, k([
                        Ow("StichSegmentSubtract")
                    ]), k([
                        A2(Eg, k([
                            Tg("checkbox"),
                            Pk(r.hI),
                            Ak(function(t) {
                                return A3(JL, n, r.fv, KL(t));
                            })
                        ]), w),
                        A2(qg, k([
                            Ow("StichSegmentTitle")
                        ]), fj)
                    ]))),
                    A2(qg, k([
                        Ow("StichSegmentUnit")
                    ]), ij),
                    A2(Eg, k([
                        uh(uj),
                        oh(Mt(r.eU)),
                        Ow("StichSegmentDuration"),
                        eh(function(t) {
                            return A3(JL, n, r.fv, GL(t));
                        })
                    ]), w),
                    A2(qg, k([
                        Ow("StichSegmentUnit")
                    ]), oj),
                    A2(Eg, k([
                        uh(nj),
                        oh(Mt(r.dX)),
                        Ow("StichSegmentDuration"),
                        eh(function(t) {
                            return A3(JL, n, r.fv, YL(t));
                        })
                    ]), w)
                ]));
            case 4:
                return A2(ye, k([
                    Ow("StichSegment")
                ]), k([
                    A2(ye, k([
                        Ow("StichSegmentDelete"),
                        Cg(A3(JL, n, r.fv, XL))
                    ]), k([
                        tj
                    ])),
                    A2(qg, k([
                        Ow("StichSegmentTitle")
                    ]), ej),
                    A2(DL, n, A2(ye, k([
                        Ow("StichSegmentSubtract")
                    ]), k([
                        A2(Eg, k([
                            Tg("checkbox"),
                            Pk(r.hI),
                            Ak(function(t) {
                                return A3(JL, n, r.fv, KL(t));
                            })
                        ]), w),
                        A2(qg, k([
                            Ow("StichSegmentTitle")
                        ]), fj)
                    ]))),
                    A2(qg, k([
                        Ow("StichSegmentUnit")
                    ]), ij),
                    A2(Eg, k([
                        uh(uj),
                        oh(Mt(r.eU)),
                        Ow("StichSegmentDuration"),
                        eh(function(t) {
                            return A3(JL, n, r.fv, GL(t));
                        })
                    ]), w)
                ]));
            default:
                return A2(ye, k([
                    Ow("StichSegment")
                ]), k([
                    A2(ye, k([
                        Ow("StichSegmentDelete"),
                        Cg(A3(JL, n, r.fv, XL))
                    ]), k([
                        tj
                    ])),
                    A2(qg, k([
                        Ow("StichSegmentTitle")
                    ]), cj),
                    A2(DL, n, A2(ye, k([
                        Ow("StichSegmentSubtract")
                    ]), k([
                        A2(Eg, k([
                            Tg("checkbox"),
                            Pk(r.hI),
                            Ak(function(t) {
                                return A3(JL, n, r.fv, KL(t));
                            })
                        ]), w),
                        A2(qg, k([
                            Ow("StichSegmentTitle")
                        ]), fj)
                    ]))),
                    A2(qg, k([
                        Ow("StichSegmentUnit")
                    ]), ij),
                    A2(Eg, k([
                        uh(uj),
                        oh(Mt(r.eU)),
                        Ow("StichSegmentDuration"),
                        eh(function(t) {
                            return A3(JL, n, r.fv, GL(t));
                        })
                    ]), w),
                    A2(qg, k([
                        Ow("StichSegmentUnit")
                    ]), oj),
                    A2(Eg, k([
                        uh(nj),
                        oh(Mt(r.dX)),
                        Ow("StichSegmentDuration"),
                        eh(function(t) {
                            return A3(JL, n, r.fv, YL(t));
                        })
                    ]), w)
                ]));
        }
    }), lj = function(n) {
        return A2(ye, k([
            Ow("StitchAdd")
        ]), $(A2(Ye, sj(!1), A2(Ra, function(n) {
            return n.fv;
        }, n.dM.dY)), k([
            A2(mh, UL(!1), ZL(n.iC))
        ])));
    }, dj = function(n) {
        return A2(ye, k([
            Ow("StitchAdd")
        ]), $(A2(Ye, sj(!0), A2(Ra, function(n) {
            return n.fv;
        }, n.dM.ec)), k([
            A2(mh, UL(!0), ZL(n.jg))
        ])));
    }, mj = function(n) {
        return A2(Ck, function(r) {
            var t = A2(Ye, function(n) {
                return d(n.a, n.b.n6);
            }, A2(Ra, A2(Pi, Zi, A2(Pi, function(n) {
                return n.n6;
            }, Ua)), pt(n.dB))), e = A2(Ye, function(n) {
                return d(n.mo, n.n6);
            }, n.dw), u = A2(Ye, function(n) {
                return d(n, n);
            }, zL), o = A2(Ye, function(n) {
                return d(n, n);
            }, OL), i = A2(Ye, function(n) {
                return d(n, n);
            }, xL), c = a(r.qZ.sw, bA(14)), f = a(r.qZ.sw, bA(4)), s = a(r.qZ.sw, bA(9)), l = function(n) {
                return A2(Y$, r.qZ.sw, A2(Ye, bA, n));
            }, m = l(qL), b = l(Ly), p = l(VL), v = l(jy), $ = l(gy), g = l(Fy), h = l(Py), C = l(BL), T = a(r.qZ.sw, bA(6)), P = l(ML), S = r.jw.sw, A = a(r.qZ.sw, bA(16)), y = A2(Y$, r.i2.sw, A2(Ye, uA, AL)), N = a(r.qZ.sw, bA(5)), L = A2(Ye, function(n) {
                return d(n.mo, lN(n));
            }, n.lX), j = A2(Ye, function(n) {
                return d(n, n);
            }, A2(Ye, bA, k([
                0,
                1,
                9,
                2,
                3,
                4,
                10,
                11,
                5,
                6,
                7,
                12,
                8,
                13,
                14,
                15,
                16
            ]))), F = A2(Ye, function(n) {
                return d(n, n);
            }, jL), M = A2(Ye, function(n) {
                return d(n, n);
            }, LL), I = A2(Ye, function(n) {
                return d(n, n);
            }, NL), D = A2(Ye, function(n) {
                return d(uA(n), function(n) {
                    switch(n){
                        case 1:
                            return "pcm_s16le (.wav 16 bits)";
                        case 0:
                            return "pcm_s24le (.wav 24 bits)";
                        case 2:
                            return "pcm_s24be (.aif)";
                        case 3:
                            return "libfdk_aac (.aac)";
                        case 4:
                            return "libmp3lame (.mp3)";
                        default:
                            return "pcm_s24le (.mov)";
                    }
                }(n));
            }, k([
                1,
                0,
                2,
                3,
                4,
                5
            ])), B = A2(Ye, function(n) {
                return d(n, n);
            }, A2(Ye, uA, k([
                1,
                0
            ]))), x = function(n) {
                return 1 !== n.oS.$;
            }(r) ? d("Save", "Edit Format") : d("Create", "New Format");
            return A4(_k, x.b, d(x.a, SL), d("Cancel", qN), k([
                A2(oC, k([
                    fC("https://docs.google.com/document/d/1INml9A9VneiIqDZlNB8FnKTU_NkmstV5SAEFFO2nSmQ"),
                    WL("_blank")
                ]), k([
                    ag("Help Format Creation")
                ])),
                A2(mh, sL, Mk(r.n6)),
                A2(mh, vL, A2(Ek, r.qZ, j)),
                A2(DL, b || A, A2(mh, BN, Fk(r.sN))),
                A2(DL, r.sN.sw || !(b || A), A2(mh, $L, Mk(r.q5))),
                A2(mh, VN, Fk(r.kc)),
                A2(yL, w, w),
                A2(IL, w, w),
                A2(yL, w, w),
                A2(FL, w, k([
                    ag("QC")
                ])),
                A2(mh, bL, A2(Ek, r.pt, t)),
                A2(mh, mL, Mk(r.ps)),
                A2(DL, !A, A2(ye, w, k([
                    A2(yL, w, w),
                    A2(IL, w, w),
                    A2(yL, w, w),
                    A2(FL, w, k([
                        ag("Video")
                    ])),
                    A2(DL, p || m || s || c, A2(mh, TL, Mk(r.sF))),
                    A2(mh, tL, A2(Ek, r.lW, L)),
                    A2(mh, jN, Fk(r.oi))
                ]))),
                A2(DL, C, A2(mh, yN, Fk(r.kF))),
                A2(DL, !A, A2(mh, rL, Mk(r.lB))),
                A2(DL, v, A2(ye, w, k([
                    A2(yL, w, w),
                    A2(IL, w, w),
                    A2(yL, w, w),
                    A2(FL, w, k([
                        ag("MXf Parameters")
                    ]))
                ]))),
                A2(DL, g, A2(mh, pL, Mk(r.pv))),
                A2(DL, $, A2(ye, w, k([
                    A2(mh, PN, Fk(r.j9)),
                    A2(mh, hN, Fk(r.iX)),
                    A2(mh, xN, Fk(r.sA))
                ]))),
                A2(DL, N, A2(mh, kN, Fk(r.iY))),
                A2(DL, v, A2(ye, w, k([
                    A2(mh, TN, Fk(r.jy)),
                    A2(mh, ON, Mk(r.iB)),
                    A2(mh, UN, Mk(r.jk))
                ]))),
                A2(DL, P, A2(ye, w, k([
                    A2(yL, w, w),
                    A2(IL, w, w),
                    A2(yL, w, w),
                    A2(ye, w, k([
                        A2(mh, NN, A2(FL, w, k([
                            Fk(r.qI)
                        ]))),
                        A2(DL, r.qI.sw, A2(ye, k([
                            Ow("EditContainer")
                        ]), k([
                            A2(mh, dL, A2(Ek, r.pj, u)),
                            A2(mh, aL, A2(Ek, r.nf, i)),
                            A2(mh, lL, A2(Ek, r.pe, o)),
                            A2(mh, LN, Fk(r.me)),
                            A2(mh, uL, Mk(r.m4)),
                            A2(mh, KN, A2(Ek, r.jX, M)),
                            A2(mh, ZN, A2(Ek, r.jW, I)),
                            A2(mh, nL, A2(Ek, r.ku, F))
                        ])))
                    ]))
                ]))),
                A2(yL, w, w),
                A2(IL, w, w),
                A2(yL, w, w),
                A2(FL, w, k([
                    ag("Audio")
                ])),
                A2(DL, !A, A2(mh, RN, A2(Ek, r.i2, B))),
                A2(DL, p || m || s || c, A2(mh, HN, Mk(r.i1))),
                A2(DL, h && !A, A2(ye, w, k([
                    A2(mh, FN, Fk(r.oj)),
                    A2(DL, !r.oj.sw, A2(ye, w, k([
                        A2(mh, cL, Mk(r.nt)),
                        A2(mh, iL, Mk(r.ns)),
                        A2(mh, fL, Mk(r.nu)),
                        A2(mh, WN, Mk(r.i4))
                    ])))
                ]))),
                A2(DL, !A, A2(mh, EN, Mk(r.i0))),
                A2(DL, A, A2(ye, w, k([
                    A2(mh, RN, A2(Ek, r.i2, D)),
                    A2(DL, y, A2(mh, HN, Mk(r.i1))),
                    A2(mh, tL, A2(Ek, r.lW, L))
                ]))),
                A2(DL, !(f || A), A2(ye, w, k([
                    A2(yL, w, w),
                    A2(IL, w, w),
                    A2(yL, w, w),
                    A2(FL, w, k([
                        ag("Effects")
                    ])),
                    A2(mh, AN, Fk(r.qC)),
                    A2(DL, r.qC.sw, A2(ye, k([
                        Ow("EditContainer")
                    ]), k([
                        A2(mh, JN, Mk(r.kk)),
                        A2(mh, YN, Mk(r.kl)),
                        A2(mh, GN, Mk(r.km)),
                        A2(mh, XN, Mk(r.kj))
                    ])))
                ]))),
                A2(DL, !(T || f || A), A2(ye, w, k([
                    A2(mh, MN, Fk(r.qM)),
                    A2(DL, r.qM.sw, A2(ye, k([
                        Ow("EditContainer")
                    ]), k([
                        A2(mh, PL, Mk(r.p4)),
                        A2(mh, eL, Mk(r.p2)),
                        A2(mh, zN, Fk(r.p1)),
                        A2(mh, oL, Fk(r.p3))
                    ])))
                ]))),
                A2(DL, !(f || A), A2(ye, w, k([
                    A2(mh, SN, Fk(r.qB)),
                    A2(DL, r.qB.sw, A2(ye, k([
                        Ow("EditContainer")
                    ]), k([
                        A2(mh, _N, Mk(r.jT)),
                        A2(mh, QN, Mk(r.jS))
                    ])))
                ]))),
                A2(DL, !A, A2(ye, w, k([
                    A2(Ck, function(n) {
                        return A2(ye, k([
                            Ow("EditSection")
                        ]), k([
                            A2(yL, w, w),
                            A2(IL, w, w),
                            A2(yL, w, w),
                            A2(FL, w, k([
                                ag("Edit Options")
                            ])),
                            A2(ye, k([
                                Ow("EditContainer")
                            ]), k([
                                A2(mh, dy, dj(n)),
                                A2(mh, dy, lj(n))
                            ]))
                        ]));
                    }, r.rf)
                ]))),
                A2(DL, !A, A2(ye, w, k([
                    A2(yL, w, w),
                    A2(IL, w, w),
                    A2(yL, w, w),
                    A2(FL, w, k([
                        ag("Subtitle")
                    ])),
                    A2(DL, f, A2(ye, w, k([
                        A2(mh, IN, Fk(r.li))
                    ]))),
                    A2(mh, CN, Fk(r.jw)),
                    A2(DL, S, A2(ye, k([
                        Ow("EditContainer")
                    ]), k([
                        A2(mh, hL, A2(Ek, r.rt, RL)),
                        A2(mh, gL, A2(Ek, r.rs, HL)),
                        A2(mh, wL, A2(Ek, r.rn, e))
                    ]))),
                    A2(mh, DN, Fk(r.rx)),
                    A2(DL, r.rx.sw, A2(ye, k([
                        Ow("EditContainer")
                    ]), k([
                        A2(mh, kL, Mk(r.rw)),
                        A2(mh, CL, Mk(r.ry))
                    ])))
                ])))
            ]));
        }, n.kP);
    }, bj = F2(function(n, r) {
        var t = Ua(r.px.sw), e = A2(Mu, function(n) {
            return A2(bu, A2(bu, Be(t), Ua), function(n) {
                return n.n6;
            })(n) || A2(bu, A2(bu, A2(bu, Be(t), Ua), bA), function(n) {
                return n.qZ;
            })(n) || A2(bu, A2(bu, Be(t), Ua), function(n) {
                return n.q5;
            })(n) || A2(bu, A2(bu, A2(bu, Be(t), Ua), lN), function(n) {
                return n.lW;
            })(n) || A2(bu, A2(bu, A2(bu, Be(t), Ua), ju("N/A")), function(n) {
                return n.lB;
            })(n) || A2(bu, A2(bu, A2(bu, Be(t), Ua), ju("N/A")), function(n) {
                return n.i0;
            })(n) || A2(bu, A2(bu, A2(bu, Be(t), Ua), ju("N/A")), function(n) {
                return n.jk;
            })(n) || A2(bu, A2(bu, A2(bu, A2(bu, Be(t), Ua), ju("N/A")), Lu(mN)), function(n) {
                return n.M;
            })(n) || A2(bu, A2(bu, A2(bu, A2(bu, Be(t), Ua), ju("N/A")), Lu(eN)), function(n) {
                return n.oj;
            })(n) || A2(bu, A2(bu, A2(bu, A2(bu, Be(t), Ua), ju("N/A")), Lu(w$)), function(n) {
                return n.rt;
            })(n) || A2(bu, A2(bu, A2(bu, A2(bu, Be(t), Ua), ju("N/A")), Lu(SA)), function(n) {
                return n.rs;
            })(n) || A2(bu, A2(bu, A2(bu, Be(t), Ua), ju("N/A")), function(n) {
                return n.rn;
            })(n);
        }, r.cX);
        return A3(gC, "Formats", ht(A2(Pg, "New\u2026", rN)), A2(ye, w, k([
            A2(mh, tN, ah(r.px)),
            mj(r),
            A3(ck, A2(gN, r.dB, r.dw), r.rN, e)
        ])));
    }), pj = {
        l: function(n) {
            return n.cX;
        },
        m: ly,
        o: F2(function(n, r) {
            return p(n, {
                cX: r
            });
        }),
        p: function(n) {
            return {
                $: 12,
                a: n
            };
        },
        q: nN,
        r: bj
    }, vj = F2(function(n, r) {
        return {
            eM: n,
            sz: r
        };
    }), $j = F2(function(n, r) {
        return {
            je: n,
            lo: r
        };
    }), wj = Fi(A4(qi, "error", function(n) {
        return n.lo;
    }, Oa, A4(rc, "available", function(n) {
        return n.je;
    }, ri, Mi($j)))), gj = Fi(A4(rc, "version", function(n) {
        return n.sz;
    }, Oa, A4(rc, "db", function(n) {
        return n.eM;
    }, wj, Mi(vj)))), hj = dl({
        $: 23
    }), kj = mc(A2(Wi, gj, Ai(hj))), Cj = A2(Xa, Me, kj), Tj = d({
        ln: kt
    }, Cj), Pj = F2(function(n, r) {
        return A2(pc, w, p(r, {
            ln: ht(n)
        }));
    }), Sj = F2(function(n, r) {
        return A2(Lh, k([
            Ow("KeyValueRow")
        ]), k([
            A2(uk, k([
                Ow("KeyValueKey")
            ]), k([
                n
            ])),
            A2(uk, k([
                Ow("KeyValueValue")
            ]), k([
                r
            ]))
        ]));
    }), Aj = Sj, yj = F2(function(n, r) {
        return A2(Aj, ag(n), ag(r));
    }), Nj = Lw("transform"), Lj = A2(Zw, k([
        Hw("40px"),
        Xw("40px"),
        Kw("0 0 40 40"),
        Fw("IconSpinner")
    ]), k([
        A2(Ik, k([
            Nj("translate(5, 9)")
        ]), k([
            A2(iC, k([
                aC("M15,0 C21.0751322,0 26,4.92486775 26,11 C26,17.0751322 21.0751322,22 15,22 C9.26195744,22 4.55007179,17.6065 4.04484302,12 L6.05492878,12 C6.55237307,16.4999505 10.3674463,20 15,20 C19.9705627,20 24,15.9705627 24,11 C24,6.02943725 19.9705627,2 15,2 L15,0 Z"),
                Fw("Fg")
            ]), w),
            A2(_w, k([
                Fw("Fg"),
                Rw("5 6 10 12 0 12")
            ]), w)
        ]))
    ])), jj = F2(function(n, r) {
        return A3(gC, "Flubber status", kt, A2(ye, w, function() {
            var n = r.ln;
            if (1 === n.$) return k([
                Lj
            ]);
            var t = n.a;
            if (t.$) {
                var e = t.a;
                return k([
                    A2(qg, k([
                        Ow("failed")
                    ]), e.nP)
                ]);
            }
            var u = t.a;
            return k([
                A2(yj, "Version", u.sz),
                A2(yj, "Database", u.eM.je ? "OK" : "KO: " + A2(ju, "No error", u.eM.lo))
            ]);
        }()));
    }), Fj = {
        l: function(n) {
            return n.cY;
        },
        m: Tj,
        o: F2(function(n, r) {
            return p(n, {
                cY: r
            });
        }),
        p: function(n) {
            return {
                $: 1,
                a: n
            };
        },
        q: Pj,
        r: jj
    }, Mj = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ij = A2(Xa, Mj, mc(A2(Wi, M$, Ai(D$)))), Dj = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Bj = A2(Xa, Dj, mc(A2(Wi, LT, Ai(FT)))), xj = {
        im: !1,
        kx: w,
        m6: !1,
        nm: !1,
        oP: !1,
        oQ: w,
        oX: A4(iv, kt, kt, kt, kt),
        rb: !1,
        rN: o$("Completed At"),
        dL: w
    }, qj = A2(pc, k([
        Ij,
        Bj
    ]), xj), Vj = F2(function(n, r) {
        switch(n.$){
            case 10:
                return A2(pc, w, p(r, {
                    kx: w
                }));
            case 4:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            case 5:
                return A2(pc, w, p(r, {
                    oP: !r.oP
                }));
            case 6:
                return A2(pc, w, p(r, {
                    m6: !r.m6
                }));
            case 7:
                return A2(pc, w, p(r, {
                    rb: !r.rb
                }));
            case 8:
                return A2(pc, w, p(r, {
                    im: !r.im
                }));
            case 2:
                return A2(pc, w, (u = n.a).$ ? r : p(r, {
                    oQ: u.a
                }));
            case 9:
                return A2(pc, w, p(r, {
                    oX: e = n.a
                }));
            case 1:
                var t = n.a, e = t.a;
                return A2(pc, w, p(r, (u = t.b).$ ? {
                    kx: w
                } : {
                    kx: u.a,
                    nm: !1,
                    oX: e
                }));
            case 0:
                return A2(pc, w, p(r, (u = n.a).$ ? {
                    kx: w
                } : {
                    kx: u.a,
                    nm: !1
                }));
            default:
                var u;
                return A2(pc, w, (u = n.a).$ ? r : p(r, {
                    dL: u.a
                }));
        }
    }), Oj = function(n) {
        return {
            $: 4,
            a: n
        };
    }, zj = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), Ej = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: zj(r)
        });
    }), Hj = F3(function(n, r, t) {
        return Gw({
            n6: n,
            ds: LP(A2(bu, jP, t)),
            dN: zj(r)
        });
    }), Rj = F2(function(n, r) {
        return A3(Hj, n, function(n) {
            return IP(r(n));
        }, r);
    }), Wj = F2(function(n, r) {
        if (r.$) return "";
        var t = r.a;
        return A2(ju, "", A2(Lu, function(n) {
            return n.n6;
        }, Eo(A2(Mu, function(n) {
            return a(n.mo, t);
        }, n))));
    }), Uj = F2(function(n, r) {
        return A2(ju, "", A2(Lu, function(n) {
            return n.n6;
        }, Eo(A2(Mu, function(n) {
            return a(n.mo, r);
        }, n.oQ))));
    }), Qj = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: LP(A2(bu, A2(bu, function(n) {
                return A2(ju, 0, n);
            }, Lu(jP)), r)),
            dN: zj(function(n) {
                return A2(ju, A2(ye, w, w), A2(Lu, IP, r(n)));
            })
        });
    }), _j = k([
        Ow("Table")
    ]), Zj = function() {
        return k([
            Ow("TableTr")
        ]);
    }, Kj = function(n) {
        return ug({
            j_: k([
                A2(OP, "Organization", A2(bu, Uj(n), function(n) {
                    return n.oM;
                })),
                A2(OP, "Type", A2(bu, VT, function(n) {
                    return n.fI;
                })),
                A2(Rj, "Created At", function(n) {
                    return n.ki;
                }),
                A2(OP, "Requester", A2(bu, A2(bu, Wj(n.dL), ht), function(n) {
                    return n.pH;
                })),
                A2(Qj, "Started At", function(n) {
                    return n.q6;
                }),
                A2(OP, "Started By", A2(bu, Wj(n.dL), function(n) {
                    return n.q7;
                })),
                A2(Qj, "Completed At", function(n) {
                    return n.j2;
                }),
                A2(OP, "Completed By", A2(bu, Wj(n.dL), function(n) {
                    return n.j3;
                })),
                A2(OP, "Acknowledge By", A2(bu, Wj(n.dL), function(n) {
                    return n.$9;
                })),
                A2(OP, "External Job Id", A2(bu, ju(""), function(n) {
                    return n.lw;
                })),
                A2(Ej, "Show", A2(bu, function(n) {
                    return A2(oC, k([
                        fC("/show/" + n.qJ)
                    ]), k([
                        ag(VP(n))
                    ]));
                }, function(n) {
                    return n.qL;
                })),
                A2(OP, "Id", function(n) {
                    return n.mo;
                })
            ]),
            kv: p(hg, {
                pS: Zj,
                rE: _j,
                rQ: k([
                    Ow("TableTd")
                ])
            }),
            rZ: function(n) {
                return n.mo;
            },
            r_: Oj
        });
    }, Xj = {
        $: 5
    }, Jj = F2(function(n, r) {
        return m(a(n.oX.oM, ht(r.mo)), "/admin" + $P({
            B: n.oX.B,
            c$: n.oX.c$,
            oM: ht(r.mo),
            P: n.oX.P
        }), r.n6);
    }), Yj = Ae("p"), Gj = {
        $: 8
    }, nF = function(n) {
        switch(Ua(n)){
            case "true":
                return ht(!0);
            case "false":
                return ht(!1);
            default:
                return kt;
        }
    }, rF = F2(function(n, r) {
        return m(a(n.oX.B, nF(Ua(r.a))), "/admin" + $P({
            B: nF(Ua(r.a)),
            c$: n.oX.c$,
            oM: n.oX.oM,
            P: n.oX.P
        }), r.b);
    }), tF = function(n) {
        var r = k([
            d("", "Acknowledged and Not Acknowledged"),
            d("true", "Acknowledged"),
            d("false", "Not Acknowledged")
        ]);
        return A4(TP, n.im, Gj, A2(Ye, rF(n), r), "Filter by Acknowledged");
    }, eF = {
        $: 7
    }, uF = F2(function(n, r) {
        return m(a(n.oX.P, ht(Ua(r.a))), "/admin" + $P({
            B: n.oX.B,
            c$: n.oX.c$,
            oM: n.oX.oM,
            P: ht(Ua(r.a))
        }), r.b);
    }), oF = function(n) {
        var r = k([
            d("", "All Status"),
            d("true", "true"),
            d("false", "false")
        ]);
        return A4(TP, n.rb, eF, A2(Ye, uF(n), r), "Filter by Status");
    }, aF = {
        $: 6
    }, iF = F2(function(n, r) {
        return m(a(n.oX.c$, ht(Ua(r.a))), "/admin" + $P({
            B: n.oX.B,
            c$: ht(Ua(r.a)),
            oM: n.oX.oM,
            P: n.oX.P
        }), r.b);
    }), cF = function(n) {
        var r = k([
            d("", "All Types"),
            d("DownloadAsIs", "DownloadAsIs"),
            d("PadTranscode", "PadTranscode"),
            d("SimpleTranscode", "SimpleTranscode"),
            d("QC", "QC"),
            d("Spotcheck", "Spotcheck")
        ]);
        return A4(TP, n.m6, aF, A2(Ye, iF(n), r), "Filter by type");
    }, fF = F2(function(n, r) {
        return A2(ye, k([
            Ow("DarkZone"),
            Ow("Filter")
        ]), k([
            A2(ye, k([
                Ow("JobsFilters")
            ]), k([
                cF(n),
                oF(n),
                tF(n)
            ])),
            A2(ye, k([
                Ow("Summary")
            ]), k([
                A2(dP, w, k([
                    ag("Summary")
                ])),
                A2(Yj, w, k([
                    ag("")
                ])),
                A2(Yj, w, k([
                    ag("Total Jobs: " + Mt(qt(r)))
                ]))
            ]))
        ]));
    }), sF = F2(function(n, r) {
        var t = r.oX.c$, e = r.oX.P, u = r.oX.B, o = A2(Mu, function(n) {
            return a(ht(n.B), u) || a(u, kt);
        }, A2(Mu, function(n) {
            if (t.$) return !0;
            var r = t.a;
            if (xe(r) > 0) {
                var e = bP(n);
                return a(Ua(VT(e.fI)), r);
            }
            return !0;
        }, A2(Mu, function(n) {
            n: for(; !e.$;)switch(e.a){
                case "true":
                    return !a(n.j2, kt);
                case "false":
                    return a(n.j2, kt);
                default:
                    break n;
            }
            return !0;
        }, r.kx)));
        return A3(gC, "Jobs", ht(function(n) {
            var r = A2(Ra, A2(bu, Ua, function(n) {
                return n.n6;
            }), n.oQ);
            return A4(TP, n.oP, Xj, A2(Ye, Jj(n), r), "Choose origanization");
        }(r)), r.nm ? A2(ye, k([
            Ow("EmptySection")
        ]), k([
            A2(ye, w, k([
                ag("loading...")
            ]))
        ])) : A2(ye, w, k([
            A2(fF, r, o),
            A3(ck, Kj(r), r.rN, o)
        ])));
    }), lF = {
        l: function(n) {
            return n.cZ;
        },
        m: qj,
        o: F2(function(n, r) {
            return p(n, {
                cZ: r
            });
        }),
        p: function(n) {
            return {
                $: 15,
                a: n
            };
        },
        q: Vj,
        r: sF
    }, dF = {
        $: 10
    }, mF = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bF = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), pF = function(n) {
        return {
            $: 6,
            a: n
        };
    }, vF = F2(function(n, r) {
        return A2(nP, r, A2(ju, A2(KT, r.mo, k([
            XT(r.mo)
        ])), Eo(A2(Mu, function(n) {
            return a(n.qJ, r.g9);
        }, n))));
    }), $F = function(n) {
        return A2(Yb, function(r) {
            return A2(Ye, vF(r), n);
        }, mc(A2(Wi, GT, A3(ow, ZT, UT(A2(Ye, function(n) {
            return n.g9;
        }, n)), rw(_T)))));
    }, wF = function(n) {
        return A2(Xa, mF, function(n) {
            return A2(BT, $F, function(n) {
                return mc(A2(Wi, ET, Ai(dl(pF(A2(bF, n, 2))))));
            }(n));
        }(n));
    }, gF = function(n) {
        return A2(Yv, Dl({
            $: 9,
            a: n
        }), iP(0));
    }, hF = {
        kP: kt,
        lo: kt,
        px: za(function(n) {
            return p(n, {
                gw: "Search Audio Mapping by Organization, Name or Tracks",
                sw: ""
            });
        }),
        p6: w,
        rz: kt,
        rN: o$("Organization")
    }, kF = function(n) {
        return {
            $: 0,
            a: n
        };
    }, CF = F4(function(n, r, t, e) {
        return {
            kN: t,
            lC: e,
            mo: n,
            n6: r
        };
    }), TF = F5(function(n, r, t, e, u) {
        var o = u;
        return {
            e: A3(Le, F2(function(n, r) {
                return n(r);
            }), o.e, Di(k([
                A2(du, n, pa(t)),
                je(e)
            ]))),
            g: function(e) {
                return A2(mt, d(n, A2(Ii, t, r(e))), o.g(e));
            }
        };
    }), PF = F5(function(n, r, t, e, u) {
        return {
            m8: t,
            m9: r,
            n6: n,
            sa: e,
            sx: u
        };
    }), SF = Fi(A4(rc, "values", function(n) {
        return n.sx;
    }, ic(Oa), A4(rc, "type", function(n) {
        return n.sa;
    }, Oa, A4(rc, "label_en", function(n) {
        return n.m8;
    }, Oa, A4(rc, "label_fr", function(n) {
        return n.m9;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(PF))))))), AF = Fi(A5(TF, "fields", function(n) {
        return n.lC;
    }, ic(SF), w, A4(rc, "description", function(n) {
        return n.kN;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(CF)))))), yF = function(n) {
        return {
            $: 2,
            a: n
        };
    }, NF = yi(yF({
        $: 1
    })), LF = mc(A2(Wi, ic(AF), Ai(NF))), jF = A2(Xa, kF, LF), FF = d(hF, jF), MF = function(n) {
        return {
            $: 3,
            a: n
        };
    }, IF = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), DF = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), BF = function(n) {
        return yi(yF({
            $: 2,
            a: n
        }));
    }, xF = function(n) {
        return za(function(r) {
            return p(r, {
                m7: "Value",
                sw: n
            });
        });
    }, qF = function(n) {
        return {
            m8: za(function(r) {
                return p(r, {
                    m7: "Label EN",
                    sw: n.m8
                });
            }),
            m9: za(function(r) {
                return p(r, {
                    m7: "Label FR",
                    sw: n.m9
                });
            }),
            n6: za(function(r) {
                return p(r, {
                    m7: "Name",
                    sw: n.n6
                });
            }),
            sa: za(function(r) {
                return p(r, {
                    m7: "Type",
                    sw: n.sa
                });
            }),
            sx: A2(Ye, xF, n.sx)
        };
    }, VF = qF({
        m8: "",
        m9: "",
        n6: "",
        sa: "",
        sx: w
    }), OF = function(n) {
        return {
            $: 8,
            a: n
        };
    }, zF = F3(function(n, r, t) {
        return {
            kN: r,
            lC: t,
            n6: n
        };
    }), EF = Fi(A4(rc, "fields", function(n) {
        return n.lC;
    }, ic(SF), A4(rc, "description", function(n) {
        return n.kN;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(zF))))), HF = function(n) {
        return A2(Xa, OF, function(n) {
            return mc(sw(A3(ow, EF, {
                kN: n.kN.sw,
                lC: A2(Ye, function(n) {
                    return {
                        m8: n.m8.sw,
                        m9: n.m9.sw,
                        n6: n.n6.sw,
                        sa: n.sa.sw,
                        sx: A2(Ye, function(n) {
                            return n.sw;
                        }, n.sx)
                    };
                }, n.lC),
                n6: n.n6.sw
            }, rw(NF))));
        }(n));
    }, RF = function(n) {
        return {
            $: 10,
            a: n
        };
    }, WF = function(n) {
        return {
            $: 9,
            a: n
        };
    }, UF = F2(function(n, r) {
        return mc(sw(A3(ow, EF, {
            kN: r.kN.sw,
            lC: A2(Ye, function(n) {
                return {
                    m8: n.m8.sw,
                    m9: n.m9.sw,
                    n6: n.n6.sw,
                    sa: n.sa.sw,
                    sx: A2(Ye, function(n) {
                        return n.sw;
                    }, n.sx)
                };
            }, r.lC),
            n6: r.n6.sw
        }, dw(BF(n.mo)))));
    }), QF = F2(function(n, r) {
        return A2(Xa, WF, A2(UF, n, r));
    }), _F = function(n) {
        var r = function(n) {
            return A2(Pi, Lu(n), ju(""));
        };
        return {
            kN: za(function(t) {
                return p(t, {
                    m7: "Description",
                    sw: A2(r, function(n) {
                        return n.kN;
                    }, n)
                });
            }),
            lC: n.$ ? w : A2(Ye, qF, n.a.lC),
            n6: za(function(t) {
                return p(t, {
                    m7: "Name",
                    sw: A2(r, function(n) {
                        return n.n6;
                    }, n)
                });
            }),
            oS: n
        };
    }, ZF = F2(function(n, r) {
        var t = n.kP;
        return t.$ ? n : p(n, {
            kP: ht(r(t.a))
        });
    }), KF = F3(function(n, r, t) {
        return A2(ZF, n, function(n) {
            return p(n, {
                lC: A2(Ht, F2(function(n, e) {
                    return a(n, r) ? t(e) : e;
                }), n.lC)
            });
        });
    }), XF = F4(function(n, r, t, e) {
        return A3(KF, n, r, function(n) {
            return p(n, {
                sx: A2(Ht, F2(function(n, r) {
                    return a(n, t) ? A2(ww, e, r) : r;
                }), n.sx)
            });
        });
    }), JF = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, k([
                    A2(Xa, MF, (f = n.a.mo, mc(A2(Wi, AF, Ai(BF(f))))))
                ]), r);
            case 3:
                return A2(pc, w, n.a.$ ? A2(DF, n.a.a, r) : p(r, {
                    kP: ht(_F(ht(n.a.a)))
                }));
            case 1:
                return A2(pc, w, p(r, {
                    kP: ht(_F(kt))
                }));
            case 6:
                return A2(pc, w, p(r, {
                    kP: kt,
                    lo: kt,
                    rz: kt
                }));
            case 4:
                var t = n.a;
                return A2(pc, w, A2(ZF, r, function(n) {
                    return p(n, {
                        n6: A2(ww, t, n.n6)
                    });
                }));
            case 5:
                return t = n.a, A2(pc, w, A2(ZF, r, function(n) {
                    return p(n, {
                        kN: A2(ww, t, n.kN)
                    });
                }));
            case 7:
                var e = r.kP;
                if (1 === e.$) return A2(pc, k([
                    n$
                ]), r);
                var u = e.a;
                return A2(pc, k([
                    (s = u.oS, 1 === s.$ ? HF(u) : A2(QF, s.a, u))
                ]), r);
            case 11:
                return A2(pc, k([
                    (c = n.a, A2(Xa, RF, function(n) {
                        return mc(sw(fw(BF(n.mo))));
                    }(c)))
                ]), r);
            case 8:
                return (o = n.a).$ ? A2(pc, w, A2(DF, o.a, r)) : A2(pc, k([
                    jF
                ]), p(r, {
                    lo: kt,
                    rz: ht("Schema created")
                }));
            case 9:
                return (o = n.a).$ ? A2(pc, w, A2(DF, o.a, r)) : A2(pc, k([
                    jF
                ]), p(r, {
                    lo: kt,
                    rz: ht("Schema updated")
                }));
            case 10:
                return (o = n.a).$ ? A2(pc, w, A2(DF, o.a, r)) : A2(pc, k([
                    jF
                ]), r);
            case 0:
                var o;
                return A2(pc, w, (o = n.a).$ ? A2(DF, o.a, r) : p(r, {
                    p6: o.a
                }));
            case 22:
                return A2(pc, w, p(r, {
                    px: A2(ww, t = n.a, r.px)
                }));
            case 21:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            case 12:
                return A2(pc, w, A2(ZF, r, function(n) {
                    return p(n, {
                        lC: Ju(k([
                            n.lC,
                            k([
                                VF
                            ])
                        ]))
                    });
                }));
            case 13:
                return A2(pc, w, A3(KF, r, a = n.a, function(n) {
                    return p(n, {
                        sx: Ju(k([
                            n.sx,
                            k([
                                xF("")
                            ])
                        ]))
                    });
                }));
            case 14:
                return t = n.b, A2(pc, w, A3(KF, r, n.a, function(n) {
                    return p(n, {
                        n6: A2(ww, t, n.n6)
                    });
                }));
            case 15:
                return t = n.b, A2(pc, w, A3(KF, r, n.a, function(n) {
                    return p(n, {
                        m8: A2(ww, t, n.m8)
                    });
                }));
            case 16:
                return t = n.b, A2(pc, w, A3(KF, r, n.a, function(n) {
                    return p(n, {
                        m9: A2(ww, t, n.m9)
                    });
                }));
            case 17:
                return t = n.b, A2(pc, w, A3(KF, r, n.a, function(n) {
                    return p(n, {
                        sa: A2(ww, t, n.sa)
                    });
                }));
            case 18:
                return A2(pc, w, A4(XF, r, a = n.a, i = n.b, t = n.c));
            case 19:
                var a = n.a;
                return A2(pc, w, A2(ZF, r, function(n) {
                    return p(n, {
                        lC: Ju(k([
                            A2(Ko, a, n.lC),
                            A2(IF, a + 1, n.lC)
                        ]))
                    });
                }));
            default:
                var i = n.b;
                return A2(pc, w, A3(KF, r, a = n.a, function(n) {
                    return p(n, {
                        sx: Ju(k([
                            A2(Ko, i, n.sx),
                            A2(IF, i + 1, n.sx)
                        ]))
                    });
                }));
        }
        var c, f, s;
    }), YF = {
        $: 1
    }, GF = function(n) {
        return {
            $: 22,
            a: n
        };
    }, nM = function(n) {
        return {
            $: 2,
            a: n
        };
    }, rM = function(n) {
        return {
            $: 11,
            a: n
        };
    }, tM = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), eM = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: tM(r)
        });
    }), uM = F2(function(n, r) {
        var t;
        return cg({
            n6: n,
            ds: Ew((t = r, A2(bu, Ua, t))),
            dN: r
        });
    }), oM = k([
        Ow("Table")
    ]), aM = ug({
        j_: k([
            A2(eM, "Edit", A2(bu, Pg("Edit"), nM)),
            A2(uM, "Name", function(n) {
                return n.n6;
            }),
            A2(uM, "Description", function(n) {
                return n.kN;
            }),
            A2(eM, "Delete", A2(bu, Bw(kg), rM))
        ]),
        kv: p(hg, {
            pS: function() {
                return k([
                    Ow("TableTr")
                ]);
            },
            rE: oM,
            rQ: k([
                Ow("TableTd")
            ])
        }),
        rZ: function(n) {
            return n.mo;
        },
        r_: function(n) {
            return {
                $: 21,
                a: n
            };
        }
    }), iM = {
        $: 6
    }, cM = function(n) {
        return {
            $: 5,
            a: n
        };
    }, fM = F2(function(n, r) {
        return {
            $: 15,
            a: n,
            b: r
        };
    }), sM = F2(function(n, r) {
        return {
            $: 16,
            a: n,
            b: r
        };
    }), lM = F2(function(n, r) {
        return {
            $: 14,
            a: n,
            b: r
        };
    }), dM = F2(function(n, r) {
        return {
            $: 17,
            a: n,
            b: r
        };
    }), mM = F3(function(n, r, t) {
        return {
            $: 18,
            a: n,
            b: r,
            c: t
        };
    }), bM = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pM = {
        $: 12
    }, vM = function(n) {
        return {
            $: 13,
            a: n
        };
    }, $M = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), wM = {
        $: 7
    }, gM = F2(function(n, r) {
        return A2(ye, k([
            Ow("ButtonIcon"),
            Cg(r)
        ]), k([
            n
        ]));
    }), hM = Ae("textarea"), kM = function(n) {
        return A2(Og, n, A2(hM, k([
            Ow("InputTextarea"),
            Xg(n.kX),
            eh(Lg),
            Gg(jg),
            nh(Fg),
            oh(n.sw),
            uh(n.gw),
            Hg(Zg(n.m7)),
            zg(n.kS)
        ]), w));
    }, CM = function(n) {
        return A2(jk, n, kM(n));
    }, TM = k([
        d("string", "String"),
        d("date", "Date"),
        d("number", "Number"),
        d("boolean", "Boolean")
    ]), PM = function(n) {
        return A2(Ck, function(n) {
            var r = function(n) {
                return 1 !== n.oS.$;
            }(n) ? d("Save", "Edit Schema") : d("Create", "New Schema");
            return A4(_k, r.b, d(r.a, wM), d("Cancel", iM), k([
                A2(mh, bM, Mk(n.n6)),
                A2(mh, cM, CM(n.kN)),
                A2(ye, w, k([
                    A2(ye, w, A2(Ht, F2(function(n, r) {
                        var t;
                        return A2(ye, w, k([
                            A2(ye, k([
                                Ow("FieldTitle")
                            ]), k([
                                A2(gM, kg, (t = n, {
                                    $: 19,
                                    a: t
                                })),
                                bC("Field #" + Mt(n + 1))
                            ])),
                            A2(mh, lM(n), Mk(r.n6)),
                            A2(mh, fM(n), Mk(r.m8)),
                            A2(mh, sM(n), Mk(r.m9)),
                            A2(mh, dM(n), A2(Ek, r.sa, TM)),
                            A2(DL, "string" === r.sa.sw, A2(ye, k([
                                Ow("InputLabel")
                            ]), k([
                                A2(dg, k([
                                    Ow("InputLabelText")
                                ]), k([
                                    ag("Possible values:")
                                ])),
                                A2(ye, k([
                                    Ow("FieldBloc")
                                ]), $(a(r.sx, w) ? k([
                                    ag("All values are accepted.")
                                ]) : A2(Ht, F2(function(r, t) {
                                    return A2(ye, k([
                                        Ow("FieldLine")
                                    ]), k([
                                        A2(mh, A2(mM, n, r), Mk(t)),
                                        A2(gM, kg, A2($M, n, r))
                                    ]));
                                }), r.sx), k([
                                    A2(Pg, "Add possible Value", vM(n))
                                ])))
                            ])))
                        ]));
                    }), n.lC)),
                    A2(ye, w, k([
                        A2(Pg, "Add New Field", pM)
                    ]))
                ])),
                A2(IL, w, w)
            ]));
        }, n.kP);
    }, SM = F2(function(n, r) {
        var t = Ua(r.px.sw), e = A2(Mu, function(n) {
            return A2(bu, A2(bu, Be(t), Ua), function(n) {
                return n.n6;
            })(n) || A2(bu, A2(bu, Be(t), Ua), function(n) {
                return n.kN;
            })(n);
        }, r.p6);
        return A3(gC, "Metadata Schemas", ht(A2(Pg, "New\u2026", YF)), A2(ye, w, k([
            A2(mh, GF, ah(r.px)),
            PM(r),
            A3(ck, aM, r.rN, e)
        ])));
    }), AM = {
        l: function(n) {
            return n.c2;
        },
        m: FF,
        o: F2(function(n, r) {
            return p(n, {
                c2: r
            });
        }),
        p: function(n) {
            return {
                $: 16,
                a: n
            };
        },
        q: JF,
        r: SM
    }, yM = {
        iS: Su,
        kP: kt,
        lo: kt,
        oN: w,
        oQ: w,
        px: za(function(n) {
            return p(n, {
                gw: "Search Organizations",
                sw: ""
            });
        }),
        rz: kt,
        rN: o$("Organization")
    }, NM = function(n) {
        return {
            $: 0,
            a: n
        };
    }, LM = function(n) {
        return {
            $: 3,
            a: n
        };
    }, jM = yi(yF(LM({
        $: 0
    }))), FM = F3(function(n, r, t) {
        return {
            iR: r,
            eZ: t,
            oO: n
        };
    }), MM = Fi(A4(qi, "enablePayment", function(n) {
        return n.eZ;
    }, ri, A4(rc, "app", function(n) {
        return n.iR;
    }, Oa, A4(rc, "organizationId", function(n) {
        return n.oO;
    }, Oa, Mi(FM))))), IM = ic(MM), DM = mc(A2(Wi, IM, Ai(jM))), BM = mc(A2(Wi, M$, Ai(D$))), xM = A2(Xa, NM, Gb(d(BM, DM))), qM = d(yM, xM), VM = function(n) {
        return {
            $: 5,
            a: n
        };
    }, OM = F3(function(n, r, t) {
        return {
            iR: r,
            eZ: t,
            oO: n
        };
    }), zM = Fi(A4(rc, "enablePayment", function(n) {
        return n.eZ;
    }, ri, A4(rc, "app", function(n) {
        return n.iR;
    }, Oa, A4(rc, "organizationId", function(n) {
        return n.oO;
    }, Oa, Mi(OM))))), EM = function(n) {
        return mc(sw(A3(ow, zM, n, rw(jM))));
    }, HM = {
        oc: kt,
        oO: kt
    }, RM = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), WM = F2(function(n, r) {
        for(;;){
            if (!r.b) return kt;
            var t = r.a, e = r.b;
            if (a(n, t.mo)) return ht(t);
            r = e;
        }
    }), UM = function(n) {
        return {
            $: 6,
            a: n
        };
    }, QM = F2(function(n, r) {
        return {
            iR: n,
            eZ: r
        };
    }), _M = Fi(A4(rc, "enablePayment", function(n) {
        return n.eZ;
    }, ri, A4(rc, "app", function(n) {
        return n.iR;
    }, Oa, Mi(QM)))), ZM = F2(function(n, r) {
        return mc(sw(A3(ow, _M, r, dw(function(n) {
            return yi(yF(LM({
                $: 1,
                a: n
            })));
        }(n)))));
    }), KM = F3(function(n, r, t) {
        return A2(Xa, UM, A2(ZM, n, {
            iR: r,
            eZ: t
        }));
    }), XM = F2(function(n, r) {
        switch(n.$){
            case 0:
                if (n.a.$) return A2(pc, w, A2(RM, n.a.a, r));
                var t = n.a.a, e = t.a, u = t.b, o = A3(Je, F2(function(n, r) {
                    return A3(hi, n.oO, function(r) {
                        if (r.$) {
                            var t = A2(WM, n.oO, e);
                            if (t.$) return kt;
                            var u = t.a;
                            return ht({
                                iR: n,
                                oM: u,
                                qb: Ua(u.n6)
                            });
                        }
                        return ht(p(r.a, {
                            iR: n
                        }));
                    }, r);
                }), Su, u);
                return A2(pc, w, p(r, {
                    iS: o,
                    oN: u,
                    oQ: e
                }));
            case 2:
                return A2(pc, w, p(r, {
                    kP: kt,
                    lo: kt,
                    rz: kt
                }));
            case 3:
                var a = A2(Ye, A2(bu, Xa(VM), EM), A2(ju, w, A2(Lu, Wo, A2(sp, function(n) {
                    var r = d(n.oO, n.oc);
                    return r.a.$ || r.b.$ ? kt : ht({
                        iR: r.b.a,
                        eZ: !1,
                        oO: r.a.a
                    });
                }, r.kP))));
                return A2(pc, a, p(r, {
                    kP: A2(Lu, function(n) {
                        return p(n, {
                            oc: kt
                        });
                    }, r.kP),
                    lo: kt,
                    rz: kt
                }));
            case 4:
                var i = n.a;
                return A2(pc, w, p(r, {
                    kP: ht(p(A2(ju, HM, r.kP), {
                        oO: "" === i ? kt : ht(i)
                    }))
                }));
            case 11:
                var c = n.a;
                return A2(pc, w, p(r, {
                    kP: ht(p(A2(ju, HM, r.kP), {
                        oc: "" === c ? kt : ht(c)
                    }))
                }));
            case 1:
                return A2(pc, w, p(r, {
                    lo: kt,
                    rz: kt
                }));
            case 5:
                return (f = n.a).$ ? A2(pc, w, A2(RM, f.a, r)) : A2(pc, k([
                    xM
                ]), p(r, {
                    lo: kt,
                    rz: ht("Onboarded organization onto app")
                }));
            case 6:
                var f;
                return (f = n.a).$ ? A2(pc, w, A2(RM, f.a, r)) : A2(pc, k([
                    xM
                ]), p(r, {
                    lo: kt,
                    rz: ht("Updated onboarded organization onto app")
                }));
            case 8:
                return A2(pc, w, p(r, {
                    kP: ht(p(HM, {
                        oO: ht(n.a.oM.mo)
                    }))
                }));
            case 9:
                return A2(pc, w, p(r, {
                    kP: ht(HM),
                    lo: kt,
                    rz: kt
                }));
            case 7:
                return A2(pc, w, p(r, {
                    px: A2(ww, n.a, r.px)
                }));
            case 10:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            default:
                return A2(pc, k([
                    A3(KM, i = n.a, n.b, n.c)
                ]), p(r, {
                    lo: kt,
                    rz: kt
                }));
        }
    }), JM = function(n) {
        return {
            $: 7,
            a: n
        };
    }, YM = {
        $: 9
    }, GM = function(n) {
        return {
            $: 8,
            a: n
        };
    }, nI = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), rI = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: nI(r)
        });
    }), tI = F2(function(n, r) {
        var t;
        return cg({
            n6: n,
            ds: Ew((t = r, A2(bu, Ua, t))),
            dN: r
        });
    }), eI = ug({
        j_: k([
            A2(rI, "Edit", A2(bu, Pg("Edit"), GM)),
            A2(tI, "Organization", A2(Pi, function(n) {
                return n.oM;
            }, function(n) {
                return n.n6;
            })),
            A2(rI, "Apps (checked is ACTIVATED payment)", function(n) {
                return A2(ye, w, k([
                    A2(dg, k([
                        Ow("OrganizationOnboarding")
                    ]), k([
                        A2(dg, k([
                            Ow("OrganizationOnboardingCheck")
                        ]), k([
                            a(n.iR.eZ, ht(!0)) ? ag("\u2705") : ag("\u274C")
                        ])),
                        ag(n.iR.iR)
                    ]))
                ]));
            })
        ]),
        kv: p(hg, {
            pS: function() {
                return k([
                    Ow("TableTr")
                ]);
            },
            rE: k([
                Ow("Table")
            ]),
            rQ: k([
                Ow("TableTd")
            ])
        }),
        rZ: A2(Pi, function(n) {
            return n.oM;
        }, function(n) {
            return n.mo;
        }),
        r_: function(n) {
            return {
                $: 10,
                a: n
            };
        }
    }), uI = function(n) {
        return A3(bt, F3(function(n, r, t) {
            return A2(mt, r, t);
        }), w, n);
    }, oI = {
        $: 1
    }, aI = function(n) {
        var r = n.lo;
        if (r.$) {
            var t = n.rz;
            if (t.$) return ag("");
            var e = t.a;
            return A2(ye, k([
                Cg(oI)
            ]), k([
                lk(e)
            ]));
        }
        var u = r.a;
        return A2(ye, k([
            Cg(oI)
        ]), k([
            sk(u)
        ]));
    }, iI = {
        $: 2
    }, cI = {
        $: 3
    }, fI = function(n) {
        return {
            $: 11,
            a: n
        };
    }, sI = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lI = k([
        "adnomalab",
        "m6pub",
        "nomalab",
        "via"
    ]), dI = {
        jQ: kt,
        bF: w,
        kS: !1,
        lx: w,
        mn: kt,
        mK: !1,
        bf: !1,
        bg: !1,
        m7: "",
        oy: kt,
        rW: "",
        sr: kt
    }, mI = Bg(w), bI = ju(mI), pI = function(n) {
        return A2(bu, bI, Lu(n));
    }, vI = function(n) {
        return A2(a(n.sr, kt) ? ye : oC, A2(yu, n.lx, k([
            A2(pI, Cg, n.oy),
            A2(pI, Ow, n.jQ),
            A2(pI, fC, n.sr),
            Bg(k([
                d("CustomButtonActive", n.mK),
                d("CustomButtonDisabled", n.kS),
                d("CustomButtonPrimary", n.bf)
            ])),
            Bg(n.bF),
            Ow("CustomButton"),
            Ow("CustomButtonMini")
        ])), k([
            function() {
                var r = n.mn;
                if (r.$) return ag("");
                var t = r.a;
                return A2(ye, k([
                    Ow("CustomButtonIcon")
                ]), k([
                    t
                ]));
            }(),
            n.bg ? A2(Aw, k([
                Ow("CustomButtonLabel"),
                Tg("submit")
            ]), k([
                ag(n.m7)
            ])) : A2(qg, k([
                Ow("CustomButtonLabel")
            ]), n.m7)
        ]));
    }, $I = F3(function(n, r, t) {
        return {
            $: 12,
            a: n,
            b: r,
            c: t
        };
    }), wI = F2(function(n, r) {
        return A2(Nk, k([
            Ow("OrganizationEditApp")
        ]), k([
            A2(Eg, k([
                Tg("checkbox"),
                Pk(a(r.eZ, ht(!0))),
                Ak(A2($I, n, r.iR))
            ]), w),
            A2(dg, w, k([
                ag(r.iR)
            ]))
        ]));
    }), gI = function(n) {
        return A2(Ck, function(r) {
            return A4(_k, "Edit Organization", d("Close", iI), d("Close", iI), function() {
                var t = A2(sp, function(r) {
                    return A2(WM, r, n.oQ);
                }, r.oO);
                if (t.$) return k([
                    aI(n),
                    A2(qk, k([
                        eh(sI)
                    ]), A2(mt, A2(xk, k([
                        oh("")
                    ]), k([
                        ag("Choose organization...")
                    ])), A2(Ye, function(n) {
                        return A2(xk, k([
                            oh(n.mo)
                        ]), k([
                            ag(n.n6)
                        ]));
                    }, n.oQ)))
                ]);
                var e = t.a, u = A2(Lu, function(n) {
                    return n.iR;
                }, A2(di, e.mo, n.iS));
                return k([
                    A2(dC, w, k([
                        ag("Editing "),
                        ag(e.n6)
                    ])),
                    aI(n),
                    A2(ye, w, k([
                        A2(Ck, wI(e.mo), u)
                    ])),
                    A2(DL, a(u, kt), A2(ye, w, k([
                        A2(qk, k([
                            eh(fI),
                            A2(ju, Bg(w), A2(Lu, oh, r.oc))
                        ]), A2(mt, A2(xk, k([
                            oh("")
                        ]), k([
                            ag("Add app...")
                        ])), A2(Ye, function(n) {
                            return A2(xk, k([
                                oh(n)
                            ]), k([
                                ag(n)
                            ]));
                        }, lI))),
                        vI(p(dI, {
                            mK: !a(r.oc, kt),
                            m7: "Add New App",
                            oy: ht(cI)
                        }))
                    ])))
                ]);
            }());
        }, n.kP);
    }, hI = F2(function(n, r) {
        var t = Ua(r.px.sw), e = A2(Mu, A2(bu, Be(t), function(n) {
            return n.qb;
        }), uI(r.iS));
        return A3(gC, "Organizations: onboarding", ht(A2(Pg, "New\u2026", YM)), A2(ye, w, k([
            A2(mh, JM, ah(r.px)),
            aI(r),
            gI(r),
            A3(ck, eI, r.rN, e)
        ])));
    }), kI = {
        l: function(n) {
            return n.db;
        },
        m: qM,
        o: F2(function(n, r) {
            return p(n, {
                db: r
            });
        }),
        p: function(n) {
            return {
                $: 3,
                a: n
            };
        },
        q: XM,
        r: hI
    }, CI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, TI = A2(Xa, CI, mc(A2(Wi, M$, Ai(D$)))), PI = {
        iT: za(Me),
        kx: w,
        ky: kt,
        n1: za(Me),
        oQ: w,
        oR: za(Me),
        rN: o$("Name"),
        sU: za(Me)
    }, SI = A2(pc, k([
        TI
    ]), PI), AI = function(n) {
        return {
            $: 6,
            a: n
        };
    }, yI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, NI = Fi(A4(rc, "path", function(n) {
        return n.gs;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "showName", function(n) {
        return n.hb;
    }, Oa, A4(qi, "duration", function(n) {
        return n.eU;
    }, dA, A4(rc, "state", function(n) {
        return n.hv;
    }, Db, A4(rc, "key", function(n) {
        return n.fL;
    }, Oa, A4(rc, "bucket", function(n) {
        return n.en;
    }, Oa, A4(qi, "mimeType", function(n) {
        return n.nT;
    }, Oa, A4(rc, "size", function(n) {
        return n.qP;
    }, dA, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    en: u,
                                                    ki: r,
                                                    eU: i,
                                                    fL: o,
                                                    nT: e,
                                                    n6: n,
                                                    gs: s,
                                                    g9: f,
                                                    hb: c,
                                                    qP: t,
                                                    hv: a
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), LI = ic(NI), jI = function(n) {
        return A2(Xa, yI, function(n) {
            return mc(A2(Wi, LI, Ai(dl(pF(A2(bF, n, 1))))));
        }(n));
    }, FI = F2(function(n, r) {
        switch(n.$){
            case 7:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            case 2:
                return A2(pc, (t = n.a).$ ? w : k([
                    jI(t.a)
                ]), p(r, {
                    oR: A2(ww, t, r.oR)
                }));
            case 3:
                var t = n.a;
                return A2(pc, k([
                    jI(r.oR.sw)
                ]), p(r, {
                    iT: A2(ww, t, r.iT)
                }));
            case 4:
                return t = n.a, A2(pc, k([
                    jI(r.oR.sw)
                ]), p(r, {
                    n1: A2(ww, t, r.n1)
                }));
            case 5:
                return t = n.a, A2(pc, k([
                    jI(r.oR.sw)
                ]), p(r, {
                    sU: A2(ww, t, r.sU)
                }));
            case 1:
                return A2(pc, w, (e = n.a).$ ? r : p(r, {
                    oQ: e.a
                }));
            case 6:
                return A2(pc, w, p(r, {
                    ky: ht(n.a)
                }));
            default:
                var e;
                if ((e = n.a).$) return A2(pc, w, p(r, {
                    kx: w
                }));
                var u = e.a;
                return A2(pc, k([
                    A2(Yv, AI, Jv)
                ]), p(r, {
                    kx: u
                }));
        }
    }), MI = F2(function(n, r) {
        return n ? r : mI;
    }), II = Vw("title"), DI = function(n) {
        return A2(a(n.sr, kt) ? ye : oC, A2(yu, n.lx, k([
            A2(MI, !n.kS, A2(pI, Cg, n.oy)),
            A2(pI, Ow, n.jQ),
            A2(MI, !n.kS, A2(pI, fC, n.sr)),
            II(n.rW),
            zg(n.kS),
            Bg(k([
                d("CustomButtonActive", n.mK),
                d("CustomButtonDisabled", n.kS),
                d("CustomButtonPrimary", n.bf)
            ])),
            Bg(n.bF),
            Ow("CustomButton")
        ])), k([
            function() {
                var r = n.mn;
                if (r.$) return ag("");
                var t = r.a;
                return A2(ye, k([
                    Ow("CustomButtonIcon")
                ]), k([
                    t
                ]));
            }(),
            n.bg ? A2(Aw, k([
                Ow("CustomButtonLabel")
            ]), k([
                ag(n.m7)
            ])) : A2(qg, k([
                Ow("CustomButtonLabel")
            ]), n.m7)
        ]));
    }, BI = A2(Zw, k([
        Hw("16px"),
        Xw("16px"),
        Kw("0 0 16 16"),
        Fw("IconOk")
    ]), k([
        A2(_w, k([
            Fw("Fg"),
            Rw("8 4 12 12 4 12")
        ]), w)
    ])), xI = F2(function(n, r) {
        return A2(ye, k([
            Ow("BannerCTA")
        ]), k([
            A2(ye, k([
                Ow("BannerCTAIcon")
            ]), k([
                BI
            ])),
            A2(qg, k([
                Ow("BannerCTALabel")
            ]), n),
            DI(r)
        ]));
    }), qI = Lw, VI = yi(yF({
        $: 0
    })), OI = A2(xI, "Download organizations files listing", p(dI, {
        lx: k([
            A2(qI, "target", "_blank"),
            A2(qI, "data-prevent-history", "true"),
            A2(qI, "download", "organizations-files-listing.csv")
        ]),
        m7: "Generate CSV",
        sr: ht(Si(VI))
    })), zI = F2(function() {
        return A3(gC, "Organization File Listing", kt, A2(ye, k([
            Ow("AdminPadding")
        ]), k([
            OI
        ])));
    }), EI = {
        l: function(n) {
            return n.dc;
        },
        m: SI,
        o: F2(function(n, r) {
            return p(n, {
                dc: r
            });
        }),
        p: function(n) {
            return {
                $: 11,
                a: n
            };
        },
        q: FI,
        r: zI
    }, HI = {
        kP: kt,
        lo: kt,
        e5: w,
        cX: w,
        f3: w,
        oQ: w,
        px: za(function(n) {
            return p(n, {
                gw: "Search Organization by Name, Test Plan or Format",
                sw: ""
            });
        }),
        $7: w,
        dw: w,
        rz: kt,
        rN: o$("Name"),
        dB: Su
    }, RI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, WI = mc(A2(Wi, qA, Ai(OA))), UI = mc(A2(Wi, M$, Ai(D$))), QI = F5(function(n, r, t, e, u) {
        return {
            lJ: n,
            nc: r,
            nM: e,
            nV: t,
            py: u
        };
    }), _I = F3(function(n, r, t) {
        return {
            cK: t,
            al: r,
            dI: n
        };
    }), ZI = Fi(A4(rc, "durationMax", function(n) {
        return n.cK;
    }, uc, A4(rc, "durationMin", function(n) {
        return n.al;
    }, uc, A4(rc, "totalBreaks", function(n) {
        return n.dI;
    }, uc, Mi(_I))))), KI = Fi(A4(rc, "ranges", function(n) {
        return n.py;
    }, ic(ZI), A4(qi, "maxInterval", function(n) {
        return n.nM;
    }, uc, A4(qi, "minInterval", function(n) {
        return n.nV;
    }, uc, A4(qi, "lastPoint", function(n) {
        return n.nc;
    }, uc, A4(qi, "firstPoint", function(n) {
        return n.lJ;
    }, uc, Mi(QI))))))), XI = F3(function(n, r, t) {
        return {
            al: t,
            b2: r,
            rW: n
        };
    }), JI = Fi(A4(qi, "durationMin", function(n) {
        return n.al;
    }, uc, A4(qi, "offset", function(n) {
        return n.b2;
    }, uc, A4(qi, "title", function(n) {
        return n.rW;
    }, Oa, Mi(XI))))), YI = F3(function(n, r, t) {
        return {
            eN: t,
            fX: r,
            fY: n
        };
    }), GI = Fi(A4(rc, "deepProbeAnalysis", function(n) {
        return n.eN;
    }, ri, A4(rc, "m2cAnalysis", function(n) {
        return n.fX;
    }, ri, A4(rc, "m2cProxy", function(n) {
        return n.fY;
    }, ri, Mi(YI))))), nD = function(n) {
        switch(n){
            case "anime":
                return At(0);
            case "telenovela":
                return At(1);
            case "other":
                return At(2);
            default:
                return Ct(A2(ka, "can't parse str to typology", s$));
        }
    }, rD = function(n) {
        switch(n){
            case 0:
                return "anime";
            case 1:
                return "telenovela";
            default:
                return "other";
        }
    }, tD = A2(Ml, rD, nD), eD = Fi(A4(rc, "skipJobs", function(n) {
        return n.ce;
    }, GI, A4(rc, "typology", function(n) {
        return n.sb;
    }, tD, A4(rc, "postCredits", function(n) {
        return n.o9;
    }, ri, A4(qi, "minOutro", function(n) {
        return n.nY;
    }, uc, A4(qi, "minIntro", function(n) {
        return n.nW;
    }, uc, A4(rc, "skipIntro", function(n) {
        return n.qQ;
    }, ri, A4(rc, "endingCredits", function(n) {
        return n.bO;
    }, JI, A4(rc, "openingCredits", function(n) {
        return n.b3;
    }, JI, A4(rc, "adBreaks", function(n) {
        return n.az;
    }, KI, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    az: t,
                                                    bO: u,
                                                    mo: n,
                                                    nW: a,
                                                    nY: i,
                                                    n6: r,
                                                    b3: e,
                                                    o9: c,
                                                    qQ: o,
                                                    ce: s,
                                                    sb: f
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), uD = ic(eD), oD = function(n) {
        return {
            $: 4,
            a: n
        };
    }, aD = yi(oD({
        $: 0
    })), iD = mc(A2(Wi, uD, Ai(aD))), cD = mc(A2(Wi, YA, Ai(ny))), fD = A2(Yb, Ji, A2(Yb, Ye(function(n) {
        return d(n.mo, n);
    }), mc(A2(Wi, uy, Ai(ay))))), sD = F6(function(n, r, t, e, u, o) {
        return A2(Ge, function(r) {
            return A2(Ge, function(t) {
                return A2(Ge, function(e) {
                    return A2(Ge, function(u) {
                        return A2(Ge, function(o) {
                            return Ze(A5(n, r, t, e, u, o));
                        }, o);
                    }, u);
                }, e);
            }, t);
        }, r);
    }), lD = sD, dD = F7(function(n, r, t, e, u, o, a) {
        return A2(BT, function(n) {
            return A2(Yb, n, a);
        }, A6(lD, n, r, t, e, u, o));
    }), mD = A2(Xa, RI, A7(dD, F6(function(n, r, t, e, u, o) {
        return {
            cX: t,
            f3: o,
            oQ: n,
            $7: u,
            dw: e,
            dB: r
        };
    }), UI, fD, WI, cD, iD, LF)), bD = d(HI, mD), pD = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), vD = F2(function(n, r) {
        var t = ti(function(t) {
            return p(t, {
                m7: r ? "Select default extra format" : "Select default format",
                sw: n.mO
            });
        });
        return {
            mo: za(function(t) {
                return p(t, {
                    m7: r ? "Extra Format" : "Format",
                    sw: n.mo
                });
            }),
            mO: t
        };
    }), $D = k([
        "\\${originalFileName}",
        "\\${broadcasterId}",
        "\\${collectionName}",
        "\\${seasonName}",
        "\\${episodeName}",
        "\\${showTitle}",
        "\\${date}"
    ]), wD = function(n) {
        return {
            iu: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Ad.nomalab destination",
                    sw: !1
                } : {
                    m7: "Ad.nomalab destination",
                    sw: n.a.iu
                });
            }),
            iy: A2(Ea, "Formats", w),
            iJ: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Allow Delivery Without Transcoding",
                    sw: !1
                } : {
                    m7: "Toggle Allow Delivery Without Transcoding",
                    sw: n.a.iJ
                });
            }),
            jc: za(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "\u26A0 Automatic Show Deletion \u26A0",
                    sw: "false"
                } : {
                    m7: "\u26A0 Automatic Show Deletion \u26A0",
                    sw: n.a.jc ? "true" : "false"
                });
            }),
            js: za(function(r) {
                var t = A2(sp, function(n) {
                    return n.js;
                }, n);
                return p(r, 1 === t.$ ? {
                    m7: "Broadcaster",
                    sw: ""
                } : {
                    m7: "Broadcaster",
                    sw: y$(t.a)
                });
            }),
            kO: za(function(r) {
                if (1 === n.$) return p(r, {
                    m7: "Delivery destination",
                    gw: A3(xt, F2(function(n, r) {
                        return r + "_" + n;
                    }), "ex : ftp://test:test@localhost/upload/", A2(Ye, Ve(1), $D)),
                    sw: ""
                });
                var t = n.a;
                return p(r, {
                    m7: "Delivery destination",
                    gw: A3(xt, F2(function(n, r) {
                        return r + (n + "_");
                    }), "ex : ftp://test:test@localhost/upload/", A2(Ye, Ve(1), $D)),
                    sw: A2(ju, "", t.kO)
                });
            }),
            kZ: za(function(r) {
                if (1 === n.$) return p(r, {
                    m7: "Download File Name",
                    gw: A3(xt, F2(function(n, r) {
                        return r + "_" + n;
                    }), "", A2(Ye, Ve(1), $D)),
                    sw: ""
                });
                var t = n.a;
                return p(r, {
                    m7: "Download File Name",
                    gw: A3(xt, F2(function(n, r) {
                        return r + (n + "_");
                    }), "", A2(Ye, Ve(1), $D)),
                    sw: A2(ju, "", t.kZ)
                });
            }),
            lc: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Toggle auto accept feature",
                    sw: !1
                } : {
                    m7: "Toggle auto accept feature",
                    sw: n.a.lc
                });
            }),
            ld: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Toggle auto reject feature",
                    sw: !1
                } : {
                    m7: "Toggle auto reject feature",
                    sw: n.a.ld
                });
            }),
            le: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Toggle creation mail",
                    sw: !1
                } : {
                    m7: "Toggle creation mail",
                    sw: n.a.le
                });
            }),
            lf: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Toggle static ip for delivery",
                    sw: !1
                } : {
                    m7: "Toggle static ip for delivery",
                    sw: n.a.dv
                });
            }),
            lg: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Toggle upload success mail",
                    sw: !1
                } : {
                    m7: "Toggle upload success mail",
                    sw: n.a.lg
                });
            }),
            lh: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Toggle video ready mail",
                    sw: !0
                } : {
                    m7: "Toggle video ready mail",
                    sw: n.a.lh
                });
            }),
            e5: function() {
                if (n.$) return Su;
                var r = n.a;
                return A2(Gi, F2(function(n, r) {
                    return A2(vD, r, !0);
                }), Ji(A2(Ht, V$, r.e5)));
            }(),
            cX: function() {
                if (n.$) return Su;
                var r = n.a;
                return A2(Gi, F2(function(n, r) {
                    return A2(vD, r, !1);
                }), Ji(A2(Ht, V$, r.cX)));
            }(),
            mM: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Advertiser",
                    sw: !1
                } : {
                    m7: "Advertiser",
                    sw: n.a.mM
                });
            }),
            nr: za(function(r) {
                var t = A2(sp, function(n) {
                    return n.nr;
                }, n);
                return p(r, t.$ ? {
                    m7: "Logo",
                    sw: ""
                } : {
                    m7: "Logo",
                    sw: t.a
                });
            }),
            nK: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Toggle manual delivery",
                    sw: !1
                } : {
                    m7: "Toggle manual delivery",
                    sw: n.a.nK
                });
            }),
            nS: za(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Metadata Schema",
                    sw: ""
                } : {
                    m7: "Metadata Schema",
                    sw: A2(ju, "", n.a.nS)
                });
            }),
            n6: za(function(r) {
                return p(r, {
                    m7: "Name",
                    sw: A2(ju, "", A2(Lu, function(n) {
                        return n.n6;
                    }, n))
                });
            }),
            oa: za(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Need accept before launching transcode",
                    sw: "false"
                } : {
                    m7: "Need accept before launching transcode",
                    sw: n.a.oa ? "true" : "false"
                });
            }),
            oS: n,
            pq: za(function(r) {
                return p(r, {
                    m7: "QC master report template",
                    sw: A2(ju, "", A2(Lu, function(n) {
                        return n.pq;
                    }, n))
                });
            }),
            pr: za(function(r) {
                return p(r, {
                    m7: "QC master test plan",
                    sw: A2(ju, "", A2(Lu, function(n) {
                        return n.pr;
                    }, n))
                });
            }),
            pF: ti(function(r) {
                return p(r, 1 === n.$ ? {
                    m7: "Toggle files replication",
                    sw: !1
                } : {
                    m7: "Toggle files replication",
                    sw: n.a.pF
                });
            }),
            $7: function() {
                if (n.$) return Su;
                var r = n.a;
                return A2(Gi, F2(function(n, r) {
                    return za(function(n) {
                        return p(n, {
                            m7: "Segmentation rule",
                            sw: r
                        });
                    });
                }), Ji(A2(Ht, V$, r.$7)));
            }(),
            dw: function() {
                if (n.$) return Su;
                var r = n.a;
                return A2(Gi, F2(function(n, r) {
                    return za(function(n) {
                        return p(n, {
                            m7: "Subtitle Format",
                            sw: r
                        });
                    });
                }), Ji(A2(Ht, V$, r.dw)));
            }()
        };
    }, gD = function(n) {
        return {
            $: 38,
            a: n
        };
    }, hD = F3(function(n, r, t) {
        if (1 === r.$) return Ct(r.a);
        var e = r.a;
        return 1 === t.$ ? Ct(t.a) : At(A2(n, e, t.a));
    }), kD = function(n) {
        return A2(Ia, w, A3(Je, F2(function(n, r) {
            var t = d(n, r);
            return t.b.$ ? Ct(t.b.a) : t.a.$ ? Ct(t.a.a) : At(A2(mt, t.a.a, t.b.a));
        }), At(w), A2(Ye, function(n) {
            var r = n.b;
            return A3(hD, L$, At(r.mo.sw), At(r.mO.sw));
        }, pt(n))));
    }, CD = Fi(A4(rc, "needAccept", function(n) {
        return n.oa;
    }, ri, A4(rc, "autoDeleteShows", function(n) {
        return n.jc;
    }, ri, A4(rc, "staticIp", function(n) {
        return n.dv;
    }, ri, A5(TF, "additionalVideoFormats", function(n) {
        return n.iy;
    }, ic(Oa), w, A4(rc, "metadataSchema", function(n) {
        return n.nS;
    }, Oa, A4(rc, "adNomalabDest", function(n) {
        return n.iu;
    }, ri, A4(rc, "noProxy", function(n) {
        return n.gg;
    }, ri, A4(rc, "noQC", function(n) {
        return n.gh;
    }, ri, A4(rc, "isAdvertiser", function(n) {
        return n.mM;
    }, ri, A4(rc, "segmentationRules", function(n) {
        return n.$7;
    }, ic(Oa), A4(rc, "extraFormats", function(n) {
        return n.e5;
    }, ic(j$), A4(rc, "subtitleFormats", function(n) {
        return n.dw;
    }, ic(Oa), A4(rc, "formats", function(n) {
        return n.cX;
    }, ic(j$), A4(qi, "logo", function(n) {
        return n.nr;
    }, Oa, A4(rc, "replication", function(n) {
        return n.pF;
    }, ri, A4(rc, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iJ;
    }, ri, A4(rc, "manualDelivery", function(n) {
        return n.nK;
    }, ri, A4(qi, "broadcaster", function(n) {
        return n.js;
    }, N$, A4(rc, "enableAutoReject", function(n) {
        return n.ld;
    }, ri, A4(rc, "enableAutoAccept", function(n) {
        return n.lc;
    }, ri, A4(rc, "enableUploadSuccessEmail", function(n) {
        return n.lg;
    }, ri, A4(rc, "enableVideoReadyEmail", function(n) {
        return n.lh;
    }, ri, A4(rc, "enableCreationEmail", function(n) {
        return n.le;
    }, ri, A4(qi, "downloadFileName", function(n) {
        return n.kZ;
    }, Oa, A4(qi, "destination", function(n) {
        return n.kO;
    }, Oa, A4(rc, "qcMasterReportTemplate", function(n) {
        return n.pq;
    }, Oa, A4(rc, "qcMasterTestPlan", function(n) {
        return n.pr;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(w) {
                                                                                return function(g) {
                                                                                    return function(h) {
                                                                                        return function(k) {
                                                                                            return function(C) {
                                                                                                return function(T) {
                                                                                                    return function(P) {
                                                                                                        return function(S) {
                                                                                                            return function(A) {
                                                                                                                return function(y) {
                                                                                                                    return {
                                                                                                                        iu: C,
                                                                                                                        iy: P,
                                                                                                                        iJ: d,
                                                                                                                        jc: A,
                                                                                                                        js: s,
                                                                                                                        kO: e,
                                                                                                                        kZ: u,
                                                                                                                        lc: c,
                                                                                                                        ld: f,
                                                                                                                        le: o,
                                                                                                                        lg: i,
                                                                                                                        lh: a,
                                                                                                                        e5: $,
                                                                                                                        cX: p,
                                                                                                                        mM: g,
                                                                                                                        nr: b,
                                                                                                                        nK: l,
                                                                                                                        nS: T,
                                                                                                                        n6: n,
                                                                                                                        oa: y,
                                                                                                                        gg: k,
                                                                                                                        gh: h,
                                                                                                                        pq: t,
                                                                                                                        pr: r,
                                                                                                                        pF: m,
                                                                                                                        $7: w,
                                                                                                                        dv: S,
                                                                                                                        dw: v
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))))))))), TD = F2(function(n, r) {
        return ze(r) ? At(kt) : A2(X$, ht, n(r));
    }), PD = Fi(A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return {
            mo: n
        };
    }))), SD = function(n) {
        var r;
        return A2(Xa, gD, A2(BT, function(n) {
            return mc(A2(nw, PD, A3(ow, CD, {
                iu: r.iu.sw,
                iy: vt(r.iy.sx),
                iJ: r.iJ.sw,
                jc: "true" === r.jc.sw,
                js: n,
                kO: ze(r.kO.sw) ? kt : ht(r.kO.sw),
                kZ: ze(r.kZ.sw) ? kt : ht(r.kZ.sw),
                lc: r.lc.sw,
                ld: r.ld.sw,
                le: r.le.sw,
                lg: r.lg.sw,
                lh: r.lh.sw,
                e5: kD(r.e5),
                cX: kD(r.cX),
                mM: r.mM.sw,
                nr: ze(r.nr.sw) ? kt : ht(r.nr.sw),
                nK: r.nK.sw,
                nS: r.nS.sw,
                n6: r.n6.sw,
                oa: "true" === r.oa.sw,
                gg: !1,
                gh: !1,
                pq: r.pq.sw,
                pr: r.pr.sw,
                pF: r.pF.sw,
                $7: A2(Ye, function(n) {
                    return n.b.sw;
                }, pt(r.$7)),
                dv: r.lf.sw,
                dw: A2(Ye, function(n) {
                    return n.b.sw;
                }, pt(r.dw))
            }, rw(D$))));
        }, A2(Qi, Dy, xy(A2(TD, A$, (r = n).js.sw)))));
    }, AD = function(n) {
        return {
            $: 41,
            a: n
        };
    }, yD = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ND = function(n) {
        return yi(I$(A2(yD, n, 1)));
    }, LD = function(n) {
        return {
            $: 39,
            a: n
        };
    }, jD = F2(function(n, r) {
        return A2(BT, function(t) {
            return mc(sw(A3(ow, CD, {
                iu: r.iu.sw,
                iy: vt(r.iy.sx),
                iJ: r.iJ.sw,
                jc: "true" === r.jc.sw,
                js: t,
                kO: ze(r.kO.sw) ? kt : ht(r.kO.sw),
                kZ: ze(r.kZ.sw) ? kt : ht(r.kZ.sw),
                lc: r.lc.sw,
                ld: r.ld.sw,
                le: r.le.sw,
                lg: r.lg.sw,
                lh: r.lh.sw,
                e5: kD(r.e5),
                cX: kD(r.cX),
                mM: r.mM.sw,
                nr: ze(r.nr.sw) ? kt : ht(r.nr.sw),
                nK: r.nK.sw,
                nS: r.nS.sw,
                n6: r.n6.sw,
                oa: "true" === r.oa.sw,
                gg: !1,
                gh: !1,
                pq: r.pq.sw,
                pr: r.pr.sw,
                pF: r.pF.sw,
                $7: A2(Ye, function(n) {
                    return n.b.sw;
                }, pt(r.$7)),
                dv: r.lf.sw,
                dw: A2(Ye, function(n) {
                    return n.b.sw;
                }, pt(r.dw))
            }, dw(ND(n.mo)))));
        }, A2(Qi, Dy, xy(A2(TD, A$, r.js.sw))));
    }), FD = F2(function(n, r) {
        return A2(Xa, LD, A2(jD, n, r));
    }), MD = F2(function(n, r) {
        return !A2(di, n, r).$;
    }), ID = F2(function(n, r) {
        var t = n.a, e = n.b, u = r.sx;
        return p(r, A2(MD, t, u) ? {
            sx: A2(gi, t, u)
        } : {
            sx: A3(Cu, t, e, u)
        });
    }), DD = F2(function(n, r) {
        return p(r, n.$ ? {
            mO: A2(vw, n.a, r.mO)
        } : {
            mo: A2(ww, n.a, r.mo)
        });
    }), BD = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, w, p(r, {
                    kP: ht(wD(ht(n.a)))
                }));
            case 1:
                return A2(pc, w, p(r, {
                    kP: ht(wD(kt))
                }));
            case 3:
                return A2(pc, w, p(r, {
                    kP: kt,
                    lo: kt,
                    rz: kt
                }));
            case 5:
                var t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        n6: A2(ww, t, n.n6)
                    });
                }, r.kP);
                return A2(pc, w, p(r, {
                    kP: e
                }));
            case 6:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        pr: A2(ww, t, n.pr)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 9:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        pq: A2(ww, t, n.pq)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 7:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        kO: A2(ww, t, n.kO)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 8:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        kZ: A2(ww, t, n.kZ)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 42:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nr: A2(ww, t, n.nr)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 10:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        le: A2(vw, t, n.le)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 11:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lh: A2(vw, t, n.lh)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 12:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lg: A2(vw, t, n.lg)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 13:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lc: A2(vw, t, n.lc)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 14:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        ld: A2(vw, t, n.ld)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 15:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        js: A2(ww, t, n.js)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 16:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nS: A2(ww, t, n.nS)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 17:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nK: A2(vw, t, n.nK)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 18:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        iJ: A2(vw, t, n.iJ)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 19:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        pF: A2(vw, t, n.pF)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 20:
                t = n.a;
                var u = n.b;
                return e = A2(Lu, function(n) {
                    return p(n, {
                        cX: A2(Gi, F2(function(n, r) {
                            return a(n, u) ? A2(DD, t, r) : r;
                        }), n.cX)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 33:
                return u = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        cX: A2(R$, F2(function(n) {
                            return !a(n, u);
                        }), n.cX)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 29:
                var o = A2(vD, {
                    mo: "",
                    mO: !1
                }, !1), i = A2(ju, 0, A2(Lu, function(n) {
                    return A2(ju, 0, W$(vt(n.cX)));
                }, r.kP));
                return e = A2(Lu, function(n) {
                    return p(n, {
                        cX: A3(Cu, i + 1, o, n.cX)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 21:
                return t = n.a, u = n.b, e = A2(Lu, function(n) {
                    return p(n, {
                        dw: A2(Gi, F2(function(n, r) {
                            return a(n, u) ? A2(ww, t, r) : r;
                        }), n.dw)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 34:
                return u = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        dw: A2(R$, F2(function(n) {
                            return !a(n, u);
                        }), n.dw)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 30:
                return o = za(function(n) {
                    return p(n, {
                        m7: "Subtitle Format",
                        sw: ""
                    });
                }), i = A2(ju, 0, A2(Lu, function(n) {
                    return A2(ju, 0, W$(vt(n.dw)));
                }, r.kP)), e = A2(Lu, function(n) {
                    return p(n, {
                        dw: A3(Cu, i + 1, o, n.dw)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 22:
                return t = n.a, u = n.b, e = A2(Lu, function(n) {
                    return p(n, {
                        e5: A2(Gi, F2(function(n, r) {
                            return a(n, u) ? A2(DD, t, r) : r;
                        }), n.e5)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 35:
                return u = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        e5: A2(R$, F2(function(n) {
                            return !a(n, u);
                        }), n.e5)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 31:
                return o = A2(vD, {
                    mo: "",
                    mO: !1
                }, !0), i = A2(ju, 0, A2(Lu, function(n) {
                    return A2(ju, 0, W$(vt(n.e5)));
                }, r.kP)), e = A2(Lu, function(n) {
                    return p(n, {
                        e5: A3(Cu, i + 1, o, n.e5)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 23:
                return t = n.a, u = n.b, e = A2(Lu, function(n) {
                    return p(n, {
                        $7: A2(Gi, F2(function(n, r) {
                            return a(n, u) ? A2(ww, t, r) : r;
                        }), n.$7)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 36:
                return u = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        $7: A2(R$, F2(function(n) {
                            return !a(n, u);
                        }), n.$7)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 32:
                return o = za(function(n) {
                    return p(n, {
                        m7: "Segmentation Rule",
                        sw: ""
                    });
                }), i = A2(ju, 0, A2(Lu, function(n) {
                    return A2(ju, 0, W$(vt(n.$7)));
                }, r.kP)), e = A2(Lu, function(n) {
                    return p(n, {
                        $7: A3(Cu, i + 1, o, n.$7)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 24:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        mM: A2(vw, t, n.mM)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 25:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        iu: A2(vw, t, n.iu)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 26:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        oa: A2(ww, t, n.oa)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 27:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lf: A2(vw, t, n.lf)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 28:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        jc: A2(ww, t, n.jc)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 37:
                var c = r.kP;
                return A2(pc, k(1 === c.$ ? [
                    n$
                ] : 1 === (m = (e = c.a).oS).$ ? [
                    SD(e)
                ] : [
                    A2(FD, m.a, e)
                ]), r);
            case 40:
                return A2(pc, k([
                    (d = n.a, A2(Xa, AD, function(n) {
                        return mc(sw(fw(ND(n.mo))));
                    }(d)))
                ]), r);
            case 38:
                return (f = n.a).$ ? A2(pc, w, A2(pD, f.a, r)) : A2(pc, k([
                    mD
                ]), p(r, {
                    lo: kt,
                    rz: ht("Organization created")
                }));
            case 39:
                return (f = n.a).$ ? A2(pc, w, A2(pD, f.a, r)) : A2(pc, k([
                    mD
                ]), p(r, {
                    lo: kt,
                    rz: ht("Organization updated")
                }));
            case 4:
                return A2(pc, w, p(r, {
                    lo: kt
                }));
            case 41:
                return (f = n.a).$ ? A2(pc, w, A2(pD, f.a, r)) : A2(pc, k([
                    mD
                ]), r);
            case 0:
                var f;
                if ((f = n.a).$) return A2(pc, w, A2(pD, f.a, r));
                var s = f.a;
                return A2(pc, w, p(r, {
                    cX: s.cX,
                    f3: s.f3,
                    oQ: s.oQ,
                    $7: s.$7,
                    dw: s.dw,
                    dB: s.dB
                }));
            case 44:
                return A2(pc, w, p(r, {
                    px: A2(ww, t = n.a, r.px)
                }));
            case 43:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            default:
                var l = n.a;
                return e = A2(Lu, function(n) {
                    return p(n, {
                        iy: A2(ID, l, n.iy)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
        }
        var d, m;
    }), xD = {
        $: 1
    }, qD = function(n) {
        return {
            $: 44,
            a: n
        };
    }, VD = function(n) {
        return {
            $: 2,
            a: n
        };
    }, OD = function(n) {
        return {
            $: 43,
            a: n
        };
    }, zD = function(n) {
        return {
            $: 40,
            a: n
        };
    }, ED = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: Ew(function(n) {
                return r(n) ? "1" : "0";
            }),
            dN: function(n) {
                return A2(zw, w, k([
                    r(n) ? Yw : Jw
                ]));
            }
        });
    }), HD = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), RD = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: HD(r)
        });
    }), WD = F2(function(n, r) {
        var t;
        return cg({
            n6: n,
            ds: Ew((t = r, A2(bu, Ua, t))),
            dN: r
        });
    }), UD = F2(function(n, r) {
        return A2(Ye, function(r) {
            var t = A2(Mu, function(n) {
                return a(n.mo, r.mo);
            }, n);
            return t.b ? t.a.n6 : "";
        }, r.e5);
    }), QD = F2(function(n, r) {
        return function(n) {
            for(;;){
                if (!n.b) return "?unknown";
                var t = n.a, e = n.b;
                if (a(t.mo, r)) return t.n6;
                n = e;
            }
        }(n);
    }), _D = F2(function(n, r) {
        return A2(Ye, function(r) {
            var t = A2(Mu, function(n) {
                return a(n.mo, r.mo);
            }, n);
            return t.b ? t.a.n6 : "";
        }, r.cX);
    }), ZD = F2(function(n, r) {
        return A2(ju, "", A2(Lu, function(n) {
            return n.n6;
        }, A2(di, r.pr, n)));
    }), KD = F2(function(n, r) {
        return A2(Ye, function(r) {
            var t = A2(Mu, function(n) {
                return a(n.mo, r);
            }, n);
            return t.b ? t.a.n6 : "";
        }, r.$7);
    }), XD = F2(function(n, r) {
        return A2(Ye, function(r) {
            var t = A2(Mu, function(n) {
                return a(n.mo, r);
            }, n);
            return t.b ? t.a.n6 : "";
        }, r.dw);
    }), JD = k([
        Ow("Table")
    ]), YD = function() {
        return k([
            Ow("TableTr")
        ]);
    }, GD = F5(function(n, r, t, e, u) {
        return ug({
            j_: k([
                A2(RD, "Edit", A2(bu, Pg("Edit"), VD)),
                A2(WD, "Name", function(n) {
                    return n.n6;
                }),
                A2(WD, "Master Test plan", ZD(n)),
                A2(WD, "Master Report template", function(n) {
                    return n.pq;
                }),
                A2(WD, "Destination", A2(bu, ju(""), function(n) {
                    return n.kO;
                })),
                A2(ED, "Manual Delivery", function(n) {
                    return n.nK;
                }),
                A2(ED, "Allow Delivery Without Transcoding", function(n) {
                    return n.iJ;
                }),
                A2(ED, "Replication", function(n) {
                    return n.pF;
                }),
                A2(ED, "Toggle creation mail", function(n) {
                    return n.le;
                }),
                A2(ED, "Toggle video ready mail", function(n) {
                    return n.lh;
                }),
                A2(ED, "Toggle upload success mail", function(n) {
                    return n.lg;
                }),
                A2(ED, "Toggle auto accept feature", function(n) {
                    return n.lc;
                }),
                A2(ED, "Toggle auto reject feature", function(n) {
                    return n.ld;
                }),
                A2(WD, "Broadcaster workflow", function(n) {
                    return A2(ju, "", A2(Lu, y$, n.js));
                }),
                A2(WD, "Formats", A2(Pi, _D(r), It(", "))),
                A2(WD, "SubtitleFormats", A2(Pi, XD(t), It(", "))),
                A2(WD, "SegmentationRules", A2(Pi, KD(e), It(", "))),
                A2(WD, "ExtraFormats", A2(Pi, UD(r), It(", "))),
                A2(WD, "Metadata Schema", function(n) {
                    return A2(ju, "", A2(Lu, QD(u), n.nS));
                }),
                A2(ED, "Advertiser", function(n) {
                    return n.mM;
                }),
                A2(ED, "Ad.Nomalab destination", function(n) {
                    return n.iu;
                }),
                A2(WD, "\u26A0 Automatic Show Deletion \u26A0", function(n) {
                    return n.jc ? "true" : "false";
                }),
                A2(WD, "Need accept before launching transcode", function(n) {
                    return n.oa ? "true" : "false";
                }),
                A2(RD, "Delete", A2(bu, Bw(kg), zD)),
                A2(ED, "Toggle static ip for delivery", function(n) {
                    return n.dv;
                })
            ]),
            kv: p(hg, {
                pS: YD,
                rE: JD,
                rQ: k([
                    Ow("TableTd")
                ])
            }),
            rZ: function(n) {
                return n.mo;
            },
            r_: OD
        });
    }), nB = {
        $: 4
    }, rB = function(n) {
        var r = n.lo;
        if (r.$) return A2(ye, w, w);
        var t = r.a;
        return A2(ye, k([
            Cg(nB)
        ]), k([
            sk(t)
        ]));
    }, tB = {
        $: 3
    }, eB = function(n) {
        return {
            $: 18,
            a: n
        };
    }, uB = function(n) {
        return {
            $: 28,
            a: n
        };
    }, oB = function(n) {
        return {
            $: 15,
            a: n
        };
    }, aB = function(n) {
        return {
            $: 7,
            a: n
        };
    }, iB = function(n) {
        return {
            $: 8,
            a: n
        };
    }, cB = function(n) {
        return {
            $: 25,
            a: n
        };
    }, fB = function(n) {
        return {
            $: 24,
            a: n
        };
    }, sB = function(n) {
        return {
            $: 42,
            a: n
        };
    }, lB = function(n) {
        return {
            $: 17,
            a: n
        };
    }, dB = function(n) {
        return {
            $: 16,
            a: n
        };
    }, mB = function(n) {
        return {
            $: 5,
            a: n
        };
    }, bB = function(n) {
        return {
            $: 26,
            a: n
        };
    }, pB = function(n) {
        return {
            $: 9,
            a: n
        };
    }, vB = function(n) {
        return {
            $: 6,
            a: n
        };
    }, $B = function(n) {
        return {
            $: 19,
            a: n
        };
    }, wB = function(n) {
        return {
            $: 13,
            a: n
        };
    }, gB = function(n) {
        return {
            $: 14,
            a: n
        };
    }, hB = function(n) {
        return {
            $: 10,
            a: n
        };
    }, kB = function(n) {
        return {
            $: 27,
            a: n
        };
    }, CB = function(n) {
        return {
            $: 12,
            a: n
        };
    }, TB = function(n) {
        return {
            $: 11,
            a: n
        };
    }, PB = {
        $: 31
    }, SB = {
        $: 29
    }, AB = {
        $: 32
    }, yB = {
        $: 30
    }, NB = function(n) {
        return {
            $: 45,
            a: n
        };
    }, LB = {
        $: 37
    }, jB = F2(function(n, r) {
        var t = "true" === n.sw;
        return A2(ye, k([
            Ow("InputLabelWrapper"),
            Bg(k([
                d("InputLabelDanger", t)
            ]))
        ]), k([
            A2(Nk, k([
                Ow("InputLabel")
            ]), k([
                A2(ye, k([
                    Ow("InputLabelText")
                ]), k([
                    ag(n.m7),
                    n.mS ? ag("") : A2(qg, k([
                        Ow("InputMandatory")
                    ]), "*")
                ])),
                A2(zk, n, r)
            ])),
            t ? A2(Yj, w, k([
                ag("Attention vous vous appreter a changer ce l'etat de suppression d'une orga est-ce que c'est bien ce que vous voulez faire ?")
            ])) : ag("")
        ]));
    }), FB = Ae("details"), MB = function(n) {
        return A2(dg, w, k([
            ag(n)
        ]));
    }, IB = Ae("summary"), DB = F2(function(n, r) {
        var t = r.a, e = r.b;
        return A2(ye, k([
            Ow("SelectMultipleItem"),
            Bg(k([
                d("SelectMultipleItemSelected", A2(MD, t, n.sx))
            ])),
            Cg(d(t, e))
        ]), k([
            ag(e)
        ]));
    }), BB = function(n) {
        var r = A2(ye, k([
            Ow("SelectMultiple"),
            Bg(k([
                d("SelectMultipleDisabled", !n.e_)
            ]))
        ]), k([
            A2(ye, k([
                Ow("SelectMultipleList")
            ]), A2(Ye, DB(n), n.jN))
        ]));
        return "" === n.m7 ? r : A2(Nk, k([
            Ow("SelectMultipleLabel")
        ]), k([
            A2(ye, k([
                Ow("SelectMultipleLabelText")
            ]), k([
                ag(n.m7)
            ])),
            r
        ]));
    }, xB = F2(function(n, r) {
        return {
            $: 22,
            a: n,
            b: r
        };
    }), qB = function(n) {
        return {
            $: 1,
            a: n
        };
    }, VB = function(n) {
        return {
            $: 0,
            a: n
        };
    }, OB = F2(function(n, r) {
        return A2(ye, w, k([
            A2(mh, VB, A2(Ek, n.mo, r)),
            A2(mh, qB, Fk(n.mO))
        ]));
    }), zB = F2(function(n, r) {
        var t = A2(mt, d("", ""), A2(Ye, function(n) {
            return d(n.mo, n.n6);
        }, A2(Ra, A2(Pi, function(n) {
            return n.n6;
        }, Ua), r)));
        return A2(Ye, Zi, pt(A2(Gi, F2(function(n, r) {
            var e;
            return A2(ye, k([
                A2(pg, "position", "relative"),
                A2(pg, "margin", "25px 0")
            ]), k([
                A2(mh, function(r) {
                    return A2(xB, r, n);
                }, A2(OB, r, t)),
                A3(Jk, "remove", k([
                    d("position", "absolute"),
                    d("right", "0")
                ]), (e = n, {
                    $: 35,
                    a: e
                }))
            ]));
        }), n.e5)));
    }), EB = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), HB = F2(function(n, r) {
        var t = A2(mt, d("", ""), A2(Ye, function(n) {
            return d(n.mo, n.n6);
        }, A2(Ra, A2(Pi, function(n) {
            return n.n6;
        }, Ua), r)));
        return A2(Ye, Zi, pt(A2(Gi, F2(function(n, r) {
            var e;
            return A2(ye, k([
                A2(pg, "position", "relative"),
                A2(pg, "margin", "25px 0")
            ]), k([
                A2(mh, function(r) {
                    return A2(EB, r, n);
                }, A2(OB, r, t)),
                A3(Jk, "remove", k([
                    d("position", "absolute"),
                    d("right", "0")
                ]), (e = n, {
                    $: 33,
                    a: e
                }))
            ]));
        }), n.cX)));
    }), RB = F2(function(n, r) {
        return {
            $: 23,
            a: n,
            b: r
        };
    }), WB = F2(function(n, r) {
        var t = A2(mt, d("", ""), A2(Ye, function(n) {
            return d(n.mo, n.n6);
        }, A2(Ra, A2(Pi, function(n) {
            return n.n6;
        }, Ua), r)));
        return A2(Ye, Zi, pt(A2(Gi, F2(function(n, r) {
            var e;
            return A2(ye, k([
                A2(pg, "position", "relative"),
                A2(pg, "margin", "25px 0")
            ]), k([
                A2(mh, function(r) {
                    return A2(RB, r, n);
                }, A2(Ek, r, t)),
                A3(Jk, "remove", k([
                    d("position", "absolute"),
                    d("right", "0")
                ]), (e = n, {
                    $: 36,
                    a: e
                }))
            ]));
        }), n.$7)));
    }), UB = F2(function(n, r) {
        return {
            $: 21,
            a: n,
            b: r
        };
    }), QB = F2(function(n, r) {
        var t = A2(mt, d("", ""), A2(Ye, function(n) {
            return d(n.mo, n.n6);
        }, A2(Ra, A2(Pi, function(n) {
            return n.n6;
        }, Ua), r)));
        return A2(Ye, Zi, pt(A2(Gi, F2(function(n, r) {
            var e;
            return A2(ye, k([
                A2(pg, "position", "relative"),
                A2(pg, "margin", "25px 0")
            ]), k([
                A2(mh, function(r) {
                    return A2(UB, r, n);
                }, A2(Ek, r, t)),
                A3(Jk, "remove", k([
                    d("position", "absolute"),
                    d("right", "0")
                ]), (e = n, {
                    $: 34,
                    a: e
                }))
            ]));
        }), n.dw)));
    }), _B = function(n) {
        return A2(Ck, function(r) {
            var t, e = A2(Ye, function(n) {
                return d(n.a, n.b.n6);
            }, A2(Ra, A2(Pi, Zi, A2(Pi, function(n) {
                return n.n6;
            }, Ua)), pt(n.dB))), u = A2(Ra, A2(Pi, Zi, Ua), A2(Ye, function(n) {
                return d(n.mo, n.n6);
            }, n.f3)), o = k([
                d("", ""),
                d(y$(0), y$(0)),
                d(y$(1), y$(1)),
                d(y$(3), y$(3)),
                d(y$(4), y$(4)),
                d(y$(5), y$(5)),
                d(y$(2), y$(2)),
                d(y$(6), y$(6)),
                d(y$(7), y$(7)),
                d(y$(8), y$(8)),
                d(y$(9), y$(9)),
                d(y$(10), y$(10)),
                d(y$(11), y$(11)),
                d(y$(12), y$(12)),
                d(y$(13), y$(13)),
                d(y$(14), y$(14)),
                d(y$(15), y$(15)),
                d(y$(16), y$(16)),
                d(y$(17), y$(17)),
                d(y$(18), y$(18)),
                d(y$(19), y$(19)),
                d(y$(20), y$(20))
            ]), a = function(n) {
                return 1 !== n.oS.$;
            }(r) ? d("Save", "Edit Organization") : d("Create", "New Organization");
            return A4(_k, a.b, d(a.a, LB), d("Cancel", tB), $(k([
                rB(n),
                A2(mh, mB, Mk(r.n6)),
                A2(mh, vB, A2(Ek, r.pr, e)),
                A2(mh, pB, Mk(r.pq)),
                A2(mh, aB, Mk(r.kO)),
                A2(mh, iB, Mk(r.kZ)),
                A2(mh, lB, Fk(r.nK)),
                A2(mh, eB, Fk(r.iJ)),
                A2(mh, hB, Fk(r.le)),
                A2(mh, TB, Fk(r.lh)),
                A2(mh, CB, Fk(r.lg)),
                A2(mh, wB, Fk(r.lc)),
                A2(mh, gB, Fk(r.ld)),
                A2(mh, kB, Fk(r.lf)),
                A2(mh, oB, A2(Ek, r.js, o)),
                A2(mh, sB, Mk(r.nr)),
                A2(IL, w, w),
                A2(IL, w, w),
                A2(FL, w, k([
                    ag("Advertisement")
                ])),
                A2(mh, fB, Fk(r.mM)),
                A2(mh, cB, Fk(r.iu)),
                A2(mh, bB, A2(Ek, r.oa, k([
                    d("false", "Deactivate"),
                    d("true", "activate")
                ]))),
                A2(yL, w, w),
                A2(yL, w, w),
                A2(FL, w, k([
                    ag("Metadata (Schema)")
                ])),
                A2(mh, dB, A2(Ek, r.nS, u)),
                A2(FL, w, k([
                    ag("Replication")
                ])),
                A2(mh, $B, Fk(r.pF)),
                A2(yL, w, w),
                A2(yL, w, w),
                A2(FL, w, k([
                    ag("Maintenance Task")
                ])),
                A2(mh, uB, A2(jB, r.jc, k([
                    d("false", "no automatic deletion"),
                    d("true", "ACTIVATE AUTOMATIC DELETION")
                ]))),
                A2(yL, w, w),
                A2(yL, w, w)
            ]), $(A2(HB, r, n.cX), $(k([
                A2(Pg, "Add New Format", SB),
                A2(yL, w, w),
                A2(yL, w, w)
            ]), $(A2(QB, r, n.dw), $(k([
                A2(Pg, "Add New Subtitle Format", yB),
                A2(yL, w, w),
                A2(yL, w, w)
            ]), $(A2(zB, r, n.cX), $(k([
                A2(Pg, "Add New Extra Format", PB),
                A2(yL, w, w),
                A2(yL, w, w)
            ]), $(A2(WB, r, n.$7), k([
                A2(Pg, "Add New Segmentation rule", AB),
                A2(yL, w, w),
                A2(yL, w, w),
                A2(FB, w, k([
                    A2(IB, w, k([
                        A2(dg, k([
                            Ow("AdminDetailsSummary")
                        ]), k([
                            ag("Additional videos")
                        ])),
                        A2(dg, k([
                            Ow("AdminDetailsSelection")
                        ]), A2(Ye, MB, uI(r.iy.sx)))
                    ])),
                    A2(ye, w, k([
                        (t = p(r.iy, {
                            jN: A2(Ye, function(n) {
                                return d(n.mo, n.n6);
                            }, n.cX)
                        }), A2(mh, NB, BB(t)))
                    ]))
                ]))
            ]))))))))));
        }, n.kP);
    }, ZB = F2(function(n, r) {
        var t, e, u, o = Ua(r.px.sw), a = A2(Mu, (t = d(r.dB, r.cX), e = t.a, u = t.b, function(n) {
            return A2(bu, A2(bu, Be(o), Ua), function(n) {
                return n.n6;
            })(n) || A2(Be, o, Ua(A2(ZD, e, n))) || A2(Be, o, Ua(A2(It, ", ", A2(_D, u, n))));
        }), r.oQ);
        return A3(gC, "Organizations", ht(A2(Pg, "New\u2026", xD)), A2(ye, w, k([
            rB(r),
            A2(mh, qD, ah(r.px)),
            _B(r),
            A3(ck, A5(GD, r.dB, r.cX, r.dw, r.$7, r.f3), r.rN, a)
        ])));
    }), KB = {
        l: function(n) {
            return n.oQ;
        },
        m: bD,
        o: F2(function(n, r) {
            return p(n, {
                oQ: r
            });
        }),
        p: function(n) {
            return {
                $: 2,
                a: n
            };
        },
        q: BD,
        r: ZB
    }, XB = function(n) {
        return {
            $: 1,
            a: n
        };
    }, JB = A2(Xa, XB, mc(A2(Wi, M$, Ai(D$)))), YB = {
        kx: w,
        oQ: w,
        oR: za(Me),
        rN: o$("Completed At")
    }, GB = A2(pc, k([
        JB
    ]), YB), nx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rx = F4(function(n, r, t, e) {
        return {
            lD: t,
            bl: r,
            gU: e,
            g9: n
        };
    }), tx = F4(function(n, r, t, e) {
        return {
            e$: e,
            fv: n,
            n6: r,
            hs: t
        };
    }), ex = Fi(A4(rc, "end_millis", function(n) {
        return n.e$;
    }, uc, A4(rc, "start_millis", function(n) {
        return n.hs;
    }, uc, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "index", function(n) {
        return n.fv;
    }, uc, Mi(tx)))))), ux = F2(function(n, r) {
        return {
            mo: n,
            n6: r
        };
    }), ox = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(ux)))), ax = F7(function(n, r, t, e, u, o, a) {
        return {
            jK: u,
            j2: e,
            ki: t,
            lo: r,
            mo: n,
            fV: o,
            rS: a
        };
    }), ix = F2(function(n, r) {
        return {
            n6: n,
            aR: r
        };
    }), cx = F2(function(n, r) {
        return {
            nL: r,
            nU: n
        };
    }), fx = Fi(A4(rc, "max", function(n) {
        return n.nL;
    }, uc, A4(rc, "min", function(n) {
        return n.nU;
    }, uc, Mi(cx)))), sx = Fi(A4(rc, "duration", function(n) {
        return n.eU;
    }, fx, Mi(function(n) {
        return {
            eU: n
        };
    }))), lx = Fi(A4(rc, "parameters", function(n) {
        return n.aR;
    }, sx, A4(rc, "name", function(n) {
        return n.n6;
    }, nS, Mi(ix)))), dx = Fi(A4(rc, "templateName", function(n) {
        return n.rS;
    }, Oa, A4(rc, "log", function(n) {
        return n.fV;
    }, Oa, A4(rc, "checks", function(n) {
        return n.jK;
    }, ic(lx), A4(qi, "completedAt", function(n) {
        return n.j2;
    }, tm, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(qi, "error", function(n) {
        return n.lo;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(ax))))))))), mx = F2(function(n, r) {
        return {
            mo: n,
            n6: r
        };
    }), bx = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(mx)))), px = Fi(A4(rc, "check_results", function(n) {
        return n.gU;
    }, ic(ex), A4(rc, "file", function(n) {
        return n.lD;
    }, ox, A4(rc, "result", function(n) {
        return n.bl;
    }, dx, A4(rc, "show", function(n) {
        return n.g9;
    }, bx, Mi(rx)))))), vx = ic(px), $x = F2(function(n, r) {
        return {
            cF: r,
            qL: n
        };
    }), wx = F2(function(n, r) {
        return A2($x, A2(ju, A2(KT, r.g9.mo, k([
            XT(r.g9.mo)
        ])), Eo(A2(Mu, function(n) {
            return a(n.qJ, r.g9.mo);
        }, n))), r);
    }), gx = function(n) {
        return A2(Yb, function(r) {
            return A2(Ye, wx(r), n);
        }, mc(A2(Wi, GT, A3(ow, ZT, UT(A2(Ye, A2(Pi, function(n) {
            return n.g9;
        }, function(n) {
            return n.mo;
        }), n)), rw(_T)))));
    }, hx = function(n) {
        return A2(Xa, nx, function(n) {
            return A2(BT, gx, function(n) {
                return mc(A2(Wi, vx, Ai(dl(ZP({
                    $: 4,
                    a: n
                })))));
            }(n));
        }(n));
    }, kx = F2(function(n, r) {
        switch(n.$){
            case 3:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            case 2:
                var t = n.a;
                return A2(pc, t.$ ? w : k([
                    hx(t.a)
                ]), p(r, {
                    oR: A2(ww, t, r.oR)
                }));
            case 1:
                return A2(pc, w, (e = n.a).$ ? r : p(r, {
                    oQ: e.a
                }));
            default:
                var e;
                return A2(pc, w, p(r, (e = n.a).$ ? {
                    kx: w
                } : {
                    kx: e.a
                }));
        }
    }), Cx = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), Tx = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: Cx(r)
        });
    }), Px = F3(function(n, r, t) {
        return Gw({
            n6: n,
            ds: LP(A2(bu, jP, t)),
            dN: Cx(r)
        });
    }), Sx = F2(function(n, r) {
        return A3(Px, n, function(n) {
            return IP(r(n));
        }, r);
    }), Ax = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: LP(A2(bu, A2(bu, function(n) {
                return A2(ju, 0, n);
            }, Lu(jP)), r)),
            dN: Cx(function(n) {
                return A2(ju, A2(ye, w, w), A2(Lu, IP, r(n)));
            })
        });
    }), yx = k([
        Ow("Table")
    ]), Nx = function(n) {
        return A3(JP, n.n6, n.aR.eU.nU, n.aR.eU.nL);
    }, Lx = ug({
        j_: k([
            A2(Tx, "Show", function(n) {
                return A2(oC, k([
                    fC("/show/" + n.cF.g9.mo)
                ]), k([
                    ag(VP(n.qL))
                ]));
            }),
            A2(Sx, "Created At", A2(Pi, function(n) {
                return n.cF;
            }, A2(Pi, function(n) {
                return n.bl;
            }, function(n) {
                return n.ki;
            }))),
            A2(Ax, "Completed At", A2(Pi, function(n) {
                return n.cF;
            }, A2(Pi, function(n) {
                return n.bl;
            }, function(n) {
                return n.j2;
            }))),
            A2(OP, "Deep probe Name", A2(bu, A2(bu, function(n) {
                return n.rS;
            }, function(n) {
                return n.bl;
            }), function(n) {
                return n.cF;
            })),
            A2(OP, "Configuration", A2(bu, A2(bu, A2(bu, A2(bu, A2(bu, It(", "), Ye(qS)), Ye(Nx)), function(n) {
                return n.jK;
            }), function(n) {
                return n.bl;
            }), function(n) {
                return n.cF;
            }))
        ]),
        kv: p(hg, {
            pS: function() {
                return k([
                    Ow("TableTr")
                ]);
            },
            rE: yx,
            rQ: k([
                Ow("TableTd")
            ])
        }),
        rZ: A2(Pi, function(n) {
            return n.cF;
        }, A2(Pi, function(n) {
            return n.bl;
        }, function(n) {
            return n.mo;
        })),
        r_: function(n) {
            return {
                $: 3,
                a: n
            };
        }
    }), jx = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Fx = F2(function(n, r) {
        var t = A2(ye, k([
            Ow("InputSelect"),
            Bg(k([
                d("InputSelectEmpty", "" === n.sw)
            ]))
        ]), k([
            A2(ye, k([
                Ow("InputSelectChoice")
            ]), k([
                Dk
            ])),
            A2(qg, k([
                Ow("InputSelectValue")
            ]), "" === n.sw || Tu(r) ? n.gw : A2(Bk, n.sw, r)),
            A2(qk, k([
                Ow("InputSelectSelect"),
                eh(Lg),
                oh(n.sw),
                uh(n.gw),
                zg(n.kS)
            ]), A2(Ye, function(r) {
                var t = r.a, e = r.b;
                return A2(xk, k([
                    oh(t),
                    Vk(a(t, n.sw))
                ]), k([
                    ag(e)
                ]));
            }, r))
        ]));
        return A2(ye, k([
            Ow("InputWrapperDark"),
            Bg(k([
                d("InputHasError", Tu(n.lp))
            ]))
        ]), k([
            t,
            Vg(n.lp)
        ]));
    }), Mx = F2(function(n, r) {
        return A2(ye, k([
            Ow("DarkZone"),
            Ow("Filter")
        ]), k([
            A2(ye, w, w),
            A2(ye, k([
                Ow("Summary")
            ]), k([
                A2(dP, w, k([
                    ag("Summary")
                ])),
                A2(Yj, w, k([
                    ag("")
                ])),
                A2(Yj, w, k([
                    ag("Total Probes: " + Mt(qt(r)))
                ]))
            ]))
        ]));
    }), Ix = F2(function(n, r) {
        return A3(gC, "Deep Probes", ht(function(n) {
            var r = A2(Ra, A2(bu, Ua, Zi), A2(Ye, function(n) {
                return d(n.mo, n.n6);
            }, n.oQ)), t = A2(mt, d("", ""), r);
            return A2(ye, k([
                A2(pg, "min-width", "100px")
            ]), k([
                A2(mh, jx, A2(Fx, n.oR, t))
            ]));
        }(r)), xe(r.oR.sw) > 0 ? A2(ye, w, k([
            A2(Mx, r, r.kx),
            A3(ck, Lx, r.rN, r.kx)
        ])) : A2(ye, k([
            Ow("EmptySection")
        ]), k([
            A2(ye, w, k([
                ag("Choose Organization")
            ]))
        ])));
    }), Dx = {
        l: function(n) {
            return n.dh;
        },
        m: GB,
        o: F2(function(n, r) {
            return p(n, {
                dh: r
            });
        }),
        p: function(n) {
            return {
                $: 18,
                a: n
            };
        },
        q: kx,
        r: Ix
    }, Bx = {
        kx: w,
        lo: kt,
        qc: za(function(n) {
            return p(n, {
                m7: "fileToFind"
            });
        })
    }, xx = A2(pc, w, Bx), qx = function(n) {
        return A2($w, n, "");
    }, Vx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ox = function(n) {
        switch(n){
            case "ProxyManifest":
                return At(0);
            case "ProxyDashVideo":
                return At(1);
            case "ProxyAudio":
                return At(2);
            case "ProxySubtitle":
                return At(3);
            case "VerificationReportPdf":
                return At(4);
            case "VerificationReportXml":
                return At(5);
            case "Video":
                return At(6);
            case "Audio":
                return At(7);
            case "Subtitle":
                return At(8);
            default:
                return At(9);
        }
    }, zx = function(n) {
        switch(n){
            case 0:
                return "ProxyManifest";
            case 1:
                return "ProxyDashVideo";
            case 2:
                return "ProxyAudio";
            case 3:
                return "ProxySubtitle";
            case 4:
                return "VerificationReportPdf";
            case 5:
                return "VerificationReportXml";
            case 6:
                return "Video";
            case 7:
                return "Audio";
            case 8:
                return "Subtitle";
            default:
                return "Extra";
        }
    }, Ex = A2(Ml, zx, Ox), Hx = Fi(A4(rc, "parent", function(n) {
        return n.gq;
    }, Oa, A4(qi, "stateExpireAt", function(n) {
        return n.hw;
    }, tm, A4(rc, "showState", function(n) {
        return n.hc;
    }, Db, A4(rc, "showKind", function(n) {
        return n.qK;
    }, Lm, A4(rc, "accepted", function(n) {
        return n.ik;
    }, ri, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, A4(qi, "title2", function(n) {
        return n.rY;
    }, Oa, A4(rc, "title1", function(n) {
        return n.rX;
    }, Oa, A4(rc, "showId", function(n) {
        return n.qJ;
    }, Oa, A4(rc, "state", function(n) {
        return n.hv;
    }, Db, A4(rc, "kind", function(n) {
        return n.c$;
    }, Ex, A4(rc, "key", function(n) {
        return n.fL;
    }, Oa, A4(rc, "bucket", function(n) {
        return n.en;
    }, Oa, A4(qi, "mimeType", function(n) {
        return n.nT;
    }, Oa, A4(rc, "size", function(n) {
        return n.qP;
    }, uc, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return {
                                                                                ik: m,
                                                                                en: o,
                                                                                ki: r,
                                                                                mo: n,
                                                                                fL: a,
                                                                                c$: i,
                                                                                nT: u,
                                                                                n6: t,
                                                                                oM: d,
                                                                                gq: $,
                                                                                qJ: f,
                                                                                qK: b,
                                                                                hc: p,
                                                                                qP: e,
                                                                                hv: c,
                                                                                hw: v,
                                                                                rX: s,
                                                                                rY: l
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))), Rx = ic(Hx), Wx = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Ux = function(n) {
        return mc(A2(Wi, Rx, Ai(dl(Wx({
            $: 1,
            a: n
        })))));
    }, Qx = F2(function(n, r) {
        switch(n.$){
            case 1:
                return A2(pc, w, p(r, {
                    lo: kt,
                    qc: A2(ww, n.a, r.qc)
                }));
            case 2:
                return A2(pc, k([
                    (u = r.qc.sw, A2(Xa, Vx, Ux(u)))
                ]), r);
            default:
                var t = n.a;
                if (!t.$ && t.a.b) {
                    var e = t.a;
                    return A2(pc, w, p(r, {
                        kx: A2(mt, e.a, e.b),
                        lo: kt,
                        qc: qx(r.qc)
                    }));
                }
                return A2(pc, w, p(r, {
                    kx: w,
                    lo: ht("le fichier " + r.qc.sw + " n'a pas \xe9t\xe9 trouv\xe9"),
                    qc: qx(r.qc)
                }));
        }
        var u;
    }), _x = mC(FL), Zx = F2(function(n, r) {
        return A2(ye, k([
            Ow("BannerError")
        ]), k([
            A2(ye, k([
                Ow("BannerHeader")
            ]), k([
                kg,
                _x(n)
            ])),
            A2(ye, k([
                Ow("BannerContent")
            ]), k([
                r
            ]))
        ]));
    }), Kx = function(n) {
        var r = n.lo;
        return 1 === r.$ ? A2(ye, k([
            A2(pg, "margin", "50px auto"),
            A2(pg, "text-align", "center")
        ]), k([
            ag("Search file by id")
        ])) : A2(Zx, "File not found", ag(r.a));
    }, Xx = function(n) {
        return s(n, 1073741824) > -1 ? Mt(re(n / 1073741824)) + " GB" : s(n, 1048576) > -1 ? Mt(re(n / 1048576)) + " MB" : 1024 > n ? n > 1 ? Mt(n) + " bytes" : 1 === n ? Mt(n) + " byte" : "0 bytes" : Mt(re(n / 1024)) + " KB";
    }, Jx = ye(k([
        Ow("LayoutHeader")
    ])), Yx = F2(function(n, r) {
        return A2(Lh, k([
            Ow("KeyValueWrapperHeader")
        ]), k([
            A2(uk, k([
                Ow("KeyValueHeader")
            ]), k([
                n
            ])),
            A2(uk, k([
                Ow("KeyValueValue")
            ]), k([
                r
            ]))
        ]));
    }), Gx = Yx, nq = function(n) {
        return A2(qg, k([
            Ow("LayoutHeaderTitle")
        ]), n);
    }, rq = function(n) {
        var r, t, e;
        return k([
            Jx(k([
                nq(n.n6),
                nq(n.fL)
            ])),
            A2(Gx, ag("FILE"), A2(ye, w, w)),
            A2(yj, "Id", n.mo),
            A2(Aj, ag("Created At"), IP(n.ki)),
            A2(yj, "Size", Xx(n.qP)),
            A2(yj, "MimeType", (e = n.nT, 1 === e.$ ? "No mime type" : e.a)),
            A2(yj, "Bucket", n.en),
            A2(yj, "Kind", zx(n.c$)),
            A2(yj, "File Archived", Ib(n.hv)),
            A2(Gx, ag("SHOW"), A2(ye, w, w)),
            A2(Aj, ag("Id"), A2(oC, k([
                fC("/show/" + n.qJ)
            ]), k([
                ag(n.qJ)
            ]))),
            A2(yj, "title", n.rX),
            A2(yj, "title2", (t = n.rY, 1 === t.$ ? "No title" : t.a)),
            A2(yj, "Organization", n.oM),
            A2(yj, "Accepted", (r = n.ik, r ? "\u2714" : "\u2716")),
            A2(yj, "kind", Nm(n.qK)),
            A2(yj, "Archived", Ib(n.hv)),
            A2(Aj, ag("Parent"), A2(oC, k([
                fC("/hierarchy/" + n.gq)
            ]), k([
                ag(n.gq)
            ])))
        ]);
    }, tq = F2(function(n, r) {
        if (n.b) {
            if (n.b.b) {
                var t = n.b;
                return $(rq(n.a), A2(tq, t, r));
            }
            return rq(n.a);
        }
        return k([
            Kx(r)
        ]);
    }), eq = function(n) {
        return {
            $: 1,
            a: n
        };
    }, uq = {
        $: 2
    }, oq = F2(function(n, r) {
        return A3(gC, "Researchs", ht(function(n) {
            return A2(ye, k([
                A2(pg, "display", "flex")
            ]), k([
                A2(Hk, k([
                    Uk(uq)
                ]), k([
                    A2(mh, eq, ah(n.qc)),
                    A2(Pg, "search", uq)
                ]))
            ]));
        }(r)), A2(ye, w, A2(tq, r.kx, r)));
    }), aq = {
        l: function(n) {
            return n.dl;
        },
        m: xx,
        o: F2(function(n, r) {
            return p(n, {
                dl: r
            });
        }),
        p: function(n) {
            return {
                $: 9,
                a: n
            };
        },
        q: Qx,
        r: oq
    }, iq = F6(function(n, r, t, e, u, o) {
        var a, i = u, c = 1 === (a = i.l(r)).$ ? d(n, d(i.m.a, bc(k([
            i.m.b,
            o
        ])))) : d(r, d(a.a, o)), f = c.b, s = f.b;
        return d(A2(i.o, c.a, ht(f.a)), A2(cp, i.p, s));
    }), cq = F5(function(n, r, t, e, u) {
        return A6(iq, n, r, t, e, u, n$);
    }), fq = {
        kP: kt,
        lo: kt,
        $7: w,
        rz: kt,
        rN: o$("Name")
    }, sq = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lq = mc(A2(Wi, uD, Ai(aD))), dq = A2(Xa, sq, lq), mq = d(fq, dq), bq = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), pq = function(n) {
        return {
            $: 27,
            a: n
        };
    }, vq = F2(function(n, r) {
        return r.$ ? Ct(n) : At(r.a);
    }), $q = function(n) {
        var r, t = nD(n.sb.sw), e = {
            eN: n.qR.sw,
            fX: n.qS.sw,
            fY: n.qT.sw
        }, u = {
            al: ze(n.oG.sw) ? kt : He(n.oG.sw),
            b2: ze(n.oH.sw) ? kt : He(n.oH.sw),
            rW: ze(n.oI.sw) ? kt : ht(n.oI.sw)
        }, o = ze(n.nY.sw) ? kt : He(n.nY.sw), a = ze(n.nW.sw) ? kt : He(n.nW.sw), i = {
            al: ze(n.lk.sw) ? kt : He(n.lk.sw),
            b2: ze(n.ll.sw) ? kt : He(n.ll.sw),
            rW: ze(n.lm.sw) ? kt : ht(n.lm.sw)
        }, c = {
            lJ: ze(n.lJ.sw) ? kt : He(n.lJ.sw),
            nc: ze(n.nc.sw) ? kt : He(n.nc.sw),
            nM: ze(n.nM.sw) ? kt : He(n.nM.sw),
            nV: ze(n.nV.sw) ? kt : He(n.nV.sw),
            py: (r = n.py, A2(Ia, w, A3(Je, F2(function(n, r) {
                var t = d(n, r);
                return t.b.$ ? Ct(t.b.a) : t.a.$ ? Ct(t.a.a) : At(A2(mt, t.a.a, t.b.a));
            }), At(w), A2(Ye, function(n) {
                var r = n.b;
                return A4(J$, _I, A2(vq, "Invalid ad value", He(r.it.sw)), A2(vq, "Invalid min value", He(r.nU.sw)), A2(vq, "Invalid max value", He(r.nL.sw)));
            }, pt(r)))))
        };
        return A2(X$, function(r) {
            return {
                az: c,
                bO: i,
                nW: a,
                nY: o,
                n6: n.n6.sw,
                b3: u,
                o9: n.o9.sw,
                qQ: n.qQ.sw,
                ce: e,
                sb: r
            };
        }, t);
    }, wq = Fi(A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return {
            mo: n
        };
    }))), gq = Fi(A4(rc, "skipJobs", function(n) {
        return n.ce;
    }, GI, A4(rc, "typology", function(n) {
        return n.sb;
    }, tD, A4(rc, "postCredits", function(n) {
        return n.o9;
    }, ri, A4(qi, "minOutro", function(n) {
        return n.nY;
    }, uc, A4(qi, "minIntro", function(n) {
        return n.nW;
    }, uc, A4(rc, "skipIntro", function(n) {
        return n.qQ;
    }, ri, A4(rc, "endingCredits", function(n) {
        return n.bO;
    }, JI, A4(rc, "openingCredits", function(n) {
        return n.b3;
    }, JI, A4(rc, "adBreaks", function(n) {
        return n.az;
    }, KI, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return {
                                                az: r,
                                                bO: e,
                                                nW: o,
                                                nY: a,
                                                n6: n,
                                                b3: t,
                                                o9: i,
                                                qQ: u,
                                                ce: f,
                                                sb: c
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), hq = function(n) {
        return A2(Xa, pq, A2(BT, function(n) {
            return mc(A2(nw, wq, A3(ow, gq, n, rw(aD))));
        }, A2(Qi, Dy, xy($q(n)))));
    }, kq = function(n) {
        return {
            $: 30,
            a: n
        };
    }, Cq = function(n) {
        return yi(oD({
            $: 1,
            a: n
        }));
    }, Tq = function(n) {
        return {
            $: 28,
            a: n
        };
    }, Pq = F2(function(n, r) {
        return A2(BT, function(r) {
            return mc(sw(A3(ow, gq, r, dw(Cq(n.mo)))));
        }, A2(Qi, Dy, xy($q(r))));
    }), Sq = F2(function(n, r) {
        return A2(Xa, Tq, A2(Pq, n, r));
    }), Aq = function(n) {
        var r = function(n) {
            return A2(Pi, Lu(n), ju(""));
        };
        return {
            lk: za(function(r) {
                return p(r, {
                    m7: "Minimum credits duration to detect (in seconds)",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return n.al;
                    }, A2(Lu, function(n) {
                        return n.bO;
                    }, n))))
                });
            }),
            ll: za(function(r) {
                return p(r, {
                    m7: "Credits Duration (in seconds)",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return n.b2;
                    }, A2(Lu, function(n) {
                        return n.bO;
                    }, n))))
                });
            }),
            lm: za(function(r) {
                return p(r, {
                    m7: "Text to detect in the first shot of the end credits (enter one line of text maximum)",
                    sw: A2(ju, "", A2(sp, function(n) {
                        return n.rW;
                    }, A2(Lu, function(n) {
                        return n.bO;
                    }, n)))
                });
            }),
            lJ: za(function(r) {
                return p(r, {
                    m7: "Minimum distance between the start of the program and the first ad break (in minutes)",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return n.lJ;
                    }, A2(Lu, function(n) {
                        return n.az;
                    }, n))))
                });
            }),
            nc: za(function(r) {
                return p(r, {
                    m7: "Minimum distance between the last ad break and the end of the program (in minutes)",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return n.nc;
                    }, A2(Lu, function(n) {
                        return n.az;
                    }, n))))
                });
            }),
            nM: za(function(r) {
                return p(r, {
                    m7: "Maximum interval between two ad breaks (in minutes)",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return n.nM;
                    }, A2(Lu, function(n) {
                        return n.az;
                    }, n))))
                });
            }),
            nV: za(function(r) {
                return p(r, {
                    m7: "Minimum interval between two ad breaks (in minutes)",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return n.nV;
                    }, A2(Lu, function(n) {
                        return n.az;
                    }, n))))
                });
            }),
            nW: za(function(r) {
                return p(r, {
                    m7: "Minimum intro duration (in seconds)",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return n.nW;
                    }, n)))
                });
            }),
            nY: za(function(r) {
                return p(r, {
                    m7: "Minimum outro duration (in seconds)",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return n.nY;
                    }, n)))
                });
            }),
            n6: za(function(t) {
                return p(t, {
                    m7: "Name",
                    sw: A2(r, function(n) {
                        return n.n6;
                    }, n)
                });
            }),
            oG: za(function(r) {
                return p(r, {
                    m7: "Minimum credits duration to detect (in seconds)",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return n.al;
                    }, A2(Lu, function(n) {
                        return n.b3;
                    }, n))))
                });
            }),
            oH: za(function(r) {
                return p(r, {
                    m7: "Credits duration (in seconds). Enter a negative value if the series title appears at the end of the credits.",
                    sw: A2(ju, "", A2(Lu, Mt, A2(sp, function(n) {
                        return n.b2;
                    }, A2(Lu, function(n) {
                        return n.b3;
                    }, n))))
                });
            }),
            oI: za(function(r) {
                return p(r, {
                    m7: "Series Title (enter one line of text maximum)",
                    sw: A2(ju, "", A2(sp, function(n) {
                        return n.rW;
                    }, A2(Lu, function(n) {
                        return n.b3;
                    }, n)))
                });
            }),
            oS: n,
            o9: ti(function(r) {
                return p(r, {
                    m7: "Enable outro detection",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.o9;
                    }, n))
                });
            }),
            py: A2(Gi, F2(function(n, r) {
                return {
                    it: za(function(n) {
                        return p(n, {
                            m7: "Number of ad breaks",
                            sw: Mt(r.dI)
                        });
                    }),
                    nL: za(function(n) {
                        return p(n, {
                            m7: "To program duration (in minutes)",
                            sw: Mt(r.cK)
                        });
                    }),
                    nU: za(function(n) {
                        return p(n, {
                            m7: "From program duration (in minutes)",
                            sw: Mt(r.al)
                        });
                    })
                };
            }), Ji(A2(Ht, V$, A2(ju, w, A2(Lu, A2(Pi, function(n) {
                return n.az;
            }, function(n) {
                return n.py;
            }), n))))),
            qQ: ti(function(r) {
                return p(r, {
                    m7: "Enable intro detection",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.qQ;
                    }, n))
                });
            }),
            qR: ti(function(r) {
                return p(r, {
                    m7: "Skip Deep probe job",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.eN;
                    }, A2(Lu, function(n) {
                        return n.ce;
                    }, n)))
                });
            }),
            qS: ti(function(r) {
                return p(r, {
                    m7: "Skip M2C analysis job",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.fX;
                    }, A2(Lu, function(n) {
                        return n.ce;
                    }, n)))
                });
            }),
            qT: ti(function(r) {
                return p(r, {
                    m7: "Skip M2C proxy creation",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.fY;
                    }, A2(Lu, function(n) {
                        return n.ce;
                    }, n)))
                });
            }),
            sb: za(function(t) {
                return p(t, {
                    m7: "Typology",
                    sw: A2(r, A2(Pi, function(n) {
                        return n.sb;
                    }, rD), n)
                });
            })
        };
    }, yq = F2(function(n, r) {
        switch(n.$){
            case 0:
                return p(r, {
                    it: A2(ww, n.a, r.it)
                });
            case 1:
                return p(r, {
                    nU: A2(ww, n.a, r.nU)
                });
            default:
                return p(r, {
                    nL: A2(ww, n.a, r.nL)
                });
        }
    }), Nq = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, w, (f = n.a).$ ? A2(bq, f.a, r) : p(r, {
                    $7: f.a
                }));
            case 1:
                return A2(pc, w, p(r, {
                    kP: ht(Aq(kt))
                }));
            case 2:
                return A2(pc, w, p(r, {
                    kP: ht(Aq(ht(n.a)))
                }));
            case 3:
                var t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        n6: A2(ww, t, n.n6)
                    });
                }, r.kP);
                return A2(pc, w, p(r, {
                    kP: e
                }));
            case 4:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lJ: A2(ww, t, n.lJ)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 5:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nc: A2(ww, t, n.nc)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 6:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nV: A2(ww, t, n.nV)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 7:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nM: A2(ww, t, n.nM)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 11:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        oI: A2(ww, t, n.oI)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 12:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        oH: A2(ww, t, n.oH)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 13:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        oG: A2(ww, t, n.oG)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 14:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lm: A2(ww, t, n.lm)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 15:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        ll: A2(ww, t, n.ll)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 16:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lk: A2(ww, t, n.lk)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 17:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        qQ: A2(vw, t, n.qQ)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 18:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nW: A2(ww, t, n.nW)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 19:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        nY: A2(ww, t, n.nY)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 20:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        o9: A2(vw, t, n.o9)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 21:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        sb: A2(ww, t, n.sb)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 10:
                var u = n.a;
                return e = A2(Lu, function(n) {
                    return p(n, {
                        py: A2(R$, F2(function(n) {
                            return !a(n, u);
                        }), n.py)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 8:
                t = n.a, u = n.b;
                n: for(; !t.a.$;)return e = A2(Lu, function(n) {
                    return p(n, {
                        py: A2(Gi, F2(function(n, r) {
                            return a(n, u) ? A2(yq, t, r) : r;
                        }), n.py)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
                return A2(pc, w, r);
            case 9:
                var o = A2(ju, 0, A2(Lu, function(n) {
                    return A2(ju, 0, W$(vt(n.py)));
                }, r.kP)), i = (d = {
                    cK: 0,
                    al: 0,
                    dI: o + 1
                }, m = za(function(n) {
                    return p(n, {
                        m7: "From program duration (in minutes)",
                        sw: Mt(d.al)
                    });
                }), b = za(function(n) {
                    return p(n, {
                        m7: "To program duration (in minutes)",
                        sw: Mt(d.cK)
                    });
                }), {
                    it: za(function(n) {
                        return p(n, {
                            m7: "Number of ad breaks",
                            sw: Mt(d.dI)
                        });
                    }),
                    nL: b,
                    nU: m
                });
                return e = A2(Lu, function(n) {
                    return p(n, {
                        py: A3(Cu, o + 1, i, n.py)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 22:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        qT: A2(vw, t, n.qT)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 23:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        qS: A2(vw, t, n.qS)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 24:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        qR: A2(vw, t, n.qR)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 25:
                return A2(pc, w, p(r, {
                    kP: kt,
                    lo: kt,
                    rz: kt
                }));
            case 26:
                var c = r.kP;
                return A2(pc, k(1 === c.$ ? [
                    n$
                ] : 1 === (l = (e = c.a).oS).$ ? [
                    hq(e)
                ] : [
                    A2(Sq, l.a, e)
                ]), r);
            case 27:
                return (f = n.a).$ ? A2(pc, w, A2(bq, f.a, r)) : A2(pc, k([
                    dq
                ]), p(r, {
                    kP: kt,
                    lo: kt,
                    rz: ht("Segmentation rule created")
                }));
            case 28:
                return (f = n.a).$ ? A2(pc, w, A2(bq, f.a, r)) : A2(pc, k([
                    dq
                ]), p(r, {
                    kP: kt,
                    lo: kt,
                    rz: ht("Segmentation rule updated")
                }));
            case 29:
                return A2(pc, k([
                    (s = n.a, A2(Xa, kq, function(n) {
                        return mc(sw(fw(Cq(n.mo))));
                    }(s)))
                ]), r);
            case 30:
                var f;
                return (f = n.a).$ ? A2(pc, w, A2(bq, f.a, r)) : A2(pc, k([
                    dq
                ]), r);
            default:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
        }
        var s, l, d, m, b;
    }), Lq = {
        $: 1
    }, jq = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Fq = function(n) {
        return {
            $: 29,
            a: n
        };
    }, Mq = F2(function(n, r) {
        if (r.b) {
            var t = r.a, e = r.b, u = F2(function(r, t) {
                return A2(mt, n, A2(mt, r, t));
            });
            return A2(mt, t, A3(Je, u, w, e));
        }
        return w;
    }), Iq = function(n) {
        return A2(dg, w, A2(Mq, A2(yL, w, w), A2(Ye, ag, A2(Dt, "\n", function(n) {
            var r, t, e, u, o = (r = n.nV).$ ? "N/A" : Mt(r.a), a = (t = n.nM).$ ? "N/A" : Mt(t.a), i = (e = n.nc).$ ? "N/A" : Mt(e.a);
            return "first point: " + ((u = n.lJ).$ ? "N/A" : Mt(u.a)) + "\nlast point: " + i + "\nmininum interval: " + o + "\nmaximum interval: " + a + "\nranges:" + (Tu(n.py) ? "N/A" : A2(It, "", A2(Ye, function(n) {
                return "\n- total breaks: " + Mt(n.dI) + ", duration min: " + Mt(n.al) + ", duration max: " + Mt(n.cK);
            }, n.py)));
        }(n)))));
    }, Dq = function(n) {
        return A2(dg, w, A2(Mq, A2(yL, w, w), A2(Ye, ag, A2(Dt, "\n", function(n) {
            return "title: " + A2(ju, "N/A", n.rW) + "\noffset: " + A2(ju, "N/A", A2(Lu, Mt, n.b2)) + "\nminimum credits duration: " + A2(ju, "N/A", A2(Lu, Mt, n.al));
        }(n)))));
    }, Bq = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: Ew(function(n) {
                return r(n) ? "1" : "0";
            }),
            dN: function(n) {
                return A2(zw, w, k([
                    r(n) ? Yw : Jw
                ]));
            }
        });
    }), xq = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), qq = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: xq(r)
        });
    }), Vq = F2(function(n, r) {
        var t;
        return cg({
            n6: n,
            ds: Ew((t = r, A2(bu, Ua, t))),
            dN: r
        });
    }), Oq = function(n) {
        return A2(ye, w, k([
            A2(ye, w, k([
                ag("M2C proxy: "),
                n.fY ? Yw : Jw
            ])),
            A2(ye, w, k([
                ag("M2C analysis: "),
                n.fX ? Yw : Jw
            ])),
            A2(ye, w, k([
                ag("Deep probe analysis: "),
                n.eN ? Yw : Jw
            ]))
        ]));
    }, zq = ug({
        j_: k([
            A2(qq, "Edit", A2(bu, Pg("Edit"), jq)),
            A2(Vq, "Name", function(n) {
                return n.n6;
            }),
            A2(Vq, "Typology", A2(bu, rD, function(n) {
                return n.sb;
            })),
            A2(qq, "Opening Credits", A2(bu, Dq, function(n) {
                return n.b3;
            })),
            A2(qq, "End Credits", A2(bu, Dq, function(n) {
                return n.bO;
            })),
            A2(qq, "Ad breaks", A2(bu, Iq, function(n) {
                return n.az;
            })),
            A2(Bq, "Intro Detection", function(n) {
                return n.qQ;
            }),
            A2(Vq, "Minimum Intro Duration", A2(bu, A2(bu, ju("N/A"), Lu(Mt)), function(n) {
                return n.nW;
            })),
            A2(Bq, "Outro Detection", function(n) {
                return n.o9;
            }),
            A2(Vq, "Minimum Outro Duration", A2(bu, A2(bu, ju("N/A"), Lu(Mt)), function(n) {
                return n.nY;
            })),
            A2(qq, "Skip Jobs", A2(bu, Oq, function(n) {
                return n.ce;
            })),
            A2(qq, "Delete", A2(bu, Bw(kg), Fq))
        ]),
        kv: p(hg, {
            pS: function() {
                return k([
                    Ow("TableTr")
                ]);
            },
            rE: k([
                Ow("Table")
            ]),
            rQ: k([
                Ow("TableTd")
            ])
        }),
        rZ: function(n) {
            return n.mo;
        },
        r_: function(n) {
            return {
                $: 31,
                a: n
            };
        }
    }), Eq = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Hq = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Rq = function(n) {
        return {
            $: 24,
            a: n
        };
    }, Wq = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Uq = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Qq = {
        $: 25
    }, _q = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Zq = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Kq = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Xq = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Jq = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Yq = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Gq = function(n) {
        return {
            $: 6,
            a: n
        };
    }, nV = function(n) {
        return {
            $: 18,
            a: n
        };
    }, rV = function(n) {
        return {
            $: 19,
            a: n
        };
    }, tV = function(n) {
        return {
            $: 3,
            a: n
        };
    }, eV = function(n) {
        return {
            $: 13,
            a: n
        };
    }, uV = function(n) {
        return {
            $: 12,
            a: n
        };
    }, oV = function(n) {
        return {
            $: 11,
            a: n
        };
    }, aV = function(n) {
        return {
            $: 21,
            a: n
        };
    }, iV = {
        $: 9
    }, cV = {
        $: 26
    }, fV = function(n) {
        return -2 === n.$;
    }, sV = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), lV = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dV = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mV = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bV = function(n) {
        return A2(Ye, Zi, pt(A2(Gi, F2(function(n, r) {
            var t, e;
            return A2(ye, k([
                A2(pg, "position", "relative"),
                A2(pg, "margin", "0 0 25px 0")
            ]), k([
                A2(mh, function(r) {
                    return A2(sV, r, n);
                }, (e = r, A2(ye, w, k([
                    A2(mh, lV, Mk(e.it)),
                    A2(mh, mV, Mk(e.nU)),
                    A2(mh, dV, Mk(e.nL))
                ])))),
                A3(Jk, "remove", k([
                    d("position", "absolute"),
                    d("right", "0")
                ]), (t = n, {
                    $: 10,
                    a: t
                }))
            ]));
        }), n.py)));
    }, pV = function(n) {
        return A2(Ck, function(n) {
            var r = A2(Ye, function(n) {
                return d(n, n);
            }, A2(Ye, rD, k([
                0,
                1,
                2
            ]))), t = function(n) {
                return 1 !== n.oS.$;
            }(n) ? d("Save", "Edit Rule") : d("Create", "New Rule");
            return A4(_k, t.b, d(t.a, cV), d("Cancel", Qq), k([
                A2(mh, tV, Mk(n.n6)),
                A2(mh, aV, A2(Ek, n.sb, r)),
                A2(yL, w, w),
                A2(ye, w, $(k([
                    A2(dC, w, k([
                        ag("Ad breaks")
                    ])),
                    A2(yL, w, w),
                    A2(FL, w, k([
                        ag("Ranges")
                    ])),
                    A2(Yj, w, k([
                        ag("Define the number of ad breaks required for a program duration.")
                    ])),
                    A2(Yj, w, k([
                        ag("Example:")
                    ])),
                    A2(Yj, w, k([
                        ag("- Number of ad breaks: 1, from program duration 0 to 45 (exclusive) min")
                    ])),
                    A2(Yj, w, k([
                        ag("- Number of ad breaks: 2, from program duration 45 (inclusive) to 60 min")
                    ])),
                    A2(Yj, w, k([
                        ag("If a program is less than 45 minutes long, it requires 1 ad break.")
                    ])),
                    A2(Yj, w, k([
                        ag("If a program is between 45 and 60 minutes long, it requires 2 ad breaks.")
                    ])),
                    A2(yL, w, w)
                ]), $(bV(n), A2(mt, A2(Pg, "New range", iV), fV(n.py) ? w : k([
                    A2(yL, w, w),
                    A2(yL, w, w),
                    A2(FL, w, k([
                        ag("Limits")
                    ])),
                    A2(mh, Xq, Mk(n.lJ)),
                    A2(mh, Jq, Mk(n.nc)),
                    A2(yL, w, w),
                    A2(FL, w, k([
                        ag("Interval")
                    ])),
                    A2(mh, Gq, Mk(n.nV)),
                    A2(mh, Yq, Mk(n.nM))
                ]))))),
                A2(yL, w, w),
                A2(dC, w, k([
                    ag("Opening credits")
                ])),
                A2(mh, eV, Mk(n.oG)),
                A2(mh, oV, Mk(n.oI)),
                A2(mh, uV, Mk(n.oH)),
                A2(yL, w, w),
                A2(dC, w, k([
                    ag("End credits")
                ])),
                A2(mh, _q, Mk(n.lk)),
                A2(mh, Kq, Mk(n.lm)),
                A2(mh, Zq, Mk(n.ll)),
                A2(yL, w, w),
                A2(dC, w, k([
                    ag("Other detections")
                ])),
                A2(mh, Hq, Fk(n.qQ)),
                A2(mh, nV, Mk(n.nW)),
                A2(mh, Eq, Fk(n.o9)),
                A2(mh, rV, Mk(n.nY)),
                A2(yL, w, w),
                A2(dC, w, k([
                    ag("Skip Jobs")
                ])),
                A2(mh, Uq, Fk(n.qT)),
                A2(mh, Wq, Fk(n.qS)),
                A2(mh, Rq, Fk(n.qR))
            ]));
        }, n.kP);
    }, vV = F2(function(n, r) {
        return A3(gC, "Segmentation Rules", ht(A2(Pg, "New\u2026", Lq)), A2(ye, w, k([
            pV(r),
            A3(ck, zq, r.rN, r.$7)
        ])));
    }), $V = {
        l: function(n) {
            return n.$7;
        },
        m: mq,
        o: F2(function(n, r) {
            return p(n, {
                $7: r
            });
        }),
        p: function(n) {
            return {
                $: 14,
                a: n
            };
        },
        q: Nq,
        r: vV
    }, wV = {
        kP: kt,
        lo: kt,
        lX: w,
        dw: w,
        rz: kt,
        rN: o$("Name")
    }, gV = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hV = dl(GA({
        $: 2
    })), kV = mc(A2(Wi, EA, Ai(hV))), CV = A2(Xa, gV, Gb(d(ry, kV))), TV = d(wV, CV), PV = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), SV = function(n) {
        return {
            $: 11,
            a: n
        };
    }, AV = function(n) {
        return n.$ ? kt : ht(n.a);
    }, yV = function(n) {
        var r = "" === n.rr.sw ? kt : ht(n.rr.sw), t = "" === n.ro.sw ? kt : ht(n.ro.sw), e = "" === n.b2.sw ? kt : ht(n.b2.sw), u = ZA(n.lE.sw);
        return A2(X$, function(u) {
            var o;
            return {
                kV: (o = u, o ? kt : AV(UA(n.kV.sw))),
                lE: u,
                n6: n.n6.sw,
                b2: e,
                ro: t,
                rr: r
            };
        }, u);
    }, NV = F6(function(n, r, t, e, u, o) {
        return {
            kV: u,
            lE: r,
            n6: n,
            b2: o,
            ro: e,
            rr: t
        };
    }), LV = Fi(A4(qi, "offset", function(n) {
        return n.b2;
    }, Oa, A4(qi, "displayStandard", function(n) {
        return n.kV;
    }, _A, A4(qi, "frameRate", function(n) {
        return n.ro;
    }, Oa, A4(qi, "startTimecode", function(n) {
        return n.rr;
    }, Oa, A4(rc, "format", function(n) {
        return n.lE;
    }, XA, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(NV)))))))), jV = function(n) {
        return A2(Xa, SV, A2(BT, function(n) {
            return mc(A2(nw, JA, A3(ow, LV, n, rw(ny))));
        }, A2(Qi, Dy, xy(yV(n)))));
    }, FV = function(n) {
        return {
            $: 14,
            a: n
        };
    }, MV = function(n) {
        return dl(GA({
            $: 1,
            a: n
        }));
    }, IV = function(n) {
        return {
            $: 12,
            a: n
        };
    }, DV = F2(function(n, r) {
        return A2(BT, function(r) {
            return mc(A2(Wi, JA, A3(ow, LV, r, dw(MV(n.mo)))));
        }, A2(Qi, Dy, xy(yV(r))));
    }), BV = F2(function(n, r) {
        return A2(Xa, IV, A2(DV, n, r));
    }), xV = function(n) {
        var r = function(n) {
            return A2(Pi, Lu(n), ju(""));
        };
        return {
            kV: za(function(r) {
                return p(r, {
                    m7: "Display Standard",
                    sw: A2(ju, "teletext_level_1", A2(Lu, QA, A2(sp, function(n) {
                        return n.kV;
                    }, n)))
                });
            }),
            lE: za(function(t) {
                return p(t, {
                    m7: "File Format",
                    sw: A2(r, A2(Pi, function(n) {
                        return n.lE;
                    }, KA), n)
                });
            }),
            n6: za(function(t) {
                return p(t, {
                    m7: "Name",
                    sw: A2(r, function(n) {
                        return n.n6;
                    }, n)
                });
            }),
            b2: za(function(r) {
                return p(r, {
                    m7: "Offset Timecode",
                    sw: A2(ju, "", A2(sp, function(n) {
                        return n.b2;
                    }, n))
                });
            }),
            oS: n,
            ro: za(function(r) {
                return p(r, {
                    m7: "Frame Rate",
                    sw: A2(ju, "", A2(sp, function(n) {
                        return A2(Lu, function(n) {
                            return n.mo;
                        }, n.ro);
                    }, n))
                });
            }),
            rr: za(function(r) {
                return p(r, {
                    m7: "Start Timecode",
                    sw: A2(ju, "", A2(sp, function(n) {
                        return n.rr;
                    }, n))
                });
            })
        };
    }, qV = F2(function(n, r) {
        switch(n.$){
            case 0:
                if ((a = n.a).$) return A2(pc, w, A2(PV, a.a, r));
                var t = a.a;
                return A2(pc, w, p(r, {
                    lX: t.b,
                    dw: t.a
                }));
            case 1:
                return A2(pc, w, p(r, {
                    kP: ht(xV(kt))
                }));
            case 2:
                return A2(pc, w, p(r, {
                    kP: ht(xV(ht(n.a)))
                }));
            case 3:
                var e = n.a, u = A2(Lu, function(n) {
                    return p(n, {
                        n6: A2(ww, e, n.n6)
                    });
                }, r.kP);
                return A2(pc, w, p(r, {
                    kP: u
                }));
            case 4:
                return e = n.a, u = A2(Lu, function(n) {
                    return p(n, {
                        lE: A2(ww, e, n.lE)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: u
                }));
            case 5:
                return e = n.a, u = A2(Lu, function(n) {
                    return p(n, {
                        rr: A2(ww, e, n.rr)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: u
                }));
            case 6:
                return e = n.a, u = A2(Lu, function(n) {
                    return p(n, {
                        ro: A2(ww, e, n.ro)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: u
                }));
            case 7:
                return e = n.a, u = A2(Lu, function(n) {
                    return p(n, {
                        kV: A2(ww, e, n.kV)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: u
                }));
            case 8:
                return e = n.a, u = A2(Lu, function(n) {
                    return p(n, {
                        b2: A2(ww, e, n.b2)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: u
                }));
            case 9:
                return A2(pc, w, p(r, {
                    kP: kt,
                    lo: kt,
                    rz: kt
                }));
            case 10:
                var o = r.kP;
                return A2(pc, k(1 === o.$ ? [
                    n$
                ] : 1 === (c = (u = o.a).oS).$ ? [
                    jV(u)
                ] : [
                    A2(BV, c.a, u)
                ]), r);
            case 11:
                return (a = n.a).$ ? A2(pc, w, A2(PV, a.a, r)) : A2(pc, k([
                    CV
                ]), p(r, {
                    kP: kt,
                    lo: kt,
                    rz: ht("Subtitle format created")
                }));
            case 12:
                return (a = n.a).$ ? A2(pc, w, A2(PV, a.a, r)) : A2(pc, k([
                    CV
                ]), p(r, {
                    kP: kt,
                    lo: kt,
                    rz: ht("Subtitle format updated")
                }));
            case 13:
                return A2(pc, k([
                    (i = n.a, A2(Xa, FV, function(n) {
                        return A2(Yb, Dl(n), mc(sw(fw(MV(n.mo)))));
                    }(i)))
                ]), r);
            case 14:
                var a;
                return (a = n.a).$ ? A2(pc, w, A2(PV, a.a, r)) : A2(pc, k([
                    CV
                ]), r);
            default:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
        }
        var i, c;
    }), VV = {
        $: 1
    }, OV = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zV = function(n) {
        return {
            $: 13,
            a: n
        };
    }, EV = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), HV = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: EV(r)
        });
    }), RV = F2(function(n, r) {
        var t;
        return cg({
            n6: n,
            ds: Ew((t = r, A2(bu, Ua, t))),
            dN: r
        });
    }), WV = ug({
        j_: k([
            A2(HV, "Edit", A2(bu, Pg("Edit"), OV)),
            A2(RV, "Name", function(n) {
                return n.n6;
            }),
            A2(RV, "File Format", A2(bu, KA, function(n) {
                return n.lE;
            })),
            A2(RV, "Start Timecode", A2(bu, ju("N/A"), function(n) {
                return n.rr;
            })),
            A2(RV, "Frame Rate", A2(bu, A2(bu, ju("N/A"), Lu(lN)), function(n) {
                return n.ro;
            })),
            A2(RV, "Display Standard", A2(bu, A2(bu, ju("N/A"), Lu(QA)), function(n) {
                return n.kV;
            })),
            A2(RV, "Offset Timecode", A2(bu, ju("N/A"), function(n) {
                return n.b2;
            })),
            A2(HV, "Delete", A2(bu, Bw(kg), zV))
        ]),
        kv: p(hg, {
            pS: function() {
                return k([
                    Ow("TableTr")
                ]);
            },
            rE: k([
                Ow("Table")
            ]),
            rQ: k([
                Ow("TableTd")
            ])
        }),
        rZ: function(n) {
            return n.mo;
        },
        r_: function(n) {
            return {
                $: 15,
                a: n
            };
        }
    }), UV = {
        $: 9
    }, QV = function(n) {
        return {
            $: 7,
            a: n
        };
    }, _V = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ZV = function(n) {
        return {
            $: 3,
            a: n
        };
    }, KV = function(n) {
        return {
            $: 8,
            a: n
        };
    }, XV = function(n) {
        return {
            $: 6,
            a: n
        };
    }, JV = function(n) {
        return {
            $: 5,
            a: n
        };
    }, YV = {
        $: 10
    }, GV = function(n) {
        return A2(Ck, function(r) {
            var t = A2(Ye, function(n) {
                return d(n.mo, lN(n));
            }, n.lX), e = A2(Ye, function(n) {
                return d(n, n);
            }, A2(Ye, KA, k([
                0,
                1,
                2,
                3
            ]))), u = A2(Ye, function(n) {
                return d(n, n);
            }, A2(Ye, QA, k([
                0,
                1,
                2
            ]))), o = function(n) {
                return 1 !== n.oS.$;
            }(r) ? d("Save", "Edit Format") : d("Create", "New Format");
            return A4(_k, o.b, d(o.a, YV), d("Cancel", UV), k([
                A2(mh, ZV, Mk(r.n6)),
                A2(mh, _V, A2(Ek, r.lE, e)),
                A2(mh, JV, Mk(r.rr)),
                A2(mh, XV, A2(Ek, r.ro, t)),
                A2(DL, a(r.lE.sw, KA(0)), A2(mh, QV, A2(Ek, r.kV, u))),
                A2(mh, KV, Mk(r.b2))
            ]));
        }, n.kP);
    }, nO = F2(function(n, r) {
        return A3(gC, "Subtitle Formats", ht(A2(Pg, "New\u2026", VV)), A2(ye, w, k([
            GV(r),
            A3(ck, WV, r.rN, r.dw)
        ])));
    }), rO = {
        l: function(n) {
            return n.dw;
        },
        m: TV,
        o: F2(function(n, r) {
            return p(n, {
                dw: r
            });
        }),
        p: function(n) {
            return {
                $: 13,
                a: n
            };
        },
        q: qV,
        r: nO
    }, tO = {
        iH: At(d(w, w)),
        lo: kt,
        rz: kt
    }, eO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uO = mc(A2(Wi, uy, Ai(ay))), oO = dl(oy({
        $: 2
    })), aO = mc(A2(Wi, ic(Oa), Ai(oO))), iO = A2(Xa, eO, Gb(d(uO, aO))), cO = A2(pc, k([
        iO
    ]), tO), fO = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), sO = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lO = function(n) {
        return A2(Xa, sO, function(n) {
            return A2(Yb, function() {
                return n;
            }, mc(sw(fw(dl(oy({
                $: 1,
                a: n.mo
            }))))));
        }(n));
    }, dO = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mO = Fi(A4(rc, "tpKey", function(n) {
        return n.r3;
    }, Oa, Mi(function(n) {
        return {
            r3: n
        };
    }))), bO = F2(function(n, r) {
        switch(n.$){
            case 1:
                return A2(pc, k([
                    (u = n.a, A2(Xa, dO, mc(A2(nw, ey, A3(ow, mO, {
                        r3: u
                    }, rw(ay))))))
                ]), r);
            case 2:
                return (t = n.a).$ ? A2(pc, w, A2(fO, e = t.a, r)) : A2(pc, k([
                    iO
                ]), p(r, {
                    lo: kt,
                    rz: ht("Test plan imported")
                }));
            case 0:
                return A2(pc, w, (t = n.a).$ ? p(A2(fO, e = t.a, r), {
                    iH: Ct(e)
                }) : p(r, {
                    iH: At(t.a)
                }));
            case 3:
                return A2(pc, k([
                    lO(n.a)
                ]), r);
            default:
                var t, e;
                return (t = n.a).$ ? A2(pc, w, A2(fO, e = t.a, r)) : A2(pc, k([
                    iO
                ]), p(r, {
                    lo: kt,
                    rz: ht("Test plan deleted")
                }));
        }
        var u;
    }), pO = Ae("b"), vO = mC(pO), $O = k([
        ag("Name"),
        ag("Import")
    ]), wO = k([
        ag("Name"),
        ag("Delete")
    ]), gO = F2(function(n, r) {
        var t = function() {
            var n = r.iH;
            if (n.$) {
                var t = n.a;
                return d(A2(qg, k([
                    Ow("failed")
                ]), t.nP), A2(qg, k([
                    Ow("failed")
                ]), t.nP));
            }
            var e, u = n.a, o = u.b;
            return d(A2(YC, wO, (e = u.a, A2(Ye, function(n) {
                var r;
                return k([
                    vO(n.n6),
                    A2(Bw, kg, (r = n, {
                        $: 3,
                        a: r
                    }))
                ]);
            }, A2(Ra, A2(bu, Ua, function(n) {
                return n.n6;
            }), e)))), A2(YC, $O, A2(Ye, function(n) {
                var r;
                return k([
                    vO(n),
                    A2(Pg, "import", (r = n, {
                        $: 1,
                        a: r
                    }))
                ]);
            }, A2(Ra, Ua, o))));
        }(), e = t.a, u = t.b;
        return A3(gC, "Verification parameters", kt, A2(ye, w, k([
            A2(IL, w, w),
            bC("Imported test plans"),
            e,
            bC("Available in S3"),
            u
        ])));
    }), hO = {
        l: function(n) {
            return n.dB;
        },
        m: cO,
        o: F2(function(n, r) {
            return p(n, {
                dB: r
            });
        }),
        p: function(n) {
            return {
                $: 6,
                a: n
            };
        },
        q: bO,
        r: gO
    }, kO = function(n) {
        return {
            $: 5,
            a: n
        };
    }, CO = function(n) {
        return {
            $: 2,
            a: n
        };
    }, TO = F2(function(n, r) {
        return {
            oZ: r,
            dK: n
        };
    }), PO = F6(function(n, r, t, e, u, o) {
        return {
            fV: u,
            o2: n,
            pk: r,
            gJ: e,
            q6: t,
            dP: o
        };
    }), SO = A2(Te, function(n) {
        var r = function(n) {
            switch(n){
                case "Waiting":
                    return At(0);
                case "Downloading":
                    return At(1);
                case "Encoding":
                    return At(2);
                case "Packaging":
                    return At(3);
                case "Uploading":
                    return At(4);
                case "Finished":
                    return At(5);
                default:
                    return Ct("can't get phase from string " + n);
            }
        }(n);
        return r.$ ? qc(r.a) : je(r.a);
    }, Da), AO = function(n) {
        return ga(function(n) {
            switch(n){
                case 0:
                    return "Waiting";
                case 1:
                    return "Downloading";
                case 2:
                    return "Encoding";
                case 3:
                    return "Packaging";
                case 4:
                    return "Uploading";
                default:
                    return "Finished";
            }
        }(n));
    }, yO = A2(Va, AO, SO), NO = F3(function(n, r, t) {
        return {
            eD: r,
            e9: t,
            n6: n
        };
    }), LO = Fi(A4(rc, "firstFrameApprox", function(n) {
        return n.e9;
    }, uc, A4(rc, "count", function(n) {
        return n.eD;
    }, uc, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(NO))))), jO = Fi(A4(rc, "warning", function(n) {
        return n.dP;
    }, ic(LO), A4(qi, "log", function(n) {
        return n.fV;
    }, Oa, A4(rc, "progressedAt", function(n) {
        return n.gJ;
    }, tm, A4(rc, "startedAt", function(n) {
        return n.q6;
    }, tm, A4(qi, "progress", function(n) {
        return n.pk;
    }, dA, A4(rc, "phase", function(n) {
        return n.o2;
    }, yO, Mi(PO)))))))), FO = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            j2: e,
            lo: u,
            df: t,
            pk: n,
            gJ: r,
            pZ: o,
            aV: i,
            dt: c,
            q_: a
        };
    }), MO = Fi(A4(qi, "source", function(n) {
        return n.dt;
    }, Oa, A4(qi, "secondsLeft", function(n) {
        return n.aV;
    }, uc, A4(rc, "speed", function(n) {
        return n.q_;
    }, dA, A4(qi, "s3Id", function(n) {
        return n.pZ;
    }, Oa, A4(qi, "error", function(n) {
        return n.lo;
    }, Oa, A4(qi, "completedAt", function(n) {
        return n.j2;
    }, tm, A4(qi, "pausedAt", function(n) {
        return n.df;
    }, tm, A4(rc, "progressedAt", function(n) {
        return n.gJ;
    }, tm, A4(rc, "progress", function(n) {
        return n.pk;
    }, dA, Mi(FO))))))))))), IO = F3(function(n, r, t) {
        return {
            lo: r,
            pk: n,
            bl: t
        };
    }), DO = F3(function(n, r, t) {
        return {
            n8: n,
            aq: r,
            b9: t
        };
    }), BO = F2(function(n, r) {
        return {
            lD: n,
            av: r
        };
    }), xO = F3(function(n, r, t) {
        return {
            lT: n,
            fO: r,
            qP: t
        };
    }), qO = Fi(A4(qi, "size", function(n) {
        return n.qP;
    }, uc, A4(qi, "lastModified", function(n) {
        return n.fO;
    }, tm, A4(qi, "format", function(n) {
        return n.lT;
    }, Oa, Mi(xO))))), VO = F6(function(n, r, t, e, u, o) {
        return {
            mo: n,
            bY: o,
            n6: e,
            b0: t,
            gq: r,
            gK: u
        };
    }), OO = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            d3: o,
            u: n,
            fZ: a,
            f9: e,
            gd: t,
            gH: c,
            g8: i,
            hL: u,
            id: r
        };
    }), zO = F2(function(n, r) {
        return {
            n6: n,
            sw: r
        };
    }), EO = Fi(A4(qi, "value", function(n) {
        return n.sw;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(zO)))), HO = F2(function(n, r) {
        return {
            fL: n,
            sw: r
        };
    }), RO = Fi(A4(rc, "$", function(n) {
        return n.u;
    }, Fi(A4(qi, "value", function(n) {
        return n.sw;
    }, Oa, A4(qi, "key", function(n) {
        return n.fL;
    }, Oa, Mi(HO)))), Mi(function(n) {
        return {
            u: n
        };
    }))), WO = nc(ic(RO)), UO = Fi(A4(qi, "ProgramLoudnessEBU", function(n) {
        return n.gH;
    }, ic(WO), A4(qi, "MaxShortTermLoudness", function(n) {
        return n.g8;
    }, ic(RO), A4(qi, "mapping", function(n) {
        return n.fZ;
    }, ic(RO), A4(qi, "area", function(n) {
        return n.d3;
    }, ic(RO), A4(qi, "SystemItem", function(n) {
        return n.hL;
    }, ic(WO), A4(qi, "TimeCodeTrack", function(n) {
        return n.f9;
    }, ic(WO), A4(qi, "TimecodeTrack", function(n) {
        return n.gd;
    }, ic(WO), A4(qi, "VideoTrackProperty", function(n) {
        return n.id;
    }, ic(WO), A4(rc, "$", function(n) {
        return n.u;
    }, EO, Mi(OO))))))))))), QO = F2(function(n, r) {
        return {
            lp: r,
            dQ: n
        };
    }), _O = F8(function(n, r, t, e, u, o, a, i) {
        return {
            et: r,
            kN: u,
            e0: i,
            mo: n,
            g6: t,
            hu: a,
            hK: e,
            hW: o
        };
    }), ZO = Fi(A4(qi, "endsmptetimecode", function(n) {
        return n.e0;
    }, Oa, A4(qi, "startsmptetimecode", function(n) {
        return n.hu;
    }, Oa, A4(qi, "smptetimecode", function(n) {
        return n.hW;
    }, Oa, A4(rc, "description", function(n) {
        return n.kN;
    }, Oa, A4(rc, "synopsis", function(n) {
        return n.hK;
    }, Oa, A4(rc, "severity", function(n) {
        return n.g6;
    }, Oa, A4(qi, "checkId", function(n) {
        return n.et;
    }, Oa, A4(qi, "id", function(n) {
        return n.mo;
    }, Oa, Mi(_O)))))))))), KO = Fi(A4(rc, "$", function(n) {
        return n.u;
    }, ZO, Mi(function(n) {
        return {
            u: n
        };
    }))), XO = Fi(A4(rc, "errors", function(n) {
        return n.lp;
    }, ic(KO), A4(rc, "warnings", function(n) {
        return n.dQ;
    }, ic(KO), Mi(QO)))), JO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, YO = function(n) {
        return {
            $: 2,
            a: n
        };
    }, GO = {
        $: 3
    }, nz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rz = F4(function(n, r, t, e) {
        return {
            cz: t,
            fF: e,
            nt: r,
            gH: n
        };
    }), tz = F2(function(n, r) {
        return {
            m7: n,
            h6: r
        };
    }), ez = Fi(A4(rc, "truePeakLevel", function(n) {
        return n.h6;
    }, Oa, A4(rc, "label", function(n) {
        return n.m7;
    }, Oa, Mi(tz)))), uz = Fi(A4(rc, "isMute", function(n) {
        return n.fF;
    }, ri, A4(rc, "channels", function(n) {
        return n.cz;
    }, ic(ez), A4(qi, "loudnessRange", function(n) {
        return n.nt;
    }, Oa, A4(qi, "programLoudness", function(n) {
        return n.gH;
    }, Oa, Mi(rz)))))), oz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, az = function(n) {
        return {
            $: 0,
            a: n
        };
    }, iz = {
        $: 2
    }, cz = F2(function(n, r) {
        return {
            eU: r,
            q5: n
        };
    }), fz = Fi(A4(qi, "duration", function(n) {
        return n.eU;
    }, Oa, A4(qi, "startTimecode", function(n) {
        return n.q5;
    }, Oa, Mi(cz)))), sz = F3(function(n, r, t) {
        return {
            gl: n,
            gD: t,
            hX: r
        };
    }), lz = F3(function(n, r, t) {
        return {
            fH: t,
            n6: n,
            sz: r
        };
    }), dz = Fi(A4(qi, "issuer", function(n) {
        return n.fH;
    }, Oa, A4(qi, "version", function(n) {
        return n.sz;
    }, Oa, A4(qi, "name", function(n) {
        return n.n6;
    }, Oa, Mi(lz))))), mz = F5(function(n, r, t, e, u) {
        return {
            eU: n,
            fl: u,
            f0: e,
            hj: t,
            hM: r
        };
    }), bz = Fi(A4(qi, "hasVitc", function(n) {
        return n.fl;
    }, Oa, A4(qi, "materialPackageStart", function(n) {
        return n.f0;
    }, Oa, A4(qi, "sourcePackageStart", function(n) {
        return n.hj;
    }, Oa, A4(qi, "systemItemStart", function(n) {
        return n.hM;
    }, Oa, A4(qi, "duration", function(n) {
        return n.eU;
    }, Oa, Mi(mz))))))), pz = Fi(A4(rc, "product", function(n) {
        return n.gD;
    }, dz, A4(rc, "timeCodes", function(n) {
        return n.hX;
    }, bz, A4(qi, "operationalPattern", function(n) {
        return n.gl;
    }, Oa, Mi(sz))))), vz = F2(function(n, r) {
        return A3($b, n, function(n) {
            return n(w);
        }, je(r));
    }), $z = lm(A3(vz, "UnsupportedContainer", iz, A4(wb, "Mov", oz, fz, A4(wb, "Mxf", az, pz, bm(F4(function(n, r, t, e) {
        switch(e.$){
            case 0:
                return n(e.a);
            case 1:
                return r(e.a);
            default:
                return t;
        }
    })))))), wz = F6(function(n, r, t, e, u, o) {
        return {
            dW: t,
            ep: e,
            eu: u,
            eS: n,
            lW: r,
            g$: o
        };
    }), gz = Fi(A4(qi, "scanningType", function(n) {
        return n.g$;
    }, Oa, A4(qi, "chromaFormat", function(n) {
        return n.eu;
    }, Oa, A4(qi, "cadencePattern", function(n) {
        return n.ep;
    }, Oa, A4(qi, "activePixelsArea", function(n) {
        return n.dW;
    }, Oa, A4(qi, "frameRate", function(n) {
        return n.lW;
    }, Oa, A4(qi, "displayAspectRatio", function(n) {
        return n.eS;
    }, Oa, Mi(wz)))))))), hz = lm(A3(vz, "UnknownNodeType", GO, A4(wb, "Container", YO, $z, A4(wb, "VideoProgram", nz, gz, A4(wb, "AudioProgram", JO, uz, bm(F5(function(n, r, t, e, u) {
        switch(u.$){
            case 0:
                return n(u.a);
            case 1:
                return r(u.a);
            case 2:
                return t(u.a);
            default:
                return e;
        }
    }))))))), kz = Fi(A4(rc, "issues", function(n) {
        return n.bY;
    }, XO, A4(rc, "properties", function(n) {
        return n.gK;
    }, nc(UO), A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "nodeType", function(n) {
        return n.b0;
    }, hz, A4(rc, "parent", function(n) {
        return n.gq;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(VO)))))))), Cz = Fi(A4(rc, "streams", function(n) {
        return n.av;
    }, nc(kz), A4(rc, "file", function(n) {
        return n.lD;
    }, qO, Mi(BO)))), Tz = Fi(A4(qi, "report", function(n) {
        return n.b9;
    }, Cz, A4(rc, "nbWarnings", function(n) {
        return n.aq;
    }, uc, A4(rc, "nbErrors", function(n) {
        return n.n8;
    }, uc, Mi(DO))))), Pz = Fi(A4(qi, "result", function(n) {
        return n.bl;
    }, Tz, A4(qi, "error", function(n) {
        return n.lo;
    }, Oa, A4(rc, "progress", function(n) {
        return n.pk;
    }, dA, Mi(IO))))), Sz = Fi(A4(qi, "format", function(n) {
        return n.lT;
    }, xA, A4(qi, "stateExpireAt", function(n) {
        return n.hw;
    }, tm, A4(rc, "state", function(n) {
        return n.hv;
    }, Db, A4(qi, "transcoding", function(n) {
        return n.r6;
    }, jO, A4(qi, "sourceId", function(n) {
        return n.hg;
    }, Oa, A4(qi, "verification", function(n) {
        return n.sy;
    }, Pz, A4(qi, "uploadedAt", function(n) {
        return n.h9;
    }, tm, A4(qi, "upload", function(n) {
        return n.sk;
    }, MO, A4(qi, "uploaderId", function(n) {
        return n.sm;
    }, Oa, A4(rc, "kind", function(n) {
        return n.c$;
    }, Ex, A4(rc, "key", function(n) {
        return n.fL;
    }, Oa, A4(rc, "bucket", function(n) {
        return n.en;
    }, Oa, A4(qi, "mimeType", function(n) {
        return n.nT;
    }, Oa, A4(rc, "size", function(n) {
        return n.qP;
    }, uc, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return {
                                                                            en: o,
                                                                            ki: r,
                                                                            lT: v,
                                                                            mo: n,
                                                                            fL: a,
                                                                            c$: i,
                                                                            nT: u,
                                                                            n6: t,
                                                                            qP: e,
                                                                            hg: d,
                                                                            hv: b,
                                                                            hw: p,
                                                                            r6: m,
                                                                            sk: f,
                                                                            h9: s,
                                                                            sm: c,
                                                                            sy: l
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), Az = F2(function(n, r) {
        return {
            fL: r,
            sl: n
        };
    }), yz = Fi(A4(rc, "key", function(n) {
        return n.fL;
    }, Oa, A4(rc, "uploadId", function(n) {
        return n.sl;
    }, Oa, Mi(Az)))), Nz = Fi(A4(rc, "parts", function(n) {
        return n.oZ;
    }, ic(yz), A4(rc, "uploads", function(n) {
        return n.dK;
    }, ic(Sz), Mi(TO)))), Lz = dl({
        $: 13,
        a: 0
    }), jz = mc(A2(Wi, Nz, Ai(Lz))), Fz = mc(A2(Wi, LT, Ai(FT))), Mz = Gb(d(jz, Fz)), Iz = {
        iD: w,
        c1: kt,
        dF: kt
    }, Dz = {
        iD: Iz,
        op: 0,
        sg: w,
        dK: w
    }, Bz = d(Dz, A2(Xa, CO, Mz)), xz = function(n) {
        return {
            $: 6,
            a: n
        };
    }, qz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vz = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Oz = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), zz = function(n) {
        return dl(Wx(A2(Oz, n, 7)));
    }, Ez = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Hz = F2(function(n, r) {
        return A2(Yv, Ez, A2(Yb, function(t) {
            return {
                d5: t,
                nP: r,
                g6: n
            };
        }, Jv));
    }), Rz = Hz(1), Wz = F2(function(n, r) {
        var t = F2(function(r, t) {
            var e = t.a, u = t.b;
            return n(r) ? d(A2(mt, r, e), u) : d(e, A2(mt, r, u));
        });
        return A3(Je, t, d(w, w), r);
    }), Uz = F3(function(n, r, t) {
        return A3(xt, F2(function(n, r) {
            var e = r.a, u = r.b, o = Eo(A2(Mu, function(r) {
                return a(n.sm, ht(r.mo));
            }, t)), i = A2(Wz, function(r) {
                return a(ht(r.sl), A2(sp, function(n) {
                    return n.pZ;
                }, n.sk));
            }, u), c = i.b;
            return d(A2(mt, {
                lD: n,
                oZ: i.a,
                st: o
            }, e), c);
        }), d(w, r), Zt(n));
    }), Qz = Hz(0), _z = F2(function(n, r) {
        switch(n.$){
            case 0:
                return d(r, n$);
            case 1:
                var t = n.a;
                return d(p(r, {
                    iD: 1 === (e = r.c1).$ ? A2(mt, t, r.iD) : A2(Ko, e.a, A2(mt, t, r.iD))
                }), n$);
            default:
                return t = n.a, d(p(r, {
                    iD: A2(Mu, function(n) {
                        return !a(n, t);
                    }, r.iD)
                }), n$);
        }
        var e;
    }), Zz = F2(function(n, r) {
        switch(n.$){
            case 1:
                return A2(pc, w, p(r, {
                    op: n.a
                }));
            case 0:
                return A2(pc, w, r);
            case 2:
                if ((i = n.a).$) return A2(pc, k([
                    A2(cp, xz, Rz(i.a.nP))
                ]), r);
                var t = i.a, e = t.a, u = A3(Uz, e.dK, e.oZ, t.b), o = u.a, a = u.b;
                return A2(pc, k([
                    A2(Yv, qz, Jv)
                ]), p(r, {
                    sg: a,
                    dK: o
                }));
            case 3:
                return A2(pc, k([
                    A2(Xa, Vz, (s = n.a, mc(sw(fw(zz(s))))))
                ]), r);
            case 4:
                var i;
                return A2(pc, k((i = n.a).$ ? [
                    A2(cp, xz, Rz(i.a.nP))
                ] : [
                    A2(cp, xz, Qz("Upload deleted"))
                ]), r);
            case 5:
                return A2(pc, k([
                    A2(Xa, CO, Mz)
                ]), r);
            default:
                var c = A2(_z, n.a, r.iD), f = c.a;
                return A2(pc, k([
                    A2(cp, xz, c.b)
                ]), p(r, {
                    iD: f
                }));
        }
        var s;
    }), Kz = mC(dP), Xz = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Jz = function(n) {
        return Mt(se(100 * n)) + "%";
    }, Yz = {
        $: 4
    }, Gz = {
        $: 2
    }, nE = {
        $: 1
    }, rE = F2(function(n, r) {
        return a(n.df, kt) ? r ? nE : function(n) {
            return {
                $: 0,
                a: n
            };
        }({
            aV: n.aV
        }) : Gz;
    }), tE = F3(function(n, r, t) {
        var e = Eo(A2(Mu, function(r) {
            return a(r.z, n);
        }, t)), u = r.lo;
        if (u.$) {
            if (a(r.j2, kt) && 1 !== r.pk) {
                if (e.$) return A2(rE, r, !1);
                var o = e.a;
                return a(o.j2, kt) ? A2(rE, r, o.dg) : Yz;
            }
            return Yz;
        }
        return function(n) {
            return {
                $: 5,
                a: n
            };
        }({
            lo: u.a
        });
    }), eE = F3(function(n, r, t) {
        return 1 > n ? "" : 1 === n ? $(r, $(Mt(n), t)) : r + (Mt(n) + (t + "s"));
    }), uE = function(n) {
        return 86400 > n ? 3600 > n ? 60 > n ? A3(eE, n, "", " seconde") : A3(eE, n / 60 | 0, "", " minute") : $(A3(eE, n / 3600 | 0, "", " heure"), A3(eE, A2(qo, 60, n), " et ", " minute")) : $(A3(eE, n / 86400 | 0, "", " jour"), A3(eE, A2(qo, 24, n), " et ", " heure"));
    }, oE = xa({
        bN: "in error",
        bT: "en erreur"
    }), aE = xa({
        bN: "Calcultating the remaining time...",
        bT: "Calcul du temps restant..."
    }), iE = xa({
        bN: "paused",
        bT: "en pause"
    }), cE = xa({
        bN: "pausing...",
        bT: "mis en pause..."
    }), fE = xa({
        bN: "seems stopped since ",
        bT: "semble \xe0 l\u2019arr\xeat depuis "
    }), sE = function(n) {
        switch(n.$){
            case 0:
                var r = n.a.aV;
                return r.$ ? aE : uE(r.a);
            case 1:
                return cE;
            case 2:
                return iE;
            case 3:
                var t = uE(n.a.qh);
                return "" === t ? "" : $(fE, t);
            case 4:
                return "";
            default:
                return oE;
        }
    }, lE = function(n) {
        switch(n.$){
            case 5:
                return "En erreur : " + n.a.lo;
            case 4:
                return "Termin\xe9";
            default:
                return sE(n);
        }
    }, dE = F2(function(n, r) {
        return A2(Ye, function(n) {
            var t = d(n.lD.sk, n.st);
            if (t.a.$ || t.b.$) return w;
            var e = t.a.a, u = t.b.a;
            return k([
                vO(n.lD.n6),
                ag(Jz(e.pk)),
                A2(ye, w, k([
                    IP(e.gJ),
                    ag(r - jP(e.gJ) > 6e5 ? "\xa0 \xa0 ???" : "")
                ])),
                ag(Xx(qf(e.q_)) + "/s"),
                ag(lE(A3(tE, n.lD.mo, e, w))),
                ag(u.n6),
                ag(Mt(qt(n.oZ))),
                A2(Bw, kg, Xz(n.lD.mo))
            ]);
        }, n);
    }), mE = k([
        ag("Fichier"),
        ag("Progression"),
        ag("Last Updated"),
        ag("Last Speed Recorded"),
        ag("Statut"),
        ag("User"),
        ag("S3 parts"),
        ag("Supprimer")
    ]), bE = Ae("ul"), pE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, vE = Ae("li"), $E = function(n) {
        return A2(vE, k([
            Cg(pE(n))
        ]), k([
            ag(n.nP)
        ]));
    }, wE = function(n) {
        var r;
        return A2(ye, w, k([
            (r = n.iD, A2(bE, w, A2(Ye, $E, r)))
        ]));
    }, gE = function(n) {
        return A2(vE, k([
            A2(pg, "list-style", "disc"),
            A2(pg, "margin-top", "5px")
        ]), k([
            ag(n.fL)
        ]));
    }, hE = F2(function(n, r) {
        return A3(gC, "Uploads", kt, A2(ye, w, k([
            A2(mh, xz, wE(r.iD)),
            A2(YC, mE, A2(dE, r.dK, r.op)),
            Kz("Unlinked S3 parts"),
            A2(bE, k([
                A2(pg, "padding-left", "1.5em")
            ]), A2(Ye, gE, r.sg))
        ])));
    }), kE = {
        l: function(n) {
            return n.dK;
        },
        m: Bz,
        o: F2(function(n, r) {
            return p(n, {
                dK: r
            });
        }),
        p: kO,
        q: Zz,
        r: hE
    }, CE = {
        kP: kt,
        lo: kt,
        oQ: Su,
        px: za(function(n) {
            return p(n, {
                gw: "Search User or Email or Organization",
                sw: ""
            });
        }),
        rz: kt,
        rN: o$("Full name"),
        dL: w
    }, TE = function(n) {
        return {
            $: 1,
            a: n
        };
    }, PE = A2(Yb, Ji, A2(Yb, Ye(function(n) {
        return d(n.mo, n);
    }), A2(Yb, Ra(function(n) {
        return n.n6;
    }), mc(A2(Wi, M$, Ai(D$)))))), SE = A2(Yb, Ra(function(n) {
        return n.n6;
    }), mc(A2(Wi, LT, Ai(FT)))), AE = A2(Xa, TE, Gb(d(SE, PE))), yE = A2(pc, k([
        AE
    ]), CE), NE = function(n) {
        return {
            $: 17,
            a: n
        };
    }, LE = {
        $: 0
    }, jE = function(n) {
        return {
            $: 24,
            a: n
        };
    }, FE = function(n) {
        return {
            $: 15,
            a: n
        };
    }, ME = yi(Li({
        $: 3
    })), IE = Fi(A4(rc, "email", function(n) {
        return n.la;
    }, Oa, Mi(function(n) {
        return {
            la: n
        };
    }))), DE = function(n) {
        return mc(sw(A3(ow, IE, n, rw(ME))));
    }, BE = F2(function(n, r) {
        return Ui(wa(k([
            d("name", ga(n)),
            d("message", ga(r))
        ])));
    }), xE = function(n) {
        return Ge(function(r) {
            var t = A2(ba, n, r);
            return t.$ ? A2(BE, "JSON Decode Error", Xt(t.a)) : Ze(t.a);
        });
    }, qE = xn, VE = function(n) {
        var r;
        return A2(Ia, A2(BE, "FFI Error", Fa), (r = A2(du, "_elm_ffi_apply_", Di(k([
            A2(Ne, Ze, A2(du, "OK", Ma)),
            A2(Te, A2(bu, je, OE(n)), A2(du, "AW", sA)),
            A2(Ne, Ui, A2(du, "ER", Ma))
        ]))), A2(ba, r, n)));
    }, OE = function(n) {
        return A2(Pi, qE, Ge(function() {
            return VE(n);
        }));
    }, zE = F2(function(n, r) {
        return VE(wa(k([
            d("_elm_ffi_apply_", wa(k([
                d("holder", r),
                d("params", A2(ac, Me, n))
            ])))
        ])));
    }), EE = F2(function(n, r) {
        return wa(k([
            d("_elm_ffi_create_", wa(k([
                d("args", A2(ac, ga, n)),
                d("code", ga(r))
            ])))
        ]));
    }), HE = F2(function(n, r) {
        var t = A2(EE, A2(Ye, $e, n), r);
        return function(r) {
            return A2(zE, A2(Ye, A2(Pi, Zi, ce(r)), n), t);
        };
    }), RE = (sf = A2(HE, k([
        d("message", ga)
    ]), "return confirm(message);"), function(n) {
        return A2(Za, function() {
            return Ze(!1);
        }, A2(xE, Pe, sf(n)));
    }), WE = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), UE = Gr("focus"), QE = Fi(A4(rc, "user", function(n) {
        return n.st;
    }, Oa, Mi(function(n) {
        return {
            st: n
        };
    }))), _E = dl(jT({
        $: 1
    })), ZE = function(n) {
        return mc(sw(A3(ow, QE, {
            st: n.mo
        }, rw(_E))));
    }, KE = function(n) {
        return {
            $: 12,
            a: n
        };
    }, XE = F7(function(n, r, t, e, u, o, a) {
        return {
            iz: o,
            kR: a,
            la: r,
            n6: n,
            oM: t,
            oQ: u,
            o_: e
        };
    }), JE = Fi(A4(rc, "disableOrganizationEmails", function(n) {
        return n.kR;
    }, ri, A4(rc, "admin", function(n) {
        return n.iz;
    }, ri, A4(rc, "organizations", function(n) {
        return n.oQ;
    }, ic(Oa), A4(rc, "password", function(n) {
        return n.o_;
    }, Oa, A4(qi, "organization", function(n) {
        return n.oM;
    }, Oa, A4(rc, "email", function(n) {
        return n.la;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(XE))))))))), YE = function(n) {
        return A2(Xa, KE, function(n) {
            var r = A2(Ye, function(n) {
                return n.b.sw;
            }, pt(n.oQ)), t = Eo(r);
            return mc(A2(nw, Uv, A3(ow, JE, {
                iz: n.iz.sw,
                kR: n.kR.sw,
                la: n.la.sw,
                n6: n.n6.sw,
                oM: t,
                oQ: r,
                o_: n.o_.sw
            }, rw(FT))));
        }(n));
    }, GE = function(n) {
        return {
            $: 14,
            a: n
        };
    }, nH = function(n) {
        return {
            $: 3,
            a: n
        };
    }, rH = A2(bu, A2(bu, dl, jT), nH), tH = function(n) {
        return A2(Xa, GE, function(n) {
            return mc(sw(fw(rH(n.mo))));
        }(n));
    }, eH = function(n) {
        return {
            $: 13,
            a: n
        };
    }, uH = F6(function(n, r, t, e, u, o) {
        return {
            iz: u,
            kR: o,
            la: r,
            n6: n,
            oM: t,
            oQ: e
        };
    }), oH = Fi(A4(rc, "disableOrganizationEmails", function(n) {
        return n.kR;
    }, ri, A4(rc, "admin", function(n) {
        return n.iz;
    }, ri, A4(rc, "organizations", function(n) {
        return n.oQ;
    }, ic(Oa), A4(qi, "organization", function(n) {
        return n.oM;
    }, Oa, A4(rc, "email", function(n) {
        return n.la;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(uH)))))))), aH = F2(function(n, r) {
        var t = A2(Ye, function(n) {
            return n.b.sw;
        }, pt(r.oQ)), e = Eo(t);
        return mc(A2(Wi, Uv, A3(ow, oH, {
            iz: r.iz.sw,
            kR: r.kR.sw,
            la: r.la.sw,
            n6: r.n6.sw,
            oM: e,
            oQ: t
        }, dw(rH(n.mo)))));
    }), iH = F2(function(n, r) {
        return A2(Xa, eH, A2(aH, n, r));
    }), cH = Zn("redirectAndRefresh", ga), fH = Fi(A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return {
            mo: n
        };
    }))), sH = yi(Li({
        $: 5
    })), lH = wP(Ap), dH = function(n) {
        return za(function(r) {
            return p(r, {
                m7: "Organization",
                sw: n.oO
            });
        });
    }, mH = F2(function(n) {
        var r;
        return {
            iz: ti(function(r) {
                return p(r, {
                    m7: "Admin",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.iz;
                    }, n))
                });
            }),
            kR: ti(function(r) {
                return p(r, {
                    m7: "Disable Emails",
                    sw: A2(ju, !1, A2(Lu, function(n) {
                        return n.kR;
                    }, n))
                });
            }),
            la: za(function(r) {
                return p(r, {
                    m7: "Email",
                    sw: A2(ju, "", A2(Lu, function(n) {
                        return n.la;
                    }, n))
                });
            }),
            n6: za(function(r) {
                return p(r, {
                    m7: "Name",
                    sw: A2(ju, "", A2(Lu, function(n) {
                        return n.n6;
                    }, n))
                });
            }),
            oQ: n.$ ? Su : (r = n.a.oQ, A2(Gi, F2(function(n, r) {
                return dH(r);
            }), Ji(A2(Ht, V$, r)))),
            oS: n,
            o_: za(function(n) {
                return p(n, {
                    m7: "Password"
                });
            })
        };
    }), bH = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, w, r);
            case 1:
                if ((f = n.a).$) return A2(pc, w, A2(WE, f.a, r));
                var t = f.a;
                return A2(pc, w, p(r, {
                    oQ: t.b,
                    dL: t.a
                }));
            case 2:
                return A2(pc, w, p(r, {
                    kP: ht(A2(mH, kt, r.oQ))
                }));
            case 3:
                var e = n.a;
                return A2(pc, k([
                    A2(Xa, function() {
                        return LE;
                    }, UE("LayoutPageTop"))
                ]), p(r, {
                    kP: ht(A2(mH, ht(e), r.oQ)),
                    lo: kt,
                    rz: kt
                }));
            case 6:
                return A2(pc, w, p(r, {
                    kP: kt,
                    lo: kt,
                    rz: kt
                }));
            case 7:
                var u = n.a, o = A2(Lu, function(n) {
                    return p(n, {
                        n6: A2(ww, u, n.n6)
                    });
                }, r.kP);
                return A2(pc, w, p(r, {
                    kP: o
                }));
            case 8:
                return u = n.a, o = A2(Lu, function(n) {
                    return p(n, {
                        la: A2(ww, u, n.la)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: o
                }));
            case 9:
                return u = n.a, o = A2(Lu, function(n) {
                    return p(n, {
                        o_: A2(ww, u, n.o_)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: o
                }));
            case 10:
                return u = n.a, o = A2(Lu, function(n) {
                    return p(n, {
                        iz: A2(vw, u, n.iz)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: o
                }));
            case 11:
                return u = n.a, o = A2(Lu, function(n) {
                    return p(n, {
                        kR: A2(vw, u, n.kR)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: o
                }));
            case 4:
                var i = r.kP;
                if (1 === i.$) return A2(pc, w, r);
                var c = (o = i.a).oS;
                return A2(pc, k(1 === c.$ ? [
                    YE(o)
                ] : [
                    A2(iH, b = c.a, o)
                ]), r);
            case 12:
                return (f = n.a).$ ? A2(pc, w, A2(WE, f.a, r)) : A2(pc, k([
                    AE
                ]), p(r, {
                    kP: kt,
                    lo: kt,
                    rz: ht("User created")
                }));
            case 13:
                return (f = n.a).$ ? A2(pc, w, A2(WE, f.a, r)) : A2(pc, k([
                    AE
                ]), p(r, {
                    kP: kt,
                    lo: kt,
                    rz: ht("User updated")
                }));
            case 5:
                return A2(pc, k([
                    tH(b = n.a)
                ]), r);
            case 14:
            case 15:
                return (f = n.a).$ ? A2(pc, w, A2(WE, f.a, r)) : A2(pc, k([
                    AE
                ]), r);
            case 16:
                return A2(pc, k([
                    A2(Xa, NE, ZE(b = n.a))
                ]), r);
            case 17:
                var f;
                return A2(pc, 1 === (f = n.a).$ ? w : k([
                    cH(lH)
                ]), r);
            case 18:
                u = n.a;
                var s = n.b;
                return o = A2(Lu, function(n) {
                    return p(n, {
                        oQ: A2(Gi, F2(function(n, r) {
                            return a(n, s) ? A2(ww, u, r) : r;
                        }), n.oQ)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: o
                }));
            case 20:
                return s = n.a, o = A2(Lu, function(n) {
                    return p(n, {
                        oQ: A2(R$, F2(function(n) {
                            return !a(n, s);
                        }), n.oQ)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: o
                }));
            case 19:
                var l = A2(ju, 0, A2(Lu, function(n) {
                    return A2(ju, 0, W$(vt(n.oQ)));
                }, r.kP)), d = A2(ju, "", Eo(A2(Ye, function(n) {
                    return n.mo;
                }, A2(Ye, Zi, pt(r.oQ))))), m = dH(A3(Rv, d, "", kt));
                return o = A2(Lu, function(n) {
                    return p(n, {
                        oQ: A3(Cu, l + 1, m, n.oQ)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: o
                }));
            case 22:
                return A2(pc, w, p(r, {
                    px: A2(ww, u = n.a, r.px)
                }));
            case 21:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
            case 23:
                return A2(pc, k([
                    A2(Xa, jE, DE({
                        la: n.a
                    }))
                ]), r);
            case 24:
                return A2(pc, w, p(r, n.a.$ ? {
                    lo: ht(n.a.a.nP)
                } : {
                    rz: ht("Sent email to reset password.")
                }));
            default:
                var b = n.a;
                return A2(pc, k([
                    A2(Xa, FE, A2(BT, function(n) {
                        return n ? mc(sw(A3(ow, fH, {
                            mo: b.mo
                        }, rw(sH)))) : iP(0);
                    }, A2(Qi, function() {
                        return {
                            lC: Su,
                            nP: "",
                            P: 0
                        };
                    }, RE("Confirm this unreversible action"))))
                ]), r);
        }
    }), pH = {
        $: 2
    }, vH = function(n) {
        return {
            $: 22,
            a: n
        };
    }, $H = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wH = function(n) {
        return {
            $: 16,
            a: n
        };
    }, gH = function(n) {
        return {
            $: 25,
            a: n
        };
    }, hH = function(n) {
        return {
            $: 21,
            a: n
        };
    }, kH = function(n) {
        return {
            $: 5,
            a: n
        };
    }, CH = function(n) {
        return n ? "\u2714" : "\u2716";
    }, TH = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), PH = function(n) {
        return Gw({
            n6: "",
            ds: rg,
            dN: TH(n)
        });
    }, SH = F2(function(n, r) {
        var t;
        return cg({
            n6: n,
            ds: Ew((t = r, A2(bu, Ua, t))),
            dN: r
        });
    }), AH = F2(function(n, r) {
        return A3(Kd, n, "0", Mt(r));
    }), yH = function(n) {
        switch(n){
            case 0:
                return "01";
            case 1:
                return "02";
            case 2:
                return "03";
            case 3:
                return "04";
            case 4:
                return "05";
            case 5:
                return "06";
            case 6:
                return "07";
            case 7:
                return "08";
            case 8:
                return "09";
            case 9:
                return "10";
            case 10:
                return "11";
            default:
                return "12";
        }
    }, NH = F2(function(n, r) {
        return $(A2(AH, 4, A2(Yd, nm, r)), $(n, $(yH(A2(Ud, nm, r)), $(n, A2(AH, 2, A2(Ed, nm, r))))));
    }), LH = function(n) {
        return A2(NH, "/", n);
    }, jH = k([
        Ow("Table")
    ]), FH = function() {
        return k([
            Ow("TableTr")
        ]);
    }, MH = F2(function(n, r) {
        return Ti(A2(Mq, ", ", A2(Ye, function(r) {
            return A2(ju, "", A2(Lu, function(n) {
                return n.n6;
            }, A2(di, r.oO, n)));
        }, r.oQ)));
    }), IH = {
        $: 6
    }, DH = function(n) {
        return {
            $: 10,
            a: n
        };
    }, BH = function(n) {
        return {
            $: 11,
            a: n
        };
    }, xH = function(n) {
        return {
            $: 8,
            a: n
        };
    }, qH = function(n) {
        return {
            $: 7,
            a: n
        };
    }, VH = function(n) {
        return {
            $: 9,
            a: n
        };
    }, OH = {
        $: 19
    }, zH = function(n) {
        return {
            $: 23,
            a: n
        };
    }, EH = {
        $: 4
    }, HH = function(n) {
        return A2(ju, !1, A2(Lu, function() {
            return !0;
        }, n.oS));
    }, RH = function(n) {
        return A2(jk, n, function(n) {
            return A2(Og, n, A2(Eg, k([
                Ow("InputPassword"),
                Xg(n.kX),
                Tg("password"),
                eh(Lg),
                Gg(jg),
                nh(Fg),
                oh(n.sw),
                uh(n.gw),
                Hg(Zg(n.m7)),
                zg(n.kS),
                A2(qI, "autocomplete", "current-password")
            ]), w));
        }(n));
    }, WH = F2(function(n, r) {
        return {
            $: 18,
            a: n,
            b: r
        };
    }), UH = function(n) {
        return {
            $: 20,
            a: n
        };
    }, QH = F2(function(n, r) {
        var t = A2(Ye, function(n) {
            return d(n.a, n.b.n6);
        }, A2(Ra, function(n) {
            return n.b.n6;
        }, pt(r)));
        return A2(Ye, Zi, pt(A2(Gi, F2(function(n, r) {
            return A2(ye, k([
                A2(pg, "position", "relative"),
                A2(pg, "margin", "25px 0")
            ]), k([
                A2(mh, function(r) {
                    return A2(WH, r, n);
                }, A2(zk, r, t)),
                A3(Jk, "remove", k([
                    d("position", "absolute"),
                    d("right", "0")
                ]), UH(n))
            ]));
        }), n.oQ)));
    }), _H = function(n) {
        return A2(Ck, function(r) {
            var t = HH(r) ? d("Save", "Edit user") : d("Create", "New User");
            return A4(_k, t.b, d(t.a, EH), d("Cancel", IH), $(k([
                A2(mh, qH, Mk(r.n6)),
                A2(mh, xH, Mk(r.la)),
                HH(r) ? ag("") : A2(mh, VH, RH(r.o_)),
                A2(mh, DH, Fk(r.iz)),
                A2(mh, BH, Fk(r.kR))
            ]), $(A2(QH, r, n.oQ), k([
                A2(Pg, "Add New Organization", OH),
                A2(Pg, "Reset password", zH(r.la.sw)),
                A2(Ck, lk, n.rz),
                A2(Ck, sk, n.lo)
            ]))));
        }, n.kP);
    }, ZH = F2(function(n, r) {
        var t, e = Ua(r.px.sw), u = A2(Mu, function(n) {
            return A2(bu, A2(bu, Be(e), Ua), function(n) {
                return n.n6;
            })(n) || A2(bu, A2(bu, Be(e), Ua), function(n) {
                return n.la;
            })(n) || A2(bu, A2(bu, Be(e), Ua), MH(r.oQ))(n);
        }, r.dL);
        return A3(gC, "Users", ht(A2(Pg, "New\u2026", pH)), A2(ye, w, k([
            A2(mh, vH, ah(r.px)),
            _H(r),
            A3(ck, (t = r.oQ, ug({
                j_: k([
                    PH(A2(bu, Pg("edit"), $H)),
                    A2(SH, "Full name", function(n) {
                        return n.n6;
                    }),
                    A2(SH, "Email address", function(n) {
                        return n.la;
                    }),
                    A2(SH, "Admin", A2(bu, CH, function(n) {
                        return n.iz;
                    })),
                    A2(SH, "Disable Organization Emails", A2(bu, CH, function(n) {
                        return n.kR;
                    })),
                    A2(SH, "Organizations", MH(t)),
                    A2(SH, "Creation date", A2(bu, A2(bu, ju("Unknown"), Lu(LH)), function(n) {
                        return n.ki;
                    })),
                    PH(A2(bu, Pg("Log as"), wH)),
                    PH(A2(bu, Pg("Delete"), kH)),
                    PH(A2(bu, Pg("Revoke"), gH))
                ]),
                kv: p(hg, {
                    pS: FH,
                    rE: jH,
                    rQ: k([
                        Ow("TableTd")
                    ])
                }),
                rZ: function(n) {
                    return n.mo;
                },
                r_: hH
            })), r.rN, u)
        ])));
    }), KH = {
        l: function(n) {
            return n.dL;
        },
        m: yE,
        o: F2(function(n, r) {
            return p(n, {
                dL: r
            });
        }),
        p: function(n) {
            return {
                $: 4,
                a: n
            };
        },
        q: bH,
        r: ZH
    }, XH = {
        kP: kt,
        lo: kt,
        oQ: w,
        rz: kt,
        rN: o$("Organization"),
        dR: w
    }, JH = function(n) {
        return {
            $: 0,
            a: n
        };
    }, YH = mc(A2(Wi, M$, Ai(D$))), GH = F5(function(n, r, t, e, u) {
        return {
            ip: e,
            lq: t,
            mo: n,
            oM: r,
            oX: u
        };
    }), nR = function(n) {
        switch(n){
            case "ShowCreation":
                return At(0);
            case "ProxyReady":
                return At(1);
            case "FileQualified":
                return At(2);
            case "FileDownload":
                return At(3);
            case "VersionAccepted":
                return At(4);
            case "VersionRejected":
                return At(5);
            case "InvitationAdded":
                return At(6);
            case "InvitationUpdated":
                return At(7);
            case "InvitationRemoved":
                return At(8);
            case "UploaderAdded":
                return At(9);
            case "UploaderRemoved":
                return At(10);
            case "UploadFinished":
                return At(11);
            case "QCFinished":
                return At(12);
            default:
                return Ct("Can't parse webhook event " + n);
        }
    }, rR = function(n) {
        switch(n){
            case 0:
                return "ShowCreation";
            case 1:
                return "ProxyReady";
            case 2:
                return "FileQualified";
            case 3:
                return "FileDownload";
            case 4:
                return "VersionAccepted";
            case 5:
                return "VersionRejected";
            case 6:
                return "InvitationAdded";
            case 7:
                return "InvitationUpdated";
            case 8:
                return "InvitationRemoved";
            case 9:
                return "UploaderAdded";
            case 10:
                return "UploaderRemoved";
            case 11:
                return "UploadFinished";
            default:
                return "QCFinished";
        }
    }, tR = A2(Ml, rR, nR), eR = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), uR = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oR = function(n) {
        switch(n){
            case "Json":
                return At(0);
            case "SaltoMam":
                return At(1);
            case "SaltoContent":
                return At(2);
            case "ADN":
                return At(3);
            default:
                return Ct("Can't parse api call format " + n);
        }
    }, aR = A2(Te, function(n) {
        var r = oR(n);
        return r.$ ? qc(r.a) : je(r.a);
    }, Da), iR = function(n) {
        switch(n){
            case "Manager":
                return At(0);
            case "Uploader":
                return At(1);
            case "EventSpecified":
                return At(2);
            default:
                return Ct("Can't parse email target " + n);
        }
    }, cR = A2(Te, function(n) {
        var r = iR(n);
        return r.$ ? qc(r.a) : je(r.a);
    }, Da), fR = an, sR = A2(Te, function(n) {
        var r = n.a, t = n.b, e = t.a, u = d(r, m(e, t.b, t.c));
        n: for(;;){
            if (u.b.a.$) {
                if ("Email" !== u.a || 1 !== u.b.b.$ || u.b.c.$) break n;
                return je(uR(u.b.c.a));
            }
            if ("ApiCall" !== u.a || u.b.b.$ || 1 !== u.b.c.$) break n;
            var o = u.b;
            return je(A2(eR, o.a.a, o.b.a));
        }
        return qc("Can't decode webhook params with kind " + r + " and url " + A2(ju, "", e));
    }, A5(fR, F4(function(n, r, t, e) {
        return d(n, m(r, t, e));
    }), A2(du, "kind", Da), Bi(A2(du, "url", Da)), Bi(A2(du, "format", aR)), Bi(A2(du, "target", cR)))), lR = function(n) {
        switch(n){
            case 0:
                return "Json";
            case 1:
                return "SaltoMam";
            case 2:
                return "SaltoContent";
            default:
                return "ADN";
        }
    }, dR = function(n) {
        return ga(lR(n));
    }, mR = function(n) {
        switch(n){
            case 0:
                return "Manager";
            case 1:
                return "Uploader";
            default:
                return "EventSpecified";
        }
    }, bR = function(n) {
        return ga(mR(n));
    }, pR = Fi(A4(rc, "params", function(n) {
        return n.oX;
    }, A2(Va, function(n) {
        if (n.$) {
            var r = n.a;
            return wa(k([
                d("kind", ga("Email")),
                d("target", bR(r))
            ]));
        }
        var t = n.a, e = n.b;
        return wa(k([
            d("kind", ga("ApiCall")),
            d("url", ga(t)),
            d("format", dR(e))
        ]));
    }, sR), A4(rc, "activated", function(n) {
        return n.ip;
    }, ri, A4(rc, "event", function(n) {
        return n.lq;
    }, tR, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(GH))))))), vR = ic(pR), $R = function(n) {
        return {
            $: 8,
            a: n
        };
    }, wR = dl($R({
        $: 0
    })), gR = mc(A2(Wi, vR, Ai(wR))), hR = A2(Xa, JH, Gb(d(gR, YH))), kR = d(XH, hR), CR = F2(function(n, r) {
        return p(r, {
            lo: ht(n.nP),
            rz: kt
        });
    }), TR = function(n) {
        return {
            $: 12,
            a: n
        };
    }, PR = F2(function(n, r) {
        return r.$ ? Ct(r.a) : n(r.a);
    }), SR = F5(function(n, r, t, e, u) {
        return {
            ip: t,
            lq: r,
            lT: u,
            oM: n,
            sr: e
        };
    }), AR = Fi(A4(rc, "format", function(n) {
        return n.lT;
    }, A2(Ml, lR, oR), A4(rc, "url", function(n) {
        return n.sr;
    }, Oa, A4(rc, "activated", function(n) {
        return n.ip;
    }, ri, A4(rc, "event", function(n) {
        return n.lq;
    }, tR, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, Mi(SR))))))), yR = F4(function(n, r, t, e) {
        return {
            ip: t,
            lq: r,
            oM: n,
            rP: e
        };
    }), NR = Fi(A4(rc, "target", function(n) {
        return n.rP;
    }, A2(Ml, mR, iR), A4(rc, "activated", function(n) {
        return n.ip;
    }, ri, A4(rc, "event", function(n) {
        return n.lq;
    }, tR, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, Mi(yR)))))), LR = dl($R({
        $: 1
    })), jR = dl($R({
        $: 3
    })), FR = function(n) {
        var r, t;
        return A2(Xa, TR, (t = nR((r = n).lq.sw), A2(BT, function(n) {
            return mc(A2(nw, pR, n));
        }, xy(A2(ha, function(n) {
            return Dy(A2(ka, n, s$));
        }, A2(PR, function(n) {
            return function(n) {
                switch(r.c$.sw){
                    case "api":
                        return A2(X$, function(t) {
                            return A3(ow, AR, {
                                ip: r.ip.sw,
                                lq: n,
                                lT: t,
                                oM: r.oM.sw,
                                sr: r.sr.sw
                            }, rw(LR));
                        }, oR(r.lT.sw));
                    case "email":
                        return A2(X$, function(t) {
                            return A3(ow, NR, {
                                ip: r.ip.sw,
                                lq: n,
                                oM: r.oM.sw,
                                rP: t
                            }, rw(jR));
                        }, iR(r.rP.sw));
                    default:
                        return Ct("Can't parse kind from form");
                }
            }(n);
        }, t))))));
    }, MR = function(n) {
        return {
            $: 15,
            a: n
        };
    }, IR = function(n) {
        return dl($R(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n)));
    }, DR = function(n) {
        return dl($R(function(n) {
            return {
                $: 4,
                a: n
            };
        }(n)));
    }, BR = function(n) {
        return {
            $: 13,
            a: n
        };
    }, xR = F2(function(n, r) {
        var t = nR(r.lq.sw);
        return A2(BT, function(n) {
            return mc(A2(Wi, pR, n));
        }, xy(A2(ha, function(n) {
            return Dy(A2(ka, n, s$));
        }, A2(PR, function(t) {
            return function(t) {
                return n.oX.$ ? A2(X$, function(e) {
                    return A3(ow, NR, {
                        ip: r.ip.sw,
                        lq: t,
                        oM: r.oM.sw,
                        rP: e
                    }, dw(DR(n.mo)));
                }, iR(r.rP.sw)) : A2(X$, function(e) {
                    return A3(ow, AR, {
                        ip: r.ip.sw,
                        lq: t,
                        lT: e,
                        oM: r.oM.sw,
                        sr: r.sr.sw
                    }, dw(IR(n.mo)));
                }, oR(r.lT.sw));
            }(t);
        }, t))));
    }), qR = F2(function(n, r) {
        return A2(Xa, BR, A2(xR, n, r));
    }), VR = function(n) {
        var r = function(n) {
            return A2(Pi, Lu(n), ju(""));
        };
        return {
            ip: ti(function(r) {
                return p(r, {
                    m7: "Activ\xe9",
                    sw: A2(ju, !0, A2(Lu, function(n) {
                        return n.ip;
                    }, n))
                });
            }),
            lq: za(function(t) {
                return p(t, {
                    m7: "\xc9v\xe9nement",
                    sw: A2(r, function(n) {
                        return rR(n.lq);
                    }, n)
                });
            }),
            lT: za(function(t) {
                return p(t, {
                    m7: "Format",
                    sw: A2(r, function(n) {
                        var r = n.oX;
                        return r.$ ? "" : lR(r.b);
                    }, n)
                });
            }),
            c$: za(function(t) {
                return p(t, {
                    m7: "Type",
                    sw: A2(r, function(n) {
                        return n.oX.$ ? "email" : "api";
                    }, n)
                });
            }),
            oM: za(function(t) {
                return p(t, {
                    m7: "Organization",
                    sw: A2(r, function(n) {
                        return n.oM;
                    }, n)
                });
            }),
            oS: n,
            rP: za(function(t) {
                return p(t, {
                    m7: "Cible",
                    sw: A2(r, function(n) {
                        var r = n.oX;
                        return r.$ ? mR(r.a) : "";
                    }, n)
                });
            }),
            sr: za(function(t) {
                return p(t, {
                    m7: "Url",
                    sw: A2(r, function(n) {
                        var r = n.oX;
                        return r.$ ? "" : r.a;
                    }, n)
                });
            })
        };
    }, OR = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, w, p(r, {
                    kP: ht(VR(ht(n.a)))
                }));
            case 1:
                return A2(pc, w, p(r, {
                    kP: ht(VR(kt))
                }));
            case 3:
                return A2(pc, w, p(r, {
                    kP: kt,
                    lo: kt,
                    rz: kt
                }));
            case 4:
                var t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        oM: A2(ww, t, n.oM)
                    });
                }, r.kP);
                return A2(pc, w, p(r, {
                    kP: e
                }));
            case 5:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lq: A2(ww, t, n.lq)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 6:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        ip: A2(vw, t, n.ip)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 7:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        c$: A2(ww, t, n.c$)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 8:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        sr: A2(ww, t, n.sr)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 9:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        lT: A2(ww, t, n.lT)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 10:
                return t = n.a, e = A2(Lu, function(n) {
                    return p(n, {
                        rP: A2(ww, t, n.rP)
                    });
                }, r.kP), A2(pc, w, p(r, {
                    kP: e
                }));
            case 11:
                var u = r.kP;
                return A2(pc, k(1 === u.$ ? [
                    n$
                ] : 1 === (c = (e = u.a).oS).$ ? [
                    FR(e)
                ] : [
                    A2(qR, c.a, e)
                ]), r);
            case 14:
                return A2(pc, k([
                    (i = n.a, A2(Xa, MR, function(n) {
                        var r = n.oX.$ ? DR : IR;
                        return A2(Yb, Dl(n), mc(sw(fw(r(n.mo)))));
                    }(i)))
                ]), r);
            case 12:
                return (o = n.a).$ ? A2(pc, w, A2(CR, o.a, r)) : A2(pc, k([
                    hR
                ]), p(r, {
                    lo: kt,
                    rz: ht("webhook created")
                }));
            case 13:
                return (o = n.a).$ ? A2(pc, w, A2(CR, o.a, r)) : A2(pc, k([
                    hR
                ]), p(r, {
                    lo: kt,
                    rz: ht("webhook updated")
                }));
            case 15:
                return (o = n.a).$ ? A2(pc, w, A2(CR, o.a, r)) : A2(pc, k([
                    hR
                ]), r);
            case 0:
                var o;
                if ((o = n.a).$) return A2(pc, w, A2(CR, o.a, r));
                var a = o.a;
                return A2(pc, w, p(r, {
                    oQ: a.b,
                    dR: a.a
                }));
            default:
                return A2(pc, w, p(r, {
                    rN: n.a
                }));
        }
        var i, c;
    }), zR = {
        $: 1
    }, ER = function(n) {
        return {
            $: 16,
            a: n
        };
    }, HR = F2(function(n, r) {
        return A2(zw, w, k([
            n(r)
        ]));
    }), RR = F2(function(n, r) {
        return Gw({
            n6: n,
            ds: rg,
            dN: HR(r)
        });
    }), WR = F2(function(n, r) {
        var t;
        return cg({
            n6: n,
            ds: Ew((t = r, A2(bu, Ua, t))),
            dN: r
        });
    }), UR = k([
        Ow("Table")
    ]), QR = function() {
        return k([
            Ow("TableTr")
        ]);
    }, _R = function(n) {
        var r = n.oX;
        return r.$ ? "" : lR(r.b);
    }, ZR = F2(function(n, r) {
        return A2(ju, "", A2(Lu, function(n) {
            return n.n6;
        }, Eo(A2(Mu, function(n) {
            return a(n.mo, r.oM);
        }, n))));
    }), KR = function(n) {
        var r = n.oX;
        return r.$ ? mR(r.a) : "";
    }, XR = function(n) {
        return n.oX.$ ? "Email" : "ApiCall";
    }, JR = function(n) {
        var r = n.oX;
        return r.$ ? "" : r.a;
    }, YR = {
        $: 3
    }, GR = function(n) {
        return {
            $: 6,
            a: n
        };
    }, nW = function(n) {
        return {
            $: 5,
            a: n
        };
    }, rW = function(n) {
        return {
            $: 9,
            a: n
        };
    }, tW = function(n) {
        return {
            $: 7,
            a: n
        };
    }, eW = function(n) {
        return {
            $: 4,
            a: n
        };
    }, uW = function(n) {
        return {
            $: 10,
            a: n
        };
    }, oW = function(n) {
        return {
            $: 8,
            a: n
        };
    }, aW = {
        $: 11
    }, iW = function(n) {
        return 1 !== n.oS.$;
    }, cW = function(n) {
        return A2(Ck, function(r) {
            var t = k([
                d("", ""),
                d(rR(0), rR(0)),
                d(rR(1), rR(1)),
                d(rR(2), rR(2)),
                d(rR(3), rR(3)),
                d(rR(4), rR(4)),
                d(rR(5), rR(5)),
                d(rR(6), rR(6)),
                d(rR(7), rR(7)),
                d(rR(8), rR(8)),
                d(rR(9), rR(9)),
                d(rR(10), rR(10)),
                d(rR(11), rR(11)),
                d(rR(12), rR(12))
            ]), e = A2(mt, d("", ""), A2(Ye, function(n) {
                return d(n.mo, n.n6);
            }, n.oQ)), u = k([
                d("", ""),
                d("api", "Call Api"),
                d("email", "Email")
            ]), o = r.c$, a = k([
                d("", ""),
                d(mR(0), mR(0)),
                d(mR(1), mR(1)),
                d(mR(2), mR(2))
            ]), i = k([
                d("", ""),
                d(lR(0), lR(0)),
                d(lR(1), lR(1)),
                d(lR(2), lR(2)),
                d(lR(3), lR(3))
            ]), c = function() {
                switch(r.c$.sw){
                    case "api":
                        return k([
                            A2(mh, oW, Mk(r.sr)),
                            A2(mh, rW, A2(Ek, r.lT, i))
                        ]);
                    case "email":
                        return k([
                            A2(mh, uW, A2(Ek, r.rP, a))
                        ]);
                    default:
                        return w;
                }
            }(), f = iW(r) ? d("Save", "Edit Webhook") : d("Create", "New Webhook");
            return A4(_k, f.b, d(f.a, aW), d("Cancel", YR), $(k([
                A2(mh, eW, A2(CT, e, Ek(r.oM))),
                A2(mh, nW, A2(Ek, r.lq, t)),
                A2(mh, GR, Fk(r.ip)),
                A2(mh, tW, A2(Ek, p(o, {
                    kS: iW(r)
                }), u))
            ]), c));
        }, n.kP);
    }, fW = F2(function(n, r) {
        var t;
        return A3(gC, "Organizations", ht(A2(Pg, "New\u2026", zR)), A2(ye, w, k([
            cW(r),
            A3(ck, (t = r.oQ, ug({
                j_: k([
                    A2(RR, "Edit", function(n) {
                        return A2(Pg, "Edit", function(n) {
                            return {
                                $: 2,
                                a: n
                            };
                        }(n));
                    }),
                    A2(WR, "Organization", ZR(t)),
                    A2(WR, "Event", A2(bu, rR, function(n) {
                        return n.lq;
                    })),
                    A2(RR, "Icon", function(n) {
                        return n.ip ? Yw : Jw;
                    }),
                    A2(WR, "Type", XR),
                    A2(WR, "Url", JR),
                    A2(WR, "Format", _R),
                    A2(WR, "Target", KR),
                    A2(RR, "Delete", function(n) {
                        return A2(Bw, kg, function(n) {
                            return {
                                $: 14,
                                a: n
                            };
                        }(n));
                    })
                ]),
                kv: p(hg, {
                    pS: QR,
                    rE: UR,
                    rQ: k([
                        Ow("TableTd")
                    ])
                }),
                rZ: function(n) {
                    return n.mo;
                },
                r_: ER
            })), r.rN, r.dR)
        ])));
    }), sW = {
        l: function(n) {
            return n.dR;
        },
        m: kR,
        o: F2(function(n, r) {
            return p(n, {
                dR: r
            });
        }),
        p: function(n) {
            return {
                $: 10,
                a: n
            };
        },
        q: OR,
        r: fW
    }, lW = F3(function(n, r, t) {
        var e = A4(iq, hc, t.oW, n, r), u = A4(cq, hc, t.oW, n, r), o = function() {
            switch(r.$){
                case 0:
                    return u(Fj);
                case 1:
                    return u(KB);
                case 2:
                    return u(kI);
                case 3:
                    return u(KH);
                case 4:
                    return u(kE);
                case 5:
                    return u(hO);
                case 6:
                    return u(kC);
                case 7:
                    return u(ST);
                case 8:
                    return u(aq);
                case 9:
                    return u(sW);
                case 10:
                    return u(EI);
                case 11:
                    return u(pj);
                case 12:
                    return u(rO);
                case 13:
                    return u($V);
                case 14:
                    return A2(e, lF, (n = r.a, bc(k([
                        A2(ju, A2(Yv, Dl(dF), iP(0)), A2(Lu, function(n) {
                            return wF(n);
                        }, n.oM)),
                        gF(n)
                    ]))));
                case 15:
                    return u(AM);
                case 16:
                    return u(GS);
                case 17:
                    return u(Dx);
                default:
                    return A2(e, UP, fP(r.a));
            }
            var n;
        }(), a = o.a;
        return A2(pc, k([
            A2(cp, Me, o.b)
        ]), p(t, {
            oW: a
        }));
    }), dW = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mW = F2(function(n, r) {
        return {
            ei: r,
            rW: n
        };
    }), bW = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pW = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vW = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $W = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wW = function(n) {
        return {
            $: 4,
            a: n
        };
    }, gW = function(n) {
        return {
            $: 5,
            a: n
        };
    }, hW = function(n) {
        return {
            $: 7,
            a: n
        };
    }, kW = function(n) {
        return {
            $: 6,
            a: n
        };
    }, CW = function(n) {
        return {
            $: 8,
            a: n
        };
    }, TW = F3(function(n, r, t) {
        return {
            m7: t,
            hn: r,
            cj: n
        };
    }), PW = F3(function(n, r, t) {
        return {
            e$: r,
            hm: t,
            hs: n
        };
    }), SW = Le(ce), AW = {
        $: 0
    }, yW = function(n) {
        return {
            $: 2,
            a: n
        };
    }, NW = {
        $: 1
    }, LW = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), jW = function(n) {
        return {
            $: 1,
            a: n
        };
    }, FW = F5(function(n, r, t, e, u) {
        return {
            mo: n,
            fT: u,
            hd: t,
            rO: e,
            h7: r
        };
    }), MW = function(n) {
        return {
            $: 5,
            c: n
        };
    }, IW = F3(function(n, r, t) {
        return A2(Te, function(e) {
            var u = A2(ba, n, e);
            if (u.$) return je(t);
            var o = u.a, a = A2(ba, Di(k([
                r,
                MW(t)
            ])), o);
            return a.$ ? qc(Xt(a.a)) : je(a.a);
        }, Ma);
    }), DW = F4(function(n, r, t, e) {
        return A2(SW, A3(IW, A2(du, n, Ma), r, t), e);
    }), BW = F3(function(n, r, t) {
        return A2(SW, A2(du, n, r), t);
    }), xW = A3(BW, "type", Da, A3(BW, "tags", oc(Da), A3(BW, "slug", Da, A4(DW, "uid", Bi(Da), kt, A3(BW, "id", Da, je(FW)))))), qW = F3(function(n, r, t) {
        return A2(SW, A2(Jg, n, r), t);
    }), VW = A2(Te, function(n) {
        switch(n){
            case "Document":
                return A3(qW, k([
                    "isBroken"
                ]), Pe, A3(qW, w, xW, je(LW)));
            case "Web":
                return A3(qW, k([
                    "url"
                ]), Da, je(jW));
            default:
                return qc("Unknown link type: " + n);
        }
    }, A2(du, "link_type", Da)), OW = A2(SW, A2(Te, function(n) {
        switch(n){
            case "em":
                return je(AW);
            case "strong":
                return je(NW);
            case "hyperlink":
                return A2(Ne, yW, A2(du, "data", VW));
            default:
                return qc("Unknown span type: " + n);
        }
    }, A2(du, "type", Da)), A3(BW, "end", tc, A3(BW, "start", tc, je(PW)))), zW = A4(DW, "label", Bi(Da), kt, A3(BW, "spans", oc(OW), A3(BW, "text", Da, je(TW)))), EW = F4(function(n, r, t, e) {
        return {
            iK: n,
            kd: r,
            kQ: e,
            sr: t
        };
    }), HW = function(n) {
        return Di(k([
            MW(kt),
            A2(Ne, ht, n)
        ]));
    }, RW = A3(BW, "dimensions", A3(BW, "height", tc, A3(BW, "width", tc, je(F2(function(n, r) {
        return {
            fm: r,
            ig: n
        };
    })))), A3(BW, "url", Da, A3(BW, "copyright", HW(Da), A3(BW, "alt", HW(Da), je(EW))))), WW = A2(Ne, Me, oc(A2(Te, function(n) {
        switch(n){
            case "heading1":
                return A2(Ne, bW, zW);
            case "heading2":
                return A2(Ne, pW, zW);
            case "heading3":
                return A2(Ne, vW, zW);
            case "heading4":
                return A2(Ne, $W, zW);
            case "heading5":
                return A2(Ne, wW, zW);
            case "heading6":
                return A2(Ne, gW, zW);
            case "paragraph":
                return A2(Ne, kW, zW);
            case "list-item":
                return A2(Ne, hW, zW);
            case "image":
                return A2(Ne, CW, RW);
            default:
                return qc("Unknown structured field type: " + n);
        }
    }, A2(du, "type", Da)))), UW = A2(du, "results", A2(Vc, 0, A2(du, "data", A3(Le, mW, A2(du, "title", A2(Vc, 0, A2(du, "text", Da))), A2(du, "body", WW))))), QW = F5(function(n, r, t, e, u) {
        return "" === n ? n$ : mf({
            cN: A2(xc, u, e),
            sr: bf + "/documents/search?ref=" + n + "&q=%5B%5Bat%28my." + r + ".uid%2C%20%22" + t + "%22%29%5D%5D&lang=*"
        });
    }), _W = F5(function(n, r, t, e, u) {
        if ("" === n) return n$;
        var o = xa({
            bN: "en-GB",
            bT: "fr-FR"
        });
        return mf({
            cN: A2(xc, u, e),
            sr: bf + "/documents/search?ref=" + n + "&q=%5B%5Bat%28my." + r + ".uid%2C%20%22" + t + "%22%29%5D%5D&lang=" + o
        });
    }), ZW = F2(function(n, r) {
        return "table" === r ? A5(_W, n, "help", "table", UW, dW) : A5(QW, n, "help", r, UW, dW);
    }), KW = F2(function(n, r) {
        return A2(pc, k([
            A2(ZW, r.f_, n)
        ]), p(r, {
            b7: ht(n)
        }));
    }), XW = F3(function(n, r, t) {
        switch(r.$){
            case 1:
                var e = r.b, u = r.c;
                if (a(ht(c = r.a), Pv(t)) && !n) {
                    var o = p(i = t.g9, {
                        iZ: e,
                        oX: u
                    });
                    return Tv(A2(pc, w, p(t, {
                        em: A2(e$, c, t.em),
                        g9: o
                    })));
                }
                var i = sl(t.ak);
                return Tv(A2(pc, k([
                    A2(cp, gv(c), Gv)
                ]), p(t, {
                    em: A2(e$, c, t.em),
                    g9: p(i, {
                        iZ: e,
                        mo: c,
                        oX: u
                    })
                })));
            case 2:
                var c;
                if (e = r.b, a(ht(c = r.a), Pv(t)) && !n) {
                    var f = p(t.ol, {
                        iZ: e
                    });
                    return A2(pc, w, p(t, {
                        em: A2(e$, c, t.em),
                        ol: f
                    }));
                }
                var s = Kv(c), l = Ff;
                return A2(pc, k([
                    A2(cp, wv, s)
                ]), p(t, {
                    em: A2(e$, c, t.em),
                    ol: p(l, {
                        iZ: e,
                        mo: c
                    })
                }));
            case 4:
                var m = t.ak, b = A3(lW, t.ak, r.a, t.iz), v = b.a;
                return A2(pc, k([
                    A2(cp, Pa, b.b)
                ]), p(t, {
                    iz: v,
                    ak: p(m, {
                        d2: !1
                    })
                }));
            case 5:
                var $ = A2(KW, r.a, t.l7);
                return v = $.a, A2(pc, k([
                    A2(cp, Aa, $.b)
                ]), p(t, {
                    l7: v
                }));
            case 6:
                return d(v = p(t, {
                    ak: p(m = t.ak, {
                        d2: !0
                    })
                }), n$);
            case 0:
                return d(v = p(t, {
                    ak: p(m = t.ak, {
                        d2: !1
                    })
                }), n$);
            default:
                return A2(pc, w, t);
        }
    }), JW = F2(function(n, r) {
        var t = $v(n.sr), e = A3(Cc, n, r, t), u = Ab.a, o = Ab.b, a = A2(gc, r, n.sz), i = a.a, c = a.b, f = pf.a, s = pf.b, l = kc.b, d = {
            iz: kc.a,
            em: Ac(e),
            ak: e,
            k0: Mf,
            lo: kt,
            l7: f,
            mW: !0,
            ol: Ff,
            b9: Qa(e.st),
            qb: yc,
            dp: i,
            g9: sl(e),
            rV: u,
            sk: jc(e.st)
        }, m = A3(XW, !0, t, d), b = m.a;
        return A2(pc, k([
            A2(cp, Na, m.b),
            A2(cp, A2(bu, Na, La), c),
            A2(cp, A2(bu, Na, ja), o),
            A2(cp, A2(bu, Na, Pa), l),
            A2(cp, A2(bu, Na, Aa), s),
            A2(cp, A2(bu, Na, Sa), ip)
        ]), ya(b));
    }), YW = function(n) {
        return {
            $: 1,
            a: n
        };
    }, GW = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nU = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rU = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tU = {
        $: 0
    }, eU = {
        la: za(function(n) {
            return p(n, {
                m7: "Email"
            });
        }),
        nP: tU
    }, uU = xa({
        bN: "Confirm your password",
        bT: "Confirmez votre mot de passe"
    }), oU = xa({
        bN: "Last & First Name",
        bT: "Nom & Pr\xe9nom"
    }), aU = xa({
        bN: "Create your password",
        bT: "Cr\xe9ez votre mot de passe"
    }), iU = {
        $: 0
    }, cU = xa({
        bN: "Email",
        bT: "Email"
    }), fU = xa({
        bN: "Password",
        bT: "Mot de passe"
    }), sU = function(n) {
        var r = n.lZ;
        return {
            la: za(function(n) {
                return p(n, {
                    m7: cU
                });
            }),
            lZ: r,
            nP: iU,
            o_: za(function(n) {
                return p(n, {
                    kX: "inputLoginPassword",
                    m7: fU
                });
            }),
            q0: 0,
            q1: kt
        };
    }, lU = {
        $: 0
    }, dU = xa({
        bN: "Password confirmation",
        bT: "Confirmation du mot de passe"
    }), mU = xa({
        bN: "Password",
        bT: "Mot de passe"
    }), bU = function(n) {
        var r = $v(n), t = function() {
            if (3 !== r.$) return nU(sU({
                lZ: kt
            }));
            switch(r.a.$){
                case 1:
                    return YW(eU);
                case 2:
                    return rU((e = (t = r.a.a).la, u = t.r0, {
                        j5: za(function(n) {
                            return p(n, {
                                m7: dU
                            });
                        }),
                        la: e,
                        nP: lU,
                        o_: za(function(n) {
                            return p(n, {
                                m7: mU
                            });
                        }),
                        o$: kt,
                        r0: u
                    }));
                case 3:
                    return GW((n = r.a.a, {
                        j5: za(function(n) {
                            return p(n, {
                                m7: uU
                            });
                        }),
                        la: n.la,
                        lo: kt,
                        n6: za(function(n) {
                            return p(n, {
                                m7: oU
                            });
                        }),
                        o_: za(function(n) {
                            return p(n, {
                                m7: aU
                            });
                        }),
                        o$: kt,
                        pB: n.pB,
                        r0: n.r0
                    }));
                default:
                    return nU(sU(r.a.a));
            }
            var n, t, e, u;
        }();
        return d(r, t);
    }, pU = function(n) {
        return {
            $: 4,
            a: n
        };
    }, vU = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $U = Wn, wU = Jn("newurl", Da), gU = function(n) {
        return {
            $: 15,
            a: n
        };
    }, hU = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kU = function(n) {
        return {
            $: 13,
            a: n
        };
    }, CU = function(n) {
        return {
            $: 3,
            a: n
        };
    }, TU = function(n) {
        return {
            $: 9,
            a: n
        };
    }, PU = Rn, SU = PU(w), AU = Jn("onKeypressNoInput", tc), yU = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), NU = F2(function(n, r) {
        return {
            gv: r,
            hC: n
        };
    }), LU = Ze(A2(NU, w, Su)), jU = function(n) {
        return d($(n.a ? "w_" : "d_", n.b), n);
    }, FU = F6(function(n, r, t, e, u, o) {
        var a = A3(H$, F3(function(e, u, o) {
            n: for(;;){
                var a = o.a, i = o.b;
                if (a.b) {
                    var c = a.a, f = c.a, l = c.b, m = a.b;
                    if (0 > s(f, e)) {
                        o = d(m, A3(n, f, l, i));
                        continue n;
                    }
                    return s(f, e) > 0 ? d(a, A3(t, e, u, i)) : d(m, A4(r, f, l, u, i));
                }
                return d(a, A3(t, e, u, i));
            }
        }), d(pt(e), o), u), i = a.a, c = a.b;
        return A3(xt, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), c, i);
    }), MU = F2(function(n, r) {
        return {
            lq: r,
            fL: n
        };
    }), IU = F3(function(n, r, t) {
        return A2(nu, function(n) {
            return d(r, n);
        }, A3(Jr, t.a ? Xr : Kr, t.b, function(t) {
            return A2(li, n, A2(MU, r, t));
        }));
    }), DU = F2(function(n, r) {
        return A3(H$, Cu, r, n);
    }), BU = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return m(e.a, e.b, A2(mt, A3(IU, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return m(A2(mt, r, t.a), e, u);
        }), o = F4(function(n, r, t, e) {
            var u = e.c;
            return m(e.a, A3(Cu, n, r, e.b), u);
        }), a = A2(Ye, jU, r), i = A6(FU, u, o, e, t.gv, Ji(a), m(w, Su, w)), c = i.b, f = i.c;
        return A2(Ge, function(n) {
            return Ze(A2(NU, a, A2(DU, c, Ji(n))));
        }, A2(Ge, function() {
            return tu(f);
        }, tu(A2(Ye, Wc, i.a))));
    }), xU = F3(function(n, r, t) {
        var e = r.fL, u = r.lq, o = A2(Kc, function(n) {
            var r = n.b.c;
            return a(n.a, e) ? A2(Yr, r, u) : kt;
        }, t.hC);
        return A2(Ge, function() {
            return Ze(t);
        }, tu(A2(Ye, eu(n), o)));
    }), qU = F2(function(n, r) {
        return A3(yU, r.a, r.b, A2(Ne, n, r.c));
    });
    qn["Browser.Events"] = Vn(LU, BU, xU, 0, qU);
    var VU = Hn("Browser.Events"), OU = F3(function(n, r, t) {
        return VU(A3(yU, n, r, t));
    }), zU = F2(function(n, r) {
        return n(r ? 1 : 0);
    }), EU = {
        $: 5
    }, HU = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), RU = F2(function(n, r) {
        return {
            gC: r,
            hN: n
        };
    }), WU = Ze(A2(RU, Su, Su)), UU = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(di, t, r);
        return A3(Cu, t, 1 === u.$ ? k([
            e
        ]) : A2(mt, e, u.a), r);
    }), QU = it, _U = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, o = Uc(A2(QU, e, A2(li, n, e)));
            return A2(Ge, function(r) {
                return A3(_U, n, u, A3(Cu, e, r, t));
            }, o);
        }
        return Ze(t);
    }), ZU = F3(function(n, r, t) {
        var e = t.gC, u = F3(function(n, r, t) {
            var e = t.c;
            return m(t.a, t.b, A2(Ge, function() {
                return e;
            }, Wc(r)));
        }), o = A3(xt, UU, Su, r), a = A6(FU, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return m(A2(mt, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return m(e.a, A3(Cu, n, t, e.b), u);
        }), u, o, e, m(w, Su, Ze(0))), i = a.a, c = a.b;
        return A2(Ge, function(n) {
            return Ze(A2(RU, o, n));
        }, A2(Ge, function() {
            return A3(_U, n, i, c);
        }, a.c));
    }), KU = F3(function(n, r, t) {
        var e = A2(di, r, t.hN);
        if (1 === e.$) return Ze(t);
        var u = e.a, o = function(r) {
            return tu(A2(Ye, function(t) {
                return A2(eu, n, t(r));
            }, u));
        };
        return A2(Ge, function() {
            return Ze(t);
        }, A2(Ge, o, Jv));
    }), XU = F2(function(n, r) {
        return A2(HU, r.a, A2(bu, n, r.b));
    });
    qn.Time = Vn(WU, ZU, KU, 0, XU);
    var JU, YU, GU, nQ, rQ, tQ, eQ, uQ, oQ, aQ, iQ = Hn("Time"), cQ = F2(function(n, r) {
        return iQ(A2(HU, n, r));
    }), fQ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sQ = function(n) {
        return 1 === n.dF.$ ? SU : A2(cQ, 1e3, fQ);
    }, lQ = function(n) {
        return PU(k([
            A2(cQ, 5e3, Dl(EU)),
            A2($U, xz, sQ(n.iD))
        ]));
    }, dQ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mQ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bQ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, pQ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, vQ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $Q = function(n) {
        return {
            $: 5,
            a: n
        };
    }, wQ = function(n) {
        return {
            $: 10,
            a: n
        };
    }, gQ = {
        $: 11
    }, hQ = function(n) {
        return {
            $: 8,
            a: n
        };
    }, kQ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, CQ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, TQ = function(n) {
        return {
            $: 9,
            a: n
        };
    }, PQ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, SQ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, AQ = A2(BW, "fileId", Da), yQ = AQ(je(function(n) {
        return {
            z: n
        };
    })), NQ = F4(function(n, r, t, e) {
        return {
            j2: e,
            z: n,
            gY: t,
            hx: r
        };
    }), LQ = F7(function(n, r, t, e, u, o, a) {
        return {
            lG: a,
            nl: t,
            pz: r,
            pC: u,
            aV: o,
            q_: n,
            r2: e
        };
    }), jQ = A3(BW, "fileSize", tc, A3(BW, "secondsLeft", HW(tc), A3(BW, "remainingSize", tc, A3(BW, "totalUploaded", tc, A3(BW, "loaded", tc, A3(BW, "readableSpeed", Da, A3(BW, "speed", sA, je(LQ)))))))), FQ = A3(BW, "completedAt", xd, A3(BW, "s3Key", Da, A3(BW, "stats", jQ, AQ(je(NQ))))), MQ = F2(function(n, r) {
        return {
            lo: r,
            z: n
        };
    }), IQ = A3(BW, "error", Da, AQ(je(MQ))), DQ = F2(function(n, r) {
        return {
            z: n,
            gY: r
        };
    }), BQ = A3(BW, "s3Key", Da, AQ(je(DQ))), xQ = F2(function(n, r) {
        return {
            d5: r,
            z: n
        };
    }), qQ = A3(BW, "at", xd, AQ(je(xQ))), VQ = AQ(je(function(n) {
        return {
            z: n
        };
    })), OQ = F4(function(n, r, t, e) {
        return {
            d5: e,
            z: n,
            pk: t,
            hx: r
        };
    }), zQ = A3(BW, "at", xd, A3(BW, "progress", sA, A3(BW, "stats", jQ, AQ(je(OQ))))), EQ = AQ(je(function(n) {
        return {
            z: n
        };
    })), HQ = AQ(je(function(n) {
        return {
            z: n
        };
    })), RQ = A3(BW, "error", HW(Da), A3(BW, "completedAt", HW(xd), A3(BW, "secondsLeft", HW(tc), A3(BW, "blob", Ma, A3(BW, "mimeType", HW(Da), A3(BW, "size", tc, A3(BW, "pausedAt", HW(xd), A3(BW, "pausing", Pe, A3(BW, "progressedAt", xd, A3(BW, "progress", sA, A3(BW, "name", Da, A3(BW, "s3Id", HW(Da), A3(BW, "fileId", Da, A3(BW, "id", Da, je(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return {
                                                                ji: s,
                                                                j2: d,
                                                                lo: m,
                                                                z: r,
                                                                mo: n,
                                                                nT: f,
                                                                n6: e,
                                                                df: i,
                                                                dg: a,
                                                                pk: u,
                                                                gJ: o,
                                                                pZ: t,
                                                                aV: l,
                                                                qP: c
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), WQ = F2(function(n, r) {
        return {
            z: n,
            p_: r
        };
    }), UQ = A3(BW, "s3UploadId", Da, AQ(je(WQ))), QQ = Jn("uploadToElm", A2(Te, function(n) {
        return A2(Te, function(r) {
            return je({
                lq: r,
                n6: n
            });
        }, A2(du, "event", Ma));
    }, A2(du, "name", Da))), _Q = A2($U, function(n) {
        var r = n.n6, t = n.lq, e = function() {
            switch(r){
                case "Created":
                    return A2(Ne, vQ, RQ);
                case "Started":
                    return A2(Ne, PQ, HQ);
                case "Progress":
                    return A2(Ne, CQ, zQ);
                case "UploadInitiated":
                    return A2(Ne, SQ, UQ);
                case "Completed":
                    return A2(Ne, pQ, FQ);
                case "Error":
                    return A2(Ne, $Q, IQ);
                case "Cancelled":
                    return A2(Ne, bQ, yQ);
                case "Pausing":
                    return A2(Ne, kQ, VQ);
                case "Paused":
                    return A2(Ne, hQ, qQ);
                case "Resumed":
                    return A2(Ne, TQ, EQ);
                case "NameChanged":
                    return A2(Ne, wQ, BQ);
                default:
                    return qc("not an Event");
            }
        }(), u = A2(ba, e, t);
        return u.$ ? gQ : u.a;
    }, QQ(Me)), ZQ = {
        $: 6
    }, KQ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, XQ = A2(OU, 0, "mousemove"), JQ = A2(OU, 0, "mouseup"), YQ = F2(function(n, r) {
        return {
            sO: n,
            sT: r
        };
    }), GQ = A3(Le, YQ, A2(du, "pageX", tc), A2(du, "pageY", tc)), n_ = function(n) {
        return 1 === n.k_.$ ? SU : PU(k([
            XQ(A2(Ne, KQ, GQ)),
            JQ(je(ZQ))
        ]));
    }, r_ = function() {
        return SU;
    }, t_ = function(n) {
        return {
            $: 27,
            a: n
        };
    }, e_ = function(n) {
        return {
            $: 38,
            a: n
        };
    }, u_ = function(n) {
        return {
            $: 11,
            a: n
        };
    }, o_ = function(n) {
        return {
            $: 39,
            a: n
        };
    }, a_ = function(n) {
        return {
            $: 11,
            a: n
        };
    }, i_ = Jn("jsToElm", Ma), c_ = function(n) {
        return {
            $: 12,
            a: n
        };
    }, f_ = function(n) {
        return {
            $: 13,
            a: n
        };
    }, s_ = Jn("content", oc(A2(Te, function(n) {
        return A2(Te, function(r) {
            return A2(Te, function(t) {
                return A2(Te, function(e) {
                    return je({
                        fv: e,
                        nd: t,
                        r9: r,
                        sz: n
                    });
                }, A2(du, "index", tc));
            }, A2(du, "layout", Da));
        }, A2(du, "typeVersion", Da));
    }, A2(du, "version", Di(k([
        MW(kt),
        A2(Ne, ht, Da)
    ])))))), l_ = Jn("lastAudioQualification", A2(Te, function(n) {
        return A2(Te, function(r) {
            return A2(Te, function(t) {
                return je({
                    cz: t,
                    z: r,
                    bl: n
                });
            }, A2(du, "channels", oc(tc)));
        }, A2(du, "fileId", Da));
    }, A2(du, "result", oc(A2(Te, function(n) {
        return A2(Te, function(r) {
            return A2(Te, function(t) {
                return A2(Te, function(e) {
                    return je({
                        fv: e,
                        nd: t,
                        r9: r,
                        sz: n
                    });
                }, A2(du, "index", tc));
            }, A2(du, "layout", Da));
        }, A2(du, "typeVersion", Da));
    }, A2(du, "version", Di(k([
        MW(kt),
        A2(Ne, ht, Da)
    ])))))))), d_ = function(n) {
        return {
            $: 28,
            a: n
        };
    }, m_ = Jn("sendPlayerName", Da), b_ = Jn("updateAudioStreams", oc(A2(Te, function(n) {
        return A2(Te, function(r) {
            return je(d(n, r));
        }, A2(Vc, 1, Di(k([
            MW(kt),
            A2(Ne, ht, Da)
        ]))));
    }, A2(Vc, 0, tc)))), p_ = F2(function(n, r) {
        return PU(k([
            A2($U, t_, PU(k([
                l_(c_),
                s_(f_)
            ]))),
            A2($U, u_, PU(k([
                m_(d_)
            ]))),
            b_(e_),
            A2(mu, function(n) {
                return a(n.j2, kt);
            }, r._) || n.nk ? A2(cQ, 5e3, Dl(Xv)) : SU,
            A2($U, o_, i_(a_))
        ]));
    }), v_ = Jn("viewport", A2(Te, function(n) {
        return A2(Te, function(r) {
            return A2(Te, function(t) {
                return je({
                    fm: t,
                    mR: r,
                    ig: n
                });
            }, A2(du, "height", tc));
        }, A2(du, "isFullscreen", Pe));
    }, A2(du, "width", tc))), $_ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, w_ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, g_ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, h_ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, k_ = {
        $: 1
    }, C_ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, T_ = function(n) {
        return p(n, {
            lp: w
        });
    }, P_ = F3(function(n, r, t) {
        return n(t) ? ht(r) : kt;
    }), S_ = ft, A_ = (JU = A2(ju, Qg, Ug("^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$")), S_(JU)), y_ = A2(P_, A2(bu, pu, A_), "Cet email n'est pas valide"), N_ = F3(function(n, r, t) {
        return p(t, {
            lC: A3(hi, n, function(n) {
                return ht(1 === n.$ ? r : A2(yu, n.a, r));
            }, t.lC)
        });
    }), L_ = {
        lC: Su,
        Y: kt
    }, j_ = A2(P_, function(n) {
        return "" === n;
    }, "Ce champ est obligatoire"), F_ = F3(function(n, r, t) {
        return n(t) ? r(t) : kt;
    }), M_ = A3(N_, "email", k([
        A2(Pi, function(n) {
            return n.la;
        }, j_),
        A2(Pi, function(n) {
            return n.la;
        }, A2(F_, function(n) {
            return "" !== n;
        }, y_))
    ]), L_), I_ = F2(function(n, r) {
        return ht(1 === r.$ ? k([
            n
        ]) : A2(mt, n, r.a));
    }), D_ = F3(function(n, r, t) {
        return p(t, {
            lC: A3(hi, n, I_(r), t.lC)
        });
    }), B_ = F2(function(n, r) {
        var t = $a;
        return A3(H$, F3(function(n, e, u) {
            return A3(xt, F2(function(e, u) {
                var o = e(r);
                return 1 === o.$ ? u : Ct(A3(D_, n, o.a, u.$ ? u.a : t));
            }), u, e);
        }), function() {
            var e = n.Y;
            if (1 === e.$) return At(r);
            var u = (0, e.a)(r);
            return 1 === u.$ ? At(r) : Ct(A2(ka, u.a, t));
        }(), n.lC);
    }), x_ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, q_ = F3(function(n, r, t) {
        return p(n, {
            lp: A2(ju, w, A2(di, r, t.lC))
        });
    }), V_ = F2(function(n, r) {
        return p(n, {
            la: A3(q_, n.la, "email", r),
            nP: "" === r.nP ? tU : x_(r.nP)
        });
    }), O_ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, w, p(r, {
                    la: A2(ww, n.a, r.la)
                }));
            case 1:
                var t = {
                    la: r.la.sw
                }, e = A2(B_, M_, t);
                return 1 === e.$ ? A2(pc, w, A2(V_, r, Dy(e.a))) : A2(pc, k([
                    A2(Xa, C_, DE(t))
                ]), p(r, {
                    nP: tU
                }));
            default:
                var u = n.a;
                if (u.$) return A2(pc, w, A2(V_, r, u.a));
                var o = function(n) {
                    return p(n, {
                        la: T_(n.la),
                        nP: tU
                    });
                }(r);
                return A2(pc, w, p(o, {
                    nP: k_
                }));
        }
    }), z_ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, E_ = dl(jT({
        $: 6
    })), H_ = F5(function(n, r, t, e, u) {
        return {
            j6: u,
            la: n,
            n6: t,
            o_: e,
            r0: r
        };
    }), R_ = Fi(A4(rc, "confirmation", function(n) {
        return n.j6;
    }, Oa, A4(rc, "password", function(n) {
        return n.o_;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "token", function(n) {
        return n.r0;
    }, Oa, A4(rc, "email", function(n) {
        return n.la;
    }, Oa, Mi(H_))))))), W_ = Ri(Dl(At(0))), U_ = F2(function(n, r) {
        return p(n, {
            j5: A3(q_, n.j5, "confirm", r),
            lo: ht(r.nP),
            n6: A3(q_, n.n6, "name", r),
            o_: A3(q_, n.o_, "password", r)
        });
    }), Q_ = F2(function(n, r) {
        var t = r.a, e = xe(t) > 0 || xe(n.sw) > 0 ? a(t, n.sw) ? " : OK" : " : KO" : "";
        return p(n, {
            m7: $(uU, e)
        });
    }), __ = function(n) {
        return A2(Pi, S_(A2(ju, Qg, Ug(n))), pu);
    }, Z_ = F2(function(n, r) {
        return 9 > xe(n) ? ht(1) : A2(__, "[a-z]", n) ? ht(2) : A2(__, "[A-Z]", n) ? ht(3) : A2(__, "[0-9]", n) ? ht(4) : A2(__, "[^A-Za-z0-9]", n) ? ht(5) : a(n, r) || "" === r ? kt : ht(0);
    }), K_ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, w, r);
            case 1:
                return A2(pc, w, p(r, {
                    n6: A2(ww, e = n.a, r.n6)
                }));
            case 2:
                var t = p(r, {
                    j5: A2(Q_, r.j5, e = n.a),
                    o_: A2(ww, e, r.o_)
                });
                return A2(pc, w, p(t, {
                    o$: A2(Z_, t.o_.sw, t.j5.sw)
                }));
            case 3:
                var e;
                return A2(pc, w, p(r, {
                    j5: A2(ww, e = n.a, A2(Q_, r.o_, e))
                }));
            case 4:
                var u = {
                    j6: r.j5.sw,
                    la: r.la,
                    n6: r.n6.sw,
                    o_: r.o_.sw,
                    r0: r.r0
                };
                return a(r.o$, kt) ? A2(pc, k([
                    A2(Xa, z_, (i = u, mc(W_(A3(ow, R_, i, rw(E_))))))
                ]), r) : A2(pc, w, r);
            default:
                var o = n.a;
                return o.$ ? A2(pc, w, A2(U_, r, o.a)) : A2(pc, k([
                    cH(r.pB)
                ]), r);
        }
        var i;
    }), X_ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, J_ = {
        $: 3
    }, Y_ = {
        $: 0
    }, G_ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, nZ = Zn("gotoSSO", ga), rZ = function(n) {
        return mc(A2(Wi, Vi, Ai(A2(ji, n.la.sw, n.lZ))));
    }, tZ = F2(function(n, r) {
        return {
            la: n,
            o_: r
        };
    }), eZ = Fi(A4(rc, "password", function(n) {
        return n.o_;
    }, Oa, A4(rc, "email", function(n) {
        return n.la;
    }, Oa, Mi(tZ)))), uZ = yi(Li({
        $: 0
    })), oZ = function(n) {
        return mc(W_(A3(ow, eZ, n, rw(uZ))));
    }, aZ = A3(N_, "password", k([
        A2(Pi, function(n) {
            return n.o_;
        }, j_)
    ]), A3(N_, "email", k([
        A2(Pi, function(n) {
            return n.la;
        }, j_),
        A2(Pi, function(n) {
            return n.la;
        }, A2(F_, function(n) {
            return "" !== n;
        }, y_))
    ]), L_)), iZ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cZ = F2(function(n, r) {
        return p(n, {
            la: A3(q_, n.la, "email", r),
            nP: "" === r.nP ? iU : iZ(r.nP),
            o_: A3(q_, n.o_, "password", r)
        });
    }), fZ = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return A2(pc, w, r);
            case 1:
                return A2(pc, w, p(r, {
                    la: A2(ww, n.a, r.la)
                }));
            case 2:
                var t = p(r, {
                    o_: A2(ww, n.a, r.o_)
                });
                if (r.q0) return A2(pc, w, t);
                n = J_, r = t;
                continue n;
            case 3:
                if ("" === r.la.sw) return A2(pc, w, r);
                if (a(r.q1, ht(r.la.sw)) && 1 !== r.q0) {
                    var e = {
                        la: r.la.sw,
                        o_: r.o_.sw
                    }, u = A2(B_, aZ, e);
                    return 1 === u.$ ? A2(pc, w, A2(cZ, r, Dy(u.a))) : A2(pc, k([
                        A2(Xa, X_, oZ(e))
                    ]), r);
                }
                return A2(pc, k([
                    A2(Xa, G_, rZ(r))
                ]), p(r, {
                    q0: 1,
                    q1: ht(r.la.sw)
                }));
            case 5:
                return A2(pc, k([
                    nZ(n.a)
                ]), r);
            case 4:
                var o = r.o_;
                return A2(pc, w, p(r, {
                    la: p(r.la, {
                        sw: ""
                    }),
                    nP: iU,
                    o_: p(o, {
                        sw: ""
                    }),
                    q0: 0
                }));
            case 6:
                return (i = n.a).$ ? A2(pc, w, A2(cZ, r, c = i.a)) : A2(pc, k([
                    function() {
                        var n = r.lZ;
                        return cH(1 === n.$ ? "/" : n.a);
                    }()
                ]), p(r, {
                    nP: iU
                }));
            default:
                var i;
                if ((i = n.a).$) {
                    var c = i.a;
                    return A2(pc, w, A2(cZ, p(r, {
                        q0: 0
                    }), c));
                }
                var f = i.a.q0;
                return f.$ ? A2(pc, k([
                    A2(Xa, Dl(Y_), UE("inputLoginPassword"))
                ]), p(r, {
                    nP: iU,
                    q0: 2
                })) : A2(pc, k([
                    nZ(f.a)
                ]), r);
        }
    }), sZ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lZ = yi(Li({
        $: 4
    })), dZ = F4(function(n, r, t, e) {
        return {
            j6: t,
            la: n,
            o_: r,
            r0: e
        };
    }), mZ = Fi(A4(rc, "token", function(n) {
        return n.r0;
    }, Oa, A4(rc, "confirmation", function(n) {
        return n.j6;
    }, Oa, A4(rc, "password", function(n) {
        return n.o_;
    }, Oa, A4(rc, "email", function(n) {
        return n.la;
    }, Oa, Mi(dZ)))))), bZ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pZ = F2(function(n, r) {
        return p(n, {
            j5: A3(q_, n.j5, "confirm", r),
            nP: "" === r.nP ? lU : bZ(r.nP),
            o_: A3(q_, n.o_, "password", r)
        });
    }), vZ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, w, r);
            case 1:
                var t = p(r, {
                    o_: A2(ww, n.a, r.o_)
                });
                return A2(pc, w, p(t, {
                    o$: A2(Z_, t.o_.sw, t.j5.sw)
                }));
            case 2:
                return t = p(r, {
                    j5: A2(ww, n.a, r.j5)
                }), A2(pc, w, p(t, {
                    o$: A2(Z_, t.o_.sw, t.j5.sw)
                }));
            case 3:
                var e = {
                    j6: r.j5.sw,
                    la: r.la,
                    o_: r.o_.sw,
                    r0: r.r0
                };
                return a(r.o$, kt) ? A2(pc, k([
                    A2(Xa, sZ, (u = e, mc(sw(A3(ow, mZ, u, rw(lZ))))))
                ]), r) : A2(pc, w, r);
            default:
                return n.a.$ ? A2(pc, w, A2(pZ, r, n.a.a)) : A2(pc, k([
                    cH("/")
                ]), r);
        }
        var u;
    }), $Z = F2(function(n, r) {
        var t = d(r.oV, n);
        n: for(;;)switch(t.b.$){
            case 0:
                if (t.a.$) break n;
                var e = A2(fZ, t.b.a, t.a.a), u = e.b;
                return d(p(r, {
                    oV: nU(e.a)
                }), A2(cp, g_, u));
            case 1:
                if (1 === t.a.$) {
                    var o = A2(O_, t.b.a, t.a.a);
                    return u = o.b, d(p(r, {
                        oV: YW(o.a)
                    }), A2(cp, $_, u));
                }
                break n;
            case 2:
                if (2 === t.a.$) {
                    var a = A2(vZ, t.b.a, t.a.a);
                    return u = a.b, d(p(r, {
                        oV: rU(a.a)
                    }), A2(cp, h_, u));
                }
                break n;
            case 3:
                if (3 === t.a.$) {
                    var i = A2(K_, t.b.a, t.a.a);
                    return u = i.b, d(p(r, {
                        oV: GW(i.a)
                    }), A2(cp, w_, u));
                }
                break n;
            default:
                var c = bU(t.b.a);
                return d(p(r, {
                    oV: c.b,
                    sr: c.a
                }), n$);
        }
        return d(r, n$);
    }), wZ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gZ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, hZ = function(n) {
        return {
            $: 10,
            a: n
        };
    }, kZ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, CZ = F2(function(n, r) {
        return A2(Y$, n, uI(r));
    }), TZ = F4(function(n, r, t, e) {
        return A2(CZ, r, e) ? Ct(A3(Cu, n, t, e)) : At(A3(Cu, n, r, e));
    }), PZ = function(n) {
        return A2(ju, !1, A2(Lu, function(n) {
            return !n.$;
        }, A2(Lu, function(n) {
            return n.j2;
        }, n.sk)));
    }, SZ = function(n) {
        return !a(A2(Lu, function(n) {
            return n.o2;
        }, n.r6), ht(5));
    }, AZ = F2(function(n, r) {
        return a(n.di, kt) ? 1 === r.$ ? 0 : function(n) {
            var r = n.lD, t = n.pm, e = n.kI;
            if (a(r.sk, kt)) {
                var u = r.sy;
                if (1 === u.$) return 1;
                var o = u.a.bl;
                return 1 === o.$ ? 1 : o.a.n8 > 0 ? 2 : a(A2(Lu, SZ, t.nw), ht(!0)) || A2(mu, function(n) {
                    return 5 !== n.r6.o2;
                }, e) ? 1 : 3;
            }
            return 1;
        }(r.a) : 4;
    }), yZ = k([
        ".aac",
        ".ac3",
        ".aif",
        ".aiff",
        ".alac",
        ".amb",
        ".amr",
        ".ape",
        ".aob",
        ".au",
        ".caf",
        ".dts",
        ".flac",
        ".m4a",
        ".mka",
        ".mov",
        ".mp2",
        ".mp3",
        ".mpc",
        ".oga",
        ".ogg",
        ".opus",
        ".ra",
        ".sln",
        ".spx",
        ".tta",
        ".voc",
        ".wav",
        ".wave",
        ".wavpack",
        ".wma",
        ".wv"
    ]), NZ = W, LZ = F2(function(n, r) {
        return A2(mu, function(r) {
            return A2(NZ, r, n);
        }, r);
    }), jZ = k([
        ".srt",
        ".stl",
        ".sub",
        ".ssa",
        ".ass",
        ".vtt",
        ".scc",
        ".cap",
        ".ttml"
    ]), FZ = k([
        ".mxf",
        ".mov",
        ".mpg",
        ".mpeg",
        ".mp4",
        ".mp2",
        ".ts",
        ".m2ts",
        ".gxf",
        ".m2t",
        ".mkv"
    ]), MZ = function(n) {
        var r = n.nT;
        n: for(; !r.$;)switch(r.a){
            case "application/mxf":
            case "video/quicktime":
            case "video/mpeg":
            case "video/mp4":
                return 0;
            case "audio/mp3":
            case "audio/wav":
                return 1;
            default:
                break n;
        }
        var t = Ua(n.n6);
        return A2(LZ, t, FZ) ? 0 : A2(LZ, t, jZ) ? 2 : A2(LZ, t, yZ) ? 1 : 3;
    }, IZ = F3(function(n, r, t) {
        return A3(xt, F2(function(r, t) {
            switch(MZ(r)){
                case 0:
                    var e = A4(TZ, r.n6, 0, 3, t);
                    if (e.$) return e.a;
                    var u = e.a;
                    return A2(AZ, n.R.bD, n.R.bQ.f$) && A2(ju, !1, A2(Lu, PZ, A2(Lu, function(n) {
                        return n.lD;
                    }, n.R.bQ.f$))) ? A3(hi, r.n6, function() {
                        return ht(3);
                    }, u) : u;
                case 1:
                    return A3(Cu, r.n6, 1, t);
                case 2:
                    return A3(Cu, r.n6, 2, t);
                default:
                    return t;
            }
        }), t, r);
    }), DZ = F5(function(n, r, t) {
        if (r.$) return Lc;
        var e = r.a;
        return kZ(t.$ || t.a.$ ? e : A3(IZ, t.a.a, n, e));
    }), BZ = F2(function(n, r) {
        return n.iz || A2(mu, function(n) {
            return a(n.oO, r);
        }, n.oQ);
    }), xZ = F2(function(n, r) {
        return A2(mu, function(r) {
            return a(n.mo, r.st) && r.sk;
        }, r);
    }), qZ = F3(function(n, r, t) {
        return A2(BZ, n, r) || A2(xZ, n, t);
    }), VZ = F2(function(n, r) {
        return !(r.st.iz || 1 === n.g9.c$);
    }), OZ = {
        C: w,
        lq: w,
        aa: kt
    }, zZ = F2(function(n, r) {
        return {
            C: r.C,
            lq: r.lq,
            aa: n
        };
    }), EZ = function(n) {
        return A2(zZ, ht(n), OZ);
    }, HZ = F3(function(n, r, t) {
        if (n.$ || n.a.$) return EZ(t);
        var e, u = n.a.a, o = A2(VZ, u, t) ? A2(Mu, function(n) {
            return 2 === MZ(n);
        }, r) : r, a = (e = d(n, t.oY)).a.$ ? 1 === e.b.$ ? d($(o, t.bQ), t.oY) : d(o, Lc) : e.b.$ ? d(o, kZ(Su)) : d($(o, t.bQ), t.oY), i = a.a, c = A5(DZ, o, a.b, n, t.pu, t.ss);
        return EZ(A3(qZ, t.st, u.oM.mo, A2(Ye, function(n) {
            return n.fB;
        }, u.fD)) ? p(t, {
            bQ: i,
            oY: c
        }) : t);
    }), RZ = {
        $: 33
    }, WZ = bc(k([
        A2(Yv, Dl(RZ), Jv),
        A2(Yv, Dl(Xv), Jv)
    ])), UZ = F4(function(n, r, t, e) {
        var u = n(A2(ju, t, e.aa)), o = A2(mu, fe(2), e.lq) ? p(u, {
            g9: p(u.g9, {
                o5: !0
            })
        }) : u, a = A2(Ye, function(n) {
            switch(n){
                case 0:
                    return A2(cp, Sa, ip);
                case 1:
                case 3:
                    return A2(cp, gv(u.g9.mo), Gv);
                case 2:
                    return A2(cp, gv(u.g9.mo), WZ);
                default:
                    return A2(cp, wv, Kv(u.ol.mo));
            }
        }, e.lq), i = A2(cp, r, bc(e.C));
        return A2(pc, A2(mt, i, a), o);
    }), QZ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, w, p(r, {
                    lo: kt
                }));
            case 1:
                return A2(pc, w, p(r, {
                    q2: A2(ww, n.a, r.q2)
                }));
            case 2:
                return A2(pc, w, p(r, {
                    lj: A2(ww, n.a, r.lj)
                }));
            default:
                return A2(pc, w, p(r, {
                    oQ: A2(ID, n.a, r.oQ)
                }));
        }
    }), _Z = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ZZ = function(n) {
        return {
            $: 10,
            a: n
        };
    }, KZ = F3(function(n, r, t) {
        return {
            kR: t,
            la: r,
            n6: n
        };
    }), XZ = Fi(A4(rc, "disableOrganizationEmails", function(n) {
        return n.kR;
    }, ri, A4(qi, "email", function(n) {
        return n.la;
    }, Oa, A4(qi, "name", function(n) {
        return n.n6;
    }, Oa, Mi(KZ))))), JZ = function(n) {
        return A2(Ci, "PATCH", Si(n));
    }, YZ = Zn("refresh", function() {
        return va;
    }), GZ = xa({
        bN: "New name saved",
        bT: "Nouveau nom enregistr\xe9"
    }), nK = xa({
        bN: "New password saved",
        bT: "Nouveau mot de passe enregistr\xe9"
    }), rK = F3(function(n, r, t) {
        return {
            j6: t,
            od: r,
            o_: n
        };
    }), tK = Fi(A4(rc, "confirmation", function(n) {
        return n.j6;
    }, Oa, A4(rc, "newPassword", function(n) {
        return n.od;
    }, Oa, A4(rc, "password", function(n) {
        return n.o_;
    }, Oa, Mi(rK))))), eK = dl(jT({
        $: 4
    })), uK = F2(function(n, r) {
        var t = r.a, e = xe(t) > 0 || xe(n.sw) > 0 ? a(t, n.sw) ? " : OK" : " : KO" : "";
        return p(n, {
            m7: $(Ja, e)
        });
    }), oK = F2(function(n, r) {
        switch(n.$){
            case 7:
                return A2(pc, w, p(r, {
                    lo: kt,
                    rz: kt
                }));
            case 0:
                return A2(pc, w, p(r, {
                    n6: A2(ww, e = n.a, r.n6)
                }));
            case 1:
                return A2(pc, w, p(r, {
                    la: A2(ww, e = n.a, r.la)
                }));
            case 5:
                return A2(pc, w, p(r, {
                    kR: A2(vw, e = n.a, r.kR)
                }));
            case 2:
                return A2(pc, w, p(r, {
                    o_: A2(ww, e = n.a, r.o_)
                }));
            case 3:
                var t = p(r, {
                    oe: A2(ww, e = n.a, r.oe),
                    of: A2(uK, r.of, e)
                });
                return A2(pc, w, p(t, {
                    o$: A2(Z_, t.oe.sw, t.of.sw)
                }));
            case 4:
                var e;
                return t = p(r, {
                    of: A2(ww, e = n.a, A2(uK, r.oe, e))
                }), A2(pc, w, p(t, {
                    o$: A2(Z_, t.oe.sw, t.of.sw)
                }));
            case 6:
                return A2(pc, k([
                    A2(Xa, _Z, (i = {
                        kR: r.kR.sw,
                        la: ht(r.la.sw),
                        n6: ht(r.n6.sw)
                    }, mc(sw(A3(ow, XZ, i, JZ(FT))))))
                ]), p(r, {
                    lo: kt
                }));
            case 8:
                return (o = n.a).$ ? A2(pc, w, p(r, {
                    lo: ht(o.a),
                    rz: kt
                })) : A2(pc, k([
                    YZ(0)
                ]), p(r, {
                    lo: kt,
                    rz: ht(GZ)
                }));
            case 9:
                var u = a(r.o$, kt) ? A2(Xa, ZZ, function(n) {
                    return mc(sw(A3(ow, tK, n, rw(eK))));
                }({
                    j6: r.of.sw,
                    od: r.oe.sw,
                    o_: r.o_.sw
                })) : n$;
                return A2(pc, k([
                    u
                ]), p(r, {
                    lo: kt
                }));
            case 10:
                var o;
                return A2(pc, w, p(r, (o = n.a).$ ? {
                    lo: ht(o.a),
                    rz: kt
                } : {
                    lo: kt,
                    oe: za(function(n) {
                        return p(n, {
                            m7: $c
                        });
                    }),
                    of: za(function(n) {
                        return p(n, {
                            m7: Ja
                        });
                    }),
                    o_: za(function(n) {
                        return p(n, {
                            m7: wc
                        });
                    }),
                    rz: ht(nK)
                }));
            default:
                return A2(pc, w, p(r, n.a.$ ? {
                    lo: ht(n.a.a)
                } : {
                    mU: ht(!a(n.a.a.q0, kt))
                }));
        }
        var i;
    }), aK = F3(function(n, r, t) {
        var e, u = function(n) {
            return {
                l: n.l,
                m: n.m,
                o: n.o,
                p: n.p,
                q: n.q
            };
        }(t), o = (e = u.l(n)).$ ? d(kt, n$) : A2(Ry, ht, A2(u.q, r, e.a)), a = o.b;
        return d(A2(u.o, n, o.a), A2(cp, u.p, a));
    }), iK = F2(function(n, r) {
        var t = n, e = aK(r.oW), u = function() {
            switch(t.$){
                case 1:
                    return A2(e, t.a, Fj);
                case 2:
                    return A2(e, t.a, KB);
                case 3:
                    return A2(e, t.a, kI);
                case 4:
                    return A2(e, t.a, KH);
                case 5:
                    return A2(e, t.a, kE);
                case 6:
                    return A2(e, t.a, hO);
                case 7:
                    return A2(e, t.a, kC);
                case 8:
                    return A2(e, t.a, ST);
                case 9:
                    return A2(e, t.a, aq);
                case 10:
                    return A2(e, t.a, sW);
                case 11:
                    return A2(e, t.a, EI);
                case 12:
                    return A2(e, t.a, pj);
                case 13:
                    return A2(e, t.a, rO);
                case 14:
                    return A2(e, t.a, $V);
                case 15:
                    return A2(e, t.a, lF);
                case 16:
                    return A2(e, t.a, AM);
                case 17:
                    return A2(e, t.a, GS);
                case 18:
                    return A2(e, t.a, Dx);
                default:
                    return A2(e, t.a, UP);
            }
        }(), o = u.a;
        return A2(pc, k([
            A2(cp, Me, u.b)
        ]), p(r, {
            oW: o
        }));
    }), cK = function(n) {
        return {
            $: 4,
            a: n
        };
    }, fK = {
        $: 0
    }, sK = function(n) {
        return {
            $: 7,
            a: n
        };
    }, lK = function(n) {
        return mc(sw(fw(zz(n))));
    }, dK = Fi(A4(rc, "error", function(n) {
        return n.lo;
    }, Oa, Mi(function(n) {
        return {
            lo: n
        };
    }))), mK = F2(function(n, r) {
        return mc(sw(A3(ow, dK, r, JZ(dl(Wx(A2(Oz, n, 11)))))));
    }), bK = yi(Li({
        $: 1
    })), pK = mc(sw(rw(bK))), vK = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return {
            n6: n
        };
    }))), $K = F2(function(n, r) {
        return mc(sw(A3(ow, vK, r, JZ(dl(Wx(A2(Oz, n, 8)))))));
    }), wK = function(n) {
        return mc(sw(dw(dl(Wx(A2(Oz, n, 12))))));
    }, gK = F4(function(n, r, t, e) {
        return {
            ey: r,
            pk: n,
            aV: e,
            q_: t
        };
    }), hK = Fi(A4(qi, "secondsLeft", function(n) {
        return n.aV;
    }, uc, A4(rc, "speed", function(n) {
        return n.q_;
    }, dA, A4(rc, "completed", function(n) {
        return n.ey;
    }, ri, A4(rc, "progress", function(n) {
        return n.pk;
    }, dA, Mi(gK)))))), kK = F2(function(n, r) {
        return mc(sw(A3(ow, hK, r, JZ(dl(Wx(A2(Oz, n, 9)))))));
    }), CK = Zn("resetPreference", function() {
        return va;
    }), TK = Fi(A4(rc, "s3Id", function(n) {
        return n.pZ;
    }, Oa, Mi(function(n) {
        return {
            pZ: n
        };
    }))), PK = F2(function(n, r) {
        return mc(sw(A3(ow, TK, r, JZ(dl(Wx(A2(Oz, n, 10)))))));
    }), SK = dl(jT({
        $: 5
    })), AK = Fi(A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, Mi(function(n) {
        return {
            oM: n
        };
    }))), yK = function(n) {
        return mc(sw(A3(ow, AK, {
            oM: n
        }, rw(SK))));
    }, NK = F3(function(n, r, t) {
        return p(t, {
            _: A2(Ye, function(t) {
                return a(t.z, n) ? r(t) : t;
            }, t._)
        });
    }), LK = F2(function(n, r) {
        return p(r, {
            _: A2(Mu, function(r) {
                return !a(r.z, n);
            }, r._)
        });
    }), jK = F2(function(n, r) {
        switch(n.$){
            case 0:
                return d(r, n$);
            case 1:
                return d(p(r, {
                    dO: n.a
                }), n$);
            case 3:
                return d(r, bc(k([
                    A2(Xa, cK, pK),
                    CK(0)
                ])));
            case 4:
                return d(r, 1 === n.a.$ ? n$ : cH("/"));
            case 2:
                var t = n.a;
                switch(t.$){
                    case 0:
                        return d(p(r, {
                            _: A2(mt, t.a, r._)
                        }), n$);
                    case 1:
                        return d(A3(NK, l = t.a.z, function(n) {
                            return p(n, {
                                df: kt
                            });
                        }, r), n$);
                    case 2:
                        var e = t.a.pk, u = t.a.d5, o = A2(kK, l = t.a.z, {
                            ey: !1,
                            pk: e,
                            aV: (i = t.a.hx).aV,
                            q_: i.q_
                        });
                        return d(A3(NK, l, function(n) {
                            return p(n, {
                                pk: e,
                                gJ: u,
                                aV: i.aV
                            });
                        }, r), A2(Xa, Dl(fK), o));
                    case 3:
                        var a = t.a.p_;
                        return o = A2(PK, l = t.a.z, {
                            pZ: a
                        }), d(A3(NK, l, function(n) {
                            return p(n, {
                                pZ: ht(a)
                            });
                        }, r), A2(Xa, function() {
                            return fK;
                        }, o));
                    case 7:
                        return d(A3(NK, l = t.a.z, function(n) {
                            return p(n, {
                                dg: !0
                            });
                        }, r), n$);
                    case 8:
                        return u = t.a.d5, o = wK(l = t.a.z), d(A3(NK, l, function(n) {
                            return p(n, {
                                df: ht(u),
                                dg: !1
                            });
                        }, r), A2(Xa, function() {
                            return fK;
                        }, o));
                    case 9:
                        return d(A3(NK, l = t.a.z, function(n) {
                            return p(n, {
                                df: kt,
                                dg: !1
                            });
                        }, r), n$);
                    case 10:
                        return o = A2($K, l = t.a.z, {
                            n6: c = t.a.gY
                        }), d(A3(NK, l, function(n) {
                            return p(n, {
                                n6: c
                            });
                        }, r), A2(Xa, function() {
                            return fK;
                        }, o));
                    case 4:
                        var i = t.a.hx, c = t.a.gY, f = t.a.j2;
                        return o = A2(kK, l = t.a.z, {
                            ey: !0,
                            pk: 1,
                            aV: ht(0),
                            q_: i.q_
                        }), d(A3(NK, l, function(n) {
                            return p(n, {
                                j2: ht(f),
                                pk: 1,
                                aV: kt
                            });
                        }, r), A2(Xa, Dl(fK), o));
                    case 5:
                        var s = t.a.lo;
                        return o = A2(mK, l = t.a.z, {
                            lo: s
                        }), d(A3(NK, l, function(n) {
                            return p(n, {
                                lo: ht(s)
                            });
                        }, r), A2(Xa, function() {
                            return fK;
                        }, o));
                    case 6:
                        var l;
                        return o = lK(l = t.a.z), d(A2(LK, l, r), A2(Xa, function() {
                            return fK;
                        }, o));
                    default:
                        return d(r, n$);
                }
            case 5:
                return d(p(r, {
                    b$: !r.b$
                }), n$);
            case 6:
                return d(r, A2(Xa, sK, yK(n.a)));
            default:
                return d(r, 1 === n.a.$ ? n$ : cH(lH));
        }
    }), FK = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), MK = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), IK = function(n) {
        return {
            $: 6,
            a: n
        };
    }, DK = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return {
            n6: n
        };
    }))), BK = F2(function(n, r) {
        return {
            n6: r,
            bm: n
        };
    }), xK = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "seasonId", function(n) {
        return n.bm;
    }, Oa, Mi(BK)))), qK = function(n) {
        return {
            $: 3,
            a: n
        };
    }, VK = dl(qK({
        $: 0
    })), OK = function(n) {
        return dl(yv(A2(Nv, n, 6)));
    }, zK = F2(function(n, r) {
        return {
            c$: r,
            n6: n
        };
    }), EK = Fi(A4(rc, "kind", function(n) {
        return n.c$;
    }, Lm, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(zK)))), HK = xa({
        bN: "Can\u2019t add.",
        bT: "Impossible d\u2019effectuer l\u2019ajout."
    }), RK = F2(function(n, r) {
        return {
            a5: n,
            n6: r
        };
    }), WK = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "collectionId", function(n) {
        return n.a5;
    }, Oa, Mi(RK)))), UK = function(n) {
        return {
            $: 2,
            a: n
        };
    }, QK = dl(UK({
        $: 0
    })), _K = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return {
            n6: n
        };
    }))), ZK = F3(function(n, r, t) {
        var e = F4(function(n, r, t, e) {
            return A2(Yb, function(n) {
                return n.mo;
            }, mc(A3(ow, t, e, A2(nw, r, rw(n)))));
        });
        if (r.$) return By({
            lC: Su,
            nP: HK,
            P: 400
        });
        if (r.a.$) return A4(e, OK(n), Ub, EK, 1 === r.a.a ? {
            c$: 1,
            n6: t
        } : {
            c$: 0,
            n6: t
        });
        switch(r.a.a){
            case 3:
                return A4(e, rp, up, _K, {
                    n6: t
                });
            case 2:
                return A4(e, VK, Hb, xK, {
                    n6: t,
                    bm: n
                });
            case 0:
                return A4(e, Lb, Bb, DK, {
                    n6: t
                });
            default:
                return A4(e, QK, Zb, WK, {
                    a5: n,
                    n6: t
                });
        }
    }), KK = F2(function(n, r) {
        return {
            kx: r,
            lo: ht(n),
            nm: !1
        };
    }), XK = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), JK = function(n) {
        return {
            $: 1,
            a: n
        };
    }, YK = {
        dU: 3,
        ik: !1,
        eC: JK(0),
        mo: "",
        fE: !0,
        m7: "",
        gi: 2,
        oM: "",
        gm: "",
        gq: "",
        gW: 1,
        hv: 0,
        h5: !1
    }, GK = function(n) {
        return !!n.hv;
    }, nX = "seeAccepted", rX = "seeActives", tX = "seeAll", eX = "seeArchives", uX = "seeNonAccepted", oX = "seeTrashed", aX = F5(function(n, r, t, e, u) {
        var o = GK(u), i = !u.h5 && a(n.iU.sw, tX) || u.h5 && a(n.iU.sw, oX) || !u.h5 && o && a(n.iU.sw, eX) || !u.h5 && !o && a(n.iU.sw, rX), c = a(n.il.sw, tX) || u.ik && a(n.il.sw, nX) || !u.ik && a(n.il.sw, uX), f = i && c ? 0 : 1;
        return p(YK, {
            dU: u.ik ? 1 : 2,
            ik: u.ik,
            eC: JK(1 === u.c$ ? 1 : 0),
            mo: u.mo,
            m7: u.rX,
            gi: f,
            oM: r,
            gq: t,
            gW: e,
            hv: u.hv,
            h5: u.h5
        });
    }), iX = A2(xt, F2(function(n, r) {
        var t = d(r, n.dU);
        n: for(;;)switch(t.a){
            case 1:
                if (1 === t.b) return 1;
                break n;
            case 2:
                if (2 === t.b) return 2;
                break n;
            case 3:
                return t.b;
            default:
                break n;
        }
        return 0;
    }), 3), cX = A2(xt, F2(function(n, r) {
        var t = d(r, n.gi);
        n: for(;;){
            r: for(;;)switch(t.a){
                case 0:
                    return 0;
                case 2:
                    switch(t.b){
                        case 0:
                            break n;
                        case 2:
                            return 2;
                        default:
                            break r;
                    }
                default:
                    if (t.b) break r;
                    break n;
            }
            return 1;
        }
        return 0;
    }), 2), fX = hT(gT(function(n) {
        return n.m7;
    })), sX = F2(function(n, r) {
        var t = r.gm, e = r.bH.oO, u = function(u) {
            var o = fX(A2(Ye, A4(aX, n, e, u.cL.mo, r.gW), u.dr));
            return p(YK, {
                dU: iX(o),
                eC: A2(XK, 2, o),
                mo: u.cL.mo,
                fE: Tu(o),
                m7: u.cL.n6,
                gi: cX(o),
                oM: e,
                gm: t,
                gW: r.gW,
                hv: u.cL.hv
            });
        }, o = function(n) {
            var o = fX(A2(Ye, u, n.cM));
            return p(YK, {
                dU: iX(o),
                eC: A2(XK, 1, o),
                mo: n.dn.mo,
                fE: Tu(o),
                m7: n.dn.n6,
                gi: cX(o),
                oM: e,
                gm: t,
                gW: r.gW,
                hv: n.dn.hv
            });
        }, a = fX(A2(Ye, o, r.g2));
        return p(YK, {
            dU: iX(a),
            eC: A2(XK, 0, a),
            mo: r.bH.mo,
            fE: Tu(a),
            m7: r.bH.n6,
            gi: cX(a),
            oM: e,
            gm: t,
            gW: r.gW,
            hv: r.bH.hv
        });
    }), lX = function(n) {
        return Ye(function(r) {
            if (r.$) {
                var t = r.a, e = t.sf.oO, u = fX(A2(Ye, A4(aX, n, e, t.sf.mo, t.gW), t.dr));
                return p(YK, {
                    dU: iX(u),
                    eC: A2(XK, 3, u),
                    mo: t.sf.mo,
                    fE: Tu(u),
                    m7: t.sf.n6,
                    gi: cX(u),
                    oM: e,
                    gm: t.gm,
                    gW: t.gW,
                    hv: t.sf.hv
                });
            }
            return A2(sX, n, r.a);
        });
    }, dX = function(n) {
        var r = fX(A2(lX, n, n.mJ));
        return p(n, {
            jL: fX(A2(lX, n, n.jM)),
            fD: r
        });
    }, mX = F2(function(n, r) {
        return A2(su, r, A2(Za, Dl(Ze(0)), A2(Ge, Dl(UE(n)), qE(150))));
    }), bX = F2(function(n, r) {
        return A2(ju, !1, A2(Lu, fe(n), r));
    }), pX = F2(function(n, r) {
        return A2(MD, n, r);
    }), vX = Zn("redirect", ga), $X = {
        bD: kt,
        cf: ht(!0)
    }, wX = function(n) {
        return wP(A3(Sp, n, 0, $X));
    }, gX = F2(function(n, r) {
        return n.$ ? n$ : n.a.$ ? vX(wX(r)) : n$;
    }), hX = F2(function(n, r) {
        return A2(gi, n, r);
    }), kX = F2(function(n, r) {
        return {
            C: n,
            lq: r.lq,
            aa: r.aa
        };
    }), CX = F2(function(n, r) {
        return A2(kX, A2(mt, n, r.C), r);
    }), TX = F3(function(n, r, t) {
        return A2(CX, Cv(d(n, r)), EZ(t));
    }), PX = function(n) {
        return {
            kx: ht(n),
            lo: kt,
            nm: !1
        };
    }, SX = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return {
            n6: n
        };
    }))), AX = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return {
            n6: n
        };
    }))), yX = xa({
        bN: "Can\u2019t edit.",
        bT: "Impossible d\u2019effectuer l\u2019\xe9dition."
    }), NX = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return {
            n6: n
        };
    }))), LX = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), jX = function(n) {
        return {
            $: 5,
            a: n
        };
    }, FX = function(n) {
        return dl(jX(A2(LX, n, 0)));
    }, MX = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return {
            n6: n
        };
    }))), IX = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(function(n) {
        return {
            n6: n
        };
    }))), DX = F3(function(n, r, t) {
        var e = F3(function(n, r, t) {
            return mc(A3(ow, r, t, W_(dw(n))));
        });
        if (r.$) return By({
            lC: Su,
            nP: yX,
            P: 400
        });
        if (r.a.$) return A3(e, FX(n), IX, {
            n6: t
        });
        switch(r.a.a){
            case 3:
                return A3(e, function(n) {
                    return dl(np(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), MX, {
                    n6: t
                });
            case 2:
                return A3(e, function(n) {
                    return dl(qK(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), AX, {
                    n6: t
                });
            case 0:
                return A3(e, function(n) {
                    return dl(Nb(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), SX, {
                    n6: t
                });
            default:
                return A3(e, function(n) {
                    return dl(UK(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), NX, {
                    n6: t
                });
        }
    }), BX = F2(function(n, r) {
        return A2(kX, $(n, r.C), r);
    }), xX = F2(function(n, r) {
        return {
            C: r.C,
            lq: n,
            aa: r.aa
        };
    }), qX = F2(function(n, r) {
        return A2(xX, A2(mt, n, r.lq), r);
    }), VX = F2(function(n, r) {
        switch(n.$){
            case 0:
                if (n.a.$) return EZ(p(r, {
                    P: A2(KK, n.a.a, r.P.kx)
                }));
                var t = n.a.a, e = A3(Je, F2(function(n, r) {
                    var t = r.a, e = r.b;
                    return n.a.gW ? d(t, A2(mt, n, e)) : d(A2(mt, n, t), e);
                }), d(w, w), t), u = e.a, o = e.b;
                return A2(BX, k([
                    A2(ju, n$, A2(Lu, function(n) {
                        return r.pN ? A2(mX, n, IK) : n$;
                    }, r.qs))
                ]), EZ(t$(dX(p(r, {
                    jM: u,
                    mJ: o,
                    pN: !1,
                    P: PX(0)
                })))));
            case 2:
                var i = A2(pX, h = n.a, r.oC), c = A2(i ? hX : If, h, r.oC), f = i && a(r.iv, ht(h)) ? kt : r.iv;
                return EZ(p(r, {
                    iv: f,
                    oC: c
                }));
            case 1:
                return EZ(p(r, {
                    oK: A2(bX, h = n.a, r.oK) ? kt : ht(h)
                }));
            case 3:
                var s = n.a, l = n.b;
                return A2(BX, k([
                    A2(mX, "new-add-form", IK)
                ]), EZ(p(r, {
                    iv: ht(l),
                    iw: p(Pc, {
                        kX: "addInBrowserInput"
                    }),
                    og: s,
                    oC: A2(If, l, r.oC)
                })));
            case 4:
                var m = n.a, b = n.b, v = r.k5;
                return A2(BX, k([
                    A2(mX, v.kX, IK)
                ]), EZ(p(r, {
                    k3: A2(bX, b.mo, r.k3) ? kt : ht(b.mo),
                    k5: p(v, {
                        sw: b.m7
                    }),
                    og: m
                })));
            case 5:
                return EZ(p(r, {
                    iv: kt,
                    k3: kt,
                    oK: kt
                }));
            case 6:
                return OZ;
            case 7:
                var $ = r.iw.sw;
                return A2(BX, k([
                    A2(Xa, FK(g = n.a), A3(ZK, g, r.og, $))
                ]), EZ(p(r, {
                    rl: A2(If, g, r.rl)
                })));
            case 8:
                return $ = r.k5.sw, A2(BX, k([
                    A2(Xa, MK(h = n.a), A3(DX, h, r.og, $))
                ]), EZ(p(r, {
                    rl: A2(If, h, r.rl)
                })));
            case 9:
                if (n.b.$) return h = n.a, EZ(p(r, {
                    lo: ht(n.b.a),
                    rl: A2(hX, h, r.rl)
                }));
                var g = n.a;
                return A2(BX, k([
                    A2(gX, r.og, h = n.b.a)
                ]), A2(qX, 0, EZ(p(r, {
                    iv: kt,
                    iw: Pc,
                    lo: kt,
                    og: kt,
                    pN: !0,
                    qs: ht(h),
                    rl: A2(hX, g, r.rl)
                }))));
            case 10:
                var h;
                return n.b.$ ? (h = n.a, EZ(p(r, {
                    lo: ht(n.b.a),
                    rl: A2(hX, h, r.rl)
                }))) : A2(qX, 0, EZ(p(r, {
                    k3: kt,
                    k5: Pc,
                    lo: kt,
                    og: kt,
                    rl: A2(hX, h = n.a, r.rl)
                })));
            case 11:
                return EZ(p(r, {
                    iw: A2(ww, n.a, r.iw)
                }));
            case 12:
                return EZ(p(r, {
                    k5: A2(ww, n.a, r.k5)
                }));
            case 16:
                return EZ(p(r, {
                    lo: kt
                }));
            case 13:
                var C = p(r, {
                    iU: A2(ww, n.a, r.iU),
                    oC: Tc
                });
                return A3(TX, "browserArchive", C.iU.sw, A3(ce, A2(Lu, e$, r.qs), ju(Me), dX(C)));
            case 14:
                return C = p(r, {
                    il: A2(ww, n.a, r.il),
                    oC: Tc
                }), A3(TX, "browserAccept", C.il.sw, A3(ce, A2(Lu, e$, r.qs), ju(Me), dX(C)));
            default:
                return EZ(p(r, {
                    oL: A2(ww, n.a, r.k5)
                }));
        }
    }), OX = {
        $: 2
    }, zX = {
        $: 3
    }, EX = F3(function(n, r, t) {
        return A3(xt, F2(function(n, e) {
            return A3(xt, F2(function(r, t) {
                return !!t || A2(S_, A2(ju, Qg, Ug("(\\b" + n + ")")), r);
            }), !1, A2(Ye, A2(Pi, Ua, fT), A2(mt, t.m7, r))) && e;
        }), !0, n);
    }), HX = F5(function(n, r, t, e, u) {
        return A3(EX, n, r, e) ? A2(mt, m(r, t, e), u) : u;
    }), RX = F2(function(n, r) {
        return A2(Je, F2(function(t, e) {
            var u = t.eC;
            if (u.$) return A5(HX, r, n, u.a, t, e);
            var o = u.b;
            return $(A3(RX, $(n, k([
                t.m7
            ])), r, o), e);
        }), w);
    }), WX = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                if (2 === n.a.$) return A2(pc, k([
                    A2(su, Dl(OX), qE(200))
                ]), r);
                var e = A2(ww, n.a, r.qc), u = k(fT(Ua(e.sw)).trim().split(/\s+/g)), o = $(A3(RX, w, u, t.jL), A3(RX, w, u, t.fD));
                return A2(pc, w, {
                    qc: e,
                    qd: o,
                    qe: !0
                });
            case 1:
                return A2(pc, r.qe ? w : k([
                    A2(mX, r.qc.kX, Dl(zX))
                ]), {
                    qc: A2(ww, Lg(""), r.qc),
                    qd: A3(RX, w, w, t.jL),
                    qe: !r.qe
                });
            case 2:
                return A2(pc, w, p(r, {
                    qe: !1
                }));
            default:
                return A2(pc, w, r);
        }
    }), UX = xa({
        bN: "A video is already there.",
        bT: "Il y a d\xe9j\xe0 une vid\xe9o."
    }), QX = xa({
        bN: "MXF video file needed",
        bT: "Vous devez d\xe9poser un fichier vid\xe9o MXF"
    }), _X = F4(function(n, r, t, e) {
        return A3(Cu, n, r, A2(Gi, F2(function(n, e) {
            return a(e, r) ? t : e;
        }), e));
    }), ZX = F3(function(n, r, t) {
        var e = function(n) {
            return d(n, kt);
        }, u = function(n) {
            return d(t, ht(n));
        }, o = d(t, r);
        if (o.a.$) return e(t);
        var a = o.a.a, i = o.b, c = d(i, MZ(n));
        n: for(;;)switch(c.a){
            case 0:
                if (c.b) break n;
                return A3(bu, e, kZ, A4(_X, n.n6, 0, 3, a));
            case 1:
                switch(c.b){
                    case 1:
                        return e(kZ(A3(Cu, n.n6, i, a)));
                    case 0:
                        return A2(LZ, Ua(n.n6), yZ) ? e(kZ(A3(Cu, n.n6, i, a))) : u(QX);
                    default:
                        break n;
                }
            case 2:
                if (2 === c.b) return e(kZ(A3(Cu, n.n6, i, a)));
                break n;
            default:
                return e(kZ(A3(Cu, n.n6, i, a)));
        }
        return u(QX);
    }), KX = function(n) {
        return A2(kX, k([
            n
        ]), OZ);
    }, XX = F3(function(n, r, t) {
        return A2(ju, n, A2(di, t.n6, r));
    }), JX = function(n) {
        return {
            $: 2,
            a: n
        };
    }, YX = xa({
        bN: "No more parts to send but job is not complete",
        bT: "No more parts to send but job is not complete"
    }), GX = F3(function(n, r, t) {
        if (t.$) return EZ(p(n, {
            iO: JX(t.a)
        }));
        var e = t.a;
        return 1 === e.$ ? $(r, A2(Mu, function(n) {
            return !A2(Y$, n, r);
        }, e.b)).b ? OZ : EZ(p(n, {
            iO: JX(Dy(A2(ka, YX, s$)))
        })) : EZ(p(n, {
            iO: e
        }));
    }), nJ = F2(function(n, r) {
        return A3(xt, F2(function(n, r) {
            return A2(gi, n.n6, r);
        }), r, n);
    }), rJ = F2(function(n, r) {
        var t, e = (t = r.oY).$ ? Lc : kZ(A2(nJ, n, t.a));
        return EZ(p(r, {
            bQ: A2(Mu, function(r) {
                return !A2(Y$, r, n);
            }, r.bQ),
            oY: e
        }));
    }), tJ = F3(function(n, r, t) {
        return {
            $: 12,
            a: n,
            b: r,
            c: t
        };
    }), eJ = F5(function(n, r, t, e, u) {
        return {
            c$: u,
            nT: t,
            n6: n,
            qP: r,
            dt: e
        };
    }), uJ = function(n) {
        switch(n){
            case 0:
                return "Material";
            case 1:
                return "Audio";
            case 2:
                return "Subtitle";
            default:
                return "Extra";
        }
    }, oJ = function(n) {
        switch(n){
            case "Material":
                return At(0);
            case "Audio":
                return At(1);
            case "Subtitle":
                return At(2);
            default:
                return At(3);
        }
    }, aJ = A2(Ml, uJ, oJ), iJ = Fi(A4(rc, "kind", function(n) {
        return n.c$;
    }, aJ, A4(qi, "source", function(n) {
        return n.dt;
    }, Oa, A4(qi, "mimeType", function(n) {
        return n.nT;
    }, Oa, A4(rc, "size", function(n) {
        return n.qP;
    }, uc, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(eJ))))))), cJ = Za, fJ = F2(function(n, r) {
        return {
            c$: r,
            n6: n
        };
    }), sJ = Fi(A4(rc, "kind", function(n) {
        return n.c$;
    }, aJ, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(fJ)))), lJ = function(n) {
        return dl(jX(A2(LX, n, 3)));
    }, dJ = F3(function(n, r, t) {
        return mc(A2(Wi, Sz, A3(ow, sJ, {
            c$: r,
            n6: t
        }, dw(lJ(n)))));
    }), mJ = F4(function(n, r, t, e) {
        return A2(cJ, function(n) {
            return 409 === n.P ? A3(dJ, r, t, e.n6) : By(n);
        }, mc(A2(nw, Sz, A3(ow, iJ, {
            c$: t,
            nT: e.nT,
            n6: e.n6,
            qP: e.qP,
            dt: ht(n.dt)
        }, rw(lJ(r))))));
    }), bJ = F4(function(n, r, t, e) {
        return A2(qX, 1, A2(BX, A2(Ye, function(e) {
            return A2(Xa, A2(tJ, n, e), A4(mJ, n, r, t(e), e));
        }, e.bQ), EZ(jc(e.st))));
    }), pJ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vJ = function(n) {
        switch(n.$){
            case 0:
                return {
                    lq: (r = n.a, wa(k([
                        d("source", ga(r.dt)),
                        d("userId", ga(r.ia)),
                        d("fileId", ga(r.z)),
                        d("key", ga(r.fL)),
                        d("file", (t = r.lD, wa(k([
                            d("name", ga(t.n6)),
                            d("size", ec(t.qP)),
                            d("mimeType", A2(ju, va, A2(Lu, ga, t.nT))),
                            d("blob", t.ji)
                        ]))))
                    ]))),
                    n6: "Upload"
                };
            case 1:
                return {
                    lq: ga(n.a),
                    n6: "Pause"
                };
            case 2:
                return {
                    lq: ga(n.a),
                    n6: "Resume"
                };
            default:
                return {
                    lq: ga(n.a),
                    n6: "Cancel"
                };
        }
        var r, t;
    }, $J = Zn("uploadToJs", function(n) {
        return wa(k([
            d("event", n.lq),
            d("name", ga(n.n6))
        ]));
    }), wJ = A2(bu, $J, vJ), gJ = A2(bu, wJ, pJ), hJ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A4(bJ, n.a, n.b.mo, A2(XX, 3, n.c), r);
            case 1:
                return EZ(jc(r.st));
            case 2:
                return A2(rJ, k([
                    t = n.a
                ]), r);
            case 4:
                var t = n.a, e = n.b;
                return 1 === e.jx ? EZ(p(r, {
                    k_: ht(m(t, {
                        sO: e.b2.sO,
                        sT: e.b2.sT
                    }, {
                        sO: e.oV.sO,
                        sT: e.oV.sT
                    }))
                })) : OZ;
            case 5:
                var u = r.k_;
                if (1 === u.$) return OZ;
                var o = u.a;
                return EZ(p(r, {
                    k_: ht(m(t = o.a, o.b, n.a))
                }));
            case 6:
                var a = (s = d(r.k_, r.k$)).a.$ || s.b.$ ? d(r.oY, kt) : A3(ZX, s.a.a.a, s.b.a, r.oY);
                return EZ(p(r, {
                    k_: kt,
                    lo: a.b,
                    oY: a.a
                }));
            case 7:
                return EZ(p(r, {
                    k$: ht(n.a)
                }));
            case 8:
                return EZ(p(r, {
                    k$: kt
                }));
            case 3:
                return OZ;
            case 9:
                return EZ(p(r, {
                    lo: kt
                }));
            case 10:
                return A3(HZ, n.a, n.b, r);
            case 11:
                var i = n.a, c = r.iO;
                switch(c.$){
                    case 1:
                        return A3(GX, r, c.b, i);
                    case 0:
                        return A3(GX, r, w, i);
                    default:
                        return OZ;
                }
            default:
                if (n.c.$) return EZ(p(r, {
                    lo: ht(UX)
                }));
                var f = n.c.a;
                return KX(gJ({
                    lD: t = n.b,
                    z: f.mo,
                    fL: f.fL,
                    dt: n.a.dt,
                    ia: "TODODODODO"
                }));
        }
        var s;
    }), kJ = F2(function(n, r) {
        if (n.$) return A2(pc, w, p(r, {
            oV: ht(n.a)
        }));
        if (n.a.$) return A2(pc, w, r);
        var t = n.a.a;
        return A2(pc, k([
            A2(ju, n$, A2(Lu, ZW(t), r.b7))
        ]), p(r, {
            f_: t
        }));
    }), CJ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, TJ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, PJ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, SJ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, AJ = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), yJ = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), NJ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), LJ = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), jJ = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), FJ = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), MJ = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), IJ = F2(function(n, r) {
        return {
            $: 13,
            a: n,
            b: r
        };
    }), DJ = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), BJ = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), xJ = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), qJ = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), VJ = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), OJ = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), zJ = function(n) {
        if (1 === n.$) return 0;
        switch(n.a.$){
            case 13:
                return 1;
            case 0:
                return 2;
            case 12:
                return 3;
            case 1:
                return 4;
            case 5:
                return 5;
            case 6:
                return 6;
            case 9:
                return 7;
            case 8:
                return 8;
            case 7:
                return 9;
            case 2:
                return 11;
            case 4:
                return 12;
            case 3:
                return 13;
            case 10:
                return 14;
            default:
                return 15;
        }
    }, EJ = F2(function(n, r) {
        return s(zJ(ht(n)), zJ(r)) > 0 ? ht(n) : r;
    }), HJ = xa({
        bN: " done",
        bT: " est termin\xe9e"
    }), RJ = xa({
        bN: " failed",
        bT: " a \xe9chou\xe9"
    }), WJ = xa({
        bN: " done generating ",
        bT: " est termin\xe9e g\xe9n\xe9rant "
    }), UJ = xa({
        bN: "Segmentation of file ",
        bT: "La segmentation du fichier "
    }), QJ = xa({
        bN: " started",
        bT: " a d\xe9marr\xe9"
    }), _J = xa({
        bN: " with rule ",
        bT: " avec la r\xe8gle "
    }), ZJ = xa({
        bN: "File ",
        bT: "Le fichier "
    }), KJ = xa({
        bN: " has been uploaded",
        bT: " a \xe9t\xe9 upload\xe9"
    }), XJ = xa({
        bN: " creeated invitation ",
        bT: " s\u2019est cr\xe9\xe9 une invitation "
    }), JJ = xa({
        bN: " deleted invitation",
        bT: " a supprim\xe9 son invitation"
    }), YJ = xa({
        bN: " deleted invitation for ",
        bT: " a supprim\xe9 l\u2019invitation de "
    }), GJ = xa({
        bN: " edit invitation ",
        bT: " a \xe9dit\xe9 son invitation "
    }), nY = xa({
        bN: " invited ",
        bT: " a invit\xe9 "
    }), rY = xa({
        bN: " expire at ",
        bT: " expirant le "
    }), tY = function(n) {
        var r = A2(AH, 4, A2(Yd, nm, n)), t = yH(A2(Ud, nm, n));
        return A2(AH, 2, A2(Ed, nm, n)) + "/" + t + "/" + r;
    }, eY = function(n) {
        return A2(ju, "", A2(Lu, function(n) {
            return $(rY, n);
        }, A2(Lu, tY, n)));
    }, uY = xa({
        bN: " to download and upload",
        bT: " autorisant le t\xe9l\xe9chargement et l\u2019upload"
    }), oY = xa({
        bN: " to download",
        bT: " autorisant le t\xe9l\xe9chargement"
    }), aY = xa({
        bN: " authorize download and unauthorize upload",
        bT: " autorisant le t\xe9l\xe9chargement et supprimant l\u2019upload"
    }), iY = xa({
        bN: " authorizing download and delivery",
        bT: " autorisant le t\xe9l\xe9chargement et la livraison"
    }), cY = xa({
        bN: " authorize download and unauthorize delivery",
        bT: " autorisant le t\xe9l\xe9chargement et supprimant la livraison"
    }), fY = xa({
        bN: " to delivery",
        bT: " autorisant la livraison"
    }), sY = xa({
        bN: " unauthorizing delivery",
        bT: " supprimant la livraison"
    }), lY = xa({
        bN: " authorizing delivery and unauthorizing download",
        bT: " autorisant la livraison et supprimant le t\xe9l\xe9chargement"
    }), dY = xa({
        bN: " unauthorizing delivery and download",
        bT: " supprimant la livraison et le t\xe9l\xe9chargement"
    }), mY = xa({
        bN: " to upload",
        bT: " autorisant l\u2019upload"
    }), bY = xa({
        bN: " to watch only",
        bT: " autorisant le visionnage seulement"
    }), pY = xa({
        bN: " unauthorizing upload",
        bT: " supprimant l\u2019upload"
    }), vY = xa({
        bN: " authorizing upload and unauthorizing download",
        bT: " autorisant l\u2019upload et supprimant le t\xe9l\xe9chargement"
    }), $Y = xa({
        bN: " unauthorizing download",
        bT: " supprimant le t\xe9l\xe9chargement"
    }), wY = xa({
        bN: " unauthorizing upload and download",
        bT: " supprimant l\u2019upload et le t\xe9l\xe9chargement"
    }), gY = F3(function(n, r, t) {
        var e = d(n, r);
        switch(e.a){
            case 0:
                switch(e.b){
                    case 0:
                        return t ? iY : uY;
                    case 1:
                        return t ? cY : aY;
                    default:
                        return oY;
                }
            case 1:
                switch(e.b){
                    case 0:
                        return t ? lY : vY;
                    case 1:
                        return t ? dY : wY;
                    default:
                        return $Y;
                }
            default:
                switch(e.b){
                    case 0:
                        return t ? fY : mY;
                    case 1:
                        return t ? sY : pY;
                    default:
                        return bY;
                }
        }
    }), hY = xa({
        bN: "unknown user",
        bT: "utilisateur inconnu"
    }), kY = xa({
        bN: "Video was watched by a guest : ",
        bT: "La vid\xe9o \xe0 \xe9t\xe9 visionn\xe9e par un invit\xe9 : "
    }), CY = xa({
        bN: " ended with ",
        bT: " s\u2019est termin\xe9e avec "
    }), TY = F4(function(n, r, t, e) {
        return 1 === r.$ || 1 === t.$ || 1 === e.$ ? kt : ht(A3(n, r.a, t.a, e.a));
    }), PY = xa({
        bN: "Copy of file ",
        bT: "La copie du fichier "
    }), SY = xa({
        bN: " for file ",
        bT: " pour le fichier "
    }), AY = xa({
        bN: "Creation of ",
        bT: "La g\xe9n\xe9ration du "
    }), yY = xa({
        bN: "deliverable with parameters ",
        bT: "livrable avec pour param\xe8tres "
    }), NY = xa({
        bN: " High Res ",
        bT: " Haute Def "
    }), LY = xa({
        bN: " and subtitles ",
        bT: " et sous-titres "
    }), jY = F2(function(n, r) {
        var t = n.aX;
        return "TC IN = " + n.dz + ", TC OUT = " + n.dA + ", version " + ab(n.sz) + ", format = " + (r + (t.$ ? "" : $(LY, t.a)));
    }), FY = F3(function(n, r, t) {
        switch(n){
            case 0:
                return "proxy";
            case 1:
                return "proxy" + NY;
            case 3:
            default:
                return "";
            case 2:
                return 1 === t.$ ? yY + "format = " + r : $(yY, A2(jY, t.a, r));
        }
    }), MY = xa({
        bN: "organization ",
        bT: "vers l\u2019organisation "
    }), IY = F6(function(n, r, t, e, u, o) {
        var a = A2(ju, "", A2(Lu, function(n) {
            return $(MY, n);
        }, u));
        return 3 === o ? PY + (n + " ") + (a + e) : AY + (A3(FY, o, t, r) + (SY + (n + " "))) + (a + e);
    }), DY = xa({
        bN: " warning",
        bT: " warning"
    }), BY = xa({
        bN: " warnings",
        bT: " warnings"
    }), xY = xa({
        bN: "files uploaded",
        bT: "fichiers upload\xe9s"
    }), qY = xa({
        bN: " sent with success",
        bT: " a \xe9t\xe9 envoy\xe9 avec succ\xe8s"
    }), VY = xa({
        bN: "Uploading of ",
        bT: "L'upload de "
    }), OY = xa({
        bN: " uploading",
        bT: " est en cours d\u2019upload"
    }), zY = xa({
        bN: " and ",
        bT: " et "
    }), EY = xa({
        bN: " error ",
        bT: " erreur "
    }), HY = xa({
        bN: " errors ",
        bT: " erreurs "
    }), RY = xa({
        bN: " failed. Report generation impossible",
        bT: " a \xe9chou\xe9e. Impossible de g\xe9n\xe9rer le rapport"
    }), WY = xa({
        bN: "Automated analysis ",
        bT: "L'analyse automatique du fichier "
    }), UY = xa({
        bN: " archived program",
        bT: " a archiv\xe9 le programme"
    }), QY = xa({
        bN: " commented program",
        bT: " a comment\xe9 le programme"
    }), _Y = xa({
        bN: " deleted ",
        bT: " a supprim\xe9 "
    }), ZY = xa({
        bN: " downloaded program",
        bT: " a t\xe9l\xe9charg\xe9 le programme"
    }), KY = xa({
        bN: "program accepted by ",
        bT: "le programme a \xe9t\xe9 accept\xe9 par "
    }), XY = xa({
        bN: " required a new version",
        bT: " a demand\xe9 une nouvelle version du programme"
    }), JY = xa({
        bN: " created program",
        bT: " a cr\xe9\xe9 le programme"
    }), YY = xa({
        bN: " from organization ",
        bT: " de l\u2019organisation "
    }), GY = xa({
        bN: " created SFTP access.",
        bT: " a cr\xe9\xe9 un acc\xe9s SFTP."
    }), nG = xa({
        bN: " deleted program",
        bT: " a supprim\xe9 le programme"
    }), rG = xa({
        bN: " unarchived program",
        bT: " a d\xe9sarchiv\xe9 le programme"
    }), tG = xa({
        bN: " undeleted program",
        bT: " a restaur\xe9 le programme"
    }), eG = function(n) {
        switch(n.$){
            case 4:
                return function(n) {
                    switch(n.c$){
                        case 0:
                            return $(n.dt.n6, JY);
                        case 1:
                            return $(KY, $(n.dt.n6, A2(ju, " ", A2(Lu, function(n) {
                                return $(YY, n);
                            }, n.dt.gm))));
                        default:
                            return $(n.dt.n6, XY);
                    }
                }(n.a);
            case 3:
                return $(n.a.dt.n6, QY);
            case 1:
                return $(ZJ, $(n.a.cS, KJ));
            case 0:
                return function(n) {
                    var r = n.cS, t = n.bl;
                    if (1 === n.lo.$) {
                        if (1 === t.$) return $(WY, $(r, QJ));
                        var e = t.a;
                        return $(WY, $(r, $(CY, $(Mt(e.n8), $(e.n8 > 1 ? HY : EY, $(zY, $(Mt(e.aq), e.aq > 1 ? BY : DY)))))));
                    }
                    return $(WY, $(r, RY));
                }(n.a);
            case 2:
                return e = (t = n.a).cW, u = t.c7, o = t.lo, i = t.c3, c = t.c4, f = t.c5, s = t.aX, l = t.dy, m = t.dJ, A6(IY, t.cS, A4(TY, F3(function(n, r, t) {
                    return {
                        aX: s,
                        dz: n,
                        dA: r,
                        sz: t
                    };
                }), i, c, f), e, t.c$ ? 1 === o.$ ? u ? $(CY, $(Mt(u), 1 === u ? DY : BY)) : HJ : RJ : QJ, l, m);
            case 5:
                return function(n) {
                    var r, t = (r = n.c6).$ ? "" : "(" + Mt(r.a) + " " + xY + ")", e = d(n.c$, n.lo);
                    return e.a ? 1 === e.b.$ ? $(n.rW, $(qY, t)) : $(VY, $(n.rW, RJ)) : $(n.rW, OY);
                }(n.a);
            case 6:
                return function(n) {
                    return $(n.dt.n6, $(A2(ju, "", A2(Lu, function(n) {
                        return " (" + n + ") ";
                    }, n.dt.gm)), GY));
                }(n.a);
            case 7:
                return (r = n.a).dt.n6 + (A2(ju, "", A2(Lu, function(n) {
                    return " (" + n + ") ";
                }, r.dt.gm)) + (ZY + " ")) + r.cS;
            case 8:
                return $(n.a.dt.n6, UY);
            case 11:
                return $(n.a.dt.n6, rG);
            case 9:
                return $(n.a.dt.n6, nG);
            case 10:
                return $(n.a.dt.n6, tG);
            case 12:
                return function(n) {
                    return $(n.dt.n6, $(_Y, n.cT));
                }(n.a);
            case 13:
                return function(n) {
                    var r = n.dt, t = n.rP, e = n.cJ, u = n.sk, o = n.cO, i = !n.qK;
                    switch(n.c$){
                        case 0:
                            return a(r.mo, t.mo) ? $(r.n6, $(XJ, $(A3(gY, e, u, i), eY(o)))) : $(r.n6, $(nY, $(t.n6, $(A3(gY, e, u, i), eY(o)))));
                        case 1:
                            return a(r.mo, t.mo) ? $(r.n6, $(GJ, $(A3(gY, e, u, i), eY(o)))) : $(r.n6, $(GJ, $(t.n6, $(A3(gY, e, u, i), eY(o)))));
                        default:
                            return a(r.mo, t.mo) ? $(r.n6, JJ) : $(r.n6, $(YJ, $(t.n6, A3(gY, e, u, i))));
                    }
                }(n.a);
            case 14:
                return function(n) {
                    var r = n.du, t = n.cS, e = n.dm;
                    if (n.cp) return "";
                    if (n.c$) {
                        if (1 === n.lo.$) {
                            if (1 === t.$) return $(UJ, $(r, 1 === e.$ ? HJ : $(_J, $(e.a, HJ))));
                            var u = t.a;
                            return $(UJ, $(r, 1 === e.$ ? $(WJ, u) : $(_J, $(e.a, $(WJ, u)))));
                        }
                        return $(UJ, $(r, 1 === e.$ ? RJ : $(_J, $(e.a, RJ))));
                    }
                    return $(UJ, $(r, 1 === e.$ ? QJ : $(_J, $(e.a, QJ))));
                }(n.a);
            default:
                return function(n) {
                    return $(kY, A2(ju, hY, A2(Lu, function(n) {
                        return n.la;
                    }, n.dt)));
                }(n.a);
        }
        var r, t, e, u, o, i, c, f, s, l, m;
    }, uG = function(n) {
        switch(n.$){
            case 4:
            case 3:
            case 6:
            case 7:
            case 8:
            case 11:
            case 9:
            case 10:
            case 12:
            case 13:
                return {
                    mo: (r = n.a).mo,
                    g9: r.g9,
                    dt: ht(r.dt),
                    hD: r.hD,
                    h_: r.h_,
                    rW: r.rW
                };
            default:
                var r;
                return {
                    mo: (r = n.a).mo,
                    g9: r.g9,
                    dt: kt,
                    hD: r.hD,
                    h_: r.h_,
                    rW: r.rW
                };
        }
    }, oG = A2(Pi, uG, function(n) {
        return n.h_;
    }), aG = A2(xt, F2(function(n, r) {
        var t = eG(n), e = d(n, r);
        switch(e.a.$){
            case 4:
                var u = e.b;
                return A2(EJ, A2((i = e.a.a).c$ ? IJ : NJ, t, i.h_), u);
            case 3:
                return u = e.b, A2(EJ, A2(yJ, t, (i = e.a.a).h_), u);
            case 1:
                return u = e.b, A2(EJ, A2(LJ, t, (i = e.a.a).h_), u);
            case 0:
                u = e.b;
                var o = (i = e.a.a).bl;
                return A2(EJ, A2(o.$ ? qJ : o.a.n8 > 0 ? VJ : OJ, t, i.h_), u);
            case 2:
                return u = e.b, A2(EJ, A2((i = e.a.a).c$ ? FJ : jJ, t, i.h_), u);
            case 5:
                return u = e.b, (i = e.a.a).c$ ? a(i.lo, kt) ? A2(EJ, A2(xJ, t, i.h_), u) : A2(EJ, A2(DJ, t, i.h_), u) : A2(EJ, A2(BJ, t, i.h_), u);
            case 8:
                return u = e.b, A2(EJ, A2(AJ, t, (i = e.a.a).h_), u);
            case 11:
                var i;
                return u = e.b, A2(EJ, A2(MJ, t, (i = e.a.a).h_), u);
            default:
                return u = e.b, A2(EJ, A2(IJ, t, oG(e.a)), u);
        }
    }), kt), iG = A2(Pi, uG, function(n) {
        return n.g9;
    }), cG = A2(Pi, uG, function(n) {
        return n.rW;
    }), fG = F3(function(n, r, t) {
        return A2(hi, n, function(n) {
            return ht(1 === n.$ ? A2(Vh, r, k([
                t
            ])) : A3(hi, r, function(n) {
                return ht(1 === n.$ ? k([
                    t
                ]) : A2(mt, t, n.a));
            }, n.a));
        });
    }), sG = (YU = F2(function(n, r) {
        return {
            e2: A2(Ra, A2(bu, A2(bu, me(-1), jP), oG), r),
            aI: !0,
            qJ: A2(ju, "", A2(Lu, iG, Eo(r))),
            P: aG(r),
            hZ: n,
            rW: A2(ju, "", A2(Lu, cG, Eo(r)))
        };
    }), A2(Pi, A2(Je, F2(function(n, r) {
        return A4(fG, LH(oG(n)), iG(n), n, r);
    }), Su), Gi(F2(function(n, r) {
        return A2(Gi, YU, r);
    })))), lG = F2(function(n, r) {
        return A2(Lu, function(n) {
            return n.mo;
        }, Eo(A2(Kc, function(r) {
            var t = r.fB;
            return a(r.st.mo, n.st.mo) ? ht(t) : kt;
        }, r.fD)));
    }), dG = F2(function(n, r) {
        return A2(kX, A2(Ye, cp(n), r.C), r);
    }), mG = F2(function(n, r) {
        return A2(zZ, A2(Lu, n, r.aa), r);
    }), bG = F2(function(n, r) {
        return A2(bu, mG(n), dG(r));
    }), pG = F2(function(n, r) {
        return A2(hi, n, function(n) {
            return n.$ ? kt : ht(A3(hi, r, function(n) {
                if (n.$) return kt;
                var r = n.a;
                return ht(p(r, {
                    aI: !r.aI
                }));
            }, n.a));
        });
    }), vG = function(n) {
        return {
            $: 10,
            a: n
        };
    }, $G = function(n) {
        return {
            $: 8,
            a: n
        };
    }, wG = function(n) {
        return {
            $: 12,
            a: n
        };
    }, gG = function(n) {
        return {
            $: 14,
            a: n
        };
    }, hG = F5(function(n, r, t, e, u) {
        return {
            cJ: e,
            la: n,
            cO: u,
            nP: r,
            sk: t
        };
    }), kG = Fi(A4(qi, "expireAt", function(n) {
        return n.cO;
    }, tm, A4(rc, "download", function(n) {
        return n.cJ;
    }, ri, A4(rc, "upload", function(n) {
        return n.sk;
    }, ri, A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, A4(rc, "email", function(n) {
        return n.la;
    }, Oa, Mi(hG))))))), CG = F2(function(n, r) {
        return mc(A2(nw, Ev, A3(ow, kG, r, rw(dl(yv(A2(Nv, n.mo, 5)))))));
    }), TG = function(n) {
        return p(n, {
            lo: kt
        });
    }, PG = function(n) {
        return {
            $: 14,
            a: n
        };
    }, SG = function(n) {
        return dl(PG(function(n) {
            return {
                $: 0,
                a: n
            };
        }(n)));
    }, AG = function(n) {
        return sp(function(r) {
            return Eo(A2(Kc, function(r) {
                var t = r.fB;
                return a(r.st.mo, n.st.mo) ? ht(t.mo) : kt;
            }, r.fD));
        });
    }, yG = function(n) {
        return A2($d, "", function(r) {
            if (a(xe(r), n)) {
                var t = He(r);
                return t.$ ? Zl('Invalid integer: "' + r + '"') : A2(pd, id, Kl(t.a));
            }
            return A2(pd, function(n) {
                return cd(A2(Hu, r, n));
            }, _l(ld(Qt)));
        });
    }, NG = function(n) {
        var r = n.b, t = n.c;
        return Bd(A2(AH, 4, n.a) + "-" + A2(AH, 2, r) + "-" + A2(AH, 2, t) + "T00:00:00.000Z");
    }, LG = function(n) {
        var r = A2(ed, A2(ed, A2(ed, Kl(F3(function(n, r, t) {
            return m(n, r, t);
        })), A2(rd, yG(4), kd("-"))), A2(rd, yG(2), kd("-"))), yG(2));
        return A2(PR, NG, A2(ha, Dl("Can't parse date"), A2(Id, r, n)));
    }, jG = F5(function(n, r, t, e, u) {
        return {
            ki: u,
            fs: n,
            fW: t,
            o_: e,
            gy: r
        };
    }), FG = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: Di(k([
                A3(Le, F2(function(n, r) {
                    return n(r);
                }), u.e, Bi(A2(du, n, pa(t))))
            ])),
            g: function(e) {
                return A2(mt, d(n, A2(Ii, xi(t), r(e))), u.g(e));
            }
        };
    }), MG = Fi(A4(FG, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(FG, "password", function(n) {
        return n.o_;
    }, Oa, A4(rc, "login", function(n) {
        return n.fW;
    }, Oa, A4(rc, "port", function(n) {
        return n.gy;
    }, uc, A4(rc, "hostname", function(n) {
        return n.fs;
    }, Oa, Mi(jG))))))), IG = function(n) {
        return dl(PG(function(n) {
            return {
                $: 1,
                a: n
            };
        }(n)));
    }, DG = function(n) {
        return mc(A2(Wi, MG, rw(IG(n))));
    }, BG = function(n) {
        return mc(sw(fw(IG(n))));
    }, xG = F2(function(n, r) {
        return A2(xX, $(n, r.lq), r);
    }), qG = F4(function(n, r, t, e) {
        switch(n.$){
            case 0:
                return EZ(p(r, {
                    la: A2(ww, n.a, r.la)
                }));
            case 1:
                return EZ(p(r, {
                    nP: A2(ww, n.a, r.nP)
                }));
            case 2:
                return EZ(p(r, {
                    lt: A2(ww, n.a, r.lt)
                }));
            case 4:
                return EZ(p(r, {
                    jz: A2(vw, n.a, r.jz)
                }));
            case 3:
                return EZ(p(r, {
                    jA: A2(vw, n.a, r.jA)
                }));
            case 5:
                return EZ(r);
            case 6:
                return EZ(p(r, {
                    kU: !r.kU
                }));
            case 7:
                return A2(BX, k([
                    A2(Xa, $G, (m = n.a, mc(sw(fw(SG(m.mo))))))
                ]), EZ(TG(r)));
            case 8:
                return (u = n.a).$ ? EZ(p(r, {
                    lo: ht(u.a)
                })) : (d = k([
                    4
                ]), A2(xX, d, OZ));
            case 10:
                var u;
                return (u = n.a).$ ? EZ(p(r, {
                    lo: ht(u.a)
                })) : A2(xG, k([
                    4
                ]), EZ(p(r, {
                    jz: $f,
                    jA: gf,
                    kU: !1,
                    la: Cf,
                    lt: Pf,
                    nP: Af
                })));
            case 9:
                var o = n.a, i = A2(ha, function() {
                    return kt;
                }, A2(X$, Me, LG(r.lt.sw))), c = {
                    cJ: r.jz.sw,
                    la: r.la.sw,
                    cO: i.$ ? kt : ht(i.a),
                    nP: r.nP.sw,
                    sk: r.jA.sw
                };
                return A2(BX, k([
                    A2(Xa, vG, A2(CG, o, c))
                ]), EZ(TG(r)));
            case 11:
                var f = A2(AG, t, e);
                if (f.$) return OZ;
                var s = f.a;
                return a(r.l_, kt) ? KX(A2(Xa, wG, function(n) {
                    return A2(BT, function() {
                        return DG(n);
                    }, BG(n));
                }(s))) : KX(A2(Xa, wG, DG(s)));
            case 12:
                return EZ(p(r, {
                    l_: ht(n.a)
                }));
            case 13:
                var l = A2(AG, t, e);
                return l.$ ? OZ : KX(A2(Xa, gG, BG(s = l.a)));
            default:
                return EZ(p(r, 1 === n.a.$ ? {
                    l_: ht(Ct(n.a.a))
                } : {
                    l_: kt
                }));
        }
        var d, m;
    }), VG = function(n) {
        return {
            $: 3,
            a: n
        };
    }, OG = function(n) {
        return {
            $: 4,
            a: n
        };
    }, zG = function(n) {
        return {
            $: 5,
            a: n
        };
    }, EG = function(n) {
        return {
            $: 3,
            a: n
        };
    }, HG = {
        $: 1
    }, RG = {
        $: 2
    }, WG = function(n) {
        return dl(jX(A2(LX, n, 7)));
    }, UG = function(n) {
        return mc(sw(rw(WG(n))));
    }, QG = function(n) {
        return mc(W_(rw(function(n) {
            return dl(yv(A2(Nv, n, 1)));
        }(n))));
    }, _G = function(n) {
        return mc(sw(rw(function(n) {
            return dl(jX(A2(LX, n, 9)));
        }(n))));
    }, ZG = function(n) {
        return mc(W_(rw(function(n) {
            return dl(yv(A2(Nv, n, 3)));
        }(n))));
    }, KG = function(n) {
        return dl(jX(A2(LX, n, 8)));
    }, XG = function(n) {
        return mc(sw(rw(KG(n))));
    }, JG = function(n) {
        return mc(W_(rw(function(n) {
            return dl(yv(A2(Nv, n, 2)));
        }(n))));
    }, YG = function(n) {
        return mc(sw(rw(function(n) {
            return dl(jX(A2(LX, n, 10)));
        }(n))));
    }, GG = function(n) {
        return mc(W_(rw(function(n) {
            return dl(yv(A2(Nv, n, 4)));
        }(n))));
    }, n1 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return EZ(p(r, {
                    P: Nf
                }));
            case 1:
                return EZ(p(r, {
                    oD: !r.oD
                }));
            case 2:
                return EZ(p(r, {
                    oF: !r.oF
                }));
            case 3:
                return (t = n.a).$ ? EZ(p(r, {
                    P: EG(t.a)
                })) : A2(xG, k([
                    4,
                    0,
                    1
                ]), EZ(p(r, {
                    P: RG
                })));
            case 4:
                return (t = n.a).$ ? EZ(p(r, {
                    r7: EG(t.a)
                })) : A2(xG, k([
                    4,
                    0,
                    1
                ]), EZ(p(r, {
                    r7: RG
                })));
            case 5:
                var t;
                return (t = n.a).$ ? EZ(p(r, {
                    sh: EG(t.a)
                })) : A2(xG, k([
                    4,
                    0,
                    1
                ]), EZ(p(r, {
                    sh: RG
                })));
            case 6:
                return A2(BX, k([
                    A2(Xa, VG, ((e = n.a).mV ? UG : QG)(e.mo))
                ]), EZ(p(r, {
                    P: HG
                })));
            case 7:
                return A2(BX, k([
                    A2(Xa, VG, ((e = n.a).mV ? XG : JG)(e.mo))
                ]), EZ(p(r, {
                    P: HG
                })));
            case 8:
                return A2(BX, k([
                    A2(Xa, OG, ((e = n.a).mV ? _G : ZG)(e.mo))
                ]), EZ(p(r, {
                    P: HG
                })));
            default:
                var e;
                return A2(BX, k([
                    A2(Xa, zG, ((e = n.a).mV ? YG : GG)(e.mo))
                ]), EZ(p(r, {
                    P: HG
                })));
        }
    }), r1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, t1 = {
        $: 1
    }, e1 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, u1 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, o1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, a1 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, i1 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, c1 = function(n) {
        return mc(A2(Wi, MG, rw(IG(n))));
    }, f1 = function(n) {
        return mc(sw(fw(IG(n))));
    }, s1 = F2(function(n, r) {
        switch(n.$){
            case 1:
                return EZ(p(r, {
                    gk: !r.gk
                }));
            case 0:
                var t = n.a;
                return A2(CX, A2(Xa, r1, mc(A2(Wi, MG, Ai(IG(t))))), EZ(p(r, {
                    fB: t,
                    gk: !0
                })));
            case 3:
                switch(r.l_.$){
                    case 3:
                    case 2:
                        return KX(A2(Xa, a1, A2(BT, function() {
                            return c1(e);
                        }, f1(e = r.fB))));
                    default:
                        return KX(A2(Xa, a1, c1(r.fB)));
                }
            case 2:
                return EZ(p(r, n.a.$ ? {
                    l_: t1
                } : {
                    l_: o1(n.a.a)
                }));
            case 4:
                return EZ(p(r, n.a.$ ? {
                    l_: u1(n.a.a)
                } : {
                    l_: e1(n.a.a)
                }));
            case 5:
                return KX(A2(Xa, i1, f1(r.fB)));
            default:
                return EZ(p(r, 1 === n.a.$ ? {
                    l_: u1(n.a.a)
                } : {
                    l_: t1,
                    gk: !1
                }));
        }
        var e;
    }), l1 = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return KX(Kv(r.mo));
            case 2:
                if ((u = n.a).$) return EZ(p(r, {
                    e2: A2(KK, u.a, r.e2.kx)
                }));
                var e = u.a;
                return EZ(p(r, {
                    e2: PX(e),
                    rV: sG(e)
                }));
            case 1:
                var u;
                if ((u = n.a).$) return EZ(p(r, {
                    P: A2(KK, u.a, r.P.kx)
                }));
                var o = u.a;
                return A2(CX, function() {
                    var n = A2(lG, t, o);
                    if (n.$) return n$;
                    var r = n.a;
                    return A2(Yv, A2(bu, PJ, CJ), iP(r));
                }(), EZ(p(r, {
                    no: !1,
                    P: PX(o)
                })));
            case 4:
                return A3(bG, function(n) {
                    return p(r, {
                        cJ: n
                    });
                }, PJ, A2(s1, n.a, r.cJ));
            case 5:
                return A3(bG, function(n) {
                    return p(r, {
                        d2: n
                    });
                }, TJ, A2(n1, n.a, r.d2));
            case 6:
                return A3(bG, function(n) {
                    return p(r, {
                        fD: n
                    });
                }, SJ, A4(qG, n.a, r.fD, t, r.P.kx));
            default:
                var a = n.a;
                return EZ(p(r, {
                    rV: A3(pG, a.a, a.b, r.rV)
                }));
        }
    }), d1 = F2(function(n, r) {
        return p(r, 0 === n.$ ? {
            aL: 1
        } : {
            aL: 0
        });
    }), m1 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, b1 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, p1 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, v1 = function(n) {
        return {
            $: 12,
            a: n
        };
    }, $1 = function(n) {
        return {
            $: 26,
            a: n
        };
    }, w1 = function(n) {
        return {
            $: 30,
            a: n
        };
    }, g1 = function(n) {
        return {
            $: 15,
            a: n
        };
    }, h1 = function(n) {
        return {
            $: 14,
            a: n
        };
    }, k1 = function(n) {
        return {
            $: 9,
            a: n
        };
    }, C1 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, T1 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, P1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, S1 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, A1 = function(n) {
        return {
            $: 40,
            a: n
        };
    }, y1 = function(n) {
        return {
            $: 13,
            a: n
        };
    }, N1 = function(n) {
        return {
            $: 22,
            a: n
        };
    }, L1 = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), j1 = function(n) {
        return {
            $: 24,
            a: n
        };
    }, F1 = function(n) {
        return {
            $: 28,
            a: n
        };
    }, M1 = F3(function(n, r, t) {
        return A2(Jf, r, A8(xf, n, Vf(n), t, 0, 0, 0, 0, 0));
    }), I1 = F3(function(n, r, t) {
        return A3(xt, F2(function(r, t) {
            return Qf(p(t, {
                lV: A2(n, t.lV, r.lV)
            }));
        }), r, A2(Ye, function(n) {
            return A3(M1, r.fg, n, r.eT);
        }, t));
    }), D1 = F2(function(n, r) {
        return A3(I1, Nt, n, r);
    }), B1 = F2(function(n, r) {
        return A2(D1, r, k([
            n
        ]));
    }), x1 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, q1 = A2(bu, wJ, x1), V1 = function(n) {
        return dl(Wx(A2(Oz, n, 0)));
    }, O1 = function(n) {
        return mc(sw(fw(V1(n))));
    }, z1 = Zn("downloadAll", ga), E1 = function(n) {
        return A2(kX, n, OZ);
    }, H1 = function(n) {
        return A2(xX, k([
            n
        ]), OZ);
    }, R1 = F6(function(n, r, t, e, u, o) {
        return (function(n) {
            return function(r) {
                return function(t) {
                    return function(e) {
                        return function(u) {
                            return function(o) {
                                return function(a) {
                                    return function(i) {
                                        return function(c) {
                                            return function(f) {
                                                return {
                                                    i3: i,
                                                    en: c,
                                                    eU: t,
                                                    lW: a,
                                                    fL: f,
                                                    n3: r,
                                                    qq: u,
                                                    qr: o,
                                                    q5: n,
                                                    rp: e
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        })(n)(r)(t)(kt)(e)(w)(u)(o)(kt)(kt);
    }), W1 = F2(function(n, r) {
        if (1 === r.$) return n.R;
        var t = r.a;
        return A2(ju, n.R, Eo(A2(Mu, function(n) {
            return a(n.bD.mo, t);
        }, n.bj)));
    }), U1 = F2(function(n, r) {
        return A2(W1, r, n.oX.bD);
    }), Q1 = F3(function(n, r, t) {
        return Eo(A2(Mu, function(n) {
            return a(n.lD.mo, t);
        }, A2(U1, n, r).bQ.d7));
    }), _1 = F3(function(n, r, t) {
        return A2(sp, A2(Pi, function(n) {
            return n.pm;
        }, function(n) {
            return n.nw;
        }), A3(Q1, n, r, t));
    }), Z1 = function(n) {
        return 1 === n.$ ? ht(n.a) : kt;
    }, K1 = function(n) {
        switch(n){
            case 0:
                return "mono";
            case 1:
                return "dual mono";
            case 2:
                return "stereo";
            case 3:
                return "stereo L";
            case 4:
                return "stereo R";
            case 5:
                return "5.1";
            case 6:
                return "5.1 L";
            case 7:
                return "5.1 R";
            case 8:
                return "5.1 C";
            case 9:
                return "5.1 SL";
            case 10:
                return "5.1 SR";
            case 11:
                return "5.1 LFE";
            case 12:
                return "7.1";
            default:
                return "multiple audio on 1 track";
        }
    }, X1 = function(n) {
        return A2(Ye, function(n) {
            return A2(V$, n.fv, A2(Lu, K1, n.aC));
        }, A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, Z1, n.av)));
    }, J1 = function(n) {
        return A2(Ye, function(n) {
            return A2(V$, n.fv, A2(Lu, K1, n.aC));
        }, A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, Z1, n.av)));
    }, Y1 = function(n) {
        return n.$ ? kt : ht(n.a);
    }, G1 = function(n) {
        return A2(ju, function(n) {
            return A2(ju, kt, A2(Lu, function(n) {
                return n.eU;
            }, function(n) {
                return Eo(A2(Ra, function(n) {
                    return n.fv;
                }, A2(Kc, Z1, n.av)));
            }(n)));
        }(n), A2(Lu, function(n) {
            return n.eU;
        }, Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, Y1, n.av)))));
    }, n0 = function(n) {
        return A2(ju, kt, A2(Lu, function(n) {
            return n.eU;
        }, function(n) {
            return Eo(A2(Ra, function(n) {
                return n.fv;
            }, A2(Kc, Z1, n.av)));
        }(n)));
    }, r0 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), t0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, e0 = function(n) {
        return mc(A2(Wi, Pb, Ai(function(n) {
            return yi(t0(A2(r0, n, 1)));
        }(n))));
    }, u0 = function(n) {
        return qf(1e3 * n.at / n.as) / 1e3;
    }, o0 = function(n) {
        return A2(Lu, u0, Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, Y1, n.av))));
    }, a0 = F6(function(n, r, t, e, u, o) {
        return {
            iJ: e,
            ki: t,
            mo: n,
            nr: u,
            n6: r,
            oa: o
        };
    }), i0 = Fi(A4(rc, "needAccept", function(n) {
        return n.oa;
    }, ri, A4(qi, "logo", function(n) {
        return n.nr;
    }, Oa, A4(rc, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iJ;
    }, ri, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(a0)))))))), c0 = function(n) {
        return mc(A2(Wi, i0, Ai(function(n) {
            return yi(I$(A2(yD, n, 6)));
        }(n))));
    }, f0 = function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return {
                                                R: a,
                                                cz: c,
                                                bK: r,
                                                bP: o,
                                                fD: f,
                                                cZ: u,
                                                c2: e,
                                                oM: t,
                                                bj: i,
                                                g9: n
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, s0 = F3(function(n, r, t) {
        return {
            bD: n,
            bJ: t,
            bQ: r
        };
    }), l0 = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            ki: t,
            eO: e,
            eU: u,
            fg: o,
            fi: c,
            mo: n,
            di: a,
            g9: r,
            h8: i
        };
    }), d0 = Fi(A4(qi, "generatedWithMapping", function(n) {
        return n.fi;
    }, ib, A4(qi, "uploadLog", function(n) {
        return n.h8;
    }, Oa, A4(qi, "rejection", function(n) {
        return n.di;
    }, Oa, A4(qi, "framerate", function(n) {
        return n.fg;
    }, dA, A4(qi, "duration", function(n) {
        return n.eU;
    }, dA, A4(qi, "deliveryProgress", function(n) {
        return n.eO;
    }, uc, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(l0))))))))))), m0 = F3(function(n, r, t) {
        return {
            d7: r,
            f$: n,
            ad: t
        };
    }), b0 = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            a6: r,
            kI: a,
            lD: n,
            pm: e,
            gP: o,
            gQ: u,
            g3: i,
            av: t,
            hH: c
        };
    }), p0 = F4(function(n, r, t, e) {
        return {
            mo: n,
            gm: t,
            rW: r,
            r6: e
        };
    }), v0 = Fi(A4(rc, "transcoding", function(n) {
        return n.r6;
    }, jO, A4(rc, "organizationName", function(n) {
        return n.gm;
    }, Oa, A4(rc, "title", function(n) {
        return n.rW;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(p0)))))), $0 = F6(function(n, r, t, e, u, o) {
        return {
            ah: u,
            eU: e,
            z: n,
            fb: t,
            cW: r,
            hY: o
        };
    }), w0 = Fi(A4(qi, "timecode", function(n) {
        return n.hY;
    }, Oa, A4(qi, "bitRate", function(n) {
        return n.ah;
    }, uc, A4(qi, "duration", function(n) {
        return n.eU;
    }, dA, A4(rc, "formatLongName", function(n) {
        return n.fb;
    }, Oa, A4(rc, "formatName", function(n) {
        return n.cW;
    }, Oa, A4(rc, "fileId", function(n) {
        return n.z;
    }, Oa, Mi($0)))))))), g0 = F7(function(n, r, t, e, u, o, a) {
        return {
            ki: e,
            bK: t,
            lD: u,
            bb: o,
            bc: a,
            mo: n,
            m7: r
        };
    }), h0 = function(n) {
        switch(n){
            case 0:
                return "openingCredits";
            case 1:
                return "endingCredits";
            case 2:
                return "introduction";
            case 3:
                return "program";
            case 4:
                return "trailer";
            case 5:
                return "advertising";
            case 6:
                return "testPattern";
            case 7:
                return "black";
            case 8:
                return "slate";
            case 9:
                return "neutralBases";
            default:
                return "customDelivery";
        }
    }, k0 = function(n) {
        switch(n){
            case "openingCredits":
                return At(0);
            case "endingCredits":
                return At(1);
            case "introduction":
                return At(2);
            case "program":
                return At(3);
            case "trailer":
                return At(4);
            case "advertising":
                return At(5);
            case "testPattern":
                return At(6);
            case "black":
                return At(7);
            case "slate":
                return At(8);
            case "neutralBases":
                return At(9);
            case "customDelivery":
                return At(10);
            default:
                return Ct("Can't parse segment from string: " + n);
        }
    }, C0 = A2(Ml, h0, k0), T0 = Fi(A4(rc, "frameOut", function(n) {
        return n.bc;
    }, uc, A4(rc, "frameIn", function(n) {
        return n.bb;
    }, uc, A4(rc, "file", function(n) {
        return n.lD;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "creator", function(n) {
        return n.bK;
    }, Uv, A4(rc, "label", function(n) {
        return n.m7;
    }, C0, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(g0))))))))), P0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, S0 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, A0 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, y0 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, N0 = function(n) {
        switch(n){
            case "Mono":
                return At(0);
            case "DualMono":
                return At(1);
            case "Stereo":
                return At(2);
            case "StereoL":
                return At(3);
            case "StereoR":
                return At(4);
            case "FiveDotOne":
                return At(5);
            case "FiveDotOneL":
                return At(6);
            case "FiveDotOneR":
                return At(7);
            case "FiveDotOneC":
                return At(8);
            case "FiveDotOneSL":
                return At(9);
            case "FiveDotOneSR":
                return At(10);
            case "FiveDotOneLFE":
                return At(11);
            case "SevenDotOne":
                return At(12);
            case "OneTrack":
                return At(13);
            default:
                return Ct("Unknown Layout");
        }
    }, L0 = function(n) {
        switch(n){
            case 0:
                return "Mono";
            case 1:
                return "DualMono";
            case 2:
                return "Stereo";
            case 3:
                return "StereoL";
            case 4:
                return "StereoR";
            case 5:
                return "FiveDotOne";
            case 6:
                return "FiveDotOneL";
            case 7:
                return "FiveDotOneR";
            case 8:
                return "FiveDotOneC";
            case 9:
                return "FiveDotOneSL";
            case 10:
                return "FiveDotOneSR";
            case 11:
                return "FiveDotOneLFE";
            case 12:
                return "SevenDotOne";
            default:
                return "OneTrack";
        }
    }, j0 = A2(Ml, L0, N0), F0 = function(n) {
        switch(n){
            case "ORIGINAL":
                return At(0);
            case "DUBBED":
                return At(1);
            case "AD":
                return At(2);
            case "MUTE":
                return At(3);
            case "INT":
                return At(4);
            case "ME":
                return At(5);
            case "VONLY":
                return At(6);
            case "C1":
                return At(7);
            case "C2":
                return At(8);
            case "C3":
                return At(9);
            case "C4":
                return At(10);
            case "C5":
                return At(11);
            case "C6":
                return At(12);
            case "C7":
                return At(13);
            case "C8":
                return At(14);
            case "C9":
                return At(15);
            case "C10":
                return At(16);
            default:
                return Ct("Not an audio type version");
        }
    }, M0 = function(n) {
        switch(n){
            case 0:
                return "ORIGINAL";
            case 1:
                return "DUBBED";
            case 2:
                return "AD";
            case 3:
                return "MUTE";
            case 4:
                return "INT";
            case 5:
                return "ME";
            case 6:
                return "VONLY";
            case 7:
                return "C1";
            case 8:
                return "C2";
            case 9:
                return "C3";
            case 10:
                return "C4";
            case 11:
                return "C5";
            case 12:
                return "C6";
            case 13:
                return "C7";
            case 14:
                return "C8";
            case 15:
                return "C9";
            default:
                return "C10";
        }
    }, I0 = A2(Ml, M0, F0), D0 = Fi(A4(qi, "typeVersion", function(n) {
        return n.r9;
    }, I0, A4(qi, "version", function(n) {
        return n.sz;
    }, g$, A4(qi, "channelLayout", function(n) {
        return n.aC;
    }, j0, A4(qi, "bitRate", function(n) {
        return n.ah;
    }, uc, A4(rc, "bitsPerSample", function(n) {
        return n.eg;
    }, uc, A4(rc, "channels", function(n) {
        return n.cz;
    }, uc, A4(rc, "sampleFormat", function(n) {
        return n.gZ;
    }, Oa, A4(rc, "sampleRate", function(n) {
        return n.g_;
    }, uc, A4(qi, "duration", function(n) {
        return n.eU;
    }, dA, A4(rc, "codecLongName", function(n) {
        return n.aE;
    }, Oa, A4(rc, "codecName", function(n) {
        return n.ai;
    }, Oa, A4(rc, "index", function(n) {
        return n.fv;
    }, uc, A4(rc, "fileId", function(n) {
        return n.z;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            ah: f,
                                                            eg: c,
                                                            aC: s,
                                                            cz: i,
                                                            aE: e,
                                                            ai: t,
                                                            eU: u,
                                                            z: n,
                                                            fv: r,
                                                            gZ: a,
                                                            g_: o,
                                                            r9: d,
                                                            sz: l
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), B0 = F3(function(n, r, t) {
        return {
            z: n,
            fv: r,
            hY: t
        };
    }), x0 = Fi(A4(qi, "timecode", function(n) {
        return n.hY;
    }, Oa, A4(rc, "index", function(n) {
        return n.fv;
    }, uc, A4(rc, "fileId", function(n) {
        return n.z;
    }, Oa, Mi(B0))))), q0 = Fi(A4(qi, "typeVersion", function(n) {
        return n.r9;
    }, AA, A4(qi, "subtitleType", function(n) {
        return n.hE;
    }, Oa, A4(qi, "lastCueTimecode", function(n) {
        return n.fN;
    }, Oa, A4(qi, "firstCueTimecode", function(n) {
        return n.e8;
    }, Oa, A4(qi, "startTimecode", function(n) {
        return n.q5;
    }, Oa, A4(qi, "frameRateDenominator", function(n) {
        return n.fe;
    }, uc, A4(qi, "frameRateNumerator", function(n) {
        return n.ff;
    }, uc, A4(qi, "version", function(n) {
        return n.sz;
    }, g$, A4(qi, "codecLongName", function(n) {
        return n.aE;
    }, Oa, A4(qi, "codecName", function(n) {
        return n.ai;
    }, Oa, A4(rc, "index", function(n) {
        return n.fv;
    }, uc, A4(rc, "fileId", function(n) {
        return n.z;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        aE: e,
                                                        ai: t,
                                                        z: n,
                                                        e8: c,
                                                        fe: a,
                                                        ff: o,
                                                        fv: r,
                                                        fN: f,
                                                        q5: i,
                                                        hE: s,
                                                        r9: l,
                                                        sz: u
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), V0 = Fi(A4(qi, "nbFrames", function(n) {
        return n.gf;
    }, uc, A4(qi, "timecode", function(n) {
        return n.hY;
    }, Oa, A4(qi, "scanningType", function(n) {
        return n.g$;
    }, Oa, A4(qi, "chromaSubsampling", function(n) {
        return n.cA;
    }, Oa, A4(qi, "profile", function(n) {
        return n.gG;
    }, Oa, A4(qi, "level", function(n) {
        return n.nf;
    }, uc, A4(rc, "rFrameRateDenominator", function(n) {
        return n.as;
    }, uc, A4(rc, "rFrameRateNumerator", function(n) {
        return n.at;
    }, uc, A4(qi, "bitRate", function(n) {
        return n.ah;
    }, uc, A4(rc, "displayAspectRatioDenominator", function(n) {
        return n.cH;
    }, uc, A4(rc, "displayAspectRatioNumerator", function(n) {
        return n.cI;
    }, uc, A4(rc, "height", function(n) {
        return n.fm;
    }, uc, A4(rc, "width", function(n) {
        return n.ig;
    }, uc, A4(qi, "duration", function(n) {
        return n.eU;
    }, dA, A4(rc, "codecLongName", function(n) {
        return n.aE;
    }, Oa, A4(rc, "codecName", function(n) {
        return n.ai;
    }, Oa, A4(rc, "index", function(n) {
        return n.fv;
    }, uc, A4(rc, "fileId", function(n) {
        return n.z;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return {
                                                                                ah: f,
                                                                                cA: b,
                                                                                aE: e,
                                                                                ai: t,
                                                                                cH: c,
                                                                                cI: i,
                                                                                eU: u,
                                                                                z: n,
                                                                                fm: a,
                                                                                fv: r,
                                                                                nf: d,
                                                                                gf: $,
                                                                                gG: m,
                                                                                as: l,
                                                                                at: s,
                                                                                g$: p,
                                                                                hY: v,
                                                                                ig: o
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))), O0 = lm(A4(wb, "DataStream", S0, x0, A4(wb, "SubtitleStream", A0, q0, A4(wb, "AudioStream", P0, D0, A4(wb, "VideoStream", y0, V0, bm(F5(function(n, r, t, e, u) {
        switch(u.$){
            case 0:
                return n(u.a);
            case 1:
                return r(u.a);
            case 2:
                return t(u.a);
            default:
                return e(u.a);
        }
    }))))))), z0 = F2(function(n, r) {
        return {
            fo: r,
            nw: n
        };
    }), E0 = Fi(A4(qi, "hiRes", function(n) {
        return n.fo;
    }, Sz, A4(qi, "lowRes", function(n) {
        return n.nw;
    }, Sz, Mi(z0)))), H0 = F2(function(n, r) {
        return {
            n6: n,
            hY: r
        };
    }), R0 = Fi(A4(rc, "timecode", function(n) {
        return n.hY;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(H0)))), W0 = Fi(A4(rc, "subtitleWarnings", function(n) {
        return n.hH;
    }, ic(R0), A4(rc, "segments", function(n) {
        return n.g3;
    }, ic(T0), A4(rc, "deliveries", function(n) {
        return n.kI;
    }, ic(v0), A4(qi, "reportPdf", function(n) {
        return n.gP;
    }, Sz, A4(qi, "reportXml", function(n) {
        return n.gQ;
    }, Sz, A4(rc, "proxies", function(n) {
        return n.pm;
    }, E0, A4(rc, "streams", function(n) {
        return n.av;
    }, ic(O0), A4(qi, "container", function(n) {
        return n.a6;
    }, w0, A4(rc, "file", function(n) {
        return n.lD;
    }, Sz, Mi(b0))))))))))), U0 = Fi(A4(rc, "subtitles", function(n) {
        return n.ad;
    }, ic(W0), A4(rc, "audios", function(n) {
        return n.d7;
    }, ic(W0), A4(qi, "material", function(n) {
        return n.f$;
    }, W0, Mi(m0))))), Q0 = F2(function(n, r) {
        return {
            cU: n,
            sy: r
        };
    }), _0 = function(n) {
        switch(n){
            case "RedFlag":
                return At(0);
            case "OrangeFlag":
                return At(1);
            case "GreenFlag":
                return At(2);
            default:
                return At(3);
        }
    }, Z0 = function(n) {
        switch(n){
            case 0:
                return "RedFlag";
            case 1:
                return "OrangeFlag";
            case 2:
                return "GreenFlag";
            default:
                return "BlueFlag";
        }
    }, K0 = A2(Ml, Z0, _0), X0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, J0 = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Y0 = F3(function(n, r, t) {
        return {
            eT: t,
            lW: r,
            sw: n
        };
    }), G0 = Fi(A4(rc, "dropFrame", function(n) {
        return n.eT;
    }, ri, A4(rc, "frameRate", function(n) {
        return n.lW;
    }, dA, A4(rc, "value", function(n) {
        return n.sw;
    }, uc, Mi(Y0))))), n2 = F4(function(n, r, t, e) {
        return A3($b, n, F3(function(n, r, u) {
            return n(k([
                A2(Ii, t, r),
                A2(Ii, e, u)
            ]));
        }), A3(Le, r, A2(Vc, 1, pa(t)), A2(Vc, 2, pa(e))));
    }), r2 = lm(A5(n2, "VerificationRange", J0, G0, G0, A4(wb, "VerificationFrame", X0, G0, A3(vz, "Verification", as, bm(F4(function(n, r, t, e) {
        switch(e.$){
            case 0:
                return n;
            case 1:
                return r(e.a);
            default:
                return A2(t, e.a, e.b);
        }
    })))))), t2 = Fi(A4(rc, "verification", function(n) {
        return n.sy;
    }, r2, A4(rc, "flag", function(n) {
        return n.cU;
    }, K0, Mi(Q0)))), e2 = F7(function(n, r, t, e, u, o, a) {
        return {
            bI: o,
            ki: t,
            bK: r,
            mo: n,
            nP: a,
            cl: u,
            cm: e
        };
    }), u2 = Fi(A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, A4(rc, "comment", function(n) {
        return n.bI;
    }, Oa, A4(rc, "updatedAt", function(n) {
        return n.cl;
    }, tm, A4(rc, "updater", function(n) {
        return n.cm;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "creator", function(n) {
        return n.bK;
    }, Uv, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(e2))))))))), o2 = ic(u2), a2 = F3(function(n, r, t) {
        return {
            e: A2(Ne, n, pa(t)),
            g: function(n) {
                return A2(Ii, t, r(n));
            }
        };
    }), i2 = A3(a2, function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, function(n) {
        return n.a;
    }, Oa), c2 = Fi(A4(rc, "answers", function(n) {
        return n.d1;
    }, o2, A4(rc, "annotations", function(n) {
        return n.S;
    }, ic(t2), A4(qi, "frame", function(n) {
        return n.bU;
    }, G0, A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, A4(rc, "broadcastable", function(n) {
        return n.bD;
    }, Oa, A4(rc, "updatedAt", function(n) {
        return n.cl;
    }, tm, A4(rc, "updater", function(n) {
        return n.cm;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "creator", function(n) {
        return n.bK;
    }, Uv, A4(rc, "id", function(n) {
        return n.mo;
    }, i2, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return {
                                                S: c,
                                                d1: f,
                                                bD: o,
                                                ki: t,
                                                bK: r,
                                                bU: i,
                                                mo: n,
                                                nP: a,
                                                cl: u,
                                                cm: e
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), f2 = ic(c2), s2 = Fi(A4(rc, "comments", function(n) {
        return n.bJ;
    }, f2, A4(rc, "files", function(n) {
        return n.bQ;
    }, U0, A4(rc, "broadcastable", function(n) {
        return n.bD;
    }, d0, Mi(s0))))), l2 = ic(s2), d2 = F5(function(n, r, t, e, u) {
        return {
            a6: e,
            lD: n,
            gL: r,
            g3: t,
            av: u
        };
    }), m2 = Fi(A4(rc, "streams", function(n) {
        return n.av;
    }, ic(O0), A4(qi, "container", function(n) {
        return n.a6;
    }, w0, A4(rc, "segments", function(n) {
        return n.g3;
    }, ic(T0), A4(qi, "proxy", function(n) {
        return n.gL;
    }, Sz, A4(rc, "file", function(n) {
        return n.lD;
    }, Sz, Mi(d2))))))), b2 = ic(m2), p2 = F2(function(n, r) {
        return {
            fB: n,
            st: r
        };
    }), v2 = Fi(A4(rc, "user", function(n) {
        return n.st;
    }, Uv, A4(rc, "invitation", function(n) {
        return n.fB;
    }, Ev, Mi(p2)))), $2 = function(n) {
        switch(n){
            case "QC":
                return At(1);
            case "Spotcheck":
                return At(0);
            case "DownloadAsIs":
                return At(2);
            case "SimpleTranscode":
                return At(3);
            case "PADTranscode":
                return At(4);
            default:
                return Ct("Can't parse jobtype " + n);
        }
    }, w2 = A2(Ml, hs, $2), g2 = Fi(A4(qi, "format", function(n) {
        return n.lT;
    }, Oa, A4(qi, "externalJobId", function(n) {
        return n.lw;
    }, Oa, A4(rc, "jobType", function(n) {
        return n.fI;
    }, w2, A4(rc, "requester", function(n) {
        return n.pH;
    }, Oa, A4(rc, "organization", function(n) {
        return n.oM;
    }, Oa, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, A4(qi, "completedAt", function(n) {
        return n.j2;
    }, tm, A4(qi, "startedAt", function(n) {
        return n.q6;
    }, tm, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return {
                                                j2: e,
                                                ki: r,
                                                lw: c,
                                                lT: f,
                                                mo: n,
                                                fI: i,
                                                oM: o,
                                                pH: a,
                                                g9: u,
                                                q6: t
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), h2 = F2(function(n, r) {
        return {
            mo: n,
            n6: r
        };
    }), k2 = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(h2)))), C2 = F2(function(n, r) {
        return {
            mo: n,
            n6: r
        };
    }), T2 = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(C2)))), P2 = Fi(A5(TF, "additionalVideoFormats", function(n) {
        return n.iy;
    }, ic(Oa), w, A4(rc, "subtitleFormats", function(n) {
        return n.dw;
    }, ic(T2), A4(rc, "formats", function(n) {
        return n.cX;
    }, ic(k2), A4(qi, "logo", function(n) {
        return n.nr;
    }, Oa, A4(rc, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iJ;
    }, ri, A4(rc, "manualDelivery", function(n) {
        return n.nK;
    }, ri, A4(qi, "broadcaster", function(n) {
        return n.js;
    }, N$, A4(rc, "enableAutoReject", function(n) {
        return n.ld;
    }, ri, A4(rc, "enableAutoAccept", function(n) {
        return n.lc;
    }, ri, A4(rc, "enableUploadSuccessEmail", function(n) {
        return n.lg;
    }, ri, A4(rc, "enableVideoReadyEmail", function(n) {
        return n.lh;
    }, ri, A4(rc, "enableCreationEmail", function(n) {
        return n.le;
    }, ri, A4(rc, "qcMasterReportTemplate", function(n) {
        return n.pq;
    }, Oa, A4(rc, "qcMasterTestPlan", function(n) {
        return n.pr;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(o) {
                            return function(a) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(m) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return {
                                                                            iy: v,
                                                                            iJ: d,
                                                                            js: s,
                                                                            ki: r,
                                                                            lc: c,
                                                                            ld: f,
                                                                            le: o,
                                                                            lg: i,
                                                                            lh: a,
                                                                            cX: b,
                                                                            mo: n,
                                                                            nr: m,
                                                                            nK: l,
                                                                            n6: t,
                                                                            pq: u,
                                                                            pr: e,
                                                                            dw: p
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), S2 = Fi(A4(rc, "invitations", function(n) {
        return n.fD;
    }, ic(v2), A4(rc, "channels", function(n) {
        return n.cz;
    }, ic(SC), A4(rc, "previousBroadcastables", function(n) {
        return n.bj;
    }, l2, A4(rc, "activeBroadcastable", function(n) {
        return n.R;
    }, s2, A4(rc, "extras", function(n) {
        return n.bP;
    }, b2, A4(rc, "jobs", function(n) {
        return n.cZ;
    }, ic(g2), A4(rc, "metadata", function(n) {
        return n.c2;
    }, nc(Wb), A4(rc, "organization", function(n) {
        return n.oM;
    }, P2, A4(rc, "creator", function(n) {
        return n.bK;
    }, Uv, A4(rc, "show", function(n) {
        return n.g9;
    }, Ub, Mi(f0)))))))))))), y2 = function(n) {
        return mc(A2(Wi, S2, Ai(FX(n))));
    }, N2 = function(n) {
        return 3 === n.$ ? ht(n.a) : kt;
    }, L2 = function(n) {
        return Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, Y1, n.av)));
    }, j2 = F2(function(n, r) {
        return r.$ ? n : ht(r.a);
    }), M2 = function(n) {
        var r = A2(sp, function(n) {
            return n.hY;
        }, L2(n)), t = A2(sp, function(n) {
            return n.hY;
        }, Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, N2, n.av))));
        return A2(j2, r, A2(j2, t, A2(sp, function(n) {
            return n.hY;
        }, n.a6)));
    }, I2 = function(n) {
        var r = A2(sp, function(n) {
            return n.hY;
        }, Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, Y1, n.av)))), t = A2(sp, function(n) {
            return n.hY;
        }, Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, N2, n.av))));
        return A2(j2, r, A2(j2, t, A2(sp, function(n) {
            return n.hY;
        }, n.a6)));
    }, D2 = function(n) {
        return n.P.nm || n.e2.nm;
    }, B2 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, x2 = F3(function(n, r, t) {
        return {
            n6: n,
            sa: r,
            sw: t
        };
    }), q2 = Fi(A4(rc, "value", function(n) {
        return n.sw;
    }, Wb, A4(rc, "type", function(n) {
        return n.sa;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(x2))))), V2 = ic(q2), O2 = function(n) {
        return yi(t0(A2(r0, n, 0)));
    }, z2 = function(n) {
        return mc(A2(Wi, V2, Ai(O2(n))));
    }, E2 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, H2 = function(n) {
        return A2(Xa, E2, mc(A2(Wi, AF, Ai(yi(I$(A2(yD, n, 5)))))));
    }, R2 = F2(function(n, r) {
        return bc(k([
            A2(Xa, B2, z2(r)),
            H2(n)
        ]));
    }), W2 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, U2 = A2(bu, wJ, W2), Q2 = F2(function(n, r) {
        return A2(Lu, A2(bu, function(n) {
            return n.en;
        }, function(n) {
            return n.lD;
        }), A2(U1, n, r).bQ.f$);
    }), _2 = F2(function(n, r) {
        return A2(Lu, A2(bu, function(n) {
            return n.fL;
        }, function(n) {
            return n.lD;
        }), A2(U1, n, r).bQ.f$);
    }), Z2 = F2(function(n, r) {
        return A2(sp, function(n) {
            var r = n.r6;
            return r.$ ? kt : 5 === r.a.o2 ? ht(n) : kt;
        }, A2(sp, A2(Pi, function(n) {
            return n.pm;
        }, n.iq.l3 ? function(n) {
            return n.fo;
        } : function(n) {
            return n.nw;
        }), A2(U1, n, r).bQ.f$));
    }), K2 = function(n) {
        var r = n.P.kx;
        if (1 === r.$) return kt;
        var t, e = r.a, u = (t = A2(Lu, function(n) {
            return n.rp;
        }, n.o3)).$ || t.a.$ ? kt : ht(t.a.a), o = A2(U1, n, e).bQ.f$, a = A2(ju, "00:00:00:00", A2(sp, M2, o)), i = A2(sp, function(n) {
            return ht((n.at / n.as * 1e3 | 0) / 1e3);
        }, A2(sp, L2, o)), c = A2(sp, function(n) {
            return n.eU;
        }, A2(sp, L2, o));
        return A2(Lu, function(r) {
            return {
                i3: A2(ju, w, A2(Lu, X1, o)),
                en: A2(Q2, n, e),
                eU: c,
                lW: i,
                fL: A2(_2, n, e),
                n3: A2(ju, r.mo, A2(Lu, function(n) {
                    return n.n3;
                }, n.o3)),
                qq: A2(sp, function(n) {
                    return n.qq;
                }, n.o3),
                qr: A2(ju, w, A2(Lu, function(n) {
                    return n.qr;
                }, n.o3)),
                q5: a,
                rp: u
            };
        }, A2(Z2, n, e));
    }, X2 = function(n) {
        return p(n.i7, {
            qp: kt
        });
    }, J2 = F2(function(n, r) {
        var t;
        return p(n.o6, {
            lW: 1 === (t = r.lW).$ ? 0 : t.a,
            q5: r.q5,
            rp: r.rp
        });
    }), Y2 = F2(function(n, r) {
        var t = K2(n);
        return EZ(p(n, {
            i7: r ? X2(n) : n.i7,
            o3: t,
            o6: 1 === t.$ ? n.o6 : A2(J2, n, t.a)
        }));
    }), G2 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, n3 = A2(bu, wJ, G2), r3 = function(n) {
        var r = n.P;
        return p(n, {
            e2: p(n.e2, {
                nm: !0
            }),
            P: p(r, {
                nm: !0
            })
        });
    }, t3 = Zn("info", function() {
        return va;
    }), e3 = t3(0), u3 = Zn("getPlayerName", function() {
        return va;
    }), o3 = u3(0), a3 = function(n) {
        return A2(Yv, Me, iP(function(n) {
            return {
                $: 37,
                a: n
            };
        }(n)));
    }, i3 = function(n) {
        return A2(Yv, Me, iP(function(n) {
            return {
                $: 36,
                a: n
            };
        }(n)));
    }, c3 = function(n) {
        switch(n){
            case 0:
            case 4:
            case 5:
            default:
                return 3;
            case 1:
            case 6:
                return 0;
            case 2:
            case 7:
                return 1;
            case 3:
            case 8:
                return 2;
        }
    }, f3 = F3(function(n, r, t) {
        return {
            io: n,
            eo: r,
            bU: t
        };
    }), s3 = F2(function(n, r) {
        return {
            e$: r,
            hs: n
        };
    }), l3 = A3(Le, s3, A2(du, "start", sA), A2(du, "end", sA)), d3 = on, m3 = A4(d3, f3, A2(du, "action", Da), A2(du, "buffer", oc(l3)), A2(du, "frame", tc)), b3 = F4(function(n, r, t, e) {
        return A2(Jf, t, A8(xf, n, Vf(n), e, 0, 0, 0, r, 0));
    }), p3 = Zn("elmToJs", Me), v3 = (GU = wa(k([
        d("action", ga("Fullscreen"))
    ])), p3(GU)), $3 = F3(function(n, r, t) {
        var e = wa(k([
            d("action", ga("GetPicture")),
            d("rawFrame", wa(k([
                d("frameRate", lA(t.lW)),
                d("bucket", ga(n)),
                d("key", ga(r))
            ])))
        ]));
        return p3(e);
    }), w3 = function() {
        var n = wa(k([
            d("action", ga("GoToEnd"))
        ]));
        return p3(n);
    }(), g3 = function() {
        var n = wa(k([
            d("action", ga("GoToStart"))
        ]));
        return p3(n);
    }(), h3 = function() {
        var n = wa(k([
            d("action", ga("NextFrame"))
        ]));
        return p3(n);
    }(), k3 = function() {
        var n = wa(k([
            d("action", ga("Pause"))
        ]));
        return p3(n);
    }(), C3 = function() {
        var n = wa(k([
            d("action", ga("Play"))
        ]));
        return p3(n);
    }(), T3 = function() {
        var n = wa(k([
            d("action", ga("PrevFrame"))
        ]));
        return p3(n);
    }(), P3 = F2(function(n, r) {
        var t = wa(k([
            d("action", ga(n + "Time")),
            d("seconds", lA(r))
        ]));
        return p3(t);
    }), S3 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return d(p(r, {
                    mP: !1,
                    mT: !0
                }), C3);
            case 1:
                return d(p(r, {
                    mT: !1
                }), k3);
            case 6:
                return d(r, A2(P3, n.a, n.b));
            case 2:
                return d(p(r, {
                    kp: 0,
                    kr: A4(b3, r.lW, 0, "00:00:00:00", !1)
                }), g3);
            case 3:
                return d(r, w3);
            case 4:
                return function(n) {
                    return d(n, n.mT ? n$ : h3);
                }(r);
            case 5:
                return function(n) {
                    return d(n, n.mT ? n$ : T3);
                }(r);
            case 7:
                return d(r, v3);
            case 8:
                return d(p(r, {
                    i$: !r.i$
                }), n$);
            case 9:
                var t = n.a, e = n.b;
                return d(r, A3($3, t.$ ? "" : t.a, e.$ ? "" : e.a, r));
            case 10:
                return d(p(r, {
                    gx: n.a
                }), n$);
            default:
                var u = (o = A2(ba, m3, n.a)).$ ? {
                    io: "",
                    eo: w,
                    bU: 0
                } : o.a;
                return d("Added" === u.io ? p(r, {
                    ix: !0
                }) : "Buffering" === u.io ? p(r, {
                    mN: !0
                }) : "StopBuffering" === u.io ? p(r, {
                    mN: !1
                }) : "Finished" === u.io ? p(r, {
                    mP: !0,
                    mT: !1
                }) : "Loaded" === u.io ? p(r, {
                    eo: u.eo
                }) : "Playing" === u.io ? p(r, {
                    kp: u.bU,
                    kr: A4(b3, r.lW, u.bU, "00:00:00:00", !1),
                    mP: !1,
                    mT: !0
                }) : "isPaused" === u.io ? p(r, {
                    kp: u.bU,
                    kr: A4(b3, r.lW, u.bU, "00:00:00:00", !1),
                    mT: !1
                }) : r, n$);
        }
        var o;
    }), y3 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, N3 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, L3 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, j3 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, M3 = {
        $: 3
    }, I3 = {
        $: 1
    }, D3 = xa({
        bN: "The selected channel doesn\u2019t exist",
        bT: "La chaine s\xe9lectionn\xe9e n\u2019existe pas."
    }), B3 = xa({
        bN: "You need to choose another channel",
        bT: "Vous devez choisir une chaine."
    }), x3 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), q3 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, V3 = function(n) {
        return yi(q3(A2(x3, n, 1)));
    }, O3 = Fi(A4(qi, "channel", function(n) {
        return n.bE;
    }, Oa, Mi(function(n) {
        return {
            bE: n
        };
    }))), z3 = F2(function(n, r) {
        var t = "" === r ? kt : ht(r);
        return mc(sw(A3(ow, O3, {
            bE: t
        }, rw(V3(n.mo)))));
    }), E3 = F4(function(n, r, t, e) {
        var u = Tu(t) ? iP(0) : "" === e ? By(Dy(A2(ka, B3, $a))) : A2(mu, function(n) {
            return a(n.sw, e);
        }, t) ? iP(0) : By(Dy(A2(ka, D3, $a)));
        return A2(BT, function() {
            return function(n) {
                return mc(sw(rw(dl(jX(A2(LX, n.mo, 6))))));
            }(n);
        }, A2(BT, function() {
            return n.c$ ? iP(0) : A2(z3, r, e);
        }, u));
    }), H3 = Fi(A4(rc, "rejection", function(n) {
        return n.di;
    }, Oa, Mi(function(n) {
        return {
            di: n
        };
    }))), R3 = F2(function(n, r) {
        return A2(Yb, function() {
            return 0;
        }, mc(A2(Wi, d0, A3(ow, H3, {
            di: r
        }, rw(dl(jX(A2(LX, n.mo, 4))))))));
    }), W3 = function(n) {
        return 1 === n.$;
    }, U3 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Q3 = function(n) {
        return {
            $: 18,
            a: n
        };
    }, _3 = F2(function(n, r) {
        return mc(sw(dw(dl(Q3(A2(U3, r.mo, 2))))));
    }), Z3 = A2(Pi, qx, T_), K3 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return EZ(p(r, {
                    gk: !r.gk
                }));
            case 1:
                return EZ(p(r, {
                    nH: A2(ww, n.a, r.nH)
                }));
            case 2:
                return EZ(p(r, {
                    nG: A2(ww, n.a, r.nG)
                }));
            case 3:
                var t = n.a, e = n.b, u = W3(r.nI) ? r : p(r, {
                    nI: I3
                });
                return A2(BX, k([
                    A2(Xa, j3, A2(_3, t, e))
                ]), EZ(u));
            case 4:
            case 6:
                return (i = n.a).$ ? EZ(p(r, {
                    nI: N3(i.a)
                })) : A2(qX, 1, EZ(p(r, {
                    nG: Z3(r.nG),
                    nH: Z3(r.nH),
                    nI: rs
                })));
            case 5:
                t = n.a;
                var o = n.b, a = n.c;
                return W3(r.nI) ? OZ : A2(BX, k([
                    A2(Xa, y3, A4(E3, t, o, a, r.nG.sw))
                ]), EZ(p(r, {
                    nI: I3
                })));
            case 7:
                return t = n.a, W3(r.nI) ? OZ : "" === r.nH.sw ? EZ(p(r, {
                    nI: M3
                })) : A2(BX, k([
                    A2(Xa, L3, A2(R3, t, r.nH.sw))
                ]), EZ(p(r, {
                    nI: I3
                })));
            case 8:
                var i;
                return (i = n.a).$ ? EZ(p(r, {
                    nI: N3(i.a)
                })) : A2(qX, 2, EZ(p(r, {
                    nG: Z3(r.nG),
                    nH: Z3(r.nH),
                    nI: rs,
                    gk: !1
                })));
            default:
                return EZ(p(r, {
                    nI: rs
                }));
        }
    }), X3 = F2(function(n, r) {
        return {
            $: 28,
            a: n,
            b: r
        };
    }), J3 = F2(function(n, r) {
        return {
            $: 26,
            a: n,
            b: r
        };
    }), Y3 = F2(function(n, r) {
        return {
            $: 24,
            a: n,
            b: r
        };
    }), G3 = F2(function(n, r) {
        return {
            $: 22,
            a: n,
            b: r
        };
    }), n6 = F2(function(n, r) {
        return {
            $: 19,
            a: n,
            b: r
        };
    }), r6 = function(n) {
        return {
            $: 14,
            a: n
        };
    }, t6 = function(n) {
        return {
            $: 42,
            a: n
        };
    }, e6 = function(n) {
        return {
            $: 38,
            a: n
        };
    }, u6 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, o6 = {
        $: 1
    }, a6 = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), i6 = function(n) {
        return {
            $: 15,
            a: n
        };
    }, c6 = function(n) {
        return {
            $: 40,
            a: n
        };
    }, f6 = function(n) {
        return {
            $: 45,
            a: n
        };
    }, s6 = {
        $: 2
    }, l6 = F7(function(n, r, t, e, u, o, a) {
        return {
            bI: o,
            ki: t,
            bK: r,
            mo: n,
            nP: a,
            cl: u,
            cm: e
        };
    }), d6 = Fi(A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, A4(rc, "comment", function(n) {
        return n.bI;
    }, Oa, A4(rc, "updatedAt", function(n) {
        return n.cl;
    }, tm, A4(rc, "updater", function(n) {
        return n.cm;
    }, Oa, A4(rc, "createdAt", function(n) {
        return n.ki;
    }, tm, A4(rc, "creator", function(n) {
        return n.bK;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(l6))))))))), m6 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), b6 = function(n) {
        return {
            $: 16,
            a: n
        };
    }, p6 = function(n) {
        return n.a;
    }, v6 = Fi(A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, Mi(function(n) {
        return {
            nP: n
        };
    }))), $6 = F2(function(n, r) {
        var t;
        return mc(A2(nw, d6, A3(ow, v6, {
            nP: r
        }, rw((t = p6(n.mo), dl(b6(A2(m6, t, 1))))))));
    }), w6 = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            S: c,
            el: o,
            ki: t,
            bK: r,
            fh: i,
            mo: n,
            nP: a,
            cl: u,
            cm: e
        };
    }), g6 = Fi(A4(rc, "annotations", function(n) {
        return n.S;
    }, ic(t2), A4(qi, "frame", function(n) {
        return n.fh;
    }, G0, A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, A4(qi, "broadcastableId", function(n) {
        return n.el;
    }, Oa, Rb(w6)))))), h6 = function(n) {
        return dl(Q3(A2(U3, n, 3)));
    }, k6 = F3(function(n, r, t) {
        return {
            S: t,
            bU: r,
            nP: n
        };
    }), C6 = Fi(A4(rc, "annotations", function(n) {
        return n.S;
    }, ic(t2), A4(qi, "frame", function(n) {
        return n.bU;
    }, G0, A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, Mi(k6))))), T6 = function(n) {
        return {
            eT: n.eT,
            lW: n.fg,
            sw: n.lV
        };
    }, P6 = function(n) {
        var r = n.bB, t = n.nP;
        return mc(A2(nw, g6, A3(ow, C6, {
            S: w,
            bU: A2(Lu, T6, n.kt),
            nP: t
        }, rw(h6(r)))));
    }, S6 = function(n) {
        return mc(sw(dw(dl(HT(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n))))));
    }, y6 = F4(function(n, r, t, e) {
        return {
            lw: t,
            lT: e,
            fI: r,
            g9: n
        };
    }), N6 = Fi(A4(qi, "format", function(n) {
        return n.lT;
    }, Oa, A4(qi, "externalJobId", function(n) {
        return n.lw;
    }, Oa, A4(rc, "jobType", function(n) {
        return n.fI;
    }, OT, A4(rc, "show", function(n) {
        return n.g9;
    }, Oa, Mi(y6)))))), L6 = F2(function(n, r) {
        var t = r.st.oM;
        if (t.$) return By(A3(Ki, 1, "Organization not available", Su));
        var e = t.a, u = n.mZ.sw;
        if (u.$) return By(A3(Ki, 1, "JobType not selected", Su));
        var o = qT(u.a);
        return o.$ ? By(A3(Ki, 1, "JobType not found", Su)) : mc(sw(A3(ow, N6, A4(y6, r.g9.mo, o.a, kt, kt), rw(function(n) {
            return dl(HT(function(n) {
                return {
                    $: 0,
                    a: n
                };
            }(n)));
        }(e)))));
    }), j6 = F3(function(n, r, t) {
        return {
            bb: r,
            bc: t,
            m7: n
        };
    }), M6 = Fi(A4(rc, "frameOut", function(n) {
        return n.bc;
    }, uc, A4(rc, "frameIn", function(n) {
        return n.bb;
    }, uc, A4(rc, "label", function(n) {
        return n.m7;
    }, C0, Mi(j6))))), I6 = function(n) {
        return dl(Wx(A2(Oz, n, 13)));
    }, D6 = function(n) {
        return mc(W_(A3(ow, M6, {
            bb: n.bb,
            bc: n.bc,
            m7: n.m7
        }, rw(I6(n.z)))));
    }, B6 = function(n) {
        return dl(function(n) {
            return {
                $: 17,
                a: n
            };
        }(n));
    }, x6 = function(n) {
        return mc(sw(fw(B6(n.mo))));
    }, q6 = function(n) {
        return dl(b6(A2(m6, n, 0)));
    }, V6 = function(n) {
        return mc(sw(fw(q6(n))));
    }, O6 = xa({
        bN: "Error while trying to delete comment",
        bT: "Echec de la suppression du commentaire."
    }), z6 = function(n) {
        return dl(function(n) {
            return {
                $: 27,
                a: n
            };
        }(n));
    }, E6 = function(n) {
        return mc(sw(fw(z6(n))));
    }, H6 = v6, R6 = F2(function(n, r) {
        return mc(A2(Wi, d6, A3(ow, H6, {
            nP: r
        }, dw(B6(n.mo)))));
    }), W6 = F2(function(n, r) {
        return {
            S: r,
            nP: n
        };
    }), U6 = Fi(A4(rc, "annotations", function(n) {
        return n.S;
    }, ic(t2), A4(rc, "message", function(n) {
        return n.nP;
    }, Oa, Mi(W6)))), Q6 = F3(function(n, r, t) {
        var e, u = (e = A2(di, p6(r.mo), n.k4)).$ ? r.S : k([
            e.a
        ]);
        return mc(A2(Wi, g6, A3(ow, U6, {
            S: u,
            nP: t
        }, dw(q6(p6(r.mo))))));
    }), _6 = function(n) {
        return za(function(r) {
            return p(r, {
                sw: n
            });
        });
    }, Z6 = F2(function(n, r) {
        return A2(Ge, function(r) {
            return A2(nu, function(n) {
                return d(r, n);
            }, n(r));
        }, r);
    }), K6 = F3(function(n, r, t) {
        var e, u = k0(t), o = (e = A2(di, p6(r.mo), n.k4)).$ ? A2(vq, "No annotations", Eo(r.S)) : At(e.a), a = A2(PR, function(n) {
            var t = n.sy;
            return 2 === t.$ ? At(d(t.a.sw, t.b.sw)) : Ct("Can't get frame info from annotations for segment " + p6(r.mo));
        }, o);
        return A2(BT, function(n) {
            var t = n.b;
            return mc(W_(A3(ow, M6, {
                bb: t.a,
                bc: t.b,
                m7: n.a
            }, dw(z6(p6(r.mo))))));
        }, A2(Qi, function(n) {
            return Dy(A2(ka, n, s$));
        }, A2(Z6, function() {
            return xy(a);
        }, xy(u))));
    }), X6 = function(n) {
        var r = wa(k([
            d("action", ga("GoTo")),
            d("frame", ec(n))
        ]));
        return p3(r);
    }, J6 = function(n) {
        return Eo(Zt(A2(Ra, A2(bu, jP, function(n) {
            return n.ki;
        }), A2(Mu, function(n) {
            return a(n.j2, kt) && a(n.q6, kt);
        }, A2(Mu, function(n) {
            return 1 === n.fI || !n.fI;
        }, n)))));
    }, Y6 = function(n) {
        return Eo(Zt(A2(Ra, A2(bu, jP, function(n) {
            return n.ki;
        }), A2(Mu, function(n) {
            return a(n.j2, kt) && !a(n.q6, kt);
        }, A2(Mu, function(n) {
            return 1 === n.fI || !n.fI;
        }, n)))));
    }, G6 = A3(N_, "message", k([
        A2(Pi, function(n) {
            return n.nP;
        }, j_)
    ]), L_), n4 = A3(N_, "message", k([
        A2(Pi, function(n) {
            return n.nP;
        }, j_)
    ]), L_), r4 = function(n) {
        switch(n){
            case "G\xe9n\xe9rique":
            case "Programme":
            case "Trailer":
            case "Mire":
            case "Noir":
            case "Panneau":
            case "Fonds neutres":
                return ht(3);
            default:
                return kt;
        }
    }, t4 = function(n) {
        return mc(sw(dw(dl(HT(function(n) {
            return {
                $: 1,
                a: n
            };
        }(n))))));
    }, e4 = function(n) {
        return mc(sw(rw(dl(Wx(A2(Oz, n, 6))))));
    }, u4 = function(n) {
        return p(n, {
            gk: !n.gk
        });
    }, o4 = F2(function(n, r) {
        return p(r, {
            cU: n
        });
    }), a4 = F3(function(n, r, t) {
        var e = function() {
            var e = d(n, t.sy);
            if (e.a) switch(e.b.$){
                case 1:
                case 2:
                    return A2(J0, e.b.a, r);
                default:
                    return t.sy;
            }
            else switch(e.b.$){
                case 0:
                case 1:
                    return X0(r);
                default:
                    return A2(J0, r, e.b.b);
            }
        }();
        return p(t, {
            sy: e
        });
    }), i4 = xa({
        bN: "Answer",
        bT: "R\xe9pondre"
    }), c4 = za(function(n) {
        return p(n, {
            gw: i4
        });
    }), f4 = F3(function(n, r, t) {
        return A3(hi, n, function(n) {
            return ht(A2(ww, r, 1 === n.$ ? c4 : n.a));
        }, t);
    }), s4 = F3(function(n, r, t) {
        return A3(hi, n, function(n) {
            return 1 === n.$ ? kt : ht(A3(q_, T_(n.a), "message", r));
        }, t);
    }), l4 = F2(function(n, r) {
        return p(n, {
            sw: ht(r)
        });
    }), d4 = function(n) {
        var r = n.bB, t = n.nP;
        return mc(A2(nw, g6, A3(ow, C6, {
            S: k([
                n.iQ
            ]),
            bU: kt,
            nP: t
        }, rw(h6(r)))));
    }, m4 = F3(function(n, r, t) {
        n: for(;;)switch(n.$){
            case 35:
                return EZ(n.a.$ ? p(r, {
                    qi: AV(k0(B = n.a.a)),
                    qj: A2(l4, r.qj, B)
                }) : p(r, {
                    qj: u4(r.qj)
                }));
            case 36:
                return EZ(n.a.$ ? p(r, {
                    mZ: A2(l4, r.mZ, B = n.a.a)
                }) : p(r, {
                    mZ: u4(r.mZ)
                }));
            case 0:
                var e = n.a, u = r.iQ, o = function() {
                    var n = r4(r.nP.sw);
                    return 1 === n.$ ? r : p(r, {
                        iQ: p(u, {
                            cU: n.a
                        })
                    });
                }();
                return EZ(p(o, {
                    nP: A2(ww, e, r.nP)
                }));
            case 1:
                return EZ(p(r, {
                    iQ: A3(a4, n.a, T6(t.kr), r.iQ)
                }));
            case 2:
                return EZ(p(r, {
                    iQ: A2(o4, n.a, r.iQ),
                    qi: kt
                }));
            case 37:
                return A2(BX, k([
                    A2(Xa, e6, A2(L6, r, n.a))
                ]), EZ(p(r, {
                    j1: os,
                    kf: o6,
                    q3: os
                })));
            case 38:
                return (D = n.a).$ ? EZ(p(r, {
                    kf: u6(D.a)
                })) : A2(qX, 1, EZ(p(r, {
                    j1: os,
                    kf: s6,
                    q3: os
                })));
            case 39:
                var a = J6(n.a);
                return a.$ ? EZ(r) : A2(BX, k([
                    A2(Xa, c6, t4(a.a.mo))
                ]), EZ(p(r, {
                    j1: os,
                    kf: os,
                    q3: o6
                })));
            case 40:
                return (D = n.a).$ ? EZ(p(r, {
                    q3: u6(D.a)
                })) : A2(qX, 1, EZ(p(r, {
                    j1: os,
                    kf: os,
                    q3: s6
                })));
            case 41:
                var i = Y6(n.a);
                return i.$ ? EZ(r) : A2(BX, k([
                    A2(Xa, t6, S6(i.a.mo))
                ]), EZ(p(r, {
                    j1: o6,
                    kf: os,
                    q3: os
                })));
            case 42:
                return (D = n.a).$ ? EZ(p(r, {
                    j1: u6(D.a)
                })) : A2(qX, 1, EZ(p(r, {
                    j1: s6,
                    kf: os,
                    q3: os
                })));
            case 43:
                return EZ(r);
            case 3:
                return EZ(p(r, {
                    iQ: p(u = r.iQ, {
                        sy: as
                    })
                }));
            case 4:
                var c = A2(vw, e = n.a, r.hY), f = c.sw ? ht(t.kr) : kt;
                return EZ(p(r, {
                    kt: f,
                    hY: c
                }));
            case 34:
                var s = n.a;
                return EZ(p(r, {
                    kt: ht(A2(B1, s.q5, A3(Yf, by(s.lW), s.fh, !1)))
                }));
            case 5:
                return EZ(p(r, {
                    d1: A3(f4, n.a, e = n.b, r.d1)
                }));
            case 6:
                var l = n.b;
                return EZ(p(r, {
                    k7: A3(hi, B = n.a, function(n) {
                        return 1 === n.$ ? kt : ht(A2(ww, l, n.a));
                    }, r.k7)
                }));
            case 7:
                var d = n.a, b = A2(B_, n4, {
                    nP: r.nP.sw
                });
                if (b.$) {
                    n = r6(Ct(Dy(h = b.a)));
                    continue n;
                }
                return E1(k([
                    A2(Xa, r6, P6({
                        bB: d.mo,
                        kt: r.kt,
                        nP: r.nP.sw
                    }))
                ]));
            case 8:
                d = n.a;
                var v = n.b, $ = m(r.iQ.cU, r.iQ.sy, r.qi);
                if (3 !== $.a || 2 !== $.b.$ || $.c.$) return E1(k([
                    A2(Xa, r6, d4({
                        iQ: r.iQ,
                        bB: d.mo,
                        kt: r.kt,
                        nP: A2(ju, r.nP.sw, A2(Lu, h0, r.qi))
                    }))
                ]));
                var g = $.b;
                return E1(k([
                    A2(Xa, i6, D6({
                        z: v.mo,
                        bb: g.a.sw,
                        bc: g.b.sw,
                        m7: $.c.a
                    }))
                ]));
            case 14:
                if ((D = n.a).$) {
                    var h = D.a;
                    return EZ(p(r, {
                        nP: A3(q_, T_(r.nP), "message", h)
                    }));
                }
                return A2(qX, 1, EZ(p(r, {
                    kt: kt,
                    nP: T_(qx(r.nP)),
                    hY: A2(pw, r.hY, !1)
                })));
            case 15:
                return (D = n.a).$ ? (h = D.a, EZ(p(r, {
                    nP: A3(q_, T_(r.nP), "message", h)
                }))) : A2(qX, 1, EZ(p(r, {
                    kt: kt,
                    nP: T_(qx(r.nP)),
                    hY: A2(pw, r.hY, !1)
                })));
            case 44:
                return A2(BX, k([
                    A2(Xa, f6, e4(n.a))
                ]), EZ(p(r, {
                    q4: o6
                })));
            case 45:
                return (D = n.a).$ ? EZ(p(r, {
                    q4: u6(D.a)
                })) : A2(qX, 1, EZ(p(r, {
                    q4: s6
                })));
            case 16:
                return EZ(p(r, {
                    k7: A3(Cu, B = n.a.mo, _6(l = n.a.nP), r.k7)
                }));
            case 17:
                return EZ(p(r, {
                    k7: A2(gi, B = n.a, r.k7)
                }));
            case 18:
                var C = A2(di, p6((N = n.a).mo), r.k7);
                if (1 === C.$) return OZ;
                var T = A2(B_, n4, {
                    nP: (F = C.a).sw
                });
                if (T.$) {
                    n = A2(n6, N, Ct(Dy(h = T.a)));
                    continue n;
                }
                return E1(k([
                    A2(Xa, n6(N), A3(Q6, r, N, F.sw))
                ]));
            case 19:
                var P = n.a;
                return (D = n.b).$ ? (h = D.a, EZ(p(r, {
                    k7: A3(s4, p6(P.mo), h, r.k7)
                }))) : A2(qX, 1, EZ(p(r, {
                    k7: A2(gi, D.a.mo, r.k7)
                })));
            case 20:
                return P = n.a, (D = n.b).$ ? (h = D.a, EZ(p(r, {
                    k7: A3(s4, p6(P.mo), h, r.k7)
                }))) : A2(qX, 1, EZ(p(r, {
                    k7: A2(gi, p6(P.mo), r.k7)
                })));
            case 9:
                var S = A2(di, p6((N = n.a).mo), r.k7);
                if (1 === S.$) return OZ;
                var A = A2(B_, n4, {
                    nP: (F = S.a).sw
                });
                if (A.$) {
                    n = A2(n6, N, Ct(Dy(h = A.a)));
                    continue n;
                }
                return E1(k(N.mo.$ ? [
                    A2(Xa, a6(N), A3(K6, r, N, F.sw))
                ] : [
                    A2(Xa, n6(N), A3(Q6, r, N, F.sw))
                ]));
            case 13:
                return P = n.a, (D = n.b).$ ? (h = D.a, EZ(p(r, {
                    k7: A3(s4, p6(P.mo), h, r.k7)
                }))) : A2(qX, 1, EZ(p(r, {
                    k7: A2(gi, D.a.mo, r.k7)
                })));
            case 10:
                return u = n.a, EZ(p(r, {
                    k4: A3(Cu, B = n.b, A3(a4, n.c, T6(t.kr), u), r.k4)
                }));
            case 12:
                return EZ(p(r, {
                    k4: A3(Cu, B = n.b, p(u = n.a, {
                        sy: as
                    }), r.k4)
                }));
            case 11:
                return EZ(p(r, {
                    k4: A3(Cu, B = n.b, A2(o4, n.c, u = n.a), r.k4)
                }));
            case 21:
                var y = (N = n.a).mo;
                return A2(BX, k(y.$ ? [
                    A2(Xa, G3(B = y.a), E6(B))
                ] : [
                    A2(Xa, G3(B = y.a), V6(B))
                ]), EZ(p(r, {
                    lo: kt
                })));
            case 22:
                return (D = n.b).$ ? EZ(p(r, {
                    lo: ht(O6)
                })) : H1(1);
            case 23:
                l = A2(ju, "", A2(Lu, function(n) {
                    return n.sw;
                }, A2(di, p6((N = n.a).mo), r.d1)));
                var N, L = A2(B_, G6, {
                    nP: l
                });
                if (L.$) {
                    n = A2(Y3, N, Ct(Dy(h = L.a)));
                    continue n;
                }
                return E1(k([
                    A2(Xa, Y3(N), A2($6, N, l))
                ]));
            case 24:
                return P = n.a, (D = n.b).$ ? (h = D.a, EZ(p(r, {
                    d1: A3(s4, p6(P.mo), h, r.d1)
                }))) : A2(qX, 1, EZ(p(r, {
                    d1: A2(gi, p6(P.mo), r.d1)
                })));
            case 25:
                var j = A2(di, (I = n.a).mo, r.k7);
                if (1 === j.$) return OZ;
                var F, M = A2(B_, G6, {
                    iQ: w,
                    nP: (F = j.a).sw
                });
                if (M.$) {
                    n = A2(J3, I, Ct(Dy(h = M.a)));
                    continue n;
                }
                return E1(k([
                    A2(Xa, J3(I), A2(R6, I, F.sw))
                ]));
            case 26:
                var I = n.a;
                return (D = n.b).$ ? EZ(p(r, {
                    k7: A3(s4, I.mo, h = D.a, r.k7)
                })) : A2(qX, 1, EZ(p(r, {
                    k7: A2(gi, D.a.mo, r.k7)
                })));
            case 27:
                return E1(k([
                    A2(Xa, X3((I = n.a).mo), x6(I))
                ]));
            case 28:
                var D, B = n.a;
                return (D = n.b).$ ? EZ(p(r, {
                    d1: A3(s4, B, h = D.a, r.d1)
                })) : H1(1);
            case 29:
                return EZ(p(r, {
                    ir: !r.ir
                }));
            case 30:
                return EZ(p(r, {
                    is: !r.is
                }));
            case 33:
                return OZ;
            case 31:
                return EZ(p(r, {
                    j0: !r.j0
                }));
            default:
                return E1(k([
                    X6(n.a)
                ]));
        }
    }), b4 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, p4 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, v4 = {
        $: 6
    }, $4 = function(n) {
        return {
            $: 10,
            a: n
        };
    }, w4 = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), g4 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, h4 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), k4 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, C4 = xa({
        bN: "Wrong layout and/or version",
        bT: "Erreur sur une version et/ou un agencement"
    }), T4 = F4(function(n, r, t, e) {
        return {
            aC: t,
            fv: n,
            r9: e,
            sz: r
        };
    }), P4 = Fi(A4(rc, "typeVersion", function(n) {
        return n.r9;
    }, I0, A4(rc, "channelLayout", function(n) {
        return n.aC;
    }, j0, A4(qi, "version", function(n) {
        return n.sz;
    }, g$, A4(rc, "index", function(n) {
        return n.fv;
    }, uc, Mi(T4)))))), S4 = F5(function(n, r, t, e, u) {
        var o = m(r, t, e);
        return o.b.$ || o.c.$ ? By({
            lC: Su,
            nP: C4,
            P: 400
        }) : mc(sw(A3(ow, P4, {
            aC: o.b.a,
            fv: u,
            r9: o.c.a,
            sz: r
        }, rw(yi(k4(A2(h4, n, 0)))))));
    }), y4 = Zn("clean", function() {
        return va;
    }), N4 = Zn("get", function(n) {
        return wa(k([
            d("channels", ac(ec)(n.cz)),
            d("fileId", ga(n.z))
        ]));
    }), L4 = function(n) {
        return a(n, M0(2)) || a(n, M0(1)) || a(n, M0(0));
    }, j4 = F2(function(n, r) {
        return d(r.a, n(r.b));
    }), M4 = F3(function(n, r, t) {
        return t.$ ? n : r(t.a);
    }), I4 = Zn("save", ac(function(n) {
        return wa(k([
            d("index", ec(n.fv)),
            d("layout", function(n) {
                return A3(M4, va, ga, n);
            }(n.nd)),
            d("typeVersion", function(n) {
                return A3(M4, va, ga, n);
            }(n.r9)),
            d("version", function(n) {
                return A3(M4, va, ga, n);
            }(n.sz))
        ]));
    })), D4 = F2(function(n, r) {
        switch(n.$){
            case 8:
                var t = n.a, e = n.b;
                return e.$ ? EZ(p(r, {
                    lo: ht(e.a)
                })) : A2(qX, 1, EZ(p(r, {
                    lo: kt,
                    pw: w,
                    sB: A2(gi, t, r.sB)
                })));
            case 10:
                return OZ;
            case 3:
                var u = n.a, o = n.b, i = n.c, c = n.d, f = {
                    nd: za(function(n) {
                        return p(n, {
                            m7: "Disposition",
                            sw: A2(ju, "", c)
                        });
                    }),
                    r9: za(function(n) {
                        return p(n, {
                            m7: "TypeVersion",
                            sw: A2(ju, "", o)
                        });
                    }),
                    sz: za(function(n) {
                        return p(n, {
                            m7: "Version",
                            sw: A2(ju, "", i)
                        });
                    })
                };
                return EZ(p(r, {
                    pw: k([
                        u
                    ]),
                    sB: A3(Cu, u, f, r.sB)
                }));
            case 0:
                var s = n.b;
                return EZ(p(r, {
                    sB: A3(hi, t = n.a, Lu(function(n) {
                        return p(n, {
                            sz: A2(ww, s, n.sz)
                        });
                    }), r.sB)
                }));
            case 2:
                return s = n.b, EZ(p(r, {
                    sB: A3(hi, t = n.a, Lu(function(n) {
                        return p(n, {
                            r9: A2(ww, s, n.r9)
                        });
                    }), r.sB)
                }));
            case 6:
                return A2(qX, 1, EZ(r));
            case 5:
                return A2(BX, k([
                    A2(Yv, Dl(v4), qE(200))
                ]), EZ(r));
            case 7:
                return EZ(p(r, {
                    pw: w,
                    sB: A2(gi, u = n.a, r.sB)
                }));
            case 1:
                return s = n.b, EZ(p(r, {
                    sB: A3(hi, t = n.a, Lu(function(n) {
                        return p(n, {
                            nd: A2(ww, s, n.nd)
                        });
                    }), r.sB)
                }));
            case 9:
                var l = (D = d(n.a, r.qp)).a.$ ? kt : 1 === D.a.a.$ ? 1 === D.b.$ ? ht(g4(M = D.a.a.a)) : 1 === D.b.a.$ ? a(M = D.a.a.a, D.b.a.a) ? kt : ht(g4(M)) : ht(g4(M = D.a.a.a)) : 1 === D.b.$ || D.b.a.$ ? ht(b4(I = D.a.a.a)) : a(I = D.a.a.a, D.b.a.a) ? kt : ht(b4(I));
                return A2(BX, k([
                    A2(Yv, $4, iP(l))
                ]), EZ(p(r, {
                    qp: l
                })));
            case 4:
                t = n.a;
                var b = function(n) {
                    var r = He(n);
                    return r.$ ? -1 : r.a;
                }, v = function() {
                    var n = A2(di, t, r.sB);
                    if (1 === n.$) return m(kt, kt, kt);
                    var e = n.a.sz, u = n.a.nd, o = n.a.r9, a = L4(o.sw) ? e.sw : "NOTHING";
                    return m(AV($$(a)), AV(N0(u.sw)), AV(F0(o.sw)));
                }(), $ = v.a, g = v.b, h = v.c, C = A2(j4, b, (B = A2(Dt, "/", t)).b && B.b.b ? d(B.a, B.b.a) : d("", "")), T = C.a, P = C.b;
                return A2(BX, k([
                    A2(Xa, w4(t), A5(S4, T, $, g, h, P))
                ]), EZ(r));
            case 11:
                var S = n.a, A = A2(Lu, function(n) {
                    return n.fL;
                }, Eo(S)), y = function() {
                    if (A.$) return n$;
                    var n = Eo(A2(Dt, "/", A.a));
                    if (n.$) return n$;
                    var r = n.a;
                    return N4({
                        cz: A2(Ye, function(n) {
                            return n.fv;
                        }, S),
                        z: r
                    });
                }();
                return KX(y);
            case 12:
                return E1(k([
                    A2(Xa, p4, (F = n.a, A3(xt, F2(function(n, r) {
                        var t = n.a, e = n.b;
                        return A2(BT, function() {
                            var n = Eo(A2(Mu, function(n) {
                                return a(n.fv, t + 1);
                            }, F.bl));
                            if (n.$) return iP(0);
                            var r = n.a;
                            return A5(S4, F.z, AV($$(A2(ju, "NOTHING", r.sz))), AV(N0(r.nd)), AV(F0(r.r9)), e);
                        }, r);
                    }), iP(0), A2(Ht, V$, F.cz))))
                ]));
            case 14:
                return E1(k([
                    y4(0),
                    t3(0)
                ]));
            case 15:
                var N = n.a;
                return E1(k([
                    I4(A2(Ht, F2(function(n, r) {
                        return {
                            fv: n + 1,
                            nd: A2(Lu, L0, r.nd),
                            r9: A2(Lu, M0, r.r9),
                            sz: A2(Lu, w$, r.sz)
                        };
                    }), N)),
                    t3(0)
                ]));
            default:
                var L = n.a, j = qt(L) ? A3(xt, F2(function(n, r) {
                    return r + "stream " + Mt(n.fv) + " " + A2(ju, "", n.sz) + " " + A2(Ia, " ", A2(X$, K1, N0(n.nd))) + " " + n.r9;
                }), "", L) : "";
                return EZ(p(r, {
                    p0: ht(j)
                }));
        }
        var F, M, I, D, B;
    }), B4 = F2(function() {
        return OZ;
    }), x4 = F4(function(n, r, t, e) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), q4 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, V4 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, O4 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, z4 = {
        $: 1
    }, E4 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, H4 = {
        $: 1
    }, R4 = {
        $: 0
    }, W4 = {
        $: 0
    }, U4 = F2(function(n, r) {
        return A2(Ge, function(r) {
            var t = r.a, e = r.b;
            return A2(nu, function(n) {
                return m(t, e, n);
            }, n(d(t, e)));
        }, r);
    }), Q4 = xa({
        bN: "Please qualify audio before deliver.",
        bT: "Veuillez qualifier les pistes audios avant de livrer."
    }), _4 = xa({
        bN: "Choose one or more segments to include",
        bT: "Choisissez un ou plusieurs segments \xe0 inclure"
    }), Z4 = F2(function(n, r) {
        return {
            ad: r,
            ci: n
        };
    }), K4 = F3(function(n, r, t) {
        return {
            lT: t,
            mo: n,
            n6: r
        };
    }), X4 = Fi(A4(qi, "format", function(n) {
        return n.lT;
    }, Oa, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(K4))))), J4 = Fi(A4(qi, "subtitles", function(n) {
        return n.ad;
    }, X4, A4(rc, "targetOrg", function(n) {
        return n.ci;
    }, Oa, Mi(Z4)))), Y4 = F2(function(n, r) {
        return A2(Yb, function(n) {
            return n.mo;
        }, mc(A2(Wi, Ub, A3(ow, J4, {
            ad: r.ad,
            ci: r.rP
        }, rw(dl(Q3(A2(U3, n, 1))))))));
    }), G4 = F2(function(n, r) {
        return {
            ad: r,
            ch: n
        };
    }), n5 = Fi(A4(qi, "subtitles", function(n) {
        return n.ad;
    }, X4, A4(rc, "targetId", function(n) {
        return n.ch;
    }, Oa, Mi(G4)))), r5 = F2(function(n, r) {
        return A2(Yb, function(n) {
            return n.mo;
        }, mc(A2(Wi, Ub, A3(ow, n5, {
            ad: r.ad,
            ch: r.rP
        }, rw(dl(Q3(A2(U3, n, 0))))))));
    }), t5 = function(n) {
        return A2(Lu, u0, Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, Y1, n.av))));
    }, e5 = function(n) {
        return Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, Y1, n.av)));
    }, u5 = F2(function(n, r) {
        return r.$ ? n : ht(r.a);
    }), o5 = function(n) {
        var r = A2(sp, function(n) {
            return n.hY;
        }, e5(n)), t = A2(sp, function(n) {
            return n.hY;
        }, Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, N2, n.av))));
        return A2(u5, r, A2(u5, t, A2(sp, function(n) {
            return n.hY;
        }, n.a6)));
    }, a5 = F3(function(n, r, t) {
        return A2(It, r, A2(Dt, n, t));
    }), i5 = F2(function(n, r) {
        return A3(I1, Ot, n, r);
    }), c5 = F2(function(n, r) {
        return A2(i5, r, k([
            n
        ]));
    }), f5 = F3(function(n, r, t) {
        var e = A2(ju, "00:00:00:00", A2(Lu, function(n) {
            return A3(a5, ";", ":", n);
        }, o5(n))), u = F2(function(n, r) {
            return A2(c5, e, A3(M1, r, n, !1)).lV;
        }), o = t5(n), a = A2(ju, 0, A2(Lu, u(t), o)), i = A2(ju, 0, A2(Lu, u(r), o));
        return mc(A2(nw, Oa, A3(ow, M6, {
            bb: i,
            bc: a,
            m7: 10
        }, rw(I6(n.lD.mo)))));
    }), s5 = xa({
        bN: "Video duration differs from at least one of standalone audio files duration. The deliverable duration may be incorrect.",
        bT: "La dur\xe9e de la vid\xe9o est diff\xe9rente de la dur\xe9e d'au moins un des audios seuls. La dur\xe9e du livrable pourrait \xeatre incorrecte."
    }), l5 = xa({
        bN: "Container duration is not available.",
        bT: "Dur\xe9e du conteneur non disponible."
    }), d5 = xa({
        bN: "Video is not loaded. Container and video stream durations are not available.",
        bT: "La vid\xe9o n'est pas charg\xe9e. Dur\xe9es du conteneur et du flux video indisponible."
    }), m5 = F2(function(n, r) {
        return xa({
            bN: "Container duration (" + by(n) + " s) and video stream duration (" + by(r) + " s) are not equals. TC out is calculated with container duration.",
            bT: "La dur\xe9e du conteneur (" + by(n) + " s) et la dur\xe9e du flux video (" + by(r) + " s) sont in\xe9gales. Le TC out est calcul\xe9 avec la dur\xe9e du conteneur."
        });
    }), b5 = xa({
        bN: "Video stream duration is not available.",
        bT: "Dur\xe9e du flux video non disponible."
    }), p5 = F4(function(n, r, t, e) {
        return A4(b3, r, qf(t * r - 1), n, e);
    }), v5 = function(n) {
        return A2(Kc, Z1, n.av);
    }, $5 = function(n) {
        return A2(W1, n, kt);
    }, w5 = function(n) {
        var r = function(n) {
            return A3(Kd, 2, "0", by(n));
        }, t = n.eT ? ";" : ":";
        return r(n.mk) + ":" + r(n.n$) + ":" + (r(n.qg) + (t + A3(Kd, 2, "0", Mt(n.fh))));
    }, g5 = function(n) {
        var r, t = A2(sp, function(n) {
            return n.bQ.f$;
        }, A2(Lu, $5, n)), e = A2(ju, "00:00:00:00", A2(Lu, function(n) {
            return A3(a5, ";", ":", n);
        }, A2(sp, o5, t))), u = A2(sp, function(n) {
            return n.eU;
        }, A2(sp, e5, t)), o = A2(sp, t5, t), a = A2(sp, function(n) {
            return n.eU;
        }, A2(sp, function(n) {
            return n.a6;
        }, t)), i = A3(Ay, F2(function(n, r) {
            return w5(A4(p5, e, r, n, !1));
        }), a, o), c = A2(ju, !1, A3(Ay, fe, a, u)), f = (r = d(a, u)).a.$ ? ht(r.b.$ ? d5 : l5) : r.b.$ ? ht(b5) : c ? kt : ht(A2(m5, r.a.a, r.b.a)), s = F2(function(n, r) {
            var t;
            return (0 > (t = n - r) ? -t : t) > 1;
        }), l = A2(mu, function(n) {
            return A2(ju, !1, A3(Ay, s, n, u));
        }, A2(Ye, function(n) {
            return n.eU;
        }, A2(Yu, v5, A2(ju, w, A2(Lu, function(n) {
            return n.bQ.d7;
        }, A2(Lu, $5, n)))))) ? ht(s5) : kt, b = d(o, i);
        return b.a.$ || b.b.$ ? m("--:--:--:--", "--:--:--:--", d(f, l)) : m(e, b.b.a, d(f, l));
    }, h5 = F9(function(n, r, t, e, u, o, a, i, c) {
        return {
            e4: a,
            e6: i,
            lT: o,
            fU: c,
            g3: t,
            ad: u,
            ch: n,
            ci: r,
            ic: e
        };
    }), k5 = Fi(A4(qi, "lockedUntil", function(n) {
        return n.fU;
    }, Oa, A4(qi, "extraVersionMapping", function(n) {
        return n.e6;
    }, ib, A4(qi, "extraFormat", function(n) {
        return n.e4;
    }, Oa, A4(rc, "format", function(n) {
        return n.lT;
    }, Oa, A4(qi, "subtitles", function(n) {
        return n.ad;
    }, X4, A4(rc, "versionMapping", function(n) {
        return n.ic;
    }, ib, A4(rc, "segments", function(n) {
        return n.g3;
    }, ic(Oa), A4(rc, "targetOrg", function(n) {
        return n.ci;
    }, Oa, A4(qi, "targetId", function(n) {
        return n.ch;
    }, Oa, Mi(h5))))))))))), C5 = Fi(A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(function(n) {
        return {
            mo: n
        };
    }))), T5 = xa({
        bN: "Program delivery for",
        bT: "Programmer la livraison pour"
    }), P5 = xa({
        bN: "Choose subtitles (optional)",
        bT: "Choisir des sous-titres (optionnel)"
    }), S5 = xa({
        bN: "Can not deliver without format",
        bT: "On ne peut pas livrer sans format"
    }), y5 = xa({
        bN: "Extra format (optional)",
        bT: "Format compl\xe9mentaire (optionnel)"
    }), N5 = F2(function(n, r) {
        var t = Eo(A2(Mu, function(n) {
            return a(n.mo, r);
        }, n));
        return !t.$ && !t.a.rs.$;
    }), L5 = xa({
        bN: "Black",
        bT: "Noir"
    }), j5 = xa({
        bN: "Custom delivery",
        bT: "Livraison custom"
    }), M5 = xa({
        bN: "Slate",
        bT: "Panneau"
    }), I5 = xa({
        bN: "Bar and tone",
        bT: "Mire"
    }), D5 = function(n) {
        switch(n.m7){
            case 0:
                return ps;
            case 1:
                return ds;
            case 2:
                return ms;
            case 3:
                return vs;
            case 4:
                return $s;
            case 5:
                return ls;
            case 6:
                return I5;
            case 7:
                return L5;
            case 8:
                return M5;
            case 9:
                return bs;
            default:
                return j5;
        }
    }, B5 = function(n) {
        var r = function(n) {
            if (1 === n.$) {
                var r = n.a;
                return !a(r.r9, kt) && !a(r.aC, kt);
            }
            return !1;
        };
        return A2(ju, !1, A2(Lu, function(n) {
            return 0 >= qt(n) || qt(A2(Mu, r, n)) > 0;
        }, A2(Lu, A2(bu, Mu(function(n) {
            return 1 === n.$;
        }), function(n) {
            return n.av;
        }), A2(sp, A2(Pi, function(n) {
            return n.bQ;
        }, function(n) {
            return n.f$;
        }), n))));
    }, x5 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, q5 = F2(function(n, r) {
        return {
            c8: n,
            dr: r
        };
    }), V5 = F4(function(n, r, t, e) {
        return {
            mo: r,
            n6: t,
            gq: e,
            qJ: n
        };
    }), O5 = Fi(A4(rc, "parent", function(n) {
        return n.gq;
    }, xi(Oa), A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, A4(rc, "showId", function(n) {
        return n.qJ;
    }, Oa, Mi(V5)))))), z5 = Fi(A4(rc, "shows", function(n) {
        return n.dr;
    }, ic(Ub), A4(rc, "nodes", function(n) {
        return n.c8;
    }, ic(O5), Mi(q5)))), E5 = F4(function(n, r, t, e) {
        return {
            mo: n,
            mO: e,
            n6: r,
            rs: t
        };
    }), H5 = Fi(A4(rc, "isDefault", function(n) {
        return n.mO;
    }, ri, A4(qi, "subtitleTypeVersion", function(n) {
        return n.rs;
    }, AA, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(E5)))))), R5 = ic(H5), W5 = F4(function(n, r, t, e) {
        return {
            mO: t,
            mQ: e,
            n6: n,
            r4: r
        };
    }), U5 = Fi(A4(rc, "isExtraDefault", function(n) {
        return n.mQ;
    }, ri, A4(rc, "isDefault", function(n) {
        return n.mO;
    }, ri, A4(rc, "tracks", function(n) {
        return n.r4;
    }, ic(h$), A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, Mi(W5)))))), Q5 = ic(U5), _5 = function(n) {
        return A2(Xa, x5, A6(lD, F5(function(n, r, t, e, u) {
            return {
                e5: u,
                cX: n,
                c8: t.c8,
                dr: t.dr,
                dw: r,
                ic: e
            };
        }), function(n) {
            return mc(A2(Wi, R5, Ai(yi(I$(A2(yD, n, 3))))));
        }(n), function(n) {
            return mc(A2(Wi, YA, Ai(dl(pF(A2(bF, n, 3))))));
        }(n), function(n) {
            return mc(A2(Wi, z5, Ai(dl(pF(A2(bF, n, 4))))));
        }(n), function(n) {
            return mc(A2(Wi, Q5, Ai(yi(I$(A2(yD, n, 0))))));
        }(n), function(n) {
            return mc(A2(Wi, R5, Ai(yi(I$(A2(yD, n, 4))))));
        }(n)));
    }, Z5 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, K5 = F3(function(n, r, t) {
        return {
            iJ: t,
            mo: n,
            n6: r
        };
    }), X5 = Fi(A4(rc, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iJ;
    }, ri, A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(K5))))), J5 = ic(X5), Y5 = dl(pF({
        $: 1
    })), G5 = mc(A2(Wi, J5, Ai(Y5))), n7 = ic(T0), r7 = ru, t7 = function(n) {
        return A2(Xa, Z5, A3(r7, F2(function(n, r) {
            return d(n, r);
        }), G5, function(n) {
            return mc(A2(Wi, n7, Ai(I6(n))));
        }(n)));
    }, e7 = xa({
        bN: "Organization",
        bT: "Organisation"
    }), u7 = xa({
        bN: "Program",
        bT: "Programme"
    }), o7 = function(n) {
        return p(n, {
            sx: Su
        });
    }, a7 = tu, i7 = xa({
        bN: "Can not deliver the original organization",
        bT: "On ne peut pas livrer l\u2019organisation d\u2019origine"
    }), c7 = xa({
        bN: "Please choose an option for subtitles",
        bT: "Veuillez choisir une option pour les sous-titres"
    }), f7 = xa({
        bN: "Subtitling method",
        bT: "Mode de sous-titrage"
    }), s7 = xa({
        bN: "Version mapping",
        bT: "Version mapping"
    }), l7 = xa({
        bN: "Extra version mapping",
        bT: "Version mapping compl\xe9mentaire"
    }), d7 = F3(function(n, r, t) {
        n: for(;;)switch(n.$){
            case 0:
                var e = d(t, A2(sp, function(n) {
                    var r = n.bQ.f$;
                    return r.$ ? Eo(n.bQ.d7) : ht(r.a);
                }, A2(Lu, $5, t)));
                return e.a.$ || e.b.$ ? OZ : A2(BX, k([
                    t7((J = e.b.a).lD.mo)
                ]), A2(qX, 0, EZ(H4)));
            case 1:
                switch(r.$){
                    case 0:
                        n = W4;
                        continue n;
                    case 1:
                        return OZ;
                    default:
                        return EZ(Ss);
                }
            case 2:
                if ((h = n.a).$) return EZ(Ss);
                var u = h.a, o = u.a, i = A2(Ra, function(n) {
                    return n.bb;
                }, u.b), c = A2(Ye, function(n) {
                    return d(n.mo, D5(n));
                }, i), f = g5(t), s = f.a, l = f.b, b = f.c, v = b.a, $ = b.b, g = {
                    lF: i,
                    oQ: o,
                    qt: kt,
                    qu: {
                        kK: za(function(n) {
                            return p(n, {
                                mS: !0,
                                m7: T5
                            });
                        }),
                        e4: za(function(n) {
                            return p(n, {
                                gw: y5
                            });
                        }),
                        e6: za(function(n) {
                            return p(n, {
                                gw: l7
                            });
                        }),
                        lT: za(function(n) {
                            return p(n, {
                                gw: "Format"
                            });
                        }),
                        nP: v,
                        n0: $,
                        oM: za(function(n) {
                            return p(n, {
                                gw: e7
                            });
                        }),
                        g3: A2(Ea, _4, c),
                        g9: za(function(n) {
                            return p(n, {
                                gw: u7
                            });
                        }),
                        rn: za(function(n) {
                            return p(n, {
                                gw: f7
                            });
                        }),
                        rv: za(function(n) {
                            return p(n, {
                                gw: P5
                            });
                        }),
                        dz: za(function(n) {
                            return p(n, {
                                gw: "Timecode in",
                                sw: s
                            });
                        }),
                        dA: za(function(n) {
                            return p(n, {
                                gw: "Timecode out",
                                sw: l
                            });
                        }),
                        r$: !a(c, w),
                        ic: za(function(n) {
                            return p(n, {
                                gw: s7
                            });
                        })
                    },
                    P: R4
                };
                return EZ(E4(g));
            case 3:
                var h = n.a;
                if (2 === r.$) {
                    var C = r.a;
                    if (h.$) return EZ(Ss);
                    var T = h.a.c8, P = h.a.dr, S = h.a.cX, A = h.a.dw, y = h.a.ic, N = h.a.e5, L = (bn = C.qu).e4, j = bn.e6, F = bn.lT, M = bn.ic, I = A2(ju, "", A2(Lu, function(n) {
                        return n.n6;
                    }, Eo(A2(Mu, function(n) {
                        return n.mO;
                    }, y)))), D = A2(ju, "", A2(Lu, function(n) {
                        return n.n6;
                    }, Eo(A2(Mu, function(n) {
                        return n.mQ;
                    }, y)))), B = A2(ju, "", 1 === qt(S) ? A2(Lu, function(n) {
                        return n.mo;
                    }, Eo(S)) : A2(Lu, function(n) {
                        return n.mo;
                    }, Eo(A2(Mu, function(n) {
                        return n.mO;
                    }, S)))), x = p(bn, {
                        e4: p(L, {
                            sw: A2(ju, "", 1 === qt(N) ? A2(Lu, function(n) {
                                return n.mo;
                            }, Eo(N)) : A2(Lu, function(n) {
                                return n.mo;
                            }, Eo(A2(Mu, function(n) {
                                return n.mO;
                            }, N))))
                        }),
                        e6: p(j, {
                            sw: D
                        }),
                        lT: p(F, {
                            sw: B
                        }),
                        ic: p(M, {
                            sw: I
                        })
                    });
                    return g = p(C, {
                        qt: ht({
                            e5: N,
                            cX: S,
                            c8: T,
                            dr: P,
                            dw: A,
                            ic: y
                        }),
                        qu: x
                    }), EZ(E4(g));
                }
                return OZ;
            case 4:
                var q = n.a, V = n.b, O = n.c, z = n.d, E = function() {
                    return 1 === O.$ ? A2(Y4, q, {
                        ad: z,
                        rP: V
                    }) : A2(r5, q, {
                        ad: z,
                        rP: O.a
                    });
                }();
                return KX(A2(Xa, q4, E));
            case 5:
                var H = n.a, R = (q = n.b, n.c), W = (O = n.d, d(R, r));
                if (W.a.$ || 2 !== W.b.$) return OZ;
                V = W.a.a, A = A2(ju, w, A2(Lu, function(n) {
                    return n.dw;
                }, (g = W.b.a).qt));
                var U = ze(g.qu.rv.sw) || Tu(A) || !ze(g.qu.rn.sw) ? "Burning" === g.qu.rn.sw || ze(g.qu.rn.sw) ? At(kt) : At(ht(g.qu.rn.sw)) : Ct(A2(ka, c7, s$)), Q = A2(Lu, $5, t), _ = "" === g.qu.kK.sw ? kt : ht(g.qu.kK.sw);
                if ("AsSource" === g.qu.lT.sw) {
                    z = function() {
                        if (Q.$) return kt;
                        var n = Q.a;
                        return ht({
                            lT: A2(Ia, kt, U),
                            mo: g.qu.rv.sw,
                            n6: A2(ju, "", A2(Lu, A2(Pi, function(n) {
                                return n.lD;
                            }, function(n) {
                                return n.n6;
                            }), Eo(A2(Mu, function(n) {
                                return a(n.lD.mo, g.qu.rv.sw);
                            }, n.bQ.ad))))
                        });
                    }(), n = A4(x4, q, V, O, z);
                    continue n;
                }
                var Z = function(n) {
                    return xy(ob(n));
                }, K = xy(U), X = vt(g.qu.g3.sx), J = A2(sp, function(n) {
                    return n.bQ.f$;
                }, Q), Y = xy(1 === qt(S = A2(ju, w, A2(Lu, function(n) {
                    return n.cX;
                }, g.qt))) ? At(A2(ju, "", Eo(A2(Ye, function(n) {
                    return n.mo;
                }, S)))) : ze(g.qu.lT.sw) ? Ct(A2(ka, S5, s$)) : At(g.qu.lT.sw)), G = ze(g.qu.e4.sw) || "NoExtra" === g.qu.e4.sw ? xy(At(kt)) : A2(Yb, ht, Z(g.qu.e6.sw)), nn = xy(ze(g.qu.e4.sw) || "NoExtra" === g.qu.e4.sw ? At(kt) : At(ht(g.qu.e4.sw))), rn = d(g.qu.dz.sw, g.qu.dA.sw), tn = (s = rn.a, l = rn.b, function() {
                    var n = d(X, J);
                    return n.a.b || n.b.$ ? iP(n.a) : g.qu.dz.fj || g.qu.dA.fj ? A2(Yb, Wo, A3(f5, n.b.a, s, l)) : a7(w);
                }()), en = A2(BT, function(n) {
                    var r, t = n.a, e = t.a, u = e.a, o = e.b, i = e.c, c = t.b, f = n.b, s = n.c;
                    return a(O, kt) && a(R, ht(H.oM)) ? By(Dy(A2(ka, i7, s$))) : B5(Q) ? (r = "" === g.qu.rv.sw ? {
                        bB: q,
                        e4: f,
                        e6: s,
                        lT: o,
                        fU: _,
                        g3: c,
                        ad: kt,
                        rP: O,
                        ci: V,
                        ic: u
                    } : {
                        bB: q,
                        e4: f,
                        e6: s,
                        lT: o,
                        fU: _,
                        g3: c,
                        ad: function() {
                            if (Q.$) return kt;
                            var n = Q.a;
                            return ht({
                                lT: i,
                                mo: g.qu.rv.sw,
                                n6: A2(ju, "", A2(Lu, A2(Pi, function(n) {
                                    return n.lD;
                                }, function(n) {
                                    return n.n6;
                                }), Eo(A2(Mu, function(n) {
                                    return a(n.lD.mo, g.qu.rv.sw);
                                }, n.bQ.ad))))
                            });
                        }(),
                        rP: O,
                        ci: V,
                        ic: u
                    }, A2(Yb, function(n) {
                        return n.mo;
                    }, mc(A2(Wi, C5, A3(ow, k5, {
                        e4: r.e4,
                        e6: r.e6,
                        lT: r.lT,
                        fU: r.fU,
                        g3: r.g3,
                        ad: r.ad,
                        ch: r.rP,
                        ci: r.ci,
                        ic: r.ic
                    }, rw(yi(q3(A2(x3, r.bB, 2))))))))) : By(Dy(A2(ka, Q4, s$)));
                }, A2(U4, function() {
                    return G;
                }, A2(Z6, function() {
                    return nn;
                }, A2(BT, function(n) {
                    return A2(Yb, function(r) {
                        return d(n, r);
                    }, tn);
                }, A2(Qi, Dy, A2(U4, function() {
                    return K;
                }, A2(Z6, function() {
                    return Y;
                }, Z(g.qu.ic.sw))))))));
                return A2(CX, A2(Xa, q4, en), EZ(E4(p(g, {
                    P: z4
                }))));
            case 6:
                var un = n.a;
                if (2 === r.$) {
                    if (g = r.a, 1 === un.$) return EZ(E4(p(g, {
                        P: V4(un.a.nP)
                    })));
                    var on = un.a, an = (P = A2(ju, w, A2(Lu, function(n) {
                        return n.dr;
                    }, g.qt)), A2(Mu, A2(Pi, function(n) {
                        return n.mo;
                    }, jo(on)), P)), cn = (bn = g.qu).g9, fn = bn.oM, sn = A2(Lu, function(n) {
                        return p(n, {
                            dr: an
                        });
                    }, g.qt), ln = E4(p(g, {
                        qt: sn,
                        qu: p(bn, {
                            oM: p(fn, {
                                sw: ""
                            }),
                            g9: p(cn, {
                                sw: ""
                            })
                        }),
                        P: O4(on)
                    }));
                    return A2(qX, 1, EZ(ln));
                }
                return OZ;
            case 17:
                var dn = n.a;
                return 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    kK: A2(ww, dn, bn.kK)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 9:
                return dn = n.a, 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    ic: A2(ww, dn, bn.ic)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 10:
                return dn = n.a, 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    e6: A2(ww, dn, bn.e6)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 11:
                return dn = n.a, 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    rv: A2(ww, dn, bn.rv)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 12:
                return dn = n.a, 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    rn: A2(ww, dn, bn.rn)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 13:
                return dn = n.a, 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    e4: A2(ww, dn, bn.e4)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 16:
                return S = n.a, dn = n.b, 2 === r.$ ? (x = p(bn = (g = r.a).qu, A2(N5, S, bn.rn.sw) ? {
                    lT: A2(ww, dn, bn.lT),
                    rn: A2($w, bn.rn, ""),
                    rv: A2($w, bn.rv, "")
                } : {
                    lT: A2(ww, dn, bn.lT)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 14:
                return dn = n.a, 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    oM: A2(ww, dn, bn.oM)
                }), A2(BX, k([
                    _5(x.oM.sw)
                ]), EZ(E4(p(g, {
                    qu: x
                }))))) : OZ;
            case 15:
                return dn = n.a, 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    g9: A2(ww, dn, bn.g9)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 7:
                return dn = n.a, 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    dz: A2(ww, dn, bn.dz)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 8:
                return dn = n.a, 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    dA: A2(ww, dn, bn.dA)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 18:
                return dn = n.a, 2 === r.$ ? (x = p(bn = (g = r.a).qu, {
                    g3: A2(ID, dn, bn.g3)
                }), EZ(E4(p(g, {
                    qu: x
                })))) : OZ;
            case 19:
                var mn = n.a;
                if (2 === r.$) {
                    var bn = (g = r.a).qu, pn = g5(t), vn = (s = pn.a, l = pn.b, pn.c);
                    return x = p(bn, {
                        nP: v = vn.a,
                        n0: $ = vn.b,
                        g3: o7(bn.g3),
                        dz: A2($w, bn.dz, s),
                        dA: A2($w, bn.dA, l),
                        r$: mn
                    }), EZ(E4(p(g, {
                        qu: x
                    })));
                }
                return OZ;
            default:
                var $n = m(r, n.a, n.b);
                r: for(;;){
                    if (2 === $n.a.$) {
                        if ($n.b) {
                            if ($n.c.$) break r;
                            return x = p(bn = (g = $n.a.a).qu, {
                                dA: p(l = bn.dA, {
                                    fj: !0,
                                    sw: w5($n.c.a)
                                })
                            }), EZ(E4(p(g, {
                                qu: x
                            })));
                        }
                        if ($n.c.$) break r;
                        x = p(bn = (g = $n.a.a).qu, {
                            dz: p(s = bn.dz, {
                                fj: !0,
                                sw: w5($n.c.a)
                            })
                        });
                        return EZ(E4(p(g, {
                            qu: x
                        })));
                    }
                    break r;
                }
                return OZ;
        }
    }), m7 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, b7 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, p7 = {
        $: 1
    }, v7 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $7 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, w7 = {
        $: 2
    }, g7 = {
        $: 1
    }, h7 = F4(function(n, r, t, e) {
        return A2(ju, e, A2(sp, AV, A2(Lu, ba(t), Eo(A2(Ye, function(n) {
            return n.sw;
        }, A2(Mu, function(r) {
            return a(r.n6, n);
        }, r))))));
    }), k7 = function(n) {
        var r = d(n.rc, n.rd);
        if (1 === r.a.$ && 1 === r.b.$) {
            var t = A2(Gi, F2(function(r, t) {
                return p(t, {
                    sw: A4(h7, r, n.c2, Da, "")
                });
            }), n.mD), e = A2(Gi, F2(function(r, t) {
                return p(t, {
                    sw: A4(h7, r, n.c2, Pe, !1)
                });
            }), n.jJ);
            return p(n, {
                jJ: e,
                mD: t
            });
        }
        return n;
    }, C7 = function(n) {
        return uw(ew(n));
    }, T7 = F2(function(n, r) {
        var t = $(A2(Kc, function(n) {
            var r = n.b;
            return "" === r.sw ? kt : ht(d(n.a, ga(r.sw)));
        }, pt(r.mD)), A2(Kc, function(n) {
            var r = n.b;
            return r.sw ? ht(d(n.a, ni(r.sw))) : kt;
        }, pt(r.jJ)));
        return A2(BT, function() {
            return mc(A2(Wi, V2, Ai(O2(n))));
        }, mc(A2(C7, wa(t), rw(O2(n)))));
    }), P7 = F2(function(n, r) {
        return mc(A2(Wi, Ub, A3(ow, IX, {
            n6: r.rX.sw
        }, dw(FX(n)))));
    }), S7 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A3(hi, n.a, Lu(ww(n.b)), r.mD);
                return EZ(p(r, {
                    mD: t
                }));
            case 2:
                return EZ(p(r, {
                    rX: A2(ww, n.a, r.rX)
                }));
            case 1:
                var e = A3(hi, n.a, Lu(vw(n.b)), r.jJ);
                return EZ(p(r, {
                    jJ: e
                }));
            case 3:
                return A2(BX, k([
                    A2(Xa, b7, A2(P7, (u = n.a).mo, r)),
                    A2(Xa, m7, A2(T7, u.mo, r))
                ]), EZ(p(r, {
                    P: w7
                })));
            case 4:
                if ((o = n.a).$) return EZ(p(r, {
                    P: $7(o.a)
                }));
                var u = o.a;
                return A2(xG, k([
                    1,
                    0
                ]), EZ(p(r, {
                    P: Ns,
                    rX: A2($w, r.rX, u.rX)
                })));
            case 6:
                return A2(qX, 1, A2(mG, function(n) {
                    return p(n, {
                        P: Ns
                    });
                }, A2(S7, B2(o = n.a), r)));
            case 5:
                return EZ((o = n.a).$ ? p(r, {
                    rc: v7(o.a)
                }) : k7(p(r, {
                    c2: o.a,
                    rc: g7
                })));
            case 7:
                var o;
                if ((o = n.a).$) return EZ(p(r, {
                    rd: v7(o.a)
                }));
                var a = o.a, i = A3(xt, F2(function(n, r) {
                    return "boolean" === n.sa ? A2(j4, A2(Cu, n.n6, ti(function(r) {
                        return p(r, {
                            m7: n.n6
                        });
                    })), r) : A2(Ry, A2(Cu, n.n6, za(function(r) {
                        return p(r, {
                            m7: n.n6
                        });
                    })), r);
                }), d(Su, Su), a.lC);
                return EZ(k7(p(r, {
                    jJ: e = i.b,
                    mD: t = i.a,
                    p5: ht(a),
                    rd: g7
                })));
            case 8:
                return EZ(p(r, {
                    P: p7,
                    rX: A2($w, r.rX, (u = n.a).rX)
                }));
            default:
                return EZ(p(r, {
                    P: Ns
                }));
        }
    }), y7 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, N7 = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), L7 = function(n) {
        return {
            $: 9,
            a: n
        };
    }, j7 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, M7 = function(n) {
        return mc(sw(fw(V1(n))));
    }, I7 = F2(function(n, r) {
        switch(n.$){
            case 3:
                return EZ(p(r, {
                    pG: A3(hi, (u = n.a).mo, function(n) {
                        return ht(A2(ju, !0, A2(Lu, pu, n)));
                    }, r.pG)
                }));
            case 5:
                return EZ(p(r, {
                    pn: A3(hi, (o = n.a) + "-" + n.b, function(n) {
                        return ht(A2(ju, !0, A2(Lu, pu, n)));
                    }, r.pn)
                }));
            case 6:
                return EZ(p(r, {
                    hH: A3(hi, (u = n.a).mo, function(n) {
                        return ht(A2(ju, !0, A2(Lu, pu, n)));
                    }, r.hH)
                }));
            case 0:
                return E1(k([
                    U2((u = n.b).fL),
                    A2(Ka, L7, wK(u.mo))
                ]));
            case 1:
                var t = n.b, e = c3((u = n.c).c$);
                return E1(k([
                    n3(u.fL),
                    A2(Ka, j7, A3(dJ, t, e, u.n6))
                ]));
            case 2:
                var u;
                return E1(k([
                    q1((u = n.b).fL),
                    A2(Ka, y7, lK(u.mo))
                ]));
            case 9:
            case 8:
            case 7:
                return H1(1);
            case 4:
                return EZ(p(r, {
                    oE: A2(A2(pX, o = n.a, r.oE) ? hX : If, o, r.oE)
                }));
            case 10:
                return E1(k([
                    A2(Ka, N7(o = n.a), M7(o))
                ]));
            case 11:
                var o = n.a, a = n.b;
                if (a.$) {
                    var i = a.a;
                    return EZ(p(r, {
                        lp: A3(hi, o, function() {
                            return ht(i.nP);
                        }, r.lp)
                    }));
                }
                return H1(1);
            default:
                return OZ;
        }
    }), D7 = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), B7 = function(n) {
        return {
            $: 11,
            a: n
        };
    }, x7 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, q7 = F2(function(n, r) {
        return mc(A2(nw, Ev, A3(ow, kG, r, rw(dl(jX(A2(LX, n.mo, 1)))))));
    }), V7 = function(n) {
        return p(n, {
            lo: kt
        });
    }, O7 = F2(function(n, r) {
        return s(n, r) > 0;
    }), z7 = Jv, E7 = xa({
        bN: "Wrong expiration date: must be greater than today.",
        bT: "Date d\u2019expiration erron\xe9e : doit \xeatre sup\xe9rieur \xe0 aujourd'hui."
    }), H7 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return EZ(p(r, {
                    la: A2(ww, n.a, r.la),
                    lo: kt
                }));
            case 1:
                return EZ(p(r, {
                    lo: kt,
                    nP: A2(ww, n.a, r.nP)
                }));
            case 2:
                return EZ(p(r, {
                    lo: kt,
                    lt: A2(ww, n.a, r.lt)
                }));
            case 4:
                return EZ(p(r, {
                    jz: A2(vw, n.a, r.jz),
                    lo: kt
                }));
            case 3:
                return EZ(p(r, {
                    jA: A2(vw, n.a, r.jA),
                    lo: kt
                }));
            case 5:
                return EZ(r);
            case 6:
                return EZ(p(r, {
                    kU: !r.kU,
                    lo: kt
                }));
            case 7:
                return A2(BX, k([
                    A2(Xa, x7, (i = n.a, mc(sw(fw(SG(i.mo))))))
                ]), EZ(V7(r)));
            case 8:
                return (t = n.a).$ ? EZ(p(r, {
                    lo: ht(t.a)
                })) : H1(1);
            case 11:
                var t;
                return (t = n.a).$ ? EZ(p(r, {
                    lo: ht(t.a)
                })) : A2(xG, k([
                    1
                ]), EZ(p(r, {
                    jz: Ms,
                    jA: Ds,
                    kU: !1,
                    la: qs,
                    lo: kt,
                    lt: Os,
                    nP: Es
                })));
            case 9:
                var e = n.a, u = n.b, o = A2(ha, function() {
                    return kt;
                }, A2(X$, Me, LG(r.lt.sw))), a = {
                    cJ: r.jz.sw,
                    la: r.la.sw,
                    cO: o.$ ? kt : ht(o.a),
                    nP: r.nP.sw,
                    sk: r.jA.sw
                };
                return o.$ || A2(O7, o.a, u) ? A2(BX, k([
                    A2(Xa, B7, A2(q7, e, a))
                ]), EZ(V7(r))) : EZ(p(r, {
                    lo: ht(A3(Ki, 1, E7, Su))
                }));
            default:
                return A2(BX, k([
                    A2(Yv, D7(e = n.a), z7)
                ]), EZ(r));
        }
        var i;
    }), R7 = function(n) {
        return {
            $: 13,
            a: n
        };
    }, W7 = function(n) {
        return {
            $: 39,
            a: n
        };
    }, U7 = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Q7 = function(n) {
        return {
            $: 10,
            a: n
        };
    }, _7 = function(n) {
        return {
            $: 32,
            a: n
        };
    }, Z7 = function(n) {
        return {
            $: 34,
            a: n
        };
    }, K7 = function(n) {
        return {
            $: 33,
            a: n
        };
    }, X7 = function(n) {
        return {
            $: 20,
            a: n
        };
    }, J7 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Y7 = function(n) {
        return {
            $: 12,
            a: n
        };
    }, G7 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, n9 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, r9 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, t9 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, e9 = {
        $: 1
    }, u9 = function(n) {
        return {
            $: 11,
            a: n
        };
    }, o9 = function(n) {
        return {
            $: 41,
            a: n
        };
    }, a9 = {
        $: 2
    }, i9 = function(n) {
        return {
            $: 24,
            a: n
        };
    }, c9 = function(n) {
        return {
            $: 17,
            a: n
        };
    }, f9 = F2(function(n, r) {
        return A2(Yb, function() {
            return 0;
        }, mc(A2(Wi, d0, A3(ow, H3, {
            di: r
        }, rw(dl(jX(A2(LX, n.mo, 5))))))));
    }), s9 = function(n) {
        return mc(sw(rw(dl(Wx(A2(Oz, n.mo, 3))))));
    }, l9 = dl(ZP({
        $: 2
    })), d9 = F2(function(n, r) {
        return {
            mo: n,
            n6: r
        };
    }), m9 = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(d9)))), b9 = ic(m9), p9 = mc(A2(Wi, b9, Ai(l9))), v9 = F2(function(n, r) {
        return {
            mo: n,
            n6: r
        };
    }), $9 = Fi(A4(rc, "name", function(n) {
        return n.n6;
    }, Oa, A4(rc, "id", function(n) {
        return n.mo;
    }, Oa, Mi(v9)))), w9 = ic($9), g9 = F2(function(n, r) {
        return {
            gX: r,
            hO: n
        };
    }), h9 = Fi(A4(rc, "rulesId", function(n) {
        return n.gX;
    }, Oa, A4(rc, "task", function(n) {
        return n.hO;
    }, Oa, Mi(g9)))), k9 = F3(function(n, r, t) {
        return mc(sw(A3(ow, h9, {
            gX: t,
            hO: r
        }, rw(yi(q3(A2(x3, n, 0)))))));
    }), C9 = Fi(A4(rc, "configuration", function(n) {
        return n.aj;
    }, Oa, Mi(function(n) {
        return {
            aj: n
        };
    }))), T9 = F2(function(n, r) {
        return mc(sw(A3(ow, C9, {
            aj: r
        }, rw(function(n) {
            return dl(ZP(function(n) {
                return {
                    $: 0,
                    a: n
                };
            }(n)));
        }(n)))));
    }), P9 = function(n) {
        return mc(sw(rw(dl(Wx(A2(Oz, n.mo, 5))))));
    }, S9 = F2(function(n, r) {
        var t = "" === r ? kt : ht(r);
        return mc(sw(A3(ow, O3, {
            bE: t
        }, rw(V3(n.mo)))));
    }), y9 = Zn("switchPlayer", function() {
        return va;
    }), N9 = F8(function(n, r, t, e, u, o, a, i) {
        return {
            j2: i,
            eC: u,
            ky: r,
            lD: e,
            mo: n,
            fV: a,
            bl: o,
            rR: t
        };
    }), L9 = F2(function(n, r) {
        return {
            fL: n,
            sw: r
        };
    }), j9 = function(n) {
        return A8(N9, n.bl.mo, n.bl.ki, n.bl.rS, n.lD.n6, A2(Ht, F2(function(n, r) {
            var t;
            return A2(L9, Mt(n), (t = Nx(r)).n6 ? "blackframe \u2208 [" + Mt(t.nU) + " ms, " + Mt(t.nL) + " ms]" : "silence \u2208 [" + Mt(t.nU) + " ms, " + Mt(t.nL) + " ms]");
        }), n.bl.jK), n.gU, n.bl.fV, n.bl.j2);
    }, M9 = function(n) {
        return mc(sw(rw(KG(n.mo))));
    }, I9 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, D9 = F3(function(n, r, t) {
        return {
            c$: t,
            sr: n,
            ib: r
        };
    }), B9 = Fi(A4(rc, "destFileKind", function(n) {
        return n.c$;
    }, aJ, A4(rc, "destVersionId", function(n) {
        return n.ib;
    }, Oa, A4(rc, "srcUrl", function(n) {
        return n.sr;
    }, Oa, Mi(D9))))), x9 = yi(yF({
        $: 4
    })), q9 = function(n) {
        switch(n){
            case "Material":
                return 0;
            case "Audio":
                return 1;
            case "Subtitle":
                return 2;
            default:
                return 3;
        }
    }, V9 = F2(function(n, r) {
        return mc(sw(A3(ow, B9, {
            c$: q9(r.qo.sw),
            sr: r.mB.sw,
            ib: n.mo
        }, rw(x9))));
    }), O9 = F8(function(n, r, t, e, u, o, a, i) {
        return {
            l4: i,
            fs: e,
            o_: t,
            o0: o,
            gz: u,
            pl: n,
            qb: a,
            sv: r
        };
    }), z9 = A3(BW, "hash", Da, A3(BW, "search", Da, A3(BW, "pathname", Da, A3(BW, "port", Da, A3(BW, "hostname", Da, A3(BW, "password", Da, A3(BW, "username", Da, A3(BW, "protocol", Da, je(O9))))))))), E9 = A2(Pi, A2(HE, k([
        d("url", ga)
    ]), " return new URL(url); "), xE(z9)), H9 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(V9, n.a, r);
                return E1(k([
                    A2(Xa, I9, A2(BT, function() {
                        return t;
                    }, A2(Qi, function() {
                        return {
                            lC: Su,
                            nP: "URL incorrect",
                            P: 500
                        };
                    }, E9(r.mB.sw))))
                ]));
            case 1:
                var e = n.a;
                return EZ(p(r, e.$ ? {
                    lo: ht(e.a)
                } : {
                    lo: kt,
                    mB: qx(r.mB),
                    qo: qx(r.qo)
                }));
            case 2:
                var u = p(r, {
                    mB: A2(ww, n.a, r.mB)
                });
                return EZ(u);
            default:
                return EZ(p(r, {
                    qo: A2(ww, n.a, r.qo)
                }));
        }
    }), R9 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, W9 = F7(function(n, r, t, e, u, o, a) {
        return {
            bD: o,
            fr: t,
            c$: a,
            o_: r,
            gs: u,
            gz: e,
            st: n
        };
    }), U9 = Fi(A4(rc, "kind", function(n) {
        return n.c$;
    }, aJ, A4(rc, "versionId", function(n) {
        return n.bD;
    }, Oa, A4(rc, "path", function(n) {
        return n.gs;
    }, Oa, A4(rc, "port", function(n) {
        return n.gz;
    }, Oa, A4(rc, "host", function(n) {
        return n.fr;
    }, Oa, A4(rc, "password", function(n) {
        return n.o_;
    }, Oa, A4(rc, "user", function(n) {
        return n.st;
    }, Oa, Mi(W9))))))))), Q9 = dl({
        $: 22
    }), _9 = F7(function(n, r, t, e, u, o, a) {
        var i = A7(W9, r, t, e, u, o, n.mo, q9(a));
        return mc(sw(A3(ow, U9, i, rw(Q9))));
    }), Z9 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return E1(k([
                    A2(Xa, R9, A7(_9, n.a, r.mC.sw, r.mw.sw, r.mv.sw, r.my.sw, r.mx.sw, r.qo.sw))
                ]));
            case 1:
                var t = n.a;
                return EZ(p(r, t.$ ? {
                    lo: ht(t.a)
                } : {
                    lo: kt,
                    mv: qx(r.mv),
                    mw: qx(r.mw),
                    mx: qx(r.mx),
                    my: qx(r.my),
                    mC: qx(r.mC),
                    qo: qx(r.qo)
                }));
            case 2:
                return EZ(p(r, {
                    mC: A2(ww, n.a, r.mC)
                }));
            case 3:
                return EZ(p(r, {
                    mw: A2(ww, n.a, r.mw)
                }));
            case 4:
                return EZ(p(r, {
                    mv: A2(ww, n.a, r.mv)
                }));
            case 5:
                return EZ(p(r, {
                    my: A2(ww, n.a, r.my)
                }));
            case 6:
                return EZ(p(r, {
                    mx: A2(ww, n.a, r.mx)
                }));
            default:
                return EZ(p(r, {
                    qo: A2(ww, n.a, r.qo)
                }));
        }
    }), K9 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, X9 = dl({
        $: 21,
        a: 0
    }), J9 = F4(function(n, r, t, e) {
        return {
            bD: t,
            en: n,
            fL: r,
            c$: e
        };
    }), Y9 = Fi(A4(rc, "kind", function(n) {
        return n.c$;
    }, aJ, A4(rc, "broadcastable", function(n) {
        return n.bD;
    }, Oa, A4(rc, "key", function(n) {
        return n.fL;
    }, Oa, A4(rc, "bucket", function(n) {
        return n.en;
    }, Oa, Mi(J9)))))), G9 = F4(function(n, r, t, e) {
        return mc(sw(A3(ow, Y9, {
            bD: n.mo,
            en: r,
            fL: t,
            c$: q9(e)
        }, rw(X9))));
    }), n8 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(BX, k([
                    A2(Xa, K9, A4(G9, n.a, r.mz.sw, r.mA.sw, r.qo.sw))
                ]), EZ(r));
            case 1:
                return EZ(n.a.$ ? r : p(r, {
                    mz: qx(r.mz),
                    mA: qx(r.mA),
                    qo: qx(r.qo)
                }));
            case 2:
                return EZ(p(r, {
                    mz: A2(ww, n.a, r.mz)
                }));
            case 3:
                return EZ(p(r, {
                    mA: A2(ww, n.a, r.mA)
                }));
            default:
                return EZ(p(r, {
                    qo: A2(ww, n.a, r.qo)
                }));
        }
    }), r8 = Fi(A4(rc, "versionMapping", function(n) {
        return n.ic;
    }, ib, Mi(function(n) {
        return {
            ic: n
        };
    }))), t8 = F2(function(n, r) {
        return mc(sw(A3(ow, r8, {
            ic: r
        }, rw(dl(Q3(A2(U3, n.mo, 4)))))));
    }), e8 = F2(function(n, r) {
        switch(n.$){
            case 11:
                return A3(bG, function(n) {
                    return p(r, {
                        pY: n
                    });
                }, u9, A2(n8, n.a, r.pY));
            case 12:
                return A3(bG, function(n) {
                    return p(r, {
                        l$: n
                    });
                }, Y7, A2(Z9, n.a, r.l$));
            case 13:
                return A3(bG, function(n) {
                    return p(r, {
                        iA: n
                    });
                }, R7, A2(H9, n.a, r.iA));
            case 30:
                return EZ(p(r, {
                    kD: A2(ww, n.a, r.kD)
                }));
            case 31:
                return EZ(p(r, {
                    qG: A2(ww, n.a, r.qG)
                }));
            case 6:
                return A2(BX, k([
                    A2(Xa, J7, (m = n.a, mc(sw(rw(yi(q3(A2(x3, m.mo, 3))))))))
                ]), EZ(p(r, {
                    kH: e9
                })));
            case 7:
                return (f = n.a).$ ? EZ(p(r, {
                    kH: G7(f.a)
                })) : A2(qX, 1, EZ(p(r, {
                    kH: a9
                })));
            case 0:
                return A2(BX, k([
                    A2(Xa, t9, (l = n.a, mc(sw(rw(dl(Wx(A2(Oz, l.mo, 4))))))))
                ]), EZ(p(r, {
                    pL: e9
                })));
            case 1:
                return (f = n.a).$ ? EZ(p(r, {
                    pL: G7(f.a)
                })) : A2(qX, 1, EZ(p(r, {
                    pL: a9
                })));
            case 2:
                return A2(BX, k([
                    A2(Xa, n9, P9(n.a))
                ]), EZ(p(r, {
                    pJ: e9
                })));
            case 3:
                return (f = n.a).$ ? EZ(p(r, {
                    pJ: G7(f.a)
                })) : A2(qX, 1, EZ(p(r, {
                    pJ: a9
                })));
            case 4:
                return A2(BX, k([
                    A2(Xa, r9, A2(S9, n.a, r.bE.sw))
                ]), EZ(p(r, {
                    pK: e9
                })));
            case 5:
                return (f = n.a).$ ? EZ(p(r, {
                    pK: G7(f.a)
                })) : A2(qX, 1, EZ(p(r, {
                    pK: a9
                })));
            case 8:
                return EZ(p(r, {
                    bE: A2(ww, n.a, r.bE)
                }));
            case 14:
                return EZ(p(r, {
                    kh: A2(ww, n.a, r.kh)
                }));
            case 9:
                return A2(BX, k([
                    A2(Xa, Q7, A2(f9, n.a, r.kh.sw))
                ]), EZ(p(r, {
                    kg: e9
                })));
            case 10:
                return (f = n.a).$ ? EZ(p(r, {
                    kg: G7(f.a)
                })) : A2(qX, 1, EZ(p(r, {
                    kg: a9,
                    kh: Z3(r.kh)
                })));
            case 15:
                switch(n.a){
                    case 9:
                        return EZ(p(r, {
                            kH: Rs
                        }));
                    case 0:
                        return EZ(p(r, {
                            pL: Rs
                        }));
                    case 1:
                        return EZ(p(r, {
                            pJ: Rs
                        }));
                    case 2:
                        return EZ(p(r, {
                            pK: Rs
                        }));
                    case 3:
                        return EZ(p(r, {
                            kg: Rs
                        }));
                    case 4:
                        return EZ(p(r, {
                            si: Rs
                        }));
                    case 6:
                        return EZ(p(r, {
                            kG: Rs
                        }));
                    case 7:
                        return EZ(p(r, {
                            d2: Rs
                        }));
                    case 8:
                        return EZ(p(r, {
                            iN: Rs
                        }));
                    default:
                        return OZ;
                }
            case 16:
                var t = n.a, e = ob(n.b.sw);
                return e.$ ? OZ : A2(qX, 1, A2(BX, k([
                    A2(Xa, c9, A2(t8, t, e.a))
                ]), EZ(p(r, {
                    si: e9
                }))));
            case 17:
                var u = n.a;
                return u.$ ? EZ(p(r, {
                    si: G7(u.a)
                })) : A2(qX, 1, EZ(p(r, {
                    si: a9
                })));
            case 18:
                return EZ(p(r, {
                    i5: A2(ww, n.a, r.i5),
                    si: Rs
                }));
            case 19:
                return A2(BX, k([
                    A2(Xa, X7, s9(n.a))
                ]), EZ(p(r, {
                    kG: e9
                })));
            case 20:
                return (f = n.a).$ ? EZ(p(r, {
                    kG: G7(f.a)
                })) : A2(qX, 1, EZ(p(r, {
                    kG: a9
                })));
            case 21:
                return A2(BX, k([
                    A2(Xa, U7, (s = n.a, mc(sw(rw(WG(s.mo))))))
                ]), EZ(p(r, {
                    d2: e9
                })));
            case 22:
                return (f = n.a).$ ? EZ(p(r, {
                    d2: G7(f.a)
                })) : A2(qX, 1, A2(qX, 0, EZ(p(r, {
                    d2: a9
                }))));
            case 23:
                return A2(BX, k([
                    A2(Xa, i9, M9(n.a))
                ]), EZ(p(r, {
                    d2: e9
                })));
            case 24:
                return (f = n.a).$ ? EZ(p(r, {
                    d2: G7(f.a)
                })) : A2(qX, 1, A2(qX, 0, EZ(p(r, {
                    d2: a9
                }))));
            case 25:
                return A2(BX, k([
                    y9(0)
                ]), EZ(r));
            case 28:
                return EZ(p(r, {
                    kq: ht(n.a)
                }));
            case 29:
                return A2(CX, A2(Xa, _7, A2(T9, n.a, n.b)), EZ(p(r, {
                    pg: e9
                })));
            case 32:
                return EZ(p(r, (f = n.a).$ ? {
                    pg: G7(f.a)
                } : {
                    pg: a9
                }));
            case 26:
                var o = (b = d(r.ma, r.g9)).a && !b.b.$ ? A2(Xa, K7, mc(A2(Wi, vx, Ai(dl(ZP(function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(b.b.a.g9.mo))))))) : n$;
                return A2(CX, o, EZ(p(r, {
                    ma: !r.ma
                })));
            case 33:
                if ((f = n.a).$) return EZ(p(r, {
                    pg: G7(f.a)
                }));
                var i = f.a;
                return EZ(p(r, {
                    pg: a9,
                    dh: A2(Ye, A2(bu, V$(!1), j9), i)
                }));
            case 27:
                var c = n.a;
                return EZ(p(r, {
                    dh: A2(Ye, function(n) {
                        return a(A2(Pi, Zi, function(n) {
                            return n.mo;
                        })(n), c) ? d(!n.a, n.b) : n;
                    }, r.dh)
                }));
            case 35:
                return A2(CX, A2(Xa, Z7, p9), EZ(p(r, {
                    l9: !1
                })));
            case 34:
                return EZ(p(r, (f = n.a).$ ? {
                    pg: G7(f.a)
                } : {
                    ph: f.a
                }));
            case 36:
                return EZ(p(r, {
                    g9: ht(n.a)
                }));
            case 37:
                return EZ(p(r, {
                    pp: ht(n.a)
                }));
            case 38:
                return A2(BX, k([
                    A2(Xa, W7, A3(k9, n.a, "Media2Cloud", n.b))
                ]), EZ(p(r, {
                    iN: e9
                })));
            case 39:
                return EZ(p(r, (f = n.a).$ ? {
                    iN: G7(f.a)
                } : {
                    iN: a9
                }));
            case 42:
                return A2(CX, A2(Xa, o9, mc(A2(Wi, w9, Ai(yi(I$(A2(yD, n.a, 2))))))), EZ(p(r, {
                    mb: !1
                })));
            case 40:
                return EZ(p(r, {
                    qk: A2(ww, n.a, r.qk)
                }));
            default:
                var f;
                return EZ(p(r, (f = n.a).$ ? {
                    iN: G7(f.a)
                } : {
                    $7: f.a
                }));
        }
        var s, l, m, b;
    }), u8 = {
        $: 5
    }, o8 = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), a8 = xa({
        bN: "Wrong layout and/or version",
        bT: "Erreur sur une version et/ou un agencement"
    }), i8 = F3(function(n, r, t) {
        return {
            fv: n,
            r9: t,
            sz: r
        };
    }), c8 = Fi(A4(rc, "typeVersion", function(n) {
        return n.r9;
    }, AA, A4(rc, "version", function(n) {
        return n.sz;
    }, g$, A4(rc, "index", function(n) {
        return n.fv;
    }, uc, Mi(i8))))), f8 = F4(function(n, r, t, e) {
        var u = d(r, t);
        return u.a.$ || u.b.$ ? By({
            lC: Su,
            nP: a8,
            P: 400
        }) : mc(sw(A3(ow, c8, {
            fv: e,
            r9: u.b.a,
            sz: u.a.a
        }, rw(yi(k4(A2(h4, n, 1)))))));
    }), s8 = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 2:
                var t = n.a, e = n.b, u = n.c, o = {
                    r9: za(function(n) {
                        return p(n, {
                            m7: "TypeVersion",
                            sw: A2(ju, "", u)
                        });
                    }),
                    sz: za(function(n) {
                        return p(n, {
                            m7: "Version",
                            sw: A2(ju, "", e)
                        });
                    })
                };
                return EZ(p(r, {
                    pw: ht(t),
                    sB: A3(Cu, t, o, r.sB)
                }));
            case 0:
                var a = n.b;
                return EZ(p(r, {
                    sB: A3(hi, i = n.a, Lu(function(n) {
                        return p(n, {
                            sz: A2(ww, a, n.sz)
                        });
                    }), r.sB)
                }));
            case 1:
                return a = n.b, EZ(p(r, {
                    sB: A3(hi, i = n.a, Lu(function(n) {
                        return p(n, {
                            r9: A2(ww, a, n.r9)
                        });
                    }), r.sB)
                }));
            case 5:
                return OZ;
            case 7:
                n = u8;
                continue n;
            case 4:
                return A2(BX, k([
                    A2(Yv, Dl(u8), qE(200))
                ]), EZ(r));
            case 6:
                return EZ(p(r, {
                    pw: kt,
                    sB: A2(gi, t = n.a, r.sB)
                }));
            default:
                var i = n.a, c = function(n) {
                    var r = He(n);
                    return r.$ ? -1 : r.a;
                }, f = function(n) {
                    var r = A2(Dt, "/", n);
                    return r.b && r.b.b ? d(r.a, r.b.a) : d("", "");
                }, s = function() {
                    var n = A2(di, i, r.sB);
                    if (1 === n.$) return d(kt, kt);
                    var t = n.a.r9;
                    return d(AV($$(n.a.sz.sw)), AV(PA(t.sw)));
                }(), l = s.a, m = s.b, b = A2(j4, c, f(i)).a;
                return A2(BX, k([
                    A2(Xa, o8(i), A4(f8, b, l, m, 0))
                ]), EZ(p(r, {
                    pw: kt
                })));
        }
    }), l8 = F3(function(n, r, t) {
        n: for(;;)switch(n.$){
            case 0:
                return EZ(r);
            case 18:
                return EZ(p(r, {
                    qD: !r.qD
                }));
            case 17:
                var e = r.ka;
                return EZ(p(r, {
                    ka: p(e, {
                        oE: A2(A2(pX, O = n.a, e.oE) ? hX : If, O, e.oE)
                    })
                }));
            case 19:
                return EZ(p(r, {
                    qE: !r.qE
                }));
            case 20:
                return EZ(p(r, {
                    qF: !r.qF
                }));
            case 1:
                return D2(r) && !a(r.P.kx, kt) ? EZ(p(r, {
                    nk: !0
                })) : A2(BX, k([
                    A2(Xa, P1, y2(r.mo)),
                    A2(Xa, T1, c0(A2(ju, "", r.oM))),
                    A2(Xa, C1, e0(r.mo)),
                    e3,
                    o3
                ]), EZ(r3(p(r, {
                    nk: !1
                }))));
            case 4:
                return EZ(p(r, (z = n.a).$ ? {
                    e2: A2(KK, z.a, r.e2.kx)
                } : {
                    e2: PX(z.a)
                }));
            case 40:
                return n.a.$ ? OZ : KX(YZ(0));
            case 2:
                if ((z = n.a).$) return EZ(p(r, {
                    P: A2(KK, z.a, r.P.kx)
                }));
                var u = r.o6, o = r.iq, i = a(t.st.oM, ht((P = z.a).oM.mo)) ? Me : CX(A2(Xa, A1, yK(P.oM.mo))), c = function(n) {
                    return n.bQ.f$;
                }(A2(U1, r, P)), f = A2(ju, "00:00:00:00", A2(sp, M2, c)), s = !a(A2(Lu, A2(Pi, function(n) {
                    return n.g9;
                }, function(n) {
                    return n.mo;
                }), r.P.kx), ht(P.g9.mo)), l = function() {
                    var n = r.o3;
                    if (n.$) return K2(r);
                    var t = n.a;
                    return s ? K2(r) : ht(t);
                }();
                return i(A2(BX, k([
                    A2(cp, u_, i3(P)),
                    A2(cp, t_, e3),
                    A2(cp, k1, A2(R2, P.oM.mo, r.mo))
                ]), EZ(p(r, {
                    iq: p(o, {
                        q5: f
                    }),
                    o3: l,
                    o6: function() {
                        return l.$ ? u : A2(J2, r, l.a);
                    }(),
                    P: PX(P)
                }))));
            case 3:
                if ((z = n.a).$) return EZ(p(r, {
                    P: A2(KK, z.a, r.P.kx)
                }));
                var b = z.a;
                return A2(BX, k([
                    A2(cp, u_, a3(b))
                ]), EZ(p(r, {
                    po: ht(b)
                })));
            case 31:
                var v = n.a, $ = K2(r), g = function() {
                    return $.$ ? r.o6 : A2(J2, r, $.a);
                }();
                return EZ(p(r, {
                    o3: A2(Lu, function(n) {
                        return p(n, {
                            rp: v
                        });
                    }, $),
                    o5: !1,
                    o6: p(g, {
                        rp: v
                    })
                }));
            case 27:
                if (10 === n.a.$) {
                    var h = n.a.a;
                    if (h.$) return A2(Y2, p(r, {
                        o3: kt
                    }), !0);
                    var C = h.a, T = r.P.kx;
                    if (T.$) return EZ(r);
                    var P = T.a, S = function() {
                        if (C.$) {
                            var n = C.a, t = A2(Dt, "/", n);
                            if (t.b && t.b.b) {
                                var e = t.a, u = t.b.a;
                                return m(A3(Q1, r, P, e), A3(_1, r, P, e), He(u));
                            }
                            return m(A3(Q1, r, P, n), A3(_1, r, P, n), kt);
                        }
                        return m(kt, A2(sp, A2(Pi, function(n) {
                            return n.pm;
                        }, function(n) {
                            return n.nw;
                        }), A2(U1, r, P).bQ.f$), kt);
                    }(), A = S.a, y = S.b, N = S.c, L = A2(ju, kt, A2(Lu, n0, A)), j = A2(ju, w, A2(Lu, X1, A));
                    return f = A2(ju, "00:00:00:00", A2(sp, M2, A)), EZ(y.$ ? r : p(r, {
                        o3: ht(A6(R1, f, y.a.mo, L, N, ht(25), j)),
                        o5: !1
                    }));
                }
                return A3(bG, function(n) {
                    var t, e = 1 === (t = n.qp).$ ? r.i7.qp : ht(t.a);
                    return p(r, {
                        i7: p(n, {
                            qp: e
                        })
                    });
                }, t_, A2(D4, Q = n.a, r.i7));
            case 28:
                if (7 === (Q = n.a).$) {
                    if ((z = Q.b).$) return OZ;
                    var F = p(r.i7, {
                        sB: A2(gi, Q.a, r.i7.sB)
                    }), M = p(r, {
                        i7: F
                    });
                    return A2(qX, 1, EZ(M));
                }
                return A3(bG, function(n) {
                    return p(r, {
                        rq: n
                    });
                }, F1, A2(s8, Q, r.rq));
            case 5:
                switch(n.a.$){
                    case 12:
                        if (n.a.a.$) return A2(Y2, p(r, {
                            o3: kt
                        }), !1);
                        if (a(ht(O = n.a.a.a), A2(Lu, function(n) {
                            return n.n3;
                        }, r.o3))) return A2(Y2, r, !0);
                        var I = function() {
                            var n = r.P.kx;
                            return n.$ ? kt : Eo(A2(Kc, Me, A2(Kc, function(n) {
                                return A2(Lu, function(r) {
                                    return a(r.mo, O) ? ht(n) : kt;
                                }, n.gL);
                            }, n.a.bP)));
                        }(), D = A2(ju, kt, A2(Lu, o0, I));
                        return f = A2(ju, "00:00:00:00", A2(sp, I2, I)), L = A2(ju, kt, A2(Lu, G1, I)), EZ(p(r, {
                            i7: X2(r),
                            o3: A2(Lu, A2(bu, A5(R1, f, O, L, kt, D), J1), I),
                            o5: !1
                        }));
                    case 13:
                        var B = a(ht(ht(O = n.a.a)), A2(Lu, function(n) {
                            return n.rp;
                        }, r.o3)) ? kt : ht(O), x = (g = r.o6, A2(Lu, function(n) {
                            return p(n, {
                                rp: B
                            });
                        }, r.o3));
                        return EZ(p(r, {
                            o3: x,
                            o6: p(g, {
                                rp: B
                            })
                        }));
                    default:
                        return A3(bG, function(n) {
                            return p(r, {
                                bQ: n
                            });
                        }, S1, A2(I7, Q = n.a, r.bQ));
                }
            case 6:
                if (33 === n.a.$) {
                    var q = r.iq;
                    return A2(Y2, p(r, {
                        iq: p(q, {
                            l3: !q.l3
                        }),
                        o3: kt,
                        o6: ns
                    }), !0);
                }
                return A3(bG, function(n) {
                    return p(r, {
                        iq: n
                    });
                }, b1, A3(m4, Q = n.a, r.iq, r.o6));
            case 7:
                return A3(bG, function(n) {
                    return p(r, {
                        ij: n
                    });
                }, m1, A2(K3, Q = n.a, r.ij));
            case 8:
                return A3(bG, function(n) {
                    return p(r, {
                        d2: n
                    });
                }, p1, A2(n1, Q = n.a, r.d2));
            case 9:
                return A3(bG, function(n) {
                    return p(r, {
                        k3: n
                    });
                }, k1, A2(S7, Q = n.a, r.k3));
            case 10:
                return EZ(r);
            case 11:
                return A3(bG, function(n) {
                    return p(r, {
                        oJ: n
                    });
                }, u_, A2(e8, Q = n.a, r.oJ));
            case 12:
                return A3(bG, function(n) {
                    return p(r, {
                        ja: n
                    });
                }, v1, A2(B4, Q = n.a, r.ja));
            case 13:
                return A3(bG, function(n) {
                    return p(r, {
                        fD: n
                    });
                }, y1, A2(H7, Q = n.a, r.fD));
            case 14:
                return A3(bG, function(n) {
                    return p(r, {
                        cJ: n
                    });
                }, h1, A2(s1, Q = n.a, r.cJ));
            case 15:
                if (20 === n.a.$ && 1 === n.a.b.$) {
                    n = g1(A2(L1, n.a.a, ht(A2(B1, r.o6.q5, r.o6.kr))));
                    continue n;
                }
                return A3(bG, function(n) {
                    return p(r, {
                        kJ: n
                    });
                }, g1, A3(d7, Q = n.a, r.kJ, r.P.kx));
            case 16:
                return x = r.o3, EZ(p(r, {
                    jr: !r.jr,
                    o3: r.jr ? kt : x,
                    o5: !!r.jr || r.o5,
                    o6: r.jr ? ns : r.o6
                }));
            case 21:
                return E1(k([
                    U2((I = n.b).fL),
                    A2(Xa, N1, wK(I.mo))
                ]));
            case 25:
                return E1(k([
                    q1((I = n.b).fL),
                    A2(Xa, $1, lK(I.mo))
                ]));
            case 23:
                P = n.b;
                var V = c3((I = n.c).c$);
                return E1(k([
                    n3(I.fL),
                    A2(Xa, j1, A3(dJ, P, V, I.n6))
                ]));
            case 22:
            case 24:
            case 26:
                return H1(1);
            case 29:
                var O;
                return A2(BX, k([
                    A2(Xa, w1, O1(O = n.a))
                ]), EZ(r));
            case 30:
                var z;
                return (z = n.a).$ ? OZ : A2(qX, 1, EZ(r));
            case 32:
                return A2(Y2, p(r, {
                    o5: !1
                }), !1);
            case 34:
                return EZ(p(r, {
                    r5: !1
                }));
            case 35:
                return EZ(p(r, {
                    r5: !0
                }));
            case 33:
                return EZ(p(r, {
                    o5: !0,
                    o6: ns
                }));
            case 37:
                var E = n.a, H = E.a, R = E.b, W = A2(Lu, function(n) {
                    return p(n, {
                        qq: ht(H),
                        qr: A2(Y$, H, A2(Ye, $e, n.qr)) ? A2(Mu, function(n) {
                            return !a(n.a, H);
                        }, n.qr) : A2(mt, d(H, R), n.qr)
                    });
                }, r.o3);
                return A2(Y2, p(r, {
                    o3: W,
                    o5: !1
                }), !1);
            case 36:
                return EZ(p(r, {
                    i_: !r.i_
                }));
            case 38:
                var U = n.a;
                return W = A2(Lu, function(n) {
                    return p(n, {
                        qr: U
                    });
                }, r.o3), EZ(p(r, {
                    o3: W
                }));
            case 39:
                var Q, _ = A2(S3, Q = n.a, r.o6);
                return F = _.a, A2(CX, A2(cp, o_, _.b), EZ(p(r, {
                    o6: F
                })));
            default:
                return KX(z1(n.a));
        }
    }), d8 = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return A2(pc, w, p(r, {
                rV: A3(pG, t.a, t.b, r.rV)
            }));
        }
        var e = n.a;
        return A2(pc, w, p(r, e.$ ? {
            lo: ht(e.a.nP)
        } : {
            lo: kt,
            rV: sG(e.a)
        }));
    }), m8 = {
        $: 1
    }, b8 = function(n) {
        return 1 === n.ak.sr.$ ? function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.g9.P.kx) : m8;
    }, p8 = F2(function(n, r) {
        switch(n.$){
            case 14:
                return A2(pc, w, r);
            case 3:
                var t = $v(n.a), e = A3(XW, !1, t, r), u = (f = e.a).ak;
                return A2(pc, k([
                    e.b
                ]), p(f, {
                    ak: p(u, {
                        sr: t
                    })
                }));
            case 13:
                return A2(pc, w, 27 === n.a ? p(r, {
                    sk: jc(r.ak.st)
                }) : r);
            case 1:
                var o = n.a, i = n.b;
                return a(o, r.g9.mo) ? A4(UZ, function(n) {
                    return p(r, {
                        g9: n
                    });
                }, gv(o), r.g9, A3(l8, i, r.g9, r.ak)) : A2(pc, w, r);
            case 2:
                return A4(UZ, function(n) {
                    return p(r, {
                        ol: n
                    });
                }, wv, r.ol, A3(l1, i = n.a, r.ol, r.ak));
            case 5:
                var c = A2(d8, i = n.a, r.rV), f = c.a;
                return A2(pc, k([
                    A2(cp, ja, c.b)
                ]), p(r, {
                    rV: f
                }));
            case 8:
                var s = A2(iK, i = n.a, r.iz);
                return f = s.a, A2(pc, k([
                    A2(cp, Pa, s.b)
                ]), p(r, {
                    iz: f
                }));
            case 7:
                var l = A2(QZ, i = n.a, r.b9);
                return f = l.a, A2(pc, k([
                    A2(cp, gZ, l.b)
                ]), p(r, {
                    b9: f
                }));
            case 6:
                var d = A2(oK, i = n.a, r.dp);
                return f = d.a, A2(pc, k([
                    A2(cp, La, d.b)
                ]), p(r, {
                    dp: f
                }));
            case 0:
                var m = A2(jK, i = n.a, r.ak);
                return f = m.a, A2(pc, k([
                    A2(cp, hU, m.b)
                ]), p(r, {
                    ak: f
                }));
            case 9:
                return A4(UZ, function(n) {
                    return p(r, {
                        sk: n
                    });
                }, TU, r.sk, A2(hJ, i = n.a, r.sk));
            case 10:
                var b = A3(WX, i = n.a, r.qb, r.em);
                return f = b.a, A2(pc, k([
                    A2(cp, hZ, b.b)
                ]), p(r, {
                    qb: f
                }));
            case 11:
                var v = A2(kJ, i = n.a, r.l7);
                return f = v.a, A2(pc, k([
                    A2(cp, Aa, v.b)
                ]), p(r, {
                    l7: f
                }));
            case 12:
                if (2 === n.a.$) {
                    var $ = n.a.a, g = A4(UZ, function(n) {
                        return p(r, {
                            sk: n
                        });
                    }, TU, r.sk, A3(HZ, b8(r), $, r.sk));
                    return f = g.a, A2(pc, k([
                        g.b
                    ]), p(f, {
                        k0: A2(d1, wZ($), r.k0)
                    }));
                }
                return A2(pc, w, p(r, {
                    k0: A2(d1, i = n.a, r.k0)
                }));
            case 4:
                return A4(UZ, function(n) {
                    return p(r, {
                        em: n
                    });
                }, Sa, r.em, A2(VX, i = n.a, r.em));
            default:
                return A2(pc, w, p(r, {
                    mW: !n.a
                }));
        }
    }), v8 = F2(function(n, r) {
        var t = d(r, n);
        n: for(;;){
            if (t.a.$) {
                if (t.b.$) break n;
                var e = A2(p8, t.b.a, t.a.a);
                return o = e.b, d(ya(e.a), A2(cp, Na, o));
            }
            if (1 === t.b.$) {
                var u = A2($Z, t.b.a, t.a.a), o = u.b;
                return d(ma(u.a), A2(cp, vU, o));
            }
            break n;
        }
        return d(r, n$);
    }), $8 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, w8 = {
        $: 1
    }, g8 = xa({
        bN: "Back to login",
        bT: "Retour au login"
    }), h8 = F2(function(n, r) {
        return A2(Hk, k([
            Uk(n),
            Ow("AccountForm")
        ]), r);
    }), k8 = F2(function(n, r) {
        return A2(oC, k([
            fC(n)
        ]), k([
            A2(Yj, w, k([
                ag(r)
            ]))
        ]));
    }), C8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, T8 = function(n) {
        switch(n.$){
            case 0:
                return "/";
            case 1:
                switch(n.a.$){
                    case 1:
                        return "/account/forgotPassword";
                    case 0:
                        var r = n.a.a.lZ;
                        if (1 === r.$) return "/account/login";
                        switch(r.a){
                            case "/":
                            case "/logout":
                                return "/account/login";
                            default:
                                return "/account/login?from=" + r.a;
                        }
                    case 2:
                        return "/account/resetPassword?email=" + n.a.a.la + "&token=" + n.a.a.r0;
                    default:
                        return "/account/invitation?redirect=" + n.a.a.pB + "&email=" + n.a.a.la + "&token=" + n.a.a.r0;
                }
            case 2:
                switch(n.a){
                    case 0:
                        return "/services/forProd";
                    case 1:
                        return "/services/forTv";
                    case 2:
                        return "/services";
                    default:
                        return "/services/references";
                }
            case 3:
                return "/legal";
            default:
                return "/404";
        }
    }, P8 = T8(C8(function(n) {
        return {
            $: 0,
            a: n
        };
    }({
        lZ: kt
    }))), S8 = xa({
        bN: "Password forgotten",
        bT: "Mot de passe oubli\xe9"
    }), y8 = xa({
        bN: "Recover",
        bT: "R\xe9cup\xe8rer"
    }), N8 = xa({
        bN: "Email sent",
        bT: "Email envoy\xe9"
    }), L8 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, j8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, M8 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, I8 = {
        $: 4
    }, D8 = xa({
        bN: "Answer invitation",
        bT: "R\xe9pondre \xe0 l\u2019invitation"
    }), B8 = function(n) {
        return A2(ye, k([
            Ow("BannerEmptyness")
        ]), k([
            BI,
            A2(qg, k([
                Ow("BannerContent")
            ]), n)
        ]));
    }, x8 = function(n) {
        switch(n){
            case 0:
                return xa({
                    bN: "Confirmation doesn't match password",
                    bT: "La confirmation est differente du mot de passe"
                });
            case 1:
                return xa({
                    bN: "Password is too short (min. 9)",
                    bT: "Mot de passe trop court (min. 9)"
                });
            case 2:
                return xa({
                    bN: "Password must contain at least a lowercase char.",
                    bT: "Le mot de passe doit contenir au moins un caract\xe8re minuscule."
                });
            case 3:
                return xa({
                    bN: "Password must contain at least an uppercase char.",
                    bT: "Le mot de passe doit contenir au moins caract\xe8re majuscule."
                });
            case 4:
                return xa({
                    bN: "Password must contain at least a number.",
                    bT: "Le mot de passe doit contenir au moins un chiffre."
                });
            default:
                return xa({
                    bN: "Password must contain at least a special char.",
                    bT: "Le mot de passe doit contenir au moins un caract\xe8re sp\xe9cial."
                });
        }
    }, q8 = xa({
        bN: "Send",
        bT: "Envoyer"
    }), V8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, O8 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, z8 = xa({
        bN: "Access Nomalab",
        bT: "Acc\xe9der \xe0 Nomalab"
    }), E8 = xa({
        bN: "Connection",
        bT: "Connexion"
    }), H8 = T8(C8({
        $: 1
    })), R8 = xa({
        bN: "Forgot password?",
        bT: "Mot de passe oubli\xe9"
    }), W8 = xa({
        bN: "Submit Email",
        bT: "Valider Email"
    }), U8 = xa({
        bN: "Email sent. You have 48h to validate.",
        bT: "Un email vient de vous \xeatre envoy\xe9. Vous disposez de 48h pour le valider."
    }), Q8 = function(n) {
        return A2(ye, k([
            Ow("AccountMessage")
        ]), k([
            function() {
                switch(n.$){
                    case 0:
                        return ag("");
                    case 1:
                        return A2(qg, k([
                            Ow("AccountSuccess")
                        ]), U8);
                    default:
                        var r = n.a;
                        return A2(qg, k([
                            Ow("AccountFail")
                        ]), r);
                }
            }()
        ]));
    }, _8 = Lw("fill"), Z8 = Lw("stroke"), K8 = Lw("stroke-linejoin"), X8 = Lw("stroke-width"), J8 = A2(Zw, k([
        Kw("0 0 524 134"),
        Xw("524px")
    ]), k([
        A2(Ik, w, k([
            A2(iC, k([
                aC("M419.771468,31.2572374 L419.771468,96.3052532 L429.351007,98.6620653 L429.351007,103.847052 L401.85773,103.847052 L401.85773,98.6620653 L410.000338,96.3052532 L410.000338,38.7990363 L401.85773,36.9135866 L401.85773,31.7285998 L419.771468,31.2572374 Z M433.014638,56.7108088 C439.91194,54.1968632 446.234372,52.9399093 451.982124,52.9399093 C457.602149,52.9399093 461.912898,54.0554559 464.914502,56.2865826 C467.916106,58.5177093 469.416885,62.2728591 469.416885,67.5521447 L469.416885,96.3052532 L477.080516,98.1907029 L477.080516,103.37569 L462.232231,103.847052 L460.220528,97.247978 C455.111415,102.275869 450.066242,104.789777 445.084857,104.789777 C440.103471,104.789777 436.367489,103.564247 433.876796,101.11315 C431.386104,98.6620531 430.140776,95.1740059 430.140776,90.648904 C430.140776,80.907365 437.485016,76.0366685 452.173715,76.0366685 L459.837346,76.0366685 L459.837346,68.4948696 C459.837346,62.8384921 456.803856,60.0103458 450.736784,60.0103458 C447.288133,60.0103458 444.446232,60.3560081 442.210995,61.0473432 L441.06145,61.4244331 L439.720315,68.4948696 L433.493615,68.4948696 L433.014638,56.7108088 Z M459.837346,82.1643802 L453.131669,82.1643802 C448.341876,82.1643802 444.941174,82.7771452 442.92946,84.0026937 C440.917747,85.2282421 439.911906,87.1293849 439.911906,89.7061791 C439.911906,92.157276 440.502638,94.026995 441.68412,95.315392 C442.865603,96.6037891 444.573937,97.247978 446.809174,97.247978 C447.89486,97.247978 448.996496,97.0594349 450.114114,96.6823431 C451.231733,96.3052513 452.317403,95.8338936 453.371158,95.2682558 C454.424912,94.7026181 455.366891,94.089853 456.197122,93.4299423 C457.027352,92.7700316 457.697913,92.1572666 458.208825,91.5916288 L459.837346,89.7061791 L459.837346,82.1643802 Z M489.197547,31.2572374 L489.197547,58.4077135 C493.859613,54.7624925 498.649334,52.9399093 503.566856,52.9399093 C510.33643,52.9399093 515.381603,55.1081548 518.702527,59.4447109 C522.02345,63.781267 523.683887,69.9403412 523.683887,77.9221183 C523.683887,81.8187339 523.10912,85.4167645 521.95957,88.716318 C520.81002,92.0158715 519.117651,94.8597298 516.882414,97.247978 C514.647178,99.6362263 511.901071,101.490233 508.644011,102.810055 C505.386952,104.129876 501.619037,104.789777 497.340155,104.789777 C494.083096,104.726928 491.161366,104.585521 488.574877,104.365551 C485.988389,104.145581 483.705288,103.721359 481.725507,103.092872 L479.618009,102.432965 L479.618009,38.7990363 L471.954378,36.9135866 L471.954378,31.7285998 L489.197547,31.2572374 Z M489.197547,96.3052532 C490.730281,96.9337395 494.051155,97.247978 499.160268,97.247978 C501.714824,97.247978 503.90213,96.7766203 505.722252,95.8338907 C507.542373,94.8911611 509.043153,93.5870715 510.224635,91.9215825 C511.406117,90.2560936 512.268267,88.2763912 512.81111,85.9824159 C513.353954,83.6884406 513.625371,81.1902446 513.625371,78.4877532 C513.625371,72.8313757 512.651461,68.4163251 510.703612,65.2424688 C508.755763,62.0686126 505.738238,60.4817082 501.650948,60.4817082 C498.457752,60.4817082 495.887268,61.0944733 493.939419,62.3200217 C491.99157,63.5455702 490.410962,64.9753553 489.197547,66.6094199 L489.197547,96.3052532 Z"),
                _8("#3BAAFF")
            ]), w),
            A2(iC, k([
                aC("M172.806239,53.8826342 L173.668397,60.5759807 C174.307037,60.0731916 175.201118,59.381867 176.350668,58.501986 C177.500219,57.6221051 178.857306,56.7736612 180.421972,55.9566289 C181.986638,55.1395966 183.710938,54.43256 185.594923,53.8354979 C187.478909,53.2384359 189.442694,52.9399093 191.48634,52.9399093 C196.659316,52.9399093 200.507059,54.4325421 203.029684,57.4178524 C205.552308,60.4031628 206.813602,64.5668226 206.813602,69.9089569 L206.813602,96.3052532 L213.998256,98.6620653 L213.998256,103.847052 L191.007363,103.847052 L191.007363,98.6620653 L197.234063,96.3052532 L197.234063,70.8516818 C197.234063,67.4578553 196.563502,64.9596594 195.22236,63.3570191 C193.881218,61.7543788 191.837603,60.9530707 189.091455,60.9530707 C187.750313,60.9530707 186.425156,61.1259018 185.115946,61.4715693 C183.806736,61.8172369 182.59334,62.2728827 181.475722,62.8385204 C180.358103,63.4041582 179.368227,64.0169232 178.506065,64.6768339 C177.643902,65.3367446 176.925444,65.9809335 176.350668,66.6094199 L174.722147,68.4948696 L174.722147,96.3052532 L180.948847,98.6620653 L180.948847,103.847052 L157,103.847052 L157,98.6620653 L165.142608,96.3052532 L165.142608,61.4244331 L157,59.5389834 L157,54.3539966 L172.806239,53.8826342 Z M213.703933,79.619023 C213.703933,75.5967102 214.294665,71.9358319 215.476147,68.6362783 C216.65763,65.3367248 218.334032,62.5242904 220.505405,60.1988908 C222.676778,57.8734911 225.247262,56.0823318 228.216934,54.825359 C231.186606,53.5683863 234.459582,52.9399093 238.035961,52.9399093 C245.188719,52.9399093 250.744796,55.1710025 254.704359,59.6332559 C258.663921,64.0955092 260.643673,70.2860073 260.643673,78.2049357 C260.643673,82.1015513 260.068906,85.6681581 258.919356,88.904863 C257.769805,92.1415678 256.157266,94.9382903 254.081689,97.2951143 C252.006112,99.6519382 249.483525,101.490233 246.513853,102.810055 C243.544181,104.129876 240.239273,104.789777 236.59903,104.789777 C229.318545,104.789777 223.682639,102.652955 219.691145,98.3792479 C215.69965,94.1055404 213.703933,87.8521947 213.703933,79.619023 L213.703933,79.619023 Z M237.65278,60.4817082 C228.392513,60.4817082 223.762448,66.6093586 223.762448,78.8648431 C223.762448,91.1203277 228.232855,97.247978 237.173803,97.247978 C241.835868,97.247978 245.236571,95.6767856 247.376012,92.5343537 C249.515453,89.3919218 250.585157,84.6783446 250.585157,78.3934807 C250.585157,66.4522394 246.274408,60.4817082 237.65278,60.4817082 L237.65278,60.4817082 Z M276.113543,53.8826342 L276.975701,60.5759807 C277.869796,59.7589484 278.955466,58.8947926 280.232744,57.9834873 C281.510023,57.0721821 282.915008,56.2394501 284.447741,55.4852664 C285.980475,54.7310828 287.593015,54.1183177 289.285409,53.646953 C290.977802,53.1755882 292.654205,52.9399093 294.314666,52.9399093 C300.764921,52.9399093 305.203397,55.6423602 307.630225,61.0473432 C308.779776,59.9160677 310.120898,58.8633688 311.653632,57.8892149 C313.186365,56.915061 314.766973,56.0509051 316.395503,55.2967215 C318.024033,54.5425378 319.620607,53.9611966 321.185273,53.5526805 C322.749938,53.1441643 324.170889,52.9399093 325.448167,52.9399093 C335.347074,52.9399093 340.296452,58.5962019 340.296452,69.9089569 L340.296452,96.3052532 L347.481107,98.6620653 L347.481107,103.847052 L324.490213,103.847052 L324.490213,98.6620653 L330.716914,96.3052532 L330.716914,70.8516818 C330.716914,67.3950066 330.110216,64.8810988 328.896801,63.3098828 C327.683387,61.7386669 325.703635,60.9530707 322.957487,60.9530707 C321.616345,60.9530707 320.32312,61.1259018 319.077774,61.4715693 C317.832428,61.8172369 316.666929,62.2728827 315.581242,62.8385204 C314.495556,63.4041582 313.537612,64.0169232 312.707381,64.6768339 C311.87715,65.3367446 311.206589,65.9809335 310.695678,66.6094199 L309.162951,68.4948696 L309.162951,96.3052532 L315.389652,98.6620653 L315.389652,103.847052 L293.356713,103.847052 L293.356713,98.6620653 L299.583413,96.3052532 L299.583413,70.8516818 C299.583413,67.3950066 298.976715,64.8810988 297.7633,63.3098828 C296.549886,61.7386669 294.570134,60.9530707 291.823986,60.9530707 C290.482844,60.9530707 289.189619,61.1259018 287.944273,61.4715693 C286.698927,61.8172369 285.533428,62.2728827 284.447741,62.8385204 C283.362055,63.4041582 282.404111,64.0169232 281.57388,64.6768339 C280.743649,65.3367446 280.073088,65.9809335 279.562177,66.6094199 L278.02945,68.4948696 L278.02945,96.3052532 L284.256151,98.6620653 L284.256151,103.847052 L260.307304,103.847052 L260.307304,98.6620653 L268.449912,96.3052532 L268.449912,61.4244331 L260.307304,59.5389834 L260.307304,54.3539966 L276.113543,53.8826342 Z M353.539622,56.7108088 C360.436925,54.1968632 366.759357,52.9399093 372.507109,52.9399093 C378.127133,52.9399093 382.437883,54.0554559 385.439486,56.2865826 C388.44109,58.5177093 389.94187,62.2728591 389.94187,67.5521447 L389.94187,96.3052532 L397.605501,98.1907029 L397.605501,103.37569 L382.757215,103.847052 L380.745512,97.247978 C375.636399,102.275869 370.591226,104.789777 365.609841,104.789777 C360.628456,104.789777 356.892473,103.564247 354.401781,101.11315 C351.911088,98.6620531 350.665761,95.1740059 350.665761,90.648904 C350.665761,80.907365 358.01,76.0366685 372.6987,76.0366685 L380.362331,76.0366685 L380.362331,68.4948696 C380.362331,62.8384921 377.328841,60.0103458 371.261769,60.0103458 C367.813118,60.0103458 364.971216,60.3560081 362.735979,61.0473432 L361.586435,61.4244331 L360.245299,68.4948696 L354.018599,68.4948696 L353.539622,56.7108088 Z M380.362331,82.1643802 L373.656654,82.1643802 C368.86686,82.1643802 365.466158,82.7771452 363.454445,84.0026937 C361.442732,85.2282421 360.43689,87.1293849 360.43689,89.7061791 C360.43689,92.157276 361.027622,94.026995 362.209105,95.315392 C363.390587,96.6037891 365.098921,97.247978 367.334158,97.247978 C368.419845,97.247978 369.52148,97.0594349 370.639099,96.6823431 C371.756717,96.3052513 372.842388,95.8338936 373.896142,95.2682558 C374.949897,94.7026181 375.891875,94.089853 376.722106,93.4299423 C377.552337,92.7700316 378.222898,92.1572666 378.733809,91.5916288 L380.362331,89.7061791 L380.362331,82.1643802 Z"),
                _8("#FFFFFF"),
                jw("HomeLogoNomalab")
            ]), w),
            A2(Ik, k([
                Z8("#252F3A"),
                K8("round"),
                X8("4"),
                Nj("translate(2.000000, 2.000000)")
            ]), k([
                A2(_w, k([
                    _8("#FFFFFF"),
                    Rw("40 10 60 0 120 30 120 50 100 60 140 80 140 100 80 130 60 120 60 100 20 120 0 110 0 50 20 40 40 50")
                ]), w),
                A2(_w, k([
                    _8("#3BAAFF"),
                    Rw("80 10 60 20 60 40 40 50 60 60 80 50 100 60 100 40 80 30")
                ]), w),
                A2(_w, k([
                    _8("#3BAAFF"),
                    Rw("40 50 20 60 20 80 0 90 20 100 40 90 60 100 60 80 40 70")
                ]), w),
                A2(_w, k([
                    _8("#3BAAFF"),
                    Rw("100 60 80 70 80 90 60 100 80 110 100 100 120 110 120 90 100 80")
                ]), w)
            ]))
        ]))
    ])), Y8 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, G8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nnn = {
        $: 3
    }, rnn = xa({
        bN: "Back to login",
        bT: "Retour au login"
    }), tnn = xa({
        bN: "Change",
        bT: "Changer"
    }), enn = function(n) {
        return A2(jk, n, function(n) {
            return A2(Og, n, A2(Eg, k([
                Ow("InputPassword"),
                Xg(n.kX),
                Tg("password"),
                eh(Lg),
                Gg(jg),
                nh(Fg),
                oh(n.sw),
                uh(n.gw),
                Hg(Zg(n.m7)),
                zg(n.kS),
                A2(qI, "autocomplete", "new-password")
            ]), w));
        }(n));
    }, unn = xa({
        bN: "Lost password",
        bT: "Mot de passe oubli\xe9"
    }), onn = xa({
        bN: "Your password has been changed",
        bT: "Votre mot de passe a \xe9t\xe9 chang\xe9"
    }), ann = function(n) {
        switch(n.$){
            case 0:
                return ag("");
            case 1:
                return ag(onn);
            default:
                return ag(n.a);
        }
    }, inn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, cnn = {
        $: 0
    }, fnn = {
        $: 1
    }, snn = F2(function(n, r) {
        return A2(Iw, n, function(n) {
            return {
                $: 3,
                a: n
            };
        }(r));
    }), lnn = F2(function(n, r) {
        return A2(snn, n, je({
            nP: r,
            pf: !0,
            rg: !1
        }));
    }), dnn = lnn("dragenter"), mnn = lnn("dragleave"), bnn = lnn("dragover"), pnn = F3(function(n, r, t) {
        return A2(snn, n, A2(Ne, function(n) {
            return {
                nP: t(n),
                pf: !0,
                rg: !0
            };
        }, r));
    }), vnn = F2(function(n, r) {
        return A3(pnn, "drop", r, function(r) {
            return n(wZ(r));
        });
    }), $nn = F2(function(n, r) {
        return k([
            dnn(n(cnn)),
            mnn(n(fnn)),
            bnn(n(cnn)),
            A2(vnn, n, r)
        ]);
    }), wnn = F4(function(n, r, t, e) {
        return {
            ji: e,
            nT: t,
            n6: n,
            qP: r
        };
    }), gnn = A5(fR, wnn, A2(du, "name", Da), A2(du, "size", tc), A2(du, "type", A2(Ne, function(n) {
        return xe(n) > 0 ? ht(n) : kt;
    }, Da)), Ma), hnn = A2(Jg, k([
        "dataTransfer",
        "files"
    ]), oc(gnn)), knn = function(n) {
        return 1 === n.aL;
    }, Cnn = F2(function(n, r) {
        return aT(A2(bu, mh(n), r));
    }), Tnn = sr, Pnn = F3(function(n, r, t) {
        return nk(A2(n, r, t));
    }), Snn = F3(function(n, r, t) {
        return la(A4(Tnn, Pnn, n, r, t));
    }), Ann = Snn, ynn = F2(function(n, r) {
        return Ann(F2(function(t, e) {
            return A2(mh, n, A2(r, t, e));
        }));
    }), Nnn = F2(function(n, r) {
        return ek(F3(function(t, e, u) {
            return A2(mh, n, A3(r, t, e, u));
        }));
    }), Lnn = {
        $: 0
    }, jnn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Fnn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Mnn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Inn = xa({
        bN: "Please contact our customer service via email or chat ",
        bT: "Merci de contacter notre service op\xe9rations via le chat ou par mail "
    }), Dnn = k([
        ag(Inn),
        A2(oC, k([
            fC("mailto:ops@nomalab.com")
        ]), k([
            ag("ops@nomalab.com")
        ])),
        ag(".")
    ]), Bnn = F2(function(n, r) {
        return A2(Zx, n, A2(ye, w, k([
            "" === r.nP && fV(r.lC) ? A2(Yj, w, Dnn) : ag(""),
            "" === r.nP ? ag("") : A2(Yj, w, k([
                ag(r.nP)
            ])),
            fV(r.lC) ? ag("") : A2(bE, w, A2(Ye, function(n) {
                return A2(vE, w, k([
                    ag(n)
                ]));
            }, Ju(uI(r.lC))))
        ])));
    }), xnn = xa({
        bN: "Generate",
        bT: "G\xe9n\xe9rer"
    }), qnn = xa({
        bN: "error occurred",
        bT: "Une erreur est survenue"
    }), Vnn = qnn, Onn = function(n) {
        return A2(Og, n, A2(Eg, k([
            Ow("InputText"),
            Tg("date"),
            eh(Lg),
            oh(n.sw),
            uh(n.gw),
            Hg(Zg(n.m7)),
            zg(n.kS)
        ]), w));
    }, znn = function(n) {
        return A2(jk, n, Onn(n));
    }, Enn = xa({
        bN: "Report",
        bT: "Rapport"
    }), Hnn = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Rnn = F3(function(n, r, t) {
        return dl(function(n) {
            return {
                $: 15,
                a: n
            };
        }(A3(Hnn, n, r, t)));
    }), Wnn = F2(function(n, r) {
        var t, e = "rapport_" + r.q2.sw + "_" + r.lj.sw + ".csv";
        return A2(ye, k([
            Ow("AccountReportWrapper")
        ]), k([
            $C(p(wC, {
                rW: Enn
            })),
            A2(ye, k([
                Ow("AccountReportContainer")
            ]), k([
                A2(ye, k([
                    Cg(Lnn)
                ]), k([
                    (t = r.lo, t.$ ? ag("") : A2(Bnn, Vnn, t.a))
                ])),
                A2(mh, Mnn, znn(r.q2)),
                A2(mh, jnn, znn(r.lj)),
                A2(mh, Fnn, BB(r.oQ)),
                vI(p(dI, {
                    jQ: ht("AccountReportSubmit"),
                    lx: k([
                        A2(qI, "target", "_blank"),
                        A2(qI, "data-prevent-history", "true"),
                        A2(qI, "download", e)
                    ]),
                    m7: xnn,
                    sr: ht(Si(A3(Rnn, r.q2.sw, r.lj.sw, vt(r.oQ.sx))))
                }))
            ]))
        ]));
    }), Unn = {
        $: 7
    }, Qnn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, _nn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Znn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Knn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Xnn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Jnn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ynn = {
        $: 6
    }, Gnn = {
        $: 9
    }, nrn = xa({
        bN: "Change password",
        bT: "Changer de mot de passe"
    }), rrn = xa({
        bN: "General Informations",
        bT: "Informations g\xe9n\xe9rales"
    }), trn = xa({
        bN: "Save",
        bT: "Enregistrer"
    }), ern = xa({
        bN: "Settings",
        bT: "Param\xe8tres"
    }), urn = F2(function(n, r) {
        return A2(Aw, k([
            Cg(r),
            Tg("button"),
            Ow("Button")
        ]), k([
            ag(n)
        ]));
    }), orn = F3(function(n, r, t) {
        var e = r.a, u = r.b;
        return A2(ye, k([
            A2(pg, "max-width", "500px"),
            A2(pg, "margin", "10px")
        ]), k([
            A2(dP, w, k([
                ag(n)
            ])),
            A2(ye, w, t),
            A2(ye, k([
                A2(pg, "display", "flex"),
                A2(pg, "justify-content", "flex-end")
            ]), k([
                A2(urn, e, u)
            ]))
        ]));
    }), arn = xa({
        bN: "Success",
        bT: "Succ\xe8s"
    }), irn = F2(function(n, r) {
        return A2(ye, k([
            Ow("BannerSuccess")
        ]), k([
            A2(ye, k([
                Ow("BannerHeader")
            ]), k([
                kg,
                _x(n)
            ])),
            A2(ye, k([
                Ow("BannerContent")
            ]), k([
                r
            ]))
        ]));
    }), crn = F2(function(n, r) {
        var t, e, u;
        return A2(ye, k([
            Ow("SettingsContainer")
        ]), k([
            $C(p(wC, {
                rW: ern
            })),
            A2(ye, k([
                Cg(Unn)
            ]), k([
                (u = r.lo, u.$ ? ag("") : A2(Bnn, Vnn, u.a)),
                (e = r.rz, e.$ ? ag("") : A2(irn, arn, ag(e.a)))
            ])),
            A3(orn, rrn, d(trn, Ynn), k([
                A2(mh, Znn, Mk(r.n6)),
                A2(mh, _nn, Mk(r.la)),
                A2(mh, Qnn, Fk(r.kR))
            ])),
            A2(DL, a(r.mU, ht(!1)), A3(orn, nrn, d(trn, Gnn), k([
                A2(mh, Jnn, RH(r.o_)),
                A2(mh, Knn, enn(r.oe)),
                A2(mh, Xnn, enn(r.of)),
                (t = r.o$, t.$ ? ag("") : B8(x8(t.a)))
            ]))),
            A2(ye, k([
                Ow("Version")
            ]), k([
                ag("version " + r.sz)
            ]))
        ]));
    }), frn = F4(function(n, r, t, e) {
        var u = e, o = u.l(n);
        return o.$ ? A2(ye, w, w) : A2(mh, u.p, A2(u.r, r, o.a));
    }), srn = F3(function(n, r, t) {
        var e = A3(frn, t.oW, n, r);
        return A3(hh, "div", k([
            Ow("AdminWrapper"),
            Ow("DarkZone")
        ]), k([
            function() {
                switch(r.$){
                    case 0:
                        return d("AdminHome", A2(mh, Me, e(Fj)));
                    case 1:
                        return d("AdminOrganizations", A2(mh, Me, e(KB)));
                    case 2:
                        return d("AdminOnboarding", A2(mh, Me, e(kI)));
                    case 3:
                        return d("AdminUsers", A2(mh, Me, e(KH)));
                    case 4:
                        return d("AdminUploads", A2(mh, Me, e(kE)));
                    case 5:
                        return d("AdminTestPlans", A2(mh, Me, e(hO)));
                    case 6:
                        return d("AdminAudioMappings", A2(mh, Me, e(kC)));
                    case 7:
                        return d("AdminChannels", A2(mh, Me, e(ST)));
                    case 8:
                        return d("AdminResearchs", A2(mh, Me, e(aq)));
                    case 9:
                        return d("AdminWebhooks", A2(mh, Me, e(sW)));
                    case 10:
                        return d("AdminOrganizationListings", A2(mh, Me, e(EI)));
                    case 11:
                        return d("AdminFormats", A2(mh, Me, e(pj)));
                    case 12:
                        return d("AdminSubtitleFormats", A2(mh, Me, e(rO)));
                    case 13:
                        return d("AdminSegmentationRules", A2(mh, Me, e($V)));
                    case 14:
                        return d("AdminJobs", A2(mh, Me, e(lF)));
                    case 15:
                        return d("AdminMetadata", A2(mh, Me, e(AM)));
                    case 16:
                        return d("AdminDeepProbe", A2(mh, Me, e(GS)));
                    case 17:
                        return d("AdminProbe", A2(mh, Me, e(Dx)));
                    default:
                        return d("AdminDashboard", A2(mh, Me, e(UP)));
                }
            }()
        ]));
    }), lrn = {
        $: 5
    }, drn = wP(gp(Up)), mrn = wP(hp), brn = A2(Zw, k([
        Hw("42px"),
        Xw("25px"),
        Fw("IconBreadcrumb")
    ]), k([
        A2(iC, k([
            aC("M 4 0L 0 0L 21 21.5L 0 42L 4 42L 25 21.5L 4 0Z")
        ]), w)
    ])), prn = Zw(k([
        Hw("18px"),
        Xw("18px"),
        Kw("0 0 18 18")
    ])), vrn = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M5,7 L5,3 L14.001899,3 L15,2 L18,2 L18,15 L6,15 L0,7 L5,7 Z M7,5 L7,7 L11,7 L16,13 L16,5 L7,5 Z"),
            Nj("translate(9.000000, 8.500000) scale(-1, 1) translate(-9.000000, -8.500000) ")
        ]), w)
    ])), $rn = function(n) {
        var r = n.a, t = n.b;
        return A2(oC, k([
            Ow("HeaderBreadcrumbItem"),
            fC(r)
        ]), k([
            vrn,
            A2(qg, k([
                Ow("HeaderBreadcrumbLabel")
            ]), t),
            brn
        ]));
    }, wrn = function(n) {
        return wP(A2(Cp, n, 0));
    }, grn = F2(function(n, r) {
        var t = F3(function(n, r, e) {
            for(;;){
                if (!e.b) return w;
                var u = e.a, o = e.b, i = u.eC;
                if (i.$) {
                    if (a(u.mo, n)) return A2(mt, d(wX(u.mo), u.m7), r);
                    e = o;
                } else {
                    var c = i.b, f = wrn(u.mo);
                    if (a(u.mo, n)) return A2(mt, d(f, u.m7), r);
                    var s = A3(t, n, A2(mt, d(f, u.m7), r), c);
                    if (s.b) return s;
                    e = o;
                }
            }
        });
        return Zt(A3(t, n, w, $(r.jL, r.fD)));
    }), hrn = F2(function(n, r) {
        return r.$ ? A2(sp, function(r) {
            return Eo(A2(Mu, function(n) {
                return a(n.oO, r);
            }, n.oQ));
        }, n.oM) : ht(r.a);
    }), krn = Lw("fill-rule"), Crn = A2(Zw, k([
        Xw("64"),
        Hw("62")
    ]), k([
        A2(Ik, k([
            Nj("translate(0 .528)"),
            _8("#181F29")
        ]), k([
            A2(iC, k([
                aC("M52.944 28.472L56 26.944V14L28 0 16 6v12l-4-2-12 6v28.944l12 6 12-6v4l12 6 28-14V34l-11.056-5.528z")
            ]), w)
        ])),
        A2(Ik, k([
            Nj("translate(4 5)"),
            _8("#FFF")
        ]), k([
            A2(iC, k([
                aC("M24 40l8-4v-8l8-4-8-4-8 4-8-4v8l8 4v8z")
            ]), w),
            A2(iC, k([
                aC("M40 24l8-4v-8L32 4v8l8 4v8z")
            ]), w),
            A2(iC, k([
                aC("M16 20l8-4V8l8-4-8-4-8 4v16z")
            ]), w),
            A2(iC, k([
                aC("M48 44l8-4v-8l-16-8v8l8 4v8z")
            ]), w),
            A2(iC, k([
                aC("M24 40l-8-4-8 4-8-4v8l8 4 16-8z")
            ]), w),
            A2(iC, k([
                aC("M48 44l-8-4-8 4-8-4v8l8 4 16-8z")
            ]), w),
            A2(iC, k([
                aC("M0 36l8-4v-8l8-4-8-4-8 4v16z")
            ]), w)
        ])),
        A2(Ik, k([
            Nj("translate(4 9)"),
            _8("#3BAAFF")
        ]), k([
            A2(iC, k([
                aC("M16 16l-8 4v8l-8 4 8 4 8-4 8 4v-8l-8-4v-8z")
            ]), w),
            A2(iC, k([
                aC("M32 0l-8 4v8l-8 4 8 4 8-4 8 4v-8l-8-4V0z")
            ]), w),
            A2(iC, k([
                aC("M40 20l-8 4v8l-8 4 8 4 8-4 8 4v-8l-8-4v-8z")
            ]), w)
        ])),
        A2(Ik, k([
            Nj("translate(1.764 7.382)"),
            _8("#181F29")
        ]), k([
            A2(iC, k([
                krn("evenodd"),
                aC("M35.236 0v9l8 4v16l8 4v10.236l-9-4.5-8 4-16-8-8 4L0 33.618 9.236 29v-8l16-8V5l10-5zm-8 6.236v8l-6.764 3.382 5.764 2.882 8-4 7 3.5v-5.764l-8-4v-7l-6 3zM40 21.618l-5.764-2.882-8 4-7-3.5V25l8 4v7l6-3v-8L40 21.618zM25.236 36v-5.764l-8-4v-7l-6 3v8l-6.764 3.382 5.764 2.882 8-4 7 3.5zm3.236 1.618l6.764-3.382v-8l6-3v7l8 4V40l-7-3.5-8 4-5.764-2.882z")
            ]), w)
        ]))
    ])), Trn = Ae("img"), Prn = function(n) {
        return A2(Vw, "src", n);
    }, Srn = function(n) {
        return A2(oC, k([
            Ow("HeaderBreadcrumbItem"),
            fC(lH)
        ]), k([
            function() {
                if (n.$) return A2(qg, k([
                    Ow("HeaderBreadcrumbLabel")
                ]), "Stock");
                var r = n.a, t = r.nr;
                if (t.$) return A2(qg, k([
                    Ow("HeaderBreadcrumbLabel")
                ]), r.gm);
                var e = t.a;
                return A2(Trn, k([
                    Ow("HeaderBreadcrumbItemLogo"),
                    Prn(e)
                ]), w);
            }(),
            brn
        ]));
    }, Arn = wP(Pp), yrn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nrn = {
        $: 1
    }, Lrn = A2(Zw, k([
        Hw("32px"),
        Xw("32px"),
        Kw("0 0 32 32"),
        Fw("IconSearch")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(_w, k([
                Rw("22.7071068 19.2928932 22 18.5857864 20.5857864 20 21.2928932 20.7071068 23.2928932 22.7071068 24 23.4142136 25.4142136 22 24.7071068 21.2928932")
            ]), w),
            A2(iC, k([
                aC("M20,15 C20,12.790861 18.209139,11 16,11 C13.790861,11 12,12.790861 12,15 C12,17.209139 13.790861,19 16,19 C18.209139,19 20,17.209139 20,15 Z M10,15 C10,11.6862915 12.6862915,9 16,9 C19.3137085,9 22,11.6862915 22,15 C22,18.3137085 19.3137085,21 16,21 C12.6862915,21 10,18.3137085 10,15 Z")
            ]), w)
        ]))
    ])), jrn = A2(Zw, k([
        Hw("27px"),
        Xw("27px"),
        Kw("0 0 27 27"),
        Fw("IconLaab")
    ]), k([
        A2(Ik, k([
            Fw("Stroked"),
            X8("2")
        ]), k([
            A2(iC, k([
                aC("M13.5,18 C15.9852814,18 18,15.9852814 18,13.5 M13.5,9 C11.0147186,9 9,11.0147186 9,13.5"),
                Nj("translate(13.500000, 13.500000) scale(-1, 1) translate(-13.500000, -13.500000) ")
            ]), w),
            A2(iC, k([
                aC("M15.5,15.5 L18.5,18.5")
            ]), w),
            A2(iC, k([
                aC("M8.5,8.5 L11.5,11.5")
            ]), w)
        ]))
    ])), Frn = A2(Zw, k([
        Hw("27px"),
        Xw("27px"),
        Kw("0 0 27 27"),
        Fw("IconPadok")
    ]), k([
        A2(Ik, k([
            Fw("IconPadok"),
            _8("none"),
            X8("2")
        ]), k([
            A2(iC, k([
                aC("M13.5,18 C15.9852814,18 18,15.9852814 18,13.5 C18,11.0147186 15.9852814,9 13.5,9 C11.0147186,9 9,11.0147186 9,13.5"),
                Nj("translate(13.500000, 13.500000) scale(-1, 1) translate(-13.500000, -13.500000) ")
            ]), w),
            A2(iC, k([
                aC("M13.5,13.5 L17.5,17.5")
            ]), w)
        ]))
    ])), Mrn = function(n) {
        var r = n.a, t = n.c, e = 1 === n.b ? m("SearchResultsMaster", jrn, wX(t.mo)) : m("SearchResultsShow", Frn, wX(t.mo)), u = e.a, o = e.b;
        return A2(oC, k([
            fC(e.c),
            Ow("SearchResultsItem"),
            Ow(u)
        ]), k([
            A2(ye, k([
                Ow("SearchResultsPath")
            ]), A2(Mq, ag(" / "), A2(Ye, ag, r))),
            A2(ye, k([
                Ow("SearchResultsTitle")
            ]), k([
                o,
                ag(t.m7)
            ]))
        ]));
    }, Irn = function(n) {
        return A2(ye, k([
            Bg(k([
                d("Search", !0),
                d("SearchClosed", !n.qe)
            ]))
        ]), k([
            A2(ye, k([
                Ow("SearchIcon"),
                Cg(Nrn)
            ]), k([
                n.qe ? tj : Lrn
            ])),
            A2(ye, k([
                Ow("SearchInput"),
                Bg(k([
                    d("Searching", n.qe)
                ]))
            ]), k([
                A2(mh, yrn, ah(n.qc))
            ])),
            A2(ye, k([
                Ow("SearchResults")
            ]), A2(Ye, Mrn, n.qd))
        ]));
    }, Drn = function(n) {
        var r = function() {
            var r = n.ak.sr;
            switch(r.$){
                case 0:
                    return k([
                        Srn(A2(hrn, n.ak.st, kt))
                    ]);
                case 1:
                    var t = r.a;
                    return A2(mt, Srn(A2(hrn, n.ak.st, function(n) {
                        return A2(Lu, function(n) {
                            return {
                                nr: n.oM.nr,
                                oO: n.oM.mo,
                                gm: n.oM.n6
                            };
                        }, n.g9.P.kx);
                    }(n))), A2(Ye, $rn, A2(grn, t, n.em)));
                case 2:
                    return t = r.a, A2(mt, Srn(A2(hrn, n.ak.st, function(n) {
                        return A2(sp, function(r) {
                            return Eo(A2(Mu, function(n) {
                                return a(n.oO, r.be.oM);
                            }, n.ak.st.oQ));
                        }, n.ol.P.kx);
                    }(n))), A2(Ye, $rn, A2(grn, t, n.em)));
                case 6:
                    return k([
                        $rn(d(mrn, "Archive"))
                    ]);
                case 8:
                    return k([
                        $rn(d(Arn, "Settings"))
                    ]);
                case 4:
                    return k([
                        $rn(d(drn, "Admin"))
                    ]);
                default:
                    return w;
            }
        }();
        return A2(ye, k([
            Ow("HeaderWrapper")
        ]), k([
            A2(oC, k([
                !n.ak.b$ && a(n.ak.sr, Ap) ? Cg(hU(lrn)) : fC(lH),
                Ow("HeaderLogo")
            ]), k([
                Crn
            ])),
            A2(mh, hZ, A2(aT, Irn, n.qb)),
            A2(ye, k([
                Ow("HeaderBreadcrumb")
            ]), A2(mt, brn, r))
        ]));
    }, Brn = A2(Zw, k([
        Hw("24px"),
        Xw("24px"),
        Kw("0 0 24 24"),
        Fw("IconSettings")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(iC, k([
                aC("M4.5.257l3.771 3.771c.409 1.889-2.33 4.66-4.242 4.242l-3.771-3.77c-.172.584-.258 1.188-.258 1.792 0 1.602.607 3.202 1.83 4.426 1.351 1.351 3.164 1.958 4.931 1.821.933-.072 1.852.269 2.514.931l9.662 9.662c.578.578 1.337.868 2.097.868 1.661 0 3.001-1.364 2.966-3.03-.016-.737-.306-1.47-.868-2.033l-9.662-9.663c-.662-.661-1.002-1.581-.931-2.514.137-1.767-.471-3.58-1.82-4.93-1.225-1.224-2.825-1.83-4.428-1.83-.603 0-1.207.086-1.791.257zm17.5 20.743c0 .553-.447 1-1 1-.553 0-1-.448-1-1s.447-1 1-1 1 .447 1 1z")
            ]), w)
        ]))
    ])), xrn = A2(Zw, k([
        Hw("30px"),
        Xw("20px"),
        Kw("0 0 26 36"),
        Fw("IconBigFile")
    ]), k([
        A2(iC, k([
            aC("M10,0 L26,0 L26,36 L0,36 L0,10 L10,0 Z M2,11 L2,34 L24,34 L24,2 L11,2 L2,11 Z"),
            Fw("Fg")
        ]), w),
        A2(_w, k([
            Fw("Fg"),
            Rw("12 12 12 0 10 0 10 10 0 10 0 12")
        ]), w)
    ])), qrn = Lw("clip-rule"), Vrn = A2(Zw, k([
        Hw("26px"),
        Xw("26px"),
        Kw("0 0 26 26"),
        Fw("IconBigFile")
    ]), k([
        A2(iC, k([
            aC("M12.0498 15.0713C12.0498 14.251 12.1494 13.5977 12.3486 13.1113C12.5479 12.625 12.9111 12.1475 13.4385 11.6787C13.9717 11.2041 14.3262 10.8203 14.502 10.5273C14.6777 10.2285 14.7656 9.91504 14.7656 9.58691C14.7656 8.59668 14.3086 8.10156 13.3945 8.10156C12.9609 8.10156 12.6123 8.23633 12.3486 8.50586C12.0908 8.76953 11.9561 9.13574 11.9443 9.60449H9.39551C9.40723 8.48535 9.76758 7.60938 10.4766 6.97656C11.1914 6.34375 12.1641 6.02734 13.3945 6.02734C14.6367 6.02734 15.6006 6.3291 16.2861 6.93262C16.9717 7.53027 17.3145 8.37695 17.3145 9.47266C17.3145 9.9707 17.2031 10.4424 16.9805 10.8877C16.7578 11.3271 16.3682 11.8164 15.8115 12.3555L15.0996 13.0322C14.6543 13.46 14.3994 13.9609 14.335 14.5352L14.2998 15.0713H12.0498ZM11.7949 17.7695C11.7949 17.377 11.9268 17.0547 12.1904 16.8027C12.46 16.5449 12.8027 16.416 13.2188 16.416C13.6348 16.416 13.9746 16.5449 14.2383 16.8027C14.5078 17.0547 14.6426 17.377 14.6426 17.7695C14.6426 18.1562 14.5107 18.4756 14.2471 18.7275C13.9893 18.9795 13.6465 19.1055 13.2188 19.1055C12.791 19.1055 12.4453 18.9795 12.1816 18.7275C11.9238 18.4756 11.7949 18.1562 11.7949 17.7695Z"),
            Fw("Fg")
        ]), w),
        A2(iC, k([
            krn("evenodd"),
            qrn("evenodd"),
            aC("M13 24C19.0751 24 24 19.0751 24 13C24 6.92487 19.0751 2 13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24ZM13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z"),
            Fw("Fg")
        ]), w)
    ])), Orn = xa({
        bN: "Help",
        bT: "Aide"
    }), zrn = function(n) {
        return wP(kp(n));
    }, Ern = xa({
        bN: "Settings",
        bT: "Param\xe8tres"
    }), Hrn = xa({
        bN: "Stock",
        bT: "Stock"
    }), Rrn = function(n) {
        return n.e_ ? A2(oC, k([
            fC(n.sr),
            Ow("MenuItem"),
            Bg(k([
                d("Active", n.Q)
            ]))
        ]), k([
            A2(ye, k([
                Ow("MenuItemIcon")
            ]), k([
                n.mn
            ])),
            A2(ye, k([
                Ow("MenuItemTitle")
            ]), k([
                ag(n.rW)
            ]))
        ])) : ag("");
    }, Wrn = Qw("rect"), Urn = Lw("x"), Qrn = Lw("y"), _rn = A2(Zw, k([
        Hw("30px"),
        Xw("20px"),
        Kw("0 0 26 36"),
        Fw("IconBigFile")
    ]), k([
        A2(iC, k([
            krn("evenodd"),
            qrn("evenodd"),
            aC("M19 4H12V28H19V4ZM10 2V30H21V2H10Z"),
            Fw("Fg")
        ]), w),
        A2(Wrn, k([
            Urn("14"),
            Qrn("6"),
            Xw("3"),
            Hw("22"),
            Fw("Fg")
        ]), w),
        A2(iC, k([
            krn("evenodd"),
            qrn("evenodd"),
            aC("M26 14H21V28H26V14ZM19 12V30H28V12H19Z"),
            Fw("Fg")
        ]), w),
        A2(iC, k([
            krn("evenodd"),
            qrn("evenodd"),
            aC("M10 10H4V28H10V10ZM2 8V30H11V8H2Z"),
            Fw("Fg")
        ]), w),
        A2(Wrn, k([
            Urn("4"),
            Qrn("12"),
            Xw("6"),
            Hw("2"),
            Fw("Fg")
        ]), w),
        A2(Wrn, k([
            Urn("4"),
            Qrn("16"),
            Xw("6"),
            Hw("2"),
            Fw("Fg")
        ]), w),
        A2(Wrn, k([
            Urn("4"),
            Qrn("20"),
            Xw("6"),
            Hw("2"),
            Fw("Fg")
        ]), w),
        A2(Wrn, k([
            Urn("4"),
            Qrn("24"),
            Xw("6"),
            Hw("2"),
            Fw("Fg")
        ]), w),
        A2(iC, k([
            krn("evenodd"),
            qrn("evenodd"),
            aC("M21 17L26 12.015L26 14L21 19L21 17Z"),
            Fw("Fg")
        ]), w),
        A2(iC, k([
            krn("evenodd"),
            qrn("evenodd"),
            aC("M21 21L26 16.015L26 18L21 23L21 21Z"),
            Fw("Fg")
        ]), w),
        A2(iC, k([
            krn("evenodd"),
            qrn("evenodd"),
            aC("M21 25L26 20.015L26 22L21 27L21 25Z"),
            Fw("Fg")
        ]), w),
        A2(iC, k([
            krn("evenodd"),
            qrn("evenodd"),
            aC("M22 28L26 24.0149L26 26L24 28L22 28Z"),
            Fw("Fg")
        ]), w)
    ])), Zrn = xa({
        bN: "Organizations",
        bT: "Organizations"
    }), Krn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Xrn = function(n) {
        var r = A2(ju, "", n.st.oM);
        return A2(Ye, function(t) {
            return function(n) {
                return A2(oC, k([
                    n.cC ? fC(lH) : Cg(Krn(n.mo)),
                    Ow("MenuItem"),
                    Bg(k([
                        d("Active", n.Q)
                    ]))
                ]), k([
                    A2(ye, k([
                        Ow("MenuItemIcon")
                    ]), k([
                        function() {
                            var r = n.nr;
                            if (r.$) return ag("");
                            var t = r.a;
                            return A2(ye, k([
                                Ow("MenuAvatar")
                            ]), k([
                                A2(Trn, k([
                                    Prn(t)
                                ]), w)
                            ]));
                        }()
                    ])),
                    A2(ye, k([
                        Ow("MenuItemTitle")
                    ]), k([
                        ag(n.n6)
                    ]))
                ]));
            }({
                Q: a(t.oO, r) && function() {
                    switch(n.sr.$){
                        case 0:
                        case 1:
                        case 2:
                            return !0;
                        default:
                            return !1;
                    }
                }(),
                cC: a(t.oO, r),
                mo: t.oO,
                nr: t.nr,
                n6: t.gm
            });
        }, A2(hT, gT(function(n) {
            return n.gm;
        }), n.st.oQ));
    }, Jrn = function(n) {
        return 1 > qt(n.st.oQ) ? ag("") : A2(ye, k([
            Ow("MenuGroup"),
            Cg(lrn)
        ]), k([
            A2(ye, k([
                Ow("MenuItem")
            ]), k([
                A2(ye, k([
                    Ow("MenuItemIcon")
                ]), k([
                    _rn
                ])),
                A2(ye, k([
                    Ow("MenuItemTitle")
                ]), k([
                    ag(Zrn)
                ]))
            ])),
            A2(ye, k([
                Ow("MenuList")
            ]), Xrn(n))
        ]));
    }, Yrn = function(n) {
        return ye(k(n.b$ ? [
            Ow("MenuWrapper"),
            Ow("MenuOpened"),
            Cg(lrn),
            kP(n.b$)
        ] : [
            Ow("MenuWrapper"),
            Ow("MenuClosed")
        ]));
    }, Grn = function(n) {
        var r = function(n) {
            return {
                l7: {
                    Q: 5 === n.sr.$,
                    e_: !0,
                    mn: Vrn,
                    rW: Orn,
                    sr: zrn("table")
                },
                dp: {
                    Q: 8 === n.sr.$,
                    e_: !0,
                    mn: Brn,
                    rW: Ern,
                    sr: Arn
                },
                dr: {
                    Q: !n.d2,
                    e_: !0,
                    mn: xrn,
                    rW: Hrn,
                    sr: lH
                }
            };
        }(n);
        return A2(Yrn, n, k([
            A2(ye, k([
                Ow("MenuMain")
            ]), k([
                Rrn(r.dr),
                Jrn(n),
                A2(ye, k([
                    Ow("MenuSpacer")
                ]), w),
                Rrn(r.l7),
                Rrn(r.dp),
                A2(ye, k([
                    Ow("MenuIntercom")
                ]), w)
            ]))
        ]));
    }, ntn = {
        $: 1
    }, rtn = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), ttn = Ig("multiple"), etn = A2(Jg, k([
        "target",
        "files"
    ]), oc(gnn)), utn = F2(function(n) {
        var r;
        return r = k([
            Kg("nativeInputFile"),
            Ow("UploadInput"),
            A2(Dw, "change", A2(Ne, function(r) {
                return A2(rtn, n.oV, r);
            }, etn))
        ]), A2(Eg, A2(mt, Tg("file"), A2(mt, ttn(!0), r)), w);
    }), otn = F2(function(n, r) {
        return n.mm || !a(r.bQ, w) || !a(r.lo, kt);
    }), atn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, itn = xa({
        bN: ". Please choose a destination:",
        bT: ". Veuillez choisir une destination :"
    }), ctn = xa({
        bN: "Choose destination",
        bT: "Choisir une destination"
    }), ftn = xa({
        bN: " file",
        bT: " fichier"
    }), stn = xa({
        bN: "Create new delivery",
        bT: "Cr\xe9er une nouvelle livraison"
    }), ltn = xa({
        bN: "Create new master",
        bT: "Cr\xe9er un nouveau master"
    }), dtn = xa({
        bN: "You are about to upload ",
        bT: "Vous \xeates sur le point d\u2019uploader "
    }), mtn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), btn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ptn = F8(function(n, r, t, e, u, o, a, i) {
        return {
            jx: o,
            jR: t,
            ks: i,
            m5: n,
            b2: e,
            oV: r,
            p7: u,
            rP: a
        };
    }), vtn = A2(Te, function(n) {
        n: for(; !n.$;)switch(n.a){
            case 0:
                return je(0);
            case 1:
                return je(1);
            case 2:
                return je(2);
            case 3:
                return je(3);
            default:
                break n;
        }
        return A2(Te, function(n) {
            n: for(; !n.$;)switch(n.a){
                case 0:
                    return je(1);
                case 1:
                    return je(2);
                case 2:
                    return je(3);
                case 4:
                    return je(4);
                case 5:
                    return je(5);
                default:
                    break n;
            }
            return je(0);
        }, Bi(A2(du, "button", tc)));
    }, Bi(A2(du, "which", tc))), $tn = function(n) {
        return {
            ox: n
        };
    }, wtn = A2(Ne, $tn, A2(du, "offsetWidth", sA)), gtn = A2(du, "currentTarget", wtn), htn = F4(function(n, r, t, e) {
        return {
            iK: n,
            ko: r,
            nR: t,
            qz: e
        };
    }), ktn = A5(fR, htn, A2(du, "altKey", Pe), A2(du, "ctrlKey", Pe), A2(du, "metaKey", Pe), A2(du, "shiftKey", Pe)), Ctn = cn, Ttn = function(n) {
        return A3(Le, YQ, A2(du, n + "X", tc), A2(du, n + "Y", tc));
    }, Ptn = A2(Te, function() {
        var n = At(0);
        return 1 === n.$ ? qc(n.a) : je(n.a);
    }, A2(du, "target", Ma)), Stn = A9(Ctn, ptn, ktn, Ttn("page"), Ttn("client"), Ttn("offset"), Ttn("screen"), vtn, Ptn, gtn), Atn = F2(function(n, r) {
        var t = A2(snn, "mousedown", je({
            nP: btn(r),
            pf: !1,
            rg: !1
        })), e = n ? k([
            A2(Dw, "mousedown", A2(Ne, mtn(r), Stn))
        ]) : w;
        return A2(ye, k([
            Ow("UploadFile")
        ]), k([
            A2(ye, A2(mt, Ow("UploadFileTitle"), e), k([
                xrn,
                A2(ye, k([
                    Ow("UploadFileSummary")
                ]), k([
                    A2(dg, k([
                        Ow("UploadFileName"),
                        II(r.n6)
                    ]), k([
                        ag(r.n6)
                    ])),
                    A2(qg, k([
                        Ow("UploadFileSize")
                    ]), Xx(r.qP))
                ]))
            ])),
            A2(ye, k([
                Ow("UploadRemove"),
                t
            ]), k([
                kg
            ]))
        ]));
    }), ytn = F3(function(n, r, t) {
        return A2(ye, k([
            Ow("UploadDrag"),
            A2(pg, "left", Mt(t.sO - r.sO) + "px"),
            A2(pg, "top", Mt(t.sT - r.sT) + "px")
        ]), k([
            A2(Atn, !1, n)
        ]));
    }), Ntn = {
        $: 9
    }, Ltn = xa({
        bN: "An error occurred.",
        bT: "Une erreur est survenue."
    }), jtn = function(n) {
        return 1 === n.lo.$ ? ag("") : A2(ye, k([
            Ow("UploadError")
        ]), k([
            A2(ye, w, k([
                ag(Ltn)
            ])),
            A2(ye, k([
                Ow("UploadErrorClose"),
                Cg(Ntn)
            ]), k([
                kg
            ]))
        ]));
    }, Ftn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Mtn = {
        $: 8
    }, Itn = xa({
        bN: "No file",
        bT: "Aucun fichier"
    }), Dtn = function(n) {
        return A2(Dw, "mouseenter", je(n));
    }, Btn = function(n) {
        return A2(Dw, "mouseleave", je(n));
    }, xtn = hh("ul"), qtn = F3(function(n, r, t) {
        var e = function() {
            if (1 === r.$) return w;
            var n = r.a;
            return k([
                A2(pg, "user-select", "none"),
                Dtn(Ftn(n)),
                Btn(Mtn)
            ]);
        }();
        return A2(ye, e, k([
            A2(dP, k([
                Ow("UploadSubtitle")
            ]), k([
                ag(n)
            ])),
            A2(xtn, k([
                Ow("UploadSection")
            ]), Tu(t) ? k([
                d("empty", A2(vE, k([
                    Ow("UploadItem")
                ]), k([
                    ag(Itn)
                ])))
            ]) : A2(Ye, function(n) {
                return d(n.n6, A2(vE, k([
                    Ow("UploadItem")
                ]), k([
                    A2(Atn, !a(r, kt), n)
                ])));
            }, t))
        ]));
    }), Vtn = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Otn = xa({
        bN: "Add",
        bT: "Ajouter"
    }), ztn = xa({
        bN: "Extra",
        bT: "Compl\xe9mentaire"
    }), Etn = xa({
        bN: "Master being loaded...",
        bT: "Master en cours de chargement..."
    }), Htn = xa({
        bN: " into master ",
        bT: " au master "
    }), Rtn = xa({
        bN: "Subtitles",
        bT: "Sous titres"
    }), Wtn = F4(function(n, r, t, e) {
        var u = function(r) {
            return 1 === n.$ || A2(VZ, n.a, e) ? ag("") : r;
        }, o = A3(xt, F2(function(n, t) {
            var e = A2(di, n.n6, r);
            if (e.$) return p(t, {
                bP: A2(mt, n, t.bP)
            });
            switch(e.a){
                case 0:
                    return p(t, {
                        cn: A2(mt, n, t.cn)
                    });
                case 1:
                    return p(t, {
                        d7: A2(mt, n, t.d7)
                    });
                case 2:
                    return p(t, {
                        ad: A2(mt, n, t.ad)
                    });
                default:
                    return p(t, {
                        bP: A2(mt, n, t.bP)
                    });
            }
        }), {
            d7: w,
            bP: w,
            ad: w,
            cn: w
        }, e.bQ), a = o.cn, i = o.d7, c = o.ad, f = o.bP;
        return k([
            u(A3(qtn, "Video", ht(0), a)),
            u(A3(qtn, "Audios", ht(1), i)),
            A3(qtn, Rtn, ht(2), c),
            A3(qtn, ztn, ht(3), f),
            A2(yL, w, w),
            function() {
                if (1 === n.$) return A2(Aw, k([
                    zg(!0)
                ]), k([
                    ag(Etn)
                ]));
                var u = n.a;
                return A2(ye, w, k([
                    A2(qg, k([
                        Ow("UploadDesc")
                    ]), $(dtn, $(Mt(qt(e.bQ)), $(ftn, $(qt(e.bQ) > 1 ? "s" : "", Htn))))),
                    A2(urn, Otn, A3(Vtn, t.e1, u.g9, r))
                ]));
            }()
        ]);
    }), Utn = xa({
        bN: "Your files",
        bT: "Vos fichiers"
    }), Qtn = F2(function(n, r) {
        return A2(ye, k([
            Ow("UploadContainer")
        ]), k([
            A2(ye, k([
                Ow("UploadTitle")
            ]), k([
                ag("Upload")
            ])),
            A2(ye, k([
                Ow("UploadClose"),
                Cg(ntn)
            ]), k([
                kg
            ])),
            jtn(r),
            A2(ye, k([
                Ow("UploadContent")
            ]), function() {
                var t = d(n.oV, r.oY);
                n: for(;;){
                    if (t.a.$) {
                        if (1 === t.b.$) return k([
                            A2(qg, k([
                                Ow("UploadDesc")
                            ]), $(dtn, $(Mt(qt(r.bQ)), $(ftn, $(qt(r.bQ) > 1 ? "s" : "", itn))))),
                            A3(qtn, Utn, kt, r.bQ),
                            A2(mh, atn, A2(zk, za(function(n) {
                                return p(n, {
                                    gw: ctn
                                });
                            }), k([
                                d("liv", stn),
                                d("mas", ltn)
                            ])))
                        ]);
                        break n;
                    }
                    if (t.b.$) break n;
                    var e = t.a.a, u = t.b.a;
                    return e.$ ? k([
                        ag("")
                    ]) : A4(Wtn, e, u, n, r);
                }
                return k([
                    ag(A2(ju, "", r.lo))
                ]);
            }()),
            function() {
                var n = r.k_;
                if (1 === n.$) return ag("");
                var t = n.a;
                return A3(ytn, t.a, t.b, t.c);
            }()
        ]));
    }), _tn = xa({
        bN: "Please drop your file(s) to upload to Nomalab",
        bT: "D\xe9posez le(s) fichier(s) pour lancer un upload sur Nomalab"
    }), Ztn = A2(ye, k([
        Ow("UploadDropping")
    ]), k([
        ag(_tn)
    ])), Ktn = F2(function(n, r) {
        if (A2(otn, n, r)) {
            var t = n.oV;
            if (t.$ || t.a.$) return ag("");
            var e = t.a.a;
            return A3(qZ, n.st, e.oM.mo, A2(Ye, function(n) {
                return n.fB;
            }, e.fD)) ? A2(ye, k([
                Ow("UploadWrapper")
            ]), k([
                A2(ye, k([
                    Ow("UploadMask"),
                    Cg(ntn)
                ]), w),
                a(r.bQ, w) && a(r.lo, kt) ? Ztn : A2(Qtn, n, r),
                A2(utn, n, r)
            ])) : ag("");
        }
        return A2(utn, n, r);
    }), Xtn = Ae("em"), Jtn = Ae("strong"), Ytn = F2(function(n, r) {
        var t, e = function(n) {
            var r = n.hm;
            switch(r.$){
                case 0:
                    return Xtn(w);
                case 1:
                    return Jtn(w);
                default:
                    return oC(function(n) {
                        for(;;){
                            if (n.$) return k([
                                fC(n.a)
                            ]);
                            var r = n.a;
                            if ("help" === r.fT) return k([
                                fC("/help/" + A2(ju, "table", r.h7))
                            ]);
                        }
                    }(r.a));
            }
        }, u = F2(function(n, t) {
            var u = t.a, o = t.b, a = A3(qe, n.hs, n.e$, r.cj);
            return d($(u, k([
                ag(A3(qe, o, n.hs, r.cj)),
                A2(e, n, k([
                    ag(a)
                ]))
            ])), n.e$);
        });
        return A2(n, A2(ju, w, A2(Lu, function(n) {
            return k([
                Ow(n)
            ]);
        }, r.m7)), $((t = A3(xt, u, d(w, 0), A2(Ra, function(n) {
            return n.hs;
        }, r.hn))).a, k([
            ag(A2(Ve, t.b, r.cj))
        ])));
    }), Gtn = Ae("h5"), nen = Ae("h6"), ren = function(n) {
        switch(n.$){
            case 8:
                return A2(Trn, k([
                    Prn(n.a.sr)
                ]), w);
            case 0:
                return A2(Ytn, pC, r = n.a);
            case 1:
                return A2(Ytn, dP, r = n.a);
            case 2:
                return A2(Ytn, dC, r = n.a);
            case 3:
                return A2(Ytn, FL, r = n.a);
            case 4:
                return A2(Ytn, Gtn, r = n.a);
            case 5:
                return A2(Ytn, nen, r = n.a);
            case 6:
                return A2(Ytn, Yj, r = n.a);
            default:
                var r = n.a;
                return A2(Ytn, F2(function(n, r) {
                    return A2(bE, w, k([
                        A2(vE, n, r)
                    ]));
                }), r);
        }
    }, ten = function(n) {
        var r = n;
        return A2(ye, k([
            Ow("structuredText")
        ]), A2(Ye, ren, r));
    }, een = function(n) {
        switch(n.P){
            case 0:
                return xa({
                    bN: "Connection lost.",
                    bT: "Perte de connection avec le serveur, v\xe9rifiez votre connection internet"
                });
            case 401:
            case 403:
                return xa({
                    bN: "You might not be authorized to acces this ressource.",
                    bT: "Vous ne semblez pas - ou plus - autoris\xe9 \xe0 consulter cette ressource"
                });
            case 404:
                return xa({
                    bN: "This ressource doesn't seem to exist.",
                    bT: "Cette ressource n'existe pas ou a \xe9t\xe9 supprim\xe9e"
                });
            default:
                return "" === n.nP ? Ei : n.nP;
        }
    }, uen = function(n) {
        var r = n.P.lo;
        return r.$ ? ag("") : sk(een(r.a));
    }, oen = A2(ye, k([
        Ow("LoadingWrapper")
    ]), k([
        A2(ye, k([
            Ow("LoadingSpinner")
        ]), k([
            Lj
        ]))
    ])), aen = F2(function(n, r) {
        return A2(ye, k([
            Ow("ShowWrapper")
        ]), k([
            A2(ye, k([
                Ow("ShowMain")
            ]), k([
                $C(p(wC, {
                    d9: ht(lH)
                })),
                oen,
                uen(r)
            ])),
            A2(ye, k([
                Ow("ShowAside")
            ]), w)
        ]));
    }), ien = function(n) {
        return n.iz;
    }, cen = F2(function(n, r) {
        return ien(n) || a(n.oM, ht(r.oM));
    }), fen = function(n) {
        return wrn(n.mo);
    }, sen = function(n) {
        return !n.hv;
    }, len = function(n) {
        return "" !== n.cJ.fB;
    }, den = {
        $: 6
    }, men = function(n) {
        return A2(ye, k([
            Ow("BannerAdvice")
        ]), k([
            BI,
            A2(qg, k([
                Ow("BannerContent")
            ]), n)
        ]));
    }, ben = F2(function(n, r) {
        return ien(n) || a(n.oM, ht(r.oM));
    }), pen = xa({
        bN: "Invitations",
        bT: "Invitations"
    }), ven = xa({
        bN: "Invite",
        bT: "Inviter"
    }), $en = xa({
        bN: "No invitations.",
        bT: "Aucune invitation."
    }), wen = A2(Zw, k([
        Hw("18px"),
        Xw("18px"),
        Kw("0 0 18 18"),
        Fw("IconPlus")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(iC, k([
                aC("M10,8 L10,3 L8,3 L8,8 L3,8 L3,10 L8,10 L8,15 L10,15 L10,10 L15,10 L15,8 L10,8 Z")
            ]), w)
        ]))
    ])), gen = function(n) {
        return {
            $: 9,
            a: n
        };
    }, hen = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ken = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Cen = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ten = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Pen = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Sen = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Aen = xa({
        bN: "Allow download (extra costs applies)",
        bT: "Autoriser le t\xe9l\xe9chargement (soumis \xe0 facturation)"
    }), yen = xa({
        bN: "Allow upload ",
        bT: "Autoriser l'upload"
    }), Nen = xa({
        bN: "Allow view",
        bT: "Autoriser \xe0 visionner"
    }), Len = A2(Zw, k([
        Hw("16px"),
        Xw("16px"),
        Kw("0 0 16 16")
    ]), k([
        A2(iC, k([
            Fw("Fg"),
            aC("M8 10H3V6H8V3L13 8L8 13V10Z")
        ]), w)
    ])), jen = ye(k([
        Ow("ButtonSubmitWrapper")
    ])), Fen = function(n) {
        return jen(k([
            DI(p(dI, {
                mn: ht(Len),
                bf: !0,
                bg: !0,
                m7: n
            }))
        ]));
    }, Men = Vw("htmlFor"), Ien = F2(function(n, r) {
        return A2(Nk, k([
            Men(r.mo),
            Ow("InputCheckboxLine")
        ]), k([
            yk(r),
            ag(n)
        ]));
    }), Den = F3(function(n, r) {
        return A2(Hk, k([
            Uk(gen(n.be)),
            Ow("InvitationsForm"),
            Ow("DarkZone")
        ]), k([
            A2(mh, hen, ah(r.la)),
            A2(mh, ken, znn(r.lt)),
            A2(mh, Cen, kM(r.nP)),
            A2(mh, Sen, A2(Ien, Nen, ti(function(n) {
                return p(n, {
                    kS: !0,
                    mo: "checkbox-canView",
                    m7: Nen,
                    sw: !0
                });
            }))),
            A2(mh, Pen, A2(Ien, yen, r.jA)),
            A2(mh, Ten, A2(Ien, Aen, r.jz)),
            Fen(ven)
        ]));
    }), Ben = function(n) {
        return {
            $: 7,
            a: n
        };
    }, xen = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M3,6 L3,3 L12.001899,3 L13,2 L16,2 L16,15 L4,15 L2,6 L3,6 Z M5,5 L5,6 L13,6 L14,13 L14,5 L5,5 Z"),
            Nj("translate(9.000000, 8.500000) scale(-1, 1) translate(-9.000000, -8.500000) ")
        ]), w)
    ])), qen = prn(k([
        A2(Ik, k([
            Fw("Fg"),
            Nj("translate(2.000000, 1.000000)")
        ]), k([
            A2(iC, k([
                aC("M4,0 L10,0 L14,4 L14,13 L4,13 L4,0 Z M6,2 L6,11 L12,11 L12,5 L9,5 L9,2 L6,2 Z")
            ]), w),
            A3(Qw, "polygon", k([
                Rw("0 3 3 3 3 5 2 5 2 14 10 14 10 16 0 16")
            ]), w)
        ]))
    ])), Ven = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M5,3 L5,15 L13,15 L13,6 L9,6 L9,3 L5,3 Z")
        ]), w)
    ])), Oen = function(n) {
        return A2(ye, k([
            Ow(n ? "FullCube" : "EmptyCube")
        ]), w);
    }, zen = function(n) {
        return A3(Ae, "format-date", k([
            MP(rm(n))
        ]), k([
            ag(rm(n))
        ]));
    }, Een = F4(function(n, r, t, e) {
        return a(r.fB.hi, ht(t.be.mo)) ? A2(ben, n.st, t.be) ? A2(uk, w, k([
            A2(ye, k([
                Ow("InvitationDelete"),
                Cg(Ben(r.fB))
            ]), k([
                kg
            ]))
        ])) : ag("") : A2(uk, w, k([
            A2(ye, k([
                Ow("InvitationSourceKind")
            ]), k([
                A2(Ck, function(n) {
                    var r;
                    return A2(oC, k([
                        fC((r = n, wrn(r)))
                    ]), k([
                        e
                    ]));
                }, r.fB.hi)
            ]))
        ]));
    }), Hen = F3(function(n, r, t) {
        var e;
        return A2(Lh, w, k([
            A2(uk, w, k([
                Oen(!0)
            ])),
            A2(uk, w, k([
                Oen(t.fB.sk)
            ])),
            A2(uk, w, k([
                Oen(t.fB.cJ)
            ])),
            A2(uk, k([
                Ow("InvitationEmail"),
                II(t.st.la)
            ]), k([
                (e = t.fB.cO, e.$ ? ag("") : zen(e.a)),
                ag("   "),
                ag(t.st.la)
            ])),
            function() {
                var e = t.fB.c$;
                n: for(; !e.$;)switch(e.a){
                    case 0:
                        return A4(Een, n, t, r, xen);
                    case 2:
                        return A4(Een, n, t, r, qen);
                    default:
                        break n;
                }
                return a(t.fB.qJ, kt) ? A2(ben, n.st, r.be) ? A2(uk, w, k([
                    A2(ye, k([
                        Ow("InvitationDelete"),
                        Cg(Ben(t.fB))
                    ]), k([
                        kg
                    ]))
                ])) : ag("") : A2(uk, w, k([
                    A2(ye, k([
                        Ow("InvitationSourceKind")
                    ]), k([
                        A2(Ck, function(n) {
                            var r;
                            return A2(oC, k([
                                fC((r = n, wX(r)))
                            ]), k([
                                Ven
                            ]));
                        }, t.fB.qJ)
                    ]))
                ]));
            }()
        ]));
    }), Ren = F3(function(n, r, t) {
        return A2(ye, k([
            Ow("InvitationsWrapper")
        ]), k([
            Jx(k([
                nq(pen),
                A2(ben, n.st, t.be) ? DI(p(dI, {
                    jQ: kt,
                    mn: ht(wen),
                    mK: !1,
                    m7: ven,
                    oy: ht(den)
                })) : ag("")
            ])),
            r.kU ? A3(Den, t, r, n.st) : ag(""),
            Tu(t.fD) ? men($en) : A2(kh, k([
                Ow("InvitationsTable")
            ]), A2(Ye, A2(Hen, n, t), A2(Ra, A2(Pi, function(n) {
                return n.st;
            }, function(n) {
                return n.la;
            }), t.fD)))
        ]));
    }), Wen = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Uen = {
        $: 0
    }, Qen = {
        $: 1
    }, _en = {
        $: 2
    }, Zen = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Ken = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Xen = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Jen = ye(k([
        Ow("LayoutHeaderActions")
    ])), Yen = xa({
        bN: "Archive",
        bT: "Archiver"
    }), Gen = xa({
        bN: "All files will be put into long lasting storage, retrieving them can take up to 12h. (extra costs applies for unarchiving)",
        bT: "Tous les fichiers iront en stockage longue dur\xe9e, les r\xe9cup\xe9rer prend jusqu'\xe0 12h et ils seront remis \xe0 disposition pour une dur\xe9e de 7 jours. (le d\xe9sarchivage est soumis \xe0 facturation)"
    }), nun = xa({
        bN: "Archiving...",
        bT: "Archivage..."
    }), run = xa({
        bN: "Cancel",
        bT: "Annuler"
    }), tun = xa({
        bN: "Operation failed",
        bT: "L'op\xe9ration a \xe9chou\xe9"
    }), eun = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M5 8H13V14H5V8Z")
        ]), w),
        A2(iC, k([
            Fw("Fg"),
            aC("M7.99957 7.68778C7.99978 7.78914 8 7.89313 8 8H6C6 7.90491 5.99978 7.80885 5.99956 7.71229C5.99854 7.26829 5.9975 6.81375 6.01771 6.39485C6.04227 5.88549 6.10037 5.34942 6.2604 4.8605C6.42521 4.35697 6.71365 3.85763 7.22215 3.49794C7.72555 3.14186 8.33543 3 9 3C9.66457 3 10.2745 3.14186 10.7779 3.49794C11.2864 3.85763 11.5748 4.35697 11.7396 4.8605C11.8996 5.34942 11.9577 5.88549 11.9823 6.39485C12.0025 6.81376 12.0015 7.26829 12.0004 7.71229C12.0002 7.80885 12 7.90491 12 8H10C10 7.89313 10.0002 7.78914 10.0004 7.68778C10.0013 7.24641 10.0022 6.85479 9.98462 6.49119C9.94969 5.76704 9.89141 5 9 5C8.10859 5 8.05031 5.76704 8.01538 6.49119C7.99785 6.85479 7.99866 7.24641 7.99957 7.68778Z")
        ]), w)
    ])), uun = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M12.5 15H5.5C4.948 15 4.5 14.552 4.5 14V6H13.5V14C13.5 14.552 13.052 15 12.5 15ZM8 8C8 7.724 7.776 7.5 7.5 7.5C7.224 7.5 7 7.724 7 8V12.5C7 12.776 7.224 13 7.5 13C7.776 13 8 12.776 8 12.5V8ZM11 8C11 7.724 10.776 7.5 10.5 7.5C10.224 7.5 10 7.724 10 8V12.5C10 12.776 10.224 13 10.5 13C10.776 13 11 12.776 11 12.5V8ZM14 5.5H4V4.5H7V3.75C7 3.3365 7.3365 3 7.75 3H10.25C10.6625 3 11 3.3355 11 3.75V4.5H14V5.5ZM8 4.5H10V4H8V4.5Z")
        ]), w)
    ])), oun = xa({
        bN: "Delete",
        bT: "Supprimer"
    }), aun = xa({
        bN: "Ressource deleted",
        bT: "Ressource supprim\xe9e"
    }), iun = xa({
        bN: "Delete...",
        bT: "Suppression..."
    }), cun = xa({
        bN: "Delete",
        bT: "Supprimer"
    }), fun = xa({
        bN: "Unarchive",
        bT: "D\xe9sarchiver"
    }), sun = xa({
        bN: "Your files are now into long lasting storage. Retrieving them can take up to 12h and for a 7 days period. (extra costs applies for unarchiving)",
        bT: "Vos fichiers sont maintenant en stockage longue dur\xe9e, les r\xe9cup\xe9rer prend jusqu'\xe0 12h et ils seront remis \xe0 disposition pour une dur\xe9e de 7 jours. (le d\xe9sarchivage est soumis \xe0 facturation)"
    }), lun = xa({
        bN: "Your files will be available within 12h and for a 7 days period only.",
        bT: "Vos fichiers seront disponibles dans les 12h et pour une dur\xe9e de 7 jours."
    }), dun = xa({
        bN: "Undelete",
        bT: "Restaurer"
    }), mun = xa({
        bN: "These files are deleted",
        bT: "Ces fichiers sont supprim\xe9s"
    }), bun = xa({
        bN: "Ressource restored",
        bT: "Ressource restaur\xe9e"
    }), pun = F3(function(n, r, t) {
        return A2(ye, k([
            Ow("ShowArchiveActions"),
            Ow("ShowArchiveStatusNone")
        ]), k([
            DI(p(dI, {
                kS: n,
                mn: ht(eun),
                m7: r,
                oy: ht(t)
            }))
        ]));
    }), vun = F2(function(n, r) {
        var t, e = 2 === r.hv;
        return A2(ye, k([
            Ow("ShowArchives")
        ]), k([
            Jx(k([
                A2(DL, 1 === r.hv, A2(dg, k([
                    Ow("ShowArchivesLock")
                ]), k([
                    eun
                ]))),
                nq(0 === r.hv ? Yen : fun),
                Jen(k([
                    DI(p(dI, {
                        kS: e,
                        mn: ht(n.oD ? tj : wen),
                        mK: n.oD,
                        m7: n.oD ? run : nun,
                        oy: ht(Qen)
                    }))
                ]))
            ])),
            A2(DL, n.oD || e, A2(ye, k([
                Ow("InvitationsForm")
            ]), k([
                3 === n.P.$ ? A2(ye, k([
                    Ow("ShowArchiveActions"),
                    Cg(Uen)
                ]), k([
                    sk(tun)
                ])) : ag(""),
                A2(ye, w, function() {
                    switch(r.hv){
                        case 0:
                            return k([
                                B8(Gen),
                                A3(pun, a(n.P, HG), Yen, Wen(r))
                            ]);
                        case 1:
                            return k([
                                sk(sun),
                                A3(pun, a(n.P, HG), fun, Ken(r))
                            ]);
                        default:
                            return k([
                                B8(lun)
                            ]);
                    }
                }())
            ]))),
            Jx(k([
                A2(DL, r.h5, A2(dg, k([
                    Ow("ShowArchivesLock")
                ]), k([
                    uun
                ]))),
                nq(r.h5 ? dun : cun),
                Jen(k([
                    DI(p(dI, {
                        mn: ht(n.oF ? tj : wen),
                        mK: n.oF,
                        m7: n.oF ? run : iun,
                        oy: ht(_en)
                    }))
                ]))
            ])),
            A2(DL, n.oF, A2(ye, k([
                Ow("InvitationsForm")
            ]), k([
                A2(ye, w, k(r.h5 ? [
                    sk(mun),
                    A2(DL, r.mL, A3(pun, a(n.r7, HG), dun, Xen(r)))
                ] : [
                    a(n.sh, RG) ? sk(bun) : a(n.r7, RG) ? sk(aun) : sk((t = r.mV, xa({
                        bN: "Warning, this action will delete permanently every files in this " + (t ? "Show" : "folder"),
                        bT: "Attention, cette action entrainera la suppression d\xe9finitive de tous les fichiers pr\xe9sents dans ce " + (t ? "Show" : "dossier")
                    }))),
                    A3(pun, a(n.r7, HG), oun, Zen(r))
                ]))
            ])))
        ]));
    }), $un = xa({
        bN: "Downloads",
        bT: "T\xe9l\xe9chargements"
    }), wun = {
        $: 3
    }, gun = {
        $: 5
    }, hun = xa({
        bN: "Create a SFTP server access, accessible from any FTP client software.",
        bT: "Cr\xe9er un acc\xe8s serveur SFTP, accessible avec n'importe quel client FTP (logiciel)."
    }), kun = xa({
        bN: "Create SFTP access",
        bT: "Cr\xe9er acc\xe8s SFTP"
    }), Cun = function(n) {
        return A2(yj, n.a, n.b);
    }, Tun = function(n) {
        return A2(kh, k([
            Ow("KeyValueWrapper")
        ]), A2(Ye, Cun, n));
    }, Pun = Ig("readOnly"), Sun = xa({
        bN: "Revoke SFTP access",
        bT: "R\xe9voquer acc\xe8s SFTP"
    }), Aun = xa({
        bN: "Renew SFTP access",
        bT: "Renouveler acc\xe8s SFTP"
    }), yun = xa({
        bN: "Here are the credentials for your SFTP server. Keep them safe as their are being given only once.",
        bT: "Voici les identifiants de votre serveur SFTP, gardez-les pr\xe9cieusement car il ne vous seront donn\xe9s qu'une fois."
    }), Nun = xa({
        bN: "A SFTP server access already exists, click on 'renew' if you can't retrieve the credentials.",
        bT: "Un acc\xe8s serveur SFTP existe, si vous n'avez plus les identifiants cliquez sur le bouton 'renouveler' pour en obtenir de nouveaux. Les anciens acc\xe8s seront supprim\xe9s."
    }), Lun = A2(Zw, k([
        Hw("7px"),
        Xw("7px"),
        Kw("401 651 7 7"),
        Fw("IconSmallDownload")
    ]), k([
        A2(_w, k([
            Fw("Fg"),
            krn("evenodd"),
            Rw("403 651 406 651 406 654 408 654 404.678829 658 401 654 403 654")
        ]), w)
    ])), jun = function(n) {
        var r, t = n.l_;
        switch(t.$){
            case 0:
                return w;
            case 1:
                return k([
                    men(hun),
                    A2(ye, k([
                        Ow("DownloadOptionsButtons")
                    ]), k([
                        DI(p(dI, {
                            mn: ht(Lun),
                            m7: kun,
                            oy: ht(wun)
                        }))
                    ]))
                ]);
            case 3:
                var e = t.a;
                return k([
                    lk(yun),
                    A2(ye, k([
                        Ow("DownloadOptionsCredentials")
                    ]), k([
                        (r = "sftp://" + e.fW + ":" + A2(ju, "", e.o_) + "@" + e.fs, A2(ye, k([
                            Ow("DownloadSftpLink")
                        ]), k([
                            ag("url: "),
                            A2(Eg, k([
                                oh(r),
                                Pun(!0),
                                Ow("DownloadSftpUrl")
                            ]), w)
                        ]))),
                        Tun(k([
                            d("hostname", e.fs),
                            d("port", Mt(e.gy)),
                            d("login", e.fW),
                            d("password", A2(ju, "*****", e.o_))
                        ]))
                    ])),
                    A2(ye, k([
                        Ow("DownloadOptionsButtons")
                    ]), k([
                        DI(p(dI, {
                            mn: ht(tj),
                            m7: Sun,
                            oy: ht(gun)
                        })),
                        DI(p(dI, {
                            mn: ht(Lun),
                            m7: Aun,
                            oy: ht(wun)
                        }))
                    ]))
                ]);
            case 2:
                return e = t.a, k([
                    men(Nun),
                    A2(ye, k([
                        Ow("DownloadOptionsCredentials")
                    ]), k([
                        Tun(k([
                            d("hostname", e.fs),
                            d("port", Mt(e.gy)),
                            d("login", e.fW)
                        ]))
                    ])),
                    A2(ye, k([
                        Ow("DownloadOptionsButtons")
                    ]), k([
                        DI(p(dI, {
                            mn: ht(tj),
                            m7: Sun,
                            oy: ht(gun)
                        })),
                        DI(p(dI, {
                            mn: ht(Lun),
                            m7: Aun,
                            oy: ht(wun)
                        }))
                    ]))
                ]);
            default:
                return k([
                    sk(een(t.a)),
                    A2(ye, k([
                        Ow("DownloadOptionsButtons")
                    ]), k([
                        DI(p(dI, {
                            mn: ht(Lun),
                            m7: kun,
                            oy: ht(wun)
                        }))
                    ]))
                ]);
        }
    }, Fun = function(n) {
        return A2(ye, w, k([
            Jx(k([
                nq($un)
            ])),
            A2(ye, k([
                Ow("InvitationsForm")
            ]), jun(n))
        ]));
    }, Mun = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M9,13.1999999 L7.14589803,14.7063391 L6.53130198,12.3978713 L4.14589803,12.5267115 L5.0055627,10.2978714 L3,9 L5.0055627,7.70212865 L4.14589803,5.47328849 L6.53130198,5.60212868 L7.14589803,3.2936609 L9,4.80000007 L10.854102,3.2936609 L11.468698,5.60212868 L13.854102,5.47328849 L12.9944373,7.70212865 L15,9 L12.9944373,10.2978714 L13.854102,12.5267115 L11.468698,12.3978713 L10.854102,14.7063391 L9,13.1999999 Z M9,11 C10.1045695,11 11,10.1045695 11,9 C11,7.8954305 10.1045695,7 9,7 C7.8954305,7 7,7.8954305 7,9 C7,10.1045695 7.8954305,11 9,11 Z")
        ]), w)
    ])), Iun = F3(function(n, r, t) {
        return k([
            A2(ye, k([
                Ow("AsideHeader")
            ]), k([
                A2(ye, k([
                    Ow("AsideTabs")
                ]), k([
                    A2(oC, k([
                        Bg(k([
                            d("AsideTab", !0),
                            d("AsideTabActive", !0)
                        ]))
                    ]), k([
                        A2(ye, k([
                            Ow("AsideTabsIcon")
                        ]), k([
                            Mun
                        ])),
                        ag("Actions")
                    ]))
                ])),
                A2(oC, k([
                    Ow("LayoutFwdButton"),
                    fC(fen(r))
                ]), k([
                    tj
                ]))
            ])),
            A2(ye, k([
                Ow("AsideBody")
            ]), k([
                A2(mh, SJ, A3(Ren, n, r.fD, t)),
                A2(DL, len(r) && sen(t.be), A2(mh, PJ, Fun(r.cJ))),
                A2(DL, A2(cen, n.st, t.be), A2(mh, TJ, A2(vun, r.d2, {
                    mo: t.be.mo,
                    mL: n.st.iz,
                    mV: !1,
                    hv: t.be.hv,
                    h5: t.be.h5
                })))
            ]))
        ]);
    }), Dun = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Bun = F4(function(n, r, t, e) {
        var u;
        return $C(p(wC, {
            d9: ht(wrn(t.mo)),
            fc: r ? ht((u = t.mo, wP(A2(Cp, u, 1)))) : kt,
            fq: ht(lH),
            rW: e.n6
        }));
    }), xun = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), qun = F2(function(n, r) {
        return A2(ye, k([
            Ow("Avatar"),
            Ow("AvatarLetter"),
            Ow(n)
        ]), k([
            ag(A3(qe, 0, 1, r))
        ]));
    }), Vun = F2(function(n, r) {
        var t = a(n.la, r.la) ? "AvatarMe" : a(n.oM, r.oM) ? "AvatarCowork" : "AvatarAlien";
        return A2(qun, t, r.la);
    }), Oun = A2(Zw, k([
        Hw("16px"),
        Xw("16px"),
        Kw("0 0 16 16"),
        Fw("IconBullet")
    ]), k([
        A2(Ik, k([
            Fw("Bg")
        ]), k([
            A2(Wrn, k([
                Hw("8"),
                Xw("8"),
                Urn("4"),
                Qrn("4")
            ]), w)
        ]))
    ])), zun = A2(Zw, k([
        Hw("18px"),
        Xw("18px"),
        Kw("0 0 18 18"),
        Fw("IconPlus")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(iC, k([
                aC("M3.58334909,5.81668873 C3.26117429,5.365644 3.4556644,5 3.99539757,5 L12.0046024,5 C12.5543453,5 12.7451752,5.35675466 12.4166509,5.81668873 L8.58334909,11.1833113 C8.26117429,11.634356 7.74517524,11.6432453 7.41665091,11.1833113 L3.58334909,5.81668873 Z")
            ]), w)
        ]))
    ])), Eun = A2(Zw, k([
        Hw("18px"),
        Xw("18px"),
        Kw("0 0 18 18"),
        Fw("IconPlus")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(iC, k([
                aC("M5,3.99539757 C5,3.44565467 5.35675466,3.25482476 5.81668873,3.58334909 L11.1833113,7.41665091 C11.634356,7.73882571 11.6432453,8.25482476 11.1833113,8.58334909 L5.81668873,12.4166509 C5.365644,12.7388257 5,12.5443356 5,12.0046024 L5,3.99539757 Z")
            ]), w)
        ]))
    ])), Hun = A2(Pi, uG, function(n) {
        return n.dt;
    }), Run = xa({
        bN: "Archived",
        bT: "Archiv\xe9"
    }), Wun = {
        jV: "#3BAAFF",
        eG: "#1D507B",
        eH: "#13334F",
        kw: "#0E2339",
        md: "#62BBFF",
        mf: "#89CCFF",
        ng: "#B0DDFF",
        nh: "#D7EEFF",
        ni: "#EBF6FF",
        nv: "#318CD3",
        nx: "#276EA7"
    }, Uun = xa({
        bN: "Comment",
        bT: "Commentaire"
    }), Qun = xa({
        bN: "Deliver started",
        bT: "Envoi d\xe9marr\xe9"
    }), _un = xa({
        bN: "Delivered",
        bT: "Livr\xe9"
    }), Zun = xa({
        bN: "Delivery",
        bT: "Livraison"
    }), Kun = {
        jV: "#1FB86A",
        eG: "#12553F",
        eH: "#0E3531",
        kw: "#0C252A",
        md: "#4BC687",
        mf: "#78D4A5",
        ng: "#A5E2C3",
        nh: "#D2F0E1",
        ni: "#E9F8F0",
        nv: "#1A975B",
        nx: "#16764D"
    }, Xun = "#878E96", Jun = "#3C4451", Yun = "#232D3A", Gun = "#181f29", non = "#9FA4AB", ron = "#B7BBC0", ton = "#CFD1D5", eon = "#E7E8EA", uon = "#6E757F", oon = "#555D68", aon = xa({
        bN: "New",
        bT: "Nouveau"
    }), ion = {
        jV: "#FF5A5A",
        eG: "#6C3039",
        eH: "#3B232E",
        kw: "#221B28",
        md: "#FF7B7B",
        mf: "#FF9C9C",
        ng: "#FFBDBD",
        nh: "#FFDEDE",
        ni: "#FFEEEE",
        nv: "#CE4C4F",
        nx: "#9a2b32"
    }, con = F2(function(n, r) {
        return A2(dg, k([
            A2(pg, "color", n),
            Ow("TimelineEventLabel")
        ]), k([
            ag(r),
            A2(dg, k([
                Ow("TimelineEventLabelPin"),
                A2(pg, "background-color", n)
            ]), k([
                ag(" ")
            ]))
        ]));
    }), fon = xa({
        bN: "Transcode",
        bT: "Transcode"
    }), son = xa({
        bN: "Unarchived",
        bT: "D\xe9sarchiv\xe9"
    }), lon = xa({
        bN: "Upload",
        bT: "Upload"
    }), don = xa({
        bN: "Verification",
        bT: "Verification"
    }), mon = function(n) {
        if (1 === n.$) return ag("");
        switch(n.a.$){
            case 13:
                return ag("");
            case 0:
                return A2(con, Wun.jV, aon);
            case 1:
                return A2(con, Wun.jV, lon);
            case 5:
                return A2(con, Xun, fon);
            case 6:
                return A2(con, Kun.jV, fon);
            case 9:
                return A2(con, Wun.jV, don);
            case 7:
                return A2(con, Kun.jV, don);
            case 8:
                return A2(con, ion.jV, don);
            case 2:
                return A2(con, Kun.jV, Qun);
            case 3:
                return A2(con, Kun.jV, _un);
            case 4:
                return A2(con, ion.jV, Zun);
            case 10:
                return A2(con, Xun, Run);
            case 11:
                return A2(con, Xun, son);
            default:
                return A2(con, Xun, Uun);
        }
    }, bon = F4(function(n, r, t, e) {
        var u, o = qt(e.e2) > 1;
        return A2(ye, k([
            Ow("TimelineEvent")
        ]), k([
            A2(ye, k([
                Ow("TimelineEventTitle")
            ]), k([
                mon(e.P),
                o ? A2(ye, k([
                    Cg(A2(xun, r, t))
                ]), k([
                    e.aI ? Eun : zun
                ])) : A2(ye, w, k([
                    Oun
                ])),
                A2(k8, wX(e.qJ), e.rW)
            ])),
            e.aI ? (u = e.P, A2(ye, k([
                Ow("TimelineEventTitleMessage")
            ]), function() {
                if (1 === u.$) return w;
                switch(u.a.$){
                    case 13:
                        var n = u.a, r = n.b;
                        return k([
                            ag(n.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 0:
                        var t = u.a;
                        return r = t.b, k([
                            ag(t.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 1:
                        var e = u.a;
                        return r = e.b, k([
                            ag(e.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 5:
                        var o = u.a;
                        return r = o.b, k([
                            ag(o.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 6:
                        var a = u.a;
                        return r = a.b, k([
                            ag(a.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 9:
                        var i = u.a;
                        return r = i.b, k([
                            ag(i.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 7:
                        var c = u.a;
                        return r = c.b, k([
                            ag(c.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 8:
                        var f = u.a;
                        return r = f.b, k([
                            ag(f.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 2:
                        var s = u.a;
                        return r = s.b, k([
                            ag(s.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 3:
                        var l = u.a;
                        return r = l.b, k([
                            ag(l.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 4:
                        var d = u.a;
                        return r = d.b, k([
                            ag(d.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 10:
                        var m = u.a;
                        return r = m.b, k([
                            ag(m.a),
                            ag(" "),
                            IP(r)
                        ]);
                    case 11:
                        var b = u.a;
                        return r = b.b, k([
                            ag(b.a),
                            ag(" "),
                            IP(r)
                        ]);
                    default:
                        var p = u.a;
                        return r = p.b, k([
                            ag(p.a),
                            ag(" "),
                            IP(r)
                        ]);
                }
            }())) : A2(ye, k([
                Ow("TimelineGroup")
            ]), A2(Ye, function(r) {
                var t;
                return A2(ye, k([
                    Ow("TimelineGroupEvent")
                ]), k([
                    (t = Hun(r), t.$ ? Oun : A2(Vun, n, t.a)),
                    A2(ye, k([
                        Ow("TimelineEventMessage")
                    ]), k([
                        ag(eG(r)),
                        IP(oG(r))
                    ]))
                ]));
            }, e.e2))
        ]));
    }), pon = F3(function(n, r, t) {
        return uI(A2(Gi, F2(function(t, e) {
            return A4(bon, n, r, t, e);
        }), t));
    }), von = F2(function(n, r) {
        return Zt(uI(A2(Gi, F2(function(r, t) {
            var e, u, o;
            return A2(ye, w, A2(mt, A2(qg, k([
                Ow("TimelineDate")
            ]), (u = A3(qe, 0, 4, e = r), o = A3(qe, 5, 7, e), A3(qe, 8, 10, e) + "/" + o + "/" + u)), A3(pon, n, r, t)));
        }), r)));
    }), $on = F4(function(n, r, t) {
        return k([
            A4(Bun, n, !0, r, t.be),
            uen(r),
            A2(mh, Dun, A2(ye, k([
                Ow("ShowHomeWrapper")
            ]), A2(von, n.st, r.rV)))
        ]);
    }), won = F4(function(n, r, t, e) {
        return A2(ye, k([
            Ow("ShowWrapper")
        ]), k([
            A2(ye, k([
                Ow("ShowMain")
            ]), A4($on, n, r, t, e)),
            A2(ye, k([
                Ow("ShowAside")
            ]), A3(Iun, n, r, t))
        ]));
    }), gon = F3(function(n, r, t) {
        var e = r.P.kx;
        return e.$ ? A2(aen, n, r) : A4(won, n, r, e.a, t);
    }), hon = function(n) {
        var r = n.P.lo;
        return r.$ ? ag("") : sk(een(r.a));
    }, kon = F2(function(n, r) {
        return A2(mu, function(r) {
            return a(n.mo, r.st) && r.cJ;
        }, r);
    }), Con = F3(function(n, r, t) {
        return !A2(BZ, n, r) && A2(kon, n, t) && A2(xZ, n, t);
    }), Ton = function(n) {
        return A3(Con, n.st, n.oM.mo, A2(Ye, function(n) {
            return n.fB;
        }, n.fD));
    }, Pon = F2(function(n, r) {
        return qt(A2(Mu, function(n) {
            return a(n.oO, r);
        }, n.oQ)) > 0;
    }), Son = {
        $: 0
    }, Aon = F3(function(n, r, t) {
        return n.ik ? Son : function(n) {
            return {
                $: 1,
                a: n
            };
        }(A2(AZ, r, t));
    }), yon = F3(function(n, r, t) {
        return {
            R: t.R,
            iZ: r.iZ,
            cz: t.cz,
            bK: t.bK,
            e1: n.e1,
            bP: t.bP,
            fD: t.fD,
            mM: n.mM,
            cZ: t.cZ,
            _: n._,
            c2: t.c2,
            oM: t.oM,
            oX: r.oX,
            o4: r.o3,
            bj: t.bj,
            g9: t.g9,
            P: A3(Aon, t.g9, t.R.bD, t.R.bQ.f$),
            st: n.st
        };
    }), Non = function(n) {
        return wX(n.mo);
    }, Lon = function(n) {
        return {
            $: 10,
            a: n
        };
    }, jon = F2(function(n, r) {
        return A2(W1, n, r.oX.bD);
    }), Fon = function(n) {
        return a(A2(Lu, function(n) {
            return GK(n.lD);
        }, n.R.bQ.f$), ht(!0));
    }, Mon = function(n) {
        return f0(n.g9)(n.bK)(n.oM)(n.c2)(n.cZ)(n.bP)(n.R)(n.bj)(n.cz)(n.fD);
    }, Ion = {
        $: 0
    }, Don = {
        $: 1
    }, Bon = {
        $: 2
    }, xon = function(n) {
        return {
            $: 9,
            a: n
        };
    }, qon = {
        $: 0
    }, Von = xa({
        bN: "Acceptation",
        bT: "Acceptation"
    }), Oon = xa({
        bN: "Capsule accepted",
        bT: "Capsule accept\xe9e"
    }), zon = xa({
        bN: "Master accepted",
        bT: "Master accept\xe9"
    }), Eon = function(n) {
        return A2(ye, k([
            Ow("AcceptationBorderWrapper")
        ]), k([
            n
        ]));
    }, Hon = xa({
        bN: "Capsule rejected",
        bT: "Capsule rejet\xe9e"
    }), Ron = xa({
        bN: "Master rejected",
        bT: "Master rejet\xe9"
    }), Won = xa({
        bN: "Please fill in the motivation for rejection",
        bT: "Veuillez donner un motif de refus"
    }), Uon = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Qon = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _on = F3(function(n, r, t) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t
        };
    }), Zon = {
        $: 0
    }, Kon = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Xon = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Jon = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Yon = {
        $: 1
    }, Gon = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nan = function(n) {
        return Gon(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n));
    }, ran = Zon, tan = Gon({
        $: 1
    }), ean = F2(function(n, r) {
        var t = r.lZ, e = r.f$;
        return A2(BZ, n, r.g9.oM) ? a(t.di, kt) ? 1 === e.$ ? nan("Vous devez uploader un fichier vid\xe9o et attendre la fin de son analyse automatique.") : 1 === A2(sp, function(n) {
            return n.bl;
        }, e.a.sy).$ ? nan("La validation n'est accessible qu'une fois l'analyse automatique termin\xe9e.") : ran : nan("Cette capsule a d\xe9j\xe0 \xe9t\xe9 rejet\xe9e.") : tan;
    }), uan = F2(function(n, r) {
        return ien(n) ? Zon : r;
    }), oan = Gon({
        $: 0
    }), aan = F4(function(n, r, t, e) {
        return A2(uan, n, A2(BZ, n, t.oM) ? t.ik ? tan : e : oan);
    }), ian = F2(function(n, r) {
        return A4(aan, n, r.ak, r.g9, A2(ean, n, r));
    }), can = function(n) {
        return A2(Aw, k([
            Ow("ButtonDisabled"),
            zg(!0)
        ]), k([
            ag(n)
        ]));
    }, fan = Lw("id"), san = prn(k([
        A2(iC, k([
            aC("M6.75,10.4726562 L6.83203125,10.0351562 C6.90039097,9.67057109 6.99609313,9.35612111 7.11914062,9.09179688 C7.24218812,8.82747264 7.40397035,8.59049584 7.60449219,8.38085938 C7.80501402,8.17122291 8.12629987,7.92057438 8.56835938,7.62890625 C8.97396036,7.36458201 9.25992755,7.14811282 9.42626953,6.97949219 C9.59261151,6.81087155 9.67578125,6.63541758 9.67578125,6.453125 C9.67578125,6.13411299 9.47070518,5.97460938 9.06054688,5.97460938 C8.48632525,5.97460938 7.77311624,6.22297929 6.92089844,6.71972656 L6.10742188,4.78515625 C7.16016151,4.1699188 8.21060674,3.86230469 9.25878906,3.86230469 C10.1748093,3.86230469 10.9028293,4.06738076 11.4428711,4.47753906 C11.9829129,4.88769736 12.2529297,5.45279588 12.2529297,6.17285156 C12.2529297,6.57845255 12.1902676,6.93391774 12.0649414,7.23925781 C11.9396153,7.54459788 11.759604,7.81917196 11.5249023,8.06298828 C11.2902006,8.3068046 10.9016954,8.5927718 10.359375,8.92089844 C9.90364355,9.1943373 9.57893977,9.42219961 9.38525391,9.60449219 C9.19156804,9.78678477 9.06510446,9.9781891 9.00585938,10.1787109 L8.90332031,10.4726562 L6.75,10.4726562 Z M6.203125,13.1318359 C6.203125,12.6442033 6.3512355,12.2568374 6.64746094,11.9697266 C6.94368638,11.6826158 7.3515599,11.5390625 7.87109375,11.5390625 C8.26758011,11.5390625 8.57177628,11.6313467 8.78369141,11.815918 C8.99560653,12.0004892 9.1015625,12.2613915 9.1015625,12.5986328 C9.1015625,13.0999374 8.95686994,13.4873033 8.66748047,13.7607422 C8.378091,14.0341811 7.98047128,14.1708984 7.47460938,14.1708984 C7.07812302,14.1708984 6.76709097,14.0820321 6.54150391,13.9042969 C6.31591684,13.7265616 6.203125,13.4690772 6.203125,13.1318359 Z"),
            fan("?")
        ]), w)
    ])), lan = F3(function(n, r, t) {
        if (t.$) return k(r.$ ? [
            Qk(n)
        ] : [
            A2(urn, n, r.a)
        ]);
        var e = t.a;
        return k([
            A2(ye, k([
                II(e)
            ]), k([
                can(n)
            ])),
            A2(ye, k([
                II(e),
                Ow("AcceptationWarning")
            ]), k([
                san
            ]))
        ]);
    }), dan = F4(function(n, r, t, e) {
        return A2(uan, n, A2(BZ, n, t.oM) ? t.ik ? tan : e : oan);
    }), man = F2(function(n, r) {
        return A4(dan, n, r.ak, r.g9, A2(ean, n, r));
    }), ban = xa({
        bN: "End file\u2019s qualification",
        bT: "Finir la qualification du fichier"
    }), pan = xa({
        bN: "You do not have the right to perform this action",
        bT: "Vous n\u2019avez pas le droit d\u2019effectuer cette action"
    }), van = xa({
        bN: "Ongoing processing",
        bT: "Traitement en cours"
    }), $an = F2(function(n, r) {
        if (1 === n.$) return ht(van);
        if (!r.$) return kt;
        var t = r.a;
        switch(t.$){
            case 0:
                return ht("");
            case 1:
                return ht(pan);
            default:
                return ht(t.a);
        }
    }), wan = F3(function(n, r, t) {
        if (1 === t.$) return A2($an, n.nI, r);
        var e = t.a.sy;
        return 1 === e.$ || 1 === e.a.bl.$ ? ht(van) : A2($an, n.nI, r);
    }), gan = xa({
        bN: "Accept",
        bT: "Accepter"
    }), han = xa({
        bN: "Accept master",
        bT: "Accepter le master"
    }), kan = xa({
        bN: "Ask for new upload",
        bT: "Demander un nouvel upload"
    }), Can = xa({
        bN: "Qualify",
        bT: "Qualifier"
    }), Tan = xa({
        bN: "Accept and deliver",
        bT: "Accepter et livrer"
    }), Pan = xa({
        bN: "Accept the capsule and deliver it to broadcaster",
        bT: "Accepter la capsule et la livrer au diffuseur"
    }), San = xa({
        bN: "Reject file and ask for a re-upload.",
        bT: "Rejeter les fichiers et demander un nouvel upload."
    }), Aan = ye(k([
        Ow("ButtonToolbar")
    ])), yan = F3(function(n, r, t) {
        var e = A3(wan, t, A2(man, n.st, {
            ak: n,
            lZ: r.bD,
            f$: A2(Lu, function(n) {
                return n.lD;
            }, r.bQ.f$),
            g9: n.g9
        }), A2(Lu, function(n) {
            return n.lD;
        }, r.bQ.f$)), u = A3(wan, t, Zon, A2(Lu, function(n) {
            return n.lD;
        }, r.bQ.f$)), o = A3(wan, t, A2(ian, n.st, {
            ak: n,
            lZ: r.bD,
            f$: A2(Lu, function(n) {
                return n.lD;
            }, r.bQ.f$),
            g9: n.g9
        }), A2(Lu, function(n) {
            return n.lD;
        }, r.bQ.f$)), a = n.g9.c$ ? d(gan, han) : d(Tan, Pan), i = a.a, c = a.b;
        return k([
            ien(n.st) ? A2(ye, k([
                Ow("AcceptationLeft"),
                Ow("AcceptationNormal")
            ]), k([
                A2(qg, k([
                    Ow("AcceptationText")
                ]), ban),
                Aan(A3(lan, Can, Qon(A2(Jon, n.g9, r.bD)), u))
            ])) : ag(""),
            A2(ye, k([
                Ow("AcceptationMiddle"),
                Ow("AcceptationOk")
            ]), k([
                A2(qg, k([
                    Ow("AcceptationTextOk")
                ]), c),
                Tu(n.cz) ? ag("") : A2(mh, Kon, A2(Ek, t.nG, A2(Ye, function(n) {
                    return d(n.sw, n.sw);
                }, n.cz))),
                Aan(A3(lan, i, Qon(A3(_on, n.g9, r.bD, n.cz)), o))
            ])),
            A2(ye, k([
                Ow("AcceptationRight")
            ]), k([
                A2(Hk, k([
                    Uk(Uon(n.g9)),
                    Ow("AcceptationKo")
                ]), k([
                    A2(qg, k([
                        Ow("AcceptationRejectionText")
                    ]), San),
                    A2(mh, Xon, kM(t.nH)),
                    Aan(A3(lan, kan, Yon, e))
                ]))
            ]))
        ]);
    }), Nan = F3(function(n, r, t) {
        return A2(DL, ien(n.st) || !0, function() {
            var e, u = (e = r.bD.di).$ ? n.g9.ik ? Ion : Fon(n) ? Bon : Don : function(n) {
                return {
                    $: 3,
                    a: n
                };
            }(e.a);
            switch(u.$){
                case 1:
                    return A2(ye, k([
                        Ow("Acceptation"),
                        Kg("accept"),
                        Bg(k([
                            d("AcceptationAccepted", n.g9.ik),
                            d("AcceptationRefused", !a(r.bD.di, kt))
                        ]))
                    ]), k([
                        Jx(k([
                            nq(Von),
                            Jen(k([
                                DI(p(dI, {
                                    mn: ht(t.gk ? tj : Yw),
                                    mK: t.gk,
                                    m7: Von,
                                    oy: ht(qon)
                                }))
                            ]))
                        ])),
                        A2(DL, t.gk, A2(ye, k([
                            Ow("InvitationsForm")
                        ]), k([
                            function() {
                                var n = t.nI;
                                switch(n.$){
                                    case 2:
                                        var r = n.a;
                                        return A2(ye, k([
                                            Cg(xon(0))
                                        ]), k([
                                            A2(Bnn, Vnn, r)
                                        ]));
                                    case 3:
                                        return A2(ye, k([
                                            Cg(xon(0))
                                        ]), k([
                                            sk(Won)
                                        ]));
                                    default:
                                        return ag("");
                                }
                            }(),
                            A2(BZ, n.st, n.g9.oM) ? A2(ye, k([
                                Ow("AcceptationChoices")
                            ]), A3(yan, n, r, t)) : ag("")
                        ])))
                    ]));
                case 2:
                    return ag("");
                case 0:
                    return Eon(lk(n.g9.c$ ? zon : Oon));
                default:
                    return Eon(A2(Zx, n.g9.c$ ? Ron : Hon, ag(u.a)));
            }
        }());
    }), Lan = xa({
        bN: "Segmentation IA",
        bT: "Segmentation IA"
    }), jan = {
        $: 0
    }, Fan = xa({
        bN: "Video archived",
        bT: "Fichier vid\xe9o archiv\xe9"
    }), Man = xa({
        bN: "Proxy required",
        bT: "Proxy requis"
    }), Ian = xa({
        bN: "Video file required",
        bT: "Fichier vid\xe9o requis"
    }), Dan = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return A2(ye, k([
                Cg(r)
            ]), k([
                A2(Bnn, Vnn, t)
            ]));
        }
        return ag("");
    }), Ban = function(n) {
        switch(n.$){
            case 0:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusNone")
                ]), w);
            case 1:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusRunning")
                ]), w);
            case 2:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusSuccess")
                ]), w);
            default:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusFailure")
                ]), w);
        }
    }, xan = F3(function(n, r, t) {
        return A2(ye, k([
            Ow("Operation")
        ]), k([
            Ban(n),
            A2(ye, k([
                Ow("OperationContent")
            ]), A2(mt, A2(Dan, n, r), t))
        ]));
    }), qan = F2(function(n, r) {
        var t = d(n.bQ.f$, A2(sp, A2(Pi, function(n) {
            return n.pm;
        }, function(n) {
            return n.nw;
        }), n.bQ.f$));
        if (1 === t.a.$) return A3(xan, jan, 0, k([
            ag(Ian)
        ]));
        if (1 === t.b.$) return A3(xan, jan, 0, k([
            ag(Man)
        ]));
        var e = t.b.a;
        return GK(t.a.a.lD) ? A3(xan, jan, 0, k([
            ag(Fan)
        ])) : r(e);
    }), Van = F2(function(n, r) {
        return A2(ye, k([
            Ow("Operation")
        ]), k([
            Ban(jan),
            A2(ye, k([
                Ow("OperationContent"),
                Ow("PlayerSettings")
            ]), k([
                A2(ye, w, k([
                    ag(A2(ju, "", n.kq))
                ])),
                A2(oC, k([
                    fC("/neoplayer/" + r),
                    Ow("Button"),
                    WL("_blank"),
                    A2(qI, "data-prevent-history", "true")
                ]), k([
                    ag("Neo Player")
                ]))
            ]))
        ]));
    }), Oan = F3(function(n, r, t) {
        var e;
        return "df35fcfb-a68e-42f4-8d9f-74d3df15125c" === (e = n.st).mo || "f4f90af8-0702-49ff-89c0-aafecd8afec9" === e.mo || "f086968b-9a32-449b-bd87-5419c15973ec" === e.mo || "7c9b1827-1d6c-4fa0-8864-598812d5efd5" === e.mo || "5de3e02c-06aa-496f-a4f6-f5aac29114ee" === e.mo || "d00b873f-d6aa-4c16-8342-3e4e08a6d658" === e.mo || "354b2862-a0b9-4292-93a2-437d51a2df47" === e.mo ? A2(ye, k([
            Ow("Segmentation")
        ]), k([
            A2(ye, k([
                Ow("LayoutHeader"),
                A2(pg, "margin-bottom", "0px")
            ]), k([
                A2(qg, k([
                    Ow("LayoutHeaderTitle")
                ]), Lan)
            ])),
            A2(qan, r, function() {
                return A2(Van, t, n.g9.mo);
            })
        ])) : ag("");
    }), zan = {
        $: 1
    }, Ean = function(n) {
        return qt(n.oQ) > 0;
    }, Han = xa({
        bN: "Cancel",
        bT: "Annuler"
    }), Ran = xa({
        bN: "Deliveries",
        bT: "Livraisons"
    }), Wan = A2(Zw, k([
        Hw("18px"),
        Xw("18px"),
        Kw("0 0 18 18"),
        Fw("IconSpinner")
    ]), k([
        A2(iC, k([
            Fw("Fg"),
            aC("M4.94601622,4.57669369 C3.74989521,5.67353545 3,7.24919402 3,9 C3,12.3137085 5.6862915,15 9,15 C12.3137085,15 15,12.3137085 15,9 C15,6.64729493 13.6458726,4.61086325 11.6744855,3.62757252 L11.2601446,5.69927685 C12.3108237,6.42010318 13,7.62956872 13,9 C13,11.209139 11.209139,13 9,13 C6.790861,13 5,11.209139 5,9 C5,7.98151039 5.38065278,7.051927 6.00745306,6.34575509 L7,8 L9,4 L4,3 L4.94601622,4.57669369 Z")
        ]), w)
    ])), Uan = xa({
        bN: "Downloading before delivery",
        bT: "T\xe9l\xe9chargement avant livraison"
    }), Qan = xa({
        bN: "Encoding in progress before delivery",
        bT: "Encodage en cours avant livraison"
    }), _an = xa({
        bN: "Delivered",
        bT: "Livr\xe9"
    }), Zan = xa({
        bN: "Packaging in progress before delivery",
        bT: "Enpaquetage en cours avant livraison"
    }), Kan = xa({
        bN: "Uploading in progress before delivery",
        bT: "Transfert en cours"
    }), Xan = xa({
        bN: "Waiting for delivery",
        bT: "Livraison en attente"
    }), Jan = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M6,11 L9,14 L13,9 L12,7 L9,11 L7,9 L6,11 Z")
        ]), w)
    ])), Yan = function(n) {
        return A2(oC, k([
            fC(wX(n.mo)),
            Ow("DownloadsLinksItem"),
            5 === n.r6.o2 ? Ow("ShowDeliveriesSuccess") : Bg(w)
        ]), k([
            A2(dg, k([
                Ow("DownloadsLinksItemIcon")
            ]), k([
                5 === n.r6.o2 ? Jan : Wan
            ])),
            A2(dg, k([
                Ow("DownloadsLinksItemWrapper")
            ]), k([
                A2(dg, k([
                    Ow("DownloadsLinksItemName")
                ]), k([
                    ag(n.gm),
                    ag(" / "),
                    ag(n.rW)
                ])),
                A2(dg, k([
                    Ow("DownloadsLinksItemDetails")
                ]), k([
                    function() {
                        switch(n.r6.o2){
                            case 0:
                                return ag(Xan);
                            case 1:
                                return ag(Uan);
                            case 2:
                                return ag(Qan);
                            case 3:
                                return ag(Zan);
                            case 4:
                                return ag(Kan);
                            default:
                                return ag(_an);
                        }
                    }(),
                    ag(" - "),
                    IP(n.r6.q6)
                ]))
            ]))
        ]));
    }, Gan = function(n) {
        return A2(Ye, Yan, A2(hT, gT(function(n) {
            return n.rW;
        }), n));
    }, nin = xa({
        bN: "New delivery",
        bT: "Nouvelle livraison"
    }), rin = xa({
        bN: "No delivery yet.",
        bT: "Aucune livraison."
    }), tin = xa({
        bN: "No material available.",
        bT: "Pas de mat\xe9riel disponible."
    }), ein = F4(function(n, r, t, e) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), uin = function(n) {
        return {
            $: 14,
            a: n
        };
    }, oin = xa({
        bN: "This action will not re-encode, but copy source files to destination.",
        bT: "Cette action ne va pas r\xe9-encoder, mais seulement copier les sources \xe0 destination."
    }), ain = xa({
        bN: "Error occurred during delivery",
        bT: "Une erreur est survenue pendant la livraison"
    }), iin = xa({
        bN: "Delivery has started...",
        bT: "La livraison a commenc\xe9..."
    }), cin = xa({
        bN: "Loading...",
        bT: "Chargement..."
    }), fin = xa({
        bN: "You can not deliver this master on any program.",
        bT: "Vous ne pouvez livrer ce master sur aucun programme."
    }), sin = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M12.5918 14.7207L12.377 15.5996C11.7324 15.8535 11.2181 16.0456 10.834 16.1758C10.4499 16.3125 10.0039 16.3809 9.49609 16.3809C8.71484 16.3809 8.10612 16.1921 7.66992 15.8145C7.24023 15.4303 7.02539 14.9453 7.02539 14.3594C7.02539 14.1315 7.04167 13.9004 7.07422 13.666C7.10677 13.4251 7.15885 13.1549 7.23047 12.8555L8.03125 10.0039C8.10286 9.73047 8.16146 9.47331 8.20703 9.23242C8.25911 8.98503 8.28516 8.76042 8.28516 8.55859C8.28516 8.19401 8.21029 7.9401 8.06055 7.79688C7.91081 7.65365 7.62435 7.58203 7.20117 7.58203C6.99284 7.58203 6.77799 7.61458 6.55664 7.67969C6.3418 7.74479 6.15625 7.80664 6 7.86523L6.21484 6.98633C6.74219 6.77148 7.24674 6.58919 7.72852 6.43945C8.21029 6.2832 8.66602 6.20508 9.0957 6.20508C9.87044 6.20508 10.4661 6.39388 10.8828 6.77148C11.306 7.14258 11.5176 7.6276 11.5176 8.22656C11.5176 8.35026 11.5013 8.56836 11.4688 8.88086C11.4427 9.19336 11.3906 9.47982 11.3125 9.74023L10.5117 12.582C10.4466 12.8099 10.388 13.0703 10.3359 13.3633C10.2839 13.6562 10.2578 13.8776 10.2578 14.0273C10.2578 14.4049 10.3424 14.6621 10.5117 14.7988C10.681 14.9355 10.974 15.0039 11.3906 15.0039C11.5859 15.0039 11.8073 14.9714 12.0547 14.9062C12.3021 14.8346 12.4811 14.7728 12.5918 14.7207ZM11.7969 3.79688C11.7969 4.29167 11.6081 4.71484 11.2305 5.06641C10.8594 5.41146 10.4102 5.58398 9.88281 5.58398C9.35547 5.58398 8.90299 5.41146 8.52539 5.06641C8.14779 4.71484 7.95898 4.29167 7.95898 3.79688C7.95898 3.30208 8.14779 2.87891 8.52539 2.52734C8.90299 2.17578 9.35547 2 9.88281 2C10.4102 2 10.8594 2.17578 11.2305 2.52734C11.6081 2.87891 11.7969 3.30208 11.7969 3.79688Z")
        ]), w)
    ])), lin = function(n) {
        return A2(ye, k([
            Ow("BannerTodo")
        ]), k([
            A2(ye, k([
                Ow("BannerTodoIcon")
            ]), k([
                sin
            ])),
            A2(ye, k([
                Ow("BannerTodoBody")
            ]), k([
                A2(qg, k([
                    Ow("BannerTodoTitle")
                ]), n)
            ]))
        ]));
    }, din = xa({
        bN: "An error occurred while searching for delivery capsules in the organization ",
        bT: "Une erreur est survenue pendant la recherche des capsules de livraison dans l\u2019organisation "
    }), min = xa({
        bN: "Start delivery",
        bT: "D\xe9marrer la livraison"
    }), bin = xa({
        bN: "No version mapping are associated to this organization. Contact ops@nomalab.com",
        bT: "Aucune version mapping n'est associ\xe9e \xe0 cette organisation. Veuillez contacter ops@nomalab.com."
    }), pin = function(n) {
        return {
            $: 17,
            a: n
        };
    }, vin = function(n) {
        return {
            $: 13,
            a: n
        };
    }, $in = function(n) {
        return {
            $: 10,
            a: n
        };
    }, win = F2(function(n, r) {
        return {
            $: 16,
            a: n,
            b: r
        };
    }), gin = function(n) {
        return {
            $: 15,
            a: n
        };
    }, hin = function(n) {
        return {
            $: 12,
            a: n
        };
    }, kin = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Cin = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Tin = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Pin = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Sin = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Ain = function(n) {
        return {
            $: 19,
            a: n
        };
    }, yin = xa({
        bN: "No transcoding delivery",
        bT: "Livraison source sans encodage"
    }), Nin = xa({
        bN: "Automatic creation",
        bT: "Cr\xe9ation automatique"
    }), Lin = xa({
        bN: "Burn subtitles",
        bT: "Sous-titres incrust\xe9s"
    }), jin = xa({
        bN: "Extra",
        bT: "Compl\xe9mentaire"
    }), Fin = F2(function(n, r) {
        return A2(F2(function(n, t) {
            for(;;){
                var e = A2(di, n, r);
                if (1 === e.$) return t;
                var u = e.a, o = u.gq;
                if (1 === o.$) return A2(mt, u.n6, t);
                n = o.a, t = A2(mt, u.n6, t);
            }
        }), n, w);
    }), Min = ye(k([
        A2(pg, "display", "contents")
    ])), Iin = function(n) {
        return A2(Og, n, A2(Eg, k([
            Ow("InputText"),
            Xg(n.kX),
            Tg("text"),
            eh(Lg),
            Gg(jg),
            nh(Fg),
            oh(n.sw),
            uh(n.gw),
            Hg(Zg(n.m7)),
            zg(n.kS),
            Pun(!0)
        ]), w));
    }, Din = xa({
        bN: "You can not deliver any of this organization\u2019s programs.",
        bT: "Vous ne pouvez livrer aucun des programmes de cette organisation."
    }), Bin = F2(function(n, r) {
        return 1 > n ? r : A3(qe, 0, -n, r);
    }), xin = xa({
        bN: "Mark in/out",
        bT: "Mark in/out"
    }), qin = xa({
        bN: "No subtitles",
        bT: "Sans sous-titres"
    }), Vin = xa({
        bN: "No extra",
        bT: "Sans compl\xe9mentaire"
    }), Oin = xa({
        bN: "No segment on this master",
        bT: "Il n'y a pas de segment pour ce master"
    }), zin = xa({
        bN: "Segment(s)",
        bT: "Segment(s)"
    }), Ein = xa({
        bN: "Sidecar format : ",
        bT: "Format \xe0 part : "
    }), Hin = xa({
        bN: "Warning, some subtitles have been detected with wrong position, they will be automatically readjusted when you will play and burn them.",
        bT: "Attention, certaines lignes de sous-titres sont d\xe9tect\xe9es avec des placements m\xe9dian, ils seront automatiquement repositionn\xe9s lors de la visualisation et l'incrustation."
    }), Rin = xa({
        bN: "The timezone used is",
        bT: "La timezone utilis\xe9e est"
    }), Win = F4(function(n, r, t, e) {
        var u, o, i, c, f = A2(mt, d("", qin), A2(Kc, function(n) {
            var r;
            return (r = n.lD.sk).$ || !a(r.a.j2, kt) ? ht(d(n.lD.mo, n.lD.n6)) : kt;
        }, n.bQ.ad)), s = A2(ju, !1, A2(Lu, A2(Pi, function(n) {
            return n.hH;
        }, A2(Pi, Tu, pu)), Eo(A2(Mu, function(n) {
            return a(n.lD.mo, t.rv.sw);
        }, n.bQ.ad)))), l = "AsSource" !== t.lT.sw, b = F2(function(n, r) {
            return n ? r : ag("");
        }), p = "" !== t.rv.sw, v = "" !== t.e4.sw && "NoExtra" !== t.e4.sw, g = qt(n.bQ.ad) > 0, h = m(e.c8, e.dr, e.ic), C = h.b, T = h.c, P = Ji(A2(Ye, function(n) {
            return d(n.mo, n);
        }, h.a)), S = $(A2(hT, gT(Zi), A2(Ye, j4(It(" > ")), A2(Ye, function(n) {
            return d(n.mo, $(A2(Fin, n.gq, P), k([
                n.rX
            ])));
        }, A2(Mu, sen, C)))), k([
            d("Aucun", Nin)
        ])), A = A2(Ye, function(n) {
            return d(n.n6, n.n6);
        }, T), y = m(e.cX, e.dw, e.e5), N = y.a, L = y.b, j = y.c, F = A2(mt, d("NoExtra", Vin), A2(Ye, function(n) {
            return d(n.mo, n.n6);
        }, j)), M = qt(F) > 1, I = (u = A2(hT, gT(Zi), A2(Ye, function(n) {
            return d(n.mo, n.n6);
        }, N)), r.iJ ? $(u, k([
            d("AsSource", yin)
        ])) : u), D = A2(N5, N, t.lT.sw);
        return d(S, k([
            A2(ye, w, Tu(S) ? k("" === t.oM.sw ? [
                ag("")
            ] : [
                sk(Din)
            ]) : k([
                A2(mh, gin, A2(zk, t.g9, S)),
                A2(b, l, A2(mh, Pin, A2(zk, t.ic, A))),
                A2(mh, win(N), A2(zk, t.lT, I)),
                A2(b, g && !D, A2(mh, kin, A2(zk, t.rv, f))),
                A2(b, g && !D && p, A2(mh, hin, A2(zk, t.rn, (o = t.rv.sw, i = A2(ju, "", Eo(A2(Ye, function(n) {
                    return n.lD.n6;
                }, A2(Mu, function(n) {
                    return a(n.lD.mo, o);
                }, n.bQ.ad)))), A2(mu, function(n) {
                    return A2(NZ, n, Ua(i));
                }, k([
                    ".stl",
                    ".vtt",
                    ".srt",
                    ".ass"
                ])) ? A2(mt, l ? d("Burning", Lin) : d("", ""), A2(hT, gT(Zi), A2(Ye, function(n) {
                    return d(n.mo, $(Ein, n.n6));
                }, L))) : w)))),
                A2(b, s, B8(Hin)),
                A2(b, M, Min(k([
                    A2(ye, k([
                        Ow("ShowDeliveriesItemTitle")
                    ]), k([
                        ag(jin)
                    ])),
                    A2(mh, vin, A2(zk, t.e4, F)),
                    A2(b, v, A2(mh, $in, A2(zk, t.e6, A)))
                ]))),
                A2(ye, w, k([
                    A2(mh, pin, (c = t.kK, A2(jk, c, function(n) {
                        var r;
                        return A2(Og, n, A2(Eg, k([
                            Ow("InputText"),
                            Tg("datetime-local"),
                            A2(Dw, "input", A2(Ne, function(n) {
                                return Lg(n);
                            }, A2(du, "timezone", Da))),
                            oh((r = n.sw, A2(Bin, 6, r))),
                            uh(n.gw),
                            Hg(Zg(n.m7)),
                            zg(n.kS)
                        ]), w));
                    }(c))))
                ])),
                A2(dg, w, k([
                    ag(Rin + " "),
                    A3(Ae, "time-zone", w, w)
                ])),
                A2(ye, k([
                    Ow("ShowDeliverySegmentsTabs")
                ]), k([
                    A2(ye, k([
                        Cg(Ain(!0)),
                        Ow("ShowDeliverySegmentsTab"),
                        Bg(k([
                            d("ShowDeliverySegmentsTabActive", t.r$)
                        ]))
                    ]), k([
                        ag(zin)
                    ])),
                    A2(ye, k([
                        Cg(Ain(!1)),
                        Ow("ShowDeliverySegmentsTab"),
                        Bg(k([
                            d("ShowDeliverySegmentsTabActive", !t.r$)
                        ]))
                    ]), k([
                        ag(xin)
                    ]))
                ])),
                A2(b, l, A2(ye, k([
                    Ow("ShowDeliverySegmentsContent")
                ]), k(t.r$ ? [
                    a(t.g3.jN, w) ? ag(Oin) : A2(mh, Sin, BB(t.g3))
                ] : [
                    A2(dg, k([
                        Ow("MasterTimecodeInputCls")
                    ]), k([
                        A2(mh, Cin, Iin(t.dz)),
                        A2(urn, "Mark in", A2(L1, 0, kt))
                    ])),
                    A2(dg, k([
                        Ow("MasterTimecodeInputCls")
                    ]), k([
                        A2(mh, Tin, Iin(t.dA)),
                        A2(urn, "Mark out", A2(L1, 1, kt))
                    ]))
                ])))
            ]))
        ]));
    }), Uin = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return ag("");
            case 1:
                return A2(ye, k([
                    Ow("InvitationsForm")
                ]), k([
                    men(cin)
                ]));
            default:
                var e = n.a.oQ, u = n.a.qt, o = n.a.qu, i = n.a.P, c = !a(A2(Lu, function(n) {
                    return n.ic;
                }, u), kt), f = A2(ju, w, A2(Lu, function(n) {
                    return n.ic;
                }, u)), s = A2(ju, w, A2(Lu, function(n) {
                    return n.dr;
                }, u)), l = A2(hT, gT(Zi), A2(Ye, function(n) {
                    return d(n.mo, n.n6);
                }, e)), m = A2(Lu, function(n) {
                    return n.mo;
                }, Eo(A2(Mu, function(n) {
                    return a(n.oM, o.oM.sw) && a(n.mo, o.g9.sw);
                }, s))), b = Eo(A2(Mu, function(n) {
                    return a(n.mo, o.oM.sw);
                }, e)), p = A2(Lu, function(n) {
                    return n.mo;
                }, b), v = a(i, z4), g = (T = d(b, u)).a.$ || T.b.$ ? d(w, w) : A4(Win, r, T.a.a, o, T.b.a), h = g.a, C = g.b;
                return Tu(l) ? A2(ye, k([
                    Ow("InvitationsForm")
                ]), k([
                    B8(fin)
                ])) : qt(A2(Mu, function(n) {
                    return !xe(n.a);
                }, h)) > 0 ? A2(ye, k([
                    Ow("InvitationsForm")
                ]), k([
                    B8($(din, A2(ju, o.oM.sw, Eo(A2(Ye, function(n) {
                        return n.n6;
                    }, A2(Mu, function(n) {
                        return a(n.mo, o.oM.sw);
                    }, e))))))
                ])) : A2(Hk, k([
                    Uk(A4(ein, t.g9, t.R.bD.mo, p, m))
                ]), $(k([
                    A2(ju, ag(""), A2(Lu, lin, o.nP)),
                    A2(ju, ag(""), A2(Lu, B8, o.n0)),
                    A2(mh, uin, A2(zk, o.oM, l))
                ]), $(C, k([
                    A2(ye, k([
                        Ow("DeliveryFormBanners")
                    ]), k([
                        function() {
                            switch(i.$){
                                case 2:
                                    return A2(Zx, ain, ag(i.a));
                                case 3:
                                    return lk(iin);
                                default:
                                    return "AsSource" === o.lT.sw ? men(oin) : "" !== o.oM.sw && c && !qt(f) ? B8(bin) : ag("");
                            }
                        }(),
                        v || "" === o.g9.sw ? can(min) : Qk(min)
                    ]))
                ]))));
        }
        var T;
    }), Qin = F3(function(n, r, t) {
        var e, u, o, i = (e = r.bQ.f$).$ ? Eo(r.bQ.d7) : ht(e.a);
        if (A2(BZ, (u = t).st, u.g9.oM) || A3(Con, (o = u).st, o.oM.mo, A2(Ye, function(n) {
            return n.fB;
        }, o.fD)) && Ean(u.st)) {
            if (i.$) return B8(tin);
            var c = i.a;
            return A2(ye, k([
                Kg("delivery")
            ]), k([
                Jx(k([
                    nq(Ran),
                    A2(DL, !Fon(t), Jen(k([
                        DI(p(dI, {
                            kS: a(n, H4),
                            mn: a(n, Ss) ? ht(wen) : ht(tj),
                            mK: !a(n, Ss),
                            m7: a(n, Ss) ? nin : Han,
                            oy: ht(zan)
                        }))
                    ])))
                ])),
                A3(Uin, n, r, t),
                a(c.kI, w) ? men(rin) : A2(ye, k([
                    Ow("DownloadsLinks")
                ]), Gan(c.kI))
            ]));
        }
        return ag("");
    }), _in = {
        $: 6
    }, Zin = xa({
        bN: "Cancel",
        bT: "Annuler"
    }), Kin = xa({
        bN: "Invitations",
        bT: "Invitations"
    }), Xin = xa({
        bN: "Invite",
        bT: "Inviter"
    }), Jin = xa({
        bN: "No invitations.",
        bT: "Aucune invitation."
    }), Yin = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Gin = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ncn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rcn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, tcn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ecn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ucn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, ocn = xa({
        bN: "Allow view",
        bT: "Autoriser \xe0 visionner"
    }), acn = xa({
        bN: "The files are archived at this time. Please unarchive before download or upload.",
        bT: "Les fichiers sont actuellement archiv\xe9s. Veuillez d\xe9sarchiver avant t\xe9l\xe9chargement ou upload."
    }), icn = F2(function(n, r) {
        return A2(Hk, k([
            Uk(ucn(n.g9)),
            Ow("InvitationsForm"),
            Ow("DarkZone")
        ]), k([
            A2(mh, Yin, ah(r.la)),
            A2(mh, Gin, znn(r.lt)),
            A2(mh, ncn, kM(r.nP)),
            A2(mh, ecn, A2(Ien, ocn, ti(function(n) {
                return p(n, {
                    kS: !0,
                    mo: "checkbox-canView",
                    m7: ocn,
                    sw: !0
                });
            }))),
            A2(mh, tcn, A2(Ien, Is, r.jA)),
            A2(mh, rcn, A2(Ien, Fs, r.jz)),
            A2(DL, GK(n.g9) && (r.jz.sw || r.jA.sw), B8(acn)),
            Fen(Xin),
            A2(ju, ag(""), A2(Lu, A2(Pi, function(n) {
                return n.nP;
            }, sk), r.lo))
        ]));
    }), ccn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, fcn = F2(function(n, r) {
        return wP(A2(Cp, n, r));
    }), scn = function(n) {
        return A2(fcn, n, 1);
    }, lcn = function(n) {
        return A2(ye, k([
            Ow(n ? "FullCube" : "EmptyCube")
        ]), w);
    }, dcn = F2(function(n, r) {
        var t;
        return A2(Lh, w, k([
            A2(uk, w, k([
                lcn(!0)
            ])),
            A2(uk, w, k([
                lcn(r.fB.sk)
            ])),
            A2(uk, w, k([
                lcn(r.fB.cJ)
            ])),
            A2(uk, k([
                Ow("InvitationEmail"),
                II(r.st.la)
            ]), k([
                ag(r.st.la),
                ag("   "),
                (t = r.fB.cO, t.$ ? ag("") : zen(t.a))
            ])),
            function() {
                if (a(n.st.oM, kt)) return ag("");
                var t = r.fB.c$;
                n: for(; !t.$;)switch(t.a){
                    case 0:
                        return A2(uk, w, k([
                            A2(ye, k([
                                Ow("InvitationSourceKind")
                            ]), k([
                                A2(Ck, function(n) {
                                    return A2(oC, k([
                                        fC(scn(n))
                                    ]), k([
                                        xen
                                    ]));
                                }, r.fB.hi)
                            ]))
                        ]));
                    case 2:
                        return A2(uk, w, k([
                            A2(ye, k([
                                Ow("InvitationSourceKind")
                            ]), k([
                                A2(Ck, function(n) {
                                    return A2(oC, k([
                                        fC(scn(n))
                                    ]), k([
                                        qen
                                    ]));
                                }, r.fB.hi)
                            ]))
                        ]));
                    default:
                        break n;
                }
                return a(r.fB.qJ, kt) ? A2(uk, w, k([
                    A2(ye, k([
                        Ow("InvitationSourceKind")
                    ]), k([
                        A2(Ck, function(n) {
                            return A2(oC, k([
                                fC(scn(n))
                            ]), k([
                                Ven
                            ]));
                        }, r.fB.hi)
                    ]))
                ])) : A2(BZ, n.st, n.g9.oM) ? A2(uk, w, k([
                    A2(ye, k([
                        Ow("InvitationDelete"),
                        Cg(ccn(r.fB))
                    ]), k([
                        kg
                    ]))
                ])) : ag("");
            }()
        ]));
    }), mcn = F2(function(n, r) {
        return A2(ye, k([
            Ow("InvitationsWrapper")
        ]), k([
            Jx(k([
                nq(Kin),
                A2(BZ, n.st, n.g9.oM) ? DI(p(dI, {
                    jQ: kt,
                    mn: ht(r.kU ? tj : wen),
                    mK: r.kU,
                    m7: r.kU ? Zin : Xin,
                    oy: ht(_in)
                })) : ag("")
            ])),
            r.kU ? A2(icn, n, r) : ag(""),
            Tu(n.fD) ? men(Jin) : A2(kh, k([
                Ow("InvitationsTable")
            ]), A2(Ye, dcn(n), A2(Ra, A2(Pi, function(n) {
                return n.st;
            }, function(n) {
                return n.la;
            }), n.fD)))
        ]));
    }), bcn = xa({
        bN: "Client ID",
        bT: "Identifiant client"
    }), pcn = hs, vcn = F2(function(n, r) {
        return A2(ye, k([
            Ow("JobsRow")
        ]), k([
            A2(dg, k([
                Ow("JobsRowLabel")
            ]), k([
                ag(n)
            ])),
            A2(ye, k([
                Ow("JobsRowContent")
            ]), k([
                ag(r)
            ]))
        ]));
    }), $cn = function(n) {
        return A2(ye, k([
            Ow("JobsContent")
        ]), k([
            A2(vcn, "Type", pcn(n.fI)),
            A2(vcn, bcn, A2(ju, "", n.lw))
        ]));
    }, wcn = xa({
        bN: "Job in progress",
        bT: "Travaux en cours"
    }), gcn = Jx(k([
        nq(wcn)
    ])), hcn = function(n) {
        return {
            $: 21,
            a: n
        };
    }, kcn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ccn = {
        $: 35
    }, Tcn = function(n) {
        return {
            $: 42,
            a: n
        };
    }, Pcn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Scn = function(n) {
        return {
            $: 40,
            a: n
        };
    }, Acn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, ycn = F2(function(n, r) {
        return {
            $: 38,
            a: n,
            b: r
        };
    }), Ncn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Lcn = function(n) {
        return {
            $: 23,
            a: n
        };
    }, jcn = F2(function(n, r) {
        return {
            $: 16,
            a: n,
            b: r
        };
    }), Fcn = xa({
        bN: "Download (S3/SFTP)",
        bT: "Download (S3/SFTP)"
    }), Mcn = xa({
        bN: "Archive show",
        bT: "Archiver le show"
    }), Icn = xa({
        bN: "Same as source",
        bT: "Comme la source"
    }), Dcn = xa({
        bN: "Deliver all ad destinations",
        bT: "Livrer vers toutes les destinations ad"
    }), Bcn = xa({
        bN: "Mark as delivered",
        bT: "Marquer comme livr\xe9"
    }), xcn = F2(function(n, r) {
        return A2(FB, k([
            Ow("LayoutDetails")
        ]), k([
            A2(IB, k([
                Ow("LayoutDetailsHeader")
            ]), k([
                n
            ])),
            A2(ye, k([
                Ow("LayoutDetailsContent")
            ]), r)
        ]));
    }), qcn = xa({
        bN: "FTP Upload",
        bT: "Upload FTP"
    }), Vcn = function(n) {
        return 2 === n.hv;
    }, Ocn = xa({
        bN: "Generate Segmentation",
        bT: "G\xe9n\xe9rer Segmentation"
    }), zcn = xa({
        bN: "Silent",
        bT: "Silencieux"
    }), Ecn = xa({
        bN: "Dubbed version only",
        bT: "Version doubl\xe9e seulement"
    }), Hcn = xa({
        bN: "Dubbed version + audiodescription",
        bT: "Version doubl\xe9e + audiodescription"
    }), Rcn = xa({
        bN: "Dubbed version + Music & effect + international version + Voice Only",
        bT: "Version doubl\xe9e + Music & effect + version internationale + Voice Only"
    }), Wcn = xa({
        bN: "Dubbed + International version + Voice Only",
        bT: "Version doubl\xe9e + internationale + Voice Only"
    }), Ucn = xa({
        bN: "Original version + dubbed version",
        bT: "Version originale + doubl\xe9e"
    }), Qcn = xa({
        bN: "Dubbed + original + audiodescription version",
        bT: "Version doubl\xe9e + originale + audiodescription"
    }), _cn = xa({
        bN: "International version only",
        bT: "Version internationale seulement"
    }), Zcn = xa({
        bN: "International + Dubbed version",
        bT: "Version internationale + doubl\xe9e"
    }), Kcn = xa({
        bN: "International + original version",
        bT: "Version internationale originale"
    }), Xcn = xa({
        bN: "Original version only",
        bT: "Version originale seulement"
    }), Jcn = xa({
        bN: "Original version + audiodescription",
        bT: "Version originale + audiodescription"
    }), Ycn = xa({
        bN: "none",
        bT: "aucun"
    }), Gcn = xa({
        bN: "Reupload file",
        bT: "Reuploader le fichier"
    }), nfn = xa({
        bN: "Retranscode proxy",
        bT: "Retranscoder le proxy"
    }), rfn = xa({
        bN: "Restart verification",
        bT: "Relancer la v\xe9rification"
    }), tfn = xa({
        bN: "Restoring the show, this can take up to 12h.",
        bT: "Restoration du show, cela peut prendre jusque 12h."
    }), efn = xa({
        bN: "S3 Upload",
        bT: "Upload S3"
    }), ufn = xa({
        bN: "Saved audio mapping: ",
        bT: "Mapping Audio enregistr\xe9 : "
    }), ofn = xa({
        bN: "Select a rule",
        bT: "S\xe9lectionner une r\xe8gle"
    }), afn = xa({
        bN: "Admin Operations",
        bT: "Op\xe9rations Admin"
    }), ifn = xa({
        bN: "Unarchive show",
        bT: "D\xe9sarchiver le show"
    }), cfn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ffn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sfn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, lfn = k([
        d("Material", "Material"),
        d("Audio", "Audio"),
        d("Subtitle", "Subtitle"),
        d("Extra", "Extra")
    ]), dfn = xa({
        bN: "Source (url)",
        bT: "Source (url)"
    }), mfn = function(n) {
        return A2(mu, function(n) {
            return "" === n.trim();
        }, k([
            n.mB.sw,
            n.qo.sw
        ]));
    }, bfn = xa({
        bN: "Start Download",
        bT: "Start Download"
    }), pfn = F2(function(n, r) {
        var t;
        return A2(Hk, k([
            Uk(cfn(n))
        ]), k([
            (t = r.lo, t.$ ? ag("") : A2(Bnn, Vnn, t.a)),
            bC(_s),
            A2(mh, sfn, A2(Ek, r.qo, lfn)),
            bC(dfn),
            A2(mh, ffn, ah(r.mB)),
            DI(p(dI, {
                kS: mfn(r),
                bg: !0,
                m7: bfn
            }))
        ]));
    }), vfn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $fn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, wfn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, gfn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, hfn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, kfn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Cfn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Tfn = xa({
        bN: "Start FTP Upload",
        bT: "Start FTP Upload"
    }), Pfn = F2(function(n, r) {
        var t;
        return A2(Hk, k([
            Uk(vfn(n))
        ]), k([
            (t = r.lo, t.$ ? ag("") : A2(Bnn, Vnn, t.a)),
            A2(ye, k([
                Ow("FTPCopyWrapper")
            ]), k([
                A2(mh, kfn, ah(r.mC)),
                A2(mh, wfn, ah(r.mw)),
                A2(mh, $fn, ah(r.mv)),
                A2(mh, hfn, ah(r.my)),
                A2(mh, gfn, ah(r.mx)),
                A2(mh, Cfn, A2(Ek, r.qo, lfn))
            ])),
            Qk(Tfn)
        ]));
    }), Sfn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Afn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, yfn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Nfn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Lfn = xa({
        bN: "Send",
        bT: "Envoyer"
    }), jfn = F2(function(n, r) {
        return A2(Hk, k([
            Uk(Sfn(n))
        ]), k([
            A2(ye, k([
                Ow("S3CopyWrapper")
            ]), k([
                A2(mh, Afn, ah(r.mz)),
                A2(mh, yfn, ah(r.mA)),
                A2(mh, Nfn, A2(Ek, r.qo, lfn))
            ])),
            Qk(Lfn)
        ]));
    }), Ffn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Mfn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Ifn = xa({
        bN: "Ask new upload",
        bT: "Demander un nouvel upload"
    }), Dfn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Bfn = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return A2(ye, k([
                Cg(Dfn(r))
            ]), k([
                A2(Bnn, Vnn, t)
            ]));
        }
        return ag("");
    }), xfn = function(n) {
        switch(n.$){
            case 0:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusNone")
                ]), w);
            case 1:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusRunning")
                ]), w);
            case 2:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusSuccess")
                ]), w);
            default:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusFailure")
                ]), w);
        }
    }, qfn = F3(function(n, r, t) {
        return A2(ye, k([
            Ow("Operation")
        ]), k([
            xfn(n),
            A2(ye, k([
                Ow("OperationContent")
            ]), A2(mt, A2(Bfn, n, r), t))
        ]));
    }), Vfn = F2(function(n, r) {
        return A3(qfn, r.kg, 3, k([
            A2(mh, Mfn, kM(r.kh)),
            A2(urn, Ifn, Ffn(n.g9))
        ]));
    }), Ofn = function(n) {
        return {
            $: 30,
            a: n
        };
    }, zfn = F2(function(n, r) {
        return {
            $: 29,
            a: n,
            b: r
        };
    }), Efn = function(n) {
        return {
            $: 31,
            a: n
        };
    }, Hfn = {
        $: 26
    }, Rfn = F2(function(n, r) {
        return n.$ ? r : A2(mt, n.a, r);
    }), Wfn = A2(Je, Rfn, w), Ufn = function(n) {
        var r = F2(function(n, r) {
            return d(r.mo, n + " " + r.n6);
        }), t = Wfn(A2(Ye, A2(Pi, function(n) {
            return n.bQ;
        }, A2(Pi, function(n) {
            return n.f$;
        }, Lu(A2(Pi, function(n) {
            return n.lD;
        }, r("(active)"))))), A2(ju, w, A2(Lu, function(n) {
            return n.bj;
        }, n.g9)))), e = A2(ju, kt, A2(Lu, A2(Pi, function(n) {
            return n.R;
        }, A2(Pi, function(n) {
            return n.bQ;
        }, A2(Pi, function(n) {
            return n.f$;
        }, Lu(A2(Pi, function(n) {
            return n.lD;
        }, r("(active)")))))), n.g9));
        return $(w, A2(Rfn, e, t));
    }, Qfn = F2(function(n, r) {
        var t = n.b;
        if (t.$) return $(r, k([
            n.a
        ]));
        var e = t.a;
        return $(r, $(k([
            n.a
        ]), e));
    }), _fn = function(n) {
        return {
            $: 27,
            a: n
        };
    }, Zfn = function(n) {
        return A2(Lw, "colspan", Mt(n));
    }, Kfn = F2(function(n, r) {
        return A2(oC, k([
            fC(n),
            Ow("Button")
        ]), k([
            ag(r)
        ]));
    }), Xfn = function(n) {
        var r = "stream " + Mt(n.fv) + ": " + n.n6 + " -> [" + Mt(n.hs) + "ms, " + Mt(n.e$) + "ms]";
        return A2(Lh, w, k([
            A2(uk, w, k([
                ag(r)
            ]))
        ]));
    }, Jfn = function(n) {
        return A2(Lh, w, k([
            A2(uk, w, k([
                ag(n.fL + ": " + n.sw)
            ]))
        ]));
    }, Yfn = F2(function(n, r) {
        if (n) {
            var t = A2(Ye, Xfn, r.bl);
            return ht(k([
                A2(Lh, w, k([
                    A2(uk, k([
                        Zfn(4)
                    ]), k([
                        ag("Configurations")
                    ]))
                ])),
                A2(Lh, w, k([
                    A2(uk, k([
                        Zfn(4)
                    ]), k([
                        A2(kh, w, A2(Ye, Jfn, r.eC))
                    ]))
                ])),
                A2(Lh, w, k([
                    A2(uk, k([
                        Zfn(4)
                    ]), k([
                        ag("Results")
                    ]))
                ])),
                A2(Lh, w, k([
                    A2(uk, k([
                        Zfn(4)
                    ]), k([
                        Tu(t) ? a(r.j2, kt) ? ag("") : ag("nothing reported") : A2(kh, w, t)
                    ]))
                ])),
                A2(Lh, w, k([
                    A2(uk, k([
                        Zfn(4),
                        Ow("ProbeLog")
                    ]), k([
                        A2(Kfn, r.fV, "LOGS"),
                        A2(ju, ag("Currently running"), A2(Lu, function() {
                            return ag("Completed ");
                        }, r.j2)),
                        A2(ju, ag(""), A2(Lu, IP, r.j2))
                    ]))
                ]))
            ]));
        }
        return kt;
    }), Gfn = function(n) {
        var r = n.a, t = n.b;
        return d(A2(Lh, w, k([
            A2(uk, k([
                Cg(_fn(t.mo)),
                Ow("ProbeItem")
            ]), k([
                ag(r ? "\u25BC" : "\u25B6")
            ])),
            A2(uk, w, k([
                IP(t.ky)
            ])),
            A2(uk, w, k([
                ag(t.rR)
            ])),
            A2(uk, w, k([
                ag(t.lD)
            ]))
        ])), A2(Yfn, r, t));
    }, nsn = function(n) {
        return Tu(n.dh) ? ag("No probes on show...") : A2(kh, k([
            Ow("DeepProbeTable")
        ]), A2(mt, A2(Lh, w, k([
            A2(uk, w, k([
                ag("")
            ])),
            A2(uk, w, k([
                ag("Date")
            ])),
            A2(uk, w, k([
                ag("Template")
            ])),
            A2(uk, w, k([
                ag("File")
            ]))
        ])), A3(xt, Qfn, w, A2(Ye, Gfn, n.dh))));
    }, rsn = function(n) {
        var r = A2(Ye, function(n) {
            return d(n.mo, n.n6);
        }, n.ph);
        return A2(ye, k([
            Ow("Operation")
        ]), k([
            xfn(n.pg),
            A2(ye, k([
                Ow("OperationContent")
            ]), k([
                A2(mh, Ofn, A2(zk, n.kD, r)),
                A2(mh, Efn, A2(zk, n.qG, Ufn(n))),
                xe(n.qG.sw) > 0 && xe(n.kD.sw) > 0 ? A2(urn, "Launch Deep Probe", A2(zfn, n.qG.sw, n.kD.sw)) : ag(""),
                A3(Jk, n.ma ? "Show Probes" : "Hide Probes", k([
                    d("align-self", "flex-end"),
                    d("position", "relative"),
                    d("top", "10px"),
                    d("margin", "0 0 10px 0")
                ]), Hfn),
                n.ma ? ag("") : nsn(n)
            ]))
        ]));
    }, tsn = xa({
        bN: "Show acceptation required",
        bT: "L'acceptation du show est n\xe9cessaire"
    }), esn = xa({
        bN: "Public organization required",
        bT: "L'organization public est n\xe9cessaire"
    }), usn = F3(function(n, r, t) {
        var e = n.pp;
        return 1 === e.$ ? A3(qfn, Rs, 5, k([
            ag(esn)
        ])) : e.a.oa ? r.g9.ik ? t : A3(qfn, Rs, 5, k([
            ag(tsn)
        ])) : t;
    }), osn = xa({
        bN: "Video archived",
        bT: "Fichier vid\xe9o archiv\xe9"
    }), asn = xa({
        bN: "Vid\xe9o file required",
        bT: "Fichier vid\xe9o requis"
    }), isn = F2(function(n, r) {
        var t = n.bQ.f$;
        if (1 === t.$) return A3(qfn, Rs, 5, k([
            ag(asn)
        ]));
        var e = t.a;
        return GK(e.lD) ? A3(qfn, Rs, 5, k([
            ag(osn)
        ])) : r(e.lD);
    }), csn = xa({
        bN: "Proxy required",
        bT: "Proxy requis"
    }), fsn = F2(function(n, r) {
        var t = d(n.bQ.f$, A2(sp, A2(Pi, function(n) {
            return n.pm;
        }, function(n) {
            return n.nw;
        }), n.bQ.f$));
        if (1 === t.a.$) return A3(qfn, Rs, 5, k([
            ag(asn)
        ]));
        if (1 === t.b.$) return A3(qfn, Rs, 5, k([
            ag(csn)
        ]));
        var e = t.b.a;
        return GK(t.a.a.lD) ? A3(qfn, Rs, 5, k([
            ag(osn)
        ])) : r(e);
    }), ssn = F2(function(n, r) {
        if (1 === r.$) return ag("");
        var t = r.a;
        return A2(ye, k([
            Ow("Operation")
        ]), k([
            xfn(Rs),
            A2(ye, k([
                Ow("OperationContent")
            ]), k([
                A2(Kfn, t, n)
            ]))
        ]));
    }), lsn = F4(function(n, r, t, e) {
        return A3(qfn, r, t, k([
            A2(urn, n, e)
        ]));
    }), dsn = F2(function(n, r) {
        return A2(ye, k([
            Ow("Operation")
        ]), k([
            xfn(Rs),
            A2(ye, k([
                Ow("OperationContent"),
                Ow("PlayerSettings")
            ]), k([
                A2(ye, w, k([
                    ag(A2(ju, "", n.kq))
                ])),
                A2(oC, k([
                    fC("/neoplayer/" + r),
                    Ow("Button"),
                    WL("_blank"),
                    A2(qI, "data-prevent-history", "true")
                ]), k([
                    ag("Neo Player")
                ]))
            ]))
        ]));
    }), msn = F3(function(n, r, t) {
        var e;
        return ien(n.st) ? A2(ye, k([
            Ow("Operations")
        ]), k([
            A2(qg, k([
                Ow("OperationsHeader")
            ]), afn),
            A2(xcn, nq(efn), k([
                A2(mh, u9, A2(jfn, r.bD, t.pY))
            ])),
            A2(xcn, nq(qcn), k([
                A2(mh, Y7, A2(Pfn, r.bD, t.l$))
            ])),
            A2(xcn, nq(Fcn), k([
                A2(mh, R7, A2(pfn, r.bD, t.iA))
            ])),
            A3(usn, t, n, A4(lsn, Dcn, t.kH, 9, kcn(r.bD))),
            A2(isn, r, function(n) {
                return A4(lsn, rfn, t.pL, 0, function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(n));
            }),
            A2(isn, r, function(n) {
                return A4(lsn, nfn, t.pJ, 1, function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(n));
            }),
            (e = Tu(n.cz) ? ag("") : A2(mh, Pcn, A2(Ek, t.bE, A2(Ye, function(n) {
                return d(n.sw, n.sw);
            }, n.cz))), A3(qfn, t.pK, 2, k([
                e,
                A2(urn, Gcn, Ncn(r.bD))
            ]))),
            A2(Vfn, n, t),
            A2(fsn, r, function(n) {
                return A2(ssn, "proxy log", A2(sp, function(n) {
                    return n.fV;
                }, n.r6));
            }),
            A2(isn, r, function(n) {
                return A2(ssn, "transcode log", A2(sp, function(n) {
                    return n.fV;
                }, n.r6));
            }),
            A2(ssn, "upload log", r.bD.h8),
            A2(isn, r, function() {
                var n, e = k([
                    d(ab(Zm), Ecn),
                    d(ab(eb), Xcn),
                    d(ab(nb), _cn),
                    d(ab(Ym), Ucn),
                    d(ab(ub), Jcn),
                    d(ab(Km), Hcn),
                    d(ab(rb), Zcn),
                    d(ab(tb), Kcn),
                    d(ab(Gm), Qcn),
                    d(ab(Jm), Wcn),
                    d(ab(Xm), Rcn),
                    d(ab(_m), zcn),
                    d(ab(Qm), Icn)
                ]), u = (n = r.bD.fi).$ ? Ycn : ab(n.a);
                return A3(qfn, t.si, 4, k([
                    A2(mh, Acn, A2(zk, t.i5, e)),
                    A2(urn, "update audio mapping", A2(jcn, r.bD, t.i5)),
                    A2(ye, w, k([
                        ag($(ufn, u))
                    ]))
                ]));
            }),
            A2(isn, r, function(n) {
                return A4(lsn, Bcn, t.kG, 6, function(n) {
                    return {
                        $: 19,
                        a: n
                    };
                }(n));
            }),
            Vcn(n.g9) ? A3(qfn, Rs, 5, k([
                ag(tfn)
            ])) : GK(n.g9) ? A4(lsn, ifn, t.d2, 7, Lcn(n.g9)) : A4(lsn, Mcn, t.d2, 7, hcn(n.g9)),
            A2(fsn, r, function() {
                return A2(dsn, t, n.g9.mo);
            }),
            A2(isn, r, function() {
                return t.mb ? A2(ye, k([
                    Ow("Operation")
                ]), k([
                    xfn(Rs),
                    A2(ye, k([
                        Ow("OperationContent"),
                        Ow("PlayerSettings")
                    ]), k([
                        A2(ye, w, k([
                            ag("Segmentation")
                        ])),
                        A2(urn, ofn, Tcn(n.oM.mo))
                    ]))
                ])) : A3(qfn, t.iN, 8, k([
                    A2(mh, Scn, A2(zk, t.qk, A2(Ye, function(n) {
                        return d(n.mo, n.n6);
                    }, t.$7))),
                    A2(urn, Ocn, A2(ycn, r.bD.mo, t.qk.sw))
                ]));
            }),
            t.l9 ? A2(ye, k([
                Ow("Operation")
            ]), k([
                xfn(Rs),
                A2(ye, k([
                    Ow("OperationContent"),
                    Ow("PlayerSettings")
                ]), k([
                    A2(ye, w, k([
                        ag("Deep Probe")
                    ])),
                    A2(urn, "Show", Ccn)
                ]))
            ])) : rsn(t)
        ])) : ag("");
    }), bsn = {
        $: 1
    }, psn = function(n) {
        return dl(Wx(A2(Oz, n, 1)));
    }, vsn = function(n) {
        return s(n, 1073741824) > -1 ? Mt(re(n / 1073741824)) + " GB" : s(n, 1048576) > -1 ? Mt(re(n / 1048576)) + " MB" : 1024 > n ? n > 1 ? Mt(n) + " bytes" : 1 === n ? Mt(n) + " byte" : "0 bytes" : Mt(re(n / 1024)) + " KB";
    }, $sn = xa({
        bN: "SFTP access",
        bT: "Acc\xe8s SFTP"
    }), wsn = function(n) {
        switch(n.$){
            case 0:
                switch(n.a){
                    case 0:
                        return "MXF (Material eXchange Format)";
                    case 1:
                        return "QuickTime File Format";
                    default:
                        return "Fichier vid\xe9o MP4";
                }
            case 1:
                return "Fichier de sous-titres";
            default:
                return "Fichier audio MP3";
        }
    }, gsn = {
        $: 1
    }, hsn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ksn = k([
        {
            D: ".mxf",
            E: hsn(0),
            nT: "application/mxf"
        },
        {
            D: ".mov",
            E: hsn(1),
            nT: "video/quicktime"
        },
        {
            D: ".mp4",
            E: hsn(2),
            nT: "video/mp4"
        },
        {
            D: ".mp3",
            E: {
                $: 2,
                a: 0
            },
            nT: "audio/mp3"
        },
        {
            D: ".srt",
            E: gsn,
            nT: "application/x-subrip"
        },
        {
            D: ".ass",
            E: gsn,
            nT: "application/x-ass"
        },
        {
            D: ".stl",
            E: gsn,
            nT: "text/subtitle"
        },
        {
            D: ".vtt",
            E: gsn,
            nT: "text/vtt"
        },
        {
            D: ".scc",
            E: gsn,
            nT: "text/scc"
        }
    ]), Csn = F2(function(n, r) {
        return A2(NZ, n, Ua(r.n6));
    }), Tsn = F2(function(n, r) {
        return A2(ju, !1, A2(Lu, function(r) {
            return a(r, n);
        }, r.nT));
    }), Psn = function(n) {
        return A2(Lu, function(n) {
            return n.E;
        }, Eo(A2(Mu, function(r) {
            return A2(Tsn, r.nT, n) || A2(Csn, r.D, n);
        }, ksn)));
    }, Ssn = F2(function(n, r) {
        if (function(n) {
            return A2(mu, function(r) {
                var t = r.fB;
                return a(r.st.mo, n.st.mo) && t.cJ;
            }, n.fD);
        }(n) && !a(n.R.bQ.f$, kt)) {
            var t = function(n) {
                var r = n.f$;
                return 1 === r.$ ? w : $(k([
                    r.a
                ]), $(n.d7, n.ad));
            }(n.R.bQ), e = "" === r.fB ? A2(ju, bsn, A2(Lu, function(n) {
                return CJ(n);
            }, function(n) {
                return A2(Lu, function(n) {
                    return n.mo;
                }, function(n) {
                    return Eo(A2(Kc, function(r) {
                        var t = r.fB;
                        return a(r.st.mo, n.st.mo) ? ht(t) : kt;
                    }, n.fD));
                }(n));
            }(n))) : bsn;
            return A2(ye, w, k([
                Jx(k([
                    nq($un),
                    Jen(k([
                        DI(p(dI, {
                            mn: ht(r.gk ? tj : wen),
                            mK: r.gk,
                            m7: $sn,
                            oy: ht(e)
                        }))
                    ]))
                ])),
                A2(DL, r.gk, A2(ye, k([
                    Ow("InvitationsForm")
                ]), jun(r))),
                (u = A2(Ye, function(n) {
                    var r;
                    return {
                        eR: A2(It, " - ", k([
                            (r = Psn(n.lD), 1 === r.$ ? "" : wsn(r.a) + " - "),
                            vsn(n.lD.qP)
                        ])),
                        mn: Ven,
                        rW: n.lD.n6,
                        sr: Si(psn(n.lD.mo))
                    };
                }, t), A2(ye, k([
                    Ow("DownloadsLinks")
                ]), A2(Ye, function(n) {
                    var r;
                    return A2(oC, k([
                        fC(n.sr),
                        Ow("DownloadsLinksItem"),
                        (r = n.rW, A2(Vw, "download", r)),
                        A2(qI, "data-prevent-history", "true"),
                        II(n.rW)
                    ]), k([
                        A2(dg, k([
                            Ow("DownloadsLinksItemIcon")
                        ]), k([
                            n.mn
                        ])),
                        A2(dg, k([
                            Ow("DownloadsLinksItemWrapper")
                        ]), k([
                            A2(dg, k([
                                Ow("DownloadsLinksItemName")
                            ]), k([
                                ag(n.rW)
                            ])),
                            A2(dg, k([
                                Ow("DownloadsLinksItemDetails")
                            ]), k([
                                ag(n.eR)
                            ]))
                        ]))
                    ]));
                }, u)))
            ]));
        }
        var u;
        return ag("");
    }), Asn = F2(function(n, r) {
        var t, e, u = !Fon(n), o = A2(jon, Mon(n), r);
        return k([
            A2(mh, g1, A3(Qin, r.kJ, o, n)),
            A2(mh, m1, A3(Nan, n, o, r.ij)),
            A2(DL, u, A2(mh, h1, A2(Ssn, n, r.cJ))),
            A2(mh, y1, A2(mcn, n, r.fD)),
            A2(mh, Lon, (t = n, e = A2(Mu, function(n) {
                return 1 === n.j2.$;
            }, t.cZ), Tu(e) ? ag("") : A2(ye, k([
                Ow("JobsWrapper")
            ]), A2(mt, gcn, A2(Ye, $cn, e))))),
            A2(mh, p1, A2(vun, r.d2, {
                mo: n.g9.mo,
                mL: n.st.iz,
                mV: !0,
                hv: n.g9.hv,
                h5: n.g9.h5
            })),
            A2(mh, v1, A3(Oan, n, o, r.ja)),
            A2(mh, u_, A3(msn, n, o, r.oJ))
        ]);
    }), ysn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nsn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lsn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, jsn = F4(function(n, r, t, e) {
        return {
            S: k([
                {
                    cU: 3,
                    sy: A2(J0, {
                        eT: e,
                        lW: t,
                        sw: n.bb
                    }, {
                        eT: e,
                        lW: t,
                        sw: n.bc
                    })
                }
            ]),
            d1: w,
            bD: r,
            ki: n.ki,
            bK: n.bK,
            bU: kt,
            mo: Lsn(n.mo),
            nP: h0(n.m7),
            cl: n.ki,
            cm: n.bK.mo
        };
    }), Fsn = function(n) {
        return A2(Lu, u0, Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, Y1, n.av))));
    }, Msn = F3(function(n, r, t) {
        var e = A2(sp, Fsn, r.bQ.f$), u = A2(Yu, function(n) {
            return 1 === e.$ ? w : k([
                A4(jsn, n, r.bD.mo, e.a, !1)
            ]);
        }, A2(ju, w, A2(Lu, function(n) {
            return n.g3;
        }, r.bQ.f$))), o = A2(Ye, function(n) {
            return {
                d5: oG(n),
                mY: Nsn(n)
            };
        }, t), a = A2(Ye, function(n) {
            return {
                d5: n.ki,
                mY: ysn(n)
            };
        }, $(r.bJ, u));
        return A2(hT, F2(function(n, r) {
            return A2(O7, n.d5, r.d5) ? 0 : 2;
        }), A2(yu, a, o));
    }), Isn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Dsn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Bsn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xsn = xa({
        bN: "Add timecode",
        bT: "Ajouter un timecode"
    }), qsn = A2(dg, k([
        Ow("TimecodeSep")
    ]), k([
        ag(":")
    ])), Vsn = A2(Pi, Mt, A2(Kd, 2, "0")), Osn = function(n) {
        switch(n){
            case 0:
                return "TimecodeHH";
            case 1:
                return "TimecodeMM";
            case 2:
                return "TimecodeSS";
            default:
                return "TimecodeFF";
        }
    }, zsn = F2(function(n, r) {
        var t = function() {
            switch(n){
                case 0:
                    return A2(Pi, qf, Vsn)(r.mk);
                case 1:
                    return A2(Pi, qf, Vsn)(r.n$);
                case 2:
                    return A2(Pi, qf, Vsn)(r.qg);
                default:
                    return Vsn(r.fh);
            }
        }();
        return A2(ye, k([
            Ow("TimecodeUnit"),
            Ow(Osn(n))
        ]), k([
            ag(t)
        ]));
    }), Esn = function(n) {
        return A2(ye, k([
            Ow("TimecodeWrapper")
        ]), k([
            A2(zsn, 0, n),
            qsn,
            A2(zsn, 1, n),
            qsn,
            A2(zsn, 2, n),
            qsn,
            A2(zsn, 3, n)
        ]));
    }, Hsn = F2(function(n, r) {
        var t;
        return A2(Hk, k([
            Uk(Dsn(n.bD)),
            Ow("ActivityCommentForm"),
            Ow("DarkZone")
        ]), k([
            A2(ye, k([
                Ow("ActivityCommentFormMessage")
            ]), k([
                A2(mh, Bsn, kM(r.nP))
            ])),
            A2(ye, k([
                Ow("ActivityCommentFormSubmit")
            ]), k([
                A2(ye, k([
                    Ow("ActivityCommentTimecode")
                ]), k([
                    A2(mh, Isn, yk(r.hY)),
                    (t = r.kt, t.$ ? A2(qg, k([
                        Ow("ActivityCommentTimecodeLabel")
                    ]), xsn) : Esn(A2(B1, r.q5, t.a)))
                ])),
                Qk(cs)
            ]))
        ]));
    }), Rsn = function(n) {
        return {
            $: 35,
            a: n
        };
    }, Wsn = {
        $: 3
    }, Usn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Qsn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _sn = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), Zsn = Lw("list"), Ksn = function(n) {
        return A2(Og, n, A2(Eg, k([
            Ow("InputTextarea"),
            Xg(n.kX),
            eh(Lg),
            Gg(jg),
            nh(Fg),
            oh(n.sw),
            uh(n.gw),
            Zsn(A2(ju, "", n.jd)),
            Mg(!1),
            Tg("search"),
            Hg(Zg(n.m7)),
            zg(n.kS),
            n.d8 ? Dg(!0) : Bg(w)
        ]), w));
    }, Xsn = xa({
        bN: "...End timecode",
        bT: "...Timecode de fin"
    }), Jsn = xa({
        bN: "Examples...",
        bT: "Examples..."
    }), Ysn = function(n) {
        switch(n){
            case 1:
                return "OrangeFlag";
            case 0:
                return "RedFlag";
            default:
                return "BlueFlag";
        }
    }, Gsn = F2(function(n, r) {
        return A4(b3, n.lW, n.sw, r.q5, n.eT);
    }), nln = A2(Zw, k([
        Hw("16px"),
        Xw("16px"),
        Kw("0 0 16 16"),
        Fw("IconDelete")
    ]), k([
        A2(iC, k([
            Fw("Fg"),
            aC("M12 3H4V13H12V11H8V5H12V3Z")
        ]), w)
    ])), rln = A2(Zw, k([
        Hw("16px"),
        Xw("16px"),
        Kw("0 0 16 16"),
        Fw("IconDelete")
    ]), k([
        A2(iC, k([
            Fw("Fg"),
            aC("M4 3H12V13H4V11H8V5H4V3Z")
        ]), w)
    ])), tln = Ae("optgroup"), eln = xa({
        bN: "Publish",
        bT: "Publier"
    }), uln = xa({
        bN: "Verification Report",
        bT: "Rapport de v\xe9rification"
    }), oln = xa({
        bN: "Verification: reason",
        bT: "V\xe9rification: motif"
    }), aln = A2(Zw, k([
        Hw("16px"),
        Xw("16px"),
        Kw("0 0 16 16"),
        Fw("IconDelete")
    ]), k([
        A2(iC, k([
            Fw("Fg"),
            aC("M11.3982 3.21591L13.6357 3.8496L10.4672 15.037L8.22975 14.4033L11.3982 3.21591Z")
        ]), w),
        A2(iC, k([
            Fw("Fg"),
            aC("M8.37838 9.61152L10.2794 2.89907L2.61646 4.35424L8.37838 9.61152Z")
        ]), w)
    ])), iln = F2(function(n, r) {
        var t = function(t) {
            return A2(ye, k([
                Ow(Ysn(t)),
                Ow("ActivityVerificationFlag"),
                Bg(k([
                    d("ActivityVerificationFlagSelected", a(t, r))
                ])),
                Cg(n(t))
            ]), k([
                aln
            ]));
        };
        return A2(ye, k([
            Ow("ActivityVerificationFlagSelect")
        ]), k([
            t(3),
            t(1),
            t(0)
        ]));
    }), cln = F2(function(n, r) {
        var t = n.bQ.f$;
        return 1 === t.$ ? ag("") : A2(Hk, k([
            Uk(A2(_sn, n.bD, t.a.lD)),
            Ow("ActivityCommentForm"),
            Ow("DarkZone"),
            Ow(Ysn(r.iQ.cU))
        ]), k([
            A2(dg, k([
                Ow("ActivityTitle")
            ]), k([
                ag(uln)
            ])),
            A2(ye, k([
                Ow("ActivityCommentVerifHeader")
            ]), k([
                3 === r.iQ.cU ? A2(mh, Rsn, ZL(r.qj)) : A2(mh, Bsn, Ksn(p(r.nP, {
                    jd: ht("VerificationMotifs"),
                    gw: oln
                }))),
                A2(iln, Usn, r.iQ.cU)
            ])),
            A3(Ae, "datalist", k([
                Kg("VerificationMotifs")
            ]), k([
                A2(tln, k([
                    A2(qI, "label", Jsn)
                ]), A2(Ye, function(n) {
                    return A2(xk, w, k([
                        ag(n)
                    ]));
                }, A2(Ye, Zi, ws)))
            ])),
            A2(ye, k([
                Ow("ActivityCommentVerif")
            ]), k([
                function() {
                    var n = r.iQ.sy;
                    switch(n.$){
                        case 0:
                            return A2(ye, k([
                                Ow("ActivityCommentVerifTc")
                            ]), k([
                                A2(gM, nln, Qsn(0)),
                                A2(qg, k([
                                    Ow("ActivityCommentVerifLabel")
                                ]), xsn)
                            ]));
                        case 1:
                            var t = n.a;
                            return A2(ye, k([
                                Ow("ActivityCommentVerifTc")
                            ]), k([
                                A2(gM, nln, Qsn(0)),
                                Esn(A2(Gsn, t, r)),
                                A2(gM, rln, Qsn(1)),
                                A2(qg, k([
                                    Ow("ActivityCommentVerifLabel")
                                ]), Xsn),
                                A2(gM, kg, Wsn)
                            ]));
                        default:
                            t = n.a;
                            var e = n.b;
                            return A2(ye, k([
                                Ow("ActivityCommentVerifTc")
                            ]), k([
                                A2(gM, nln, Qsn(0)),
                                Esn(A2(Gsn, t, r)),
                                A2(gM, rln, Qsn(1)),
                                Esn(A2(Gsn, e, r)),
                                A2(gM, kg, Wsn)
                            ]));
                    }
                }()
            ])),
            A2(ye, k([
                Ow("ActivityCommentFormSubmit")
            ]), k([
                Qk(eln)
            ]))
        ]));
    }), fln = function(n) {
        return !a(n.S, w);
    }, sln = function(n) {
        var r = n.mY;
        if (r.$) return 0;
        var t = r.a;
        return fln(t) ? A2(ju, 0, A2(Lu, function(n) {
            var r = n.sy;
            switch(r.$){
                case 1:
                case 2:
                    return r.a.sw;
                default:
                    return 0;
            }
        }, Eo(t.S))) : 0;
    }, lln = F2(function(n, r) {
        return 4 === n.iZ ? A2(Ra, sln, A2(Mu, function(n) {
            var r = n.mY;
            return !r.$ && fln(r.a);
        }, r)) : r;
    }), dln = function(n) {
        switch(n){
            case 0:
                return "Neutral";
            case 1:
                return "Good";
            case 2:
                return "Bad";
            default:
                return "Warn";
        }
    }, mln = F3(function(n, r, t) {
        var e = function() {
            switch(t.$){
                case 2:
                    return A2(Y$, t.a.dJ, k([
                        4,
                        5,
                        6
                    ]));
                case 14:
                    return A2(Y$, t.a.cp, k([
                        1
                    ]));
                default:
                    return !1;
            }
        }(), u = oG(t), o = A2(O7, r, u), a = function() {
            switch(t.$){
                case 4:
                    switch((r = t.a).c$){
                        case 0:
                            return d(0, A2(Vun, n, r.dt));
                        case 1:
                            return d(1, A2(Vun, n, r.dt));
                        default:
                            return d(2, A2(Vun, n, r.dt));
                    }
                case 3:
                    return d(0, A2(Vun, n, (r = t.a).dt));
                case 0:
                    var r = t.a;
                    return d(function() {
                        if (1 === r.lo.$) {
                            var n = r.bl;
                            if (n.$) return 0;
                            var t = n.a;
                            return t.n8 > 0 ? 2 : t.aq > 0 ? 3 : 1;
                        }
                        return 2;
                    }(), Oun);
                case 2:
                    return d(1 === (r = t.a).c$ ? 1 === r.lo.$ ? r.c7 ? 3 : 1 : 2 : 0, Oun);
                case 5:
                    return d((r = t.a).c$ ? 1 === r.lo.$ ? 1 : 2 : 0, Oun);
                case 14:
                    return d(1 === (r = t.a).c$ ? 1 === r.lo.$ ? 1 : 2 : 0, Oun);
                default:
                    return d(0, Oun);
            }
        }(), i = a.a, c = a.b;
        return e ? ag("") : A2(ye, k([
            Ow("EventsItem"),
            Ow(dln(i)),
            Bg(k([
                d("EventsItemArchived", o)
            ]))
        ]), k([
            A2(ye, k([
                Ow("EventsItemIcon")
            ]), k([
                c
            ])),
            A2(ye, k([
                Ow("EventsItemBody")
            ]), k([
                A2(qg, k([
                    Ow("EventsItemLabel")
                ]), eG(t)),
                ag(Qd(sg(160))),
                A2(dg, k([
                    Ow("EventsItemDate")
                ]), k([
                    IP(u)
                ]))
            ]))
        ]));
    }), bln = function(n) {
        return {
            $: 17,
            a: n
        };
    }, pln = function(n) {
        return {
            $: 21,
            a: n
        };
    }, vln = function(n) {
        return {
            $: 32,
            a: n
        };
    }, $ln = function(n) {
        return {
            $: 16,
            a: n
        };
    }, wln = function(n) {
        return A2(ye, k([
            Ow("TimecodeDarker")
        ]), k([
            Esn(n)
        ]));
    }, gln = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M5,11 L7,13 L6,14 L4,14 L4,12 L5,11 Z M12,4 L14,6 L8,12 L6,10 L12,4 Z")
        ]), w)
    ])), hln = F2(function(n, r) {
        return A2(ye, k([
            Ow("ButtonMiniIcon"),
            Cg(r)
        ]), k([
            n
        ]));
    }), kln = xa({
        bN: ", modified",
        bT: ", modifi\xe9"
    }), Cln = ag(Qd(sg(160))), Tln = F2(function(n, r) {
        return A2(dg, k([
            Ow(n)
        ]), k([
            IP(r)
        ]));
    }), Pln = function(n) {
        return A2(hT, F2(function(n, r) {
            return A2(O7, n.ki, r.ki) ? 2 : 0;
        }), n);
    }, Sln = function(n) {
        return {
            $: 27,
            a: n
        };
    }, Aln = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), yln = xa({
        bN: "Save",
        bT: "Sauvegarder"
    }), Nln = F3(function(n, r, t) {
        return A2(Hk, k([
            Uk(n),
            Ow("ActivityCommentEditForm")
        ]), k([
            A2(mh, Aln(r), ah(t)),
            A2(ye, k([
                Ow("ActivityCommentHideSubmit")
            ]), k([
                Qk(yln)
            ]))
        ]));
    }), Lln = F3(function(n, r, t) {
        return A2(ye, k([
            Ow("ActivityAnswer")
        ]), k([
            A2(Vun, n.st, t.bK),
            A2(ye, k([
                Ow("ActivityCommentContent")
            ]), k([
                A2(ye, k([
                    Ow("ActivityCommentHeader")
                ]), k([
                    A2(qg, k([
                        Ow("ActivityCommentAuthor")
                    ]), "" === t.bK.n6 ? t.bK.la : t.bK.n6),
                    Cln,
                    A2(Tln, "ActivityCommentDate", t.ki),
                    Cln,
                    a(t.ki, t.cl) ? ag("") : ag(kln),
                    A2(ye, k([
                        Ow("ActivityCommentActions")
                    ]), k([
                        a(t.bK.mo, n.st.mo) ? A2(MD, t.mo, r.k7) ? A2(hln, tj, bln(t.mo)) : A2(hln, gln, $ln({
                            mo: t.mo,
                            nP: t.nP
                        })) : ag("")
                    ])),
                    A2(ye, k([
                        Ow("ActivityCommentDelete")
                    ]), k([
                        a(t.bK.mo, n.st.mo) ? A2(hln, tj, Sln(t)) : ag("")
                    ]))
                ])),
                function() {
                    var n = A2(di, t.mo, r.k7);
                    if (1 === n.$) return A2(qg, k([
                        Ow("ActivityAnswerMessage")
                    ]), t.nP);
                    var e = n.a;
                    return A3(Nln, function(n) {
                        return {
                            $: 25,
                            a: n
                        };
                    }(t), t.mo, e);
                }()
            ]))
        ]));
    }), jln = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Fln = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), Mln = F4(function(n, r, t, e) {
        return A2(Hk, k([
            Uk(jln(e)),
            Ow("ActivityAnswerForm")
        ]), k([
            A2(Vun, n.st, n.st),
            A2(mh, Fln(p6(e.mo)), ah(A2(ju, c4, A2(di, p6(e.mo), t.d1)))),
            A2(ye, k([
                Ow("ActivityCommentHideSubmit")
            ]), k([
                Qk(i4)
            ]))
        ]));
    }), Iln = F4(function(n, r, t, e) {
        return A2(ye, k([
            Ow("ActivityItem"),
            Ow("ActivityComment")
        ]), k([
            A2(Vun, n.st, e.bK),
            A2(ye, k([
                Ow("ActivityCommentContent")
            ]), k([
                A2(ye, k([
                    Ow("ActivityCommentHeader")
                ]), k([
                    A2(qg, k([
                        Ow("ActivityCommentAuthor")
                    ]), "" === e.bK.n6 ? e.bK.la : e.bK.n6),
                    Cln,
                    A2(Tln, "ActivityCommentDate", e.ki),
                    Cln,
                    a(e.ki, e.cl) ? ag("") : ag(kln),
                    A2(qg, k([
                        Ow("ActivityCommentSpacer")
                    ]), ""),
                    A2(ye, k([
                        Ow("ActivityCommentActions")
                    ]), k([
                        a(e.bK.mo, n.st.mo) ? A2(MD, p6(e.mo), t.k7) ? A2(hln, tj, bln(p6(e.mo))) : A2(hln, gln, $ln({
                            mo: p6(e.mo),
                            nP: e.nP
                        })) : ag("")
                    ])),
                    A2(ye, k([
                        Ow("ActivityCommentDelete")
                    ]), k([
                        a(e.bK.mo, n.st.mo) ? A2(hln, tj, pln(e)) : ag("")
                    ]))
                ])),
                function() {
                    var n = A2(di, p6(e.mo), t.k7);
                    if (1 === n.$) return A2(ye, k([
                        Ow("ActivityCommentWrap")
                    ]), k([
                        A2(qg, k([
                            Ow("ActivityCommentMessage")
                        ]), e.nP),
                        A2(Ck, function(n) {
                            var r = n.sw, e = n.lW, u = n.eT;
                            return A2(ye, k([
                                Ow("ActivityCommentTimecode")
                            ]), k([
                                A2(gM, Eun, vln(r)),
                                wln(A4(b3, e, r, t.q5, u))
                            ]));
                        }, e.bU)
                    ]));
                    var r = n.a;
                    return A3(Nln, function(n) {
                        return {
                            $: 18,
                            a: n
                        };
                    }(e), p6(e.mo), r);
                }(),
                A2(ye, k([
                    Ow("ActivityAnswers")
                ]), A2(Ye, A2(Lln, n, t), Pln(e.d1))),
                A4(Mln, n, r, t, e)
            ]))
        ]));
    }), Dln = function(n) {
        switch(n){
            case "openingCredits":
                return ps;
            case "endingCredits":
                return ds;
            case "introduction":
                return ms;
            case "program":
                return vs;
            case "trailer":
                return $s;
            case "advertising":
                return ls;
            case "testPattern":
                return I5;
            case "black":
                return L5;
            case "slate":
                return M5;
            case "neutralBases":
                return bs;
            default:
                return n;
        }
    }, Bln = function(n) {
        return {
            $: 9,
            a: n
        };
    }, xln = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), qln = F3(function(n, r, t) {
        return {
            $: 11,
            a: n,
            b: r,
            c: t
        };
    }), Vln = F3(function(n, r, t) {
        return {
            $: 10,
            a: n,
            b: r,
            c: t
        };
    }), Oln = xa({
        bN: "Edit",
        bT: "Editer"
    }), zln = F2(function(n, r) {
        var t = d(A2(di, p6(r.mo), n.k4), Eo(r.S));
        return t.a.$ ? t.b.$ ? {
            cU: 3,
            sy: as
        } : t.b.a : t.a.a;
    }), Eln = F2(function(n, r) {
        var t = d(n, r);
        return t.a.$ ? t.b.$ ? as : t.b.a.sy : t.a.a.sy;
    }), Hln = F2(function(n, r) {
        var t = function(t) {
            return A2(ye, k([
                Ow(Ysn(t)),
                Ow("ActivityVerificationFlag"),
                Bg(k([
                    d("ActivityVerificationFlagSelected", a(t, r))
                ])),
                Cg(n(t))
            ]), k([
                aln
            ]));
        };
        return A2(ye, k([
            Ow("ActivityVerificationFlagSelect")
        ]), k([
            t(1),
            t(0)
        ]));
    }), Rln = F4(function(n, r, t, e) {
        var u = A2(zln, n, t);
        return A2(Hk, k([
            Uk(Bln(t)),
            Ow(Ysn(u.cU))
        ]), k([
            3 === u.cU ? A2(ye, k([
                Ow("ActivityVerificationMessage"),
                Ow(Ysn(u.cU))
            ]), k([
                ag(Dln(t.nP))
            ])) : A2(ye, k([
                Ow("ActivityCommentVerifHeader")
            ]), k([
                A2(mh, Aln(p6(t.mo)), Ksn(p(e, {
                    jd: ht("VerificationMotifs"),
                    kX: "editverif" + p6(t.mo),
                    gw: oln
                }))),
                A2(Hln, A2(qln, u, p6(t.mo)), u.cU)
            ])),
            A2(ye, k([
                Ow("ActivityCommentVerif")
            ]), k([
                function() {
                    var r = A2(Eln, A2(di, p6(t.mo), n.k4), Eo(t.S));
                    switch(r.$){
                        case 0:
                            return A2(ye, k([
                                Ow("ActivityCommentVerifTc")
                            ]), k([
                                A2(gM, nln, A3(Vln, u, p6(t.mo), 0)),
                                A2(qg, k([
                                    Ow("ActivityCommentVerifLabel")
                                ]), xsn)
                            ]));
                        case 1:
                            var e = r.a;
                            return A2(ye, k([
                                Ow("ActivityCommentVerifTc")
                            ]), k([
                                A2(gM, nln, A3(Vln, u, p6(t.mo), 0)),
                                Esn(A2(Gsn, e, n)),
                                A2(gM, rln, A3(Vln, u, p6(t.mo), 1)),
                                A2(qg, k([
                                    Ow("ActivityCommentVerifLabel")
                                ]), Xsn),
                                A2(gM, kg, A2(xln, u, p6(t.mo)))
                            ]));
                        default:
                            e = r.a;
                            var o = r.b;
                            return A2(ye, k([
                                Ow("ActivityCommentVerifTc")
                            ]), k([
                                A2(gM, nln, A3(Vln, u, p6(t.mo), 0)),
                                Esn(A2(Gsn, e, n)),
                                A2(gM, rln, A3(Vln, u, p6(t.mo), 1)),
                                Esn(A2(Gsn, o, n)),
                                A2(gM, kg, A2(xln, u, p6(t.mo)))
                            ]));
                    }
                }()
            ])),
            A2(ye, k([
                Ow("ActivityCommentFormSubmit")
            ]), k([
                Qk(Oln)
            ]))
        ]));
    }), Wln = F4(function(n, r, t, e) {
        return A2(Ck, function(u) {
            return A2(ye, k([
                Ow("ActivityItem"),
                Ow("ActivityComment"),
                Ow(Ysn(u.cU))
            ]), k([
                A2(Vun, n.st, e.bK),
                A2(ye, k([
                    Ow("ActivityCommentContent")
                ]), $(k([
                    A2(ye, k([
                        Ow("ActivityCommentHeader")
                    ]), k([
                        A2(qg, k([
                            Ow("ActivityCommentAuthor")
                        ]), "" === e.bK.n6 ? e.bK.la : e.bK.n6),
                        Cln,
                        A2(Tln, "ActivityCommentDate", e.ki),
                        a(e.ki, e.cl) ? ag("") : ag(kln),
                        A2(qg, k([
                            Ow("ActivityCommentSpacer")
                        ]), ""),
                        A2(ye, k([
                            Ow("ActivityCommentActions")
                        ]), k([
                            !a(e.bK.mo, n.st.mo) && n.st.iz ? ag("") : A2(MD, p6(e.mo), t.k7) ? A2(hln, tj, bln(p6(e.mo))) : A2(hln, gln, $ln({
                                mo: p6(e.mo),
                                nP: e.nP
                            })),
                            A2(ye, k([
                                Ow("ActivityCommentDelete")
                            ]), k([
                                a(e.bK.mo, n.st.mo) ? A2(hln, tj, pln(e)) : ag("")
                            ]))
                        ]))
                    ])),
                    function() {
                        var n = A2(di, p6(e.mo), t.k7);
                        if (1 === n.$) return A2(ye, k([
                            Ow("ActivityVerificationBloc")
                        ]), k([
                            function() {
                                var n = u.sy;
                                switch(n.$){
                                    case 0:
                                        return ag("");
                                    case 1:
                                        var r = n.a;
                                        return A2(ye, k([
                                            Ow("ActivityCommentVerifTc")
                                        ]), k([
                                            A2(gM, Eun, vln(r.sw)),
                                            wln(A2(Gsn, r, t))
                                        ]));
                                    default:
                                        r = n.a;
                                        var e = n.b;
                                        return A2(ye, k([
                                            Ow("ActivityCommentVerifTc")
                                        ]), k([
                                            A2(gM, Eun, vln(r.sw)),
                                            wln(A2(Gsn, r, t)),
                                            A2(gM, Eun, vln(e.sw)),
                                            wln(A2(Gsn, e, t))
                                        ]));
                                }
                            }(),
                            A2(ye, k([
                                Ow("ActivityVerificationMessage"),
                                Ow(Ysn(u.cU))
                            ]), k([
                                ag(Dln(e.nP))
                            ]))
                        ]));
                        var o = n.a;
                        return A2(ye, k([
                            Ow("ActivityVerificationBloc")
                        ]), k([
                            A4(Rln, t, r, e, o)
                        ]));
                    }()
                ]), 1 === e.mo.$ ? w : k([
                    A2(ye, k([
                        Ow("ActivityAnswers")
                    ]), A2(Ye, A2(Lln, n, t), Pln(e.d1))),
                    A4(Mln, n, r, t, e)
                ])))
            ]));
        }, Eo(e.S));
    }), Uln = F4(function(n, r, t, e) {
        return fln(e) ? A4(Wln, n, r, t, e) : A4(Iln, n, r, t, e);
    }), Qln = F4(function(n, r, t, e) {
        var u = d(e.mY, n.iZ);
        n: for(;;)if (1 === u.a.$) switch(u.b){
            case 0:
                return 3 === u.a.a.$ ? kt : ht(A3(mln, n.st, r.bD.ki, u.a.a));
            case 3:
                return ht(A3(mln, n.st, r.bD.ki, u.a.a));
            default:
                break n;
        }
        else switch(u.b){
            case 0:
                return ht(A4(Uln, n, r, t, o = u.a.a));
            case 4:
                return fln(o = u.a.a) ? ht(A4(Wln, n, r, t, o)) : kt;
            case 5:
                var o;
                return fln(o = u.a.a) ? kt : ht(A4(Iln, n, r, t, o));
            default:
                break n;
        }
        return kt;
    }), _ln = F4(function(n, r, t, e) {
        var u = a(n.oX.cf, ht(!1)) ? Me : lln(n);
        return A2(ye, k([
            Ow("ActivityContent"),
            Ow("DarkZone")
        ]), A2(Kc, A3(Qln, n, r, t), u(e)));
    }), Zln = function(n) {
        return {
            $: 36,
            a: n
        };
    }, Kln = xa({
        bN: "Complete Last started Job",
        bT: "Finir dernier Job d\xe9marr\xe9"
    }), Xln = xa({
        bN: "Create New Job",
        bT: "Nouveau Job"
    }), Jln = xa({
        bN: "Start Last created Job",
        bT: "D\xe9marrer dernier Job cr\xe9\xe9"
    }), Yln = function(n) {
        return {
            $: 43,
            a: n
        };
    }, Gln = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return A2(ye, k([
                Cg(Yln(r))
            ]), k([
                A2(Bnn, Vnn, t)
            ]));
        }
        return ag("");
    }), ndn = function(n) {
        switch(n.$){
            case 0:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusNone")
                ]), w);
            case 1:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusRunning")
                ]), w);
            case 2:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusSuccess")
                ]), w);
            default:
                return A2(ye, k([
                    Ow("OperationStatus"),
                    Ow("OperationStatusFailure")
                ]), w);
        }
    }, rdn = F3(function(n, r, t) {
        return A2(ye, k([
            Ow("Operation")
        ]), k([
            ndn(n),
            A2(ye, k([
                Ow("OperationContent"),
                Ow("VerifOperationContent")
            ]), A2(mt, A2(Gln, n, r), t))
        ]));
    }), tdn = function(n) {
        return Eo(Zt(A2(Ra, A2(bu, jP, function(n) {
            return n.ki;
        }), A2(Mu, function(n) {
            return !a(n.j2, kt);
        }, A2(Mu, function(n) {
            return 1 === n.fI;
        }, n.cZ)))));
    }, edn = function(n) {
        return Eo(Zt(A2(Ra, A2(bu, jP, function(n) {
            return n.ki;
        }), A2(Mu, function(n) {
            return a(n.j2, kt);
        }, A2(Mu, function(n) {
            return 1 === n.fI;
        }, n.cZ)))));
    }, udn = F2(function(n, r) {
        if (r.$) return ag("");
        var t = r.a;
        return A2(ye, w, k([
            ag(n),
            ag(" "),
            IP(t.ki)
        ]));
    }), odn = F2(function(n, r) {
        var t = A2(Mu, function(r) {
            return a(r.fI, n);
        }, r.cZ), e = A2(Kc, function(n) {
            return n.q6;
        }, A2(Mu, function(n) {
            return a(n.j2, kt);
        }, t)), u = function(n) {
            return Mt(qt(n));
        }, o = F4(function(r, t, e, o) {
            return u(r) + " " + hs(n) + " jobs ( " + u(t) + " created, " + u(e) + " started, " + u(o) + " completed )";
        }), i = A2(Mu, function(n) {
            return a(n.j2, kt) && a(n.q6, kt);
        }, t), c = A2(Kc, function(n) {
            return n.j2;
        }, t);
        return Tu(t) ? ag("") : A2(ye, k([
            Ow("VerifContent")
        ]), k([
            ag(A4(o, t, i, e, c)),
            A2(udn, "Last completed " + hs(n) + " Job", tdn(r)),
            A2(udn, "Last uncompleted " + hs(n) + " Job", edn(r))
        ]));
    }), adn = F3(function(n, r) {
        var t = A2(Mu, function(n) {
            return 1 === n.fI || !n.fI;
        }, r.cZ), e = A2(Mu, function(n) {
            return a(n.j2, kt) && !a(n.q6, kt);
        }, t), u = A2(Mu, function(n) {
            return a(n.j2, kt) && a(n.q6, kt);
        }, t), o = Tu(u) ? can(Jln) : A2(urn, Jln, function(n) {
            return {
                $: 39,
                a: n
            };
        }(r.cZ)), i = Tu(e) ? can(Kln) : A2(urn, Kln, function(n) {
            return {
                $: 41,
                a: n
            };
        }(r.cZ)), c = Tu(u) && Tu(e) ? A2(urn, Xln, function(n) {
            return {
                $: 37,
                a: n
            };
        }(r)) : can(Xln);
        return ien(r.st) ? A2(ye, k([
            Ow("Operations")
        ]), k([
            A2(qg, k([
                Ow("OperationsHeader")
            ]), "Operation Admin"),
            A2(odn, 1, r),
            A2(odn, 0, r),
            A3(rdn, n.kf, 0, k([
                A2(mh, Zln, ZL(n.mZ)),
                c
            ])),
            A3(rdn, n.q3, 0, k([
                o
            ])),
            A3(rdn, n.j1, 0, k([
                i
            ]))
        ])) : ag("");
    }), idn = {
        $: 30
    }, cdn = xa({
        bN: "Order by date",
        bT: "Trier par date"
    }), fdn = xa({
        bN: "Order by timecode",
        bT: "Trier par timecode"
    }), sdn = F3(function(n, r, t) {
        return wP(A3(Sp, n, r, t));
    }), ldn = F3(function(n, r, t) {
        var e = A2(ju, "", Eo(A2(Kc, function(n) {
            return n.a ? ht(n.c) : kt;
        }, t)));
        return A2(ye, k([
            Ow("Select"),
            Bg(k([
                d("SelectOpened", n)
            ])),
            Cg(r),
            kP(n)
        ]), k([
            A2(ye, k([
                Ow("SelectButton")
            ]), k([
                A2(ye, k([
                    Ow("SelectButtonIcon")
                ]), k([
                    Dk
                ])),
                A2(qg, k([
                    Ow("SelectButtonTitle")
                ]), e)
            ])),
            A2(ye, k([
                Ow("SelectList")
            ]), A2(Ye, CP, t))
        ]));
    }), ddn = F3(function(n, r, t) {
        var e = n.oX;
        return 4 === n.iZ ? A2(ye, k([
            Ow("ActivityHeader")
        ]), k([
            A3(ldn, t.is, idn, k([
                m(a(e.cf, kt), A3(sdn, n.g9.mo, n.iZ, p(e, {
                    cf: kt
                })), fdn),
                m(a(e.cf, ht(!1)), A3(sdn, n.g9.mo, n.iZ, p(e, {
                    cf: ht(!1)
                })), cdn)
            ]))
        ])) : ag("");
    }), mdn = {
        $: 33
    }, bdn = function(n) {
        return 5 === n.o2;
    }, pdn = function(n) {
        return A2(ju, !1, A2(Lu, function(n) {
            return function(n) {
                return A2(ju, !1, A2(Lu, bdn, n.r6));
            }(n) || !a(n.h9, kt);
        }, A2(Lu, function(n) {
            return n.lD;
        }, n.R.bQ.f$)));
    }, vdn = xa({
        bN: "Switch Proxy",
        bT: "Changer de proxy"
    }), $dn = xa({
        bN: "For a more thourough verification, you can switch to a high-qualitity proxy.",
        bT: "Pour une v\xe9rification plus pouss\xe9e, vous pouvez choisir un proxy mp4 de meilleure qualit\xe9."
    }), wdn = xa({
        bN: "Switch to hi-res proxy",
        bT: "Afficher le 'proxy hi-res'"
    }), gdn = xa({
        bN: "Switch back to low-res proxy",
        bT: "Retour au 'proxy low-res'"
    }), hdn = xa({
        bN: "Generate new proxy verif",
        bT: "G\xe9n\xe9ration du proxy de v\xe9rification"
    }), kdn = F2(function(n, r) {
        return A2(ye, k([
            Ow("Operation")
        ]), k([
            ndn(os),
            A2(ye, k([
                Ow("OperationContent")
            ]), k([
                ag(n),
                r
            ]))
        ]));
    }), Cdn = xa({
        bN: "Currently watching hi-res proxy",
        bT: "Vous \xeates sur le 'proxy hi-res'"
    }), Tdn = xa({
        bN: "Currently watching low-res proxy",
        bT: "Vous \xeates sur le 'proxy low-res'"
    }), Pdn = F3(function(n, r, t) {
        var e, u = ien(r.st), o = pdn(r), a = function(n) {
            return A2(ju, !1, A2(Lu, function(n) {
                var r = n.r6;
                return !r.$ && 5 === r.a.o2;
            }, A2(sp, A2(Pi, function(n) {
                return n.pm;
            }, function(n) {
                return n.fo;
            }), n.bQ.f$)));
        }(t);
        return A2(DL, o && u || a, A2(ye, k([
            Ow("RegularOperations")
        ]), k([
            A2(qg, k([
                Ow("RegularOperationsHeader")
            ]), vdn),
            u ? A3(rdn, n.q4, 0, k([
                (e = t.bQ.f$, 1 === e.$ ? ag("") : A2(urn, hdn, function(n) {
                    return {
                        $: 44,
                        a: n
                    };
                }(e.a.lD.mo)))
            ])) : men($dn),
            A2(DL, a, n.l3 ? A2(kdn, Cdn, A2(urn, gdn, mdn)) : A2(kdn, Tdn, A2(urn, wdn, mdn)))
        ])));
    }), Sdn = F4(function(n, r, t, e) {
        return A2(ye, k([
            Ow("Activity")
        ]), k([
            A3(ddn, n, r, t),
            A2(ju, ag(""), A2(Lu, sk, t.lo)),
            A2(ye, k([
                Ow("ActivityContent"),
                Ow("DarkZone")
            ]), function() {
                switch(n.iZ){
                    case 4:
                        return k([
                            A3(adn, t, n, r),
                            A3(Pdn, t, n, r),
                            A2(cln, r, t),
                            A4(_ln, n, r, t, A3(Msn, n, r, e))
                        ]);
                    case 5:
                        return k([
                            A2(Hsn, r, t),
                            A4(_ln, n, r, t, A3(Msn, n, r, e))
                        ]);
                    default:
                        return k([
                            A4(_ln, n, r, t, A3(Msn, n, r, e))
                        ]);
                }
            }())
        ]));
    }), Adn = F2(function(n, r) {
        var t, e, u = A2(jon, Mon(n), r);
        return k([
            (e = r.P.lo, 1 === e.$ ? ag("") : sk(een(e.a))),
            (t = r.e2.kx, t.$ ? ag("") : A2(mh, b1, A4(Sdn, n, u, r.iq, t.a)))
        ]);
    }), ydn = {
        $: 36
    }, Ndn = xa({
        bN: "Actions",
        bT: "Actions"
    }), Ldn = xa({
        bN: "Activity",
        bT: "Activit\xe9"
    }), jdn = xa({
        bN: "Comments",
        bT: "Commentaires"
    }), Fdn = xa({
        bN: "Settings",
        bT: "Param\xe8tres"
    }), Mdn = xa({
        bN: "Verification report",
        bT: "Rapport de v\xe9rification"
    }), Idn = function(n) {
        switch(n){
            case 0:
            case 1:
                return Ndn;
            case 2:
                return Fdn;
            case 3:
                return Ldn;
            case 4:
                return Mdn;
            default:
                return jdn;
        }
    }, Ddn = F2(function(n, r) {
        return wP(A3(Sp, n, r, $X));
    }), Bdn = F2(function(n, r) {
        return A2(oC, k([
            Ow("AsideMenuItem"),
            fC(A2(Ddn, n.g9.mo, r)),
            Bg(k([
                d("Active", a(r, n.iZ))
            ]))
        ]), k([
            ag(Idn(r))
        ]));
    }), xdn = F2(function(n, r) {
        return A2(ye, k([
            Ow("AsideTabs"),
            Cg(ydn),
            kP(r.i_),
            Bg(k([
                d("AsideMenuOpened", r.i_)
            ]))
        ]), k([
            A2(ye, k([
                Ow("AsideTab")
            ]), k([
                A2(ye, k([
                    Ow("AsideTabInner")
                ]), k([
                    A2(ye, k([
                        Ow("AsideTabsIcon")
                    ]), k([
                        Mun
                    ])),
                    A2(qg, k([
                        Ow("AsideTabLabel")
                    ]), Idn(n.iZ)),
                    Dk
                ]))
            ])),
            A2(ye, k([
                Ow("AsideMenu")
            ]), k([
                A2(Bdn, n, 1),
                A2(Bdn, n, 2),
                A2(Bdn, n, 3),
                A2(Bdn, n, 4),
                A2(Bdn, n, 5)
            ]))
        ]));
    }), qdn = function(n) {
        return 2 === n.$ ? ht(n.a) : kt;
    }, Vdn = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M8,12 L8,10 L6,10 L6,12 L8,12 Z M12,14 L12,8 L9,10 L9,12 L12,14 Z")
        ]), w)
    ])), Odn = xa({
        bN: "audio stream ",
        bT: "stream audio "
    }), zdn = xa({
        bN: "Channels",
        bT: "Canaux"
    }), Edn = xa({
        bN: "File duration",
        bT: "Dur\xe9e totale"
    }), Hdn = function(n) {
        return A3(Kd, 2, "0", Mt(n));
    }, Rdn = function(n) {
        var r = se(1e3 * n), t = r % 1e3, e = r / 1e3 | 0, u = e % 60;
        return Hdn(e / 60 | 0) + " min " + Hdn(u) + " sec " + Hdn(t) + " ms";
    }, Wdn = function(n) {
        var r = A2(sp, function(n) {
            return n.eU;
        }, n);
        return 1 === r.$ ? "?" : Rdn(r.a);
    }, Udn = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M5,9 L5,11 L13,11 L13,9 L5,9 Z M5,13 L5,15 L10,15 L10,13 L5,13 Z")
        ]), w)
    ])), Qdn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, _dn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Zdn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Kdn = F4(function(n, r, t, e) {
        return n.eY || n.hB || "" !== t ? A2(ye, k([
            Ow("EditRow")
        ]), k([
            A2(qg, k([
                Ow("EditRowLabel")
            ]), r),
            A2(ye, k([
                Ow("EditRowContent")
            ]), k([
                n.eY ? e : ag(t)
            ]))
        ])) : ag("");
    }), Xdn = F4(function(n, r, t, e) {
        return A4(Kdn, n, r, e.sw ? "\u2714" : "", A2(mh, Zdn(t), yk(e)));
    }), Jdn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ydn = F4(function(n, r, t, e) {
        return A4(Kdn, n, r, e.sw, A2(mh, Jdn(t), Onn(e)));
    }), Gdn = F4(function(n, r, t, e) {
        return A4(Kdn, n, r, e.sw, A2(mh, Jdn(t), ah(e)));
    }), nmn = F5(function(n, r, t, e, u) {
        return A4(Kdn, n, r, e.sw, A2(mh, Jdn(t), A2(zk, e, u)));
    }), rmn = function(n) {
        return xa({
            bN: n.m8,
            bT: n.m9
        });
    }, tmn = F3(function(n, r, t) {
        var e = A2(di, t.n6, r.mD);
        if (e.$) {
            var u = A2(di, t.n6, r.jJ);
            if (u.$) return ag("");
            var o = u.a;
            return A4(Xdn, n, rmn(t), t.n6, o);
        }
        var i = e.a;
        return "date" === t.sa ? A4(Ydn, n, rmn(t), t.n6, i) : a(t.sx, w) ? A4(Gdn, n, rmn(t), t.n6, i) : A5(nmn, n, rmn(t), t.n6, i, A2(Ye, function(n) {
            return d(n, n);
        }, t.sx));
    }), emn = xa({
        bN: "Save",
        bT: "Sauvegarder"
    }), umn = F2(function(n, r) {
        return n.eY || n.hB || !a(r.sw, kt) && !a(r.sw, ht(""));
    }), omn = F2(function(n, r) {
        var t = r.mu;
        return A2(umn, n, r) ? A2(ye, k([
            Ow("EditRow")
        ]), k([
            A2(qg, k([
                Ow("EditRowLabel")
            ]), r.mu.m7),
            A2(ye, k([
                Ow("EditRowContent")
            ]), k([
                n.eY ? A2(mh, r.p, r.dk(p(t, {
                    kS: n.hB
                }))) : ag(A2(ju, "", r.sw))
            ]))
        ])) : ag("");
    }), amn = F3(function(n, r, t) {
        var e, u = r.g9, o = omn(n);
        return A2(ye, k([
            Ow("EditContent")
        ]), k([
            (e = t.P, 3 === e.$ ? A2(Bnn, Vnn, e.a) : ag("")),
            o({
                mu: t.rX,
                dk: ah,
                p: _dn,
                sw: ht(u.rX)
            }),
            A2(Ck, function(r) {
                return Min(A2(Ye, A2(tmn, n, t), r.lC));
            }, t.p5),
            A2(DL, n.eY, A2(ye, k([
                Ow("EditFooter")
            ]), k([
                (n.hB ? can : Qk)(emn)
            ])))
        ]));
    }), imn = xa({
        bN: "Informations",
        bT: "Informations"
    }), cmn = {
        $: 9
    }, fmn = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), smn = xa({
        bN: "Cancel",
        bT: "Annuler"
    }), lmn = xa({
        bN: "Edit",
        bT: "Editer"
    }), dmn = F4(function(n, r, t) {
        return A2(ye, k([
            Ow("EditHeaderActions")
        ]), k(n.eY ? [
            DI(p(dI, {
                kS: n.hB,
                mn: ht(tj),
                mK: !0,
                m7: smn,
                oy: ht(cmn)
            }))
        ] : [
            DI(p(dI, {
                mn: ht(gln),
                mK: !1,
                m7: lmn,
                oy: ht(A2(fmn, r, t))
            }))
        ]));
    }), mmn = F5(function(n, r, t, e, u) {
        return Jx(k([
            nq(imn),
            A2(BZ, n.st, n.g9.oM) ? A4(dmn, r, t, e, u) : ag("")
        ]));
    }), bmn = F2(function(n, r) {
        var t = function(n) {
            return {
                eY: 0 !== n.P.$,
                hB: a(n.P, w7)
            };
        }(r);
        return A2(Hk, k([
            Ow("EditWrapper"),
            Uk(Qdn(n.g9)),
            Bg(k([
                d("EditEditing", t.eY)
            ]))
        ]), k([
            A5(mmn, n, t, n.g9, r.c2, r),
            A3(amn, t, n, r)
        ]));
    }), pmn = xa({
        bN: "Audio Qualification",
        bT: "Qualification Audio"
    }), vmn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, $mn = {
        $: 14
    }, wmn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, gmn = xa({
        bN: "Apply",
        bT: "Appliquer"
    }), hmn = xa({
        bN: "Audio Layout",
        bT: "Agencement Audio"
    }), kmn = xa({
        bN: "Copy",
        bT: "Copier"
    }), Cmn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Tmn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Pmn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Smn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Amn = F4(function(n, r, t, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), ymn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Nmn = F2(function(n, r) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n + ":" + r);
    }), Lmn = F2(function(n, r) {
        return n + "(" + A2(It, ", ", r) + ")";
    }), jmn = F3(function(n, r, t) {
        return {
            a2: 1,
            a4: t,
            jV: 0,
            bd: r,
            bk: n,
            sw: A2(Lmn, "rgb", A2(Ye, Mt, k([
                n,
                r,
                t
            ])))
        };
    }), Fmn = qg(k([
        (uQ = k([
            (rQ = A3(jmn, 59, 170, 255), A2(Nmn, "color", rQ.sw)),
            (nQ = {
                X: 0,
                sw: "bold"
            }, A2(Nmn, "font-weight", nQ.sw))
        ]), oQ = function(n) {
            return Tu(n) ? "unstyled" : A2(So, "_", zo(A2(Bo, 15739, ia(Wo(fa(Wo(A2(Wh, n, $o(w)))))))));
        }(uQ), aQ = A2(xw, "className", ga(oQ)), A3(yw, aQ, uQ, oQ))
    ])), Mmn = function(n) {
        switch(n){
            case 0:
                return xa({
                    bN: "Original version",
                    bT: "Version originale"
                });
            case 1:
                return xa({
                    bN: "Dubbed version",
                    bT: "Version doubl\xe9e"
                });
            case 2:
                return xa({
                    bN: "Audio Description",
                    bT: "Audiodescription"
                });
            case 3:
                return xa({
                    bN: "Silence",
                    bT: "Silence"
                });
            case 4:
                return xa({
                    bN: "International",
                    bT: "International"
                });
            case 5:
                return xa({
                    bN: "Music and effects",
                    bT: "Musique et effets"
                });
            case 6:
                return xa({
                    bN: "Voice only",
                    bT: "Voix seule"
                });
            case 7:
                return xa({
                    bN: "Custom 1",
                    bT: "Custom 1"
                });
            case 8:
                return xa({
                    bN: "Custom 2",
                    bT: "Custom 2"
                });
            case 9:
                return xa({
                    bN: "Custom 3",
                    bT: "Custom 3"
                });
            case 10:
                return xa({
                    bN: "Custom 4",
                    bT: "Custom 4"
                });
            case 11:
                return xa({
                    bN: "Custom 5",
                    bT: "Custom 5"
                });
            case 12:
                return xa({
                    bN: "Custom 6",
                    bT: "Custom 6"
                });
            case 13:
                return xa({
                    bN: "Custom 7",
                    bT: "Custom 7"
                });
            case 14:
                return xa({
                    bN: "Custom 8",
                    bT: "Custom 8"
                });
            case 15:
                return xa({
                    bN: "Custom 9",
                    bT: "Custom 9"
                });
            default:
                return xa({
                    bN: "Custom 10",
                    bT: "Custom 10"
                });
        }
    }, Imn = k([
        d(M0(0), Mmn(0)),
        d(M0(1), Mmn(1)),
        d(M0(4), Mmn(4)),
        d(M0(2), Mmn(2)),
        d(M0(3), Mmn(3)),
        d(M0(5), Mmn(5)),
        d(M0(6), Mmn(6)),
        d(M0(7), Mmn(7)),
        d(M0(8), Mmn(8)),
        d(M0(9), Mmn(9)),
        d(M0(10), Mmn(10)),
        d(M0(11), Mmn(11)),
        d(M0(12), Mmn(12)),
        d(M0(13), Mmn(13)),
        d(M0(14), Mmn(14)),
        d(M0(15), Mmn(15)),
        d(M0(16), Mmn(16))
    ]), Dmn = xa({
        bN: "Cancel",
        bT: "Annuler"
    }), Bmn = Lh(k([
        Ow("TableTrHead")
    ])), xmn = Ae("i"), qmn = mC(xmn), Vmn = function(n) {
        return ht(function(n) {
            return {
                $: 9,
                a: n
            };
        }(n));
    }, Omn = xa({
        bN: "Back to video",
        bT: "Retour au media principal"
    }), zmn = xa({
        bN: "Play",
        bT: "Lecture"
    }), Emn = F2(function(n, r) {
        var t = n.qp;
        if (t.$) return zmn;
        var e = d(t.a, r);
        n: for(;;){
            if (e.a.$) {
                if (e.b.$ || 1 !== e.b.a.$) break n;
                return a(e.a.a, e.b.a.a) ? Omn : zmn;
            }
            if (e.b.$ || e.b.a.$) break n;
            return a(e.a.a, e.b.a.a) ? Omn : zmn;
        }
        return zmn;
    }), Hmn = xa({
        bN: "Qualify",
        bT: "Qualifier"
    }), Rmn = xa({
        bN: "Save",
        bT: "Enregistrer"
    }), Wmn = F2(function(n, r) {
        return "" === n.sw && a(n.lp, w) ? A2(ye, k([
            Ow("InputWrapper"),
            Ow("InputWrapperPrechoice"),
            Bg(k([
                d("InputWrapperDisabled", n.kS)
            ]))
        ]), A2(mt, A2(ye, k([
            Ow("InputSelectAllChoice")
        ]), k([
            Dk,
            A2(Ok, n, r)
        ])), A2(Ye, function(n) {
            var r = n.a, t = n.b;
            return A2(qg, k([
                Ow("InputSelectPrechoice"),
                Cg(Lg(r))
            ]), t);
        }, r))) : A2(zk, n, r);
    }), Umn = kh(k([
        Ow("Table")
    ])), Qmn = function(n) {
        return A2(uk, k([
            Ow("TableTd")
        ]), k([
            n
        ]));
    }, _mn = function(n) {
        return A2(uk, k([
            Ow("TableTh")
        ]), k([
            n
        ]));
    }, Zmn = Lh(k([
        Ow("TableTr")
    ])), Kmn = function(n) {
        var r = F2(function(n, r) {
            var t = n.b, e = r.b;
            return d(A2(mt, n.a, r.a), A2(mt, t, e));
        });
        return A3(Je, r, d(w, w), n);
    }, Xmn = F6(function(n, r, t, e, u, o) {
        var i, c, f, s, l = A2(Lu, Kk, e.sz), b = A2(Lu, w$, e.sz), v = A2(Lu, Mmn, e.r9), $ = A2(Lu, M0, e.r9), w = a(t.pw, k([
            e.fL
        ])), g = k([
            d(L0(1), K1(1)),
            d(L0(2), K1(2))
        ]), h = k([
            d(L0(5), K1(5)),
            d(L0(13), K1(13))
        ]), C = k([
            d(L0(0), K1(0)),
            d(L0(3), K1(3)),
            d(L0(4), K1(4)),
            d(L0(6), K1(6)),
            d(L0(7), K1(7)),
            d(L0(8), K1(8)),
            d(L0(11), K1(11)),
            d(L0(9), K1(9)),
            d(L0(10), K1(10))
        ]), T = k([
            d(L0(12), K1(12)),
            d(L0(13), K1(13))
        ]), P = function() {
            switch(e.cz){
                case "1":
                    return C;
                case "2":
                    return g;
                case "6":
                    return h;
                case "8":
                    return T;
                default:
                    return k([
                        d(L0(0), K1(0)),
                        d(L0(2), K1(2)),
                        d(L0(3), K1(3)),
                        d(L0(4), K1(4)),
                        d(L0(1), K1(1)),
                        d(L0(6), K1(6)),
                        d(L0(7), K1(7)),
                        d(L0(8), K1(8)),
                        d(L0(11), K1(11)),
                        d(L0(9), K1(9)),
                        d(L0(10), K1(10)),
                        d(L0(12), K1(12)),
                        d(L0(13), K1(13))
                    ]);
            }
        }(), S = A2(Lu, K1, e.nd), A = A2(Lu, L0, e.nd), y = !a(S, kt) && !a(v, kt), N = !(i = A2(di, e.fL, t.sB)).$ && L4(i.a.r9.sw), L = t.e_ && A3(qZ, r.st, r.g9.oM, A2(Ye, function(n) {
            return n.fB;
        }, r.fD)), j = k(y ? [
            A2(Ck, Fmn, S),
            A2(Ck, vO, v),
            A2(Ck, qmn, l)
        ] : [
            vO(e.rW)
        ]), F = A2(ju, m(ag(""), ag(""), ag("")), A2(Lu, function(n) {
            var r;
            return m(A2(mh, Pmn(e.fL), A2(Wmn, n.r9, Imn)), (r = n.sz, A2(mh, Smn(e.fL), A2(Wmn, p(r, {
                kS: !N
            }), Xk))), A2(mh, Tmn(e.fL), A2(Wmn, n.nd, P)));
        }, A2(sp, function() {
            return A2(di, e.fL, t.sB);
        }, Eo(t.pw)))), M = F.a, I = F.b, D = F.c;
        return A2(ye, k([
            Ow("AudioQualifyFilesAudioStream")
        ]), k([
            A2(ye, k([
                Ow("AudioQualifyFilesHeader")
            ]), k([
                Vdn,
                A2(ye, k([
                    Ow("AudioQualifyFilesTitle")
                ]), j),
                u ? A2(ye, k([
                    Ow("PlayAudio")
                ]), k([
                    vI(p(dI, {
                        mn: ht(Len),
                        m7: A2(Emn, t, o),
                        oy: Vmn(o)
                    }))
                ])) : ag(""),
                L ? A2(ye, k([
                    Ow("AudioQualifyQualifyEdit")
                ]), k([
                    vI(p(dI, {
                        mn: ht(w ? tj : gln),
                        bf: w,
                        m7: w ? Dmn : Hmn,
                        oy: ht(w ? Cmn(e.fL) : A4(Amn, e.fL, $, b, A))
                    }))
                ])) : ag("")
            ])),
            a(t.pw, k([
                e.fL
            ])) ? A2(Hk, k([
                Uk(ymn(e.fL)),
                Ow("AudioQualifyQualifyForm")
            ]), k([
                D,
                M,
                I,
                Fen(Rmn)
            ])) : ag(""),
            A2(ye, k([
                Ow("AudioQualifyFilesDesc")
            ]), (c = Kmn(e.kM), f = c.a, s = c.b, k([
                Umn(k([
                    Bmn(A2(Ye, A2(bu, _mn, ag), f)),
                    Zmn(A2(Ye, A2(bu, Qmn, ag), s))
                ]))
            ])))
        ]));
    }), Jmn = F5(function(n, r, t, e, u) {
        if (Tu(t)) return ag("");
        var o, a = A2(Ra, function(n) {
            return n.fv;
        }, t), i = F2(function(n, r) {
            return A2(Lu, function(n) {
                return n.$ ? g4(n.a + "/" + Mt(r)) : b4(r + 1);
            }, n);
        });
        return A2(ye, k([
            Ow("AudioQualifyWrapper")
        ]), k([
            A2(ye, w, A2(Ht, F2(function(t, o) {
                return A6(Xmn, t, n, r, o, e, A2(i, u, t));
            }), a)),
            r.e_ && A3(qZ, n.st, n.g9.oM, A2(Ye, function(n) {
                return n.fB;
            }, n.fD)) && (u.$ || 1 !== u.a.$) ? A2(ye, k([
                Ow("AudioQualifyMemo")
            ]), k([
                A2(dg, k([
                    Ow("AudioQualifyMemoLabel")
                ]), k([
                    ag(hmn)
                ])),
                vI(p(dI, {
                    mn: kt,
                    m7: kmn,
                    oy: ht(wmn(t))
                })),
                (o = r.p0, 1 === o.$ || "" === o.a ? ag("") : vI(p(dI, {
                    mn: kt,
                    m7: gmn,
                    oy: ht(vmn(t))
                })))
            ])) : ag(""),
            function() {
                if (r.e_) {
                    if (u.$ || 1 !== u.a.$) {
                        var n = r.p0;
                        if (1 === n.$) return ag("");
                        if ("" === n.a) return ag("");
                        var t = n.a;
                        return A2(dg, k([
                            Ow("AudioQualifyMemoRecap")
                        ]), k([
                            ag(gmn + " '" + t + "' ?"),
                            A2(hln, kg, $mn)
                        ]));
                    }
                    return ag("");
                }
                return ag("");
            }()
        ]));
    }), Ymn = F5(function(n, r, t, e, u) {
        return A2(ye, k([
            Ow("AudioQualify")
        ]), k([
            Jx(k([
                nq(pmn)
            ])),
            A5(Jmn, n, r, t, e, u)
        ]));
    }), Gmn = xa({
        bN: "Subtitle Qualification",
        bT: "Qualification des sous-titres"
    }), nbn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, rbn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), tbn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ebn = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), ubn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, obn = xa({
        bN: "Qualify",
        bT: "Qualifier"
    }), abn = xa({
        bN: "Save",
        bT: "Enregistrer"
    }), ibn = F5(function(n, r, t, e) {
        var u = A2(Lu, Kk, e.sz), o = A2(Lu, w$, e.sz), i = A2(Lu, EL, e.r9), c = A2(Lu, SA, e.r9), f = t.e_ && A3(qZ, r.st, r.g9.oM, A2(Ye, function(n) {
            return n.fB;
        }, r.fD)), s = A2(ju, d(ag(""), ag("")), A2(Lu, function(n) {
            return d(A2(mh, tbn(e.fL), A2(zk, n.sz, RL)), A2(mh, rbn(e.fL), A2(zk, n.r9, HL)));
        }, A2(sp, function() {
            return A2(di, e.fL, t.sB);
        }, t.pw))), l = s.a, m = s.b;
        return A2(ye, k([
            Ow("SubtitleQualifyFilesSubtitleStream")
        ]), k([
            A2(ye, k([
                Ow("SubtitleQualifyFilesHeader")
            ]), k([
                Vdn,
                A2(qg, k([
                    Ow("SubtitleQualifyFilesTitle")
                ]), e.rW),
                f ? A2(ye, k([
                    Ow("SubtitleQualifyQualifyEdit")
                ]), k([
                    vI(p(dI, {
                        mn: ht(Len),
                        mK: a(t.pw, ht(e.fL)),
                        m7: obn,
                        oy: a(t.pw, ht(e.fL)) ? ht(nbn(e.fL)) : ht(A3(ebn, e.fL, o, c))
                    }))
                ])) : ag("")
            ])),
            a(t.pw, ht(e.fL)) ? A2(Hk, k([
                Uk(ubn(e.fL)),
                Ow("SubtitleQualifyQualifyForm")
            ]), k([
                l,
                m,
                Qk(abn)
            ])) : A2(ye, k([
                Ow("SubtitleQualifyQualify")
            ]), k([
                A2(Ck, qg(k([
                    Ow("SubtitleQualifyQualifyItem")
                ])), u),
                A2(Ck, qg(k([
                    Ow("SubtitleQualifyQualifyItem")
                ])), i)
            ]))
        ]));
    }), cbn = F4(function(n, r, t, e) {
        return Tu(t) ? ag("") : A2(ye, k([
            Ow("SubtitleQualifyWrapper")
        ]), k([
            A2(ye, w, A2(Ht, F2(function(t, u) {
                return A5(ibn, t, n, r, u, e);
            }), t))
        ]));
    }), fbn = F4(function(n, r, t, e) {
        return A2(ye, k([
            Ow("SubtitleQualify")
        ]), k([
            Jx(k([
                nq(Gmn)
            ])),
            A4(cbn, n, r, t, e)
        ]));
    }), sbn = F2(function(n, r) {
        var t = !1, e = A2(jon, Mon(n), r), u = A3(Je, jt, w, A2(Ye, function(n) {
            return A2(Ye, function(r) {
                return {
                    z: r.z,
                    fv: r.fv,
                    n6: n.lD.n6,
                    r9: r.r9,
                    sz: r.sz
                };
            }, A2(Kc, qdn, n.av));
        }, e.bQ.ad)), o = A2(hT, gT(function(n) {
            return n.rW;
        }), A2(Ye, function(n) {
            return {
                mn: Udn,
                fv: n.fv,
                fL: n.z + "/" + Mt(n.fv),
                rW: n.n6,
                r9: n.r9,
                sz: n.sz
            };
        }, u)), a = function() {
            var n = e.bQ.f$;
            return n.$ ? w : n.a.av;
        }(), i = A2(Kc, Z1, a), c = A2(hT, gT(function(n) {
            return n.rW;
        }), A2(Ye, function(n) {
            return {
                cz: Mt(n.cz),
                kM: k([
                    d("Codec", n.aE),
                    d(Edn, Wdn(ht(n))),
                    d(zdn, Mt(n.cz))
                ]),
                mn: Vdn,
                fv: n.fv,
                fL: n.z + "/" + Mt(n.fv),
                nd: n.aC,
                rW: $(Odn, A3(Kd, 2, "0", Mt(n.fv))),
                r9: n.r9,
                sz: n.sz
            };
        }, i));
        return k([
            A2(mh, k1, A2(bmn, n, r.k3)),
            A2(mh, t_, A5(Ymn, n, r.i7, c, t, ht(b4(-1)))),
            A2(mh, F1, A4(fbn, n, r.rq, o, t))
        ]);
    }), lbn = F2(function(n, r) {
        return k([
            A2(ye, k([
                Ow("AsideHeader")
            ]), k([
                A2(xdn, n, r),
                A2(oC, k([
                    Ow("LayoutFwdButton"),
                    fC(Non(r))
                ]), k([
                    tj
                ]))
            ])),
            A2(ye, k([
                Ow("AsideBody")
            ]), function() {
                switch(n.iZ){
                    case 1:
                    case 0:
                        return A2(Asn, n, r);
                    case 2:
                        return A2(sbn, n, r);
                    default:
                        return A2(Adn, n, r);
                }
            }())
        ]);
    }), dbn = F2(function(n, r) {
        return n ? r : ag("");
    }), mbn = function(n) {
        return {
            $: 41,
            a: n
        };
    }, bbn = {
        $: 18
    }, pbn = {
        $: 19
    }, vbn = {
        $: 20
    }, $bn = F3(function(n, r, t) {
        return A2(BZ, n, r) || A2(kon, n, t);
    }), wbn = function(n) {
        return {
            $: 29,
            a: n
        };
    }, gbn = xa({
        bN: "Delete",
        bT: "Supprimer"
    }), hbn = xa({
        bN: "Download",
        bT: "T\xe9l\xe9charger"
    }), kbn = F3(function(n, r, t) {
        var e = n.P.kx;
        return !(e.$ || !t.iz && 9 !== r.c$ && (e.a.g9.c$ || 8 !== r.c$ && 7 !== r.c$));
    }), Cbn = xa({
        bN: "In progress...",
        bT: "En cours..."
    }), Tbn = function(n) {
        switch(n){
            case 0:
                return "ProgressIdle";
            case 1:
                return "ProgressActive";
            case 2:
                return "ProgressError";
            case 3:
                return "ProgressWarning";
            case 4:
                return "ProgressPaused";
            default:
                return "ProgressCompleted";
        }
    }, Pbn = function(n) {
        var r = function() {
            var r = n.pk;
            if (1 === r.$) return d(d(Cbn, 100), d(!1, !0));
            var t = r.a;
            return d(d(Jz(t), 100 * t), d(1 > t, !1));
        }(), t = r.a, e = t.a, u = t.b, o = r.b, a = o.a, i = o.b;
        return A2(ye, k([
            Ow("ProgressBarOuter"),
            II(e)
        ]), k([
            A2(ye, k([
                Ow("ProgressBarInner"),
                Ow(Tbn(n.P)),
                Bg(k([
                    d("ProgressBarProgressing", a),
                    d("ProgressBarAnimated", i)
                ])),
                A2(pg, "width", by(u) + "%")
            ]), w)
        ]));
    }, Sbn = F7(function(n, r, t, e, u, o, i) {
        var c, f, s, l = function() {
            var n = u.sk;
            if (1 === n.$) return ag("");
            var r = n.a;
            return a(r.j2, kt) ? a(r.lo, kt) ? a(r.df, kt) ? Pbn({
                pk: ht(r.pk),
                P: 1
            }) : Pbn({
                pk: ht(r.pk),
                P: 4
            }) : Pbn({
                pk: ht(r.pk),
                P: 2
            }) : ag("");
        }(), m = A2(ju, !0, A2(Lu, function(n) {
            return !a(n.j2, kt);
        }, u.sk)) ? A2(ye, k([
            Ow("MasterFilesDownload")
        ]), k([
            vI(!GK(u) && r || ien(e) ? p(dI, {
                lx: k([
                    A2(qI, "target", "_blank"),
                    A2(qI, "data-prevent-history", "true"),
                    Ow(o)
                ]),
                mn: ht(Lun),
                bf: !0,
                m7: hbn + " (" + Xx(u.qP) + ")",
                sr: ht(u.sr)
            }) : p(dI, {
                m7: Xx(u.qP)
            })),
            A3(kbn, t, u, e) ? vI(p(dI, {
                mn: ht(kg),
                m7: gbn,
                oy: ht(wbn(u.mo))
            })) : ag("")
        ])) : ag("");
        return A2(ye, k([
            Ow("MasterFilesAsset"),
            Bg(k([
                d("MasterFilesShowDesc", n)
            ]))
        ]), k([
            A2(ye, k([
                Ow("MasterFilesHeader")
            ]), k([
                A2(ye, k([
                    Ow("MasterFilesIcon")
                ]), k([
                    u.mn
                ])),
                A2(qg, k([
                    Ow("MasterFilesTitle")
                ]), u.rW),
                l,
                m
            ])),
            u.kM.b ? A2(ye, k([
                Ow("MasterFilesDesc")
            ]), (c = Kmn(u.kM), f = c.a, s = c.b, k([
                Umn(k([
                    Bmn(A2(Ye, A2(bu, _mn, ag), f)),
                    Zmn(A2(Ye, A2(bu, Qmn, ag), s))
                ]))
            ]))) : ag(""),
            A2(ye, k([
                Ow("MasterFilesChildren")
            ]), u.jL),
            i
        ]));
    }), Abn = F2(function(n, r) {
        return r.$ ? n : ht(r.a);
    }), ybn = function(n) {
        var r = A2(sp, function(n) {
            return n.hY;
        }, Eo(A2(Kc, Y1, n.av))), t = A2(sp, function(n) {
            return n.hY;
        }, Eo(A2(Ra, function(n) {
            return n.fv;
        }, A2(Kc, N2, n.av))));
        return A2(Abn, r, A2(Abn, t, A2(sp, function(n) {
            return n.hY;
        }, n.a6)));
    }, Nbn = F3(function(n, r, t) {
        return A2(ye, k([
            Ow("MasterChild"),
            Ow(n)
        ]), k([
            A2(ye, k([
                Ow("MasterChildLabel")
            ]), r),
            A2(ye, k([
                Ow("MasterChildProgress")
            ]), t)
        ]));
    }), Lbn = F2(function(n, r) {
        return {
            $: 25,
            a: n,
            b: r
        };
    }), jbn = F2(function(n, r) {
        return A2(Pg, Han, A2(Lbn, n, r));
    }), Fbn = F2(function(n, r) {
        return {
            $: 21,
            a: n,
            b: r
        };
    }), Mbn = xa({
        bN: "Pause",
        bT: "Pause"
    }), Ibn = F2(function(n, r) {
        return A2(Pg, Mbn, A2(Fbn, n, r));
    }), Dbn = F3(function(n, r, t) {
        return {
            $: 23,
            a: n,
            b: r,
            c: t
        };
    }), Bbn = xa({
        bN: "Resume",
        bT: "Reprendre"
    }), xbn = F3(function(n, r, t) {
        return A2(Pg, Bbn, A3(Dbn, n, r, t));
    }), qbn = F5(function(n, r, t, e, u) {
        if (!a(ht(n.dt), e.dt) && !a(u, Yz)) return k([
            A2(jbn, n, t)
        ]);
        switch(u.$){
            case 0:
                return k([
                    A2(Ibn, n, t),
                    A2(jbn, n, t)
                ]);
            case 1:
            case 4:
            default:
                return w;
            case 2:
                return k([
                    A3(xbn, n, r, t),
                    A2(jbn, n, t)
                ]);
            case 3:
                return k([
                    A2(jbn, n, t)
                ]);
        }
    }), Vbn = F3(function(n, r, t) {
        var e = t.sk;
        if (1 === e.$) return ag("");
        var u = e.a;
        return u.j2.$ ? A3(Nbn, "UploadChild", A5(qbn, n.e1, r.g9.mo, t, u, A3(tE, t.mo, u, n._)), w) : ag("");
    }), Obn = F4(function(n, r, t, e) {
        var u = e.lD, o = e.av, a = e.pm, i = function() {
            var n = a.nw;
            if (n.$) return !1;
            var r = A2(Lu, function(n) {
                return n.o2;
            }, n.a.r6);
            return !r.$ && 5 === r.a;
        }(), c = A5(Jmn, r, t.i7, A2(Kc, function(n) {
            if (1 === n.$) {
                var r = n.a;
                return ht({
                    cz: Mt(r.cz),
                    kM: k([
                        d("Codec", r.aE),
                        d(Edn, A2(ju, "?", A2(Lu, Rdn, r.eU))),
                        d(zdn, Mt(r.cz)),
                        d("Start Timecode", A2(ju, "N/A", ybn(e)))
                    ]),
                    mn: Vdn,
                    fv: r.fv,
                    fL: u.mo + "/" + Mt(r.fv),
                    nd: r.aC,
                    rW: $(Odn, A3(Kd, 2, "0", Mt(r.fv))),
                    r9: r.r9,
                    sz: r.sz
                });
            }
            return kt;
        }, o), i, ht(g4(u.mo)));
        return A7(Sbn, t.qE, A3($bn, r.st, r.g9.oM, A2(Ye, function(n) {
            return n.fB;
        }, r.fD)), t, r.st, {
            jL: k([
                A2(mh, t_, c)
            ]),
            kM: w,
            lA: kt,
            mn: Vdn,
            mo: u.mo,
            c$: u.c$,
            qP: u.qP,
            hv: u.hv,
            rW: u.n6,
            sk: u.sk,
            sr: Si(psn(u.mo))
        }, "audioFile", A3(Vbn, n, r, u));
    }), zbn = xa({
        bN: "Audios alone",
        bT: "Audios seuls"
    }), Ebn = function(n) {
        return qf(n.cI / n.cH * 100) / 100;
    }, Hbn = F2(function(n, r) {
        var t = r * n.at / n.as, e = se(r), u = e * n.at / n.as, o = e % 60;
        return Hdn(e / 60 | 0) + " min " + Hdn(o) + " sec " + A3(Kd, 2, "0", Mt(qf(t - u))) + " frame(s)";
    }), Rbn = function(n) {
        var r = n.eU;
        return r.$ ? "N/A" : A2(Hbn, n, r.a);
    }, Wbn = F3(function(n, r, t) {
        var e, u, o;
        return A2(ye, k([
            Ow("MasterFilesAsset"),
            Bg(k([
                d("MasterFilesShowDesc", n.qD)
            ]))
        ]), k([
            t,
            r.kM.b ? A2(ye, k([
                Ow("MasterFilesDesc")
            ]), (e = Kmn(r.kM), u = e.a, o = e.b, k([
                Umn(k([
                    Bmn(A2(Ye, A2(bu, _mn, ag), u)),
                    Zmn(A2(Ye, A2(bu, Qmn, ag), o))
                ]))
            ]))) : ag(""),
            n.qD ? A2(ye, k([
                Ow("MasterFilesChildren")
            ]), r.jL) : ag("")
        ]));
    }), Ubn = function(n) {
        return s(n, 1e9) > -1 ? Mt(n / 1e9 | 0) + " Gbps" : s(n, 1e6) > -1 ? Mt(n / 1e6 | 0) + " Mbps" : 1e3 > n ? Mt(n) + " bps" : Mt(n / 1e3 | 0) + " kbps";
    }, Qbn = xa({
        bN: "Level",
        bT: "Niveau"
    }), _bn = xa({
        bN: "Quality",
        bT: "Qualit\xe9"
    }), Zbn = function(n) {
        var r = d(d(ien(n.st), A2(BZ, n.st, n.g9.oM)), n.g9.c$);
        return !!r.a.a || !!r.a.b && 1 === r.b;
    }, Kbn = function(n) {
        return A3($bn, n.st, n.g9.oM, A2(Ye, function(n) {
            return n.fB;
        }, n.fD));
    }, Xbn = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M6,7 L6,13 L12,10 L6,7 Z")
        ]), w)
    ])), Jbn = F2(function(n, r) {
        return n.qD ? A2(ye, k([
            Ow("MasterFilesVideoStream")
        ]), k([
            A2(ye, k([
                Ow("MasterFilesHeader")
            ]), k([
                Xbn,
                A2(qg, k([
                    Ow("MasterFilesTitle")
                ]), r.rW)
            ])),
            A2(ye, k([
                Ow("MasterFilesDesc")
            ]), function() {
                var n = Kmn(r.kM), t = n.a, e = n.b;
                return k([
                    Umn(k([
                        Bmn(A2(Ye, A2(bu, _mn, ag), t)),
                        Zmn(A2(Ye, A2(bu, Qmn, ag), e))
                    ]))
                ]);
            }())
        ])) : A2(ye, w, w);
    }), Ybn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Gbn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, npn = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), rpn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, tpn = function(n) {
        return A3(qZ, n.st, n.g9.oM, A2(Ye, function(n) {
            return n.fB;
        }, n.fD));
    }, epn = xa({
        bN: "Upload was interrupted, re-upload exactly the same file to resume where it was.",
        bT: "L\u2019upload a \xe9t\xe9 interrompu, r\xe9-uploadez exactement le m\xeame fichier pour reprendre o\xf9 il en \xe9tait."
    }), upn = xa({
        bN: "Delete",
        bT: "Supprimer"
    }), opn = xa({
        bN: "Download",
        bT: "T\xe9l\xe9charger"
    }), apn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, ipn = xa({
        bN: "Hide",
        bT: "Masquer"
    }), cpn = xa({
        bN: "Show",
        bT: "Montrer"
    }), fpn = F3(function(n, r, t) {
        if (n.$) return " ";
        var e = n.a;
        return a(ht(e), t) || a(ht(e), r) ? ipn : cpn;
    }), spn = F2(function(n, r) {
        return A2(sp, function(n) {
            var t = A2(sp, A2(bu, Lu(function(n) {
                return n.o2;
            }), function(n) {
                return n.r6;
            }), r);
            if (t.$ || 5 !== t.a) return kt;
            switch(n.c$){
                case 0:
                    return ht(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n.mo));
                case 3:
                    return ht(function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(n.mo));
                default:
                    return kt;
            }
        }, r);
    }), lpn = function(n) {
        return A2(Zw, k([
            Hw("18px"),
            Xw("18px"),
            Kw("0 0 18 18"),
            Fw("IconIcon18")
        ]), A2(mt, A2(Wrn, k([
            Fw("Bg"),
            Hw("18"),
            Xw("18"),
            Urn("0"),
            Qrn("0")
        ]), w), n));
    }, dpn = lpn(k([
        A2(_w, k([
            Fw("Fg"),
            Rw("6 5 12 9 6 13")
        ]), w)
    ])), mpn = F4(function(n, r, t, e) {
        var u, o = A2(spn, n, r), i = o.$ ? d(kt, kt) : 1 === o.a.$ ? a(ht(u = o.a.a), t) ? d(ht(apn(kt)), ht(u)) : d(ht(apn(ht(u))), ht(u)) : d(ht(function(n) {
            return {
                $: 13,
                a: n
            };
        }(u = o.a.a)), ht(u)), c = i.a, f = i.b, s = vI(p(dI, {
            mn: ht(dpn),
            m7: A3(fpn, f, t, e),
            oy: c
        }));
        return 9 !== n.c$ || a(o, kt) ? ag("") : s;
    }), bpn = xa({
        bN: "Error occurred while deleting file.",
        bT: "Une erreur est survenue lors de la suppression du fichier."
    }), ppn = xa({
        bN: "Are you uploading from another tab or window? If not, you can re-upload exactly the same file to resume where it was.",
        bT: "Uploadez-vous depuis un autre onglet ou fen\xeatre? Si non, vous pouvez r\xe9-uploadez exactement le m\xeame fichier pour reprendre o\xf9 il en \xe9tait."
    }), vpn = function(n) {
        switch(n){
            case 3:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, $pn = A2(xt, F2(function(n, r) {
        if (1 === n.$) return r;
        var t = n.a;
        return 0 > s(vpn(t), vpn(r)) ? t : r;
    }), 0), wpn = function(n) {
        return A2(ye, k([
            Ow("LayoutSmallHeader")
        ]), k([
            bC(n)
        ]));
    }, gpn = F2(function(n, r) {
        var t = 1 === n.$ ? "FrameRate not defined. Unable to compute timecode for frame" + Mt(r.e9) : w5(A3(Yf, by(n.a), r.e9, !1));
        return A2(Lh, k([
            Ow("TranscodeWarning")
        ]), k([
            A2(uk, k([
                Ow("TranscodeWarningField")
            ]), k([
                ag(r.n6)
            ])),
            A2(uk, k([
                Ow("TranscodeWarningField")
            ]), k([
                ag(Mt(r.eD))
            ])),
            A2(uk, k([
                Ow("TranscodeWarningField")
            ]), k([
                ag(t)
            ]))
        ]));
    }), hpn = xa({
        bN: "Count",
        bT: "Nombre total"
    }), kpn = xa({
        bN: "First error at",
        bT: "Premiere erreur \xe0"
    }), Cpn = xa({
        bN: "Message",
        bT: "Message"
    }), Tpn = F2(function(n, r) {
        var t = n.r6;
        if (1 === t.$) return ag("");
        var e = t.a.dP;
        return Tu(e) ? ag("") : A2(ye, k([
            Ow("FileOperationWarning")
        ]), k([
            wpn("Warnings"),
            Umn($(k([
                Bmn(k([
                    _mn(ag(Cpn)),
                    _mn(ag(hpn)),
                    _mn(ag(kpn))
                ]))
            ]), A2(Ye, gpn(r), e)))
        ]));
    }), Ppn = xa({
        bN: "Download ",
        bT: "T\xe9l\xe9charger "
    }), Spn = function(n) {
        var r = n.m7;
        return A2(oC, k([
            fC(n.sr),
            A2(qI, "target", "_blank"),
            A2(qI, "download", ""),
            A2(qI, "data-prevent-history", "true"),
            Ow("ReportLinksButton")
        ]), k([
            A2(ye, k([
                Ow("ReportLinksIcon")
            ]), k([
                Lun
            ])),
            A2(qg, k([
                Ow("ReportLinksLabel")
            ]), r)
        ]));
    }, Apn = function(n) {
        var r = m(ien(n.st), A2(BZ, n.st, n.g9.oM) || A3($bn, n.st, n.g9.oM, A2(Ye, function(n) {
            return n.fB;
        }, n.fD)), n.g9.c$);
        return !!r.a || !(!r.b || 1 !== r.c);
    }, ypn = function(n) {
        return A2(ye, k([
            Ow("LayoutSubHeader")
        ]), k([
            Kz(n)
        ]));
    }, Npn = xa({
        bN: "Summary automated analysis",
        bT: "R\xe9sum\xe9 analyse automatique"
    }), Lpn = function(n) {
        return n ? "\u2714" : "\u2716";
    }, jpn = ju("unknown"), Fpn = F3(function(n, r, t) {
        return A2(n, t, r);
    }), Mpn = Sj, Ipn = F2(function(n, r) {
        return A2(Mpn, ag(n), ag(r));
    }), Dpn = Sj, Bpn = F2(function(n, r) {
        return A2(Dpn, ag(n), ag(r));
    }), xpn = F2(function(n, r) {
        return A2(Gx, ag(n), ag(r));
    }), qpn = xa({
        bN: "Unavailable information",
        bT: "Informations indisponibles"
    }), Vpn = qmn(qpn), Opn = function(n) {
        var r, t = (r = n.b0).$ ? kt : ht(r.a), e = jpn(A2(Lu, A2(Fpn, jt, " LUFS"), A2(sp, function(n) {
            return n.gH;
        }, t))), u = A2(ju, ag("unknown"), A2(Lu, function(n) {
            return A2(ye, w, A2(mt, A2(Bpn, "channel", "value"), A2(Ye, function(n) {
                return A2(Ipn, n.m7, n.h6 + " DbTP");
            }, n)));
        }, A2(Lu, function(n) {
            return n.cz;
        }, t))), o = jpn(A2(Lu, A2(Fpn, jt, " LU"), A2(sp, function(n) {
            return n.nt;
        }, t))), a = jpn(A2(Lu, Lpn, A2(Lu, function(n) {
            return n.fF;
        }, t)));
        return A2(mt, A2(xpn, "Type (ID-Parent)", n.n6 + " (" + n.mo + "-" + n.gq + ")"), k(t.$ ? [
            Vpn
        ] : [
            A2(yj, "Mute track ?", a),
            A2(yj, "Program Loudness EBU", e),
            A2(yj, "Loudness Range EBU", o),
            A2(Aj, ag("True Peak EBU"), u)
        ]));
    }, zpn = function(n) {
        var r, t = (r = n, uI(A2(R$, F2(function(n, r) {
            return !r.b0.$;
        }), r.av)));
        return A2(ye, w, A2(mt, wpn("Audio Streams"), A3(Je, jt, w, A2(Ye, Opn, A2(Ra, function(n) {
            return A2(ju, 0, He(n.mo));
        }, t)))));
    }, Epn = function(n) {
        var r = A2(ju, iz, A2(sp, function(n) {
            var r = n.b0;
            return 2 === r.$ ? ht(r.a) : kt;
        }, A2(di, "0", n.av)));
        return A2(ye, w, A2(mt, wpn("Container"), function() {
            switch(r.$){
                case 1:
                    return function(n) {
                        return k([
                            A2(yj, "Format", "MOV"),
                            A2(yj, "Duration SMPTE", jpn(n.eU)),
                            A2(yj, "Start timecode", jpn(n.q5))
                        ]);
                    }(r.a);
                case 0:
                    return function(n) {
                        return k([
                            A2(yj, "Duration SMPTE (source package TC)", jpn(n.hX.eU)),
                            A2(yj, "Format & Pattern", "MXF " + A2(ju, "(unknown pattern)", n.gl)),
                            A2(yj, "Product Name & Version", A2(ju, "(unknown product)", n.gD.n6) + " " + A2(ju, "(unknown version)", n.gD.sz)),
                            A2(yj, "Company Name", jpn(n.gD.fH)),
                            A2(xpn, "Item", "Start timecode"),
                            A2(yj, "Source package", jpn(n.hX.hj)),
                            A2(yj, "Material package", jpn(n.hX.f0)),
                            A2(yj, "System item", jpn(n.hX.hM)),
                            A2(yj, "VITC presence", jpn(n.hX.fl))
                        ]);
                    }(r.a);
                default:
                    return k([
                        Vpn
                    ]);
            }
        }()));
    }, Hpn = function(n) {
        return A2(ye, w, k([
            wpn("Content summary"),
            Umn($(k([
                Bmn(k([
                    _mn(ag("Name")),
                    Qmn(ag("ID")),
                    Qmn(ag("Parent"))
                ]))
            ]), A2(Ye, function(n) {
                return Zmn(k([
                    _mn(ag(n.n6)),
                    Qmn(ag(n.mo)),
                    Qmn(ag(n.gq))
                ]));
            }, A2(Ra, function(n) {
                return A2(ju, 0, He(n.mo));
            }, A2(Mu, function(n) {
                return 2 !== n.b0.$;
            }, uI(n.av))))))
        ]));
    }, Rpn = function(n) {
        var r, t = Eo((r = n, uI(A2(R$, F2(function(n, r) {
            return 1 === r.b0.$;
        }), r.av)))), e = A2(sp, function(n) {
            var r = n.b0;
            return 1 === r.$ ? ht(r.a) : kt;
        }, t), u = d(t, e);
        if (u.a.$ || u.b.$) return A2(ye, w, k([
            Vpn
        ]));
        var o = u.a.a, a = u.b.a;
        return A2(ye, w, k([
            wpn("Video Stream"),
            A2(xpn, "Type (ID-Parent)", o.n6 + " (" + o.mo + "-" + o.gq + ")"),
            A2(yj, "Chroma format", jpn(a.eu)),
            A2(yj, "Frame rate", jpn(a.lW)),
            A2(yj, "Scanning type", jpn(a.g$)),
            A2(yj, "Cadence", jpn(a.ep)),
            A2(yj, "Active pixels", jpn(a.dW)),
            A2(yj, "Display Aspect Ratio", jpn(a.eS))
        ]));
    }, Wpn = function(n) {
        return A2(ye, w, k([
            ypn(Npn),
            Epn(n),
            Hpn(n),
            Rpn(n),
            zpn(n)
        ]));
    }, Upn = xa({
        bN: "Critical errors reported by automated analysis",
        bT: "Erreurs critiques relev\xe9es par l'analyse automatique"
    }), Qpn = F2(function(n, r) {
        return n + " (" + r + ")";
    }), _pn = xa({
        bN: "Crit\xe8re d\u2019analyse",
        bT: "Crit\xe8re d\u2019analyse"
    }), Zpn = xa({
        bN: " Specified criteria: ",
        bT: " Specified criteria: "
    }), Kpn = Ae("tbody"), Xpn = Kpn(w), Jpn = xa({
        bN: "Localization",
        bT: "Localisation"
    }), Ypn = Ae("code"), Gpn = mC(Ypn), nvn = F2(function(n, r) {
        var t, e, u = (e = d(r.u.hW, r.u.e0)).a.$ ? kt : ht(1 === e.b.$ ? e.a.a : e.a.a + " - " + e.b.a), o = A2(ju, A2(ju, "", r.u.et), r.u.mo), a = (t = A2(Dt, Zpn, r.u.kN)).b && t.b.b && !t.b.b.b ? d(t.a, ht(t.b.a)) : d(r.u.kN, kt), i = a.a, c = a.b;
        return Xpn($(k([
            Bmn(k([
                _mn(ag(o)),
                Qmn(ag(i))
            ]))
        ]), $(function() {
            if (1 === u.$) return w;
            var n = u.a;
            return k([
                Zmn(k([
                    _mn(ag(Jpn)),
                    Qmn(Gpn(n))
                ]))
            ]);
        }(), function() {
            if (1 === c.$) return w;
            var n = c.a;
            return k([
                Zmn(k([
                    _mn(ag(_pn)),
                    Qmn(Gpn(n))
                ]))
            ]);
        }())));
    }), rvn = F3(function(n, r, t) {
        var e = n(t);
        if (e.b) {
            var u = e;
            return ht(A2(vE, w, k([
                wpn(t.n6 + " (" + t.mo + "-" + t.gq + ")"),
                Umn(A2(Ye, nvn(r), u))
            ])));
        }
        return kt;
    }), tvn = F4(function(n, r, t, e) {
        return A2(ye, k([
            Ow("ReportSection")
        ]), k([
            ypn(t),
            A2(bE, w, A2(Kc, Me, A2(Ye, A2(rvn, r, e), uI(n.av))))
        ]));
    }), evn = function(n) {
        var r = Mt(qt(A2(Yu, function(n) {
            return n.bY.lp;
        }, uI(n.av))));
        return A4(tvn, n, function(n) {
            return n.bY.lp;
        }, A2(Qpn, Upn, r), "red");
    }, uvn = xa({
        bN: "File summary",
        bT: "R\xe9sum\xe9 fichier"
    }), ovn = A2(bu, At, rm), avn = F2(function(n, r) {
        var t = jpn(A2(sp, A2(bu, AV, ovn), n.lD.fO)), e = jpn(A2(Lu, Xx, n.lD.qP));
        return A2(ye, w, k([
            A2(yj, "File name", r.n6),
            A2(yj, "Modification date", t),
            A2(yj, "File size", e)
        ]));
    }), ivn = F2(function(n, r) {
        return A2(ye, k([
            Ow("ReportSection")
        ]), k([
            ypn(uvn),
            A2(avn, n, r)
        ]));
    }), cvn = xa({
        bN: "Download the full report (",
        bT: "T\xe9l\xe9charger le rapport complet ("
    }), fvn = F3(function(n, r, t) {
        return 1 === t.$ ? ag("") : Spn({
            m7: cvn + (r + ")"),
            sr: Si(psn(t.a.mo))
        });
    }), svn = xa({
        bN: "Warnings reported by automated analysis",
        bT: "Signalements relev\xe9s par l'analyse automatique"
    }), lvn = function(n) {
        var r = Mt(qt(A2(Yu, function(n) {
            return n.bY.dQ;
        }, uI(n.av))));
        return A4(tvn, n, function(n) {
            return n.bY.dQ;
        }, A2(Qpn, svn, r), "orange");
    }, dvn = F4(function(n, r, t, e) {
        return A2(ye, k([
            Ow("ReportWrapper")
        ]), k([
            A2(ye, k([
                Ow("ReportLinks")
            ]), k([
                A3(fvn, r, "xml", e.gQ),
                A3(fvn, r, "pdf", e.gP),
                Apn(n) ? Spn({
                    m7: Ppn + (e.lD.n6 + " (") + Xx(e.lD.qP) + ")",
                    sr: Si(psn(e.lD.mo))
                }) : ag("")
            ])),
            A2(ivn, t, e.lD),
            A2(IL, w, w),
            Wpn(t),
            A2(IL, w, w),
            evn(t),
            A2(IL, w, w),
            lvn(t)
        ]));
    }), mvn = F3(function(n, r) {
        var t = r.bQ.f$;
        if (1 === t.$) return ag("");
        var e = t.a, u = A2(sp, function(n) {
            return n.bl;
        }, e.lD.sy);
        if (1 === u.$) return ag("");
        var o = u.a.b9;
        return 1 === o.$ ? ag("") : A4(dvn, n, r, o.a, e);
    }), bvn = {
        $: 0
    }, pvn = xa({
        bN: "Processing - downloading stage",
        bT: "En traitement - phase de t\xe9l\xe9chargement"
    }), vvn = xa({
        bN: "Processing - encoding stage",
        bT: "En traitement - phase d'encodage"
    }), $vn = xa({
        bN: "Finished",
        bT: "Termin\xe9"
    }), wvn = xa({
        bN: "Processing - packaging stage",
        bT: "En traitement - phase de packaging"
    }), gvn = xa({
        bN: "Processing - uploading stage",
        bT: "En traitement - phase d'upload"
    }), hvn = xa({
        bN: "Processing - waiting stage",
        bT: "En traitement - phase d'attente"
    }), kvn = function(n) {
        switch(n){
            case 0:
                return hvn;
            case 1:
                return pvn;
            case 2:
                return vvn;
            case 3:
                return wvn;
            case 4:
                return gvn;
            default:
                return $vn;
        }
    }, Cvn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Tvn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Pvn = F2(function(n, r) {
        return A2(ju, Tvn(n), A2(Lu, function(r) {
            return A2(Cvn, n, r);
        }, r));
    }), Svn = xa({
        bN: "Done",
        bT: "Termin\xe9"
    }), Avn = function(n) {
        var r = n.dP, t = !!n.pk.$, e = function() {
            var r = n.pk;
            switch(r.$){
                case 0:
                    return Svn;
                case 1:
                    return (t = r.a) + "...";
                default:
                    var t, e = r.b;
                    return "" === (t = r.a) ? Jz(e) : t + " : " + Jz(e);
            }
        }(), u = !a(n.lo, kt), o = A2(ju, u ? 2 : t ? 1 : r ? 3 : 5, n.I);
        return d(ht(t ? 3 : u ? 1 : r ? 2 : 0), A2(ye, k([
            Ow("FileOperation")
        ]), k([
            A2(ye, k([
                Ow("FileOperationSummary")
            ]), k([
                A2(ye, k([
                    Ow("FileOperationIcon")
                ]), k([
                    a(n.eR, kt) ? zun : Eun
                ])),
                A2(ye, k([
                    Ow("FileOperationIcon")
                ]), k([
                    n.mn
                ])),
                A2(ye, k([
                    Ow("FileOperationLabel")
                ]), k([
                    A2(qg, k([
                        Ow("FileOperationLabelTitle")
                    ]), n.m7),
                    A2(qg, k([
                        Ow("FileOperationLabelProgress")
                    ]), " (" + e + ")")
                ])),
                A2(ye, k([
                    Ow("FileOperationProgress")
                ]), k([
                    Pbn({
                        pk: function() {
                            var r = n.pk;
                            switch(r.$){
                                case 0:
                                    return ht(1);
                                case 2:
                                    return ht(r.b);
                                default:
                                    return kt;
                            }
                        }(),
                        P: o
                    })
                ]))
            ])),
            function() {
                var r = n.lo;
                if (r.$) {
                    var t = n.eR;
                    if (1 === t.$) return ag("");
                    var e = t.a;
                    return A2(ye, k([
                        Ow("FileOperationDetails")
                    ]), k([
                        A2(dg, k([
                            Ow("FileOperationDetailsLabel")
                        ]), k([
                            e.m7
                        ])),
                        Tu(e.dV) ? ag("") : A2(ye, k([
                            Ow("FileOperationDetailsActions")
                        ]), e.dV)
                    ]));
                }
                var u = r.a;
                return A2(ye, k([
                    Ow("FileOperationDetails")
                ]), k([
                    A2(qg, k([
                        Ow("FileOperationDetailsLabel")
                    ]), u)
                ]));
            }()
        ])));
    }, yvn = F2(function(n, r) {
        if (1 === r.$) return d(kt, ag(""));
        var t = r.a.r6;
        if (1 === t.$) return d(kt, ag(""));
        var e = t.a.o2, u = t.a.pk, o = t.a.dP;
        return Avn(5 === e ? {
            eR: kt,
            lo: kt,
            mn: ag(""),
            m7: n,
            pk: bvn,
            I: kt,
            dP: !Tu(o)
        } : {
            eR: kt,
            lo: kt,
            mn: ag(""),
            m7: n,
            pk: A2(Pvn, kvn(e), u),
            I: kt,
            dP: !1
        });
    }), Nvn = xa({
        bN: "Processing",
        bT: "G\xe9n\xe9ration"
    }), Lvn = F2(function(n, r) {
        return A3(Ae, "format-distance", k([
            A2(qI, "startdate", rm(n)),
            A2(qI, "enddate", rm(r))
        ]), k([
            ag("...")
        ]));
    }), jvn = xa({
        bN: "Duration: ",
        bT: "Dur\xe9e : "
    }), Fvn = F2(function(n, r) {
        return A2(ju, Tvn(n), A2(Lu, function(r) {
            return 1 > r ? A2(Cvn, n, r) : bvn;
        }, r));
    }), Mvn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Ivn = xa({
        bN: "Cancel",
        bT: "Annuler"
    }), Dvn = F2(function(n, r) {
        return A2(Pg, Ivn, A2(Mvn, n, r));
    }), Bvn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), xvn = xa({
        bN: "Pause",
        bT: "Pause"
    }), qvn = F2(function(n, r) {
        return A2(Pg, xvn, A2(Bvn, n, r));
    }), Vvn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), Ovn = xa({
        bN: "Resume",
        bT: "Reprendre"
    }), zvn = F3(function(n, r, t) {
        return A2(Pg, Ovn, A3(Vvn, n, r, t));
    }), Evn = F5(function(n, r, t, e, u) {
        if (!a(ht(n.dt), e.dt)) return k([
            A2(Dvn, n, t)
        ]);
        switch(u.$){
            case 0:
                return k([
                    A2(qvn, n, t),
                    A2(Dvn, n, t)
                ]);
            case 1:
            case 4:
            default:
                return w;
            case 2:
                return k([
                    A3(zvn, n, r, t),
                    A2(Dvn, n, t)
                ]);
            case 3:
                return k([
                    A2(Dvn, n, t)
                ]);
        }
    }), Hvn = F2(function(n, r) {
        var t = r.h9;
        if (t.$) {
            var e = r.sk;
            if (1 === e.$) return d(kt, ag(""));
            var u = e.a, o = A3(tE, r.mo, u, n._), i = ht(A2(ju, u.pk, Eo(A2(Kc, function(n) {
                return a(r.mo, n.z) ? ht(n.pk) : kt;
            }, n._)))), c = function() {
                switch(o.$){
                    case 0:
                    case 4:
                        return d(kt, ht(sE(o)));
                    case 1:
                    case 2:
                        return d(ht(4), ht(sE(o)));
                    case 3:
                        return d(ht(0), ht(sE(o)));
                    default:
                        return d(kt, kt);
                }
            }(), f = c.a, s = c.b;
            return Avn({
                eR: function() {
                    if (1 === s.$) return kt;
                    var t = s.a;
                    return ht({
                        dV: A5(Evn, n.e1, n.g9.mo, r, u, o),
                        m7: ag(t)
                    });
                }(),
                lo: u.lo,
                mn: ag(""),
                m7: "Upload",
                pk: A2(Fvn, "", i),
                I: f,
                dP: !1
            });
        }
        var l = t.a;
        return Avn({
            eR: ht({
                dV: w,
                m7: A2(dg, w, k([
                    ag(jvn),
                    A2(Lvn, r.ki, l)
                ]))
            }),
            lo: kt,
            mn: ag(""),
            m7: "Upload",
            pk: bvn,
            I: kt,
            dP: !1
        });
    }), Rvn = xa({
        bN: " errors and ",
        bT: " erreurs et "
    }), Wvn = xa({
        bN: "Nothing to report",
        bT: "Rien \xe0 signaler"
    }), Uvn = xa({
        bN: "Automated analysis",
        bT: "Analyse automatique"
    }), Qvn = xa({
        bN: "Unable to generate the verification report: ",
        bT: "Impossible de g\xe9n\xe9rer le rapport de v\xe9rification : "
    }), _vn = xa({
        bN: " warnings.",
        bT: " avertissements."
    }), Zvn = F7(function(n, r, t, e, u, o, i) {
        var c, f, s, l = function() {
            var r = i.lD.sk;
            if (1 === r.$) return !1;
            var t = r.a;
            return a(ht(n.st.mo), i.lD.sm) && A2(vu, function(n) {
                return !a(n.z, i.lD.mo);
            }, n._) && function() {
                switch(A3(tE, i.lD.mo, t, n._).$){
                    case 2:
                    case 3:
                    case 0:
                    case 1:
                        return !0;
                    default:
                        return !1;
                }
            }();
        }(), b = function() {
            var r = i.lD.sk;
            if (1 === r.$) return !1;
            var t = r.a;
            return a(ht(n.st.mo), i.lD.sm) && function() {
                switch(A3(tE, i.lD.mo, t, n._).$){
                    case 2:
                    case 3:
                        return a(n._, w);
                    default:
                        return !1;
                }
            }();
        }(), v = function(n) {
            var r = n.sy;
            if (1 === r.$) return d(kt, ag(""));
            var t = r.a, e = function() {
                var n = t.bl;
                if (1 === n.$) {
                    var r = t.lo;
                    return 1 === r.$ ? m(A2(Cvn, "", t.pk), kt, kt) : m(bvn, ht($(Qvn, r.a)), ht({
                        dV: w,
                        m7: ag(Wvn)
                    }));
                }
                var e, u = n.a;
                return m(bvn, u.n8 > 0 ? ht($(Mt(u.n8), $(Rvn, $(Mt(u.aq), _vn)))) : kt, (e = u.aq > 0 ? $(Mt(u.aq), _vn) : Wvn, ht({
                    dV: w,
                    m7: ag(e)
                })));
            }(), u = e.a;
            return Avn({
                eR: e.c,
                lo: e.b,
                mn: ag(""),
                m7: Uvn,
                pk: u,
                I: kt,
                dP: !1
            });
        }(i.lD), g = v.a, h = v.b, C = A2(Hvn, n, i.lD), T = C.a, P = C.b, S = A2(yvn, "Proxy", i.pm.nw), A = S.a, y = S.b, N = A2(yvn, "Proxy (hi-res)", i.pm.fo), L = N.a, j = N.b, F = function(n) {
            var r = n.r6;
            if (1 === r.$) return d(kt, ag(""));
            var t = r.a.pk, e = r.a.o2;
            return Avn(5 === e ? {
                eR: kt,
                lo: kt,
                mn: ag(""),
                m7: Nvn,
                pk: bvn,
                I: kt,
                dP: !1
            } : {
                eR: kt,
                lo: kt,
                mn: ag(""),
                m7: Nvn,
                pk: A2(Pvn, kvn(e), t),
                I: kt,
                dP: !1
            });
        }(i.lD), M = F.b, I = $pn(k([
            F.a,
            g,
            A,
            L,
            T
        ])), D = 3 !== I && A2(ju, a(i.lD.sm, kt), A2(Lu, function(n) {
            return !a(n.j2, kt);
        }, i.lD.sk)), B = !!I || A2(pX, i.lD.mo, t.oE), x = function() {
            switch(I){
                case 3:
                    return "FileStatusOperation";
                case 1:
                    return "FileStatusFailure";
                case 2:
                    return "FileStatusWarning";
                default:
                    return "FileStatusSuccess";
            }
        }();
        return A2(ye, k([
            Ow("FileItem")
        ]), k([
            A2(ye, k([
                Ow("FileStatus"),
                Ow(x)
            ]), w),
            A2(ye, k([
                Ow("FileContent")
            ]), A2(mt, A2(ye, k([
                Ow("FileDescription")
            ]), k([
                A2(ye, k([
                    Ow("FileDescriptionTitle")
                ]), k([
                    A2(ye, k([
                        Cg(Gbn(i.lD.mo)),
                        Ow("FileTitle")
                    ]), k([
                        B ? zun : Eun,
                        A2(qg, k([
                            Ow("FileDescriptionTitleName")
                        ]), i.lD.n6)
                    ])),
                    A4(mpn, i.lD, i.pm.nw, u, o),
                    e && 9 === i.lD.c$ ? vI(p(dI, {
                        mn: ht(kg),
                        m7: upn,
                        oy: ht(Ybn(i.lD.mo))
                    })) : ag(""),
                    e && D && sen(i.lD) ? vI(p(dI, {
                        lx: k([
                            A2(qI, "target", "_blank"),
                            A2(qI, "data-prevent-history", "true"),
                            Ow("masterFile")
                        ]),
                        mn: ht(Lun),
                        bf: !0,
                        m7: opn + " (" + Xx(i.lD.qP) + ")",
                        sr: ht(Si(psn(i.lD.mo)))
                    })) : ag("")
                ])),
                A2(ye, k([
                    Ow("FileDescriptionDetails")
                ]), k([
                    (s = Psn(i.lD), ag(1 === s.$ ? "" : wsn(s.a) + " - ")),
                    ag(vsn(i.lD.qP)),
                    ag(" "),
                    IP(i.lD.ki)
                ]))
            ])), B ? k([
                M,
                tpn(n) ? A2(ye, k([
                    Cg(rpn(i.lD))
                ]), k([
                    h
                ])) : ag(""),
                (f = A2(di, i.lD.mo, t.pG), f.$ ? ag("") : f.a && a(ht(i.lD.mo), A2(Lu, function(n) {
                    return n.lD.mo;
                }, r.bQ.f$)) ? A3(mvn, n, r, {}) : ag("")),
                (c = i.pm.nw, 1 === c.$ ? ag("") : A2(ye, k([
                    Cg(A2(npn, c.a.mo, "lowRes"))
                ]), k([
                    y
                ]))),
                function() {
                    var n = i.pm.nw;
                    if (1 === n.$) return ag("");
                    var r = n.a, e = A2(di, r.mo + "-lowRes", t.pn);
                    return e.$ ? ag("") : e.a ? A2(Tpn, r, Fsn(i)) : ag("");
                }(),
                function() {
                    if (n.st.iz) {
                        var r = i.pm.fo;
                        return 1 === r.$ ? ag("") : A2(ye, k([
                            Cg(A2(npn, r.a.mo, "hiRes"))
                        ]), k([
                            j
                        ]));
                    }
                    return ag("");
                }(),
                function() {
                    var n = i.pm.fo;
                    if (1 === n.$) return ag("");
                    var r = n.a, e = A2(di, r.mo + "-hiRes", t.pn);
                    return e.$ ? ag("") : e.a ? A2(Tpn, r, Fsn(i)) : ag("");
                }(),
                P,
                function() {
                    if (b) return B8(epn);
                    if (l) return B8(ppn);
                    if (A2(MD, i.lD.mo, t.lp)) {
                        var n = A2(di, i.lD.mo, t.lp);
                        return sk(1 === n.$ ? bpn : n.a);
                    }
                    return ag("");
                }()
            ]) : w))
        ]));
    }), Kvn = F5(function(n, r, t, e, u) {
        var o, a = t.lD, i = t.av, c = 1 === (o = A2(Lu, function(n) {
            return n.fb;
        }, t.a6)).$ ? "?" : o.a, f = p(r.i7, {
            e_: !1
        }), s = A3(xt, F2(function(n, r) {
            var t = r.a, e = r.b, u = r.c;
            switch(n.$){
                case 0:
                    return m(A2(mt, n.a, t), e, u);
                case 1:
                    return m(t, A2(mt, n.a, e), u);
                default:
                    return m(t, e, u);
            }
        }), m(w, w, w), i), l = s.a, b = A2(Ye, function(n) {
            var r, t, e, u = 1 === (r = n.g$).$ ? "" : A2(Ee, 1, r.a), o = 1 === (t = n.nf).$ ? "N/A" : Mt(t.a), a = 1 === (e = n.cA).$ ? "" : " (" + e.a + ")", i = "@" + A2(ju, "N/A", A2(Lu, Ubn, n.ah));
            return {
                kM: k([
                    d("Codec", n.aE),
                    d(Edn, Rbn(n)),
                    d(_bn, Mt(n.ig) + "x" + (Mt(n.fm) + (i + a))),
                    d("Framerate", $(by(u0(n)), u)),
                    d(Qbn, o),
                    d("Profil", A2(ju, "N/A", n.gG)),
                    d("Aspect Ratio", by(Ebn(n)) + ":1")
                ]),
                mn: Xbn,
                rW: "video stream " + A3(Kd, 2, "0", Mt(n.fv))
            };
        }, l);
        return A3(Wbn, r, {
            jL: $(A2(Ye, Jbn(r), b), k([
                A2(mh, t_, A5(Jmn, n, f, e, !1, ht(b4(-1))))
            ])),
            kM: k([
                d("Type", c),
                d(Edn, A2(ju, "N/A", A2(Lu, Rbn, Eo(l)))),
                d("Start Timecode", A2(ju, "N/A", ybn(t)))
            ]),
            lA: kt,
            mn: Xbn,
            mo: a.mo,
            c$: a.c$,
            qP: a.qP,
            hv: a.hv,
            rW: a.n6,
            sk: a.sk,
            sr: Si(psn(a.mo))
        }, function() {
            var t = u.bQ.f$;
            if (t.$) return ag("");
            var e = t.a;
            return A2(mh, S1, A7(Zvn, n, u, r.bQ, Zbn(n) || Kbn(n), kt, kt, e));
        }());
    }), Xvn = xa({
        bN: "Main file",
        bT: "Fichier principal"
    }), Jvn = xa({
        bN: "Download all",
        bT: "Tout t\xe9l\xe9charger"
    }), Yvn = xa({
        bN: "Hide details",
        bT: "Masquer les d\xe9tails"
    }), Gvn = xa({
        bN: "Show details",
        bT: "Afficher les d\xe9tails"
    }), n$n = function(n) {
        return hT(gT(n));
    }, r$n = xa({
        bN: "subtitles",
        bT: "Sous-titres"
    }), t$n = function(n) {
        return {
            $: 31,
            a: n
        };
    }, e$n = xa({
        bN: "Hide",
        bT: "Masquer"
    }), u$n = xa({
        bN: "Show",
        bT: "Afficher"
    }), o$n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, a$n = xa({
        bN: "Subtitle analysis",
        bT: "Analyse des sous-titres"
    }), i$n = F2(function(n, r) {
        var t, e, u = Avn({
            eR: kt,
            lo: kt,
            mn: ag(""),
            m7: a$n,
            pk: bvn,
            I: kt,
            dP: !Tu(r.hH)
        }), o = u.b, a = $pn(k([
            u.a
        ])), i = function() {
            switch(a){
                case 3:
                    return "FileStatusOperation";
                case 1:
                    return "FileStatusFailure";
                case 2:
                    return "FileStatusWarning";
                default:
                    return "FileStatusSuccess";
            }
        }();
        return A2(ye, k([
            Ow("FileItem")
        ]), k([
            A2(ye, k([
                Ow("FileStatus"),
                Ow(i)
            ]), w),
            A2(ye, k([
                Ow("FileContent")
            ]), k([
                A2(ye, k([
                    Cg(o$n(r.lD))
                ]), k([
                    o
                ])),
                (e = A2(di, r.lD.mo, n.hH), e.$ ? ag("") : e.a ? Tu((t = r).hH) ? ag("") : A2(ye, k([
                    Ow("FileOperationWarning")
                ]), k([
                    wpn("Warnings"),
                    Umn($(k([
                        Bmn(k([
                            _mn(ag("Warning")),
                            _mn(ag("Timecode"))
                        ]))
                    ]), A2(Ye, function(n) {
                        return A2(Lh, k([
                            Ow("TranscodeWarning")
                        ]), k([
                            A2(uk, k([
                                Ow("TranscodeWarningField")
                            ]), k([
                                ag(n.n6)
                            ])),
                            A2(uk, k([
                                Ow("TranscodeWarningField")
                            ]), k([
                                ag(n.hY)
                            ]))
                        ]));
                    }, t.hH)))
                ])) : ag(""))
            ]))
        ]));
    }), c$n = F4(function(n, r, t, e) {
        var u, o, i, c, f = A2(Lu, Kk, e.sz), s = A2(Lu, EL, e.r9);
        return A2(ye, k([
            Ow("MasterFilesAudioStream")
        ]), k([
            A2(ye, k([
                Ow("MasterFilesHeader")
            ]), k([
                Udn,
                A2(qg, k([
                    Ow("MasterFilesTitle")
                ]), e.rW),
                A2(ye, k([
                    Ow("MasterQualify")
                ]), k([
                    A2(Ck, qg(k([
                        Ow("MasterQualifyItem")
                    ])), f),
                    A2(Ck, qg(k([
                        Ow("MasterQualifyItem")
                    ])), s),
                    A2(ye, k([
                        Ow("PlayAudio")
                    ]), k([
                        5 === e.o2 ? vI(p(dI, {
                            mn: ht(dpn),
                            m7: function() {
                                var n = r.o3;
                                return n.$ ? u$n : a(n.a.rp, e.gL) ? e$n : u$n;
                            }(),
                            oy: ht(t$n((c = r.o3, c.$ ? e.gL : a(c.a.rp, e.gL) ? kt : e.gL)))
                        })) : ag("")
                    ]))
                ]))
            ])),
            A2(DL, !Tu(t.hH), A2(ye, k([
                Ow("MasterFilesAsset")
            ]), k([
                A2(mh, S1, A2(i$n, r.bQ, t))
            ]))),
            A2(ye, k([
                Ow("MasterFilesDesc")
            ]), (u = Kmn(e.kM), o = u.a, i = u.b, k([
                Umn(k([
                    Bmn(A2(Ye, A2(bu, _mn, ag), o)),
                    Zmn(A2(Ye, A2(bu, Qmn, ag), i))
                ]))
            ])))
        ]));
    }), f$n = F3(function(n, r, t) {
        var e, u, o = t.lD, a = t.av, i = t.pm, c = A2(sp, function(n) {
            return 2 === n.$ ? n.a.sz : kt;
        }, Eo(a)), f = A2(sp, function(n) {
            return 2 === n.$ ? n.a.r9 : kt;
        }, Eo(a)), s = A2(ju, {
            e8: kt,
            lW: kt,
            fN: kt,
            q5: kt,
            hE: kt
        }, A2(Lu, function(n) {
            if (2 === n.$) {
                var r = n.a;
                return {
                    e8: r.e8,
                    lW: A3(Ay, F2(function(n, r) {
                        return qf(1e3 * n / r) / 1e3;
                    }), r.ff, r.fe),
                    fN: r.fN,
                    q5: r.q5,
                    hE: r.hE
                };
            }
            return {
                e8: kt,
                lW: kt,
                fN: kt,
                q5: kt,
                hE: kt
            };
        }, Eo(a))), l = s.lW, m = s.q5, b = s.e8, p = s.fN, v = s.hE, $ = 1 === (e = A2(Lu, function(n) {
            return n.fb;
        }, t.a6)).$ ? A2(ju, "?", v) : e.a, g = (u = A2(Lu, function(e) {
            var u;
            return A4(c$n, n, r, t, {
                kM: k([
                    d("Type", $),
                    d("Framerate", A2(ju, "N/A", A2(Lu, by, l))),
                    d("Start Timecode", A2(ju, "N/A", m)),
                    d("First Subtitle Timecode", A2(ju, "N/A", b)),
                    d("Last Subtitle Timecode", A2(ju, "N/A", p))
                ]),
                mn: Udn,
                fL: o.mo,
                o2: (u = e.r6, u.$ ? 0 : u.a.o2),
                gL: A2(Lu, function(n) {
                    return n.mo;
                }, i.nw),
                rW: r$n,
                r9: f,
                sz: c
            });
        }, i.nw)).$ ? w : Wo(u.a);
        return A7(Sbn, r.qF, A3($bn, n.st, n.g9.oM, A2(Ye, function(n) {
            return n.fB;
        }, n.fD)), r, n.st, {
            jL: g,
            kM: w,
            lA: kt,
            mn: Vdn,
            mo: o.mo,
            c$: o.c$,
            qP: o.qP,
            hv: o.hv,
            rW: o.n6,
            sk: o.sk,
            sr: Si(psn(o.mo))
        }, "subtitleFile", ag(""));
    }), s$n = F5(function(n, r, t, e, u) {
        var o = A2(n$n, A2(Pi, function(n) {
            return n.lD;
        }, function(n) {
            return n.n6;
        }), u.bQ.ad), i = A2(n$n, A2(Pi, function(n) {
            return n.lD;
        }, function(n) {
            return n.n6;
        }), u.bQ.d7), c = Zbn(t) || Kbn(t);
        return A2(ye, k([
            Ow("MasterFilesWrapper")
        ]), k([
            A2(dbn, !a(u.bQ.f$, kt), A2(ye, k([
                Ow("ReversedLayout")
            ]), k([
                nq(Xvn),
                vI(p(dI, {
                    mn: ht(BI),
                    mK: r.qD,
                    m7: r.qD ? Yvn : Gvn,
                    oy: ht(bbn)
                }))
            ]))),
            function() {
                var n = u.bQ.f$;
                return n.$ ? ag("") : A2(ye, w, k([
                    A5(Kvn, t, r, n.a, e, u)
                ]));
            }(),
            A2(dbn, !a(u.bQ.d7, w), Jx(k([
                nq(zbn),
                A2(DL, c, vI(p(dI, {
                    mn: ht(Lun),
                    m7: Jvn,
                    oy: ht(mbn("audioFile"))
                }))),
                Cln,
                vI(p(dI, {
                    mn: ht(BI),
                    mK: r.qE,
                    m7: r.qE ? Yvn : Gvn,
                    oy: ht(pbn)
                }))
            ]))),
            A2(dbn, !a(u.bQ.d7, w), A2(ye, w, A2(Ye, A3(Obn, n, t, r), i))),
            A2(dbn, !a(u.bQ.ad, w), Jx(k([
                nq(r$n),
                A2(DL, c, vI(p(dI, {
                    mn: ht(Lun),
                    m7: Jvn,
                    oy: ht(mbn("subtitleFile"))
                }))),
                Cln,
                vI(p(dI, {
                    mn: ht(BI),
                    mK: r.qF,
                    m7: r.qF ? Yvn : Gvn,
                    oy: ht(vbn)
                }))
            ]))),
            A2(dbn, !a(u.bQ.ad, w), A2(ye, w, A2(Ye, A2(f$n, t, r), o)))
        ]));
    }), l$n = function(n) {
        var r = n.pm.nw;
        if (r.$) return !1;
        var t = r.a.r6;
        return !t.$ && 5 === t.a.o2;
    }, d$n = F2(function(n, r) {
        return A2(ju, w, Eo(A2(Ye, function(n) {
            return n.av;
        }, A2(Mu, A2(Pi, function(n) {
            return n.pm;
        }, A2(Pi, function(n) {
            return n.nw;
        }, F2(function(n, r) {
            return A2(ju, !1, A2(Lu, function(r) {
                return a(n, ht(r.mo));
            }, r));
        })(n))), A2(Mu, l$n, r)))));
    }), m$n = function(n) {
        return A2(Ye, function(n) {
            return {
                a6: kt,
                kI: w,
                lD: n.lD,
                pm: {
                    fo: kt,
                    nw: n.gL
                },
                gP: kt,
                gQ: kt,
                g3: n.g3,
                av: w,
                hH: w
            };
        }, A2(hT, gT(A2(Pi, function(n) {
            return n.lD;
        }, function(n) {
            return n.n6;
        })), n.bP));
    }, b$n = function(n) {
        return A2(sp, A2(Pi, function(n) {
            return n.pm;
        }, function(n) {
            return n.nw;
        }), n.bQ.f$);
    }, p$n = function(n) {
        if (n.$) return !1;
        var r = n.a.r6;
        return !r.$ && 5 === r.a.o2;
    }, v$n = {
        $: 0
    }, $$n = {
        $: 32
    }, w$n = prn(k([
        A2(_w, k([
            Fw("Fg"),
            Rw("6 5 12 9 6 13")
        ]), w)
    ])), g$n = xa({
        bN: "Play",
        bT: "Play"
    }), h$n = xa({
        bN: "Audios(s)",
        bT: "Audio(s)"
    }), k$n = xa({
        bN: "Video format",
        bT: "Format Video"
    }), C$n = xa({
        bN: "Main file specifications",
        bT: "Description technique du fichier principal"
    }), T$n = xa({
        bN: " audio stream(s)",
        bT: " stream(s) audio(s)"
    }), P$n = k([
        d(2997, 100),
        d(3e4, 1001),
        d(5994, 100),
        d(6e4, 1001)
    ]), S$n = F2(function(n, r) {
        var t, e = A2(Y$, d(n.at, n.as), P$n) ? A2(Be, ";", r) ? "DF" : "NDF" : "", u = function() {
            var r = n.cA;
            return 1 === r.$ ? "" : " (" + r.a + ")";
        }(), o = "@" + A2(ju, "N/A", A2(Lu, Ubn, n.ah));
        return A2(It, " \u2022 ", k([
            (t = n.ai, t.toUpperCase()),
            Mt(n.ig) + "x" + (Mt(n.fm) + (o + u)),
            by(u0(n)) + " fps " + e,
            by(Ebn(n)) + ":1"
        ]));
    }), A$n = F4(function(n, r, t, e) {
        var u = A2(Ra, function(n) {
            return n.bb;
        }, t), o = n.at / n.as, a = function(r) {
            return D5(r) + " (" + A2(Hbn, n, (1 + r.bc - r.bb) / o) + ")";
        };
        return A2(ye, k([
            Ow("PlayerFoldInfos")
        ]), k([
            A2(ye, k([
                Ow("PlayerFoldInfosTitle")
            ]), k([
                ag(C$n)
            ])),
            A2(ye, k([
                Ow("PlayerFoldInfo")
            ]), k([
                A2(qg, k([
                    Ow("PlayerFoldInfoLabel")
                ]), k$n),
                A2(qg, k([
                    Ow("PlayerFoldInfoValue")
                ]), A2(S$n, n, e))
            ])),
            A2(ye, k([
                Ow("PlayerFoldInfo")
            ]), k([
                A2(qg, k([
                    Ow("PlayerFoldInfoLabel")
                ]), Edn),
                A2(qg, k([
                    Ow("PlayerFoldInfoValue")
                ]), Rbn(n))
            ])),
            A2(ye, k([
                Ow("PlayerFoldInfo")
            ]), k([
                A2(qg, k([
                    Ow("PlayerFoldInfoLabel")
                ]), h$n),
                A2(ye, k([
                    Ow("PlayerFoldInfoValues")
                ]), k([
                    A2(qg, k([
                        Ow("PlayerFoldInfoValue")
                    ]), $(Mt(qt(r)), T$n))
                ]))
            ])),
            Tu(t) ? ag("") : A2(ye, k([
                Ow("PlayerFoldInfo")
            ]), k([
                A2(qg, k([
                    Ow("PlayerFoldInfoLabel")
                ]), zin),
                A2(ye, k([
                    Ow("PlayerFoldInfoValues")
                ]), A2(Ye, A2(bu, qg(k([
                    Ow("PlayerFoldInfoValue")
                ])), a), u))
            ]))
        ]));
    }), y$n = {
        $: 8
    }, N$n = {
        $: 7
    }, L$n = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), j$n = {
        $: 3
    }, F$n = {
        $: 2
    }, M$n = {
        $: 4
    }, I$n = {
        $: 5
    }, D$n = function(n) {
        return {
            $: 10,
            a: n
        };
    }, B$n = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), x$n = A2(Zw, k([
        Hw("1080"),
        Xw("1920"),
        Kw("0 0 1920 1080")
    ]), k([
        A2(Wrn, k([
            _8("#74F7FF"),
            Hw("3"),
            Xw("1920"),
            Qrn("22")
        ]), w),
        A2(Wrn, k([
            _8("#70FF00"),
            Hw("3"),
            Xw("1920"),
            Qrn("133")
        ]), w),
        A2(Wrn, k([
            _8("#FF4BF8"),
            Hw("3"),
            Xw("1920"),
            Qrn("140")
        ]), w),
        A2(Wrn, k([
            _8("#FF4BF8"),
            Hw("3"),
            Xw("1920"),
            Qrn("940")
        ]), w),
        A2(Wrn, k([
            _8("#70FF00"),
            Hw("3"),
            Xw("1920"),
            Qrn("947")
        ]), w),
        A2(Wrn, k([
            _8("#74F7FF"),
            Hw("3"),
            Xw("1920"),
            Qrn("1058")
        ]), w),
        A2(Wrn, k([
            _8("#74F7FF"),
            Hw("31"),
            Xw("58"),
            Qrn("22")
        ]), w),
        A2(Wrn, k([
            _8("#70FF00"),
            Hw("31"),
            Xw("58"),
            Qrn("105")
        ]), w),
        A2(Wrn, k([
            _8("#FF4BF8"),
            Hw("31"),
            Xw("58"),
            Qrn("140")
        ]), w),
        A2(iC, k([
            aC("M13.6935 43H10.783V31.0332L7.30859 32.1826V29.6582L13.3813 27.3379H13.6935V43ZM18.7389 41.4746C18.7389 40.9805 18.8933 40.5794 19.2022 40.2715C19.5178 39.9635 19.9105 39.8096 20.3805 39.8096C20.8572 39.8096 21.2499 39.9635 21.5587 40.2715C21.8743 40.5794 22.0321 40.9805 22.0321 41.4746C22.0321 41.9616 21.8777 42.359 21.5689 42.667C21.26 42.9678 20.8639 43.1182 20.3805 43.1182C19.9038 43.1182 19.511 42.9678 19.2022 42.667C18.8933 42.359 18.7389 41.9616 18.7389 41.4746ZM34.0265 31.5166C34.0265 32.2757 33.8485 32.9489 33.4926 33.5361C33.1369 34.1234 32.6467 34.5924 32.0224 34.9434C32.734 35.3086 33.298 35.8135 33.7143 36.458C34.1305 37.0954 34.3386 37.8473 34.3386 38.7139C34.3386 40.1032 33.8955 41.2025 33.0093 42.0117C32.123 42.8138 30.9179 43.2148 29.3939 43.2148C27.8698 43.2148 26.6613 42.8102 25.7684 42.001C24.8754 41.1917 24.429 40.096 24.429 38.7139C24.429 37.8473 24.6371 37.0918 25.0534 36.4473C25.4696 35.8027 26.0302 35.3014 26.7351 34.9434C26.1108 34.5924 25.6206 34.1234 25.2649 33.5361C24.9157 32.9489 24.7412 32.2757 24.7412 31.5166C24.7412 30.1846 25.1574 29.1247 25.9899 28.3369C26.8224 27.542 27.9537 27.1445 29.3838 27.1445C30.8071 27.1445 31.9351 27.5384 32.7676 28.3262C33.6068 29.1068 34.0265 30.1702 34.0265 31.5166ZM31.418 38.4883C31.418 37.8079 31.2335 37.2637 30.8642 36.8555C30.4949 36.4473 29.9981 36.2432 29.3737 36.2432C28.756 36.2432 28.2626 36.4473 27.8933 36.8555C27.524 37.2565 27.3395 37.8008 27.3395 38.4883C27.3395 39.1543 27.5207 39.6914 27.8832 40.0996C28.2458 40.5078 28.7494 40.7119 29.3939 40.7119C30.0249 40.7119 30.5184 40.515 30.8743 40.1211C31.2368 39.7272 31.418 39.1829 31.418 38.4883ZM31.116 31.667C31.116 31.0583 30.9649 30.5713 30.6628 30.2061C30.3606 29.8337 29.9344 29.6475 29.3838 29.6475C28.8399 29.6475 28.417 29.8265 28.1149 30.1846C27.8127 30.5426 27.6617 31.0368 27.6617 31.667C27.6617 32.29 27.8127 32.7913 28.1149 33.1709C28.417 33.5505 28.8433 33.7402 29.3939 33.7402C29.9444 33.7402 30.3674 33.5505 30.6628 33.1709C30.9649 32.7913 31.116 32.29 31.116 31.667ZM36.7456 35.3086L37.5915 27.3594H45.8092V29.9482H39.9783L39.6157 33.3105C40.3072 32.9167 41.0424 32.7197 41.8212 32.7197C43.2177 32.7197 44.312 33.1816 45.1043 34.1055C45.8965 35.0293 46.2927 36.3219 46.2927 37.9834C46.2927 38.9932 46.0912 39.8991 45.6884 40.7012C45.2923 41.4961 44.7216 42.1156 43.9763 42.5596C43.2311 42.9964 42.3516 43.2148 41.3378 43.2148C40.4516 43.2148 39.6291 43.0251 38.8705 42.6455C38.1118 42.2588 37.511 41.7181 37.0678 41.0234C36.6314 40.3288 36.3997 39.5374 36.3729 38.6494H39.2532C39.3136 39.3011 39.5251 39.8096 39.8876 40.1748C40.2569 40.5329 40.7369 40.7119 41.3278 40.7119C41.9857 40.7119 42.4926 40.4613 42.8484 39.96C43.2043 39.4515 43.3822 38.7354 43.3822 37.8115C43.3822 36.9235 43.1774 36.2432 42.7679 35.7705C42.3583 35.2979 41.7776 35.0615 41.0256 35.0615C40.3341 35.0615 39.7735 35.2549 39.3438 35.6416L39.0619 35.9209L36.7456 35.3086Z"),
            _8("black")
        ]), w),
        A2(iC, k([
            aC("M16.6709 125H6.62018V122.873L11.3635 117.48C12.0148 116.721 12.4949 116.059 12.8037 115.493C13.1192 114.927 13.277 114.39 13.277 113.882C13.277 113.187 13.1125 112.643 12.7835 112.249C12.4545 111.848 11.9846 111.648 11.3736 111.648C10.7157 111.648 10.1954 111.891 9.81267 112.378C9.43664 112.858 9.24866 113.492 9.24866 114.279H6.32812C6.32812 113.327 6.53962 112.457 6.96259 111.669C7.39227 110.881 7.99653 110.265 8.77533 109.821C9.55411 109.37 10.437 109.145 11.424 109.145C12.9345 109.145 14.1061 109.531 14.9386 110.305C15.7779 111.078 16.1975 112.17 16.1975 113.581C16.1975 114.354 16.0095 115.142 15.6335 115.944C15.2576 116.746 14.613 117.681 13.6999 118.748L10.3665 122.497H16.6709V125ZM18.7353 123.475C18.7353 122.98 18.8897 122.579 19.1986 122.271C19.5142 121.964 19.9069 121.81 20.3769 121.81C20.8536 121.81 21.2463 121.964 21.5551 122.271C21.8707 122.579 22.0285 122.98 22.0285 123.475C22.0285 123.962 21.8741 124.359 21.5653 124.667C21.2565 124.968 20.8603 125.118 20.3769 125.118C19.9002 125.118 19.5075 124.968 19.1986 124.667C18.8897 124.359 18.7353 123.962 18.7353 123.475ZM27.4264 115.805H28.9773C29.7159 115.805 30.2631 115.608 30.6189 115.214C30.9748 114.82 31.1526 114.297 31.1526 113.646C31.1526 113.015 30.9748 112.525 30.6189 112.174C30.2698 111.823 29.7864 111.648 29.1687 111.648C28.6114 111.648 28.1448 111.812 27.7689 112.142C27.3929 112.464 27.2049 112.886 27.2049 113.409H24.2944C24.2944 112.593 24.4992 111.862 24.9088 111.218C25.325 110.566 25.9024 110.058 26.6409 109.692C27.3862 109.327 28.2053 109.145 29.0982 109.145C30.6491 109.145 31.8644 109.542 32.7438 110.337C33.6234 111.125 34.0631 112.213 34.0631 113.603C34.0631 114.319 33.8583 114.978 33.4488 115.579C33.0392 116.181 32.5021 116.643 31.8375 116.965C32.6633 117.28 33.2775 117.753 33.6804 118.383C34.09 119.013 34.2947 119.758 34.2947 120.617C34.2947 122.007 33.818 123.12 32.8647 123.958C31.9181 124.796 30.6626 125.215 29.0982 125.215C27.6345 125.215 26.4361 124.803 25.503 123.979C24.5764 123.156 24.1132 122.067 24.1132 120.714H27.0236C27.0236 121.301 27.2284 121.781 27.6379 122.153C28.0542 122.526 28.5645 122.712 29.1687 122.712C29.8603 122.712 30.4007 122.519 30.7901 122.132C31.1863 121.738 31.3843 121.219 31.3843 120.574C31.3843 119.013 30.5786 118.232 28.9673 118.232H27.4264V115.805ZM36.742 117.309L37.5879 109.359H45.8056V111.948H39.9747L39.6121 115.311C40.3036 114.917 41.0388 114.72 41.8176 114.72C43.2141 114.72 44.3085 115.182 45.1007 116.105C45.8929 117.029 46.2891 118.322 46.2891 119.983C46.2891 120.993 46.0876 121.899 45.6848 122.701C45.2887 123.496 44.718 124.116 43.9727 124.56C43.2275 124.996 42.348 125.215 41.3342 125.215C40.448 125.215 39.6255 125.025 38.8669 124.646C38.1082 124.259 37.5074 123.718 37.0642 123.023C36.6278 122.329 36.3961 121.537 36.3693 120.649H39.2496C39.31 121.301 39.5215 121.81 39.884 122.175C40.2533 122.533 40.7333 122.712 41.3242 122.712C41.9821 122.712 42.489 122.461 42.8448 121.96C43.2007 121.451 43.3786 120.735 43.3786 119.812C43.3786 118.924 43.1738 118.243 42.7643 117.771C42.3547 117.298 41.774 117.062 41.022 117.062C40.3305 117.062 39.7699 117.255 39.3402 117.642L39.0583 117.921L36.742 117.309Z"),
            _8("black")
        ]), w),
        A2(iC, k([
            aC("M16.6709 163H6.62018V160.873L11.3635 155.48C12.0148 154.721 12.4949 154.059 12.8037 153.493C13.1192 152.927 13.277 152.39 13.277 151.882C13.277 151.187 13.1125 150.643 12.7835 150.249C12.4545 149.848 11.9846 149.647 11.3736 149.647C10.7157 149.647 10.1954 149.891 9.81267 150.378C9.43664 150.858 9.24866 151.492 9.24866 152.279H6.32812C6.32812 151.327 6.53962 150.457 6.96259 149.669C7.39227 148.881 7.99653 148.265 8.77533 147.821C9.55411 147.37 10.437 147.145 11.424 147.145C12.9345 147.145 14.1061 147.531 14.9386 148.305C15.7779 149.078 16.1975 150.17 16.1975 151.581C16.1975 152.354 16.0095 153.142 15.6335 153.944C15.2576 154.746 14.613 155.681 13.6999 156.748L10.3665 160.497H16.6709V163ZM18.7353 161.475C18.7353 160.98 18.8897 160.579 19.1986 160.271C19.5142 159.964 19.9069 159.81 20.3769 159.81C20.8536 159.81 21.2463 159.964 21.5551 160.271C21.8707 160.579 22.0285 160.98 22.0285 161.475C22.0285 161.962 21.8741 162.359 21.5653 162.667C21.2565 162.968 20.8603 163.118 20.3769 163.118C19.9002 163.118 19.5075 162.968 19.1986 162.667C18.8897 162.359 18.7353 161.962 18.7353 161.475ZM27.4264 153.805H28.9773C29.7159 153.805 30.2631 153.608 30.6189 153.214C30.9748 152.82 31.1526 152.297 31.1526 151.646C31.1526 151.015 30.9748 150.525 30.6189 150.174C30.2698 149.823 29.7864 149.647 29.1687 149.647C28.6114 149.647 28.1448 149.812 27.7689 150.142C27.3929 150.464 27.2049 150.886 27.2049 151.409H24.2944C24.2944 150.593 24.4992 149.862 24.9088 149.218C25.325 148.566 25.9024 148.058 26.6409 147.692C27.3862 147.327 28.2053 147.145 29.0982 147.145C30.6491 147.145 31.8644 147.542 32.7438 148.337C33.6234 149.125 34.0631 150.213 34.0631 151.603C34.0631 152.319 33.8583 152.978 33.4488 153.579C33.0392 154.181 32.5021 154.643 31.8375 154.965C32.6633 155.28 33.2775 155.753 33.6804 156.383C34.09 157.013 34.2947 157.758 34.2947 158.617C34.2947 160.007 33.818 161.12 32.8647 161.958C31.9181 162.796 30.6626 163.215 29.0982 163.215C27.6345 163.215 26.4361 162.803 25.503 161.979C24.5764 161.156 24.1132 160.067 24.1132 158.714H27.0236C27.0236 159.301 27.2284 159.781 27.6379 160.153C28.0542 160.526 28.5645 160.712 29.1687 160.712C29.8603 160.712 30.4007 160.519 30.7901 160.132C31.1863 159.738 31.3843 159.219 31.3843 158.574C31.3843 157.013 30.5786 156.232 28.9673 156.232H27.4264V153.805ZM43.1168 156.748C42.3581 157.543 41.4719 157.94 40.458 157.94C39.1623 157.94 38.125 157.468 37.3462 156.522C36.5674 155.57 36.178 154.288 36.178 152.677C36.178 151.653 36.3861 150.715 36.8024 149.862C37.2254 149.003 37.8128 148.337 38.5648 147.864C39.3167 147.384 40.1626 147.145 41.1026 147.145C42.0694 147.145 42.9287 147.402 43.6807 147.918C44.4327 148.434 45.0168 149.175 45.4331 150.142C45.8493 151.108 46.0608 152.215 46.0675 153.461V154.61C46.0675 157.217 45.4599 159.265 44.2447 160.755C43.0295 162.244 41.3074 163.039 39.0783 163.14L38.3634 163.15V160.562L39.0079 160.551C41.539 160.429 42.9087 159.161 43.1168 156.748ZM41.1731 155.566C41.643 155.566 42.0459 155.438 42.3816 155.18C42.724 154.922 42.9825 154.61 43.157 154.245V152.967C43.157 151.914 42.969 151.098 42.5931 150.518C42.2171 149.938 41.7135 149.647 41.0824 149.647C40.4984 149.647 40.0184 149.934 39.6423 150.507C39.2664 151.073 39.0783 151.785 39.0783 152.645C39.0783 153.497 39.2596 154.199 39.6222 154.75C39.9915 155.294 40.5084 155.566 41.1731 155.566Z"),
            _8("black")
        ]), w)
    ])), q$n = lpn(k([
        A2(Wrn, k([
            Fw("Fg"),
            Hw("1"),
            Xw("18"),
            Urn("0"),
            Qrn("2")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("1"),
            Xw("18"),
            Urn("0"),
            Qrn("4")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("1"),
            Xw("18"),
            Urn("0"),
            Qrn("12")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("1"),
            Xw("18"),
            Urn("0"),
            Qrn("14")
        ]), w)
    ])), V$n = lpn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M5.04443 10.3306H1.81641V8.92871H5.04443V10.3306ZM9.34238 13H7.52695V7.2207L5.74375 7.7417V6.3667L9.17588 5.17969H9.34238V13ZM13.6726 11.3672C13.6726 11.2132 13.592 11.0897 13.4309 10.9966C13.2697 10.9035 12.9636 10.8068 12.5124 10.7065C12.0612 10.6063 11.6888 10.4756 11.3952 10.3145C11.1016 10.1497 10.8778 9.95101 10.7238 9.71826C10.5699 9.48551 10.4929 9.21875 10.4929 8.91797C10.4929 8.38444 10.7131 7.9458 11.1535 7.60205C11.5939 7.25472 12.1704 7.08105 12.883 7.08105C13.6493 7.08105 14.2652 7.25472 14.7307 7.60205C15.1962 7.94938 15.4289 8.40592 15.4289 8.97168H13.6135C13.6135 8.50618 13.3682 8.27344 12.8776 8.27344C12.6879 8.27344 12.5285 8.32715 12.3996 8.43457C12.2707 8.53841 12.2063 8.66911 12.2063 8.82666C12.2063 8.98779 12.285 9.11849 12.4426 9.21875C12.6001 9.31901 12.8508 9.40137 13.1945 9.46582C13.5419 9.53027 13.8462 9.60726 14.1076 9.69678C14.9813 9.99756 15.4182 10.5365 15.4182 11.3135C15.4182 11.8434 15.1818 12.2749 14.7092 12.6079C14.2401 12.9409 13.6314 13.1074 12.883 13.1074C12.3853 13.1074 11.9413 13.0179 11.551 12.8389C11.1607 12.6598 10.8563 12.4163 10.6379 12.1084C10.4195 11.8005 10.3103 11.4764 10.3103 11.1362H12.0021C12.0093 11.4048 12.0988 11.6017 12.2707 11.7271C12.4426 11.8488 12.6628 11.9097 12.9313 11.9097C13.1784 11.9097 13.3628 11.8595 13.4846 11.7593C13.6099 11.659 13.6726 11.5283 13.6726 11.3672Z")
        ]), w)
    ])), O$n = xa({
        bN: "Back 1s",
        bT: "Retour 1s en arri\xe8re"
    }), z$n = lpn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M4.04443 10.3306H0.816406V8.92871H4.04443V10.3306ZM5.5376 9.17578L6.01562 5.17969H10.5864V6.58691H7.4873L7.31006 8.13916C7.43896 8.06396 7.60726 7.99772 7.81494 7.94043C8.0262 7.88314 8.2321 7.85449 8.43262 7.85449C9.20964 7.85449 9.80583 8.08545 10.2212 8.54736C10.6401 9.0057 10.8496 9.65023 10.8496 10.481C10.8496 10.9823 10.7368 11.437 10.5112 11.8452C10.2892 12.2498 9.97591 12.5614 9.57129 12.7798C9.16667 12.9982 8.68864 13.1074 8.13721 13.1074C7.64665 13.1074 7.18652 13.0072 6.75684 12.8066C6.32715 12.6025 5.99056 12.325 5.74707 11.9741C5.50358 11.6196 5.38363 11.2204 5.38721 10.7764H7.20264C7.22054 11.0628 7.31185 11.2902 7.47656 11.4585C7.64128 11.6268 7.85791 11.7109 8.12646 11.7109C8.73519 11.7109 9.03955 11.2598 9.03955 10.3574C9.03955 9.52311 8.66715 9.10596 7.92236 9.10596C7.49984 9.10596 7.18473 9.24202 6.97705 9.51416L5.5376 9.17578ZM14.8726 11.3672C14.8726 11.2132 14.792 11.0897 14.6309 10.9966C14.4697 10.9035 14.1636 10.8068 13.7124 10.7065C13.2612 10.6063 12.8888 10.4756 12.5952 10.3145C12.3016 10.1497 12.0778 9.95101 11.9238 9.71826C11.7699 9.48551 11.6929 9.21875 11.6929 8.91797C11.6929 8.38444 11.9131 7.9458 12.3535 7.60205C12.7939 7.25472 13.3704 7.08105 14.083 7.08105C14.8493 7.08105 15.4652 7.25472 15.9307 7.60205C16.3962 7.94938 16.6289 8.40592 16.6289 8.97168H14.8135C14.8135 8.50618 14.5682 8.27344 14.0776 8.27344C13.8879 8.27344 13.7285 8.32715 13.5996 8.43457C13.4707 8.53841 13.4062 8.66911 13.4062 8.82666C13.4062 8.98779 13.485 9.11849 13.6426 9.21875C13.8001 9.31901 14.0508 9.40137 14.3945 9.46582C14.7419 9.53027 15.0462 9.60726 15.3076 9.69678C16.1813 9.99756 16.6182 10.5365 16.6182 11.3135C16.6182 11.8434 16.3818 12.2749 15.9092 12.6079C15.4401 12.9409 14.8314 13.1074 14.083 13.1074C13.5853 13.1074 13.1413 13.0179 12.751 12.8389C12.3607 12.6598 12.0563 12.4163 11.8379 12.1084C11.6195 11.8005 11.5103 11.4764 11.5103 11.1362H13.2021C13.2093 11.4048 13.2988 11.6017 13.4707 11.7271C13.6426 11.8488 13.8628 11.9097 14.1313 11.9097C14.3784 11.9097 14.5628 11.8595 14.6846 11.7593C14.8099 11.659 14.8726 11.5283 14.8726 11.3672Z")
        ]), w)
    ])), E$n = xa({
        bN: "Back 5s",
        bT: "Retour 5s en arri\xe8re"
    }), H$n = lpn(k([
        A2(_w, k([
            Fw("Fg"),
            Rw("11 5 11 13 6 9")
        ]), w)
    ])), R$n = xa({
        bN: "Error",
        bT: "Erreur"
    }), W$n = function(n) {
        return A2(Lw, "tabIndex", Mt(n));
    }, U$n = A2(Eg, k([
        Ow("TimecodeInput"),
        Ow("TimecodeEditable"),
        W$n(0),
        Tg("text")
    ]), w), Q$n = xa({
        bN: "End",
        bT: "Fin"
    }), _$n = lpn(k([
        A2(_w, k([
            Fw("Fg"),
            Rw("7 5 7 13 12 9")
        ]), w),
        A2(_w, k([
            Fw("Fg"),
            Rw("3 5 3 13 8 9")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("8"),
            Xw("1.5"),
            Urn("11.75"),
            Qrn("5")
        ]), w)
    ])), Z$n = lpn(k([
        A2(_w, k([
            Fw("Fg"),
            Rw("7 5 7 13 12 9")
        ]), w)
    ])), K$n = lpn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M9.1347656 5.1386719 L5.7011719 6.3242188 L5.7011719 7.6992188 L7.4863281 7.1796875 L7.4863281 12.958984 L9.3007812 12.958984 L9.3007812 12.957031 L9.3007812 5.1386719 L9.1347656 5.1386719z M12.841797 7.0390625 C12.128797 7.0390625 11.551328 7.2125469 11.111328 7.5605469 C10.671328 7.9035469 10.451172 8.3429531 10.451172 8.8769531 C10.451172 9.1769531 10.528641 9.4447344 10.681641 9.6777344 A1.895 1.895 0 0 0 11.353516 10.273438 C11.646516 10.434438 12.019703 10.565016 12.470703 10.666016 C12.921703 10.766016 13.228625 10.861078 13.390625 10.955078 C13.551625 11.047078 13.630859 11.172172 13.630859 11.326172 A0.479 0.479 0 0 1 13.443359 11.71875 C13.321359 11.81875 13.136672 11.867188 12.888672 11.867188 C12.620672 11.867187 12.400516 11.807547 12.228516 11.685547 C12.056516 11.560547 11.967937 11.363703 11.960938 11.095703 L10.269531 11.095703 A1.654 1.654 0 0 0 10.597656 12.066406 A2.228 2.228 0 0 0 11.509766 12.798828 C11.899766 12.976828 12.343797 13.066406 12.841797 13.066406 C13.589797 13.066406 14.197969 12.899406 14.667969 12.566406 C15.139969 12.233406 15.376953 11.801484 15.376953 11.271484 C15.376953 10.494484 14.940406 9.9552969 14.066406 9.6542969 C13.805406 9.5652969 13.500344 9.4888281 13.152344 9.4238281 C12.808344 9.3598281 12.558391 9.2777344 12.400391 9.1777344 C12.243391 9.0777344 12.164062 8.9461562 12.164062 8.7851562 A0.483 0.483 0 0 1 12.357422 8.3925781 C12.486422 8.2855781 12.645938 8.2324219 12.835938 8.2324219 C13.326938 8.2324219 13.572266 8.4646875 13.572266 8.9296875 L15.388672 8.9296875 C15.388672 8.3646875 15.155453 7.9085469 14.689453 7.5605469 C14.224453 7.2135469 13.607797 7.0390625 12.841797 7.0390625z M2.7246094 7.7363281 L2.7246094 8.8867188 L1.7753906 8.8867188 L1.7753906 10.289062 L2.7246094 10.289062 L2.7246094 11.394531 L4.0683594 11.394531 L4.0683594 10.289062 L5.0039062 10.289062 L5.0039062 10.287109 L5.0039062 8.8867188 L4.0683594 8.8867188 L4.0683594 7.7363281 L2.7246094 7.7363281z")
        ]), w)
    ])), X$n = xa({
        bN: "Forward 1s",
        bT: "Avance 1s en avant"
    }), J$n = lpn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M6.015625 5.1796875 L5.5371094 9.1757812 L6.9765625 9.5136719 C7.1845625 9.2416719 7.499875 9.1054688 7.921875 9.1054688 C8.666875 9.1054688 9.0390625 9.4554219 9.0390625 10.357422 C9.0390625 11.260422 8.7349531 11.710938 8.1269531 11.710938 C7.8569531 11.710938 7.6405625 11.626031 7.4765625 11.457031 C7.3115625 11.289031 7.221125 11.062391 7.203125 10.775391 L5.3867188 10.775391 A2.036 2.036 0 0 0 5.7460938 11.974609 A2.505 2.505 0 0 0 6.7578125 12.806641 C7.1878125 13.006641 7.6467187 13.107422 8.1367188 13.107422 C8.6887188 13.107422 9.1663125 12.997297 9.5703125 12.779297 A2.294 2.294 0 0 0 10.511719 11.845703 C10.737719 11.437703 10.849609 10.981469 10.849609 10.480469 C10.849609 9.6494688 10.640703 9.005875 10.220703 8.546875 C9.8057031 8.084875 9.2105937 7.8535156 8.4335938 7.8535156 C8.2325938 7.8535156 8.0254531 7.8824531 7.8144531 7.9394531 C7.6064531 7.9974531 7.4395469 8.0636719 7.3105469 8.1386719 L7.4863281 6.5878906 L10.585938 6.5878906 L10.585938 5.1796875 L6.015625 5.1796875z M14.082031 7.0800781 C13.369031 7.0800781 12.793516 7.2545625 12.353516 7.6015625 C11.913516 7.9455625 11.693359 8.3839687 11.693359 8.9179688 A1.416 1.416 0 0 0 11.923828 9.71875 A1.895 1.895 0 0 0 12.595703 10.314453 C12.889703 10.476453 13.262891 10.607031 13.712891 10.707031 C14.164891 10.807031 14.469859 10.903094 14.630859 10.996094 C14.791859 11.089094 14.873047 11.213188 14.873047 11.367188 A0.479 0.479 0 0 1 14.685547 11.759766 C14.563547 11.859766 14.377859 11.910156 14.130859 11.910156 C13.862859 11.910156 13.642703 11.848562 13.470703 11.726562 C13.298703 11.601562 13.208172 11.405719 13.201172 11.136719 L11.509766 11.136719 A1.654 1.654 0 0 0 11.837891 12.107422 A2.228 2.228 0 0 0 12.751953 12.837891 C13.141953 13.017891 13.584031 13.107422 14.082031 13.107422 C14.830031 13.107422 15.439203 12.940422 15.908203 12.607422 C16.381203 12.274422 16.617188 11.8425 16.617188 11.3125 C16.617187 10.5355 16.181594 9.9973125 15.308594 9.6953125 C15.046594 9.6063125 14.742531 9.5307969 14.394531 9.4667969 C14.051531 9.4017969 13.799578 9.31875 13.642578 9.21875 C13.484578 9.11775 13.40625 8.9861719 13.40625 8.8261719 A0.483 0.483 0 0 1 13.599609 8.4355469 C13.727609 8.3275469 13.888125 8.2734375 14.078125 8.2734375 C14.568125 8.2734375 14.814453 8.5066563 14.814453 8.9726562 L16.628906 8.9726562 C16.628906 8.4066562 16.396641 7.9485625 15.931641 7.6015625 C15.465641 7.2545625 14.848031 7.0800781 14.082031 7.0800781z M1.7949219 7.7265625 L1.7949219 8.9296875 L0.81640625 8.9296875 L0.81640625 10.330078 L1.7949219 10.330078 L1.7949219 11.384766 L3.1386719 11.384766 L3.1386719 10.330078 L4.0449219 10.330078 L4.0449219 8.9296875 L3.1386719 8.9296875 L3.1386719 7.7265625 L1.7949219 7.7265625z")
        ]), w)
    ])), Y$n = xa({
        bN: "Forward 5s",
        bT: "Avance 5s en avant"
    }), G$n = xa({
        bN: "Full Screen",
        bT: "Plein \xe9cran"
    }), nwn = lpn(k([
        A2(Wrn, k([
            Fw("Fg"),
            Hw("4"),
            Xw("2"),
            Urn("3"),
            Qrn("3")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("4"),
            Xw("2"),
            Urn("13"),
            Qrn("3")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("4"),
            Xw("2"),
            Urn("3"),
            Qrn("12")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("4"),
            Xw("2"),
            Urn("13"),
            Qrn("12")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("2"),
            Xw("2"),
            Urn("5"),
            Qrn("3")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("2"),
            Xw("2"),
            Urn("11"),
            Qrn("3")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("2"),
            Xw("2"),
            Urn("5"),
            Qrn("14")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("2"),
            Xw("3"),
            Urn("11"),
            Qrn("14")
        ]), w)
    ])), rwn = xa({
        bN: "Initialization",
        bT: "Initialisation"
    }), twn = xa({
        bN: "Next Frame",
        bT: "Frame suivante"
    }), ewn = xa({
        bN: "normal speed",
        bT: "Vitesses normale"
    }), uwn = xa({
        bN: "Previous Frame",
        bT: "Frame pr\xe9c\xe9dente"
    }), own = xa({
        bN: "Show raw frame",
        bT: "Afficher image originale"
    }), awn = A2(Zw, k([
        Hw("18px"),
        Xw("18px"),
        Kw("0 0 20 20"),
        Fw("IconRawImage")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(iC, k([
                aC("m17.31864,1.25l-14.67396,0c-1.18282,0 -2.14468,0.96154 -2.14468,2.14576l0,13.48626c0,1.18282 0.96186,2.14334 2.14468,2.14334l14.6739,0c1.18282,0 2.14366,-0.96052 2.14366,-2.14334l0,-13.48626c0.00006,-1.18422 -0.96078,-2.14576 -2.1436,-2.14576zm-4.55665,3.19115c1.14384,0 2.07149,0.92771 2.07149,2.07149s-0.92771,2.07149 -2.07149,2.07149c-1.14416,0 -2.07149,-0.92771 -2.07149,-2.07149s0.92733,-2.07149 2.07149,-2.07149zm3.88406,12.60171l-6.66508,0l-6.36814,0c-0.57211,0 -0.82691,-0.41393 -0.569,-0.9246l3.55506,-7.04144c0.25759,-0.5106 0.74851,-0.55618 1.09617,-0.10188l3.57474,4.67161c0.34766,0.45436 0.95532,0.49302 1.35751,0.08595l0.87451,-0.88556c0.40187,-0.40707 0.99398,-0.35667 1.32196,0.11185l2.26452,3.23469c0.32735,0.46922 0.12987,0.84938 -0.44224,0.84938z")
            ]), w)
        ]))
    ])), iwn = A2(Zw, k([
        Hw("1080"),
        Xw("1920"),
        Kw("0 0 1920 1080")
    ]), k([
        A2(Wrn, k([
            _8("#FFD600"),
            Hw("31"),
            Xw("130"),
            Qrn("54"),
            Urn("97")
        ]), w),
        A2(Wrn, k([
            Z8("#FFD600"),
            _8("none"),
            Hw("972"),
            Xw("1728"),
            Qrn("54"),
            Urn("96")
        ]), w),
        A2(iC, k([
            aC("M113.5 66.4531C113.433 65.8329 113.154 65.3499 112.662 65.0043C112.174 64.6586 111.539 64.4858 110.758 64.4858C110.209 64.4858 109.738 64.5687 109.345 64.7344C108.952 64.9001 108.651 65.125 108.443 65.4091C108.234 65.6932 108.128 66.0175 108.123 66.3821C108.123 66.6851 108.192 66.9479 108.329 67.1705C108.471 67.393 108.663 67.5824 108.904 67.7386C109.146 67.8902 109.413 68.018 109.707 68.1222C110.001 68.2263 110.297 68.3139 110.595 68.3849L111.958 68.7259C112.508 68.8537 113.036 69.0265 113.542 69.2443C114.054 69.4621 114.511 69.7367 114.913 70.0682C115.32 70.3996 115.642 70.7997 115.879 71.2685C116.116 71.7372 116.234 72.2865 116.234 72.9162C116.234 73.7685 116.016 74.5189 115.581 75.1676C115.145 75.8116 114.515 76.3158 113.691 76.6804C112.872 77.0402 111.88 77.2202 110.716 77.2202C109.584 77.2202 108.601 77.045 107.768 76.6946C106.94 76.3442 106.291 75.8329 105.822 75.1605C105.358 74.4882 105.107 73.669 105.069 72.7031H107.662C107.699 73.2098 107.856 73.6312 108.13 73.9673C108.405 74.3035 108.762 74.5545 109.203 74.7202C109.648 74.8859 110.145 74.9688 110.694 74.9688C111.267 74.9688 111.769 74.8835 112.2 74.7131C112.636 74.5379 112.976 74.2964 113.223 73.9886C113.469 73.6761 113.594 73.3116 113.599 72.8949C113.594 72.5161 113.483 72.2036 113.265 71.9574C113.047 71.7064 112.742 71.4981 112.349 71.3324C111.961 71.1619 111.506 71.0104 110.985 70.8778L109.331 70.4517C108.133 70.1439 107.186 69.6776 106.49 69.0526C105.798 68.4228 105.453 67.5871 105.453 66.5455C105.453 65.6884 105.685 64.938 106.149 64.294C106.618 63.6501 107.254 63.1506 108.059 62.7955C108.864 62.4356 109.776 62.2557 110.794 62.2557C111.826 62.2557 112.73 62.4356 113.507 62.7955C114.288 63.1506 114.901 63.6454 115.346 64.2798C115.791 64.9096 116.021 65.634 116.035 66.4531H113.5ZM118.583 77V62.4545H128.043V64.6634H121.218V68.6122H127.553V70.821H121.218V74.7912H128.1V77H118.583ZM143.182 67.3622H140.526C140.45 66.9266 140.31 66.5407 140.107 66.2045C139.903 65.8636 139.65 65.5748 139.347 65.3381C139.044 65.1013 138.698 64.9238 138.31 64.8054C137.926 64.6823 137.512 64.6207 137.067 64.6207C136.276 64.6207 135.575 64.8196 134.964 65.2173C134.354 65.6103 133.875 66.188 133.53 66.9503C133.184 67.7079 133.011 68.6335 133.011 69.7273C133.011 70.84 133.184 71.7775 133.53 72.5398C133.88 73.2973 134.358 73.8703 134.964 74.2585C135.575 74.642 136.274 74.8338 137.06 74.8338C137.495 74.8338 137.902 74.777 138.281 74.6634C138.665 74.545 139.008 74.3722 139.311 74.1449C139.619 73.9176 139.877 73.6383 140.085 73.3068C140.298 72.9754 140.445 72.5966 140.526 72.1705L143.182 72.1847C143.082 72.8759 142.867 73.5246 142.536 74.1307C142.209 74.7367 141.78 75.2718 141.25 75.7358C140.72 76.1951 140.099 76.5549 139.389 76.8153C138.679 77.071 137.891 77.1989 137.024 77.1989C135.746 77.1989 134.605 76.9029 133.601 76.3111C132.597 75.7192 131.806 74.8646 131.229 73.7472C130.651 72.6297 130.362 71.2898 130.362 69.7273C130.362 68.16 130.653 66.8201 131.236 65.7074C131.818 64.59 132.611 63.7353 133.615 63.1435C134.619 62.5516 135.755 62.2557 137.024 62.2557C137.834 62.2557 138.587 62.3693 139.283 62.5966C139.979 62.8239 140.599 63.1577 141.143 63.598C141.688 64.0336 142.135 64.5687 142.486 65.2031C142.841 65.8329 143.073 66.5526 143.182 67.3622ZM154.764 62.4545H157.399V71.9574C157.399 72.9991 157.153 73.9152 156.66 74.706C156.172 75.4967 155.486 76.1146 154.6 76.5597C153.715 77 152.681 77.2202 151.497 77.2202C150.308 77.2202 149.271 77 148.386 76.5597C147.501 76.1146 146.814 75.4967 146.326 74.706C145.839 73.9152 145.595 72.9991 145.595 71.9574V62.4545H148.23V71.7372C148.23 72.3433 148.362 72.883 148.627 73.3565C148.897 73.83 149.276 74.2017 149.764 74.4716C150.252 74.7367 150.829 74.8693 151.497 74.8693C152.164 74.8693 152.742 74.7367 153.23 74.4716C153.722 74.2017 154.101 73.83 154.366 73.3565C154.631 72.883 154.764 72.3433 154.764 71.7372V62.4545ZM164.585 64.6634V62.4545H176.19V64.6634H171.694V77H169.08V64.6634H164.585ZM181.062 62.4545V77H178.427V62.4545H181.062ZM183.276 64.6634V62.4545H194.881V64.6634H190.385V77H187.772V64.6634H183.276ZM197.118 77V62.4545H202.573C203.69 62.4545 204.628 62.6487 205.385 63.0369C206.148 63.4252 206.723 63.9697 207.111 64.6705C207.504 65.3665 207.701 66.1785 207.701 67.1065C207.701 68.0393 207.502 68.849 207.104 69.5355C206.711 70.2173 206.131 70.7453 205.364 71.1193C204.597 71.4886 203.655 71.6733 202.537 71.6733H198.652V69.4858H202.182C202.836 69.4858 203.371 69.3958 203.787 69.2159C204.204 69.0312 204.512 68.7637 204.711 68.4134C204.914 68.0582 205.016 67.6226 205.016 67.1065C205.016 66.5904 204.914 66.1501 204.711 65.7855C204.507 65.4162 204.197 65.1368 203.78 64.9474C203.364 64.7533 202.826 64.6562 202.168 64.6562H199.753V77H197.118ZM204.632 70.4091L208.233 77H205.293L201.756 70.4091H204.632ZM210.126 77V62.4545H219.586V64.6634H212.761V68.6122H219.096V70.821H212.761V74.7912H219.643V77H210.126Z"),
            _8("black")
        ]), w)
    ])), cwn = xa({
        bN: "Speed X 2",
        bT: "Vitesse X 2"
    }), fwn = xa({
        bN: "Speed X 4",
        bT: "Vitesse X 4"
    }), swn = xa({
        bN: "Start",
        bT: "D\xe9but"
    }), lwn = lpn(k([
        A2(_w, k([
            Fw("Fg"),
            Rw("11 5 11 13 6 9")
        ]), w),
        A2(_w, k([
            Fw("Fg"),
            Rw("15 5 15 13 10 9")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("8"),
            Xw("1.5"),
            Urn("4.75"),
            Qrn("5")
        ]), w)
    ])), dwn = lpn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M5.3833 8.02344L6.37988 6.13184H8.60156L6.79248 9.47705L8.69043 13H6.45605L5.37695 10.9688L4.31689 13H2.06982L3.97412 9.47705L2.17139 6.13184H4.41846L5.3833 8.02344ZM14.1271 13H11.9816V6.16992L9.87414 6.78564V5.16064L13.9303 3.75781H14.1271V13Z")
        ]), w)
    ])), mwn = lpn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M12.433594 3.234375 C11.644303 3.234375 11.024458 3.3490632 10.576172 3.5761719 C10.131717 3.7989131 9.7881853 4.1212769 9.5429688 4.5449219 C9.2977522 4.9641994 9.1290656 5.5495757 9.0371094 6.3007812 L11.380859 6.5175781 C11.445995 5.9760113 11.573975 5.5987719 11.761719 5.3847656 C11.953294 5.1707594 12.197236 5.0625 12.496094 5.0625 C12.783457 5.0625 13.02124 5.1673144 13.208984 5.3769531 C13.40056 5.5822244 13.496094 5.8323792 13.496094 6.125 C13.496094 6.3957834 13.40056 6.6810661 13.208984 6.9824219 C13.017409 7.2837776 12.578418 7.7257665 11.892578 8.3066406 C10.769946 9.2543825 10.003721 10.076595 9.59375 10.775391 C9.1876102 11.469819 8.9437429 12.213393 8.8632812 13.003906 L15.886719 13.003906 L15.886719 10.828125 L12.232422 10.828125 C12.446986 10.587914 12.631971 10.394588 12.789062 10.246094 C12.949986 10.0976 13.267006 9.8360791 13.738281 9.4648438 C14.531403 8.8271925 15.076142 8.2418162 15.375 7.7089844 C15.677689 7.1761525 15.830078 6.6184447 15.830078 6.0332031 C15.830078 5.4829014 15.697968 4.9860368 15.433594 4.5449219 C15.173051 4.0994395 14.813297 3.7706469 14.353516 3.5566406 C13.897566 3.3426344 13.257368 3.234375 12.433594 3.234375z M2.0703125 6.1328125 L3.9746094 9.6542969 L2.171875 13 L4.4179688 13 L5.3828125 11.109375 L6.3789062 13 L8.6015625 13 L6.7929688 9.6542969 L8.6914062 6.1328125 L6.4550781 6.1328125 L5.3769531 8.1621094 L4.3164062 6.1328125 L2.0703125 6.1328125z")
        ]), w)
    ])), bwn = lpn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M5.3833 8.02344L6.37988 6.13184H8.60156L6.79248 9.47705L8.69043 13H6.45605L5.37695 10.9688L4.31689 13H2.06982L3.97412 9.47705L2.17139 6.13184H4.41846L5.3833 8.02344ZM15.0348 9.38818H15.9742V11.0386H15.0348V13H12.8956V11.0386H9.32189L9.19494 9.73096L12.8956 3.77686V3.75781H15.0348V9.38818ZM11.2325 9.38818H12.8956V6.54443L12.7623 6.76025L11.2325 9.38818Z")
        ]), w)
    ])), pwn = {
        $: 1
    }, vwn = {
        $: 0
    }, $wn = lpn(k([
        A2(Wrn, k([
            Fw("Fg"),
            Hw("8"),
            Xw("3"),
            Urn("5"),
            Qrn("5")
        ]), w),
        A2(Wrn, k([
            Fw("Fg"),
            Hw("8"),
            Xw("3"),
            Urn("10"),
            Qrn("5")
        ]), w)
    ])), wwn = function(n) {
        return n.mT ? A2(ye, k([
            Ow("PlayerControlsPlayPause"),
            II("Lire / Mettre en pause"),
            Cg(pwn)
        ]), k([
            $wn
        ])) : A2(ye, k([
            Ow("PlayerControlsPlayPause"),
            II("Lire / Mettre en pause"),
            Cg(vwn)
        ]), k([
            dpn
        ]));
    }, gwn = F2(function(n, r) {
        var t, e = (t = 100 * (r.e$ - r.hs) / n) > 100 ? "100" : by(t);
        return A2(ye, k([
            Ow("PlayerControlsTimeBuffered"),
            A2(pg, "left", "0%"),
            A2(pg, "width", e + "%")
        ]), w);
    }), hwn = F3(function(n, r, t) {
        var e, u, o = (e = se(r * t) - 1, (u = 100 * n.kp / e) > 100 ? "100" : by(u));
        return A2(ye, k([
            Ow("PlayerControlsTimeProgress"),
            A2(pg, "left", "0%"),
            A2(pg, "width", o + "%")
        ]), w);
    }), kwn = F3(function(n, r, t) {
        var e = 1 === r.$ ? 0 : r.a, u = k(1 === t.$ ? [
            A2(ye, k([
                Ow("PlayerControlsTimeProgress"),
                A2(pg, "width", "0%")
            ]), w)
        ] : [
            A3(hwn, n, t.a, e)
        ]), o = 1 > qt(n.eo) ? k([
            A2(ye, k([
                Ow("PlayerControlsTimeBuffered"),
                A2(pg, "left", "0%"),
                A2(pg, "width", "0%")
            ]), w)
        ]) : A2(Ye, gwn(e), n.eo);
        return A2(ye, k([
            Ow("PlayerControlsTime")
        ]), A2(mt, A2(ye, k([
            Ow("PlayerControlsTimeMask")
        ]), w), A2(mt, ag(""), A2(mt, A2(ye, k([
            Ow("PlayerControlsBufferProgress")
        ]), o), u))));
    }), Cwn = F3(function(n, r, t) {
        var e, u = {
            i8: function() {
                var n = t.qq;
                return 1 === n.$ ? w : k([
                    Mt(n.a)
                ]);
            }(),
            nJ: t.n3,
            gx: kt,
            ad: r.rp
        }, o = r.mN || !r.ix ? "block" : "none", i = r.i$ && !n || !r.i$ && n ? "block" : "none";
        return A2(ye, k([
            Ow("PlayerVideoWrapper"),
            Kg("player-wrapper"),
            W$n(1)
        ]), k([
            A2(ye, k([
                Ow("PlayerBox")
            ]), k([
                A2(ye, k([
                    Ow("BannerEmptyness"),
                    Ow("PlayerBanner"),
                    A2(pg, "display", "none")
                ]), k([
                    BI,
                    A2(dg, k([
                        Ow("BannerContent")
                    ]), k([
                        ag(R$n)
                    ]))
                ])),
                A2(ye, k([
                    Ow("PlayerVideo"),
                    Bg(k([
                        d("PlayerDeployed", r.ix),
                        d("PlayerCollapsed", !r.ix)
                    ]))
                ]), k([
                    A2(ye, k([
                        Ow("PlayerVideoBuffering"),
                        A2(pg, "display", o)
                    ]), k([
                        (e = rwn, A2(ye, k([
                            Ow("LoadingWrapper")
                        ]), k([
                            A2(ye, k([
                                Ow("LoadingSpinner")
                            ]), k([
                                Lj,
                                A2(ye, k([
                                    Ow("LoadingSpinnerText")
                                ]), k([
                                    ag(e)
                                ]))
                            ]))
                        ])))
                    ])),
                    A3(Ae, "noma-player", k([
                        A2(qI, "data-manifest", u.nJ),
                        A2(qI, "data-audiostracks", "[" + A2(It, ",", u.i8) + "]"),
                        A2(qI, "data-playbackspeed", by(r.gx)),
                        A2(qI, "data-subtitles", A2(ju, "", u.ad)),
                        A2(qI, "data-framerate", by(r.lW)),
                        A2(qI, "data-starttimecode", t.q5)
                    ]), w),
                    A2(ye, k([
                        Ow("PlayerAspectRatio"),
                        A2(pg, "display", i),
                        A2(pg, "z-index", "3")
                    ]), k([
                        n ? iwn : x$n
                    ]))
                ]))
            ])),
            A2(ye, k([
                Ow("PlayerControlsBox")
            ]), k([
                A2(ye, k([
                    Ow("PlayerControls")
                ]), k([
                    wwn(r),
                    A3(kwn, r, t.eU, t.lW)
                ])),
                A2(ye, k([
                    Ow("PlayerControls")
                ]), k([
                    U$n,
                    A2(ye, k([
                        Ow("PlayerControlsStart"),
                        II(swn),
                        Cg(F$n)
                    ]), k([
                        lwn
                    ])),
                    A2(ye, k([
                        Ow("PlayerControlsBackward"),
                        II(uwn),
                        Cg(I$n)
                    ]), k([
                        H$n
                    ])),
                    A2(ye, k([
                        Ow("PlayerControlsForward"),
                        II(twn),
                        Cg(M$n)
                    ]), k([
                        Z$n
                    ])),
                    A2(ye, k([
                        Ow("PlayerControlsEnd"),
                        II(Q$n),
                        Cg(j$n)
                    ]), k([
                        _$n
                    ])),
                    A2(qg, k([
                        Ow("PlayerOperationsSeparator")
                    ]), ""),
                    A2(ye, k([
                        Ow("PlayerGoBack1s"),
                        II(O$n),
                        Cg(A2(B$n, "Substract", 1))
                    ]), k([
                        V$n
                    ])),
                    A2(ye, k([
                        Ow("PlayerGoBack5s"),
                        II(E$n),
                        Cg(A2(B$n, "Substract", 5))
                    ]), k([
                        z$n
                    ])),
                    A2(ye, k([
                        Ow("PlayerGoForward1s"),
                        II(X$n),
                        Cg(A2(B$n, "Add", 1))
                    ]), k([
                        K$n
                    ])),
                    A2(ye, k([
                        Ow("PlayerGoForward5s"),
                        II(Y$n),
                        Cg(A2(B$n, "Add", 5))
                    ]), k([
                        J$n
                    ])),
                    A2(qg, k([
                        Ow("PlayerOperationsSeparator")
                    ]), ""),
                    A2(ye, k([
                        Ow("PlayerPlaybackSpeed1"),
                        Bg(k([
                            d("PlayerSelectedSpeed", a(r.gx, 1))
                        ])),
                        II(ewn),
                        Cg(D$n(1))
                    ]), k([
                        dwn
                    ])),
                    A2(ye, k([
                        Ow("PlayerPlaybackSpeed2"),
                        Bg(k([
                            d("PlayerSelectedSpeed", a(r.gx, 2))
                        ])),
                        II(cwn),
                        Cg(D$n(2))
                    ]), k([
                        mwn
                    ])),
                    A2(ye, k([
                        Ow("PlayerPlaybackSpeed4"),
                        Bg(k([
                            d("PlayerSelectedSpeed", a(r.gx, 4))
                        ])),
                        II(fwn),
                        Cg(D$n(4))
                    ]), k([
                        bwn
                    ])),
                    A2(qg, k([
                        Ow("PlayerOperationsSpacer")
                    ]), ""),
                    A2(ye, k([
                        Ow("PlayerControlsRatio"),
                        II("aspect ratio"),
                        Cg(y$n)
                    ]), k([
                        q$n
                    ])),
                    A2(ye, k([
                        Ow("ButtonDisplayRawImage"),
                        II(own),
                        Cg(A2(L$n, t.en, t.fL))
                    ]), k([
                        awn
                    ])),
                    A2(ye, k([
                        Ow("PlayerControlsFullScreen"),
                        II(G$n),
                        Cg(N$n)
                    ]), k([
                        nwn
                    ]))
                ]))
            ]))
        ]));
    }), Twn = F5(function(n, r, t, e, u) {
        var o = A2(ju, "", A2(sp, ybn, A2(jon, Mon(r), u).bQ.f$)), a = A2(ju, w, A2(Lu, function(n) {
            return n.g3;
        }, A2(jon, Mon(r), u).bQ.f$)), i = b$n(A2(jon, Mon(r), u)), c = p$n(i) ? $$n : v$n;
        if (t.$) return u.o5 ? ag("") : A2(ye, k([
            Kg("player"),
            Ow("PlayerUnfold")
        ]), k([
            (f = u.o3, 1 === f.$ ? ag("") : A2(mh, o_, A3(Cwn, n, u.o6, f.a)))
        ]));
        var f, s, l = t.a;
        return u.o5 ? A2(ye, k([
            Ow("PlayerFold"),
            Bg(k([
                d("PlayerFolded", u.o5)
            ]))
        ]), k([
            p$n(i) ? A2(ye, k([
                Ow("PlayerFoldPreview"),
                Cg(c)
            ]), k([
                A2(ye, k([
                    Ow("PlayerFoldPlay")
                ]), k([
                    w$n
                ])),
                A2(ye, k([
                    Ow("PlayerFoldProxy")
                ]), k([
                    ag(g$n)
                ]))
            ])) : A2(ye, k([
                Ow("PlayerFoldPreview")
            ]), k([
                A2(ye, k([
                    Ow("PlayerFoldSpinner")
                ]), k([
                    Lj
                ]))
            ])),
            A4(A$n, l, e, a, o)
        ])) : A2(ye, k([
            Kg("player"),
            Ow("PlayerUnfold")
        ]), k([
            (s = u.o3, 1 === s.$ ? ag("") : A2(mh, o_, A3(Cwn, n, u.o6, s.a)))
        ]));
    }), Pwn = xa({
        bN: "No audio stream present for this video.",
        bT: "Aucun stream audio pr\xe9sente pour cette vid\xe9o"
    }), Swn = function(n) {
        return {
            $: 37,
            a: n
        };
    }, Awn = F2(function(n, r) {
        var t = A2(ju, "", A2(Lu, Kk, r.sz)), e = A2(ju, "", A2(Lu, Mmn, r.r9)), u = A2(Lu, K1, r.aC);
        return A2(Nk, k([
            Ow("TracksTrackSelectLabel")
        ]), k([
            A2(Eg, k([
                Tg("radio"),
                oh(Mt(r.fv)),
                Hg("selected-audio-track" + A3(Kd, 2, "0", Mt(r.fv))),
                Cg(Swn(d(r.fv, u))),
                Pk(A2(Y$, r.fv, A2(ju, w, A2(Lu, A2(bu, Ye($e), function(n) {
                    return n.qr;
                }), n.o3))))
            ]), w),
            A2(dg, k([
                Ow("TracksTrackSelectItem")
            ]), k([
                A2(qg, k([
                    Ow("TracksTrackSelectItemIndex")
                ]), A3(Kd, 2, "0", Mt(r.fv))),
                A2(qg, k([
                    Ow("TracksTrackSelectItemTitle")
                ]), t + " " + e),
                A2(qg, k([
                    Ow("TracksTrackSelectItemProp")
                ]), Mt(r.cz) + " channel(s)"),
                A2(qg, k([
                    Ow("TracksTrackSelectItemProp")
                ]), A2(ju, "", u))
            ]))
        ]));
    }), ywn = function(n) {
        return A2(Nk, k([
            Ow("TracksTrackSelectLabel")
        ]), k([
            A2(Eg, k([
                Tg("radio"),
                oh(Mt(n.fv)),
                Hg("selected-subtitle-track")
            ]), w),
            A2(dg, k([
                Ow("TracksTrackSelectItem")
            ]), k([
                A2(qg, k([
                    Ow("TracksTrackSelectItemTitle")
                ]), "subtitle stream " + A3(Kd, 2, "0", Mt(n.fv))),
                A2(qg, k([
                    Ow("TracksTrackSelectItemProp")
                ]), A2(ju, "", A2(Lu, Kk, n.sz)))
            ]))
        ]));
    }, Nwn = F2(function(n, r) {
        return A2(ye, k([
            Ow("TracksTrack")
        ]), k([
            A2(ye, k([
                Ow("TracksTrackIcon")
            ]), k([
                n
            ])),
            A2(ye, k([
                Ow("TracksTrackSelect")
            ]), r)
        ]));
    }), Lwn = A2(Nk, k([
        Ow("TracksTrackSelectLabel")
    ]), k([
        A2(Eg, k([
            Tg("checkbox"),
            Hg("selected-video-track")
        ]), w),
        A2(dg, k([
            Ow("TracksTrackSelectItem")
        ]), k([
            A2(qg, k([
                Ow("TracksTrackSelectItemTitle")
            ]), "Video"),
            A2(qg, k([
                Ow("TracksTrackSelectItemProp")
            ]), "")
        ]))
    ])), jwn = F3(function(n, r, t) {
        return A2(ye, k([
            Ow("Tracks")
        ]), k([
            A2(Nwn, Xbn, k([
                Lwn
            ])),
            A2(Nwn, Vdn, a(r, w) ? k([
                B8(Pwn)
            ]) : A2(Ye, Awn(n), A2(Ra, function(n) {
                return n.fv;
            }, r))),
            a(t, w) ? ag("") : A2(Nwn, Udn, A2(Ye, ywn, t))
        ]));
    }), Fwn = xa({
        bN: "Additional material",
        bT: "Mat\xe9riel compl\xe9mentaire"
    }), Mwn = F5(function(n, r, t, e, u) {
        var o = m$n(n), a = A3($bn, n.st, n.g9.oM, A2(Ye, function(n) {
            return n.fB;
        }, n.fD));
        return A2(ye, k([
            Ow("FilesWrapper")
        ]), k([
            Tu(o) ? ag("") : A2(ye, w, A2(Ye, A6(Zvn, n, r, u, a, t, e), o))
        ]));
    }), Iwn = xa({
        bN: "File upload",
        bT: "Upload de fichier"
    }), Dwn = xa({
        bN: "Looking for upload?",
        bT: "Vous voulez uploader des fichiers ?"
    }), Bwn = xa({
        bN: A2(ye, w, k([
            A2(Yj, w, k([
                ag("You can only upload subtitles.")
            ])),
            A2(Yj, w, k([
                ag("You are not allowed to deliver directly into the destination placeholder. First, you have to upload your master file into your own stock in Nomalab, then you will be able to start the delivery in Nomalab."),
                ag("For the records, you can follow the 3 steps tutorial available on this link: "),
                A2(oC, k([
                    fC(zrn("table"))
                ]), k([
                    ag("Read help")
                ])),
                ag(". If you need any assistance, you can also contact us via the Chat on the bottom left of this page.")
            ]))
        ])),
        bT: A2(ye, w, k([
            A2(Yj, w, k([
                ag("Vous ne pouver uploader que des sous-titres.")
            ])),
            A2(Yj, w, k([
                ag("Vous ne pouvez pas uploader directement dans la capsule de r\xe9ception de votre destinataire. "),
                ag("Vous devez dans un premier temps uploader votre master dans le stock de votre organisation. "),
                ag("Pour rappel, un tutoriel avec les 3 etapes \xe0 suivre pour livrer un programme avec Nomalab est disponible sur le lien suivant : "),
                A2(oC, k([
                    fC(zrn("table"))
                ]), k([
                    ag("Consulter l'aide")
                ])),
                ag(". En cas de besoin, vous pouvez contacter notre \xe9quipe op\xe9rationnelle via le bouton de messagerie instantan\xe9e disponible en bas \xe0 gauche de l'interface")
            ]))
        ]))
    }), xwn = A2(ye, k([
        Ow("PadokUpload"),
        Ow("PadokUploadKo")
    ]), k([
        A2(qg, k([
            Ow("PadokUploadTitle"),
            Ow("PadokUploadTitleKo")
        ]), Dwn),
        A2(ye, k([
            Ow("PadokUploadInfo")
        ]), k([
            Bwn
        ]))
    ])), qwn = xa({
        bN: "You can upload files",
        bT: "Vous pouvez uploader des fichiers"
    }), Vwn = xa({
        bN: "Drop files here or ",
        bT: "Glisser-d\xe9poser les fichiers dans la fen\xeatre, ou "
    }), Own = F2(function(n, r) {
        return A2(Nk, k([
            Men(n),
            Ow("InputFileLabel")
        ]), k([
            ag(r)
        ]));
    }), zwn = xa({
        bN: "select manually",
        bT: "s\xe9lectionner manuellement"
    }), Ewn = A2(ye, k([
        Ow("PadokUpload")
    ]), k([
        A2(qg, k([
            Ow("PadokUploadTitle")
        ]), qwn),
        A2(ye, k([
            Ow("PadokUploadInfo")
        ]), k([
            ag(Vwn),
            A2(Own, "nativeInputFile", zwn)
        ]))
    ])), Hwn = xa({
        bN: " and ",
        bT: " et "
    }), Rwn = xa({
        bN: ' Go to the "Settings" tab, Invitations area, to invite your contacts via their email adresses to upload files.',
        bT: ' Allez dans l\'onglet "Param\xe8tres" \xe0 gauche de l\'\xe9cran, zone "invitations", puis invitez vos contacts avec leurs adresses mail en upload.'
    }), Wwn = xa({
        bN: " has been invited to upload files.",
        bT: " a \xe9t\xe9 invit\xe9(e) \xe0 uploader les fichiers."
    }), Uwn = xa({
        bN: "Nobody is assigned for upload.",
        bT: "Si une autre personne doit uploader le fichier pour vous, "
    }), Qwn = xa({
        bN: " others were invited to upload files.",
        bT: " autres ont \xe9t\xe9 invit\xe9(e)s \xe0 uploader les fichiers."
    }), _wn = function(n) {
        return a(n.n6, n.la) ? n.n6 : n.n6 + " (" + n.la + ")";
    }, Zwn = xa({
        bN: " were invited to upload files.",
        bT: " ont \xe9t\xe9 invit\xe9(e)s \xe0 uploader les fichiers."
    }), Kwn = function(n) {
        var r = A2(Mu, A2(Pi, function(n) {
            return n.fB;
        }, function(n) {
            return n.sk;
        }), n.fD);
        return A2(ye, k([
            Ow("PadokUploadInvitation")
        ]), k([
            ag(function() {
                if (r.b) {
                    if (r.b.b) {
                        if (r.b.b.b) {
                            var n = r.b;
                            return A2(It, " ", k([
                                _wn(r.a.st),
                                Hwn,
                                Mt(qt(n)),
                                Qwn
                            ]));
                        }
                        var t = r.b.a;
                        return A2(It, " ", k([
                            _wn(r.a.st),
                            Hwn,
                            _wn(t.st),
                            Zwn
                        ]));
                    }
                    return A2(It, " ", k([
                        _wn(r.a.st),
                        Wwn
                    ]));
                }
                return Uwn;
            }()),
            ag(A2(BZ, n.st, n.g9.oM) ? Rwn : "")
        ]));
    }, Xwn = function(n) {
        var r = !n.g9.c$ && !n.st.iz, t = A3(qZ, n.st, n.g9.oM, A2(Ye, function(n) {
            return n.fB;
        }, n.fD));
        return A2(ye, k([
            Ow("PadokUploadWrapper")
        ]), k([
            r ? xwn : t ? Ewn : A2(qg, k([
                Ow("PadokUploadTitle")
            ]), Iwn),
            Kwn(n)
        ]));
    }, Jwn = {
        $: 16
    }, Ywn = xa({
        bN: "Current capsule",
        bT: "Capsule courante"
    }), Gwn = xa({
        bN: "Current master",
        bT: "Master courant"
    }), ngn = xa({
        bN: "No video file",
        bT: "Pas de fichier vid\xe9o"
    }), rgn = xa({
        bN: " (Rejected)",
        bT: " (Rejet\xe9)"
    }), tgn = F2(function(n, r) {
        var t = n.oX;
        return !qt(n.bj) || Ton(n) && !Ean(n.st) ? ag("") : A2(ye, k([
            Ow("ShowSelectBroadcastable")
        ]), k([
            A3(ldn, r.jr, Jwn, A2(mt, m(a(t.bD, kt), A3(sdn, n.g9.mo, n.iZ, p(t, {
                bD: kt
            })), function() {
                var r = d(n.R.bQ.f$, n.g9.c$);
                return 1 === r.a.$ ? r.b ? Gwn : Ywn : r.b ? r.a.a.lD.n6 + " (" + Gwn + ")" : r.a.a.lD.n6 + " (" + Ywn + ")";
            }()), A2(Ye, function(r) {
                var e;
                return m(a(t.bD, ht(r.bD.mo)), A3(sdn, n.g9.mo, n.iZ, p(t, {
                    bD: ht(r.bD.mo)
                })), 1 === (e = r.bQ.f$).$ ? ngn : $(e.a.lD.n6, rgn));
            }, n.bj)))
        ]));
    }), egn = xa({
        bN: "Hide player",
        bT: "Masquer la video"
    }), ugn = prn(k([
        A2(iC, k([
            Fw("Fg"),
            aC("M4.94601622,4.57669369 C3.74989521,5.67353545 3,7.24919402 3,9 C3,12.3137085 5.6862915,15 9,15 C12.3137085,15 15,12.3137085 15,9 C15,6.64729493 13.6458726,4.61086325 11.6744855,3.62757252 L11.2601446,5.69927685 C12.3108237,6.42010318 13,7.62956872 13,9 C13,11.209139 11.209139,13 9,13 C6.790861,13 5,11.209139 5,9 C5,7.98151039 5.38065278,7.051927 6.00745306,6.34575509 L7,8 L9,4 L4,3 L4.94601622,4.57669369 Z")
        ]), w)
    ])), ogn = xa({
        bN: "Refresh",
        bT: "Rafra\xeechir"
    }), agn = F4(function(n, r, t, e) {
        var u = A2(Lu, Hu("#"), t.jt), o = ht(r.d2 ? mrn : lH), a = Ton(n) ? kt : t.co ? ht(A2(Ddn, e.mo, kv(r.bL.qA))) : kt, i = ht(wX(e.mo)), c = A2(sC, w, k([
            DI(p(dI, {
                mn: ht(e.P.nm ? Wan : ugn),
                m7: ogn,
                oy: ht(Xv)
            })),
            e.o5 ? ag("") : DI(p(dI, {
                mn: ht(tj),
                m7: egn,
                oy: ht(RZ)
            }))
        ]));
        return $C(p(wC, {
            dV: ht(c),
            d9: i,
            fc: a,
            fq: o,
            mo: u,
            rW: t.rW
        }));
    }), ign = F2(function(n, r) {
        return A2(ye, k([
            Ow("BannerCTA")
        ]), k([
            A2(ye, k([
                Ow("BannerCTAIcon")
            ]), k([
                sin
            ])),
            A2(qg, k([
                Ow("BannerCTALabel")
            ]), n),
            DI(r)
        ]));
    }), cgn = xa({
        bN: "Deliver",
        bT: "Livrer"
    }), fgn = xa({
        bN: "Proceed to delivery",
        bT: "Proc\xe9der \xe0 la livraison"
    }), sgn = xa({
        bN: "Qualify",
        bT: "Qualifier"
    }), lgn = xa({
        bN: "All audios are not qualified",
        bT: "Toutes les pistes audios ne sont pas qualifi\xe9es"
    }), dgn = F3(function(n, r, t) {
        var e = !Fon(n);
        return pdn(n) && function(n) {
            return A3(qZ, n.st, n.oM.mo, A2(Ye, function(n) {
                return n.fB;
            }, n.fD));
        }(n) ? A2(ye, k([
            Ow("ShowTodos")
        ]), k([
            A2(dbn, t, A2(ign, lgn, p(dI, {
                mn: ht(Len),
                m7: sgn,
                sr: ht(A2(Ddn, r.mo, 2))
            }))),
            A2(dbn, e, A2(ign, fgn, p(dI, {
                mn: ht(Len),
                m7: cgn,
                oy: ht(g1(zan)),
                sr: ht(A2(Ddn, r.mo, 1))
            })))
        ])) : ag("");
    }), mgn = F3(function(n, r, t) {
        var e, u, o, i = m$n(r), c = A2(sp, AV, A2(Lu, ba(Da), Eo(A2(Ye, function(n) {
            return n.sw;
        }, A2(Mu, function(n) {
            return "broadcasterShowId" === n.n6;
        }, t.k3.c2))))), f = A2(jon, Mon(r), t), s = b$n(f), l = (e = f.bQ.f$).$ ? w : e.a.av, m = (u = f.bQ.f$).$ ? w : A2(Kc, qdn, u.a.av), b = (o = f.bQ.f$).$ ? kt : Eo(A2(Kc, Y1, o.a.av)), p = A2(Kc, Z1, l), v = A2(hT, gT(function(n) {
            return n.rW;
        }), A2(Ye, function(n) {
            return {
                cz: Mt(n.cz),
                kM: k([
                    d("Codec", n.aE),
                    d(Edn, Wdn(ht(n))),
                    d(zdn, Mt(n.cz))
                ]),
                mn: Vdn,
                fv: n.fv,
                fL: n.z + "/" + Mt(n.fv),
                nd: n.aC,
                rW: $(Odn, A3(Kd, 2, "0", Mt(n.fv))),
                r9: n.r9,
                sz: n.sz
            };
        }, p)), g = A2(mu, function(n) {
            return a(n.r9, kt);
        }, p), h = $(function() {
            var n = f.bQ.f$;
            return n.$ ? w : k([
                n.a
            ]);
        }(), A2(yu, i, f.bQ.d7));
        return k([
            A4(agn, r, n, {
                co: !0,
                jt: c,
                rW: r.g9.rX
            }, t),
            hon(t),
            A2(ye, k([
                Ow("ShowHomeWrapper")
            ]), k([
                A3(dgn, r, t, g),
                A2(tgn, r, t),
                A5(Twn, n.mM, r, b, p, t),
                A2(dbn, p$n(s), A3(jwn, t, A2(Kc, Z1, A2(d$n, A2(Lu, function(n) {
                    return n.mo;
                }, s), h)), m)),
                A5(s$n, n, t, r, v, f),
                A2(dbn, !a(r.bP, w), Jx(k([
                    nq(Fwn)
                ]))),
                A2(mh, S1, A5(Mwn, r, f, A2(Lu, function(n) {
                    return n.n3;
                }, t.o3), A2(sp, function(n) {
                    return n.rp;
                }, t.o3), t.bQ)),
                A3(qZ, n.st, r.g9.oM, A2(Ye, function(n) {
                    return n.fB;
                }, r.fD)) ? Xwn(r) : ag("")
            ]))
        ]);
    }), bgn = F3(function(n, r, t) {
        var e = A3(yon, n, r, t), u = A2(Pon, e.st, e.g9.oM);
        return Ton(e), A2(ye, k([
            Ow("ShowWrapper"),
            Ow(e.g9.ik && u ? "ShowAccepted" : "ShowNoop")
        ]), k([
            A2(ye, k([
                Ow("ShowMain")
            ]), A3(mgn, n, e, r)),
            A2(ye, k([
                Ow("ShowAside")
            ]), A2(lbn, e, r))
        ]));
    }), pgn = F2(function(n, r) {
        var t = r.P.kx;
        return 1 === t.$ ? function(n) {
            return A2(ye, k([
                Ow("ShowWrapper")
            ]), k([
                A2(ye, k([
                    Ow("ShowMain")
                ]), k([
                    $C(p(wC, {
                        fq: ht(lH)
                    })),
                    hon(n)
                ])),
                A2(ye, k([
                    Ow("ShowAside")
                ]), w)
            ]));
        }(r) : A3(bgn, n, r, t.a);
    }), vgn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $gn = F2(function(n, r) {
        return A2(ye, k([
            Ow("TimelineWrapper")
        ]), k([
            function() {
                var n = r.lo;
                return 1 === n.$ ? ag("") : A2(Zx, Vnn, ag(n.a));
            }(),
            A2(mh, vgn, A2(ye, k([
                Ow("TimelineList")
            ]), A2(von, n.st, r.rV)))
        ]));
    }), wgn = A2(ye, k([
        Ow("BrowserWrapper")
    ]), k([
        oen
    ])), ggn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, hgn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, kgn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Cgn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Tgn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Pgn = xa({
        bN: "Accepted only",
        bT: "Accept\xe9s seulement"
    }), Sgn = xa({
        bN: "Display all",
        bT: "Tout afficher"
    }), Agn = xa({
        bN: "Non-accepted only",
        bT: "Non-accept\xe9s seulement"
    }), ygn = k([
        d(tX, Sgn),
        d(nX, Pgn),
        d(uX, Agn)
    ]), Ngn = xa({
        bN: "Actives only",
        bT: "Actifs seulement"
    }), Lgn = xa({
        bN: "Archives only",
        bT: "Archives seulement"
    }), jgn = xa({
        bN: "Trash",
        bT: "Corbeille"
    }), Fgn = k([
        m(!1, tX, Sgn),
        m(!1, rX, Ngn),
        m(!1, eX, Lgn),
        m(!0, oX, jgn)
    ]), Mgn = xa({
        bN: "New",
        bT: "Nouveau"
    }), Ign = xa({
        bN: "Add Advertiser",
        bT: "Ajouter un Annonceur"
    }), Dgn = xa({
        bN: "Add Collection",
        bT: "Ajouter une Collection"
    }), Bgn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, xgn = {
        $: 5
    }, qgn = A2(ye, k([
        Ow("LoadingMiniSpinner")
    ]), k([
        ugn
    ])), Vgn = xa({
        bN: "New Ad",
        bT: "Nouveau Spot"
    }), Ogn = xa({
        bN: "New Advertiser",
        bT: "Nouvel Annonceur"
    }), zgn = xa({
        bN: "New Capsule",
        bT: "Nouvelle Capsule"
    }), Egn = xa({
        bN: "New Collection",
        bT: "Nouvelle Collection"
    }), Hgn = xa({
        bN: "New Episode",
        bT: "Nouvel Episode"
    }), Rgn = xa({
        bN: "New Master",
        bT: "Nouveau Master"
    }), Wgn = xa({
        bN: "New Product",
        bT: "Nouveau Produit"
    }), Ugn = xa({
        bN: "New Season",
        bT: "Nouvelle Saison"
    }), Qgn = xa({
        bN: "New Title",
        bT: "Nouveau Titre"
    }), _gn = xa({
        bN: "New Unitary",
        bT: "Nouvel Unitaire"
    }), Zgn = A2(Zw, k([
        Hw("18px"),
        Xw("18px"),
        Kw("0 0 18 18"),
        Fw("IconPlus")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(iC, k([
                aC("M10,8 L10,4 L8,4 L8,8 L4,8 L4,10 L8,10 L8,14 L10,14 L10,10 L14,10 L14,8 L10,8 Z")
            ]), w)
        ]))
    ])), Kgn = F2(function(n, r) {
        var t = function(n) {
            return {
                $: 7,
                a: n
            };
        }(r), e = function() {
            var r = n.og;
            if (r.$) return "";
            if (r.a.$) return 1 === r.a.a ? n.mM ? Vgn : Rgn : zgn;
            switch(r.a.a){
                case 0:
                    return n.mM ? Ogn : Egn;
                case 1:
                    return n.mM ? Wgn : Ugn;
                case 2:
                    return n.mM ? Qgn : Hgn;
                default:
                    return _gn;
            }
        }(), u = n.iw;
        return A2(Hk, k([
            Uk(t),
            Ow("BrowserNewForm")
        ]), k([
            A2(ye, k([
                Ow("BrowserNewFormIcon")
            ]), k([
                function() {
                    var r = n.og;
                    n: for(; !r.$;){
                        if (r.a.$) return 1 === r.a.a ? jrn : Frn;
                        switch(r.a.a){
                            case 0:
                                return xen;
                            case 1:
                                return qen;
                            default:
                                break n;
                        }
                    }
                    return Ven;
                }()
            ])),
            A2(mh, Bgn, ah(p(u, {
                kX: "new-add-form",
                gw: e
            }))),
            A2(Aw, k([
                Tg("submit"),
                Ow("BrowserNewFormIcon")
            ]), k([
                A2(pX, r, n.rl) ? qgn : Zgn
            ])),
            A2(ye, k([
                Ow("BrowserNewFormIcon"),
                Cg(xgn)
            ]), k([
                tj
            ]))
        ]));
    }), Xgn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Jgn = function(n) {
        return Cg(n);
    }, Ygn = function(n) {
        var r = n.a, t = n.b, e = n.c;
        return A2(ye, k([
            Ow("BrowserOptionsItem"),
            Jgn(A2(Xgn, ht(r), t))
        ]), k([
            ag(e)
        ]));
    }, Ggn = xa({
        bN: "Add Unitary",
        bT: "Ajouter un Unitaire"
    }), nhn = "alphabeticalInversed", rhn = xa({
        bN: "Reverse alphabetical",
        bT: "Alphab\xe9tique invers\xe9"
    }), thn = xa({
        bN: "Alphabetical",
        bT: "Alphab\xe9tique"
    }), ehn = k([
        d("alphabetical", thn),
        d(nhn, rhn)
    ]), uhn = {
        $: 16
    }, ohn = xa({
        bN: "Vous n\u2019avez aucune enveloppe.",
        bT: "Vous n\u2019avez aucune enveloppe."
    }), ahn = function(n) {
        return A2(ye, k([
            Ow("BrowserErrors"),
            Cg(uhn)
        ]), k([
            Tu(n.jL) && Tu(n.fD) ? B8(ohn) : ag(""),
            function() {
                var r = n.lo;
                return r.$ ? ag("") : A2(Bnn, Vnn, r.a);
            }()
        ]));
    }, ihn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), chn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fhn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, shn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lhn = function(n) {
        switch(n){
            case 0:
                return "MixedAccepted";
            case 1:
                return "AcceptedContent";
            case 2:
                return "NonAcceptedContent";
            default:
                return "EmptyAccepted";
        }
    }, dhn = F4(function(n, r, t, e) {
        return A2(ye, k([
            Ow("BrowserIcon")
        ]), k([
            A2(pX, r.mo, n) ? t : e
        ]));
    }), mhn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), bhn = F3(function(n, r, t) {
        var e = A2(bX, t.mo, n.k3);
        return A2(ye, k([
            Ow("BrowserEdit"),
            Jgn(A2(mhn, r, t))
        ]), k([
            e ? tj : gln
        ]));
    }), phn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, vhn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, $hn = F2(function(n, r) {
        var t = n.k5;
        return A2(Hk, k([
            Uk(vhn(r.mo))
        ]), k([
            A2(mh, phn, ah(t))
        ]));
    }), whn = xa({
        bN: "Add Ad",
        bT: "Ajouter un Spot"
    }), ghn = xa({
        bN: "Add Capsule",
        bT: "Ajouter une Capsule"
    }), hhn = xa({
        bN: "Add Episode",
        bT: "Ajouter un \xc9pisode"
    }), khn = xa({
        bN: "Add Master",
        bT: "Ajouter un Master"
    }), Chn = xa({
        bN: "Add Product",
        bT: "Ajouter un Produit"
    }), Thn = xa({
        bN: "Add Season",
        bT: "Ajouter une Saison"
    }), Phn = xa({
        bN: "Add Title",
        bT: "Ajouter un Titre"
    }), Shn = prn(k([
        A2(Ik, k([
            Fw("Fg"),
            Nj("translate(1.000000, 0.000000)")
        ]), k([
            A2(iC, k([
                aC("M6,0 L12,0 L16,4 L16,13 L6,13 L6,0 Z M8,2 L8,11 L14,11 L14,5 L11,5 L11,2 L8,2 Z")
            ]), w),
            A3(Qw, "polygon", k([
                Rw("0 5 5 5 5 7 2 7 2 16 8 16 8 14 10 14 10 18 0 18")
            ]), w)
        ]))
    ])), Ahn = F3(function(n, r, t) {
        if (1 === t.$) {
            var e = t.a, u = t.b, o = t.c, a = A2(bX, r.mo, n.iv);
            return A2(ye, k([
                Ow("BrowserOptions"),
                Cg(a ? xgn : A2(Xgn, ht(e), u)),
                Bg(k([
                    d("BrowserOptionsOpened", a)
                ])),
                II(o)
            ]), k([
                A2(ye, k([
                    Ow("BrowserOptionsTitle")
                ]), k([
                    a ? tj : wen
                ]))
            ]));
        }
        var i = t.a;
        return a = A2(bX, r.mo, n.oK), A2(ye, k([
            Ow("BrowserOptions"),
            Cg(Tgn(r.mo)),
            kP(a),
            Bg(k([
                d("BrowserOptionsOpened", a)
            ]))
        ]), k([
            A2(ye, k([
                Ow("BrowserOptionsTitle")
            ]), k([
                a ? tj : wen
            ])),
            a ? A2(ye, k([
                Ow("BrowserOptionsMenu")
            ]), A2(Ye, Ygn, i)) : ag("")
        ]));
    }), yhn = F4(function(n, r, t, e) {
        var u = t.mM ? Chn : Thn, o = t.mM ? whn : khn, i = t.mM ? Phn : hhn, c = a(t.qs, ht(e.mo)), f = A2(pX, e.mo, t.oC), s = A2(bX, e.mo, t.iv), l = 2 === e.gi && GK(e), b = 1 !== e.gi && !l;
        if (s || b) {
            var p = e.eC;
            if (p.$) return v = p.a, d(e.mo, A2(ye, k([
                Ow("BrowserTitle"),
                Bg(k([
                    d("BrowserTitleOpened", A2(bX, e.mo, r)),
                    d("BrowserTitleHidden", c && !b)
                ])),
                Ow("BrowserItemWrapper")
            ]), k([
                A2(oC, k([
                    Kg(e.mo),
                    Ow("BrowserItem"),
                    fC(wX(e.mo))
                ]), k([
                    A2(ye, k([
                        Ow("BrowserIcon")
                    ]), k([
                        1 === v ? jrn : Frn
                    ])),
                    A2(dg, k([
                        Ow(1 === v ? "BrowserLabelMaster" : "BrowserLabelShow")
                    ]), k([
                        A2(bX, e.mo, t.k3) ? A2($hn, t, e) : ag(e.m7)
                    ])),
                    e.ik ? A2(ye, k([
                        Ow("BrowserIcon")
                    ]), k([
                        A2(dg, k([
                            Ow("BrowserShowAccepted")
                        ]), w)
                    ])) : ag(""),
                    e.h5 ? A2(ye, k([
                        Ow("BrowserIcon")
                    ]), k([
                        uun
                    ])) : GK(e) ? A2(ye, k([
                        Ow("BrowserIcon")
                    ]), k([
                        eun
                    ])) : ag("")
                ])),
                A2(bX, e.oM, n.st.oM) ? A3(bhn, t, ht(shn(v)), e) : ag(""),
                A2(pX, e.mo, t.oC) ? A2(ye, k([
                    Ow("BrowserList")
                ]), k([
                    A2(bX, e.mo, t.iv) ? A2(Kgn, t, e.mo) : ag("")
                ])) : ag("")
            ])));
            var v = p.a, g = p.b, h = function() {
                switch(v){
                    case 0:
                        return m(d("BrowserCollection", 0), d(vrn, xen), d(A3(ihn, kgn(1), e.mo, u), ht(wrn(e.mo))));
                    case 1:
                        return m(d("BrowserSeason", 1), d(Shn, qen), d(A3(ihn, kgn(2), e.mo, i), ht(wrn(e.mo))));
                    case 2:
                        return m(d("BrowserEpisode", 2), d(Ven, Ven), d(chn(k([
                            m(shn(1), e.mo, o),
                            m(shn(0), e.mo, ghn)
                        ])), ht(wrn(e.mo))));
                    default:
                        return m(d("BrowserCollection", 3), d(Ven, Ven), d(chn(k([
                            m(shn(1), e.mo, khn),
                            m(shn(0), e.mo, ghn)
                        ])), ht(wrn(e.mo))));
                }
            }(), C = h.b, T = C.a, P = C.b, S = h.c, A = S.a, y = S.b;
            return d(e.mo, A2(ye, k([
                Ow(h.a.a),
                Ow(lhn(e.dU))
            ]), k([
                A2(ye, k([
                    Ow("BrowserItemWrapper"),
                    Bg(k([
                        d("BrowserOpened", f),
                        d("BrowserAdding", s),
                        d("BrowserEmpty", 2 === e.gi),
                        d("BrowserShowAccepted", 1 === e.dU),
                        d("BrowserTitleOpened", A2(bX, e.mo, r)),
                        d("BrowserHasMenuOpened", A2(bX, e.mo, t.oK))
                    ]))
                ]), $(k([
                    A2(ye, k([
                        Ow("BrowserItem"),
                        Cg(fhn(e.mo))
                    ]), k([
                        A4(dhn, t.oC, e, T, P),
                        A2(dg, k([
                            Ow("BrowserLabelMaster")
                        ]), k([
                            A2(bX, e.mo, t.k3) ? A2($hn, t, e) : ag(e.m7)
                        ])),
                        e.h5 ? A2(ye, k([
                            Ow("BrowserIcon")
                        ]), k([
                            uun
                        ])) : 1 === e.hv ? A2(ye, k([
                            Ow("BrowserIcon")
                        ]), k([
                            eun
                        ])) : ag("")
                    ])),
                    function() {
                        var r = d(y, A2(bX, e.oM, n.st.oM));
                        if (!r.a.$ && r.b) {
                            var t = r.a.a;
                            return A2(oC, k([
                                Ow("BrowserAttachment"),
                                fC(t),
                                Kg(e.mo)
                            ]), k([
                                Mun
                            ]));
                        }
                        return ag("");
                    }()
                ]), A2(bX, e.oM, n.st.oM) ? k([
                    A3(bhn, t, ht(kgn(v)), e),
                    A3(Ahn, t, e, A)
                ]) : w)),
                f ? A3(hh, "div", k([
                    Ow("BrowserList"),
                    Bg(k([
                        d("BrowserListOpened", f),
                        d("BrowserAdding", s)
                    ]))
                ]), (a(t.oL.sw, nhn) ? Zt : Me)(A2(Ye, A3(yhn, n, r, t), g))) : ag(""),
                s ? A2(ye, w, k([
                    A2(Kgn, t, e.mo)
                ])) : ag("")
            ])));
        }
        return d(e.mo, ag(""));
    }), Nhn = F3(function(n, r, t) {
        return A2(mt, d("head", function() {
            var n = Eo(t.jL);
            if (n.$) return ag("");
            var r, e = n.a;
            return A2(qg, k([
                Ow("BrowserSection")
            ]), xa({
                bN: (r = e.gm) + "\u2019s Stock",
                bT: "Stock de " + r
            }));
        }()), (a(t.oL.sw, nhn) ? Zt : Me)(A2(Ye, A3(yhn, n, r, t), t.jL)));
    }), Lhn = F3(function(n, r, t) {
        var e = function(n) {
            return vt(n);
        }(Df(A2(Ye, function(n) {
            return n.gm;
        }, A2(Mu, function(r) {
            return a(GK(r), n.d2);
        }, t.fD))));
        return A2(mt, d("Invitations", A2(qg, k([
            Ow("BrowserSection")
        ]), "Invitations")), A2(Ye, function(e) {
            return d(e, A3(hh, "div", w, A2(mt, d("org", A2(qg, k([
                Ow("BrowserSubSection")
            ]), e)), A2(Ye, A3(yhn, n, r, t), A2(Mu, function(n) {
                return a(n.gm, e);
            }, t.fD)))));
        }, e));
    }), jhn = F3(function(n, r, t) {
        var e = t.mM ? Ign : Dgn, u = k(t.mM ? [
            m(kgn(0), "", e)
        ] : [
            m(kgn(0), "", e),
            m(kgn(3), "", Ggn)
        ]), o = A2(bX, "", t.oK), i = !a(n.st.oM, kt), c = A2(Kc, function(r) {
            return r.a && !n.st.iz ? kt : ht(d(r.b, r.c));
        }, Fgn);
        return A2(ye, k([
            Ow("BrowserWrapper")
        ]), k([
            A2(ye, k([
                Ow("BrowserHeader")
            ]), k([
                A2(ye, k([
                    Ow("BrowserOrder")
                ]), k([
                    A2(mh, hgn, A2(zk, t.iU, c)),
                    A2(mh, ggn, A2(zk, t.il, ygn)),
                    A2(mh, Cgn, A2(zk, t.oL, ehn))
                ])),
                A2(ye, k([
                    Ow("BrowserNewButton")
                ]), k([
                    i ? DI(p(dI, {
                        lx: k([
                            kP(o)
                        ]),
                        mn: ht(wen),
                        mK: o,
                        m7: Mgn,
                        oy: ht(Tgn(""))
                    })) : ag(""),
                    A2(bX, "", t.oK) ? A2(ye, k([
                        Ow("BrowserOptionsMenu")
                    ]), A2(Ye, Ygn, u)) : ag("")
                ]))
            ])),
            A2(ye, k([
                Ow("BrowserNew")
            ]), k([
                A2(bX, "", t.iv) ? A2(Kgn, t, "") : ag("")
            ])),
            ahn(t),
            A2(ye, k([
                Ow("Browser")
            ]), k([
                A3(hh, "div", w, A3(Nhn, n, r, t)),
                A3(hh, "div", w, A3(Lhn, n, r, t))
            ]))
        ]));
    }), Fhn = F3(function(n, r, t) {
        return 1 === t.P.kx.$ ? wgn : A3(jhn, n, r, t);
    }), Mhn = F5(function(n, r, t, e, u) {
        return A3(hh, "div", k([
            Ow("ShowsWrapper"),
            Ow(r.sr.$ ? "ActiveShow" : "ActiveShows")
        ]), k([
            d("Browser", A2(mh, Sa, A3(Fhn, r, t, e))),
            d(n, u)
        ]));
    }), Ihn = {
        $: 3
    }, Dhn = wP(gp(zp)), Bhn = wP(gp(rv)), xhn = wP(gp(tv)), qhn = wP(gp(Ep)), Vhn = wP(gp(Rp)), Ohn = wP(gp(Wp)), zhn = function(n) {
        return 4 === n.$ && 18 === n.a.$;
    }, Ehn = function(n) {
        return 4 === n.$ && 14 === n.a.$;
    }, Hhn = wP(gp(_p)), Rhn = wP(gp(Zp)), Whn = wP(gp(Kp)), Uhn = wP(gp(Xp)), Qhn = wP(gp(Jp)), _hn = xa({
        bN: "Report",
        bT: "Rapport"
    }), Zhn = wP(Tp), Khn = wP(gp(Yp)), Xhn = wP(gp(Gp)), Jhn = wP(gp(nv)), Yhn = F3(function(n, r, t) {
        return A2(oC, k([
            Bg(k([
                d("MenuSettingsActive", n)
            ])),
            Ow("MenuSettingsItem"),
            fC(r)
        ]), k([
            t
        ]));
    }), Ghn = wP(gp(ev)), nkn = wP(gp(uv)), rkn = function(n) {
        var r;
        return A2(ye, k([
            Ow("MenuSettingsSub")
        ]), k([
            A3(Yhn, zhn(n.sr), gP({
                c$: kt
            }), ag("Dashboard")),
            A3(Yhn, a(n.sr, Tp), Zhn, ag(_hn)),
            A3(Yhn, a(n.sr, gp(Xp)), Uhn, ag("Organizations")),
            A3(Yhn, a(n.sr, gp(Zp)), Rhn, ag("Onboarding")),
            A3(Yhn, a(n.sr, gp(ev)), Ghn, ag("Users")),
            A3(Yhn, a(n.sr, gp(tv)), xhn, ag("Uploads")),
            A3(Yhn, a(n.sr, gp(rv)), Bhn, ag("Test Plans")),
            A3(Yhn, a(n.sr, gp(zp)), Dhn, ag("Audio Mappings")),
            A3(Yhn, a(n.sr, gp(Ep)), qhn, ag("Channels")),
            A3(Yhn, a(n.sr, gp(Yp)), Khn, ag("Researchs")),
            A3(Yhn, a(n.sr, gp(uv)), nkn, ag("Webhooks")),
            A3(Yhn, a(n.sr, gp(Kp)), Whn, ag("Organization file listing")),
            A3(Yhn, a(n.sr, gp(Wp)), Ohn, ag("Formats")),
            A3(Yhn, a(n.sr, gp(nv)), Jhn, ag("Subtitle Formats")),
            A3(Yhn, a(n.sr, gp(Gp)), Xhn, ag("Segmentation rules")),
            A3(Yhn, Ehn(n.sr), (r = A4(iv, kt, kt, kt, kt), wP(gp(Qp(r)))), ag("Jobs")),
            A3(Yhn, a(n.sr, gp(_p)), Hhn, ag("Metadata")),
            A3(Yhn, a(n.sr, gp(Rp)), Vhn, ag("Deep Probe Templates")),
            A3(Yhn, a(n.sr, gp(Jp)), Qhn, ag("Deep Probes")),
            A3(Yhn, a(n.sr, gp(Up)), drn, ag("Flubber"))
        ]));
    }, tkn = A2(Zw, k([
        Hw("40px"),
        Xw("40px"),
        Kw("0 0 27 27"),
        Fw("IconSettings")
    ]), k([
        A2(Ik, k([
            Fw("Fg")
        ]), k([
            A2(iC, k([
                aC("M11.3255145,8.62757252 L11.7398554,10.6992769 C10.6891763,11.4201032 10,12.6295687 10,14 C10,16.209139 11.790861,18 14,18 C16.209139,18 18,16.209139 18,14 C18,12.6295687 17.3108237,11.4201032 16.2601446,10.6992769 L16.6744855,8.62757252 C18.6458726,9.61086325 20,11.6472949 20,14 C20,17.3137085 17.3137085,20 14,20 C10.6862915,20 8,17.3137085 8,14 C8,11.6472949 9.35412735,9.61086325 11.3255145,8.62757252 Z M13,7 L15,7 L15,15 L13,15 L13,7 Z")
            ]), w)
        ]))
    ])), ekn = xa({
        bN: "Logout",
        bT: "D\xe9connexion"
    }), ukn = function(n) {
        return A2(ye, k([
            Ow("MenuSettingsSub")
        ]), k([
            A3(Yhn, a(n.sr, Tp), Zhn, ag(_hn))
        ]));
    }, okn = F3(function(n, r, t) {
        var e, u;
        return A3(hh, "div", k([
            Ow("SettingsWrapper")
        ]), k([
            d("SettingsMenu", A2(mh, hU, (e = r, u = 8 === e.sr.$, A2(ye, k([
                Ow("MenuSettings")
            ]), k([
                e.st.iz ? rkn(e) : ukn(e),
                A2(oC, k([
                    Ow("MenuSettingsItem"),
                    Ow("MenuSettingsProfile"),
                    fC(Arn),
                    Bg(k([
                        d("MenuSettingsActive", u)
                    ]))
                ]), k([
                    A2(ye, k([
                        Ow("MenuSettingsIcon")
                    ]), k([
                        Brn
                    ])),
                    A2(ye, k([
                        Ow("MenuSettingsTitle")
                    ]), k([
                        A2(ye, k([
                            Ow("UserCardName")
                        ]), k([
                            ag(e.st.n6)
                        ]))
                    ]))
                ])),
                A2(ye, k([
                    Ow("MenuSettingsItem"),
                    Ow("MenuSettingsLogout"),
                    Cg(Ihn)
                ]), k([
                    A2(ye, k([
                        Ow("MenuSettingsIcon")
                    ]), k([
                        tkn
                    ])),
                    A2(ye, k([
                        Ow("MenuSettingsTitle")
                    ]), k([
                        ag(ekn)
                    ]))
                ]))
            ]))))),
            d(n, t)
        ]));
    }), akn = function(n) {
        if (1 === n.$) return A2(mh, Na, function(n) {
            var r = 1 === n.ak.sr.$ ? A2($nn, inn, hnn) : w;
            return A2(ye, A2(mt, Bg(k([
                d("IsFullscreen", n.ak.dO.mR),
                d("AsideOpened", function() {
                    var r = n.ak.sr;
                    switch(r.$){
                        case 1:
                        case 2:
                            return !!r.b;
                        default:
                            return !1;
                    }
                }())
            ])), r), k([
                A2(ye, k([
                    Ow("AppWrapper")
                ]), k([
                    Drn(n),
                    A3(hh, "div", k([
                        Ow("Wrapper")
                    ]), k([
                        d("Menu", A3(Cnn, hU, Grn, n.ak)),
                        function() {
                            var r = n.ak.sr;
                            switch(r.$){
                                case 8:
                                    return d("Settings", A3(okn, "", n.ak, A4(ynn, La, crn, n.ak, n.dp)));
                                case 9:
                                    return d("Report", A3(okn, "", n.ak, A4(ynn, gZ, Wnn, n.ak, n.b9)));
                                case 0:
                                    return d("APP", A5(Mhn, "Shows", n.ak, kt, n.em, A4(ynn, ja, $gn, n.ak, n.rV)));
                                case 2:
                                    return d("APP", A5(Mhn, "Hierarchy", n.ak, ht(r.a), n.em, A5(Nnn, wv, gon, n.ak, n.ol, n.em)));
                                case 1:
                                    return d("APP", A5(Mhn, "Show", n.ak, ht(r.a), n.em, A4(ynn, gv(n.g9.mo), pgn, n.ak, n.g9)));
                                case 6:
                                    return d("APP", A5(Mhn, "Archive", n.ak, kt, n.em, A4(ynn, ja, $gn, n.ak, n.rV)));
                                case 4:
                                    return d("Admin", A3(okn, "", n.ak, A5(Nnn, Pa, srn, n.ak, r.a, n.iz)));
                                case 5:
                                    return d("Help", function(n) {
                                        var r = n.oV;
                                        if (r.$) return A2(ye, k([
                                            Ow("SettingsWrapper")
                                        ]), k([
                                            Lj
                                        ]));
                                        if (r.a.$) return ag("Erreur 404");
                                        var t = r.a.a;
                                        return A2(ye, k([
                                            Ow("SettingsWrapper")
                                        ]), k([
                                            A3(gC, t.rW, kt, A2(ye, k([
                                                Ow("Help")
                                            ]), k([
                                                ten(t.ei)
                                            ])))
                                        ]));
                                    }(n.l7));
                                case 7:
                                    return d("Upload", A4(ynn, TU, Ktn, {
                                        e1: n.ak.e1,
                                        mm: knn(n.k0),
                                        oV: b8(n),
                                        st: n.ak.st
                                    }, n.sk));
                                default:
                                    return d("notfound", A2(ye, k([
                                        Ow("SettingsWrapper")
                                    ]), k([
                                        ag("NOT FOUND")
                                    ])));
                            }
                        }()
                    ])),
                    A4(ynn, TU, Ktn, {
                        e1: n.ak.e1,
                        mm: knn(n.k0),
                        oV: b8(n),
                        st: n.ak.st
                    }, n.sk)
                ]))
            ]));
        }(n.a));
        var r = n.a;
        return function(n) {
            return A2(ye, k([
                Ow("AccountPageWrapper")
            ]), k([
                A2(ye, w, k([
                    A2(oC, k([
                        Ow("AccountPageLogo"),
                        fC("/")
                    ]), k([
                        J8
                    ]))
                ])),
                A2(ye, k([
                    Ow("AccountPageContent")
                ]), n)
            ]));
        }(k([
            function() {
                var n = r.oV;
                switch(n.$){
                    case 0:
                        var t = n.a;
                        return A2(mh, A2(bu, vU, g_), function(n) {
                            var r = 2 !== n.q0;
                            return A2(h8, J_, k([
                                A2(ye, k([
                                    Ow("AccountHeader")
                                ]), k([
                                    A2(qg, k([
                                        Ow("AccountTitle")
                                    ]), z8)
                                ])),
                                A2(ye, k([
                                    Ow("AccountFormFields")
                                ]), k([
                                    A2(mh, V8, Mk(n.la)),
                                    A2(ye, k([
                                        Bg(k([
                                            d("AccountFormPassword", !0),
                                            d("AccountFormPasswordHide", r)
                                        ]))
                                    ]), k([
                                        A2(mh, O8, RH(n.o_))
                                    ]))
                                ])),
                                A2(ye, k([
                                    Ow("AccountMessage")
                                ]), k([
                                    Q8(n.nP)
                                ])),
                                A2(ye, k([
                                    Ow("AccountFooter")
                                ]), k([
                                    A2(ye, k([
                                        Ow("AccountFooterLinks")
                                    ]), k([
                                        A2(DL, !r, A2(k8, H8, R8))
                                    ])),
                                    Qk(r ? W8 : E8)
                                ]))
                            ]));
                        }(t));
                    case 1:
                        return t = n.a, A2(mh, A2(bu, vU, $_), function(n) {
                            return A2(h8, w8, k([
                                A2(ye, k([
                                    Ow("AccountHeader")
                                ]), k([
                                    A2(qg, k([
                                        Ow("AccountTitle")
                                    ]), S8)
                                ])),
                                A2(ye, k([
                                    Ow("AccountFormFields")
                                ]), k([
                                    A2(mh, $8, Mk(n.la))
                                ])),
                                A2(ye, k([
                                    Ow("AccountMessage")
                                ]), k([
                                    function() {
                                        var r = n.nP;
                                        switch(r.$){
                                            case 0:
                                                return ag("");
                                            case 1:
                                                return A2(qg, k([
                                                    Ow("succeed")
                                                ]), N8);
                                            default:
                                                var t = r.a;
                                                return A2(qg, k([
                                                    Ow("failed")
                                                ]), t);
                                        }
                                    }()
                                ])),
                                A2(ye, k([
                                    Ow("AccountFooter")
                                ]), k([
                                    A2(ye, k([
                                        Ow("AccountFooterLinks")
                                    ]), k([
                                        A2(k8, P8, g8)
                                    ])),
                                    Qk(y8)
                                ]))
                            ]));
                        }(t));
                    case 2:
                        return t = n.a, A2(mh, A2(bu, vU, h_), function(n) {
                            var r;
                            return A2(h8, nnn, k([
                                A2(ye, k([
                                    Ow("AccountHeader")
                                ]), k([
                                    A2(qg, k([
                                        Ow("AccountTitle")
                                    ]), unn)
                                ])),
                                A2(ye, k([
                                    Ow("AccountFormFields")
                                ]), k([
                                    A2(mh, G8, enn(n.o_)),
                                    A2(mh, Y8, enn(n.j5)),
                                    ann(n.nP),
                                    (r = n.o$, r.$ ? ag("") : B8(x8(r.a)))
                                ])),
                                A2(ye, k([
                                    Ow("AccountFooter")
                                ]), k([
                                    A2(ye, k([
                                        Ow("AccountFooterLinks")
                                    ]), k([
                                        A2(k8, P8, rnn)
                                    ])),
                                    Qk(tnn)
                                ]))
                            ]));
                        }(t));
                    default:
                        return t = n.a, A2(mh, A2(bu, vU, w_), function(n) {
                            var r;
                            return A2(h8, I8, k([
                                A2(ye, k([
                                    Ow("AccountHeader")
                                ]), k([
                                    A2(qg, k([
                                        Ow("AccountTitle")
                                    ]), D8)
                                ])),
                                A2(ye, k([
                                    Ow("AccountFormFields")
                                ]), k([
                                    A2(mh, j8, Mk(n.n6)),
                                    A2(mh, M8, RH(n.o_)),
                                    A2(mh, L8, RH(n.j5)),
                                    (r = n.o$, r.$ ? ag("") : B8(x8(r.a)))
                                ])),
                                A2(ye, k([
                                    Ow("AccountMessage")
                                ]), k([
                                    A2(Ck, qg(k([
                                        Ow("failed")
                                    ])), n.lo)
                                ])),
                                A2(ye, k([
                                    Ow("AccountFooter")
                                ]), k([
                                    A2(ye, k([
                                        Ow("AccountFooterLinks")
                                    ]), w),
                                    Qk(q8)
                                ]))
                            ]));
                        }(t));
                }
            }()
        ]));
    }, ikn = function(n) {
        switch(n.$){
            case 0:
                return Mt(n.a) + "px";
            case 1:
                return by(n.a) + "%";
            case 2:
                return by(n.a) + "em";
            default:
                return "auto";
        }
    }, ckn = Nmn, fkn = function(n) {
        return A2(ckn, "bottom", ikn(n));
    }, skn = function(n) {
        return A2(ckn, "left", ikn(n));
    }, lkn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, dkn = lkn, mkn = {
        ii: A2(ckn, "position", "absolute"),
        lK: A2(ckn, "position", "fixed"),
        dj: A2(ckn, "position", "relative"),
        q9: A2(ckn, "position", "static"),
        hy: A2(ckn, "position", "sticky")
    }, bkn = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, pkn = function(n) {
        return A2(ckn, "top", ikn(n));
    }, vkn = F3(function(n, r, t) {
        return dkn(k([
            mkn.ii,
            pkn(bkn(n)),
            fkn(bkn(r)),
            skn(bkn(t))
        ]));
    }), $kn = function(n) {
        return A2(ckn, "right", ikn(n));
    }, wkn = F4(function(n, r, t, e) {
        return dkn(k([
            mkn.ii,
            pkn(bkn(n)),
            $kn(bkn(r)),
            fkn(bkn(t)),
            skn(bkn(e))
        ]));
    }), gkn = F2(function(n, r) {
        return A2(Wh, r, $o(k([
            Eh(n)
        ])));
    }), hkn = gkn, kkn = {
        jj: A2(ckn, "display", "block"),
        lN: A2(ckn, "display", "flex"),
        mq: A2(ckn, "display", "inline"),
        mr: A2(ckn, "display", "inline-block"),
        ms: A2(ckn, "display", "inline-flex"),
        mt: A2(ckn, "display", "inline-table"),
        nj: A2(ckn, "display", "list-item"),
        om: A2(ckn, "display", "none"),
        pW: A2(ckn, "display", "run-in"),
        rD: A2(ckn, "display", "table"),
        rF: A2(ckn, "display", "table-caption"),
        rG: A2(ckn, "display", "table-cell"),
        rH: A2(ckn, "display", "table-column"),
        rI: A2(ckn, "display", "table-column-group"),
        rJ: A2(ckn, "display", "table-footer-group"),
        rK: A2(ckn, "display", "table-header-group"),
        rL: A2(ckn, "display", "table-row"),
        rM: A2(ckn, "display", "table-row-group")
    }, Ckn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Tkn = Ckn(3), Pkn = Tkn, Skn = F2(function(n, r) {
        return A2(Wh, r, A2(po, n, w));
    }), Akn = Skn, ykn = F2(function(n, r) {
        return A2(Akn, "", k([
            Pkn(A2(Ye, ce(r), n))
        ]));
    }), Nkn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Lkn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), jkn = F2(function(n, r) {
        var t = A2(Yu, Yo, r), e = function(r) {
            n: for(;;){
                if (!r.b) return w;
                switch(r.a.$){
                    case 0:
                        r = o = r.b;
                        continue n;
                    case 1:
                        var t = r.a, u = t.b, o = r.b;
                        return A2(mt, A2(Lkn, A2(yu, n, t.a), u), e(o));
                    default:
                        return A2(mt, r.a, e(o = r.b));
                }
            }
        }, u = function(n) {
            n: for(;;){
                if (n.b) {
                    if (n.a.$) {
                        n = n.b;
                        continue n;
                    }
                    return A2(mt, n.a.a, u(n.b));
                }
                return w;
            }
        }, o = A2(Lkn, n, u(t));
        return A2(mt, o, e(t));
    }), Fkn = F2(function(n, r) {
        return A2(jkn, A2(Ye, Nkn, n), r);
    }), Mkn = Fkn, Ikn = function(n) {
        return {
            jb: A2(ckn, n, "auto"),
            l8: A2(ckn, n, "hidden"),
            p9: A2(ckn, n, "scroll"),
            sH: A2(ckn, n, "visible")
        };
    }, Dkn = Ikn("overflow"), Bkn = k([
        A2(Mkn, k([
            "(min-width: 1400px)"
        ]), k([
            A2(ykn, k([
                hkn("LayoutBackButton"),
                hkn("LayoutHomeButton"),
                hkn("LayoutFwdButton")
            ]), k([
                kkn.om
            ])),
            A2(ykn, k([
                hkn("SettingsWrapper"),
                hkn("ShowsWrapper")
            ]), k([
                A4(wkn, 0, 0, 0, 94),
                Dkn.l8
            ])),
            A2(hkn, "BrowserWrapper", k([
                A3(vkn, 0, 0, 0)
            ])),
            A2(ykn, k([
                hkn("TimelineWrapper"),
                hkn("ShowWrapper"),
                hkn("MasterWrapper")
            ]), k([
                A4(wkn, 0, 0, 0, 404)
            ]))
        ]))
    ]), xkn = ckn("animation"), qkn = k([
        A2(hkn, "IsFullscreen", k([
            Pkn(k([
                A2(hkn, "ShowPlayer", k([
                    xkn("none")
                ]))
            ]))
        ]))
    ]), Vkn = function(n) {
        return A2(ckn, "flex-basis", ikn(n));
    }, Okn = {
        jY: A2(ckn, "flex-direction", "column"),
        jZ: A2(ckn, "flex-direction", "column-reverse"),
        pR: A2(ckn, "flex-direction", "row"),
        pU: A2(ckn, "flex-direction", "row-reverse")
    }, zkn = dkn(k([
        kkn.lN,
        Okn.jY
    ])), Ekn = A2(bu, ckn("flex-shrink"), Mt), Hkn = function(n) {
        return A2(ckn, "height", ikn(n));
    }, Rkn = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, Wkn = F3(function(n, r, t) {
        return A2(hkn, n, k([
            Pkn(k([
                A2(hkn, r, t)
            ]))
        ]));
    }), Ukn = ckn("transition"), Qkn = dkn(k([
        Ukn("all cubic-bezier(0.8, 0, 0.1, 1) 80ms")
    ])), _kn = ckn("transform"), Zkn = F3(function(n, r, t) {
        return _kn("translate3d(" + Mt(n) + "px," + Mt(r) + "px," + Mt(t) + "px)");
    }), Kkn = Nmn, Xkn = k([
        A2(Mkn, k([
            "(min-width: 1000px) and (max-width: 1400px)"
        ]), k([
            A2(hkn, "ShowWrapper", k([
                Ekn(0),
                Vkn(Rkn(100)),
                Qkn
            ])),
            A2(ykn, k([
                hkn("ShowWrapper")
            ]), k([
                A3(Zkn, 404, 0, 0),
                A4(wkn, 0, 0, 0, 0)
            ])),
            A2(hkn, "TimelineWrapper", k([
                A4(wkn, 0, 0, 0, 404)
            ])),
            A2(hkn, "MasterWrapper", k([
                A4(wkn, 0, 0, 0, 404)
            ])),
            A2(hkn, "ShowsWrapper", k([
                zkn,
                A4(wkn, 0, 0, 0, 94),
                Dkn.l8
            ])),
            A2(hkn, "SettingsWrapper", k([
                A4(wkn, 0, 0, 0, 94),
                Dkn.l8
            ])),
            A2(hkn, "BrowserWrapper", k([
                Qkn,
                A3(vkn, 0, 0, 0)
            ])),
            A2(hkn, "ShowMain", k([
                A2(Kkn, "width", "calc(100% - 404px)"),
                Ekn(0)
            ])),
            A2(Akn, ".ShowMain:only-child", k([
                mkn.ii,
                Hkn(Rkn(100))
            ])),
            A2(hkn, "LayoutBackButton", k([
                kkn.om
            ])),
            A2(hkn, "LayoutHomeButton", k([
                kkn.om
            ])),
            A2(hkn, "AsideOpened", k([
                Pkn(k([
                    A2(hkn, "ShowWrapper", k([
                        A3(Zkn, 0, 0, 0)
                    ])),
                    A2(hkn, "BrowserWrapper", k([
                        A3(Zkn, -404, 0, 0)
                    ])),
                    A2(hkn, "LayoutBackButton", k([
                        kkn.lN
                    ])),
                    A3(Wkn, "ShowMain", "LayoutFwdButton", k([
                        kkn.om
                    ]))
                ]))
            ]))
        ]))
    ]), Jkn = dkn(k([
        kkn.lN,
        Okn.pR
    ])), Ykn = k([
        A2(hkn, "AppWrapper", k([
            Jkn,
            A4(wkn, 4, 4, 4, 4),
            A3(Zkn, 0, 0, 0),
            Dkn.l8
        ])),
        A2(hkn, "Wrapper", k([
            Jkn,
            A4(wkn, 44, 0, 0, 0),
            A3(Zkn, 0, 0, 0),
            Dkn.l8
        ]))
    ]), Gkn = F2(function(n, r) {
        return ykn(A2(Ye, n, r));
    }), nCn = {
        $: 3
    }, rCn = F2(function(n, r) {
        return A2(ckn, "border", Mt(n) + "px solid " + r);
    }), tCn = {
        jn: A2(ckn, "clear", "both"),
        c0: A2(ckn, "clear", "left"),
        om: A2(ckn, "clear", "none"),
        pP: A2(ckn, "clear", "right")
    }, eCn = ckn("color"), uCn = Kkn("fill"), oCn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), aCn = function(n) {
        return oCn(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n));
    }, iCn = aCn("first-child"), cCn = iCn, fCn = {
        c0: A2(ckn, "float", "left"),
        om: A2(ckn, "float", "none"),
        pP: A2(ckn, "float", "right")
    }, sCn = {
        jl: A2(ckn, "font-weight", "600"),
        jm: A2(ckn, "font-weight", "700"),
        nh: A2(ckn, "font-weight", "400"),
        on: A2(ckn, "font-weight", "500")
    }, lCn = function(n) {
        return Tkn(k([
            A2(gkn, "Fg", k([
                A2(Kkn, "fill", n)
            ]))
        ]));
    }, dCn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mCn = F2(function(n, r) {
        return A2(Wh, r, $o(k([
            dCn(n)
        ])));
    }), bCn = mCn, pCn = function(n) {
        return A2(ckn, "margin", ikn(n));
    }, vCn = function(n) {
        return A2(ckn, "margin-top", ikn(n));
    }, $Cn = function(n) {
        return A2(ckn, "opacity", by(n / 100));
    }, wCn = function(n) {
        return A2(ckn, "padding", ikn(n));
    }, gCn = function(n) {
        return A2(ckn, "width", ikn(n));
    }, hCn = function(n) {
        return oCn(Eh(n));
    }, kCn = bkn(0), CCn = k([
        A2(Mkn, k([
            "print"
        ]), k([
            A2(Akn, ".Button", k([
                A2(Kkn, "display", "none !important")
            ])),
            A2(hkn, "IconBreadcrumb", k([
                uCn(ton)
            ])),
            A2(hkn, "Private", k([
                Dkn.p9
            ])),
            A2(hkn, "HeaderLogo", k([
                pkn(nCn),
                skn(nCn)
            ])),
            A3(Gkn, Akn, k([
                "button",
                "form"
            ]), k([
                A2(Kkn, "display", "none !important")
            ])),
            A2(bCn, "player", k([
                A2(Kkn, "display", "none !important")
            ])),
            A3(Gkn, hkn, k([
                "MasterFilesDesc"
            ]), k([
                A2(Kkn, "display", "flex !important")
            ])),
            A3(Gkn, Akn, k([
                ".ActivityItem",
                "tr"
            ]), k([
                A2(Kkn, "page-break-inside", "avoid")
            ])),
            A3(Gkn, hkn, k([
                "Search",
                "MenuWrapper",
                "BrowserWrapper",
                "PlayerVideoWrapper",
                "LayoutFwdButton",
                "LayoutHomeButton",
                "LayoutAppBarActions",
                "LayoutBackButton",
                "CustomButton",
                "PadokUploadWrapper",
                "ProgressBarOuter",
                "ActivityHeader",
                "ButtonMiniIcon",
                "ActivityAnswerForm",
                "FileOperationLabelProgress",
                "FileOperationProgress",
                "FileOperationIcon",
                "PadokUploadWrapper",
                "DeliveryChild",
                "UploadChild",
                "PlayerFoldPreview",
                "AcceptationHeaderActions",
                "Button",
                "ReportLinksButton",
                "HeaderLogo",
                "Acceptation",
                "LayoutAppBarWrapper",
                "FileOperation",
                "ActivityHeader",
                "ActivityCommentForm",
                "Operations"
            ]), k([
                A2(Kkn, "display", "none !important")
            ])),
            A2(hkn, "HeaderBreadcrumbLabel", k([
                eCn(Gun),
                sCn.jl
            ])),
            A2(hkn, "HeaderBreadcrumb", k([
                lCn(Gun + "!important"),
                A2(rCn, 3, Gun),
                vCn(bkn(8))
            ])),
            A2(hkn, "IconBreadcrumb", k([
                cCn(k([
                    kkn.om
                ]))
            ])),
            A2(hkn, "ActivityItem", k([
                A2(Kkn, "order", "10"),
                A2(hCn, "RedFlag", k([
                    A2(Kkn, "order", "1")
                ]))
            ])),
            A2(hkn, "ActivityContent", k([
                A2(rCn, 0, "!important")
            ])),
            A2(hkn, "ActivityItem", k([
                A2(rCn, 2, Gun)
            ])),
            A2(Akn, ".ActivityVerificationMessage:after", k([
                A2(Kkn, "content", '" "'),
                tCn.jn,
                kkn.jj,
                Hkn(bkn(1))
            ])),
            A2(hkn, "ActivityCommentVerifTc", k([
                fCn.c0,
                pCn(bkn(5)),
                Pkn(k([
                    A2(hkn, "ButtonIcon", k([
                        $Cn(0)
                    ])),
                    A2(hkn, "TimecodeWrapper", k([
                        A2(rCn, 2, Jun)
                    ])),
                    A2(hkn, "TimecodeUnit", k([
                        eCn(Jun)
                    ]))
                ]))
            ])),
            A3(Gkn, hkn, k([
                "AppWrapper",
                "Wrapper",
                "ShowsWrapper",
                "ShowWrapper",
                "ShowMain",
                "ShowAside",
                "ShowHomeWrapper",
                "MasterFilesWrapper"
            ]), k([
                _kn("translate(0,0)"),
                gCn(nCn),
                Hkn(nCn),
                pkn(kCn),
                $kn(kCn),
                fkn(kCn),
                skn(kCn),
                A2(Kkn, "overflow", "unset !important"),
                A2(Kkn, "display", "unset !important"),
                A2(Kkn, "position", "unset !important")
            ])),
            A3(Gkn, hkn, k([
                "MasterFilesWrapper",
                "ShowAside"
            ]), k([
                A2(rCn, 3, Gun),
                vCn(bkn(4)),
                A2(Kkn, "display", "block !important")
            ])),
            A2(hkn, "FileStatus", k([
                A2(rCn, 0, "black")
            ])),
            A2(hkn, "AsideTab", k([
                A2(rCn, 0, "black"),
                wCn(kCn),
                kkn.jj,
                gCn(kCn)
            ])),
            A3(Gkn, hkn, k([
                "AsideTabsIcon",
                "IconChoice"
            ]), k([
                kkn.om
            ])),
            A3(Gkn, hkn, k([
                "AsideHeader",
                "AsideTabsLabel",
                "AsideTabInner",
                "AsideTabs",
                "AsideTab"
            ]), k([
                kkn.jj,
                gCn(nCn),
                Hkn(nCn),
                wCn(kCn),
                A2(rCn, 0, "black !important")
            ])),
            A2(hkn, "AsideHeader", k([
                pCn(bkn(10))
            ])),
            A2(hkn, "Activity", k([
                pCn(bkn(3))
            ])),
            A2(hkn, "HeaderBreadcrumbItemLogo", k([
                A2(rCn, 0, "black")
            ])),
            A3(Gkn, hkn, k([
                "ShowHomeWrapper",
                "ShowWrapper"
            ]), k([
                zkn
            ])),
            A3(Gkn, hkn, k([
                "ActivityVerificationMessage",
                "ShowWrapper"
            ]), k([
                eCn(Gun)
            ]))
        ]))
    ]), TCn = k([
        A2(Mkn, k([
            "(max-width: 650px)"
        ]), k([
            A2(ykn, k([
                hkn("SettingsWrapper"),
                hkn("ShowsWrapper")
            ]), k([
                A4(wkn, 0, 0, 0, 0)
            ])),
            A2(hkn, "MenuWrapper", k([
                kkn.om,
                A2(hCn, "MenuOpened", k([
                    kkn.lN
                ]))
            ])),
            A2(hkn, "OptionalMenuItem", k([
                A2(Kkn, "display", "none !important")
            ]))
        ]))
    ]), PCn = {
        cs: A2(ckn, "align-items", "baseline"),
        jH: A2(ckn, "align-items", "center"),
        bR: A2(ckn, "align-items", "flex-end"),
        lR: A2(ckn, "align-items", "flex-start"),
        rh: A2(ckn, "align-items", "stretch")
    }, SCn = ckn("background"), ACn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), yCn = function(n) {
        return ACn(n);
    }, NCn = yCn("before"), LCn = F2(function(n, r) {
        return A2(ckn, "border-bottom", Mt(n) + "px solid " + r);
    }), jCn = F2(function(n, r) {
        return A2(ckn, "border-top", Mt(n) + "px solid " + r);
    }), FCn = function(n) {
        return A2(ckn, "font-size", ikn(n));
    }, MCn = dkn(k([
        FCn(bkn(20)),
        sCn.jl
    ])), ICn = {
        jH: A2(ckn, "justify-content", "center"),
        bR: A2(ckn, "justify-content", "flex-end"),
        lR: A2(ckn, "justify-content", "flex-start"),
        hk: A2(ckn, "justify-content", "space-around"),
        qY: A2(ckn, "justify-content", "space-between")
    }, DCn = F2(function(n, r) {
        return A2(ckn, "margin", A2(It, " ", A2(Ye, ikn, k([
            n,
            r
        ]))));
    }), BCn = F3(function(n, r, t) {
        return A2(ckn, "margin", A2(It, " ", A2(Ye, ikn, k([
            n,
            r,
            t
        ]))));
    }), xCn = function(n) {
        return A2(ckn, "max-width", ikn(n));
    }, qCn = F2(function(n, r) {
        return A2(ckn, "padding", A2(It, " ", A2(Ye, ikn, k([
            n,
            r
        ]))));
    }), VCn = function(n) {
        return A2(ckn, "padding-left", ikn(n));
    }, OCn = function(n) {
        return A2(ckn, "padding-right", ikn(n));
    }, zCn = {
        jH: A2(ckn, "text-align", "center"),
        fJ: A2(ckn, "text-align", "justify"),
        c0: A2(ckn, "text-align", "left"),
        pP: A2(ckn, "text-align", "right")
    }, ECn = "#fff", HCn = A2(bu, ckn("z-index"), Mt), RCn = k([
        A2(hkn, "AccountPageWrapper", k([
            xCn(bkn(580)),
            A3(BCn, bkn(50), nCn, bkn(0)),
            A2(qCn, bkn(0), bkn(10))
        ])),
        A2(hkn, "AccountPageLogo", k([
            kkn.jj,
            _kn("scale(0.7)")
        ])),
        A2(Mkn, k([
            "(max-width: 650px)"
        ]), k([
            A2(hkn, "AccountPageLogo", k([
                Pkn(k([
                    A2(Akn, "svg", k([
                        gCn(Rkn(100))
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "AccountPageContent", k([
            A2(rCn, 4, Wun.kw),
            A2(DCn, bkn(40), bkn(0))
        ])),
        A2(hkn, "AccountWrapper", w),
        A2(hkn, "AccountForm", k([
            SCn(ECn),
            wCn(bkn(10))
        ])),
        A2(hkn, "AccountFormFields", k([
            wCn(bkn(10))
        ])),
        A2(hkn, "AccountTitle", k([
            MCn
        ])),
        A2(hkn, "AccountSubmit", w),
        A2(hkn, "AccountLink", k([
            zkn,
            gCn(bkn(200)),
            A2(qCn, bkn(5), bkn(0))
        ])),
        A2(hkn, "AccountMessage", w),
        A2(hkn, "AccountSuccess", k([
            eCn(Kun.jV),
            A2(qCn, bkn(5), bkn(0))
        ])),
        A2(hkn, "AccountFail", k([
            eCn(ion.jV),
            A2(qCn, bkn(5), bkn(0))
        ])),
        A2(hkn, "AccountHeader", k([
            wCn(bkn(10)),
            A2(LCn, 2, Yun),
            zCn.jH,
            pCn(bkn(4)),
            eCn(Yun)
        ])),
        A2(hkn, "AccountFooter", k([
            Jkn,
            wCn(bkn(10)),
            A2(jCn, 2, Yun),
            pCn(bkn(4))
        ])),
        A2(hkn, "AccountFooterLinks", k([
            zkn,
            gCn(bkn(220)),
            OCn(bkn(20)),
            zCn.pP
        ])),
        A2(Mkn, k([
            "(device-aspect-ratio: 40/71)"
        ]), k([
            A2(hkn, "AccountFooterLinks", k([
                zkn,
                gCn(bkn(175))
            ]))
        ])),
        A2(hkn, "BetaLoginFooter", k([
            Jkn,
            ICn.qY,
            PCn.jH
        ])),
        A2(hkn, "AccountSSO", k([
            mkn.dj
        ])),
        A2(Mkn, k([
            "(min-width: 650px)"
        ]), k([
            A2(hkn, "AccountSSO", k([
                VCn(bkn(235))
            ]))
        ])),
        A2(hkn, "AccountFormPassword", k([
            mkn.dj,
            Dkn.l8
        ])),
        A2(hkn, "AccountFormPasswordHide", k([
            mkn.dj,
            NCn(k([
                A2(Kkn, "content", '" "'),
                mkn.ii,
                A2(Kkn, "inset", "0"),
                HCn(90),
                SCn("white")
            ]))
        ]))
    ]), WCn = ckn("background-color"), UCn = F2(function(n, r) {
        return A2(ckn, "flex", Mt(n) + " " + Mt(r));
    }), QCn = function(n) {
        return A2(ckn, "min-width", ikn(n));
    }, _Cn = dkn(k([
        A2(UCn, 1, 1),
        QCn(kCn)
    ])), ZCn = dkn(k([
        kkn.lN,
        Okn.pU
    ])), KCn = aCn("hover"), XCn = Ikn("overflow-x"), JCn = Ikn("overflow-y"), YCn = {
        jB: A2(ckn, "text-transform", "capitalize"),
        nC: A2(ckn, "text-transform", "lowercase"),
        om: A2(ckn, "text-transform", "none"),
        sq: A2(ckn, "text-transform", "uppercase")
    }, GCn = k([
        A2(hkn, "AccountReportWrapper", k([
            zkn,
            _Cn,
            WCn(Yun)
        ])),
        A2(hkn, "AccountReportContainer", k([
            XCn.l8,
            JCn.jb,
            zkn,
            _Cn,
            wCn(bkn(20)),
            xCn(bkn(800)),
            gCn(Rkn(100))
        ])),
        A2(hkn, "AccountReportSubmit", k([
            WCn(Yun),
            ZCn,
            Pkn(k([
                A2(hkn, "CustomButtonLabel", k([
                    eCn(ECn),
                    WCn(Wun.nv),
                    YCn.sq,
                    sCn.jm,
                    FCn(bkn(10)),
                    KCn(k([
                        WCn(Wun.jV)
                    ]))
                ]))
            ]))
        ]))
    ]), nTn = function(n) {
        return A2(ckn, "margin-bottom", ikn(n));
    }, rTn = k([
        A2(hkn, "SettingsWrapper", k([
            Jkn,
            _Cn,
            A4(wkn, 0, 0, 0, 94)
        ])),
        A2(hkn, "SettingsTitle", k([
            FCn(bkn(18)),
            eCn(ECn)
        ])),
        A2(hkn, "SettingsForm", k([
            wCn(bkn(10)),
            xCn(bkn(500)),
            WCn(Yun)
        ])),
        A2(hkn, "SettingsContainer", k([
            WCn(Yun),
            XCn.l8,
            JCn.jb,
            zkn,
            _Cn
        ])),
        A2(hkn, "Version", k([
            zCn.jH,
            nTn(bkn(5)),
            mkn.ii,
            $kn(bkn(15)),
            vCn(bkn(10))
        ]))
    ]), tTn = Ju(k([
        RCn,
        rTn,
        GCn
    ])), eTn = Ckn(2), uTn = {
        iE: A2(ckn, "cursor", "alias"),
        iG: A2(ckn, "cursor", "all-scroll"),
        jb: A2(ckn, "cursor", "auto"),
        jG: A2(ckn, "cursor", "cell"),
        jU: A2(ckn, "cursor", "col-resize"),
        j7: A2(ckn, "cursor", "context-menu"),
        kb: A2(ckn, "cursor", "copy"),
        kn: A2(ckn, "cursor", "crosshair"),
        kE: A2(ckn, "cursor", "default"),
        k1: A2(ckn, "cursor", "e-resize"),
        lr: A2(ckn, "cursor", "ew-resize"),
        l1: A2(ckn, "cursor", "grab"),
        l2: A2(ckn, "cursor", "grabbing"),
        l7: A2(ckn, "cursor", "help"),
        n2: A2(ckn, "cursor", "move"),
        n5: A2(ckn, "cursor", "n-resize"),
        n9: A2(ckn, "cursor", "ne-resize"),
        ob: A2(ckn, "cursor", "nesw-resize"),
        oh: A2(ckn, "cursor", "no-drop"),
        om: A2(ckn, "cursor", "none"),
        oo: A2(ckn, "cursor", "not-allowed"),
        or: A2(ckn, "cursor", "ns-resize"),
        ou: A2(ckn, "cursor", "nw-resize"),
        ov: A2(ckn, "cursor", "nwse-resize"),
        o7: A2(ckn, "cursor", "pointer"),
        pk: A2(ckn, "cursor", "progress"),
        pT: A2(ckn, "cursor", "row-resize"),
        p$: A2(ckn, "cursor", "s-resize"),
        qa: A2(ckn, "cursor", "se-resize"),
        rB: A2(ckn, "cursor", "sw-resize"),
        cj: A2(ckn, "cursor", "text"),
        sD: A2(ckn, "cursor", "vertical-text"),
        sI: A2(ckn, "cursor", "w-resize"),
        sJ: A2(ckn, "cursor", "wait"),
        sV: A2(ckn, "cursor", "zoom-in"),
        sW: A2(ckn, "cursor", "zoom-out")
    }, oTn = function(n) {
        return dkn(k([
            A2(Kkn, "gap", Mt(n) + "px")
        ]));
    }, aTn = A2(bu, ckn("flex-grow"), Mt), iTn = function(n) {
        return A2(ckn, "line-height", ikn(n));
    }, cTn = F4(function(n, r, t, e) {
        return A2(ckn, "margin", A2(It, " ", A2(Ye, ikn, k([
            n,
            r,
            t,
            e
        ]))));
    }), fTn = function(n) {
        return A2(ckn, "margin-left", ikn(n));
    }, sTn = function(n) {
        return A2(ckn, "margin-right", ikn(n));
    }, lTn = function(n) {
        return A2(ckn, "min-height", ikn(n));
    }, dTn = k([
        A2(hkn, "AdminWrapper", k([
            Jkn,
            _Cn
        ])),
        A2(Mkn, k([
            "(min-width: 1000px)"
        ]), w),
        A2(hkn, "AdminTabsWrapper", k([
            Jkn,
            _Cn,
            lTn(bkn(0))
        ])),
        A2(hkn, "AdminHeader", k([
            Hkn(bkn(80)),
            wCn(bkn(10)),
            WCn(Xun),
            nTn(bkn(4)),
            Jkn
        ])),
        A2(hkn, "AdminPadding", k([
            xCn(bkn(800)),
            A2(DCn, bkn(15), nCn),
            A2(rCn, 3, Gun)
        ])),
        A2(hkn, "AdminTitle", k([
            _Cn,
            eCn(Gun),
            wCn(bkn(15)),
            iTn(bkn(30))
        ])),
        A2(hkn, "AdminTabs", k([
            zkn,
            gCn(bkn(200)),
            sTn(bkn(4)),
            Dkn.jb
        ])),
        A2(hkn, "AdminTab", k([
            Hkn(bkn(48)),
            A2(qCn, bkn(15), bkn(25)),
            FCn(bkn(14)),
            nTn(bkn(4)),
            uTn.o7,
            eCn(uon),
            WCn(Yun),
            Jkn,
            KCn(k([
                eCn(ECn),
                WCn(Wun.jV)
            ])),
            A2(hCn, "AdminTabActive", k([
                eCn(Wun.ng),
                WCn(Wun.nx)
            ])),
            Pkn(k([
                A2(Akn, "a", k([
                    eCn("inherit")
                ]))
            ]))
        ])),
        A2(hkn, "AdminContent", k([
            eCn(ron),
            _Cn,
            Dkn.jb
        ])),
        A2(hkn, "EditContainer", k([
            fTn(bkn(220))
        ])),
        A2(hkn, "EditSection", k([
            vCn(bkn(20))
        ])),
        A2(hkn, "EmptySection", k([
            kkn.lN,
            PCn.jH,
            ICn.jH,
            lTn(bkn(300))
        ])),
        A2(hkn, "Summary", k([
            wCn(bkn(10)),
            Pkn(k([
                A2(Akn, "h2", k([
                    A2(qCn, bkn(10), bkn(0))
                ])),
                A2(Akn, "p", k([
                    A2(DCn, bkn(10), bkn(0))
                ]))
            ]))
        ])),
        A2(hkn, "Filter", k([
            eTn(k([
                A2(Akn, ":first-child", k([
                    kkn.lN,
                    pCn(bkn(0)),
                    A2(qCn, bkn(0), bkn(10)),
                    WCn(Gun)
                ]))
            ]))
        ])),
        A2(hkn, "FilterSelect", k([
            gCn(bkn(225)),
            A4(cTn, bkn(6), bkn(0), bkn(10), bkn(10)),
            kkn.lN,
            eTn(k([
                A2(Akn, ":first-child", k([
                    kkn.lN,
                    Vkn(Rkn(40)),
                    PCn.jH
                ]))
            ]))
        ])),
        A2(hkn, "JobsFilters", k([
            PCn.jH,
            eTn(k([
                A2(Akn, ".Select", k([
                    Hkn(bkn(32)),
                    nTn(bkn(4))
                ]))
            ]))
        ])),
        A2(hkn, "LayoutAppBarActions", k([
            QCn(bkn(100))
        ])),
        A2(hkn, "AdminForumSubsection", k([
            fTn(bkn(100))
        ])),
        A2(hkn, "FieldTitle", k([
            Jkn,
            oTn(6)
        ])),
        A2(hkn, "FieldBloc", k([
            zkn,
            aTn(1)
        ])),
        A2(hkn, "FieldLine", k([
            Jkn,
            PCn.jH,
            aTn(1)
        ])),
        A2(Akn, ".FieldLine .InputLabel", k([
            Jkn,
            PCn.jH,
            aTn(1)
        ])),
        A2(hkn, "OrganizationOnboarding", k([
            Jkn,
            PCn.jH,
            A2(qCn, kCn, bkn(6)),
            A2(Kkn, "gap", "3px")
        ])),
        A2(hkn, "OrganizationEditApp", k([
            Jkn,
            PCn.jH,
            wCn(bkn(6)),
            A2(Kkn, "gap", "6px")
        ]))
    ]), mTn = function(n) {
        return A2(ckn, "border-radius", ikn(n));
    }, bTn = {
        na: A2(ckn, "font-size", "large"),
        nb: A2(ckn, "font-size", "larger"),
        nN: A2(ckn, "font-size", "medium"),
        qU: A2(ckn, "font-size", "small"),
        qX: A2(ckn, "font-size", "smaller"),
        sP: A2(ckn, "font-size", "x-large"),
        sQ: A2(ckn, "font-size", "x-small"),
        sR: A2(ckn, "font-size", "xx-large"),
        sS: A2(ckn, "font-size", "xx-small")
    }, pTn = k([
        A2(hkn, "EditContainer", k([
            fTn(bkn(220))
        ])),
        A2(hkn, "EditSection", k([
            vCn(bkn(20))
        ])),
        A2(hkn, "AdminDetailsSummary", k([
            vCn(bkn(10)),
            eCn("white"),
            sCn.jl,
            bTn.nN
        ])),
        A2(hkn, "AdminDetailsSelection", k([
            kkn.lN,
            oTn(4)
        ])),
        A2(Akn, ".AdminDetailsSelection span", k([
            A2(qCn, bkn(2), bkn(4)),
            SCn(Wun.nv),
            mTn(bkn(3)),
            eCn("white")
        ]))
    ]), vTn = {
        oq: A2(ckn, "flex-wrap", "nowrap"),
        sL: A2(ckn, "flex-wrap", "wrap"),
        sM: A2(ckn, "flex-wrap", "wrap-reverse")
    }, $Tn = {
        mX: A2(ckn, "font-style", "italic"),
        on: A2(ckn, "font-style", "normal"),
        ow: A2(ckn, "font-style", "oblique")
    }, wTn = F4(function(n, r, t, e) {
        return A2(ckn, "padding", A2(It, " ", A2(Ye, ikn, k([
            n,
            r,
            t,
            e
        ]))));
    }), gTn = k([
        A2(hkn, "StitchWrapper", k([
            zkn,
            nTn(bkn(4))
        ])),
        A2(hkn, "StitchHeader", k([
            Jkn,
            wCn(bkn(10)),
            WCn(oon),
            eCn(Gun),
            nTn(bkn(4))
        ])),
        A2(hkn, "StitchTitle", k([
            FCn(bkn(16)),
            iTn(bkn(28)),
            sCn.jl,
            _Cn
        ])),
        A2(hkn, "StitchAdd", k([
            A2(rCn, 2, Jun),
            vCn(bkn(3)),
            eCn(ECn),
            Jkn,
            vTn.sL,
            ICn.lR,
            A4(wTn, bkn(0), bkn(0), bkn(3), bkn(3)),
            A4(cTn, bkn(0), bkn(0), bkn(10), bkn(0)),
            Pkn(k([
                A2(hkn, "Select", k([
                    Vkn(Rkn(30)),
                    A2(rCn, 0, Gun),
                    A4(cTn, bkn(3), bkn(3), bkn(0), bkn(0))
                ])),
                A2(hkn, "SelectButtonIcon", k([
                    Hkn(bkn(30))
                ]))
            ]))
        ])),
        A2(hkn, "StichSegment", k([
            Jkn,
            aTn(1),
            Vkn(Rkn(100)),
            wCn(bkn(3)),
            A4(cTn, bkn(3), bkn(3), bkn(0), bkn(0)),
            WCn(Gun),
            WCn(Jun),
            PCn.jH
        ])),
        A2(hkn, "StichSegmentTitle", k([
            _Cn,
            A2(qCn, kCn, bkn(6))
        ])),
        A2(hkn, "StichSegmentUnit", k([
            eCn(Xun),
            $Tn.mX,
            OCn(bkn(3))
        ])),
        A2(hkn, "StichSegmentDuration", k([
            gCn(bkn(60)),
            eCn(Wun.jV),
            sCn.jm,
            zCn.pP,
            WCn(Gun)
        ])),
        A2(hkn, "StichSegmentDelete", k([
            Hkn(bkn(18)),
            fTn(bkn(3))
        ])),
        A2(hkn, "StichSegmentUrl", k([
            aTn(1),
            eCn(Wun.jV),
            sCn.jm,
            zCn.pP,
            WCn(Gun),
            QCn(bkn(315))
        ])),
        A2(hkn, "StichVideoSegment", k([
            zkn,
            fTn(bkn(10))
        ])),
        A2(hkn, "StichSegmentSubtract", k([
            Jkn,
            _Cn,
            sTn(bkn(10))
        ]))
    ]), hTn = Ju(k([
        gTn,
        pTn
    ])), kTn = Ju(k([
        hTn,
        dTn
    ])), CTn = F2(function(n, r) {
        return dkn(k([
            mkn.ii,
            pkn(bkn(n)),
            $kn(bkn(r))
        ]));
    }), TTn = "#000", PTn = F2(function(n, r) {
        return A2(ckn, "border-left", Mt(n) + "px solid " + r);
    }), STn = F2(function(n, r) {
        return A2(ckn, "border-right", Mt(n) + "px solid " + r);
    }), ATn = function(n) {
        return A2(Wh, n, $o(w));
    }, yTn = ckn("font-family"), NTn = function(n) {
        return A2(ckn, "max-height", ikn(n));
    }, LTn = F3(function(n, r, t) {
        return A2(ckn, "padding", A2(It, " ", A2(Ye, ikn, k([
            n,
            r,
            t
        ]))));
    }), jTn = function(n) {
        return A2(ckn, "padding-bottom", ikn(n));
    }, FTn = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAA4CAYAAAAl63xKAAAAAXNSR0IArs4c6QAABZJJREFUeAHtXMly1DAQVRIDYQmBIlxYTsCFUMWV4v8LyImiCk7AieVCKJYAEwIkzFN4To+mtXgjM5nWRba1up+6n6SWvXTr/sMDNw6rq6vu+o2bbuPKhltaWsKjqXBwcOC2P267d2/fuN3d3Yl0rfyTJ498nkvrl+u8e7/2xmVHbn9/3z9bW7voNjfv1eklF+zH61cvfXZZvyz/+csnf/vgwUP5uL5+8eK529n56u+Xl5fHMjjrTp86XafnLlj/rdt3VLlp75+rM5ceyq9CAXQegEAgACcEkgKTwPGFUR6AaOWRxhA2LAFnntIYA+zqxlXf39IyWr67dzcnBuSPH9/d7vKoMZDoy9BBkx9k7gG8uLbumCEEAh3TgJMjFddaeb7U150vtcZJ4GKaznJDxxwIsDrSsrQFcoj+Uq60WFJ+W1uPDwFEwwBBA4KdosZJ4JgWK890NC4bzgFHjX//7q2v4tr1G6qJYv1ajBcvDSkg91Z+ugsX1kqrUvOhLzG5qQX+Pfz2bcf9/vPb38Xk5zVQViKB/Dk2jQhnGnKDrK/JNYGTGo/yMdOu1R2OWHBsaQiBRLsUYGkdMh/aBse21Wi2HeNYtDUFIDtAIHmfi0PBYcTAHCMYxx5O+toCmeLYKIA5wJiuAcdJEGw0gnHscBzrARzSRhNoajQB52SJ6caxlESz2APYVrVLbHTYHQmkcWx3jq1AkJw0tAUyZaNDAHlPIHmfi6m5cjptHLvpKgh/ntdBAH6ROdab0HD6LDVy1tdB1FxqNDV1UTh2YhYaAjkP6yACyFgCuQgcOwEghUAgAWCXcJx7jQSytP/U3HnjWBXA0pfO5eNAMI4dbq+4evbsqbO9xrw7jRpNTZ0Vjq1Go5HtNUb8eZqFkUDOAsdW586dN39eC38egdRA1p5Rc/vm2IodYQM0DVhKMJg/j5JoHlOuErg+94rrSYwGJLuLxmP+KOaRMd1C5s/L+/MoN03+chUQ2yuuAWRFXWICx40A1oWO4BlHHmansRCO2JPuzwvlIIEs4dgawFBw5s9zbh7WsZUGHDXF/HmHh6dmeR1bwQOBkOM4qdryFBpNQMxGM10rzzTj2PZnZrwJTZ25oJAZSyBKbDTL9REbx05KEf5YD6D58yYFk7vjFqGcJebKaOl9cGw9idEa6OOZcWxcihwIXTi2CECAANPZNJSca2Sd0jQbxx6dYsv5Y5MA/o9zjQSQsQTSODZ/ZiYJYB82GsAYx3J4lsU0rSUcmwSQFXWx0WVdbp9r0Tk2CSDFmgIyZ6NZRyo2jm3/7Udle43z/e1HBZ5rGqiRJTY6Vbdx7FkvHjnrlpv+UnYxqqgAxnEFDgTj2PZnZlQO5JaV+fOG9+dReeTyiRrJtNRe8QSABM78eYeim4dvPzyAGnD0LuBVOCJCxyxHCOKYjYZ5bBpoWo1j899XVh+2P9Qft0DQBE5uneGaANmZmabDMZ2fcm17ZqbiKNeAk023tdGyDl5T441ju3NstTL+xYh9A8+h1Syehb3i8UJ+vajXmqrDnCJAe6Vp5ZEMLlGocXJyRI1HeePY5v+ZoUWcmIVCmGHQgCNAdmbm+M/MJAE0f144nPV7zpq1DYmh94qTAM7DOkiKVDPVSA+XPzTtsiyvQ4sz63vFSQD5UubPoyTKYmokZ/hlpaZzlewVFwE4XXV/T8IRL483GsfmObYXAAGCXPiXwmscWyYparTGsZ0AnIV1EESwyOvYTgCW2OiSMWYcWyKlozzUSHBsJwBZkababX6cetTF/q5OOsdGAcSLl4YUkEOvg1J9XASOnQIwHLGzvg5KAbgI69gawBA4OZ1PCUlLo0b+j3WQ1n747CRzbPL7QABxnIEDwTg27o8t/j5QAsktK/PndffnUa70zsTW0/Q+0FLSE/QXU2aja+FG/18AAAAASUVORK5CYII=) repeat", MTn = F4(function(n, r, t, e) {
        return A2(ckn, "text-shadow", ikn(n) + " " + ikn(r) + " " + ikn(t) + " " + e);
    }), ITn = Hkn(bkn(24)), DTn = {
        d$: A2(ckn, "user-select", "all"),
        jb: A2(ckn, "user-select", "auto"),
        eB: A2(ckn, "user-select", "contain"),
        om: A2(ckn, "user-select", "none"),
        cj: A2(ckn, "user-select", "text")
    }, BTn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), xTn = function(n) {
        return BTn(A2(Ye, Nkn, n));
    }, qTn = k([
        A2(bCn, "player-template", k([
            kkn.om
        ])),
        A2(hkn, "PlayerVideoWrapper", k([
            zkn
        ])),
        A2(hkn, "PlayerBox", k([
            zkn,
            PCn.jH,
            ICn.jH,
            SCn(Jun),
            A2(rCn, 6, Jun)
        ])),
        A2(hkn, "PlayerVideoBuffering", k([
            mkn.ii,
            pkn(bkn(0)),
            fkn(bkn(0)),
            skn(bkn(0)),
            $kn(bkn(0)),
            zkn,
            PCn.jH,
            ICn.jH
        ])),
        A2(hkn, "PlayerVideo", k([
            mkn.dj
        ])),
        A2(hkn, "PlayerDeployed", k([
            _Cn,
            Dkn.l8,
            A2(Kkn, "aspect-ratio", "16 / 9"),
            A2(Kkn, "max-height", "calc(100vh - 215px)"),
            eTn(k([
                A2(Akn, "video", k([
                    vCn(Rkn(-3.78))
                ]))
            ]))
        ])),
        A2(Akn, "noma-player", k([
            A2(Kkn, "aspect-ratio", "16 / 9")
        ])),
        A2(hkn, "PlayerFullScreen", k([
            Pkn(k([
                A2(hkn, "PlayerBox", k([
                    _Cn,
                    wCn(kCn),
                    A2(rCn, 0, Jun),
                    Jkn,
                    ICn.jH,
                    A2(xTn, k([
                        "(min-aspect-ratio: 16/9)"
                    ]), k([
                        zkn
                    ]))
                ])),
                A2(hkn, "PlayerDeployed", k([
                    A2(Kkn, "max-height", "100%"),
                    A2(Kkn, "max-width", "100%")
                ])),
                A2(hkn, "PlayerControlsBox", k([
                    A2(Kkn, "outline", "3px solid black"),
                    A2(jCn, 3, Jun)
                ]))
            ]))
        ])),
        A2(hkn, "PlayerCollapsed", k([
            Hkn(bkn(124)),
            SCn("radial-gradient(ellipse at center, rgba(24,31,41,0) 0%,rgba(24,31,41,.9) 100%), " + FTn),
            Dkn.l8
        ])),
        A2(hkn, "PlayerVideoBuffering", k([
            mkn.ii,
            pkn(bkn(0)),
            fkn(bkn(0)),
            skn(bkn(0)),
            $kn(bkn(0)),
            kkn.lN,
            PCn.jH,
            ICn.jH
        ])),
        A2(hkn, "PlayerControls", k([
            Jkn,
            wCn(bkn(3)),
            VCn(bkn(0)),
            A2(rCn, 3, Jun),
            A2(jCn, 0, Jun),
            WCn(Gun),
            vTn.sL,
            eTn(k([
                ATn(k([
                    fTn(bkn(3)),
                    ITn,
                    DTn.om,
                    Ekn(1)
                ]))
            ])),
            Pkn(k([
                A2(Akn, ".InputSelect", k([
                    pCn(kCn)
                ]))
            ]))
        ])),
        A2(hkn, "PlayerControlsHidden", k([
            A2(hCn, "PlayerFullScreen", k([
                Pkn(k([
                    A2(hkn, "PlayerControlsBox", k([
                        Qkn,
                        $Cn(0)
                    ]))
                ])),
                uTn.om
            ]))
        ])),
        A2(ykn, k([
            hkn("PlayerControlsPlayPause"),
            hkn("PlayerControlsForward"),
            hkn("PlayerControlsBackward"),
            hkn("PlayerControlsSound"),
            hkn("PlayerControlsOptions"),
            hkn("PlayerControlsFullScreen"),
            hkn("PlayerControlsStart"),
            hkn("PlayerControlsEnd"),
            hkn("PlayerPlaybackSpeed1"),
            hkn("PlayerPlaybackSpeed2"),
            hkn("PlayerPlaybackSpeed4"),
            hkn("PlayerGoBack1s"),
            hkn("PlayerControlsRatio"),
            hkn("PlayerGoBack5s"),
            hkn("PlayerGoForward1s"),
            hkn("PlayerGoForward5s"),
            hkn("ButtonDisplayRawImage")
        ]), k([
            ITn,
            uTn.o7,
            wCn(bkn(3)),
            WCn(Yun),
            KCn(k([
                WCn(Wun.jV),
                Pkn(k([
                    A2(hkn, "Fg", k([
                        uCn(ECn)
                    ]))
                ]))
            ])),
            Pkn(k([
                A2(hkn, "Bg", k([
                    uCn("none")
                ]))
            ]))
        ])),
        A2(hkn, "PlayerBanner", k([
            gCn(Rkn(100))
        ])),
        A2(hkn, "PlayerControlsTime", k([
            mkn.dj,
            _Cn,
            WCn(Yun)
        ])),
        A2(hkn, "PlayerControlsTimeMask", k([
            mkn.ii,
            pkn(bkn(0)),
            fkn(bkn(0)),
            skn(bkn(0)),
            $kn(bkn(0)),
            $Cn(0),
            HCn(100)
        ])),
        A2(hkn, "PlayerControlsTimeProgress", k([
            mkn.ii,
            pkn(bkn(0)),
            fkn(bkn(0)),
            skn(bkn(0)),
            ITn,
            WCn(Wun.jV),
            HCn(10)
        ])),
        A2(hkn, "PlayerControlsTimeBuffered", k([
            mkn.ii,
            pkn(bkn(0)),
            fkn(bkn(0)),
            ITn,
            WCn(Wun.eG),
            HCn(5)
        ])),
        A2(hkn, "PlayerControlsTimeCursor", k([
            mkn.ii,
            fkn(bkn(0)),
            A2(STn, 2, Wun.jV),
            Hkn(bkn(60)),
            jTn(bkn(40)),
            HCn(15)
        ])),
        A2(hkn, "PlayerControlsTimeTimecode", k([
            WCn(Wun.jV),
            eCn(ECn),
            mkn.ii,
            $kn(bkn(0)),
            kkn.jj,
            yTn("monospace"),
            sCn.jl,
            A4(MTn, bkn(1), bkn(1), bkn(0), "rgba(0,0,0,.3)"),
            A2(qCn, bkn(6), bkn(10))
        ])),
        A2(hkn, "PlayerControlsTimeGhost", k([
            mkn.ii,
            pkn(bkn(-6)),
            Hkn(bkn(40)),
            $Cn(0),
            gCn(Rkn(100))
        ])),
        A2(hkn, "PlayerControlsDuration", k([
            yTn("monospace"),
            eCn(ton),
            WCn(oon),
            A4(MTn, bkn(1), bkn(1), bkn(0), "rgba(0,0,0,.3)"),
            A2(qCn, kCn, bkn(6))
        ])),
        A2(hkn, "PlayerControlsBox", k([
            zkn,
            HCn(4)
        ])),
        A2(hkn, "PlayerControlsBoxLeft", k([
            zkn,
            _Cn
        ])),
        A2(hkn, "PlayerControlsBoxRight", k([
            zkn
        ])),
        A2(Akn, ".PlayerControlsBoxRight .PlayerControls", k([
            A2(PTn, 0, Jun)
        ])),
        A2(hkn, "PlayerSelection", k([
            A3(LTn, bkn(0), bkn(3), bkn(3)),
            WCn(Jun)
        ])),
        A2(Akn, ".PlayerSelection .Select:nth-child(1)", k([
            A2(jCn, 3, Gun)
        ])),
        A2(hkn, "PlayerOperations", k([
            wCn(bkn(3)),
            A2(STn, 3, Jun),
            A2(LCn, 3, Jun),
            SCn(Gun),
            zkn,
            _Cn
        ])),
        A2(hkn, "PlayerOperationsSeparator", k([
            WCn(Yun),
            $Cn(30),
            gCn(bkn(10))
        ])),
        A2(hkn, "PlayerOperationsSpacer", k([
            WCn(Yun),
            $Cn(30),
            aTn(1)
        ])),
        A2(hkn, "PlayerOperationsMarkinout", k([
            Pkn(k([
                A2(hkn, "CustomButton", k([
                    A3(LTn, bkn(3), kCn, kCn)
                ]))
            ]))
        ])),
        A2(hkn, "PlayerControlsOptions", k([
            mkn.dj
        ])),
        A2(hkn, "PlayerControlsOptionsMenu", k([
            kkn.om,
            A2(CTn, 33, 0),
            SCn(Wun.jV),
            eCn(ECn)
        ])),
        A2(hkn, "PlayerControlsOptionsMenuOpened", k([
            WCn(Wun.jV),
            Pkn(k([
                A2(hkn, "Fg", k([
                    uCn(ECn)
                ]))
            ]))
        ])),
        A3(Wkn, "PlayerControlsOptionsMenuOpened", "PlayerControlsOptionsMenu", k([
            zkn,
            gCn(bkn(150))
        ])),
        A2(hkn, "PlayerOperationsMarkin", w),
        A2(hkn, "PlayerOperationsMarkout", w),
        A2(hkn, "PlayerOperationsSonagram", w),
        A2(hkn, "PlayerSonagram", k([
            vCn(bkn(4))
        ])),
        A2(hkn, "PlayerMarkinout", k([
            vCn(bkn(4)),
            WCn(oon)
        ])),
        A2(hkn, "PlayerSelectedSpeed", k([
            SCn(Jun)
        ])),
        A2(hkn, "PlayerAspectRatio", k([
            A4(wkn, 0, 0, 0, 0),
            Pkn(k([
                A2(Akn, "svg", k([
                    mkn.ii,
                    pkn(Rkn(50)),
                    skn(bkn(0)),
                    _kn("translateY(calc(-50% - 2px))"),
                    gCn(Rkn(100)),
                    Hkn(nCn)
                ]))
            ]))
        ])),
        A2(ykn, k([
            Akn(".PlayerVideoWrapper:fullscreen"),
            Akn(".PlayerVideoWrapper:-webkit-full-screen"),
            Akn(".PlayerVideoWrapper:-moz-full-screen"),
            Akn(".PlayerVideoWrapper:-ms-fullscreen")
        ]), k([
            mkn.lK,
            pkn(bkn(0)),
            fkn(bkn(0)),
            skn(bkn(0)),
            $kn(bkn(0)),
            xCn(Rkn(100)),
            NTn(Rkn(100)),
            SCn(Gun),
            Dkn.l8,
            HCn(3)
        ])),
        A2(ykn, k([
            Akn(".PlayerVideoWrapper:fullscreen .PlayerDeployed"),
            Akn(".PlayerVideoWrapper:-webkit-full-screen .PlayerDeployed"),
            Akn(".PlayerVideoWrapper:-moz-full-screen .PlayerDeployed"),
            Akn(".PlayerVideoWrapper:-ms-fullscreen .PlayerDeployed")
        ]), k([
            A2(rCn, 0, TTn)
        ])),
        A2(ykn, k([
            Akn(".PlayerVideoWrapper:fullscreen .PlayerControlsBox"),
            Akn(".PlayerVideoWrapper:-webkit-full-screen .PlayerControlsBox"),
            Akn(".PlayerVideoWrapper:-moz-full-screen .PlayerControlsBox"),
            Akn(".PlayerVideoWrapper:-ms-fullscreen .PlayerControlsBox")
        ]), k([
            mkn.lK,
            fkn(bkn(20)),
            skn(Rkn(50)),
            _kn("translateX(-50%)"),
            gCn(Rkn(100)),
            xCn(bkn(1e3)),
            SCn("transparent"),
            eTn(k([
                A2(ykn, k([
                    hkn("PlayerControlsBoxLeft"),
                    hkn("PlayerControlsBoxRight")
                ]), k([
                    Okn.jZ,
                    A2(jCn, 3, Jun)
                ]))
            ]))
        ])),
        A2(ykn, k([
            Akn(".PlayerVideoWrapper:-moz-full-screen .PlayerControlsBox")
        ]), k([
            mkn.ii
        ])),
        A2(ykn, k([
            Akn(".IPhone")
        ]), k([
            Pkn(k([
                A2(ykn, k([
                    Akn(".PlayerVideoWrapper")
                ]), k([
                    gCn(Rkn(50)),
                    pkn(bkn(0))
                ]))
            ]))
        ])),
        A2(ykn, k([
            Akn(".IPad")
        ]), k([
            Pkn(k([
                A2(ykn, k([
                    Akn(".PlayerVideoWrapper")
                ]), k([
                    gCn(Rkn(100)),
                    pkn(bkn(20))
                ]))
            ]))
        ])),
        A2(ykn, k([
            Akn(".IOSTheater")
        ]), k([
            Pkn(k([
                A2(ykn, k([
                    Akn(".ShowSelectBroadcastable")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".ShowAside")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".Acceptation")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".MasterFilesWrapper")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".DownloadWrapper")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".FilesWrapper")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".LayoutAppBarWrapper")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".BrowserWrapper")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".MenuWrapper")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".HeaderWrapper")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".ShowsWrapper.ActiveShow")
                ]), k([
                    skn(bkn(0))
                ])),
                A2(ykn, k([
                    Akn(".ShowWrapper.ShowNoop")
                ]), k([
                    _kn("translate3d(0px,0px,0px)")
                ])),
                A2(ykn, k([
                    Akn(".Wrapper")
                ]), k([
                    pkn(bkn(0))
                ])),
                A2(ykn, k([
                    Akn(".ShowMain")
                ]), k([
                    gCn(Rkn(100))
                ])),
                A2(ykn, k([
                    Akn(".ShowHomeWrapper")
                ]), k([
                    PCn.jH,
                    ICn.jH
                ])),
                A2(ykn, k([
                    Akn(".PadokUploadWrapper")
                ]), k([
                    kkn.om
                ])),
                A2(ykn, k([
                    Akn(".PlayerVideoWrapper")
                ]), k([
                    mkn.lK,
                    skn(Rkn(50)),
                    _kn("translateX(-50%)"),
                    xCn(bkn(1070)),
                    SCn("transparent")
                ])),
                A2(ykn, k([
                    Akn("video")
                ]), k([
                    gCn(Rkn(100))
                ]))
            ]))
        ]))
    ]), VTn = ckn("border-color"), OTn = "#EC79ED", zTn = "#8C96F7", ETn = "#57E5D0", HTn = k([
        A2(hkn, "Avatar", k([
            gCn(bkn(24)),
            Hkn(bkn(24)),
            WCn(Yun)
        ])),
        A2(hkn, "AvatarLetter", k([
            iTn(bkn(20)),
            zCn.jH,
            YCn.sq,
            sCn.jm,
            A2(rCn, 2, Xun),
            eCn(Xun)
        ])),
        A2(hkn, "AvatarMe", k([
            eCn(ETn),
            VTn(ETn)
        ])),
        A2(hkn, "AvatarCowork", k([
            eCn(zTn),
            VTn(zTn)
        ])),
        A2(hkn, "AvatarAlien", k([
            eCn(OTn),
            VTn(OTn)
        ]))
    ]), RTn = F2(function(n, r) {
        return A2(hkn, n, k([
            eCn(r.ng),
            Pkn(k([
                A2(Akn, "svg", k([
                    SCn(r.nx),
                    pCn(bkn(2)),
                    Pkn(k([
                        A2(hkn, "Fg", k([
                            uCn(r.jV)
                        ]))
                    ]))
                ])),
                A2(hkn, "BannerHeader", k([
                    SCn(r.jV),
                    eCn(ECn),
                    _Cn,
                    Jkn
                ])),
                A2(Akn, "h4", k([
                    FCn(bkn(12)),
                    eCn(ECn),
                    YCn.sq,
                    wCn(bkn(2)),
                    A4(MTn, bkn(1), bkn(1), bkn(2), "rgba(0,0,0,0.4)")
                ])),
                A2(hkn, "BannerContent", k([
                    SCn(r.nv),
                    A2(qCn, bkn(5), bkn(10))
                ]))
            ]))
        ]));
    }), WTn = {
        jV: "#FCB63B",
        eG: "#6A542C",
        eH: "#3A3527",
        kw: "#212425",
        md: "#FCC462",
        mf: "#FDD389",
        ng: "#FDE1B0",
        nh: "#FEF0D7",
        ni: "#FEF7EB",
        nv: "#CB9536",
        nx: "#9B7531"
    }, UTn = function(n) {
        return function(n) {
            return {
                $: 2,
                a: n
            };
        }(n);
    }, QTn = F2(function(n, r) {
        return A2(hkn, n, k([
            SCn(r.eH),
            eCn(r.jV),
            sCn.jl,
            Jkn,
            PCn.jH,
            wCn(bkn(6)),
            iTn(UTn(1.5)),
            eTn(k([
                A2(Akn, "svg", k([
                    SCn(r.nx),
                    pCn(bkn(2)),
                    Pkn(k([
                        A2(hkn, "Fg", k([
                            uCn(r.kw)
                        ]))
                    ]))
                ])),
                A2(hkn, "BannerContent", k([
                    A2(qCn, kCn, bkn(4)),
                    _Cn
                ]))
            ]))
        ]));
    }), _Tn = {
        fR: A2(ckn, "text-decoration", "line-through"),
        om: A2(ckn, "text-decoration", "none"),
        go: A2(ckn, "text-decoration", "overline"),
        se: A2(ckn, "text-decoration", "underline")
    }, ZTn = k([
        A2(RTn, "BannerError", ion),
        A2(RTn, "BannerWarning", WTn),
        A2(RTn, "BannerSuccess", Kun),
        A2(RTn, "BannerAction", Wun),
        A2(QTn, "BannerInvalid", ion),
        A2(QTn, "BannerEmptyness", WTn),
        A2(QTn, "BannerValid", Kun),
        A2(QTn, "BannerAdvice", Wun),
        A2(hkn, "BannerTodo", k([
            Jkn,
            WCn("#5E2F83"),
            eCn("#E6B0FF")
        ])),
        A2(hkn, "BannerTodoIcon", k([
            pCn(bkn(6)),
            lCn(Gun),
            eTn(k([
                ATn(k([
                    A2(rCn, 2, Gun)
                ]))
            ]))
        ])),
        A2(hkn, "BannerTodoBody", k([
            zkn,
            pCn(bkn(6)),
            eCn("#E6B0FF"),
            _Cn,
            Pkn(k([
                A2(Akn, "a", k([
                    _Tn.se,
                    eCn("inherit"),
                    KCn(k([
                        eCn(ECn)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "BannerTodoTitle", k([
            eCn(ECn)
        ])),
        A2(hkn, "BannerCTA", k([
            Jkn,
            PCn.jH,
            WCn(Yun),
            Pkn(k([
                A2(hkn, "CustomButton", k([
                    A4(wTn, kCn, kCn, kCn, bkn(3))
                ])),
                A2(hkn, "CustomButtonLabel", k([
                    WCn("#5E2F83"),
                    eCn(ECn)
                ])),
                A2(hkn, "CustomButtonIcon", k([
                    lCn("#AB47BC")
                ]))
            ]))
        ])),
        A2(hkn, "BannerCTAIcon", k([
            lCn("#AB47BC"),
            gCn(bkn(30)),
            zCn.jH
        ])),
        A2(hkn, "BannerCTALabel", k([
            _Cn,
            eCn(non)
        ]))
    ]), KTn = F2(function(n, r) {
        return lkn(k([
            A2(jCn, n, r),
            A2(PTn, n, r)
        ]));
    }), XTn = dkn(k([
        ICn.jH,
        PCn.jH,
        kkn.lN
    ])), JTn = k([
        zkn,
        WCn(Yun),
        uTn.o7,
        eTn(k([
            A2(ykn, k([
                hkn("BrowserOpened"),
                hkn("BrowserListOpened")
            ]), k([
                WCn(Jun),
                eTn(k([
                    A2(hkn, "BrowserItem", k([
                        WCn(Yun),
                        eCn(ron),
                        lCn(Wun.jV)
                    ]))
                ]))
            ])),
            A2(hkn, "BrowserAdding", k([
                WCn(Wun.nx)
            ]))
        ]))
    ]), YTn = k([
        A2(hkn, "BrowserWrapper", k([
            zkn,
            gCn(bkn(400)),
            Pkn(k([
                A2(hkn, "LayoutAppBarWrapper", k([
                    fTn(bkn(82))
                ]))
            ]))
        ])),
        A2(hkn, "Browser", k([
            zkn,
            Dkn.jb,
            eCn(Xun),
            _Cn
        ])),
        A2(hkn, "BrowserHeader", k([
            WCn(Wun.nx),
            wCn(bkn(6)),
            Jkn
        ])),
        A2(hkn, "BrowserSection", k([
            SCn(Xun),
            eCn(Gun),
            sCn.jm,
            A2(qCn, bkn(5), bkn(10)),
            Jkn,
            A3(BCn, bkn(4), bkn(0), bkn(0))
        ])),
        A2(hkn, "BrowserSubSection", k([
            SCn(oon),
            eCn(eon),
            sCn.jm,
            A2(qCn, bkn(5), bkn(10)),
            Jkn,
            A3(BCn, bkn(4), bkn(0), bkn(0))
        ])),
        A2(hkn, "BrowserOrder", k([
            wCn(bkn(1)),
            OCn(kCn),
            _Cn,
            SCn(Gun),
            Jkn
        ])),
        A2(hkn, "BrowserNewButton", k([
            mkn.dj
        ])),
        A2(hkn, "BrowserSection", k([
            A2(Kkn, "position", "sticky"),
            pkn(bkn(4)),
            HCn(4),
            A2(Kkn, "outline", "4px solid " + Gun)
        ])),
        A2(hkn, "BrowserSubSection", k([
            A2(Kkn, "position", "sticky"),
            pkn(bkn(4)),
            HCn(4),
            A2(Kkn, "outline", "4px solid " + Gun)
        ])),
        A2(Akn, ".BrowserCollection > .BrowserItemWrapper.BrowserOpened", k([
            A2(Kkn, "position", "sticky"),
            pkn(bkn(33)),
            HCn(3),
            A2(Kkn, "outline", "2px solid " + Gun)
        ])),
        A2(Akn, ".BrowserSeason > .BrowserItemWrapper.BrowserOpened", k([
            A2(Kkn, "position", "sticky"),
            pkn(bkn(63)),
            HCn(2),
            A2(Kkn, "outline", "2px solid " + Gun)
        ])),
        A2(ykn, k([
            hkn("BrowserCollection"),
            hkn("BrowserSeason"),
            hkn("BrowserEpisode")
        ]), k([
            Pkn(k([
                A2(ykn, k([
                    hkn("BrowserSeason"),
                    hkn("BrowserEpisode"),
                    hkn("BrowserTitle")
                ]), k([
                    fTn(bkn(13)),
                    A2(KTn, 2, Gun)
                ]))
            ]))
        ])),
        A2(hkn, "BrowserCollection", $(k([
            vCn(bkn(4)),
            WCn(Yun)
        ]), JTn)),
        A2(hkn, "BrowserSeason", $(k([
            A2(jCn, 2, Gun),
            WCn(Yun)
        ]), JTn)),
        A2(hkn, "BrowserEpisode", $(k([
            A2(jCn, 2, Gun),
            WCn(Yun)
        ]), JTn)),
        A2(hkn, "BrowserTitle", A2(mt, A2(KTn, 2, Gun), JTn)),
        A2(hkn, "BrowserItem", k([
            iTn(bkn(24)),
            pCn(bkn(2)),
            Jkn,
            _Cn,
            eCn(Xun)
        ])),
        A2(hkn, "BrowserItemWrapper", k([
            Jkn
        ])),
        A2(Akn, ".BrowserHasMenuOpened", k([
            A2(Kkn, "z-index", "8 !important")
        ])),
        A2(hkn, "BrowserLabelMaster", k([
            _Cn,
            A2(Kkn, "overflow-wrap", "break-word"),
            A2(Kkn, "word-wrap", "break-word"),
            A2(Kkn, "hyphens", "auto"),
            FCn(bkn(14)),
            sCn.jl,
            Pkn(k([
                A2(hkn, "InputText", k([
                    wCn(kCn),
                    pCn(kCn),
                    A2(rCn, 0, Yun),
                    eCn(Wun.jV),
                    Hkn(nCn)
                ]))
            ]))
        ])),
        A2(hkn, "BrowserLabelShow", k([
            _Cn,
            A2(Kkn, "overflow-wrap", "break-word"),
            A2(Kkn, "word-wrap", "break-word"),
            A2(Kkn, "hyphens", "auto"),
            FCn(bkn(14)),
            sCn.jl,
            Pkn(k([
                A2(hkn, "InputText", k([
                    wCn(kCn),
                    pCn(kCn),
                    A2(rCn, 0, Yun),
                    eCn(Wun.jV),
                    Hkn(nCn)
                ]))
            ]))
        ])),
        A2(hkn, "BrowserIcon", k([
            gCn(bkn(24)),
            Hkn(bkn(24)),
            XTn,
            lCn(oon)
        ])),
        A2(hkn, "BrowserOptions", k([
            mkn.dj,
            A2(hCn, "BrowserOptionsOpened", k([
                Pkn(k([
                    A2(ykn, k([
                        hkn("BrowserOptionsTitle")
                    ]), k([
                        WCn(Wun.jV),
                        lCn(ECn)
                    ])),
                    A2(hkn, "BrowserOptionsMenu", k([
                        A2(CTn, 25, 3),
                        A2(rCn, 1, Gun)
                    ]))
                ]))
            ]))
        ])),
        A2(ykn, k([
            hkn("BrowserOptionsTitle"),
            hkn("BrowserAttachment"),
            hkn("BrowserEdit")
        ]), k([
            gCn(bkn(24)),
            Hkn(bkn(24)),
            XTn,
            Qkn,
            uTn.o7,
            WCn(Yun),
            A2(rCn, 2, Yun),
            A4(cTn, bkn(2), bkn(2), bkn(2), bkn(0)),
            lCn(oon),
            KCn(k([
                WCn(Wun.jV),
                lCn(ECn)
            ]))
        ])),
        A2(hkn, "BrowserOptionsMenu", k([
            A2(CTn, 29, 0),
            WCn(Wun.jV),
            A2(rCn, 3, Gun),
            eCn(ECn),
            HCn(99),
            gCn(bkn(200)),
            wCn(bkn(3))
        ])),
        A2(hkn, "BrowserOptionsItem", k([
            wCn(bkn(5)),
            uTn.o7,
            KCn(k([
                WCn(Wun.nv)
            ]))
        ])),
        A2(hkn, "BrowserOptionsLink", k([
            wCn(bkn(5)),
            uTn.o7,
            eCn(Wun.ng),
            kkn.jj,
            KCn(k([
                WCn(Wun.nx),
                eCn(ECn)
            ]))
        ])),
        A2(hkn, "BrowserNewForm", k([
            Jkn,
            wCn(bkn(1)),
            WCn(Gun),
            Pkn(k([
                A2(hkn, "InputText", k([
                    A2(qCn, bkn(0), bkn(4)),
                    WCn(Wun.jV),
                    eCn(ECn)
                ]))
            ]))
        ])),
        A3(Wkn, "BrowserNew", "BrowserNewForm", k([
            A2(rCn, 8, Wun.nx),
            A2(jCn, 0, ""),
            Pkn(k([
                A2(hkn, "InputText", k([
                    pCn(bkn(2)),
                    A2(rCn, 0, ""),
                    Hkn(bkn(26))
                ]))
            ]))
        ])),
        A2(hkn, "BrowserNewFormIcon", k([
            gCn(bkn(30)),
            Hkn(bkn(30)),
            XTn,
            A2(rCn, 2, Gun),
            WCn(Wun.jV),
            lCn(ECn)
        ])),
        A3(Wkn, "Browser", "BrowserNewForm", k([
            A2(rCn, 0, ""),
            A2(LCn, 3, Wun.nx),
            A2(PTn, 13, Wun.nx),
            OCn(bkn(0)),
            Pkn(k([
                A2(hkn, "InputText", k([
                    pCn(bkn(1)),
                    A2(rCn, 0, ""),
                    Hkn(bkn(28))
                ])),
                A2(hkn, "BrowserNewFormIcon", k([
                    A2(rCn, 1, Gun)
                ]))
            ]))
        ])),
        A2(hkn, "BrowserSubmitting", k([
            WCn(Wun.jV)
        ])),
        A2(hkn, "BrowserErrors", k([
            eTn(k([
                ATn(k([
                    vCn(bkn(4))
                ]))
            ]))
        ])),
        A2(hkn, "BrowserList", k([
            zkn
        ])),
        A2(hkn, "BrowserListOpened", k([
            kkn.lN
        ])),
        A2(hkn, "BrowserItem", k([
            WCn(Yun)
        ])),
        A2(hkn, "BrowserOpened", k([
            eTn(k([
                A2(hkn, "BrowserItemWrapper", k([
                    eTn(k([
                        A2(hkn, "BrowserIcon", k([
                            lCn(Wun.jV)
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "BrowserTitleOpened", k([
            WCn(Wun.jV),
            A2(hCn, "BrowserEmpty", k([
                WCn(WTn.eG),
                eTn(k([
                    A2(hkn, "BrowserItem", k([
                        eCn(WTn.jV)
                    ]))
                ]))
            ])),
            eTn(k([
                A2(hkn, "BrowserItem", k([
                    eCn(Wun.jV)
                ]))
            ]))
        ])),
        A2(hkn, "BrowserTitleHidden", k([
            $Cn(50)
        ])),
        A2(hkn, "BrowserLink", k([
            iTn(bkn(24)),
            Jkn,
            _Cn,
            eCn(Xun)
        ])),
        A2(hkn, "BrowserEmpty", k([
            Pkn(k([
                A2(hkn, "BrowserLabelMaster", k([
                    $Cn(50)
                ]))
            ]))
        ])),
        A2(hkn, "BrowserShowAccepted", k([
            eTn(k([
                A2(hkn, "BrowserItem", k([
                    eTn(k([
                        A2(hkn, "BrowserIcon", k([
                            lCn(Kun.nx)
                        ]))
                    ]))
                ]))
            ])),
            A2(hCn, "BrowserOpened", k([
                eTn(k([
                    A2(hkn, "BrowserItem", k([
                        eTn(k([
                            A2(hkn, "BrowserIcon", k([
                                lCn(Kun.jV)
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]), GTn = {
        jb: A2(ckn, "align-self", "auto"),
        cs: A2(ckn, "align-self", "baseline"),
        jH: A2(ckn, "align-self", "center"),
        bR: A2(ckn, "align-self", "flex-end"),
        lR: A2(ckn, "align-self", "flex-start"),
        rh: A2(ckn, "align-self", "stretch")
    }, nPn = aCn("active"), rPn = F2(function(n, r) {
        return lkn(A2(Ye, ce(r), n));
    })(k([
        KCn,
        hCn("Active"),
        nPn
    ])), tPn = gCn(bkn(28)), ePn = aCn("visited"), uPn = k([
        A2(hkn, "ButtonToolbar", k([
            Jkn,
            WCn(Gun),
            wCn(bkn(3)),
            ICn.bR,
            Hkn(bkn(28)),
            Pkn(k([
                ATn(k([
                    fTn(bkn(3)),
                    cCn(k([
                        fTn(bkn(0))
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "ButtonCounter", w),
        A2(hkn, "ButtonLabel", w),
        A2(hkn, "Button", k([
            FCn(bkn(12)),
            WCn(Wun.nv),
            eCn(Wun.nh),
            A2(qCn, bkn(4), bkn(8)),
            uTn.o7,
            kkn.jj,
            YCn.sq,
            sCn.jm,
            GTn.bR,
            KCn(k([
                eCn(ECn),
                WCn(Wun.jV)
            ]))
        ])),
        A2(hkn, "ButtonIcon", k([
            XTn,
            tPn,
            ITn,
            uTn.o7,
            lCn(Wun.nh),
            WCn(Wun.nv),
            KCn(k([
                lCn(ECn),
                WCn(Wun.jV)
            ]))
        ])),
        A2(hkn, "ButtonMini", k([
            FCn(bkn(10)),
            sCn.jl,
            A2(qCn, bkn(2), bkn(5)),
            WCn(Wun.nv),
            eCn(Wun.nh),
            YCn.sq,
            sCn.jm,
            A2(DCn, bkn(0), bkn(2)),
            KCn(k([
                eCn(ECn),
                WCn(Wun.jV)
            ]))
        ])),
        A2(hkn, "ButtonMiniIcon", k([
            gCn(bkn(18)),
            Hkn(bkn(18)),
            wCn(bkn(0)),
            lCn(Jun),
            uTn.o7,
            KCn(k([
                WCn(Wun.jV),
                lCn(Yun)
            ]))
        ])),
        A2(hkn, "ButtonBlock", k([
            zCn.jH,
            WCn(Jun),
            wCn(bkn(5)),
            nTn(bkn(4)),
            KCn(k([
                WCn(oon),
                eCn(ton)
            ]))
        ])),
        A2(hkn, "ButtonDisabled", k([
            FCn(bkn(12)),
            WCn(uon),
            eCn(eon),
            A2(qCn, bkn(4), bkn(8)),
            uTn.o7,
            kkn.jj,
            YCn.sq,
            sCn.jm,
            GTn.bR
        ])),
        A2(hkn, "CustomButton", k([
            Hkn(bkn(32)),
            FCn(bkn(13)),
            sCn.jl,
            WCn(Gun),
            wCn(bkn(3)),
            uTn.o7,
            Jkn,
            rPn(k([
                Pkn(k([
                    A2(hkn, "CustomButtonLabel", k([
                        WCn(Wun.jV),
                        eCn(ECn)
                    ]))
                ]))
            ])),
            A2(hCn, "CustomButtonActive", k([
                Pkn(k([
                    A2(hkn, "CustomButtonIcon", k([
                        WCn(Wun.jV)
                    ])),
                    A2(hkn, "CustomButtonLabel", k([
                        WCn(Wun.jV),
                        eCn(ECn)
                    ])),
                    A2(hkn, "Fg", k([
                        uCn(ECn)
                    ]))
                ]))
            ])),
            A2(hCn, "CustomButtonDisabled", k([
                $Cn(30),
                uTn.kE
            ])),
            A2(hCn, "CustomButtonMini", k([
                Hkn(bkn(26)),
                FCn(bkn(12)),
                wCn(bkn(3)),
                iTn(bkn(18)),
                Pkn(k([
                    A2(hkn, "CustomButtonIcon", k([
                        gCn(bkn(18))
                    ])),
                    A2(hkn, "CustomButtonLabel", k([
                        A2(qCn, bkn(1), bkn(3))
                    ]))
                ]))
            ])),
            A2(hCn, "CustomButtonPrimary", k([
                Pkn(k([
                    A2(hkn, "CustomButtonIcon", k([
                        lCn(Wun.jV)
                    ])),
                    A2(hkn, "CustomButtonLabel", k([
                        SCn(Wun.nv),
                        eCn(Wun.nh)
                    ]))
                ])),
                KCn(k([
                    Pkn(k([
                        A2(hkn, "CustomButtonLabel", k([
                            eCn(ECn),
                            WCn(Wun.jV)
                        ]))
                    ]))
                ])),
                ePn(k([
                    Pkn(k([
                        A2(hkn, "CustomButtonLabel", k([
                            eCn(Gun),
                            WCn(Xun)
                        ]))
                    ]))
                ]))
            ])),
            A2(hCn, "CustomButtonDisabled", k([
                Pkn(k([
                    A2(hkn, "CustomButtonIcon", k([
                        SCn(oon + " !important")
                    ])),
                    A2(hkn, "CustomButtonLabel", k([
                        SCn(oon + " !important"),
                        eCn(Xun + " !important")
                    ])),
                    A2(hkn, "Fg", k([
                        uCn(Xun + " !important")
                    ]))
                ]))
            ]))
        ])),
        A2(Akn, "button", k([
            mTn(bkn(0))
        ])),
        A2(hkn, "CustomButtonIcon", k([
            WCn(Yun),
            eCn(non),
            Jkn,
            XTn,
            gCn(bkn(28)),
            sTn(bkn(2)),
            Pkn(k([
                A2(hkn, "Fg", k([
                    uCn(Wun.jV)
                ]))
            ]))
        ])),
        A2(hkn, "CustomButtonLabel", k([
            WCn(Xun),
            eCn(Gun),
            A2(qCn, bkn(0), bkn(8)),
            sCn.jl,
            Jkn,
            PCn.jH
        ])),
        A2(hkn, "ButtonSubmitWrapper", k([
            Jkn,
            ICn.bR
        ]))
    ]), oPn = k([
        A2(hkn, "DropDown", k([
            mkn.dj
        ])),
        A2(hkn, "DropDownMenu", k([
            A2(CTn, 20, 0),
            zkn,
            wCn(bkn(2)),
            kkn.om
        ])),
        A2(hkn, "DropDownItem", k([
            Jkn,
            wCn(bkn(4))
        ]))
    ]), aPn = k([
        A2(hkn, "EventsItem", k([
            Jkn,
            nTn(bkn(2)),
            WCn(Yun),
            eCn(non),
            wCn(bkn(4))
        ])),
        A2(hkn, "EventsItemIcon", k([
            gCn(bkn(24)),
            Hkn(bkn(24)),
            XTn
        ])),
        A2(hkn, "EventsItemBody", k([
            _Cn,
            A2(qCn, bkn(2), bkn(6))
        ])),
        A2(hkn, "EventsItemLabel", w),
        A2(hkn, "EventsItemDate", k([
            $Cn(70)
        ])),
        A2(hkn, "Neutral", w),
        A2(hkn, "Good", k([
            WCn(Kun.nv),
            eCn(ECn)
        ])),
        A2(hkn, "Bad", k([
            WCn(ion.nv),
            eCn(ECn)
        ])),
        A2(hkn, "Warn", k([
            WCn(WTn.nv),
            eCn(ECn)
        ])),
        A2(hkn, "Live", k([
            WCn(Wun.nv),
            eCn(ECn)
        ])),
        A2(hkn, "EventsItemArchived", k([
            $Cn(70)
        ]))
    ]), iPn = k([
        A2(hkn, "InputCheckbox", k([
            A2(qCn, bkn(4), bkn(8)),
            vCn(bkn(10))
        ])),
        A2(hkn, "InputCheckboxLine", k([
            Jkn,
            vCn(bkn(3)),
            wCn(bkn(6)),
            SCn(Yun),
            Pkn(k([
                A2(hkn, "InputWrapper", k([
                    xCn(bkn(20))
                ])),
                A2(hkn, "InputCheckbox", k([
                    vCn(bkn(2))
                ]))
            ]))
        ]))
    ]), cPn = F4(function(n, r, t, e) {
        return A2(ckn, "box-shadow", function(n) {
            var r = n.a, t = r.b, e = n.b, u = e.a, o = e.b, a = n.c;
            return ikn(r.a) + " " + ikn(t) + " " + ikn(u) + " " + o + (a ? " inset" : "");
        }(m(d(n, r), d(t, e), !1)));
    }), fPn = aCn("focus"), sPn = dkn(k([
        _Cn,
        eCn(ton),
        A2(qCn, bkn(1), bkn(4)),
        pCn(bkn(2)),
        A2(rCn, 2, oon),
        WCn(Yun),
        A2(hCn, "InputSelectEmpty", k([
            VTn(Jun),
            eCn(Xun),
            WCn(Gun)
        ])),
        fPn(k([
            VTn(Wun.jV)
        ]))
    ])), lPn = ckn("outline"), dPn = function(n) {
        return A2(ckn, "padding-top", ikn(n));
    }, mPn = {
        jb: A2(ckn, "pointer-events", "auto"),
        om: A2(ckn, "pointer-events", "none")
    }, bPn = {
        bG: A2(ckn, "text-overflow", "clip"),
        k9: A2(ckn, "text-overflow", "ellipsis"),
        ri: A2(ckn, "text-overflow", "string")
    }, pPn = {
        on: A2(ckn, "white-space", "normal"),
        oq: A2(ckn, "white-space", "nowrap"),
        pa: A2(ckn, "white-space", "pre"),
        pb: A2(ckn, "white-space", "pre-line"),
        pc: A2(ckn, "white-space", "pre-wrap")
    }, vPn = dkn(k([
        bPn.k9,
        Dkn.l8,
        pPn.oq
    ])), $Pn = k([
        A2(hkn, "DarkZone", w),
        A2(hkn, "InputWrapper", k([
            _Cn,
            zkn
        ])),
        A2(hkn, "InputWrapperDark", k([
            _Cn,
            zkn,
            WCn(Yun)
        ])),
        A2(hkn, "InputLabel", k([
            Jkn,
            A2(DCn, bkn(10), bkn(0))
        ])),
        A2(Mkn, k([
            "(max-width: 650px)"
        ]), k([
            A2(hkn, "InputLabel", k([
                zkn
            ]))
        ])),
        A2(hkn, "InputLabelText", k([
            gCn(bkn(220)),
            dPn(bkn(10))
        ])),
        A2(hkn, "InputText", k([
            sPn
        ])),
        A2(hkn, "InputSearch", w),
        A2(hkn, "InputPassword", k([
            sPn
        ])),
        A2(hkn, "InputTextarea", k([
            sPn
        ])),
        A2(hkn, "InputSelect", k([
            sPn,
            Jkn,
            mkn.dj,
            PCn.jH
        ])),
        A2(hkn, "InputSelectMini", k([
            xCn(bkn(100)),
            pCn(kCn),
            wCn(kCn)
        ])),
        A2(hkn, "InputSelectValue", k([
            sCn.jl,
            _Cn,
            vPn
        ])),
        A2(hkn, "InputSelectChoice", k([
            gCn(bkn(20)),
            Hkn(bkn(20))
        ])),
        A2(hkn, "InputSelectSelect", k([
            $Cn(0),
            A4(wkn, 0, 0, 0, 0),
            gCn(Rkn(100))
        ])),
        A2(hkn, "InputWrapperPrechoice", k([
            sPn,
            Jkn,
            Dkn.l8,
            oTn(2),
            wCn(bkn(2)),
            mkn.dj,
            OCn(bkn(50))
        ])),
        A2(hkn, "InputSelectAllChoice", k([
            A2(CTn, 0, 0),
            fkn(kCn),
            gCn(bkn(30)),
            WCn(Xun),
            A2(rCn, 3, oon),
            A4(cPn, bkn(-5), bkn(0), bkn(5), Yun),
            lCn(Gun),
            XTn,
            KCn(k([
                WCn(Wun.jV),
                lCn(ECn)
            ]))
        ])),
        A2(hkn, "InputSelectPrechoice", k([
            eCn(ron),
            A3(LTn, bkn(0), bkn(3), bkn(1)),
            uTn.o7,
            A2(rCn, 1, Jun),
            KCn(k([
                WCn(Wun.jV),
                eCn(ECn)
            ]))
        ])),
        A2(hkn, "InputSelectEmpty", k([
            eTn(k([
                A2(hkn, "InputSelectValue", k([
                    $Cn(60),
                    sCn.on
                ]))
            ]))
        ])),
        A2(hkn, "InputErrors", w),
        A2(hkn, "InputError", k([
            eCn(ion.jV)
        ])),
        A2(hkn, "InputMandatory", k([
            eCn(Wun.jV)
        ])),
        A2(hkn, "InputWrapperDisabled", k([
            $Cn(50),
            mPn.om
        ])),
        A2(hkn, "InputFileLabel", k([
            _Tn.se,
            uTn.o7
        ])),
        A2(hkn, "InputLabelDanger", k([
            WCn(ion.eG),
            lPn("2px solid red")
        ])),
        A2(hkn, "InputLabelWrapper", k([
            zkn,
            A2(qCn, bkn(0), bkn(6))
        ]))
    ]), wPn = F3(function(n, r, t) {
        return dkn(k([
            mkn.ii,
            pkn(bkn(n)),
            $kn(bkn(r)),
            skn(bkn(t))
        ]));
    }), gPn = Ckn(0), hPn = aCn("checked"), kPn = dkn(k([
        bPn.k9,
        pPn.oq,
        Dkn.l8
    ])), CPn = k([
        A2(hkn, "Select", k([
            Jkn,
            _Cn,
            mkn.dj,
            WCn(Xun),
            A2(rCn, 3, Gun),
            KCn(k([
                Pkn(k([
                    A2(hkn, "SelectButtonTitle", k([
                        eCn(ECn),
                        WCn(Wun.jV),
                        kPn
                    ]))
                ]))
            ])),
            A2(hCn, "SelectOpened", k([
                WCn(Wun.jV),
                Pkn(k([
                    A2(hkn, "SelectList", k([
                        zkn
                    ])),
                    A2(hkn, "SelectButtonTitle", k([
                        eCn(ECn)
                    ])),
                    A2(hkn, "SelectButtonIcon", k([
                        WCn(Wun.jV),
                        lCn(ECn)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "SelectNative", k([
            xCn(bkn(50))
        ])),
        A2(hkn, "SelectDisabled", w),
        A2(hkn, "SelectButton", k([
            Jkn,
            _Cn
        ])),
        A2(hkn, "SelectButtonIcon", k([
            wCn(bkn(3)),
            WCn(Yun),
            A2(STn, 2, Gun),
            gCn(bkn(28)),
            Hkn(bkn(26)),
            lCn(Wun.jV)
        ])),
        A2(hkn, "SelectButtonTitle", k([
            _Cn,
            Jkn,
            A2(qCn, bkn(0), bkn(8)),
            eCn(Gun),
            sCn.jl,
            PCn.jH,
            bPn.k9,
            pPn.oq,
            Dkn.l8
        ])),
        A2(hkn, "SelectList", k([
            kkn.om,
            A3(wPn, 26, -3, -3),
            HCn(99),
            WCn(Wun.jV),
            eCn(ECn),
            A2(rCn, 3, Gun),
            wCn(bkn(3))
        ])),
        A2(hkn, "SelectItem", k([
            wCn(bkn(6)),
            eCn(ECn),
            KCn(k([
                WCn(Wun.nv)
            ]))
        ])),
        A2(hkn, "SelectItemSelected", k([
            WCn(Wun.nx)
        ])),
        A2(hkn, "SelectEmpty", w),
        A2(hkn, "SelectRadios", k([
            zkn,
            WCn(Gun),
            A3(LTn, bkn(0), bkn(3), bkn(3))
        ])),
        A2(hkn, "SelectRadio", k([
            Jkn
        ])),
        A2(hkn, "SelectRadiosItem", k([
            Jkn,
            WCn(Yun),
            A2(rCn, 3, Jun),
            vCn(bkn(3)),
            _Cn,
            PCn.jH,
            KCn(k([
                eCn(ECn)
            ]))
        ])),
        A2(hkn, "SelectRadiosLabel", k([
            A2(qCn, bkn(6), bkn(4))
        ])),
        A2(hkn, "SelectRadiosType", k([
            A2(DCn, bkn(0), bkn(6)),
            gCn(bkn(18)),
            Hkn(bkn(18)),
            A2(rCn, 2, Xun),
            A2(Kkn, "box-shadow", "inset 0 0 0 2px " + Yun),
            mTn(bkn(10))
        ])),
        A2(hkn, "SelectRadiosInput", k([
            mkn.ii,
            pkn(bkn(-9999)),
            skn(bkn(-9999)),
            hPn(k([
                gPn(k([
                    A2(hkn, "SelectRadiosItem", k([
                        VTn(Wun.jV),
                        eCn(ECn),
                        Pkn(k([
                            A2(hkn, "SelectRadiosType", k([
                                VTn(Wun.jV),
                                WCn(Wun.jV)
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]), TPn = k([
        A2(hkn, "SelectMultiple", k([
            Jkn,
            _Cn,
            mkn.dj,
            WCn(Xun),
            A2(rCn, 3, Gun)
        ])),
        A2(hkn, "SelectMultipleDisabled", w),
        A2(hkn, "SelectMultipleLabel", k([
            zkn,
            A2(DCn, bkn(10), bkn(0))
        ])),
        A2(hkn, "SelectMultipleLabelText", k([
            jTn(bkn(10))
        ])),
        A2(hkn, "SelectMultipleList", k([
            zkn,
            _Cn,
            WCn(Xun),
            eCn(ECn),
            wCn(bkn(3))
        ])),
        A2(hkn, "SelectMultipleItem", k([
            wCn(bkn(6)),
            eCn(ECn),
            KCn(k([
                WCn(Wun.nv)
            ]))
        ])),
        A2(hkn, "SelectMultipleItemSelected", k([
            WCn(Wun.nx)
        ]))
    ]), PPn = dkn(k([
        vCn(bkn(3)),
        cCn(k([
            vCn(bkn(0))
        ]))
    ])), SPn = k([
        A2(hkn, "HeaderWrapper", k([
            Jkn,
            _Cn,
            PPn,
            PCn.jH,
            Hkn(bkn(40)),
            WCn(Jun)
        ])),
        A2(hkn, "HeaderLogo", k([
            mkn.dj,
            pkn(bkn(-5)),
            skn(bkn(-4)),
            GTn.lR,
            HCn(99)
        ])),
        A2(hkn, "HeaderBreadcrumb", k([
            Jkn,
            _Cn
        ])),
        A2(hkn, "HeaderBreadcrumbItem", k([
            Jkn,
            PCn.jH,
            eCn(ton),
            VCn(bkn(10)),
            KCn(k([
                eCn(ECn)
            ]))
        ])),
        A2(hkn, "HeaderBreadcrumbItemLogo", k([
            A2(rCn, 3, Gun),
            kkn.jj,
            NTn(bkn(32)),
            xCn(bkn(50)),
            gCn(nCn),
            Hkn(nCn),
            A2(Kkn, "object-fit", "cover")
        ])),
        A2(hkn, "HeaderBreadcrumbItemDisabled", k([
            Jkn,
            PCn.jH,
            eCn(non),
            VCn(bkn(10)),
            lCn(Xun)
        ])),
        A2(hkn, "HeaderBreadcrumbLabel", k([
            OCn(bkn(10)),
            VCn(bkn(6)),
            Jkn,
            PCn.jH
        ]))
    ]), APn = "#AB47BC", yPn = Kkn("stroke"), NPn = k([
        A2(hkn, "Bg", k([
            uCn(Jun)
        ])),
        A2(hkn, "Fg", k([
            uCn(Wun.jV)
        ])),
        A2(hkn, "IconButton", w),
        A2(hkn, "Stroked", k([
            yPn(Wun.jV)
        ])),
        A2(hkn, "IconChoice", w),
        A2(hkn, "IconSort", w),
        A2(hkn, "IconSearch", w),
        A2(hkn, "IconSmallDownload", w),
        A2(hkn, "IconDelete", w),
        A2(hkn, "IconKo", w),
        A2(hkn, "IconOk", w),
        A2(hkn, "IconBigFile", w),
        A2(hkn, "IconFileWithLabel", w),
        A2(hkn, "IconBullet", w),
        A2(hkn, "IconAvatar", w),
        A2(hkn, "IconSpinner", w),
        A2(hkn, "IconIcon18", w),
        A2(hkn, "IconIcon24", w),
        A2(hkn, "IconLogo", w),
        A2(hkn, "IconLaab", w),
        A2(hkn, "IconPadok", k([
            yPn(APn)
        ])),
        A2(hkn, "IconSettings", w),
        A2(hkn, "IconPlus", w),
        A2(hkn, "IconBack", w),
        A2(hkn, "IconBreadcrumb", k([
            uCn(Gun)
        ]))
    ]), LPn = function(n) {
        return aCn("nth-child(" + n + ")");
    }, jPn = k([
        A2(hkn, "KeyValueWrapper", k([
            zkn,
            WCn(Yun),
            nTn(bkn(4))
        ])),
        A2(hkn, "KeyValueRow", k([
            Jkn,
            A2(LPn, "odd", k([
                SCn("rgba(255,255,255,0.05)")
            ]))
        ])),
        A2(hkn, "KeyValueKey", k([
            sCn.jl,
            gCn(Rkn(38)),
            eCn(non),
            A2(qCn, bkn(4), bkn(10))
        ])),
        A2(hkn, "KeyValueValue", k([
            _Cn,
            eCn(ton),
            A2(qCn, bkn(4), bkn(10))
        ])),
        A2(hkn, "KeyValueHeader", k([
            sCn.jl,
            FCn(bkn(15)),
            eCn(non),
            A2(qCn, bkn(6), bkn(20))
        ])),
        A2(hkn, "KeyValueWrapperHeader", k([
            Jkn,
            SCn(Yun)
        ]))
    ]), FPn = k([
        A2(hkn, "LayoutPageWrapper", k([
            gCn(Rkn(100)),
            zkn,
            _Cn,
            Dkn.jb
        ])),
        A2(hkn, "LayoutPageHeader", k([
            wCn(bkn(10))
        ])),
        A2(hkn, "LayoutPageTitle", k([
            kkn.mq,
            VCn(bkn(10))
        ])),
        A2(hkn, "LayoutPageContent", k([
            WCn(Jun),
            zkn,
            _Cn,
            Dkn.jb
        ])),
        A2(hkn, "LayoutPageActions", k([
            fCn.pP
        ])),
        A2(hkn, "LayoutAppBarWrapper", k([
            Hkn(bkn(80)),
            Jkn,
            nTn(bkn(4))
        ])),
        A2(hkn, "LayoutAppBar", k([
            A2(qCn, bkn(8), bkn(15)),
            WCn(Xun),
            Jkn,
            _Cn,
            Pkn(k([
                A2(Akn, "h1", k([
                    eCn(Gun),
                    Dkn.l8,
                    Hkn(bkn(25))
                ])),
                A2(Akn, "h2", k([
                    eCn("rgba(255,255,255,.8)")
                ])),
                A2(Akn, "h3", k([
                    eCn("rgba(0,0,0,.6)"),
                    FCn(bkn(13)),
                    vCn(bkn(2)),
                    YCn.sq,
                    sCn.jl
                ]))
            ]))
        ])),
        A2(hkn, "LayoutAppBarTitle", k([
            zkn,
            ICn.jH,
            _Cn
        ])),
        A2(hkn, "LayoutAppBarActions", k([
            GTn.jH,
            Jkn,
            Hkn(bkn(32))
        ])),
        A2(hkn, "LayoutHeader", k([
            Jkn,
            PCn.jH,
            A2(qCn, kCn, bkn(8)),
            Hkn(bkn(48)),
            WCn(Wun.nx),
            eCn(Gun),
            nTn(bkn(4)),
            Pkn(k([
                A2(hkn, "ButtonLabel", k([
                    WCn(oon)
                ]))
            ]))
        ])),
        A2(hkn, "LayoutHeaderTitle", k([
            FCn(bkn(15)),
            VCn(bkn(8)),
            sCn.jm,
            _Cn,
            eCn(ECn),
            A4(MTn, bkn(1), bkn(1), bkn(1), TTn)
        ])),
        A2(hkn, "LayoutSubHeader", k([
            Jkn,
            A2(qCn, bkn(5), bkn(10)),
            WCn(Jun),
            eCn(ton),
            nTn(bkn(4))
        ])),
        A2(hkn, "LayoutSmallHeader", k([
            Jkn,
            A2(qCn, bkn(4), bkn(10)),
            WCn(Jun),
            eCn(Xun),
            nTn(bkn(4))
        ])),
        A2(hkn, "LayoutHeaderActions", w),
        A2(ykn, k([
            hkn("LayoutHomeButton"),
            hkn("LayoutBackButton")
        ]), k([
            Jkn,
            XTn,
            gCn(bkn(80)),
            WCn(Xun),
            sTn(bkn(2)),
            Pkn(k([
                A2(hkn, "Fg", k([
                    uCn(oon)
                ]))
            ])),
            KCn(k([
                WCn(ton)
            ]))
        ])),
        A2(hkn, "LayoutBloc", k([
            WCn(Yun),
            wCn(bkn(3)),
            nTn(bkn(3))
        ])),
        A2(hkn, "LayoutDetails", k([
            WCn(Yun),
            wCn(bkn(3)),
            vCn(bkn(3))
        ])),
        A2(hkn, "LayoutDetailsHeader", k([
            wCn(bkn(3)),
            eCn(ton)
        ])),
        A2(hkn, "LayoutDetailsContent", k([
            wCn(bkn(6)),
            WCn(Gun)
        ])),
        A2(hkn, "LayoutFwdButton", k([
            Jkn,
            XTn,
            gCn(bkn(80)),
            WCn(Xun),
            A2(PTn, 2, Gun),
            Pkn(k([
                A2(hkn, "Fg", k([
                    uCn(oon)
                ]))
            ])),
            KCn(k([
                WCn(ton)
            ]))
        ]))
    ]), MPn = k([
        A2(hkn, "LoadingWrapper", k([
            Hkn(Rkn(100)),
            gCn(Rkn(100)),
            PCn.jH,
            ICn.jH,
            kkn.lN,
            Jkn,
            _Cn
        ])),
        A2(hkn, "LoadingSpinner", k([
            gCn(bkn(100)),
            Hkn(bkn(40)),
            zCn.jH
        ])),
        A2(hkn, "LoadingMiniSpinner", k([
            gCn(bkn(18)),
            Hkn(bkn(18))
        ])),
        A2(hkn, "IconSpinner", k([
            A2(Kkn, "animation", "anim_spin 1s linear infinite")
        ]))
    ]), IPn = F2(function(n, r) {
        return dkn(k([
            mkn.ii,
            pkn(bkn(n)),
            skn(bkn(r))
        ]));
    }), DPn = F2(function(n, r) {
        return A3(Zkn, r, n, 0);
    }), BPn = k([
        A2(hkn, "MenuWrapper", k([
            A4(wkn, 0, 0, 0, 0),
            Jkn,
            WCn("rgba(24, 31, 41, .6)"),
            HCn(9)
        ])),
        A2(hkn, "MenuMain", k([
            zkn,
            WCn(Gun),
            A2(Kkn, "outline", "4px solid " + Gun)
        ])),
        A2(hkn, "MenuHeader", k([
            Hkn(bkn(80)),
            Jkn
        ])),
        A2(hkn, "MenuHeaderTitle", k([
            Jkn,
            _Cn,
            wCn(bkn(15)),
            PCn.jH,
            WCn(Xun),
            eCn(Gun)
        ])),
        A2(hkn, "MenuList", k([
            zkn,
            WCn(Gun),
            A2(rCn, 10, Jun),
            Pkn(k([
                A2(hkn, "MenuItem", k([
                    Hkn(bkn(40))
                ])),
                A2(hkn, "MenuItemIcon", k([
                    gCn(bkn(50))
                ]))
            ]))
        ])),
        A2(Mkn, k([
            "(max-width: 650px)"
        ]), k([
            A2(hkn, "MenuWrapper", k([
                Dkn.jb
            ]))
        ])),
        A2(Mkn, k([
            "(min-width: 650px)"
        ]), k([
            A2(hkn, "MenuList", k([
                _Cn,
                kkn.om,
                Dkn.jb,
                A4(wkn, 0, 100, 0, 304),
                xCn(bkn(400)),
                wCn(bkn(4)),
                A2(Kkn, "outline", "4px solid " + Gun)
            ])),
            A2(Akn, ".MenuOpened .MenuGroup:hover .MenuList", k([
                kkn.lN
            ])),
            A2(Akn, ".MenuOpened .MenuMain", k([
                gCn(bkn(300))
            ])),
            A2(Akn, ".MenuOpened .MenuGroup:hover > .MenuItem", k([
                Pkn(k([
                    A2(hkn, "MenuItemIcon", k([
                        WCn(Wun.nv),
                        lCn(ECn)
                    ])),
                    A2(hkn, "MenuItemTitle", k([
                        WCn(Jun),
                        eCn(ECn)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "MenuItem", k([
            Hkn(bkn(80)),
            A2(LCn, 4, Gun),
            mkn.dj,
            HCn(99),
            Jkn,
            uTn.o7,
            Pkn(k([
                A2(hkn, "Fg", k([
                    uCn(Wun.nv),
                    Qkn
                ])),
                A2(hkn, "Stroked", k([
                    yPn(Wun.nv),
                    Qkn
                ]))
            ])),
            rPn(k([
                Pkn(k([
                    A2(hkn, "MenuItemIcon", k([
                        WCn(Jun)
                    ])),
                    A2(hkn, "MenuItemTitle", k([
                        WCn(Jun),
                        eCn(ECn)
                    ])),
                    A2(hkn, "Fg", k([
                        uCn(Wun.jV)
                    ])),
                    A2(hkn, "Stroked", k([
                        yPn(ECn)
                    ]))
                ]))
            ])),
            KCn(k([
                Pkn(k([
                    A2(hkn, "MenuItemIcon", k([
                        WCn(Wun.nv),
                        lCn(ECn)
                    ]))
                ]))
            ])),
            A2(hCn, "MenuLogout", k([
                Pkn(k([
                    A2(hkn, "Fg", k([
                        uCn(ion.nx)
                    ]))
                ])),
                KCn(k([
                    eTn(k([
                        ATn(k([
                            WCn(ion.nv)
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(Akn, ".MenuItemIcon:hover + .MenuItemTitle", k([
            kkn.lN
        ])),
        A2(hkn, "MenuItemTitle", k([
            Hkn(Rkn(100)),
            A2(IPn, 0, 94),
            A2(qCn, kCn, bkn(25)),
            WCn(Yun),
            FCn(bkn(16)),
            FCn(bkn(18)),
            sCn.jl,
            eCn(non),
            zkn,
            ICn.jH,
            A2(Kkn, "outline", "4px solid " + Gun)
        ])),
        A2(hkn, "MenuClosed", k([
            gCn(bkn(90)),
            Pkn(k([
                A2(hkn, "MenuItemTitle", k([
                    kkn.om
                ]))
            ]))
        ])),
        A2(hkn, "MenuOpened", k([
            A2(Kkn, "outline", "4px solid " + Gun),
            Pkn(k([
                A2(hkn, "MenuItem", k([
                    gCn(nCn),
                    kkn.lN
                ])),
                A2(hkn, "MenuItemTitle", k([
                    mkn.dj,
                    skn(bkn(4)),
                    kkn.lN,
                    _Cn,
                    QCn(bkn(210)),
                    gCn(nCn)
                ]))
            ]))
        ])),
        A2(hkn, "MenuItemIcon", k([
            gCn(bkn(90)),
            Hkn(Rkn(100)),
            WCn(Yun),
            Qkn,
            XTn,
            lCn(Xun),
            Ekn(0)
        ])),
        A2(hkn, "MenuUser", k([
            mkn.ii,
            fkn(bkn(0)),
            skn(bkn(0)),
            gCn(bkn(80)),
            Hkn(bkn(148)),
            A2(jCn, 2, Gun),
            A2(DPn, 0, 0),
            Qkn
        ])),
        A2(hkn, "MenuAvatar", k([
            A2(rCn, 3, Yun),
            WCn(Yun),
            Pkn(k([
                A2(Akn, "img", k([
                    NTn(bkn(28)),
                    xCn(bkn(50))
                ]))
            ]))
        ])),
        A2(hkn, "UserCard", k([
            zCn.jH
        ])),
        A2(hkn, "UserCardStatus", w),
        A2(hkn, "MenuSpacer", k([
            _Cn,
            nTn(bkn(4)),
            WCn(Yun)
        ])),
        A2(hkn, "MenuIntercom", k([
            Hkn(bkn(90)),
            WCn(Jun)
        ])),
        A2(hkn, "MenuSettings", k([
            zkn,
            A2(rCn, 10, Yun),
            wCn(bkn(4)),
            A2(xTn, k([
                "(min-width: 650px)"
            ]), k([
                gCn(bkn(280)),
                sTn(bkn(4))
            ]))
        ])),
        A2(hkn, "MenuSettingsExpand", k([
            _Cn,
            WCn(Yun),
            vCn(bkn(4))
        ])),
        A2(hkn, "MenuSettingsItems", k([
            zkn,
            _Cn,
            wCn(bkn(4)),
            A2(rCn, 10, Jun),
            Hkn(bkn(100)),
            JCn.jb
        ])),
        A2(hkn, "MenuSettingsItem", k([
            Jkn,
            wCn(bkn(16)),
            WCn(Yun),
            vCn(bkn(4)),
            KCn(k([
                WCn(Jun)
            ])),
            cCn(k([
                vCn(kCn)
            ]))
        ])),
        A2(hkn, "MenuSettingsTitle", k([
            zkn,
            GTn.jH,
            _Cn
        ])),
        A2(hkn, "MenuSettingsProfile", k([
            FCn(bkn(16)),
            lCn(Wun.jV),
            WCn(Jun),
            eCn("rgba(255,255,255,.5)"),
            KCn(k([
                eCn(ECn),
                WCn(Wun.eG)
            ]))
        ])),
        A2(hkn, "MenuSettingsLogout", k([
            FCn(bkn(16)),
            lCn(ion.jV),
            uTn.o7,
            WCn(ion.eH),
            eCn(ion.mf),
            KCn(k([
                eCn(ECn),
                WCn(ion.eG)
            ]))
        ])),
        A2(hkn, "MenuSettingsSub", k([
            zkn,
            _Cn,
            Dkn.jb
        ])),
        A2(hkn, "SettingsTitle", k([
            FCn(bkn(18)),
            eCn(ECn)
        ])),
        A2(hkn, "SettingsForm", k([
            wCn(bkn(10)),
            xCn(bkn(500)),
            WCn(Yun)
        ])),
        A2(hkn, "MenuSettingsActive", k([
            WCn(Wun.nv),
            eCn(Wun.ng),
            KCn(k([
                WCn(Wun.jV)
            ]))
        ])),
        A2(hkn, "SettingsContainer", k([
            WCn(Yun),
            XCn.l8,
            JCn.jb,
            zkn,
            _Cn
        ])),
        A2(hkn, "MenuSettingsIcon", k([
            gCn(bkn(44)),
            Hkn(bkn(44)),
            sTn(bkn(10)),
            Jkn,
            PCn.jH,
            ICn.jH,
            WCn(Gun)
        ]))
    ]), xPn = F4(function(n, r, t, e) {
        return "rgba(" + Mt(n) + "," + Mt(r) + "," + Mt(t) + "," + by(e) + ")";
    }), qPn = k([
        A2(hkn, "ModalWrapper", k([
            WCn(Gun),
            HCn(999),
            A4(cPn, bkn(-5), bkn(0), bkn(0), A4(xPn, 24, 31, 41, .3)),
            nTn(bkn(0)),
            VCn(bkn(3))
        ])),
        A2(Mkn, k([
            "(min-width: 1000px)"
        ]), k([
            A2(hkn, "ModalWrapper", k([
                mkn.lK,
                pkn(bkn(0)),
                fkn(bkn(0)),
                $kn(bkn(0)),
                gCn(Rkn(80)),
                xCn(bkn(800)),
                pCn(bkn(0)),
                Dkn.jb
            ]))
        ])),
        A2(hkn, "ModalTitle", k([
            WCn(Jun),
            Jkn,
            wCn(bkn(10)),
            FCn(bkn(20)),
            eCn(non),
            ICn.qY,
            mkn.hy,
            HCn(99),
            pkn(bkn(0)),
            A2(LCn, 3, Gun)
        ])),
        A2(hkn, "ModalContent", k([
            zkn,
            oTn(3),
            wCn(bkn(10)),
            jTn(bkn(20)),
            WCn(Yun),
            eCn(non)
        ])),
        A2(hkn, "ModalSubmit", k([
            Jkn,
            oTn(6),
            ICn.bR,
            wCn(bkn(10)),
            mkn.hy,
            HCn(99),
            fkn(bkn(0)),
            WCn(Jun),
            A2(jCn, 3, Gun)
        ]))
    ]), VPn = k([
        A2(hkn, "ProgressIdle", k([
            WCn(Wun.jV),
            $Cn(50)
        ])),
        A2(hkn, "ProgressActive", k([
            WCn(Wun.jV)
        ])),
        A2(hkn, "ProgressPaused", k([
            WCn(WTn.jV)
        ])),
        A2(hkn, "ProgressError", k([
            WCn(ion.jV)
        ])),
        A2(hkn, "ProgressWarning", k([
            WCn(WTn.jV)
        ])),
        A2(hkn, "ProgressCompleted", k([
            WCn(Kun.jV)
        ])),
        A2(hkn, "ProgressBarProgressing", k([
            A2(STn, 3, Jun)
        ])),
        A2(hkn, "ProgressBarOuter", k([
            A2(rCn, 3, Yun),
            WCn(uon)
        ])),
        A2(hkn, "ProgressBarInner", k([
            kkn.jj,
            Hkn(bkn(16))
        ])),
        A2(hkn, "ProgressBarAnimated", k([
            A2(Kkn, "background-size", "1rem 1rem"),
            A2(Kkn, "background-image", "linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)"),
            A2(Kkn, "-webkit-animation", "progress-bar-animated 1s linear infinite"),
            A2(Kkn, "animation", "progress-bar-animated 1s linear infinite")
        ]))
    ]), OPn = k([
        A2(hkn, "Search", k([
            Jkn,
            WCn(Gun),
            wCn(bkn(3)),
            Hkn(bkn(32)),
            Pkn(k([
                A2(Akn, "input", k([
                    A2(rCn, 0, ""),
                    _Cn,
                    WCn(Yun),
                    pCn(kCn)
                ]))
            ]))
        ])),
        A2(hkn, "SearchIcon", k([
            WCn(Yun),
            XTn,
            gCn(bkn(28))
        ])),
        A2(hkn, "SearchInput", k([
            _Cn,
            Jkn,
            fTn(bkn(2)),
            kkn.om,
            fPn(k([
                kkn.lN
            ])),
            A2(hCn, "Searching", k([
                kkn.lN
            ]))
        ])),
        A2(hkn, "SearchResults", k([
            zkn,
            Dkn.jb,
            _Cn,
            mkn.lK,
            pkn(bkn(36)),
            skn(bkn(94)),
            gCn(bkn(330)),
            NTn(Rkn(90)),
            A4(wTn, bkn(0), bkn(4), bkn(4), bkn(4)),
            HCn(9),
            WCn(Gun),
            Qkn,
            A2(Kkn, "outline", "3px solid " + Gun)
        ])),
        A2(hkn, "SearchClosed", k([
            Pkn(k([
                A2(hkn, "SearchResults", k([
                    mPn.om,
                    $Cn(0)
                ]))
            ]))
        ])),
        A2(hkn, "SearchResultsItem", k([
            WCn(Yun),
            A2(qCn, bkn(4), bkn(8)),
            A2(rCn, 2, Yun),
            nTn(bkn(2)),
            KCn(k([
                A2(rCn, 2, Jun),
                eTn(k([
                    A2(hkn, "SearchResultsTitle", k([
                        eCn(ton)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "SearchResultsPath", k([
            eCn(Xun),
            kPn
        ])),
        A2(hkn, "SearchResultsMaster", k([
            lCn(Wun.jV)
        ])),
        A2(hkn, "SearchResultsShow", k([
            lCn(APn)
        ])),
        A2(hkn, "SearchResultsTitle", k([
            FCn(bkn(14)),
            sCn.jl,
            eCn(Wun.jV),
            Jkn,
            PCn.jH
        ]))
    ]), zPn = k([
        A2(hkn, "Switch", k([
            uTn.o7,
            gCn(bkn(30)),
            Hkn(bkn(15)),
            mTn(bkn(15)),
            SCn(Xun),
            kkn.jj,
            mkn.dj,
            GTn.jH
        ])),
        A2(hkn, "Switcher", k([
            mkn.ii,
            pkn(bkn(3)),
            skn(bkn(3)),
            gCn(bkn(9)),
            Hkn(bkn(9)),
            Ukn("300ms"),
            SCn(ECn),
            mTn(Rkn(50))
        ])),
        A2(hkn, "SwitchChecked", k([
            SCn(Wun.jV),
            Pkn(k([
                A2(hkn, "Switcher", k([
                    A2(Kkn, "left", "calc(100% - " + Mt(3) + "px)"),
                    _kn("translateX(-100%)")
                ]))
            ]))
        ])),
        A2(hkn, "SwitchDisabled", k([
            uTn.kE,
            $Cn(50)
        ]))
    ]), EPn = {
        cs: A2(ckn, "vertical-align", "baseline"),
        jo: A2(ckn, "vertical-align", "bottom"),
        ne: A2(ckn, "vertical-align", "length"),
        f4: A2(ckn, "vertical-align", "middle"),
        rj: A2(ckn, "vertical-align", "sub"),
        rA: A2(ckn, "vertical-align", "super"),
        rT: A2(ckn, "vertical-align", "text-bottom"),
        rU: A2(ckn, "vertical-align", "text-top"),
        r1: A2(ckn, "vertical-align", "top")
    }, HPn = k([
        A2(hkn, "Table", k([
            QCn(Rkn(100)),
            mkn.dj,
            gCn(Rkn(100))
        ])),
        A2(hkn, "TableHeader", k([
            Hkn(bkn(40)),
            EPn.f4,
            zCn.c0,
            A2(jCn, 2, Yun),
            A2(LCn, 2, Yun),
            wCn(bkn(10)),
            A2(hCn, "TableRight", k([
                zCn.pP
            ]))
        ])),
        A2(Akn, "th", k([
            Hkn(bkn(40)),
            EPn.f4,
            zCn.c0,
            A2(jCn, 2, Yun),
            A2(LCn, 2, Yun),
            wCn(bkn(10)),
            mkn.hy,
            pkn(bkn(0)),
            HCn(1),
            WCn(Yun),
            A2(hCn, "TableRight", k([
                zCn.pP
            ]))
        ])),
        A2(hkn, "TableTr", k([
            SCn("rgba(0,0,0,0.0)"),
            eCn(ton),
            A2(LPn, "odd", k([
                SCn("rgba(0,0,0,0.1)")
            ]))
        ])),
        A2(hkn, "TableTrHead", k([
            WCn(Yun),
            eCn(Xun)
        ])),
        A2(Akn, "td", k([
            A2(qCn, bkn(3), bkn(10))
        ])),
        A2(hkn, "TableTdBold", k([
            A2(qCn, bkn(3), bkn(10)),
            sCn.jl,
            eCn(eon)
        ])),
        A2(hkn, "TableTh", k([
            A2(qCn, bkn(3), bkn(10)),
            eCn(Xun),
            sCn.jl,
            zCn.c0
        ]))
    ]), RPn = function(n) {
        return A2(ckn, "letter-spacing", ikn(n));
    }, WPn = yCn("selection"), UPn = k([
        A2(hkn, "TimecodeWrapper", k([
            Jkn,
            wCn(bkn(3)),
            WCn(Gun),
            ITn,
            iTn(bkn(16))
        ])),
        A2(hkn, "TimecodeSep", k([
            A2(qCn, bkn(0), bkn(2)),
            ICn.jH
        ])),
        A2(hkn, "TimecodeUnit", k([
            WCn(Yun),
            eCn(Xun),
            A2(qCn, bkn(0), bkn(3)),
            ICn.jH,
            sCn.jl,
            RPn(bkn(2)),
            Jkn,
            _Cn
        ])),
        A2(hkn, "TimecodeHH", k([
            eCn(ton)
        ])),
        A2(hkn, "TimecodeMM", k([
            eCn(ton)
        ])),
        A2(hkn, "TimecodeSS", w),
        A2(hkn, "TimecodeFF", k([
            eCn(uon)
        ])),
        A2(Akn, "input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button", k([
            pCn(bkn(0)),
            A2(Kkn, "-webkit-appearance", "none")
        ])),
        A2(hkn, "TimecodeEditable", k([
            A2(STn, 2, Gun),
            WCn(Yun),
            eCn(Xun),
            ITn,
            A2(qCn, bkn(0), bkn(3)),
            iTn(bkn(24)),
            ICn.jH,
            sCn.jl,
            RPn(bkn(2)),
            Jkn,
            gCn(bkn(120)),
            zCn.jH,
            WPn(k([
                eCn(ECn),
                WCn(Wun.jV)
            ]))
        ])),
        A2(hkn, "TimecodeDarker", k([
            Pkn(k([
                A2(hkn, "TimecodeWrapper", k([
                    WCn(Jun)
                ])),
                A2(hkn, "TimecodeUnit", k([
                    WCn(Gun)
                ]))
            ]))
        ]))
    ]), QPn = k([
        A2(hkn, "UploadWrapper", k([
            mkn.lK,
            pkn(bkn(0)),
            fkn(bkn(0)),
            skn(bkn(0)),
            $kn(bkn(0)),
            HCn(999999)
        ])),
        A2(hkn, "UploadMask", k([
            A4(wkn, 0, 0, 0, 0),
            WCn(Wun.jV),
            $Cn(75)
        ])),
        A2(hkn, "UploadClose", k([
            A2(CTn, 20, 20),
            KCn(k([
                eCn(Wun.jV)
            ]))
        ])),
        A2(hkn, "UploadDropping", k([
            A4(wkn, 40, 40, 40, 40),
            XTn,
            eCn(ECn),
            FCn(bkn(16))
        ])),
        A2(hkn, "UploadContainer", k([
            A4(wkn, 88, 88, 88, 88),
            WCn(Gun),
            XCn.l8,
            JCn.jb
        ])),
        A2(hkn, "UploadContent", k([
            A2(qCn, bkn(20), bkn(50)),
            xCn(bkn(600)),
            A2(DCn, bkn(0), nCn)
        ])),
        A2(hkn, "UploadTitle", k([
            FCn(bkn(20)),
            eCn(ECn),
            pCn(bkn(20)),
            sCn.jl,
            zCn.jH
        ])),
        A2(hkn, "UploadSubtitle", k([
            eCn("white"),
            dPn(bkn(20))
        ])),
        A2(hkn, "UploadInput", k([
            kkn.om
        ])),
        A2(hkn, "UploadDesc", k([
            FCn(bkn(16)),
            eCn(non)
        ])),
        A2(hkn, "UploadError", k([
            eCn(ion.ng),
            WCn(ion.nx),
            wCn(bkn(10)),
            Jkn,
            PCn.jH,
            ICn.jH
        ])),
        A2(hkn, "UploadErrorClose", k([
            fTn(bkn(10)),
            Pkn(k([
                A2(hkn, "Fg", k([
                    uCn(ion.ng),
                    uTn.o7
                ])),
                A2(hkn, "IconDelete", k([
                    kkn.jj
                ]))
            ]))
        ])),
        A2(hkn, "UploadDrag", k([
            mkn.lK,
            WCn("rgba(22, 32, 46, 0.6)"),
            eCn("white"),
            DTn.om,
            mPn.om
        ])),
        A2(hkn, "UploadItem", k([
            vCn(bkn(15))
        ])),
        A2(hkn, "UploadFile", k([
            mkn.dj,
            Jkn,
            PCn.jH
        ])),
        A2(hkn, "UploadFileTitle", k([
            Jkn,
            _Cn
        ])),
        A2(hkn, "UploadFileSummary", k([
            zkn,
            fTn(bkn(10)),
            Ekn(1),
            QCn(bkn(0))
        ])),
        A2(hkn, "UploadFileName", k([
            pPn.oq,
            Dkn.l8,
            bPn.k9
        ])),
        A2(hkn, "UploadFileSize", k([
            pPn.oq
        ])),
        A2(hkn, "UploadRemove", k([
            fTn(bkn(10))
        ])),
        A2(hkn, "UploadFilesItemIconStamps", k([
            mkn.ii,
            zkn,
            pkn(bkn(43)),
            skn(bkn(30)),
            _kn("translate(-50%,-50%)")
        ])),
        A2(hkn, "UploadFilesItemIconStamp", k([
            Jkn,
            QCn(bkn(20)),
            Hkn(bkn(17)),
            iTn(bkn(17)),
            pCn(bkn(2)),
            A2(qCn, bkn(0), bkn(5)),
            mTn(bkn(10)),
            dkn(k([
                FCn(bkn(12)),
                sCn.jl
            ])),
            eCn(ECn),
            ICn.jH,
            Pkn(k([
                A2(hkn, "Fg", k([
                    uCn(ECn)
                ]))
            ]))
        ])),
        A2(hkn, "UploadFilesItemNormal", k([
            Pkn(k([
                A2(hkn, "UploadFilesItemIconStamp", k([
                    WCn(Wun.jV)
                ])),
                A2(hkn, "Bg", k([
                    uCn(Wun.jV)
                ]))
            ]))
        ])),
        A2(hkn, "UploadFilesItemWarning", k([
            Pkn(k([
                A2(hkn, "UploadFilesItemIconStamp", k([
                    SCn(WTn.nv)
                ])),
                A2(hkn, "UploadFilesItemWarning", k([
                    SCn(WTn.nv)
                ])),
                A2(hkn, "Bg", k([
                    uCn(WTn.nv)
                ]))
            ]))
        ])),
        A2(hkn, "UploadCardIdWarning", k([
            eCn(ECn),
            gCn(bkn(50)),
            ICn.jH,
            WCn(WTn.nv),
            sCn.jl,
            wCn(bkn(4)),
            pCn(bkn(4))
        ])),
        A2(hkn, "UploadCardName", k([
            _Cn,
            ICn.jH,
            sCn.jm,
            eCn(ton),
            wCn(bkn(4)),
            pCn(bkn(4))
        ])),
        A2(hkn, "UploadCardWrapper", k([
            zkn
        ])),
        A2(hkn, "UploadCardRow", k([
            Jkn,
            A2(LPn, "odd", k([
                SCn("rgba(255,255,255,0.05)")
            ]))
        ]))
    ]), _Pn = k([
        A2(hkn, "AdminCopyWrapper", k([
            zkn,
            Pkn(k([
                A2(Akn, ".InputWrapper:last-child", k([
                    Hkn(bkn(30))
                ]))
            ]))
        ]))
    ]), ZPn = k([
        A2(hkn, "FTPCopyWrapper", k([
            zkn,
            Pkn(k([
                A2(Akn, ".InputWrapper:last-child", k([
                    Hkn(bkn(30))
                ]))
            ]))
        ]))
    ]), KPn = k([
        A2(hkn, "S3CopyWrapper", k([
            Pkn(k([
                A2(Akn, ".InputWrapper:last-child", k([
                    Hkn(bkn(30))
                ]))
            ]))
        ]))
    ]), XPn = Ju(k([
        HTn,
        ZTn,
        YTn,
        OPn,
        uPn,
        oPn,
        aPn,
        iPn,
        $Pn,
        CPn,
        TPn,
        NPn,
        jPn,
        FPn,
        MPn,
        SPn,
        BPn,
        qPn,
        VPn,
        zPn,
        HPn,
        UPn,
        QPn,
        KPn,
        ZPn,
        _Pn
    ])), JPn = k([
        A2(hkn, "AsideTabs", k([
            Jkn,
            _Cn,
            WCn(Xun),
            A3(LTn, bkn(10), bkn(20), bkn(0)),
            mkn.dj,
            lCn(Gun)
        ])),
        A2(hkn, "AsideTab", k([
            wCn(bkn(15)),
            sCn.jl,
            A2(rCn, 4, Gun),
            A2(LCn, 0, ""),
            fTn(bkn(-4)),
            FCn(bkn(16)),
            sCn.jm,
            Jkn,
            _Cn,
            PCn.jH,
            eCn(Gun),
            WCn(Wun.nx),
            nTn(bkn(-4)),
            jTn(bkn(19)),
            uTn.o7,
            KCn(k([
                eCn(Gun),
                SCn(Wun.nv),
                jTn(bkn(15)),
                A2(LCn, 4, Wun.nx),
                Pkn(k([
                    A2(hkn, "AsideTabsIcon", k([
                        A2(rCn, 3, Gun),
                        lCn(Gun)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "AsideTabInner", k([
            pCn(bkn(6)),
            wCn(bkn(6)),
            A2(rCn, 3, Gun),
            Jkn,
            _Cn,
            PCn.jH
        ])),
        A2(hkn, "AsideTabLabel", k([
            Jkn,
            _Cn
        ])),
        A2(hkn, "AsideTabsIcon", k([
            A2(rCn, 3, Gun),
            lCn(Gun),
            sTn(bkn(8)),
            gCn(bkn(30)),
            Hkn(bkn(30)),
            XTn
        ])),
        A2(hkn, "AsideToggleButton", k([
            Jkn,
            XTn,
            gCn(bkn(80)),
            WCn(Xun),
            sTn(bkn(4)),
            Pkn(k([
                A2(hkn, "Fg", k([
                    uCn(oon)
                ]))
            ])),
            KCn(k([
                WCn(ton)
            ]))
        ])),
        A2(hkn, "AsideHeader", k([
            Jkn,
            Hkn(bkn(80))
        ])),
        A2(hkn, "AsideBody", k([
            zkn,
            _Cn,
            vCn(bkn(4)),
            A2(Kkn, "gap", "3px"),
            Dkn.jb,
            A2(jCn, 6, Wun.nx),
            cCn(w)
        ])),
        A2(Mkn, k([
            "(min-width: 600px)"
        ]), k([
            A2(hkn, "AsideBody", k([
                fTn(bkn(4))
            ]))
        ])),
        A2(hkn, "MasterFilesShowDesc", k([
            Pkn(k([
                A2(hkn, "MasterFilesDesc", k([
                    kkn.lN,
                    WCn(Gun)
                ])),
                A2(Akn, ".TableTr", k([
                    eCn(Xun)
                ]))
            ]))
        ])),
        A2(hkn, "MasterFilesAsset", k([
            WCn(oon),
            nTn(bkn(4))
        ])),
        A2(hkn, "AsideMenu", k([
            A2(IPn, 80, 16),
            $kn(bkn(20)),
            HCn(99),
            zkn,
            kkn.om,
            A2(rCn, 2, Gun),
            SCn(Wun.nv)
        ])),
        A2(hkn, "AsideMenuItem", k([
            Jkn,
            wCn(bkn(16)),
            eCn(Gun),
            FCn(bkn(15)),
            sCn.jl,
            A2(rCn, 2, Gun),
            rPn(k([
                SCn(Wun.md)
            ]))
        ])),
        A3(Wkn, "AsideMenuOpened", "AsideMenu", k([
            kkn.lN
        ])),
        A3(Wkn, "AsideMenuOpened", "AsideTab", k([
            SCn(Wun.md)
        ]))
    ]), YPn = function(n) {
        return A2(aCn, "not(:first-child)", n);
    }, GPn = k([
        A2(hkn, "DownloadList", k([
            zkn,
            A2(rCn, 3, Jun),
            wCn(bkn(3))
        ])),
        A2(hkn, "DownloadListItemWrapper", k([
            Jkn,
            YPn(k([
                A2(jCn, 3, Jun)
            ]))
        ])),
        A2(hkn, "DownloadListIcon", k([
            SCn(Jun),
            lCn(ECn),
            Pkn(k([
                A2(Akn, "svg", k([
                    gCn(bkn(18))
                ]))
            ]))
        ])),
        A2(hkn, "DownloadListItem", k([
            zkn,
            _Cn
        ])),
        A2(hkn, "DownloadListItemTitle", k([
            Jkn
        ])),
        A2(hkn, "DownloadListItemDesc", k([
            Jkn,
            WCn(ton)
        ])),
        A2(hkn, "DownloadListItemBullet", w),
        A2(hkn, "DownloadListItemFilename", k([
            _Cn
        ])),
        A2(hkn, "DownloadListItemDownload", k([
            Jkn
        ])),
        A2(hkn, "DownloadListItemDownloadIcon", w),
        A2(hkn, "DownloadListItemDownloadLabel", w),
        A2(hkn, "DownloadListItemSpecs", w),
        A2(hkn, "DownloadListAlt", w)
    ]), nSn = dkn(k([
        PCn.jH,
        ICn.jH
    ])), rSn = k([
        A2(hkn, "AudioQualifyWrapper", k([
            zkn,
            vCn(bkn(4)),
            nTn(bkn(2)),
            A2(qCn, kCn, bkn(2)),
            SCn(oon)
        ])),
        A2(hkn, "AudioQualifyTitleHeader", k([
            Jkn,
            SCn(oon),
            PCn.jH,
            eCn(eon)
        ])),
        A2(hkn, "AudioQualifyTitle", k([
            sCn.jm,
            A2(qCn, bkn(5), bkn(10)),
            nTn(bkn(4)),
            _Cn
        ])),
        A2(hkn, "AudioQualifyMemo", k([
            Jkn,
            wCn(bkn(4))
        ])),
        A2(hkn, "AudioQualifyMemoLabel", k([
            Jkn,
            _Cn,
            eCn(ton),
            A2(qCn, bkn(0), bkn(5))
        ])),
        A2(hkn, "AudioQualifyMemoRecap", k([
            A2(qCn, bkn(3), bkn(5)),
            zCn.pP,
            eCn(ton),
            $Tn.mX,
            Pkn(k([
                A2(Akn, ".ButtonMiniIcon", k([
                    kkn.mr,
                    pCn(bkn(5)),
                    KCn(k([
                        WCn(ion.jV)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "AudioQualifyFilesAudioStream", k([
            WCn(Jun),
            nTn(bkn(2)),
            A2(rCn, 2, Yun)
        ])),
        A2(hkn, "AudioQualifyQualify", k([
            Jkn,
            ICn.bR,
            VCn(bkn(26)),
            SCn(Yun)
        ])),
        A2(hkn, "AudioQualifyQualifyItem", k([
            A2(qCn, bkn(3), bkn(5)),
            eCn(ton),
            _Cn
        ])),
        A2(hkn, "AudioQualifyQualifyEdit", w),
        A2(hkn, "AudioQualifyQualifyForm", k([
            WCn(Yun),
            zkn,
            wCn(bkn(4)),
            Pkn(k([
                A2(Akn, "label", k([
                    A2(qCn, bkn(0), bkn(4)),
                    iTn(bkn(28)),
                    Jkn
                ]))
            ]))
        ])),
        A2(hkn, "AudioQualifyFilesHeader", k([
            Jkn,
            PCn.jH,
            lTn(bkn(32)),
            VCn(bkn(6)),
            OCn(bkn(3))
        ])),
        A2(hkn, "AudioQualifyFilesTitle", k([
            _Cn,
            eCn(eon),
            A2(qCn, bkn(3), bkn(6)),
            sCn.jl,
            Jkn,
            oTn(6)
        ])),
        A2(hkn, "AudioQualifyFilesDesc", k([
            kkn.om,
            nTn(bkn(2))
        ])),
        A2(hkn, "MasterFilesShowDesc", k([
            Pkn(k([
                A2(hkn, "AudioQualifyFilesDesc", k([
                    kkn.lN,
                    WCn(Gun)
                ])),
                A2(Akn, ".TableTr", k([
                    eCn(Xun)
                ]))
            ]))
        ])),
        A2(hkn, "PlayAudio", k([
            A2(DCn, bkn(0), bkn(5))
        ])),
        A2(hkn, "AudioQualifyCheckbox", k([
            Pkn(k([
                A2(hkn, "InputWrapper", k([
                    gCn(bkn(30)),
                    A2(Kkn, "flex", "unset")
                ]))
            ]))
        ]))
    ]), tSn = {
        jp: A2(ckn, "word-break", "break-all"),
        m3: A2(ckn, "word-break", "keep-all"),
        on: A2(ckn, "word-break", "normal")
    }, eSn = k([
        A2(hkn, "SubtitleQualifyWrapper", k([
            zkn,
            vCn(bkn(4)),
            nTn(bkn(2)),
            A2(qCn, kCn, bkn(2)),
            SCn(oon)
        ])),
        A2(hkn, "SubtitleQualifyTitleHeader", k([
            Jkn,
            SCn(oon),
            PCn.jH,
            eCn(eon)
        ])),
        A2(hkn, "SubtitleQualifyTitle", k([
            sCn.jm,
            A2(qCn, bkn(5), bkn(10)),
            nTn(bkn(4)),
            _Cn
        ])),
        A2(hkn, "SubtitleQualifyMemo", k([
            Jkn,
            wCn(bkn(4))
        ])),
        A2(hkn, "SubtitleQualifyMemoLabel", k([
            Jkn,
            _Cn,
            eCn(ton),
            A2(qCn, bkn(0), bkn(5))
        ])),
        A2(hkn, "SubtitleQualifyMemoRecap", k([
            A2(qCn, bkn(3), bkn(5)),
            zCn.pP,
            eCn(ton),
            $Tn.mX,
            Pkn(k([
                A2(Akn, ".ButtonMiniIcon", k([
                    kkn.mr,
                    pCn(bkn(5)),
                    KCn(k([
                        WCn(ion.jV)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "SubtitleQualifyFilesSubtitleStream", k([
            WCn(Jun),
            nTn(bkn(2)),
            A2(rCn, 2, Yun)
        ])),
        A2(hkn, "SubtitleQualifyQualify", k([
            Jkn,
            ICn.bR,
            VCn(bkn(26)),
            SCn(Yun)
        ])),
        A2(hkn, "SubtitleQualifyQualifyItem", k([
            A2(qCn, bkn(3), bkn(5)),
            eCn(ton),
            _Cn
        ])),
        A2(hkn, "SubtitleQualifyQualifyEdit", w),
        A2(hkn, "SubtitleQualifyQualifyForm", k([
            WCn(Yun),
            zkn,
            wCn(bkn(4)),
            Pkn(k([
                A2(Akn, "label", k([
                    A2(qCn, bkn(0), bkn(4)),
                    iTn(bkn(28)),
                    Jkn
                ]))
            ]))
        ])),
        A2(hkn, "SubtitleQualifyFilesHeader", k([
            Jkn,
            PCn.jH,
            lTn(bkn(32)),
            VCn(bkn(6)),
            OCn(bkn(3))
        ])),
        A2(hkn, "SubtitleQualifyFilesTitle", k([
            _Cn,
            eCn(eon),
            A2(qCn, bkn(3), bkn(6)),
            sCn.jl,
            tSn.jp
        ])),
        A2(hkn, "SubtitleQualifyFilesDesc", k([
            kkn.om,
            nTn(bkn(2))
        ])),
        A2(hkn, "MasterFilesShowDesc", k([
            Pkn(k([
                A2(hkn, "SubtitleQualifyFilesDesc", k([
                    kkn.lN,
                    WCn(Gun)
                ])),
                A2(Akn, ".TableTr", k([
                    eCn(Xun)
                ]))
            ]))
        ])),
        A2(hkn, "PlaySubtitle", k([
            A2(DCn, bkn(0), bkn(5))
        ])),
        A2(hkn, "SubtitleQualifyCheckbox", k([
            Pkn(k([
                A2(hkn, "InputWrapper", k([
                    gCn(bkn(30)),
                    A2(Kkn, "flex", "unset")
                ]))
            ]))
        ]))
    ]), uSn = Ju(k([
        rSn,
        eSn,
        k([
            A2(ykn, k([
                hkn("MasterWrapper"),
                hkn("MasterShadow")
            ]), k([
                Qkn,
                zkn
            ])),
            A2(hkn, "MasterWrapper", k([
                $Cn(100),
                A3(Zkn, 0, 0, 0)
            ])),
            A2(hkn, "MasterShadow", k([
                $Cn(0),
                A3(Zkn, 100, 0, 0)
            ])),
            A2(hkn, "MasterHeader", k([
                Hkn(bkn(80)),
                wCn(bkn(10)),
                WCn(Wun.jV),
                zkn
            ])),
            A2(hkn, "MasterHeaderId", k([
                eCn(Wun.nx),
                Hkn(bkn(14))
            ])),
            A2(hkn, "MasterHeaderTitle", k([
                eCn(Gun),
                MCn,
                _Cn
            ])),
            A2(hkn, "MasterHome", k([
                Jkn,
                _Cn,
                Dkn.jb
            ])),
            A2(hkn, "MasterTitle", k([
                WCn(oon),
                YCn.sq,
                A2(qCn, kCn, bkn(10)),
                iTn(bkn(36)),
                eCn(ton),
                Jkn
            ])),
            A2(hkn, "MasterFiles", k([
                zkn,
                _Cn
            ])),
            A2(hkn, "MasterFilesTitleDesc", k([
                eCn(non),
                FCn(bkn(12))
            ])),
            A2(hkn, "MasterHeaderSubTitle", k([
                eCn(non),
                FCn(bkn(12))
            ])),
            A2(hkn, "MasterMaterialWrapper", k([
                zkn
            ])),
            A2(hkn, "MasterMaterialTitle", k([
                WCn(Jun),
                YCn.sq,
                FCn(bkn(12)),
                A2(qCn, bkn(5), bkn(10))
            ])),
            A2(hkn, "MasterMaterialTitleType", k([
                eCn(non)
            ])),
            A2(hkn, "MasterMaterialTitleFormat", k([
                eCn(Wun.jV)
            ])),
            A2(hkn, "MasterMaterialItem", k([
                WCn(Yun),
                A2(qCn, bkn(4), bkn(10)),
                Jkn,
                nTn(bkn(4))
            ])),
            A2(hkn, "MasterMaterialItemThumb", k([
                gCn(bkn(160)),
                Hkn(bkn(90)),
                WCn(Yun),
                kkn.lN,
                nSn
            ])),
            A2(hkn, "MasterMaterialItemDetails", k([
                eCn(Xun),
                A2(rCn, 3, "rgba(0,0,0,0.2)"),
                _Cn,
                Dkn.jb
            ])),
            A2(hkn, "MasterWarning", k([
                Hkn(bkn(40)),
                wCn(bkn(10)),
                SCn(WTn.nv),
                eCn(ECn),
                sCn.jm,
                FCn(bkn(14)),
                kkn.lN,
                A2(LCn, 4, Gun)
            ])),
            A2(hkn, "MasterError", w),
            A2(hkn, "MasterFilesWrapper", k([
                zkn,
                eCn(ton),
                XCn.jb
            ])),
            A2(hkn, "MasterFilesAsset", k([
                A2(qCn, bkn(3), bkn(0)),
                WCn(oon),
                nTn(bkn(4))
            ])),
            A2(hkn, "MasterFilesToggleDesc", w),
            A2(hkn, "MasterFilesChildren", k([
                pCn(bkn(3)),
                Pkn(k([
                    A2(hkn, "Fg", k([
                        uCn(Xun)
                    ]))
                ]))
            ])),
            A2(hkn, "MasterFilesHeader", k([
                Jkn,
                PCn.jH,
                lTn(bkn(32)),
                eTn(k([
                    A2(hkn, "ProgressBarOuter", k([
                        _Cn,
                        xCn(bkn(250))
                    ]))
                ]))
            ])),
            A2(hkn, "MasterFilesIcon", k([
                gCn(bkn(28)),
                Hkn(bkn(28)),
                XTn
            ])),
            A2(hkn, "MasterStreamIcon", k([
                gCn(bkn(22)),
                Hkn(bkn(22)),
                XTn
            ])),
            A2(hkn, "MasterFilesTitle", k([
                _Cn,
                FCn(bkn(15)),
                A2(qCn, bkn(3), bkn(6)),
                sCn.jl,
                tSn.jp
            ])),
            A2(hkn, "MasterFilesDownload", k([
                kkn.lN,
                Okn.pR,
                Pkn(k([
                    A2(hkn, "CustomButton", k([
                        sTn(bkn(5))
                    ])),
                    A2(Akn, "CustomButton:last-child", k([
                        sTn(bkn(10))
                    ]))
                ]))
            ])),
            A2(hkn, "MasterFilesDesc", k([
                kkn.om,
                nTn(bkn(4)),
                mkn.dj
            ])),
            A2(hkn, "MasterFilesVideoStream", k([
                WCn(Jun),
                nTn(bkn(2)),
                A2(rCn, 2, Yun),
                VCn(bkn(6)),
                OCn(bkn(3))
            ])),
            A2(hkn, "MasterFilesShowDesc", k([
                Pkn(k([
                    A2(hkn, "MasterFilesDesc", k([
                        kkn.lN,
                        WCn(Gun)
                    ])),
                    A2(Akn, ".TableTr", k([
                        eCn(Xun)
                    ]))
                ]))
            ])),
            A2(hkn, "MasterTimecodeInputCls", k([
                Jkn,
                _Cn
            ])),
            A2(hkn, "MasterFilesAudioStream", k([
                WCn(Jun),
                nTn(bkn(2)),
                A2(rCn, 2, Yun)
            ])),
            A2(hkn, "MasterChild", k([
                Jkn,
                wCn(bkn(5)),
                WCn(oon),
                nTn(bkn(4)),
                PCn.jH
            ])),
            A2(hkn, "MasterChildLabel", k([
                aTn(1),
                Ekn(1),
                QCn(bkn(250)),
                pPn.oq,
                Dkn.l8,
                bPn.k9,
                sCn.jl,
                eCn(eon),
                eTn(k([
                    A2(Akn, "a", k([
                        eCn("#F3F3F4"),
                        _Tn.se
                    ]))
                ]))
            ])),
            A2(hkn, "MasterTimecodeInput", k([
                Jkn,
                _Cn
            ])),
            A2(hkn, "MasterChildProgress", k([
                gCn(Rkn(50)),
                Ekn(1),
                xCn(bkn(250))
            ])),
            A2(hkn, "MasterQualify", k([
                Jkn
            ])),
            A2(hkn, "MasterQualifyItem", k([
                A2(qCn, bkn(3), bkn(5)),
                eCn(ton)
            ])),
            A2(hkn, "MasterQualifyEdit", w),
            A2(hkn, "MasterQualifyForm", k([
                WCn(Yun),
                Jkn,
                wCn(bkn(4)),
                Pkn(k([
                    A2(Akn, "label", k([
                        A2(qCn, bkn(0), bkn(4)),
                        iTn(bkn(28)),
                        Jkn
                    ]))
                ]))
            ])),
            A2(hkn, "ReversedLayout", k([
                Jkn,
                PCn.jH,
                A2(qCn, kCn, bkn(8)),
                Hkn(bkn(48)),
                WCn(Wun.nx),
                eCn(Gun),
                nTn(bkn(4)),
                Pkn(k([
                    A2(Akn, ".ButtonLabel", k([
                        WCn(oon)
                    ])),
                    A2(Akn, ".LayoutHeaderTitle", k([
                        _Cn
                    ]))
                ]))
            ]))
        ])
    ])), oSn = k([
        A2(hkn, "PlayerFold", k([
            A2(rCn, 3, Jun),
            wCn(bkn(3)),
            zkn,
            lTn(bkn(190))
        ])),
        A2(hkn, "PlayerFoldInfos", k([
            zkn,
            _Cn,
            wCn(bkn(6)),
            fTn(bkn(3)),
            WCn(Yun)
        ])),
        A2(hkn, "PlayerFoldInfo", k([
            Jkn,
            A2(jCn, 1, Gun)
        ])),
        A2(hkn, "PlayerFoldInfosTitle", k([
            eCn(ton),
            YCn.sq,
            sCn.jl,
            wCn(bkn(6))
        ])),
        A2(hkn, "PlayerFoldInfoLabel", k([
            eCn(Xun),
            A2(qCn, bkn(3), bkn(6)),
            gCn(bkn(100))
        ])),
        A2(hkn, "PlayerFoldInfoValues", k([
            zkn,
            _Cn
        ])),
        A2(hkn, "PlayerFoldInfoValue", k([
            eCn(ton),
            _Cn,
            A2(qCn, bkn(3), bkn(6))
        ])),
        A2(hkn, "PlayerFoldPreview", k([
            Jkn,
            uTn.o7,
            PCn.jH,
            SCn("radial-gradient(ellipse at center, rgba(24,31,41,.6) 0%,rgba(24,31,41,1) 100%), " + FTn),
            VTn(Gun),
            Qkn,
            Hkn(bkn(90)),
            KCn(k([
                SCn("radial-gradient(ellipse at center, rgba(24,31,41,0) 0%,rgba(24,31,41,1) 100%), " + FTn)
            ]))
        ])),
        A2(hkn, "PlayerFoldPlay", k([
            gCn(bkn(60)),
            Hkn(bkn(60)),
            WCn(Wun.jV),
            A2(rCn, 3, Gun),
            lCn(ECn),
            Pkn(k([
                A2(Akn, "svg", k([
                    gCn(bkn(60)),
                    Hkn(bkn(60))
                ]))
            ]))
        ])),
        A2(hkn, "PlayerFoldProxy", k([
            Hkn(bkn(60)),
            WCn(Yun),
            wCn(bkn(20)),
            A2(rCn, 3, Gun),
            A2(PTn, 0, Gun),
            sCn.jl,
            eCn(ECn)
        ])),
        A2(hkn, "PlayerFoldSpinner", k([
            zCn.jH,
            _Cn,
            lCn(oon)
        ])),
        A2(hkn, "PlayerUnfold", k([
            lTn(bkn(190))
        ]))
    ]), aSn = k([
        A2(hkn, "Settings", k([
            zkn,
            _Cn
        ])),
        A2(hkn, "AdminOps", k([
            Pkn(k([
                A2(hkn, "LayoutHeader", k([
                    WCn(WTn.nx)
                ]))
            ]))
        ])),
        A2(Mkn, k([
            "(min-width: 1000px)"
        ]), k([
            A2(hkn, "Settings", k([
                XCn.l8,
                JCn.jb
            ]))
        ]))
    ]), iSn = aCn("empty"), cSn = dkn(k([
        FCn(bkn(16)),
        sCn.jl
    ])), fSn = function(n) {
        return oCn(function(n) {
            return {
                $: 3,
                a: n
            };
        }(n));
    }, sSn = k([
        A2(ykn, k([
            hkn("MasterWrapper"),
            hkn("MasterShadow")
        ]), k([
            Qkn,
            zkn
        ])),
        A2(hkn, "MasterWrapper", k([
            $Cn(100),
            A3(Zkn, 0, 0, 0),
            Pkn(k([
                A2(ykn, k([
                    hkn("ShowMain")
                ]), k([
                    gCn(Rkn(100))
                ]))
            ]))
        ])),
        A2(hkn, "MasterShadow", k([
            $Cn(0),
            A3(Zkn, 100, 0, 0)
        ])),
        A2(hkn, "ShowWrapper", k([
            Jkn,
            _Cn
        ])),
        A2(hkn, "ShowMain", k([
            _Cn,
            zkn,
            _kn("translate(0,0)")
        ])),
        A2(hkn, "ShowHomeWrapper", k([
            zkn,
            Dkn.jb,
            _Cn
        ])),
        A2(hkn, "ShowAside", k([
            gCn(bkn(404)),
            zkn
        ])),
        A2(hkn, "ShowDesc", k([
            WCn(Gun),
            Qkn,
            zkn,
            _Cn
        ])),
        A2(hkn, "ShowSelectBroadcastable", k([
            nTn(bkn(4)),
            wCn(bkn(1)),
            A2(rCn, 3, Jun)
        ])),
        A2(hkn, "ShowTodos", k([
            A2(rCn, 3, "#5E2F83"),
            zkn,
            wCn(bkn(3)),
            A2(Kkn, "gap", "3px"),
            nTn(bkn(4)),
            iSn(k([
                kkn.om
            ]))
        ])),
        A2(hkn, "DeliveryForm", k([
            A2(rCn, 6, Jun),
            wCn(bkn(1))
        ])),
        A2(hkn, "DeliveryFormBanners", k([
            A2(rCn, 3, Gun),
            zkn,
            A2(Kkn, "gap", "3px")
        ])),
        A2(hkn, "ShowDeliveries", k([
            vCn(bkn(4))
        ])),
        A2(hkn, "ShowDeliveriesTitle", k([
            WCn(Wun.eG),
            eCn(Wun.ng),
            sCn.jl,
            FCn(bkn(16)),
            wCn(bkn(6)),
            nTn(bkn(3))
        ])),
        A2(hkn, "ShowDeliveryNew", k([
            WCn(Wun.eG),
            eCn(ton),
            sCn.jl,
            FCn(bkn(16)),
            wCn(bkn(6)),
            nTn(bkn(3))
        ])),
        A2(hkn, "ShowDeliveriesItem", k([
            A2(rCn, 3, Wun.nx),
            nTn(bkn(3)),
            WCn(Wun.nx),
            eCn(Wun.mf),
            zkn,
            A2(fSn, "open", k([
                Pkn(k([
                    A2(hkn, "IconFolded", k([
                        _kn("rotate(90deg)")
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "IconFolded", k([
            lCn(Wun.eH)
        ])),
        A2(hkn, "ShowDeliveriesItemTitle", k([
            Jkn,
            PCn.jH,
            eCn(ECn),
            wCn(bkn(6))
        ])),
        A2(hkn, "ShowDeliveriesItemTitleLink", k([
            eCn("inherit"),
            _Cn,
            KCn(k([
                _Tn.se
            ]))
        ])),
        A2(hkn, "ShowDeliveriesItemStatus", k([
            WCn(ECn),
            A2(rCn, 3, Gun),
            eCn(Xun),
            wCn(bkn(6))
        ])),
        A2(hkn, "ShowDeliveriesSuccess", k([
            lCn(Kun.jV)
        ])),
        A2(hkn, "ShowDeliverySegmentsTabs", k([
            Jkn,
            vCn(bkn(3))
        ])),
        A2(hkn, "ShowDeliverySegmentsContent", k([
            WCn(Jun),
            wCn(bkn(4))
        ])),
        A2(Akn, ".ShowDeliverySegmentsContent .InputText", k([
            eCn(ton)
        ])),
        A2(hkn, "ShowDeliverySegmentsTab", k([
            A2(qCn, bkn(4), bkn(8)),
            eCn(ton)
        ])),
        A2(hkn, "ShowDeliverySegmentsTabActive", k([
            WCn(Jun),
            eCn(ECn)
        ])),
        A2(ykn, k([
            hkn("ShowMaterial"),
            hkn("ShowPlayer")
        ]), k([
            WCn(Gun),
            HCn(8888),
            zkn
        ])),
        A2(hkn, "ShowInfos", k([
            zkn
        ])),
        A2(hkn, "ShowComments", k([
            WCn(Gun),
            Qkn,
            zkn,
            HCn(9999)
        ])),
        A2(hkn, "ShowHeader", k([
            Hkn(bkn(80)),
            wCn(bkn(10)),
            WCn(Xun),
            nTn(bkn(4)),
            zkn
        ])),
        A2(hkn, "ShowActions", k([
            Hkn(bkn(28)),
            Jkn,
            GTn.jH
        ])),
        A2(hkn, "ShowHeaderTitle", k([
            MCn,
            eCn(Gun)
        ])),
        A2(hkn, "ShowHeaderId", k([
            eCn(Yun),
            Hkn(bkn(14))
        ])),
        A2(hkn, "ShowHeaderSubTitle", k([
            eCn(Yun),
            cSn
        ])),
        A2(hkn, "ShowActivity", w),
        A2(hkn, "ShowActivityList", w),
        A2(hkn, "ShowActivityItem", k([
            pCn(bkn(4)),
            eCn(non),
            VCn(bkn(20)),
            mkn.dj,
            Pkn(k([
                A2(Akn, "svg", k([
                    A2(IPn, 2, 2)
                ]))
            ]))
        ])),
        A2(hkn, "ShowActivityDate", k([
            fTn(bkn(10)),
            eCn(uon),
            pPn.oq
        ])),
        A2(hkn, "ShowAccepted", k([
            Pkn(k([
                A2(ykn, k([
                    hkn("LayoutAppBar"),
                    hkn("AsideTabs")
                ]), k([
                    WCn(Kun.jV)
                ]))
            ]))
        ])),
        A2(hkn, "ShowError", k([
            zkn,
            _Cn
        ])),
        A2(Mkn, k([
            "(min-width: 1000px)"
        ]), w),
        A2(Mkn, k([
            "(max-width: 650px)"
        ]), w),
        A2(Akn, "#player", k([
            Pkn(k([
                A2(hkn, "LoadingSpinner", k([
                    pCn(nCn)
                ]))
            ]))
        ]))
    ]), lSn = function(n) {
        return dkn(k([
            Pkn(k([
                A2(hkn, "Button", k([
                    SCn(n.nv),
                    eCn(n.nh),
                    KCn(k([
                        SCn(n.jV),
                        eCn(ECn)
                    ]))
                ]))
            ]))
        ]));
    }, dSn = k([
        A2(hkn, "Acceptation", k([
            WCn(Wun.nx)
        ])),
        A2(hkn, "AcceptationAccepted", k([
            WCn(Kun.nx),
            Pkn(k([
                A2(hkn, "AcceptationContent", k([
                    VTn(Kun.nx)
                ]))
            ]))
        ])),
        A2(hkn, "AcceptationRefused", k([
            WCn(ion.nv),
            Pkn(k([
                A2(hkn, "AcceptationContent", k([
                    VTn(ion.nv)
                ]))
            ]))
        ])),
        A2(hkn, "AcceptationHeader", k([
            Jkn,
            eCn(Gun),
            A2(qCn, kCn, bkn(7)),
            Hkn(bkn(48)),
            PCn.jH
        ])),
        A2(hkn, "AcceptationHeaderTitle", k([
            _Cn,
            pPn.oq,
            Dkn.l8,
            bPn.k9,
            sCn.jl,
            FCn(bkn(14)),
            VCn(bkn(8))
        ])),
        A2(hkn, "AcceptationHeaderActions", k([
            WCn(Gun),
            eCn(ECn),
            wCn(bkn(3)),
            Jkn
        ])),
        A2(hkn, "AcceptationHeaderActionsWrapper", k([
            uTn.o7,
            KCn(k([
                Pkn(k([
                    A2(hkn, "AcceptationHeaderActionsAction", k([
                        WCn(Wun.jV),
                        lCn(Wun.ng)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "AcceptationHeaderActionsAction", k([
            QCn(bkn(26)),
            Hkn(bkn(26)),
            A2(qCn, bkn(0), bkn(5)),
            WCn(Yun),
            Jkn,
            PCn.jH,
            A2(hCn, "AcceptationHeaderActionsOk", k([
                lCn(Kun.jV)
            ])),
            A2(hCn, "AcceptationHeaderActionsKo", k([
                lCn(ion.jV)
            ]))
        ])),
        A2(hkn, "AcceptationHeaderActionsIcon", k([
            vCn(bkn(4))
        ])),
        A2(hkn, "AcceptationHeaderActionsLabel", k([
            A2(qCn, kCn, bkn(3))
        ])),
        A2(hkn, "AcceptationContent", k([
            zkn,
            WCn(Gun),
            A2(rCn, 6, Wun.nx),
            A2(jCn, 0, ""),
            wCn(bkn(3)),
            Pkn(k([
                A2(hkn, "InputTextarea", k([
                    A2(rCn, 3, Gun),
                    A2(Kkn, "width", "100% !important"),
                    pCn(kCn),
                    WCn(Yun),
                    _Cn
                ])),
                A2(hkn, "InputWrapper", k([
                    zkn,
                    _Cn
                ])),
                A2(hkn, "AcceptationButton", k([
                    eCn(ECn),
                    vCn(bkn(3))
                ])),
                A2(hkn, "ButtonDisabled", k([
                    WCn(Jun),
                    eCn(uon),
                    KCn(k([
                        WCn(Jun),
                        eCn(uon)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "AcceptationChoices", k([
            zkn,
            eTn(k([
                ATn(k([
                    WCn(Yun),
                    zkn,
                    vCn(bkn(3)),
                    cCn(k([
                        vCn(bkn(0))
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "AcceptationOk", k([
            WCn(Kun.jV),
            wCn(bkn(3)),
            zkn,
            _Cn,
            lSn(Kun)
        ])),
        A2(hkn, "AcceptationNormal", k([
            WCn(Wun.nv),
            wCn(bkn(3)),
            zkn,
            _Cn
        ])),
        A2(hkn, "AcceptationKo", k([
            A2(rCn, 3, ion.jV),
            WCn(Gun),
            wCn(bkn(3)),
            zkn,
            _Cn,
            lSn(ion)
        ])),
        A2(hkn, "AcceptationText", k([
            A3(LTn, bkn(3), bkn(6), bkn(6)),
            WCn(Wun.eH),
            A2(rCn, 3, Gun),
            eCn(Wun.md),
            _Cn,
            zCn.jH
        ])),
        A2(hkn, "AcceptationTextOk", k([
            A3(LTn, bkn(3), bkn(6), bkn(6)),
            WCn(Kun.eH),
            A2(rCn, 3, Gun),
            eCn(Kun.md),
            _Cn,
            zCn.jH
        ])),
        A2(hkn, "AcceptationRejectionText", k([
            A3(LTn, bkn(3), bkn(6), bkn(6)),
            WCn(ion.eH),
            eCn(ion.md),
            _Cn,
            zCn.jH
        ])),
        A2(ykn, k([
            hkn("AcceptationVoteTitleAccepted"),
            hkn("AcceptationVoteTitleRejected")
        ]), k([
            zCn.jH,
            wCn(bkn(6))
        ])),
        A2(hkn, "AcceptationVoteTitleRejected", k([
            eCn(ion.jV)
        ])),
        A2(hkn, "AcceptationVote", k([
            eCn(ton),
            A2(jCn, 2, Gun)
        ])),
        A2(hkn, "AcceptationVoteUser", k([
            Jkn,
            PCn.jH,
            wCn(bkn(3)),
            Pkn(k([
                A2(hkn, "Avatar", k([
                    sTn(bkn(10))
                ]))
            ]))
        ])),
        A2(hkn, "AcceptationVoteUserName", k([
            aTn(1),
            Ekn(1),
            Dkn.l8,
            bPn.k9,
            pPn.oq
        ])),
        A2(hkn, "AcceptationVoteReason", k([
            A2(qCn, bkn(5), bkn(10))
        ])),
        A2(hkn, "AcceptationVoteAccepted", k([
            Jkn,
            WCn(Kun.jV),
            eCn(ECn)
        ])),
        A2(hkn, "AcceptationVoteWaiting", k([
            Jkn,
            WCn(Yun)
        ])),
        A2(hkn, "AcceptationVoteRejected", k([
            zkn,
            WCn(ion.jV),
            eCn(ECn)
        ])),
        A2(hkn, "AcceptationRejection", k([
            wCn(bkn(10)),
            WCn(ion.nv),
            eCn(ECn)
        ])),
        A2(hkn, "AcceptationWarning", k([
            Jkn,
            PCn.jH,
            eTn(k([
                A2(Akn, "svg", k([
                    SCn(WTn.nx),
                    Pkn(k([
                        A2(hkn, "Fg", k([
                            uCn(WTn.kw)
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "AcceptationBorderWrapper", k([
            A2(rCn, 6, Wun.nx),
            wCn(bkn(3))
        ]))
    ]), mSn = {
        jb: A2(ckn, "flex", "auto"),
        lO: function(n) {
            return A2(ckn, "flex", "flex-basis(" + Mt(n) + ")");
        },
        lP: function(n) {
            return A2(ckn, "flex", "flex-grow(" + Mt(n) + ")");
        },
        lQ: function(n) {
            return A2(ckn, "flex", "flex-shrink(" + Mt(n) + ")");
        },
        om: A2(ckn, "flex", "none")
    }, bSn = A2(bu, ckn("font-weight"), Mt), pSn = k([
        A2(hkn, "Activity", k([
            zkn,
            _Cn
        ])),
        A2(hkn, "ActivityTitle", k([
            wCn(bkn(6)),
            WCn(Wun.eG),
            eCn(ECn),
            sCn.jl,
            Jkn,
            nTn(bkn(2))
        ])),
        A2(hkn, "ActivityHeader", k([
            Hkn(bkn(48)),
            WCn(Wun.nx),
            A2(qCn, kCn, bkn(10)),
            Jkn,
            nTn(bkn(4)),
            PCn.jH,
            eTn(k([
                A2(hkn, "Select", k([
                    A2(STn, 0, ""),
                    eTn(k([
                        A2(hkn, "SelectButton", k([
                            A2(STn, 3, Gun)
                        ]))
                    ])),
                    A2(DCn, bkn(0), bkn(5))
                ]))
            ]))
        ])),
        A2(hkn, "ActivityHeaderLink", k([
            eCn(ECn),
            A2(qCn, kCn, bkn(10))
        ])),
        A2(hkn, "ActivityContent", k([
            zkn,
            _Cn
        ])),
        A2(hkn, "ActivityItem", k([
            WCn(Yun),
            wCn(bkn(3)),
            nTn(bkn(2)),
            eTn(k([
                A2(hkn, "IconBullet", k([
                    A2(DPn, 0, 4)
                ]))
            ]))
        ])),
        A2(hkn, "ActivityEvent", k([
            mkn.dj,
            VCn(bkn(34)),
            eTn(k([
                A2(hkn, "IconBullet", k([
                    A2(IPn, 1, 8)
                ]))
            ]))
        ])),
        A2(Mkn, k([
            "(min-width: 1000px)"
        ]), k([
            A2(hkn, "Activity", k([
                zkn,
                _Cn
            ])),
            A2(hkn, "ActivityContent", k([
                _Cn,
                nTn(bkn(2))
            ]))
        ])),
        A2(hkn, "ActivityOnlyEvents", k([
            Pkn(k([
                A2(hkn, "ActivityComment", k([
                    kkn.om
                ]))
            ]))
        ])),
        A2(hkn, "ActivityOnlyComments", k([
            Pkn(k([
                A2(hkn, "ActivityEvent", k([
                    kkn.om
                ]))
            ]))
        ])),
        A2(hkn, "CommentButton", k([
            sTn(bkn(4))
        ])),
        A2(hkn, "ActivityCommentForm", k([
            eCn(ron),
            WCn(Gun),
            wCn(bkn(3)),
            nTn(bkn(4)),
            A2(rCn, 8, Wun.nx)
        ])),
        A2(hkn, "ActivityAnswerForm", k([
            Jkn,
            WCn(Gun),
            eCn(ron),
            eTn(k([
                A2(hkn, "Avatar", k([
                    pCn(bkn(2))
                ]))
            ]))
        ])),
        A2(hkn, "ActivityCommentFormMessage", k([
            WCn(Yun)
        ])),
        A2(hkn, "ActivityCommentFormSubmit", k([
            Jkn,
            ICn.bR,
            vCn(bkn(2)),
            WCn(Yun)
        ])),
        A2(hkn, "ActivityCommentHideSubmit", k([
            kkn.om
        ])),
        A2(hkn, "ActivityComment", k([
            WCn(Yun),
            wCn(bkn(4)),
            nTn(bkn(2)),
            Jkn
        ])),
        A2(hkn, "ActivityCommentHeader", k([
            Jkn
        ])),
        A2(hkn, "ActivityCommentActions", k([
            Jkn
        ])),
        A2(hkn, "ActivityCommentDelete", k([
            Jkn,
            KCn(k([
                lCn(ECn),
                Pkn(k([
                    A2(hkn, "ButtonMiniIcon", k([
                        WCn(ion.jV)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "ActivityCommentAuthor", k([
            eCn(non),
            bSn(500)
        ])),
        A2(hkn, "ActivityCommentContent", k([
            A2(qCn, bkn(4), bkn(6)),
            _Cn,
            zkn
        ])),
        A2(hkn, "ActivityCommentDate", w),
        A2(hkn, "ActivityCommentWrap", k([
            zkn,
            A2(DCn, bkn(2), bkn(0))
        ])),
        A2(hkn, "ActivityCommentMessage", k([
            A2(qCn, bkn(8), bkn(0)),
            eCn(ton),
            pPn.pc
        ])),
        A2(hkn, "ActivityCommentTimecode", k([
            Jkn,
            _Cn,
            Pkn(k([
                A2(hkn, "InputWrapper", k([
                    mSn.om,
                    gCn(bkn(30)),
                    XTn
                ])),
                A2(hkn, "InputCheckbox", k([
                    wCn(kCn),
                    pCn(kCn)
                ]))
            ]))
        ])),
        A3(Wkn, "ActivityCommentContent", "ActivityCommentTimecode", k([
            A2(DCn, bkn(8), bkn(0))
        ])),
        A2(hkn, "ActivityCommentTimecodeLabel", k([
            $Tn.mX,
            eCn(Xun),
            wCn(bkn(2))
        ])),
        A2(hkn, "ActivityAnswerMessage", k([
            A2(qCn, bkn(2), bkn(0)),
            eCn(ton)
        ])),
        A2(hkn, "ActivityAnswers", w),
        A2(hkn, "ActivityAnswer", w),
        A2(hkn, "ActivityAnswerHeader", k([
            Jkn
        ])),
        A2(hkn, "ActivityAnswer", k([
            wCn(bkn(4)),
            WCn(Gun),
            Jkn,
            nTn(bkn(2))
        ])),
        A2(hkn, "ActivityCommentVerif", k([
            vCn(bkn(2))
        ])),
        A2(hkn, "ActivityCommentVerifTc", k([
            Jkn,
            nTn(bkn(2))
        ])),
        A2(hkn, "ActivityCommentVerifLabel", k([
            Jkn,
            _Cn,
            A2(qCn, bkn(3), bkn(6)),
            WCn(Yun)
        ])),
        A2(hkn, "ActivityCommentVerifHeader", k([
            Jkn,
            Pkn(k([
                A2(hkn, "InputTextarea", k([
                    FCn(bkn(16)),
                    A2(qCn, bkn(3), bkn(6)),
                    A4(cTn, bkn(0), bkn(3), bkn(0), bkn(0))
                ]))
            ]))
        ])),
        A2(bCn, "VerificationMotifInput", k([
            FCn(bkn(16)),
            A2(qCn, bkn(3), bkn(6))
        ])),
        A2(hkn, "RedFlag", k([
            Pkn(k([
                A2(hkn, "InputTextarea", k([
                    VTn(ion.jV)
                ]))
            ]))
        ])),
        A2(hkn, "OrangeFlag", k([
            Pkn(k([
                A2(hkn, "InputTextarea", k([
                    VTn(WTn.jV)
                ]))
            ]))
        ])),
        A2(hkn, "GreenFlag", k([
            Pkn(k([
                A2(hkn, "InputTextarea", k([
                    VTn(Kun.jV)
                ]))
            ]))
        ])),
        A2(hkn, "BlueFlag", k([
            Pkn(k([
                A2(hkn, "InputTextarea", k([
                    VTn(Wun.jV)
                ]))
            ]))
        ])),
        A2(hkn, "ActivityVerificationBloc", k([
            WCn(Gun),
            wCn(bkn(2))
        ])),
        A2(hkn, "ActivityVerificationMessage", k([
            FCn(bkn(16)),
            A2(qCn, bkn(3), bkn(6)),
            A2(rCn, 3, Wun.jV),
            eCn(ECn),
            A2(hCn, "RedFlag", k([
                VTn(ion.jV)
            ])),
            A2(hCn, "OrangeFlag", k([
                VTn(WTn.jV)
            ])),
            A2(hCn, "GreenFlag", k([
                VTn(Kun.jV)
            ]))
        ])),
        A2(hkn, "ActivityVerificationFlag", k([
            wCn(bkn(5)),
            fTn(bkn(1)),
            WCn(Yun)
        ])),
        A2(hkn, "RegularOperations", k([
            zkn,
            A2(rCn, 4, Wun.jV),
            wCn(bkn(3)),
            vCn(bkn(3)),
            nTn(bkn(3))
        ])),
        A2(hkn, "RegularOperationsHeader", k([
            wCn(bkn(10)),
            WCn(Wun.nx),
            eCn(Wun.kw),
            sCn.jm,
            FCn(bkn(15))
        ])),
        A2(hkn, "Operations", k([
            zkn,
            A2(rCn, 4, WTn.jV),
            wCn(bkn(3))
        ])),
        A2(hkn, "OperationsHeader", k([
            wCn(bkn(10)),
            WCn(WTn.nx),
            eCn(WTn.kw),
            sCn.jm,
            FCn(bkn(15))
        ])),
        A2(hkn, "OperationContent", k([
            zkn,
            aTn(1),
            Ekn(1),
            wCn(bkn(10)),
            WCn(Yun),
            eCn(ECn),
            A2(PTn, 3, Gun),
            Pkn(k([
                A2(hkn, "InputWrapper", k([
                    nTn(bkn(5))
                ]))
            ]))
        ])),
        A2(hkn, "OperationStatusNone", k([
            WCn(uon)
        ])),
        A2(hkn, "OperationStatusRunning", k([
            WCn(Wun.jV)
        ])),
        A2(hkn, "OperationStatusSuccess", k([
            WCn(Kun.jV)
        ])),
        A2(hkn, "OperationStatusFailure", k([
            WCn(ion.jV)
        ])),
        A2(hkn, "VerifContent", k([
            zkn,
            aTn(1),
            Ekn(1),
            wCn(bkn(10)),
            WCn(Yun),
            eCn(ECn),
            Pkn(k([
                A2(hkn, "InputWrapper", k([
                    nTn(bkn(5))
                ]))
            ]))
        ])),
        A2(hkn, "ActivityVerificationFlagSelect", k([
            Jkn,
            Pkn(k([
                A2(hkn, "OrangeFlag", k([
                    lCn(WTn.jV),
                    A2(hCn, "ActivityVerificationFlagSelected", k([
                        WCn(WTn.jV),
                        lCn(ECn)
                    ])),
                    KCn(k([
                        WCn(WTn.jV),
                        lCn(ECn)
                    ]))
                ])),
                A2(hkn, "RedFlag", k([
                    lCn(ion.jV),
                    A2(hCn, "ActivityVerificationFlagSelected", k([
                        WCn(ion.jV),
                        lCn(ECn)
                    ])),
                    KCn(k([
                        WCn(ion.jV),
                        lCn(ECn)
                    ]))
                ])),
                A2(hkn, "BlueFlag", k([
                    lCn(Wun.jV),
                    A2(hCn, "ActivityVerificationFlagSelected", k([
                        WCn(Wun.jV),
                        lCn(ECn)
                    ])),
                    KCn(k([
                        WCn(Wun.jV),
                        lCn(ECn)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "ActivityCommentSpacer", k([
            _Cn
        ])),
        A2(Akn, ".Activity > .ActivityContent", k([
            A2(jCn, 4, Wun.nx)
        ])),
        A2(hkn, "VerifOperationContent", k([
            PCn.bR
        ])),
        A2(Akn, ".VerifOperationContent .Select", k([
            nTn(bkn(10)),
            QCn(bkn(135))
        ]))
    ]), vSn = k([
        A2(hkn, "ShowArchives", k([
            zkn
        ])),
        A2(hkn, "ShowArchivesHeader", k([
            wCn(bkn(10)),
            WCn(oon),
            eCn(Gun),
            sCn.jm,
            FCn(bkn(15))
        ])),
        A2(hkn, "ShowArchive", k([
            Jkn,
            A2(jCn, 3, Gun)
        ])),
        A2(hkn, "ShowArchiveActions", k([
            wCn(bkn(6)),
            WCn(Yun),
            ICn.bR,
            Jkn
        ])),
        A2(hkn, "ShowArchivesLock", k([
            lCn(Wun.kw),
            XTn,
            Jkn
        ])),
        A2(hkn, "ShowArchiveStatus", k([
            gCn(bkn(10))
        ])),
        A2(hkn, "ShowArchiveContent", k([
            zkn,
            aTn(1),
            Ekn(1),
            wCn(bkn(10)),
            WCn(Yun),
            eCn(ECn),
            A2(PTn, 3, Gun),
            Pkn(k([
                A2(hkn, "ShowInputWrapper", k([
                    nTn(bkn(5))
                ]))
            ]))
        ]))
    ]), $Sn = aCn("disabled"), wSn = k([
        A2(hkn, "DownloadWrapper", k([
            WCn(Wun.nx),
            vCn(bkn(4))
        ])),
        A2(hkn, "DownloadBloc", k([
            wCn(bkn(4)),
            SCn(Yun),
            vCn(bkn(3))
        ])),
        A2(hkn, "DownloadBlocTitle", k([
            eCn(Xun),
            sCn.jl,
            FCn(bkn(15)),
            A3(LTn, bkn(4), bkn(6), bkn(4))
        ])),
        A2(hkn, "DownloadSection", w),
        A2(hkn, "DownloadSectionTitle", k([
            eCn(ECn),
            A3(LTn, bkn(8), bkn(6), bkn(4)),
            kkn.jj
        ])),
        A2(hkn, "DownloadSectionChoices", k([
            wCn(bkn(1)),
            SCn(Gun)
        ])),
        A2(hkn, "DownloadSectionChoice", k([
            Jkn,
            pCn(bkn(2)),
            eCn(Gun),
            sCn.jl,
            KCn(k([
                Pkn(k([
                    A2(hkn, "DownloadSectionLabel", k([
                        SCn(Wun.jV),
                        eCn(ECn)
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "DownloadSectionInput", k([
            wCn(bkn(8)),
            kkn.lN,
            SCn(Yun)
        ])),
        A2(hkn, "DownloadSectionLabel", k([
            wCn(bkn(6)),
            SCn(Xun),
            _Cn,
            fTn(bkn(2))
        ])),
        A2(hkn, "DownloadSubmit", k([
            Jkn,
            vCn(bkn(4)),
            wCn(bkn(1)),
            SCn(Gun)
        ])),
        A2(hkn, "DownloadSubmitSpacer", k([
            _Cn,
            pCn(bkn(2)),
            SCn(Yun)
        ])),
        A2(hkn, "DownloadSubmitButton", k([
            eCn(ECn),
            pCn(bkn(2)),
            A2(qCn, bkn(4), bkn(6)),
            FCn(bkn(16)),
            SCn(Wun.nv),
            KCn(k([
                SCn(Wun.jV)
            ])),
            $Sn(k([
                SCn(uon),
                eCn(Gun)
            ]))
        ])),
        A2(hkn, "DownloadSimpleButton", k([
            eCn(Gun),
            pCn(bkn(2)),
            A2(qCn, bkn(4), bkn(6)),
            SCn(uon),
            KCn(k([
                SCn(Xun)
            ]))
        ])),
        A2(hkn, "DownloadFile", k([
            Jkn,
            vCn(bkn(3)),
            SCn(Gun)
        ])),
        A2(hkn, "DownloadFileIcon", k([
            zkn,
            wCn(bkn(6)),
            SCn(Wun.nx),
            lCn(ECn)
        ])),
        A2(hkn, "DownloadFileBody", k([
            Jkn,
            _Cn,
            fTn(bkn(2))
        ])),
        A2(hkn, "DownloadFileName", k([
            _Cn,
            wCn(bkn(6)),
            SCn(Wun.nx),
            eCn(ECn)
        ])),
        A2(hkn, "DownloadFileAction", k([
            wCn(bkn(6)),
            SCn(Wun.nx),
            eCn(Wun.ng),
            Pkn(k([
                A2(Akn, "p", k([
                    pCn(bkn(0)),
                    dPn(bkn(4))
                ]))
            ]))
        ])),
        A2(hkn, "DownloadFileButton", k([
            wCn(bkn(6)),
            SCn(Wun.nv),
            vCn(bkn(1)),
            A2(rCn, 3, Gun),
            lCn(ECn),
            eCn(Wun.nh),
            Jkn,
            _Cn,
            Pkn(k([
                A2(Akn, "svg", k([
                    pCn(bkn(2))
                ]))
            ])),
            KCn(k([
                SCn(Wun.jV),
                eCn(ECn)
            ]))
        ])),
        A2(hkn, "Downloaded", k([
            Pkn(k([
                A2(hkn, "DownloadFileIcon", k([
                    SCn(Kun.nx)
                ])),
                A2(hkn, "DownloadFileName", k([
                    SCn(Kun.nx)
                ])),
                A2(hkn, "DownloadFileAction", k([
                    SCn(Kun.nx),
                    eCn(Kun.ng)
                ])),
                A2(hkn, "DownloadFileButton", k([
                    SCn(Kun.nv),
                    eCn(Kun.nh)
                ]))
            ]))
        ])),
        A2(hkn, "DownloadDisabled", k([
            Pkn(k([
                A2(hkn, "DownloadFileIcon", k([
                    SCn(Yun),
                    lCn(oon)
                ])),
                A2(hkn, "DownloadFileName", k([
                    SCn(Jun),
                    eCn(Xun)
                ])),
                A2(hkn, "DownloadFileAction", k([
                    SCn(Jun),
                    eCn(Xun)
                ])),
                A2(hkn, "DownloadFileButton", k([
                    SCn(Yun),
                    eCn(Xun),
                    lCn(Xun)
                ]))
            ]))
        ])),
        A2(hkn, "HowToOpenIntercom", k([
            wCn(bkn(20)),
            FCn(bkn(14)),
            eCn(eon),
            kkn.jj
        ])),
        A2(hkn, "DownloadOptionsWrapper", k([
            WCn(Yun),
            wCn(bkn(3)),
            A2(rCn, 3, Gun),
            iSn(k([
                kkn.om
            ]))
        ])),
        A2(hkn, "DownloadOptionsBloc", k([
            mkn.dj,
            SCn(Yun),
            HCn(9),
            wCn(bkn(6)),
            zkn
        ])),
        A2(hkn, "DownloadOptionsBack", w),
        A2(hkn, "DownloadOptionsClose", k([
            A2(CTn, 12, 12)
        ])),
        A2(hkn, "DownloadRowBloc", k([
            Jkn
        ])),
        A2(hkn, "DownloadOptionsCredentials", k([
            SCn(Yun),
            wCn(bkn(6))
        ])),
        A2(hkn, "DownloadOptionsText", k([
            _Cn,
            vCn(bkn(3)),
            wCn(bkn(6))
        ])),
        A2(hkn, "DownloadOptionsButtons", k([
            SCn(Yun),
            Jkn,
            wCn(bkn(6)),
            ICn.bR
        ])),
        A2(hkn, "DownloadRowButtons", k([
            WCn("#5E2F83"),
            wCn(bkn(6))
        ])),
        A2(hkn, "DownloadSftpLink", k([
            wCn(bkn(6)),
            _Cn,
            Jkn,
            PCn.jH
        ])),
        A2(hkn, "DownloadSftpUrl", k([
            WCn(oon),
            eCn(Wun.jV),
            Jkn,
            _Cn,
            FCn(UTn(1.2)),
            fTn(bkn(10))
        ])),
        A2(hkn, "DownloadsLinks", k([
            zkn,
            A2(Kkn, "gap", "3px")
        ])),
        A2(hkn, "DownloadsLinksItem", k([
            Jkn,
            wCn(bkn(3)),
            WCn(Jun),
            eCn(ron),
            KCn(k([
                WCn(Wun.nv),
                eCn(ECn)
            ]))
        ])),
        A2(hkn, "DownloadsLinksItemIcon", k([
            wCn(bkn(6)),
            WCn(Gun),
            XTn,
            gCn(bkn(40))
        ])),
        A2(hkn, "DownloadsLinksItemWrapper", k([
            zkn,
            _Cn,
            wCn(bkn(6))
        ])),
        A2(hkn, "DownloadsLinksItemName", k([
            sCn.jl,
            FCn(UTn(1.1)),
            tSn.jp
        ])),
        A2(hkn, "DownloadsLinksItemDetails", k([
            FCn(UTn(.95)),
            $Cn(70)
        ]))
    ]), gSn = k([
        A2(hkn, "EditWrapper", k([
            zkn,
            nTn(bkn(4))
        ])),
        A2(Mkn, k([
            "(min-width: 1000px)"
        ]), w),
        A2(hkn, "EditForm", k([
            zkn
        ])),
        A2(hkn, "EditHeaderIcon", k([
            gCn(bkn(50)),
            WCn(Wun.nx)
        ])),
        A2(hkn, "EditHeaderLabel", k([
            aTn(1),
            Ekn(1),
            pPn.oq,
            Dkn.l8,
            bPn.k9,
            wCn(bkn(10)),
            eCn(Jun)
        ])),
        A2(hkn, "EditHeaderActions", k([
            Jkn
        ])),
        A2(hkn, "EditFooter", k([
            Jkn,
            WCn(Gun),
            wCn(bkn(3)),
            ICn.bR
        ])),
        A2(hkn, "EditContent", k([
            zkn,
            WCn(Yun),
            eCn(ron),
            wCn(bkn(3))
        ])),
        A2(hkn, "EditEditing", k([
            Pkn(k([
                A2(hkn, "EditContent", k([
                    WCn(Yun)
                ])),
                A2(hkn, "EditRowContent", k([
                    WCn(Gun),
                    Dkn.sH
                ]))
            ]))
        ])),
        A2(hkn, "EditRow", k([
            Jkn,
            nTn(bkn(3)),
            vTn.sL
        ])),
        A2(hkn, "EditRowContent", k([
            aTn(1),
            Ekn(1),
            pPn.oq,
            Dkn.l8,
            bPn.k9,
            eCn(ECn),
            WCn(Yun),
            wCn(bkn(6)),
            Pkn(k([
                A2(Akn, "input", k([
                    pCn(kCn),
                    wCn(kCn),
                    A2(rCn, 0, "")
                ]))
            ]))
        ])),
        A2(hkn, "EditRowLabel", k([
            eCn(Xun),
            wCn(bkn(6)),
            gCn(Rkn(40)),
            $Tn.mX
        ]))
    ]), hSn = function(n) {
        return dkn(k([
            FCn(bkn(n)),
            sCn.jl
        ]));
    }, kSn = F2(function(n, r) {
        return k([
            Rh(A3(Hh, A3(to, A2(vo, n, w), w, kt), w, r))
        ]);
    }), CSn = kSn("svg"), TSn = k([
        A2(hkn, "FilesWrapper", k([
            zkn,
            eCn(ton)
        ])),
        A2(hkn, "FilesHeader", k([
            Jkn,
            WCn(oon),
            A2(qCn, bkn(0), bkn(10)),
            Hkn(bkn(48)),
            PCn.jH
        ])),
        A2(hkn, "FilesTitle", k([
            hSn(16),
            eCn(Gun),
            iTn(bkn(28)),
            _Cn
        ])),
        A2(hkn, "FilesItem", k([
            Jkn
        ])),
        A2(hkn, "FilesItemIcon", k([
            mkn.dj,
            Jkn
        ])),
        A2(hkn, "FilesItemIconStamps", k([
            mkn.ii,
            zkn,
            pkn(bkn(43)),
            skn(bkn(30)),
            _kn("translate(-50%,-50%)")
        ])),
        A2(hkn, "FilesItemIconStamp", k([
            Jkn,
            QCn(bkn(20)),
            Hkn(bkn(17)),
            iTn(bkn(17)),
            pCn(bkn(2)),
            A2(qCn, bkn(0), bkn(5)),
            mTn(bkn(10)),
            hSn(12),
            eCn(ECn),
            ICn.jH,
            Pkn(k([
                A2(hkn, "Fg", k([
                    uCn(ECn)
                ]))
            ]))
        ])),
        A2(hkn, "FilesItemSuccess", k([
            Pkn(k([
                A2(hkn, "FilesItemIconStamp", k([
                    WCn(Kun.jV)
                ])),
                A2(hkn, "Bg", k([
                    uCn(Kun.jV)
                ]))
            ]))
        ])),
        A2(hkn, "FilesItemFailure", k([
            Pkn(k([
                A2(hkn, "FilesItemIconStamp", k([
                    WCn(ion.jV)
                ])),
                A2(hkn, "Bg", k([
                    uCn(ion.jV)
                ]))
            ]))
        ])),
        A2(hkn, "FilesItemWarning", k([
            Pkn(k([
                A2(hkn, "FilesItemIconStamp", k([
                    WCn(Kun.jV)
                ])),
                A2(hkn, "FilesItemWarning", k([
                    SCn(WTn.jV)
                ])),
                A2(hkn, "Bg", k([
                    uCn(Kun.jV)
                ]))
            ]))
        ])),
        A2(ykn, k([
            hkn("FilesItemAwait"),
            hkn("FilesMaterial")
        ]), k([
            Pkn(k([
                A2(hkn, "Fg", k([
                    uCn(ron)
                ])),
                A2(hkn, "Bg", k([
                    uCn(ron)
                ]))
            ]))
        ])),
        A2(hkn, "FilesBroadcast", k([
            zkn,
            wCn(bkn(10)),
            WCn(eon),
            nTn(bkn(4)),
            KCn(k([
                SCn(ECn)
            ]))
        ])),
        A2(hkn, "FilesMaterial", k([
            zkn,
            wCn(bkn(10)),
            WCn(eon),
            nTn(bkn(4)),
            KCn(k([
                SCn(ECn)
            ]))
        ])),
        A2(hkn, "FilesGroupTitle", k([
            hSn(16),
            WCn(Jun),
            eCn(ton),
            A2(qCn, bkn(10), bkn(10))
        ])),
        A2(hkn, "FilesItemContent", k([
            A2(qCn, bkn(5), bkn(10))
        ])),
        A2(hkn, "FilesItemTitle", k([
            hSn(14),
            zkn,
            A2(qCn, bkn(5), bkn(10))
        ])),
        A2(hkn, "FilesItemTitle2", k([
            FCn(bkn(12)),
            sCn.jm,
            A2(qCn, bkn(5), bkn(0)),
            YCn.sq,
            eCn(uon)
        ])),
        A2(hkn, "FilesItemNextStep", k([
            A2(qCn, bkn(5), bkn(10)),
            SCn("rgba(0,0,0,.1)"),
            eCn("rgba(255,255,255,.8)"),
            pCn(bkn(2)),
            Jkn
        ])),
        A2(ykn, k([
            hkn("FilesAccepted"),
            hkn("FilesAwaitingUpload"),
            hkn("FilesUploading"),
            hkn("FilesRunningTasks")
        ]), k([
            WCn(Wun.jV),
            eCn(ECn),
            zkn
        ])),
        A2(hkn, "FilesAwaitingUpload", w),
        A2(hkn, "FilesUploading", w),
        A2(hkn, "FilesRunningTasks", k([
            wCn(bkn(2))
        ])),
        A2(hkn, "FilesFileOk", w),
        A2(hkn, "FilesFileKo", w),
        A2(hkn, "FilesAccepted", k([
            WCn(Kun.jV)
        ])),
        A2(hkn, "ManagerActionsWrapper", k([
            ZCn,
            _Cn,
            wCn(bkn(3))
        ])),
        A2(hkn, "FileItem", k([
            Jkn,
            nTn(bkn(4))
        ])),
        A2(hkn, "FileStatus", k([
            gCn(bkn(15)),
            A2(STn, 2, Jun)
        ])),
        A2(hkn, "FileStatusOperation", k([
            WCn(Wun.jV)
        ])),
        A2(hkn, "FileStatusFailure", k([
            WCn(ion.jV)
        ])),
        A2(hkn, "FileStatusWarning", k([
            WCn(WTn.jV)
        ])),
        A2(hkn, "FileStatusSuccess", k([
            WCn(Kun.jV)
        ])),
        A2(hkn, "FileContent", k([
            zkn,
            _Cn,
            WCn(eon),
            eCn(Yun),
            wCn(bkn(2))
        ])),
        A2(hkn, "FileDescription", k([
            wCn(bkn(5))
        ])),
        A2(hkn, "FilesWrapperSectionTitle", k([
            SCn(oon),
            eCn(eon),
            sCn.jm,
            A2(qCn, bkn(5), bkn(10)),
            Jkn,
            nTn(bkn(4))
        ])),
        A2(hkn, "FileDescriptionTitle", k([
            sCn.jm,
            Jkn,
            lCn(Xun)
        ])),
        A2(hkn, "FileDescriptionTitleName", k([
            _Cn,
            xCn(Rkn(95)),
            tSn.jp
        ])),
        A2(hkn, "FileDescriptionDetails", k([
            eCn(uon)
        ])),
        A2(hkn, "FileOperation", k([
            vCn(bkn(2))
        ])),
        A2(hkn, "FileOperationSummary", k([
            Jkn,
            wCn(bkn(3)),
            PCn.jH,
            WCn(ton)
        ])),
        A2(hkn, "FileOperationLabel", k([
            aTn(1),
            Ekn(1),
            QCn(bkn(250)),
            pPn.oq,
            Dkn.l8,
            bPn.k9,
            lCn(Xun),
            eTn(k([
                CSn(k([
                    A2(DPn, 0, 4)
                ]))
            ]))
        ])),
        A2(hkn, "FileOperationLabelTitle", k([
            sCn.jm,
            eCn(Gun)
        ])),
        A2(hkn, "FileOperationLabelProgress", k([
            eCn(uon)
        ])),
        A2(hkn, "FileOperationProgress", k([
            gCn(Rkn(50)),
            Ekn(1),
            xCn(bkn(250))
        ])),
        A2(hkn, "FileOperationDetails", k([
            Jkn,
            WCn(non),
            eCn(Yun),
            wCn(bkn(5))
        ])),
        A2(hkn, "FileOperationDetailsLabel", k([
            aTn(1),
            Ekn(1),
            pPn.oq,
            Dkn.l8,
            bPn.k9
        ])),
        A2(hkn, "FileOperationDetailsActions", w),
        A2(hkn, "FileOperationWarning", k([
            zkn,
            kkn.jj,
            Dkn.jb,
            WCn(Yun),
            eCn(non),
            wCn(bkn(5)),
            Pkn(k([
                A2(Akn, "tr:nth-child(odd)", k([
                    WCn("#555d68")
                ])),
                A2(Akn, "th", k([
                    pPn.oq
                ]))
            ]))
        ])),
        A2(hkn, "TranscodeWarning", k([
            aTn(1),
            pPn.oq,
            Dkn.l8,
            bPn.k9
        ])),
        A2(hkn, "TranscodeWarningField", k([
            _Cn
        ])),
        A2(hkn, "FileOperationIcon", k([
            Hkn(bkn(20)),
            gCn(bkn(20)),
            XTn,
            lCn(Xun)
        ])),
        A2(hkn, "FileTitle", k([
            aTn(1),
            Ekn(1),
            Jkn
        ]))
    ]), PSn = function(n) {
        return A2(ckn, "border-spacing", ikn(n));
    }, SSn = xa({
        bN: "Download",
        bT: "Download"
    }), ASn = {
        jb: A2(ckn, "table-layout", "auto"),
        lK: A2(ckn, "table-layout", "fixed")
    }, ySn = {
        cu: A2(ckn, "transform-origin", "center bottom"),
        cv: A2(ckn, "transform-origin", "left bottom"),
        cw: A2(ckn, "transform-origin", "right bottom"),
        jH: A2(ckn, "transform-origin", "center"),
        cx: A2(ckn, "transform-origin", "left center"),
        cy: A2(ckn, "transform-origin", "right center"),
        cD: ckn("transform-origin"),
        dG: A2(ckn, "transform-origin", "center top"),
        bq: A2(ckn, "transform-origin", "left top"),
        dH: A2(ckn, "transform-origin", "right top")
    }, NSn = xa({
        bN: "View",
        bT: "Visionnage"
    }), LSn = k([
        A2(hkn, "InvitationsWrapper", k([
            zkn,
            WCn("#181e28"),
            Pkn(k([
                A2(Akn, ".InvitationsForm .InputLabelText", k([
                    A2(Kkn, "align-items", "center"),
                    SCn("#232d39"),
                    VCn(bkn(8))
                ])),
                A2(Akn, ".InvitationsForm .InputLabel", k([
                    fTn(bkn(0)),
                    sTn(bkn(0)),
                    nTn(bkn(0)),
                    vCn(bkn(3))
                ]))
            ]))
        ])),
        A2(hkn, "InvitationsTable", k([
            Pkn(k([
                A2(Akn, "td:not(.InvitationEmail)", k([
                    wCn(bkn(3))
                ]))
            ]))
        ])),
        A2(hkn, "InvitationsHeader", k([
            Jkn,
            wCn(bkn(10)),
            WCn(oon),
            eCn(Gun),
            nTn(bkn(4)),
            Pkn(k([
                A2(hkn, "ButtonLabel", k([
                    WCn(oon)
                ]))
            ]))
        ])),
        A2(hkn, "Header", k([
            Pkn(k([
                A2(Akn, "td:not(:last-child)", k([
                    _kn("rotate(-45deg) translate(20px, -15px)"),
                    ySn.bq
                ]))
            ]))
        ])),
        A2(hkn, "InvitationsTable", k([
            dPn(bkn(70)),
            ASn.lK,
            gCn(Rkn(100)),
            WCn("#232D3A"),
            PSn(bkn(0)),
            nTn(bkn(3)),
            Pkn(k([
                A2(Akn, ".InputCheckboxLine .InputWrapper", k([
                    pCn(nCn)
                ])),
                A2(Akn, "tr", k([
                    WCn("#555D68c2"),
                    Hkn(bkn(30))
                ])),
                A2(Akn, "tr:nth-child(odd)", k([
                    WCn("#555d68")
                ])),
                A2(Akn, "td", k([
                    mkn.dj,
                    gCn(bkn(30)),
                    A2(Kkn, "border", "1px solid #181f29")
                ])),
                A2(Akn, "tr:first-child td:first-child:before", k([
                    A2(Kkn, "content", "'" + NSn + "'"),
                    _kn("rotate(-45deg) translate(16px, -20px)"),
                    kkn.mr,
                    mkn.ii,
                    ySn.bq,
                    skn(Rkn(30))
                ])),
                A2(Akn, "tr:first-child td:nth-child(2):before", k([
                    A2(Kkn, "content", "'Upload'"),
                    _kn("rotate(-45deg) translate(16px, -20px)"),
                    kkn.mr,
                    mkn.ii,
                    ySn.bq,
                    skn(Rkn(30))
                ])),
                A2(Akn, "tr:first-child td:nth-child(3):before", k([
                    A2(Kkn, "content", "'" + SSn + "'"),
                    _kn("rotate(-45deg) translate(16px, -20px)"),
                    kkn.mr,
                    mkn.ii,
                    ySn.bq,
                    skn(Rkn(30))
                ])),
                A2(Akn, "tr:first-child td:nth-child(4):before", k([
                    A2(Kkn, "content", "'Transcode'"),
                    _kn("rotate(-45deg) translate(16px, -20px)"),
                    kkn.mr,
                    mkn.ii,
                    ySn.bq,
                    skn(Rkn(30))
                ])),
                A2(hkn, "InvitationEmail", k([
                    gCn(Rkn(60))
                ])),
                A2(hkn, "InvitationDelete", k([
                    zCn.jH,
                    uTn.o7
                ])),
                A2(hkn, "InvitationSourceKind", k([
                    zCn.jH
                ]))
            ]))
        ])),
        A2(hkn, "InvitationEmail", k([
            xCn(bkn(100)),
            Dkn.l8,
            bPn.k9,
            pPn.oq,
            VCn(bkn(5)),
            eCn("#ffffff")
        ])),
        A2(hkn, "InvitationEdit", k([
            Pkn(k([
                A2(Akn, "svg", k([
                    _kn("scale(2)")
                ]))
            ]))
        ])),
        A2(hkn, "FullCube", k([
            gCn(bkn(17)),
            Hkn(bkn(17)),
            WCn("#3BAAFF"),
            A2(Kkn, "margin", "auto"),
            A2(Kkn, "border", "2px solid #181f29")
        ])),
        A2(hkn, "EmptyCube", k([
            gCn(bkn(17)),
            Hkn(bkn(17)),
            WCn(""),
            A2(Kkn, "margin", "auto"),
            A2(Kkn, "border", "2px solid #181f29")
        ])),
        A2(hkn, "InvitationsForm", k([
            zkn,
            wCn(bkn(4)),
            nTn(bkn(4)),
            vCn(bkn(-4)),
            WCn(Gun),
            A2(rCn, 8, Wun.nx),
            A2(jCn, 0, Wun.nx),
            Pkn(k([
                A2(hkn, "InputLabel", k([
                    _Cn,
                    pCn(bkn(6)),
                    wCn(kCn)
                ])),
                A2(hkn, "InputLabelText", k([
                    wCn(kCn),
                    _Cn,
                    Jkn
                ])),
                A2(hkn, "InputText", k([
                    A2(rCn, 0, Gun),
                    pCn(kCn),
                    eCn(ton),
                    wCn(bkn(6)),
                    SCn(Yun)
                ]))
            ]))
        ])),
        A2(hkn, "ShowTranscode", k([
            kkn.rG
        ])),
        A2(hkn, "HideTranscode", k([
            kkn.om
        ]))
    ]), jSn = k([
        A2(hkn, "JobsWrapper", k([
            zkn
        ])),
        A2(Mkn, k([
            "(min-width: 1000px)"
        ]), w),
        A2(hkn, "JobsContent", k([
            zkn,
            WCn(Yun),
            eCn(ron),
            A2(LCn, 3, Gun),
            wCn(bkn(3))
        ])),
        A2(hkn, "JobsRow", k([
            Jkn,
            nTn(bkn(3)),
            vTn.sL
        ])),
        A2(hkn, "JobsRowContent", k([
            aTn(1),
            Ekn(1),
            pPn.oq,
            Dkn.l8,
            bPn.k9,
            eCn(ECn),
            WCn(Yun),
            wCn(bkn(6)),
            Pkn(k([
                A2(Akn, "input", k([
                    pCn(kCn),
                    wCn(kCn),
                    A2(rCn, 0, "")
                ]))
            ]))
        ])),
        A2(hkn, "JobsRowLabel", k([
            eCn(Xun),
            wCn(bkn(6)),
            gCn(Rkn(40)),
            $Tn.mX
        ]))
    ]), FSn = k([
        A2(hkn, "Operations", k([
            zkn,
            A2(rCn, 4, WTn.jV),
            wCn(bkn(3))
        ])),
        A2(hkn, "OperationsHeader", k([
            wCn(bkn(10)),
            WCn(WTn.nx),
            eCn(WTn.kw),
            sCn.jm,
            FCn(bkn(15))
        ])),
        A2(hkn, "Operation", k([
            Jkn,
            A2(jCn, 3, Gun)
        ])),
        A2(hkn, "OperationStatus", k([
            gCn(bkn(10))
        ])),
        A2(hkn, "OperationStatusNone", k([
            WCn(uon)
        ])),
        A2(hkn, "OperationStatusRunning", k([
            WCn(Wun.jV)
        ])),
        A2(hkn, "OperationStatusSuccess", k([
            WCn(Kun.jV)
        ])),
        A2(hkn, "OperationStatusFailure", k([
            WCn(ion.jV)
        ])),
        A2(hkn, "OperationContent", k([
            zkn,
            aTn(1),
            Ekn(1),
            wCn(bkn(10)),
            WCn(Yun),
            eCn(ECn),
            A2(PTn, 3, Gun),
            Pkn(k([
                A2(hkn, "InputWrapper", k([
                    nTn(bkn(5))
                ])),
                A2(hkn, "ShowHideTable", k([
                    GTn.lR,
                    mkn.dj,
                    pkn(bkn(-22))
                ]))
            ]))
        ])),
        A2(hkn, "PlayerSettings", k([
            Jkn,
            Pkn(k([
                A2(Akn, "div", k([
                    aTn(1)
                ]))
            ]))
        ])),
        A2(Akn, ".ButtonMini", k([
            uTn.o7
        ])),
        A2(hkn, "DeepProbeTable", k([
            dPn(bkn(10)),
            ASn.lK,
            gCn(Rkn(100)),
            WCn("#232D3A"),
            PSn(bkn(0)),
            kkn.jj,
            Pkn(k([
                A2(Akn, ".InputCheckboxLine .InputWrapper", k([
                    pCn(nCn)
                ])),
                A2(Akn, "tr", k([
                    WCn("#555D68c2"),
                    Hkn(bkn(30))
                ])),
                A2(Akn, "tr:nth-child(odd)", k([
                    WCn("#555d68")
                ])),
                A2(Akn, "td", k([
                    mkn.dj,
                    gCn(Rkn(40)),
                    A2(Kkn, "border", "1px solid #181f29"),
                    A2(qCn, bkn(0), bkn(5))
                ])),
                A2(Akn, "td:first-child", k([
                    mkn.dj,
                    gCn(Rkn(3)),
                    A2(Kkn, "border", "none"),
                    WCn("#232D3A")
                ])),
                A2(hkn, "ProbeItem", k([
                    uTn.o7
                ])),
                A2(Akn, "tr:first-child", k([
                    WCn("#232D3A"),
                    Pkn(k([
                        A2(Akn, "td", k([
                            mkn.dj,
                            gCn(Rkn(3)),
                            A2(Kkn, "border", "0px")
                        ]))
                    ]))
                ])),
                A2(Akn, "table", k([
                    gCn(Rkn(95)),
                    A4(cTn, Rkn(0), Rkn(0), Rkn(0), Rkn(6)),
                    WCn("#181f29"),
                    Pkn(k([
                        A2(Akn, "tr", k([
                            WCn("transparent")
                        ])),
                        A2(Akn, "tr:nth-child(odd)", k([
                            WCn("transparent")
                        ])),
                        A2(Akn, "tr", k([
                            A2(Kkn, "border", "none")
                        ])),
                        A2(Akn, "td:first-child", k([
                            WCn("#181f29")
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(hkn, "ProbeLog", k([
            Pkn(k([
                A2(Akn, ".Button", k([
                    kkn.mq,
                    sTn(bkn(10))
                ]))
            ]))
        ]))
    ]), MSn = {
        jH: A2(ckn, "align-content", "center"),
        bR: A2(ckn, "align-content", "flex-end"),
        lR: A2(ckn, "align-content", "flex-start"),
        hk: A2(ckn, "align-content", "space-around"),
        qY: A2(ckn, "align-content", "space-between"),
        rh: A2(ckn, "align-content", "stretch")
    }, ISn = k([
        A2(hkn, "ReportWrapper", k([
            WCn(Yun),
            wCn(bkn(10)),
            Dkn.jb,
            Jkn,
            kkn.jj
        ])),
        A2(hkn, "ReportSection", k([
            kkn.rD,
            tCn.jn,
            gCn(Rkn(100))
        ])),
        A2(hkn, "ReportLinks", k([
            zkn,
            vTn.sL,
            MSn.rh
        ])),
        A2(hkn, "ReportLinksIcon", k([
            gCn(bkn(22)),
            Hkn(bkn(22)),
            XTn,
            WCn(Gun)
        ])),
        A2(hkn, "ReportLinksLabel", k([
            A2(qCn, bkn(2), bkn(5)),
            _Cn
        ])),
        A2(hkn, "ReportLinksButton", k([
            Jkn,
            nTn(bkn(3)),
            PCn.jH,
            WCn(Wun.eG),
            wCn(bkn(2)),
            KCn(k([
                eCn(Wun.nh),
                WCn(Wun.nv)
            ]))
        ]))
    ]), DSn = A2(bu, ckn("order"), Mt), BSn = k([
        A2(hkn, "Tracks", k([
            zkn,
            nTn(bkn(4))
        ])),
        A2(hkn, "TracksTitle", k([
            WCn(Jun),
            eCn(non),
            A2(qCn, bkn(2), bkn(6)),
            vCn(bkn(3)),
            YCn.sq,
            sCn.jl
        ])),
        A2(hkn, "TracksTrack", k([
            Jkn,
            A2(rCn, 3, Jun),
            wCn(bkn(3)),
            A2(jCn, 0, Jun)
        ])),
        A2(hkn, "TracksTrackIcon", k([
            WCn(Jun),
            sTn(bkn(3)),
            lCn(Xun),
            wCn(bkn(6))
        ])),
        A2(hkn, "TracksTrackSelect", k([
            zkn,
            _Cn,
            vCn(bkn(-3)),
            Pkn(k([
                A2(hkn, "BannerEmptyness", k([
                    A3(BCn, bkn(3), bkn(0), bkn(0))
                ])),
                A2(hkn, "BannerTodo", k([
                    A3(BCn, bkn(3), bkn(0), bkn(0))
                ]))
            ]))
        ])),
        A2(hkn, "TracksTrackSelectItem", k([
            Jkn,
            PCn.jH,
            uTn.o7,
            A2(rCn, 3, Jun),
            WCn(Yun),
            wCn(bkn(3)),
            KCn(k([
                eCn(ECn)
            ])),
            YPn(k([
                vCn(bkn(3))
            ]))
        ])),
        A2(hkn, "TracksTrackSelectItemTitle", k([
            FCn(bkn(15)),
            wCn(bkn(3)),
            Vkn(Rkn(50))
        ])),
        A2(hkn, "TracksTrackSelectItemProp", k([
            wCn(bkn(3)),
            _Cn,
            Vkn(Rkn(20))
        ])),
        A2(hkn, "TracksTrackSelectItemIndex", k([
            wCn(bkn(3)),
            Vkn(bkn(40))
        ])),
        A2(Akn, ".TracksTrackSelectItemProp:last-child", k([
            zCn.pP
        ])),
        A2(hkn, "TracksTrackToggleMore", k([
            kkn.om
        ])),
        A2(Akn, ".TracksTrackSelectGroup.TracksTrackSelectFolded .TracksTrackSelectLabel:nth-child(n+5)", k([
            kkn.om
        ])),
        A2(hkn, "TracksTrackSelectMore", k([
            zCn.jH,
            WCn(Yun),
            FCn(bkn(15)),
            A2(qCn, bkn(4), bkn(6)),
            vCn(bkn(3)),
            DSn(99),
            eCn(ECn),
            KCn(k([
                WCn(Jun)
            ]))
        ])),
        A2(hkn, "TracksTrackSelectGroup", k([
            zkn
        ])),
        A2(hkn, "TracksTrackSelectLabel", k([
            Pkn(k([
                A2(Akn, "input", k([
                    kkn.om
                ])),
                A2(Akn, "input:checked", k([
                    gPn(k([
                        A2(hkn, "TracksTrackSelectItem", k([
                            VTn(Wun.jV),
                            eCn(ECn)
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]), xSn = Ju(k([
        pSn,
        dSn,
        vSn,
        TSn,
        ISn,
        gSn,
        jSn,
        FSn,
        LSn,
        wSn,
        sSn,
        JPn,
        uSn,
        oSn,
        BSn,
        GPn,
        aSn
    ])), qSn = k([
        A2(hkn, "TimelineWrapper", k([
            _Cn,
            Qkn,
            zkn,
            Dkn.jb
        ])),
        A2(hkn, "TimelineList", k([
            zkn,
            Pkn(k([
                A2(Akn, "a:hover", k([
                    _Tn.se
                ]))
            ]))
        ])),
        A2(hkn, "TimelineDate", k([
            A2(qCn, bkn(4), bkn(10)),
            kkn.jj,
            zCn.jH,
            WCn(Jun),
            eCn(non),
            nTn(bkn(4))
        ])),
        A2(hkn, "TimelineEvent", k([
            WCn(Yun),
            eCn(Xun),
            iTn(bkn(25)),
            A2(qCn, bkn(10), bkn(10)),
            nTn(bkn(4)),
            zkn
        ])),
        A2(hkn, "TimelineGroup", k([
            A2(qCn, bkn(4), bkn(6))
        ])),
        A2(hkn, "TimelineGroupEvent", k([
            Jkn,
            PCn.jH,
            vCn(bkn(2))
        ])),
        A2(hkn, "TimelineSingleEvent", k([
            Jkn,
            PCn.jH,
            vCn(bkn(2))
        ])),
        A2(hkn, "TimelineEventMessage", k([
            A2(qCn, bkn(0), bkn(8)),
            _Cn,
            Pkn(k([
                A2(Akn, "span", k([
                    eCn(uon)
                ]))
            ]))
        ])),
        A2(hkn, "TimelineEventTitle", k([
            mkn.dj,
            Pkn(k([
                A2(Akn, "a", k([
                    kkn.mq
                ])),
                A2(Akn, "p", k([
                    kkn.mq
                ])),
                A2(Akn, "svg", k([
                    fTn(bkn(5)),
                    sTn(bkn(5))
                ])),
                A2(Akn, "div", k([
                    mkn.dj,
                    pkn(bkn(5)),
                    kkn.mq,
                    uTn.o7,
                    pCn(bkn(0))
                ])),
                A2(hkn, "TimelineEventTitleMessage", k([
                    mkn.q9,
                    uTn.jb,
                    fTn(bkn(10))
                ])),
                A2(hkn, "TimelineEventResumeSingle", k([
                    uTn.jb
                ]))
            ]))
        ])),
        A2(hkn, "TimelineEventResume", k([
            kkn.mq,
            fTn(bkn(15)),
            mkn.dj,
            pkn(bkn(5)),
            uTn.o7
        ])),
        A2(hkn, "TimelineEventLabel", k([
            fCn.pP
        ])),
        A2(hkn, "TimelineEventLabelPin", k([
            gCn(bkn(10)),
            Hkn(bkn(10)),
            mTn(bkn(10)),
            kkn.mr,
            fTn(bkn(6))
        ]))
    ]), VSn = k([
        A2(hkn, "PadokUploadWrapper", k([
            zkn
        ])),
        A2(hkn, "PadokUploadTitle", k([
            WCn(Wun.nx),
            wCn(bkn(10)),
            FCn(bkn(15)),
            sCn.jm,
            eCn(ECn),
            nTn(bkn(4))
        ])),
        A2(hkn, "PadokUpload", k([
            zkn,
            WCn(Wun.eG),
            nTn(bkn(4)),
            eCn(Wun.mf)
        ])),
        A2(hkn, "PadokUploadInfo", k([
            wCn(bkn(10)),
            kkn.mq
        ])),
        A2(hkn, "PadokUploadKo", k([
            WCn(WTn.eG),
            eCn(WTn.mf)
        ])),
        A2(hkn, "PadokUploadTitleKo", k([
            WCn(WTn.nx)
        ])),
        A2(hkn, "PadokUploadInvitation", k([
            WCn(Jun),
            wCn(bkn(10)),
            bSn(600),
            nTn(bkn(4))
        ]))
    ]), OSn = k([
        A2(Mkn, k([
            "(max-width: 1000px)"
        ]), k([
            A2(hkn, "ShowsWrapper", k([
                A4(wkn, 0, 0, 0, 94),
                Dkn.l8,
                zkn
            ])),
            A2(hkn, "SettingsWrapper", k([
                A4(wkn, 0, 0, 0, 94),
                Dkn.jb,
                zkn
            ])),
            A2(hkn, "MenuSettings", k([
                gCn(nCn)
            ])),
            A2(hkn, "BrowserWrapper", k([
                gCn(nCn)
            ])),
            A2(ykn, k([
                hkn("BrowserWrapper"),
                hkn("TimelineWrapper"),
                hkn("ShowWrapper"),
                hkn("MasterWrapper")
            ]), k([
                Ekn(0),
                _kn("translate3d(0,0,0)"),
                A2(PTn, 0, "transparent"),
                sTn(bkn(2)),
                nTn(bkn(2)),
                A4(wkn, 0, 0, 0, 0),
                Qkn
            ])),
            A2(ykn, k([
                hkn("ShowMain"),
                hkn("ShowAside")
            ]), k([
                A4(wkn, 0, 0, 0, 0),
                Qkn
            ])),
            A2(hkn, "ShowAside", k([
                gCn(nCn)
            ])),
            A2(ykn, k([
                hkn("ShowWrapper"),
                hkn("ShowAside"),
                hkn("TimelineWrapper")
            ]), k([
                _kn("translate3d(101%,0,0)")
            ])),
            A3(Wkn, "ActiveShow", "ShowWrapper", k([
                _kn("translate3d(0,0,0)")
            ])),
            A3(Wkn, "ActiveShow", "BrowserWrapper", k([
                _kn("translate3d(-100%,0,0)")
            ])),
            A3(Wkn, "AsideOpened", "ShowAside", k([
                _kn("translate3d(0,0,0)")
            ])),
            A3(Wkn, "AsideOpened", "ShowMain", k([
                _kn("translate3d(-101%,0,0)")
            ])),
            A2(hkn, "LayoutFwdButton", k([
                gCn(bkn(80))
            ])),
            A2(hkn, "LayoutBackButton", k([
                kkn.om
            ])),
            A2(hkn, "AsideOpened", k([
                Pkn(k([
                    A2(hkn, "LayoutBackButton", k([
                        kkn.om
                    ])),
                    A2(hkn, "LayoutHomeButton", k([
                        kkn.lN
                    ]))
                ]))
            ]))
        ]))
    ]), zSn = kSn("input"), ESn = $Tn.mX, HSn = yCn("placeholder"), RSn = kSn("textarea"), WSn = (tQ = k([
        HSn(k([
            $Cn(80),
            eCn(Xun),
            ESn
        ]))
    ]), k([
        zSn(tQ),
        RSn(tQ)
    ])), USn = Ju(k([
        Ykn,
        XPn,
        tTn,
        kTn,
        xSn,
        VSn,
        qSn,
        Bkn,
        Xkn,
        OSn,
        TCn,
        qkn,
        WSn,
        qTn,
        CCn
    ])), QSn = nk, _Sn = lu({
        m: function(n) {
            var r = bU(n.sr), t = d(ma({
                lL: n,
                oV: r.b,
                sr: r.a
            }), n$), e = n.st;
            if (e.$) return t;
            var u = A2(Ta, Uv, e.a);
            return u.$ ? t : A2(JW, n, u.a);
        },
        rm: function(n) {
            return 1 === n.$ ? A2($U, Na, function(n) {
                var r, t, e;
                return PU(k([
                    wU(CU),
                    AU(kU),
                    (r = gU, t = void 0 !== nr.hidden ? {
                        l8: "hidden",
                        jI: "visibilitychange"
                    } : void 0 !== nr.mozHidden ? {
                        l8: "mozHidden",
                        jI: "mozvisibilitychange"
                    } : void 0 !== nr.msHidden ? {
                        l8: "msHidden",
                        jI: "msvisibilitychange"
                    } : void 0 !== nr.webkitHidden ? {
                        l8: "webkitHidden",
                        jI: "webkitvisibilitychange"
                    } : {
                        l8: "hidden",
                        jI: "visibilitychange"
                    }, A3(OU, 0, t.jI, A2(Ne, zU(r), A2(du, "target", A2(du, t.l8, Pe))))),
                    A2($U, hU, (e = v_, PU(k([
                        A2($U, dQ, _Q),
                        e(mQ)
                    ])))),
                    A2($U, TU, n_(n.sk)),
                    function() {
                        var r = n.ak.sr;
                        n: for(;;)switch(r.$){
                            case 1:
                                return A2($U, gv(n.g9.mo), A2(p_, n.g9, n.ak));
                            case 4:
                                if (4 === r.a.$) {
                                    var t = n.iz.oW.dK;
                                    if (t.$) return SU;
                                    var e = t.a;
                                    return A2($U, A2(bu, A2(bu, Pa, Me), kO), lQ(e));
                                }
                                break n;
                            case 2:
                                return A2($U, wv, r_());
                            default:
                                break n;
                        }
                        return SU;
                    }()
                ]));
            }(n.a)) : A2($U, vU, wU(pU));
        },
        q: v8,
        r: function(n) {
            var r;
            return QSn(A2(ye, w, k([
                akn(n),
                (r = USn, da(A3(ca, "style", w, Wo(sa(ia(Wo(fa(r))))))))
            ])));
        }
    });
    eQ = {
        Private: {
            init: _Sn(A2(Te, function(n) {
                return A2(Te, function(r) {
                    return A2(Te, function(t) {
                        return A2(Te, function(e) {
                            return A2(Te, function(u) {
                                return A2(Te, function(o) {
                                    return A2(Te, function(a) {
                                        return A2(Te, function(i) {
                                            return je({
                                                bL: i,
                                                fm: a,
                                                mM: o,
                                                op: u,
                                                sr: e,
                                                st: t,
                                                sz: r,
                                                ig: n
                                            });
                                        }, A2(du, "defaults", A2(Te, function(n) {
                                            return A2(Te, function(r) {
                                                return A2(Te, function(t) {
                                                    return je({
                                                        ju: t,
                                                        jv: r,
                                                        qA: n
                                                    });
                                                }, A2(du, "browserAccept", Da));
                                            }, A2(du, "browserArchive", Da));
                                        }, A2(du, "showAside", Da))));
                                    }, A2(du, "height", tc));
                                }, A2(du, "isAdvertiser", Pe));
                            }, A2(du, "now", tc));
                        }, A2(du, "url", Da));
                    }, A2(du, "user", Di(k([
                        MW(kt),
                        A2(Ne, ht, Ma)
                    ]))));
                }, A2(du, "version", Da));
            }, A2(du, "width", tc)))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? o(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, eQ) : n.Elm = eQ;
}($cc2b0350e0cbd02a$exports);


var $08e5db9bd951c9f9$require$Elm = $cc2b0350e0cbd02a$exports.Elm;
// Expose the config for everyboAdaY
window.nomalab = {
    user: null,
    isAdvertiser: false,
    aws: null,
    // nomalabEnv is exposed by config.js ()
    // See helpers/thirdParty
    sentry: null,
    intercom: null,
    raw_frame_url: null
};















window.addEventListener('load', async function() {
    const response = await fetch('/v4/config/front');
    if (response.ok) {
        const config = await response.json();
        window.nomalab.sentry = config.sentry;
        window.nomalab.intercom = config.intercom;
        window.nomalab.raw_frame_url = config.raw_frame?.url;
    }
    // Fetch user infos
    fetch('/v3/users/me').then(function(response) {
        if (response.status === 200) return response.json();
        else throw 'not logged';
    }).then(function(me) {
        // Setup the user
        window.nomalab.user = me;
        return Promise.all([
            // fetch isAdvertiser status
            me.organization ? fetch(`/v4/organizations/${me.organization}/isAdvertiser`).then(function(response) {
                return response.json();
            }).then(function(data) {
                window.nomalab.isAdvertiser = data.isAdvertiser;
            }) : Promise.resolve(null),
            // fetch aws config
            fetch('/v3/aws/config').then(function(response) {
                return response.json();
            }).then(function(awsConfig) {
                // See helpers/upload
                window.nomalab.aws = awsConfig;
            })
        ]);
    }).catch(function(err) {
        // Not logged
        if (location.pathname === "/account/settings" || !location.pathname.startsWith("/account")) {
            const from = "?from=" + location.pathname;
            window.history.replaceState(null, "", "/account/login" + from);
        }
    }).finally(function() {
        // RUN THE APP
        var app = $08e5db9bd951c9f9$require$Elm.Private.init({
            node: document.getElementById('page'),
            flags: {
                user: window.nomalab.user,
                url: window.location.pathname + window.location.search,
                lang: window.navigator.userLanguage || window.navigator.language,
                width: window.innerWidth,
                height: window.innerHeight,
                now: new Date().getTime(),
                defaults: $53dd92cf139b6a84$exports.defaults(),
                version: 'dev',
                isAdvertiser: window.nomalab.isAdvertiser ?? false
            }
        });
        (parcelRequire("8TgEi"))(app);
        (parcelRequire("bvPu1"))(app);
        (parcelRequire("hjsOJ"))(app);
        (parcelRequire("iHeIR"))(app, 'redirect');
        // do not bother to load when not logged
        if (window.nomalab.user) {
            (parcelRequire("8oUNT"));
            (parcelRequire("3mVol"));
            (parcelRequire("4ARPW"));
            (parcelRequire("5JGum"));
            (parcelRequire("3Ii3I"))(app);
            (parcelRequire("4lCIN"))(app);
            (parcelRequire("56a0I"))(app);
            (parcelRequire("j63Xd"));
            (parcelRequire("fFcjN")).default(app);
            (parcelRequire("5pxJW"))(app);
            (parcelRequire("kRPup"))(app);
            $53dd92cf139b6a84$exports.subscribe(app);
        }
    });
});


//# sourceMappingURL=apps.b70ec045.js.map
